webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(896)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(468),
  /* template */
  __webpack_require__(2355),
  /* scopeId */
  "data-v-27e66917",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(487),
  /* template */
  __webpack_require__(2363),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(747),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSharedToken;
/* harmony export (immutable) */ __webpack_exports__["c"] = setSharedToken;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeSharedToken;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(2044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);


var SHARED_TOKEN_KEY = 'Nidin_bdms_token';

var COOKIE_OPTIONS = {
  path: '/',
  sameSite: 'Lax',

  expires: 7,
  secure: window.location.protocol === 'https:',

  domain: window.location.hostname.indexOf('nidin.shop') !== -1 ? '.nidin.shop' : undefined
};

function getSharedToken() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(SHARED_TOKEN_KEY);
}

function setSharedToken(token) {
  if (!token) return;
  __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(SHARED_TOKEN_KEY, token, COOKIE_OPTIONS);
}

function removeSharedToken() {
  __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove(SHARED_TOKEN_KEY, COOKIE_OPTIONS);
}

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(911)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(570),
  /* template */
  __webpack_require__(2378),
  /* scopeId */
  "data-v-320c4ea4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(987)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(2469),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(871)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(532),
  /* template */
  __webpack_require__(2321),
  /* scopeId */
  "data-v-105c5a52",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1047)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(638),
  /* template */
  __webpack_require__(2545),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(857)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(661),
  /* template */
  __webpack_require__(2303),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */,
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var parse = {
  divideList: function divideList(list, getList, number) {
    var productList = [];
    if (number >= 0) {
      if (list[0] !== 0) {
        for (var i = 0; i < list.length; i++) {
          productList.push(getList(list[i])[number]);
        }
        return productList;
      } else {
        return 0;
      }
    } else {
      if (list[0] !== 0) {
        for (var j = 0; j < list.length; j++) {
          productList.push(getList(list[j]));
        }
        return productList;
      } else {
        return 0;
      }
    }
  },
  getCommons: function getCommons(commonList) {
    var combineCount = 1;
    var screen = [];
    var carry = [];
    var result = [];
    for (var m = commonList.length - 1; m >= 0; m--) {
      combineCount = combineCount * commonList[m].length;
      carry.push(combineCount);
      screen.push(0);
    }
    for (var i = 0; i < combineCount; i++) {
      var isCarry = false;
      for (var j = commonList.length - 1; j >= 0; j--) {
        if (i >= carry[j] && i % carry[j] === 0) {
          for (var k = j; k >= 0; k--) {
            screen[k] = 0;
          }
          screen[j + 1]++;
          isCarry = true;
          break;
        }
      }
      if (i > 0 && !isCarry) {
        screen[0]++;
      }
      var fullName = [];
      for (var si = screen.length - 1; si >= 0; si--) {
        var sir = (si - screen.length + 1) * -1;

        fullName.push(commonList[sir][screen[si]]);
      }
      result.push(fullName);
    }
    return result;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (parse);

/***/ }),
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 75 */,
/* 76 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(863)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(483),
  /* template */
  __webpack_require__(2309),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(973)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(527),
  /* template */
  __webpack_require__(2454),
  /* scopeId */
  "data-v-63ce7f9e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1054)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(687),
  /* template */
  __webpack_require__(2557),
  /* scopeId */
  "data-v-e2b992de",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 79 */,
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_beta_jkos_js__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_beta_jkos_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_beta_jkos_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_prod_jkos_js__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_prod_jkos_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_prod_jkos_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_prod_prebeta_js__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_prod_prebeta_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config_prod_prebeta_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_prod_js__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_prod_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config_prod_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_beta_js__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_beta_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_beta_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_beta_dev_js__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_beta_dev_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__config_beta_dev_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_js__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__config_js__);








var config = void 0;
var brand = "nidin" || null;
var mode = "prod" || null;

switch (brand) {
  case 'jkos':
    switch (mode) {
      case 'beta':
        config = __WEBPACK_IMPORTED_MODULE_0__config_beta_jkos_js___default.a;
        break;
      case 'prod':
        config = __WEBPACK_IMPORTED_MODULE_1__config_prod_jkos_js___default.a;
        break;
      default:
        config = __WEBPACK_IMPORTED_MODULE_1__config_prod_jkos_js___default.a;
        break;
    }
    break;
  case 'nidin':
    switch (mode) {
      case 'beta-dev':
      case 'dev':
        config = __WEBPACK_IMPORTED_MODULE_5__config_beta_dev_js___default.a;
        break;
      case 'beta':
        config = __WEBPACK_IMPORTED_MODULE_4__config_beta_js___default.a;
        break;
      case 'prebeta':
        config = __WEBPACK_IMPORTED_MODULE_2__config_prod_prebeta_js___default.a;
        break;
      default:
        config = __WEBPACK_IMPORTED_MODULE_3__config_prod_js___default.a;
        break;
    }
    break;
  default:
    config = __WEBPACK_IMPORTED_MODULE_6__config_js___default.a;
    break;
}

/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(639),
  /* template */
  __webpack_require__(2319),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1026)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(724),
  /* template */
  __webpack_require__(2513),
  /* scopeId */
  "data-v-89fa8176",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(729),
  /* template */
  __webpack_require__(2568),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(739),
  /* template */
  __webpack_require__(2333),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC42NjY3IDE2LjUwMDRDMTAuNjY2NyAxNi45NjA2IDExLjAzOTggMTcuMzMzNyAxMS41MDAxIDE3LjMzMzdDMTEuOTYwMyAxNy4zMzM3IDEyLjMzMzQgMTYuOTYwNiAxMi4zMzM0IDE2LjUwMDRWMy44MjZMMTUuODU2NCA4LjExMDcxQzE2LjE0ODcgOC40NjYyIDE2LjY3MzggOC41MTc0NCAxNy4wMjkzIDguMjI1MTRDMTcuMzg0OCA3LjkzMjg0IDE3LjQzNiA3LjQwNzcgMTcuMTQzNyA3LjA1MjJMMTIuMTQzNyAwLjk3MTExNUMxMS45MjAzIDAuNjk5MzMxIDExLjU1MDIgMC41OTcxODkgMTEuMjE5IDAuNzE1ODc5QzEwLjg4NzcgMC44MzQ1NjggMTAuNjY2NyAxLjE0ODUxIDEwLjY2NjcgMS41MDAzN1YxNi41MDA0Wk03LjMzMzQ0IDEuNTAwMzdDNy4zMzM0NCAxLjA0MDEzIDYuOTYwMzQgMC42NjcwMzYgNi41MDAxIDAuNjY3MDM2QzYuMDM5ODcgMC42NjcwMzYgNS42NjY3NyAxLjA0MDEzIDUuNjY2NzcgMS41MDAzN1YxNC4xNzQ3TDIuMTQzNzkgOS44OTAwM0MxLjg1MTQ5IDkuNTM0NTMgMS4zMjYzNSA5LjQ4MzMgMC45NzA4NTEgOS43NzU2QzAuNjE1MzUyIDEwLjA2NzkgMC41NjQxMTggMTAuNTkzIDAuODU2NDE3IDEwLjk0ODVMNS44NTY0MiAxNy4wMjk2QzYuMDc5ODggMTcuMzAxNCA2LjQ0OTk3IDE3LjQwMzUgNi43ODEyMSAxNy4yODQ5QzcuMTEyNDQgMTcuMTY2MiA3LjMzMzQ0IDE2Ljg1MjIgNy4zMzM0NCAxNi41MDA0VjEuNTAwMzdaIiBmaWxsPSIjMzMzMzMzIi8+Cjwvc3ZnPgo="

/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 138 */,
/* 139 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(990)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(2472),
  /* scopeId */
  "data-v-6bf85731",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(951)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(491),
  /* template */
  __webpack_require__(2424),
  /* scopeId */
  "data-v-53f3d27f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(551),
  /* template */
  __webpack_require__(2295),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(912)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(658),
  /* template */
  __webpack_require__(2379),
  /* scopeId */
  "data-v-338f69d7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(913)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(686),
  /* template */
  __webpack_require__(2380),
  /* scopeId */
  "data-v-34b96bf4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 144 */,
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TOKEN_INVALID_CODES; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isTokenInvalid;

var TOKEN_INVALID_CODES = [1302, 1303, 1304, 1305, 1306];

function isTokenInvalid(error) {
  var httpStatus = error.response && error.response.status;
  var apiStatus = error.response && error.response.data && error.response.data.status;
  return httpStatus === 401 || httpStatus === 403 || TOKEN_INVALID_CODES.includes(apiStatus);
}

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getters__ = __webpack_require__(466);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_5__getters__["a" /* default */]
}));

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  callingAPI: false,
  searching: '',
  serverURI: 'http://10.110.1.136:8080',
  user: null,

  userId: '',
  token: '',
  roleType: 0,
  account: '',
  authError: '',
  brandId: '',
  brands: [],
  storeId: '',
  storeInfo: {},
  stores: [],
  menuStartTime: '',
  menuEndTime: '',

  upCategory: false,
  upAdjust: false,

  modal: false,

  selRoleType: 'admin',
  selManagerId: 1,
  modalView: false,

  blackReason: [],

  pickupList: [1, 2, 3, 4, 5, 21],

  unReadNotify: 0,
  tradeType: [],
  restrictedList: [],
  denyList: [],

  cityList: [],

  nidin_league: 0
});

/***/ }),
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = downloadFile;
function downloadFile(data, filename, mime, bom) {
  var url = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

  var blobData = typeof bom !== 'undefined' ? [bom, data] : [data];
  var blob = new Blob(blobData, { type: mime || 'application/octet-stream' });
  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    window.navigator.msSaveBlob(blob, filename);
  } else {
    var blobURL = window.URL && window.URL.createObjectURL ? window.URL.createObjectURL(blob) : window.webkitURL.createObjectURL(blob);
    var tempLink = document.createElement('a');
    tempLink.style.display = 'none';
    tempLink.href = url || blobURL;
    tempLink.setAttribute('download', filename);

    if (typeof tempLink.download === 'undefined') {
      tempLink.setAttribute('target', '_blank');
    }

    document.body.appendChild(tempLink);
    tempLink.click();

    setTimeout(function () {
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(blobURL);
    }, 200);
  }
}

/***/ }),
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),
/* 165 */,
/* 166 */
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(862)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(486),
  /* template */
  __webpack_require__(2308),
  /* scopeId */
  "data-v-097edf91",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1060)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(2564),
  /* scopeId */
  "data-v-efe12f4a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(502),
  /* template */
  __webpack_require__(2489),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(521),
  /* template */
  __webpack_require__(2371),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(970)
__webpack_require__(971)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(522),
  /* template */
  __webpack_require__(2451),
  /* scopeId */
  "data-v-61282631",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(914)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(2381),
  /* scopeId */
  "data-v-37f8f61c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(950)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(526),
  /* template */
  __webpack_require__(2423),
  /* scopeId */
  "data-v-53da6099",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(530),
  /* template */
  __webpack_require__(2349),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(531),
  /* template */
  __webpack_require__(2368),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(984)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(533),
  /* template */
  __webpack_require__(2466),
  /* scopeId */
  "data-v-6909aa70",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(961)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(534),
  /* template */
  __webpack_require__(2440),
  /* scopeId */
  "data-v-5b80521a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(981)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(541),
  /* template */
  __webpack_require__(2461),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(999)
__webpack_require__(1001)
__webpack_require__(1000)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(561),
  /* template */
  __webpack_require__(2484),
  /* scopeId */
  "data-v-775dff46",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(921)
__webpack_require__(923)
__webpack_require__(922)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(567),
  /* template */
  __webpack_require__(2392),
  /* scopeId */
  "data-v-413321c2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(994)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(602),
  /* template */
  __webpack_require__(2475),
  /* scopeId */
  "data-v-6eea97bc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(937)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(615),
  /* template */
  __webpack_require__(2407),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(867)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(618),
  /* template */
  __webpack_require__(2313),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(623),
  /* template */
  __webpack_require__(2566),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1010)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(624),
  /* template */
  __webpack_require__(2497),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(630),
  /* template */
  __webpack_require__(2479),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(909)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(636),
  /* template */
  __webpack_require__(2374),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1015)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(637),
  /* template */
  __webpack_require__(2503),
  /* scopeId */
  "data-v-808fbbd8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(927)
__webpack_require__(928)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(640),
  /* template */
  __webpack_require__(2397),
  /* scopeId */
  "data-v-45b119c6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1003)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(647),
  /* template */
  __webpack_require__(2486),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(889)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(648),
  /* template */
  __webpack_require__(2347),
  /* scopeId */
  "data-v-1c5f7d44",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(944)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(649),
  /* template */
  __webpack_require__(2415),
  /* scopeId */
  "data-v-4f246fd0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(930)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(651),
  /* template */
  __webpack_require__(2402),
  /* scopeId */
  "data-v-480f46e8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(963)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(652),
  /* template */
  __webpack_require__(2443),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1040)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(653),
  /* template */
  __webpack_require__(2536),
  /* scopeId */
  "data-v-ab97fd10",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(654),
  /* template */
  __webpack_require__(2459),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(853)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(662),
  /* template */
  __webpack_require__(2301),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(669),
  /* template */
  __webpack_require__(2317),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(670),
  /* template */
  __webpack_require__(2562),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(671),
  /* template */
  __webpack_require__(2460),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(672),
  /* template */
  __webpack_require__(2386),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(673),
  /* template */
  __webpack_require__(2556),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(674),
  /* template */
  __webpack_require__(2298),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1004)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(675),
  /* template */
  __webpack_require__(2487),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(676),
  /* template */
  __webpack_require__(2413),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1007)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(677),
  /* template */
  __webpack_require__(2493),
  /* scopeId */
  "data-v-7b572db7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(679),
  /* template */
  __webpack_require__(2320),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(680),
  /* template */
  __webpack_require__(2433),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(952)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(695),
  /* template */
  __webpack_require__(2426),
  /* scopeId */
  "data-v-54df9d27",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1043)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(697),
  /* template */
  __webpack_require__(2540),
  /* scopeId */
  "data-v-b94e10c8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(942)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(723),
  /* template */
  __webpack_require__(2412),
  /* scopeId */
  "data-v-4d105827",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(730),
  /* template */
  __webpack_require__(2521),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(731),
  /* template */
  __webpack_require__(2427),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(925)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(735),
  /* template */
  __webpack_require__(2394),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1039)
__webpack_require__(1038)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(736),
  /* template */
  __webpack_require__(2534),
  /* scopeId */
  "data-v-a79e1dbe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1032)
__webpack_require__(1031)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(741),
  /* template */
  __webpack_require__(2523),
  /* scopeId */
  "data-v-9e79dd66",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 414 */,
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/**
 * jQuery Gantt Chart
 *
 * @see http://taitems.github.io/jQuery.Gantt/
 * @license MIT
 */
/*jshint camelcase:true, freeze:true, jquery:true */
(function ($, undefined) {
    "use strict";

    var UTC_DAY_IN_MS = 24 * 60 * 60 * 1000;

    // custom selector `:findday` used to match on specified day in ms.
    //
    // The selector is passed a date in ms and elements are added to the
    // selection filter if the element date matches, as determined by the
    // id attribute containing a parsable date in ms.
    function findDay(elt, text) {
        var cd = new Date(parseInt(text, 10));
        cd.setHours(0, 0, 0, 0);
        var id = $(elt).attr("id") || "";
        var si = id.indexOf("-") + 1;
        var ed = new Date(parseInt(id.substring(si, id.length), 10));
        ed.setHours(0, 0, 0, 0);
        return cd.getTime() === ed.getTime();
    }
    $.expr.pseudos.findday = $.expr.createPseudo ?
        $.expr.createPseudo(function(text) {
            return function(elt) {
                return findDay(elt, text);
            };
        }) :
        function(elt, i, match) {
            return findDay(elt, match[3]);
        };

    // custom selector `:findweek` used to match on specified week in ms.
    function findWeek(elt, text) {
        var cd = new Date(parseInt(text, 10));
        var y = cd.getFullYear();
        var w = cd.getWeekOfYear();
        var m = cd.getMonth();
        if (m === 11 && w === 1) {
            y++;
        } else if (!m && w > 51) {
            y--;
        }
        cd = y + "-" + w;
        var id = $(elt).attr("id") || "";
        var si = id.indexOf("-") + 1;
        var ed = id.substring(si, id.length);
        return cd === ed;
    }
    $.expr.pseudos.findweek = $.expr.createPseudo ?
        $.expr.createPseudo(function(text) {
            return function(elt) {
                return findWeek(elt, text);
            };
        }) :
        function(elt, i, match) {
            return findWeek(elt, match[3]);
        };

    // custom selector `:findmonth` used to match on specified month in ms.
    function findMonth(elt, text) {
        var cd = new Date(parseInt(text, 10));
        cd = cd.getFullYear() + "-" + cd.getMonth();
        var id = $(elt).attr("id") || "";
        var si = id.indexOf("-") + 1;
        var ed = id.substring(si, id.length);
        return cd === ed;
    }
    $.expr[':'].findmonth = $.expr.createPseudo ?
        $.expr.createPseudo(function(text) {
            return function(elt) {
                return findMonth(elt, text);
            };
        }) :
        function(elt, i, match) {
            return findMonth(elt, match[3]);
        };

    // Date prototype helpers
    // ======================

    // `getWeekId` returns a string in the form of 'dh-YYYY-WW', where WW is
    // the week # for the year.
    // It is used to add an id to the week divs
    Date.prototype.getWeekId = function () {
        var y = this.getFullYear();
        var w = this.getWeekOfYear();
        var m = this.getMonth();
        if (m === 11 && w === 1) {
            y++;
        } else if (!m && w > 51) {
            y--;
        }
        return 'dh-' + y + "-" + w;
    };

    // `getRepDate` returns the milliseconds since the epoch for a given date
    // depending on the active scale
    Date.prototype.getRepDate = function (scale) {
        switch (scale) {
        case "hours":
            return this.getTime();
        case "weeks":
            return this.getDayForWeek().getTime();
        case "months":
            return new Date(this.getFullYear(), this.getMonth(), 1).getTime();
        case "days":
            /* falls through */
        default:
            return this.getTime();
        }
    };

    // `getDayOfYear` returns the day number for the year
    Date.prototype.getDayOfYear = function () {
        var year = this.getFullYear();
        return (Date.UTC(year, this.getMonth(), this.getDate()) -
                Date.UTC(year, 0, 0)) / UTC_DAY_IN_MS;
    };

    // Use ISO week by default
    //TODO: make these options.
    var firstDay = 1; // ISO week starts with Monday (1); use Sunday (0) for, e.g., North America
    var weekOneDate = 4; // ISO week one always contains 4 Jan; use 1 Jan for, e.g., North America

    // `getWeekOfYear` returns the week number for the year
    //TODO: fix bug when firstDay=6/weekOneDate=1 : https://github.com/moment/moment/issues/2115
    Date.prototype.getWeekOfYear = function () {
        var year = this.getFullYear(),
            month = this.getMonth(),
            date = this.getDate(),
            day = this.getDay();
        //var diff = weekOneDate - day + 7 * (day < firstDay ? -1 : 1);
        var diff = weekOneDate - day;
        if (day < firstDay) {
            diff -= 7;
        }
        if (diff + 7 < weekOneDate - firstDay) {
            diff += 7;
        }
        return Math.ceil(new Date(year, month, date + diff).getDayOfYear() / 7);
    };

    // `getDayForWeek` returns the first day of this Date's week
    Date.prototype.getDayForWeek = function () {
        var day = this.getDay();
        var diff = (day < firstDay ? -7 : 0) + firstDay - day;
        return new Date( this.getFullYear(), this.getMonth(), this.getDate() + diff );
    };

    // fixes https://github.com/taitems/jQuery.Gantt/issues/62
    function ktkGetNextDate(currentDate, scaleStep) {
        for(var minIncrements = 1;; minIncrements++) {
            var nextDate = new Date(currentDate);
            nextDate.setHours(currentDate.getHours() + scaleStep * minIncrements);

            if (nextDate.getTime() !== currentDate.getTime()) {
                return nextDate;
            }

            // If code reaches here, it's because current didn't really increment (invalid local time) because of daylight-saving adjustments
            // => retry adding 2, 3, 4 hours, and so on (until nextDate > current)
        }
    }

    $.fn.gantt = function (options) {

        var scales = ["hours", "days", "weeks", "months"];
        //Default settings
        var settings = {
            source: [],
            holidays: [],
            // paging
            itemsPerPage: 7,
            // localisation
            dow: ["S", "M", "T", "W", "T", "F", "S"],
            months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            waitText: "Please wait...",
            // navigation
            navigate: "buttons",
            scrollToToday: true,
            // cookie options
            useCookie: false,
            cookieKey: "jquery.fn.gantt",
            // scale parameters
            scale: "days",
            maxScale: "months",
            minScale: "hours",
            // callbacks
            onItemClick: function (data) { return; },
            onAddClick: function (dt, rowId) { return; },
            onRender: $.noop
        };

        // read options
        $.extend(settings, options);

        // can't use cookie if don't have `$.cookie`
        settings.useCookie = settings.useCookie && $.isFunction($.cookie);

        // Grid management
        // ===============

        // Core object is responsible for navigation and rendering
        var core = {
            // Return the element whose topmost point lies under the given point
            // Normalizes for old browsers (NOTE: doesn't work when element is outside viewport)
            //TODO: https://github.com/taitems/jQuery.Gantt/issues/137
            elementFromPoint: (function(){ // IIFE
                // version for normal browsers
                if (document.compatMode === "CSS1Compat") {
                    return function (x, y) {
                        x -= window.pageXOffset;
                        y -= window.pageYOffset;
                        return document.elementFromPoint(x, y);
                    };
                }
                // version for older browsers
                return function (x, y) {
                    x -= $(document).scrollLeft();
                    y -= $(document).scrollTop();
                    return document.elementFromPoint(x, y);
                };
            })(),

            // **Create the chart**
            create: function (element) {

                // Initialize data with a json object or fetch via an xhr
                // request depending on `settings.source`
                if (typeof settings.source !== "string") {
                    element.data = settings.source;
                    core.init(element);
                } else {
                    $.getJSON(settings.source, function (jsData) {
                        element.data = jsData;
                        core.init(element);
                    });
                }
            },

            // **Setup the initial view**
            // Here we calculate the number of rows, pages and visible start
            // and end dates once the data are ready
            init: function (element) {
                element.rowsNum = element.data.length;
                element.pageCount = Math.ceil(element.rowsNum / settings.itemsPerPage);
                element.rowsOnLastPage = element.rowsNum - (Math.floor(element.rowsNum / settings.itemsPerPage) * settings.itemsPerPage);

                element.dateStart = tools.getMinDate(element);
                element.dateEnd = tools.getMaxDate(element);


                /* core.render(element); */
                core.waitToggle(element, function () { core.render(element); });
            },

            // **Render the grid**
            render: function (element) {
                var content = $('<div class="fn-content"/>');
                var $leftPanel = core.leftPanel(element);
                content.append($leftPanel);
                var $rightPanel = core.rightPanel(element, $leftPanel);
                var pLeft, hPos;

                content.append($rightPanel);
                content.append(core.navigation(element));

                var $dataPanel = $rightPanel.find(".dataPanel");

                element.gantt = $('<div class="fn-gantt" />').append(content);

                $(element).empty().append(element.gantt);

                element.scrollNavigation.panelMargin = parseInt($dataPanel.css("left").replace("px", ""), 10);
                element.scrollNavigation.panelMaxPos = ($dataPanel.width() - $rightPanel.width());

                element.scrollNavigation.canScroll = ($dataPanel.width() > $rightPanel.width());

                core.markNow(element);
                core.fillData(element, $dataPanel, $leftPanel);

                // Set a cookie to record current position in the view
                if (settings.useCookie) {
                    var sc = $.cookie(settings.cookieKey + "ScrollPos");
                    if (sc) {
                        element.hPosition = sc;
                    }
                }

                // Scroll the grid to today's date
                if (settings.scrollToToday) {
                    core.navigateTo(element, 'now');
                    core.scrollPanel(element, 0);
                // or, scroll the grid to the left most date in the panel
                } else {
                    if (element.hPosition !== 0) {
                        if (element.scaleOldWidth) {
                            pLeft = ($dataPanel.width() - $rightPanel.width());
                            hPos = pLeft * element.hPosition / element.scaleOldWidth;
                            element.hPosition = hPos > 0 ? 0 : hPos;
                            element.scaleOldWidth = null;
                        }
                        $dataPanel.css({ "left": element.hPosition });
                        element.scrollNavigation.panelMargin = element.hPosition;
                    }
                    core.repositionLabel(element);
                }

                $dataPanel.css({ height: $leftPanel.height() });
                core.waitToggle(element);
                settings.onRender();
            },

            // Create and return the left panel with labels
            leftPanel: function (element) {
                /* Left panel */
                var ganttLeftPanel = $('<div class="leftPanel"/>')
                    .append($('<div class="row spacer"/>')
                    .css("height", tools.getCellSize() * element.headerRows));

                var entries = [];
                $.each(element.data, function (i, entry) {
                    if (i >= element.pageNum * settings.itemsPerPage &&
                        i < (element.pageNum * settings.itemsPerPage + settings.itemsPerPage)) {
                        var dataId = ('id' in entry) ? '" data-id="' + entry.id : '';
                        entries.push(
                            '<div class="row name row' + i +
                            (entry.desc ? '' : (' fn-wide '+dataId)) +
                            '" id="rowheader' + i +
                            '" data-offset="' + i % settings.itemsPerPage * tools.getCellSize() + '">' +
                            '<span class="fn-label' +
                            (entry.cssClass ? ' ' + entry.cssClass : '') + '">' +
                            (entry.name || '') +
                            '</span>' +
                            '</div>');

                        if (entry.desc) {
                            entries.push(
                                '<div class="row desc row' + i +
                                ' " id="RowdId_' + i + dataId + '">' +
                                '<span class="fn-label' +
                                (entry.cssClass ? ' ' + entry.cssClass : '') + '">' +
                                entry.desc +
                                '</span>' +
                                '</div>');
                        }

                    }
                });
                return ganttLeftPanel.append(entries.join(""));
            },

            // Create and return the data panel element
            dataPanel: function (element, width) {
                var dataPanel = $('<div class="dataPanel" style="width: ' + width + 'px;"/>');

                // Handle mousewheel events for scrolling the data panel
                var wheel = 'onwheel' in element ?
                    'wheel' : document.onmousewheel !== undefined ?
                    'mousewheel' : 'DOMMouseScroll';
                $(element).on(wheel, function (e) { core.wheelScroll(element, e); });

                // Handle click events and dispatch to registered `onAddClick` function
                dataPanel.click(function (e) {

                    e.stopPropagation();
                    var corrX/* <- never used? */, corrY;
                    var leftpanel = $(element).find(".fn-gantt .leftPanel");
                    var datapanel = $(element).find(".fn-gantt .dataPanel");
                    switch (settings.scale) {
                    case "months":
                        corrY = tools.getCellSize();
                        break;
                    case "hours":
                        corrY = tools.getCellSize() * 4;
                        break;
                    case "days":
                        corrY = tools.getCellSize() * 3;
                        break;
                    case "weeks":
                        /* falls through */
                    default:
                        corrY = tools.getCellSize() * 2;
                    }

                    /* Adjust, so get middle of elm
                    corrY -= Math.floor(tools.getCellSize() / 2);
                    */

                    // Find column where click occurred
                    var col = core.elementFromPoint(e.pageX, datapanel.offset().top + corrY);
                    // Was the label clicked directly?
                    if (col.className === "fn-label") {
                        col = $(col.parentNode);
                    } else {
                        col = $(col);
                    }

                    var dt = col.data("repdate");
                    // Find row where click occurred
                    var row = core.elementFromPoint(leftpanel.offset().left + leftpanel.width() - 10, e.pageY);
                    // Was the label clicked directly?
                    if (row.className.indexOf("fn-label") === 0) {
                        row = $(row.parentNode);
                    } else {
                        row = $(row);
                    }
                    var rowId = row.data('id');

                    // Dispatch user registered function with the DateTime in ms
                    // and the id if the clicked object is a row
                    settings.onAddClick(dt, rowId);
                });
                return dataPanel;
            },

            // Creates and return the right panel containing the year/week/day header
            rightPanel: function (element, leftPanel /* <- never used? */) {
                var range = null;
                // Days of the week have a class of one of
                // `sn` (Sunday), `sa` (Saturday), or `wd` (Weekday)
                var dowClass = ["sn", "wd", "wd", "wd", "wd", "wd", "sa"];
                //unused: was someone planning to allow styles to stretch to the bottom of the chart?
                //var gridDowClass = [" sn", "", "", "", "", "", " sa"];

                var yearArr = [];
                var scaleUnitsThisYear = 0;

                var monthArr = [];
                var scaleUnitsThisMonth = 0;

                var dayArr = [];
                var hoursInDay = 0;

                var dowArr = [];
                var horArr = [];

                var today = new Date();
                today.setHours(0, 0, 0, 0);

                // reused variables
                var $row = $('<div class="row header"></div>');
                var i, len;
                var year, month, week, day;
                var rday, dayClass;
                var dataPanel, dataPanelWidth;

                // Setup the headings based on the chosen `settings.scale`
                switch (settings.scale) {
                // **Hours**
                case "hours":
                    range = tools.parseTimeRange(element.dateStart, element.dateEnd, element.scaleStep);
                    dataPanelWidth = range.length * tools.getCellSize();

                    year = range[0].getFullYear();
                    month = range[0].getMonth();
                    day = range[0];

                    for (i = 0, len = range.length; i < len; i++) {
                        rday = range[i];

                        // Fill years
                        var rfy = rday.getFullYear();
                        if (rfy !== year) {
                            yearArr.push(
                                '<div class="row year" style="width: ' +
                                tools.getCellSize() * scaleUnitsThisYear +
                                'px;"><div class="fn-label">' +
                                year +
                                '</div></div>');

                            year = rfy;
                            scaleUnitsThisYear = 0;
                        }
                        scaleUnitsThisYear++;


                        // Fill months
                        var rm = rday.getMonth();
                        if (rm !== month) {
                            monthArr.push(
                                '<div class="row month" style="width: ' +
                                tools.getCellSize() * scaleUnitsThisMonth + 'px"><div class="fn-label">' +
                                settings.months[month] +
                                '</div></div>');

                            month = rm;
                            scaleUnitsThisMonth = 0;
                        }
                        scaleUnitsThisMonth++;

                        // Fill days & hours
                        var rgetDay = rday.getDay();
                        var getDay = day.getDay();
                        if (rgetDay !== getDay) {
                            dayClass = (today - day === 0) ?
                                "today" : tools.isHoliday( day.getTime() ) ?
                                "holiday" : dowClass[getDay];

                            dayArr.push(
                                '<div class="row date ' + dayClass + '" ' +
                                'style="width: ' + tools.getCellSize() * hoursInDay + 'px;">' +
                                '<div class="fn-label">' + day.getDate() + '</div></div>');
                            dowArr.push(
                                '<div class="row day ' + dayClass + '" ' +
                                'style="width: ' + tools.getCellSize() * hoursInDay + 'px;">' +
                                '<div class="fn-label">' + settings.dow[getDay] + '</div></div>');

                            day = rday;
                            hoursInDay = 0;
                        }
                        hoursInDay++;

                        dayClass = dowClass[rgetDay];
                        if (tools.isHoliday(rday)) {
                            dayClass = "holiday";
                        }
                        horArr.push(
                            '<div class="row day ' +
                            dayClass +
                            '" id="dh-' +
                            rday.getTime() +
                            '" data-offset="' + i * tools.getCellSize() +
                            '" data-repdate="' + rday.getRepDate(settings.scale) +
                            '"><div class="fn-label">' +
                            rday.getHours() +
                            '</div></div>');
                    }

                    // Last year
                    yearArr.push(
                        '<div class="row year" style="width: ' +
                        tools.getCellSize() * scaleUnitsThisYear + 'px;"><div class="fn-label">' +
                        year +
                        '</div></div>');

                    // Last month
                    monthArr.push(
                        '<div class="row month" style="width: ' +
                        tools.getCellSize() * scaleUnitsThisMonth + 'px"><div class="fn-label">' +
                        settings.months[month] +
                        '</div></div>');

                    dayClass = dowClass[day.getDay()];

                    if ( tools.isHoliday(day) ) {
                        dayClass = "holiday";
                    }

                    dayArr.push(
                        '<div class="row date ' + dayClass + '" ' +
                        'style="width: ' + tools.getCellSize() * hoursInDay + 'px;">' +
                        '<div class="fn-label">' + day.getDate() + '</div></div>');

                    dowArr.push(
                        '<div class="row day ' + dayClass + '" ' +
                        'style="width: ' + tools.getCellSize() * hoursInDay + 'px;">' +
                        '<div class="fn-label">' + settings.dow[day.getDay()] + '</div></div>');

                    dataPanel = core.dataPanel(element, dataPanelWidth);

                    // Append panel elements
                    dataPanel.append(
                        $row.clone().html(yearArr.join("")),
                        $row.clone().html(monthArr.join("")),
                        $row.clone().html(dayArr.join("")),
                        $row.clone().html(dowArr.join("")),
                        $row.clone().html(horArr.join(""))
                    );
                    break;

                // **Weeks**
                case "weeks":
                    range = tools.parseWeeksRange(element.dateStart, element.dateEnd);
                    dataPanelWidth = range.length * tools.getCellSize();

                    year = range[0].getFullYear();
                    month = range[0].getMonth();
                    week = range[0].getWeekOfYear();
                    var diff;

                    for (i = 0, len = range.length; i < len; i++) {
                        rday = range[i];

                        // Fill years
                        if (week > (week = rday.getWeekOfYear())) {
                            // partial weeks to subtract from year header
                            diff = rday.getDate() - 1;
                            // offset one month (December) if week starts in last year
                            diff -= !rday.getMonth() ? 0 : 31;
                            diff /= 7;
                            yearArr.push(
                                '<div class="row year" style="width: ' +
                                tools.getCellSize() * (scaleUnitsThisYear - diff) +
                                'px;"><div class="fn-label">' +
                                year +
                                '</div></div>');
                            year++;
                            scaleUnitsThisYear = diff;
                        }
                        scaleUnitsThisYear++;

                        // Fill months
                        if (rday.getMonth() !== month) {
                            // partial weeks to subtract from month header
                            diff = rday.getDate() - 1;
                            // offset one week if week starts in last month
                            //diff -= (diff <= 6) ? 0 : 7;
                            diff /= 7;
                            monthArr.push(
                                '<div class="row month" style="width:' +
                                tools.getCellSize() * (scaleUnitsThisMonth - diff) +
                                'px;"><div class="fn-label">' +
                                settings.months[month] +
                                '</div></div>');
                            month = rday.getMonth();
                            scaleUnitsThisMonth = diff;
                        }
                        scaleUnitsThisMonth++;

                        // Fill weeks
                        dayArr.push(
                            '<div class="row day wd"' +
                            ' id="' + rday.getWeekId() +
                            '" data-offset="' + i * tools.getCellSize() +
                            '" data-repdate="' + rday.getRepDate(settings.scale) + '">' +
                            '<div class="fn-label">' + week + '</div></div>');
                    }

                    // Last year
                    yearArr.push(
                        '<div class="row year" style="width: ' +
                        tools.getCellSize() * scaleUnitsThisYear + 'px;"><div class="fn-label">' +
                        year +
                        '</div></div>');

                    // Last month
                    monthArr.push(
                        '<div class="row month" style="width: ' +
                        tools.getCellSize() * scaleUnitsThisMonth + 'px"><div class="fn-label">' +
                        settings.months[month] +
                        '</div></div>');

                    dataPanel = core.dataPanel(element, dataPanelWidth);

                    // Append panel elements
                    dataPanel.append(
                        $row.clone().html(yearArr.join("")),
                        $row.clone().html(monthArr.join("")),
                        $row.clone().html(dayArr.join(""))
                    );
                    break;

                // **Months**
                case 'months':
                    range = tools.parseMonthsRange(element.dateStart, element.dateEnd);
                    dataPanelWidth = range.length * tools.getCellSize();

                    year = range[0].getFullYear();
                    month = range[0].getMonth();

                    for (i = 0, len = range.length; i < len; i++) {
                        rday = range[i];

                        // Fill years
                        if (rday.getFullYear() !== year) {
                            yearArr.push(
                                '<div class="row year" style="width: ' +
                                tools.getCellSize() * scaleUnitsThisYear +
                                'px;"><div class="fn-label">' +
                                year +
                                '</div></div>');
                            year = rday.getFullYear();
                            scaleUnitsThisYear = 0;
                        }
                        scaleUnitsThisYear++;
                        monthArr.push(
                            '<div class="row day wd" id="dh-' + tools.genId(rday) +
                            '" data-offset="' + i * tools.getCellSize() +
                            '" data-repdate="' + rday.getRepDate(settings.scale) + '">' +
                            (1 + rday.getMonth()) + '</div>');
                    }

                    // Last year
                    yearArr.push(
                        '<div class="row year" style="width: ' +
                        tools.getCellSize() * scaleUnitsThisYear + 'px;"><div class="fn-label">' +
                        year +
                        '</div></div>');

                    dataPanel = core.dataPanel(element, dataPanelWidth);

                    // Append panel elements
                    dataPanel.append(
                        $row.clone().html(yearArr.join("")),
                        $row.clone().html(monthArr.join(""))
                    );
                    break;

                // **Days (default)**
                default:
                    range = tools.parseDateRange(element.dateStart, element.dateEnd);
                    dataPanelWidth = range.length * tools.getCellSize();

                    var dateBefore = ktkGetNextDate(range[0], -1);
                    year = dateBefore.getFullYear();
                    month = dateBefore.getMonth();
                    //day = dateBefore; // <- never used?

                    for (i = 0, len = range.length; i < len; i++) {
                        rday = range[i];

                        // Fill years
                        if (rday.getFullYear() !== year) {
                            yearArr.push(
                                '<div class="row year" style="width:' +
                                tools.getCellSize() * scaleUnitsThisYear +
                                'px;"><div class="fn-label">' +
                                year +
                                '</div></div>');
                            year = rday.getFullYear();
                            scaleUnitsThisYear = 0;
                        }
                        scaleUnitsThisYear++;

                        // Fill months
                        if (rday.getMonth() !== month) {
                            monthArr.push(
                                '<div class="row month" style="width:' +
                                tools.getCellSize() * scaleUnitsThisMonth +
                                'px;"><div class="fn-label">' +
                                settings.months[month] +
                                '</div></div>');
                            month = rday.getMonth();
                            scaleUnitsThisMonth = 0;
                        }
                        scaleUnitsThisMonth++;

                        day = rday.getDay();
                        dayClass = dowClass[day];
                        if ( tools.isHoliday(rday) ) {
                            dayClass = "holiday";
                        }

                        dayArr.push(
                            '<div class="row date ' + dayClass + '"' +
                            ' id="dh-' + tools.genId(rday) +
                            '" data-offset="' + i * tools.getCellSize() +
                            '" data-repdate="' + rday.getRepDate(settings.scale) + '">' +
                            '<div class="fn-label">' + rday.getDate() + '</div></div>');
                        dowArr.push(
                            '<div class="row day ' + dayClass + '"' +
                            ' id="dw-' + tools.genId(rday) +
                            '" data-repdate="' + rday.getRepDate(settings.scale) + '">' +
                            '<div class="fn-label">' + settings.dow[day] + '</div></div>');
                    } //for

                    // Last year
                    yearArr.push(
                        '<div class="row year" style="width: ' +
                        tools.getCellSize() * scaleUnitsThisYear + 'px;"><div class="fn-label">' +
                        year +
                        '</div></div>');

                    // Last month
                    monthArr.push(
                        '<div class="row month" style="width: ' +
                        tools.getCellSize() * scaleUnitsThisMonth + 'px"><div class="fn-label">' +
                        settings.months[month] +
                        '</div></div>');

                    dataPanel = core.dataPanel(element, dataPanelWidth);

                    // Append panel elements
                    dataPanel.append(
                        $row.clone().html(yearArr.join("")),
                        $row.clone().html(monthArr.join("")),
                        $row.clone().html(dayArr.join("")),
                        $row.clone().html(dowArr.join(""))
                    );
                }

                return $('<div class="rightPanel"></div>').append(dataPanel);
            },

            // **Navigation**
            navigation: function (element) {
                var ganttNavigate = null;
                // Scrolling navigation is provided by setting
                // `settings.navigate='scroll'`
                if (settings.navigate === "scroll") {
                    ganttNavigate = $('<div class="navigate" />')
                        .append($('<div class="nav-slider" />')
                            .append($('<div class="nav-slider-left" />')
                                .append($('<button type="button" class="nav-link nav-page-back"/>')
                                    .html('&uarr;')
                                    .click(function () {
                                        core.navigatePage(element, -1);
                                    }))
                                .append($('<div class="page-number"/>')
                                        .append($('<span/>')
                                            .html(element.pageNum + 1 + ' / ' + element.pageCount)))
                                .append($('<button type="button" class="nav-link nav-page-next"/>')
                                    .html('&darr;')
                                    .click(function () {
                                        core.navigatePage(element, 1);
                                    }))
                                .append($('<button type="button" class="nav-link nav-now"/>')
                                    .html('&#9679;')
                                    .click(function () {
                                        core.navigateTo(element, 'now');
                                    }))
                                .append($('<button type="button" class="nav-link nav-prev-week"/>')
                                    .html('&lt;&lt;')
                                    .click(function () {
                                        if (settings.scale === 'hours') {
                                            core.navigateTo(element, tools.getCellSize() * 8);
                                        } else if (settings.scale === 'days') {
                                            core.navigateTo(element, tools.getCellSize() * 30);
                                        } else if (settings.scale === 'weeks') {
                                            core.navigateTo(element, tools.getCellSize() * 12);
                                        } else if (settings.scale === 'months') {
                                            core.navigateTo(element, tools.getCellSize() * 6);
                                        }
                                    }))
                                .append($('<button type="button" class="nav-link nav-prev-day"/>')
                                    .html('&lt;')
                                    .click(function () {
                                        if (settings.scale === 'hours') {
                                            core.navigateTo(element, tools.getCellSize() * 4);
                                        } else if (settings.scale === 'days') {
                                            core.navigateTo(element, tools.getCellSize() * 7);
                                        } else if (settings.scale === 'weeks') {
                                            core.navigateTo(element, tools.getCellSize() * 4);
                                        } else if (settings.scale === 'months') {
                                            core.navigateTo(element, tools.getCellSize() * 3);
                                        }
                                    })))
                            .append($('<div class="nav-slider-content" />')
                                    .append($('<div class="nav-slider-bar" />')
                                            .append($('<a class="nav-slider-button" />')
                                                )
                                                .mousedown(function (e) {
                                                    e.preventDefault();
                                                    element.scrollNavigation.scrollerMouseDown = true;
                                                    core.sliderScroll(element, e);
                                                })
                                                .mousemove(function (e) {
                                                    if (element.scrollNavigation.scrollerMouseDown) {
                                                        core.sliderScroll(element, e);
                                                    }
                                                })
                                            )
                                        )
                            .append($('<div class="nav-slider-right" />')
                                .append($('<button type="button" class="nav-link nav-next-day"/>')
                                    .html('&gt;')
                                    .click(function () {
                                        if (settings.scale === 'hours') {
                                            core.navigateTo(element, tools.getCellSize() * -4);
                                        } else if (settings.scale === 'days') {
                                            core.navigateTo(element, tools.getCellSize() * -7);
                                        } else if (settings.scale === 'weeks') {
                                            core.navigateTo(element, tools.getCellSize() * -4);
                                        } else if (settings.scale === 'months') {
                                            core.navigateTo(element, tools.getCellSize() * -3);
                                        }
                                    }))
                            .append($('<button type="button" class="nav-link nav-next-week"/>')
                                    .html('&gt;&gt;')
                                    .click(function () {
                                        if (settings.scale === 'hours') {
                                            core.navigateTo(element, tools.getCellSize() * -8);
                                        } else if (settings.scale === 'days') {
                                            core.navigateTo(element, tools.getCellSize() * -30);
                                        } else if (settings.scale === 'weeks') {
                                            core.navigateTo(element, tools.getCellSize() * -12);
                                        } else if (settings.scale === 'months') {
                                            core.navigateTo(element, tools.getCellSize() * -6);
                                        }
                                    }))
                                .append($('<button type="button" class="nav-link nav-zoomIn"/>')
                                    .html('&#43;')
                                    .click(function () {
                                        core.zoomInOut(element, -1);
                                    }))
                                .append($('<button type="button" class="nav-link nav-zoomOut"/>')
                                    .html('&#45;')
                                    .click(function () {
                                        core.zoomInOut(element, 1);
                                    }))
                                    )
                                );
                    $(document).mouseup(function () {
                        element.scrollNavigation.scrollerMouseDown = false;
                    });
                // Button navigation is provided by setting `settings.navigation='buttons'`
                } else {
                    ganttNavigate = $('<div class="navigate" />')
                        .append($('<button type="button" class="nav-link nav-page-back"/>')
                            .html('&uarr;')
                            .click(function () {
                                core.navigatePage(element, -1);
                            }))
                        .append($('<div class="page-number"/>')
                                .append($('<span/>')
                                    .html(element.pageNum + 1 + ' / ' + element.pageCount)))
                        .append($('<button type="button" class="nav-link nav-page-next"/>')
                            .html('&darr;')
                            .click(function () {
                                core.navigatePage(element, 1);
                            }))
                        .append($('<button type="button" class="nav-link nav-begin"/>')
                            .html('&#124;&lt;')
                            .click(function () {
                                core.navigateTo(element, 'begin');
                            }))
                        .append($('<button type="button" class="nav-link nav-prev-week"/>')
                            .html('&lt;&lt;')
                            .click(function () {
                                core.navigateTo(element, tools.getCellSize() * 7);
                            }))
                        .append($('<button type="button" class="nav-link nav-prev-day"/>')
                            .html('&lt;')
                            .click(function () {
                                core.navigateTo(element, tools.getCellSize());
                            }))
                        .append($('<button type="button" class="nav-link nav-now"/>')
                            .html('&#9679;')
                            .click(function () {
                                core.navigateTo(element, 'now');
                            }))
                        .append($('<button type="button" class="nav-link nav-next-day"/>')
                            .html('&gt;')
                            .click(function () {
                                core.navigateTo(element, tools.getCellSize() * -1);
                            }))
                        .append($('<button type="button" class="nav-link nav-next-week"/>')
                            .html('&gt;&gt;')
                            .click(function () {
                                core.navigateTo(element, tools.getCellSize() * -7);
                            }))
                        .append($('<button type="button" class="nav-link nav-end"/>')
                            .html('&gt;&#124;')
                            .click(function () {
                                core.navigateTo(element, 'end');
                            }))
                        .append($('<button type="button" class="nav-link nav-zoomIn"/>')
                            .html('&#43;')
                            .click(function () {
                                core.zoomInOut(element, -1);
                            }))
                        .append($('<button type="button" class="nav-link nav-zoomOut"/>')
                            .html('&#45;')
                            .click(function () {
                                core.zoomInOut(element, 1);
                            }));
                }
                return $('<div class="bottom"></div>').append(ganttNavigate);
            },

            // **Progress Bar**
            // Return an element representing a progress of position within the entire chart
            createProgressBar: function (label, desc, classNames, dataObj) {
                label = label || "";
                var bar = $('<div class="bar"><div class="fn-label">' + label + '</div></div>')
                        .data("dataObj", dataObj);
                if (desc) {
                    bar
                      .mouseenter(function (e) {
                          var hint = $('<div class="fn-gantt-hint" />').html(desc);
                          // $("body").append(hint);
                          var info = '<h4>' + dataObj.store_name + '</h4>' +
                            '<h5>菜單：' + dataObj.menu_name + ' (' + dataObj.menu_id + ')' + '</h5>' +
                            '<h5>開始時間：' + dataObj.start_time + '</h5>' +
                            '<h5>結束時間：' + dataObj.end_time + '</h5>'
                          $(".menu-info").html(info)
                          hint.css("left", e.pageX);
                          hint.css("top", e.pageY);
                          hint.show();
                      })
                      .mouseleave(function () {
                        var info_default = '<h4></h4>' +
                          '<h5></h5>' +
                          '<h5></h5>' +
                          '<h5></h5>'
                          $(".menu-info").html(info_default)
                          $(".fn-gantt-hint").remove();
                      })
                      .mousemove(function (e) {
                          $(".fn-gantt-hint").css("left", e.pageX);
                          $(".fn-gantt-hint").css("top", e.pageY + 15);
                      });
                }
                if (classNames) {
                    bar.addClass(classNames);
                }
                bar.click(function (e) {
                    e.stopPropagation();
                    settings.onItemClick($(this).data("dataObj"));
                });
                return bar;
            },

            // Remove the `wd` (weekday) class and add `today` class to the
            // current day/week/month (depending on the current scale)
            markNow: function (element) {
                var cd = new Date().setHours(0, 0, 0, 0);
                switch (settings.scale) {
                case "weeks":
                    $(element).find(':findweek("' + cd + '")').removeClass('wd').addClass('today');
                    break;
                case "months":
                    $(element).find(':findmonth("' + cd + '")').removeClass('wd').addClass('today');
                    break;
                case "days":
                    /* falls through */
                case "hours":
                    /* falls through */
                default:
                    $(element).find(':findday("' + cd + '")').removeClass('wd').addClass('today');
                }
            },

            // **Fill the Chart**
            // Parse the data and fill the data panel
            fillData: function (element, datapanel, leftpanel /* <- never used? */) {
                var cellWidth = tools.getCellSize();
                var barOffset = (cellWidth - 18) / 2;
                var dataPanelWidth = datapanel.width();
                var invertColor = function (colStr) {
                    try {
                        colStr = colStr.replace("rgb(", "").replace(")", "");
                        var rgbArr = colStr.split(",");
                        var R = parseInt(rgbArr[0], 10);
                        var G = parseInt(rgbArr[1], 10);
                        var B = parseInt(rgbArr[2], 10);
                        var gray = Math.round((255 - (0.299 * R + 0.587 * G + 0.114 * B)) * 0.9);
                        return "rgb(" + gray + ", " + gray + ", " + gray + ")";
                    } catch (err) {
                        return "";
                    }
                };
                // Loop through the values of each data element and set a row
                $.each(element.data, function (i, entry) {
                    if (i >= element.pageNum * settings.itemsPerPage &&
                        i < (element.pageNum * settings.itemsPerPage + settings.itemsPerPage)) {

                        $.each(entry.values, function (j, day) {
                            var _bar;
                            var from, to, cFrom, cTo, dFrom, dTo, dl, dp;
                            var topEl, top;
                            switch (settings.scale) {
                            // **Hourly data**
                            case "hours":
                                dFrom = tools.genId(tools.dateDeserialize(day.from), element.scaleStep);
                                from = $(element).find('#dh-' + dFrom);
                                dTo = tools.genId(tools.dateDeserialize(day.to), element.scaleStep);
                                to = $(element).find('#dh-' + dTo);
                                cFrom = from.data("offset");
                                cTo = to.data("offset");
                                dl = Math.floor((cTo - cFrom) / cellWidth) + 1;
                                dp = 100 * (cellWidth * dl - 1) / dataPanelWidth;

                                _bar = core.createProgressBar(day.label, day.desc, day.customClass, day.dataObj);

                                // find row
                                topEl = $(element).find("#rowheader" + i);
                                top = cellWidth * 5 + barOffset + topEl.data("offset");
                                _bar.css({
                                  top: top,
                                  left: Math.floor(cFrom),
                                  width: dp + '%'
                                });

                                datapanel.append(_bar);
                                break;

                            // **Weekly data**
                            case "weeks":
                                dFrom = tools.dateDeserialize(day.from);
                                dTo = tools.dateDeserialize(day.to);

                                from = $(element).find("#" + dFrom.getWeekId());
                                cFrom = from.data("offset");
                                to = $(element).find("#" + dTo.getWeekId());
                                cTo = to.data("offset");
                                dl = Math.round((cTo - cFrom) / cellWidth) + 1;
                                dp = 100 * (cellWidth * dl - 1) / dataPanelWidth;

                                _bar = core.createProgressBar(day.label, day.desc, day.customClass, day.dataObj);

                                // find row
                                topEl = $(element).find("#rowheader" + i);
                                top = cellWidth * 3 + barOffset + topEl.data("offset");
                                _bar.css({
                                  top: top,
                                  left: Math.floor(cFrom),
                                  width: dp + '%'
                                });

                                datapanel.append(_bar);
                                break;

                            // **Monthly data**
                            case "months":
                                dFrom = tools.dateDeserialize(day.from);
                                dTo = tools.dateDeserialize(day.to);

                                if (dFrom.getDate() <= 3 && dFrom.getMonth() === 0) {
                                    dFrom.setDate(dFrom.getDate() + 4);
                                }

                                if (dFrom.getDate() <= 3 && dFrom.getMonth() === 0) {
                                    dFrom.setDate(dFrom.getDate() + 4);
                                }

                                if (dTo.getDate() <= 3 && dTo.getMonth() === 0) {
                                    dTo.setDate(dTo.getDate() + 4);
                                }

                                from = $(element).find("#dh-" + tools.genId(dFrom));
                                cFrom = from.data("offset");
                                to = $(element).find("#dh-" + tools.genId(dTo));
                                cTo = to.data("offset");
                                dl = Math.round((cTo - cFrom) / cellWidth) + 1;
                                dp = 100 * (cellWidth * dl - 1) / dataPanelWidth;

                                _bar = core.createProgressBar(day.label, day.desc, day.customClass, day.dataObj);

                                // find row
                                topEl = $(element).find("#rowheader" + i);
                                top = cellWidth * 2 + barOffset + topEl.data("offset");
                                _bar.css({
                                  top: top,
                                  left: Math.floor(cFrom),
                                  width: dp + '%'
                                });

                                datapanel.append(_bar);
                                break;

                            // **Days**
                            case "days":
                                /* falls through */
                            default:
                                dFrom = tools.genId(tools.dateDeserialize(day.from));
                                dTo = tools.genId(tools.dateDeserialize(day.to));
                                from = $(element).find("#dh-" + dFrom);
                                cFrom = from.data("offset");
                                dl = Math.floor((dTo - dFrom) / UTC_DAY_IN_MS) + 1;
                                dp = 100 * (cellWidth * dl - 1) / dataPanelWidth;

                                _bar = core.createProgressBar(day.label, day.desc, day.customClass, day.dataObj);

                                // find row
                                topEl = $(element).find("#rowheader" + i);
                                top = cellWidth * 4 + barOffset + topEl.data("offset");
                                _bar.css({
                                  top: top,
                                  left: Math.floor(cFrom),
                                  width: dp + '%'
                                });

                                datapanel.append(_bar);
                            }

                            var $l = _bar.find(".fn-label");
                            if ($l.length) {
                                var gray = invertColor(_bar.css('backgroundColor'));
                                $l.css("color", gray);
                            }
                        });

                    }
                });
            },
            // **Navigation**
            navigateTo: function (element, val) {
                var $rightPanel = $(element).find(".fn-gantt .rightPanel");
                var $dataPanel = $rightPanel.find(".dataPanel");
                var rightPanelWidth = $rightPanel.width();
                var dataPanelWidth = $dataPanel.width();
                var shift = function () {
                  core.repositionLabel(element);
                };
                var maxLeft, curLeft;
                switch (val) {
                case "begin":
                    $dataPanel.animate({ "left": "0" }, "fast", shift);
                    element.scrollNavigation.panelMargin = 0;
                    break;
                case "end":
                    var pLeft = dataPanelWidth - rightPanelWidth;
                    element.scrollNavigation.panelMargin = pLeft * -1;
                    $dataPanel.animate({ "left": "-" + pLeft }, "fast", shift);
                    break;
                case "now":
                    if (!element.scrollNavigation.canScroll || !$dataPanel.find(".today").length) {
                        return false;
                    }
                    maxLeft = (dataPanelWidth - rightPanelWidth) * -1;
                    curLeft = $dataPanel.css("left").replace("px", "");
                    val = $dataPanel.find(".today").offset().left - $dataPanel.offset().left;
                    val *= -1;
                    if (val > 0) {
                        val = 0;
                    } else if (val < maxLeft) {
                        val = maxLeft;
                    }
                    $dataPanel.animate({ "left": val }, "fast", shift);
                    element.scrollNavigation.panelMargin = val;
                    break;
                default:
                    maxLeft = (dataPanelWidth - rightPanelWidth) * -1;
                    curLeft = $dataPanel.css("left").replace("px", "");
                    val = parseInt(curLeft, 10) + val;
                    if (val <= 0 && val >= maxLeft) {
                        $dataPanel.animate({ "left": val }, "fast", shift);
                    }
                    element.scrollNavigation.panelMargin = val;
                }
                core.synchronizeScroller(element);
            },

            // Navigate to a specific page
            navigatePage: function (element, val) {
                if ((element.pageNum + val) >= 0 &&
                    (element.pageNum + val) < Math.ceil(element.rowsNum / settings.itemsPerPage)) {
                    core.waitToggle(element, function () {
                        element.pageNum += val;
                        element.hPosition = $(".fn-gantt .dataPanel").css("left").replace("px", "");
                        element.scaleOldWidth = false;
                        core.init(element);
                    });
                }
            },

            // Change zoom level
            zoomInOut: function (element, val) {
                core.waitToggle(element, function () {

                    var zoomIn = (val < 0);

                    var scaleSt = element.scaleStep + val * 3;
                    scaleSt = scaleSt <= 1 ? 1 : scaleSt === 4 ? 3 : scaleSt;
                    var scale = settings.scale;
                    var headerRows = element.headerRows;
                    if (settings.scale === "hours" && scaleSt >= 13) {
                        scale = "days";
                        headerRows = 4;
                        scaleSt = 13;
                    } else if (settings.scale === "days" && zoomIn) {
                        scale = "hours";
                        headerRows = 5;
                        scaleSt = 12;
                    } else if (settings.scale === "days" && !zoomIn) {
                        scale = "weeks";
                        headerRows = 3;
                        scaleSt = 13;
                    } else if (settings.scale === "weeks" && !zoomIn) {
                        scale = "months";
                        headerRows = 2;
                        scaleSt = 14;
                    } else if (settings.scale === "weeks" && zoomIn) {
                        scale = "days";
                        headerRows = 4;
                        scaleSt = 13;
                    } else if (settings.scale === "months" && zoomIn) {
                        scale = "weeks";
                        headerRows = 3;
                        scaleSt = 13;
                    }

                    // do nothing if attempting to zoom past max/min
                    if ((zoomIn && $.inArray(scale, scales) < $.inArray(settings.minScale, scales)) ||
                        (!zoomIn && $.inArray(scale, scales) > $.inArray(settings.maxScale, scales))) {
                        core.init(element);
                        return;
                    }

                    element.scaleStep = scaleSt;
                    settings.scale = scale;
                    element.headerRows = headerRows;
                    var $rightPanel = $(element).find(".fn-gantt .rightPanel");
                    var $dataPanel = $rightPanel.find(".dataPanel");
                    element.hPosition = $dataPanel.css("left").replace("px", "");
                    element.scaleOldWidth = ($dataPanel.width() - $rightPanel.width());

                    if (settings.useCookie) {
                        $.cookie(settings.cookieKey + "CurrentScale", settings.scale);
                        // reset scrollPos
                        $.cookie(settings.cookieKey + "ScrollPos", null);
                    }
                    core.init(element);
                });
            },

            // Move chart via mouseclick
            mouseScroll: function (element, e) {
                var $dataPanel = $(element).find(".fn-gantt .dataPanel");
                $dataPanel.css("cursor", "move");
                var bPos = $dataPanel.offset();
                var mPos = element.scrollNavigation.mouseX === null ? e.pageX : element.scrollNavigation.mouseX;
                var delta = e.pageX - mPos;
                element.scrollNavigation.mouseX = e.pageX;

                core.scrollPanel(element, delta);

                clearTimeout(element.scrollNavigation.repositionDelay);
                element.scrollNavigation.repositionDelay = setTimeout(core.repositionLabel, 50, element);
            },

            // Move chart via mousewheel
            wheelScroll: function (element, e) {
                e.preventDefault(); // e is a jQuery Event

                // attempts to normalize scroll wheel velocity
                var delta = ( 'detail' in e ? e.detail :
                              'wheelDelta' in e.originalEvent ? - 1/120 * e.originalEvent.wheelDelta :
                              e.originalEvent.deltaY ? e.originalEvent.deltaY / Math.abs(e.originalEvent.deltaY) :
                              e.originalEvent.detail );

                // simpler normalization, ignoring per-device/browser/platform acceleration & semantic variations
                //var delta = e.detail || - (e = e.originalEvent).wheelData || e.deltaY /* || e.deltaX */ || e.detail;
                //delta = ( delta / Math.abs(delta) ) || 0;

                core.scrollPanel(element, -50 * delta);

                clearTimeout(element.scrollNavigation.repositionDelay);
                element.scrollNavigation.repositionDelay = setTimeout(core.repositionLabel, 50, element);
            },

            // Move chart via slider control
            sliderScroll: function (element, e) {
                var $sliderBar = $(element).find(".nav-slider-bar");
                var $sliderBarBtn = $sliderBar.find(".nav-slider-button");
                var $rightPanel = $(element).find(".fn-gantt .rightPanel");
                var $dataPanel = $rightPanel.find(".dataPanel");

                var bPos = $sliderBar.offset();
                var bWidth = $sliderBar.width();
                var wButton = $sliderBarBtn.width();

                var pos, pLeft;

                if ((e.pageX >= bPos.left) && (e.pageX <= bPos.left + bWidth)) {
                    pos = e.pageX - bPos.left;
                    pos = pos - wButton / 2;
                    $sliderBarBtn.css("left", pos);

                    pLeft = $dataPanel.width() - $rightPanel.width();

                    var pPos = pos * pLeft / bWidth * -1;
                    if (pPos >= 0) {
                        $dataPanel.css("left", "0");
                        element.scrollNavigation.panelMargin = 0;
                    } else if (pos >= bWidth - (wButton * 1)) {
                        $dataPanel.css("left", pLeft * -1);
                        element.scrollNavigation.panelMargin = pLeft * -1;
                    } else {
                        $dataPanel.css("left", pPos);
                        element.scrollNavigation.panelMargin = pPos;
                    }
                    clearTimeout(element.scrollNavigation.repositionDelay);
                    element.scrollNavigation.repositionDelay = setTimeout(core.repositionLabel, 5, element);
                }
            },

            // Update scroll panel margins
            scrollPanel: function (element, delta) {
                if (!element.scrollNavigation.canScroll) {
                    return false;
                }
                var _panelMargin = parseInt(element.scrollNavigation.panelMargin, 10) + delta;
                if (_panelMargin > 0) {
                    element.scrollNavigation.panelMargin = 0;
                    $(element).find(".fn-gantt .dataPanel").css("left", element.scrollNavigation.panelMargin);
                } else if (_panelMargin < element.scrollNavigation.panelMaxPos * -1) {
                    element.scrollNavigation.panelMargin = element.scrollNavigation.panelMaxPos * -1;
                    $(element).find(".fn-gantt .dataPanel").css("left", element.scrollNavigation.panelMargin);
                } else {
                    element.scrollNavigation.panelMargin = _panelMargin;
                    $(element).find(".fn-gantt .dataPanel").css("left", element.scrollNavigation.panelMargin);
                }
                core.synchronizeScroller(element);
            },

            // Synchronize scroller
            synchronizeScroller: function (element) {
                if (settings.navigate !== "scroll") { return; }
                var $rightPanel = $(element).find(".fn-gantt .rightPanel");
                var $dataPanel = $rightPanel.find(".dataPanel");
                var $sliderBar = $(element).find(".nav-slider-bar");
                var $sliderBtn = $sliderBar.find(".nav-slider-button");

                var bWidth = $sliderBar.width();
                var wButton = $sliderBtn.width();

                var pLeft = $dataPanel.width() - $rightPanel.width();
                var hPos = $dataPanel.css("left") || 0;
                if (hPos) {
                    hPos = hPos.replace("px", "");
                }
                var pos = hPos * bWidth / pLeft - $sliderBtn.width() * 0.25;
                pos = pos > 0 ? 0 : (pos * -1 >= bWidth - (wButton * 0.75)) ? (bWidth - (wButton * 1.25)) * -1 : pos;
                $sliderBtn.css("left", pos * -1);
            },

            // Reposition data labels
            repositionLabel: function (element) {
                setTimeout(function () {
                    var $dataPanel;
                    if (!element) {
                        $dataPanel = $(".fn-gantt .rightPanel .dataPanel");
                    } else {
                        var $rightPanel = $(element).find(".fn-gantt .rightPanel");
                        $dataPanel = $rightPanel.find(".dataPanel");
                    }

                    if (settings.useCookie) {
                        $.cookie(settings.cookieKey + "ScrollPos", $dataPanel.css("left").replace("px", ""));
                    }
                }, 500);
            },

            // waitToggle
            waitToggle: function (element, showCallback) {
                if ( $.isFunction(showCallback) ) {
                    var $elt = $(element);
                    var eo = $elt.offset();
                    var ew = $elt.outerWidth();
                    var eh = $elt.outerHeight();

                    if (!element.loader) {
                        element.loader = $('<div class="fn-gantt-loader">' +
                        '<div class="fn-gantt-loader-spinner"><span>' + settings.waitText + '</span></div></div>');
                    }
                    $elt.append(element.loader);
                    setTimeout(showCallback, 500);

                } else if (element.loader) {
                  element.loader.detach();
                }
            }
        };

        // Utility functions
        // =================
        var tools = {

            // Return the maximum available date in data depending on the scale
            getMaxDate: function (element) {
                var maxDate = null;
                $.each(element.data, function (i, entry) {
                    $.each(entry.values, function (i, date) {
                        maxDate = maxDate < tools.dateDeserialize(date.to) ? tools.dateDeserialize(date.to) : maxDate;
                    });
                });
                maxDate = maxDate || new Date();
                var bd;
                switch (settings.scale) {
                case "hours":
                    maxDate.setHours(Math.ceil((maxDate.getHours()) / element.scaleStep) * element.scaleStep);
                    maxDate.setHours(maxDate.getHours() + element.scaleStep * 3);
                    break;
                case "weeks":
                    // wtf is happening here?
                    bd = new Date(maxDate.getTime());
                    bd = new Date(bd.setDate(bd.getDate() + 3 * 7));
                    var md = Math.floor(bd.getDate() / 7) * 7;
                    maxDate = new Date(bd.getFullYear(), bd.getMonth(), md === 0 ? 4 : md - 3);
                    break;
                case "months":
                    bd = new Date(maxDate.getFullYear(), maxDate.getMonth(), 1);
                    bd.setMonth(bd.getMonth() + 2);
                    maxDate = new Date(bd.getFullYear(), bd.getMonth(), 1);
                    break;
                case "days":
                    /* falls through */
                default:
                    maxDate.setHours(0);
                    maxDate.setDate(maxDate.getDate() + 3);
                }
                return maxDate;
            },

            // Return the minimum available date in data depending on the scale
            getMinDate: function (element) {
                var minDate = null;
                $.each(element.data, function (i, entry) {
                    $.each(entry.values, function (i, date) {
                        minDate = minDate > tools.dateDeserialize(date.from) ||
                            minDate === null ? tools.dateDeserialize(date.from) : minDate;
                    });
                });
                minDate = minDate || new Date();
                switch (settings.scale) {
                case "hours":
                    minDate.setHours(Math.floor((minDate.getHours()) / element.scaleStep) * element.scaleStep);
                    minDate.setHours(minDate.getHours() - element.scaleStep * 3);
                    break;
                case "weeks":
                    // wtf is happening here?
                    var bd = new Date(minDate.getTime());
                    bd = new Date(bd.setDate(bd.getDate() - 3 * 7));
                    var md = Math.floor(bd.getDate() / 7) * 7;
                    minDate = new Date(bd.getFullYear(), bd.getMonth(), md === 0 ? 4 : md - 3);
                    break;
                case "months":
                    minDate.setHours(0, 0, 0, 0);
                    minDate.setDate(1);
                    minDate.setMonth(minDate.getMonth() - 3);
                    break;
                case "days":
                    /* falls through */
                default:
                    minDate.setHours(0, 0, 0, 0);
                    minDate.setDate(minDate.getDate() - 3);
                }
                return minDate;
            },

            // Return an array of Date objects between `from` and `to`
            parseDateRange: function (from, to) {
                var current = new Date(from.getTime());
                var ret = [];
                var i = 0;
                do {
                    ret[i++] = new Date(current.getTime());
                    current.setDate(current.getDate() + 1);
                } while (current <= to);
                return ret;
            },

            // Return an array of Date objects between `from` and `to`,
            // scaled hourly
            parseTimeRange: function (from, to, scaleStep) {
                var current = new Date(from);
                var end = new Date(to);

                // GR: Fix begin
                current.setHours(0, 0, 0, 0);

                end.setMilliseconds(0);
                end.setSeconds(0);
                if (end.getMinutes() > 0 || end.getHours() > 0) {
                    end.setMinutes(0);
                    end.setHours(0);
                    end.setTime(end.getTime() + UTC_DAY_IN_MS);
                }
                // GR: Fix end

                var ret = [];
                var i = 0;
                for(;;) {
                    var dayStartTime = new Date(current);
                    dayStartTime.setHours(Math.floor((current.getHours()) / scaleStep) * scaleStep);

                    if (ret[i] && dayStartTime.getDay() !== ret[i].getDay()) {
                        // If mark-cursor jumped to next day, make sure it starts at 0 hours
                        dayStartTime.setHours(0);
                    }
                    ret[i] = dayStartTime;

                    // Note that we use ">" because we want to include the end-time point.
                    if (current > to)  { break; }

                    /* BUG-2: current is moved backwards producing a dead-lock! (crashes chrome/IE/firefox)
                     * SEE: https://github.com/taitems/jQuery.Gantt/issues/62
                    if (current.getDay() !== ret[i].getDay()) {
                       current.setHours(0);
                    }
                    */

                    // GR Fix Begin
                    current = ktkGetNextDate(dayStartTime, scaleStep);
                    // GR Fix End

                    i++;
                }

                return ret;
            },

            // Return an array of Date objects between a range of weeks
            // between `from` and `to`
            parseWeeksRange: function (from, to) {
                var current = from.getDayForWeek();

                var ret = [];
                var i = 0;
                do {
                    ret[i++] = current.getDayForWeek();
                    current.setDate(current.getDate() + 7);
                } while (current <= to);

                return ret;
            },


            // Return an array of Date objects between a range of months
            // between `from` and `to`
            parseMonthsRange: function (from, to) {
                var current = new Date(from);
                var end = new Date(to); // <- never used?

                var ret = [];
                var i = 0;
                do {
                    ret[i++] = new Date(current.getFullYear(), current.getMonth(), 1);
                    current.setMonth(current.getMonth() + 1);
                } while (current <= to);

                return ret;
            },

            // Deserialize a date from a string or integer
            dateDeserialize: function (date) {
                if (typeof date === "string") {
                    date = date.replace(/\/Date\((.*)\)\//, "$1");
                    date = $.isNumeric(date) ? parseInt(date, 10) : $.trim(date);
                }
                return new Date( date );
            },

            // Generate an id for a date
            genId: function (t) { // varargs
                if ( $.isNumeric(t) ) {
                    t = new Date(t);
                }
                switch (settings.scale) {
                case "hours":
                    var hour = t.getHours();
                    if (arguments.length >= 2) {
                        hour = (Math.floor(t.getHours() / arguments[1]) * arguments[1]);
                    }
                    return (new Date(t.getFullYear(), t.getMonth(), t.getDate(), hour)).getTime();
                case "weeks":
                    var y = t.getFullYear();
                    var w = t.getWeekOfYear();
                    var m = t.getMonth();
                    if (m === 11 && w === 1) {
                        y++;
                    } else if (!m && w > 51) {
                        y--;
                    }
                    return y + "-" + w;
                case "months":
                    return t.getFullYear() + "-" + t.getMonth();
                case "days":
                    /* falls through */
                default:
                    return (new Date(t.getFullYear(), t.getMonth(), t.getDate())).getTime();
                }
            },

            // normalizes an array of dates into a map of start-of-day millisecond values
            _datesToDays: function ( dates ) {
                var dayMap = {};
                for (var i = 0, len = dates.length, day; i < len; i++) {
                    day = tools.dateDeserialize( dates[i] );
                    dayMap[ day.setHours(0, 0, 0, 0) ] = true;
                }
                return dayMap;
            },
            // Returns true when the given date appears in the array of holidays, if provided
            isHoliday: (function() { // IIFE
                // short-circuits the function if no holidays option was passed
                if (!settings.holidays || !settings.holidays.length) {
                  return function () { return false; };
                }
                var holidays = false;
                // returns the function that will be used to check for holidayness of a given date
                return function(date) {
                    if (!holidays) {
                      holidays = tools._datesToDays( settings.holidays );
                    }
                    return !!holidays[
                      // assumes numeric dates are already normalized to start-of-day
                      $.isNumeric(date) ?
                      date :
                      ( new Date(date.getFullYear(), date.getMonth(), date.getDate()) ).getTime()
                    ];
                };
            })(),

            // Get the current cell height
            getCellSize: function () {
                if (typeof tools._getCellSize === "undefined") {
                    var measure = $('<div style="display: none; position: absolute;" class="fn-gantt"><div class="row"></div></div>');
                    $("body").append(measure);
                    tools._getCellSize = measure.find(".row").height();
                    measure.empty().remove();
                }
                return tools._getCellSize;
            },

            // Get the current page height
            getPageHeight: function (element) {
                return element.pageNum + 1 === element.pageCount ? element.rowsOnLastPage * tools.getCellSize() : settings.itemsPerPage * tools.getCellSize();
            }
        };


        this.each(function () {
            this.data = null;        // Received data
            this.pageNum = 0;        // Current page number
            this.pageCount = 0;      // Available pages count
            this.rowsOnLastPage = 0; // How many rows on last page
            this.rowsNum = 0;        // Number of total rows
            this.hPosition = 0;      // Current position on diagram (Horizontal)
            this.dateStart = null;
            this.dateEnd = null;
            this.scrollClicked = false;
            this.scaleOldWidth = null;
            this.headerRows = null;

            // Update cookie with current scale
            if (settings.useCookie) {
                var sc = $.cookie(settings.cookieKey + "CurrentScale");
                if (sc) {
                    settings.scale = sc;
                } else {
                    $.cookie(settings.cookieKey + "CurrentScale", settings.scale);
                }
            }

            switch (settings.scale) {
            //case "hours":
            //    this.headerRows = 5;
            //    this.scaleStep = 8;
            //    break;
            case "hours":
                this.headerRows = 5;
                this.scaleStep = 1;
                break;
            case "weeks":
                this.headerRows = 3;
                this.scaleStep = 13;
                break;
            case "months":
                this.headerRows = 2;
                this.scaleStep = 14;
                break;
            case "days":
                /* falls through */
            default:
                this.headerRows = 4;
                this.scaleStep = 13;
            }

            this.scrollNavigation = {
                panelMouseDown: false,
                scrollerMouseDown: false,
                mouseX: null,
                panelMargin: 0,
                repositionDelay: 0,
                panelMaxPos: 0,
                canScroll: true
            };

            this.gantt = null;
            this.loader = null;

            core.create(this);

        });

    };
})(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = domain;
/* harmony export (immutable) */ __webpack_exports__["a"] = count;
/* harmony export (immutable) */ __webpack_exports__["c"] = prettyDate;
/* harmony export (immutable) */ __webpack_exports__["d"] = pluralize;
/* harmony export (immutable) */ __webpack_exports__["e"] = deliveryName;
/* harmony export (immutable) */ __webpack_exports__["f"] = orderStatusName;
/* harmony export (immutable) */ __webpack_exports__["h"] = shippingStatusName;
/* harmony export (immutable) */ __webpack_exports__["g"] = orderStateColor;
/* harmony export (immutable) */ __webpack_exports__["i"] = shippingStateColor;
/* harmony export (immutable) */ __webpack_exports__["k"] = tradeName;
/* harmony export (immutable) */ __webpack_exports__["l"] = cityCode;
/* harmony export (immutable) */ __webpack_exports__["j"] = shippingVendorName;
/* harmony export (immutable) */ __webpack_exports__["m"] = disItemSrcType;
/* harmony export (immutable) */ __webpack_exports__["n"] = disItemStatus;
/* harmony export (immutable) */ __webpack_exports__["o"] = disItemActionType;
var urlParser = document.createElement('a');

function domain(url) {
  urlParser.href = url;
  return urlParser.hostname;
}

function count(arr) {
  return arr.length;
}

function prettyDate(date) {
  var a = new Date(date);
  return a.toDateString();
}

function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }

  return time + label + 's';
}

function deliveryName(type) {
  if (type === 0) {
    return '所有取餐方式';
  } else if (type === 1) {
    return '自取';
  } else if (type === 2) {
    return '內用';
  } else if (type === 3) {
    return '外送';
  } else if (type === 4) {
    return '外帶';
  } else if (type === 5) {
    return '吧台';
  } else if (type === 21) {
    return '內用-桌邊掃碼';
  } else {
    return '無資料';
  }
}

function orderStatusName(state) {
  if (state === 0) {
    return '訂單尚未確認';
  } else if (state === 1) {
    return '訂單已送出，尚未付款';
  } else if (state === 2) {
    return '付款中';
  } else if (state === 3) {
    return '訂單已付款，尚未通知店家';
  } else if (state === 99) {
    return '客人取消';
  } else if (state === 100) {
    return '未接單';
  } else if (state === 110) {
    return '已接單';
  } else if (state === 120) {
    return '店家退訂';
  } else if (state === 121) {
    return '系統退訂';
  } else if (state === 122) {
    return '已取消';
  } else if (state === 130) {
    return '已完成';
  } else if (state === 140) {
    return '已作廢';
  }
}

function shippingStatusName(state) {
  if (state === 100) {
    return '成立物流單';
  } else if (state === 110) {
    return '物流接單';
  } else if (state === 120) {
    return '已分派外送員';
  } else if (state === 130) {
    return '已取貨';
  } else if (state === 140) {
    return '已送達';
  } else if (state === 900) {
    return '門市取消叫件';
  } else if (state === 920) {
    return '媒合失敗';
  }
}

function orderStateColor(state) {
  switch (state) {
    case 140:
    case 120:
    case 121:
    case 122:
    case 99:
      return 'label-danger';
    case 100:
      return 'label-default';
    case 110:
      return 'label-primary';
    case 130:
      return 'label-success';
    default:
      return 'label-warning';
  }
}

function shippingStateColor(state) {
  switch (state) {
    case 900:
    case 920:
      return 'label-danger';
    case 100:
      return 'label-default';
    case 110:
      return 'label-pink';
    case 120:
      return 'label-warning';
    case 130:
      return 'label-primary';
    case 140:
      return 'label-success';
    default:
      return 'label-default';
  }
}

function tradeName(type) {
  var name = '';
  switch (type) {
    case 1:
      name = '現金';
      break;
    case 701:
      name = 'iPASS MONEY';
      break;
    case 707:
      name = 'LINE PAY';
      break;
    case 709:
      name = '信用卡(台新)';
      break;
    case 706:
      name = '信用卡';
      break;
    case 710:
      name = '信用卡';
      break;
    case 713:
      name = '台灣Pay';
      break;
    case 716:
      name = '全盈+PAY';
      break;
    case 717:
      name = '悠遊付';
      break;
    case 718:
      name = 'Pi 拍錢包';
      break;
    case 719:
      name = '全支付';
      break;
    case 720:
      name = 'icash Pay';
      break;
    case 908:
      name = '街口支付';
      break;
    case 909:
      name = '遠傳電信代收';
      break;
    default:
      name = '其他';
      break;
  }
  return name;
}

function cityCode(cityList) {
  if (!cityList || !cityList.length) return '不限制';
  var cityName = cityList.map(function (item) {
    return item.name;
  });
  return cityName.join('、');
}

function shippingVendorName(code) {
  switch (code) {
    case 'glo':
      return '全球快遞';
    case 'mete-mix':
      return 'AI 混合自動派件';
    case 'mete-pg':
      return 'Pandago';
    case 'mete-ud':
      return 'Uber Direct';
    case 'mete-lm':
      return 'Lalamove';
    case 'mete-glo':
      return '全球快遞';
    case 'pandago':
      return 'Pandago';
    default:
      return '-';
  }
}

function disItemSrcType(type) {
  var name = '';
  switch (type) {
    case 1:
      name = 'ECMS';
      break;
    case 2:
      name = 'POS';
      break;
    case 3:
      name = '接單APP';
      break;
    default:
      name = '其他';
      break;
  }
  return name;
}

function disItemStatus(type) {
  var name = '';
  switch (type) {
    case 0:
      name = '多店解除停賣';
      break;
    case 1:
      name = '多店停賣';
      break;
    default:
      name = '其他';
      break;
  }
  return name;
}

function disItemActionType(type) {
  var name = '';
  switch (type) {
    case 0:
      name = '永久停賣';
      break;
    case 2:
      name = '當日停賣';
      break;
    default:
      name = '其他';
      break;
  }
  return name;
}

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dash_vue__ = __webpack_require__(2087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dash_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Dash_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login_vue__ = __webpack_require__(2088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_404_vue__ = __webpack_require__(2086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_404_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_Dashboard_vue__ = __webpack_require__(2142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_Dashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_views_Dashboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_BrandDashboard_vue__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_BrandDashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_views_BrandDashboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_Account_AccountTable_vue__ = __webpack_require__(2098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_Account_AccountTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_views_Account_AccountTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_Account_CrAccount_vue__ = __webpack_require__(2099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_Account_CrAccount_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_views_Account_CrAccount_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_Account_UpAccount_vue__ = __webpack_require__(2101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_Account_UpAccount_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_views_Account_UpAccount_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_views_LineNotify_LineNotifyTable_vue__ = __webpack_require__(2164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_views_LineNotify_LineNotifyTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_views_LineNotify_LineNotifyTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_views_Member_MemberTable_vue__ = __webpack_require__(2190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_views_Member_MemberTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_views_Member_MemberTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_views_Member_MemberOrderTable_vue__ = __webpack_require__(2189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_views_Member_MemberOrderTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_views_Member_MemberOrderTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_views_Member_MemberIdentityTable_vue__ = __webpack_require__(2187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_views_Member_MemberIdentityTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_views_Member_MemberIdentityTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_views_Member_UpMember_vue__ = __webpack_require__(2196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_views_Member_UpMember_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_views_Member_UpMember_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_views_Member_MemberInfo_vue__ = __webpack_require__(2188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_views_Member_MemberInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_views_Member_MemberInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_views_Member_UpgradeMemberInfo_vue__ = __webpack_require__(2197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_views_Member_UpgradeMemberInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_views_Member_UpgradeMemberInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_views_Member_ShopperMoneyTable_vue__ = __webpack_require__(2192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_views_Member_ShopperMoneyTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_views_Member_ShopperMoneyTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_views_Member_OneShopperMoney_vue__ = __webpack_require__(2191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_views_Member_OneShopperMoney_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_views_Member_OneShopperMoney_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_views_Platform_PlatformTable_vue__ = __webpack_require__(2242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_views_Platform_PlatformTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_views_Platform_PlatformTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_views_Platform_AdTable_vue__ = __webpack_require__(2238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_views_Platform_AdTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_views_Platform_AdTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_views_Platform_CrAd_vue__ = __webpack_require__(2239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_views_Platform_CrAd_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_views_Platform_CrAd_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_views_Platform_UpAd_vue__ = __webpack_require__(2247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_views_Platform_UpAd_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_views_Platform_UpAd_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_views_Platform_MealTagTable_vue__ = __webpack_require__(2241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_views_Platform_MealTagTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_views_Platform_MealTagTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_views_Platform_MealTagForm_vue__ = __webpack_require__(2240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_views_Platform_MealTagForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_views_Platform_MealTagForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_views_TradeSetting_vue__ = __webpack_require__(2280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_views_TradeSetting_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_views_TradeSetting_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_views_Brand_BrandTable_vue__ = __webpack_require__(2108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_views_Brand_BrandTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_views_Brand_BrandTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_views_Brand_StoreTable_vue__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_views_Brand_StoreTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_views_Brand_StoreTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_views_Brand_GroupTable_vue__ = __webpack_require__(2116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_views_Brand_GroupTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_views_Brand_GroupTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_views_Brand_CrBrand_vue__ = __webpack_require__(2112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_views_Brand_CrBrand_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_views_Brand_CrBrand_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_views_Brand_UpBrand_vue__ = __webpack_require__(2123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_views_Brand_UpBrand_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_views_Brand_UpBrand_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_views_Brand_CrStore_vue__ = __webpack_require__(2115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_views_Brand_CrStore_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_views_Brand_CrStore_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_views_Brand_CrGroup_vue__ = __webpack_require__(2114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_views_Brand_CrGroup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_views_Brand_CrGroup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_views_Brand_UpStore_vue__ = __webpack_require__(2126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_views_Brand_UpStore_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_views_Brand_UpStore_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_views_Brand_UpGroup_vue__ = __webpack_require__(2125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_views_Brand_UpGroup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_views_Brand_UpGroup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_views_Brand_BrandInfo_vue__ = __webpack_require__(2107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_views_Brand_BrandInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_views_Brand_BrandInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_views_Brand_StoreInfo_vue__ = __webpack_require__(2117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_views_Brand_StoreInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_views_Brand_StoreInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_views_Brand_store_group_vue__ = __webpack_require__(2127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_views_Brand_store_group_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_views_Brand_store_group_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_views_Brand_ChangeStoresIcon_vue__ = __webpack_require__(2109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_views_Brand_ChangeStoresIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_views_Brand_ChangeStoresIcon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_views_Brand_AdTable_vue__ = __webpack_require__(2104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_views_Brand_AdTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_views_Brand_AdTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_views_Brand_CrAd_vue__ = __webpack_require__(2111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_views_Brand_CrAd_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_views_Brand_CrAd_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_views_Brand_UpAd_vue__ = __webpack_require__(2122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_views_Brand_UpAd_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_views_Brand_UpAd_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_views_Brand_CopyAd_vue__ = __webpack_require__(2110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_views_Brand_CopyAd_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_views_Brand_CopyAd_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_views_Brand_BrandAdTable_vue__ = __webpack_require__(2106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_views_Brand_BrandAdTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_views_Brand_BrandAdTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_views_Brand_CrBrandAd_vue__ = __webpack_require__(2113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_views_Brand_CrBrandAd_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_views_Brand_CrBrandAd_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_views_Brand_UpBrandAd_vue__ = __webpack_require__(2124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_views_Brand_UpBrandAd_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_views_Brand_UpBrandAd_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_views_Brand_BatchSetupStore_vue__ = __webpack_require__(2105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_views_Brand_BatchSetupStore_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_views_Brand_BatchSetupStore_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_views_Order_OrderTable_vue__ = __webpack_require__(2234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_views_Order_OrderTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_views_Order_OrderTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_views_Order_OrderExceptionTable_vue__ = __webpack_require__(2232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_views_Order_OrderExceptionTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_views_Order_OrderExceptionTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_views_Order_OrderInfo_vue__ = __webpack_require__(2233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_views_Order_OrderInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__components_views_Order_OrderInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_views_Order_BlackListTable_vue__ = __webpack_require__(2231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_views_Order_BlackListTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__components_views_Order_BlackListTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_views_Order_menuquerystringview_vue__ = __webpack_require__(2237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_views_Order_menuquerystringview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__components_views_Order_menuquerystringview_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_views_Menu_MenuTable_vue__ = __webpack_require__(2211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_views_Menu_MenuTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__components_views_Menu_MenuTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_views_Menu_MenuDetailTable_vue__ = __webpack_require__(2206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_views_Menu_MenuDetailTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__components_views_Menu_MenuDetailTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_views_Menu_menu_build_vue__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_views_Menu_menu_build_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__components_views_Menu_menu_build_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_views_Menu_MenuInfo_vue__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_views_Menu_MenuInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__components_views_Menu_MenuInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_views_Menu_menu_step_vue__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_views_Menu_menu_step_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__components_views_Menu_menu_step_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_views_Menu_CrMenu_vue__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_views_Menu_CrMenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__components_views_Menu_CrMenu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_views_Menu_CrMenuProduct_vue__ = __webpack_require__(2202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_views_Menu_CrMenuProduct_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__components_views_Menu_CrMenuProduct_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_views_Menu_CrMenuOption_vue__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_views_Menu_CrMenuOption_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__components_views_Menu_CrMenuOption_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_views_Menu_CrCombination_vue__ = __webpack_require__(2198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_views_Menu_CrCombination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__components_views_Menu_CrCombination_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_views_Menu_CrJoinMenu_vue__ = __webpack_require__(2201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_views_Menu_CrJoinMenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__components_views_Menu_CrJoinMenu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_views_Menu_Temp_store_menu_table_vue__ = __webpack_require__(2227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_views_Menu_Temp_store_menu_table_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__components_views_Menu_Temp_store_menu_table_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_views_Menu_UpMenu_vue__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_views_Menu_UpMenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__components_views_Menu_UpMenu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_views_Menu_UpMenuProduct_vue__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_views_Menu_UpMenuProduct_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__components_views_Menu_UpMenuProduct_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_views_Menu_up_menu_adjust_vue__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_views_Menu_up_menu_adjust_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__components_views_Menu_up_menu_adjust_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_views_Menu_up_menu_option_vue__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_views_Menu_up_menu_option_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__components_views_Menu_up_menu_option_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_views_Menu_UpMenuCategory_vue__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_views_Menu_UpMenuCategory_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__components_views_Menu_UpMenuCategory_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_views_Menu_UpMenuBlock_vue__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_views_Menu_UpMenuBlock_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__components_views_Menu_UpMenuBlock_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_views_Menu_UpMenuPackage_vue__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_views_Menu_UpMenuPackage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__components_views_Menu_UpMenuPackage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_views_Menu_UpCombination_vue__ = __webpack_require__(2228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_views_Menu_UpCombination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__components_views_Menu_UpCombination_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_views_Menu_UpCombinationPrice_vue__ = __webpack_require__(2229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_views_Menu_UpCombinationPrice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__components_views_Menu_UpCombinationPrice_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_views_Menu_UpJoinMenu_vue__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_views_Menu_UpJoinMenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__components_views_Menu_UpJoinMenu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_views_Menu_binding_pos_vue__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_views_Menu_binding_pos_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__components_views_Menu_binding_pos_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_views_Menu_CrBinding_vue__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_views_Menu_CrBinding_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__components_views_Menu_CrBinding_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_views_Menu_ProductImage_vue__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_views_Menu_ProductImage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__components_views_Menu_ProductImage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_views_Menu_ProductSetting_vue__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_views_Menu_ProductSetting_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__components_views_Menu_ProductSetting_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_views_Menu_CrImgSetting_vue__ = __webpack_require__(2200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_views_Menu_CrImgSetting_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76__components_views_Menu_CrImgSetting_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_views_Menu_CrProductSetting_vue__ = __webpack_require__(2203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_views_Menu_CrProductSetting_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77__components_views_Menu_CrProductSetting_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_views_Menu_CrIconSetting_vue__ = __webpack_require__(2199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_views_Menu_CrIconSetting_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__components_views_Menu_CrIconSetting_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_views_Menu_CrStoreClass_vue__ = __webpack_require__(2204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_views_Menu_CrStoreClass_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79__components_views_Menu_CrStoreClass_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_views_Menu_Temp_CopyStoreTemp_vue__ = __webpack_require__(2213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_views_Menu_Temp_CopyStoreTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80__components_views_Menu_Temp_CopyStoreTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_views_Menu_CupDiscountTable_vue__ = __webpack_require__(2205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_views_Menu_CupDiscountTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81__components_views_Menu_CupDiscountTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_views_Schedule_ScheduleTable_vue__ = __webpack_require__(2276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_views_Schedule_ScheduleTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82__components_views_Schedule_ScheduleTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_views_Schedule_StoreScheduleTable_vue__ = __webpack_require__(2277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_views_Schedule_StoreScheduleTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83__components_views_Schedule_StoreScheduleTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_views_Schedule_BrandScheduleTable_vue__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_views_Schedule_BrandScheduleTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84__components_views_Schedule_BrandScheduleTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__components_views_Schedule_UpSchedule_vue__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__components_views_Schedule_UpSchedule_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85__components_views_Schedule_UpSchedule_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__components_views_Schedule_CrSchedule_vue__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__components_views_Schedule_CrSchedule_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86__components_views_Schedule_CrSchedule_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__components_views_History_BrandHistoryTable_vue__ = __webpack_require__(2156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__components_views_History_BrandHistoryTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87__components_views_History_BrandHistoryTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__components_views_History_StoreHistoryTable_vue__ = __webpack_require__(2161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__components_views_History_StoreHistoryTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88__components_views_History_StoreHistoryTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__components_views_History_OneStoreHistoryTable_vue__ = __webpack_require__(2159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__components_views_History_OneStoreHistoryTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89__components_views_History_OneStoreHistoryTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__components_views_History_OneDayHistoryTable_vue__ = __webpack_require__(2158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__components_views_History_OneDayHistoryTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90__components_views_History_OneDayHistoryTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__components_views_History_SearchHistory_vue__ = __webpack_require__(2160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__components_views_History_SearchHistory_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91__components_views_History_SearchHistory_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__components_views_History_HistoryOrderInfo_vue__ = __webpack_require__(2157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__components_views_History_HistoryOrderInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92__components_views_History_HistoryOrderInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__components_views_Chart_ChartDash_vue__ = __webpack_require__(2132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__components_views_Chart_ChartDash_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93__components_views_Chart_ChartDash_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__components_views_Chart_WeekChartDash_vue__ = __webpack_require__(2140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__components_views_Chart_WeekChartDash_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94__components_views_Chart_WeekChartDash_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__components_views_Chart_SearchMap_vue__ = __webpack_require__(2134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__components_views_Chart_SearchMap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_95__components_views_Chart_SearchMap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__components_views_Chart_CouponChart_vue__ = __webpack_require__(2133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__components_views_Chart_CouponChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_96__components_views_Chart_CouponChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__components_views_RealTime_DisItemTableOld_vue__ = __webpack_require__(2257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__components_views_RealTime_DisItemTableOld_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_97__components_views_RealTime_DisItemTableOld_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__components_views_RealTime_DisItemTable_vue__ = __webpack_require__(2255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__components_views_RealTime_DisItemTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_98__components_views_RealTime_DisItemTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__components_views_RealTime_DisProdu_vue__ = __webpack_require__(2259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__components_views_RealTime_DisProdu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_99__components_views_RealTime_DisProdu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__components_views_RealTime_MqttTable_vue__ = __webpack_require__(2263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__components_views_RealTime_MqttTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_100__components_views_RealTime_MqttTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__components_views_RealTime_MqttSearch_vue__ = __webpack_require__(2262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__components_views_RealTime_MqttSearch_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_101__components_views_RealTime_MqttSearch_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__components_views_RealTime_TableSetting_vue__ = __webpack_require__(2267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__components_views_RealTime_TableSetting_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_102__components_views_RealTime_TableSetting_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__components_views_RealTime_PrinterTable_vue__ = __webpack_require__(2266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__components_views_RealTime_PrinterTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_103__components_views_RealTime_PrinterTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__components_views_RealTime_PrinterInfo_vue__ = __webpack_require__(2264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__components_views_RealTime_PrinterInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_104__components_views_RealTime_PrinterInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__components_views_RealTime_CrPrinter_vue__ = __webpack_require__(2252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__components_views_RealTime_CrPrinter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_105__components_views_RealTime_CrPrinter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__components_views_RealTime_UpPrinter_vue__ = __webpack_require__(2274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__components_views_RealTime_UpPrinter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_106__components_views_RealTime_UpPrinter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__components_views_RealTime_CrPrinterStore_vue__ = __webpack_require__(2253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__components_views_RealTime_CrPrinterStore_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_107__components_views_RealTime_CrPrinterStore_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__components_views_RealTime_UpPrinterStore_vue__ = __webpack_require__(2275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__components_views_RealTime_UpPrinterStore_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_108__components_views_RealTime_UpPrinterStore_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__components_views_RealTime_PrinterStoreTable_vue__ = __webpack_require__(2265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__components_views_RealTime_PrinterStoreTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_109__components_views_RealTime_PrinterStoreTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__components_views_RealTime_DisScheduleItemTable_vue__ = __webpack_require__(2260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__components_views_RealTime_DisScheduleItemTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_110__components_views_RealTime_DisScheduleItemTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__components_views_RealTime_LimitedScheduleItemTable_vue__ = __webpack_require__(2261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__components_views_RealTime_LimitedScheduleItemTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_111__components_views_RealTime_LimitedScheduleItemTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__components_views_RealTime_CrDisableSchedule_vue__ = __webpack_require__(2251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__components_views_RealTime_CrDisableSchedule_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_112__components_views_RealTime_CrDisableSchedule_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__components_views_RealTime_CopylimitedSchedule_vue__ = __webpack_require__(2250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__components_views_RealTime_CopylimitedSchedule_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_113__components_views_RealTime_CopylimitedSchedule_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__components_views_RealTime_CrlimitedSchedule_vue__ = __webpack_require__(2254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__components_views_RealTime_CrlimitedSchedule_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_114__components_views_RealTime_CrlimitedSchedule_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__components_views_RealTime_DisItemTableBrand_vue__ = __webpack_require__(2256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__components_views_RealTime_DisItemTableBrand_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_115__components_views_RealTime_DisItemTableBrand_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__components_views_RealTime_DisItemTableStore_vue__ = __webpack_require__(2258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__components_views_RealTime_DisItemTableStore_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_116__components_views_RealTime_DisItemTableStore_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__components_views_Marketing_MarketingScheduleTable_vue__ = __webpack_require__(2171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__components_views_Marketing_MarketingScheduleTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_117__components_views_Marketing_MarketingScheduleTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__components_views_Marketing_CrActivity_vue__ = __webpack_require__(2170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__components_views_Marketing_CrActivity_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_118__components_views_Marketing_CrActivity_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__components_views_Marketing_ActivityInfo_vue__ = __webpack_require__(2167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__components_views_Marketing_ActivityInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_119__components_views_Marketing_ActivityInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__components_views_Marketing_Temp_ActivityInfoTemp_vue__ = __webpack_require__(2177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__components_views_Marketing_Temp_ActivityInfoTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_120__components_views_Marketing_Temp_ActivityInfoTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__components_views_Marketing_ActivityInfoForm_vue__ = __webpack_require__(2168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__components_views_Marketing_ActivityInfoForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_121__components_views_Marketing_ActivityInfoForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__components_views_Marketing_CouponTable_vue__ = __webpack_require__(2169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__components_views_Marketing_CouponTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_122__components_views_Marketing_CouponTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__components_views_Marketing_UpCouponTable_vue__ = __webpack_require__(2186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__components_views_Marketing_UpCouponTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_123__components_views_Marketing_UpCouponTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__components_views_Marketing_OperatingChart_vue__ = __webpack_require__(2172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__components_views_Marketing_OperatingChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_124__components_views_Marketing_OperatingChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__components_views_Marketing_SystemUsage_vue__ = __webpack_require__(2173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__components_views_Marketing_SystemUsage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_125__components_views_Marketing_SystemUsage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__components_views_Discount_DiscountTable_vue__ = __webpack_require__(2150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__components_views_Discount_DiscountTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_126__components_views_Discount_DiscountTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__components_views_Discount_ChooseDiscount_vue__ = __webpack_require__(2147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__components_views_Discount_ChooseDiscount_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_127__components_views_Discount_ChooseDiscount_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__components_views_Discount_CrDiscount_vue__ = __webpack_require__(2148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__components_views_Discount_CrDiscount_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_128__components_views_Discount_CrDiscount_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__components_views_Discount_UpDiscountTable_vue__ = __webpack_require__(2155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__components_views_Discount_UpDiscountTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_129__components_views_Discount_UpDiscountTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__components_views_Discount_UpDiscount_vue__ = __webpack_require__(2153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__components_views_Discount_UpDiscount_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_130__components_views_Discount_UpDiscount_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__components_views_Discount_DiscountInfo_vue__ = __webpack_require__(2149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__components_views_Discount_DiscountInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_131__components_views_Discount_DiscountInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__components_views_Discount_UpDiscountStore_vue__ = __webpack_require__(2154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__components_views_Discount_UpDiscountStore_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_132__components_views_Discount_UpDiscountStore_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__components_views_CashAccount_CashAccountTable_vue__ = __webpack_require__(2131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__components_views_CashAccount_CashAccountTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_133__components_views_CashAccount_CashAccountTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__components_views_CashAccount_CashAccountErrorTable_vue__ = __webpack_require__(2129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__components_views_CashAccount_CashAccountErrorTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_134__components_views_CashAccount_CashAccountErrorTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__components_views_CashAccount_CashAccountInfo_vue__ = __webpack_require__(2130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__components_views_CashAccount_CashAccountInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_135__components_views_CashAccount_CashAccountInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__components_views_CashAccount_AccountSearch_vue__ = __webpack_require__(2128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__components_views_CashAccount_AccountSearch_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_136__components_views_CashAccount_AccountSearch_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__components_views_Designated_DesignatedTable_vue__ = __webpack_require__(2144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__components_views_Designated_DesignatedTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_137__components_views_Designated_DesignatedTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__components_views_Designated_CrDesignated_vue__ = __webpack_require__(2143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__components_views_Designated_CrDesignated_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_138__components_views_Designated_CrDesignated_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__components_views_Designated_UpDesignated_vue__ = __webpack_require__(2146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__components_views_Designated_UpDesignated_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_139__components_views_Designated_UpDesignated_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__components_views_Rating_RatingTable_vue__ = __webpack_require__(2248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__components_views_Rating_RatingTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_140__components_views_Rating_RatingTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__components_views_Announcement__ = __webpack_require__(2103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__components_views_Announcement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_141__components_views_Announcement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__components_views_Announcement_components_AnnouncementForm_vue__ = __webpack_require__(2102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__components_views_Announcement_components_AnnouncementForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_142__components_views_Announcement_components_AnnouncementForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__components_views_VenderTradeTable__ = __webpack_require__(2283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__components_views_VenderTradeTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_143__components_views_VenderTradeTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__components_views_VenderTradeTable_CommissionHistory_vue__ = __webpack_require__(2281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__components_views_VenderTradeTable_CommissionHistory_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_144__components_views_VenderTradeTable_CommissionHistory_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__components_views_VenderTradeTable_CommissionStore_vue__ = __webpack_require__(2282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__components_views_VenderTradeTable_CommissionStore_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_145__components_views_VenderTradeTable_CommissionStore_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__routes_modules_brand_to_store_menu_js__ = __webpack_require__(464);








































































































































































var routes = [{
  path: '/login',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Login_vue___default.a,
  requiresAuth: false
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Dash_vue___default.a,
  children: [{
    path: 'dashboard',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_4__components_views_Dashboard_vue___default.a,
    name: 'dashboard',
    meta: {
      title: '首頁',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'brandDashboard',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_5__components_views_BrandDashboard_vue___default.a,
    name: 'brandDashboard',
    meta: {
      title: '首頁',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'accountTable',
    component: __WEBPACK_IMPORTED_MODULE_6__components_views_Account_AccountTable_vue___default.a,
    name: 'accountTable',
    meta: {
      title: '帳號管理',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'crAccount',
    component: __WEBPACK_IMPORTED_MODULE_7__components_views_Account_CrAccount_vue___default.a,
    name: 'crAccount',
    meta: {
      title: '新增帳號',
      description: '',
      route: '帳號管理',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'upAccount/:role_type/:manager_id',
    component: __WEBPACK_IMPORTED_MODULE_8__components_views_Account_UpAccount_vue___default.a,
    name: 'upAccount',
    meta: {
      title: '編輯帳號',
      description: '',
      route: '帳號管理',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'lineNotifyTable',
    component: __WEBPACK_IMPORTED_MODULE_9__components_views_LineNotify_LineNotifyTable_vue___default.a,
    name: 'lineNotifyTable',
    meta: {
      title: 'LINE通知管理',
      description: '',
      route: '',
      requiresAuth: true
    }
  }, {
    path: 'memberTable',
    component: __WEBPACK_IMPORTED_MODULE_10__components_views_Member_MemberTable_vue___default.a,
    name: 'memberTable',
    meta: {
      title: '會員管理',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'memberOrderTable/:user_id',
    component: __WEBPACK_IMPORTED_MODULE_11__components_views_Member_MemberOrderTable_vue___default.a,
    name: 'memberOrderTable',
    meta: {
      title: '會員線上訂單列表',
      description: '',
      route: '會員管理',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'upMember/:user_id',
    component: __WEBPACK_IMPORTED_MODULE_13__components_views_Member_UpMember_vue___default.a,
    name: 'upMember',
    meta: {
      title: '編輯會員',
      description: '',
      route: '會員管理',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'memberInfo/:user_id',
    component: __WEBPACK_IMPORTED_MODULE_14__components_views_Member_MemberInfo_vue___default.a,
    name: 'memberInfo',
    meta: {
      title: '會員資訊',
      description: '',
      route: '會員管理',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'upgradememberInfo/:user_id',
    component: __WEBPACK_IMPORTED_MODULE_15__components_views_Member_UpgradeMemberInfo_vue___default.a,
    name: 'memberInfo',
    meta: {
      title: '整合帳號列表',
      description: '',
      route: '會員管理',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'memberIdentity/:shopper_id',
    component: __WEBPACK_IMPORTED_MODULE_12__components_views_Member_MemberIdentityTable_vue___default.a,
    name: 'memberIdentity',
    meta: {
      title: '會員登入紀錄',
      description: '',
      route: '會員管理',
      requiresAuth: true
    }
  }, {
    path: 'shopperMoneyTable',
    component: __WEBPACK_IMPORTED_MODULE_16__components_views_Member_ShopperMoneyTable_vue___default.a,
    name: 'shopperMoneyTable',
    meta: {
      title: '會員消費列表',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'oneShopperMoney/:shopper_id',
    component: __WEBPACK_IMPORTED_MODULE_17__components_views_Member_OneShopperMoney_vue___default.a,
    name: 'oneShopperMoney',
    meta: {
      title: '會員消費紀錄',
      description: '',
      route: '會員消費管理',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'platformTable',
    component: __WEBPACK_IMPORTED_MODULE_18__components_views_Platform_PlatformTable_vue___default.a,
    name: 'platformTable',
    meta: {
      title: '平台管理',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'platformAdTable',
    component: __WEBPACK_IMPORTED_MODULE_19__components_views_Platform_AdTable_vue___default.a,
    name: 'platformAdTable',
    meta: {
      title: '平台廣告',
      description: '',
      route: '平台管理',
      requiresAuth: true,
      isShowInJkos: false,
      docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/brandAdTable.pdf'
    }
  }, {
    path: 'mealTagTable',
    component: __WEBPACK_IMPORTED_MODULE_22__components_views_Platform_MealTagTable_vue___default.a,
    name: 'mealTagTable',
    meta: {
      title: '餐點種類列表',
      description: '',
      route: '平台管理/餐點種類列表',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'crMealTag',
    component: __WEBPACK_IMPORTED_MODULE_23__components_views_Platform_MealTagForm_vue___default.a,
    name: 'crMealTag',
    meta: {
      title: '新增餐點種類',
      description: '',
      route: '平台管理/餐點種類',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'upMealTag/:tag_id',
    component: __WEBPACK_IMPORTED_MODULE_23__components_views_Platform_MealTagForm_vue___default.a,
    name: 'upMealTag',
    meta: {
      title: '編輯餐點種類',
      description: '',
      route: '平台管理/餐點種類',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'crPlatformAd',
    component: __WEBPACK_IMPORTED_MODULE_20__components_views_Platform_CrAd_vue___default.a,
    name: 'crPlatform',
    meta: {
      title: '新增平台廣告',
      description: '',
      route: '平台管理/平台廣告',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'upPlatformAd/:ad_id',
    component: __WEBPACK_IMPORTED_MODULE_21__components_views_Platform_UpAd_vue___default.a,
    name: 'upPlatformAd',
    meta: {
      title: '編輯平台廣告',
      description: '',
      route: '平台管理/平台廣告',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'brandTable',
    component: __WEBPACK_IMPORTED_MODULE_25__components_views_Brand_BrandTable_vue___default.a,
    name: 'brandTable',
    meta: {
      title: '品牌管理',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'storeTable/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_26__components_views_Brand_StoreTable_vue___default.a,
    name: 'storeTable',
    meta: {
      title: '門市管理',
      description: '',
      route: '品牌管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'batchSetupStore/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_45__components_views_Brand_BatchSetupStore_vue___default.a,
    name: 'batchSetupStore',
    meta: {
      title: '批次設定門市資訊',
      description: '',
      route: '批次設定門市資訊',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'groupTable/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_27__components_views_Brand_GroupTable_vue___default.a,
    name: 'groupTable',
    meta: {
      title: '群組管理',
      description: '',
      route: '品牌管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'crBrand',
    component: __WEBPACK_IMPORTED_MODULE_28__components_views_Brand_CrBrand_vue___default.a,
    name: 'crBrand',
    meta: {
      title: '新增品牌',
      description: '',
      route: '品牌管理',
      requiresAuth: true
    }
  }, {
    path: 'upBrand/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_29__components_views_Brand_UpBrand_vue___default.a,
    name: 'upBrand',
    meta: {
      title: '編輯品牌',
      description: '',
      route: '品牌管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'brandInfo/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_34__components_views_Brand_BrandInfo_vue___default.a,
    name: 'brandInfo',
    meta: {
      title: '品牌資訊',
      description: '',
      route: '品牌管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'brandAdTable/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_42__components_views_Brand_BrandAdTable_vue___default.a,
    name: 'brandAdTable',
    meta: {
      title: '品牌廣告',
      description: '',
      route: '品牌管理',
      requiresAuth: true,
      isShowInJkos: true,
      docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/brandAdTable.pdf'
    }
  }, {
    path: 'crBrandAd/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_43__components_views_Brand_CrBrandAd_vue___default.a,
    name: 'crBrandAd',
    meta: {
      title: '新增品牌廣告',
      description: '',
      route: '品牌管理/品牌廣告',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'upBrandAd/:brand_id/:ad_id',
    component: __WEBPACK_IMPORTED_MODULE_44__components_views_Brand_UpBrandAd_vue___default.a,
    name: 'upBrandAd',
    meta: {
      title: '編輯品牌廣告',
      description: '',
      route: '品牌管理/品牌廣告',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'crStore/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_30__components_views_Brand_CrStore_vue___default.a,
    name: 'crStore',
    meta: {
      title: '新增門市',
      description: '',
      route: '品牌管理/門市管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'crGroup/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_31__components_views_Brand_CrGroup_vue___default.a,
    name: 'crGroup',
    meta: {
      title: '新增群組',
      description: '',
      route: '品牌管理/群組管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'upStore/:brand_id/:store_id',
    component: __WEBPACK_IMPORTED_MODULE_32__components_views_Brand_UpStore_vue___default.a,
    name: 'upStore',
    meta: {
      title: '編輯單一門市資訊',
      description: '',
      route: '品牌管理/門市管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'upGroup/:brand_id/:group_id',
    component: __WEBPACK_IMPORTED_MODULE_33__components_views_Brand_UpGroup_vue___default.a,
    name: 'upGroup',
    meta: {
      title: '編輯群組',
      description: '',
      route: '品牌管理/門市管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'storeInfo/:brand_id/:store_id',
    component: __WEBPACK_IMPORTED_MODULE_35__components_views_Brand_StoreInfo_vue___default.a,
    name: 'storeInfo',
    meta: {
      title: '門市資訊',
      description: '',
      route: '品牌管理/門市管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'changeIcon/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_37__components_views_Brand_ChangeStoresIcon_vue___default.a,
    name: 'changeIcon',
    meta: {
      title: '批次更換圖示',
      description: '',
      route: '品牌管理/門市管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'adTable/:brand_id/:store_id',
    component: __WEBPACK_IMPORTED_MODULE_38__components_views_Brand_AdTable_vue___default.a,
    name: 'adTable',
    meta: {
      title: '廣告管理',
      description: '',
      route: '品牌管理/門市管理',
      requiresAuth: true,
      isShowInJkos: true,
      docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/brandAdTable.pdf'
    }
  }, {
    path: 'crAd/:brand_id/:store_id',
    component: __WEBPACK_IMPORTED_MODULE_39__components_views_Brand_CrAd_vue___default.a,
    name: 'crAd',
    meta: {
      title: '新增廣告',
      description: '',
      route: '品牌管理/門市管理/廣告管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'upAd/:brand_id/:store_id/:ad_id',
    component: __WEBPACK_IMPORTED_MODULE_40__components_views_Brand_UpAd_vue___default.a,
    name: 'upAd',
    meta: {
      title: '編輯廣告',
      description: '',
      route: '品牌管理/門市管理/廣告管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'copyAd/:brand_id/:store_id',
    component: __WEBPACK_IMPORTED_MODULE_41__components_views_Brand_CopyAd_vue___default.a,
    name: 'copyAd',
    meta: {
      title: '複製廣告',
      description: '',
      route: '品牌管理/門市管理/廣告管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'disItemTableOld',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_97__components_views_RealTime_DisItemTableOld_vue___default.a,
    name: 'disItemTableOld',
    meta: {
      title: '停賣管理',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'disItemTable',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_98__components_views_RealTime_DisItemTable_vue___default.a,
    name: 'disItemTable',
    meta: {
      title: '停賣管理',
      subTitle: '於菜單頁面停賣/解除停賣指定商品',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'disProduct/:brand_id/:menu_id',
    component: __WEBPACK_IMPORTED_MODULE_99__components_views_RealTime_DisProdu_vue___default.a,
    name: 'disProduct',
    meta: {
      title: '編輯多店停賣',
      description: '',
      route: '停賣管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'reDisProduct/:brand_id/:menu_id',
    component: __WEBPACK_IMPORTED_MODULE_99__components_views_RealTime_DisProdu_vue___default.a,
    name: 'reDisProduct',
    meta: {
      title: '編輯多店解除停賣',
      description: '',
      route: '停賣管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'disProduct/:brand_id/:menu_id/:store_id/forever',
    component: __WEBPACK_IMPORTED_MODULE_99__components_views_RealTime_DisProdu_vue___default.a,
    name: 'disProductStoreForever',
    meta: {
      title: '編輯永久停賣',
      description: '',
      route: '停賣管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'disProduct/:brand_id/:menu_id/:store_id/daily',
    component: __WEBPACK_IMPORTED_MODULE_99__components_views_RealTime_DisProdu_vue___default.a,
    name: 'disProductStoreDaily',
    meta: {
      title: '編輯當日停賣',
      description: '',
      route: '停賣管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'disItemScheduleTable',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_110__components_views_RealTime_DisScheduleItemTable_vue___default.a,
    name: 'disItemScheduleTable',
    meta: {
      title: '時段停賣管理',
      subTitle: '於指定的時間、日期、星期停賣/解除停賣指定商品',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false,
      docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/disItemScheduleTable.pdf'
    }
  }, {
    path: 'limitedItemScheduleTable',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_111__components_views_RealTime_LimitedScheduleItemTable_vue___default.a,
    name: 'limitedItemScheduleTable',
    meta: {
      title: '門市限時限量設定',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false,
      docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/limitedItemScheduleTable.pdf'
    }
  }, {
    path: 'crDisableSchedule',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_112__components_views_RealTime_CrDisableSchedule_vue___default.a,
    name: 'crDisableSchedule',
    meta: {
      title: '新增時段停賣',
      description: '',
      route: '時段停賣管理',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'crDisableScheduleItem',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_112__components_views_RealTime_CrDisableSchedule_vue___default.a,
    name: 'crDisableScheduleItem',
    meta: {
      title: '新增時段停賣單一商品',
      description: '',
      route: '時段停賣管理',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'copyLimiScheduleItem/:setting_id',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_113__components_views_RealTime_CopylimitedSchedule_vue___default.a,
    name: 'copyLimiScheduleItem',
    meta: {
      title: '複製門市限時限量設定',
      description: '',
      route: '時段停賣管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'crLimitScheduleItem',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_114__components_views_RealTime_CrlimitedSchedule_vue___default.a,
    name: 'crLimitScheduleItem',
    meta: {
      title: '新增門市限時限量',
      description: '',
      route: '時段停賣管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'upLimitScheduleItem/:setting_id',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_114__components_views_RealTime_CrlimitedSchedule_vue___default.a,
    name: 'upLimitScheduleItem',
    meta: {
      title: '編輯門市限時限量',
      description: '',
      route: '時段停賣管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'upDisableSchedule/:setting_id',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_112__components_views_RealTime_CrDisableSchedule_vue___default.a,
    name: 'upDisableSchedule',
    meta: {
      title: '編輯時段停賣',
      description: '',
      route: '時段停賣管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'disItemTable/:brand_id',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_115__components_views_RealTime_DisItemTableBrand_vue___default.a,
    name: 'DisItemTableBrand',
    meta: {
      title: '批次記錄',
      description: '',
      route: '時段停賣管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'disItemTable/:brand_id/:store_id',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_116__components_views_RealTime_DisItemTableStore_vue___default.a,
    name: 'DisItemTableStore',
    meta: {
      title: '歷程記錄',
      description: '',
      route: '時段停賣管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'mqttTable',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_100__components_views_RealTime_MqttTable_vue___default.a,
    name: 'mqttTable',
    meta: {
      title: '連線管理',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'mqttSearch/:store_id',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_101__components_views_RealTime_MqttSearch_vue___default.a,
    name: 'mqttSearch',
    meta: {
      title: '單日連線紀錄',
      description: '',
      route: '連線管理',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'tableSetting',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_102__components_views_RealTime_TableSetting_vue___default.a,
    name: 'tableSetting',
    meta: {
      title: '座位管理',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'printerTable',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_103__components_views_RealTime_PrinterTable_vue___default.a,
    name: 'printerTable',
    meta: {
      title: '出單機管理',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'printerInfo/:printer_id',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_104__components_views_RealTime_PrinterInfo_vue___default.a,
    name: 'printerInfo',
    meta: {
      title: '出單機資訊',
      description: '',
      route: '出單機管理',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'crPrinter',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_105__components_views_RealTime_CrPrinter_vue___default.a,
    name: 'crPrinter',
    meta: {
      title: '新增出單機',
      description: '',
      route: '出單機管理',
      requiresAuth: true
    }
  }, {
    path: 'upPrinter/:printer_id',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_106__components_views_RealTime_UpPrinter_vue___default.a,
    name: 'upPrinter',
    meta: {
      title: '編輯出單機',
      description: '',
      route: '出單機管理',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'crPrinterStore/:printer_id',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_107__components_views_RealTime_CrPrinterStore_vue___default.a,
    name: 'crPrinterStore',
    meta: {
      title: '新增店家綁定',
      description: '',
      route: '出單機管理/出單機資訊',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'upPrinterStore/:printer_id/:binding_id',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_108__components_views_RealTime_UpPrinterStore_vue___default.a,
    name: 'upPrinterStore',
    meta: {
      title: '編輯店家綁定',
      description: '',
      route: '出單機管理/出單機資訊',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'printerStore/:printer_id/:store_id',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_109__components_views_RealTime_PrinterStoreTable_vue___default.a,
    name: 'printerStore',
    meta: {
      title: '店家綁定列表',
      description: '',
      route: '出單機管理/出單機資訊',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'orderTable',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_46__components_views_Order_OrderTable_vue___default.a,
    name: 'orderTable',
    meta: {
      title: '線上訂單管理',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'onSiteOrderTable',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_46__components_views_Order_OrderTable_vue___default.a,
    name: 'onSiteOrderTable',
    meta: {
      title: '線下訂單管理',
      subTitle: '線下訂單會顯示消費者於門市現場消費並累積點數的資訊',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'onSiteOrderTable/member',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_46__components_views_Order_OrderTable_vue___default.a,
    name: 'onSiteOrderMemberTable',
    meta: {
      title: '線下訂單管理',
      subTitle: '線下訂單會顯示消費者於門市現場消費並累積點數的資訊',
      description: '',
      route: '會員單',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'onSiteOrderTable/guest',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_46__components_views_Order_OrderTable_vue___default.a,
    name: 'onSiteOrderGuestTable',
    meta: {
      title: '線下訂單管理',
      subTitle: '線下訂單會顯示消費者於門市現場消費並累積點數的資訊',
      description: '',
      route: '訪客單',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'orderExceptionTable',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_47__components_views_Order_OrderExceptionTable_vue___default.a,
    name: 'orderExceptionTable',
    meta: {
      title: '例外訂單管理',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'menuQuerystringView',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_50__components_views_Order_menuquerystringview_vue___default.a,
    name: 'menuQuerystringView',
    meta: {
      title: '追蹤碼',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'blackListTable',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_49__components_views_Order_BlackListTable_vue___default.a,
    name: 'blackListTable',
    meta: {
      title: '黑名單訂單管理',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'onSiteOrderTableInfo/:order_id',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_48__components_views_Order_OrderInfo_vue___default.a,
    name: 'onSiteOrderTableInfo',
    meta: {
      title: '訂單資訊',
      description: '',
      route: '訂單管理',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'orderInfo/:order_id',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_48__components_views_Order_OrderInfo_vue___default.a,
    name: 'orderInfo',
    meta: {
      title: '訂單資訊',
      description: '',
      route: '訂單管理',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'menuTable',
    component: __WEBPACK_IMPORTED_MODULE_51__components_views_Menu_MenuTable_vue___default.a,
    name: 'menuTable',
    meta: {
      title: '菜單管理',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'menuDetailTable',
    component: __WEBPACK_IMPORTED_MODULE_52__components_views_Menu_MenuDetailTable_vue___default.a,
    name: 'menuDetailTable',
    meta: {
      title: '菜單管理',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true,
      docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/menu.pdf'
    }
  }, {
    path: 'brandMenu/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_55__components_views_Menu_menu_step_vue___default.a,
    name: 'brandMenu',
    meta: {
      title: '配料庫',
      description: '',
      docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/menu.pdf',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'crStoreClass/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_79__components_views_Menu_CrStoreClass_vue___default.a,
    name: 'crStoreClass',
    meta: {
      title: '門市群組',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'store-group/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_36__components_views_Brand_store_group_vue___default.a,
    name: 'storeGroup',
    meta: {
      title: '門市群組',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'storeTable/productImage/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_61__components_views_Menu_Temp_store_menu_table_vue___default.a,
    name: 'storeTableProductImage',
    meta: {
      title: '圖片庫',
      description: '',
      docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/menu.pdf',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'storeTable/productSetting/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_61__components_views_Menu_Temp_store_menu_table_vue___default.a,
    name: 'storeTableProductSetting',
    meta: {
      title: '別名/描述/警語',
      description: '',
      docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/menu.pdf',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'copy/productImage/:brand_id/:store_id',
    component: __WEBPACK_IMPORTED_MODULE_80__components_views_Menu_Temp_CopyStoreTemp_vue___default.a,
    name: 'copyProductImage',
    meta: {
      title: '複製 門市圖片庫 至其他店家',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'copy/productSetting/:brand_id/:store_id',
    component: __WEBPACK_IMPORTED_MODULE_80__components_views_Menu_Temp_CopyStoreTemp_vue___default.a,
    name: 'copyProductSetting',
    meta: {
      title: '複製 門市別名/描述/警語 至其他店家',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'storeTable/productImage/:brand_id/:store_id',
    component: __WEBPACK_IMPORTED_MODULE_74__components_views_Menu_ProductImage_vue___default.a,
    name: 'ProductImage',
    meta: {
      title: '圖片庫',
      description: '',
      docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/menu.pdf',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'storeTable/productSetting/:brand_id/:store_id',
    component: __WEBPACK_IMPORTED_MODULE_75__components_views_Menu_ProductSetting_vue___default.a,
    name: 'ProductSetting',
    meta: {
      title: '別名 / 描述 / 警語',
      description: '',
      docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/menu.pdf',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'crProductSetting/:brand_id/:store_id',
    component: __WEBPACK_IMPORTED_MODULE_77__components_views_Menu_CrProductSetting_vue___default.a,
    name: 'crProductSetting',
    meta: {
      title: '新增門市別名/描述/警語',
      description: '',
      route: '門市別名/描述',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'upProductAlias/:brand_id/:store_id/:setting_id',
    component: __WEBPACK_IMPORTED_MODULE_77__components_views_Menu_CrProductSetting_vue___default.a,
    name: 'upProductAlias',
    meta: {
      title: '更新別名',
      description: '',
      route: '門市別名/描述',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'upProductDescription/:brand_id/:store_id/:setting_id',
    component: __WEBPACK_IMPORTED_MODULE_77__components_views_Menu_CrProductSetting_vue___default.a,
    name: 'upProductDescription',
    meta: {
      title: '更新描述/警語',
      description: '',
      route: '門市別名/描述',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'cupDiscountTable/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_81__components_views_Menu_CupDiscountTable_vue___default.a,
    name: 'cupDiscountTable',
    meta: {
      title: '自備飲料杯管理',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'cupDiscountTable/:brand_id/:store_id',
    component: __WEBPACK_IMPORTED_MODULE_81__components_views_Menu_CupDiscountTable_vue___default.a,
    name: 'cupDiscountTable',
    meta: {
      title: '自備飲料杯管理',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'crProductImg/:brand_id/:store_id',
    component: __WEBPACK_IMPORTED_MODULE_76__components_views_Menu_CrImgSetting_vue___default.a,
    name: 'crProductImg',
    meta: {
      title: '新增商品圖片',
      description: '',
      route: '門市圖片庫',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'crPackageImg/:brand_id/:store_id',
    component: __WEBPACK_IMPORTED_MODULE_76__components_views_Menu_CrImgSetting_vue___default.a,
    name: 'crPackageImg',
    meta: {
      title: '新增套餐圖片',
      description: '',
      route: '門市圖片庫',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'crCategoryImg/:brand_id/:store_id',
    component: __WEBPACK_IMPORTED_MODULE_76__components_views_Menu_CrImgSetting_vue___default.a,
    name: 'crCategoryImg',
    meta: {
      title: '新增商品分類圖片',
      description: '',
      route: '門市圖片庫',
      requiresAuth: true
    }
  }, {
    path: 'upProductImg/:brand_id/:store_id/:setting_id',
    component: __WEBPACK_IMPORTED_MODULE_76__components_views_Menu_CrImgSetting_vue___default.a,
    name: 'upProductImg',
    meta: {
      title: '更新商品圖片',
      description: '',
      route: '門市圖片庫',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'upPackageImg/:brand_id/:store_id/:setting_id',
    component: __WEBPACK_IMPORTED_MODULE_76__components_views_Menu_CrImgSetting_vue___default.a,
    name: 'upPackageImg',
    meta: {
      title: '更新套餐圖片',
      description: '',
      route: '門市圖片庫',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'upCategoryImg/:brand_id/:store_id/:setting_id',
    component: __WEBPACK_IMPORTED_MODULE_76__components_views_Menu_CrImgSetting_vue___default.a,
    name: 'upCategoryImg',
    meta: {
      title: '更新商品分類圖片',
      description: '',
      route: '門市圖片庫',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'crProductIcon/:brand_id/:store_id',
    component: __WEBPACK_IMPORTED_MODULE_78__components_views_Menu_CrIconSetting_vue___default.a,
    name: 'crProductIcon',
    meta: {
      title: '新增菜單圖示',
      description: '',
      route: '門市圖片庫',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'upProductIcon/:brand_id/:store_id/:icon_id',
    component: __WEBPACK_IMPORTED_MODULE_78__components_views_Menu_CrIconSetting_vue___default.a,
    name: 'upProductIcon',
    meta: {
      title: '編輯菜單圖示',
      description: '',
      route: '品牌圖片庫',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'binding-pos/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_72__components_views_Menu_binding_pos_vue___default.a,
    name: 'BindingPos',
    meta: {
      title: '菜單綁定',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'crOptions/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_73__components_views_Menu_CrBinding_vue___default.a,
    name: 'crOptions',
    meta: {
      title: '配料綁定',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'crAdjusts/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_73__components_views_Menu_CrBinding_vue___default.a,
    name: 'crAdjusts',
    meta: {
      title: '配料群組綁定',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'crCategories/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_73__components_views_Menu_CrBinding_vue___default.a,
    name: 'crCategories',
    meta: {
      title: '商品分類綁定',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'crProducts/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_73__components_views_Menu_CrBinding_vue___default.a,
    name: 'crProducts',
    meta: {
      title: '商品綁定',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'crBlocks/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_73__components_views_Menu_CrBinding_vue___default.a,
    name: 'crBlocks',
    meta: {
      title: '品項選擇區綁定',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'crPackages/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_73__components_views_Menu_CrBinding_vue___default.a,
    name: 'crPackages',
    meta: {
      title: '套餐綁定',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'brandMenuTable/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_53__components_views_Menu_menu_build_vue___default.a,
    name: 'brandMenuTable',
    meta: {
      title: '菜單建置',
      description: '',
      docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/menu.pdf',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'crMenu/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_56__components_views_Menu_CrMenu_vue___default.a,
    name: 'crMenu',
    meta: {
      title: '新增菜單',
      description: '',
      route: '菜單管理/品牌菜單管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'crProduct',
    component: __WEBPACK_IMPORTED_MODULE_57__components_views_Menu_CrMenuProduct_vue___default.a,
    name: 'crProduct',
    meta: {
      title: '新增菜單',
      description: '',
      route: '菜單管理/品牌菜單管理',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'crOption',
    component: __WEBPACK_IMPORTED_MODULE_58__components_views_Menu_CrMenuOption_vue___default.a,
    name: 'crOption',
    meta: {
      title: '新增菜單',
      description: '',
      route: '菜單管理/品牌菜單管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'crCombination',
    component: __WEBPACK_IMPORTED_MODULE_59__components_views_Menu_CrCombination_vue___default.a,
    name: 'crCombination',
    meta: {
      title: '新增菜單',
      description: '',
      route: '菜單管理/品牌菜單管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'crJoinMenu',
    component: __WEBPACK_IMPORTED_MODULE_60__components_views_Menu_CrJoinMenu_vue___default.a,
    name: 'crJoinMenu',
    meta: {
      title: '新增菜單',
      description: '',
      route: '菜單管理/品牌菜單管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'menuInfo/:brand_id/:menu_id',
    component: __WEBPACK_IMPORTED_MODULE_54__components_views_Menu_MenuInfo_vue___default.a,
    name: 'menuInfo',
    meta: {
      title: '菜單資訊',
      description: '',
      route: '菜單管理/品牌菜單管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'upMenu/:brand_id/:menu_id',
    component: __WEBPACK_IMPORTED_MODULE_62__components_views_Menu_UpMenu_vue___default.a,
    name: 'upMenu',
    meta: {
      title: '編輯菜單',
      description: '',
      route: '菜單管理/品牌菜單管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'upProduct/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_63__components_views_Menu_UpMenuProduct_vue___default.a,
    name: 'upProduct',
    meta: {
      title: '編輯菜單-商品',
      description: '',
      route: '菜單管理/品牌菜單管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'upOption/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_65__components_views_Menu_up_menu_option_vue___default.a,
    name: 'upOption',
    meta: {
      title: '編輯菜單-配料',
      description: '',
      route: '菜單管理/品牌菜單管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'upAdjust/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_64__components_views_Menu_up_menu_adjust_vue___default.a,
    name: 'upAdjust',
    meta: {
      title: '編輯菜單-配料群組',
      description: '',
      route: '菜單管理/品牌菜單管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'upCategory/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_66__components_views_Menu_UpMenuCategory_vue___default.a,
    name: 'upCategory',
    meta: {
      title: '編輯菜單-商品分類',
      description: '',
      route: '菜單管理/品牌菜單管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'upBlock/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_67__components_views_Menu_UpMenuBlock_vue___default.a,
    name: 'upBlock',
    meta: {
      title: '編輯菜單-選擇區',
      description: '',
      route: '菜單管理/品牌菜單管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'upPackage/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_68__components_views_Menu_UpMenuPackage_vue___default.a,
    name: 'upPackage',
    meta: {
      title: '編輯菜單-套餐',
      description: '',
      route: '菜單管理/品牌菜單管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'upCombination/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_69__components_views_Menu_UpCombination_vue___default.a,
    name: 'upCombination',
    meta: {
      title: '編輯菜單',
      description: '',
      route: '菜單管理/品牌菜單管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'upCombinationPrice/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_70__components_views_Menu_UpCombinationPrice_vue___default.a,
    name: 'upCombinationPrice',
    meta: {
      title: '編輯菜單',
      description: '',
      route: '菜單管理/品牌菜單管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'upJoinMenu/:brand_id/:menu_id',
    component: __WEBPACK_IMPORTED_MODULE_71__components_views_Menu_UpJoinMenu_vue___default.a,
    name: 'upJoinMenu',
    meta: {
      title: '編輯菜單',
      description: '',
      route: '菜單管理/品牌菜單管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'upJoinMenu/:brand_id/:menu_id/ok',
    component: __WEBPACK_IMPORTED_MODULE_71__components_views_Menu_UpJoinMenu_vue___default.a,
    name: 'upJoinMenuOk',
    meta: {
      title: '編輯菜單',
      description: '',
      route: '菜單管理/品牌菜單管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'scheduleTable',
    component: __WEBPACK_IMPORTED_MODULE_82__components_views_Schedule_ScheduleTable_vue___default.a,
    name: 'scheduleTable',
    meta: {
      title: '菜單排程管理',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'brandScheduleTable/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_84__components_views_Schedule_BrandScheduleTable_vue___default.a,
    name: 'brandScheduleTable',
    meta: {
      title: '排程管理',
      description: '',
      docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/menu.pdf',
      route: '菜單排程管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'storeScheduleTable/:brand_id/:store_id',
    component: __WEBPACK_IMPORTED_MODULE_83__components_views_Schedule_StoreScheduleTable_vue___default.a,
    name: 'storeScheduleTable',
    meta: {
      title: '店家菜單排程管理',
      description: '',
      route: '菜單排程管理/品牌菜單排程管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'crSchedule/:brand_id/:menu_id',
    component: __WEBPACK_IMPORTED_MODULE_86__components_views_Schedule_CrSchedule_vue___default.a,
    name: 'crSchedule',
    meta: {
      title: '新增排程',
      description: '',
      route: '菜單排程管理/品牌菜單排程管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'upSchedule/group/:brand_id/:group_id',
    component: __WEBPACK_IMPORTED_MODULE_85__components_views_Schedule_UpSchedule_vue___default.a,
    name: 'upSchedule',
    meta: {
      title: '編輯排程',
      description: '',
      route: '菜單排程管理/品牌菜單排程管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'upSchedule/:brand_id/:schedule_id',
    component: __WEBPACK_IMPORTED_MODULE_85__components_views_Schedule_UpSchedule_vue___default.a,
    name: 'upStoreSchedule',
    meta: {
      title: '編輯排程',
      description: '',
      route: '菜單排程管理/品牌菜單排程管理',
      requiresAuth: true,
      isShowInJkos: true
    }
  }, {
    path: 'couponTable',
    component: __WEBPACK_IMPORTED_MODULE_122__components_views_Marketing_CouponTable_vue___default.a,
    name: 'couponTable',
    meta: {
      title: '優惠券活動列表',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'crActivity',
    component: __WEBPACK_IMPORTED_MODULE_118__components_views_Marketing_CrActivity_vue___default.a,
    name: 'crActivity',
    meta: {
      title: '建立活動',
      description: '',
      route: '活動管理/優惠券活動列表',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'crActivityInfoForm',
    component: __WEBPACK_IMPORTED_MODULE_121__components_views_Marketing_ActivityInfoForm_vue___default.a,
    name: 'crActivityInfoForm',
    meta: {
      title: '建立活動資訊',
      description: '',
      route: '活動管理/優惠券活動列表',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'upActivity/:activity_id',
    component: __WEBPACK_IMPORTED_MODULE_121__components_views_Marketing_ActivityInfoForm_vue___default.a,
    name: 'upActivity',
    meta: {
      title: '編輯活動資訊',
      description: '',
      route: '活動管理/優惠券活動列表',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'activityInfo/:activity_id',
    component: __WEBPACK_IMPORTED_MODULE_119__components_views_Marketing_ActivityInfo_vue___default.a,
    name: 'activityInfo',
    meta: {
      title: '活動資訊',
      description: '',
      route: '折扣活動列表',
      requiresAuth: true,
      isShowInJkos: false
    },
    children: [{
      path: 'detail',
      component: __WEBPACK_IMPORTED_MODULE_120__components_views_Marketing_Temp_ActivityInfoTemp_vue___default.a,
      name: 'activityDetail',
      meta: {
        title: '活動資訊'
      }
    }]
  }, {
    path: 'upCouponTable',
    component: __WEBPACK_IMPORTED_MODULE_123__components_views_Marketing_UpCouponTable_vue___default.a,
    name: 'upCouponTable',
    meta: {
      title: '編輯優惠券活動列表',
      description: '',
      route: '折扣活動列表',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'discountTable',
    component: __WEBPACK_IMPORTED_MODULE_126__components_views_Discount_DiscountTable_vue___default.a,
    name: 'discountTable',
    meta: {
      title: '折扣活動列表',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false,
      docLink: 'https://drive.google.com/drive/folders/1tG0Y1dkD95QOP2Yw_5XEx6z2fkWp2Vzw'
    }
  }, {
    path: 'chooseDiscount',
    component: __WEBPACK_IMPORTED_MODULE_127__components_views_Discount_ChooseDiscount_vue___default.a,
    name: 'chooseDiscount',
    meta: {
      title: '選擇折扣活動方式',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false,
      docLink: 'https://drive.google.com/drive/folders/1tG0Y1dkD95QOP2Yw_5XEx6z2fkWp2Vzw'
    }
  }, {
    path: 'crDiscount',
    component: __WEBPACK_IMPORTED_MODULE_128__components_views_Discount_CrDiscount_vue___default.a,
    name: 'crDiscount',
    meta: {
      title: '新增折扣活動',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'upDiscountList',
    component: __WEBPACK_IMPORTED_MODULE_129__components_views_Discount_UpDiscountTable_vue___default.a,
    name: 'upDiscountList',
    meta: {
      title: '編輯折扣活動列表',
      description: '',
      route: '折扣活動列表',
      requiresAuth: true,
      isShowInJkos: false,
      docLink: 'https://drive.google.com/drive/folders/1tG0Y1dkD95QOP2Yw_5XEx6z2fkWp2Vzw'
    }
  }, {
    path: 'upDiscount/:activity_id',
    component: __WEBPACK_IMPORTED_MODULE_130__components_views_Discount_UpDiscount_vue___default.a,
    name: 'upDiscount',
    meta: {
      title: '編輯折扣活動',
      description: '',
      route: '折扣活動列表/編輯折扣活動列表',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'discountInfo/:activity_id',
    component: __WEBPACK_IMPORTED_MODULE_131__components_views_Discount_DiscountInfo_vue___default.a,
    name: 'discountInfo',
    meta: {
      title: '折扣活動資訊',
      description: '',
      route: '折扣活動列表',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'discountStore/:activity_id',
    component: __WEBPACK_IMPORTED_MODULE_132__components_views_Discount_UpDiscountStore_vue___default.a,
    name: 'discountStore',
    meta: {
      title: '活動參與店家',
      description: '',
      route: '折扣活動列表',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'brandHistoryTable',
    component: __WEBPACK_IMPORTED_MODULE_87__components_views_History_BrandHistoryTable_vue___default.a,
    name: 'brandHistoryTable',
    meta: {
      title: '拆帳管理',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'storeHistoryTable/:brand_id',
    component: __WEBPACK_IMPORTED_MODULE_88__components_views_History_StoreHistoryTable_vue___default.a,
    name: 'storeHistoryTable',
    meta: {
      title: '門市管理',
      description: '',
      route: '拆帳管理',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'oneStoreHistoryTable/:brand_id/:store_id',
    component: __WEBPACK_IMPORTED_MODULE_89__components_views_History_OneStoreHistoryTable_vue___default.a,
    name: 'oneStoreHistoryTable',
    meta: {
      title: '店家拆帳列表管理',
      description: '',
      route: '拆帳管理/門市管理',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'oneDayHistoryTable/:brand_id/:store_id/:date',
    component: __WEBPACK_IMPORTED_MODULE_90__components_views_History_OneDayHistoryTable_vue___default.a,
    name: 'oneDayHistoryTable',
    meta: {
      title: '店家單日拆帳列表管理',
      description: '',
      route: '拆帳管理/門市管理/店家拆帳列表管理',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'oneDayHistory/:order_sn',
    component: __WEBPACK_IMPORTED_MODULE_90__components_views_History_OneDayHistoryTable_vue___default.a,
    name: 'oneDayHistory',
    meta: {
      title: '單筆拆帳訂單',
      description: '',
      route: '編號搜尋拆帳訂單',
      requiresAuth: true
    }
  }, {
    path: 'searchHistory',
    component: __WEBPACK_IMPORTED_MODULE_91__components_views_History_SearchHistory_vue___default.a,
    name: 'searchHistory',
    meta: {
      title: '搜尋拆帳訂單',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'historyOrderInfo/:order_id',
    component: __WEBPACK_IMPORTED_MODULE_92__components_views_History_HistoryOrderInfo_vue___default.a,
    name: 'historyOrderInfo',
    meta: {
      title: '拆帳訂單資訊',
      description: '',
      route: '拆帳管理/門市管理/店家拆帳列表管理/店家單日拆帳列表管理',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'chartDash',
    component: __WEBPACK_IMPORTED_MODULE_93__components_views_Chart_ChartDash_vue___default.a,
    name: 'chartDash',
    meta: {
      title: '月報表',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'weekChartDash',
    component: __WEBPACK_IMPORTED_MODULE_94__components_views_Chart_WeekChartDash_vue___default.a,
    name: 'weekChartDash',
    meta: {
      title: '週報表',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'searchMap',
    component: __WEBPACK_IMPORTED_MODULE_95__components_views_Chart_SearchMap_vue___default.a,
    name: 'searchMap',
    meta: {
      title: '搜尋區域',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'marketingChart',
    component: __WEBPACK_IMPORTED_MODULE_117__components_views_Marketing_MarketingScheduleTable_vue___default.a,
    name: 'marketingChart',
    meta: {
      title: '行銷列表',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'couponChart/:promotion_id',
    component: __WEBPACK_IMPORTED_MODULE_96__components_views_Chart_CouponChart_vue___default.a,
    name: 'couponChart',
    meta: {
      title: '行銷報表',
      description: '',
      route: '行銷列表',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'operatingChart',
    component: __WEBPACK_IMPORTED_MODULE_124__components_views_Marketing_OperatingChart_vue___default.a,
    name: 'operatingChart',
    meta: {
      title: '營運報表',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'systemUsage',
    component: __WEBPACK_IMPORTED_MODULE_125__components_views_Marketing_SystemUsage_vue___default.a,
    name: 'systemUsage',
    meta: {
      title: '系統使用率報表',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'cashAccountTable',
    component: __WEBPACK_IMPORTED_MODULE_133__components_views_CashAccount_CashAccountTable_vue___default.a,
    name: 'cashAccountTable',
    meta: {
      title: '對帳紀錄表',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'cashAccountErrorTable',
    component: __WEBPACK_IMPORTED_MODULE_134__components_views_CashAccount_CashAccountErrorTable_vue___default.a,
    name: 'cashAccountErrorTable',
    meta: {
      title: '對帳錯誤記錄表',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'cashAccountInfo/:accounting_id',
    component: __WEBPACK_IMPORTED_MODULE_135__components_views_CashAccount_CashAccountInfo_vue___default.a,
    name: 'cashAccountInfo',
    meta: {
      title: '對帳資訊',
      description: '',
      route: '對帳紀錄表',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'venderTradeTable',
    component: __WEBPACK_IMPORTED_MODULE_143__components_views_VenderTradeTable___default.a,
    name: 'venderTradeTable',
    meta: {
      title: '廠商對帳紀錄表',
      description: '',
      route: '廠商對帳紀錄表',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'cashAccountSearch',
    component: __WEBPACK_IMPORTED_MODULE_136__components_views_CashAccount_AccountSearch_vue___default.a,
    name: 'cashAccountSearch',
    meta: {
      title: '查詢對帳資訊',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'commissionHistory',
    component: __WEBPACK_IMPORTED_MODULE_144__components_views_VenderTradeTable_CommissionHistory_vue___default.a,
    name: 'commissionHistory',
    meta: {
      title: '抽成歷史報表',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'commissionStore/:store_id',
    component: __WEBPACK_IMPORTED_MODULE_145__components_views_VenderTradeTable_CommissionStore_vue___default.a,
    name: 'commissionStore',
    meta: {
      title: '分店訂單列表',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'designatedTable',
    component: __WEBPACK_IMPORTED_MODULE_137__components_views_Designated_DesignatedTable_vue___default.a,
    name: 'designatedTable',
    meta: {
      title: '特約商店列表',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'crDesignated',
    component: __WEBPACK_IMPORTED_MODULE_138__components_views_Designated_CrDesignated_vue___default.a,
    name: 'crDesignated',
    meta: {
      title: '新增特約商店',
      description: '',
      route: '',
      requiresAuth: true
    }
  }, {
    path: 'upDesignated/:brand_id/:unit_id',
    component: __WEBPACK_IMPORTED_MODULE_139__components_views_Designated_UpDesignated_vue___default.a,
    name: 'upDesignated',
    meta: {
      title: '修改特約商店',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'ratingTable',
    component: __WEBPACK_IMPORTED_MODULE_140__components_views_Rating_RatingTable_vue___default.a,
    name: 'ratingTable',
    meta: {
      title: '評價列表',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'announcement',
    component: __WEBPACK_IMPORTED_MODULE_141__components_views_Announcement___default.a,
    name: 'announcement',
    meta: {
      title: '訊息公告',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'addAnnouncement',
    component: __WEBPACK_IMPORTED_MODULE_142__components_views_Announcement_components_AnnouncementForm_vue___default.a,
    name: 'addAnnouncement',
    meta: {
      title: '新增公告訊息',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'editAnnouncement/:announcement_id',
    component: __WEBPACK_IMPORTED_MODULE_142__components_views_Announcement_components_AnnouncementForm_vue___default.a,
    name: 'editAnnouncement',
    meta: {
      title: '編輯公告訊息',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }, {
    path: 'trade-setting',
    component: __WEBPACK_IMPORTED_MODULE_24__components_views_TradeSetting_vue___default.a,
    name: 'TradeSetting',
    meta: {
      title: '金流設定',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_146__routes_modules_brand_to_store_menu_js__["a" /* default */]))
}, {
  path: '*',
  name: 'NotFound',
  component: __WEBPACK_IMPORTED_MODULE_3__components_404_vue___default.a
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 418 */,
/* 419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1008)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(2495),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(919)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(489),
  /* template */
  __webpack_require__(2388),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1055)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(492),
  /* template */
  __webpack_require__(2558),
  /* scopeId */
  "data-v-e2f82b12",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(997)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(493),
  /* template */
  __webpack_require__(2481),
  /* scopeId */
  "data-v-75083018",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */
/***/ (function(module, exports) {

module.exports = {
  baseURL: 'https://beta-nd-panel-api.nidin.shop/1.0',
  token: 'Nidin_wb_token',
  userId: 'Nidin_wb_user_id',
  roleType: 'Nidin_wb_role_type',
  account: 'Nidin_wb_account',
  web: 'https://beta-nd-nl-package.nidin.shop/',
  bdms: 'https://beta-nd-bdms-dev.nidin.shop/',
  brand: 'nidin'
};

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports = {
  baseURL: 'https://beta-nd-panel-api.nidin.shop/1.0',
  token: 'Nidin_wb_token',
  userId: 'Nidin_wb_user_id',
  roleType: 'Nidin_wb_role_type',
  account: 'Nidin_wb_account',
  web: 'https://beta-nd-order.nidin.shop/',
  bdms: 'https://beta-nd-bdms.nidin.shop/',
  brand: 'jkos'
};

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports = {
  baseURL: 'https://beta-nd-staging-panel-api.nidin.shop/1.0',
  token: 'Nidin_wb_token',
  userId: 'Nidin_wb_user_id',
  roleType: 'Nidin_wb_role_type',
  account: 'Nidin_wb_account',
  web: 'https://beta-nd-order.nidin.shop/',
  bdms: 'https://beta-nd-bdms.nidin.shop/',
  brand: 'nidin'
};

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports = {
  baseURL: 'https://panel-api.nidin.shop/1.0',
  token: 'Nidin_wb_token',
  userId: 'Nidin_wb_user_id',
  roleType: 'Nidin_wb_role_type',
  account: 'Nidin_wb_account',
  web: 'https://order.nidin.shop/',
  bdms: 'https://bdms.nidin.shop/',
  brand: 'jkos'
};

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports = {
  baseURL: 'https://panel-api.nidin.shop/1.0',
  token: 'Nidin_wb_token',
  userId: 'Nidin_wb_user_id',
  roleType: 'Nidin_wb_role_type',
  account: 'Nidin_wb_account',
  web: 'https://pre-beta.nidin.shop/',
  bdms: 'https://bdms-pre-beta.nidin.shop/',
  brand: 'nidin'
};

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports = {
  baseURL: 'https://panel-api.nidin.shop/1.0',
  token: 'Nidin_wb_token',
  userId: 'Nidin_wb_user_id',
  roleType: 'Nidin_wb_role_type',
  account: 'Nidin_wb_account',
  web: 'https://order.nidin.shop/',
  bdms: 'https://bdms.nidin.shop/',
  brand: 'nidin'
};

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports = {
  baseURL: 'https://beta-nd-panel-api.nidin.shop/1.0',
  token: 'Nidin_wb_token',
  userId: 'Nidin_wb_user_id',
  roleType: 'Nidin_wb_role_type',
  account: 'Nidin_wb_account',
  web: 'https://beta-nd-order.nidin.shop/',
  bdms: 'https://bdms.nidin.shop/',
  brand: 'nidin'
};

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_timepicker__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_gtag__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_virtual_scroller__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_css_style_sass__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_css_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_css_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_timepicker_dist_VueTimepicker_css__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_timepicker_dist_VueTimepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue2_timepicker_dist_VueTimepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_virtual_scroller_dist_vue_virtual_scroller_css__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_virtual_scroller_dist_vue_virtual_scroller_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_virtual_scroller_dist_vue_virtual_scroller_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex_router_sync__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_js_shared_token_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_js_token_error_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__routes__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__filters__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_App_vue__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_multiselect_listbox_dist_vue_multi_select_listbox_css__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_multiselect_listbox_dist_vue_multi_select_listbox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_multiselect_listbox_dist_vue_multi_select_listbox_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_select__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_multiselect__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_functional_calendar__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_multiselect_two_sides__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_multiselect_two_sides___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_multiselect_two_sides__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_elements_jMutiSelect_vue__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_elements_jMutiSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_elements_jMutiSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_elements_jMutiSelect_v2_vue__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_elements_jMutiSelect_v2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_elements_jMutiSelect_v2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_multiselect_listbox__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_multiselect_listbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_vue_multiselect_listbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_elements_Paginate_vue__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_elements_Paginate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_elements_Paginate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_elements_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__store_state_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__assets_js_handle_config_js__ = __webpack_require__(80);



var _this = this;

var syncTokenFromCookie = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    var cookieToken, data, tokenInvalid, response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cookieToken = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__assets_js_shared_token_js__["a" /* getSharedToken */])();

            if (cookieToken) {
              _context.next = 3;
              break;
            }

            return _context.abrupt('return');

          case 3:

            __WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */].dispatch('setAuthError', '');data = null;
            tokenInvalid = false;
            _context.prev = 6;
            _context.next = 9;
            return __WEBPACK_IMPORTED_MODULE_11_axios___default()({
              baseURL: __WEBPACK_IMPORTED_MODULE_29__assets_js_handle_config_js__["a" /* default */].baseURL,
              method: 'post',
              url: '/auth/checkToken',
              headers: {
                'MC-API-Token': cookieToken
              },

              timeout: 5000
            });

          case 9:
            response = _context.sent;

            data = response.data;
            if (!data || data.status !== 200) {
              tokenInvalid = __WEBPACK_IMPORTED_MODULE_13__assets_js_token_error_js__["a" /* TOKEN_INVALID_CODES */].includes(data && data.status);
            }
            _context.next = 17;
            break;

          case 14:
            _context.prev = 14;
            _context.t0 = _context['catch'](6);

            tokenInvalid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__assets_js_token_error_js__["b" /* isTokenInvalid */])(_context.t0);

          case 17:
            if (!(!data || data.status !== 200)) {
              _context.next = 20;
              break;
            }

            if (tokenInvalid) {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__assets_js_shared_token_js__["b" /* removeSharedToken */])();
              __WEBPACK_IMPORTED_MODULE_2_vue__["default"].notify({
                title: '登入已失效',
                text: '您的登入已失效或權限不足，請重新登入。',
                duration: 5000,
                type: 'danger',
                width: 400
              });
            } else {
              __WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */].dispatch('setAuthError', '系統暫時無法回應，請稍後再試或重新登入。');
            }
            return _context.abrupt('return');

          case 20:

            window.localStorage.setItem(__WEBPACK_IMPORTED_MODULE_29__assets_js_handle_config_js__["a" /* default */].token, cookieToken);
            window.localStorage.setItem(__WEBPACK_IMPORTED_MODULE_29__assets_js_handle_config_js__["a" /* default */].userId, data.user_id);
            window.localStorage.setItem(__WEBPACK_IMPORTED_MODULE_29__assets_js_handle_config_js__["a" /* default */].roleType, data.role_type);
            if (data.user_name) window.localStorage.setItem(__WEBPACK_IMPORTED_MODULE_29__assets_js_handle_config_js__["a" /* default */].account, data.user_name);
            __WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */].dispatch('setUserInfo', {
              userId: data.user_id,
              token: cookieToken,
              roleType: data.role_type,
              account: data.user_name || ''
            });

          case 25:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[6, 14]]);
  }));

  return function syncTokenFromCookie() {
    return _ref.apply(this, arguments);
  };
}();
























__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('v-select', __WEBPACK_IMPORTED_MODULE_19_vue_select___default.a);


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_vue_functional_calendar__["a" /* default */], {
  dayNames: ['一', '二', '三', '四', '五', '六', '日'],
  monthNames: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
});
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('multiselect', __WEBPACK_IMPORTED_MODULE_20_vue_multiselect___default.a);


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('muti-select-two', __WEBPACK_IMPORTED_MODULE_23__components_elements_jMutiSelect_vue___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('muti-select-two-v2', __WEBPACK_IMPORTED_MODULE_24__components_elements_jMutiSelect_v2_vue___default.a);


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('v-multiselect-listbox', __WEBPACK_IMPORTED_MODULE_25_vue_multiselect_listbox___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('paginate', __WEBPACK_IMPORTED_MODULE_26__components_elements_Paginate_vue___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('m-modal', __WEBPACK_IMPORTED_MODULE_27__components_elements_Modal_vue___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('RecycleScroller', __WEBPACK_IMPORTED_MODULE_6_vue_virtual_scroller__["a" /* RecycleScroller */]);




__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$config = __WEBPACK_IMPORTED_MODULE_29__assets_js_handle_config_js__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('count', __WEBPACK_IMPORTED_MODULE_16__filters__["a" /* count */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('domain', __WEBPACK_IMPORTED_MODULE_16__filters__["b" /* domain */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('prettyDate', __WEBPACK_IMPORTED_MODULE_16__filters__["c" /* prettyDate */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('pluralize', __WEBPACK_IMPORTED_MODULE_16__filters__["d" /* pluralize */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('deliveryName', __WEBPACK_IMPORTED_MODULE_16__filters__["e" /* deliveryName */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('orderStatusName', __WEBPACK_IMPORTED_MODULE_16__filters__["f" /* orderStatusName */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('orderStateColor', __WEBPACK_IMPORTED_MODULE_16__filters__["g" /* orderStateColor */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('shippingStatusName', __WEBPACK_IMPORTED_MODULE_16__filters__["h" /* shippingStatusName */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('shippingStateColor', __WEBPACK_IMPORTED_MODULE_16__filters__["i" /* shippingStateColor */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('shippingVendorName', __WEBPACK_IMPORTED_MODULE_16__filters__["j" /* shippingVendorName */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('tradeName', __WEBPACK_IMPORTED_MODULE_16__filters__["k" /* tradeName */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('cityCode', __WEBPACK_IMPORTED_MODULE_16__filters__["l" /* cityCode */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('disItemSrcType', __WEBPACK_IMPORTED_MODULE_16__filters__["m" /* disItemSrcType */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('disItemStatus', __WEBPACK_IMPORTED_MODULE_16__filters__["n" /* disItemStatus */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('disItemActionType', __WEBPACK_IMPORTED_MODULE_16__filters__["o" /* disItemActionType */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue2_timepicker___default.a);

if (true) {
  var gtag = {
    config: { id: 'G-FLWMCT2Y2J' }
  };
  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_gtag__["a" /* default */], gtag);
}

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_14__routes__["a" /* default */],
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (to.params.savedPosition) return {};
    return savedPosition || { x: 0, y: 0 };
  }
});

router.beforeEach(function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(to, from, next) {
    var needsAuth, isLogin, login;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            needsAuth = to.matched.some(function (record) {
              return record.meta.requiresAuth;
            });

            if (!(needsAuth && !__WEBPACK_IMPORTED_MODULE_28__store_state_js__["a" /* default */].token && !window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_29__assets_js_handle_config_js__["a" /* default */].token))) {
              _context2.next = 4;
              break;
            }

            _context2.next = 4;
            return syncTokenFromCookie();

          case 4:
            isLogin = __WEBPACK_IMPORTED_MODULE_28__store_state_js__["a" /* default */].token || window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_29__assets_js_handle_config_js__["a" /* default */].token);

            if (needsAuth) {
              if (isLogin) {
                if (__WEBPACK_IMPORTED_MODULE_29__assets_js_handle_config_js__["a" /* default */].brand === 'jkos') {
                  if (to.meta.isShowInJkos) {
                    if (to.name === 'dashboard') {
                      next('/menuDetailTable');
                    } else {
                      next();
                    }
                  } else {
                    next({ name: 'NotFound' });
                  }
                } else {
                  if (to.name === 'upJoinMenu' && from.name === 'menuInfo') {
                    next({
                      path: '/' + to.name + '/' + from.params.brand_id + '/' + from.params.menu_id + '/ok'
                    });
                  } else {
                    next();
                  }
                }
              } else {
                login = { path: '/login' };

                if (to.fullPath !== '/') login.query = { redirect: to.fullPath };
                next(login);
              }
            } else {
              next();
            }

          case 6:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function (_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}());
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */], router);

new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  el: '#root',
  router: router,
  store: __WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_17__components_App_vue___default.a);
  }
});

if (window.localStorage) {
  var localUserString = window.localStorage.getItem('user') || 'null';
  var localUser = JSON.parse(localUserString);

  if (localUser && __WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */].state.user !== localUser) {
    __WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */].commit('SET_USER', localUser);
    __WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */].commit('SET_TOKEN', window.localStorage.getItem('token'));
  }
}

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_Menu_binding_pos_vue__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_Menu_binding_pos_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_Menu_binding_pos_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_Schedule_BrandScheduleTable_vue__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_Schedule_BrandScheduleTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_views_Schedule_BrandScheduleTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_Menu_CrBinding_vue__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_Menu_CrBinding_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_views_Menu_CrBinding_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_Menu_CrMenu_vue__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_Menu_CrMenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_views_Menu_CrMenu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_Menu_CrMenuOption_vue__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_Menu_CrMenuOption_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_views_Menu_CrMenuOption_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_Schedule_CrSchedule_vue__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_Schedule_CrSchedule_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_views_Schedule_CrSchedule_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_Menu_menu_build_vue__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_Menu_menu_build_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_views_Menu_menu_build_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_Menu_MenuInfo_vue__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_Menu_MenuInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_views_Menu_MenuInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_Menu_MenuSettingRuleStoreCopy_vue__ = __webpack_require__(2207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_Menu_MenuSettingRuleStoreCopy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_views_Menu_MenuSettingRuleStoreCopy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_views_Menu_MenuSettingRuleStoreCopyLogs_vue__ = __webpack_require__(2208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_views_Menu_MenuSettingRuleStoreCopyLogs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_views_Menu_MenuSettingRuleStoreCopyLogs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_views_Menu_MenuSettingRuleStoreUpdate_vue__ = __webpack_require__(2209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_views_Menu_MenuSettingRuleStoreUpdate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_views_Menu_MenuSettingRuleStoreUpdate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_views_Menu_MenuSettingRuleStoreUpdateLogs_vue__ = __webpack_require__(2210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_views_Menu_MenuSettingRuleStoreUpdateLogs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_views_Menu_MenuSettingRuleStoreUpdateLogs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_views_Menu_menu_step_vue__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_views_Menu_menu_step_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_views_Menu_menu_step_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_views_Menu_ProductImage_vue__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_views_Menu_ProductImage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_views_Menu_ProductImage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_views_Menu_ProductSetting_vue__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_views_Menu_ProductSetting_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_views_Menu_ProductSetting_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_views_Menu_store_menu_vue__ = __webpack_require__(2230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_views_Menu_store_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_views_Menu_store_menu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_views_Menu_UpMenuBlock_vue__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_views_Menu_UpMenuBlock_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_views_Menu_UpMenuBlock_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_views_Menu_UpMenuCategory_vue__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_views_Menu_UpMenuCategory_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_views_Menu_UpMenuCategory_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_views_Menu_UpJoinMenu_vue__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_views_Menu_UpJoinMenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_views_Menu_UpJoinMenu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_views_Menu_UpMenu_vue__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_views_Menu_UpMenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_views_Menu_UpMenu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_views_Menu_UpMenuPackage_vue__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_views_Menu_UpMenuPackage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_views_Menu_UpMenuPackage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_views_Menu_UpMenuProduct_vue__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_views_Menu_UpMenuProduct_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_views_Menu_UpMenuProduct_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_views_Menu_up_menu_adjust_vue__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_views_Menu_up_menu_adjust_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_views_Menu_up_menu_adjust_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_views_Menu_up_menu_option_vue__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_views_Menu_up_menu_option_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_views_Menu_up_menu_option_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_views_Schedule_UpSchedule_vue__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_views_Schedule_UpSchedule_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_views_Schedule_UpSchedule_vue__);



























var brandToStoreMenu = [{
  path: 'brand/:brand_id/store/menu',
  component: __WEBPACK_IMPORTED_MODULE_15__components_views_Menu_store_menu_vue___default.a,
  name: 'StoreMenu',
  meta: {
    title: '門市菜單管理 / 菜單管理',
    description: '',
    route: '',
    requiresAuth: true,
    isShowInJkos: false
  }
}, {
  path: 'brand/:brand_id/ajust/menu',
  component: __WEBPACK_IMPORTED_MODULE_15__components_views_Menu_store_menu_vue___default.a,
  name: 'StoreToMenu',
  meta: {
    title: '選擇門市-配料庫',
    description: '',
    route: '',
    docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/menu.pdf',
    requiresAuth: true,
    isShowInJkos: false
  }
}, {
  path: 'brand/:brand_id/build/menu',
  component: __WEBPACK_IMPORTED_MODULE_15__components_views_Menu_store_menu_vue___default.a,
  name: 'StoreToMenu',
  meta: {
    title: '選擇門市-菜單建置',
    description: '',
    route: '',
    docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/menu.pdf',
    requiresAuth: true,
    isShowInJkos: false
  }
}, {
  path: 'brand/:brand_id/schedule/menu',
  component: __WEBPACK_IMPORTED_MODULE_15__components_views_Menu_store_menu_vue___default.a,
  name: 'StoreToMenu',
  meta: {
    title: '選擇門市-菜單排程',
    description: '',
    route: '',
    docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/menu.pdf',
    requiresAuth: true,
    isShowInJkos: false
  }
}, {
  path: 'brand/:brand_id/store/:store_id/menu/:menu_id/info',
  component: __WEBPACK_IMPORTED_MODULE_7__components_views_Menu_MenuInfo_vue___default.a,
  name: 'StoreMenuInfo',
  meta: {
    title: '門市菜單管理 / 菜單資訊',
    description: '',
    route: '',
    requiresAuth: true,
    isShowInJkos: true
  }
}, {
  path: 'brand/:brand_id/store/:store_id/menu/schedule',
  component: __WEBPACK_IMPORTED_MODULE_1__components_views_Schedule_BrandScheduleTable_vue___default.a,
  name: 'StoreMenuSchedule',
  meta: {
    title: '門市菜單管理 / 排程管理',
    description: '',
    route: '',
    requiresAuth: true,
    isShowInJkos: true
  }
}, {
  path: 'brand/:brand_id/store/:store_id/menu/:menu_id/schedule/create',
  component: __WEBPACK_IMPORTED_MODULE_5__components_views_Schedule_CrSchedule_vue___default.a,
  name: 'StoreMenuScheduleCreate',
  meta: {
    title: '門市菜單管理 / 新增排程',
    description: '',
    route: '',
    requiresAuth: true,
    isShowInJkos: true
  }
}, {
  path: 'brand/:brand_id/store/:store_id/menu/schedule/edit/g/:group_id',
  component: __WEBPACK_IMPORTED_MODULE_24__components_views_Schedule_UpSchedule_vue___default.a,
  name: 'StoreMenuScheduleEditG',
  meta: {
    title: '門市菜單管理 / 編輯排程',
    description: '',
    route: '',
    requiresAuth: true,
    isShowInJkos: true
  }
}, {
  path: 'brand/:brand_id/store/:store_id/menu/schedule/edit/s/:schedule_id',
  component: __WEBPACK_IMPORTED_MODULE_24__components_views_Schedule_UpSchedule_vue___default.a,
  name: 'StoreMenuScheduleEditS',
  meta: {
    title: '門市菜單管理 / 編輯排程',
    description: '',
    route: '',
    requiresAuth: true,
    isShowInJkos: true
  }
}, {
  path: 'brand/:brand_id/store/:store_id/menu/:menu_id/edit',
  component: __WEBPACK_IMPORTED_MODULE_19__components_views_Menu_UpMenu_vue___default.a,
  name: 'StoreMenuEdite',
  meta: {
    title: '門市菜單管理 / 編輯菜單',
    description: '',
    route: '',
    requiresAuth: true,
    isShowInJkos: true
  }
}, {
  path: 'brand/:brand_id/store/:store_id/menu/:menu_id/edit/up-join',
  component: __WEBPACK_IMPORTED_MODULE_18__components_views_Menu_UpJoinMenu_vue___default.a,
  name: 'StoreMenuEditeUpJoin',
  meta: {
    title: '門市菜單管理 / 編輯菜單',
    description: '',
    route: '',
    requiresAuth: true,
    isShowInJkos: true
  }
}, {
  path: 'brand/:brand_id/store/:store_id/menu/step',
  component: __WEBPACK_IMPORTED_MODULE_12__components_views_Menu_menu_step_vue___default.a,
  name: 'StoreMenuStep',
  meta: {
    title: '門市菜單管理 / 配料庫',
    description: '',
    route: '',
    requiresAuth: true,
    isShowInJkos: false
  }
}, {
  path: 'brand/:brand_id/store/:store_id/menu/binding-pos',
  component: __WEBPACK_IMPORTED_MODULE_0__components_views_Menu_binding_pos_vue___default.a,
  name: 'StoreMenuBindingPos',
  meta: {
    title: '門市菜單管理 / 菜單綁定',
    description: '',
    route: '',
    requiresAuth: true,
    isShowInJkos: false
  }
}, {
  path: 'brand/:brand_id/store/:store_id/menu/build',
  component: __WEBPACK_IMPORTED_MODULE_6__components_views_Menu_menu_build_vue___default.a,
  name: 'StoreMenuBuild',
  meta: {
    title: '門市菜單管理 / 菜單建置',
    description: '',
    route: '',
    requiresAuth: true,
    isShowInJkos: true
  }
}, {
  path: 'brand/:brand_id/store/:store_id/menu/build/create',
  component: __WEBPACK_IMPORTED_MODULE_3__components_views_Menu_CrMenu_vue___default.a,
  name: 'StoreMenuBuildCreate',
  meta: {
    title: '門市菜單管理 / 新增菜單',
    description: '',
    route: '',
    requiresAuth: true,
    isShowInJkos: true
  }
}, {
  path: 'brand/:brand_id/store/:store_id/menu/build/option/create/',
  component: __WEBPACK_IMPORTED_MODULE_4__components_views_Menu_CrMenuOption_vue___default.a,
  name: 'StoreMenuOptionCreateView',
  meta: {
    title: '門市菜單管理 / 新增菜單',
    description: '',
    route: '',
    requiresAuth: true,
    isShowInJkos: true
  }
}, {
  path: 'brand/:brand_id/store/:store_id/menu/option',
  component: __WEBPACK_IMPORTED_MODULE_23__components_views_Menu_up_menu_option_vue___default.a,
  name: 'StoreMenuOption',
  meta: {
    title: '門市菜單管理 / 配料',
    description: '',
    route: '',
    requiresAuth: true,
    isShowInJkos: true
  }
}, {
  path: 'brand/:brand_id/store/:store_id/menu/option/create',
  component: __WEBPACK_IMPORTED_MODULE_2__components_views_Menu_CrBinding_vue___default.a,
  name: 'StoreMenuOptionCreate',
  meta: {
    title: '門市菜單管理 / 新增配料',
    description: '',
    route: '',
    requiresAuth: true,
    isShowInJkos: true
  }
}, {
  path: 'brand/:brand_id/store/:store_id/menu/adjust',
  component: __WEBPACK_IMPORTED_MODULE_22__components_views_Menu_up_menu_adjust_vue___default.a,
  name: 'StoreMenuAdjust',
  meta: {
    title: '門市菜單管理 / 配料群組',
    description: '',
    route: '',
    requiresAuth: true,
    isShowInJkos: true
  }
}, {
  path: 'brand/:brand_id/store/:store_id/menu/adjust/create',
  component: __WEBPACK_IMPORTED_MODULE_2__components_views_Menu_CrBinding_vue___default.a,
  name: 'StoreMenuAdjustCreate',
  meta: {
    title: '門市菜單管理 / 新增配料群組',
    description: '',
    route: '',
    requiresAuth: true,
    isShowInJkos: true
  }
}, {
  path: 'brand/:brand_id/store/:store_id/menu/category',
  component: __WEBPACK_IMPORTED_MODULE_17__components_views_Menu_UpMenuCategory_vue___default.a,
  name: 'StoreMenuCategory',
  meta: {
    title: '門市菜單管理 / 商品分類',
    description: '',
    route: '',
    requiresAuth: true,
    isShowInJkos: true
  }
}, {
  path: 'brand/:brand_id/store/:store_id/menu/category/create',
  component: __WEBPACK_IMPORTED_MODULE_2__components_views_Menu_CrBinding_vue___default.a,
  name: 'StoreMenuCategoryCreate',
  meta: {
    title: '門市菜單管理 / 新增商品分類',
    description: '',
    route: '',
    requiresAuth: true,
    isShowInJkos: true
  }
}, {
  path: 'brand/:brand_id/store/:store_id/menu/product',
  component: __WEBPACK_IMPORTED_MODULE_21__components_views_Menu_UpMenuProduct_vue___default.a,
  name: 'StoreMenuProduct',
  meta: {
    title: '門市菜單管理 / 商品',
    description: '',
    route: '',
    requiresAuth: true,
    isShowInJkos: true
  }
}, {
  path: 'brand/:brand_id/store/:store_id/menu/product/create',
  component: __WEBPACK_IMPORTED_MODULE_2__components_views_Menu_CrBinding_vue___default.a,
  name: 'StoreMenuProductCreate',
  meta: {
    title: '門市菜單管理 / 新增商品',
    description: '',
    route: '',
    requiresAuth: true,
    isShowInJkos: true
  }
}, {
  path: 'brand/:brand_id/store/:store_id/menu/block',
  component: __WEBPACK_IMPORTED_MODULE_16__components_views_Menu_UpMenuBlock_vue___default.a,
  name: 'StoreMenuBlock',
  meta: {
    title: '門市菜單管理 / 品項選擇區',
    description: '',
    route: '',
    requiresAuth: true,
    isShowInJkos: true
  }
}, {
  path: 'brand/:brand_id/store/:store_id/menu/block/create',
  component: __WEBPACK_IMPORTED_MODULE_2__components_views_Menu_CrBinding_vue___default.a,
  name: 'StoreMenuBlockCreate',
  meta: {
    title: '門市菜單管理 / 新增品項選擇區',
    description: '',
    route: '',
    requiresAuth: true,
    isShowInJkos: true
  }
}, {
  path: 'brand/:brand_id/store/:store_id/menu/package',
  component: __WEBPACK_IMPORTED_MODULE_20__components_views_Menu_UpMenuPackage_vue___default.a,
  name: 'StoreMenuPackage',
  meta: {
    title: '門市菜單管理 / 套餐',
    description: '',
    route: '',
    requiresAuth: true,
    isShowInJkos: true
  }
}, {
  path: 'brand/:brand_id/store/:store_id/menu/package/create',
  component: __WEBPACK_IMPORTED_MODULE_2__components_views_Menu_CrBinding_vue___default.a,
  name: 'StoreMenuPackageCreate',
  meta: {
    title: '門市菜單管理 / 新增套餐',
    description: '',
    route: '',
    requiresAuth: true,
    isShowInJkos: true
  }
}, {
  path: 'brand/:brand_id/store/:store_id/menu/image',
  component: __WEBPACK_IMPORTED_MODULE_13__components_views_Menu_ProductImage_vue___default.a,
  name: 'StoreMenuImage',
  meta: {
    title: '門市菜單管理 / 圖片庫',
    description: '',
    route: '',
    requiresAuth: true,
    isShowInJkos: true
  }
}, {
  path: 'brand/:brand_id/store/:store_id/menu/setting',
  component: __WEBPACK_IMPORTED_MODULE_14__components_views_Menu_ProductSetting_vue___default.a,
  name: 'StoreMenuSetting',
  meta: {
    title: '門市菜單管理 / 別名/描述/警語',
    description: '',
    route: '',
    requiresAuth: true,
    isShowInJkos: true
  }
}, {
  path: 'brand/:brand_id/menu/setting-rule/store-copy',
  component: __WEBPACK_IMPORTED_MODULE_8__components_views_Menu_MenuSettingRuleStoreCopy_vue___default.a,
  name: 'MenuSettingRuleStoreCopyView',
  meta: {
    title: '門市菜單管理 / 菜單同步權限設定',
    description: '',
    route: '菜單管理/菜單同步權限設定',
    requiresAuth: true,
    isShowInJkos: false
  }
}, {
  path: 'brand/:brand_id/menu/setting-rule/store-copy/logs',
  component: __WEBPACK_IMPORTED_MODULE_9__components_views_Menu_MenuSettingRuleStoreCopyLogs_vue___default.a,
  name: 'MenuSettingRuleStoreCopyLogsView',
  meta: {
    title: '門市菜單管理 / 菜單同步權限設定歷史紀錄',
    description: '',
    route: '菜單管理/菜單同步權限設定/歷史紀錄',
    requiresAuth: true,
    isShowInJkos: false
  }
}, {
  path: 'brand/:brand_id/menu/setting-rule/store-update',
  component: __WEBPACK_IMPORTED_MODULE_10__components_views_Menu_MenuSettingRuleStoreUpdate_vue___default.a,
  name: 'MenuSettingRuleStoreUpdateView',
  meta: {
    title: '門市菜單管理 / 菜單編輯權限設定',
    description: '',
    route: '',
    requiresAuth: true,
    isShowInJkos: false
  }
}, {
  path: 'brand/:brand_id/menu/setting-rule/store-update/logs',
  component: __WEBPACK_IMPORTED_MODULE_11__components_views_Menu_MenuSettingRuleStoreUpdateLogs_vue___default.a,
  name: 'MenuSettingRuleStoreUpdateLogsView',
  meta: {
    title: '門市菜單管理 / 菜單編輯權限設定',
    description: '',
    route: '',
    requiresAuth: true,
    isShowInJkos: false
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (brandToStoreMenu);

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_handle_config_js__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_shared_token_js__ = __webpack_require__(21);




/* harmony default export */ __webpack_exports__["a"] = ({
  setMenuStartTime: function setMenuStartTime(_ref, value) {
    var commit = _ref.commit;

    commit('SET_MENU_START_TIME', value);
  },
  setMenuEndTime: function setMenuEndTime(_ref2, value) {
    var commit = _ref2.commit;

    commit('SET_MENU_END_TIME', value);
  },
  setUserInfo: function setUserInfo(_ref3, _ref4) {
    var commit = _ref3.commit;
    var userId = _ref4.userId,
        token = _ref4.token,
        roleType = _ref4.roleType,
        account = _ref4.account;

    commit('SET_TOKEN', token);
    commit('SET_USER_ID', userId);
    commit('SET_ROLE_TYPE', roleType);
    commit('SET_ACCOUNT', account);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__assets_js_shared_token_js__["c" /* setSharedToken */])(token);
  },
  setRestrictList: function setRestrictList(_ref5, restrict) {
    var commit = _ref5.commit;

    commit('SET_RESTRICT', restrict);
  },
  setTradeTypeList: function setTradeTypeList(_ref6, value) {
    var commit = _ref6.commit;

    commit('SET_TRADE_TPYE', value);
  },
  setToken: function setToken(_ref7, value) {
    var commit = _ref7.commit;

    commit('SET_TOKEN', value);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__assets_js_shared_token_js__["c" /* setSharedToken */])(value);
  },
  setAuthError: function setAuthError(_ref8, value) {
    var commit = _ref8.commit;

    commit('SET_AUTH_ERROR', value);
  },
  clearUserInfo: function clearUserInfo(_ref9) {
    var commit = _ref9.commit;

    commit('SET_TOKEN', '');
    commit('SET_USER_ID', '');
    commit('SET_ROLE_TYPE', '');
    commit('SET_ACCOUNT', '');
    commit('SET_AUTH_ERROR', '');
    window.localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_1__assets_js_handle_config_js__["a" /* default */].token);
    window.localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_1__assets_js_handle_config_js__["a" /* default */].userId);
    window.localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_1__assets_js_handle_config_js__["a" /* default */].roleType);
    window.localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_1__assets_js_handle_config_js__["a" /* default */].account);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__assets_js_shared_token_js__["b" /* removeSharedToken */])();
  },
  setUpCategory: function setUpCategory(_ref10, value) {
    var commit = _ref10.commit;

    commit('SET_UP_CATEGORY', value);
  },
  setUpAdjust: function setUpAdjust(_ref11, value) {
    var commit = _ref11.commit;

    commit('SET_UP_ADJUST', value);
  },
  setModal: function setModal(_ref12, value) {
    var commit = _ref12.commit;

    commit('SET_MODAL', value);
  },
  setSelManagerId: function setSelManagerId(_ref13, value) {
    var commit = _ref13.commit;

    commit('SET_SEL_MANAGER_ID', value);
  },
  setSelRoleType: function setSelRoleType(_ref14, value) {
    var commit = _ref14.commit;

    commit('SET_SEL_ROLE_TYPE', value);
  },
  setModalView: function setModalView(_ref15, value) {
    var commit = _ref15.commit;

    commit('SET_MODAL_VIEW', value);
  },
  setBrandId: function setBrandId(_ref16, value) {
    var commit = _ref16.commit;

    commit('SET_BRAND_ID', value);
  },
  setStoreId: function setStoreId(_ref17, value) {
    var commit = _ref17.commit;

    commit('SET_STORE_ID', value);
  },
  setBrands: function setBrands(_ref18, value) {
    var commit = _ref18.commit;

    commit('SET_BRANDS', value);
  },
  setStores: function setStores(_ref19, value) {
    var commit = _ref19.commit;

    commit('SET_STORES', value);
  },
  setBlackReason: function setBlackReason(_ref20, value) {
    var commit = _ref20.commit;

    commit('SET_BLACK_REASON', value);
  },
  setUnReadNotify: function setUnReadNotify(_ref21, value) {
    var commit = _ref21.commit;

    commit('SET_UNREAD_NOTIFY', value);
  },
  setCityList: function setCityList(_ref22) {
    var commit = _ref22.commit;

    __WEBPACK_IMPORTED_MODULE_0_axios___default()({
      baseURL: __WEBPACK_IMPORTED_MODULE_1__assets_js_handle_config_js__["a" /* default */].baseURL,
      method: 'get',
      url: '/platform/cityAreaList',
      data: null
    }).then(function (response) {
      commit('SET_CITY_LIST', response.data.list);
    }).catch(function (error) {
      console.error(error);
    });
  }
});

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  getMenuStartTime: function getMenuStartTime(state) {
    return state.menuStartTime;
  },
  getMenuEndTime: function getMenuEndTime(state) {
    return state.menuEndTime;
  },

  getUserId: function getUserId(state) {
    return state.userId;
  },
  getToken: function getToken(state) {
    return state.token;
  },
  getRoleType: function getRoleType(state) {
    return state.roleType;
  },
  getAccount: function getAccount(state) {
    return state.account;
  },
  getBrandId: function getBrandId(state) {
    return state.brandId;
  },
  getStoreId: function getStoreId(state) {
    return state.storeId;
  },
  getBrands: function getBrands(state) {
    return state.brands;
  },
  getStores: function getStores(state) {
    return state.stores;
  },

  getUpCategory: function getUpCategory(state) {
    return state.upCategory;
  },
  getUpAdjust: function getUpAdjust(state) {
    return state.upAdjust;
  },

  getModal: function getModal(state) {
    return state.modal;
  },

  getSelManagerId: function getSelManagerId(state) {
    return state.selManagerId;
  },
  getSelRoleType: function getSelRoleType(state) {
    return state.selRoleType;
  },
  getModalView: function getModalView(state) {
    return state.modalView;
  },

  getBlackReason: function getBlackReason(state) {
    return state.blackReason;
  },

  getPickupType: function getPickupType(state) {
    return state.pickupList;
  },

  getUnReadNotify: function getUnReadNotify(state) {
    return state.unReadNotify;
  },
  getTradeType: function getTradeType(state) {
    return state.tradeType;
  },
  getEtradeType: function getEtradeType(state) {
    return state.tradeType.filter(function (x) {
      return x.value !== 1;
    });
  },
  getECtradeType: function getECtradeType(state) {
    return state.tradeType.filter(function (x) {
      return x.value !== 1 && x.value !== 999;
    });
  },

  getRestricted: function getRestricted(state) {
    return state.restrictedList;
  },
  getDenyList: function getDenyList(state) {
    return state.denyList;
  },

  getCityOption: function getCityOption(state) {
    return state.cityList.map(function (city) {
      return {
        name: city.name,
        code: city.city_code
      };
    });
  },

  getNidinLeague: function getNidinLeague(state) {
    return state.nidin_league;
  }
});

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  TOGGLE_LOADING: function TOGGLE_LOADING(state) {
    state.callingAPI = !state.callingAPI;
  },
  TOGGLE_SEARCHING: function TOGGLE_SEARCHING(state) {
    state.searching = state.searching === '' ? 'loading' : '';
  },
  SET_MENU_START_TIME: function SET_MENU_START_TIME(state, menuStartTime) {
    state.menuStartTime = menuStartTime;
  },
  SET_MENU_END_TIME: function SET_MENU_END_TIME(state, menuEndTime) {
    state.menuEndTime = menuEndTime;
  },
  SET_USER_ID: function SET_USER_ID(state, userId) {
    state.userId = userId;
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_AUTH_ERROR: function SET_AUTH_ERROR(state, authError) {
    state.authError = authError;
  },
  SET_RESTRICT: function SET_RESTRICT(state, RESTRICT) {
    state.restrictedList = RESTRICT;
  },
  SET_NIDIN_LEAGUE: function SET_NIDIN_LEAGUE(state, LEAGUE) {
    state.nidin_league = LEAGUE;
  },
  SET_DENYLIST: function SET_DENYLIST(state, denyList) {
    state.denyList = denyList;
  },
  SET_TRADE_TPYE: function SET_TRADE_TPYE(state, value) {
    state.tradeType = value;
  },
  SET_ROLE_TYPE: function SET_ROLE_TYPE(state, roleType) {
    state.roleType = roleType;
  },
  SET_ACCOUNT: function SET_ACCOUNT(state, account) {
    state.account = account || '';
  },
  SET_UP_CATEGORY: function SET_UP_CATEGORY(state, upCategory) {
    state.upCategory = upCategory || false;
  },
  SET_UP_ADJUST: function SET_UP_ADJUST(state, upAdjust) {
    state.upAdjust = upAdjust || false;
  },
  SET_MODAL: function SET_MODAL(state, modal) {
    state.modal = modal || false;
  },
  SET_SEL_MANAGER_ID: function SET_SEL_MANAGER_ID(state, selManagerId) {
    state.selManagerId = selManagerId || 1;
  },
  SET_SEL_ROLE_TYPE: function SET_SEL_ROLE_TYPE(state, selRoleType) {
    state.selRoleType = selRoleType || 'admin';
  },
  SET_MODAL_VIEW: function SET_MODAL_VIEW(state, modalView) {
    state.modalView = modalView || false;
  },
  SET_BRAND_ID: function SET_BRAND_ID(state, brandId) {
    state.brandId = brandId || '';
  },
  SET_BRANDS: function SET_BRANDS(state, brands) {
    state.brands = brands;
  },
  SET_STORE_ID: function SET_STORE_ID(state, storeId) {
    state.storeId = storeId || '';
  },
  SET_STORE_INFO: function SET_STORE_INFO(state, stores) {
    state.storeInfo = stores;
  },
  SET_STORES: function SET_STORES(state, stores) {
    state.stores = stores;
  },
  SET_BLACK_REASON: function SET_BLACK_REASON(state, blackReason) {
    state.blackReason = blackReason || [];
  },
  SET_UNREAD_NOTIFY: function SET_UNREAD_NOTIFY(state, amount) {
    state.unReadNotify = amount || 0;
  },
  SET_CITY_LIST: function SET_CITY_LIST(state, list) {
    state.cityList = list || [];
  }
});

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    required: false,
    date: {
      type: Object,
      required: true
    },
    option: {
      type: Object,
      default: function _default() {
        return {
          type: 'day',
          SundayFirst: false,
          week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
          month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
          format: 'YYYY-MM-DD',
          color: {
            checked: '#F50057',
            header: '#3f51b5',
            headerText: '#fff'
          },
          inputStyle: {
            'display': 'inline-block',
            'padding': '6px',
            'line-height': '22px',
            'font-size': '16px',
            'border': '2px solid #fff',
            'box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
            'border-radius': '2px',
            'color': '#5F5F5F'
          },
          placeholder: 'when?',
          buttons: {
            ok: 'OK',
            cancel: 'Cancel'
          },
          overlayOpacity: 0.5,
          dismissible: true
        };
      }
    },
    limit: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    function hours() {
      var list = [];
      var hour = 24;
      while (hour > 0) {
        hour--;
        list.push({
          checked: false,
          value: hour < 10 ? '0' + hour : hour
        });
      }
      return list;
    }
    function mins() {
      var list = [];
      var min = 60;
      while (min > 0) {
        min--;
        list.push({
          checked: false,
          value: min < 10 ? '0' + min : min
        });
      }
      return list;
    }
    return {
      hours: hours(),
      mins: mins(),
      showInfo: {
        hour: false,
        day: false,
        month: false,
        year: false,
        check: false
      },
      displayInfo: {
        month: ''
      },
      library: {
        week: this.option.week,
        month: this.option.month,
        year: []
      },
      checked: {
        oldtime: '',
        currentMoment: null,
        year: '',
        month: '',
        day: '',
        hour: '00',
        min: '00'
      },
      dayList: [],
      selectedDays: []
    };
  },

  methods: {
    pad: function pad(n) {
      n = Math.floor(n);
      return n < 10 ? '0' + n : n;
    },
    nextMonth: function nextMonth(type) {
      var next = null;
      type === 'next' ? next = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).add(1, 'M') : next = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).add(-1, 'M');
      this.showDay(next);
    },
    showDay: function showDay(time) {
      if (time === undefined || !Date.parse(time)) {
        this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
      } else {
        this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(time, this.option.format);
      }
      this.showOne('day');
      this.checked.year = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).format('YYYY');
      this.checked.month = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).format('MM');
      this.checked.day = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).format('DD');
      this.displayInfo.month = this.library.month[__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).month()];
      var days = [];
      var currentMoment = this.checked.currentMoment;
      var firstDay = __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).date(1).day();

      var previousMonth = __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment);
      var nextMonth = __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment);
      nextMonth.add(1, 'months');
      previousMonth.subtract(1, 'months');
      var monthDays = __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).daysInMonth();
      var oldtime = this.checked.oldtime;
      for (var i = 1; i <= monthDays; ++i) {
        days.push({
          value: i,
          inMonth: true,
          unavailable: false,
          checked: false,
          moment: __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).date(i)
        });
        if (i === Math.ceil(__WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).format('D')) && __WEBPACK_IMPORTED_MODULE_2_moment___default()(oldtime, this.option.format).year() === __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).year() && __WEBPACK_IMPORTED_MODULE_2_moment___default()(oldtime, this.option.format).month() === __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).month()) {
          days[i - 1].checked = true;
        }
        this.checkBySelectDays(i, days);
      }
      if (firstDay === 0) firstDay = 7;
      for (var _i = 0; _i < firstDay - (this.option.SundayFirst ? 0 : 1); _i++) {
        var passiveDay = {
          value: previousMonth.daysInMonth() - _i,
          inMonth: false,
          action: 'previous',
          unavailable: false,
          checked: false,
          moment: __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).date(1).subtract(_i + 1, 'days')
        };
        days.unshift(passiveDay);
      }
      if (this.limit.length > 0) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.limit), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var li = _step.value;

            switch (li.type) {
              case 'fromto':
                days = this.limitFromTo(li, days);
                break;
              case 'weekday':
                days = this.limitWeekDay(li, days);
                break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      var passiveDaysAtFinal = 42 - days.length;
      for (var _i2 = 1; _i2 <= passiveDaysAtFinal; _i2++) {
        var _passiveDay = {
          value: _i2,
          inMonth: false,
          action: 'next',
          unavailable: false,
          checked: false,
          moment: __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).add(1, 'months').date(_i2)
        };
        days.push(_passiveDay);
      }
      this.dayList = days;
    },
    checkBySelectDays: function checkBySelectDays(d, days) {
      var _this = this;

      this.selectedDays.forEach(function (day) {
        if (_this.checked.year === __WEBPACK_IMPORTED_MODULE_2_moment___default()(day).format('YYYY') && _this.checked.month === __WEBPACK_IMPORTED_MODULE_2_moment___default()(day).format('MM') && d === Math.ceil(__WEBPACK_IMPORTED_MODULE_2_moment___default()(day).format('D'))) {
          days[d - 1].checked = true;
        }
      });
    },
    limitWeekDay: function limitWeekDay(limit, days) {
      days.map(function (day) {
        if (limit.available.indexOf(Math.floor(day.moment.format('d'))) === -1) {
          day.unavailable = true;
        }
      });
      return days;
    },
    limitFromTo: function limitFromTo(limit, days) {
      var _this2 = this;

      if (limit.from || limit.to) {
        days.map(function (day) {
          if (_this2.getLimitCondition(limit, day)) {
            day.unavailable = true;
          }
        });
      }
      return days;
    },
    getLimitCondition: function getLimitCondition(limit, day) {
      var tmpMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.year + '-' + this.pad(this.checked.month) + '-' + this.pad(day.value));
      if (limit.from && !limit.to) {
        return !tmpMoment.isAfter(limit.from);
      } else if (!limit.from && limit.to) {
        return !tmpMoment.isBefore(limit.to);
      } else {
        return !tmpMoment.isBetween(limit.from, limit.to);
      }
    },
    checkDay: function checkDay(obj) {
      if (obj.unavailable || obj.value === '') {
        return false;
      }
      if (!obj.inMonth) {
        this.nextMonth(obj.action);
      }
      if (this.option.type === 'day' || this.option.type === 'min') {
        this.dayList.forEach(function (x) {
          x.checked = false;
        });
        this.checked.day = this.pad(obj.value);
        obj.checked = true;
      } else {
        var day = this.pad(obj.value);
        var ctime = this.checked.year + '-' + this.checked.month + '-' + day;
        if (obj.checked === true) {
          obj.checked = false;
          this.selectedDays.$remove(ctime);
        } else {
          this.selectedDays.push(ctime);
          obj.checked = true;
        }
      }
      switch (this.option.type) {
        case 'day':
          this.picked();
          break;
        case 'min':
          this.showOne('hour');

          this.shiftActTime();
          break;
      }
    },
    showYear: function showYear() {
      var _this3 = this;

      var year = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).year();
      this.library.year = [];
      var yearTmp = [];
      for (var i = year - 100; i < year + 5; ++i) {
        yearTmp.push(i);
      }
      this.library.year = yearTmp;
      this.showOne('year');
      this.$nextTick(function () {
        var listDom = document.getElementById('yearList');
        listDom.scrollTop = listDom.scrollHeight - 100;
        _this3.addYear();
      });
    },
    showOne: function showOne(type) {
      switch (type) {
        case 'year':
          this.showInfo.hour = false;
          this.showInfo.day = false;
          this.showInfo.year = true;
          this.showInfo.month = false;
          break;
        case 'month':
          this.showInfo.hour = false;
          this.showInfo.day = false;
          this.showInfo.year = false;
          this.showInfo.month = true;
          break;
        case 'day':
          this.showInfo.hour = false;
          this.showInfo.day = true;
          this.showInfo.year = false;
          this.showInfo.month = false;
          break;
        case 'hour':
          this.showInfo.hour = true;
          this.showInfo.day = false;
          this.showInfo.year = false;
          this.showInfo.month = false;
          break;
        default:
          this.showInfo.day = true;
          this.showInfo.year = false;
          this.showInfo.month = false;
          this.showInfo.hour = false;
      }
    },
    showMonth: function showMonth() {
      this.showOne('month');
    },
    addYear: function addYear() {
      var _this4 = this;

      var listDom = document.getElementById('yearList');
      listDom.addEventListener('scroll', function (e) {
        if (listDom.scrollTop < listDom.scrollHeight - 100) {
          var len = _this4.library.year.length;
          var lastYear = _this4.library.year[len - 1];
          _this4.library.year.push(lastYear + 1);
        }
      }, false);
    },
    setYear: function setYear(year) {
      this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(year + '-' + this.checked.month + '-' + this.checked.day);
      this.showDay(this.checked.currentMoment);
    },
    setMonth: function setMonth(month) {
      var mo = this.library.month.indexOf(month) + 1;
      if (mo < 10) {
        mo = '0' + '' + mo;
      }
      this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.year + '-' + mo + '-' + this.checked.day);
      this.showDay(this.checked.currentMoment);
    },
    showCheck: function showCheck() {
      if (this.date.time === '') {
        this.showDay();
      } else {
        if (this.option.type === 'day' || this.option.type === 'min') {
          this.checked.oldtime = this.date.time;
          this.showDay(this.date.time);
        } else {
          this.selectedDays = JSON.parse(this.date.time);
          if (this.selectedDays.length) {
            this.checked.oldtime = this.selectedDays[0];
            this.showDay(this.selectedDays[0]);
          } else {
            this.showDay();
          }
        }
      }
      this.showInfo.check = true;
    },
    setTime: function setTime(type, obj, list) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          item.checked = false;
          if (item.value === obj.value) {
            item.checked = true;
            this.checked[type] = item.value;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    picked: function picked() {
      if (this.option.type === 'day' || this.option.type === 'min') {
        var ctime = this.checked.year + '-' + this.checked.month + '-' + this.checked.day + ' ' + this.checked.hour + ':' + this.checked.min;
        this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(ctime, 'YYYY-MM-DD HH:mm');
        this.date.time = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).format(this.option.format);
      } else {
        this.date.time = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedDays);
      }
      this.showInfo.check = false;
      this.$emit('change', this.date.time);
    },
    dismiss: function dismiss(evt) {
      if (evt.target.className === 'datepicker-overlay') {
        if (this.option.dismissible === undefined || this.option.dismissible) {
          this.showInfo.check = false;
          this.$emit('cancel');
        }
      }
    },
    shiftActTime: function shiftActTime() {
      this.$nextTick(function () {
        if (!document.querySelector('.hour-item.active')) {
          return false;
        }
        document.querySelector('.hour-box').scrollTop = (document.querySelector('.hour-item.active').offsetTop || 0) - 250;
        document.querySelector('.min-box').scrollTop = (document.querySelector('.min-item.active').offsetTop || 0) - 250;
      });
    }
  }
});

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Arrows',
  props: {
    fConfigs: {
      type: Object,
      required: true
    },
    allowPreDate: {
      type: Boolean,
      required: true
    },
    allowNextDate: {
      type: Boolean,
      required: true
    },
    calendarKey: {
      type: Number,
      default: 0
    },
    isMultiple: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    oneArrows: function oneArrows() {
      return !this.fConfigs.isSeparately && !this.isMultiple;
    },
    manyArrows: function manyArrows() {
      return this.fConfigs.isSeparately && this.isMultiple;
    }
  }
});

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Day',
  props: {
    day_key: {
      type: Number,
      required: true
    },
    week: {
      type: Object,
      required: true
    },
    day: {
      type: Object,
      required: true
    },
    helpCalendar: {
      type: Object,
      required: true
    },
    fConfigs: {
      type: Object,
      required: true
    },
    calendar: {
      type: Object,
      required: true
    },
    alwaysUseDefaultClasses: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      toolTip: false,
      onNumber: false
    };
  },

  computed: {
    startActive: function startActive() {
      if (!this.fConfigs.isMultipleDateRange) return (this.day.isDateRangeStart || this.day.isMouseToLeft) && !this.day.hideLeftAndRightDays;

      if (!''.inRange) this.inRangeInit();

      var inAnyRange = this.day.date.inRange(this.calendar.multipleDateRange);

      var lastElement = this.calendar.multipleDateRange[this.calendar.multipleDateRange.length - 1];
      if (!lastElement) return inAnyRange;
      var lastHasDayStart = ~this.calendar.multipleDateRange.map(function (range) {
        return range.start;
      }).indexOf(this.day.date);
      var lastHasDayEnd = ~this.calendar.multipleDateRange.map(function (range) {
        return range.end;
      }).indexOf(this.day.date);

      if (lastHasDayStart === lastHasDayEnd && lastHasDayEnd) return inAnyRange;

      if (lastHasDayStart && ~lastHasDayStart > -1 && this.calendar.multipleDateRange[~lastHasDayStart].end) return lastHasDayStart || inAnyRange;

      if (!lastElement.start && !lastElement.end) {
        return lastHasDayStart || inAnyRange;
      }


      return (this.day.isDateRangeStart || this.day.isMouseToLeft) && !this.day.hideLeftAndRightDays || inAnyRange;
    },
    endActive: function endActive() {
      if (!this.fConfigs.isMultipleDateRange) return (this.day.isDateRangeEnd || this.day.isMouseToRight) && !this.day.hideLeftAndRightDays;

      if (!''.inRange) this.inRangeInit();

      var inAnyRange = this.day.date.inRange(this.calendar.multipleDateRange);

      var lastElement = this.calendar.multipleDateRange[this.calendar.multipleDateRange.length - 1];
      if (!lastElement) return inAnyRange;

      var lastHasDayStart = ~this.calendar.multipleDateRange.map(function (range) {
        return range.start;
      }).indexOf(this.day.date);
      var lastHasDayEnd = ~this.calendar.multipleDateRange.map(function (range) {
        return range.end;
      }).indexOf(this.day.date);

      if (lastHasDayStart === lastHasDayEnd && lastHasDayEnd) return inAnyRange;

      if (lastHasDayEnd) return true;

      if (!lastElement.start && !lastElement.end) {
        if (lastElement.start === lastElement.end) return false;
        return lastHasDayEnd;
      }
      return (this.day.isDateRangeEnd || this.day.isMouseToRight) && !this.day.hideLeftAndRightDays || inAnyRange;
    },
    numberShow: function numberShow() {
      if (!this.fConfigs.isMultipleDateRange) return false;

      var endPos = this.calendar.multipleDateRange.map(function (range) {
        return range.end;
      }).indexOf(this.day.date);

      return !!(~endPos || ~this.calendar.multipleDateRange.map(function (range) {
        return range.start;
      }).indexOf(this.day.date));
    },
    timesShow: function timesShow() {
      var res = this.calendar.multipleDateRange ? ~this.calendar.multipleDateRange.map(function (range) {
        return range.end;
      }).indexOf(this.day.date) : -1;
      return this.fConfigs.isMultipleDateRange && res;
    },
    getDaysNumber: function getDaysNumber() {
      var endPosFirst = this.calendar.multipleDateRange.map(function (range) {
        return range.end;
      }).indexOf(this.day.date);
      var startPosFirst = this.calendar.multipleDateRange.map(function (range) {
        return range.start;
      }).indexOf(this.day.date);
      var endPosLast = this.calendar.multipleDateRange.map(function (range) {
        return range.end;
      }).lastIndexOf(this.day.date);
      var startPosLast = this.calendar.multipleDateRange.map(function (range) {
        return range.start;
      }).lastIndexOf(this.day.date);

      this.toolTip = endPosFirst !== endPosLast || startPosFirst !== startPosLast || endPosFirst > -1 && startPosFirst > -1 || startPosFirst > -1 && endPosFirst > -1;

      if (this.toolTip) {
        return '·';
      }

      return (endPosFirst > -1 ? Number(endPosFirst) : 0) || startPosFirst;
    }
  },
  methods: {
    toolTipTxt: function toolTipTxt() {
      var numbers = [];
      var endArr = this.calendar.multipleDateRange.map(function (range) {
        return range.end;
      });
      var startArr = this.calendar.multipleDateRange.map(function (range) {
        return range.start;
      });
      var endIndex = 0;
      var startIndex = 0;
      var ind = endArr.indexOf(this.day.date, endIndex);
      while (~endArr.indexOf(this.day.date, endIndex)) {
        ind = endArr.indexOf(this.day.date, endIndex);

        numbers.push(ind);
        endIndex = ind + 1;
      }
      ind = startArr.indexOf(this.day.date, startIndex);
      while (~startArr.indexOf(this.day.date, startIndex)) {
        ind = startArr.indexOf(this.day.date, startIndex);

        numbers.push(ind);
        startIndex = ind + 1;
      }
      return numbers.sort(function (a, b) {
        return a - b;
      });
    },
    inRangeInit: function inRangeInit() {
      var helpCalendar = this.helpCalendar;
      String.prototype.inRange = function (arr) {
        var _this = this;

        var res = false;
        arr.forEach(function (el) {
          var start = +helpCalendar.getDateFromFormat(el.start.split(' ')[0]);
          var end = +helpCalendar.getDateFromFormat(el.end.split(' ')[0]);
          var current = +helpCalendar.getDateFromFormat(_this.split(' ')[0]);
          if (start === end) return;
          if (start && end) res = res || start < current && current < end;
        });
        return res;
      };
    },
    clearRange: function clearRange() {
      var _this2 = this;

      var removeIndex = this.calendar.multipleDateRange.findIndex(function (range) {
        return range.end === _this2.day.date;
      });
      this.calendar.multipleDateRange.splice(removeIndex, 1);
    },
    dayMouseOver: function dayMouseOver() {
      this.$emit('dayMouseOver', this.day.date);
    },
    hasSlot: function hasSlot() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';

      return !!this.$parent.$parent.$slots[name] || !!this.$parent.$parent.$scopedSlots[name];
    },
    isDisabledDate: function isDisabledDate(date) {
      var datesCollection = this.fConfigs.disabledDates;

      return this.isDateIncludedInDatesCollection(date, datesCollection) || !this.isEnabledDate(date);
    },
    isEnabledDate: function isEnabledDate(date) {
      var datesCollection = this.fConfigs.enabledDates;

      return datesCollection.length === 0 || this.isDateIncludedInDatesCollection(date, datesCollection);
    },
    isDateIncludedInDatesCollection: function isDateIncludedInDatesCollection(date, datesCollection) {
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      var dateObj = this.helpCalendar.getDateFromFormat(date);

      return datesCollection.includes(date) || datesCollection.includes('beforeToday') && dateObj.getTime() < today.getTime() || datesCollection.includes('afterToday') && dateObj.getTime() > today.getTime();
    },
    getClassNames: function getClassNames(day) {
      var _this3 = this;

      var classes = [];

      if (!this.hasSlot('default') || this.alwaysUseDefaultClasses) {
        classes.push('vfc-span-day');
      }

      var dateDay = this.helpCalendar.getDateFromFormat(day.date).getDay() - 1;
      if (dateDay === -1) {
        dateDay = 6;
      }
      var dayOfWeekString = this.fConfigs.dayNames[dateDay];
      if (this.fConfigs.disabledDayNames.includes(dayOfWeekString)) {
        day.hide = true;
        classes.push('vfc-cursor-not-allowed');
      }

      var date = this.helpCalendar.getDateFromFormat(day.date);
      var today = new Date();
      today.setHours(0, 0, 0, 0);

      if (this.isDisabledDate(day.date)) {
        classes.push('vfc-disabled');
        classes.push('vfc-cursor-not-allowed');
      }

      if (this.fConfigs.limits) {
        var min = this.helpCalendar.getDateFromFormat(this.fConfigs.limits.min).getTime();
        var max = this.helpCalendar.getDateFromFormat(this.fConfigs.limits.max).getTime();

        if (date.getTime() < min || date.getTime() > max) {
          classes.push('vfc-disabled');
          classes.push('vfc-cursor-not-allowed');
        }
      }

      if (day.hide) {
        classes.push('vfc-hide');
      }

      if (day.isToday) {
        classes.push('vfc-today');
      }
      if (!day.hideLeftAndRightDays && !this.fConfigs.disabledDayNames.includes(dayOfWeekString)) {
        if (day.isMarked) {
          classes.push('vfc-marked');
        } else if (day.isHovered) {
          classes.push('vfc-hovered');
        }
        if (this.fConfigs.markedDates.includes(day.date)) {
          classes.push('vfc-borderd');
        }

        if (Array.isArray(this.fConfigs.markedDateRange)) {
          this.fConfigs.markedDateRange.forEach(function (range) {
            if (_this3.helpCalendar.getDateFromFormat(range.start) <= _this3.helpCalendar.getDateFromFormat(day.date) && _this3.helpCalendar.getDateFromFormat(range.end) >= _this3.helpCalendar.getDateFromFormat(day.date)) {
              classes.push('vfc-marked');
            }
            if (day.date === range.start) {
              classes.push('vfc-start-marked');
            } else if (day.date === range.end) {
              classes.push('vfc-end-marked');
            }
          });
        } else if (this.fConfigs.markedDateRange.start && this.fConfigs.markedDateRange.end) {

          if (this.helpCalendar.getDateFromFormat(this.fConfigs.markedDateRange.start) <= this.helpCalendar.getDateFromFormat(day.date) && this.helpCalendar.getDateFromFormat(this.fConfigs.markedDateRange.end) >= this.helpCalendar.getDateFromFormat(day.date)) {
            classes.push('vfc-marked');
          }
          if (day.date === this.fConfigs.markedDateRange.start) {
            classes.push('vfc-start-marked');
          } else if (day.date === this.fConfigs.markedDateRange.end) {
            classes.push('vfc-end-marked');
          }
        } else {
          if (this.fConfigs.markedDateRange.start) {
            if (this.helpCalendar.getDateFromFormat(this.fConfigs.markedDateRange.start) <= this.helpCalendar.getDateFromFormat(day.date)) classes.push('vfc-marked');
          }

          if (this.fConfigs.markedDateRange.end) {
            if (this.helpCalendar.getDateFromFormat(this.fConfigs.markedDateRange.end) >= this.helpCalendar.getDateFromFormat(day.date)) classes.push('vfc-marked');
          }
        }

        classes.push('vfc-hover');
      }

      if (this.fConfigs.isMultipleDateRange) {
        if (!''.inRange) this.inRangeInit();

        if (day.isMarked || ~this.calendar.multipleDateRange.map(function (range) {
          return range.start.split(' ')[0];
        }).indexOf(day.date) || ~this.calendar.multipleDateRange.map(function (range) {
          return range.end.split(' ')[0];
        }).indexOf(day.date) || day.date.inRange(this.calendar.multipleDateRange)) {
          classes.push('vfc-marked');
        }

        if (this.fConfigs.markedDates.includes(day.date)) {
          classes.push('vfc-borderd');
        }

        if (~this.calendar.multipleDateRange.map(function (range) {
          return range.start.split(' ')[0];
        }).indexOf(day.date)) {
          classes.push('vfc-start-marked');
        }

        if (~this.calendar.multipleDateRange.map(function (range) {
          return range.end.split(' ')[0];
        }).indexOf(day.date)) {
          classes.push('vfc-end-marked');
        }
      }

      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.fConfigs.markedDates) === 'object') {
        var checkMarked = this.fConfigs.markedDates.find(function (markDate) {
          return markDate.date === day.date;
        });

        if (typeof checkMarked !== 'undefined') {
          classes.push(checkMarked.class);
        }
      }

      if (day.date === this.calendar.dateRange.start.split(' ')[0]) {
        classes.push('vfc-start-marked');
      }

      if (day.date === this.calendar.dateRange.end.split(' ')[0]) {
        classes.push('vfc-end-marked');
      }

      if (day.date === this.calendar.selectedDate || this.calendar.hasOwnProperty('selectedDates') && this.calendar.selectedDates.find(function (sDate) {
        return sDate.date === day.date;
      })) {
        classes.push('vfc-borderd');
      }

      return classes;
    }
  }
});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Footer'
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_js_helpCalendar__ = __webpack_require__(2083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_propsAndData__ = __webpack_require__(2084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_TimePicker_vue__ = __webpack_require__(2290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_TimePicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_TimePicker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Arrows_vue__ = __webpack_require__(2284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Arrows_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Arrows_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_WeekNumbers_vue__ = __webpack_require__(2291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_WeekNumbers_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_WeekNumbers_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Day_vue__ = __webpack_require__(2285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Day_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Day_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_MonthYearPicker_vue__ = __webpack_require__(2288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_MonthYearPicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_MonthYearPicker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_PickerInputs_vue__ = __webpack_require__(2289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_PickerInputs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_PickerInputs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Footer_vue__ = __webpack_require__(2286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Footer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_helpers__ = __webpack_require__(2085);



















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FunctionalCalendar',
  components: {
    MonthYearPicker: __WEBPACK_IMPORTED_MODULE_10__components_MonthYearPicker_vue___default.a,
    TimePicker: __WEBPACK_IMPORTED_MODULE_6__components_TimePicker_vue___default.a,
    PickerInputs: __WEBPACK_IMPORTED_MODULE_11__components_PickerInputs_vue___default.a,
    Arrows: __WEBPACK_IMPORTED_MODULE_7__components_Arrows_vue___default.a,
    Footer: __WEBPACK_IMPORTED_MODULE_12__components_Footer_vue___default.a,
    Day: __WEBPACK_IMPORTED_MODULE_9__components_Day_vue___default.a,
    WeekNumbers: __WEBPACK_IMPORTED_MODULE_8__components_WeekNumbers_vue___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_propsAndData__["a" /* propsAndData */]],
  computed: {
    startDMY: function startDMY() {
      if (this.calendar.dateRange.start) {
        return this.calendar.dateRange.start.split(' ')[0];
      }
      return '';
    },
    endDMY: function endDMY() {
      if (this.calendar.dateRange.end) {
        return this.calendar.dateRange.end.split(' ')[0];
      }
      return '';
    },
    rangeIsSelected: function rangeIsSelected() {
      if (!this.isMultipleDateRange) return !!(this.calendar.dateRange.end && this.calendar.dateRange.start);
      return this.calendar.multipleDateRange.length > 0;
    },
    helpCalendar: function helpCalendar() {
      return new __WEBPACK_IMPORTED_MODULE_4__assets_js_helpCalendar__["a" /* default */](this.fConfigs.sundayStart, this.checkHiddenElement('leftAndRightDays'), this.fConfigs.dateFormat, this.fConfigs.dayNames);
    },

    singleSelectedDate: {
      get: function get() {
        var res = '';
        if (this.displayTimeInput) {
          var validFormats = ['HH:MM', 'HH:mm', 'hh:MM', 'hh:mm', 'MM:HH', 'mm:HH', 'MM:hh', 'mm:hh'];
          var format = this.fConfigs.dateFormat;
          if (this.dateFormat) {
            format = this.dateFormat;
          }
          if (validFormats.indexOf(format.split(' ')[1]) > 3) {
            res += ' ' + [this.calendar.selectedHour, this.calendar.selectedMinute].reverse().join(':');
          } else {
            res += ' ' + [this.calendar.selectedHour, this.calendar.selectedMinute].join(':');
          }
        }

        return this.calendar.selectedDate ? this.calendar.selectedDate + res : '';
      },
      set: function set(newValue) {
        newValue = this.helpCalendar.mask(newValue);
        if (this.helpCalendar.getDateFromFormat(newValue).getMonth()) {
          this.calendar.selectedDate = newValue;
        }
      }
    }
  },
  created: function created() {
    this.setConfigs();
    this.initCalendar();
  },
  mounted: function mounted() {
    if (this.displayTimeInput) {
      var timeFormat = this.fConfigs.placeholder.split(' ')[1];
      if (!timeFormat) {
        this.fConfigs.placeholder += ' hh:mm';
      }
    }

    this.popoverElement = this.$refs.popoverElement;

    this.popoverElement.addEventListener('focusin', this.onFocusIn);
    this.popoverElement.addEventListener('focusout', this.onFocusOut);
    window.addEventListener('click', this.hideMonthYearPicker, {
      capture: true
    });

    this.$watch('value', function (value) {
      if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(value)) === 'object' && (value.hasOwnProperty('dateRange') || value.hasOwnProperty('selectedDate'))) {
        this.calendar = value;
      } else if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(value)) === 'object' && value.hasOwnProperty('multipleDateRange')) {
        this.calendar.multipleDateRange = value.multipleDateRange;
        var lastElement = this.calendar.multipleDateRange[Math.max(0, this.calendar.multipleDateRange.length - 1)];
        if (lastElement && (lastElement.start && !lastElement.end || !lastElement.start && lastElement.end)) {
          throw new Error('Invalid Data Range');
        }
      }
    }, { immediate: true, deep: true });

    this.$watch('showCalendar', function (value) {
      if (value) this.$emit('opened');else this.$emit('closed');
    }, { immediate: true, deep: true });
  },

  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('focusin', this.onFocusIn);
    window.removeEventListener('focusout', this.onFocusOut);
    window.removeEventListener('click', this.hideMonthYearPicker);
  },
  watch: {
    enabledDates: {
      handler: function handler() {
        this.fConfigs.enabledDates = this.enabledDates;
      },

      deep: true
    },
    'configs.enabledDates': {
      handler: function handler() {
        this.fConfigs.enabledDates = this.configs.enabledDates;
      },

      deep: true
    },
    fConfigs: {
      handler: function handler() {
        this.markChooseDays();
      },

      deep: true,
      immediate: true
    },
    calendar: {
      handler: function handler() {
        this.markChooseDays();
      },

      deep: true,
      immediate: true
    },
    'calendar.currentDate': {
      handler: function handler(value) {
        this.$emit('input', this.calendar);
        this.checkLimits(value);
      }
    }
  },
  methods: {
    initCalendar: function initCalendar() {
      this.setCalendarData();
      this.listRendering();
      this.markChooseDays();
      this.checkLimits(this.calendar.currentDate);
    },
    updateCalendar: function updateCalendar() {
      this.setExistingCalendarData();
      this.listRendering();
      this.markChooseDays();
    },
    isNotSeparatelyAndFirst: function isNotSeparatelyAndFirst(key) {
      return this.isSeparately || key == 0;
    },
    setCalendarData: function setCalendarData() {
      var date = this.calendar.currentDate;
      date = new Date(date.getFullYear(), date.getMonth() - 1);

      this.listCalendars = [];

      for (var i = 0; i < this.fConfigs.calendarsCount; i++) {
        date = new Date(date.getFullYear(), date.getMonth() + 1);

        var calendar = {
          key: i + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["a" /* hUniqueID */])(),
          date: date,
          dateTop: this.fConfigs.monthNames[date.getMonth()] + ' ' + date.getFullYear(),
          month: this.fConfigs.monthNames[date.getMonth()],
          year: date.getFullYear(),
          weeks: this.helpCalendar.getFinalizedWeeks(date.getMonth(), date.getFullYear())
        };

        this.listCalendars.push(calendar);

        if (!this.fConfigs.isMultiple) {
          break;
        }
      }
    },
    setExistingCalendarData: function setExistingCalendarData() {
      for (var i = 0; i < this.listCalendars.length; i++) {
        var calendar = this.listCalendars[i];
        var date = calendar.date;

        this.$set(this.listCalendars, i, {
          key: calendar.key,
          date: date,
          dateTop: this.fConfigs.monthNames[date.getMonth()] + ' ' + date.getFullYear(),
          month: this.fConfigs.monthNames[date.getMonth()],
          year: date.getFullYear(),
          weeks: this.helpCalendar.getFinalizedWeeks(date.getMonth(), date.getFullYear())
        });

        if (!this.fConfigs.isMultiple) {
          break;
        }
      }
    },
    setConfigs: function setConfigs() {
      var _this = this;

      var globalOptions = void 0;
      if (typeof this.$getOptions !== 'undefined') {
        globalOptions = this.$getOptions();
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(globalOptions).forEach(function (objectKey) {
          if (typeof _this.fConfigs[objectKey] !== 'undefined') {
            _this.$set(_this.fConfigs, objectKey, globalOptions[objectKey]);
          }
        });
      }

      if (typeof this.configs !== 'undefined') {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.fConfigs).forEach(function (objectKey) {
          if (typeof _this.configs[objectKey] !== 'undefined') {
            _this.$set(_this.fConfigs, objectKey, _this.configs[objectKey]);
          }
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.$props).forEach(function (objectKey) {
          if (typeof _this.fConfigs[objectKey] !== 'undefined' && typeof _this.$props[objectKey] !== 'undefined') {
            _this.$set(_this.fConfigs, objectKey, _this.$props[objectKey]);
          }
        });
      }

      if (this.fConfigs.isModal) this.showCalendar = false;

      if (!this.fConfigs.placeholder) this.fConfigs.placeholder = this.fConfigs.dateFormat;

      if (typeof this.newCurrentDate !== 'undefined') {
        this.calendar.currentDate = this.newCurrentDate;
      }

      if (this.fConfigs.sundayStart) {
        var dayNames = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.fConfigs.dayNames));
        var sundayName = dayNames[dayNames.length - 1];
        dayNames.splice(dayNames.length - 1, 1);
        dayNames.unshift(sundayName);
        this.fConfigs.dayNames = dayNames;
      }
    },
    listRendering: function listRendering() {
      var _this2 = this;

      this.listCalendars.forEach(function (calendar) {
        calendar.weeks.forEach(function (week) {
          var finalizedDays = [];

          week.days.forEach(function (day) {
            var date = new Date(day.year, day.month, day.day);
            var now = new Date();

            var isToday = false;

            date.setHours(0, 0, 0, 0);
            now.setHours(0, 0, 0, 0);

            if (date.getTime() === now.getTime()) {
              isToday = true;
            }

            var checkMarked = void 0;

            if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(_this2.fConfigs.markedDates[0]) === 'object') {
              checkMarked = _this2.fConfigs.markedDates.find(function (markDate) {
                return markDate.date === _this2.helpCalendar.formatDate(date);
              });
            } else {
              checkMarked = _this2.fConfigs.markedDates.find(function (markDate) {
                return markDate === _this2.helpCalendar.formatDate(date);
              });
            }

            if (_this2.startDMY === _this2.helpCalendar.formatDate(date)) {
              checkMarked = true;
            }

            var isMarked = false;
            if (typeof checkMarked !== 'undefined') {
              isMarked = true;
            }

            finalizedDays.push({
              day: day.day,
              date: _this2.helpCalendar.formatDate(date),
              hide: day.hide,
              isMouseToLeft: false,
              isMouseToRight: false,
              isHovered: false,
              isDateRangeStart: _this2.checkDateRangeStart(_this2.helpCalendar.formatDate(date)),
              isDateRangeEnd: _this2.checkDateRangeEnd(_this2.helpCalendar.formatDate(date)),
              hideLeftAndRightDays: day.hideLeftAndRightDays,
              isToday: isToday,
              isMarked: isMarked
            });
          });

          week.days = finalizedDays;
        });
      });
    },
    clickDay: function clickDay(item, isDisabledDate) {
      var _this3 = this;

      if (this.fConfigs.withTimePicker && this.fConfigs.isDateRange) {
        item.date = item.date + ' 00:00';
      }
      this.$emit('dayClicked', item);

      if (!this.fConfigs.isDateRange && !this.fConfigs.isDatePicker && !this.fConfigs.isMultipleDatePicker) {
        return false;
      }

      var dateDay = this.helpCalendar.getDateFromFormat(item.date).getDay() - 1;
      if (dateDay === -1) {
        dateDay = 6;
      }

      var dayOfWeekString = this.fConfigs.dayNames[dateDay];
      if (this.fConfigs.disabledDayNames.includes(dayOfWeekString) || isDisabledDate(item.date)) {
        return false;
      }

      if (this.fConfigs.limits) {
        var min = this.helpCalendar.getDateFromFormat(this.fConfigs.limits.min).getTime();
        var max = this.helpCalendar.getDateFromFormat(this.fConfigs.limits.max).getTime();
        var date = this.helpCalendar.getDateFromFormat(item.date).getTime();

        if (date < min || date > max) {
          return false;
        }
      }

      if (this.fConfigs.isMultipleDateRange) {
        var clickDate = this.helpCalendar.getDateFromFormat(item.date.split(' ')[0]).getTime();
        var rangesLength = this.calendar.multipleDateRange.length;
        var lastRange = this.calendar.multipleDateRange[rangesLength - 1];
        var startDate = '';


        if (!lastRange) {
          this.calendar.multipleDateRange.push({ end: '', start: '' });
          rangesLength = this.calendar.multipleDateRange.length;
          lastRange = this.calendar.multipleDateRange[rangesLength - 1];
        }

        if (lastRange.start) {
          startDate = this.helpCalendar.getDateFromFormat(lastRange.start);
        }

        if (lastRange.start !== '' && lastRange.end !== '') {
          this.calendar.multipleDateRange.push({ end: '', start: item.date });
        } else if (lastRange.start === '' && lastRange.end === '') {
          lastRange.start = item.date;
        } else if (lastRange.end === '' && clickDate > startDate.getTime()) {
          lastRange.end = item.date;
        } else if (lastRange.start !== '' && clickDate <= startDate.getTime()) {
          this.$nextTick(function () {
            if (_this3.calendar.withTimePicker) {
              _this3.$refs['timePicker'].startDateActive = true;
            }
          });
          lastRange.end = lastRange.start;
          lastRange.start = item.date;
        }

        if (lastRange.start !== '' && lastRange.end !== '') {
          var oneDay = 24 * 60 * 60 * 1000;
          var firstDate = this.helpCalendar.getDateFromFormat(lastRange.start);
          var secondDate = this.helpCalendar.getDateFromFormat(lastRange.end);
          var diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay));
          var itemTime = this.helpCalendar.getDateFromFormat(item.date).getTime();

          this.$emit('selectedDaysCount', diffDays);

          if (this.fConfigs.isModal && this.fConfigs.isAutoCloseable) {
            this.showCalendar = false;
          }

          var minSelDays = this.fConfigs.minSelDays;

          if (minSelDays && itemTime >= startDate.getTime() && diffDays < minSelDays) {
            startDate.setDate(startDate.getDate() + (minSelDays - 1));
            lastRange.end = this.helpCalendar.formatDate(startDate);
          }

          if (minSelDays && itemTime < startDate.getTime() && diffDays < minSelDays) {
            startDate.setDate(startDate.getDate() - (minSelDays - 1));
            lastRange.start = this.helpCalendar.formatDate(startDate);
          }

          var maxSelDays = this.fConfigs.maxSelDays;

          if (maxSelDays && itemTime >= startDate.getTime() && diffDays >= maxSelDays) {
            startDate.setDate(startDate.getDate() + (maxSelDays - 1));
            lastRange.end = this.helpCalendar.formatDate(startDate);
          }

          if (maxSelDays && itemTime < startDate.getTime() && diffDays >= maxSelDays) {
            startDate.setDate(startDate.getDate() - (maxSelDays - 1));
            lastRange.start = this.helpCalendar.formatDate(startDate);
          }
        }

        this.$emit('input', this.calendar);
      } else if (this.fConfigs.isDateRange) {
          var _clickDate = this.helpCalendar.getDateFromFormat(item.date.split(' ')[0]).getTime();

          var _startDate = '';
          if (this.calendar.dateRange.start) {
            _startDate = this.helpCalendar.getDateFromFormat(this.calendar.dateRange.start);
          }

          if (this.calendar.dateRange.start !== '' && this.calendar.dateRange.end !== '') {
            this.calendar.dateRange.start = item.date;
            this.calendar.dateRange.end = '';
          } else if (this.calendar.dateRange.start === '' && this.calendar.dateRange.end === '') {
            this.calendar.dateRange.start = item.date;
          } else if (this.calendar.dateRange.end === '' && _clickDate > _startDate.getTime()) {
            this.calendar.dateRange.end = item.date;
          } else if (this.calendar.dateRange.start !== '' && _clickDate <= _startDate.getTime()) {
            this.$nextTick(function () {
              if (_this3.calendar.dateRange && _this3.calendar.withTimePicker) {
                _this3.$refs['timePicker'].startDateActive = true;
              }
            });
            this.calendar.dateRange.end = this.calendar.dateRange.start;
            this.calendar.dateRange.start = item.date;
          }

          if (this.calendar.dateRange.start !== '' && this.calendar.dateRange.end !== '') {
            var _oneDay = 24 * 60 * 60 * 1000;
            var _firstDate = this.helpCalendar.getDateFromFormat(this.calendar.dateRange.start);
            var _secondDate = this.helpCalendar.getDateFromFormat(this.calendar.dateRange.end);
            var _diffDays = Math.round(Math.abs((_firstDate.getTime() - _secondDate.getTime()) / _oneDay));
            var _itemTime = this.helpCalendar.getDateFromFormat(item.date).getTime();

            this.$emit('selectedDaysCount', _diffDays);

            if (this.fConfigs.isModal && this.fConfigs.isAutoCloseable) {
              this.showCalendar = false;
            }

            var _minSelDays = this.fConfigs.minSelDays;

            if (_minSelDays && _itemTime >= _startDate.getTime() && _diffDays < _minSelDays) {
              _startDate.setDate(_startDate.getDate() + (_minSelDays - 1));
              this.calendar.dateRange.end = this.helpCalendar.formatDate(_startDate);
            }

            if (_minSelDays && _itemTime < _startDate.getTime() && _diffDays < _minSelDays) {
              _startDate.setDate(_startDate.getDate() - (_minSelDays - 1));
              this.calendar.dateRange.start = this.helpCalendar.formatDate(_startDate);
            }

            var _maxSelDays = this.fConfigs.maxSelDays;

            if (_maxSelDays && _itemTime >= _startDate.getTime() && _diffDays >= _maxSelDays) {
              _startDate.setDate(_startDate.getDate() + (_maxSelDays - 1));
              this.calendar.dateRange.end = this.helpCalendar.formatDate(_startDate);
            }

            if (_maxSelDays && _itemTime < _startDate.getTime() && _diffDays >= _maxSelDays) {
              _startDate.setDate(_startDate.getDate() - (_maxSelDays - 1));
              this.calendar.dateRange.start = this.helpCalendar.formatDate(_startDate);
            }
          }

          this.$emit('input', this.calendar);
        } else if (this.fConfigs.isDatePicker) {
          this.calendar.selectedDate = item.date;
          this.$emit('input', this.calendar);

          if (this.fConfigs.isModal && this.fConfigs.isAutoCloseable) {
            this.showCalendar = false;
          }
        } else if (this.fConfigs.isMultipleDatePicker) {
          if (this.calendar.hasOwnProperty('selectedDates') && this.calendar.selectedDates.find(function (date) {
            return date.date === item.date;
          })) {
            var dateIndex = this.calendar.selectedDates.findIndex(function (date) {
              return date.date === item.date;
            });
            this.calendar.selectedDates.splice(dateIndex, 1);
          } else {
            var _date = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.defaultDateFormat);
            _date.date = item.date;

            if (!this.calendar.hasOwnProperty('selectedDates')) {
              this.calendar.selectedDates = [];
            }

            this.calendar.selectedDates.push(_date);
          }

          this.$emit('input', this.calendar);
        }

      this.markChooseDays();

      if (this.fConfigs.withTimePicker) {
        if (this.fConfigs.isDateRange || this.fConfigs.isDatePicker) {
          this.openTimePicker();
        }

        if (this.calendar.selectedDates.find(function (date) {
          return date.date === item.date;
        }) && this.fConfigs.isMultipleDatePicker) {
          this.openTimePicker();
        }
      }

      this.$emit('choseDay', item);
    },
    markChooseDays: function markChooseDays() {
      var _this4 = this;

      var startDate = this.startDMY;
      var endDate = this.endDMY;
      this.listCalendars.forEach(function (calendar) {
        calendar.weeks.forEach(function (week) {
          week.days.forEach(function (day) {
            day.isMarked = false;
            day.date = day.date.split(' ')[0];

            if (_this4.fConfigs.isDatePicker) {
              if (_this4.calendar.selectedDate === day.date) day.isMarked = true;
            } else if (_this4.fConfigs.isMultipleDatePicker) {
              if (_this4.calendar.hasOwnProperty('selectedDates') && _this4.calendar.selectedDates.find(function (date) {
                return date.date === day.date;
              })) day.isMarked = true;
            } else {
              day.isMouseToLeft = false;
              day.isMouseToRight = false;

              if (startDate === day.date) {
                day.isMouseToLeft = !!endDate;
                day.isMarked = true;
              }

              if (endDate === day.date) {
                day.isMouseToRight = !!endDate;
                day.isMarked = true;
              }

              if (_this4.calendar.multipleDateRange) {
                if (~_this4.calendar.multipleDateRange.map(function (range) {
                  return range.start.split(' ')[0];
                }).indexOf(day.date)) {
                  day.isMouseToLeft = !!endDate;
                  day.isMarked = true;
                }
                if (~_this4.calendar.multipleDateRange.map(function (range) {
                  return range.end.split(' ')[0];
                }).indexOf(day.date)) {
                  day.isMouseToRight = !!endDate;
                  day.isMarked = true;
                }
                _this4.calendar.multipleDateRange.forEach(function (range) {
                  if (range.start && range.start === range.end) {
                    day.isMouseToLeft = false;
                    day.isMouseToRight = false;
                  }
                  if (range.start && range.end) {
                    if (_this4.helpCalendar.getDateFromFormat(day.date).getTime() > _this4.helpCalendar.getDateFromFormat(range.start) && _this4.helpCalendar.getDateFromFormat(day.date) < _this4.helpCalendar.getDateFromFormat(range.end)) {
                      day.isMarked = true;
                    }
                  }
                });
              }

              if (startDate && startDate === endDate) {
                day.isMouseToLeft = false;
                day.isMouseToRight = false;
              }
              if (startDate && endDate) {
                if (_this4.helpCalendar.getDateFromFormat(day.date).getTime() > _this4.helpCalendar.getDateFromFormat(startDate) && _this4.helpCalendar.getDateFromFormat(day.date) < _this4.helpCalendar.getDateFromFormat(endDate)) {
                  day.isMarked = true;
                }
              }
            }
            if (_this4.fConfigs.markedDates.includes(day.date)) day.isMarked = true;
          });
        });
      });
    },
    dayMouseOver: function dayMouseOver(date) {
      this.$emit('dayMouseOver', date);

      if (!this.fConfigs.isDateRange) {
        return false;
      }

      if (this.fConfigs.limits) {
        var limitMin = this.helpCalendar.getDateFromFormat(this.fConfigs.limits.min).getTime();
        var limitMax = this.helpCalendar.getDateFromFormat(this.fConfigs.limits.max).getTime();
        var limitDate = this.helpCalendar.getDateFromFormat(date).getTime();

        if (limitDate < limitMin || limitDate > limitMax) {
          return false;
        }
      }

      if ((this.calendar.dateRange.start === '' || this.calendar.dateRange.end === '') && (this.calendar.dateRange.start !== '' || this.calendar.dateRange.end !== '')) {
        for (var e = 0; e < this.listCalendars.length; e++) {
          var calendar = this.listCalendars[e];

          for (var f = 0; f < calendar.weeks.length; f++) {
            var week = calendar.weeks[f];

            for (var i = 0; i < week.days.length; i++) {
              var item = week.days[i];

              this.listCalendars[e].weeks[f].days[i].isHovered = false;
              if (item.date !== this.startDMY && !this.fConfigs.markedDates.includes(item.date)) {
                this.listCalendars[e].weeks[f].days[i].isMarked = false;
              }

              if (this.calendar.dateRange.start) {
                var itemDate = this.helpCalendar.getDateFromFormat(item.date).getTime();

                var thisDate = this.helpCalendar.getDateFromFormat(date).getTime();
                var startDate = this.helpCalendar.getDateFromFormat(this.calendar.dateRange.start);

                this.listCalendars[e].weeks[f].days[i].isMouseToLeft = itemDate === startDate.getTime() && thisDate > startDate.getTime() || itemDate === thisDate && thisDate < startDate.getTime();
                this.listCalendars[e].weeks[f].days[i].isMouseToRight = itemDate === startDate.getTime() && thisDate < startDate.getTime() || itemDate === thisDate && thisDate > startDate.getTime();

                var dateDay = this.helpCalendar.getDateFromFormat(item.date).getDay() - 1;
                if (dateDay === -1) {
                  dateDay = 6;
                }

                var dayOfWeekString = this.fConfigs.dayNames[dateDay];
                if (!this.fConfigs.disabledDayNames.includes(dayOfWeekString) && (itemDate > startDate.getTime() && itemDate < thisDate || itemDate < startDate.getTime() && itemDate > thisDate)) {
                  this.listCalendars[e].weeks[f].days[i].isMarked = true;
                }

                if (!this.calendar.dateRange.end && itemDate === thisDate) {
                  this.listCalendars[e].weeks[f].days[i].isHovered = false;
                }

                if (this.checkSelDates('min', this.calendar.dateRange.start, item.date, date)) {
                  this.listCalendars[e].weeks[f].days[i].isMarked = true;

                  var minDateToRight = void 0,
                      minDateToLeft = void 0;
                  minDateToLeft = new Date(startDate.getTime());
                  minDateToRight = new Date(startDate.getTime());
                  minDateToLeft.setDate(minDateToLeft.getDate() - this.fConfigs.minSelDays + 1);
                  minDateToRight.setDate(minDateToRight.getDate() + this.fConfigs.minSelDays - 1);

                  if (thisDate >= minDateToLeft.getTime() && this.helpCalendar.formatDate(minDateToLeft) === item.date) {
                    this.listCalendars[e].weeks[f].days[i].isMarked = false;
                    this.listCalendars[e].weeks[f].days[i].isMouseToLeft = true;
                    this.listCalendars[e].weeks[f].days[i].isHovered = true;
                  } else if (thisDate <= minDateToRight.getTime() && this.helpCalendar.formatDate(minDateToRight) === item.date) {
                    this.listCalendars[e].weeks[f].days[i].isMarked = false;
                    this.listCalendars[e].weeks[f].days[i].isMouseToRight = true;
                    this.listCalendars[e].weeks[f].days[i].isHovered = true;
                  }
                }

                if (this.checkSelDates('max', this.calendar.dateRange.start, item.date, date)) {
                  this.listCalendars[e].weeks[f].days[i].isMarked = false;
                  this.listCalendars[e].weeks[f].days[i].isHovered = false;
                  this.listCalendars[e].weeks[f].days[i].isMouseToLeft = false;
                  this.listCalendars[e].weeks[f].days[i].isMouseToRight = false;

                  var maxDateToLeft = void 0,
                      maxDateToRight = void 0;
                  maxDateToLeft = new Date(startDate.getTime());
                  maxDateToRight = new Date(startDate.getTime());
                  maxDateToLeft.setDate(maxDateToLeft.getDate() - this.fConfigs.maxSelDays + 1);
                  maxDateToRight.setDate(maxDateToRight.getDate() + this.fConfigs.maxSelDays - 1);

                  if (thisDate <= maxDateToLeft.getTime()) {
                    if (this.helpCalendar.formatDate(maxDateToLeft) === item.date) {
                      this.listCalendars[e].weeks[f].days[i].isHovered = true;
                      this.listCalendars[e].weeks[f].days[i].isMouseToLeft = true;
                    }
                  }

                  if (thisDate >= maxDateToRight.getTime()) {
                    if (this.helpCalendar.formatDate(maxDateToRight) === item.date) {
                      this.listCalendars[e].weeks[f].days[i].isHovered = true;
                      this.listCalendars[e].weeks[f].days[i].isMouseToRight = true;
                    }
                  }
                }
              }
            }
          }
        }
      }
      if (this.calendar.multipleDateRange) {
        var range = this.calendar.multipleDateRange[this.calendar.multipleDateRange.length - 1];
        if (!range) return;

        if ((range.start === '' || range.end === '') && (range.start !== '' || range.end !== '')) {
          for (var _e = 0; _e < this.listCalendars.length; _e++) {
            var _calendar = this.listCalendars[_e];

            for (var _f = 0; _f < _calendar.weeks.length; _f++) {
              var _week = _calendar.weeks[_f];

              for (var _i = 0; _i < _week.days.length; _i++) {
                var _item = _week.days[_i];

                this.listCalendars[_e].weeks[_f].days[_i].isHovered = false;
                if (_item.date !== this.startDMY && !this.fConfigs.markedDates.includes(_item.date)) {
                  this.listCalendars[_e].weeks[_f].days[_i].isMarked = false;
                }

                if (range.start) {
                  var _itemDate = this.helpCalendar.getDateFromFormat(_item.date).getTime();

                  var _thisDate = this.helpCalendar.getDateFromFormat(date).getTime();
                  var _startDate2 = this.helpCalendar.getDateFromFormat(range.start);

                  this.listCalendars[_e].weeks[_f].days[_i].isMouseToLeft = _itemDate === _startDate2.getTime() && _thisDate > _startDate2.getTime() || _itemDate === _thisDate && _thisDate < _startDate2.getTime();
                  this.listCalendars[_e].weeks[_f].days[_i].isMouseToRight = _itemDate === _startDate2.getTime() && _thisDate < _startDate2.getTime() || _itemDate === _thisDate && _thisDate > _startDate2.getTime();

                  var _dateDay = this.helpCalendar.getDateFromFormat(_item.date).getDay() - 1;
                  if (_dateDay === -1) {
                    _dateDay = 6;
                  }

                  var _dayOfWeekString = this.fConfigs.dayNames[_dateDay];
                  if (!this.fConfigs.disabledDayNames.includes(_dayOfWeekString) && (_itemDate > _startDate2.getTime() && _itemDate < _thisDate || _itemDate < _startDate2.getTime() && _itemDate > _thisDate)) {
                    this.listCalendars[_e].weeks[_f].days[_i].isMarked = true;
                  }

                  if (!range.end && _itemDate === _thisDate) {
                    this.listCalendars[_e].weeks[_f].days[_i].isHovered = false;
                  }

                  if (this.checkSelDates('min', range.start, _item.date, date)) {
                    this.listCalendars[_e].weeks[_f].days[_i].isMarked = true;

                    var _minDateToRight = void 0,
                        _minDateToLeft = void 0;
                    _minDateToLeft = new Date(_startDate2.getTime());
                    _minDateToRight = new Date(_startDate2.getTime());
                    _minDateToLeft.setDate(_minDateToLeft.getDate() - this.fConfigs.minSelDays + 1);
                    _minDateToRight.setDate(_minDateToRight.getDate() + this.fConfigs.minSelDays - 1);

                    if (_thisDate >= _minDateToLeft.getTime() && this.helpCalendar.formatDate(_minDateToLeft) === _item.date) {
                      this.listCalendars[_e].weeks[_f].days[_i].isMarked = false;
                      this.listCalendars[_e].weeks[_f].days[_i].isMouseToLeft = true;
                      this.listCalendars[_e].weeks[_f].days[_i].isHovered = true;
                    } else if (_thisDate <= _minDateToRight.getTime() && this.helpCalendar.formatDate(_minDateToRight) === _item.date) {
                      this.listCalendars[_e].weeks[_f].days[_i].isMarked = false;
                      this.listCalendars[_e].weeks[_f].days[_i].isMouseToRight = true;
                      this.listCalendars[_e].weeks[_f].days[_i].isHovered = true;
                    }
                  }

                  if (this.checkSelDates('max', range.start, _item.date, date)) {
                    this.listCalendars[_e].weeks[_f].days[_i].isMarked = false;
                    this.listCalendars[_e].weeks[_f].days[_i].isHovered = false;
                    this.listCalendars[_e].weeks[_f].days[_i].isMouseToLeft = false;
                    this.listCalendars[_e].weeks[_f].days[_i].isMouseToRight = false;

                    var _maxDateToLeft = void 0,
                        _maxDateToRight = void 0;
                    _maxDateToLeft = new Date(_startDate2.getTime());
                    _maxDateToRight = new Date(_startDate2.getTime());
                    _maxDateToLeft.setDate(_maxDateToLeft.getDate() - this.fConfigs.maxSelDays + 1);
                    _maxDateToRight.setDate(_maxDateToRight.getDate() + this.fConfigs.maxSelDays - 1);

                    if (_thisDate <= _maxDateToLeft.getTime()) {
                      if (this.helpCalendar.formatDate(_maxDateToLeft) === _item.date) {
                        this.listCalendars[_e].weeks[_f].days[_i].isHovered = true;
                        this.listCalendars[_e].weeks[_f].days[_i].isMouseToLeft = true;
                      }
                    }

                    if (_thisDate >= _maxDateToRight.getTime()) {
                      if (this.helpCalendar.formatDate(_maxDateToRight) === _item.date) {
                        this.listCalendars[_e].weeks[_f].days[_i].isHovered = true;
                        this.listCalendars[_e].weeks[_f].days[_i].isMouseToRight = true;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    PreMonth: function PreMonth() {
      var calendarKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!this.allowPreDate) return false;

      this.transitionPrefix = 'right';

      var step = this.fConfigs.changeMonthStep;

      calendarKey = calendarKey !== null ? calendarKey : 0;

      var currentCalendar = this.listCalendars[calendarKey];
      currentCalendar.date = new Date(currentCalendar.date.getFullYear(), currentCalendar.date.getMonth() - step);
      currentCalendar.key -= __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["a" /* hUniqueID */])();
      this.updateCalendar();

      if (!this.fConfigs.isSeparately) {
        this.calendar.currentDate = currentCalendar.date;
        this.initCalendar();
      }

      this.$emit('changedMonth', currentCalendar.date);
    },
    NextMonth: function NextMonth() {
      var calendarKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!this.allowNextDate) return false;

      this.transitionPrefix = 'left';

      var step = this.fConfigs.changeMonthStep;

      calendarKey = calendarKey !== null ? calendarKey : 0;

      var currentCalendar = this.listCalendars[calendarKey];
      currentCalendar.date = new Date(currentCalendar.date.getFullYear(), currentCalendar.date.getMonth() + step);
      currentCalendar.key += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["a" /* hUniqueID */])();
      this.updateCalendar();

      if (!this.fConfigs.isSeparately) {
        this.calendar.currentDate = currentCalendar.date;
        this.initCalendar();
      }

      this.$emit('changedMonth', currentCalendar.date);
    },
    PreYear: function PreYear() {
      var calendarKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!this.allowPreDate) return false;

      var step = this.showYearPicker ? this.fConfigs.changeYearStep : 1;

      calendarKey = calendarKey !== null ? calendarKey : 0;

      var currentCalendar = this.listCalendars[calendarKey];
      currentCalendar.date = new Date(currentCalendar.date.getFullYear() - step, currentCalendar.date.getMonth());
      this.updateCalendar();

      if (!this.fConfigs.isSeparately) {
        this.calendar.currentDate = currentCalendar.date;
        this.initCalendar();
      }

      this.$emit('changedYear', currentCalendar.date);
    },
    NextYear: function NextYear() {
      var calendarKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!this.allowNextDate) return false;

      var step = this.showYearPicker ? this.fConfigs.changeYearStep : 1;

      calendarKey = calendarKey !== null ? calendarKey : 0;

      var currentCalendar = this.listCalendars[calendarKey];
      currentCalendar.date = new Date(currentCalendar.date.getFullYear() + step, currentCalendar.date.getMonth());
      this.updateCalendar();

      if (!this.fConfigs.isSeparately) {
        this.calendar.currentDate = currentCalendar.date;
        this.initCalendar();
      }

      this.$emit('changedYear', currentCalendar.date);
    },
    ChooseDate: function ChooseDate(date) {
      var newDate = this.helpCalendar.getDateFromFormat(date);

      if (date === 'today') {
        newDate = new Date();
      }

      this.listCalendars[0].date = this.calendar.currentDate = newDate;

      this.updateCalendar();
      this.initCalendar();
    },
    openMonthPicker: function openMonthPicker(key) {
      if (this.fConfigs.changeMonthFunction) {
        this.showMonthPicker = key === this.showMonthPicker ? false : key;
        this.showYearPicker = false;
      }
    },
    openYearPicker: function openYearPicker(key) {
      if (this.fConfigs.changeYearFunction) {
        this.showYearPicker = key === this.showYearPicker ? false : key;
        this.showMonthPicker = false;
      }
    },
    openTimePicker: function openTimePicker() {
      this.showTimePicker = true;
    },
    pickMonth: function pickMonth(key, calendarKey) {
      this.showMonthPicker = false;
      if (!this.isSeparately) {
        this.listCalendars.forEach(function (currentCalendar, index) {
          var date = currentCalendar.date;
          currentCalendar.date = new Date(date.getFullYear(), key + 1 + index, 0);
          currentCalendar.key += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["a" /* hUniqueID */])();
        });
      } else {
        var _currentCalendar = this.listCalendars[calendarKey];
        var date = _currentCalendar.date;
        _currentCalendar.date = new Date(date.getFullYear(), key + 1, 0);
        _currentCalendar.key += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["a" /* hUniqueID */])();
      }

      var currentCalendar = this.listCalendars[calendarKey];
      this.$emit('changedMonth', currentCalendar.date);
      this.updateCalendar();
    },
    pickYear: function pickYear(year, calendarKey) {
      this.showYearPicker = false;
      if (!this.isSeparately) {
        this.listCalendars.forEach(function (currentCalendar) {
          var date = currentCalendar.date;
          currentCalendar.date = new Date(year, date.getMonth() + 1, 0);
          currentCalendar.key += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["a" /* hUniqueID */])();
        });
      } else {
        var currentCalendar = this.listCalendars[calendarKey];
        var date = currentCalendar.date;
        currentCalendar.date = new Date(year, date.getMonth() + 1, 0);
        currentCalendar.key += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["a" /* hUniqueID */])();
      }
      this.updateCalendar();
    },
    getYearList: function getYearList(date, delta) {
      var years = [];
      var year = date.getFullYear() - 4 + delta;
      for (var i = 0; i < 12; i++) {
        var finalYear = year + i;

        years.push({
          year: finalYear
        });
      }
      return years;
    },
    addToSelectedDates: function addToSelectedDates() {
      if (this.helpCalendar.checkValidDate(this.calendar.selectedDatesItem)) {
        var date = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.defaultDateFormat);
        date.date = this.calendar.selectedDatesItem;
        this.calendar.selectedDates.push(date);
        this.calendar.selectedDatesItem = '';
        this.markChooseDays();
      }
    },
    removeFromSelectedDates: function removeFromSelectedDates(index) {
      this.calendar.selectedDates.splice(index, 1);
      this.markChooseDays();
    },
    checkDateRangeEnd: function checkDateRangeEnd(date) {
      if (Array.isArray(this.fConfigs.markedDateRange)) {
        return this.fConfigs.markedDateRange.findIndex(function (range) {
          return range.end === date;
        }) !== -1;
      }

      return date === this.fConfigs.markedDateRange.end;
    },
    checkSelDates: function checkSelDates(type, startDate, itemDate, hoverDate) {
      var startTime = this.helpCalendar.getDateFromFormat(startDate).getTime();
      var itemTime = this.helpCalendar.getDateFromFormat(itemDate).getTime();
      var hoverTime = this.helpCalendar.getDateFromFormat(hoverDate).getTime();

      var days = type === 'min' ? this.fConfigs.minSelDays : this.fConfigs.maxSelDays - 2;
      var minTime = days * 1000 * 60 * 60 * 24;
      var rightTime = startTime + minTime;
      var leftTime = startTime - minTime;

      var result = void 0;
      if (hoverTime > startTime) {
        if (type === 'min') result = itemTime < rightTime && itemTime > startTime && this.fConfigs.minSelDays;else result = itemTime > rightTime && itemTime > startTime && this.fConfigs.maxSelDays;
      } else if (hoverTime < startTime) {
        if (type === 'min') result = itemTime > leftTime && itemTime < startTime && this.fConfigs.minSelDays;else result = itemTime < leftTime && itemTime < startTime && this.fConfigs.maxSelDays;
      }

      return result;
    },
    checkLimits: function checkLimits(value) {
      if (this.fConfigs.limits) {
        var min = new Date(this.helpCalendar.getDateFromFormat(this.fConfigs.limits.min));
        min.setDate(1);
        min.setHours(0, 0, 0, 0);
        var max = new Date(this.helpCalendar.getDateFromFormat(this.fConfigs.limits.max));
        max.setDate(1);
        max.setHours(0, 0, 0, 0);

        this.allowPreDate = true;
        this.allowNextDate = true;

        var current = new Date(value);
        current.setDate(1);
        current.setHours(0, 0, 0, 0);

        if (current <= min) {
          this.allowPreDate = false;
        }

        if (current >= max) {
          this.allowNextDate = false;
        }
      }
    },
    getTransition_: function getTransition_() {
      if (!this.fConfigs.transition) return '';

      var name = '';
      if (this.transitionPrefix === 'left') {
        name = 'vfc-calendar-slide-left';
      } else if (this.transitionPrefix === 'right') {
        name = 'vfc-calendar-slide-right';
      }
      return name;
    },
    checkHiddenElement: function checkHiddenElement(elementName) {
      return !this.fConfigs.hiddenElements.includes(elementName);
    },
    onFocusIn: function onFocusIn() {
      if (this.fConfigs.isModal) {
        this.showCalendar = true;
      }
    },
    onFocusOut: function onFocusOut(e) {
      if (this.fConfigs.isModal && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["b" /* hElContains */])(this.popoverElement, e.relatedTarget)) {
        return this.showCalendar = this.showMonthPicker = this.showYearPicker = false;
      }
    },
    hideMonthYearPicker: function hideMonthYearPicker(e) {
      var _this5 = this;

      this.$nextTick(function () {
        if (_this5.showMonthPicker || _this5.showYearPicker) {
          var key = _this5.showMonthPicker ? _this5.showMonthPicker - 1 : _this5.showYearPicker - 1;

          var MYactive = _this5.$refs.calendars.querySelectorAll('.vfc-content-MY-picker')[key];
          if (MYactive.contains(e.target)) {
            return;
          }
          return _this5.showMonthPicker = _this5.showYearPicker = false;
        }
      });
    },
    checkDateRangeStart: function checkDateRangeStart(date) {
      if (Array.isArray(this.fConfigs.markedDateRange)) {
        return this.fConfigs.markedDateRange.findIndex(function (range) {
          return range.start === date;
        }) !== -1;
      }

      return date === this.fConfigs.markedDateRange.start;
    },
    cleanRange: function cleanRange() {
      if (!this.isMultipleDateRange) {
        this.calendar.dateRange.end = '';
        this.calendar.dateRange.start = '';
        return;
      }
      this.calendar.multipleDateRange = [];
    }
  }
});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MonthYearPicker',
  props: {
    calendarKey: {
      type: Number,
      default: 0
    },
    changeYearStep: {
      type: Number,
      default: 3
    }
  },
  data: function data() {
    return {
      delta: 0
    };
  },

  watch: {
    delta: function delta(newDelta) {
      if (newDelta < -new Date().getFullYear()) this.delta = 0;
    }
  },
  methods: {
    changePicker: function changePicker(to) {
      if (this.$parent.showMonthPicker) {
        if (to === 'right') this.$parent.NextYear(this.calendarKey);else this.$parent.PreYear(this.calendarKey);
        return;
      }

      if (to === 'right') this.delta += this.changeYearStep;else this.delta -= this.changeYearStep;
    }
  }
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PickerInputs',
  props: {
    fConfigs: {
      type: Object,
      required: true
    },
    singleSelectedDate: {
      type: String,
      required: true
    },
    calendar: {
      type: Object,
      required: true
    }
  },
  computed: {
    dateRangeSelectedStartDate: {
      get: function get() {
        return this.calendar.dateRange.start ? this.calendar.dateRange.start : '';
      },
      set: function set(newValue) {
        newValue = this.helpCalendar.mask(newValue);
        if (this.helpCalendar.getDateFromFormat(newValue).getMonth()) {
          this.calendar.dateRange.start = newValue;
        }
      }
    },
    dateRangeSelectedEndDate: {
      get: function get() {
        return this.calendar.dateRange.end ? this.calendar.dateRange.end : '';
      },
      set: function set(newValue) {
        newValue = this.helpCalendar.mask(newValue);
        if (this.helpCalendar.getDateFromFormat(newValue).getMonth()) {
          this.calendar.dateRange.end = newValue;
        }
      }
    }
  }
});

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TimePicker',
  data: function data() {
    return {
      startDateActive: true,
      currentSelectedDate: ''
    };
  },

  props: {
    height: {
      type: Number,
      required: true
    }
  },
  watch: {
    startDateActive: function startDateActive() {
      this.setScrollPosition();
    }
  },
  computed: {
    getCurrentDate: function getCurrentDate() {
      return this.currentSelectedDate.date;
    },
    getCurrentDateTime: function getCurrentDateTime() {
      return this.currentSelectedDate.dateTime;
    }
  },
  created: function created() {
    var selectedDates = this.$parent.calendar.selectedDates;
    this.currentSelectedDate = selectedDates[selectedDates.length - 1];
  },
  mounted: function mounted() {
    var startDate = this.$parent.calendar.dateRange.start.split(' ')[0];
    var endDate = this.$parent.calendar.dateRange.end.split(' ')[0];
    if (startDate && this.$parent.helpCalendar.getDateFromFormat(startDate) < this.$parent.helpCalendar.getDateFromFormat(endDate)) {
      this.startDateActive = false;
    } else {
      this.startDateActive = true;
    }

    this.setSelectedDateTime();
    this.setStyles();
  },

  methods: {
    formatTime: function formatTime(i) {
      return i <= 10 ? '0' + (i - 1) : i - 1;
    },
    close: function close() {
      this.$parent.showTimePicker = false;
    },
    addMinuteHour: function addMinuteHour(what, val, to) {
      var res = '';
      res += val.split(' ')[0];
      if (what == 'hour') {
        res += ' ' + to + ':';
        res += val.split(' ')[1].split(':')[1];
      } else {
        res += ' ' + val.split(' ')[1].split(':')[0] + ':';
        res += to;
      }
      return res;
    },
    changeHour: function changeHour(hour) {
      var _this = this;

      if (this.$parent.fConfigs.isDateRange) {
        if (this.checkStartDate()) {
          this.$parent.calendar.dateRange.start = this.addMinuteHour('hour', this.$parent.calendar.dateRange.start, hour);
        } else {
          this.$parent.calendar.dateRange.end = this.addMinuteHour('hour', this.$parent.calendar.dateRange.end, hour);
        }
      } else if (this.$parent.fConfigs.isMultipleDatePicker) {
        var currentDate = this.$parent.calendar.selectedDates.find(function (date) {
          return date.date === _this.getCurrentDate;
        });
        currentDate.hour = hour;
      } else {
        this.$parent.calendar.selectedHour = hour;
      }

      this.setSelectedDateTime();
      this.setScrollPosition();
    },
    changeMinute: function changeMinute(minute) {
      var _this2 = this;

      if (this.$parent.fConfigs.isDateRange) {
        if (this.checkStartDate()) {
          this.$parent.calendar.dateRange.start = this.addMinuteHour('minute', this.$parent.calendar.dateRange.start, minute);
        } else {
          this.$parent.calendar.dateRange.end = this.addMinuteHour('minute', this.$parent.calendar.dateRange.end, minute);
        }
      } else if (this.$parent.fConfigs.isMultipleDatePicker) {
        var currentDate = this.$parent.calendar.selectedDates.find(function (date) {
          return date.date === _this2.getCurrentDate;
        });
        currentDate.minute = minute;
      } else {
        this.$parent.calendar.selectedMinute = minute;
      }

      this.setSelectedDateTime();
      this.setScrollPosition();
    },
    setSelectedDateTime: function setSelectedDateTime() {
      var _this3 = this;

      if (this.$parent.fConfigs.isDatePicker) {
        this.$parent.calendar.selectedDateTime = this.$parent.calendar.selectedDate + ' ' + this.$parent.calendar.selectedHour + ':' + this.$parent.calendar.selectedMinute;
      } else if (this.$parent.fConfigs.isMultipleDatePicker) {
        var currentDate = this.$parent.calendar.selectedDates.find(function (date) {
          return date.date === _this3.getCurrentDate;
        });
        currentDate.dateTime = currentDate.date + ' ' + currentDate.hour + ':' + currentDate.minute;
      }
    },
    checkStartDate: function checkStartDate() {
      return this.startDateActive;
    },
    checkHourActiveClass: function checkHourActiveClass(i) {
      var _this4 = this;

      var hour = void 0;
      if (this.$parent.fConfigs.isDateRange) {
        if (this.checkStartDate()) {
          hour = this.$parent.calendar.dateRange.start.split(' ')[1].split(':')[0];
        } else {
          hour = this.$parent.calendar.dateRange.end.split(' ')[1].split(':')[0];
        }
      } else if (this.$parent.fConfigs.isMultipleDatePicker) {
        hour = this.$parent.calendar.selectedDates.find(function (date) {
          return date.date === _this4.getCurrentDate;
        }).hour;
      } else {
        hour = this.$parent.calendar.selectedHour;
      }
      return hour == this.formatTime(i);
    },
    checkMinuteActiveClass: function checkMinuteActiveClass(i) {
      var _this5 = this;

      var minute = void 0;
      if (this.$parent.fConfigs.isDateRange) {
        if (this.checkStartDate()) {
          minute = this.$parent.calendar.dateRange.start.split(':')[1];
        } else {
          minute = this.$parent.calendar.dateRange.end.split(':')[1];
        }
      } else if (this.$parent.fConfigs.isMultipleDatePicker) {
        minute = this.$parent.calendar.selectedDates.find(function (date) {
          return date.date === _this5.getCurrentDate;
        }).minute;
      } else {
        minute = this.$parent.calendar.selectedMinute;
      }

      return minute == this.formatTime(i);
    },
    setStyles: function setStyles() {

      this.setScrollPosition();

      var timeLineHeight = +this.height - 35 - 85;
      document.getElementsByClassName('vfc-time-picker__list')[0].style.height = timeLineHeight + 'px';
      document.getElementsByClassName('vfc-time-picker__list')[1].style.height = timeLineHeight + 'px';
    },
    setScrollPosition: function setScrollPosition() {
      var container = this.$parent.$refs.mainContainer;

      this.$nextTick(function () {
        var selectedHour = this.$refs.hourList.querySelector('.vfc-time-picker__item--selected');
        var selectedMinute = this.$refs.minuteList.querySelector('.vfc-time-picker__item--selected');

        this.$refs.hourList.scrollTop = selectedHour ? selectedHour.offsetTop - container.clientHeight / 2 : 0;
        this.$refs.minuteList.scrollTop = selectedMinute ? selectedMinute.offsetTop - container.clientHeight / 2 : 0;
      });
    }
  }
});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'WeekNumbers',
  props: {
    number: {
      tyoe: Number,
      required: true
    },
    borderColor: {
      type: String,
      default: ''
    }
  }
});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'ClipLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '35px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size,
        width: this.size,
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: this.color + ' ' + this.color + ' transparent',
        borderRadius: this.radius,
        background: 'transparent'
      };
    }
  }
});

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotFound'
});

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notification__ = __webpack_require__(2571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate__ = __webpack_require__(2578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_dist_vuelidate_min_js__ = __webpack_require__(2577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_dist_vuelidate_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_dist_vuelidate_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_dist_validators_min_js__ = __webpack_require__(2576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_dist_validators_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate_dist_validators_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_js_token_error_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(3);








__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_notification___default.a);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App',
  data: function data() {
    return {
      section: 'Head'
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapActions */])(['setToken', 'setUserInfo', 'clearUserInfo', 'setTradeTypeList', 'setRestrictList']), {
    setLStorage: function setLStorage(title, content) {
      window.localStorage.setItem(title, content);
    },
    getLStorage: function getLStorage(title) {
      return window.localStorage.getItem(title);
    },
    fixedH: function fixedH() {
      var windowW = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(window).width();
      var windowH = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(window).height();
      var minH = windowH - 55;
      this.$nextTick(function () {
        var bodyH = __WEBPACK_IMPORTED_MODULE_7_jquery___default()('.content-wrapper').height();
        if (windowW >= 768 && bodyH < windowH) {
          __WEBPACK_IMPORTED_MODULE_7_jquery___default()('.content-wrapper').css('min-height', minH + 'px');
        } else {
          __WEBPACK_IMPORTED_MODULE_7_jquery___default()('.content-wrapper').css('min-height', 'none');
        }
      });
    },
    getData: function getData(method, url, data, callback) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_6_axios___default()({
        baseURL: this.$config.baseURL,
        method: method,
        url: url,
        data: data
      }).then(function (res) {
        callback(res);
      }).catch(function (err) {
        self.$notify({
          title: err.response ? err.response.data.message : '',
          text: err.response ? err.response.data.description : '',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      });
    },
    getDataH: function getDataH(method, url, data, callback, handleError) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_6_axios___default()({
        baseURL: this.$config.baseURL,
        method: method,
        url: url,
        data: data,
        headers: {
          'MC-API-Token': self.getToken
        }
      }).then(function (response) {
        if (response.data.token_need_replace === 1) {
          self.updateToken();
        } else {
          callback(response);
        }
      }).catch(function (error) {
        if (error.response) {
          if (__WEBPACK_IMPORTED_MODULE_8__assets_js_token_error_js__["a" /* TOKEN_INVALID_CODES */].includes(error.response.data.status)) {
            self.clearAll();
          } else {
            if (handleError) {
              handleError(error);
            } else {
              self.$notify({
                title: error.response.data.message,
                text: error.response.data.description,
                duration: 3000,
                type: 'danger',
                width: 400
              });
            }
          }
        }
      });
    },
    getFile: function getFile(method, url, data, callback) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_6_axios___default()({
        responseType: 'blob',
        baseURL: this.$config.baseURL,
        method: method,
        url: url,
        data: data,
        headers: {
          'MC-API-Token': self.getToken
        }
      }).then(function (response) {
        callback(response);
      }).catch(function (error) {
        self.$notify({
          title: error.response.data.message,
          text: error.response.data.description,
          duration: 3000,
          type: 'danger',
          width: 400
        });
        callback(error.response);
      });
    },
    updateToken: function updateToken() {
      var self = this;
      var url = '/auth/' + this.getUserId + '/replaceToken';
      this.getDataH('get', url, null, function (response) {
        var token = response.data.token;
        self.setToken(token);
        self.setLStorage(self.$config.token, token);
      });
    },
    clearAll: function clearAll() {
      if (!this.getToken) return;
      this.clearUserInfo();
      this.$notify({
        title: '登入已失效',
        text: '您的登入已失效或權限不足，請重新登入。',
        duration: 5000,
        type: 'danger',
        width: 400
      });
      this.$router.push('/login');
    },
    checkInput: function checkInput(str) {
      if (str) {
        str = str.toString();
        str = str.replace(/["']/g, '').trim();
      } else if (typeof str === 'number') {
        return '0';
      } else return '';
      return str;
    },
    getTradeTypeList: function getTradeTypeList() {
      var _this = this;

      var url = '/platform/tradeTypeList';
      this.getData('get', url, null, function (response) {
        if (response.data.status === 200) {
          var data = response.data.list.filter(function (x) {
            return x.is_valid;
          }).map(function (x) {
            return {
              value: x.type,
              label: x.name
            };
          });
          data.unshift({ label: '== 付款類型 ==', value: 999 });
          _this.setTradeTypeList(data);
        }
      });
    },
    getSubordinate: function getSubordinate(userId, roleType) {
      var self = this;
      var roleTypeName = '';
      if (roleType === 99) {
        roleTypeName = 'admin';
      } else if (roleType === 30) {
        roleTypeName = 'brand';
      } else if (roleType === 10) {
        roleTypeName = 'store';
      }

      var url = '/manager/' + roleTypeName + '/' + userId + '/subordinate';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var restricList = [];
          var denyList = [];
          var nidinLeague = 0;
          if (response.data.subordinate.allowed_restricted_function_list) {
            restricList = response.data.subordinate.allowed_restricted_function_list;
          }
          if (response.data.subordinate.denied_restricted_function_list) {
            denyList = response.data.subordinate.denied_restricted_function_list;
          }
          if (response.data.subordinate.in_nidin_league) {
            nidinLeague = response.data.subordinate.in_nidin_league;
          }
          self.$store.commit('SET_NIDIN_LEAGUE', nidinLeague);
          self.$store.commit('SET_RESTRICT', restricList);
          self.$store.commit('SET_DENYLIST', denyList);
        }
      });
    },
    setUserInfoToken: function setUserInfoToken() {
      var userId = this.getLStorage(this.$config.userId);
      var token = this.getLStorage(this.$config.token);
      var roleType = parseInt(this.getLStorage(this.$config.roleType), 10);
      var account = this.getLStorage(this.$config.account);
      if (userId && token && roleType) {
        this.setUserInfo({ userId: userId, token: token, roleType: roleType, account: account });
        this.setToken(token);
      }
    }
  }),
  created: function created() {
    this.fixedH();
    this.setUserInfoToken();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapGetters */])(['getUserId', 'getToken'])),
  watch: {
    'getUserId': function getUserId(val) {
      if (val) {
        var roleType = parseInt(this.getLStorage(this.$config.roleType), 10);
        this.getTradeTypeList();
        this.getSubordinate(val, roleType);
      }
    }
  }
});

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_faker__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_faker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_faker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Sidebar_vue__ = __webpack_require__(2089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Sidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Sidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_nd_announcement_overlay_vue__ = __webpack_require__(2093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_nd_announcement_overlay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_elements_nd_announcement_overlay_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_hideseek__ = __webpack_require__(2041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_hideseek___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_hideseek__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Dash',
  components: {
    Sidebar: __WEBPACK_IMPORTED_MODULE_4__Sidebar_vue___default.a,
    'nd-announcement-overlay': __WEBPACK_IMPORTED_MODULE_5__components_elements_nd_announcement_overlay_vue___default.a
  },
  data: function data() {
    return {
      year: new Date().getFullYear(),
      classes: {
        fixed_layout: this.$config.fixedLayout,
        hide_logo: this.$config.hideLogoOnMobile
      },
      error: '',
      bodyH: 0,
      currentTime: '',
      isRead: false,
      unReadAmount: 0,
      announcementList: [],
      dailogOpen: false,
      message: {},
      openNotifyNews: false
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getUserId', 'getAccount', 'getRoleType', 'getUnReadNotify', 'getNidinLeague']), {
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    },
    getFile: function getFile() {
      return this.$parent.getFile;
    },
    breadcrumb: function breadcrumb() {
      var array = this.$route.meta.route.split('/');
      return array;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    },
    demo: function demo() {
      return {
        displayName: __WEBPACK_IMPORTED_MODULE_2_faker___default.a.name.findName(),
        avatar: __WEBPACK_IMPORTED_MODULE_2_faker___default.a.image.avatar(),
        email: __WEBPACK_IMPORTED_MODULE_2_faker___default.a.internet.email(),
        randomCard: __WEBPACK_IMPORTED_MODULE_2_faker___default.a.helpers.createCard()
      };
    }
  }),
  created: function created() {
    this.getBlackReason();
    this.announcementInfo('open');
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['clearUserInfo', 'setBlackReason', 'setUnReadNotify']), {
    getBlackReason: function getBlackReason() {
      var self = this;
      var url = 'score/shopperBlackReasonList';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var list = response.data.list;
          self.setBlackReason(list);
        }
      });
    },
    close: function close() {
      this.dailogOpen = false;
      this.markAsRead(this.message.announcement_id);
    },
    changeRead: function changeRead(type) {
      this.isRead = type;
      this.announcementInfo('close');
    },
    unReadTotal: function unReadTotal() {
      var _this = this;

      var url = 'announcement/online/unReadTotal';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this.$store.commit('SET_UNREAD_NOTIFY', response.data.amount);
          _this.unReadAmount = response.data.amount;
        }
      });
    },
    markAsRead: function markAsRead() {
      var _this2 = this;

      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var url = 'announcement/online/markAsRead';
      var data = {};
      if (id) {
        data = {
          'announcement_ids': id
        };
      }
      this.getDataH('POST', url, data, function (response) {
        if (response.data.status === 200) {
          _this2.announcementInfo('open');
        }
      });
    },
    announcementDetail: function announcementDetail(ID) {
      var _this3 = this;

      var url = '/announcement/online/' + ID;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this3.message = response.data.announcement;
        }
      });
    },
    announcementInfo: function announcementInfo(status) {
      var _this4 = this;

      var noShowOpen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var read = this.isRead ? 1 : 0;
      if (status === 'open') {
        read = 0;
      }
      var url = '/announcement/online/list?is_read=' + read + '&page=1&size=20';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this4.announcementList = response.data.announcement_list;
          if (status === 'open') {
            var overlayItem = response.data.announcement_list.find(function (x) {
              return x.is_overlay === 1;
            });

            if (overlayItem && !noShowOpen) {
              setTimeout(function () {
                _this4.openNews(overlayItem);
              }, 500);
            }
          }
          _this4.unReadTotal();
        }
      });
    },
    changeloading: function changeloading() {
      this.$store.commit('TOGGLE_SEARCHING');
    },
    goto: function goto(name, index, arr) {
      if (index === arr.length - 1) this.$router.go(-1);else {
        if (name === '品牌管理') this.$router.push('/brandTable');
      }
    },
    clickLogout: function clickLogout() {
      var _this5 = this;

      var url = '/auth/' + this.getUserId + '/logout';
      this.getDataH('post', url, null, function (response) {
        if (response.data.status === 200) {
          _this5.clearUserInfo();
          _this5.clearSession();
          _this5.$router.push('/login');
        }
      });
    },
    clearSession: function clearSession() {
      var allSession = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sessionStorage);
      var array = [];
      allSession.map(function (c, i, a) {
        array.push(c);
      });
      array.forEach(function (key) {
        sessionStorage.removeItem(key);
      });
    },
    linkDoc: function linkDoc() {
      window.open(this.$route.meta.docLink, '_blank');
    },
    openNews: function openNews(news) {
      this.openNotifyNews = false;
      this.dailogOpen = true;
      this.announcementDetail(news.announcement_id);
    }
  }),
  mounted: function mounted() {
    var self = this;
    this.$nextTick(function () {
      self.fixedH();
      self.currentTime = __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('MM/DD HH:mm:ss');
    });
  },
  updated: function updated() {
    var self = this;
    this.$nextTick(function () {
      self.fixedH();
    });
  },

  watch: {
    '$route.path': function $routePath() {
      this.currentTime = __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('MM/DD HH:mm:ss');
    },

    'getUnReadNotify': {
      handler: function handler(val) {
        this.unReadAmount = val;
      },
      immediate: true
    }
  }
});

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_handle_config_js__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_js_shared_token_js__ = __webpack_require__(21);



var sha256 = __webpack_require__(209).sha256;





function isSafeRedirect(path) {
  if (typeof path !== 'string' || !/^\/(?!\/)/.test(path)) return false;

  return path !== '/' && !path.startsWith('/login');
}

function defaultPath(roleType) {
  return parseInt(roleType, 10) === 50 ? '/mqttTable' : '/dashboard';
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var isLogin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__assets_js_shared_token_js__["a" /* getSharedToken */])() || window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__assets_js_handle_config_js__["a" /* default */].token);
    if (!isLogin || __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.authError) {
      next();
      return;
    }

    var redirect = to.query.redirect;
    if (isSafeRedirect(redirect)) next(redirect);else next(defaultPath(__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.roleType || window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__assets_js_handle_config_js__["a" /* default */].roleType)));
  },
  data: function data(router) {
    return {
      section: 'Login',
      loading: '',
      account: '',
      password: '',
      response: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getUserId', 'getToken']), {
    getData: function getData() {
      return this.$parent.getData;
    },
    setLStorage: function setLStorage() {
      return this.$parent.setLStorage;
    },
    randomString: function randomString() {
      var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz';

      var stringLength = Math.random() * (16 - 8) + 8;
      var randomS = '';
      for (var i = 0; i < stringLength; i++) {
        var rNum = Math.floor(Math.random() * chars.length);
        randomS += chars.substring(rNum, rNum + 1);
      }
      return randomS;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['setUserInfo', 'setAuthError']), {
    checkInput: function checkInput() {
      if (!this.account) {
        this.$notify({
          title: '帳號為空',
          text: '請輸入帳號，進行登入',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!this.password) {
        this.$notify({
          title: '密碼為空',
          text: '請輸入密碼，進行登入',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.clickLogin();
      }
    },
    clickLogin: function clickLogin() {
      var _this = this;

      var data = {
        account: this.account,
        password: sha256(this.password),
        device_id: 'NIDINPanelWeb_' + this.randomString
      };
      var url = '/auth/login';
      this.getData('post', url, data, function (response) {
        if (response.data.status === 200) {
          var userId = response.data.user_id;
          var token = response.data.token;
          var roleType = response.data.role_type;
          var account = data.account;
          _this.setUserInfo({ userId: userId, token: token, roleType: roleType, account: account });
          _this.setLStorage(_this.$config.userId, userId);
          _this.setLStorage(_this.$config.account, data.account);
          _this.setLStorage(_this.$config.token, token);
          _this.setLStorage(_this.$config.roleType, roleType);
          var redirect = _this.$route.query.redirect;
          if (isSafeRedirect(redirect)) _this.$router.push(redirect);else _this.$router.push(defaultPath(roleType));
        }
      });
    },
    toggleLoading: function toggleLoading() {
      this.loading = this.loading === '' ? 'loading' : '';
    },
    resetResponse: function resetResponse() {
      this.response = '';
    }
  }),
  created: function created() {
    if (this.$store.state.authError) {
      this.response = this.$store.state.authError;
      this.setAuthError('');
    }
  }
});

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_js_shared_token_js__ = __webpack_require__(21);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Sidebar',
  data: function data() {
    return {
      sBrandId: '',
      sStoreId: '',
      storeList: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getAccount', 'getRoleType', 'getUserId']), {
    allow_update_menu: function allow_update_menu() {
      return this.$store.state.storeInfo.allow_update_menu === 1;
    },
    brandId: function brandId() {
      if (this.getRoleType === 99) return this.$route.params.brand_id;else if (this.getRoleType === 30) return this.$route.params.brand_id;else if (this.getRoleType === 10) return this.sStoreId;
    },
    brandIdForStore: function brandIdForStore() {
      if (this.getRoleType === 99) return this.$route.params.brand_id;else if (this.getRoleType === 30) return this.$route.params.brand_id;else if (this.getRoleType === 10) return this.sBrandId || this.$route.params.brand_id;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  }),
  created: function created() {
    if (this.getRoleType !== 99) {
      this.getBrandList();
    }
  },

  methods: {
    getBrandList: function getBrandList() {
      var _this = this;

      console.log('getBrandList | Sidebar');
      var url = '/brand/list?page=1&size=1';
      this.getDataH('get', url, null, function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(response) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(response.data.status === 200)) {
                    _context.next = 8;
                    break;
                  }

                  _this.sBrandId = response.data.list[0].id;
                  _this.$store.commit('SET_BRANDS', response.data.list);
                  _this.$store.commit('SET_BRAND_ID', response.data.list[0]['id']);

                  if (!(_this.getRoleType === 10)) {
                    _context.next = 8;
                    break;
                  }

                  _context.next = 7;
                  return _this.getStoreBrief(response.data.list[0].id);

                case 7:
                  _this.getStoreInfo();

                case 8:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    getStoreBrief: function getStoreBrief(brandId) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        console.log('getStoreBrief | Sidebar');
        var url = '/brand/' + brandId + '/storeListBrief';
        _this2.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            _this2.storeList = response.data.list;
            _this2.sStoreId = response.data.list[0].store_id;
            _this2.$store.commit('SET_STORES', response.data.list);
            _this2.$store.commit('SET_STORE_ID', response.data.list[0]['store_id']);
            resolve();
          }
        });
      });
    },
    getStoreInfo: function getStoreInfo() {
      var _this3 = this;

      console.log('getStoreInfo | Sidebar');
      var url = '/store/' + this.$store.state.storeId + '/info';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this3.$store.commit('SET_STORE_INFO', response.data.info);
        }
      });
    },
    goto: function goto() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__assets_js_shared_token_js__["c" /* setSharedToken */])(window.localStorage.getItem(this.$config.token));
      window.location.href = this.$config.bdms;
    }
  }
});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    option: {
      type: Object,
      required: true
    },
    elementList: Array,
    showMoney: Boolean,
    hideCancel: Boolean,
    curId: [Number, String]
  },
  data: function data() {
    return {
      selected: 0,
      inputValue: '',
      elementRemark: '',
      searchLabel: ''
    };
  },

  computed: {
    filteredList: function filteredList() {
      var self = this;
      return this.elementList.filter(function (elem) {
        if (elem.name.toLowerCase().includes(self.searchLabel.toLowerCase()) || elem.remark.toLowerCase().includes(self.searchLabel.toLowerCase())) return elem;
      });
    }
  },
  methods: {
    showRemark: function showRemark(elem) {
      this.elementRemark = elem.remark;
    },
    hideRemark: function hideRemark() {
      this.elementRemark = '';
    },
    trigger: function trigger(event) {
      this.$emit('trigger', event);
    },
    clickElement: function clickElement(elem) {
      this.elementList.find(function (o) {
        if (parseInt(o.item_id, 10) === parseInt(elem.item_id, 10)) {
          var active = !o.active;
          o.active = active;

          if (typeof o.newPrice !== 'undefined') o.newPrice = o.price;
          if (o.child_list) {
            o.child_list.forEach(function (child) {
              child.active = active;
            });
          }
        }
      });
    },
    clearAll: function clearAll() {
      for (var i = 0; i < this.elementList.length; i++) {
        this.elementList[i].active = false;
      }
    },
    getPrice: function getPrice(price) {
      return Math.floor(price * 100) / 100;
    }
  }
});

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_Menu_Temp_PriceInput_vue__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_Menu_Temp_PriceInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_Menu_Temp_PriceInput_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    option: {
      type: Object,
      required: true
    },
    adjustList: Array,
    hideCancel: Boolean
  },
  data: function data() {
    return {
      selected: 0,
      inputValue: '',
      elementRemark: ''
    };
  },

  components: {
    'price-input': __WEBPACK_IMPORTED_MODULE_0__views_Menu_Temp_PriceInput_vue___default.a
  },
  methods: {
    showRemark: function showRemark(elem) {
      this.elementRemark = elem.remark;
    },
    hideRemark: function hideRemark() {
      this.elementRemark = '';
    },
    trigger: function trigger(event) {
      if (event === 'changePrice') {}
    },
    clickElement: function clickElement(option, adjust) {
      option.active = !option.active;
    },
    clearAll: function clearAll() {
      for (var i = 0; i < this.elementList.length; i++) {
        this.elementList[i].active = false;
      }
    }
  }
});

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    option: {
      type: Object,
      required: true
    },
    adjustList: Array,
    hideCancel: Boolean
  },
  data: function data() {
    return {
      selected: 0,
      inputValue: '',
      elementRemark: ''
    };
  },

  methods: {
    showRemark: function showRemark(elem) {
      this.elementRemark = elem.remark;
    },
    hideRemark: function hideRemark() {
      this.elementRemark = '';
    },
    trigger: function trigger(event) {
      this.$emit('trigger', event);
    },
    clickElement: function clickElement(option, adjust) {
      option.active = !option.active;
    },
    clearAll: function clearAll() {
      for (var i = 0; i < this.elementList.length; i++) {
        this.elementList[i].active = false;
      }
    },
    choseOption: function choseOption(adjust, isChose) {
      var oList = adjust.child_list;
      for (var i = 0; i < oList.length; i++) {
        oList[i].active = isChose;
      }
    }
  }
});

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    option: {
      type: Object,
      required: true
    },
    storeId: Number,
    search: String,
    openModal: Boolean,
    mutiSelect: Boolean },
  data: function data() {
    return {
      searchText: '',
      productInfoList: [] };
  },

  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    store: function store() {
      return this.storeId || this.$route.params.store_id;
    },
    filterProductList: function filterProductList() {
      var _this = this;

      var result = this.productInfoList.filter(function (item) {
        return item.name.toLowerCase().includes(_this.searchText.toLowerCase().trim());
      });
      return result;
    }
  },
  created: function created() {
    this.getMenuId();
  },

  methods: {
    selectedProd: function selectedProd() {
      var selected = this.productInfoList.filter(function (item) {
        return item.checked === true;
      });
      this.closeModal();
      this.$emit('selectedProd', selected);
      this.clearAll();
    },
    clearAll: function clearAll() {
      this.searchText = '';
      this.productInfoList.forEach(function (item) {
        item.checked = false;
      });
    },
    getMenuId: function getMenuId() {
      var _this2 = this;

      var url = 'onlineMenu/list?page=1&size=1&store_id=' + this.store;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var result = response.data.menu_list ? response.data.menu_list[0] ? response.data.menu_list[0].id : null : null;
          if (result) {
            _this2.getProductInfoList(result);
          }
        }
      });
    },
    getProductInfoList: function getProductInfoList(menuId) {
      var _this3 = this;

      var url = 'onlineMenu/' + menuId + '/productBrief';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this3.productInfoList = [];
          var menu = response.data.brief;
          menu.category_list.forEach(function (category) {
            category.child_list.forEach(function (prod) {
              prod.checked = false;
              _this3.productInfoList.push(prod);
            });
          });
        }
      });
    },
    checkSelect: function checkSelect(val) {
      if (val && !this.mutiSelect) {
        this.productInfoList.forEach(function (item) {
          if (item !== val) {
            item.checked = false;
          }
        });
      }
    },
    closeModal: function closeModal() {
      this.$emit('update:openModal', false);
    }
  },
  watch: {
    openModal: function openModal(val) {
      if (val) {
        this.searchText = this.search || '';
        this.$refs.chooseProd.click();
      }
    }
  }
});

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'nd-modal',
  props: {
    option: {
      type: Object,
      required: true
    },
    selectOptions: {
      type: Object
    },
    selectDefault: {
      type: [String, Number]
    },
    selectChange: {
      type: [String, Number]
    }
  },
  data: function data() {
    return {
      selected: 0,
      inputValue: ''
    };
  },

  methods: {
    trigger: function trigger(event) {
      this.$emit('trigger', event);
    },
    selectOnChange: function selectOnChange() {
      this.$emit('selectOnChange', this.selected);
    },
    inputOnChange: function inputOnChange() {
      this.$emit('inputOnChange', this.inputValue);
    }
  },
  created: function created() {
    if (this.selectOptions) {
      for (var i = 0; i < this.selectOptions.options.length; i++) {
        if (i === 0 && !this.selectDefault) this.selected = this.selectOptions.options[i].value;else if (this.selectDefault) {
          this.selected = parseInt(this.selectDefault, 10);
          break;
        }
      }
    }
  },

  watch: {
    selectChange: function selectChange() {
      this.selected = parseInt(this.selectChange, 10);
    }
  }
});

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'More',
  props: {
    moreText: {
      type: String,
      default: ''
    },
    height: {
      type: Number,
      default: 63
    },
    title: {
      type: String,
      default: '可用門市'
    }
  },
  computed: {
    left: function left() {
      var width = this.$refs['ellipsis' + this.random].scrollWidth;
      return 'left:' + width + 'px';
    }
  },
  data: function data() {
    return {
      showMore: false,
      random: 0,
      showBenefits: false,
      benefitText: ''
    };
  },
  mounted: function mounted() {
    this.showMoreBtn();
  },

  methods: {
    showMoreBtn: function showMoreBtn() {
      var _this = this;

      this.random = Math.floor(Math.random() * 10000);
      this.$nextTick(function () {
        if (Number(_this.$refs['ellipsis' + _this.random].scrollHeight) > _this.height) {
          _this.showMore = true;
        } else {
          _this.showMore = false;
        }
      });
    }
  },
  watch: {
    moreText: function moreText() {
      this.showMoreBtn();
    }
  }
});

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageAmount: Number,
    groupAmount: Number,
    clickPage: Function,
    isActive: Function,
    total: Number
  },
  data: function data() {
    return {
      pageGroup: 1,
      tableIndex: 1
    };
  },

  methods: {
    clickIndex: function clickIndex(index) {
      this.tableIndex = index;
      this.clickPage(index);
    },
    clickGroup: function clickGroup(type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1;
        this.tableIndex = this.groupAmount * this.pageGroup;
        this.clickPage(this.tableIndex);
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1;
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1;
        this.clickPage(this.tableIndex);
      }
    },
    clickEnd: function clickEnd(type) {
      if (type === 'pre') {
        this.tableIndex = 1;
        this.clickPage(1);
        this.pageGroup = 1;
      } else if (type === 'forward') {
        if (this.pageAmount) {
          this.tableIndex = this.pageAmount;
          this.clickPage(this.pageAmount);
        } else {
          this.tableIndex = 1;
          this.clickPage(1);
        }
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount);
      }
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    }
  },
  watch: {
    tableIndex: function tableIndex() {
      var path = this.$route.name;
      window.sessionStorage.setItem('Nidin_' + path + '_tIndex', this.tableIndex);
      window.sessionStorage.setItem('Nidin_' + path + '_pGroup', this.pageGroup);
    }
  }
});

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    option: {
      type: Object,
      required: true
    },

    productList: Array
  },

  data: function data() {
    return {
      selected: 0,
      inputValue: '',
      elementRemark: '',
      curClick: 0
    };
  },


  computed: {
    productInfo: function productInfo() {
      var self = this;
      var empty = {
        product_id: 0,
        sort: '',
        newPrice: '',
        is_mandatory: '',
        is_default: '',
        min_limit: '',
        max_limit: ''
      };
      if (self.curClick) {
        var p = this.productList.find(function (p) {
          return p.item_id === self.curClick;
        });
        if (p) return p;else return empty;
      } else return empty;
    }
  },

  methods: {
    showRemark: function showRemark(elem) {
      this.elementRemark = elem.remark;
    },
    hideRemark: function hideRemark() {
      this.elementRemark = '';
    },
    trigger: function trigger(event) {
      this.$emit('trigger', event);
    },
    clickElement: function clickElement(elem) {
      this.curClick = elem.item_id;
    },
    clearAll: function clearAll() {
      for (var i = 0; i < this.elementList.length; i++) {
        this.elementList[i].active = false;
      }
    },
    getPrice: function getPrice(price) {
      return Math.floor(price * 100) / 100;
    },
    veritySort: function veritySort() {
      var e = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$refs.sort);
      this.productInfo.sort = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityMinLimit: function verityMinLimit() {
      var e = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$refs.minLimit);
      this.productInfo.min_limit = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityMaxLimit: function verityMaxLimit() {
      var e = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$refs.maxLimit);
      this.productInfo.max_limit = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityPrice: function verityPrice() {
      var e = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$refs.price);
      this.productInfo.price = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    }
  }
});

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chooseStoreModal',
  props: {
    option: {
      type: Object,
      required: true
    },
    tooltip: {
      type: String,
      required: false,
      default: '相同料號的商品會覆蓋設定'
    }
  },
  data: function data() {
    return {
      storeBrief: [],
      addStoresSetting: {
        class: 'copy-store',
        options: [],
        choose: []
      },
      storeClassList: [],
      curId: 0,
      reNew: 0,
      reSet: 0
    };
  },

  methods: {
    getStoreBrief: function getStoreBrief() {
      this.storeBrief = [];
      this.addStoresSetting.options = [];
      var self = this;
      var url = '/brand/' + this.$route.params.brand_id + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.getStoreClassList();
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            if (parseInt(sList[i].store_id, 10) !== parseInt(self.$route.params.store_id, 10)) {
              self.storeBrief.push(obj);
              self.addStoresSetting.options.push(obj);
            }
          }
          self.reNew++;
        }
      });
    },
    getStoreClassList: function getStoreClassList() {
      var _this = this;

      if (this.getRoleType === 10) return;

      var url = 'brand/' + this.$route.params.brand_id + '/storeClassList';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          _this.storeClassList = sList;
        }
      });
    },
    copyStore: function copyStore() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.$emit('copyStore', _this2.addStoresSetting.choose);

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    clickOption: function clickOption(option) {
      var _this3 = this;

      this.addStoresSetting.options = [];
      this.curId = option.id;
      if (this.curId) {
        this.$nextTick(function () {
          _this3.reSet++;
          _this3.addStoresSetting.options = _this3.storeBrief;
          _this3.getCurStoreClass();
        });
      }
    },
    getCurStoreClass: function getCurStoreClass() {
      var _this4 = this;

      this.addStoresSetting.choose = [];
      var url = 'brand/' + this.$route.params.brand_id + '/storeClass/' + this.curId;
      if (this.getRoleType === 10) url = 'store/' + this.$route.params.brand_id + '/storeClass/' + this.curId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var classInfo = response.data.class;
          classInfo.store_list.forEach(function (s) {
            if (s.id !== parseInt(_this4.$route.params.store_id, 10)) {
              _this4.addStoresSetting.choose.push(s.id);
            }
          });
        }
      });
    }
  },
  created: function created() {
    this.getStoreBrief();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  })
});

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    setting: {
      type: Object,
      required: true
    },
    reNew: Number,
    reSet: Number
  },
  data: function data() {
    return {
      selected: 0,
      inputValue: '',
      elementRemark: '',
      first: true,
      isChoose: false
    };
  },
  mounted: function mounted() {
    if (this.$route.name === 'crSchedule') this.first = false;

    var self = this;
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + self.setting.class + ' #multiselect').multiselect({
      right: '#multiselect_to-' + self.setting.class,
      rightAll: '#multiselect_rightAll-' + self.setting.class,
      rightSelected: '#multiselect_rightSelected-' + self.setting.class,
      leftSelected: '#multiselect_leftSelected-' + self.setting.class,
      leftAll: '#multiselect_leftAll-' + self.setting.class,
      afterMoveToLeft: function afterMoveToLeft($left, $right, $options) {
        self.setting.choose = [];
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + self.setting.class + ' #multiselect_to-' + self.setting.class + ' option').each(function () {
          self.setting.choose.push(parseInt(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val(), 10));
        });
      },
      afterMoveToRight: function afterMoveToRight($left, $right, $options) {
        self.setting.choose = [];
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + self.setting.class + ' #multiselect_to-' + self.setting.class + ' option').each(function () {
          self.setting.choose.push(parseInt(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val(), 10));
        });
      },
      search: {
        left: '<input type="text" name="q-' + self.setting.class + '" class="form-control" placeholder="搜尋..." />',
        right: '<input type="text" name="q-' + self.setting.class + '" class="form-control" placeholder="搜尋..." />'
      },
      fireSearch: function fireSearch(value) {
        return value.length > 0;
      }
    });

    var leftSel = '.' + self.setting.class + ' #multiselect';
    var rightSel = '.' + self.setting.class + ' #multiselect_to-' + self.setting.class;
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(leftSel).off('dblclick').on('dblclick', function (e) {
      e.preventDefault();e.stopImmediatePropagation();return false;
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(rightSel).off('dblclick').on('dblclick', function (e) {
      e.preventDefault();e.stopImmediatePropagation();return false;
    });
  },

  methods: {
    init: function init() {
      var self = this;
      self.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + self.setting.class + ' #multiselect option').remove();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + self.setting.class + ' #multiselect_to-' + self.setting.class + ' option').remove();
        this.setting.options.forEach(function (option) {
          var o = new Option(option.label, option.value);
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + self.setting.class + ' #multiselect').append(o);
        });

        this.setting.choose.forEach(function (choseVal, index) {
          var oObj = self.setting.options.find(function (option) {
            return choseVal === option.value;
          });
          if (oObj) {
            var o = new Option(oObj.label, oObj.value);
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + self.setting.class + ' #multiselect_to-' + self.setting.class).append(o);
            if (index === self.setting.choose.length - 1) self.first = false;
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + self.setting.class + ' #multiselect option[value="' + oObj.value + '"]').remove();
          }
        });
      });
    }
  },
  watch: {
    reSet: function reSet() {
      this.first = true;
    },
    reNew: function reNew() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + self.setting.class + ' #multiselect option').remove();

      if (this.$route.name === 'crActivityInfoForm') {
        this.setting.options.forEach(function (option) {
          var o = new Option(option.label, option.value);
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + self.setting.class + ' #multiselect').append(o);
        });
      }
    },
    'setting.choose': function settingChoose() {
      var self = this;
      self.$nextTick(function () {
        var rName = this.$route.name;
        var rPath = this.$route.path;
        if (!this.setting.choose.length) __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + self.setting.class + ' #multiselect_to-' + self.setting.class + ' option').remove();
        if (!self.isChoose && (self.first && this.$route.name.indexOf('up') > -1 && this.setting.choose.length && this.$route.name !== 'upStore' || rName === 'crStoreClass' && self.first && this.setting.choose.length || rName === 'crSchedule' && self.first && this.setting.choose.length || rName === 'upSchedule' && self.first && this.setting.choose.length || rName === 'upDiscount' && self.first && this.setting.choose.length || rName === 'crDiscount' && self.first && this.setting.choose.length || rName === 'crActivityInfoForm' && self.first && this.setting.choose.length || rName === 'upActivity' && self.first && this.setting.choose.length || rName === 'storeGroup' && self.first && this.setting.choose.length || rName === 'crBrandAd' && self.first && this.setting.choose.length || rName === 'upBrandAd' && self.first && this.setting.choose.length || rName === 'copyAd' && self.first && this.setting.choose.length || rName === 'upStore' && self.first && this.setting.choose.length || rName === 'batchSetupStore' && self.first && this.setting.choose.length || (rPath.includes('productSetting') || rPath.includes('productImage')) && self.first && this.setting.choose.length)) {
          this.setting.choose.forEach(function (choseVal, index) {
            var oObj = self.setting.options.find(function (option) {
              return choseVal === option.value;
            });
            if (oObj) {
              var o = new Option(oObj.label, oObj.value);
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + self.setting.class + ' #multiselect_to-' + self.setting.class).append(o);
              if (index === self.setting.choose.length - 1) self.first = false;
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + self.setting.class + ' #multiselect option[value="' + oObj.value + '"]').remove();
            }
          });
        }
        self.isChoose = false;
      });
    }
  }
});

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    setting: {
      type: Object,
      required: true
    },
    reNew: Number,
    reSet: Number
  },
  data: function data() {
    return {
      selected: 0,
      inputValue: '',
      elementRemark: '',
      first: true,
      isChoose: false
    };
  },
  mounted: function mounted() {
    if (this.$route.name === 'crSchedule') this.first = false;

    var self = this;
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + self.setting.class + ' #multiselect').multiselect({
      right: '#multiselect_to-' + self.setting.class,
      rightAll: '#multiselect_rightAll-' + self.setting.class,
      rightSelected: '#multiselect_rightSelected-' + self.setting.class,
      leftSelected: '#multiselect_leftSelected-' + self.setting.class,
      leftAll: '#multiselect_leftAll-' + self.setting.class,
      afterMoveToLeft: function afterMoveToLeft($left, $right, $options) {
        self.setting.choose = [];
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + self.setting.class + ' #multiselect_to-' + self.setting.class + ' option').each(function () {
          self.setting.choose.push(parseInt(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val(), 10));
        });
      },
      afterMoveToRight: function afterMoveToRight($left, $right, $options) {
        self.setting.choose = [];
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + self.setting.class + ' #multiselect_to-' + self.setting.class + ' option').each(function () {
          self.setting.choose.push(parseInt(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val(), 10));
        });
      },
      search: {
        left: '<input type="text" name="q-' + self.setting.class + '" class="form-control" placeholder="搜尋..." />',
        right: '<input type="text" name="q-' + self.setting.class + '" class="form-control" placeholder="搜尋..." />'
      },
      fireSearch: function fireSearch(value) {
        return value.length > 0;
      }
    });
  },

  methods: {
    init: function init() {
      var self = this;
      self.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + self.setting.class + ' #multiselect option').remove();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + self.setting.class + ' #multiselect_to-' + self.setting.class + ' option').remove();
        this.setting.options.forEach(function (option) {
          var o = new Option(option.label, option.value);
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + self.setting.class + ' #multiselect').append(o);
        });

        this.setting.choose.forEach(function (choseVal, index) {
          var oObj = self.setting.options.find(function (option) {
            return choseVal === option.value;
          });
          if (oObj) {
            var o = new Option(oObj.label, oObj.value);
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + self.setting.class + ' #multiselect_to-' + self.setting.class).append(o);
            if (index === self.setting.choose.length - 1) self.first = false;
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + self.setting.class + ' #multiselect option[value="' + oObj.value + '"]').remove();
          }
        });
      });
    }
  },
  watch: {
    reSet: function reSet() {
      this.first = true;
    },
    reNew: function reNew() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + self.setting.class + ' #multiselect option').remove();

      if (this.$route.name === 'crActivityInfoForm') {
        this.setting.options.forEach(function (option) {
          var o = new Option(option.label, option.value);
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + self.setting.class + ' #multiselect').append(o);
        });
      }
    },
    'setting.choose': function settingChoose() {
      var self = this;
      self.$nextTick(function () {
        var rName = this.$route.name;
        if (!this.setting.choose.length) __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + self.setting.class + ' #multiselect_to-' + self.setting.class + ' option').remove();
        if (!self.isChoose && (self.first && this.$route.name.indexOf('up') > -1 && this.setting.choose.length && this.$route.name !== 'upStore' || rName === 'crStoreClass' && self.first && this.setting.choose.length || rName === 'crSchedule' && self.first && this.setting.choose.length || rName === 'upSchedule' && self.first && this.setting.choose.length || rName === 'upDiscount' && self.first && this.setting.choose.length || rName === 'crDiscount' && self.first && this.setting.choose.length || rName === 'crActivityInfoForm' && self.first && this.setting.choose.length || rName === 'upActivity' && self.first && this.setting.choose.length || rName === 'storeGroup' && self.first && this.setting.choose.length || rName === 'crBrandAd' && self.first && this.setting.choose.length || rName === 'upBrandAd' && self.first && this.setting.choose.length)) {
          this.setting.choose.forEach(function (choseVal, index) {
            var oObj = self.setting.options.find(function (option) {
              return choseVal === option.value;
            });
            if (oObj) {
              var o = new Option(oObj.label, oObj.value);
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + self.setting.class + ' #multiselect_to-' + self.setting.class).append(o);
              if (index === self.setting.choose.length - 1) self.first = false;
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + self.setting.class + ' #multiselect option[value="' + oObj.value + '"]').remove();
            }
          });
        }
        self.isChoose = false;
      });
    }
  }
});

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NdAnnouncementOverlay',
  props: {
    dailogOpen: {
      type: Boolean,
      default: false
    },
    message: {
      type: Object,
      default: {}
    }
  },
  methods: {
    close: function close() {
      this.$emit('update:close', this.message);
    }
  },
  watch: {
    dailogOpen: function dailogOpen(val) {
      if (val) {
        this.$refs.modal.click();
      }
    }
  }
});

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_nd_multi_select_listbox_vue__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_nd_multi_select_listbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_elements_nd_multi_select_listbox_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'nd-copy-options-store',
  props: {
    brandId: {
      type: Number,
      default: 0
    },
    getDataH: {
      type: Function
    },
    storeId: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      chose: []
    };
  },

  components: {
    'nd-multi-select-listbox': __WEBPACK_IMPORTED_MODULE_0__components_elements_nd_multi_select_listbox_vue___default.a
  },
  methods: {
    updateChoose: function updateChoose(val) {
      this.chose = val;
      this.$emit('update:choose', val);
    }
  }
});

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    required: false,
    date: {
      type: Object,
      required: true
    },
    option: {
      type: Object,
      default: function _default() {
        return {
          type: 'day',
          SundayFirst: false,
          week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
          month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
          format: 'YYYY-MM-DD',
          color: {
            checked: '#F50057',
            header: '#3f51b5',
            headerText: '#fff'
          },
          inputStyle: {
            'display': 'inline-block',
            'padding': '6px',
            'line-height': '22px',
            'font-size': '16px',
            'border': '2px solid #fff',
            'box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
            'border-radius': '2px',
            'color': '#5F5F5F'
          },
          placeholder: 'when?',
          buttons: {
            ok: 'OK',
            cancel: 'Cancel'
          },
          overlayOpacity: 0.5,
          dismissible: true
        };
      }
    },
    limit: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    function hours() {
      var list = [];
      var hour = 24;
      while (hour > 0) {
        hour--;
        list.push({
          checked: false,
          value: hour < 10 ? '0' + hour : hour
        });
      }
      return list;
    }
    function mins() {
      var list = [];
      var min = 60;
      while (min > 0) {
        min--;
        list.push({
          checked: false,
          value: min < 10 ? '0' + min : min
        });
      }
      return list;
    }
    return {
      hours: hours(),
      mins: mins(),
      showInfo: {
        hour: false,
        day: false,
        month: false,
        year: false,
        check: false
      },
      displayInfo: {
        month: ''
      },
      library: {
        week: this.option.week,
        month: this.option.month,
        year: []
      },
      checked: {
        oldtime: '',
        currentMoment: null,
        year: '',
        month: '',
        day: '',
        hour: '00',
        min: '00'
      },
      dayList: [],
      selectedDays: []
    };
  },

  methods: {
    pad: function pad(n) {
      n = Math.floor(n);
      return n < 10 ? '0' + n : n;
    },
    nextMonth: function nextMonth(type) {
      var next = null;
      type === 'next' ? next = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).add(1, 'M') : next = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).add(-1, 'M');
      this.showDay(next);
    },
    showDay: function showDay(time) {
      if (time === undefined || !Date.parse(time)) {
        this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
      } else {
        this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(time, this.option.format);
      }
      this.showOne('day');
      this.checked.year = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).format('YYYY');
      this.checked.month = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).format('MM');
      this.checked.day = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).format('DD');
      this.displayInfo.month = this.library.month[__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).month()];
      var days = [];
      var currentMoment = this.checked.currentMoment;
      var firstDay = __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).date(1).day();

      var previousMonth = __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment);
      var nextMonth = __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment);
      nextMonth.add(1, 'months');
      previousMonth.subtract(1, 'months');
      var monthDays = __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).daysInMonth();
      var oldtime = this.checked.oldtime;
      for (var i = 1; i <= monthDays; ++i) {
        days.push({
          value: i,
          inMonth: true,
          unavailable: false,
          checked: false,
          moment: __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).date(i)
        });
        if (i === Math.ceil(__WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).format('D')) && __WEBPACK_IMPORTED_MODULE_2_moment___default()(oldtime, this.option.format).year() === __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).year() && __WEBPACK_IMPORTED_MODULE_2_moment___default()(oldtime, this.option.format).month() === __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).month()) {
          days[i - 1].checked = true;
        }
        this.checkBySelectDays(i, days);
      }
      if (firstDay === 0) firstDay = 7;
      for (var _i = 0; _i < firstDay - (this.option.SundayFirst ? 0 : 1); _i++) {
        var passiveDay = {
          value: previousMonth.daysInMonth() - _i,
          inMonth: false,
          action: 'previous',
          unavailable: false,
          checked: false,
          moment: __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).date(1).subtract(_i + 1, 'days')
        };
        days.unshift(passiveDay);
      }
      var passiveDaysAtFinal = 42 - days.length;
      for (var _i2 = 1; _i2 <= passiveDaysAtFinal; _i2++) {
        var _passiveDay = {
          value: _i2,
          inMonth: false,
          action: 'next',
          unavailable: false,
          checked: false,
          moment: __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).add(1, 'months').date(_i2)
        };
        days.push(_passiveDay);
      }
      if (this.limit.length > 0) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.limit), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var li = _step.value;

            switch (li.type) {
              case 'fromto':
                days = this.limitFromTo(li, days);
                break;
              case 'weekday':
                days = this.limitWeekDay(li, days);
                break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      this.dayList = days;
    },
    checkBySelectDays: function checkBySelectDays(d, days) {
      var _this = this;

      this.selectedDays.forEach(function (day) {
        if (_this.checked.year === __WEBPACK_IMPORTED_MODULE_2_moment___default()(day).format('YYYY') && _this.checked.month === __WEBPACK_IMPORTED_MODULE_2_moment___default()(day).format('MM') && d === Math.ceil(__WEBPACK_IMPORTED_MODULE_2_moment___default()(day).format('D'))) {
          days[d - 1].checked = true;
        }
      });
    },
    limitWeekDay: function limitWeekDay(limit, days) {
      days.map(function (day) {
        if (limit.available.indexOf(Math.floor(day.moment.format('d'))) === -1) {
          day.unavailable = true;
        }
      });
      return days;
    },
    limitFromTo: function limitFromTo(limit, days) {
      var _this2 = this;

      if (limit.from || limit.to) {
        days.map(function (day) {
          if (_this2.getLimitCondition(limit, day)) {
            day.unavailable = true;
          }
        });
      }
      return days;
    },
    getLimitCondition: function getLimitCondition(limit, day) {

      var tmpMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(day.moment);
      if (limit.from && !limit.to) {
        return !tmpMoment.isAfter(limit.from);
      } else if (!limit.from && limit.to) {
        return !tmpMoment.isBefore(limit.to);
      } else {
        return !tmpMoment.isBetween(limit.from, limit.to);
      }
    },
    checkDay: function checkDay(obj) {
      if (obj.unavailable || obj.value === '') {
        return false;
      }
      if (!obj.inMonth) {
        this.nextMonth(obj.action);
      }
      if (this.option.type === 'day' || this.option.type === 'min') {
        this.dayList.forEach(function (x) {
          x.checked = false;
        });
        this.checked.day = this.pad(obj.value);
        obj.checked = true;
      } else {
        var day = this.pad(obj.value);
        var ctime = this.checked.year + '-' + this.checked.month + '-' + day;
        if (obj.checked === true) {
          obj.checked = false;
          this.selectedDays.$remove(ctime);
        } else {
          this.selectedDays.push(ctime);
          obj.checked = true;
        }
      }
      switch (this.option.type) {
        case 'day':
          this.picked();
          break;
        case 'min':
          this.showOne('hour');

          this.shiftActTime();
          break;
      }
    },
    showYear: function showYear() {
      var _this3 = this;

      var year = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).year();
      this.library.year = [];
      var yearTmp = [];
      for (var i = year - 100; i < year + 5; ++i) {
        yearTmp.push(i);
      }
      this.library.year = yearTmp;
      this.showOne('year');
      this.$nextTick(function () {
        var listDom = document.getElementById('yearList');
        listDom.scrollTop = listDom.scrollHeight - 100;
        _this3.addYear();
      });
    },
    showOne: function showOne(type) {
      switch (type) {
        case 'year':
          this.showInfo.hour = false;
          this.showInfo.day = false;
          this.showInfo.year = true;
          this.showInfo.month = false;
          break;
        case 'month':
          this.showInfo.hour = false;
          this.showInfo.day = false;
          this.showInfo.year = false;
          this.showInfo.month = true;
          break;
        case 'day':
          this.showInfo.hour = false;
          this.showInfo.day = true;
          this.showInfo.year = false;
          this.showInfo.month = false;
          break;
        case 'hour':
          this.showInfo.hour = true;
          this.showInfo.day = false;
          this.showInfo.year = false;
          this.showInfo.month = false;
          break;
        default:
          this.showInfo.day = true;
          this.showInfo.year = false;
          this.showInfo.month = false;
          this.showInfo.hour = false;
      }
    },
    showMonth: function showMonth() {
      this.showOne('month');
    },
    addYear: function addYear() {
      var _this4 = this;

      var listDom = document.getElementById('yearList');
      listDom.addEventListener('scroll', function (e) {
        if (listDom.scrollTop < listDom.scrollHeight - 100) {
          var len = _this4.library.year.length;
          var lastYear = _this4.library.year[len - 1];
          _this4.library.year.push(lastYear + 1);
        }
      }, false);
    },
    setYear: function setYear(year) {
      this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(year + '-' + this.checked.month + '-' + this.checked.day);
      this.showDay(this.checked.currentMoment);
    },
    setMonth: function setMonth(month) {
      var mo = this.library.month.indexOf(month) + 1;
      if (mo < 10) {
        mo = '0' + '' + mo;
      }
      this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.year + '-' + mo + '-' + this.checked.day);
      this.showDay(this.checked.currentMoment);
    },
    showCheck: function showCheck() {
      if (this.date.time === '') {
        this.showDay();
      } else {
        if (this.option.type === 'day' || this.option.type === 'min') {
          this.checked.oldtime = this.date.time;
          this.showDay(this.date.time);
        } else {
          this.selectedDays = JSON.parse(this.date.time);
          if (this.selectedDays.length) {
            this.checked.oldtime = this.selectedDays[0];
            this.showDay(this.selectedDays[0]);
          } else {
            this.showDay();
          }
        }
      }
      this.showInfo.check = true;
    },
    setTime: function setTime(type, obj, list) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          item.checked = false;
          if (item.value === obj.value) {
            item.checked = true;
            this.checked[type] = item.value;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    picked: function picked() {
      if (this.option.type === 'day' || this.option.type === 'min') {
        var ctime = this.checked.year + '-' + this.checked.month + '-' + this.checked.day + ' ' + this.checked.hour + ':' + this.checked.min;
        this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(ctime, 'YYYY-MM-DD HH:mm');
        this.date.time = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).format(this.option.format);
      } else {
        this.date.time = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedDays);
      }
      this.showInfo.check = false;
      this.$emit('change', this.date.time);
    },
    dismiss: function dismiss(evt) {
      if (evt.target.className === 'datepicker-overlay') {
        if (this.option.dismissible === undefined || this.option.dismissible) {
          this.showInfo.check = false;
          this.$emit('cancel');
        }
      }
    },
    shiftActTime: function shiftActTime() {
      this.$nextTick(function () {
        if (!document.querySelector('.hour-item.active')) {
          return false;
        }
        document.querySelector('.hour-box').scrollTop = (document.querySelector('.hour-item.active').offsetTop || 0) - 250;
        document.querySelector('.min-box').scrollTop = (document.querySelector('.min-item.active').offsetTop || 0) - 250;
      });
    }
  }
});

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'nd-multi-select-listbox',
  props: {
    brandId: {
      type: Number,
      default: 0
    },
    getDataH: {
      type: Function
    },
    storeId: {
      type: Number,
      default: 0
    },

    type: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      curId: 0,
      info: {
        brandId: 0,
        storeId: 0
      },
      setting: {
        class: 'copy-store',
        options: [],
        choose: []
      },
      stores: [],
      storeClass: [],
      storeClassList: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getRoleType'])),
  watch: {
    'setting.choose': function settingChoose(val) {
      this.$emit('update:choose', val);
    }
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.info.brandId = _this.brandId;
      _this.info.storeId = _this.storeId;
      _this.getInfo();
    }, 100);
  },

  methods: {
    clickOption: function clickOption(option) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.curId = option.id;

                if (!_this2.curId) {
                  _context.next = 5;
                  break;
                }

                _context.next = 4;
                return _this2.getStoreClass();

              case 4:
                _this2.updataChoose();

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    formatData: function formatData() {
      for (var i = 0; i < this.stores.length; i++) {
        var temp = {
          label: this.stores[i].name,
          value: this.stores[i].store_id
        };
        if (parseInt(this.stores[i].store_id, 10) !== parseInt(this.brandId, 10)) {
          this.setting.options.push(temp);
        }
      }
    },
    getBrandList: function getBrandList() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (_this3.info.brandId) {
          resolve();
          return;
        }
        var url = '/brand/list?page=1&size=1';
        _this3.getDataH('get', url, null, function (res) {
          if (res.data.status === 200) {
            _this3.info.brandId = res.data.list[0].id;
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    getInfo: function getInfo() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this4.getBrandList();

              case 2:
                _context2.next = 4;
                return _this4.getStoreListBrief();

              case 4:
                _context2.next = 6;
                return _this4.getStoreClassList();

              case 6:
                _this4.formatData();

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    getStoreClass: function getStoreClass() {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var url = 'brand/' + _this5.info.brandId + '/storeClass/' + _this5.curId;
        _this5.getDataH('get', url, null, function (res) {
          if (res.data.status === 200) {
            _this5.storeClass = res.data.class;
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    getStoreListBrief: function getStoreListBrief() {
      var _this6 = this;

      console.log({
        component: this.$options.name,
        function: 'getStoreListBrief',
        payload: {},
        time: __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('HH:mm:ss')
      });
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this6.stores = [];
        _this6.setting.options = [];
        var url = '/brand/' + _this6.info.brandId + '/storeListBrief';
        if (url.indexOf('?') === -1) {
          url = url + '?';
        }
        var temp = [];
        if (_this6.type === 1) {
          temp.push('allow_copy_menu=1');
        }
        if (_this6.info.storeId) {
          temp.push('store_ids=' + _this6.info.storeId);
        }

        url = url + temp.join('&');
        _this6.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            _this6.stores = response.data.list;
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    getStoreClassList: function getStoreClassList() {
      var _this7 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (_this7.getRoleType === 10) {
          resolve();
          return;
        }
        var url = 'brand/' + _this7.info.brandId + '/storeClassList';
        _this7.getDataH('get', url, null, function (res) {
          if (res.data.status === 200) {
            _this7.storeClassList = res.data.list;
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    updataChoose: function updataChoose() {
      var _this8 = this;

      this.setting.choose = [];
      this.storeClass.store_list.forEach(function (i) {
        var storeIndex = _this8.stores.findIndex(function (store) {
          return i.id === store.store_id;
        });
        if (storeIndex !== -1) {
          _this8.setting.choose.push(i.id);
        }
      });
    }
  }
});

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'nd-trade-apply-store-multi-select-listbox',
  props: {
    brandId: {
      type: Number,
      default: 0
    },
    getDataH: {
      type: Function
    },
    status: {
      type: Array,
      default: function _default() {
        return [2, 3];
      }
    },
    tradeType: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      setting: {
        class: 'nd-trade-apply-store-multi-select-input',
        options: [],
        choose: []
      },
      stores: [],
      storesTradeApplied: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getRoleType'])),
  watch: {
    brandId: {
      immediate: true,
      handler: function handler() {
        this.getInfo();
      }
    },
    'setting.choose': function settingChoose(val) {
      this.$emit('update:choose', val);
    }
  },
  methods: {
    formatData: function formatData() {
      console.log({
        component: this.$options.name,
        function: 'formatData',
        payload: {},
        time: __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('HH:mm:ss')
      });

      for (var i = 0; i < this.stores.length; i++) {
        if (this.storesTradeApplied.indexOf(this.stores[i].store_id) === -1) {
          var temp = {
            label: this.stores[i].name,
            value: this.stores[i].store_id
          };
          this.setting.options.push(temp);
        }
      }
    },
    getInfo: function getInfo() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.setting.choose = [];
                _context.next = 3;
                return _this.getStores();

              case 3:
                _context.next = 5;
                return _this.getStoresTrade();

              case 5:
                _this.formatData();

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getStores: function getStores() {
      var _this2 = this;

      console.log({
        component: this.$options.name,
        function: 'getStores',
        payload: {},
        time: __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('HH:mm:ss')
      });

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.stores = [];
        _this2.setting.options = [];

        if (!_this2.brandId) {
          resolve();
          return;
        }

        var url = '/brand/' + _this2.brandId + '/storeListBrief';
        var temp = [];

        temp.push('status=' + _this2.status.join(','));
        if (temp.length && url.indexOf('?') === -1) url = url + '?';
        url = url + temp.join('&');


        _this2.getDataH('get', url, null, function (res) {
          if (res.data.status === 200) {
            _this2.stores = res.data.list;
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    getStoresTrade: function getStoresTrade() {
      var _this3 = this;

      console.log({
        component: this.$options.name,
        function: 'getStoresTrade',
        payload: {},
        time: __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('HH:mm:ss')
      });

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (!_this3.brandId) {
          resolve();
          return;
        }

        var url = '/tradeTypeBiz/storelist/' + _this3.brandId + '?trade_type=' + _this3.tradeType;
        _this3.getDataH('get', url, null, function (res) {
          if (res.data.status === 200) {
            _this3.storesTradeApplied = res.data.exist_store_list;
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    updataChoose: function updataChoose() {
      var _this4 = this;

      this.setting.choose = [];
      this.storeClass.store_list.forEach(function (i) {
        var storeIndex = _this4.stores.findIndex(function (store) {
          return i.id === store.store_id;
        });
        if (storeIndex !== -1) {
          _this4.setting.choose.push(i.id);
        }
      });
    }
  }
});

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_nd_trade_apply_store_multi_select_listbox_vue__ = __webpack_require__(2096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_nd_trade_apply_store_multi_select_listbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_elements_nd_trade_apply_store_multi_select_listbox_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'nd-trade-apply-store',
  props: {
    brands: {
      type: Array,
      default: []
    },
    getDataH: {
      type: Function
    },
    tradeType: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      brand: {
        label: '== 品牌 ==',
        value: 0
      },
      chose: [],
      status: [1, 2],
      storeId: 0
    };
  },

  components: {
    'nd-trade-apply-store-multi-select-listbox': __WEBPACK_IMPORTED_MODULE_0__components_elements_nd_trade_apply_store_multi_select_listbox_vue___default.a
  },
  computed: {
    brandId: function brandId() {
      return this.brand.value;
    }
  },
  methods: {
    updateChoose: function updateChoose(val) {
      this.chose = val;
      this.$emit('update:choose', {
        brand: this.brandId,
        store: this.chose
      });
    }
  }
});

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Temp_AccountTableTemp_vue__ = __webpack_require__(2100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Temp_AccountTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Temp_AccountTableTemp_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      tableIndex: 1
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#example1').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      });
    });
  },

  methods: {
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    }
  },
  components: {
    'account-table': __WEBPACK_IMPORTED_MODULE_3__Temp_AccountTableTemp_vue___default.a
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    }
  }
});

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_AccountFormTemp_vue__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_AccountFormTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_AccountFormTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  components: {
    'account-form': __WEBPACK_IMPORTED_MODULE_0__Temp_AccountFormTemp_vue___default.a
  },
  methods: {},
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  }
});

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__elements_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(2584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);



var sha256 = __webpack_require__(209).sha256;




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    'info': {
      type: Object
    },
    'current': {
      type: Object
    },
    'brandList': {
      type: Array
    },
    'storeList': {
      type: Array
    },
    'posList': {
      type: Array
    }
  },
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default.a,
    'm-modal': __WEBPACK_IMPORTED_MODULE_0__elements_Modal_vue___default.a
  },
  data: function data() {
    return {
      phone: '',
      radioRoleType: 'admin',
      delOption: {
        id: 'delModal',
        title: '刪除帳號',
        body: '確定刪除?<br>刪除此管理者，將無法再用此帳號登入！',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delManager'
        }]
      },
      show: {
        delBtn: false
      },
      select: {
        bindingBrandList: [],
        bindingStoreList: [],
        bindingPosList: []
      },
      content: {
        account: '',
        password: '',
        re_password: '',
        name: '',
        phone: '',
        email: '',
        birth: '',
        sex: 0,
        is_suspend: 0,
        bindingBrandList: [],
        bindingStoreList: [],
        bindingPosList: []
      },
      birth: {
        time: ''
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      dateLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD')
      }],
      brandName: '',
      brandType: '',
      brandBrief: [],
      storeBrief: [],
      posBrief: [],
      brandDefault: {
        value: 0,
        label: ''
      }
    };
  },

  validations: {
    content: {
      phone: {
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minLength"])(10),
        maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(10)
      },
      password: {
        required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
      },
      re_password: {
        required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
        sameAsPassword: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["sameAs"])('password')
      },
      email: {
        email: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["email"]
      }
    }
  },
  methods: {
    init: function init() {
      if (!this.info) {
        this.getBrandBrief();
        this.getPosBrief();
      }
    },
    trigger: function trigger(event) {
      if (event === 'delManager') {
        this.delManager();
      }
    },
    addAccount: function addAccount() {
      var self = this;
      var url = '/manager/' + this.radioRoleType;
      var info = this.content;
      var data = {
        account: info.account,
        password: sha256(info.password),
        re_password: sha256(info.re_password),
        name: info.name
      };
      if (info.phone) data['phone'] = info.phone;
      if (info.email) data['email'] = info.email;
      if (this.birth.time) data['birth'] = this.birth.time;
      if (info.sex) data['sex'] = info.sex;

      if (this.content.bindingBrandList.length && this.radioRoleType === 'brand') {
        var bList = [];
        for (var i = 0; i < this.content.bindingBrandList.length; i++) {
          bList.push(parseInt(this.content.bindingBrandList[i].value, 10));
        }
        data['binding_brand_list'] = bList;
      }
      if (this.content.bindingStoreList.length && this.radioRoleType === 'store') {
        var sList = [];
        for (var j = 0; j < this.content.bindingStoreList.length; j++) {
          sList.push(parseInt(this.content.bindingStoreList[j].value, 10));
        }
        data['binding_store_list'] = sList;
      }
      if (this.content.bindingPosList.length && this.radioRoleType === 'pos') {
        var pList = [];
        for (var k = 0; k < this.content.bindingPosList.length; k++) {
          pList.push(parseInt(this.content.bindingPosList[k].value, 10));
        }
        data['binding_pos_list'] = pList;
      }
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.replace('/accountTable');
        }
      });
    },
    upAccount: function upAccount() {
      var self = this;
      var url = '/manager/' + this.current.role_type + '/' + this.current.manager_id;
      var info = this.content;
      var data = {
        name: info.name,
        phone: info.phone,
        email: info.email,
        sex: info.sex,
        is_suspend: info.is_suspend
      };
      data['birth'] = this.birth.time;
      if (info.bindingBrandList.length && this.current.role_type === 'brand') {
        var bList = [];
        for (var i = 0; i < info.bindingBrandList.length; i++) {
          bList.push(parseInt(info.bindingBrandList[i].value, 10));
        }
        data['binding_brand_list'] = bList;
      }
      if (info.bindingStoreList.length && this.current.role_type === 'store') {
        var sList = [];
        for (var j = 0; j < info.bindingStoreList.length; j++) {
          sList.push(parseInt(info.bindingStoreList[j].value, 10));
        }
        data['binding_store_list'] = sList;
      }
      if (this.content.bindingPosList.length && this.current.role_type === 'pos') {
        var pList = [];
        for (var k = 0; k < info.bindingPosList.length; k++) {
          pList.push(parseInt(info.bindingPosList[k].value, 10));
        }
        data['binding_pos_list'] = pList;
      }
      if (info.password && info.re_password) {
        data['password'] = sha256(info.password);
        data['re_password'] = sha256(info.re_password);
      }
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.replace('/accountTable');
        }
      });
    },
    verityPhone: function verityPhone() {
      var e = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#phone');
      this.content.phone = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            self.brandBrief.push(obj);
            if (i === 0) {
              if (!self.storeList) self.brandDefault = obj;else {
                if (!self.storeList.length) self.brandDefault = obj;else {
                  self.brandDefault.value = self.storeList[0].brand_id;
                  var brandid = self.storeList[0].brand_id;
                  for (var _i = 0; _i < bList.length; _i++) {
                    if (bList[_i].brand_id === brandid) self.brandDefault.label = bList[_i].name;
                  }
                }
              }
            }
          }
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      this.storeBrief = [];
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
          }
        }
      });
    },
    delManager: function delManager() {
      var self = this;
      var url = '/manager/' + this.$route.params.role_type + '/' + this.info.manager_id;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.replace('/accountTable');
        }
      });
    },
    getPosBrief: function getPosBrief() {
      this.posBrief = [];
      var self = this;
      var url = '/pos/vendorBriefList';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var pList = response.data.list;
          for (var i = 0; i < pList.length; i++) {
            var obj = { label: pList[i].name, value: pList[i].pos_vendor_id };
            self.posBrief.push(obj);
          }
        }
      });
    }
  },
  created: function created() {
    this.init();
  },

  watch: {
    'select.bindingBrandList': function selectBindingBrandList() {
      this.content.bindingBrandList = this.select.bindingBrandList;
    },
    'select.bindingStoreList': function selectBindingStoreList() {
      this.content.bindingStoreList = this.select.bindingStoreList;
    },
    'select.bindingPosList': function selectBindingPosList() {
      this.content.bindingPosList = [this.select.bindingPosList];
    },
    info: function info() {
      var info = this.info;
      var content = this.content;
      content.name = info.name;
      content.phone = info.phone;
      content.email = info.email;
      this.birth.time = info.birth;
      content.sex = info.sex;
      content.is_suspend = info.is_suspend;
      if (info.account !== 'admin' && info.account !== 'matcher_admin') this.show.delBtn = true;
      if (this.$route.params.role_type === 'pos') this.getPosBrief();else this.getBrandBrief();
    },
    'brandDefault.value': function brandDefaultValue() {
      this.storeBrief = [];
      this.bindingStoreList = [];
      this.content.bindingStoreList = [];
      this.getStoreBrief(this.brandDefault.value);
    },
    brandBrief: function brandBrief() {
      var contentBList = [];
      var bList = this.brandList;
      if (bList) {
        for (var i = 0; i < bList.length; i++) {
          this.brandBrief.filter(function (elem, index, obj) {
            if (elem.value === bList[i]) {
              contentBList.push(elem);
            }
          });
        }
        this.content.bindingBrandList = contentBList;
        this.select.bindingBrandList = contentBList;
      }
    },
    storeBrief: function storeBrief() {
      var contentSList = [];
      if (this.storeList) {
        if (this.storeList.length) {
          var sList = this.storeList[0].binding_store_list;
          if (sList) {
            for (var i = 0; i < sList.length; i++) {
              this.storeBrief.filter(function (elem, index, obj) {
                if (elem.value === sList[i]) {
                  contentSList.push(elem);
                }
              });
            }
            this.content.bindingStoreList = contentSList;
            this.select.bindingStoreList = contentSList;
          }
        }
      }
    },
    posBrief: function posBrief() {
      var contentPList = [];
      var pList = this.posList;
      if (pList) {
        for (var i = 0; i < pList.length; i++) {
          this.posBrief.filter(function (elem, index, obj) {
            if (elem.value === pList[i]) {
              contentPList.push(elem);
            }
          });
        }
        this.content.bindingPosList = contentPList;
        this.select.bindingPosList = contentPList;
      }
    }
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    bindStore: function bindStore() {
      var contentSList = [];
      var sList = this.storeList;
      if (sList) {
        for (var i = 0; i < sList.length; i++) {
          this.storeBrief.filter(function (elem, index, obj) {
            if (elem.value === sList[i]) {
              contentSList.push(elem);
            }
          });
        }
        return contentSList;
      }
    }
  }
});

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'm-modal': __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue___default.a
  },
  data: function data() {
    return {
      count: 10,
      managerList: [],
      show: {
        brand: false,
        menu: false,
        schedule: false
      },
      type: 'admin',
      selectRoleType: 'admin',
      total: 0,
      maxTotal: 0,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      delOption: {
        id: 'delModal',
        title: '刪除帳號',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delManager'
        }]
      },
      current: {
        role_type: '',
        manager_id: '',
        account: '',
        account_name: ''
      },
      searchKey: 'name',
      searchValue: ''
    };
  },

  methods: {
    trigger: function trigger(event) {
      if (event === 'delManager') {
        this.delManager();
      }
    },
    delManager: function delManager() {
      var self = this;
      var url = '/manager/' + self.current.role_type + '/' + self.current.manager_id;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.getAccountList(1);
        }
      });
    },
    showSelect: function showSelect(type) {
      if (this.selectRoleType === 'all') return true;else {
        if (this.selectRoleType === type) return true;else return false;
      }
    },
    getAccountList: function getAccountList(index) {
      this.tableIndex = index;
      this.managerList = [];
      var self = this;
      var data = {
        page: this.tableIndex,
        count: this.count
      };
      var url = '/manager/' + self.selectRoleType + '/list?page=' + data.page + '&size=' + data.count;
      if (this.searchValue) {
        url += '&' + this.searchKey + '=' + this.searchValue;
      }
      this.getDataH('get', url, data, function (response) {
        if (response.data.status === 200) {
          for (var j = 0; j < response.data.manager_list.length; j++) {
            var manager = response.data.manager_list[j];
            manager['role_type'] = self.selectRoleType;
            self.managerList.push(manager);
          }
          if (self.managerList.length === 0) __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.dataTables_empty').css('display', 'show');
          self.maxTotal = response.data.total;
          self.total = response.data.total;
        }
      });
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    isType: function isType(type) {
      if (this.selectRoleType === type) return true;else return false;
    },
    roleName: function roleName(type) {
      if (type === 'admin') {
        return '系統';
      } else if (type === 'brand') {
        return '品牌';
      } else if (type === 'store') {
        return '店家';
      }
    },
    getCurrent: function getCurrent(roleType, managerId, account, accountName) {
      this.current.role_type = roleType;
      this.current.manager_id = managerId;
      this.current.account = account;
      this.current.account_name = accountName;
      this.delOption.body = '確定刪除 ' + accountName + ' ?<br>刪除此管理者，將無法再用此帳號登入！';
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.getAccountList(index);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.maxTotal / this.count);
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    }
  }),
  created: function created() {
    this.fixedH();
    if (this.$route.name === 'brandTable') this.show.brand = true;else if (this.$route.name === 'menuTable') this.show.menu = true;else if (this.$route.name === 'scheduleTable') this.show.schedule = true;
    this.getAccountList(1);
  },

  watch: {
    selectRoleType: function selectRoleType() {
      this.searchValue = '';
      this.getAccountList(1);
    }
  }
});

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_AccountFormTemp_vue__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_AccountFormTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_AccountFormTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      info: {},
      brandList: [],
      storeList: [],
      posList: [],
      current: {
        role_type: this.$route.params.role_type,
        manager_id: this.$route.params.manager_id
      }
    };
  },

  components: {
    'account-form': __WEBPACK_IMPORTED_MODULE_0__Temp_AccountFormTemp_vue___default.a
  },
  methods: {
    getAccountInfo: function getAccountInfo() {
      var self = this;
      var url = '/manager/' + this.current.role_type + '/' + this.current.manager_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.info = response.data.manager_info;
          if (response.data.binding_brand_list) self.brandList = response.data.binding_brand_list;
          if (response.data.store_list) self.storeList = response.data.store_list;
          if (response.data.binding_pos_list) self.posList = response.data.binding_pos_list;
        }
      });
    }
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  },
  created: function created() {
    this.getAccountInfo();
  }
});

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_elements_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'announcementForm',
  components: {
    'm-modal': __WEBPACK_IMPORTED_MODULE_4__components_elements_Modal_vue___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker__["a" /* default */]
  },
  data: function data() {
    return {
      formTime: {
        time: __WEBPACK_IMPORTED_MODULE_8_moment___default()().set('second', 0).format('YYYY-MM-DD HH:mm:ss')
      },
      delDesAlisOption: {
        id: 'delNewsModal',
        title: '確認刪除此公告',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'deleteSingleNews'
        }]
      },
      announcement: {
        title: '',
        content: '',
        announce_time: '',
        role_type: '0',
        is_overlay: '0'
      },
      img_list: [],
      url_list: [],
      img_list_del: [],
      img: {
        width: 0,
        height: 0
      },

      img_size_error: false,
      onFileChangeCurr: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    img_view: function img_view() {
      if (this.img_list) {
        var deleteCount = 0;
        this.img_list.forEach(function (img) {
          if (img.image_name === 'delete') {
            deleteCount = deleteCount + 1;
          }
        });
        if (deleteCount === this.img_list.length) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    }
  }),
  created: function created() {
    if (this.$route.name === 'editAnnouncement') {
      this.getAnnouncement();
    }
    if (this.$route.name === 'addAnnouncement') {
      this.announcement.announce_time = __WEBPACK_IMPORTED_MODULE_8_moment___default()().set('second', 0).format('YYYY-MM-DD HH:mm:ss');
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapActions */])(['setUnReadNotify']), {
    addimg: function addimg() {
      var img = {
        image_name: ''
      };
      this.img_list.push(img);
    },
    addurl: function addurl() {
      var url = '';
      this.url_list.push(url);
    },
    getAnnouncement: function getAnnouncement() {
      var _this = this;

      var url = 'announcement/' + this.$route.params.announcement_id;
      this.getDataH('get', url, null, function (response) {
        _this.announcement = response.data.announcement;
        _this.announcement.republish = '0';
        _this.formTime.time = _this.announcement.announce_time;
        _this.total = response.data.total;
        _this.img_list = _this.announcement.images;
        _this.url_list = _this.announcement.link;
      });
    },
    notBeforeToday: function notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    notBeforeNow: function notBeforeNow(date) {
      return date < new Date(__WEBPACK_IMPORTED_MODULE_8_moment___default()().set('second', 0).toString());
    },
    vaildForm: function vaildForm() {
      var _this2 = this;

      if (this.announcement.title === '') {
        this.$notify({
          title: '無填寫標題',
          text: '無填寫標題!',
          duration: 3000,
          type: 'danger',
          width: 400
        });
        return false;
      }
      if (this.announcement.content === '') {
        this.$notify({
          title: '無填寫內文',
          text: '無填寫內文!',
          duration: 3000,
          type: 'danger',
          width: 400
        });
        return false;
      }
      if (this.announcement.announce_time === '') {
        this.$notify({
          title: '無填寫發布時間',
          text: '無填寫發布時間!',
          duration: 3000,
          type: 'danger',
          width: 400
        });
        return false;
      }
      if (this.img_list && this.img_view) {
        for (var i = 0; i < this.img_list.length; i++) {
          if ((!__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#img-' + i)[0].files[0] || this.img_list[i].image_name === '') && !this.img_list[i].id && this.img_list[i].image_name !== 'delete') {
            this.$notify({
              title: '圖片尚未上傳',
              text: '圖片尚未上傳',
              duration: 3000,
              type: 'danger',
              width: 400
            });
            return false;
          }
        }
      }
      if (this.announcement.link && this.announcement.link.length > 0) {
        var urlerror = false;
        this.announcement.link.some(function (element, index) {
          if (element === '') {
            _this2.$notify({
              title: '連結有誤',
              text: '連結有誤!',
              duration: 3000,
              type: 'danger',
              width: 400
            });
            urlerror = true;
            return true;
          } else if (element) {
            var lc = element.toLowerCase();
            var isMatch = lc.substr(0, 8) === 'https://' || lc.substr(0, 7) === 'http://';
            if (!isMatch) {
              _this2.$notify({
                title: '連結有誤',
                text: '連結有誤!',
                duration: 3000,
                type: 'danger',
                width: 400
              });
              urlerror = true;
              return true;
            }
          }
        });
        if (urlerror === true) {
          return false;
        }
      }

      var now = __WEBPACK_IMPORTED_MODULE_8_moment___default()().set('second', 0).format('YYYY-MM-DD HH:mm:ss');
      if (this.$route.name === 'editAnnouncement' && this.announcement.republish === '1' && __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.announcement.announce_time).isBefore(now)) {
        this.$notify({
          title: '請調整發佈時間',
          text: '發佈時間不可是已過去時間',
          duration: 3000,
          type: 'danger',
          width: 400
        });
        return false;
      }
      return true;
    },
    updataAll: function updataAll(method) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var imgEmpty, i, _i, _i2;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.img_size_error = false;
                imgEmpty = false;

                if (!(method === 'up')) {
                  _context.next = 38;
                  break;
                }

                if (_this3.vaildForm()) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt('return', false);

              case 7:
                if (!_this3.img_list) {
                  _context.next = 34;
                  break;
                }

                _this3.img_size_error = false;
                _this3.img = {
                  width: 0,
                  height: 0
                };
                imgEmpty = false;
                i = 0;

              case 12:
                if (!(i < _this3.img_list.length)) {
                  _context.next = 25;
                  break;
                }

                if (!(_this3.img_list[i].image_name === '')) {
                  _context.next = 18;
                  break;
                }

                _this3.$notify({
                  title: '圖片尚未上傳',
                  text: '圖片尚未上傳',
                  duration: 3000,
                  type: 'danger',
                  width: 400
                });
                imgEmpty = true;
                _context.next = 22;
                break;

              case 18:
                if (!(_this3.img_list[i].img_size_error === true && _this3.img_list[i].image_name !== 'delete')) {
                  _context.next = 22;
                  break;
                }

                _this3.img_size_error = true;
                _this3.$notify({
                  title: '提醒',
                  text: '圖片' + (i + 1) + '尺寸為' + _this3.img_list[i].width + 'x' + _this3.img_list[i].height + '請上傳 寬不限制x高330 圖片',
                  duration: 3000,
                  type: 'danger',
                  width: 400
                });
                return _context.abrupt('return', false);

              case 22:
                i++;
                _context.next = 12;
                break;

              case 25:
                if (!(!imgEmpty && !_this3.img_size_error && _this3.img_view)) {
                  _context.next = 34;
                  break;
                }

                _i = 0;

              case 27:
                if (!(_i < _this3.img_list.length)) {
                  _context.next = 34;
                  break;
                }

                if (!(__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#img-' + _i)[0].files[0] && _this3.img_list[_i].image_name !== 'delete')) {
                  _context.next = 31;
                  break;
                }

                _context.next = 31;
                return _this3.checkImgSize('up', _i);

              case 31:
                _i++;
                _context.next = 27;
                break;

              case 34:
                if (_this3.img_list_del && _this3.img_list_del.length > 0 && !imgEmpty && !_this3.img_size_error) {
                  _this3.deleteImg();
                }
                if (!_this3.img_size_error && !imgEmpty && !_this3.img_size_error) {
                  _this3.updateAnnouncement();
                }

              case 36:
                _context.next = 54;
                break;

              case 38:
                if (!(method === 'add')) {
                  _context.next = 54;
                  break;
                }

                if (_this3.vaildForm()) {
                  _context.next = 43;
                  break;
                }

                return _context.abrupt('return', false);

              case 43:
                _this3.img_size_error = false;
                _i2 = 0;

              case 45:
                if (!(_i2 < _this3.img_list.length)) {
                  _context.next = 53;
                  break;
                }

                if (!(_this3.img_list[_i2].img_size_error === true && _this3.img_list[_i2].image_name !== 'delete')) {
                  _context.next = 50;
                  break;
                }

                _this3.img_size_error = true;
                _this3.$notify({
                  title: '提醒',
                  text: '圖片' + (_i2 + 1) + '尺寸為' + _this3.img_list[_i2].width + 'x' + _this3.img_list[_i2].height + '請上傳 寬不限制x高330 圖片',
                  duration: 3000,
                  type: 'danger',
                  width: 400
                });
                return _context.abrupt('return', false);

              case 50:
                _i2++;
                _context.next = 45;
                break;

              case 53:
                if (_this3.img_size_error === false) {
                  _this3.addAnnouncement();
                }

              case 54:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    addAnnouncement: function addAnnouncement() {
      var _this4 = this;

      if (!this.vaildForm()) {
        return false;
      }
      var url = 'announcement/create';
      var data = new FormData();
      data.append('role_type', Number(this.announcement.role_type));
      data.append('is_overlay', Number(this.announcement.is_overlay));
      data.append('title', this.announcement.title);
      data.append('content', this.announcement.content);
      data.append('announce_time', this.announcement.announce_time);
      if (this.url_list && this.url_list.length > 0) {
        this.url_list.forEach(function (element, index) {
          data.append('link[]', element);
        });
      }
      if (this.img_list && this.img_list.length > 0) {
        this.img_list.forEach(function (element, index) {
          if (__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#img-' + index)[0].files[0] && _this4.img_list[index].image_name !== 'delete') {
            data.append('image_web_file[]', __WEBPACK_IMPORTED_MODULE_6_jquery___default()('#img-' + index)[0].files[0]);
          }
        });
      }
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          _this4.$parent.announcementInfo('open', true);
          _this4.$router.push({ name: 'announcement' });
        }
      });
    },
    updateAnnouncement: function updateAnnouncement() {
      var _this5 = this;

      var url = 'announcement/' + this.$route.params.announcement_id;
      this.announcement.role_type = Number(this.announcement.role_type);
      this.announcement.is_overlay = Number(this.announcement.is_overlay);
      this.announcement.republish = Number(this.announcement.republish);
      this.getDataH('PUT', url, this.announcement, function (response) {
        if (response.data.status === 200) {
          _this5.$parent.announcementInfo('open', true);
          _this5.$router.push({ name: 'announcement' });
        }
      });
    },
    trigger: function trigger(event) {
      var _this6 = this;

      var url = 'announcement?announcement_ids=' + this.$route.params.announcement_id;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          _this6.$router.push({ name: 'announcement' });
        }
      });
    },
    del_img: function del_img(list, index) {
      if (list[index].id) {
        this.img_list_del.push(list[index].id);
      }

      list[index].image_name = 'delete';
    },
    del_url: function del_url(list, index) {
      list.splice(index, 1);
    },
    updatedImg: function updatedImg(method, pid) {
      var _this7 = this;

      var data = new FormData();
      if (this.img_list[pid] && this.img_list[pid].id) {
        data.append('announcement_image_id', this.img_list[pid].id);
      }
      data.append('image_name', __WEBPACK_IMPORTED_MODULE_6_jquery___default()('#img-' + pid)[0].files[0]);
      var url = '/announcement/uploadImage/' + this.$route.params.announcement_id;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this7.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            return resolve();
          }
        });
      });
    },
    deleteImg: function deleteImg() {
      var _this8 = this;

      var url = '/announcement/deleteImage/' + this.$route.params.announcement_id + '?announcement_image_ids=' + this.img_list_del.toString();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this8.getDataH('delete', url, null, function (response) {
          if (response.data.status === 200) {
            return resolve();
          }
        });
      });
    },
    checkImgSize: function checkImgSize(type, pid) {
      if (this.img_list[pid].height !== 330 && this.img_list[pid].width !== 0 && this.img_list[pid].height !== 0) {
        this.$notify({
          title: '提醒',
          text: '圖片' + (pid + 1) + '尺寸為' + this.img_list[pid].width + 'x' + this.img_list[pid].height + '請上傳 寬不限制x高330 圖片',
          duration: 3000,
          type: 'danger',
          width: 400
        });
        this.img_size_error = true;
        this.img_list[pid].img_size_error = true;
      } else if (type === 'up') {
        this.updatedImg('up', pid);
      }
    },
    createImage: function createImage(file) {
      var _this9 = this;

      var reader = new FileReader();
      reader.onload = function (e) {
        var img = new Image();
        img.src = e.target.result;
        _this9.img_list[_this9.onFileChangeCurr].image_name = img.src;
        img.onload = function () {
          _this9.img_list[_this9.onFileChangeCurr].width = img.width;
          _this9.img_list[_this9.onFileChangeCurr].height = img.height;
          _this9.checkImgSize(null, _this9.onFileChangeCurr);
        };
      };

      reader.readAsDataURL(file, this.onFileChangeCurr);
    },
    onFileChange: function onFileChange() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var imgName = files[0].name.split('.');
      var imgSize = Math.round(files[0].size / 1000);
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (imgSize > 512) {
        this.$notify({
          title: '提醒',
          text: '圖片檔案為' + imgSize + 'KB，請上傳小於512KB之圖片',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.createImage(files[0]);
      }
    },
    onFileChangeBtn: function onFileChangeBtn(index) {
      this.onFileChangeCurr = index;
    }
  }),
  watch: {
    'formTime.time': function formTimeTime(val) {
      this.announcement.announce_time = val;
    }
  }
});

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_elements_Modal_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'News',
  components: {
    'm-modal': __WEBPACK_IMPORTED_MODULE_0__components_elements_Modal_vue___default.a
  },
  data: function data() {
    return {
      total: 84,
      count: 10,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      announcementList: [],
      isDeleteStatus: false,
      delDesAlisOption: {
        id: 'delNewsModal',
        title: '確認刪除此公告',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'deleteBatchNews'
        }]
      },
      deleteId: null,
      isLoading: true
    };
  },

  filters: {
    roleType: function roleType(val) {
      switch (val) {
        case 0:
          return '不限';
        case 1:
          return 'Admin';
        case 2:
          return 'Brand';
        case 3:
          return 'Store';
      }
    }
  },
  computed: {
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  },
  created: function created() {
    this.getList();
  },

  methods: {
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.getList();
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    trigger: function trigger(event) {
      if (!event) {
        return;
      } else if (event === 'deleteBatchNews') {
        this.deleteNews('batch');
      } else {
        this.deleteNews('single');
      }
    },
    deleteAnnouncement: function deleteAnnouncement() {
      this.delDesAlisOption.btns[1].event = 'deleteBatchNews';
    },
    deleteNews: function deleteNews(type) {
      var _this = this;

      var deleteQuery = '';
      if (type === 'batch') {
        var deleteItems = this.announcementList.filter(function (x) {
          return x.selectItem;
        }).map(function (x) {
          return x.announcement_id;
        });
        deleteQuery = deleteItems.toString();
      } else {
        deleteQuery = this.deleteId;
      }
      var url = 'announcement?announcement_ids=' + deleteQuery;
      this.getDataH('delete', url, null, function (response) {
        _this.tableIndex = 1;
        _this.getList();
      });
    },
    deleteSingleAnnouncement: function deleteSingleAnnouncement(id) {
      this.deleteId = id;
      this.delDesAlisOption.btns[1].event = 'deleteSingleAnnouncement';
    },
    getList: function getList() {
      var _this2 = this;

      this.isLoading = true;
      var url = 'announcement/list?page=' + this.tableIndex + '&size=' + this.count;
      this.getDataH('get', url, null, function (response) {
        _this2.announcementList = response.data.announcement_list;
        _this2.total = response.data.total;
        _this2.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Temp_AdTableTemp_vue__ = __webpack_require__(2118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Temp_AdTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Temp_AdTableTemp_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      tableIndex: 1,
      show: {
        menu: false,
        menuDetail: false
      }
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#example1').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      });
    });
  },

  methods: {
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    }
  },
  components: {
    'ad-table': __WEBPACK_IMPORTED_MODULE_3__Temp_AdTableTemp_vue___default.a
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  }
});

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__elements_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Temp_ImgUploadTemp_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Temp_ImgUploadTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Temp_ImgUploadTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue2_timepicker__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_js_down_load_file__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Temp_ShippingForm__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Temp_ShippingForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__Temp_ShippingForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue2_datepicker__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Temp_DeliveryLimit_vue__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Temp_DeliveryLimit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__Temp_DeliveryLimit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue2_datepicker_index_css__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue2_datepicker_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue2_datepicker_index_css__);






















/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    'info': {
      type: Object
    }
  },
  data: function data() {
    return {
      statusTypeList: [{ label: '== 營業狀態 ==', value: 99 }, { label: '營業中', value: 2 }, { label: '籌備中', value: 1 }, { label: '尚未營業', value: 0 }, { label: '休息中', value: 3 }, { label: '已歇業', value: 9 }],
      form: {
        statusSelect: 99,
        orderStatusSelect: 99,
        isSearchSelect: 99
      },
      showCalendar: false,
      mealTagList: [],
      posBrief: [],
      storeName: '',
      storeDes: '',
      adRowNum: 2,
      groupList: [],
      areaTimes: 0,
      cityAreaList: [],
      areaOption: [],
      cityOption: [],
      imgLogoOption: [],
      imgBgOption: [],
      storeBrief: [],
      groupSelect: 0,
      imgLogoSelect: '',
      imgBgSelect: '',
      copyStoreSelect: null,
      copyBannerTypeList: null,
      areaSelect: 99,
      citySelect: 99,
      posSelect: null,
      posTypeSelect: 10,
      statusSelect: null,
      orderStatusSelect: null,
      isVisibleSelect: null,
      isStickerSelect: null,
      barcodeSelect: null,
      hasInvoicePaperSelect: null,
      hasInvoiceCarrierSelect: null,
      invoiceRemark: '',
      hasInvoiceNpobnaSelect: null,
      isInvoiceException: null,
      apiTypeSelect: null,
      showMenuIconSelect: null,
      plasticSelect: null,
      plasticAmountAdjustable: null,
      deliveryNeedSelect: null,
      isSearchSelect: null,
      roundingTypeSelect: null,
      couponFormSelect: null,
      showProdSettingSelect: null,
      isPosAccount: null,
      isCopy: null,
      img: {
        width: 0,
        height: 0
      },
      bgImg: {
        width: 0,
        height: 0
      },
      tradeInfo: [],
      tradeTypeOption: [{ label: '現金付款', value: 1 }, { label: 'LINE Pay', value: 4 }, { label: '信用卡付款(TAPPAY)', value: 6 }, { label: '街口', value: 7 }, { label: '全盈+PAY', value: 8 }, { label: '台灣Pay', value: 10 }, { label: 'icash Pay', value: 11 }, { label: '全支付', value: 12 }, { label: '遠傳電信代收', value: 13 }, { label: '悠遊付', value: 14 }],
      takeTimeInfo: [{ take_type: 1, prepare_time_seg: null, take_time_seg: null }, { take_type: 2, prepare_time_seg: null, take_time_seg: null }, { take_type: 3, prepare_time_seg: null, take_time_seg: null }, { take_type: 4, prepare_time_seg: null, take_time_seg: null }, { take_type: 5, prepare_time_seg: null, take_time_seg: null }, { take_type: 21, prepare_time_seg: null, take_time_seg: null }],
      openingInfo: [{ week_day: 1, start: null, end: null }, { week_day: 2, start: null, end: null }, { week_day: 3, start: null, end: null }, { week_day: 4, start: null, end: null }, { week_day: 5, start: null, end: null }, { week_day: 6, start: null, end: null }, { week_day: 7, start: null, end: null }],
      deliveryWaysInfo: [{ take_type: 1, is_enable: null, is_support: null, is_default: null }, { take_type: 2, is_enable: null, is_support: null, is_default: null }, { take_type: 3, is_enable: null, is_support: null, is_default: null }, { take_type: 4, is_enable: null, is_support: null, is_default: null }, { take_type: 5, is_enable: null, is_support: null, is_default: null }, { take_type: 21, is_enable: null, is_support: null, is_default: null }],
      deliveryOther: [],
      storeInfo: {
        brand_name: '',
        branch_code: '',
        pos_branch_code: '',
        name: '',
        name_short: '',
        description: '',
        comment: '',
        ein: '',
        bl_name: '',
        address_short: '',
        tel: '',
        tel2: '',
        email: '',
        one_order_max_money: null,
        to_store_pay_max_money: null,
        order_start_time_m: null,
        order_end_time_m: null,
        auto_reject_order_m: null,
        image_name: '',
        bg_image_name: '',
        area_code: '',
        city_code: '',
        search_description: '',
        order_start_day: null,
        order_tolerance_day: null,
        auto_reject_order_reserve_m: null,
        plastic_unit: null,
        is_off_allow_order: null,
        is_preparing_allow_order: null,
        is_close_allow_order: null,
        show_menu_product_icon: null,
        menu_layout_type: null,
        menu_expand_type: null,
        max_delivery_distance_m: '',
        order_status_reason: null,
        menu_stop_sale_today_type: null,
        menu_stop_sale_type: null,
        menu_ab_block_type: null,
        photo_name: '',
        introduction: '',
        youtube_video_code: '',
        binding_meal_tag_ids: [],
        delivery_stage_limit_type: null,
        is_support_custom_remark: null,
        store_list: [],

        store_shipping_vendor: [{
          vendor_code: 'mete-mix',
          is_enable: null
        }, {
          vendor_code: 'mete-pg',
          is_enable: null
        }, {
          vendor_code: 'mete-ud',
          is_enable: null
        }, {
          vendor_code: 'mete-lm',
          is_enable: null
        }, {
          vendor_code: 'mete-glo',
          is_enable: null
        }]
      },
      posAccount: {
        account: null,
        password: null
      },
      deliveryInfo: [{ label: '自取', value: 1 }, { label: '內用', value: 2 }, { label: '外送', value: 3 }, { label: '內用-桌邊掃碼', value: 21 }],
      menuLayout: [{ label: '文字，選項方塊 (飲料店用)', value: 1 }, { label: '圖文，商品描述為點擊後', value: 2 }, { label: '圖文，商品描述在下方', value: 3 }, { label: '圖文，商品描述在下方，外層大圖', value: 31 }, { label: '文字，選項條列式 (餐廳用)', value: 4 }],
      deliveryWayPlastic: null,
      offdaySetting: {
        date: [],
        weekDay: [],
        monthDay: [],
        options: {
          date: [{ label: '無指定', value: 0 }],
          weekDay: [{ label: '無指定', value: 0 }, { label: '週日', value: 1 }, { label: '週一', value: 2 }, { label: '週二', value: 3 }, { label: '週三', value: 4 }, { label: '週四', value: 5 }, { label: '週五', value: 6 }, { label: '週六', value: 7 }],
          month: [{ label: '無指定', value: 0 }, { label: '一月', value: 1 }, { label: '二月', value: 2 }, { label: '三月', value: 3 }, { label: '四月', value: 4 }, { label: '五月', value: 5 }, { label: '六月', value: 6 }, { label: '七月', value: 7 }, { label: '八月', value: 8 }, { label: '九月', value: 9 }, { label: '十月', value: 10 }, { label: '十一月', value: 11 }, { label: '十二月', value: 12 }],
          monthDay: [{ label: '無指定', value: 0 }]
        }
      },
      processTimeList: [],
      deliveryTypeOption: [{ label: '所有', value: 0 }, { label: '自取', value: 1 }, { label: '內用', value: 2 }, { label: '外送', value: 3 }, { label: '內用-桌邊掃碼', value: 21 }],
      storeMethod: 1,
      printerStoreList: [],
      printerInfo: {
        identity: '',
        type: 1
      },
      printerSelect: 1,
      isPrinterSelect: '',
      printerList: [],
      delOption: {
        id: 'delModal',
        title: '刪除店家綁定',
        body: '確定刪除?<br>刪除此店家綁定！',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delBinding'
        }]
      },
      updateOption: {
        id: 'updateModal',
        title: '提醒',
        body: '指定的設定值將立即覆蓋門市原設定，請再次確認是否執行。',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'updateBinding'
        }]
      },
      selectChange: '',
      resetShopping: false,
      editOption: {
        id: 'editModal',
        title: '編輯店家綁定',
        body: '編輯店家綁定！',
        input: {
          name: '綁定名稱'
        },
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'editBinding'
        }]
      },
      selectOptions: {
        name: '綁定啟用',
        options: [{ text: '啟用', value: 1 }, { text: '不啟用', value: 0 }]
      },
      current: {},
      change: {
        is_enabled: 1,
        binding_name: ''
      },
      tradeList: [],
      exceptionTradeList: [],
      exceptionCalendar: [],
      disModeSelect: null,
      reload: false,

      printerLayoutList: [],
      printerLayoutSetting: [],
      selectDate: {
        'currentDate': '',
        'selectedDate': false,
        'selectedDateTime': false,
        'selectedHour': '00',
        'selectedMinute': '00',
        'selectedDatesItem': '',
        'selectedDates': [],
        'dateRange': { 'start': '', 'end': '' },
        'multipleDateRange': []
      },
      remarkMaxlength: 100,
      specialDayRemarkMaxlength: 15,
      tableNumberUrl: {
        text: '',
        type: 1
      },
      enterType: [],
      hideDeliveryType: [4, 5],

      tableNumber: {
        default_login_type: null,
        is_cash_pay_after_meal: null,
        is_table_no_editable: null,
        is_table_no_required: null,
        show_table_no: null,
        sub_delivery_type: null,
        type: 21
      },
      removeComment: null,
      includeStoresSetting: {
        class: 'include-class-store',
        options: [],
        choose: []
      },
      reNew: 0,
      reSet: 0,

      brandInvalidQuota: 0,
      orderCommissionSetting: {
        has_independent_report: null,
        allow_invalid_order_quota: null,
        type: null,
        item_list: [] },
      showOverlapErrorIndex: [],
      commissionItemList: {
        delivery_type: 0,
        start_time: null,
        end_time: null,
        ratio: null,
        rounding_type: 3 },
      supportDeliveryOption: [{ label: '自取', value: 1 }, { label: '外送', value: 3 }],
      invalidStoreMap: null,
      showTablewareStrawOption: null,
      setTablewareStrawDefaultVal: null,
      showSpecialDayCalendar: false,
      selectSpecialDay: [],
      tempSpecialDayCalendar: {
        'currentDate': '',
        'selectedDate': false,
        'selectedDateTime': false,
        'selectedHour': '00',
        'selectedMinute': '00',
        'selectedDatesItem': '',
        'selectedDates': [],
        'dateRange': { 'start': '', 'end': '' },
        'multipleDateRange': []
      }
    };
  },

  methods: {
    getBrandInfo: function getBrandInfo() {
      var _this = this;

      var url = '/brand/' + this.$route.params.brand_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this.brandInvalidQuota = response.data.brand_info.order_commission_setting.allow_invalid_order_quota;
        }
      });
    },
    clearPage: function clearPage() {
      this.includeStoresSetting.option = null;
      this.includeStoresSetting.choose = null;
      if (this.storeMethod === 1) {
        this.removeComment = null;
        this.storeInfo.comment = null;
        this.storeInfo.binding_meal_tag_ids = null;
        this.storeInfo.image_name = null;
        this.storeInfo.photo_name = null;
        this.storeInfo.bg_image_name = null;
        this.storeInfo.introduction = null;
        this.storeInfo.youtube_video_code = null;
        this.storeInfo.food_business_no = null;
        this.storeInfo.meat_origin_description = null;
        this.storeInfo.description = null;
        this.storeInfo.search_description = null;
      } else if (this.storeMethod === 2) {
        this.apiTypeSelect = null;
        this.statusSelect = null;
        this.disModeSelect = null;
        this.barcodeSelect = null;
        this.roundingTypeSelect = null;
        this.couponFormSelect = null;
        this.showProdSettingSelect = null;
        this.hasInvoicePaperSelect = null;
        this.hasInvoiceCarrierSelect = null;
        this.invoiceRemark = '';
        this.hasInvoiceNpobnaSelect = null;
        this.isInvoiceException = null;
        this.isVisibleSelect = null;
        this.isSearchSelect = null;
        this.isStickerSelect = null;
        this.storeInfo.delivery_stage_limit_type = null;
        this.storeInfo.is_support_custom_remark = null;
        this.storeInfo.one_order_max_money = null;
        this.storeInfo.to_store_pay_max_money = null;
        this.storeInfo.menu_layout_type = null;
        this.showMenuIconSelect = null;
        this.storeInfo.show_menu_product_icon = null;
        this.storeInfo.menu_expand_type = null;
        this.storeInfo.menu_stop_sale_today_type = null;
        this.storeInfo.menu_stop_sale_type = null;
        this.storeInfo.menu_ab_block_type = null;
        this.storeInfo.custom_sticker_max_length = null;
      } else if (this.storeMethod === 3) {
        this.storeInfo.order_start_day = null;
        this.storeInfo.order_tolerance_day = null;
        this.storeInfo.auto_reject_order_reserve_m = null;
        this.orderStatusSelect = null;
        this.storeInfo.order_status_reason = null;
        this.storeInfo.auto_reject_order_m = null;
        this.storeInfo.is_preparing_allow_order = null;
        this.storeInfo.is_close_allow_order = null;
      } else if (this.storeMethod === 4) {
        this.tradeInfo = this.tradeInfo.map(function (x) {
          return {
            name: x.name,
            trade_type_id: x.trade_type_id,
            is_enable: null,
            is_support: null,
            remark: ''
          };
        });
        this.exceptionTradeList = [];
        this.tableNumber.is_cash_pay_after_meal = null;
      } else if (this.storeMethod === 5) {
        this.takeTimeInfo = this.takeTimeInfo.map(function (x) {
          return {
            take_type: x.take_type,
            prepare_time_seg: null,
            take_time_seg: null
          };
        });
        this.processTimeList = [];
      } else if (this.storeMethod === 6) {
        this.deliveryWaysInfo = [{ take_type: 1, is_enable: null, is_support: null, is_default: null }, { take_type: 2, is_enable: null, is_support: null, is_default: null }, { take_type: 3, is_enable: null, is_support: null, is_default: null }, { take_type: 4, is_enable: null, is_support: null, is_default: null }, { take_type: 5, is_enable: null, is_support: null, is_default: null }, { take_type: 21, is_enable: null, is_support: null, is_default: null }];
        this.deliveryOther = [];
        this.tableNumber = {
          default_login_type: null,
          is_cash_pay_after_meal: null,
          is_table_no_editable: null,
          is_table_no_required: null,
          show_table_no: null,
          sub_delivery_type: null,
          type: 21
        };
        this.exceptionCalendar = [];
        this.storeInfo.max_delivery_distance_m = null;
        this.resetShopping = !this.resetShopping;
      } else if (this.storeMethod === 7) {
        this.openingInfo = [{ week_day: 1, start: null, end: null }, { week_day: 2, start: null, end: null }, { week_day: 3, start: null, end: null }, { week_day: 4, start: null, end: null }, { week_day: 5, start: null, end: null }, { week_day: 6, start: null, end: null }, { week_day: 7, start: null, end: null }];
        this.storeInfo.is_off_allow_order = null;
        this.selectDate = null;
        this.selectSpecialDay = [];
        this.offdaySetting.date = null;
        this.offdaySetting.weekDay = null;
        this.offdaySetting.monthDay = null;
      } else if (this.storeMethod === 8) {
        this.storeInfo.plastic_unit = null;
        this.plasticSelect = null;
        this.deliveryWayPlastic = null;
        this.plasticAmountAdjustable = null;
      } else if (this.storeMethod === 12) {
        this.orderCommissionSetting = {
          has_independent_report: null,
          allow_invalid_order_quota: null,
          type: null,
          item_list: [] };
      } else if (this.storeMethod === 13) {
        this.storeInfo.store_shipping_vendor.forEach(function (item) {
          item.is_enable = null;
        });
      } else if (this.storeMethod === 15) {
        this.showTablewareStrawOption = null;
        this.setTablewareStrawDefaultVal = null;
      }
    },
    calendarSelected: function calendarSelected(val) {
      var selectedDate = __WEBPACK_IMPORTED_MODULE_10_moment___default()(val.date, 'DD/MM/YYYY');
      var minDate = __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.calendarLimits.min, 'DD/MM/YYYY');
      var maxDate = __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.calendarLimits.max, 'DD/MM/YYYY');

      if (selectedDate.isBefore(minDate) || selectedDate.isAfter(maxDate)) {
        return;
      }

      var formatDay = __WEBPACK_IMPORTED_MODULE_10_moment___default()(val.date, 'D/M/YYYY').format('YYYY-MM-DD');
      if (!val.isMarked) {
        var oDate = { label: formatDay, value: formatDay };
        this.offdaySetting.date.push(oDate);
      } else {
        var index = this.offdaySetting.date.findIndex(function (e) {
          return e.value === formatDay;
        });
        this.offdaySetting.date.splice(index, 1);
      }
    },
    specialDayCalendarSelected: function specialDayCalendarSelected(rowIndex, val) {
      var _this2 = this;

      var selectedDate = __WEBPACK_IMPORTED_MODULE_10_moment___default()(val.date, 'DD/MM/YYYY');
      var minDate = __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.calendarLimits.min, 'DD/MM/YYYY');
      var maxDate = __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.calendarLimits.max, 'DD/MM/YYYY');

      if (selectedDate.isBefore(minDate) || selectedDate.isAfter(maxDate)) {
        return;
      }

      var formatDay = __WEBPACK_IMPORTED_MODULE_10_moment___default()(val.date, 'DD/MM/YYYY').format('YYYY-MM-DD');
      if (!val.isMarked) {
        var oDate = { label: formatDay, value: formatDay };
        this.selectSpecialDay[rowIndex].calendar_list.push(oDate);
      } else {
        var index = this.selectSpecialDay[rowIndex].calendar_list.findIndex(function (e) {
          return e.value === formatDay;
        });
        if (index > -1) {
          this.selectSpecialDay[rowIndex].calendar_list.splice(index, 1);
        }
      }

      this.$nextTick(function () {
        var selectedDates = _this2.selectSpecialDay[rowIndex].calendar_list.map(function (item) {
          var date = __WEBPACK_IMPORTED_MODULE_10_moment___default()(item.value, 'YYYY-MM-DD').format('D/M/YYYY');
          return { date: date, dateTime: false, hour: '00', minute: '00' };
        });
        _this2.tempSpecialDayCalendar.selectedDates = selectedDates.slice();
      });
    },
    removeTag: function removeTag(type, rowIndex, val) {
      var formatday = __WEBPACK_IMPORTED_MODULE_10_moment___default()(val.value, 'YYYY-MM-DD').format('D/M/YYYY');

      if (type === 'date') {
        if (this.selectDate.selectedDates) {
          var index = this.selectDate.selectedDates.findIndex(function (e) {
            return e.date === formatday;
          });
          if (index > -1) {
            this.selectDate.selectedDates.splice(index, 1);
          }
        }
      } else if (type === 'specialDay') {
        var _index = this.selectSpecialDay[rowIndex].calendar_list.findIndex(function (e) {
          return e.value === val.value;
        });
        if (_index > -1) {
          this.selectSpecialDay[rowIndex].calendar_list.splice(_index, 1);
        }
      }
    },
    openSpecialDayCalendar: function openSpecialDayCalendar(rowIndex) {
      var selectedDates = this.selectSpecialDay[rowIndex].calendar_list.map(function (item) {
        return { date: __WEBPACK_IMPORTED_MODULE_10_moment___default()(item.value, 'YYYY-MM-DD').format('D/M/YYYY'), dateTime: false, hour: '00', minute: '00' };
      });
      this.tempSpecialDayCalendar.selectedDates = selectedDates.slice();
      this.selectSpecialDay[rowIndex].showSpecialDayCalendar = true;
      this.removeMultiselectWrapper();
    },
    openDateCalendar: function openDateCalendar() {
      this.showCalendar = true;
      this.removeMultiselectWrapper();
    },
    removeMultiselectWrapper: function removeMultiselectWrapper() {
      this.$nextTick(function () {
        var calendarMultiselects = document.querySelectorAll('.calendar-multiselect');
        calendarMultiselects.forEach(function (multiselect) {
          var wrappers = multiselect.querySelector('.multiselect__content-wrapper');
          wrappers.forEach(function (wrapper) {
            wrapper.remove();
          });
        });
      });
    },
    setReload: function setReload(tradeType) {
      if (tradeType.meta) tradeType.meta.delete_key = 1;
      if (tradeType.custom_config) tradeType.custom_config.delete_key = 1;
      this.reload = true;
    },
    removeListItem: function removeListItem(list, index) {
      list.splice(index, 1);
    },
    validateTimeRange: function validateTimeRange(item) {
      var startTimeKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'start_time';
      var endTimeKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'end_time';

      var startTime = item[startTimeKey];
      var endTime = item[endTimeKey];

      if (!startTime || !endTime) {
        return true;
      }

      var startTimeTrimmed = startTime.trim();
      var endTimeTrimmed = endTime.trim();

      var startMoment = __WEBPACK_IMPORTED_MODULE_10_moment___default()(startTimeTrimmed, 'HH:mm', true);
      var endMoment = __WEBPACK_IMPORTED_MODULE_10_moment___default()(endTimeTrimmed, 'HH:mm', true);

      if (startMoment.isSameOrAfter(endMoment)) {
        this.$notify({
          title: '提醒',
          text: '結束時間必須晚於開始時間',
          duration: 3000,
          type: 'danger',
          width: 400
        });
        item[endTimeKey] = '';
        return false;
      }
      return true;
    },
    clearProcess: function clearProcess(process) {
      process.end_value = '';
      process.start_value = '';
    },
    addItemTime: function addItemTime(process) {
      var item = {
        start_time: '',
        end_time: '',
        process_time: ''
      };
      process.item_list.push(item);
    },
    addProcessTime: function addProcessTime() {
      var process = {
        month: 0,
        value_type: 1,
        start_value: '',
        end_value: '',
        delivery_type: 1,
        item_list: [{
          start_time: '',
          end_time: '',
          process_time: ''
        }]
      };
      this.processTimeList.push(process);
    },
    addExCalendar: function addExCalendar() {
      var calendar = {
        delivery_type: 1,
        date_type: [],
        week_day: [],
        month_day: []
      };
      this.exceptionCalendar.push(calendar);
    },
    addExDate: function addExDate(exCalendar) {
      var date = {
        date: '',
        start_time: '',
        end_time: ''
      };
      exCalendar.date_type.push(date);
    },
    addExWeekDay: function addExWeekDay(exCalendar) {
      var weekDay = {
        day: 1,
        start_time: '',
        end_time: ''
      };
      exCalendar.week_day.push(weekDay);
    },
    addExMonthDay: function addExMonthDay(exCalendar) {
      var monthDay = {
        day: '',
        start_time: '',
        end_time: ''
      };
      exCalendar.month_day.push(monthDay);
    },
    addStartMonthDayTag: function addStartMonthDayTag(newTag, id) {
      var tag = {
        label: newTag,
        value: newTag
      };
      this.offdaySetting.options.monthDay.push(tag);
    },
    addEndMonthDayTag: function addEndMonthDayTag(newTag, id) {
      var tag = {
        label: newTag,
        value: newTag
      };
      this.offdaySetting.options.monthDay.push(tag);
    },
    addDateTag: function addDateTag(newTag) {
      var tag = {
        label: newTag,
        value: newTag
      };
      this.offdaySetting.options.date.push(tag);
    },
    addMonthDayTag: function addMonthDayTag(newTag) {
      var tag = {
        label: newTag,
        value: newTag
      };
      this.offdaySetting.options.monthDay.push(tag);
    },
    addSpecialDay: function addSpecialDay() {
      var calendar = {
        showSpecialDayCalendar: false,
        calendar_list: [],
        start_time: '',
        end_time: '',
        remark: ''
      };
      this.selectSpecialDay.push(calendar);
    },
    returnNum: function returnNum(e) {
      var charCode = e.which ? e.which : e.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        e.preventDefault();
      } else {
        return true;
      }
    },
    getMealTagList: function getMealTagList(callback) {
      var self = this;
      var url = '/mealTag/listBrief?is_visible=1';
      self.mealTagList = [];
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          response.data.list.forEach(function (tag) {
            var obj = {
              label: tag.name,
              value: tag.tag_id
            };
            self.mealTagList.push(obj);
          });
          callback();
        }
      });
    },
    init: function init() {
      var self = this;
      this.getMealTagList(function () {
        self.getTradeTypeList();
      });
      this.getCityAreaList();
      if (this.getRoleType === 99 || this.getRoleType === 30) this.getBrandImgList();else this.storeMethod = 3;
      this.getStoreBrief();
      this.getBrandInfo();
      this.getShippingVendorList();
    },
    addAdRow: function addAdRow() {
      this.adRowNum = this.adRowNum + 1;
    },
    delAdRow: function delAdRow() {
      this.adRowNum = this.adRowNum - 1;
    },
    getGroupList: function getGroupList() {
      var self = this;
      var url = '/brand/' + this.$route.params.brand_id + '/storeGroupListBrief';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.groupList = response.data.list;
          if (self.groupList.length) self.groupSelect = self.groupList[0].id;
        }
      });
    },
    getPrinterLayoutList: function getPrinterLayoutList() {
      var self = this;
      var url = '/platform/printerLayoutList';
      this.getData('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.printerLayoutList = response.data.list;
          self.printerLayoutList.forEach(function (layout) {
            var obj = {
              trigger_type: 1,
              layout_type: layout.layout_type,
              layout_name: layout.name,
              is_enabled: 1
            };
            if (layout.is_enabled) {
              self.printerLayoutSetting.push(obj);
            }
          });
        }
      });
    },
    getTradeTypeList: function getTradeTypeList() {
      var self = this;
      var url = '/platform/tradeTypeList';
      this.getData('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.tradeInfo = [];
          var list = response.data.list;
          for (var i = 0; i < list.length; i++) {
            if (list[i].is_valid) {
              var option = {
                name: list[i].name,
                trade_type_id: parseInt(list[i].id, 10),
                is_enable: null,
                is_support: null,
                remark: ''
              };
              if (i === 0) option.is_enable = null;
              if (list[i].meta !== null) {
                option.meta = {
                  use_key: 0,
                  key: {}
                };
                list[i].meta.keys.forEach(function (key) {
                  option.meta.key[key] = '';
                });
              }
              if (list[i].custom_config !== null) {
                option.custom_config = {
                  use_key: 0,
                  key: {}
                };
                list[i].custom_config.keys.forEach(function (key) {
                  option.custom_config.key[key] = '';
                });
              }
              self.tradeInfo.push(option);
              var option2 = {
                label: list[i].name,
                value: parseInt(list[i].type, 10)
              };
              self.tradeList.push(option2);
            }
          }
        }
        if (self.$route.name !== 'upStore') self.getPrinterLayoutList();
      });
    },
    getCityAreaList: function getCityAreaList() {
      var self = this;
      var url = '/platform/cityAreaList';
      this.getData('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.cityAreaList = response.data.list;
          for (var i = 0; i < self.cityAreaList.length; i++) {
            var option = { name: self.cityAreaList[i].name, value: self.cityAreaList[i].city_code };
            self.cityOption.push(option);
            if (i === 0) self.citySelect = self.cityAreaList[i].city_code;
          }
        }
      });
    },
    getShippingVendorList: function getShippingVendorList() {
      var _this3 = this;

      var url = '/platform/shippingVendorList?type=2&is_visable=1';
      this.getData('get', url, null, function (response) {
        if (response.data.status === 200) {
          var visibleList = response.data.list.map(function (item) {
            return item.vendor_code;
          });
          _this3.storeInfo.store_shipping_vendor = _this3.storeInfo.store_shipping_vendor.filter(function (item) {
            return visibleList.includes(item.vendor_code);
          });
        }
      });
    },
    checkDefault: function checkDefault(type) {
      this.deliveryWaysInfo.forEach(function (item) {
        if (item.take_type !== type) {
          item.is_default = 0;
        }
      });

      var selectedDelivery = this.deliveryWaysInfo.find(function (item) {
        return item.take_type === type;
      });
      if (selectedDelivery) {
        selectedDelivery.is_default = 1;
      }

      this.$forceUpdate();
    },
    checkOtherDelivery: function checkOtherDelivery() {
      for (var i = 0; i < this.deliveryOther.length; i++) {
        if (i === 0) {
          this.deliveryOther[i].price = this.deliveryWaysInfo[2].price;
        }
      }
    },
    checkDelivery: function checkDelivery() {
      for (var i = 0; i < this.deliveryOther.length; i++) {
        if (i === 0) {
          this.deliveryWaysInfo[2].price = this.deliveryOther[i].price;
        }
      }
    },
    getWeekDayName: function getWeekDayName(weekDay) {
      if (weekDay === 1) return '星期日';else if (weekDay === 2) return '星期一';else if (weekDay === 3) return '星期二';else if (weekDay === 4) return '星期三';else if (weekDay === 5) return '星期四';else if (weekDay === 6) return '星期五';else if (weekDay === 7) return '星期六';
    },
    onPhotoFileChange: function onPhotoFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var imgName = files[0].name.split('.');
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.createImage(files[0], 4);
      }
    },
    onFileChange: function onFileChange(e) {
      this.imgLogoSelect = '';
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var imgName = files[0].name.split('.');
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.createImage(files[0], 1);
      }
    },
    createImage: function createImage(file, method) {
      var reader = new FileReader();
      var self = this;
      reader.onload = function (e) {
        var img = new Image();
        img.src = e.target.result;
        if (method === 1) {
          self.storeInfo.image = img.src;
          self.storeInfo.image_name = img.src;
        } else if (method === 4) self.storeInfo.photo_name = img.src;
        img.onload = function () {
          self.img.width = img.width;
          self.img.height = img.height;
          self.checkImgSize(null, method);
        };
      };
      reader.readAsDataURL(file);
    },
    checkImgSize: function checkImgSize(type, method) {
      var self = this;
      if ((this.img.width !== 200 || this.img.height !== 200) && this.img.width !== 0 && this.img.height !== 0 && method === 1) {
        this.$notify({
          title: '提醒',
          text: 'LOGO尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳200x200之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if ((this.img.width !== 800 || this.img.height !== 460) && this.img.width !== 0 && this.img.height !== 0 && method === 3) {
        this.$notify({
          title: '提醒',
          text: '底圖照片寸為' + self.img.width + 'x' + self.img.height + '，請上傳800x460之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (type === 'cr') {} else if (type === 'up') {}
    },
    onBgChange: function onBgChange(e) {
      this.imgBgSelect = '';
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var imgName = files[0].name.split('.');
      var imgSize = Math.round(files[0].size / 1000);
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (imgSize > 1024) {
        this.$notify({
          title: '提醒',
          text: '圖片檔案為' + imgSize + 'KB，請上傳小於1024KB之圖片',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {}
    },
    createBgImage: function createBgImage(file) {
      var reader = new FileReader();
      var self = this;
      reader.onload = function (e) {
        var img = new Image();
        img.src = e.target.result;
        if (self.storeInfo.bg_image) self.storeInfo.bg_image = img.src;
        self.storeInfo.bg_image_name = img.src;
        img.onload = function () {
          self.bgImg.width = img.width;
          self.bgImg.height = img.height;
          self.checkBgImgSize();
        };
      };
      reader.readAsDataURL(file);
    },
    checkBgImgSize: function checkBgImgSize(type) {
      var self = this;
      if ((this.bgImg.width !== 625 || this.bgImg.height !== 300) && this.bgImg.width !== 0 && this.bgImg.height !== 0) {
        this.$notify({
          title: '提醒',
          text: '圖片尺寸為' + self.bgImg.width + 'x' + self.bgImg.height + '，請上傳625x300之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (type === 'cr') {} else if (type === 'up') {}
    },
    getPosBrief: function getPosBrief() {
      this.posBrief = [];
      var self = this;
      var url = '/pos/vendorBriefList';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var pList = response.data.list;
          for (var i = 0; i < pList.length; i++) {
            var obj = { label: pList[i].name, value: pList[i].pos_vendor_id };
            self.posBrief.push(obj);
            if (i === pList.length - 1) {
              self.posSelect = pList[i].pos_vendor_id;
            }
          }
        }
      });
    },
    getStoreBrief: function getStoreBrief() {
      var _this4 = this;

      this.includeStoresSetting.options = [];
      this.includeStoresSetting.choose = [];
      this.storeBrief = [];
      var self = this;

      var url = '/brand/' + this.$route.params.brand_id + '/storeListBrief?list_sort=name ASC';
      if (this.form.statusSelect !== 99) {
        url += '&status=' + this.form.statusSelect.toString();
      }
      if (this.form.orderStatusSelect !== 99) {
        url += '&order_status=' + this.form.orderStatusSelect.toString();
      }
      if (this.form.isSearchSelect !== 99) {
        url += '&is_search=' + this.form.isSearchSelect.toString();
      }
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          if (self.getRoleType === 99 && self.info) self.getPrinterStoreList();
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.includeStoresSetting.options.push(obj);
            if (i === 0) self.copyStoreSelect = sList[i].store_id;
          }
        }
        _this4.reNew++;
      });
    },
    verityTel: function verityTel() {
      var e = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this.$refs.tel);
      this.storeInfo.tel = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9-#()\s]*/));
      }
    },
    verityTel2: function verityTel2() {
      var e = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this.$refs.tel2);
      this.storeInfo.tel2 = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9-#()\s]*/));
      }
    },
    verityEin: function verityEin() {
      var e = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this.$refs.ein);
      this.storeInfo.ein = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityOneOrderMaxMoney: function verityOneOrderMaxMoney() {
      var e = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this.$refs.oneOrderMaxMoney);
      this.storeInfo.one_order_max_money = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityStorePayMaxMoney: function verityStorePayMaxMoney() {
      var e = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this.$refs.storePayMaxMoney);
      this.storeInfo.to_store_pay_max_money = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityRejectTime: function verityRejectTime() {
      var e = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this.$refs.rejectTime);
      this.storeInfo.auto_reject_order_m = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityStartTime: function verityStartTime() {
      var e = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this.$refs.startTime);
      this.storeInfo.order_start_time_m = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityEndTime: function verityEndTime() {
      var e = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this.$refs.endTime);
      this.storeInfo.order_end_time_m = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    getToast: function getToast(msg, type) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        if (type === 'cr') this.createdStore();else if (type === 'up' && this.storeMethod === 1 && this.getRoleType !== 10) this.updatedLogoImg();else if (type === 'up') this.updatedStore();
      }
    },
    getBrandImgList: function getBrandImgList() {
      var self = this;
      var url = '/brand/' + this.$route.params.brand_id + '/storesImage?image_type=1';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var logoList = response.data.list;
          for (var i = 0; i < logoList.length; i++) {
            var option = { name: logoList[i].image_name, value: logoList[i].image_url };
            self.imgLogoOption.push(option);
          }
        }
      });
      var url2 = '/brand/' + this.$route.params.brand_id + '/storesImage?image_type=3';
      this.getDataH('get', url2, null, function (response) {
        if (response.data.status === 200) {
          var bgList = response.data.list;
          for (var j = 0; j < bgList.length; j++) {
            var option2 = { name: bgList[j].image_name, value: bgList[j].image_url };
            self.imgBgOption.push(option2);
          }
        }
      });
    },
    dateRangeOverlaps: function dateRangeOverlaps(startA, endA, startB, endB) {
      if (startA === endA && startB === endB) {
        return startA === startB;
      } else if (startA === endA && startB !== endB) {
        return startA >= startB && startA <= endB;
      } else if (startA !== endA && startB === endB) {
        return startB >= startA && startB <= endA;
      } else {
        return startA <= endB && startB < endA;
      }
    },
    updatedLogoImg: function updatedLogoImg() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, imgPath, imgName, imgPath2, imgName2;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = new FormData();

                if (!_this5.imgLogoSelect) {
                  _context.next = 7;
                  break;
                }

                data.append('image_name', _this5.imgLogoSelect);
                _context.next = 5;
                return _this5.upImg(data, 1);

              case 5:
                _context.next = 14;
                break;

              case 7:
                if (!__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#brand-img-load')[0].files[0]) {
                  _context.next = 14;
                  break;
                }

                data.append('image_file', __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#brand-img-load')[0].files[0]);
                imgPath = __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#brand-img-load')[0].files[0];
                imgName = imgPath.name.replace(/\.(jpg|gif|png)$/, '');

                data.append('image_name', imgName);
                _context.next = 14;
                return _this5.upImg(data, 1);

              case 14:
                if (!(_this5.getRoleType !== 10)) {
                  _context.next = 22;
                  break;
                }

                if (!__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#brand-photo-load')[0].files[0]) {
                  _context.next = 22;
                  break;
                }

                data.append('image_file', __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#brand-photo-load')[0].files[0]);
                imgPath2 = __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#brand-photo-load')[0].files[0];
                imgName2 = imgPath2.name.replace(/\.(jpg|gif|png)$/, '');

                data.append('image_name', imgName2);
                _context.next = 22;
                return _this5.upImg(data, 4);

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    },
    checkCommission: function checkCommission() {
      var itemList = this.orderCommissionSetting.item_list;
      if (this.orderCommissionSetting.allow_invalid_order_quota === '') {
        return '請輸入每月作廢訂單額度(筆)';
      } else if (this.orderCommissionSetting.type > 1) {
        if (!itemList.length) {
          return '請增加資訊服務費抽成設定';
        } else {
          this.showOverlapErrorIndex = [];
          for (var i = 0; i < itemList.length; i++) {
            var startTime = itemList[i].start_time;
            var endTime = itemList[i].end_time;
            if (itemList[i].ratio === '') {
              this.showOverlapErrorIndex = [i];
              return '請輸入資訊服務費抽成%';
            } else if (!startTime || !endTime) {
              this.showOverlapErrorIndex = [i];
              return '\u8ACB\u8F38\u5165\u62BD\u6210' + (!startTime ? '生效' : '結束') + '\u6642\u9593';
            } else if (__WEBPACK_IMPORTED_MODULE_10_moment___default()(endTime).isBefore(startTime)) {
              this.showOverlapErrorIndex = [i];
              return '結束時間小於開始時間，請重新選擇!';
            } else if (i > 0) {
              for (var j = i - 1; j >= 0; j--) {
                if (itemList[i].delivery_type === 0 || itemList[j].delivery_type === 0 || itemList[i].delivery_type === itemList[j].delivery_type) {
                  var lastStartTime = itemList[j].start_time;
                  var lastEndTime = itemList[j].end_time;
                  if (this.dateRangeOverlaps(startTime, endTime, lastStartTime, lastEndTime)) {
                    this.showOverlapErrorIndex.push(j);
                    this.showOverlapErrorIndex.push(i);
                  }
                }
              }
            }
          }
          if (this.showOverlapErrorIndex.length) {
            return '\u6642\u9593\u91CD\u8986\u8A2D\u5B9A\uFF0C\u8ACB\u78BA\u8A8D!';
          }
        }
      }
      return false;
    },
    upImg: function upImg(data, type) {
      var self = this;
      data.append('image_type', type);
      if (this.includeStoresSetting.choose.length) {
        data.append('store_list', this.includeStoresSetting.choose.toString());
      }
      var url = '/brand/' + this.$route.params.brand_id + '/storesImage';
      if (data) {
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            });
          }
        });
      }
    },
    updatedBgImg: function updatedBgImg() {
      var self = this;
      var data = new FormData();

      if (self.imgBgSelect) {
        data.append('image_name', self.imgBgSelect);
        self.upImg(data, 3);
      } else if (__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#bg-img-load')[0].files[0]) {
        data.append('image_file', __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#bg-img-load')[0].files[0]);
        var bgPath = __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#bg-img-load')[0].files[0];
        var bgName = bgPath.name.replace(/\.(jpg|gif|png)$/, '');
        data.append('bg_image_name', bgName);
        self.upImg(data, 3);
      } else if (self.getRoleType === 99) self.updatedStore();
    },
    updatedStore: function updatedStore() {
      var _this6 = this;

      var isChecked = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var self, sInfo, oneOrderMaxMoney, toStorePayMaxMoney, orderStartTimeM, orderEndTimeM, autoRejectOrderM, orderStartDay, orderToleranceDay, autoRejectOrderReserveM, method, data, comment, ids, tradeInfo, l, option4, customConfig, newETradeList, newTimeList, takeTimeInfo, k, option3, deliveryWays, memoList, shippingComponent, overLimit, shippingSetSuccess, _k, option, memoItem, j, option2, _customConfig, newECalendarList, openingTimes, i, obj, openTime, specialTimes, offday, dWayPlastic, query, arr, sendData, url;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this6.storeMethod === 1 && (_this6.getRoleType === 99 || _this6.getRoleType === 30))) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return _this6.updatedLogoImg();

              case 3:
                if (!(_this6.storeMethod === 9)) {
                  _context2.next = 6;
                  break;
                }

                _this6.$refs.shipping.checkShipping();
                return _context2.abrupt('return');

              case 6:
                self = _this6;
                sInfo = _this6.storeInfo;
                oneOrderMaxMoney = sInfo.one_order_max_money ? parseInt(sInfo.one_order_max_money, 10) : null;
                toStorePayMaxMoney = sInfo.to_store_pay_max_money ? parseInt(sInfo.to_store_pay_max_money, 10) : null;
                orderStartTimeM = sInfo.order_start_time_m ? parseInt(sInfo.order_start_time_m, 10) : null;
                orderEndTimeM = sInfo.order_end_time_m ? parseInt(sInfo.order_end_time_m, 10) : null;
                autoRejectOrderM = sInfo.auto_reject_order_m ? parseInt(sInfo.auto_reject_order_m, 10) : null;
                orderStartDay = sInfo.order_start_day ? parseInt(sInfo.order_start_day, 10) : null;
                orderToleranceDay = sInfo.order_tolerance_day ? parseInt(sInfo.order_tolerance_day, 10) : null;
                autoRejectOrderReserveM = sInfo.auto_reject_order_reserve_m ? parseInt(sInfo.auto_reject_order_reserve_m, 10) : null;
                method = _this6.storeMethod;
                data = {};

                if (!(method === 1)) {
                  _context2.next = 31;
                  break;
                }

                data = {};
                comment = sInfo.comment;

                if (sInfo.comment) data.comment = comment;
                ids = sInfo.binding_meal_tag_ids.map(function (item) {
                  return item.value;
                });

                if (ids.length) data.binding_meal_tag_ids = ids;
                if (sInfo.youtube_video_code) data.youtube_video_code = sInfo.youtube_video_code;

                if (sInfo.meat_origin_description) data.meat_origin_description = sInfo.meat_origin_description;

                data.description = sInfo.description;
                data.search_description = sInfo.search_description;
                data.introduction = sInfo.introduction;
                _context2.next = 150;
                break;

              case 31:
                if (!(method === 2)) {
                  _context2.next = 35;
                  break;
                }

                data = {
                  api_type: _this6.apiTypeSelect,
                  status: _this6.statusSelect,
                  is_visible: _this6.isVisibleSelect,
                  barcode_type: _this6.barcodeSelect,
                  one_order_max_money: oneOrderMaxMoney,
                  to_store_pay_max_money: toStorePayMaxMoney,
                  has_invoice_paper: _this6.hasInvoicePaperSelect,
                  has_invoice_carrier: _this6.hasInvoiceCarrierSelect,
                  invoice_remark: _this6.invoiceRemark,
                  has_invoice_npoban: _this6.hasInvoiceNpobnaSelect,
                  is_invoice_exception: _this6.isInvoiceException,
                  show_menu_icon: _this6.showMenuIconSelect,
                  show_menu_product_icon: sInfo.show_menu_product_icon,
                  menu_layout_type: sInfo.menu_layout_type,
                  rounding_type: self.roundingTypeSelect,
                  coupon_form: self.couponFormSelect,
                  menu_expand_type: sInfo.menu_expand_type,
                  is_search: self.isSearchSelect,
                  menu_ab_block_type: sInfo.menu_ab_block_type,
                  menu_stop_sale_type: sInfo.menu_stop_sale_type,

                  menu_stop_sale_today_type: sInfo.menu_stop_sale_today_type,

                  distance_service_model: self.disModeSelect,
                  is_support_custom_sticker: self.isStickerSelect,

                  delivery_stage_limit_type: sInfo.delivery_stage_limit_type,

                  show_product_setting: self.showProdSettingSelect,
                  is_support_custom_remark: sInfo.is_support_custom_remark,
                  custom_sticker_max_length: sInfo.custom_sticker_max_length
                };
                _context2.next = 150;
                break;

              case 35:
                if (!(method === 3)) {
                  _context2.next = 39;
                  break;
                }

                data = {
                  order_status: _this6.orderStatusSelect,
                  order_start_time_m: orderStartTimeM,
                  order_end_time_m: orderEndTimeM,
                  auto_reject_order_m: autoRejectOrderM,
                  order_start_day: orderStartDay,
                  order_tolerance_day: orderToleranceDay,
                  auto_reject_order_reserve_m: autoRejectOrderReserveM,
                  is_preparing_allow_order: sInfo.is_preparing_allow_order,
                  is_close_allow_order: sInfo.is_close_allow_order,
                  order_status_reason: sInfo.order_status_reason
                };
                _context2.next = 150;
                break;

              case 39:
                if (!(method === 4)) {
                  _context2.next = 49;
                  break;
                }

                tradeInfo = [];

                for (l = 0; l < _this6.tradeInfo.length; l++) {
                  option4 = {
                    trade_type_id: _this6.tradeInfo[l].trade_type_id || null,
                    is_enable: _this6.tradeInfo[l].is_enable || null,
                    is_support: _this6.tradeInfo[l].is_support || null,
                    remark: _this6.tradeInfo[l].remark || null
                  };

                  option4 = _this6.setData(option4);
                  if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(option4).length > 1) {
                    tradeInfo.push(option4);
                  }
                }
                if (tradeInfo.length > 0) {
                  data.trade_types = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(tradeInfo);
                }

                if (_this6.tableNumber.is_cash_pay_after_meal !== null) {
                  customConfig = data.delivery_way_custom_config || [];

                  customConfig.push({
                    type: 21,
                    config: {
                      is_cash_pay_after_meal: _this6.tableNumber.is_cash_pay_after_meal
                    }
                  });
                  data.delivery_way_custom_config = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(customConfig);
                }
                newETradeList = [];

                _this6.exceptionTradeList.forEach(function (eTrade) {
                  var obj = eTrade;
                  if (!obj.start_money) obj.start_money = null;
                  if (!obj.end_money) obj.end_money = null;
                  newETradeList.push(obj);
                });
                if (newETradeList.length) {
                  data.delivery_exception_trade_setting = newETradeList;
                }
                _context2.next = 150;
                break;

              case 49:
                if (!(method === 5)) {
                  _context2.next = 72;
                  break;
                }

                newTimeList = [];

                _this6.processTimeList.forEach(function (item) {
                  var process = {
                    month: item.month.value,
                    value_type: item.value_type,
                    start_value: item.start_value.value,
                    end_value: item.end_value.value,
                    delivery_type: item.delivery_type.value,
                    item_list: item.item_list
                  };
                  newTimeList.push(process);
                });
                if (newTimeList.length) data['process_time_setting'] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(newTimeList);
                takeTimeInfo = [];
                k = 0;

              case 55:
                if (!(k < _this6.takeTimeInfo.length)) {
                  _context2.next = 69;
                  break;
                }

                if (_this6.takeTimeInfo[k].prepare_time_seg === '') {
                  _this6.takeTimeInfo[k].prepare_time_seg = null;
                }
                if (_this6.takeTimeInfo[k].take_time_seg === '') {
                  _this6.takeTimeInfo[k].take_time_seg = null;
                }

                if (!(_this6.takeTimeInfo[k].prepare_time_seg !== null || _this6.takeTimeInfo[k].take_time_seg !== null)) {
                  _context2.next = 66;
                  break;
                }

                if (!(_this6.takeTimeInfo[k].prepare_time_seg < 3)) {
                  _context2.next = 62;
                  break;
                }

                _this6.$notify({
                  title: '提醒',
                  text: '準備時間不可低於 3 分鐘',
                  duration: 3000,
                  type: 'danger',
                  width: 400
                });
                return _context2.abrupt('return', false);

              case 62:
                option3 = {
                  take_type: parseInt(_this6.takeTimeInfo[k].take_type, 10)
                };

                if (_this6.takeTimeInfo[k].prepare_time_seg !== null) {
                  option3.prepare_time_seg = parseInt(_this6.takeTimeInfo[k].prepare_time_seg, 10);
                }
                if (_this6.takeTimeInfo[k].take_time_seg !== null) {
                  option3.take_time_seg = parseInt(_this6.takeTimeInfo[k].take_time_seg, 10);
                }
                takeTimeInfo.push(option3);

              case 66:
                k++;
                _context2.next = 55;
                break;

              case 69:
                if (takeTimeInfo.length) {
                  data.take_time_seg = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(takeTimeInfo);
                }
                _context2.next = 150;
                break;

              case 72:
                if (!(method === 6)) {
                  _context2.next = 116;
                  break;
                }

                deliveryWays = [];
                memoList = [];
                shippingComponent = _this6.$refs.shippingInfo;

                if (!shippingComponent) {
                  _context2.next = 87;
                  break;
                }

                if (!(shippingComponent.feeTypeSelect !== 1 && sInfo.max_delivery_distance_m)) {
                  _context2.next = 82;
                  break;
                }

                overLimit = shippingComponent.itemList.some(function (item) {
                  return item.distance > sInfo.max_delivery_distance_m;
                });

                if (!overLimit) {
                  _context2.next = 82;
                  break;
                }

                _this6.$notify({
                  title: '提醒',
                  text: '運送距離不可超過最遠可外送距離！',
                  duration: 3000,
                  type: 'danger',
                  width: 400
                });
                return _context2.abrupt('return');

              case 82:
                shippingSetSuccess = false;
                _context2.next = 85;
                return shippingComponent.upShippingFee().then(function (res) {
                  shippingSetSuccess = true;
                }).catch(function (res) {
                  shippingSetSuccess = false;
                });

              case 85:
                if (shippingSetSuccess) {
                  _context2.next = 87;
                  break;
                }

                return _context2.abrupt('return');

              case 87:

                for (_k = 0; _k < _this6.deliveryWaysInfo.length; _k++) {
                  if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(_this6.deliveryWaysInfo[_k]).filter(function (x) {
                    return x !== null;
                  }).length > 1) {
                    option = {
                      distance_m: _this6.deliveryWaysInfo[_k].distance_m,
                      is_allow_guest_order: _this6.deliveryWaysInfo[_k].is_allow_guest_order,
                      is_default: _this6.deliveryWaysInfo[_k].is_default,
                      is_enable: _this6.deliveryWaysInfo[_k].is_enable,
                      is_support: _this6.deliveryWaysInfo[_k].is_support,
                      option: 1,
                      price: _this6.deliveryWaysInfo[_k].price || null,
                      take_type: _this6.deliveryWaysInfo[_k].take_type
                    };

                    if (option.distance_m || option.is_allow_guest_order || option.is_default || option.is_enable !== null || option.is_support !== null || option.price) {
                      deliveryWays.push(option);
                    }
                    if (option.price) {
                      option.distance_m = 0;
                    }

                    memoItem = { take_type: _this6.deliveryWaysInfo[_k].take_type };

                    if (_this6.deliveryWaysInfo[_k].memo) memoItem.memo = _this6.deliveryWaysInfo[_k].memo;
                    if (_this6.deliveryWaysInfo[_k].pickup_memo) memoItem.pickup_memo = _this6.deliveryWaysInfo[_k].pickup_memo;
                    memoList.push(memoItem);
                  }
                }
                if (memoList.length) {
                  data.delivery_way_memo = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(memoList);
                }
                j = 0;

              case 90:
                if (!(j < _this6.deliveryOther.length)) {
                  _context2.next = 99;
                  break;
                }

                option2 = {
                  take_type: _this6.deliveryOther[j].take_type,
                  is_support: _this6.deliveryOther[j].is_support,
                  is_enable: _this6.deliveryOther[j].is_enable,
                  distance_m: _this6.deliveryOther[j].distance_m || null,
                  price: _this6.deliveryOther[j].price || null,
                  option: 2,
                  is_allow_guest_order: _this6.deliveryOther[j].is_allow_guest_order
                };

                if (!(!_this6.deliveryOther[j].distance_m || !_this6.deliveryOther[j].price)) {
                  _context2.next = 95;
                  break;
                }

                _this6.$notify({
                  title: '提醒',
                  text: '請輸入完整的外送條件',
                  duration: 3000,
                  type: 'danger',
                  width: 400
                });
                return _context2.abrupt('return', false);

              case 95:
                if (_this6.deliveryOther[j].distance_m && (_this6.deliveryOther[j].price || j === 0)) {
                  deliveryWays.push(option2);
                }

              case 96:
                j++;
                _context2.next = 90;
                break;

              case 99:
                if (!(deliveryWays.filter(function (x) {
                  return x.take_type === 3 && x.option === 2;
                }).length > 0 && deliveryWays.filter(function (x) {
                  return x.take_type === 3 && x.option === 1;
                }).length < 1)) {
                  _context2.next = 102;
                  break;
                }

                _this6.$notify({
                  title: '提醒',
                  text: '請輸入正確的最低門檻',
                  duration: 3000,
                  type: 'danger',
                  width: 400
                });
                return _context2.abrupt('return', false);

              case 102:
                if (!(deliveryWays.filter(function (x) {
                  return x.take_type === 3 && x.option === 1 && x.price;
                }).length > 0 && !sInfo.max_delivery_distance_m)) {
                  _context2.next = 105;
                  break;
                }

                _this6.$notify({
                  title: '提醒',
                  text: '請輸入正確的最遠可送',
                  duration: 3000,
                  type: 'danger',
                  width: 400
                });
                return _context2.abrupt('return', false);

              case 105:
                if (deliveryWays.length > 0) {
                  data.delivery_ways = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(deliveryWays);
                }

                if (sInfo.max_delivery_distance_m) data.max_delivery_distance_m = sInfo.max_delivery_distance_m;else data.max_delivery_distance_m = null;
                _customConfig = data.delivery_way_custom_config || [];

                _customConfig.push({
                  type: 21,
                  config: {
                    default_login_type: _this6.tableNumber.default_login_type,
                    is_table_no_editable: _this6.tableNumber.is_table_no_editable,
                    is_table_no_required: _this6.tableNumber.is_table_no_required,
                    show_table_no: _this6.tableNumber.show_table_no,
                    sub_delivery_type: _this6.tableNumber.sub_delivery_type
                  }
                });
                _customConfig[0].config = _this6.setData(_customConfig[0].config);
                if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(_customConfig[0].config).length > 0) {
                  data.delivery_way_custom_config = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_customConfig);
                }
                newECalendarList = {};

                _this6.exceptionCalendar.forEach(function (eCalendar) {
                  var obj = {
                    date_type: eCalendar.date_type,
                    week_day: eCalendar.week_day,
                    month_day: eCalendar.month_day
                  };
                  if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(obj).length) {
                    newECalendarList[eCalendar.delivery_type] = obj;
                  }
                });
                if (_this6.exceptionCalendar.length) {
                  data.delivery_exception_calendar_setting = newECalendarList;
                }
                _context2.next = 150;
                break;

              case 116:
                if (!(method === 7)) {
                  _context2.next = 129;
                  break;
                }

                data = {
                  is_off_allow_order: sInfo.is_off_allow_order
                };
                openingTimes = [];

                for (i = 0; i < _this6.openingInfo.length; i++) {
                  obj = _this6.openingInfo[i];

                  if (obj.start || obj.end) {
                    openTime = {
                      week_day: obj.week_day,
                      start_time: obj.start + ':00',
                      end_time: obj.end + ':59'
                    };

                    openingTimes.push(openTime);
                  }
                }
                if (openingTimes.length) {
                  data.opening_times = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(openingTimes);
                }

                if (_this6.selectSpecialDay.length > 0) {
                  specialTimes = [];

                  _this6.selectSpecialDay.forEach(function (item) {
                    var obj = {
                      calendar_list: item.calendar_list.map(function (date) {
                        return { usage_type: 1, usage_date: date.value };
                      }),
                      start_time: item.start_time + ':00',
                      end_time: item.end_time + ':59',
                      remark: item.remark
                    };
                    specialTimes.push(obj);
                  });
                  data.order_time_setting = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(specialTimes);
                } else {
                  data.order_time_setting = '';
                }
                offday = {};

                if (_this6.offdaySetting.date.length) {
                  offday['date'] = _this6.offdaySetting.date.map(function (x) {
                    return x.value;
                  });
                }
                if (_this6.offdaySetting.weekDay.length) {
                  offday['week_day'] = _this6.offdaySetting.weekDay.map(function (x) {
                    return x.value;
                  });
                }
                if (_this6.offdaySetting.monthDay.length) {
                  offday['month_day'] = _this6.offdaySetting.monthDay.map(function (x) {
                    return x.value;
                  });
                }
                if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(offday).length) {
                  data['offday_setting'] = offday;
                }
                _context2.next = 150;
                break;

              case 129:
                if (!(method === 8)) {
                  _context2.next = 135;
                  break;
                }

                data = {
                  plastic_unit: _this6.storeInfo.plastic_unit ? parseInt(_this6.storeInfo.plastic_unit, 10) : null,
                  plastic_option: _this6.plasticSelect,
                  delivery_need_plastic: _this6.deliveryNeedSelect,
                  is_plastic_amount_adjustable: _this6.plasticAmountAdjustable
                };

                dWayPlastic = [];

                if (_this6.deliveryWayPlastic) {
                  _this6.deliveryWayPlastic.forEach(function (delivery) {
                    if (delivery.value) {
                      dWayPlastic.push(delivery.value);
                    }
                  });
                  data['delivery_way_plastic_selected'] = dWayPlastic;
                }
                _context2.next = 150;
                break;

              case 135:
                if (!(method === 10)) {
                  _context2.next = 141;
                  break;
                }

                data = {
                  printer_layout_setting: []
                };
                _this6.printerLayoutSetting.forEach(function (layoutSetting) {
                  var obj = {
                    layout_type: layoutSetting.layout_type,
                    trigger_type: layoutSetting.trigger_type,
                    is_enabled: layoutSetting.is_enabled
                  };
                  data.printer_layout_setting.push(obj);
                });
                data.printer_layout_setting = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(data.printer_layout_setting);
                _context2.next = 150;
                break;

              case 141:
                if (!(method === 12)) {
                  _context2.next = 149;
                  break;
                }

                if (!_this6.checkCommission()) {
                  _context2.next = 145;
                  break;
                }

                _this6.$notify({
                  title: '提醒',
                  text: _this6.checkCommission(),
                  duration: 3000,
                  type: 'danger',
                  width: 400
                });
                return _context2.abrupt('return', false);

              case 145:
                query = _this6.setCommissionQuery();

                data['order_commission_setting'] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(query);
                _context2.next = 150;
                break;

              case 149:
                if (method === 13) {
                  arr = _this6.storeInfo.store_shipping_vendor.filter(function (item) {
                    return item.is_enable !== null;
                  });

                  if (arr.length) {
                    data['store_shipping_vendor'] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(arr);
                  }
                } else if (method === 15) {
                  data = {
                    store_special_item_setting: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()([{
                      type: 1,
                      sub_type: 1,
                      is_show: _this6.showTablewareStrawOption,
                      default_value: _this6.setTablewareStrawDefaultVal
                    }])
                  };
                }

              case 150:
                sendData = _this6.setData(data);

                data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, sendData, {
                  store_list: _this6.includeStoresSetting.choose.toString()
                });
                if (_this6.removeComment) data.comment = '';
                if (isChecked) {
                  data.is_checked = 1;
                }
                url = '/brand/' + _this6.$route.params.brand_id + '/syncStore/create';

                _this6.getDataH('POST', url, data, function (response) {
                  if (response.data.status === 200) {
                    self.$notify({
                      title: response.data.message,
                      text: response.data.description,
                      duration: 3000,
                      type: 'success',
                      width: 400
                    });
                  }
                }, function (error) {
                  if (error.response && error.response.data && error.response.data.invalid_params_store_map) {
                    _this6.invalidStoreMap = error.response.data.invalid_params_store_map;
                    var button = document.getElementById('reCheckButton');
                    if (button) {
                      button.click();
                    }
                  } else {
                    return null;
                  }
                });

              case 156:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },
    setData: function setData(data) {
      var sendData = {};
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
        if (data[key] !== null) {
          sendData[key] = data[key];
        }
      });
      return sendData;
    },
    intranceName: function intranceName(type) {
      switch (type) {
        case 1:
          return '你訂平台';
        case 2:
          return '專屬網址';
        case 3:
          return 'LINE';
      }
    },
    goToStoreTable: function goToStoreTable() {
      this.$router.push('/storeTable/' + this.$route.params.brand_id);
    },
    getPrinterStoreList: function getPrinterStoreList() {
      var self = this;
      var url = '/printer/storePrinterList/' + this.$route.params.store_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.printerStoreList = response.data.list;
          self.getPrinterList();
        }
      });
    },
    getPrinterList: function getPrinterList() {
      var self = this;
      var data = {
        page: 1,
        size: 20
      };
      var url = '/printer/list?page=' + data.page + '&size=' + data.size;
      if (this.searchResult) url = url + '&identity=' + this.searchResult;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.printerList = response.data.list;
          if (self.printerList.length) self.isPrinterSelect = self.printerList[0].printer_id;
          self.printerInfo = {
            identity: '',
            type: 1
          };
        }
      });
    },
    checkPrinter: function checkPrinter() {
      var msg = '';
      if (!this.printerInfo.identity && this.printerSelect === 1) {
        msg = '請輸入辨識碼';
      }
      this.getToast2(msg);
    },
    getToast2: function getToast2(msg) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        if (this.printerSelect === 1) this.addPrinter();else this.crPrinterStore(this.isPrinterSelect);
      }
    },
    addPrinter: function addPrinter() {
      var self = this;
      var url = '/printer';
      var info = this.printerInfo;
      var data = {
        type: info.type,
        identity: info.identity
      };
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.crPrinterStore(response.data.printer_id);
        }
      });
    },
    crPrinterStore: function crPrinterStore(printerId) {
      var self = this;
      var url = '/printer/storePrinter';
      var data = {
        printer_id: printerId,
        store_id: this.$route.params.store_id
      };
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.getPrinterStoreList();
        }
      });
    },
    printerType: function printerType(type) {
      switch (type) {
        case 1:
          return 'W牌出單機(1)';
        case 2:
          return 'F牌出單機(2)';
        case 3:
          return 'F牌貼紙機(3)';
      }
    },
    selectOnChange: function selectOnChange(value) {
      this.change.binding_is_enabled = value;
    },
    inputOnChange: function inputOnChange(value) {
      this.change.binding_name = value;
    },
    trigger: function trigger(event) {
      if (event === 'delBinding') {
        this.delBinding();
      } else if (event === 'editBinding') {
        this.editBinding();
      } else if (event === 'updateBinding') {
        this.updatedStore();
      } else if (event === 'reCheckBinding') {
        this.updatedStore(true);
      } else if (event === 'reCheckCancel') {
        this.invalidStoreMap = null;
      }
    },
    delBinding: function delBinding() {
      var self = this;
      var url = '/printer/storePrinter/' + this.current.binding_id;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.getPrinterStoreList();
        }
      });
    },
    editBinding: function editBinding() {
      var self = this;
      var url = '/printer/storePrinter/' + this.current.binding_id;
      var data = {
        is_enabled: this.change.binding_is_enabled
      };
      if (this.current.binding_name) data['name'] = this.change.binding_name;
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.change = {
            is_enabled: 1,
            binding_name: ''
          };
          self.getPrinterStoreList();
        }
      });
    },
    getCurrent: function getCurrent(obj) {
      this.current = obj;
      this.editOption.body = '編輯出單機' + obj.printer_identity + '綁定';
      this.selectChange = obj.binding_is_enabled;
      this.change = {
        is_enabled: obj.binding_is_enabled,
        binding_name: obj.binding_name
      };
    },
    clickClose: function clickClose(type, notSupport, val, index) {
      var _this7 = this;

      if (type === 'deliveryWays') {
        if (parseInt(val, 10) === 1) {
          this.$refs.pickupWarnModal.click();
          this.$nextTick(function () {
            _this7.deliveryWaysInfo[index].is_enable = 1;
            _this7.deliveryWaysInfo[index].is_support = 1;
          });
        } else if (notSupport) {
          this.deliveryWaysInfo[index].is_enable = 0;
          this.deliveryWaysInfo[index].is_support = 0;
        }
      } else if (type === 'tradeType') {
        if (parseInt(val, 10) === 1) {
          this.$nextTick(function () {
            _this7.tradeInfo[index].is_enable = 1;
            _this7.tradeInfo[index].is_support = 1;
          });
        }
      }
    },
    addExceptionTrade: function addExceptionTrade() {
      var obj = {
        delivery_type: 0,
        start_money: '',
        end_money: '',
        trade_type: 1
      };
      this.exceptionTradeList.push(obj);
    },
    exportUrl: function exportUrl() {
      var _this8 = this;

      if (this.tableNumberUrl.text) {
        var arr = this.tableNumberUrl.text.split(/,|\n|，/);
        var csvFile = [['入口', '桌號', '網址']];
        arr.forEach(function (number) {
          var numberWithTrim = number.trim();
          if (numberWithTrim) {
            var row = [];
            _this8.enterType.forEach(function (x) {
              if (x.value === _this8.tableNumberUrl.type) {
                var url = x.url + '/onSite/' + _this8.$route.params.store_id + '/store?tableNo=' + numberWithTrim;

                row.push(x.name, numberWithTrim, url);
                csvFile.push(row);
              }
            });
          }
        });
        if (csvFile.length > 1) {
          var data = csvFile.map(function (e) {
            return e.join(',');
          }).join('\n');
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__assets_js_down_load_file__["a" /* default */])(data, '桌號網址.csv', 'text/csv;charset=utf-8', new Uint8Array([0xEF, 0xBB, 0xBF]));
        }
      }
    },
    setCommissionQuery: function setCommissionQuery() {
      var query = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.orderCommissionSetting));
      if (!this.orderCommissionSetting.item_list.length) {
        delete query['item_list'];
      } else if (this.orderCommissionSetting.type === 1) {
        delete query['item_list'];
        query['has_independent_report'] = 0;
      } else {
        query.item_list.forEach(function (item) {
          item.start_time = item.start_time + ':00';
          item.end_time = item.end_time + ':59';
        });
      }
      return this.setData(query);
    },
    notBeforeToday: function notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    notBeforeTodayAddTwoMins: function notBeforeTodayAddTwoMins(date) {
      return date < new Date(__WEBPACK_IMPORTED_MODULE_10_moment___default()().set('second', 0).add(5, 'm').toString());
    },
    setTakeTime: function setTakeTime() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var timeSeg = 0;
      var val = item.take_time_seg;
      if (type === 'add') {
        timeSeg = Math.floor(val / 10) * 10 + 10;
      } else if (type === 'minus' && val > 10) {
        timeSeg = Math.ceil(val / 10) * 10 - 10;
      }
      item.take_time_seg = timeSeg;
    },
    clickOutsideCloseCalendar: function clickOutsideCloseCalendar(event) {
      var _this9 = this;

      var calendarContainers = document.querySelectorAll('.calendar-container');
      calendarContainers.forEach(function (container, index) {
        if (!container.contains(event.target)) {
          if (_this9.selectSpecialDay[index]) {
            _this9.selectSpecialDay[index].showSpecialDayCalendar = false;
          }
        }
      });

      var offDayCalendarContainers = document.querySelectorAll('.calendar-container');
      var clickedOutsideOffDayCalendar = true;
      offDayCalendarContainers.forEach(function (container) {
        if (container.contains(event.target)) {
          clickedOutsideOffDayCalendar = false;
        }
      });
      if (clickedOutsideOffDayCalendar) {
        this.showCalendar = false;
      }
    }
  },
  created: function created() {
    this.init();
  },
  mounted: function mounted() {
    if (this.$route.query.tab) {
      this.storeMethod = Number(this.$route.query.tab);
    }

    var observer = new MutationObserver(function () {
      var calendarMultiselects = document.querySelectorAll('.calendar-multiselect');
      calendarMultiselects.forEach(function (multiselect) {
        var wrappers = multiselect.querySelectorAll('.multiselect__content-wrapper');
        wrappers.forEach(function (wrapper) {
          wrapper.remove();
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true });

    document.addEventListener('click', this.clickOutsideCloseCalendar);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('click', this.clickOutsideCloseCalendar);
  },

  components: {
    'img-upload': __WEBPACK_IMPORTED_MODULE_8__Temp_ImgUploadTemp_vue___default.a,
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_9_vue_datepicker_vue_datepicker_es6_vue___default.a,
    'shipping-form': __WEBPACK_IMPORTED_MODULE_14__Temp_ShippingForm___default.a,
    'm-modal': __WEBPACK_IMPORTED_MODULE_6__elements_Modal_vue___default.a,
    VueTimepicker: __WEBPACK_IMPORTED_MODULE_11_vue2_timepicker___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_15_vue2_datepicker__["a" /* default */],
    'delivery-limit': __WEBPACK_IMPORTED_MODULE_16__Temp_DeliveryLimit_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vuex__["b" /* mapGetters */])(['getRoleType', 'getRestricted']), {
    offdayWeekDayOptions: function offdayWeekDayOptions() {
      return this.offdaySetting.options.weekDay.filter(function (item) {
        return item.value;
      });
    },
    offdayMonthDayOptions: function offdayMonthDayOptions() {
      return this.offdaySetting.options.monthDay.filter(function (item) {
        return item.value;
      });
    },
    calendarLimits: function calendarLimits() {
      return {
        min: __WEBPACK_IMPORTED_MODULE_10_moment___default()().format('DD/MM/YYYY'),
        max: '31/12/2126'
      };
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    },
    showTableNumber: function showTableNumber() {
      var table = this.deliveryWaysInfo.find(function (item) {
        return item.take_type === 21;
      });
      return table ? Number(table.is_enable) : 0;
    },
    shippingInfo: function shippingInfo() {
      if (!this.deliveryWaysInfo) return {};
      return this.deliveryWaysInfo[2] || {};
    },
    reCheckOption: function reCheckOption() {
      var _this10 = this;

      var body = this.invalidStoreMap ? '<ul style="padding-left: 2rem; margin: 0.5rem 0;">' : '';
      if (this.invalidStoreMap && this.invalidStoreMap.delivery_ways) {
        var deliveryMap = this.deliveryTypeOption.reduce(function (acc, cur) {
          acc[cur.value] = cur.label;
          return acc;
        }, {});

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.invalidStoreMap.delivery_ways).forEach(function (key) {
          var deliveryWay = _this10.invalidStoreMap.delivery_ways[key];
          if (deliveryWay && deliveryWay.is_enabled) {
            var deliveryType = deliveryMap[key];
            var stores = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(deliveryWay.is_enabled).join('、');
            body += '<li>\u53D6\u9910\u985E\u578B\u300C' + deliveryType + '\u300D: \u65BC\u4EE5\u4E0B\u9580\u5E02\u70BA\u9810\u8A2D\u53D6\u9910\u65B9\u5F0F\u6216\u4E0D\u652F\u63F4\u7684\u72C0\u614B<br>\u7121\u6CD5\u8B8A\u66F4\u9580\u5E02\uFF1A' + stores + '</li>';
          }
        });
      } else if (this.invalidStoreMap && this.invalidStoreMap.is_invoice_exception) {
        var invoiceExceptionArray = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.invalidStoreMap.is_invoice_exception);
        invoiceExceptionArray.forEach(function (key) {
          var stores = _this10.invalidStoreMap.is_invoice_exception[key];
          body += '<li>\u65BC\u4EE5\u4E0B\u9580\u5E02\u8A2D\u5B9A\u958B\u7ACB\u767C\u7968\uFF0C\u9700\u81F3\u5C11\u958B\u653E\u4EFB\u4E00\u767C\u7968\u985E\u578B (\u7D19\u672C\u767C\u7968\u3001\u96FB\u5B50\u8F09\u5177\u3001\u611B\u5FC3\u6350\u8D08\u767C\u7968)\uFF0C\u958B\u653E\u72C0\u614B\u7121\u6CD5\u8B8A\u66F4\u70BA\u505C\u7528<br>\u7121\u6CD5\u8B8A\u66F4\u9580\u5E02\uFF1A' + stores + '</li>';
        });
      } else if (this.invalidStoreMap && this.invalidStoreMap.trade_types) {
        var tradeTypeMap = this.tradeTypeOption.reduce(function (acc, cur) {
          acc[cur.value] = cur.label;
          return acc;
        }, {});

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.invalidStoreMap.trade_types).forEach(function (tradeTypeId) {
          var tradeTypeStores = _this10.invalidStoreMap.trade_types[tradeTypeId];
          var storeNames = [];

          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(tradeTypeStores).forEach(function (storeId) {
            var storeInfo = tradeTypeStores[storeId];
            if (storeInfo && storeInfo.is_support === '0') {
              storeNames.push(storeInfo.name);
            }
          });

          if (storeNames.length > 0) {
            var tradeTypeLabel = tradeTypeMap[tradeTypeId];
            var storesText = storeNames.join('、');
            body += '<li>\u4ED8\u6B3E\u985E\u578B\u300C' + tradeTypeLabel + '\u300D: \u76EE\u524D\u5C1A\u672A\u65BC\u4EE5\u4E0B\u9580\u5E02\u958B\u901A<br>\u7121\u6CD5\u8B8A\u66F4\u9580\u5E02\uFF1A' + storesText + '</li>';
          }
        });
      }

      body += this.invalidStoreMap ? '</ul>' : '';
      return {
        id: 'reCheckModal',
        title: '部分設定無法變更',
        body: body,
        btns: [{
          name: '取消',
          event: 'reCheckCancel'
        }, {
          name: '確定',
          event: 'reCheckBinding'
        }]
      };
    },
    hasInvoiceSelected: function hasInvoiceSelected() {
      return this.hasInvoiceCarrierSelect === 1 || this.hasInvoicePaperSelect === 1 || this.getRoleType === 99 && this.hasInvoiceNpobnaSelect === 1;
    },
    allInvoiceClosed: function allInvoiceClosed() {
      return this.hasInvoiceCarrierSelect === 0 && this.hasInvoicePaperSelect === 0 && (this.getRoleType !== 99 || this.hasInvoiceNpobnaSelect === 0);
    }
  }),
  watch: {
    form: {
      handler: function handler() {
        this.getStoreBrief();
      },
      deep: true
    },
    citySelect: function citySelect() {
      var cityCode = parseInt(this.citySelect, 10);
      var cityElement = this.cityAreaList.find(function (e, i, o) {
        return e.city_code === cityCode;
      });
      var areaList = cityElement.area_list;
      this.areaOption = [];
      for (var i = 0; i < areaList.length; i++) {
        var option = { name: areaList[i].name, value: areaList[i].area_code };
        this.areaOption.push(option);
        if (i === 0 && (this.$route.name !== 'upStore' || this.areaTimes)) {
          this.areaSelect = option.value.toString();
        } else this.areaTimes = 1;
      }
    },
    'storeInfo.city_code': function storeInfoCity_code() {
      if (this.$route.name === 'upStore') this.areaSelect = this.storeInfo.area_code;
    },
    imgLogoSelect: function imgLogoSelect() {
      var self = this;
      if (self.imgLogoSelect) {
        var imgSrc = this.imgLogoOption.find(function (e) {
          return e.name === self.imgLogoSelect;
        }).value;
        this.storeInfo.image_name = imgSrc;
      }
    },
    imgBgSelect: function imgBgSelect() {
      var self = this;
      if (self.imgBgSelect) {
        var imgSrc = this.imgBgOption.find(function (e) {
          return e.name === self.imgBgSelect;
        }).value;
        this.storeInfo.bg_image_name = imgSrc;
      }
    },
    'tableNumber.sub_delivery_type': function tableNumberSub_delivery_type(val) {
      if (val === 1) {
        this.tableNumber.is_table_no_required = 0;
        this.tableNumber.show_table_no = 0;
      }
    },
    storeMethod: function storeMethod(val) {
      var tab = {
        tab: val
      };
      this.$router.push({ query: tab });
      this.invalidStoreMap = null;
    },

    deliveryWaysInfo: {
      deep: true,
      handler: function handler(val) {
        if (typeof this.deliveryOther[0] !== 'undefined' && this.deliveryOther[0] !== null) {
          this.deliveryOther[0].price = val[2].price;
        }
      }
    },
    hasInvoiceSelected: function hasInvoiceSelected(val) {
      if (val) {
        this.isInvoiceException = 0;
      }
    },
    allInvoiceClosed: function allInvoiceClosed(val) {
      if (val) {
        this.isInvoiceException = 1;
      }
    }
  }
});

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Temp_BrandAdTableTemp_vue__ = __webpack_require__(2119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Temp_BrandAdTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Temp_BrandAdTableTemp_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      tableIndex: 1,
      show: {
        menu: false,
        menuDetail: false
      }
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#example1').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      });
    });
  },

  methods: {
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    }
  },
  components: {
    'ad-table': __WEBPACK_IMPORTED_MODULE_3__Temp_BrandAdTableTemp_vue___default.a
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  }
});

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      info: {
        website_setting: [],
        meal_tag_setting: [],
        name_alias: []
      }
    };
  },

  methods: {
    getBrandInfo: function getBrandInfo() {
      var self = this;
      var url = '/brand/' + this.$route.params.brand_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.info = response.data.brand_info;
        }
      });
    }
  },
  created: function created() {
    this.getBrandInfo();
  },

  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    nameAliasDisplay: function nameAliasDisplay() {
      if (!this.info.name_alias || !Array.isArray(this.info.name_alias)) {
        return '';
      }
      return this.info.name_alias.map(function (alias) {
        if ((typeof alias === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(alias)) === 'object' && alias !== null) {
          return alias.label || alias.value || alias;
        }
        return alias;
      }).join('、');
    }
  }
});

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_BrandTableTemp_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_BrandTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Temp_BrandTableTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      tableIndex: 1,
      show: {
        menu: false,
        menuDetail: false
      }
    };
  },

  methods: {
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    }
  },
  components: {
    'brand-table': __WEBPACK_IMPORTED_MODULE_2__Temp_BrandTableTemp_vue___default.a
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  }
});

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_ChangeStoresIconTemp_vue__ = __webpack_require__(2120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_ChangeStoresIconTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_ChangeStoresIconTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      info: {
        name: '光復店',
        des: '滿200外送'
      }
    };
  },

  components: {
    'stores-icon-form': __WEBPACK_IMPORTED_MODULE_0__Temp_ChangeStoresIconTemp_vue___default.a
  },
  computed: {
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    }
  }
});

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_CopyAdTemp_vue__ = __webpack_require__(2121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_CopyAdTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_CopyAdTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      info: {
        name: '光復店',
        des: '滿200外送'
      }
    };
  },

  components: {
    'copy-ad-form': __WEBPACK_IMPORTED_MODULE_0__Temp_CopyAdTemp_vue___default.a
  },
  computed: {
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    }
  }
});

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_AdFormTemp_vue__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_AdFormTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_AdFormTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  components: {
    'ad-form': __WEBPACK_IMPORTED_MODULE_0__Temp_AdFormTemp_vue___default.a
  },
  methods: {},
  computed: {
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    }
  }
});

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_BrandFormTemp_vue__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_BrandFormTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_BrandFormTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  components: {
    'brand-form': __WEBPACK_IMPORTED_MODULE_0__Temp_BrandFormTemp_vue___default.a
  },
  methods: {},
  computed: {
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  }
});

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_BrandAdFormTemp_vue__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_BrandAdFormTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_BrandAdFormTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  components: {
    'ad-form': __WEBPACK_IMPORTED_MODULE_0__Temp_BrandAdFormTemp_vue___default.a
  },
  methods: {},
  computed: {
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    }
  }
});

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_GroupFormTemp_vue__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_GroupFormTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_GroupFormTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  components: {
    'group-form': __WEBPACK_IMPORTED_MODULE_0__Temp_GroupFormTemp_vue___default.a
  },
  computed: {
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  }
});

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_StoreFormTemp_vue__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_StoreFormTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_StoreFormTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  components: {
    'store-form': __WEBPACK_IMPORTED_MODULE_0__Temp_StoreFormTemp_vue___default.a
  },
  methods: {},
  computed: {
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    }
  }
});

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_datatables_net_bs__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      total: 1,
      count: 10,
      history: false,
      groupList: [],
      current: {
        openList: {},
        deliveryList: {},
        payList: {},
        name: ''
      }
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#example1').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      });
    });
  },

  methods: {
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    getStateName: function getStateName(state) {
      if (state === 0) {
        return '尚未營業';
      } else if (state === 1) {
        return '籌備中';
      } else if (state === 2) {
        return '營業中';
      } else if (state === 3) {
        return '休息中';
      } else if (state === 9) {
        return '已歇業';
      }
    },
    getDayName: function getDayName(day) {
      if (day === 1) {
        return '日';
      } else if (day === 2) {
        return '一';
      } else if (day === 3) {
        return '二';
      } else if (day === 4) {
        return '三';
      } else if (day === 5) {
        return '四';
      } else if (day === 6) {
        return '五';
      } else if (day === 7) {
        return '六';
      }
    },
    getStoreGroupList: function getStoreGroupList() {
      var self = this;
      var data = {
        page: this.tableIndex,
        size: this.count
      };
      var url = '/brand/' + this.$route.params.brand_id + '/storeGroupList?page=' + data.page + '&size=' + data.size;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.groupList = response.data.list;
          self.total = response.data.list_total;
        }
      });
    },
    openModal: function openModal(store) {
      this.current.openList = store.opening_info;
      this.current.deliveryList = store.delivery_info;
      this.current.payList = store.trade_info;
      this.current.name = store.name_short;
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.getStoreGroupList();
    }
  },
  created: function created() {
    var path = this.$route.name;
    if (path === 'storeHistoryTable') this.history = true;
    this.getStoreGroupList();
  },

  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  }
});

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Order_Temp_OrderTableTemp_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Order_Temp_OrderTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Order_Temp_OrderTableTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      numeral: __WEBPACK_IMPORTED_MODULE_3_numeral___default.a,
      tableIndex: 1,
      storeInfo: {
        is_support_custom_remark: 0,
        offday_info: {
          date: [],
          month_day: [],
          week_day: []
        },
        shipping_fee_normal_info: {
          item_list: []
        },
        delivery_exception_items_info: {
          adjust: [],
          block: [],
          category: [],
          combination: [],
          option: [],
          package: [],
          product: []
        },
        delivery_way_plastic_selected: [],
        has_invoice_paper: 0,
        has_invoice_carrier: 0,
        invoice_remark: '',
        has_invoice_npoban: 0 },
      storeMethod: 1,
      printerStoreList: [],
      exceptionTradeList: [],
      exceptionCalendar: [],
      hidePickupType: [4, 5],
      tableNoCustomConfig: {},
      specialOpenTime: [] };
  },

  filters: {
    km: function km(val) {
      if (val === null || isNaN(val)) return '無限制';
      return __WEBPACK_IMPORTED_MODULE_3_numeral___default()(val).divide(1000).value();
    },
    payAfterMeal: function payAfterMeal(val) {
      if (!val || !val.store_value) return '無';
      switch (Number(val.store_value)) {
        case 1:
          return '餐後付款';
        case 0:
          return '餐前付款';
        default:
          return '無';
      }
    },
    subDeliveryType: function subDeliveryType(val) {
      if (!val || !val.store_value) return '無';
      switch (Number(val.store_value)) {
        case 1:
          return '叫號取餐';
        case 2:
          return '店家送餐';
        default:
          return '無';
      }
    }
  },
  watch: {
    storeMethod: function storeMethod() {
      this.$router.replace({
        name: 'storeInfo',
        query: {
          'store-method': this.storeMethod
        },
        params: {
          brand_id: this.$route.params.brand_id,
          store_id: this.$route.params.store_id
        }
      });
    }
  },
  created: function created() {
    this.getStoreInfo();
  },
  mounted: function mounted() {
    if (this.$route.query['store-method']) {
      this.storeMethod = Number(this.$route.query['store-method']);
    }
  },

  methods: {
    getStoreInfo: function getStoreInfo() {
      var self = this;
      var url = '/store/' + this.$route.params.store_id + '/info';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.storeInfo = response.data.info;
          var sInfo = self.storeInfo;

          self.exceptionTradeList = [];
          if (sInfo.delivery_exception_trade_info) {
            for (var key in sInfo.delivery_exception_trade_info) {
              var value = sInfo.delivery_exception_trade_info[key];
              value.forEach(function (item) {
                var obj = item;
                obj.trade_type = parseInt(key, 10);
                self.exceptionTradeList.push(obj);
              });
            }
          }

          self.exceptionCalendar = [];
          if (sInfo.delivery_exception_calendar_info) {
            for (var cKey in sInfo.delivery_exception_calendar_info) {
              var cValue = sInfo.delivery_exception_calendar_info[cKey];
              cValue.delivery_type = parseInt(cKey, 10);
              if (cValue.date_type.length || cValue.month_day.length || cValue.week_day.length) self.exceptionCalendar.push(cValue);
            }
          }

          if (self.getRoleType === 99) self.getPrinterStoreList();

          self.specialOpenTime = [];
          if (sInfo.order_time_setting.length > 0) {
            self.specialOpenTime = sInfo.order_time_setting.map(function (setting) {
              return {
                id: setting.id,
                start_time: setting.start_time,
                end_time: setting.end_time,
                order_start_time: setting.order_start_time,
                order_end_time: setting.order_end_time,
                remark: setting.remark,
                calendarList: setting.calendar_list.map(function (item) {
                  return item.usage_date;
                })
              };
            });
          }
        }
      });
    },
    getWeek: function getWeek(value) {
      switch (value) {
        case 0:
          return '無指定';
        case 1:
          return '週日';
        case 2:
          return '週一';
        case 3:
          return '週二';
        case 4:
          return '週三';
        case 5:
          return '週四';
        case 6:
          return '週五';
        case 7:
          return '週六';
        default:
          return '無指定';
      }
    },
    getTimeValue: function getTimeValue(value, type) {
      if (type === 2) {
        return this.getWeek(value);
      } else {
        switch (value) {
          case 0:
            return '無指定';
          default:
            return value + '日';
        }
      }
    },
    couponFormName: function couponFormName(type) {
      if (type === 1) {
        return '依付款方式使用優惠券';
      } else if (type === 2) {
        return '依虛擬商品使用優惠券';
      }
    },
    roundTypeName: function roundTypeName(roundType) {
      if (roundType === 1) {
        return '無條件進位';
      } else if (roundType === 2) {
        return '無條件捨去';
      } else if (roundType === 3) {
        return '四捨五入';
      } else {
        return '保留小數點';
      }
    },
    barcodeTypeName: function barcodeTypeName(type) {
      if (type === 0) {
        return '不支援';
      } else if (type === 1) {
        return '一維條碼';
      } else if (type === 2) {
        return '二維條碼 (QRcode)';
      } else if (type === 3) {
        return '一維&二維條碼皆支援';
      }
    },
    getStateName: function getStateName(state) {
      if (state === 0) {
        return '尚未營業';
      } else if (state === 1) {
        return '籌備中';
      } else if (state === 2) {
        return '營業中';
      } else if (state === 3) {
        return '休息中';
      } else if (state === 9) {
        return '已歇業';
      }
    },
    menuLayout: function menuLayout(layout) {
      if (layout === 1) {
        return '文字，選項方塊 (飲料店用)';
      } else if (layout === 11) {
        return '文字，選項方塊，配料全展開';
      } else if (layout === 2) {
        return '圖文，商品描述為點擊後';
      } else if (layout === 3) {
        return '圖文，商品描述在下方';
      } else if (layout === 4) {
        return '文字，選項條列式 (餐廳用)';
      } else if (layout === 31) {
        return '圖文，商品描述在下方，外層大圖';
      }
    },
    orderStatusName: function orderStatusName(status) {
      var s = parseInt(status, 10);
      if (s === 10) {
        return '接單中';
      } else if (s === 20) {
        return '不接單';
      } else {
        return '未設定';
      }
    },
    getDayName: function getDayName(day) {
      if (day === 1) {
        return '日';
      } else if (day === 2) {
        return '一';
      } else if (day === 3) {
        return '二';
      } else if (day === 4) {
        return '三';
      } else if (day === 5) {
        return '四';
      } else if (day === 6) {
        return '五';
      } else if (day === 7) {
        return '六';
      }
    },
    getDeliveryName: function getDeliveryName(type) {
      if (type === 1) {
        return '自取';
      } else if (type === 2) {
        return '內用';
      } else if (type === 3) {
        return '外送';
      } else if (type === 4) {
        return '外帶';
      } else if (type === 5) {
        return '吧台';
      } else if (type === 21) {
        return '內用-桌邊掃碼';
      } else if (type === 0) {
        return '全部取餐類型';
      }
    },
    getTime: function getTime(time) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(time, 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss');
    },
    printerType: function printerType(type) {
      switch (type) {
        case 1:
          return '熒埔';
        case 2:
          return '飛鵝';
      }
    },
    getCategoryName: function getCategoryName(category) {
      switch (category) {
        case 'adjust':
          return '調整分類';
        case 'block':
          return '選擇區';
        case 'category':
          return '商品分類';
        case 'combination':
          return '組合';
        case 'option':
          return '配料';
        case 'package':
          return '套餐';
        case 'product':
          return '商品';
      }
    },
    getPrinterStoreList: function getPrinterStoreList() {
      var self = this;
      var url = '/printer/storePrinterList/' + this.$route.params.store_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.printerStoreList = response.data.list;
        }
      });
    },
    showMemo: function showMemo(type, memoType) {
      var deliveryMemo = this.storeInfo.delivery_memo || [];
      var data = deliveryMemo.find(function (item) {
        return item.delivery_type === type;
      });
      return data ? memoType === 'memo' ? data.memo : data.pickup_memo : '';
    }
  },
  components: {
    'order-table': __WEBPACK_IMPORTED_MODULE_1__Order_Temp_OrderTableTemp_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    },
    statusName: function statusName() {
      var status = this.storeInfo.status;
      if (status === 0) {
        return '尚未營業';
      } else if (status === 1) {
        return '籌備中';
      } else if (status === 2) {
        return '營業中(上架)';
      } else if (status === 3) {
        return '休息中';
      } else if (status === 9) {
        return '已歇業';
      }
    },
    systemReasonName: function systemReasonName() {
      var reason = this.storeInfo.system_order_status_reason;
      if (reason === 0) {
        return 'MQTT連線已建立';
      } else if (reason === 10) {
        return 'MQTT連線已中斷';
      } else if (reason === 20) {
        return '不接單';
      }
    },
    showTableNumber: function showTableNumber() {
      var table = this.storeInfo.delivery_info.find(function (item) {
        return item.delivery_type === 21;
      });
      return table ? Number(table.is_enable) : 0;
    },
    showItemList: function showItemList() {
      var content = [];
      var last = [];
      this.storeInfo.shipping_fee_normal_info.item_list.forEach(function (item) {
        if (item.distance === null) {
          last.push(item);
        } else {
          content.push(item);
        }
      });
      return content.concat(last);
    },
    getShippingMaxFee: function getShippingMaxFee() {
      return this.storeInfo.shipping_fee_normal_info.item_list.find(function (obj) {
        return !obj.money;
      }).fee;
    },
    shippingInfo: function shippingInfo() {
      return this.storeInfo.delivery_info ? this.storeInfo.delivery_info[2] : {};
    }
  })
});

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_spinner_src_ClipLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_spinner_src_ClipLoader_vue__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  components: {
    Clip: __WEBPACK_IMPORTED_MODULE_7_vue_spinner_src_ClipLoader_vue___default.a
  },
  data: function data() {
    return {
      name: '迷客夏',
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      total: 1,
      count: 10,
      history: false,
      storeList: [],
      current: {
        openList: {},
        deliveryList: {},
        payList: {},
        name: '',
        mqttInfo: []
      },
      searchSelect: 1,
      searchInput: '',
      statusSelect: 99,
      trTypeSelect: 999,
      statusTypeList: [{ label: '== 營業狀態 ==', value: 99 }, { label: '營業中', value: 2 }, { label: '籌備中', value: 1 }, { label: '尚未營業', value: 0 }, { label: '休息中', value: 3 }, { label: '已歇業', value: 9 }],
      orderStatusSelect: 99,
      isSearchSelect: 99,
      isDownloading: false,
      searchQuery: {} };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#example1').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      });
    });
  },

  methods: {
    getDTypeInfo: function getDTypeInfo(dInfo, dIndex) {
      return dInfo.find(function (obj) {
        return obj.delivery_type === dIndex;
      });
    },
    isActive: function isActive(index) {
      if (Number(this.tableIndex) === index) return true;else return false;
    },
    stateColor: function stateColor(name) {
      if (name.indexOf('現金') > -1) {
        return 'label-default';
      } else if (name.indexOf('LINE') > -1) {
        return 'label-success';
      } else if (name.indexOf('iP') > -1) {
        return 'label-success';
      } else if (name.indexOf('台新') > -1) {
        return 'label-primary';
      } else if (name.indexOf('國泰') > -1) {
        return 'label-primary';
      } else if (name.indexOf('TAPPAY') > -1) {
        return 'label-primary';
      } else if (name.indexOf('街口') > -1) {
        return 'label-danger';
      } else if (name.indexOf('Pi') > -1) {
        return 'label-info';
      } else if (name.indexOf('全盈') > -1) {
        return 'label-primary';
      } else if (name.indexOf('台灣') > -1) {
        return 'label-warning';
      } else if (name.indexOf('icash') > -1) {
        return 'label-info';
      } else if (name.indexOf('全支付') > -1) {
        return 'label-warning';
      } else if (name.indexOf('遠傳電信') > -1) {
        return 'label-danger';
      } else if (name.indexOf('悠遊付') > -1) {
        return 'label-primary';
      } else {
        return 'label-default';
      }
    },
    tradeType: function tradeType(name) {
      if (name.indexOf('現金') > -1) {
        return '現金';
      } else if (name.indexOf('LINE') > -1) {
        return 'LINE PAY';
      } else if (name.indexOf('台新') > -1) {
        return '信用卡(台新)';
      } else if (name.indexOf('國泰') > -1) {
        return '信用卡';
      } else if (name.indexOf('TAPPAY') > -1) {
        return '信用卡';
      } else if (name.indexOf('街口') > -1) {
        return '街口支付';
      } else if (name.indexOf('Pi') > -1) {
        return 'Pi 拍錢包';
      } else if (name.indexOf('全盈') > -1) {
        return '全盈+PAY';
      } else if (name.indexOf('台灣') > -1) {
        return '台灣Pay';
      } else if (name.indexOf('icash') > -1) {
        return 'icash Pay';
      } else if (name.indexOf('全支付') > -1) {
        return '全支付';
      } else if (name.indexOf('遠傳電信') > -1) {
        return '遠傳電信代收';
      } else if (name.indexOf('悠遊付') > -1) {
        return '悠遊付';
      } else {
        return name;
      }
    },
    getStateName: function getStateName(state) {
      if (state === 0) {
        return '尚未營業';
      } else if (state === 1) {
        return '籌備中';
      } else if (state === 2) {
        return '營業中';
      } else if (state === 3) {
        return '休息中';
      } else if (state === 9) {
        return '已歇業';
      }
    },
    getDayName: function getDayName(day) {
      if (day === 1) {
        return '日';
      } else if (day === 2) {
        return '一';
      } else if (day === 3) {
        return '二';
      } else if (day === 4) {
        return '三';
      } else if (day === 5) {
        return '四';
      } else if (day === 6) {
        return '五';
      } else if (day === 7) {
        return '六';
      }
    },
    getStoreList: function getStoreList() {
      var self = this;
      var data = {
        page: this.tableIndex,
        size: this.count,
        searchSelect: parseInt(this.searchSelect, 10),
        inputVal: this.searchInput.trim()
      };

      var url = '/brand/' + this.$route.params.brand_id + '/storeList?size=' + data.size;
      var queryValue = {};
      if (data.searchSelect === 1 && data.inputVal) {
        if (this.$route.query.name && this.$route.query.name !== data.inputVal) this.tableIndex = 1;
        queryValue = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, queryValue, { name: data.inputVal });
        url = url + '&name=' + data.inputVal;
      }

      if (parseInt(this.statusSelect, 10) !== 99) {
        if (this.$route.query.status && this.$route.query.status !== this.statusSelect) this.tableIndex = 1;
        queryValue = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, queryValue, { status: this.statusSelect });
        url = url + '&status=' + this.statusSelect;
      }
      if (parseInt(this.orderStatusSelect, 10) !== 99) {
        if (this.$route.query.is_search && this.$route.query.is_search !== this.isSearchSelect) this.tableIndex = 1;
        queryValue = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, queryValue, { order_status: this.orderStatusSelect });
        url = url + '&order_status=' + this.orderStatusSelect;
      }
      if (parseInt(this.trTypeSelect, 10) !== 999) {
        if (this.$route.query.is_search && this.$route.query.is_search !== this.isSearchSelect) this.tableIndex = 1;
        queryValue = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, queryValue, { trade_type: this.trTypeSelect });
        url = url + '&trade_type=' + this.trTypeSelect;
      }
      if (parseInt(this.isSearchSelect, 10) !== 99) {
        if (this.$route.query.is_search && this.$route.query.is_search !== this.isSearchSelect) this.tableIndex = 1;
        queryValue = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, queryValue, { is_search: this.isSearchSelect });
        url = url + '&is_search=' + this.isSearchSelect;
      }
      if (this.tableIndex) {
        queryValue = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, queryValue, { page: this.tableIndex });
        url = url + '&page=' + this.tableIndex;
      }
      this.searchQuery = queryValue;
      this.$router.push({ query: queryValue });
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.storeList = response.data.list;
          self.total = response.data.list_total;
          self.$store.commit('SET_BRAND_ID', Number(self.$route.params.brand_id));
          self.$store.commit('SET_STORES', response.data.list);
        }
      });
    },
    openModal: function openModal(store) {
      this.current.openList = store.opening_info;
      this.current.deliveryList = store.delivery_info;
      this.current.payList = store.trade_info;
      this.current.name = store.name_short;
      this.current.mqttInfo = store.mqtt_info;
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.getStoreList();
    },
    getTime: function getTime(time) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(time, 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss');
    },
    searchStore: function searchStore() {
      this.tableIndex = 1;
      this.getStoreList();
    },
    exportFile: function exportFile() {
      var _this = this;

      this.isDownloading = true;
      var query = this.searchQuery;
      var searchParams = '';
      if (query.page) {
        delete query.page;
      }
      if (query.size) {
        delete query.size;
      }
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(query).length) {
        searchParams = new URLSearchParams(query);
      }
      var url = '/brand/' + this.$route.params.brand_id + '/storeListSheet?' + searchParams.toString();
      this.getFile('get', url, null, function (response) {
        _this.isDownloading = false;
        var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        var objectUrl = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = objectUrl;
        a.download = '\u9580\u5E02\u6E05\u55AE.xlsx';
        document.body.appendChild(a);
        a.click();
      });
    }
  },
  created: function created() {
    var path = this.$route.name;
    if (path === 'storeHistoryTable') this.history = true;
    if (this.$route.query.page) this.tableIndex = this.$route.query.page;
    if (this.$route.query.name) this.searchInput = this.$route.query.name;
    if (this.$route.query.status) this.statusSelect = this.$route.query.status;
    if (this.$route.query.order_status) this.orderStatusSelect = this.$route.query.order_status;
    if (this.$route.query.is_search) this.isSearchSelect = this.$route.query.is_search;
    if (this.$route.query.trade_type) this.trTypeSelect = this.$route.query.trade_type;
    this.getStoreList();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['getRoleType', 'getPickupType', 'getTradeType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    },
    webDomain: function webDomain() {
      return this.$config.web;
    },
    getFile: function getFile() {
      return this.$parent.getFile;
    }
  }),
  watch: {
    statusSelect: function statusSelect() {
      this.searchStore();
    },
    orderStatusSelect: function orderStatusSelect() {
      this.searchStore();
    },
    isSearchSelect: function isSearchSelect() {
      this.searchStore();
    },
    trTypeSelect: function trTypeSelect() {
      this.searchStore();
    }
  }
});

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ImgUploadTemp_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ImgUploadTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ImgUploadTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_timepicker__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue2_timepicker__);












/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    'info': {
      type: Object
    }
  },
  data: function data() {
    return {
      bannerType: Number(this.$route.query.tab) || 12,
      newPhoto: this.$route.query.new,
      img: {
        width: 0,
        height: 0
      },
      adInfo: {
        name: '',
        url: '',
        start_time: '',
        end_time: '',
        image_web_file: '',
        sort: 1,
        is_active: 1,
        is_platform_visible: 1,
        is_jkos_visible: 0,
        is_limit_location: 0,
        city_code_list: [],
        dedicated_visible_setting: [],
        foreverShow: 0
      },
      storeInfo: {},

      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: ''
        }
      },
      startTime: {
        time: ''
      },
      endtime: {
        time: ''
      },
      timeoption: {
        type: 'min',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD HH:mm:ss',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'font-size': '15px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 0px 0px 0px',
          'color': '#555',
          'text-align': 'left',
          'padding': '0px 12px',
          'line-height': '34px'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      startLimit: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(-1, 'day').format('YYYY-MM-DD HH:mm:ss')
      }],
      endLimit: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD HH:mm:ss')
      }]
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapActions */])(['setCityList']), {
    init: function init() {
      if (this.$route.name === 'upAd') this.getAdInfo();
    },
    veritySort: function veritySort() {
      var e = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this.$refs.sort);
      this.adInfo.sort = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    getAdInfo: function getAdInfo() {
      var self = this;
      var url = '/store/' + this.$route.params.store_id + '/banner/' + this.$route.params.ad_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var adInfo = response.data.info;
          self.adInfo = {
            name: adInfo.name,
            url: adInfo.url.trim(),
            start_time: adInfo.start_time,
            end_time: adInfo.end_time,
            is_active: adInfo.is_active,
            image_web_file: adInfo.image_web,
            sort: adInfo.sort,
            is_platform_visible: adInfo.is_platform_visible,
            is_jkos_visible: adInfo.dedicated_visible_setting.indexOf(1) > -1 ? 1 : 0,
            foreverShow: 0,
            is_limit_location: adInfo.is_limit_location || 0,
            city_code_list: adInfo.city_code_list || []
          };
          if (adInfo.banner_type === 12) self.newPhoto = true;
          self.menuTime.start.time = self.adInfo.start_time;
          self.menuTime.end.time = self.adInfo.end_time;
        }
      });
    },
    onFileChange: function onFileChange(e) {
      this.imgLogoSelect = '';
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var imgName = files[0].name.split('.');
      var imgSize = Math.round(files[0].size / 1000);
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (imgSize > 1024) {
        this.$notify({
          title: '提醒',
          text: '圖片檔案為' + imgSize + 'KB，請上傳小於1024KB之圖片',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.createImage(files[0]);
      }
    },
    createImage: function createImage(file) {
      var reader = new FileReader();
      var self = this;
      reader.onload = function (e) {
        var img = new Image();
        img.src = e.target.result;
        self.adInfo.image_web_file = img.src;
        img.onload = function () {
          self.img.width = img.width;
          self.img.height = img.height;
          self.checkImgSize();
        };
      };
      reader.readAsDataURL(file);
    },
    checkImgSize: function checkImgSize(type) {
      var self = this;
      if ((this.img.width !== 1280 || this.img.height !== 300) && this.img.width !== 0 && this.img.height !== 0 && this.$route.query.tab === 11) {
        this.$notify({
          title: '提醒',
          text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳1280x300之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if ((this.img.width !== 1000 || this.img.height !== 460) && this.img.width !== 0 && this.img.height !== 0 && this.$route.query.tab === 12) {
        this.$notify({
          title: '提醒',
          text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳1000x460之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if ((this.img.width !== 480 || this.img.height !== 530) && this.img.width !== 0 && this.img.height !== 0 && this.$route.query.tab === 41) {
        this.$notify({
          title: '提醒',
          text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳480x530之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      }
    },
    checkBeforeSend: function checkBeforeSend(type) {
      var all = this.getInput;
      var msg = '';
      if (!all.name) {
        msg = '請輸入廣告名稱';
      } else if (!this.menuTime.start.time) {
        msg = '請輸入開始時間';
      } else if (!this.menuTime.end.time) {
        msg = '請輸入結束時間';
      } else if (!__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#brand-img-load')[0].files[0] && type === 'cr') {
        msg = '請上傳一張圖片';
      }
      this.getToast(msg, type);
    },
    getToast: function getToast(msg, type) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        if (type === 'cr') this.createdAd();else if (type === 'up') this.updatedAdImg();
      }
    },
    getStoreInfo: function getStoreInfo() {
      var self = this;
      var url = '/store/' + this.$route.params.store_id + '/info';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.storeInfo = response.data.info;
        }
      });
    },
    getBrandImgList: function getBrandImgList() {
      var self = this;
      var url = '/brand/' + this.$route.params.brand_id + '/storesImage?image_type=1';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var logoList = response.data.list;
          for (var i = 0; i < logoList.length; i++) {
            var option = { name: logoList[i].image_name, value: logoList[i].image_url };
            self.imgLogoOption.push(option);
          }
        }
      });
      var url2 = '/brand/' + this.$route.params.brand_id + '/storesImage?image_type=3';
      this.getDataH('get', url2, null, function (response) {
        if (response.data.status === 200) {
          var bgList = response.data.list;
          for (var j = 0; j < bgList.length; j++) {
            var option2 = { name: bgList[j].image_name, value: bgList[j].image_url };
            self.imgBgOption.push(option2);
          }
        }
      });
    },
    createdAd: function createdAd() {
      var self = this;
      var data = new FormData();
      var info = this.getInput;
      var name = info.name;
      var picUrl = info.url;
      var startTime = this.menuTime.start.time;
      var endTime = this.menuTime.end.time;
      var sort = parseInt(info.sort, 10);
      if (!picUrl) picUrl = ' ';
      if (!this.newPhoto) data.append('banner_type', 11);else data.append('banner_type', this.bannerType);
      data.append('name', name);
      data.append('url', picUrl);
      data.append('start_time', startTime);
      data.append('end_time', endTime);
      data.append('sort', sort);
      data.append('is_active', this.adInfo.is_active);

      data.append('image_web_file', __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#brand-img-load')[0].files[0]);
      data.append('is_platform_visible', Number(this.adInfo.is_platform_visible));
      if (this.adInfo.is_jkos_visible) {
        data.append('dedicated_visible_setting[]', 1);
      } else {
        data.append('dedicated_visible_setting[]', null);
      }

      data.append('is_limit_location', this.adInfo.is_limit_location);
      if (this.adInfo.is_limit_location && this.adInfo.city_code_list.length) {
        this.adInfo.city_code_list.forEach(function (item) {
          data.append('city_code_list[]', item.code);
        });
      }
      var url = '/store/' + this.$route.params.store_id + '/banner';
      if (data) {
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            });
            self.$router.push({
              name: 'adTable',
              params: {
                brand_id: self.$route.params.brand_id,
                store_id: self.$route.params.store_id
              },
              query: {
                tab: self.bannerType
              }
            });
          }
        }, function (err) {
          console.error(err);
          self.handleError(err);
        });
      }
    },
    updatedAdImg: function updatedAdImg() {
      var data = new FormData();

      if (__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#brand-img-load')[0].files[0]) {
        data.append('image_web_file', __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#brand-img-load')[0].files[0]);
        this.upImg(data, 1);
      } else this.updatedAd();
    },
    upImg: function upImg(data, type) {
      var self = this;
      var url = '/store/' + this.$route.params.store_id + '/banner/' + this.$route.params.ad_id + '/image';
      if (data) {
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            self.updatedAd();
          }
        });
      }
    },
    updatedAd: function updatedAd() {
      var self = this;
      var info = this.getInput;
      var data = {
        name: info.name,
        url: info.url,
        start_time: this.menuTime.start.time,
        end_time: this.menuTime.end.time,
        sort: info.sort,
        is_active: this.adInfo.is_active,
        is_platform_visible: this.adInfo.is_platform_visible,
        dedicated_visible_setting: [],
        is_limit_location: this.adInfo.is_limit_location
      };
      if (this.adInfo.is_limit_location && this.adInfo.city_code_list.length) {
        data.city_code_list = this.adInfo.city_code_list.map(function (item) {
          return item.code;
        });
      }
      if (self.adInfo.is_jkos_visible === 1 || self.adInfo.is_jkos_visible === '1') {
        data.dedicated_visible_setting = [1];
      } else {
        data.dedicated_visible_setting = [];
      }
      var url = '/store/' + this.$route.params.store_id + '/banner/' + this.$route.params.ad_id;
      if (data) {
        this.getDataH('put', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            });
            self.$router.push({
              name: 'adTable',
              params: {
                brand_id: self.$route.params.brand_id,
                store_id: self.$route.params.store_id
              },
              query: {
                tab: self.bannerType
              }
            });
          }
        }, function (err) {
          self.handleError(err);
        });
      }
    },
    handleError: function handleError(err) {
      var title = '';
      var text = '';
      if (err.response.data.status === 90055) {
        title = '錯誤訊息';
        text = '目前已有一進行中的蓋版廣告，若需更換廣告，請將進行中的廣告停用，再將欲上架的廣告啟用。';
      } else {
        title = err.response.data.message;
        text = err.response.data.description;
      }
      this.$notify({
        title: title,
        text: text,
        duration: 3000,
        type: 'danger',
        width: 400
      });
    }
  }),
  created: function created() {
    if (!this.getCityOption.length) {
      this.setCityList();
    }
    this.init();
  },

  components: {
    'img-upload': __WEBPACK_IMPORTED_MODULE_5__ImgUploadTemp_vue___default.a,
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_6_vue_datepicker_vue_datepicker_es6_vue___default.a,
    VueTimepicker: __WEBPACK_IMPORTED_MODULE_7_vue2_timepicker___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getCityOption']), {
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    },
    getInput: function getInput() {
      var aInfo = this.adInfo;
      for (var key in aInfo) {
        if (!aInfo[key] && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(aInfo[key]) === 'object') aInfo[key] = ' ';
      }
      return {
        name: this.checkInput(aInfo.name.toString()),
        url: this.checkInput(aInfo.url.toString()),
        sort: this.checkInput(aInfo.sort.toString())
      };
    },
    defaultImage: function defaultImage() {
      var url = '';
      switch (this.$route.query.tab) {
        case 12:
        case 41:
          url = '';
          break;
        default:
          break;
      }
      return url;
    },
    tipsImage: function tipsImage() {
      var size = '';
      var kb = '512';
      switch (this.$route.query.tab) {
        case 12:
          size = '1000x460';
          break;
        case 41:
          size = '480x530';
          kb = '256';
          break;
        default:
          break;
      }
      return '\u5716\u7247\u5927\u5C0F\u70BA ' + size + ' ' + kb + 'KB \u5167';
    },
    title: function title() {
      var title = '';
      switch (this.$route.query.tab) {
        case 12:
          title = '平台';
          break;
        case 41:
          title = '蓋版';
          break;
        default:
          break;
      }
      return title + '\u5EE3\u544A\u8CC7\u8A0A';
    }
  }),
  watch: {
    'menuTime.start.time': function menuTimeStartTime() {
      this.endLimit = [{
        type: 'fromto',
        from: this.menuTime.start.time
      }];
    },
    'menuTime.end.time': function menuTimeEndTime() {
      this.startLimit = [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(-1, 'day').format('YYYY-MM-DD HH:mm:ss'),
        to: this.menuTime.end.time
      }];
    },
    'adInfo.foreverShow': function adInfoForeverShow(val) {
      if (val) {
        this.menuTime.end.time = '2099-12-31 00:00:00';
      }
    },
    'adInfo.is_jkos_visible': function adInfoIs_jkos_visible(val) {
      if (val === '1') {
        this.adInfo.dedicated_visible_setting = [1];
      } else {
        this.adInfo.dedicated_visible_setting = [];
      }
    }
  }
});

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_More_vue__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_More_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_elements_More_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default.a,
    More: __WEBPACK_IMPORTED_MODULE_4__components_elements_More_vue___default.a
  },
  filters: {
    status: function status(val) {
      switch (val) {
        case 'notyet':
          return '尚未開始';
        case 'going':
          return '進行中';
        case 'end':
          return '結束';
        default:
          return '';
      }
    }
  },
  data: function data() {
    return {
      bannerType: Number(this.$route.query.tab) || 12,
      selectActive: 99,
      test: '指定區域：台北市、新北市、新竹市、台中市、台中市、台中市、台中市、台中市、台中市',
      show: {
        brand: false,
        menu: false,
        schedule: false,
        history: false,
        menuDetail: false
      },
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      total: 1,
      count: 10,
      adList: [],
      searchInput: '',
      isBatchDelete: false,
      isDraggable: false,
      isLoading: true,

      searchType: 1,
      selectCity: []
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapActions */])(['setCityList']), {
    BatchDelete: function BatchDelete(type) {
      var _this = this;

      this.isBatchDelete = false;
      var formData = this.adList.filter(function (x) {
        return x.selectItem;
      }).map(function (x) {
        return x.id;
      });
      if (type && formData.length) {
        var _formData = this.adList.filter(function (x) {
          return x.selectItem;
        }).map(function (x) {
          return x.id;
        });
        var url = '/store/' + this.$route.params.store_id + '/banner/batchDelete?banner_ids=' + _formData.toString();
        this.getDataH('delete', url, null, function (response) {
          if (response.data.status === 200) {
            _this.$notify({
              title: '提醒',
              text: '刪除門市廣告成功',
              duration: 3000,
              type: 'success',
              width: 400
            });
            _this.clickPage(1);
          }
        });
      }
    },
    startBatchDelete: function startBatchDelete() {
      this.isDraggable = false;
      this.isBatchDelete = true;
    },
    startDrag: function startDrag() {
      this.isBatchDelete = false;
      this.isDraggable = true;
      this.tableIndex = 1;
      this.getAdList();
    },
    stopDrag: function stopDrag(val) {
      if (val) {
        this.setListOrder();
      } else {
        this.getAdList();
      }
      this.isDraggable = false;
    },
    setListOrder: function setListOrder() {
      var _this2 = this;

      var url = '/store/' + this.$route.params.store_id + '/banner/sortBanner';
      var data = {
        banner_id_list: this.adList.map(function (x) {
          return x.id;
        })
      };
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          _this2.$notify({
            title: '提醒',
            text: '編輯品牌網站廣告成功',
            duration: 3000,
            type: 'success',
            width: 400
          });
          _this2.getAdList();
        }
      });
    },
    timeMethodColor: function timeMethodColor(val) {
      switch (val) {
        case 'notyet':
          return 'label label-default';
        case 'going':
          return 'label label-success';
        case 'end':
          return 'label label-danger';
        default:
          return '';
      }
    },
    deleteBanner: function deleteBanner(id) {
      var _this3 = this;

      var url = '/store/' + this.$route.params.store_id + '/banner/' + id;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          _this3.$notify({
            title: '提醒',
            text: '刪除店家廣告成功',
            duration: 3000,
            type: 'success',
            width: 400
          });
          _this3.clickPage(1);
        }
      });
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.getAdList();
    },
    changeBannerType: function changeBannerType(val) {
      this.$router.replace({ query: { tab: val } });
      this.bannerType = val;
      this.tableIndex = 1;
      this.getAdList();
    },
    getAdList: function getAdList() {
      this.isLoading = true;
      var self = this;
      var data = {
        page: this.tableIndex,
        size: this.count
      };
      var url = '/store/' + this.$route.params.store_id + '/bannerList?page=' + data.page + '&size=' + data.size + '&banner_type=' + this.bannerType;
      if (parseInt(this.selectActive, 10) !== 99) url = url + '&is_active=' + this.selectActive;
      if (this.bannerType !== 41 && this.searchType === 1 && this.searchInput.trim()) {
        url = url + '&name=' + this.searchInput;
      }
      if (this.bannerType !== 41 && this.searchType === 2 && this.selectCity.length) {
        var cityCode = this.selectCity.map(function (item) {
          return item.code;
        });
        url = url + '&city_code=' + cityCode.join(',');
      }
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.adList = response.data.list;
          self.total = response.data.list_total;
          self.isLoading = false;
        }
      });
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    }
  }),
  created: function created() {
    this.getAdList(1);
    if (!this.getCityOption.length) {
      this.setCityList();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getRoleType', 'getCityOption']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    },
    cityOption: function cityOption() {
      return [{
        name: '不限',
        code: 999
      }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.getCityOption));
    }
  }),
  watch: {
    selectActive: function selectActive() {
      this.tableIndex = 1;
      this.searchInput = '';
      this.getAdList();
    }
  }
});

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ImgUploadTemp_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ImgUploadTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ImgUploadTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_timepicker__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue2_timepicker__);












/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    'info': {
      type: Object
    }
  },
  data: function data() {
    return {
      bannerType: Number(this.$route.query.tab) || 12,
      newPhoto: this.$route.query.new,
      img: {
        width: 0,
        height: 0
      },
      isCopyStore: true,
      isJkosOpen: false,
      addStoresSetting: {
        class: 'add-store',
        options: [],
        choose: []
      },
      adInfo: {
        name: '',
        url: '',
        start_time: '',
        end_time: '',
        image_web_file: '',
        sort: 1,
        is_active: 1,
        is_limit_location: 0,
        city_code_list: [],
        foreverShow: 0
      },
      storeInfo: {},
      storeClassList: [],
      curId: 0,
      reNew: 0,
      reSet: 0,

      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: ''
        }
      },
      startTime: {
        time: ''
      },
      endtime: {
        time: ''
      },
      timeoption: {
        type: 'min',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD HH:mm:ss',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'max-width': '280px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      startLimit: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(-1, 'day').format('YYYY-MM-DD HH:mm:ss')
      }],
      endLimit: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD HH:mm:ss')
      }]
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapActions */])(['setCityList']), {
    init: function init() {
      this.getStoreBrief();
    },
    getStoreBrief: function getStoreBrief() {
      this.storeBrief = [];
      this.addStoresSetting.options = [];
      var self = this;
      var url = '/brand/' + this.$route.params.brand_id + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.getStoreClassList();
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            if (parseInt(sList[i].store_id, 10) !== parseInt(self.$route.params.store_id, 10)) {
              self.storeBrief.push(obj);
              self.addStoresSetting.options.push(obj);
            }
          }
          self.reNew++;
          if (self.$route.name === 'upBrandAd') self.getAdInfo();
        }
      });
    },
    getStoreClassList: function getStoreClassList() {
      var self = this;
      var url = 'brand/' + this.$route.params.brand_id + '/storeClassList';
      if (this.getRoleType === 10) url = 'store/' + this.$route.params.brand_id + '/storeClassList';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          self.storeClassList = sList;
        }
      });
    },
    clickOption: function clickOption(option) {
      var self = this;
      this.addStoresSetting.options = [];
      self.curId = option.id;
      if (self.curId) {
        self.$nextTick(function () {
          self.reSet++;
          self.addStoresSetting.options = self.storeBrief;
          self.getCurStoreClass();
        });
      }
    },
    getCurStoreClass: function getCurStoreClass() {
      this.addStoresSetting.choose = [];
      var self = this;
      var url = 'brand/' + this.$route.params.brand_id + '/storeClass/' + this.curId;
      if (this.getRoleType === 10) url = 'store/' + this.$route.params.brand_id + '/storeClass/' + this.curId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var classInfo = response.data.class;
          classInfo.store_list.forEach(function (s) {
            self.addStoresSetting.choose.push(s.id);
          });
        }
      });
    },
    veritySort: function veritySort() {
      var e = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this.$refs.sort);
      this.adInfo.sort = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    getAdInfo: function getAdInfo() {
      var self = this;
      var url = '/brand/' + this.$route.params.brand_id + '/banner/' + this.$route.params.ad_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var adInfo = response.data.info;
          self.adInfo = {
            name: adInfo.name,
            url: adInfo.url.trim(),
            start_time: adInfo.start_time,
            end_time: adInfo.end_time,
            is_active: adInfo.is_active,
            image_web_file: adInfo.image_web,
            sort: adInfo.sort,
            foreverShow: 0,
            is_limit_location: adInfo.is_limit_location || 0,
            city_code_list: adInfo.city_code_list || []
          };
          self.isCopyStore = !!adInfo.store_list.length;
          adInfo.store_list.forEach(function (item) {
            self.addStoresSetting.choose.push(item);
          });
          self.menuTime.start.time = self.adInfo.start_time;
          self.menuTime.end.time = self.adInfo.end_time;
          if (adInfo.banner_type === 12 || adInfo.banner_type === 41) {
            self.newPhoto = true;
          }
          if (adInfo.dedicated_visible_setting.length) {
            self.isJkosOpen = adInfo.dedicated_visible_setting.includes(1);
          }
        }
      });
    },
    onFileChange: function onFileChange(e) {
      this.imgLogoSelect = '';
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var imgName = files[0].name.split('.');
      var imgSize = Math.round(files[0].size / 1000);
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (imgSize > 1024) {
        this.$notify({
          title: '提醒',
          text: '圖片檔案為' + imgSize + 'KB，請上傳小於1024KB之圖片',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.createImage(files[0]);
      }
    },
    createImage: function createImage(file) {
      var reader = new FileReader();
      var self = this;
      reader.onload = function (e) {
        var img = new Image();
        img.src = e.target.result;
        self.adInfo.image_web_file = img.src;
        img.onload = function () {
          self.img.width = img.width;
          self.img.height = img.height;
          self.checkImgSize();
        };
      };
      reader.readAsDataURL(file);
    },
    checkImgSize: function checkImgSize(type) {
      var self = this;
      if ((this.img.width !== 1280 || this.img.height !== 300) && this.img.width !== 0 && this.img.height !== 0 && !this.newPhoto && this.bannerType === 11) {
        this.$notify({
          title: '提醒',
          text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳1280x300之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if ((this.img.width !== 1000 || this.img.height !== 460) && this.img.width !== 0 && this.img.height !== 0 && this.newPhoto && this.bannerType === 12) {
        this.$notify({
          title: '提醒',
          text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳1000x460之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if ((this.img.width !== 480 || this.img.height !== 530) && this.img.width !== 0 && this.img.height !== 0 && this.newPhoto && this.bannerType === 41) {
        this.$notify({
          title: '提醒',
          text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳480x530之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      }
    },
    checkBeforeSend: function checkBeforeSend(type) {
      var all = this.getInput;
      var msg = '';
      if (!all.name) {
        msg = '請輸入廣告名稱';
      } else if (!this.menuTime.start.time) {
        msg = '請輸入開始時間';
      } else if (!this.menuTime.end.time) {
        msg = '請輸入結束時間';
      } else if (!__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#brand-img-load')[0].files[0] && type === 'cr') {
        msg = '請上傳一張圖片';
      } else if (this.isCopyStore && !this.addStoresSetting.choose.length) {
        msg = '請選擇套用門市';
      }
      this.getToast(msg, type);
    },
    getToast: function getToast(msg, type) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        if (type === 'cr') this.createdAd();else if (type === 'up') this.updatedAd();
      }
    },
    getStoreInfo: function getStoreInfo() {
      var self = this;
      var url = '/store/' + this.$route.params.store_id + '/info';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.storeInfo = response.data.info;
        }
      });
    },
    getBrandImgList: function getBrandImgList() {
      var self = this;
      var url = '/brand/' + this.$route.params.brand_id + '/storesImage?image_type=1';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var logoList = response.data.list;
          for (var i = 0; i < logoList.length; i++) {
            var option = { name: logoList[i].image_name, value: logoList[i].image_url };
            self.imgLogoOption.push(option);
          }
        }
      });
      var url2 = '/brand/' + this.$route.params.brand_id + '/storesImage?image_type=3';
      this.getDataH('get', url2, null, function (response) {
        if (response.data.status === 200) {
          var bgList = response.data.list;
          for (var j = 0; j < bgList.length; j++) {
            var option2 = { name: bgList[j].image_name, value: bgList[j].image_url };
            self.imgBgOption.push(option2);
          }
        }
      });
    },
    createdAd: function createdAd() {
      var self = this;
      var data = new FormData();
      var info = this.getInput;
      var name = info.name;
      var picUrl = info.url;
      var startTime = this.menuTime.start.time;
      var endTime = this.menuTime.end.time;
      var sort = parseInt(info.sort, 10);
      if (!picUrl) picUrl = ' ';
      if (!this.newPhoto) data.append('banner_type', 11);else data.append('banner_type', this.bannerType);
      data.append('name', name);
      data.append('url', picUrl);
      data.append('start_time', startTime);
      data.append('end_time', endTime);
      data.append('sort', sort);
      data.append('is_active', this.adInfo.is_active);

      data.append('image_web_file', __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#brand-img-load')[0].files[0]);

      data.append('is_limit_location', this.adInfo.is_limit_location);
      if (this.adInfo.is_limit_location && this.adInfo.city_code_list.length) {
        var city = this.adInfo.city_code_list.map(function (item) {
          return item.code;
        });
        if (city.length) data.append('city_code_list', city.join(','));
      }

      if (this.isCopyStore) {
        this.addStoresSetting.choose.forEach(function (id) {
          data.append('store_list[]', id);
        });
      }

      if (this.isJkosOpen) {
        data.append('dedicated_visible_setting[]', 1);
      }
      var url = '/brand/' + this.$route.params.brand_id + '/banner/newBanner';
      if (data) {
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            });

            self.$router.go(-1);
          }
        }, function (err) {
          console.error(err);
          self.handleError();
        });
      }
    },
    updatedAd: function updatedAd() {
      var self = this;
      var data = new FormData();
      var info = this.getInput;
      var name = info.name;
      var picUrl = info.url;
      var startTime = this.menuTime.start.time;
      var endTime = this.menuTime.end.time;
      var sort = parseInt(info.sort, 10);
      if (!picUrl) picUrl = ' ';
      if (!this.newPhoto) data.append('banner_type', 11);else data.append('banner_type', this.bannerType);
      data.append('name', name);
      data.append('url', picUrl);
      data.append('start_time', startTime);
      data.append('end_time', endTime);
      data.append('sort', sort);
      data.append('is_active', this.adInfo.is_active);

      data.append('is_limit_location', this.adInfo.is_limit_location);
      if (this.adInfo.is_limit_location && this.adInfo.city_code_list.length) {
        var city = this.adInfo.city_code_list.map(function (item) {
          return item.code;
        });
        if (city.length) data.append('city_code_list', city.join(','));
      }

      if (__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#brand-img-load')[0].files[0]) {
        data.append('image_web_file', __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#brand-img-load')[0].files[0]);
      }

      if (this.isCopyStore) {
        this.addStoresSetting.choose.forEach(function (id) {
          data.append('store_list[]', id);
        });
      }

      if (this.isJkosOpen) {
        data.append('dedicated_visible_setting[]', 1);
      }
      var url = '/brand/' + this.$route.params.brand_id + '/banner/' + this.$route.params.ad_id;
      if (data) {
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            });

            self.$router.go(-1);
          }
        }, function (err) {
          self.handleError(err);
        });
      }
    },
    handleError: function handleError(err) {
      var title = '';
      var text = '';
      if (err.response.data.status === 90055) {
        title = '錯誤訊息';
        text = '目前已有一進行中的蓋版廣告，若需更換廣告，請將進行中的廣告停用，再將欲上架的廣告啟用。';
      } else {
        title = err.response.data.message;
        text = err.response.data.description;
      }
      this.$notify({
        title: title,
        text: text,
        duration: 3000,
        type: 'danger',
        width: 400
      });
    }
  }),
  created: function created() {
    if (!this.getCityOption.length) {
      this.setCityList();
    }
    this.init();
  },

  components: {
    'img-upload': __WEBPACK_IMPORTED_MODULE_5__ImgUploadTemp_vue___default.a,
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_6_vue_datepicker_vue_datepicker_es6_vue___default.a,
    VueTimepicker: __WEBPACK_IMPORTED_MODULE_7_vue2_timepicker___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getCityOption']), {
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    },
    getInput: function getInput() {
      var aInfo = this.adInfo;
      for (var key in aInfo) {
        if (!aInfo[key] && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(aInfo[key]) === 'object') aInfo[key] = ' ';
      }
      return {
        name: this.checkInput(aInfo.name.toString()),
        url: this.checkInput(aInfo.url.toString()),
        sort: this.checkInput(aInfo.sort.toString())
      };
    },
    defaultImage: function defaultImage() {
      var url = '';
      switch (this.bannerType) {
        case 12:
        case 41:
          url = '';
          break;
        default:
          break;
      }
      return url;
    },
    tipsImage: function tipsImage() {
      var size = '';
      var kb = '512';
      switch (this.bannerType) {
        case 12:
          size = '1000x460';
          break;
        case 31:
          size = '720x240';
          break;
        case 41:
          size = '480x530';
          kb = '256';
          break;
        default:
          break;
      }
      return '\u5716\u7247\u5927\u5C0F\u70BA ' + size + ' ' + kb + 'KB \u5167';
    },
    title: function title() {
      var title = '';
      switch (this.bannerType) {
        case 12:
          title = '橫幅';
          break;
        case 41:
          title = '蓋版';
          break;
        default:
          break;
      }
      return title + '\u5EE3\u544A\u8CC7\u8A0A';
    }
  }),
  watch: {
    'menuTime.start.time': function menuTimeStartTime() {
      this.endLimit = [{
        type: 'fromto',
        from: this.menuTime.start.time
      }];
    },
    'menuTime.end.time': function menuTimeEndTime() {
      this.startLimit = [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(-1, 'day').format('YYYY-MM-DD HH:mm:ss'),
        to: this.menuTime.end.time
      }];
    },
    'adInfo.foreverShow': function adInfoForeverShow(val) {
      if (val) {
        this.menuTime.end.time = '2099-12-31 00:00:00';
      }
    },
    'adInfo.is_active': function adInfoIs_active() {
      if (this.adInfo.is_active === '0') {
        this.isJkosOpen = false;
      }
    }
  }
});

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_More_vue__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_More_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_elements_More_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default.a,
    More: __WEBPACK_IMPORTED_MODULE_4__components_elements_More_vue___default.a
  },
  filters: {
    status: function status(val) {
      switch (val) {
        case 'notyet':
          return '尚未開始';
        case 'going':
          return '進行中';
        case 'end':
          return '結束';
        default:
          return '';
      }
    }
  },
  data: function data() {
    return {
      bannerType: Number(this.$route.query.tab) || 12,
      isDraggable: false,
      isBatchDelete: false,
      selectActive: 99,
      show: {
        brand: false,
        menu: false,
        schedule: false,
        history: false,
        menuDetail: false
      },
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      total: 1,
      count: 20,
      adList: [],
      searchInput: '',
      isLoading: true,

      searchType: 1,
      selectCity: []
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapActions */])(['setCityList']), {
    BatchDelete: function BatchDelete(type) {
      var _this = this;

      this.isBatchDelete = false;
      var formData = this.adList.filter(function (x) {
        return x.selectItem;
      }).map(function (x) {
        return x.id;
      });
      if (type && formData.length) {
        var url = '/brand/' + this.$route.params.brand_id + '/banner/batchDelete?banner_ids=' + formData.toString();
        this.getDataH('delete', url, null, function (response) {
          if (response.data.status === 200) {
            _this.$notify({
              title: '提醒',
              text: '刪除品牌廣告成功',
              duration: 3000,
              type: 'success',
              width: 400
            });
            _this.clickPage(1);
          }
        });
      }
    },
    startBatchDelete: function startBatchDelete() {
      this.isDraggable = false;
      this.isBatchDelete = true;
    },
    timeMethodColor: function timeMethodColor(val) {
      switch (val) {
        case 'notyet':
          return 'label label-default';
        case 'going':
          return 'label label-success';
        case 'end':
          return 'label label-danger';
        default:
          return '';
      }
    },
    changeBannerType: function changeBannerType(val) {
      this.$router.replace({ query: { tab: val } });
      this.bannerType = val;
      this.tableIndex = 1;
      this.getAdList();
    },
    setListOrder: function setListOrder() {
      var _this2 = this;

      var url = '/brand/' + this.$route.params.brand_id + '/banner/sortBanner';
      var data = {
        banner_id_list: this.adList.map(function (x) {
          return x.id;
        })
      };
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          _this2.$notify({
            title: '提醒',
            text: '編輯品牌網站廣告成功',
            duration: 3000,
            type: 'success',
            width: 400
          });
          _this2.getAdList();
        }
      });
    },
    stopDrag: function stopDrag(val) {
      if (val) {
        this.setListOrder();
      } else {
        this.getAdList();
      }
      this.isDraggable = false;
    },
    startDrag: function startDrag() {
      this.isBatchDelete = false;
      this.isDraggable = true;
      this.tableIndex = 1;
      this.getAdList();
    },
    deleteBanner: function deleteBanner(id) {
      var _this3 = this;

      var url = '/brand/' + this.$route.params.brand_id + '/banner/' + id;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          _this3.$notify({
            title: '提醒',
            text: '刪除品牌廣告成功',
            duration: 3000,
            type: 'success',
            width: 400
          });
          _this3.clickPage(1);
        }
      });
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.getAdList();
    },
    getAdList: function getAdList() {
      this.isLoading = true;
      var self = this;
      var data = {
        page: this.tableIndex,
        size: this.count
      };
      var url = '/brand/' + this.$route.params.brand_id + '/banner/list?page=' + data.page + '&size=' + data.size + '&banner_type=' + this.bannerType;
      if (parseInt(this.selectActive, 10) !== 99) url = url + '&is_active=' + this.selectActive;
      if (this.bannerType !== 41 && this.searchType === 1 && this.searchInput.trim()) {
        url = url + '&name=' + this.searchInput;
      }
      if (this.bannerType !== 41 && this.searchType === 2 && this.selectCity.length) {
        var cityCode = this.selectCity.map(function (item) {
          return item.code;
        });
        url = url + '&city_code=' + cityCode.join(',');
      }
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.adList = response.data.list.map(function (x, index) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, x, {
              index: index + 1
            });
          });
          self.total = response.data.list_total;
          self.isLoading = false;
        }
      });
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    }
  }),
  created: function created() {
    this.getAdList(1);
    if (!this.getCityOption.length) {
      this.setCityList();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getCityOption']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    },
    cityOption: function cityOption() {
      return [{
        name: '不限',
        code: 999
      }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.getCityOption));
    }
  }),
  watch: {
    selectActive: function selectActive() {
      this.tableIndex = 1;
      this.searchInput = '';
      this.getAdList();
    }
  }
});

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__elements_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    'info': {
      type: Object
    }
  },
  components: {
    'm-modal': __WEBPACK_IMPORTED_MODULE_3__elements_Modal_vue___default.a
  },
  data: function data() {
    return {
      brandName: '',
      brandType: '',
      tab: 1,
      tabTotal: 2,
      image: '',
      img: {
        width: 0,
        height: 0
      },
      mealTagList: [],
      brandInfo: {
        binding_meal_tag_ids: [],
        brand_code: '',
        brand_key: '',
        name: '',
        name_short: '',
        slogan: '',
        comment: '',
        description: '',
        is_visible: 1,
        image_name: '',
        logo_name: '',
        email: '',
        youtube_video_code: '',
        introduction: '',
        order_commission_setting: {
          allow_invalid_order_quota: 0
        },
        main_color_code: '#000000',
        sub_color_code: '#000000',
        clear_main_color_code: 1,
        clear_sub_color_code: 1,
        name_alias: [] },
      delOption: {
        id: 'delModal',
        title: '刪除品牌',
        body: '刪除某一品牌，此處刪除只會標註刪除，不會真的在資料庫移除。另外，此品牌無店家才可刪除！',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delBrand'
        }]
      },
      typeOptions: [{ label: '官網', value: 1, url: '' }, { label: 'Facebook', value: 2, url: '' }, { label: 'Instagram', value: 3, url: '' }, { label: 'Line', value: 4, url: '' }],
      select: {
        websiteSetting: []
      },
      reNew: 0,
      reSet: 0,
      addStoresSetting: {
        class: 'add-store',
        options: [],
        choose: []
      },
      isCopyStore: true,

      independentStoreList: [],
      isLoading: false,
      total: 0,
      count: 10,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      allowRestric: false,
      nameAliasList: [{ label: '無指定',
        value: ''
      }]
    };
  },

  watch: {
    '$route.query.tab': function $routeQueryTab(val) {
      if (!val) return;
      this.tab = val;
    }
  },
  methods: {
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.getList();
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    trigger: function trigger(event) {
      if (event === 'delBrand') {
        this.delBrand();
      }
    },
    delBrand: function delBrand() {
      var self = this;
      var url = '/brand/' + this.$route.params.brand_id;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.push('/brandTable');
        }
      });
    },
    init: function init() {
      var self = this;
      if (typeof this.info !== 'undefined') {
        if (this.getRoleType === 99) {
          this.getMealTagList(function () {
            self.getBrandInfo();
          });
        } else this.getBrandInfo();
      } else this.getMealTagList(function () {});
      if (this.$route.name !== 'crBrand') {
        this.getStoreBrief();
      }
    },
    getStoreBrief: function getStoreBrief() {
      this.storeBrief = [];
      this.addStoresSetting.options = [];
      var self = this;
      var url = '/brand/' + this.$route.params.brand_id + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            if (parseInt(sList[i].store_id, 10) !== parseInt(self.$route.params.store_id, 10)) {
              self.storeBrief.push(obj);
              self.addStoresSetting.options.push(obj);
            }
          }
          self.reNew++;
        }
      });
    },
    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var imgName = files[0].name.split('.');
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.createImage(files[0], 1);
      }
    },
    onPhotoFileChange: function onPhotoFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var imgName = files[0].name.split('.');
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.createImage(files[0], 3);
      }
    },
    onLogoFileChange: function onLogoFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var imgName = files[0].name.split('.');
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png|svg)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.createImage(files[0], 2);
      }
    },
    createImage: function createImage(file, method) {
      var reader = new FileReader();
      var self = this;
      reader.onload = function (e) {
        var img = new Image();
        img.src = e.target.result;
        if (method === 1) self.brandInfo.image_name = img.src;else if (method === 2) self.brandInfo.logo_name = img.src;else if (method === 3) self.brandInfo.photo_name = img.src;
        img.onload = function () {
          self.img.width = img.width;
          self.img.height = img.height;
          self.checkImgSize(null, method);
        };
      };
      reader.readAsDataURL(file, method);
    },
    checkImgSize: function checkImgSize(type, method) {
      var self = this;
      if ((this.img.width !== 200 || this.img.height !== 200) && this.img.width !== 0 && this.img.height !== 0 && method === 1) {
        this.$notify({
          title: '提醒',
          text: 'LOGO尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳200x200之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if ((this.img.width !== 300 || this.img.height !== 90) && this.img.width !== 0 && this.img.height !== 0 && method === 2) {
        this.$notify({
          title: '提醒',
          text: '聯名尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳300x90之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if ((this.img.width !== 800 || this.img.height !== 460) && this.img.width !== 0 && this.img.height !== 0 && method === 3) {
        this.$notify({
          title: '提醒',
          text: '底圖照片寸為' + self.img.width + 'x' + self.img.height + '，請上傳800x460之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (type === 'cr') {
        if (this.getRoleType === 99 || this.getRoleType === 30) {
          this.createdBrand();
        }
      } else if (type === 'up') {
        if (this.getRoleType === 99 || this.getRoleType === 30) {
          if (__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#brand-logo-load')[0].files[0]) this.updatedLogo('up');else if (__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#brand-img-load')[0].files[0]) this.updatedIcon();else if (__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#brand-photo-load')[0].files[0] || this.addStoresSetting.choose.length > 0 && this.isCopyStore) this.updatedPhoto();else this.updatedBrand();
        }
      }
    },
    verityCode: function verityCode() {
      var e = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#brand-code');
      this.brandInfo.brand_code = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[a-z0-9]*/));
      }
    },
    verityKey: function verityKey() {
      var e = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#brand-key');
      this.brandInfo.brand_key = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    checkInputEmpty: function checkInputEmpty(type) {
      var title = '';
      var text = '';
      if (type === 'cr' || this.tab === 1) {
        if (!this.getInput.brand_code && this.getRoleType === 99) {
          title = '請填寫代碼';
          text = '代碼為英文小寫與數字的組合！';
        } else if (this.getInput.brand_code.length < 6 && this.getRoleType === 99) {
          title = '提醒';
          text = '代碼須為6~12字，英文小寫與數字的組合！';
        } else if (!this.getInput.name && this.getRoleType === 99) {
          title = '提醒';
          text = '請填寫名稱！';
        } else if (!this.getInput.name_short && this.getRoleType === 99) {
          title = '提醒';
          text = '請填寫縮寫名稱！';
        } else if (this.getInput.email && this.isEmailFalse(this.getInput.email)) {
          title = '提醒';
          text = '請填寫正確的電子信箱！';
        } else if (this.select.websiteSetting.length && this.websiteFalse()) {
          title = '提醒';
          text = '請填寫正確的品牌資訊！';
        }
      } else if (type === 'cr' || this.tab === 2) {
        if (this.getRoleType === 99 && this.brandInfo.order_commission_setting.allow_invalid_order_quota === '') {
          title = '提醒';
          text = '請填寫每月作廢訂單額度！';
        }
      }
      if (title && text) {
        this.$notify({
          title: title,
          text: text,
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        if (![30, 99].includes(this.getRoleType) || type === 'up' && this.tab === 2) {
          this.updatedBrand();
        } else {
          this.checkImgSize(type);
        }
      }
    },
    changeTab: function changeTab(index) {
      this.tab = index;
      var query = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.$route.query);
      this.$router.replace({ query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, query, {
          tab: index
        }) });
    },
    websiteFalse: function websiteFalse() {
      var wList = this.select.websiteSetting;
      var parseUrl = /^(?:([A-Za-z]+):)?(\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/;
      for (var i = 0; i < wList.length; i++) {
        if (!wList[i].url) return true;else if (wList[i].url) {
          if (wList[i].url.search(parseUrl) === -1) {
            return true;
          }
        }
      }
      return false;
    },
    isEmailFalse: function isEmailFalse(email) {
      var emailRule = /^[^\s]+@[^\s]+\.[^\s]{2,}$/;
      if (email) {
        if (email.search(emailRule) !== -1) return false;else return true;
      }
      return false;
    },
    createdBrand: function createdBrand() {
      var self = this;
      var data = new FormData();
      data.append('brand_code', this.getInput.brand_code);
      data.append('name', this.getInput.name);
      data.append('is_visible', this.brandInfo.is_visible);
      data.append('order_commission_setting', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.brandInfo.order_commission_setting));
      var ids = this.brandInfo.binding_meal_tag_ids.map(function (item) {
        return item.value;
      });

      data.append('clear_main_color_code', this.brandInfo.clear_main_color_code);
      data.append('clear_sub_color_code', this.brandInfo.clear_sub_color_code);
      if (!this.brandInfo.clear_main_color_code) data.append('main_color_code', this.brandInfo.main_color_code.replace('#', ''));
      if (!this.brandInfo.clear_sub_color_code) data.append('sub_color_code', this.brandInfo.sub_color_code.replace('#', ''));

      if (this.brandInfo.binding_meal_tag_ids.length) data.append('binding_meal_tag_ids', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ids));
      if (this.getInput.brand_key) data.append('brand_key', this.getInput.brand_key);
      if (this.getInput.name_short) data.append('name_short', this.getInput.name_short);
      if (this.getInput.slogan) data.append('slogan', this.getInput.slogan);
      if (this.getInput.comment) data.append('comment', this.getInput.comment);
      if (this.getInput.description) data.append('description', this.getInput.description);
      if (this.getInput.email) data.append('email', this.getInput.email);
      if (this.getInput.youtube_video_code) data.append('youtube_video_code', this.getInput.youtube_video_code);
      if (this.getInput.introduction) data.append('introduction', this.getInput.introduction);

      if (this.brandInfo.name_alias && Array.isArray(this.brandInfo.name_alias) && this.brandInfo.name_alias.length > 0) {
        var aliasStr = this.brandInfo.name_alias.map(function (item) {
          return item.value;
        }).join(',');
        data.append('name_alias', aliasStr);
      }
      if (this.select.websiteSetting.length) {
        var settingList = [];
        this.select.websiteSetting.forEach(function (setting) {
          var obj = { type: setting.value, url: setting.url };
          settingList.push(obj);
        });
        data.append('website_setting', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(settingList));
      }
      if (__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#brand-img-load')[0].files[0]) data.append('image_file', __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#brand-img-load')[0].files[0]);
      if (__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#brand-logo-load')[0].files[0]) data.append('logo_file', __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#brand-logo-load')[0].files[0]);
      if (__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#brand-photo-load')[0].files[0]) data.append('photo_file', __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#brand-photo-load')[0].files[0]);
      var url = '/brand/';
      if (data) {
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            });

            self.$router.go(-1);
          }
        });
      }
    },
    updatedLogo: function updatedLogo(method) {
      var self = this;
      var data = new FormData();
      data.append('image_file', __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#brand-logo-load')[0].files[0]);
      var url = '/brand/' + this.$route.params.brand_id + '/logo';
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          if (method === 'cr') self.createdBrand();else if (method === 'up') {
            if (__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#brand-img-load')[0].files[0]) self.updatedIcon();else if (__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#brand-photo-load')[0].files[0]) this.updatedPhoto();else if (self.getRoleType === 99) self.updatedBrand();else {
              self.$notify({
                title: response.data.message,
                text: response.data.description,
                duration: 3000,
                type: 'success',
                width: 400
              });

              self.$router.go(-1);
            }
          }
        }
      });
    },
    updatedIcon: function updatedIcon() {
      var self = this;
      var data = new FormData();
      data.append('image_file', __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#brand-img-load')[0].files[0]);
      var url = '/brand/' + this.$route.params.brand_id + '/icon';
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          if (__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#brand-photo-load')[0].files[0]) self.updatedPhoto();else if (self.getRoleType === 99 || self.getRoleType === 30) self.updatedBrand();else {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            });

            self.$router.go(-1);
          }
        }
      });
    },
    updatedPhoto: function updatedPhoto() {
      var self = this;
      var data = new FormData();
      if (__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#brand-photo-load')[0].files[0]) {
        data.append('image_file', __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#brand-photo-load')[0].files[0]);
      }
      if (this.addStoresSetting.choose.length > 0) {
        data.append('store_list', this.addStoresSetting.choose.toString());
      }
      var url = '/brand/' + this.$route.params.brand_id + '/photo';
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          if (self.getRoleType === 99 || self.getRoleType === 30) self.updatedBrand();else {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            });

            self.$router.go(-1);
          }
        }
      });
    },
    updatedBrand: function updatedBrand() {
      var self = this;
      var data = {};
      if (this.tab === 1) {
        var ids = this.brandInfo.binding_meal_tag_ids.map(function (item) {
          return item.value;
        });
        data = {
          brand_key: this.getInput.brand_key,
          brand_code: this.getInput.brand_code,
          name: this.getInput.name,
          is_visible: this.brandInfo.is_visible,
          name_short: this.getInput.name_short,
          slogan: this.getInput.slogan,
          comment: this.getInput.comment,
          description: this.getInput.description,
          youtube_video_code: this.getInput.youtube_video_code,
          introduction: this.getInput.introduction,
          binding_meal_tag_ids: ids
        };

        if (this.brandInfo.name_alias && Array.isArray(this.brandInfo.name_alias) && this.brandInfo.name_alias.length > 0) {
          data['name_alias'] = this.brandInfo.name_alias.map(function (item) {
            return item.value;
          }).join(',');
        } else {
          data['name_alias'] = '';
        }
        if (this.getInput.email) data['email'] = this.getInput.email;

        if (!this.brandInfo.clear_main_color_code) data['main_color_code'] = this.brandInfo.main_color_code.replace('#', '');
        if (!this.brandInfo.clear_sub_color_code) data['sub_color_code'] = this.brandInfo.sub_color_code.replace('#', '');
        data['clear_main_color_code'] = this.brandInfo.clear_main_color_code;
        data['clear_sub_color_code'] = this.brandInfo.clear_sub_color_code;

        var settingList = [];
        this.select.websiteSetting.forEach(function (setting) {
          var obj = { type: setting.value, url: setting.url };
          settingList.push(obj);
        });
        data['website_setting'] = settingList;
      } else if (this.tab === 2) {
        data['order_commission_setting'] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.brandInfo.order_commission_setting);
      }
      var url = '/brand/' + this.$route.params.brand_id;
      if (data) {
        this.getDataH('put', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            });
          }
        });
      }
    },
    getMealTagList: function getMealTagList(callback) {
      var self = this;
      var url = '/mealTag/listBrief?is_visible=1';
      self.mealTagList = [];
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          response.data.list.forEach(function (tag) {
            var obj = {
              label: tag.name,
              value: tag.tag_id
            };
            self.mealTagList.push(obj);
          });
          callback();
        }
      });
    },
    getBrandInfo: function getBrandInfo() {
      var _this = this;

      var url = '/brand/' + this.$route.params.brand_id;
      this.select.websiteSetting = [];
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this.brandInfo = response.data.brand_info;
          _this.$set(_this.brandInfo, 'binding_meal_tag_ids', []);
          if (_this.brandInfo.meal_tag_setting) {
            _this.brandInfo.meal_tag_setting.forEach(function (setting) {
              var obj = { value: setting.tag_id, label: setting.name };
              var hasTag = _this.mealTagList.find(function (mealTag) {
                return mealTag.value === setting.tag_id;
              });
              if (hasTag) {
                _this.brandInfo.binding_meal_tag_ids.push(obj);
              }
            });
          }
          _this.brandInfo.website_setting.forEach(function (setting) {
            var obj = { value: setting.type, url: setting.url, label: '' };
            obj.label = _this.typeOptions.find(function (typeO) {
              return setting.type === typeO.value;
            }).label;
            _this.select.websiteSetting.push(obj);
          });
          if (_this.brandInfo.photo_store_list && _this.brandInfo.photo_store_list.length > 0) {
            _this.addStoresSetting.choose = _this.brandInfo.photo_store_list.map(function (x) {
              return x.store_id;
            });
          }

          var mainColor = _this.brandInfo.main_color_code;
          var subColor = _this.brandInfo.sub_color_code;
          if (mainColor) {
            _this.brandInfo.main_color_code = '#' + mainColor;
            _this.brandInfo.clear_main_color_code = 0;
          } else {
            _this.brandInfo.clear_main_color_code = 1;
          }
          if (subColor) {
            _this.brandInfo.sub_color_code = '#' + subColor;
            _this.brandInfo.clear_sub_color_code = 0;
          } else {
            _this.brandInfo.clear_sub_color_code = 1;
          }

          if (_this.brandInfo.name_alias && Array.isArray(_this.brandInfo.name_alias)) {
            _this.brandInfo.name_alias = _this.brandInfo.name_alias.map(function (alias) {
              if (typeof alias === 'string') {
                return { label: alias, value: alias };
              }
              return alias;
            });

            _this.brandInfo.name_alias.forEach(function (aliasObj) {
              var exists = _this.nameAliasList.some(function (item) {
                return item.value === aliasObj.value;
              });
              if (!exists) {
                _this.nameAliasList.push(aliasObj);
              }
            });
          } else if (!_this.brandInfo.name_alias) {
            _this.brandInfo.name_alias = [];
          }
        }
      });
    },
    getStoreQuota: function getStoreQuota() {
      var _this2 = this;

      var url = '/brand/' + this.$route.params.brand_id + '/independentStoreList?page=' + this.tableIndex + '&size=' + this.count;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this2.independentStoreList = response.data.list;
        }
      });
    },
    addAliasTag: function addAliasTag(newTag) {
      var tag = {
        label: newTag,
        value: newTag
      };
      var existsInList = this.nameAliasList.some(function (item) {
        return item.value === newTag;
      });
      if (!existsInList) {
        this.nameAliasList.push(tag);
      }
      this.brandInfo.name_alias.push(tag);
    }
  },
  created: function created() {
    this.init();
    if (!this.info && !this.hasCommissionPermission) {
      this.tabTotal = 1;
    }
    if (this.getRoleType === 99 && this.info) {
      this.getStoreQuota();
      if (this.$route.query.tab) {
        this.tab = parseInt(this.$route.query.tab, 10);
      }
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['getRoleType', 'getRestricted']), {
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getInput: function getInput() {
      var bInfo = this.brandInfo;
      return {
        brand_key: this.checkInput(bInfo.brand_key),
        brand_code: this.checkInput(bInfo.brand_code),
        name: this.checkInput(bInfo.name),
        name_short: this.checkInput(bInfo.name_short),
        slogan: this.checkInput(bInfo.slogan),
        comment: this.checkInput(bInfo.comment),
        description: this.checkInput(bInfo.description),
        email: this.checkInput(bInfo.email),
        youtube_video_code: this.checkInput(bInfo.youtube_video_code),
        introduction: this.checkInput(bInfo.introduction)
      };
    },
    hasCommissionPermission: function hasCommissionPermission() {
      return this.getRestricted.includes(900);
    },

    orderCommissionSetting: {
      get: function get() {
        var def = {
          quota_type: 0,
          allow_invalid_order_quota: 0,
          store_allow_invalid_order_quota: 0,
          default_allow_invalid_order_quota: 0,
          default_store_allow_invalid_order_quota: 0 };
        return this.brandInfo.order_commission_setting || def;
      },
      set: function set(val) {
        console.log('orderCommissionSetting', val);
        this.brandInfo.order_commission_setting = val;
      }
    }
  })
});

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BrandTableTemp',
  data: function data() {
    return {
      show: {
        activity: false,
        brand: false,
        history: false,
        isDownloading: false,
        menu: false,
        menuDetail: false,
        schedule: false
      },
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      total: 1,
      count: 10,
      brandList: [],
      searchResult: '',
      isLoading: true,
      retry: 0,
      retryTimer: null,
      retryFrequency: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    },
    webDomain: function webDomain() {
      return this.$config.web;
    }
  }),
  created: function created() {
    var path = this.$route.name;
    if (this.$route.query.name) this.searchResult = this.$route.query.name;
    if (this.$route.query.page) this.tableIndex = this.$route.query.page;
    if (path === 'brandTable') this.show.brand = true;else if (path === 'menuTable') this.show.menu = true;else if (path === 'scheduleTable') this.show.schedule = true;else if (path === 'brandHistoryTable') this.show.history = true;else if (path === 'menuDetailTable') this.show.menuDetail = true;else if (path === 'brandActivityTable') this.show.activity = true;
    this.getBrandList();
  },
  mounted: function mounted() {
    this.$refs.brandPaginate.tableIndex = this.tableIndex;
    this.$refs.brandPaginate.pageGroup = this.pageGroup;
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['setBrandId', 'setBrands']), {
    isActive: function isActive(index) {
      if (Number(this.tableIndex) === index) return true;else return false;
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.getBrandList();
    },
    exportFile: function exportFile() {
      var _this = this;

      console.log({
        component: this.$options.name,
        function: 'exportFile',
        payload: {},
        time: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY/MM/DD HH:mm:ss')
      });

      this.isDownloading = true;
      var query = this.$route.query;
      var searchParams = '';
      if (query.page) delete query.page;
      if (query.size) delete query.size;
      if (this.retry === 1) query.retry = 1;
      if (query && (typeof query === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(query)) === 'object' && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(query).length) searchParams = new URLSearchParams(query);
      var url = '/brand/brandListSheetSche' + (searchParams.toString() ? '?' + searchParams.toString() : '');
      this.getDataH('get', url, null, function (res) {
        if (res.data.sche_info.status === 3) {
          _this.show.isDownloading = false;
          _this.retry = 0;
          var el = document.createElement('a');
          el.href = res.data.sche_info.file_url;
          el.download = '\u54C1\u724C\u9580\u5E02\u5831\u8868.zip';
          document.body.appendChild(el);
          el.click();
          clearTimeout(_this.retryTimer);
          _this.retryFrequency = 0;
        } else if (res.data.sche_info.status === 9) {
          _this.show.isDownloading = false;
          if (_this.retryFrequency > 3) {
            alert('請聯絡客服或等24小時候再試');
            return false;
          }
          var yes = confirm('輸出未完成，請聯絡客服或再試一次。');
          if (yes) _this.retryFrequency++;
          clearTimeout(_this.retryTimer);
        } else {
          _this.retry = 1;
          _this.retryTimer = setTimeout(_this.exportFile, 6000);
        }
      });
    },
    getBrandList: function getBrandList() {
      var _this2 = this;

      this.isLoading = true;
      var data = {
        page: this.tableIndex,
        size: this.count
      };
      var url = '/brand/list?size=' + data.size;
      var queryValue = {};
      if (this.searchResult) {
        if (this.$route.query.name !== this.searchResult) this.tableIndex = 1;
        queryValue = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, queryValue, { name: this.searchResult });
        url = url + ('&name=' + this.searchResult);
      }
      if (this.tableIndex) {
        queryValue = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, queryValue, { page: this.tableIndex });
        url = url + ('&page=' + this.tableIndex);
      }
      this.$router.replace({ query: queryValue });
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this2.brandList = response.data.list;
          if (response.data.list && response.data.list.length) {
            _this2.$store.commit('SET_BRAND_ID', response.data.list[0].id);
            _this2.$store.commit('SET_BRANDS', response.data.list);
          }
          _this2.total = response.data.list_total;
          _this2.isLoading = false;
        }
      });
    }
  })
});

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ImgUploadTemp_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ImgUploadTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ImgUploadTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_timepicker__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_timepicker__);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    'info': {
      type: Object
    }
  },
  data: function data() {
    return {
      bindingStoreList: [],
      imgLogoOption: [],
      imgBgOption: [],
      storeBrief: [],
      imgLogoSelect: '',
      imgBgSelect: '',
      img: {
        width: 0,
        height: 0
      },
      bgImg: {
        width: 0,
        height: 0
      },
      deliveryOther: [],
      storeInfo: {
        image_name: '',
        bg_image_name: ''
      },
      iconTypeSelect: 1,
      iconTypeList: [{ value: 1, label: 'logo' }, { value: 4, label: '照片底圖' }]
    };
  },

  methods: {
    init: function init() {
      this.getBrandImgList();
      this.getStoreBrief();
    },
    onFileChange: function onFileChange(e) {
      this.imgLogoSelect = '';
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var imgName = files[0].name.split('.');
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.createImage(files[0]);
      }
    },
    createImage: function createImage(file) {
      var reader = new FileReader();
      var self = this;
      reader.onload = function (e) {
        var img = new Image();
        img.src = e.target.result;
        if (self.storeInfo.image) self.storeInfo.image = img.src;
        self.storeInfo.image_name = img.src;
        img.onload = function () {
          self.img.width = img.width;
          self.img.height = img.height;
          self.checkImgSize();
        };
      };
      reader.readAsDataURL(file);
    },
    checkImgSize: function checkImgSize(type) {
      var self = this;
      if (this.iconTypeSelect === 1 && (this.img.width !== 200 || this.img.height !== 200) && this.img.width !== 0 && this.img.height !== 0) {
        this.$notify({
          title: '提醒',
          text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳200x200之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (this.iconTypeSelect === 4 && (this.img.width !== 800 || this.img.height !== 460) && this.img.width !== 0 && this.img.height !== 0) {
        this.$notify({
          title: '提醒',
          text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳800x460之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      }
    },
    onBgChange: function onBgChange(e) {
      this.imgBgSelect = '';
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var imgName = files[0].name.split('.');
      var imgSize = Math.round(files[0].size / 1000);
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (imgSize > 1024) {
        this.$notify({
          title: '提醒',
          text: '圖片檔案為' + imgSize + 'KB，請上傳小於1024KB之圖片',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.createBgImage(files[0]);
      }
    },
    createBgImage: function createBgImage(file) {
      var reader = new FileReader();
      var self = this;
      reader.onload = function (e) {
        var img = new Image();
        img.src = e.target.result;
        if (self.storeInfo.bg_image) self.storeInfo.bg_image = img.src;
        self.storeInfo.bg_image_name = img.src;
        img.onload = function () {
          self.bgImg.width = img.width;
          self.bgImg.height = img.height;
          self.checkBgImgSize();
        };
      };
      reader.readAsDataURL(file);
    },
    checkBgImgSize: function checkBgImgSize(type) {
      var self = this;
      if ((this.bgImg.width !== 625 || this.bgImg.height !== 300) && this.bgImg.width !== 0 && this.bgImg.height !== 0) {
        this.$notify({
          title: '提醒',
          text: '圖片尺寸為' + self.bgImg.width + 'x' + self.bgImg.height + '，請上傳625x300之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (type === 'cr') {} else if (type === 'up') {}
    },
    getStoreBrief: function getStoreBrief() {
      this.storeBrief = [];
      var self = this;
      var url = '/brand/' + this.$route.params.brand_id + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
            if (i === 0) self.copyStoreSelect = sList[i].store_id;
          }
        }
      });
    },
    getBrandImgList: function getBrandImgList() {
      var self = this;
      var url = '/brand/' + this.$route.params.brand_id + '/storesImage?image_type=1';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var logoList = response.data.list;
          for (var i = 0; i < logoList.length; i++) {
            var option = { name: logoList[i].image_name, value: logoList[i].image_url };
            self.imgLogoOption.push(option);
          }
        }
      });
      var url2 = '/brand/' + this.$route.params.brand_id + '/storesImage?image_type=3';
      this.getDataH('get', url2, null, function (response) {
        if (response.data.status === 200) {
          var bgList = response.data.list;
          for (var j = 0; j < bgList.length; j++) {
            var option2 = { name: bgList[j].image_name, value: bgList[j].image_url };
            self.imgBgOption.push(option2);
          }
        }
      });
    },
    updatedLogoImg: function updatedLogoImg() {
      var data = new FormData();

      if (this.imgLogoSelect) {
        data.append('image_name', this.imgLogoSelect);
        this.upImg(data, 1);
      } else if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#brand-img-load')[0].files[0]) {
        data.append('image_file', __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#brand-img-load')[0].files[0]);
        this.upImg(data, 1);
      } else this.updatedBgImg();
    },
    upImg: function upImg(data, type) {
      var self = this;
      var imgType = type;
      if (type === 1 && this.iconTypeSelect !== 1) imgType = this.iconTypeSelect;
      data.append('image_type', imgType);

      var string = '';
      for (var i = 0; i < this.bindingStoreList.length; i++) {
        string = string + this.bindingStoreList[i].value + ',';
      }
      string = string.slice(0, -1);
      if (string) data.append('exception_stores', string);
      var url = '/brand/' + this.$route.params.brand_id + '/storesImage';
      if (data) {
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            if (type === 1) {
              self.$notify({
                title: '更新成功',
                text: '更新成功',
                duration: 3000,
                type: 'success',
                width: 400
              });
              self.$router.replace({ path: '/storeTable/' + self.$route.params.brand_id });
            }
          }
        });
      }
    },
    updatedBgImg: function updatedBgImg() {
      var data = new FormData();

      if (this.imgBgSelect) {
        data.append('image_name', this.imgBgSelect);
        this.upImg(data, 3);
      } else if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#bg-img-load')[0].files[0]) {
        data.append('image_file', __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#bg-img-load')[0].files[0]);
        this.upImg(data, 3);
      } else {
        this.$notify({
          title: '更新成功',
          text: '更新成功',
          duration: 3000,
          type: 'success',
          width: 400
        });
        this.$router.replace({ path: '/storeTable/' + this.$route.params.brand_id });
      }
    }
  },
  created: function created() {
    this.init();
  },

  components: {
    'img-upload': __WEBPACK_IMPORTED_MODULE_2__ImgUploadTemp_vue___default.a,
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_3_vue_datepicker_vue_datepicker_es6_vue___default.a,
    VueTimepicker: __WEBPACK_IMPORTED_MODULE_4_vue2_timepicker___default.a
  },
  computed: {
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    },
    getInput: function getInput() {
      var sInfo = this.storeInfo;
      for (var key in sInfo) {
        if (!sInfo[key] && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(sInfo[key]) === 'object') sInfo[key] = '';
      }
      return {
        branch_code: this.checkInput(sInfo.branch_code.toString()),
        pos_branch_code: this.checkInput(sInfo.pos_branch_code.toString()),
        name: this.checkInput(sInfo.name.toString()),
        name_short: this.checkInput(sInfo.name_short.toString()),
        description: this.checkInput(sInfo.description.toString()),
        comment: this.checkInput(sInfo.comment.toString()),
        ein: this.checkInput(sInfo.ein.toString()),
        bl_name: this.checkInput(sInfo.bl_name.toString()),
        address_short: this.checkInput(sInfo.address_short.toString()),
        tel: this.checkInput(sInfo.tel.toString()),
        tel2: this.checkInput(sInfo.tel2.toString()),
        email: this.checkInput(sInfo.email.toString()),
        one_order_max_money: this.checkInput(sInfo.one_order_max_money.toString()),
        to_store_pay_max_money: this.checkInput(sInfo.to_store_pay_max_money.toString()),
        order_start_time_m: this.checkInput(sInfo.order_start_time_m.toString()),
        order_end_time_m: this.checkInput(sInfo.order_end_time_m.toString()),
        auto_reject_order_m: this.checkInput(sInfo.auto_reject_order_m.toString())
      };
    }
  },
  watch: {
    citySelect: function citySelect() {
      var cityCode = parseInt(this.citySelect, 10);
      var cityElement = this.cityAreaList.find(function (e, i, o) {
        return e.city_code === cityCode;
      });
      var areaList = cityElement.area_list;
      for (var i = 0; i < areaList.length; i++) {
        var option = { name: areaList[i].name, value: areaList[i].area_code };
        this.areaOption.push(option);
        if (i === 0 && this.$route.name !== 'upStore') this.areaSelect = areaList[i].area_code;
      }
      if (this.$route.name === 'upStore') this.areaSelect = this.storeInfo.area_code;
    },
    imgLogoSelect: function imgLogoSelect() {
      var self = this;
      if (self.imgLogoSelect) {
        var imgSrc = this.imgLogoOption.find(function (e) {
          return e.name === self.imgLogoSelect;
        }).value;
        this.storeInfo.image_name = imgSrc;
      }
    },
    imgBgSelect: function imgBgSelect() {
      var self = this;
      if (self.imgBgSelect) {
        var imgSrc = this.imgBgOption.find(function (e) {
          return e.name === self.imgBgSelect;
        }).value;
        this.storeInfo.bg_image_name = imgSrc;
      }
    },
    'deliveryWaysInfo': function deliveryWaysInfo() {
      this.checkOtherDelivery();
    }
  }
});

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ImgUploadTemp_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ImgUploadTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ImgUploadTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_timepicker__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_timepicker__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    'info': {
      type: Object
    }
  },
  data: function data() {
    return {
      bindingStoreList: [],
      storeBrief: [],
      syncBannerTypeList: Number(this.$route.query.tab) || [],
      addStoresSetting: {
        class: 'copy-store',
        options: [],
        choose: []
      },
      storeClassList: [],
      curId: 0,
      reNew: 0,
      reSet: 0
    };
  },

  methods: {
    init: function init() {
      this.getStoreBrief();
    },
    getStoreBrief: function getStoreBrief() {
      this.storeBrief = [];
      this.addStoresSetting.options = [];
      var self = this;
      var url = '/brand/' + this.$route.params.brand_id + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.getStoreClassList();
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            if (parseInt(sList[i].store_id, 10) !== parseInt(self.$route.params.store_id, 10)) {
              self.storeBrief.push(obj);
              self.addStoresSetting.options.push(obj);
            }
          }
        }
      });
    },
    getStoreClassList: function getStoreClassList() {
      var self = this;
      var url = 'brand/' + this.$route.params.brand_id + '/storeClassList';
      if (this.getRoleType === 10) url = 'store/' + this.$route.params.brand_id + '/storeClassList';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          self.storeClassList = sList;
        }
      });
    },
    copyAd: function copyAd() {
      var self = this;
      var url = '/store/syncBanner';
      var syncList = '';
      for (var i = 0; i < this.addStoresSetting.choose.length; i++) {
        syncList = syncList + this.addStoresSetting.choose[i] + ',';
      }
      syncList = syncList.slice(0, -1);
      var data = {
        store_id: parseInt(this.$route.params.store_id, 10),
        sync_store_ids: syncList,
        sync_banner_type_list: this.syncBannerTypeList
      };
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.push({ path: '/storeTable/' + self.$route.params.brand_id });
        }
      });
    },
    clickOption: function clickOption(option) {
      var self = this;
      this.addStoresSetting.options = [];
      self.curId = option.id;
      if (self.curId) {
        self.$nextTick(function () {
          self.reSet++;
          self.addStoresSetting.options = self.storeBrief;
          self.getCurStoreClass();
        });
      }
    },
    getCurStoreClass: function getCurStoreClass() {
      this.addStoresSetting.choose = [];
      var self = this;
      var url = 'brand/' + this.$route.params.brand_id + '/storeClass/' + this.curId;
      if (this.getRoleType === 10) url = 'store/' + this.$route.params.brand_id + '/storeClass/' + this.curId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var classInfo = response.data.class;
          classInfo.store_list.forEach(function (s) {
            self.addStoresSetting.choose.push(s.id);
          });
        }
      });
    }
  },
  created: function created() {
    this.init();
  },

  components: {
    'img-upload': __WEBPACK_IMPORTED_MODULE_0__ImgUploadTemp_vue___default.a,
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default.a,
    VueTimepicker: __WEBPACK_IMPORTED_MODULE_2_vue2_timepicker___default.a
  },
  computed: {
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    },
    titleType: function titleType() {
      var title = '所有';
      if (this.syncBannerTypeList === 12) {
        title = '橫幅';
      } else if (this.syncBannerTypeList === 41) {
        title = '蓋版';
      }
      return title;
    }
  },
  watch: {
    citySelect: function citySelect() {
      var cityCode = parseInt(this.citySelect, 10);
      var cityElement = this.cityAreaList.find(function (e, i, o) {
        return e.city_code === cityCode;
      });
      var areaList = cityElement.area_list;
      for (var i = 0; i < areaList.length; i++) {
        var option = { name: areaList[i].name, value: areaList[i].area_code };
        this.areaOption.push(option);
        if (i === 0 && this.$route.name !== 'upStore') this.areaSelect = areaList[i].area_code;
      }
      if (this.$route.name === 'upStore') this.areaSelect = this.storeInfo.area_code;
    },
    imgLogoSelect: function imgLogoSelect() {
      var self = this;
      if (self.imgLogoSelect) {
        var imgSrc = this.imgLogoOption.find(function (e) {
          return e.name === self.imgLogoSelect;
        }).value;
        this.storeInfo.image_name = imgSrc;
      }
    },
    imgBgSelect: function imgBgSelect() {
      var self = this;
      if (self.imgBgSelect) {
        var imgSrc = this.imgBgOption.find(function (e) {
          return e.name === self.imgBgSelect;
        }).value;
        this.storeInfo.bg_image_name = imgSrc;
      }
    },
    'deliveryWaysInfo': function deliveryWaysInfo() {
      this.checkOtherDelivery();
    }
  }
});

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    'storeInfo': {
      type: Object
    },
    'deliveryWays': {
      type: Object
    },
    'deliveryOther': {
      type: Array
    },
    'deliveryWaysInfo': {
      type: Array
    }
  },
  data: function data() {
    return {
      numeral: __WEBPACK_IMPORTED_MODULE_2_numeral___default.a
    };
  },

  computed: {
    maxDeliveryDistanceKM: {
      get: function get() {
        return this.storeInfo.max_delivery_distance_m ? __WEBPACK_IMPORTED_MODULE_2_numeral___default()(this.storeInfo.max_delivery_distance_m).divide(1000).value() : null;
      },
      set: function set(val) {
        var info = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.storeInfo));
        info.max_delivery_distance_m = val ? __WEBPACK_IMPORTED_MODULE_2_numeral___default()(val).multiply(1000).value() : null;
        this.$emit('update:storeInfo', info);
      }
    },
    deliveryOtherKM: {
      get: function get() {
        var deliveryOther = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.deliveryOther));
        return deliveryOther.map(function (item) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
            distance_km: item.distance_m ? __WEBPACK_IMPORTED_MODULE_2_numeral___default()(item.distance_m || 0).divide(1000).value() : null
          });
        });
      },
      set: function set(val) {
        var deliveryOtherKM = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(val));
        var deliveryOther = deliveryOtherKM.map(function (item) {
          item.distance_m = item.distance_km ? __WEBPACK_IMPORTED_MODULE_2_numeral___default()(item.distance_km || 0).multiply(1000).value() : '';
          return item;
        });
        this.$emit('update:deliveryOther', deliveryOther);
      }
    }
  },
  methods: {
    addOtherDelivery: function addOtherDelivery() {
      var isSupport = this.deliveryWaysInfo.find(function (elm) {
        return elm.take_type === 3;
      }).is_support;
      var isEnable = this.deliveryWaysInfo.find(function (elm) {
        return elm.take_type === 3;
      }).is_enable;
      var option = { take_type: 3, distance_m: 0, distance_km: 0, price: 0, is_support: isSupport, is_enable: isEnable, is_default: 0 };
      if (!this.deliveryOtherKM.length) option.price = this.deliveryWaysInfo[2].price;
      this.deliveryOtherKM.push(option);
      this.changeOtherDelivery();
    },
    removeOtherDelivery: function removeOtherDelivery(index) {
      this.deliveryOtherKM.splice(index, 1);
      this.changeOtherDelivery();
    },
    changeOtherDelivery: function changeOtherDelivery() {
      var _this = this;

      this.deliveryOtherKM.forEach(function (item, index) {
        if (!item.price) item.price = 0;
        if (!item.distance_km) item.distance_km = 0;

        if (_this.maxDeliveryDistanceKM && item.distance_km > _this.maxDeliveryDistanceKM) {
          item.distance_km = 0;
        }
      });

      if (this.deliveryWays.price && this.deliveryOtherKM[0]) {
        this.deliveryOtherKM[0].price = this.deliveryWays.price;
      }

      this.deliveryOtherKM = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.deliveryOtherKM));
    }
  }
});

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__elements_Modal_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    'info': {
      type: Object
    }
  },
  data: function data() {
    return {
      brandName: '',
      show: {
        delBtn: false
      },
      delOption: {
        id: 'delModal',
        title: '刪除群組',
        body: '確定刪除群組?',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delGroup'
        }]
      }
    };
  },

  methods: {
    addAdRow: function addAdRow() {
      this.adRowNum = this.adRowNum + 1;
    },
    delAdRow: function delAdRow() {
      this.adRowNum = this.adRowNum - 1;
    },
    addGroup: function addGroup() {
      var self = this;
      if (this.getInput.name) {
        var data = {
          name: this.getInput.name
        };
        var url = '/brand/' + this.$route.params.brand_id + '/storeGroup';
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            });
            self.$router.push({ path: '/groupTable/' + self.$route.params.brand_id });
          }
        });
      } else {
        this.$notify({
          title: '提醒',
          text: '群組名稱不可為空',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      }
    },
    upGroup: function upGroup() {
      var self = this;
      if (this.getInput.name) {
        var data = {
          name: this.getInput.name
        };
        var url = '/brand/' + this.$route.params.brand_id + '/storeGroup/' + this.$route.params.group_id;
        this.getDataH('put', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            });
            self.$router.push({ path: '/groupTable/' + self.$route.params.brand_id });
          }
        });
      } else {
        this.$notify({
          title: '提醒',
          text: '群組名稱不可為空',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      }
    },
    delGroup: function delGroup() {
      var self = this;
      var url = '/brand/' + this.$route.params.brand_id + '/storeGroup/' + this.$route.params.group_id;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.push({ path: '/groupTable/' + self.$route.params.brand_id });
        }
      });
    },
    goToStoreTable: function goToStoreTable() {
      this.$router.push({ path: '/storeTable/' + this.$route.params.brand_id });
    },
    goToEditStore: function goToEditStore(storeId) {
      this.$router.push({ path: '/upStore/' + this.$route.params.brand_id + '/' + storeId });
    },
    trigger: function trigger(event) {
      if (event === 'delGroup') {
        this.delGroup();
      }
    }
  },
  computed: {
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getInput: function getInput() {
      return {
        name: this.checkInput(this.brandName.toString())
      };
    }
  },
  watch: {
    info: function info() {
      this.brandName = this.info.name;
      if (this.info.stores) {
        if (!this.info.stores.length) this.show.delBtn = true;
      }
    }
  },
  components: {
    'm-modal': __WEBPACK_IMPORTED_MODULE_0__elements_Modal_vue___default.a
  }
});

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['index', 'type'],
  data: function data() {
    return {
      image: '',
      img: {
        width: 0,
        height: 0
      }
    };
  },

  methods: {
    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var imgName = files[0].name.split('.');
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.createImage(files[0]);
      }
    },
    createImage: function createImage(file) {
      var reader = new FileReader();
      var self = this;
      reader.onload = function (e) {
        var img = new Image();
        img.src = e.target.result;
        self.image = img.src;

        img.onload = function () {
          self.img.width = img.width;
          self.img.height = img.height;
        };
      };
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.img-size').css('background', 'white');
      reader.readAsDataURL(file);
    }
  }
});

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_numeral__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_numeral__);












/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    resetShopping: {
      type: Boolean,
      default: false
    },
    storeInfo: {
      type: Object,
      default: function _default() {}
    },
    showVendorId: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      numeral: __WEBPACK_IMPORTED_MODULE_8_numeral___default.a,
      sInfo: {
        shipping_fee_type: 0,
        shipping_description: '',
        api_type: 1,
        setting_info: {
          vendor_custom_id: null
        }
      },
      feeTypeSelect: null,
      allShippingFee: {},
      itemList: [],

      storeBrief: [],
      addStoresSetting: {
        class: 'copy-shipping-store',
        options: [],
        choose: []
      }
    };
  },

  methods: {
    updateValue: function updateValue(itemList, key) {
      var offset = key === 'money' ? 1 : 0.1;

      itemList.forEach(function (item, idx) {
        if (item[key] === -1) return;
        var preValue = itemList[idx - 1] ? __WEBPACK_IMPORTED_MODULE_8_numeral___default()(itemList[idx - 1][key]).add(offset).value() : 0;
        item[key] = item[key] * 1 < preValue ? preValue : item[key];
      });

      if (key === 'distance') this.itemListKM = itemList;
    },
    getStoreBrief: function getStoreBrief() {
      var _this = this;

      this.storeBrief = [];
      this.addStoresSetting.options = [];
      var url = '/brand/' + this.$route.params.brand_id + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          if (_this.$route.name === 'batchSetupStore') {
            if (sList.findIndex(function (x) {
              return x.api_type === 1;
            }) > -1) {
              _this.sInfo.api_type = 1;
            }
          } else {
            for (var i = 0; i < sList.length; i++) {
              var obj = { label: sList[i].name, value: sList[i].store_id };
              if (parseInt(sList[i].store_id, 10) !== parseInt(_this.$route.params.store_id, 10)) {
                _this.storeBrief.push(obj);
                _this.addStoresSetting.options.push(obj);
              }
            }
          }
        }
      });
    },
    copyShipping: function copyShipping() {
      var self = this;
      var url = '/store/' + this.$route.params.store_id + '/syncShippingFee';
      var syncList = '';
      for (var i = 0; i < this.addStoresSetting.choose.length; i++) {
        syncList = syncList + this.addStoresSetting.choose[i] + ',';
      }
      syncList = syncList.slice(0, -1);
      var data = {
        sync_store_ids: syncList
      };
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
        }
      });
    },
    goToStoreTable: function goToStoreTable() {
      this.$router.push('/storeTable/' + this.$route.params.brand_id);
    },
    addItem: function addItem() {
      var defaultValue = 1;
      var type = this.feeTypeSelect === 1 ? 'money' : 'distance';
      var itemList = type === 'money' ? this.itemList : this.itemListKM;
      var valueOffset = type === 'money' ? 1 : 0.1;
      var prevItem = itemList[itemList.length - 2];

      if (prevItem && prevItem[type] !== -1) defaultValue = __WEBPACK_IMPORTED_MODULE_8_numeral___default()(prevItem[type]).add(valueOffset).value();

      itemList.splice(itemList.length - 1, 0, { distance: defaultValue, money: defaultValue, fee: 0, range: [{ money: 1, fee: 0 }, { money: -1, fee: 0 }] });

      if (type === 'distance') this.itemListKM = itemList;
      this.$forceUpdate();
    },
    removeItemTime: function removeItemTime(index) {
      var itemList = this.feeTypeSelect === 1 ? this.itemList : this.itemListKM;
      itemList.splice(index, 1);
      if (this.feeTypeSelect !== 1) this.itemListKM = itemList;
    },
    checkShipping: function checkShipping(maxDeliveryDistanceM) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var msg = '';
        if (_this2.feeTypeSelect !== 1 && maxDeliveryDistanceM) {
          var overLimit = _this2.itemList.some(function (item) {
            return item.distance > maxDeliveryDistanceM;
          });
          if (overLimit) msg = '運送距離不可超過最遠可外送距離！';
        }
        if (!msg && _this2.feeTypeSelect === 1) {
          var moneyList = [];
          _this2.itemList.forEach(function (obj) {
            if (!obj.money && obj.money !== 0) {
              msg = '門檻金額未填';
            } else if (!obj.fee && obj.fee !== 0) {
              msg = '運費金額未填';
            } else if (typeof moneyList.find(function (money) {
              return money === obj.money;
            }) !== 'undefined') {
              msg = '門檻金額重複';
            } else {
              moneyList.push(obj.money);
            }
          });
        }

        if (_this2.sInfo.api_type === 1 && _this2.sInfo.setting_info && !_this2.sInfo.setting_info.vendor_custom_id && _this2.feeTypeSelect !== 0) {
          msg = '設定 API 服務類型為專屬客製 POS，需要填寫 POS 廠商 ID';
        }
        if (msg) {
          _this2.$notify({
            title: '提醒',
            text: msg,
            duration: 3000,
            type: 'danger',
            width: 400
          });
          reject(msg);
        } else {
          resolve();
        }
      });
    },
    maxValue: function maxValue(list, key) {
      if (!list.length) return 0;
      var values = list.map(function (obj) {
        return obj[key];
      });
      return Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(values));
    },
    getShippingFee: function getShippingFee() {
      var _this3 = this;

      var url = '/store/' + this.$route.params.store_id + '/shippingFee';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this3.sInfo = response.data;
          _this3.feeTypeSelect = _this3.sInfo.shipping_fee_type;
          _this3.itemList = [];
          _this3.allShippingFee = _this3.sInfo.all_shipping_fee_type;
          _this3.sInfo.setting_info.item_list.forEach(function (obj, idx) {
            var isLast = idx === _this3.sInfo.setting_info.item_list.length - 1;
            if (!obj.money) obj.money = isLast ? -1 : 0;
            if (!obj.distance) obj.distance = isLast ? -1 : 0;

            if (!obj.range) obj.range = [{ money: 0, fee: 0 }, { money: -1, fee: 0 }];
            obj.range.forEach(function (range, rIdx) {
              if (!range.money) range.money = rIdx === obj.range.length - 1 ? -1 : 0;
            });

            _this3.itemList.push(obj);
          });
        }
      });
    },
    upShippingFee: function upShippingFee(newStoreId) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, newItemList, url, storeId;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = {};


                if (_this4.sInfo.setting_info && _this4.sInfo.setting_info.vendor_custom_id) data.vendor_custom_id = _this4.sInfo.setting_info.vendor_custom_id;

                if (_this4.feeTypeSelect !== 99) {
                  newItemList = [];

                  _this4.itemList.sort(function (a, b) {
                    switch (_this4.feeTypeSelect) {
                      case 1:
                        if (a.money === -1) return 1;
                        return a.money - b.money;
                      case 2:
                        if (a.distance === -1) return 1;
                        return a.distance - b.distance;
                      case 3:
                        if (a.distance === -1) return 1;
                        return a.distance - b.distance;
                    }
                  });
                  if (_this4.feeTypeSelect === 3) {
                    _this4.itemList.forEach(function (obj) {
                      obj.range.sort(function (a, b) {
                        if (a.money === -1) return 1;
                        return a.money - b.money;
                      });
                    });
                  }

                  _this4.itemList.forEach(function (obj) {
                    newItemList.push(obj);
                  });

                  data.item_list = newItemList;
                }
                data.shipping_description = _this4.sInfo.shipping_description;
                data.shipping_fee_type = _this4.feeTypeSelect;

                _context.t0 = _this4.feeTypeSelect;
                _context.next = _context.t0 === 0 ? 8 : _context.t0 === 1 ? 10 : _context.t0 === 2 ? 12 : _context.t0 === 3 ? 14 : 16;
                break;

              case 8:
                delete data.item_list;
                return _context.abrupt('break', 16);

              case 10:
                data.item_list.forEach(function (obj) {
                  delete obj.distance;
                  delete obj.range;
                });
                return _context.abrupt('break', 16);

              case 12:
                data.item_list.forEach(function (obj) {
                  delete obj.money;
                  delete obj.range;
                });
                return _context.abrupt('break', 16);

              case 14:
                data.item_list.forEach(function (obj) {
                  delete obj.money;
                });
                return _context.abrupt('break', 16);

              case 16:

                if (_this4.$route.name === 'batchSetupStore') {
                  data = {
                    shipping_fee_setting: data,
                    store_list: _this4.$parent.includeStoresSetting.choose.toString()
                  };

                  if (!data.shipping_fee_setting.shipping_fee_type) delete data.shipping_fee_setting.shipping_fee_type;
                  if (!data.shipping_fee_setting.shipping_description) delete data.shipping_fee_setting.shipping_description;
                  if (!data.shipping_fee_setting.item_list.length) delete data.shipping_fee_setting.item_list;
                  if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(data.shipping_fee_setting).length === 0) delete data.shipping_fee_setting;
                }

                url = '';

                if (!(_this4.$route.name === 'batchSetupStore')) {
                  _context.next = 25;
                  break;
                }

                url = '/brand/' + _this4.$route.params.brand_id + '/syncStore/create';
                _context.next = 22;
                return _this4.getDataH('post', url, data);

              case 22:
                return _context.abrupt('return', _context.sent);

              case 25:
                storeId = newStoreId || _this4.$route.params.store_id;

                url = '/store/' + storeId + '/shippingFee';
                _context.next = 29;
                return _this4.getDataH('put', url, data);

              case 29:
                return _context.abrupt('return', _context.sent);

              case 30:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    }
  },
  created: function created() {
    if (this.$route.name !== 'batchSetupStore' && this.$route.name !== 'crStore') {
      this.getShippingFee();
    }
    if (this.storeInfo) this.sInfo = this.storeInfo;
    this.getStoreBrief();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },

    itemListKM: {
      get: function get() {
        return this.itemList.map(function (obj) {
          var newObj = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, obj);
          if (newObj.distance && newObj.distance !== -1) newObj.distance = __WEBPACK_IMPORTED_MODULE_8_numeral___default()(newObj.distance).divide(1000).value();
          return newObj;
        });
      },
      set: function set(value) {
        this.itemList = value.map(function (obj, idx) {
          var newObj = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, obj);
          if (newObj.distance && newObj.distance !== -1) newObj.distance = __WEBPACK_IMPORTED_MODULE_8_numeral___default()(value[idx].distance).multiply(1000).value();
          return newObj;
        });
      }
    },
    vendorCustomId: {
      get: function get() {
        if (!this.sInfo.setting_info || !this.sInfo.setting_info.vendor_custom_id) return null;
        return this.sInfo.setting_info.vendor_custom_id;
      },
      set: function set(value) {
        if (!this.sInfo.setting_info) this.sInfo.setting_info = {};
        this.sInfo.setting_info.vendor_custom_id = value;
      }
    }
  }),
  watch: {
    sInfo: {
      handler: function handler(val) {
        this.$emit('update:storeInfo', val);
      },

      deep: true
    },
    resetShopping: function resetShopping(val) {
      this.sInfo = {
        shipping_fee_type: 0,
        shipping_description: '',
        api_type: 1
      };

      this.feeTypeSelect = null;

      if (this.$route.name !== 'batchSetupStore') {
        this.sInfo.setting_info = {
          vendor_custom_id: null
        };
      }
    },
    feeTypeSelect: function feeTypeSelect(val) {
      var _this5 = this;

      if (this.allShippingFee && this.allShippingFee[val] || this.sInfo && this.sInfo.shipping_fee_type === val && this.sInfo.setting_info && this.sInfo.setting_info.item_list && this.sInfo.setting_info.item_list.length) {
        this.itemList = [];

        var shippingFee = this.allShippingFee[val];

        if (shippingFee && shippingFee.item_list) {
          var stringData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(shippingFee.item_list);
          stringData = stringData.replace(/null/g, '-1');
          this.itemList = JSON.parse(stringData);
          return;
        }

        this.sInfo.setting_info.item_list.forEach(function (obj, idx) {
          var isLast = idx === _this5.sInfo.setting_info.item_list.length - 1;
          if (!obj.money) obj.money = isLast ? -1 : 0;
          if (!obj.distance) obj.distance = isLast ? -1 : 0;

          if (!obj.range) obj.range = [{ money: 0, fee: 0 }, { money: -1, fee: 0 }];
          obj.range.forEach(function (range, rIdx) {
            if (!range.money) range.money = rIdx === obj.range.length - 1 ? -1 : 0;
          });

          _this5.itemList.push(obj);
        });
      } else {
        switch (val) {
          case 1:
            this.itemList = [{ money: -1, fee: 0 }];
            break;
          case 2:
            this.itemList = [{ distance: -1, fee: 0 }];
            break;
          case 3:
            this.itemList = [{ distance: -1, range: [{ money: 0, fee: 0 }, { money: -1, fee: 0 }] }];
            break;
          default:
            this.itemList = [];
            break;
        }
      }
    }
  }
});

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__elements_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ImgUploadTemp_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ImgUploadTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ImgUploadTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_js_down_load_file_js__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ShippingForm_vue__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ShippingForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__ShippingForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DeliveryLimit_vue__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DeliveryLimit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__DeliveryLimit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_elements_chooseStoreModal_vue__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_elements_chooseStoreModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_elements_chooseStoreModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue2_timepicker__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue2_datepicker__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue2_datepicker_index_css__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue2_datepicker_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue2_datepicker_index_css__);

























/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    'info': {
      type: Object
    }
  },
  data: function data() {
    return {
      storeOption: {
        id: 'copyModal'
      },
      delExceptionOption: {
        id: 'delExceptionModal',
        title: '批次刪除排除商品',
        body: '確認批次刪除所選排除商品？',
        btns: [{
          name: '取消',
          event: 'close'
        }, {
          name: '確定',
          event: 'delExceptionProduct'
        }]
      },
      optionsList: [],
      deliveryExceptionProductSelect: false,
      deliveryExceptionProductSelectAll: false,
      deliveryExceptionProductList: [],
      loading: false,
      originAddress: {
        city_code: 0,
        area_code: 0,
        address_short: ''
      },
      crStep: [1, 2, 3, 4, 5, 6, 7, 8, 12, 13, 14, 15],
      showCalendar: false,
      bindingClassList: [],
      mealTagList: [],
      posBrief: [],
      storeName: '',
      storeDes: '',
      adRowNum: 2,
      groupList: [],
      areaTimes: 0,
      cityAreaList: [],
      areaOption: [],
      cityOption: [],
      imgLogoOption: [],
      imgBgOption: [],
      storeBrief: [],
      groupSelect: 0,
      imgLogoSelect: '',
      imgBgSelect: '',
      copyStoreSelect: 99,
      copyBannerTypeList: [],
      areaSelect: 99,
      citySelect: 99,
      posSelect: 99,
      posTypeSelect: 10,
      storeTypeSelect: 0,
      statusSelect: 2,
      orderStatusSelect: 20,
      isVisibleSelect: 1,
      isStickerSelect: 0,
      barcodeSelect: 0,
      hasInvoicePaperSelect: 1,
      hasInvoiceCarrierSelect: 0,
      invoiceRemark: '',
      hasInvoiceNpobnaSelect: 0,
      isInvoiceException: 0,
      apiTypeSelect: 2,
      showMenuIconSelect: 0,
      plasticSelect: 0,
      plasticAmountAdjustable: 0,
      deliveryNeedSelect: 0,
      isSearchSelect: 0,
      roundingTypeSelect: 1,
      couponFormSelect: 1,
      showProdSettingSelect: 1,
      isPosAccount: 0,
      isCopy: 0,
      img: {
        width: 0,
        height: 0
      },
      bgImg: {
        width: 0,
        height: 0
      },
      tradeInfo: [],
      takeTimeInfo: [{ take_type: 1, prepare_time_seg: 15, take_time_seg: 0 }, { take_type: 2, prepare_time_seg: 15, take_time_seg: 0 }, { take_type: 3, prepare_time_seg: 30, take_time_seg: 0 }, { take_type: 4, prepare_time_seg: 15, take_time_seg: 0 }, { take_type: 5, prepare_time_seg: 15, take_time_seg: 0 }, { take_type: 21, prepare_time_seg: 3, take_time_seg: 0 }],
      openingInfo: [{ week_day: 1, start: '08:00', end: '22:00' }, { week_day: 2, start: '08:00', end: '22:00' }, { week_day: 3, start: '08:00', end: '22:00' }, { week_day: 4, start: '08:00', end: '22:00' }, { week_day: 5, start: '08:00', end: '22:00' }, { week_day: 6, start: '08:00', end: '22:00' }, { week_day: 7, start: '08:00', end: '22:00' }],
      deliveryWaysInfo: [{ take_type: 1, is_support: 1, is_enable: 1, distance_m: 0, price: 0, is_default: 0, is_allow_guest_order: 1, memo: '', pickup_memo: '' }, { take_type: 2, is_support: 1, is_enable: 0, distance_m: 0, price: 0, is_default: 0, is_allow_guest_order: 1, memo: '', pickup_memo: '' }, { take_type: 3, is_support: 1, is_enable: 1, distance_m: 0, price: 0, is_default: 0, is_allow_guest_order: 1, memo: '', pickup_memo: '' }, { take_type: 4, is_support: 0, is_enable: 0, distance_m: 0, price: 0, is_default: 0, is_allow_guest_order: 1, memo: '', pickup_memo: '' }, { take_type: 5, is_support: 0, is_enable: 0, distance_m: 0, price: 0, is_default: 0, is_allow_guest_order: 1, memo: '', pickup_memo: '' }, { take_type: 21, is_support: 1, is_enable: 0, distance_m: 0, price: 0, is_default: 0, is_allow_guest_order: 1, memo: '', pickup_memo: '' }],
      deliveryOther: [],
      storeInfo: {
        address_remark: '',
        address_short: '',
        allow_copy_menu: 1,
        allow_update_menu: 1,
        area_code: '',
        auto_reject_order_m: 15,
        auto_reject_order_reserve_m: 60,
        bg_image_name: '',
        binding_class: false,
        binding_class_ids: [],
        binding_meal_tag_ids: [],
        bl_name: '',
        branch_code: '',
        brand_name: '',
        city_code: '',
        comment: '',
        custom_sticker_max_length: 10,
        delivery_stage_limit_type: 1,
        description: '',
        ein: '',
        email: '',
        food_business_no: '',
        image_name: '',
        introduction: '',
        is_close_allow_order: 1,
        is_off_allow_order: 1,
        is_preparing_allow_order: 1,
        is_support_custom_remark: 0,
        max_delivery_distance_m: '',
        meat_origin_description: '',
        membership_provider_parent_id: -1,
        menu_ab_block_type: 1,
        menu_expand_type: 1,
        menu_layout_type: 1,
        menu_stop_sale_today_type: 1,
        menu_stop_sale_type: 2,
        name: '',
        name_short: '',
        one_order_max_money: 10000,
        order_end_time_m: 0,
        order_start_day: 0,
        order_start_time_m: 0,
        order_status_reason: '',
        order_tolerance_day: 0,
        photo_name: '',
        plastic_unit: 6,
        pos_branch_code: '',
        search_description: '',
        show_menu_product_icon: 0,
        show_menu_zero_money: 0,
        tel: '',
        tel2: '',
        to_store_pay_max_money: 10000,
        youtube_video_code: ''
      },

      copyInfo: {
        menuStore: false,
        menuStoreId: null,
        productAlias: false,
        productAliasStoreId: null,
        productDescription: false,
        productDescriptionStoreId: null,
        productImage: false,
        productImageStoreId: null
      },
      posAccount: {
        account: '',
        password: ''
      },

      deliveryInfo: [{ label: '自取', value: 1 }, { label: '內用', value: 2 }, { label: '外送', value: 3 }, { label: '內用-桌邊掃碼', value: 21 }],
      menuLayout: [{ label: '文字，選項方塊 (飲料店用)', value: 1 }, { label: '圖文，商品描述為點擊後', value: 2 }, { label: '圖文，商品描述在下方', value: 3 }, { label: '圖文，商品描述在下方，外層大圖', value: 31 }, { label: '文字，選項條列式 (餐廳用)', value: 4 }],
      deliveryWayPlastic: [],
      offdaySetting: {
        date: [],
        weekDay: [],
        monthDay: [],
        options: {
          date: [{ label: '無指定', value: 0 }],
          weekDay: [{ label: '無指定', value: 0 }, { label: '週日', value: 1 }, { label: '週一', value: 2 }, { label: '週二', value: 3 }, { label: '週三', value: 4 }, { label: '週四', value: 5 }, { label: '週五', value: 6 }, { label: '週六', value: 7 }],
          month: [{ label: '無指定', value: 0 }, { label: '一月', value: 1 }, { label: '二月', value: 2 }, { label: '三月', value: 3 }, { label: '四月', value: 4 }, { label: '五月', value: 5 }, { label: '六月', value: 6 }, { label: '七月', value: 7 }, { label: '八月', value: 8 }, { label: '九月', value: 9 }, { label: '十月', value: 10 }, { label: '十一月', value: 11 }, { label: '十二月', value: 12 }],
          monthDay: [{ label: '無指定', value: 0 }]
        }
      },
      processTimeList: [],
      deliveryTypeOption: [{ label: '所有', value: 0 }, { label: '自取', value: 1 }, { label: '內用', value: 2 }, { label: '外送', value: 3 }, { label: '內用-桌邊掃碼', value: 21 }],
      storeMethod: 1,
      printerStoreList: [],
      printerInfo: {
        identity: '',
        type: 1
      },
      printerSelect: 1,
      isPrinterSelect: '',
      printerList: [],
      delOption: {
        id: 'delModal',
        title: '刪除店家綁定',
        body: '確定刪除?<br>刪除此店家綁定！',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delBinding'
        }]
      },
      selectChange: '',
      addressOption: {
        id: 'addressModal',
        title: '地址修改提醒',
        body: '如有開通米特物流服務，修改地址後請同步通知米特物流窗口。',
        btns: [{
          name: '確定',
          event: 'saveAddress'
        }],
        footerTextAlign: 'right'
      },

      einOption: {
        id: 'einModal',
        title: '統一編號不一致',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'saveEin'
        }],
        footerTextAlign: 'right'
      },
      einCheckList: [],
      einCheckStoreEin: '',
      einConfirmed: false,
      einConfirmType: 'up',
      originEin: '',
      originTradeEin: {},
      editOption: {
        id: 'editModal',
        title: '編輯店家綁定',
        body: '編輯店家綁定！',
        input: {
          name: '綁定名稱'
        },
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'editBinding'
        }]
      },
      selectOptions: {
        name: '綁定啟用',
        options: [{ text: '啟用', value: 1 }, { text: '不啟用', value: 0 }]
      },
      leave: false,
      leaveOption: {
        id: 'leaveModal',
        title: '提醒',
        body: '您即將離開此頁面!<br>請先確認上方計費方式設定已填寫完成後，再前往修改。',
        btns: [{
          name: '取消'
        }, {
          name: '儲存並前往修改',
          event: 'save'
        }]
      },
      current: {},
      change: {
        is_enabled: 1,
        binding_name: ''
      },
      tradeList: [],
      exceptionTradeList: [],
      exceptionCalendar: [],
      disModeSelect: 13,
      reload: false,

      printerLayoutList: [],
      printerLayoutSetting: [],
      selectDate: {
        'currentDate': '',
        'selectedDate': false,
        'selectedDateTime': false,
        'selectedHour': '00',
        'selectedMinute': '00',
        'selectedDatesItem': '',
        'selectedDates': [],
        'dateRange': { 'start': '', 'end': '' },
        'multipleDateRange': []
      },
      remarkMaxlength: 100,
      specialDayRemarkMaxlength: 15,
      tableNumberUrl: {
        text: '',
        type: 1
      },
      enterType: [],
      hideDeliveryType: [4, 5],

      tableNumber: {
        default_login_type: 1,
        is_cash_pay_after_meal: 0,
        is_table_no_editable: 0,
        is_table_no_required: 0,
        sub_delivery_type: 1,
        show_table_no: 1,
        type: 21
      },

      brandInvalidQuota: 0,
      orderCommissionSetting: {
        has_independent_report: 0,
        allow_invalid_order_quota: 2,
        type: 1,
        item_list: [] },
      showOverlapErrorIndex: [],
      commissionItemList: {
        delivery_type: 0,
        start_time: null,
        end_time: null,
        ratio: null,
        rounding_type: 3 },
      repeatPosAccountList: [],
      posList: [{
        account: '',
        password: '',
        pos_vendor_id: 99,
        role_type: 10,
        remark: '',
        is_active: 1,
        vaildSingleAccount: true
      }],
      copyPostList: [],
      realPostList: [],
      pay_party: 1,
      supportShippingVendorList: [],
      shippingVendorInfo: [],
      membershipGroupType: 0,
      providerId: 0,
      urlRedirection: {
        new_store_id: 0,
        new_store_info: [],
        stores: []
      },
      showTablewareStrawOption: 0,
      setTablewareStrawDefaultVal: 0,
      showSpecialDayCalendar: false,
      selectSpecialDay: [],
      tempSpecialDayCalendar: {
        'currentDate': '',
        'selectedDate': false,
        'selectedDateTime': false,
        'selectedHour': '00',
        'selectedMinute': '00',
        'selectedDatesItem': '',
        'selectedDates': [],
        'dateRange': { 'start': '', 'end': '' },
        'multipleDateRange': []
      }
    };
  },

  methods: {
    copyStore: function copyStore(storeList) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, url;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = {
                  sync_store_ids: storeList.join(',')
                };
                url = 'store/' + _this.$route.params.store_id + '/syncDeliveryExceptionProduct';
                _context.next = 4;
                return _this.getDataH('post', url, data, function (response) {
                  if (response.data.status === 200) {
                    _this.$notify({
                      title: '新增成功',
                      text: '新增成功',
                      duration: 1000,
                      type: 'success',
                      width: 400
                    });
                  }
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleProductSelect: function handleProductSelect(item) {
      this.reload = true;
      item.vendor_custom_id = item.search_result.id;
      item.product_name = item.search_result.name;
      item.product_type = item.search_result.type;
    },
    getMenuId: function getMenuId() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                url = 'onlineMenu/list?page=1&size=1&store_id=' + _this2.$route.params.store_id;
                _context2.next = 3;
                return _this2.getDataH('get', url, null, function (response) {
                  if (response.data.status === 200) {
                    var result = response.data.menu_list ? response.data.menu_list[0] ? response.data.menu_list[0].id : null : null;
                    if (result) {
                      _this2.getProductInfoList(result);
                    }
                  }
                });

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getProductInfoList: function getProductInfoList(menuId) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                url = 'onlineMenu/' + menuId + '/productBrief';
                _context3.next = 3;
                return _this3.getDataH('get', url, null, function (response) {
                  if (response.data.status === 200) {
                    _this3.optionsList = [];
                    var menu = response.data.brief;
                    menu.category_list.forEach(function (category) {
                      category.child_list.forEach(function (prod) {
                        if (_this3.optionsList.findIndex(function (x) {
                          return x.id === prod.vendor_custom_id;
                        }) < 0) {
                          var data = {
                            name: prod.name,
                            id: prod.vendor_custom_id,
                            type: prod.type
                          };
                          _this3.optionsList.push(data);
                        }
                      });
                    });
                  }
                });

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    addProductItem: function addProductItem(type) {
      this.deliveryExceptionProductList.push({ product_name: '', vendor_custom_id: '', product_type: 0, is_enabled: 1, item_type: type, delivery_type: 3, selected: false });
    },
    deleteProductItem: function deleteProductItem(index) {
      this.deliveryExceptionProductList.splice(index, 1);
    },
    batchDeleteProduct: function batchDeleteProduct() {
      this.deliveryExceptionProductSelect = false;
    },
    selectAllProducts: function selectAllProducts() {
      var _this4 = this;

      this.deliveryExceptionProductSelectAll = !this.deliveryExceptionProductSelectAll;
      this.deliveryExceptionProductList = this.deliveryExceptionProductList.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, item, {
          selected: _this4.deliveryExceptionProductSelectAll
        });
      });
    },
    checkPosSingleAccount: function checkPosSingleAccount(item, index) {
      var vaildAccount = this.copyPostList.filter(function (x) {
        return x.pos_account_id === item.pos_account_id;
      });
      if (item.pos_account_id && vaildAccount[0].account !== item.account || !item.pos_account_id) {
        var url = '/pos/list?account_full=' + item.account + '&page=1&size=20';
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            if (response.data.list && response.data.list.length > 0) {
              item.vaildSingleAccount = false;
            } else {
              item.vaildSingleAccount = true;
            }
          }
        });
      }
    },
    changeTab: function changeTab(index) {
      if (this.$route.name === 'upStore') {
        this.storeMethod = Number(index);
      }
    },
    cheakAllPostAccount: function cheakAllPostAccount() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.realPostList.forEach(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee4(item, index) {
                    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _context4.next = 2;
                            return _this5.checkPosSingleAccount(item, index);

                          case 2:
                          case 'end':
                            return _context4.stop();
                        }
                      }
                    }, _callee4, _this5);
                  }));

                  return function (_x, _x2) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    updatePosAccount: function updatePosAccount(storeId) {
      var _this6 = this;

      this.realPostList.forEach(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee6(x) {
          var method, url, data;
          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  method = 'post';
                  url = '/pos';

                  if (x.pos_account_id) {
                    method = 'put';
                    url += '/' + x.pos_account_id;
                  }
                  data = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, x, {
                    brand_id: _this6.$route.params.brand_id,
                    store_id: storeId
                  });
                  _context6.next = 6;
                  return _this6.getDataH(method, url, data, function (response) {
                    if (_this6.$route.name === 'upStore') {
                      _this6.getPosAccountList();
                    }
                  });

                case 6:
                case 'end':
                  return _context6.stop();
              }
            }
          }, _callee6, _this6);
        }));

        return function (_x3) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    deletePosAccount: function deletePosAccount(index) {
      this.posList.splice(index, 1);
    },
    newPosAccount: function newPosAccount() {
      this.posList.push({
        account: '',
        password: '',
        pos_vendor_id: 99,
        role_type: 10,
        remark: '',
        is_active: 1,
        vaildSingleAccount: true
      });
    },
    goStep: function goStep(step) {
      var sIndex = this.crStep.indexOf(this.storeMethod);
      if (step > 0) {
        this.storeMethod = this.crStep[sIndex + 1];
        this.checkBeforeSend();
      } else {
        this.storeMethod = this.crStep[sIndex - 1];
      }
    },
    notBeforeToday: function notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    notBeforeTodayAddTwoMins: function notBeforeTodayAddTwoMins(date) {
      return date < new Date(__WEBPACK_IMPORTED_MODULE_8_moment___default()().set('second', 0).add(5, 'm').toString());
    },
    checkCommission: function checkCommission() {
      var itemList = this.orderCommissionSetting.item_list;
      if (this.orderCommissionSetting.allow_invalid_order_quota === '') {
        return '請輸入每月作廢訂單額度(筆)';
      } else if (this.orderCommissionSetting.type > 1) {
        if (!itemList.length) {
          return '請增加資訊服務費抽成設定';
        } else {
          this.showOverlapErrorIndex = [];
          for (var i = 0; i < itemList.length; i++) {
            var startTime = itemList[i].start_time;
            var endTime = itemList[i].end_time;
            if (itemList[i].ratio === '') {
              this.showOverlapErrorIndex = [i];
              return '請輸入資訊服務費抽成%';
            } else if (!startTime || !endTime) {
              this.showOverlapErrorIndex = [i];
              return '\u8ACB\u8F38\u5165\u62BD\u6210' + (!startTime ? '生效' : '結束') + '\u6642\u9593';
            } else if (__WEBPACK_IMPORTED_MODULE_8_moment___default()(endTime).isBefore(startTime)) {
              this.showOverlapErrorIndex = [i];
              return '結束時間小於開始時間，請重新選擇!';
            } else if (i > 0) {
              for (var j = i - 1; j >= 0; j--) {
                if (itemList[i].delivery_type === 0 || itemList[j].delivery_type === 0 || itemList[i].delivery_type === itemList[j].delivery_type) {
                  var lastStartTime = itemList[j].start_time;
                  var lastEndTime = itemList[j].end_time;
                  if (this.dateRangeOverlaps(startTime, endTime, lastStartTime, lastEndTime)) {
                    this.showOverlapErrorIndex.push(j);
                    this.showOverlapErrorIndex.push(i);
                  }
                }
              }
            }
          }
          if (this.showOverlapErrorIndex.length) {
            return '\u6642\u9593\u91CD\u8986\u8A2D\u5B9A\uFF0C\u8ACB\u78BA\u8A8D!';
          }
        }
      }
      return false;
    },
    setCommissionQuery: function setCommissionQuery() {
      var query = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.orderCommissionSetting));
      if (!this.orderCommissionSetting.item_list.length) {
        delete query['item_list'];
      } else if (this.orderCommissionSetting.type === 1) {
        delete query['item_list'];
        query['has_independent_report'] = 0;
      } else {
        query.item_list.forEach(function (item) {
          item.start_time = item.start_time + ':00';
          item.end_time = item.end_time + ':59';
        });
      }
      return query;
    },
    dateRangeOverlaps: function dateRangeOverlaps(startA, endA, startB, endB) {
      if (startA === endA && startB === endB) {
        return startA === startB;
      } else if (startA === endA && startB !== endB) {
        return startA >= startB && startA <= endB;
      } else if (startA !== endA && startB === endB) {
        return startB >= startA && startB <= endA;
      } else {
        return startA <= endB && startB < endA;
      }
    },
    calendarSelected: function calendarSelected(val) {
      var selectedDate = __WEBPACK_IMPORTED_MODULE_8_moment___default()(val.date, 'DD/MM/YYYY');
      var minDate = __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.calendarLimits.min, 'DD/MM/YYYY');
      var maxDate = __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.calendarLimits.max, 'DD/MM/YYYY');

      if (selectedDate.isBefore(minDate) || selectedDate.isAfter(maxDate)) {
        return;
      }

      var formatDay = __WEBPACK_IMPORTED_MODULE_8_moment___default()(val.date, 'D/M/YYYY').format('YYYY-MM-DD');
      if (!val.isMarked) {
        var oDate = { label: formatDay, value: formatDay };
        this.offdaySetting.date.push(oDate);
      } else {
        var index = this.offdaySetting.date.findIndex(function (e) {
          return e.value === formatDay;
        });
        this.offdaySetting.date.splice(index, 1);
      }
    },
    specialDayCalendarSelected: function specialDayCalendarSelected(rowIndex, val) {
      var _this7 = this;

      var selectedDate = __WEBPACK_IMPORTED_MODULE_8_moment___default()(val.date, 'DD/MM/YYYY');
      var minDate = __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.calendarLimits.min, 'DD/MM/YYYY');
      var maxDate = __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.calendarLimits.max, 'DD/MM/YYYY');

      if (selectedDate.isBefore(minDate) || selectedDate.isAfter(maxDate)) {
        return;
      }

      var formatDay = __WEBPACK_IMPORTED_MODULE_8_moment___default()(val.date, 'DD/MM/YYYY').format('YYYY-MM-DD');

      if (!val.isMarked) {
        var oDate = { label: formatDay, value: formatDay };
        this.selectSpecialDay[rowIndex].calendar_list.push(oDate);
      } else {
        var index = this.selectSpecialDay[rowIndex].calendar_list.findIndex(function (e) {
          return e.value === formatDay;
        });
        if (index > -1) {
          this.selectSpecialDay[rowIndex].calendar_list.splice(index, 1);
        }
      }

      this.$nextTick(function () {
        var selectedDates = _this7.selectSpecialDay[rowIndex].calendar_list.map(function (item) {
          var date = __WEBPACK_IMPORTED_MODULE_8_moment___default()(item.value, 'YYYY-MM-DD').format('D/M/YYYY');
          return { date: date, dateTime: false, hour: '00', minute: '00' };
        });
        _this7.tempSpecialDayCalendar.selectedDates = selectedDates.slice();
      });
    },
    removeTag: function removeTag(type, rowIndex, val) {
      var formatday = __WEBPACK_IMPORTED_MODULE_8_moment___default()(val.value, 'YYYY-MM-DD').format('D/M/YYYY');

      if (type === 'date') {
        if (this.selectDate.selectedDates) {
          var index = this.selectDate.selectedDates.findIndex(function (e) {
            return e.date === formatday;
          });
          if (index > -1) {
            this.selectDate.selectedDates.splice(index, 1);
          }
        }
      } else if (type === 'specialDay') {
        var _index = this.selectSpecialDay[rowIndex].calendar_list.findIndex(function (e) {
          return e.value === val.value;
        });
        if (_index > -1) {
          this.selectSpecialDay[rowIndex].calendar_list.splice(_index, 1);
        }
      }
    },
    openSpecialDayCalendar: function openSpecialDayCalendar(rowIndex) {
      var selectedDates = this.selectSpecialDay[rowIndex].calendar_list.map(function (item) {
        return { date: __WEBPACK_IMPORTED_MODULE_8_moment___default()(item.value, 'YYYY-MM-DD').format('D/M/YYYY'), dateTime: false, hour: '00', minute: '00' };
      });
      this.tempSpecialDayCalendar.selectedDates = selectedDates.slice();
      this.selectSpecialDay[rowIndex].showSpecialDayCalendar = true;
      this.removeMultiselectWrapper();
    },
    removeListItem: function removeListItem(list, index) {
      list.splice(index, 1);
    },
    openDateCalendar: function openDateCalendar() {
      this.showCalendar = true;
      this.removeMultiselectWrapper();
    },
    removeMultiselectWrapper: function removeMultiselectWrapper() {
      this.$nextTick(function () {
        var calendarMultiselects = document.querySelectorAll('.calendar-multiselect');
        calendarMultiselects.forEach(function (multiselect) {
          var wrappers = multiselect.querySelectorAll('.multiselect__content-wrapper');
          wrappers.forEach(function (wrapper) {
            wrapper.remove();
          });
        });
      });
    },
    validateTimeRange: function validateTimeRange(item) {
      var startTimeKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'start_time';
      var endTimeKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'end_time';

      var startTime = item[startTimeKey];
      var endTime = item[endTimeKey];

      if (!startTime || !endTime) {
        return true;
      }

      var startTimeTrimmed = startTime.trim();
      var endTimeTrimmed = endTime.trim();

      var startMoment = __WEBPACK_IMPORTED_MODULE_8_moment___default()(startTimeTrimmed, 'HH:mm', true);
      var endMoment = __WEBPACK_IMPORTED_MODULE_8_moment___default()(endTimeTrimmed, 'HH:mm', true);

      if (startMoment.isSameOrAfter(endMoment)) {
        this.$notify({
          title: '提醒',
          text: '結束時間必須晚於開始時間',
          duration: 3000,
          type: 'danger',
          width: 400
        });
        item[endTimeKey] = '';
        return false;
      }
      return true;
    },
    clearProcess: function clearProcess(process) {
      process.end_value = '';
      process.start_value = '';
    },
    addItemTime: function addItemTime(process) {
      var item = {
        start_time: '',
        end_time: '',
        process_time: ''
      };
      process.item_list.push(item);
    },
    addProcessTime: function addProcessTime() {
      var process = {
        month: 0,
        value_type: 1,
        start_value: '',
        end_value: '',
        delivery_type: 1,
        item_list: [{
          start_time: '',
          end_time: '',
          process_time: ''
        }]
      };
      this.processTimeList.push(process);
    },
    addExCalendar: function addExCalendar() {
      var calendar = {
        delivery_type: 1,
        date_type: [],
        week_day: [],
        month_day: []
      };
      this.exceptionCalendar.push(calendar);
    },
    addExDate: function addExDate(exCalendar) {
      var date = {
        date: '',
        start_time: '',
        end_time: ''
      };
      exCalendar.date_type.push(date);
    },
    addExWeekDay: function addExWeekDay(exCalendar) {
      var weekDay = {
        day: 1,
        start_time: '',
        end_time: ''
      };
      exCalendar.week_day.push(weekDay);
    },
    addExMonthDay: function addExMonthDay(exCalendar) {
      var monthDay = {
        day: '',
        start_time: '',
        end_time: ''
      };
      exCalendar.month_day.push(monthDay);
    },
    addStartMonthDayTag: function addStartMonthDayTag(newTag, id) {
      var tag = {
        label: newTag,
        value: newTag
      };
      this.offdaySetting.options.monthDay.push(tag);
    },
    addEndMonthDayTag: function addEndMonthDayTag(newTag, id) {
      var tag = {
        label: newTag,
        value: newTag
      };
      this.offdaySetting.options.monthDay.push(tag);
    },
    addDateTag: function addDateTag(newTag) {
      var tag = {
        label: newTag,
        value: newTag
      };
      this.offdaySetting.options.date.push(tag);
    },
    addMonthDayTag: function addMonthDayTag(newTag) {
      var tag = {
        label: newTag,
        value: newTag
      };
      this.offdaySetting.options.monthDay.push(tag);
    },
    addSpecialDay: function addSpecialDay() {
      var calendar = {
        showSpecialDayCalendar: false,
        calendar_list: [],
        start_time: '',
        end_time: '',
        remark: ''
      };
      this.selectSpecialDay.push(calendar);
    },
    returnNum: function returnNum(e) {
      var charCode = e.which ? e.which : e.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        e.preventDefault();
      } else {
        return true;
      }
    },
    getMealTagList: function getMealTagList(callback) {
      var self = this;
      var url = '/mealTag/listBrief?is_visible=1';
      self.mealTagList = [];
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          response.data.list.forEach(function (tag) {
            var obj = {
              label: tag.name,
              value: tag.tag_id
            };
            self.mealTagList.push(obj);
          });
          callback();
        }
      });
    },
    getBindingClassList: function getBindingClassList() {
      var self = this;
      var url = 'brand/' + self.$route.params.brand_id + '/storeClassList';
      self.bindingClassList = [];
      self.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          response.data.list.forEach(function (bindingClass) {
            var obj = {
              label: bindingClass.name,
              value: bindingClass.id
            };
            self.bindingClassList.push(obj);
          });
        }
      });
    },
    init: function init() {
      var self = this;
      this.getMealTagList(function () {
        self.getTradeTypeList();
      });
      if (this.$route.name !== 'upStore') this.getGroupList();
      this.getCityAreaList();
      if (this.getRoleType === 99) this.getPosBrief();
      if (this.getRoleType === 99 || this.getRoleType === 30) this.getBrandImgList();

      this.getStoreBrief();
      this.getBrandInfo();
      if (this.$route.name === 'upStore' && this.getRoleType === 99) {
        this.getPosAccountList();
      }
      if (this.$route.name === 'crStore' && this.getRoleType === 99) {
        this.getBindingClassList();
        this.getMembershipType();
      }
      this.getShippingVendorList();
      this.getMenuId();
    },
    getMembershipType: function getMembershipType() {
      var _this8 = this;

      var url = '/membership/provider/list/?brand_id=' + this.$route.params.brand_id + '&page=1&size=20';
      this.getDataH('get', url, null, function (response) {
        _this8.membershipGroupType = response.data.list[0].meta.membership_group_type;
        _this8.providerId = response.data.list[0].id;
      });
    },
    getPosAccountList: function getPosAccountList() {
      var _this9 = this;

      var url = '/pos/list/?brand_id=' + this.$route.params.brand_id + '&store_id=' + this.$route.params.store_id + '&page=1&size=20';
      this.getDataH('get', url, null, function (response) {
        _this9.isPosAccount = response.data.list.length > 0 ? 1 : 0;
        _this9.posList = response.data.list.map(function (x) {
          return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, x, {
            vaildSingleAccount: true
          });
        });
        _this9.copyPostList = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_this9.posList));
      });
    },
    addAdRow: function addAdRow() {
      this.adRowNum = this.adRowNum + 1;
    },
    delAdRow: function delAdRow() {
      this.adRowNum = this.adRowNum - 1;
    },
    getGroupList: function getGroupList() {
      var self = this;
      var url = '/brand/' + this.$route.params.brand_id + '/storeGroupListBrief';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.groupList = response.data.list;
          if (self.groupList.length) self.groupSelect = self.groupList[0].id;
        }
      });
    },
    getPrinterLayoutList: function getPrinterLayoutList() {
      var self = this;
      var url = '/platform/printerLayoutList';
      this.getData('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.printerLayoutList = response.data.list;
          self.printerLayoutList.forEach(function (layout) {
            var obj = {
              trigger_type: 1,
              layout_type: layout.layout_type,
              layout_name: layout.name,
              is_enabled: 1
            };
            if (layout.is_enabled) {
              self.printerLayoutSetting.push(obj);
            }
          });
        }
      });
    },
    getTradeTypeList: function getTradeTypeList() {
      var self = this;
      var url = '/platform/tradeTypeList?new_version=1';
      this.getData('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.tradeInfo = [];
          var list = response.data.list;
          for (var i = 0; i < list.length; i++) {
            if (list[i].is_valid) {
              var option = {
                name: list[i].name,
                trade_type_id: parseInt(list[i].id, 10),
                is_support: parseInt(list[i].id, 10) === 1 ? 1 : 0,
                is_enable: 0,
                remark: '',
                ein: '',
                check_offline: list[i].check_offline
              };
              if (i === 0) option.is_enable = 1;
              if (list[i].meta !== null) {
                option.meta = {
                  use_key: 0,
                  use_offline_key: 0,
                  key: {},
                  group: { online: {}, offline: {} }
                };

                if (list[i].meta.keys) {
                  list[i].meta.keys.forEach(function (key) {
                    option.meta.key[key] = '';
                    if (key.includes('offline')) option.meta.group.offline[key] = list[i][key];else option.meta.group.online[key] = list[i][key];
                  });
                }

                if (list[i].meta.group) {
                  ['online', 'offline'].forEach(function (type) {
                    list[i].meta.group[type].forEach(function (key) {
                      option.meta.group[type][key] = '';
                    });
                  });
                }
              }
              if (list[i].custom_config !== null) {
                option.custom_config = {
                  use_key: 0,
                  key: {}
                };
                list[i].custom_config.keys.forEach(function (key) {
                  option.custom_config.key[key] = '';
                });
              }
              self.tradeInfo.push(option);
              var option2 = {
                label: list[i].name,
                value: parseInt(list[i].type, 10),
                trade_type_id: parseInt(list[i].id, 10)
              };
              self.tradeList.push(option2);
            }
          }
          if (self.$route.name === 'upStore') self.getStoreInfo();
        }
        if (self.$route.name !== 'upStore') self.getPrinterLayoutList();
      });
    },
    getCityAreaList: function getCityAreaList() {
      var self = this;
      var url = '/platform/cityAreaList';
      this.getData('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.cityAreaList = response.data.list;
          for (var i = 0; i < self.cityAreaList.length; i++) {
            var option = { name: self.cityAreaList[i].name, value: self.cityAreaList[i].city_code };
            self.cityOption.push(option);
            if (i === 0) self.citySelect = self.cityAreaList[i].city_code;
          }
        }
      });
    },
    getShippingVendorList: function getShippingVendorList() {
      var _this10 = this;

      var url = '/platform/shippingVendorList?type=2&is_visable=1';
      this.getData('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this10.supportShippingVendorList = response.data.list;

          if (_this10.$route.name === 'crStore' && _this10.getRoleType === 99) {
            _this10.shippingVendorInfo = response.data.list.map(function (item) {
              var obj = {};
              item.custom_config.forEach(function (config) {
                obj[config.attribute] = config.default;
              });
              return {
                vendor_code: item.vendor_code,
                is_enable: 0,
                custom_config: obj
              };
            });
          }
        }
      });
    },
    checkDefault: function checkDefault(type) {
      for (var i = 0; i < this.deliveryWaysInfo.length; i++) {
        if (this.deliveryWaysInfo[i].take_type !== type) {
          this.deliveryWaysInfo[i].is_default = 0;
        }
      }
    },
    checkOtherDelivery: function checkOtherDelivery() {
      for (var i = 0; i < this.deliveryOther.length; i++) {
        if (i === 0) {
          this.deliveryOther[i].price = this.deliveryWaysInfo[2].price;
        }
      }
    },
    checkDelivery: function checkDelivery() {
      for (var i = 0; i < this.deliveryOther.length; i++) {
        if (i === 0) {
          this.deliveryWaysInfo[2].price = this.deliveryOther[i].price;
        }
      }
    },
    getWeekDayName: function getWeekDayName(weekDay) {
      if (weekDay === 1) return '星期日';else if (weekDay === 2) return '星期一';else if (weekDay === 3) return '星期二';else if (weekDay === 4) return '星期三';else if (weekDay === 5) return '星期四';else if (weekDay === 6) return '星期五';else if (weekDay === 7) return '星期六';
    },
    onPhotoFileChange: function onPhotoFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var imgName = files[0].name.split('.');
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.createImage(files[0], 4);
      }
    },
    onFileChange: function onFileChange(e) {
      this.imgLogoSelect = '';
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var imgName = files[0].name.split('.');
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.createImage(files[0], 1);
      }
    },
    createImage: function createImage(file, method) {
      var reader = new FileReader();
      var self = this;
      reader.onload = function (e) {
        var img = new Image();
        img.src = e.target.result;
        if (method === 1) {
          self.storeInfo.image = img.src;
          self.storeInfo.image_name = img.src;
        } else if (method === 4) self.storeInfo.photo_name = img.src;
        img.onload = function () {
          self.img.width = img.width;
          self.img.height = img.height;
          self.checkImgSize(null, method);
        };
      };
      reader.readAsDataURL(file);
    },
    checkImgSize: function checkImgSize(type, method) {
      var self = this;
      if ((this.img.width !== 200 || this.img.height !== 200) && this.img.width !== 0 && this.img.height !== 0 && method === 1) {
        this.$notify({
          title: '提醒',
          text: 'LOGO尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳200x200之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if ((this.img.width !== 800 || this.img.height !== 460) && this.img.width !== 0 && this.img.height !== 0 && method === 3) {
        this.$notify({
          title: '提醒',
          text: '底圖照片寸為' + self.img.width + 'x' + self.img.height + '，請上傳800x460之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (type === 'cr') {
        this.createdBrand();
      } else if (type === 'up') {
        if (__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#brand-img-load')[0].files[0]) this.updatedIcon();else this.updatedBrand();
      }
    },
    onBgChange: function onBgChange(e) {
      this.imgBgSelect = '';
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var imgName = files[0].name.split('.');
      var imgSize = Math.round(files[0].size / 1000);
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (imgSize > 1024) {
        this.$notify({
          title: '提醒',
          text: '圖片檔案為' + imgSize + 'KB，請上傳小於1024KB之圖片',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {}
    },
    createBgImage: function createBgImage(file) {
      var reader = new FileReader();
      var self = this;
      reader.onload = function (e) {
        var img = new Image();
        img.src = e.target.result;
        if (self.storeInfo.bg_image) self.storeInfo.bg_image = img.src;
        self.storeInfo.bg_image_name = img.src;
        img.onload = function () {
          self.bgImg.width = img.width;
          self.bgImg.height = img.height;
          self.checkBgImgSize();
        };
      };
      reader.readAsDataURL(file);
    },
    checkBgImgSize: function checkBgImgSize(type) {
      var self = this;
      if ((this.bgImg.width !== 625 || this.bgImg.height !== 300) && this.bgImg.width !== 0 && this.bgImg.height !== 0) {
        this.$notify({
          title: '提醒',
          text: '圖片尺寸為' + self.bgImg.width + 'x' + self.bgImg.height + '，請上傳625x300之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (type === 'cr') {} else if (type === 'up') {}
    },
    getPosBrief: function getPosBrief() {
      this.posBrief = [];
      var self = this;
      var url = '/pos/vendorBriefList';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var pList = response.data.list;
          for (var i = 0; i < pList.length; i++) {
            var obj = { label: pList[i].name, value: pList[i].pos_vendor_id };
            self.posBrief.push(obj);
            if (i === pList.length - 1) {
              self.posSelect = pList[i].pos_vendor_id;
            }
          }
        }
      });
    },
    getStoreBrief: function getStoreBrief() {
      var _this11 = this;

      this.storeBrief = [];
      var url = '/brand/' + this.$route.params.brand_id + '/storeListBrief?list_sort=name ASC';
      this.getDataH('get', url, null, function (res) {
        if (res.data.status === 200) {
          if (_this11.getRoleType === 99 && _this11.info) _this11.getPrinterStoreList();
          var sList = res.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            _this11.storeBrief.push(obj);
            if (i === 0) _this11.copyStoreSelect = sList[i].store_id;
          }
          _this11.$store.commit('SET_BRAND_ID', Number(_this11.$route.params.brand_id));
          _this11.$store.commit('SET_STORE_ID', Number(_this11.$route.params.store_id));
          _this11.$store.commit('SET_STORES', res.data.list);
          _this11.urlRedirection.stores = res.data.list;
        }
      });
    },
    verityPos: function verityPos() {
      if (this.posList.filter(function (x) {
        return x.account === '' || x.password === '';
      }).length > 0) {
        return false;
      }
      return true;
    },
    verityTel: function verityTel() {
      var e = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this.$refs.tel);
      this.storeInfo.tel = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9-#()\s]*/));
      }
    },
    verityTel2: function verityTel2() {
      var e = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this.$refs.tel2);
      this.storeInfo.tel2 = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9-#()\s]*/));
      }
    },
    verityEin: function verityEin() {
      var e = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this.$refs.ein);
      this.storeInfo.ein = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityTradeEin: function verityTradeEin(index) {
      this.reload = true;
      var ein = this.tradeInfo[index].ein || '';
      this.$set(this.tradeInfo[index], 'ein', ein.replace(/\D/g, ''));
    },
    isTradeMetaKeyFilled: function isTradeMetaKeyFilled(trade) {
      if (!trade.meta) return false;
      return ['online', 'offline'].some(function (lineType) {
        var useKey = lineType === 'online' ? 'use_key' : 'use_offline_key';
        var deleteKey = lineType === 'online' ? 'delete_key' : 'delete_offline_key';
        var group = trade.meta.group && trade.meta.group[lineType] || {};
        if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(group).some(function (name) {
          return !!group[name];
        })) return true;
        return parseInt(trade.meta[useKey], 10) === 1 && !parseInt(trade.meta[deleteKey], 10);
      });
    },
    isTradeEinFieldFilled: function isTradeEinFieldFilled(trade) {
      if (trade.ein) return true;

      if (this.isTradeMetaKeyFilled(trade)) return true;

      var customKey = trade.custom_config && trade.custom_config.key || {};
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(customKey).some(function (name) {
        return !!customKey[name];
      });
    },
    getEinCheckTradeList: function getEinCheckTradeList() {
      var _this12 = this;

      return this.tradeInfo.filter(function (trade) {
        if (!trade.meta && !trade.custom_config) return false;
        return _this12.isTradeEinFieldFilled(trade);
      });
    },
    getTradeCustomKeyState: function getTradeCustomKeyState(trade) {
      if (!trade.custom_config) return '';
      var key = trade.custom_config.key || {};
      var state = {};
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(key).sort().forEach(function (name) {
        state[name] = key[name] || '';
      });
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(state);
    },
    snapshotTradeEin: function snapshotTradeEin() {
      var _this13 = this;

      var origin = {};
      this.tradeInfo.forEach(function (trade) {
        origin[trade.trade_type_id] = {
          ein: trade.ein || '',
          use_key: trade.meta ? parseInt(trade.meta.use_key, 10) || 0 : 0,
          use_offline_key: trade.meta ? parseInt(trade.meta.use_offline_key, 10) || 0 : 0,
          custom_key: _this13.getTradeCustomKeyState(trade)
        };
      });
      this.originTradeEin = origin;
    },
    isTradeMetaKeyChanged: function isTradeMetaKeyChanged(trade, origin) {
      if (!trade.meta) return false;
      return ['online', 'offline'].some(function (lineType) {
        var useKey = lineType === 'online' ? 'use_key' : 'use_offline_key';
        if (parseInt(trade.meta[useKey], 10) !== 2) return false;
        var group = trade.meta.group && trade.meta.group[lineType] || {};
        var isEmpty = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(group).every(function (name) {
          return !group[name];
        });
        return !isEmpty || parseInt(origin[useKey], 10) === 1;
      });
    },
    isTradeEinChanged: function isTradeEinChanged(trade) {
      var origin = this.originTradeEin[trade.trade_type_id] || {};

      if ((origin.ein || '') !== (trade.ein || '')) return true;

      if (this.isTradeMetaKeyChanged(trade, origin)) return true;

      return (origin.custom_key || '') !== this.getTradeCustomKeyState(trade);
    },
    needEinConfirm: function needEinConfirm(method, type) {
      var _this14 = this;

      if (this.getRoleType !== 99) return false;

      if (type !== 'cr' && type !== 'up') return false;

      if (this.einConfirmed) {
        this.einConfirmed = false;
        return false;
      }

      if (type === 'up' && method !== 1 && method !== 4) return false;

      if (type === 'up' && method === 1 && (this.storeInfo.ein || '') === (this.originEin || '')) return false;

      var storeEin = this.storeInfo.ein || '';

      var diffList = this.getEinCheckTradeList().filter(function (trade) {
        return (trade.ein || '') !== storeEin;
      });

      if (type === 'up' && method === 4) diffList = diffList.filter(function (trade) {
        return _this14.isTradeEinChanged(trade);
      });
      if (!diffList.length) return false;

      this.einCheckStoreEin = storeEin;
      this.einCheckList = diffList.map(function (trade) {
        return { name: trade.name, ein: trade.ein || '' };
      });
      return true;
    },
    verityOneOrderMaxMoney: function verityOneOrderMaxMoney() {
      var e = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this.$refs.oneOrderMaxMoney);
      this.storeInfo.one_order_max_money = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityStorePayMaxMoney: function verityStorePayMaxMoney() {
      var e = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this.$refs.storePayMaxMoney);
      this.storeInfo.to_store_pay_max_money = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityRejectTime: function verityRejectTime() {
      var e = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this.$refs.rejectTime);
      this.storeInfo.auto_reject_order_m = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityStartTime: function verityStartTime() {
      var e = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this.$refs.startTime);
      this.storeInfo.order_start_time_m = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityEndTime: function verityEndTime() {
      var e = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this.$refs.endTime);
      this.storeInfo.order_end_time_m = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityFoodBusinessNo: function verityFoodBusinessNo() {
      var pattern = /^[A-Z]{1}-[1-2]{1}\d{8}-\d{5}-\d{1}$/;
      var temp = false;
      if (this.storeInfo.food_business_no && !pattern.test(this.storeInfo.food_business_no)) {
        temp = false;
      } else {
        temp = true;
      }
      return temp;
    },
    isPureNumber: function isPureNumber(val) {
      return (/^\d+$/.test(val)
      );
    },
    checkBeforeSend: function checkBeforeSend(type) {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var all, title, msg, prepareTimeError, processTimeListError, checkMondayError, checkDeliveryExceptionProductList, deliveryExceptionList, cal, monthDay, r, i, j, k, method, isUp;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                all = _this15.getInput;
                title = '提醒';
                msg = '';
                prepareTimeError = false;
                processTimeListError = false;
                checkMondayError = false;
                checkDeliveryExceptionProductList = false;
                deliveryExceptionList = _this15.deliveryExceptionProductList.filter(function (item) {
                  return item.vendor_custom_id === '' || item.product_name === '';
                });

                if (deliveryExceptionList.length > 0) {
                  checkDeliveryExceptionProductList = true;
                }
                for (cal = 0; cal < _this15.exceptionCalendar.length; cal++) {
                  for (monthDay = 0; monthDay < _this15.exceptionCalendar[cal].month_day.length; monthDay++) {
                    r = _this15.exceptionCalendar[cal].month_day[monthDay].day;

                    if (!_this15.isPureNumber(r)) {
                      checkMondayError = true;
                    }
                    if (_this15.exceptionCalendar[cal].month_day[monthDay].day < 1 || _this15.exceptionCalendar[cal].month_day[monthDay].day > 31) {
                      checkMondayError = true;
                    }
                  }
                }

                for (i = 0; i < _this15.takeTimeInfo.length; i++) {
                  if (!_this15.takeTimeInfo[i].prepare_time_seg.toString()) {
                    if (_this15.takeTimeInfo[i].take_type !== 3) _this15.takeTimeInfo[i].prepare_time_seg = 15;else _this15.takeTimeInfo[i].prepare_time_seg = 30;
                  } else if (_this15.takeTimeInfo[i].prepare_time_seg < 3) {
                    prepareTimeError = true;
                  }
                  if (!_this15.takeTimeInfo[i].take_time_seg.toString()) _this15.takeTimeInfo[i].take_time_seg = 0;
                }

                processTimeListError = _this15.processTimeList.some(function (item) {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(item.month) !== 'object' || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(item.delivery_type) !== 'object';
                });
                for (j = 0; j < _this15.deliveryWaysInfo.length; j++) {
                  if (!_this15.deliveryWaysInfo[j].distance_m.toString()) _this15.deliveryWaysInfo[j].distance_m = 0;
                  if (!_this15.deliveryWaysInfo[j].price.toString()) _this15.deliveryWaysInfo[j].price = 0;
                }
                for (k = 0; k < _this15.deliveryOther.length; k++) {
                  if (!_this15.deliveryOther[k].distance_m.toString()) _this15.deliveryOther[k].distance_m = 0;
                  if (!_this15.deliveryOther[k].price.toString()) _this15.deliveryOther[k].price = 0;
                }
                method = _this15.storeMethod;
                isUp = _this15.info;


                if (!all.name && (method === 1 && isUp || !isUp)) {
                  msg = '請輸入店家名稱';
                  _this15.storeMethod = 1;
                } else if (!all.name_short && (method === 1 && isUp || !isUp)) {
                  msg = '請輸入店家縮寫';
                  _this15.storeMethod = 1;
                } else if (!all.address_short && (method === 1 && isUp || !isUp)) {
                  msg = '請輸入地址';
                  _this15.storeMethod = 1;
                } else if (_this15.storeInfo.membership_provider_parent_id < 0 && method === 3 && _this15.membershipGroupType === 2) {
                  msg = '請選擇是否開通會員卡。';
                  _this15.storeMethod = 2;
                } else if (!all.order_start_day && (method === 3 && isUp || !isUp)) {
                  msg = '請輸入預訂開始日';
                  _this15.storeMethod = 3;
                } else if (!all.order_tolerance_day && (method === 3 && isUp || !isUp)) {
                  msg = '請輸入預訂結束日';
                  _this15.storeMethod = 3;
                } else if (!all.auto_reject_order_reserve_m && (method === 3 && isUp || !isUp)) {
                  msg = '請輸入自動拒絕預約單時間';
                  _this15.storeMethod = 3;
                } else if (!all.plastic_unit && (method === 8 && isUp || !isUp)) {
                  msg = '請輸入塑膠袋單位';
                  _this15.storeMethod = 8;
                } else if (!all.address_short && (method === 1 && isUp || !isUp)) {
                  msg = '請輸入地址';
                  _this15.storeMethod = 1;
                } else if (!all.tel && (method === 1 && isUp || !isUp)) {
                  msg = '請至少輸入一筆電話';
                  _this15.storeMethod = 1;
                } else if (!all.custom_sticker_max_length && (method === 2 && isUp || !isUp)) {
                  msg = '請輸入單筆訂單最高上限之金額';
                  _this15.storeMethod = 2;
                } else if (!all.one_order_max_money && (method === 2 && isUp || !isUp)) {
                  msg = '請輸入單筆訂單最高上限之金額';
                  _this15.storeMethod = 2;
                } else if (!all.auto_reject_order_m && (method === 3 && isUp || !isUp)) {
                  msg = '請輸入自動拒單時間';
                  _this15.storeMethod = 3;
                } else if (parseInt(all.auto_reject_order_m, 10) > 1440 && (method === 3 && isUp || !isUp)) {
                  msg = '自動拒單時間須小於或等於1440分鐘';
                  _this15.storeMethod = 3;
                } else if (!all.order_start_time_m && (method === 3 && isUp || !isUp)) {
                  msg = '請輸入距營業時間方可訂購之時間';
                  _this15.storeMethod = 3;
                } else if (parseInt(all.order_start_time_m, 10) > 1440 && (method === 3 && isUp || !isUp)) {
                  msg = '距營業時間方可訂購之時間須小於或等於1440分鐘';
                  _this15.storeMethod = 3;
                } else if (!all.order_end_time_m && (method === 3 && isUp || !isUp)) {
                  msg = '請輸入距打烊時間為最後訂購之時間';
                  _this15.storeMethod = 3;
                } else if (parseInt(all.order_end_time_m, 10) > 1440 && (method === 3 && isUp || !isUp)) {
                  msg = '距打烊時間為最後訂購之時間須小於或等於1440分鐘';
                  _this15.storeMethod = 3;
                } else if ((method === 5 || !isUp) && prepareTimeError) {
                  msg = '準備時間不可低於 3 分鐘';
                  _this15.storeMethod = 5;
                } else if ((method === 5 || !isUp) && processTimeListError) {
                  msg = '請填好完整時段製作時間';
                  _this15.storeMethod = 5;
                } else if (method === 6 && checkDeliveryExceptionProductList) {
                  msg = '商品名稱或料號不得為空值';
                  _this15.storeMethod = 6;
                } else if ((method === 6 || !isUp) && checkMondayError) {
                  msg = '每月幾號不可填入小於 1 或大於 31 的數字';
                  _this15.storeMethod = 6;
                } else if ((method === 12 || !isUp) && _this15.checkCommission() !== false) {
                  msg = _this15.checkCommission();
                  _this15.storeMethod = 12;
                } else if (_this15.isPosAccount === 1 && method === 2) {
                  if (_this15.posList.length < 1) {
                    msg = '請至少新增一個帳號';
                    _this15.storeMethod = 2;
                  }
                  if (!_this15.verityPos()) {
                    msg = '請填好完整POS資訊';
                    _this15.storeMethod = 2;
                  }
                  if (_this15.repeatPosAccountList.length > 0 || _this15.posList.filter(function (x) {
                    return !x.vaildSingleAccount;
                  }).length > 0) {
                    msg = 'POS帳號不能重複';
                    _this15.storeMethod = 2;
                  }
                } else if (method === 2 && _this15.copyInfo.menuStore && !_this15.copyInfo.menuStoreId) {
                  msg = '請選擇複製店家的菜單';
                  _this15.storeMethod = 2;
                } else if (method === 2 && _this15.copyInfo.productAlias && !_this15.copyInfo.productAliasStoreId) {
                  msg = '請選擇複製店家的別名/描述/警語';
                  _this15.storeMethod = 2;
                } else if (method === 2 && _this15.copyInfo.productImage && !_this15.copyInfo.productImageStoreId) {
                  msg = '請選擇複製店家的圖片庫';
                  _this15.storeMethod = 2;
                } else if (method === 1 && !_this15.verityFoodBusinessNo()) {
                  title = '食品業者登錄字號格式錯誤';
                  msg = '請輸入格式正確的 19 碼字串，需包含英文、數字與「-」';
                  _this15.storeMethod = 1;
                }

                _this15.tradeInfo.forEach(function (payment) {
                  if (!payment.meta) return;

                  ['online', 'offline'].forEach(function (lineType) {
                    if (msg) return;

                    var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(payment.meta.group[lineType]);
                    var emptyKeys = [];

                    keys.forEach(function (key) {
                      var value = payment.meta.group[lineType][key];
                      if (!value) emptyKeys.push(key);
                    });

                    if (!emptyKeys.length || emptyKeys.length === keys.length) return;

                    msg = '\u8ACB\u8F38\u5165 ' + emptyKeys[0];
                    _this15.storeMethod = 4;
                  });
                });

                if (!(!msg && _this15.needEinConfirm(method, type))) {
                  _context7.next = 22;
                  break;
                }

                _this15.einConfirmType = type;
                window.$('#einModal').modal('show');
                return _context7.abrupt('return');

              case 22:

                _this15.getToast(msg, type, title);

              case 23:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this15);
      }))();
    },
    getToast: function getToast(msg, type) {
      var title = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '提醒';

      if (msg) {
        this.$notify({
          title: title,
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        if (type === 'cr') this.createdStore();else if (type === 'up' && this.storeMethod === 1) this.updatedLogoImg();else if (type === 'up') this.updatedStore();
      }
    },
    getBrandInfo: function getBrandInfo() {
      var _this16 = this;

      var url = '/brand/' + this.$route.params.brand_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this16.brandInvalidQuota = response.data.brand_info.order_commission_setting.allow_invalid_order_quota;
        }
      });
    },
    getBrandImgList: function getBrandImgList() {
      var self = this;
      var url = '/brand/' + this.$route.params.brand_id + '/storesImage?image_type=1';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var logoList = response.data.list;
          for (var i = 0; i < logoList.length; i++) {
            var option = { name: logoList[i].image_name, value: logoList[i].image_url };
            self.imgLogoOption.push(option);
          }
        }
      });
      var url2 = '/brand/' + this.$route.params.brand_id + '/storesImage?image_type=3';
      this.getDataH('get', url2, null, function (response) {
        if (response.data.status === 200) {
          var bgList = response.data.list;
          for (var j = 0; j < bgList.length; j++) {
            var option2 = { name: bgList[j].image_name, value: bgList[j].image_url };
            self.imgBgOption.push(option2);
          }
        }
      });
    },
    createdStore: function createdStore() {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var self, sInfo, info, shippingComponent, data, brandId, name, addressShort, tel, oneOrderMaxMoney, toStorePayMaxMoney, orderStartTimeM, orderEndTimeM, autoRejectOrderM, orderStartDay, orderToleranceDay, autoRejectOrderReserveM, plasticUnit, ids, bindingClassIds, newETradeList, newECalendarList, newTimeList, dWayPlastic, offday, openingTimes, i, obj, openTime, specialTimes, deliveryWays, memoList, isSupport, isEnable, k, option, j, option2, takeTimeInfo, _k, option3, deliveryCustomArr, tableConfigObj, tradeInfo, _loop, l, branchCode, posBranchCode, nameShort, description, comment, ein, blName, tel2, email, searchDescription, imgPath, imgName, imgPath2, imgName2, query, url;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                self = _this17;
                sInfo = _this17.storeInfo;
                info = _this17.getInput;
                shippingComponent = _this17.$refs.shippingInfo;

                if (!(shippingComponent && shippingComponent.feeTypeSelect !== null)) {
                  _context9.next = 13;
                  break;
                }

                _context9.prev = 5;
                _context9.next = 8;
                return shippingComponent.checkShipping(info.max_delivery_distance_m);

              case 8:
                _context9.next = 13;
                break;

              case 10:
                _context9.prev = 10;
                _context9.t0 = _context9['catch'](5);
                return _context9.abrupt('return');

              case 13:
                _this17.loading = true;
                data = new FormData();
                brandId = parseInt(_this17.$route.params.brand_id, 10);
                name = info.name;
                addressShort = info.address_short;
                tel = info.tel;
                oneOrderMaxMoney = parseInt(info.one_order_max_money, 10);
                toStorePayMaxMoney = parseInt(info.to_store_pay_max_money, 10);
                orderStartTimeM = info.order_start_time_m;
                orderEndTimeM = info.order_end_time_m;
                autoRejectOrderM = info.auto_reject_order_m;
                orderStartDay = info.order_start_day;
                orderToleranceDay = info.order_tolerance_day;
                autoRejectOrderReserveM = info.auto_reject_order_reserve_m;
                plasticUnit = info.plastic_unit;

                data.append('brand_id', brandId);
                data.append('store_group_id', parseInt(_this17.groupSelect, 10));
                data.append('name', name);
                data.append('city_code', parseInt(_this17.citySelect, 10));
                data.append('area_code', parseInt(_this17.areaSelect, 10));
                data.append('address_short', addressShort);
                data.append('tel', tel);
                data.append('store_type', parseInt(_this17.storeTypeSelect, 10));
                data.append('status', parseInt(_this17.statusSelect, 10));
                data.append('order_status', parseInt(_this17.orderStatusSelect, 10));
                data.append('is_visible', parseInt(_this17.isVisibleSelect, 10));
                data.append('barcode_type', parseInt(_this17.barcodeSelect, 10));
                data.append('one_order_max_money', oneOrderMaxMoney);
                data.append('to_store_pay_max_money', toStorePayMaxMoney);
                data.append('order_start_time_m', orderStartTimeM);
                data.append('order_end_time_m', orderEndTimeM);
                data.append('has_invoice_paper', _this17.hasInvoicePaperSelect);
                data.append('has_invoice_carrier', _this17.hasInvoiceCarrierSelect);
                data.append('has_invoice_npoban', _this17.hasInvoiceNpobnaSelect);
                data.append('is_invoice_exception', _this17.isInvoiceException);
                data.append('invoice_remark', _this17.invoiceRemark);
                data.append('auto_reject_order_m', autoRejectOrderM);
                data.append('is_search', self.isSearchSelect);

                data.append('api_type', parseInt(_this17.apiTypeSelect, 10));
                data.append('order_start_day', orderStartDay);
                data.append('order_tolerance_day', orderToleranceDay);
                data.append('auto_reject_order_reserve_m', autoRejectOrderReserveM);
                data.append('plastic_unit', plasticUnit);
                data.append('plastic_option', parseInt(_this17.plasticSelect, 10));
                data.append('delivery_need_plastic', parseInt(_this17.deliveryNeedSelect, 10));
                data.append('show_menu_icon', parseInt(_this17.showMenuIconSelect, 10));

                data.append('is_off_allow_order', sInfo.is_off_allow_order);
                data.append('is_preparing_allow_order', sInfo.is_preparing_allow_order);
                data.append('is_close_allow_order', sInfo.is_close_allow_order);
                data.append('show_menu_product_icon', sInfo.show_menu_product_icon);
                data.append('menu_layout_type', sInfo.menu_layout_type);

                data.append('rounding_type', self.roundingTypeSelect);
                data.append('coupon_form', self.couponFormSelect);

                data.append('menu_expand_type', sInfo.menu_expand_type);

                data.append('order_status_reason', sInfo.order_status_reason);

                data.append('menu_stop_sale_type', sInfo.menu_stop_sale_type);

                data.append('menu_stop_sale_today_type', sInfo.menu_stop_sale_today_type);

                data.append('show_menu_zero_money', sInfo.show_menu_zero_money);

                if (sInfo.membership_provider_parent_id && _this17.membershipGroupType === 2) {
                  data.append('membership_provider_parent_id', sInfo.membership_provider_parent_id);
                }

                data.append('distance_service_model', self.disModeSelect);

                data.append('is_support_custom_sticker', self.isStickerSelect);

                if (info.introduction) data.append('introduction', info.introduction);
                if (info.youtube_video_code) data.append('youtube_video_code', info.youtube_video_code);
                ids = sInfo.binding_meal_tag_ids.map(function (item) {
                  return item.value;
                });

                if (sInfo.binding_meal_tag_ids.length) data.append('binding_meal_tag_ids', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(ids));
                data.append('delivery_stage_limit_type', sInfo.delivery_stage_limit_type);

                data.append('show_product_setting', _this17.showProdSettingSelect);

                if (_this17.copyInfo.menuStore && _this17.copyInfo.menuStoreId) {
                  data.append('copy_menu_store_id', _this17.copyInfo.menuStoreId.value);
                }
                if (_this17.copyInfo.productAlias && _this17.copyInfo.productAliasStoreId) {
                  data.append('copy_product_alias_store_id', _this17.copyInfo.productAliasStoreId.value);
                }
                if (_this17.copyInfo.productDescription && _this17.copyInfo.productDescriptionStoreId) {
                  data.append('copy_product_description_store_id', _this17.copyInfo.productDescriptionStoreId.value);
                }
                if (_this17.copyInfo.productImage && _this17.copyInfo.productImageStoreId) {
                  data.append('copy_product_image_store_id', _this17.copyInfo.productImageStoreId.value);
                }bindingClassIds = sInfo.binding_class_ids.map(function (item) {
                  return item.value;
                });

                if (sInfo.binding_class && sInfo.binding_class_ids.length) data.append('binding_class_ids', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(bindingClassIds));

                if (typeof sInfo.allow_copy_menu !== 'undefined' && sInfo.allow_copy_menu !== null) data.append('allow_copy_menu', sInfo.allow_copy_menu);
                if (typeof sInfo.allow_update_menu !== 'undefined' && sInfo.allow_update_menu !== null) data.append('allow_update_menu', sInfo.allow_update_menu);
                data.append('store_shipping_vendor', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_this17.supportShippingVendor));

                data.append('menu_expand_type', sInfo.menu_expand_type);

                newETradeList = [];

                _this17.exceptionTradeList.forEach(function (eTrade) {
                  var obj = eTrade;
                  if (!obj.start_money) obj.start_money = null;
                  if (!obj.end_money) obj.end_money = null;
                  newETradeList.push(obj);
                });
                if (newETradeList.length) data.append('delivery_exception_trade_setting', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(newETradeList));
                newECalendarList = {};

                _this17.exceptionCalendar.forEach(function (eCalendar) {
                  var obj = {
                    date_type: eCalendar.date_type,
                    week_day: eCalendar.week_day,
                    month_day: eCalendar.month_day
                  };
                  newECalendarList[eCalendar.delivery_type] = obj;
                });
                data.append('delivery_exception_calendar_setting', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(newECalendarList));
                newTimeList = [];

                _this17.processTimeList.forEach(function (item) {
                  var process = {
                    month: item.month.value,
                    value_type: item.value_type,
                    start_value: item.start_value.value,
                    end_value: item.end_value.value,
                    delivery_type: item.delivery_type.value,
                    item_list: item.item_list
                  };
                  newTimeList.push(process);
                });
                if (newTimeList.length) data.append('process_time_setting', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(newTimeList));
                dWayPlastic = [];

                _this17.deliveryWayPlastic.forEach(function (delivery) {
                  dWayPlastic.push(delivery.value);
                });
                if (dWayPlastic.length) data.append('delivery_way_plastic_selected', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(dWayPlastic));
                offday = {
                  date: [],
                  week_day: [],
                  month_day: []
                };

                _this17.offdaySetting.date.forEach(function (date) {
                  offday.date.push(date.value);
                });
                _this17.offdaySetting.weekDay.forEach(function (weekDay) {
                  offday.week_day.push(weekDay.value);
                });
                _this17.offdaySetting.monthDay.forEach(function (monthDay) {
                  offday.month_day.push(monthDay.value);
                });
                data.append('offday_setting', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(offday));
                openingTimes = [];

                for (i = 0; i < _this17.openingInfo.length; i++) {
                  obj = _this17.openingInfo[i];
                  openTime = {
                    week_day: obj.week_day,
                    start_time: obj.start + ':00',
                    end_time: obj.end + ':59'
                  };

                  openingTimes.push(openTime);
                }
                data.append('opening_times', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(openingTimes));

                if (_this17.selectSpecialDay.length > 0) {
                  specialTimes = [];

                  _this17.selectSpecialDay.forEach(function (item) {
                    var obj = {
                      calendar_list: item.calendar_list.map(function (date) {
                        return { usage_type: 1, usage_date: date.value };
                      }),
                      start_time: item.start_time + ':00',
                      end_time: item.end_time + ':59',
                      remark: item.remark
                    };
                    specialTimes.push(obj);
                  });
                  data.append('order_time_setting', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(specialTimes));
                } else {
                  data.append('order_time_setting', '');
                }
                deliveryWays = [];
                memoList = [];
                isSupport = 1;
                isEnable = 1;

                for (k = 0; k < _this17.deliveryWaysInfo.length; k++) {
                  option = {
                    take_type: parseInt(_this17.deliveryWaysInfo[k].take_type, 10),
                    is_support: parseInt(_this17.deliveryWaysInfo[k].is_support, 10),
                    is_enable: parseInt(_this17.deliveryWaysInfo[k].is_enable, 10),
                    distance_m: parseInt(_this17.deliveryWaysInfo[k].distance_m, 10),
                    price: parseInt(_this17.deliveryWaysInfo[k].price, 10),
                    is_default: parseInt(_this17.deliveryWaysInfo[k].is_default, 10),
                    is_allow_guest_order: parseInt(_this17.deliveryWaysInfo[k].is_allow_guest_order, 10)
                  };

                  if (option.take_type === 3) {
                    isSupport = parseInt(_this17.deliveryWaysInfo[k].is_support, 10);
                    isEnable = parseInt(_this17.deliveryWaysInfo[k].is_enable, 10);
                  }
                  deliveryWays.push(option);
                  memoList.push({
                    take_type: parseInt(_this17.deliveryWaysInfo[k].take_type, 10),
                    memo: _this17.deliveryWaysInfo[k].memo || '',
                    pickup_memo: _this17.deliveryWaysInfo[k].pickup_memo || ''
                  });
                }
                for (j = 0; j < _this17.deliveryOther.length; j++) {
                  option2 = {
                    take_type: parseInt(_this17.deliveryOther[j].take_type, 10),
                    is_support: parseInt(_this17.deliveryOther[j].is_support, 10),
                    is_enable: parseInt(_this17.deliveryOther[j].is_enable, 10),
                    distance_m: parseInt(_this17.deliveryOther[j].distance_m, 10),
                    price: parseInt(_this17.deliveryOther[j].price, 10),
                    is_allow_guest_order: parseInt(_this17.deliveryOther[j].is_allow_guest_order, 10)
                  };

                  if (option2.take_type === 3) {
                    option2.is_support = isSupport;
                    option2.is_enable = isEnable;
                  }
                  if (_this17.deliveryOther[j].distance_m && (_this17.deliveryOther[j].price || j === 0)) {
                    deliveryWays.push(option2);
                  }
                }
                data.append('delivery_ways', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(deliveryWays));
                data.append('delivery_way_memo', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(memoList));
                takeTimeInfo = [];

                for (_k = 0; _k < _this17.takeTimeInfo.length; _k++) {
                  option3 = {
                    take_type: parseInt(_this17.takeTimeInfo[_k].take_type, 10),
                    prepare_time_seg: parseInt(_this17.takeTimeInfo[_k].prepare_time_seg, 10),
                    take_time_seg: parseInt(_this17.takeTimeInfo[_k].take_time_seg, 10)
                  };

                  takeTimeInfo.push(option3);
                }
                data.append('take_time_seg', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(takeTimeInfo));
                deliveryCustomArr = [];
                tableConfigObj = {
                  type: null,
                  config: {}
                };

                __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this17.tableNumber).forEach(function (item) {
                  if (item === 'type') {
                    tableConfigObj.type = _this17.tableNumber[item];
                  } else {
                    tableConfigObj.config[item] = _this17.tableNumber[item];
                  }
                });
                deliveryCustomArr.push(tableConfigObj);
                data.append('delivery_way_custom_config', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(deliveryCustomArr));
                tradeInfo = [];

                _loop = function _loop(l) {
                  var option4 = {
                    trade_type_id: parseInt(_this17.tradeInfo[l].trade_type_id, 10),
                    is_enable: parseInt(_this17.tradeInfo[l].is_enable, 10),
                    is_support: parseInt(_this17.tradeInfo[l].is_support, 10),
                    remark: _this17.tradeInfo[l].remark
                  };

                  if (_this17.getRoleType === 99 && (_this17.tradeInfo[l].meta || _this17.tradeInfo[l].custom_config)) {
                    option4.ein = _this17.tradeInfo[l].ein || null;
                  }

                  if (_this17.tradeInfo[l].meta) {
                    option4.meta = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_this17.tradeInfo[l].meta));
                    delete option4.meta.key;

                    var lineTypes = ['online', 'offline'];
                    lineTypes.forEach(function (type) {
                      var useKey = type === 'online' ? 'use_key' : 'use_offline_key';
                      var deleteKey = type === 'online' ? 'delete_key' : 'delete_offline_key';
                      var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(option4.meta.group[type]);
                      var isEmpty = keys.every(function (key) {
                        return !option4.meta.group[type][key];
                      });

                      if (option4.meta[useKey] === 2) {
                        option4.meta[useKey] = 1;
                        option4.meta[deleteKey] = isEmpty ? 1 : 0;
                      } else {
                        option4.meta[useKey] = 0;
                        option4.meta[deleteKey] = 0;
                        delete option4.meta.group[type];
                      }
                    });

                    var isEmptyGroup = !__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(option4.meta.group).length;
                    if (isEmptyGroup) delete option4.meta;
                  }

                  if (_this17.tradeInfo[l].custom_config) {
                    option4.custom_config = {
                      use_key: 0,
                      key: _this17.tradeInfo[l].custom_config.key
                    };
                    var vIndex = 0;
                    var sumIndex = 0;
                    for (var tKey in _this17.tradeInfo[l].custom_config.key) {
                      if (_this17.tradeInfo[l].custom_config.key[tKey]) vIndex++;
                      sumIndex++;
                    }
                    if (vIndex === sumIndex) option4.custom_config.use_key = 1;else delete option4.custom_config;
                  }
                  tradeInfo.push(option4);
                };

                for (l = 0; l < _this17.tradeInfo.length; l++) {
                  _loop(l);
                }
                data.append('trade_types', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(tradeInfo));
                branchCode = info.branch_code;
                posBranchCode = info.pos_branch_code;
                nameShort = info.name_short;
                description = info.description;
                comment = info.comment;
                ein = info.ein;
                blName = info.bl_name;
                tel2 = info.tel2;
                email = info.email;
                searchDescription = info.search_description;

                if (info.branch_code) data.append('branch_code', branchCode);
                if (info.pos_branch_code) data.append('pos_branch_code', posBranchCode);
                if (info.name_short) data.append('name_short', nameShort);
                if (info.description) data.append('description', description);
                if (info.comment) data.append('comment', comment);
                if (info.ein) data.append('ein', ein);
                if (info.bl_name) data.append('bl_name', blName);
                if (info.tel2) data.append('tel2', tel2);
                if (info.email) data.append('email', email);
                if (info.search_description) data.append('search_description', searchDescription);
                if (info.address_remark) data.append('address_remark', info.address_remark);
                if (info.max_delivery_distance_m) data.append('max_delivery_distance_m', info.max_delivery_distance_m);
                if (info.shipping_description) data.append('shipping_description', info.shipping_description);
                if (info.is_support_custom_remark) data.append('is_support_custom_remark', info.is_support_custom_remark);

                if (_this17.storeInfo.image_name.indexOf('http') > -1 && _this17.imgLogoSelect) data.append('image_name', _this17.imgLogoSelect);else if (__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#brand-img-load')[0].files[0]) {
                  data.append('image_file', __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#brand-img-load')[0].files[0]);
                  imgPath = __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#brand-img-load')[0].files[0];
                  imgName = imgPath.name.replace(/\.(jpg|gif|png)$/, '');

                  data.append('image_name', imgName);
                }

                if (__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#brand-photo-load')[0].files[0]) {
                  data.append('photo_file', __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#brand-photo-load')[0].files[0]);
                  imgPath2 = __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#brand-photo-load')[0].files[0];
                  imgName2 = imgPath2.name.replace(/\.(jpg|gif|png)$/, '');

                  data.append('photo_name', imgName2);
                }
                query = _this17.setCommissionQuery();

                data.append('order_commission_setting', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(query));

                if (parseInt(_this17.isCopy, 10) === 1) data.append('copy_banner_store_id', _this17.copyStoreSelect);

                if (parseInt(_this17.isCopy, 10) === 1) {
                  _this17.copyBannerTypeList.forEach(function (i) {
                    data.append('copy_banner_type_list[]', i);
                  });
                }

                if (info.custom_sticker_max_length) data.append('custom_sticker_max_length', info.custom_sticker_max_length);

                if (sInfo.service_fee_description) data.append('service_fee_description', sInfo.service_fee_description);

                if (info.food_business_no) data.append('food_business_no', info.food_business_no);

                if (info.meat_origin_description) data.append('meat_origin_description', info.meat_origin_description);

                data.append('is_plastic_amount_adjustable', self.plasticAmountAdjustable);

                data.append('delivery_exception_product_setting', _this17.deliveryExceptionProductList);

                if (data) {
                  url = '/store';

                  _this17.getDataH('post', url, data, function () {
                    var _ref3 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee8(response) {
                      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                        while (1) {
                          switch (_context8.prev = _context8.next) {
                            case 0:
                              if (!(response.data.status === 200)) {
                                _context8.next = 14;
                                break;
                              }

                              _this17.loading = false;
                              _this17.$notify({
                                title: response.data.message,
                                text: response.data.description,
                                duration: 3000,
                                type: 'success',
                                width: 400
                              });
                              if (!response.data.has_latlng) {
                                _this17.$notify({
                                  title: '提醒',
                                  text: '經緯度未設定，請再檢查地址是否正確！',
                                  duration: 3000,
                                  type: 'warning',
                                  width: 400
                                });
                              }

                              if (!(shippingComponent && shippingComponent.feeTypeSelect !== null && response.data.new_store_id)) {
                                _context8.next = 12;
                                break;
                              }

                              _context8.prev = 5;
                              _context8.next = 8;
                              return shippingComponent.upShippingFee(response.data.new_store_id);

                            case 8:
                              _context8.next = 12;
                              break;

                            case 10:
                              _context8.prev = 10;
                              _context8.t0 = _context8['catch'](5);

                            case 12:
                              if (parseInt(_this17.isPosAccount, 10) === 1) {
                                _this17.updatePosAccount(response.data.new_store_id);
                              }
                              if (_this17.leave) {
                                _this17.$router.push({ path: '/upBrand/' + _this17.$route.params.brand_id + '?tab=2' });
                              } else {
                                _this17.$router.push({ path: '/storeTable/' + _this17.$route.params.brand_id });
                              }

                            case 14:
                            case 'end':
                              return _context8.stop();
                          }
                        }
                      }, _callee8, _this17, [[5, 10]]);
                    }));

                    return function (_x7) {
                      return _ref3.apply(this, arguments);
                    };
                  }(), function (error) {
                    _this17.$notify({
                      title: error.response.data.message,
                      text: error.response.data.description,
                      duration: 3000,
                      type: 'danger',
                      width: 400
                    });
                    _this17.loading = false;
                  });
                } else {
                  _this17.loading = false;
                }

              case 168:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this17, [[5, 10]]);
      }))();
    },
    updatedLogoImg: function updatedLogoImg() {
      var data = new FormData();

      if (this.imgLogoSelect) {
        data.append('image_name', this.imgLogoSelect);
        this.upImg(data, 1);
      } else if (__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#brand-img-load')[0].files[0]) {
        data.append('image_file', __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#brand-img-load')[0].files[0]);
        var imgPath = __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#brand-img-load')[0].files[0];
        var imgName = imgPath.name.replace(/\.(jpg|gif|png)$/, '');
        data.append('image_name', imgName);
        this.upImg(data, 1);
      }
      if (__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#brand-photo-load')[0].files[0]) {
        data.append('image_file', __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#brand-photo-load')[0].files[0]);
        var imgPath2 = __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#brand-photo-load')[0].files[0];
        var imgName2 = imgPath2.name.replace(/\.(jpg|gif|png)$/, '');
        data.append('image_name', imgName2);
        this.upImg(data, 4);
      }
      this.updatedStore();
    },
    upImg: function upImg(data, type) {
      var self = this;
      data.append('image_type', type);
      var url = '/store/' + this.$route.params.store_id + '/image';
      if (data) {
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            if (self.getRoleType === 99) self.updatedStore();else {
              self.$notify({
                title: response.data.message,
                text: response.data.description,
                duration: 3000,
                type: 'success',
                width: 400
              });
            }
          }
        });
      }
    },
    updatedBgImg: function updatedBgImg() {
      var self = this;
      var data = new FormData();

      if (self.imgBgSelect) {
        data.append('image_name', self.imgBgSelect);
        self.upImg(data, 3);
      } else if (__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#bg-img-load')[0].files[0]) {
        data.append('image_file', __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#bg-img-load')[0].files[0]);
        var bgPath = __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#bg-img-load')[0].files[0];
        var bgName = bgPath.name.replace(/\.(jpg|gif|png)$/, '');
        data.append('bg_image_name', bgName);
        self.upImg(data, 3);
      } else if (self.getRoleType === 99) self.updatedStore();
    },
    repeatPosAccount: function repeatPosAccount(account) {
      if (this.repeatPosAccountList.filter(function (x) {
        return x.account === account;
      }).length > 0) {
        return true;
      }
      return false;
    },
    updatedStore: function updatedStore() {
      var _this18 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var self, info, name, addressShort, tel, oneOrderMaxMoney, toStorePayMaxMoney, orderStartTimeM, orderEndTimeM, autoRejectOrderM, orderStartDay, orderToleranceDay, autoRejectOrderReserveM, plasticUnit, sInfo, method, data, branchCode, posBranchCode, nameShort, description, comment, ein, blName, tel2, email, searchDescription, ids, _tradeInfo, _loop2, l, customConfig, newETradeList, newTimeList, _takeTimeInfo, k, option3, _deliveryWays, _memoList, isSupport, isEnable, shippingComponent, shippingSetSuccess, _k2, option, j, option2, _customConfig, newECalendarList, _openingTimes, i, obj, openTime, specialTimes, offday, dWayPlastic, query, _obj, url, _self;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                self = _this18;
                info = _this18.getInput;
                name = info.name;
                addressShort = info.address_short;
                tel = info.tel;
                oneOrderMaxMoney = parseInt(info.one_order_max_money, 10);
                toStorePayMaxMoney = parseInt(info.to_store_pay_max_money, 10);
                orderStartTimeM = info.order_start_time_m;
                orderEndTimeM = info.order_end_time_m;
                autoRejectOrderM = info.auto_reject_order_m;
                orderStartDay = info.order_start_day;
                orderToleranceDay = info.order_tolerance_day;
                autoRejectOrderReserveM = info.auto_reject_order_reserve_m;
                plasticUnit = info.plastic_unit;
                sInfo = _this18.storeInfo;
                method = _this18.storeMethod;
                data = {};

                if (!(method === 1)) {
                  _context11.next = 47;
                  break;
                }

                data = {
                  name: name,
                  city_code: _this18.citySelect,
                  area_code: _this18.areaSelect,
                  address_short: addressShort,
                  tel: tel,
                  youtube_video_code: info.youtube_video_code,
                  introduction: info.introduction
                };
                branchCode = info.branch_code;
                posBranchCode = info.pos_branch_code;
                nameShort = info.name_short;
                description = info.description;
                comment = info.comment;
                ein = info.ein;
                blName = info.bl_name;
                tel2 = info.tel2;
                email = info.email;
                searchDescription = info.search_description;

                if (info.branch_code) data.branch_code = branchCode;
                if (info.pos_branch_code) data.pos_branch_code = posBranchCode;
                if (info.name_short) data.name_short = nameShort;
                if (info.description) data.description = description;
                if (info.comment) data.comment = comment;else data.comment = null;
                if (info.ein) data.ein = ein;else data.ein = null;
                data.bl_name = blName;
                if (info.tel2) data.tel2 = tel2;
                data.email = email;
                if (info.search_description) data.search_description = searchDescription;
                if (info.address_remark || info.address_remark === '') data.address_remark = info.address_remark;
                if (info.shipping_description) data.shipping_description = info.shipping_description;
                ids = _this18.storeInfo.binding_meal_tag_ids.map(function (item) {
                  return item.value;
                });

                if (ids) data.binding_meal_tag_ids = ids;

                if (info.food_business_no) data.food_business_no = info.food_business_no;else data.food_business_no = null;
                if (info.meat_origin_description) data.meat_origin_description = info.meat_origin_description;else data.meat_origin_description = '';_context11.next = 104;
                break;

              case 47:
                if (!(method === 2)) {
                  _context11.next = 51;
                  break;
                }

                data = {
                  store_type: parseInt(_this18.storeTypeSelect, 10),
                  status: _this18.statusSelect,
                  is_visible: _this18.isVisibleSelect,
                  barcode_type: _this18.barcodeSelect,
                  one_order_max_money: oneOrderMaxMoney,
                  to_store_pay_max_money: toStorePayMaxMoney,
                  has_invoice_paper: _this18.hasInvoicePaperSelect,
                  has_invoice_carrier: _this18.hasInvoiceCarrierSelect,
                  invoice_remark: _this18.invoiceRemark,
                  has_invoice_npoban: _this18.hasInvoiceNpobnaSelect,
                  is_invoice_exception: _this18.isInvoiceException,
                  api_type: _this18.apiTypeSelect,
                  show_menu_icon: _this18.showMenuIconSelect,
                  show_menu_product_icon: sInfo.show_menu_product_icon,
                  menu_layout_type: sInfo.menu_layout_type,
                  rounding_type: self.roundingTypeSelect,
                  coupon_form: self.couponFormSelect,
                  menu_expand_type: sInfo.menu_expand_type,
                  is_search: self.isSearchSelect,

                  menu_stop_sale_type: sInfo.menu_stop_sale_type,

                  menu_stop_sale_today_type: sInfo.menu_stop_sale_today_type,

                  show_menu_zero_money: sInfo.show_menu_zero_money,

                  distance_service_model: self.disModeSelect,
                  is_support_custom_sticker: self.isStickerSelect,

                  delivery_stage_limit_type: sInfo.delivery_stage_limit_type,

                  show_product_setting: self.showProdSettingSelect,
                  is_support_custom_remark: sInfo.is_support_custom_remark,

                  custom_sticker_max_length: sInfo.custom_sticker_max_length,

                  allow_copy_menu: sInfo.allow_copy_menu,
                  allow_update_menu: sInfo.allow_update_menu,
                  new_store_id: _this18.urlRedirection.new_store_id,

                  menu_ab_block_type: sInfo.menu_ab_block_type
                };
                _context11.next = 104;
                break;

              case 51:
                if (!(method === 3)) {
                  _context11.next = 55;
                  break;
                }

                data = {
                  order_status: _this18.orderStatusSelect,
                  order_start_time_m: orderStartTimeM,
                  order_end_time_m: orderEndTimeM,
                  auto_reject_order_m: autoRejectOrderM,
                  order_start_day: orderStartDay,
                  order_tolerance_day: orderToleranceDay,
                  auto_reject_order_reserve_m: autoRejectOrderReserveM,
                  is_preparing_allow_order: sInfo.is_preparing_allow_order,
                  is_close_allow_order: sInfo.is_close_allow_order,
                  order_status_reason: sInfo.order_status_reason
                };
                _context11.next = 104;
                break;

              case 55:
                if (!(method === 4)) {
                  _context11.next = 68;
                  break;
                }

                _tradeInfo = [];

                _loop2 = function _loop2(l) {
                  var option4 = {
                    trade_type_id: parseInt(_this18.tradeInfo[l].trade_type_id, 10),
                    is_enable: parseInt(_this18.tradeInfo[l].is_enable, 10),
                    is_support: parseInt(_this18.tradeInfo[l].is_support, 10),
                    remark: _this18.tradeInfo[l].remark
                  };

                  if (_this18.getRoleType === 99 && (_this18.tradeInfo[l].meta || _this18.tradeInfo[l].custom_config)) {
                    option4.ein = _this18.tradeInfo[l].ein || null;
                  }

                  if (_this18.tradeInfo[l].meta) {
                    option4.meta = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_this18.tradeInfo[l].meta));
                    delete option4.meta.key;

                    var lineTypes = ['online', 'offline'];
                    lineTypes.forEach(function (type) {
                      var useKey = type === 'online' ? 'use_key' : 'use_offline_key';
                      var deleteKey = type === 'online' ? 'delete_key' : 'delete_offline_key';
                      var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(option4.meta.group[type]);
                      var isEmpty = keys.every(function (key) {
                        return !option4.meta.group[type][key];
                      });

                      if (option4.meta[useKey] === 2) {
                        option4.meta[useKey] = 1;
                        option4.meta[deleteKey] = isEmpty ? 1 : 0;
                      } else {
                        option4.meta[useKey] = 0;
                        option4.meta[deleteKey] = 0;
                        delete option4.meta.group[type];
                      }
                    });

                    var isEmptyGroup = !__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(option4.meta.group).length;
                    if (isEmptyGroup) delete option4.meta;
                  }

                  if (_this18.tradeInfo[l].custom_config) {
                    option4.custom_config = {
                      use_key: 0,
                      delete_key: 0,
                      key: _this18.tradeInfo[l].custom_config.key
                    };

                    var vIndex = 0;
                    var sumIndex = 0;

                    for (var cKey in _this18.tradeInfo[l].custom_config.key) {
                      if (_this18.tradeInfo[l].custom_config.key[cKey]) vIndex++;else if (_this18.tradeInfo[l].custom_config.key[cKey] === '') {
                        vIndex++;
                        _this18.tradeInfo[l].custom_config.key[cKey] = null;
                      }
                      sumIndex++;
                    }

                    if (vIndex === sumIndex) option4.custom_config.use_key = 1;else if (_this18.tradeInfo[l].custom_config.delete_key) {
                      option4.custom_config.delete_key = 1;
                      option4.custom_config.use_key = 1;
                    } else if (_this18.tradeInfo[l].custom_config.d_use_key) delete option4.custom_config;else if (!_this18.tradeInfo[l].custom_config.use_key) delete option4.custom_config;
                  }
                  _tradeInfo.push(option4);
                };

                for (l = 0; l < _this18.tradeInfo.length; l++) {
                  _loop2(l);
                }
                data.trade_types = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_tradeInfo);
                customConfig = data.delivery_way_custom_config || [];

                customConfig.push({
                  type: 21,
                  config: {
                    is_cash_pay_after_meal: _this18.tableNumber.is_cash_pay_after_meal
                  }
                });
                data.delivery_way_custom_config = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(customConfig);
                newETradeList = [];

                _this18.exceptionTradeList.forEach(function (eTrade) {
                  var obj = eTrade;
                  if (!obj.start_money) obj.start_money = null;
                  if (!obj.end_money) obj.end_money = null;
                  newETradeList.push(obj);
                });
                data.delivery_exception_trade_setting = newETradeList;
                _context11.next = 104;
                break;

              case 68:
                if (!(method === 5)) {
                  _context11.next = 77;
                  break;
                }

                newTimeList = [];

                _this18.processTimeList.forEach(function (item) {
                  var process = {
                    month: item.month.value,
                    value_type: item.value_type,
                    start_value: item.start_value.value,
                    end_value: item.end_value.value,
                    delivery_type: item.delivery_type.value,
                    item_list: item.item_list
                  };
                  newTimeList.push(process);
                });
                if (newTimeList.length) data['process_time_setting'] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(newTimeList);else data['process_time_setting'] = [];
                _takeTimeInfo = [];

                for (k = 0; k < _this18.takeTimeInfo.length; k++) {
                  option3 = {
                    take_type: parseInt(_this18.takeTimeInfo[k].take_type, 10),
                    prepare_time_seg: parseInt(_this18.takeTimeInfo[k].prepare_time_seg, 10),
                    take_time_seg: parseInt(_this18.takeTimeInfo[k].take_time_seg, 10)
                  };

                  _takeTimeInfo.push(option3);
                }
                data.take_time_seg = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_takeTimeInfo);
                _context11.next = 104;
                break;

              case 77:
                if (!(method === 6)) {
                  _context11.next = 103;
                  break;
                }

                _deliveryWays = [];
                _memoList = [];
                isSupport = 1;
                isEnable = 1;
                shippingComponent = _this18.$refs.shippingInfo;

                if (!shippingComponent) {
                  _context11.next = 89;
                  break;
                }

                shippingSetSuccess = false;
                _context11.next = 87;
                return shippingComponent.checkShipping(info.max_delivery_distance_m).then(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee10() {
                  return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
                    while (1) {
                      switch (_context10.prev = _context10.next) {
                        case 0:
                          _context10.next = 2;
                          return shippingComponent.upShippingFee();

                        case 2:
                          shippingSetSuccess = true;

                        case 3:
                        case 'end':
                          return _context10.stop();
                      }
                    }
                  }, _callee10, _this18);
                }))).catch(function () {
                  shippingSetSuccess = false;
                });

              case 87:
                if (shippingSetSuccess) {
                  _context11.next = 89;
                  break;
                }

                return _context11.abrupt('return');

              case 89:

                for (_k2 = 0; _k2 < _this18.deliveryWaysInfo.length; _k2++) {
                  option = {
                    take_type: parseInt(_this18.deliveryWaysInfo[_k2].take_type, 10),
                    is_support: parseInt(_this18.deliveryWaysInfo[_k2].is_support, 10),
                    is_enable: parseInt(_this18.deliveryWaysInfo[_k2].is_enable, 10),
                    distance_m: parseInt(_this18.deliveryWaysInfo[_k2].distance_m, 10),
                    price: parseInt(_this18.deliveryWaysInfo[_k2].price, 10),
                    is_default: parseInt(_this18.deliveryWaysInfo[_k2].is_default, 10),
                    is_allow_guest_order: parseInt(_this18.deliveryWaysInfo[_k2].is_allow_guest_order, 10)
                  };

                  if (option.take_type === 3) {
                    isSupport = parseInt(_this18.deliveryWaysInfo[_k2].is_support, 10);
                    isEnable = parseInt(_this18.deliveryWaysInfo[_k2].is_enable, 10);
                  }
                  _deliveryWays.push(option);
                  _memoList.push({
                    take_type: parseInt(_this18.deliveryWaysInfo[_k2].take_type, 10),
                    memo: _this18.deliveryWaysInfo[_k2].memo || '',
                    pickup_memo: _this18.deliveryWaysInfo[_k2].pickup_memo || ''
                  });
                }
                for (j = 0; j < _this18.deliveryOther.length; j++) {
                  option2 = {
                    take_type: parseInt(_this18.deliveryOther[j].take_type, 10),
                    is_support: parseInt(_this18.deliveryOther[j].is_support, 10),
                    is_enable: parseInt(_this18.deliveryOther[j].is_enable, 10),
                    distance_m: parseInt(_this18.deliveryOther[j].distance_m, 10),
                    price: parseInt(_this18.deliveryOther[j].price, 10),
                    is_allow_guest_order: parseInt(_this18.deliveryOther[j].is_allow_guest_order, 10)
                  };

                  if (option2.take_type === 3) {
                    option2.is_support = isSupport;
                    option2.is_enable = isEnable;
                  }
                  if (_this18.deliveryOther[j].distance_m && (_this18.deliveryOther[j].price || j === 0)) {
                    _deliveryWays.push(option2);
                  }
                }
                data.delivery_ways = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_deliveryWays);
                data.delivery_way_memo = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_memoList);

                if (info.max_delivery_distance_m) data.max_delivery_distance_m = info.max_delivery_distance_m;else data.max_delivery_distance_m = null;
                _customConfig = data.delivery_way_custom_config || [];

                _customConfig.push({
                  type: 21,
                  config: {
                    default_login_type: _this18.tableNumber.default_login_type,
                    is_table_no_required: _this18.tableNumber.is_table_no_required,
                    is_table_no_editable: _this18.tableNumber.is_table_no_editable,
                    show_table_no: _this18.tableNumber.show_table_no,
                    sub_delivery_type: _this18.tableNumber.sub_delivery_type
                  }
                });
                data.delivery_way_custom_config = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_customConfig);
                newECalendarList = {};

                _this18.exceptionCalendar.forEach(function (eCalendar) {
                  var obj = {
                    date_type: eCalendar.date_type,
                    week_day: eCalendar.week_day,
                    month_day: eCalendar.month_day
                  };
                  newECalendarList[eCalendar.delivery_type] = obj;
                });
                data.delivery_exception_calendar_setting = newECalendarList;

                data.delivery_exception_product_setting = _this18.deliveryExceptionProductList;
                _context11.next = 104;
                break;

              case 103:
                if (method === 7) {
                  data = {
                    is_off_allow_order: sInfo.is_off_allow_order
                  };
                  _openingTimes = [];

                  for (i = 0; i < _this18.openingInfo.length; i++) {
                    obj = _this18.openingInfo[i];
                    openTime = {
                      week_day: obj.week_day,
                      start_time: obj.start + ':00',
                      end_time: obj.end + ':59'
                    };

                    _openingTimes.push(openTime);
                  }
                  data.opening_times = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_openingTimes);

                  if (_this18.selectSpecialDay.length > 0) {
                    specialTimes = [];

                    _this18.selectSpecialDay.forEach(function (item) {
                      var obj = {
                        calendar_list: item.calendar_list.map(function (date) {
                          return { usage_type: 1, usage_date: date.value };
                        }),
                        start_time: item.start_time + ':00',
                        end_time: item.end_time + ':59',
                        remark: item.remark
                      };
                      specialTimes.push(obj);
                    });
                    data.order_time_setting = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(specialTimes);
                  } else {
                    data.order_time_setting = '';
                  }
                  offday = {
                    date: [],
                    week_day: [],
                    month_day: []
                  };

                  _this18.offdaySetting.date.forEach(function (date) {
                    offday.date.push(date.value);
                  });
                  _this18.offdaySetting.weekDay.forEach(function (weekDay) {
                    offday.week_day.push(weekDay.value);
                  });
                  _this18.offdaySetting.monthDay.forEach(function (monthDay) {
                    offday.month_day.push(monthDay.value);
                  });
                  data['offday_setting'] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(offday);
                } else if (method === 8) {
                  data = {
                    plastic_unit: plasticUnit,
                    plastic_option: _this18.plasticSelect,
                    delivery_need_plastic: _this18.deliveryNeedSelect,
                    is_plastic_amount_adjustable: _this18.plasticAmountAdjustable
                  };
                  dWayPlastic = [];

                  _this18.deliveryWayPlastic.forEach(function (delivery) {
                    if (delivery.value) {
                      dWayPlastic.push(delivery.value);
                    }
                  });
                  data['delivery_way_plastic_selected'] = dWayPlastic;
                } else if (method === 10) {
                  data = {
                    printer_layout_setting: []
                  };
                  _this18.printerLayoutSetting.forEach(function (layoutSetting) {
                    var obj = {
                      layout_type: layoutSetting.layout_type,
                      trigger_type: layoutSetting.trigger_type,
                      is_enabled: layoutSetting.is_enabled
                    };
                    data.printer_layout_setting.push(obj);
                  });
                  data.printer_layout_setting = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(data.printer_layout_setting);
                } else if (method === 12) {
                  query = _this18.setCommissionQuery();

                  data['order_commission_setting'] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(query);
                } else if (method === 13) {
                  data = {
                    store_shipping_vendor: _this18.supportShippingVendor
                  };
                  if (sInfo.shipping_info.mete_store_id) data.pay_party = _this18.pay_party;
                } else if (method === 14) {
                  data['service_fee_description'] = sInfo.service_fee_description;
                } else if (method === 15) {
                  data = {
                    store_special_item_setting: []
                  };
                  _obj = {
                    type: 1,
                    sub_type: 1,
                    is_show: _this18.showTablewareStrawOption,
                    default_value: _this18.setTablewareStrawDefaultVal
                  };

                  data.store_special_item_setting.push(_obj);
                  data.store_special_item_setting = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(data.store_special_item_setting);
                }

              case 104:
                if (method === 2 && parseInt(_this18.isPosAccount, 10) === 1) {
                  _this18.updatePosAccount(_this18.$route.params.store_id);
                }
                if (data) {
                  url = '/store/' + _this18.$route.params.store_id;
                  _self = _this18;

                  _this18.getDataH('put', url, data, function (response) {
                    if (response.data.status === 200) {
                      _this18.$notify({
                        title: response.data.message,
                        text: '店家資訊更新成功！',
                        duration: 1000,
                        type: 'success',
                        width: 400
                      });
                      if (!response.data.has_latlng && method === 1 && _this18.getRoleType === 99) {
                        _this18.$notify({
                          title: '提醒',
                          text: '經緯度未設定，請再檢查地址是否正確！',
                          duration: 1000,
                          type: 'warning',
                          width: 400
                        });
                      }

                      if (method === 1) _this18.originEin = _this18.storeInfo.ein || '';
                      if (method === 4) _this18.snapshotTradeEin();
                      if (_this18.leave) {
                        _this18.$router.push({ path: '/upBrand/' + _this18.$route.params.brand_id + '?tab=2' });
                      } else if (_this18.reload) {
                        window.location.reload();
                      }
                    }
                  }, function (error) {
                    var status = error && error.response && error.response.data && error.response.data.status || '';
                    var title = '更新失敗';
                    var text = error.response.data.description || '發生不明錯誤！請聯絡客服或等24小時候再試。';
                    if (status === 1799) {
                      title = '發票設定錯誤';
                      text = '店家已設定開立發票，請至少開放任一發票類型 (紙本發票、電子載具、愛心捐贈發票)';
                    } else if ([1738, 1748].includes(status)) {
                      text = '店家時間更新失敗！日期／時間格式不符';
                    } else if (status === 17024) {
                      title = '填寫資料有缺少';
                      text = '請將必填欄位填寫完整';
                    }
                    _self.$notify({
                      title: title,
                      text: text,
                      duration: 3000,
                      type: 'danger',
                      width: '570px'
                    });
                  });
                }

              case 106:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this18);
      }))();
    },
    getStoreInfo: function getStoreInfo() {
      var self = this;
      var url = '/store/' + this.$route.params.store_id + '/info';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sInfo = response.data.info;
          self.storeInfo = {
            allow_copy_menu: sInfo.allow_copy_menu,
            allow_update_menu: sInfo.allow_update_menu,
            branch_code: sInfo.branch_code,
            pos_branch_code: sInfo.pos_branch_code,
            name: sInfo.name,
            name_short: sInfo.name_short,
            description: sInfo.description,
            comment: sInfo.comment,
            ein: sInfo.ein,
            bl_name: sInfo.bl_name,
            address_short: sInfo.address,
            tel: sInfo.tel,
            tel2: sInfo.tel2,
            email: sInfo.email,
            one_order_max_money: sInfo.one_order_max_money,
            to_store_pay_max_money: sInfo.to_store_pay_max_money,
            order_start_time_m: sInfo.order_start_time_m,
            order_end_time_m: sInfo.order_end_time_m,
            auto_reject_order_m: sInfo.auto_reject_order_m,
            image_name: sInfo.image,
            bg_image_name: sInfo.bg_image,
            city_code: sInfo.city_code,
            search_description: sInfo.search_description,
            order_start_day: sInfo.order_start_day,
            order_tolerance_day: sInfo.order_tolerance_day,
            auto_reject_order_reserve_m: sInfo.auto_reject_order_reserve_m,
            plastic_unit: sInfo.plastic_unit,
            is_off_allow_order: sInfo.is_off_allow_order,
            is_preparing_allow_order: sInfo.is_preparing_allow_order,
            is_close_allow_order: sInfo.is_close_allow_order,
            show_menu_product_icon: sInfo.show_menu_product_icon,
            menu_ab_block_type: sInfo.menu_ab_block_type,
            menu_layout_type: sInfo.menu_layout_type,
            address_remark: sInfo.address_remark,
            menu_expand_type: sInfo.menu_expand_type,
            max_delivery_distance_m: sInfo.max_delivery_distance_m,
            order_status_reason: sInfo.order_status_reason,
            brand_name: sInfo.brand_name,
            menu_stop_sale_type: sInfo.menu_stop_sale_type,
            menu_stop_sale_today_type: sInfo.menu_stop_sale_today_type,
            show_menu_zero_money: sInfo.show_menu_zero_money,
            photo_name: sInfo.photo,
            youtube_video_code: sInfo.youtube_video_code,
            introduction: sInfo.introduction,
            binding_class: false,
            binding_class_ids: [],
            binding_meal_tag_ids: [],
            delivery_stage_limit_type: sInfo.delivery_stage_limit_type,
            new_store_info: sInfo.new_store_info,
            service_fee_description: sInfo.service_fee_description,
            shipping_info: sInfo.shipping_info,
            food_business_no: sInfo.food_business_no,
            meat_origin_description: sInfo.meat_origin_description
          };
          self.originAddress = {
            city_code: sInfo.city_code,
            area_code: sInfo.area_code,
            address_short: sInfo.address
          };
          self.originEin = sInfo.ein || '';
          self.citySelect = sInfo.city_code;
          self.storeInfo.area_code = sInfo.area_code;
          self.storeTypeSelect = sInfo.store_type;
          self.statusSelect = sInfo.status;
          self.barcodeSelect = sInfo.barcode_type;
          self.orderStatusSelect = sInfo.order_status;
          self.isVisibleSelect = sInfo.is_visible;
          self.hasInvoicePaperSelect = sInfo.has_invoice_paper;
          self.hasInvoiceCarrierSelect = sInfo.has_invoice_carrier;
          self.hasInvoiceNpobnaSelect = sInfo.has_invoice_npoban;
          self.invoiceRemark = sInfo.invoice_remark;
          self.isInvoiceException = sInfo.is_invoice_exception;
          self.apiTypeSelect = sInfo.api_type;
          self.showMenuIconSelect = sInfo.show_menu_icon;
          self.plasticSelect = sInfo.plastic_option;
          self.plasticAmountAdjustable = sInfo.is_plastic_amount_adjustable;
          self.deliveryNeedSelect = sInfo.delivery_need_plastic;
          self.isSearchSelect = sInfo.is_search;
          self.roundingTypeSelect = sInfo.rounding_type;
          self.couponFormSelect = sInfo.coupon_form;
          self.disModeSelect = sInfo.distance_service_model;
          self.isStickerSelect = sInfo.is_support_custom_sticker;
          self.showProdSettingSelect = sInfo.show_product_setting;
          self.storeInfo.is_support_custom_remark = sInfo.is_support_custom_remark || 0;
          self.storeInfo.membership_provider_parent_id = sInfo.membership_provider_parent_id || -1;
          self.storeInfo.custom_sticker_max_length = sInfo.custom_sticker_max_length || 0;
          self.exceptionTradeList = [];
          self.deliveryExceptionProductList = sInfo.delivery_exception_product_info.map(function (item) {
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, item, {
              updated: true });
          });

          self.shippingVendorInfo = sInfo.shipping_info.store_shipping_vendor;
          self.pay_party = sInfo.shipping_info.pay_party;

          if (sInfo.order_commission_setting.item_list && sInfo.order_commission_setting.item_list.length) {
            sInfo.order_commission_setting.item_list.forEach(function (item) {
              item.start_time = __WEBPACK_IMPORTED_MODULE_8_moment___default()(item.start_time).format('YYYY-MM-DD HH:mm');
              item.end_time = __WEBPACK_IMPORTED_MODULE_8_moment___default()(item.end_time).format('YYYY-MM-DD HH:mm');
            });
          }
          self.orderCommissionSetting = sInfo.order_commission_setting || {};
          if (sInfo.meal_tag_info) {
            sInfo.meal_tag_info.forEach(function (setting) {
              var obj = { value: setting.tag_id, label: setting.name };
              var hasTag = self.mealTagList.find(function (mealTag) {
                return mealTag.value === setting.tag_id;
              });
              if (hasTag) {
                self.storeInfo.binding_meal_tag_ids.push(obj);
              }
            });
          }
          if (sInfo.delivery_exception_trade_info) {
            for (var key in sInfo.delivery_exception_trade_info) {
              var value = sInfo.delivery_exception_trade_info[key];
              value.forEach(function (item) {
                var obj = item;
                obj.trade_type = parseInt(key, 10);
                self.exceptionTradeList.push(obj);
              });
            }
          }
          self.exceptionCalendar = [];
          if (sInfo.delivery_exception_calendar_info) {
            for (var cKey in sInfo.delivery_exception_calendar_info) {
              var cValue = sInfo.delivery_exception_calendar_info[cKey];
              cValue.delivery_type = parseInt(cKey, 10);
              if (cValue.date_type.length || cValue.month_day.length || cValue.week_day.length) self.exceptionCalendar.push(cValue);
            }
          }
          self.processTimeList = [];
          if (sInfo.process_time_info) {
            sInfo.process_time_info.forEach(function (item) {
              var process = {
                month: self.offdaySetting.options.month.find(function (month) {
                  return item.month === month.value;
                }),
                value_type: item.value_type,
                delivery_type: self.deliveryTypeOption.find(function (delivery) {
                  return delivery.value === item.delivery_type;
                }),
                item_list: item.item_list
              };
              if (item.value_type === 1) {
                var sObj = { label: item.start_value, value: item.start_value };
                if (sObj.value !== 0) {
                  self.offdaySetting.options.monthDay.push(sObj);
                  process.start_value = sObj;
                } else {
                  process.start_value = self.offdaySetting.options.monthDay.find(function (monthDay) {
                    return monthDay.value === 0;
                  });
                }
                var eObj = { label: item.end_value, value: item.end_value };
                if (eObj.value !== 0) {
                  self.offdaySetting.options.monthDay.push(eObj);
                  process.end_value = eObj;
                } else {
                  process.end_value = self.offdaySetting.options.monthDay.find(function (monthDay) {
                    return monthDay.value === 0;
                  });
                }
              } else {
                process.start_value = self.offdaySetting.options.weekDay.find(function (monthDay) {
                  return monthDay.value === item.start_value;
                });
                process.end_value = self.offdaySetting.options.weekDay.find(function (monthDay) {
                  return monthDay.value === item.end_value;
                });
              }
              self.processTimeList.push(process);
            });
          }

          for (var i = 0; i < sInfo.trade_info.length; i++) {
            var option = {
              trade_type_id: sInfo.trade_info[i].trade_type_id,
              is_support: sInfo.trade_info[i].is_support,
              is_enable: sInfo.trade_info[i].is_enable,
              use_key: sInfo.trade_info[i].use_key,
              use_offline_key: sInfo.trade_info[i].use_offline_key,
              custom_config: sInfo.trade_info[i].custom_config,
              remark: sInfo.trade_info[i].remark || '',
              ein: sInfo.trade_info[i].ein || ''
            };

            self.tradeInfo.find(function (o) {
              if (o.trade_type_id === option.trade_type_id) {
                o.is_enable = option.is_enable;
                o.is_support = option.is_support;
                self.$set(o, 'remark', option.remark);
                self.$set(o, 'ein', option.ein);
                if (o.meta) {
                  o.meta.use_key = option.use_key;
                  self.$set(o.meta, 'delete_key', 0);
                  o.meta.use_offline_key = option.use_offline_key;
                  self.$set(o.meta, 'delete_offline_key', 0);
                }

                if (o.custom_config) {
                  o.custom_config.use_key = option.use_key;
                  self.$set(o.custom_config, 'delete_key', 0);
                  for (var co in o.custom_config.key) {
                    for (var oc in option.custom_config) {
                      if (co === oc) {
                        o.custom_config.key[co] = option.custom_config[oc];
                      }
                    }
                  }
                }
              }
            });
          }

          self.snapshotTradeEin();

          self.takeTimeInfo = [];
          sInfo.take_time_info.forEach(function (takeTime) {
            self.takeTimeInfo.push(takeTime);
          });

          if (sInfo.delivery_way_plastic_selected) {
            sInfo.delivery_way_plastic_selected.forEach(function (delivery) {
              var deliveryMatch = self.deliveryInfo.find(function (info) {
                return delivery === info.value;
              });
              if (deliveryMatch !== undefined) {
                self.deliveryWayPlastic.push(deliveryMatch);
              }
            });
          }

          sInfo.offday_info.date.forEach(function (date) {
            var ary = date.split('-');
            var formatday = [Number(ary[2]), Number(ary[1]), ary[0]].join('/');
            var oDate = { label: date, value: date };
            self.offdaySetting.date.push(oDate);
            self.offdaySetting.options.date.push(oDate);
            var obj = { 'date': formatday, 'dateTime': false, 'hour': '00', 'minute': '00' };
            self.selectDate.selectedDates.push(obj);
          });
          sInfo.offday_info.month_day.forEach(function (monthDay) {
            var mDay = { label: monthDay, value: monthDay };
            self.offdaySetting.monthDay.push(mDay);
            self.offdaySetting.options.monthDay.push(mDay);
          });
          sInfo.offday_info.week_day.forEach(function (weekDay) {
            self.offdaySetting.weekDay.push(self.offdaySetting.options.weekDay.find(function (wDay) {
              return weekDay === wDay.value;
            }));
          });

          self.deliveryWaysInfo = [];
          self.deliveryOther = [];
          var deliveryTimes = 0;
          var otherDelivery;
          sInfo.delivery_info.forEach(function (delivery) {
            if (delivery.delivery_type === 3) {
              deliveryTimes++;
              otherDelivery = sInfo.delivery_info.filter(function (e) {
                return e.delivery_type === 3;
              });
            }
            var dOption = {
              take_type: delivery.delivery_type,
              is_support: delivery.is_support,
              is_enable: delivery.is_enable,
              distance_m: delivery.order_min_distance_m,
              price: delivery.order_min_price,
              is_default: delivery.is_default,
              is_allow_guest_order: delivery.is_allow_guest_order,
              memo: '',
              pickup_memo: ''
            };
            if (sInfo.delivery_memo && sInfo.delivery_memo.length) {
              sInfo.delivery_memo.forEach(function (x) {
                if (x.delivery_type === delivery.delivery_type) {
                  dOption.memo = x.memo;
                  dOption.pickup_memo = x.pickup_memo || '';
                }
              });
            }
            if (delivery.delivery_type !== 3 || delivery.delivery_type === 3 && deliveryTimes === 1) {
              self.deliveryWaysInfo.push(dOption);
            }
          });
          if (otherDelivery) {
            otherDelivery.splice(0, 1);
            for (var k = 0; k < otherDelivery.length; k++) {
              var oOption = {
                take_type: otherDelivery[k].delivery_type,
                is_support: otherDelivery[k].is_support,
                is_enable: otherDelivery[k].is_enable,
                distance_m: otherDelivery[k].order_min_distance_m,
                price: otherDelivery[k].order_min_price,
                is_allow_guest_order: otherDelivery[k].is_allow_guest_order
              };
              self.deliveryOther.push(oOption);
            }
          }

          self.openingInfo = [];
          for (var o = 0; o < sInfo.opening_info.length; o++) {
            var startTime = sInfo.opening_info[o].start_time.split(':');
            var endTime = sInfo.opening_info[o].end_time.split(':');
            var wOption = {
              week_day: sInfo.opening_info[o].week_day,
              start: startTime[0] + ':' + startTime[1],
              end: endTime[0] + ':' + endTime[1]
            };
            self.openingInfo.push(wOption);
          }

          sInfo.order_time_setting.forEach(function (item) {
            var calendarList = item.calendar_list ? item.calendar_list.map(function (cal) {
              return {
                label: cal.usage_date,
                value: cal.usage_date
              };
            }) : [];
            var obj = {
              setting_id: item.setting_id,
              calendar_list: calendarList,
              start_time: item.start_time.substring(0, 5),
              end_time: item.end_time.substring(0, 5),
              remark: item.remark,
              showSpecialDayCalendar: false
            };
            self.selectSpecialDay.push(obj);
          });

          self.printerLayoutSetting = [];
          sInfo.printer_layout_info.forEach(function (layout) {
            var obj = layout;
            if (!obj.trigger_type) obj.trigger_type = 1;
            self.printerLayoutSetting.push(obj);
          });

          self.enterType = [];
          sInfo.order_web_domain.forEach(function (item) {
            self.enterType.push({
              name: self.intranceName(item.type),
              value: item.type,
              url: item.url
            });
          });

          var tableInfo = sInfo.delivery_way_custom_config ? sInfo.delivery_way_custom_config[21] ? sInfo.delivery_way_custom_config[21] : {} : {};
          if (tableInfo && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(tableInfo).length) {
            __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(tableInfo).forEach(function (key) {
              if (self.tableNumber && typeof self.tableNumber[key] !== 'undefined' && self.tableNumber[key] !== null) {
                self.tableNumber[key] = Number(tableInfo[key].store_value);
              }
            });
          }

          if (sInfo.store_special_item_setting && sInfo.store_special_item_setting.length) {
            var item = sInfo.store_special_item_setting[0];
            self.showTablewareStrawOption = item.is_show;
            self.setTablewareStrawDefaultVal = item.default_value;
          }

          var temp = {
            store_id: sInfo.new_store_info.id,
            name: sInfo.new_store_info.name
          };
          self.urlRedirection.new_store_info.push(temp);


          self.$emit('update:store-info', self.storeInfo);
        }
      });
    },
    intranceName: function intranceName(type) {
      switch (type) {
        case 1:
          return '你訂平台';
        case 2:
          return '專屬網址';
        case 3:
          return 'LINE';
      }
    },
    goToStoreTable: function goToStoreTable() {
      this.$router.go(-1);
    },
    getPrinterStoreList: function getPrinterStoreList() {
      var self = this;
      var url = '/printer/storePrinterList/' + this.$route.params.store_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.printerStoreList = response.data.list;
          self.getPrinterList();
        }
      });
    },
    getPrinterList: function getPrinterList() {
      var self = this;
      var data = {
        page: 1,
        size: 20
      };
      var url = '/printer/list?page=' + data.page + '&size=' + data.size;
      if (this.searchResult) url = url + '&identity=' + this.searchResult;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.printerList = response.data.list;
          if (self.printerList.length) self.isPrinterSelect = self.printerList[0].printer_id;
          self.printerInfo = {
            identity: '',
            type: 1
          };
        }
      });
    },
    checkPrinter: function checkPrinter() {
      var msg = '';
      if (!this.printerInfo.identity && this.printerSelect === 1) {
        msg = '請輸入辨識碼';
      }
      this.getToast2(msg);
    },
    getToast2: function getToast2(msg) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        if (this.printerSelect === 1) this.addPrinter();else this.crPrinterStore(this.isPrinterSelect);
      }
    },
    addPrinter: function addPrinter() {
      var self = this;
      var url = '/printer';
      var info = this.printerInfo;
      var data = {
        type: info.type,
        identity: info.identity
      };
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.crPrinterStore(response.data.printer_id);
        }
      });
    },
    crPrinterStore: function crPrinterStore(printerId) {
      var self = this;
      var url = '/printer/storePrinter';
      var data = {
        printer_id: printerId,
        store_id: this.$route.params.store_id
      };
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.getPrinterStoreList();
        }
      });
    },
    printerType: function printerType(type) {
      switch (type) {
        case 1:
          return 'W牌出單機(1)';
        case 2:
          return 'F牌出單機(2)';
        case 3:
          return 'F牌貼紙機(3)';
      }
    },
    selectOnChange: function selectOnChange(value) {
      this.change.binding_is_enabled = value;
    },
    inputOnChange: function inputOnChange(value) {
      this.change.binding_name = value;
    },
    trigger: function trigger(event) {
      var type = this.$route.name.indexOf('up') > -1 ? 'up' : 'cr';
      if (event === 'delBinding') {
        this.delBinding();
      } else if (event === 'editBinding') {
        this.editBinding();
      } else if (event === 'save') {
        this.leave = true;
        this.checkBeforeSend(type);
      } else if (event === 'saveAddress') {
        if (type === 'up') {
          this.originAddress = {
            city_code: this.storeInfo.city_code,
            area_code: this.storeInfo.area_code,
            address_short: this.storeInfo.address_short
          };
        }
        this.checkBeforeSend(type);
      } else if (event === 'saveEin') {
        this.einConfirmed = true;
        this.checkBeforeSend(this.einConfirmType);
      } else if (event === 'delExceptionProduct') {
        this.delExceptionProduct();
      }
    },
    delExceptionProduct: function delExceptionProduct() {
      var _this19 = this;

      var selectID = this.deliveryExceptionProductSelectItems.map(function (item) {
        return item.id;
      });
      var data = {
        delivery_exception_product_setting: this.deliveryExceptionProductList.filter(function (item) {
          return !selectID.includes(item.id);
        })
      };
      var url = '/store/' + this.$route.params.store_id;
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          _this19.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          window.location.reload();
        }
      });
    },
    delBinding: function delBinding() {
      var self = this;
      var url = '/printer/storePrinter/' + this.current.binding_id;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.getPrinterStoreList();
        }
      });
    },
    editBinding: function editBinding() {
      var self = this;
      var url = '/printer/storePrinter/' + this.current.binding_id;
      var data = {
        is_enabled: this.change.binding_is_enabled
      };
      if (this.current.binding_name) data['name'] = this.change.binding_name;
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.change = {
            is_enabled: 1,
            binding_name: ''
          };
          self.getPrinterStoreList();
        }
      });
    },
    getCurrent: function getCurrent(obj) {
      this.current = obj;
      this.editOption.body = '編輯出單機' + obj.printer_identity + '綁定';
      this.selectChange = obj.binding_is_enabled;
      this.change = {
        is_enabled: obj.binding_is_enabled,
        binding_name: obj.binding_name
      };
    },
    clickClose: function clickClose(type, notSupport, val, index) {
      var _this20 = this;

      if (type === 'deliveryWays') {
        if (parseInt(val, 10) === 1) {
          this.$refs.pickupWarnModal.click();
          this.$nextTick(function () {
            _this20.deliveryWaysInfo[index].is_enable = 1;
            _this20.deliveryWaysInfo[index].is_support = 1;
          });
        } else if (notSupport) {
          this.deliveryWaysInfo[index].is_enable = 0;
          this.deliveryWaysInfo[index].is_support = 0;
        }
      } else if (type === 'tradeType') {
        if (parseInt(val, 10) === 1) {
          this.$nextTick(function () {
            _this20.tradeInfo[index].is_enable = 1;
            _this20.tradeInfo[index].is_support = 1;
          });
        }
      }
    },
    addExceptionTrade: function addExceptionTrade() {
      var obj = {
        delivery_type: 0,
        start_money: '',
        end_money: '',
        trade_type: 1
      };
      this.exceptionTradeList.push(obj);
    },
    exportUrl: function exportUrl() {
      var _this21 = this;

      if (this.tableNumberUrl.text) {
        var arr = this.tableNumberUrl.text.split(/,|\n|，/);
        var csvFile = [['入口', '桌號', '網址']];
        arr.forEach(function (number) {
          var numberWithTrim = number.trim();
          if (numberWithTrim) {
            var row = [];
            _this21.enterType.forEach(function (x) {
              if (x.value === _this21.tableNumberUrl.type) {
                var xUrl = void 0;
                switch (window.location.hostname) {
                  case 'beta-nd-ecms-dev.nidin.shop':
                    xUrl = 'https://beta-nd-nl-package.nidin.shop';
                    break;
                  default:
                    xUrl = x.url;
                    break;
                }
                var url = xUrl + '/onSite/' + _this21.$route.params.store_id + '/store?tableNo=' + numberWithTrim;

                row.push(x.name, numberWithTrim, url);
                csvFile.push(row);
              }
            });
          }
        });
        if (csvFile.length > 1) {
          var data = csvFile.map(function (e) {
            return e.join(',');
          }).join('\n');
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__assets_js_down_load_file_js__["a" /* default */])(data, '桌號網址.csv', 'text/csv;charset=utf-8', new Uint8Array([0xEF, 0xBB, 0xBF]));
        }
      }
    },
    setTakeTime: function setTakeTime() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var timeSeg = 0;
      var val = item.take_time_seg;
      if (type === 'add') {
        timeSeg = Math.floor(val / 10) * 10 + 10;
      } else if (type === 'minus' && val > 10) {
        timeSeg = Math.ceil(val / 10) * 10 - 10;
      }
      item.take_time_seg = timeSeg;
    },
    clickOutsideCloseCalendar: function clickOutsideCloseCalendar(event) {
      var _this22 = this;

      var calendarContainers = document.querySelectorAll('.calendar-container');
      calendarContainers.forEach(function (container, index) {
        if (!container.contains(event.target)) {
          if (_this22.selectSpecialDay[index]) {
            _this22.selectSpecialDay[index].showSpecialDayCalendar = false;
          }
        }
      });

      var offDayCalendarContainers = document.querySelectorAll('.calendar-container');
      var clickedOutsideOffDayCalendar = true;
      offDayCalendarContainers.forEach(function (container) {
        if (container.contains(event.target)) {
          clickedOutsideOffDayCalendar = false;
        }
      });
      if (clickedOutsideOffDayCalendar) {
        this.showCalendar = false;
      }
    }
  },
  created: function created() {
    if (!this.hasCommissionPermission) {
      this.crStep = this.crStep.filter(function (item) {
        return item !== 12;
      });
    }
    this.init();
  },
  mounted: function mounted() {
    if (this.$route.query['store-method']) {
      this.changeTab(this.$route.query['store-method']);
    }

    var observer = new MutationObserver(function () {
      var calendarMultiselects = document.querySelectorAll('.calendar-multiselect');
      calendarMultiselects.forEach(function (multiselect) {
        var directWrappers = multiselect.querySelectorAll('.multiselect__content-wrapper');
        directWrappers.forEach(function (wrapper) {
          wrapper.remove();
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true });

    document.addEventListener('click', this.clickOutsideCloseCalendar);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('click', this.clickOutsideCloseCalendar);
  },

  components: {
    'img-upload': __WEBPACK_IMPORTED_MODULE_11__ImgUploadTemp_vue___default.a,
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_17_vue_datepicker_vue_datepicker_es6_vue___default.a,
    'shipping-form': __WEBPACK_IMPORTED_MODULE_13__ShippingForm_vue___default.a,
    'm-modal': __WEBPACK_IMPORTED_MODULE_10__elements_Modal_vue___default.a,
    VueTimepicker: __WEBPACK_IMPORTED_MODULE_16_vue2_timepicker___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_18_vue2_datepicker__["a" /* default */],
    'delivery-limit': __WEBPACK_IMPORTED_MODULE_14__DeliveryLimit_vue___default.a,
    'choose-store-modal': __WEBPACK_IMPORTED_MODULE_15__components_elements_chooseStoreModal_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapGetters */])(['getRoleType', 'getRestricted', 'getDenyList']), {
    offdayWeekDayOptions: function offdayWeekDayOptions() {
      return this.offdaySetting.options.weekDay.filter(function (item) {
        return item.value;
      });
    },
    offdayMonthDayOptions: function offdayMonthDayOptions() {
      return this.offdaySetting.options.monthDay.filter(function (item) {
        return item.value;
      });
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    checkDeliveryExceptionProductList: function checkDeliveryExceptionProductList() {
      var list = this.deliveryExceptionProductList.filter(function (item) {
        return !item.id;
      });
      if (this.deliveryExceptionProductList.length > 0 && list.length > 0) {
        return false;
      }
      return true;
    },
    calendarLimits: function calendarLimits() {
      return {
        min: __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('DD/MM/YYYY'),
        max: '31/12/2126'
      };
    },
    deliveryExceptionProductSelectItems: function deliveryExceptionProductSelectItems() {
      return this.deliveryExceptionProductList.filter(function (item) {
        return item.selected;
      });
    },
    addressChanged: function addressChanged() {
      var sameCityCode = this.originAddress.city_code === this.citySelect;
      var sameAreaCode = this.originAddress.area_code === this.areaSelect;
      var sameAddressShort = this.originAddress.address_short === this.storeInfo.address_short;
      var isAddressChanged = !sameCityCode || !sameAreaCode || !sameAddressShort;
      return this.storeMethod === 1 && isAddressChanged;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    },
    getInput: function getInput() {
      var sInfo = this.storeInfo;
      for (var key in sInfo) {
        if (!sInfo[key] && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(sInfo[key]) === 'object') sInfo[key] = '';
      }
      return {
        address_remark: this.checkInput(sInfo.address_remark),
        address_short: this.checkInput(sInfo.address_short.toString()),
        allow_copy_menu: this.checkInput(sInfo.allow_copy_menu),
        allow_update_menu: this.checkInput(sInfo.allow_update_menu),
        area_code: this.checkInput(sInfo.area_code.toString()),
        auto_reject_order_m: this.checkInput(sInfo.auto_reject_order_m.toString()),
        auto_reject_order_reserve_m: this.checkInput(sInfo.auto_reject_order_reserve_m.toString()),
        bg_image_name: this.checkInput(sInfo.bg_image_name.toString()),
        bl_name: this.checkInput(sInfo.bl_name.toString()),
        branch_code: this.checkInput(sInfo.branch_code.toString()),
        brand_name: this.checkInput(sInfo.brand_name.toString()),
        city_code: this.checkInput(sInfo.city_code.toString()),
        comment: this.checkInput(sInfo.comment.toString()),
        custom_sticker_max_length: this.checkInput(sInfo.custom_sticker_max_length),
        delivery_stage_limit_type: this.checkInput(sInfo.delivery_stage_limit_type),
        description: this.checkInput(sInfo.description.toString()),
        ein: this.checkInput(sInfo.ein.toString()),
        email: this.checkInput(sInfo.email.toString()),
        food_business_no: this.checkInput(sInfo.food_business_no.toString()),
        image_name: this.checkInput(sInfo.image_name.toString()),
        introduction: this.checkInput(sInfo.introduction.toString()),
        is_close_allow_order: this.checkInput(sInfo.is_close_allow_order),
        is_off_allow_order: this.checkInput(sInfo.is_off_allow_order),
        is_preparing_allow_order: this.checkInput(sInfo.is_preparing_allow_order),
        is_support_custom_remark: this.checkInput(sInfo.is_support_custom_remark),
        max_delivery_distance_m: this.checkInput(sInfo.max_delivery_distance_m.toString()),
        meat_origin_description: this.checkInput(sInfo.meat_origin_description.toString()),
        membership_provider_parent_id: this.checkInput(sInfo.membership_provider_parent_id),
        menu_ab_block_type: this.checkInput(sInfo.menu_ab_block_type),
        menu_expand_type: this.checkInput(sInfo.menu_expand_type),
        menu_layout_type: this.checkInput(sInfo.menu_layout_type),
        menu_stop_sale_today_type: this.checkInput(sInfo.menu_stop_sale_today_type),
        menu_stop_sale_type: this.checkInput(sInfo.menu_stop_sale_type),
        name: this.checkInput(sInfo.name.toString()),
        name_short: this.checkInput(sInfo.name_short.toString()),
        one_order_max_money: this.checkInput(sInfo.one_order_max_money.toString()),
        order_end_time_m: this.checkInput(sInfo.order_end_time_m.toString()),
        order_start_day: this.checkInput(sInfo.order_start_day.toString()),
        order_start_time_m: this.checkInput(sInfo.order_start_time_m.toString()),
        order_status_reason: this.checkInput(sInfo.order_status_reason),
        order_tolerance_day: this.checkInput(sInfo.order_tolerance_day.toString()),
        photo_name: this.checkInput(sInfo.photo_name.toString()),
        plastic_unit: this.checkInput(sInfo.plastic_unit.toString()),
        pos_branch_code: this.checkInput(sInfo.pos_branch_code.toString()),
        search_description: this.checkInput(sInfo.search_description.toString()),
        shipping_description: this.checkInput(sInfo.shipping_description),
        show_menu_product_icon: this.checkInput(sInfo.show_menu_product_icon),
        show_menu_zero_money: this.checkInput(sInfo.show_menu_zero_money),
        tel: this.checkInput(sInfo.tel.toString()),
        tel2: this.checkInput(sInfo.tel2.toString()),
        to_store_pay_max_money: this.checkInput(sInfo.to_store_pay_max_money.toString()),
        youtube_video_code: this.checkInput(sInfo.youtube_video_code)
      };
    },
    showTableNumber: function showTableNumber() {
      var table = this.deliveryWaysInfo.find(function (item) {
        return item.take_type === 21;
      });
      return table ? Number(table.is_enable) : 0;
    },
    isEnableOnSite: function isEnableOnSite() {
      return Number(this.deliveryWaysInfo.find(function (i) {
        return i.take_type === 21;
      }).is_enable);
    },
    supportDeliveryOption: function supportDeliveryOption() {
      var _this23 = this;

      var result = [];
      this.deliveryWaysInfo.forEach(function (delivery) {
        if (parseInt(delivery.is_support, 10) === 1) {
          var data = _this23.deliveryTypeOption.find(function (option) {
            return option.value === delivery.take_type;
          });
          if (data) result.push(data);
        }
      });
      return result;
    },
    hasCommissionPermission: function hasCommissionPermission() {
      return this.getRestricted.includes(900);
    },
    supportShippingVendor: function supportShippingVendor() {
      var _this24 = this;

      var result = [];
      this.supportShippingVendorList.forEach(function (vendor) {
        var data = _this24.shippingVendorInfo.find(function (option) {
          return option.vendor_code === vendor.vendor_code && vendor.is_visable === 1;
        });
        if (data) result.push(data);
      });
      return result;
    },
    shippingInfo: function shippingInfo() {
      if (!this.deliveryWaysInfo) return {};
      return this.deliveryWaysInfo[2] || {};
    },
    hasInvoiceSelected: function hasInvoiceSelected() {
      return this.hasInvoiceCarrierSelect === 1 || this.hasInvoicePaperSelect === 1 || this.getRoleType === 99 && this.hasInvoiceNpobnaSelect === 1;
    }
  }),
  watch: {
    hasInvoiceCarrierSelect: function hasInvoiceCarrierSelect(val) {
      this.hasInvoiceNpobnaSelect = val;
    },

    posList: {
      handler: function () {
        var _ref5 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee12(list) {
          var _this25 = this;

          var set;
          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  set = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();

                  this.realPostList = [];
                  this.repeatPosAccountList = list.filter(function (item) {
                    return set.has(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(item.account)) ? true : (set.add(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(item.account)), false);
                  });
                  this.realPostList = list.filter(function (item, index) {
                    return _this25.copyPostList[index] === undefined || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(item) !== __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_this25.copyPostList[index]);
                  });
                  _context12.next = 6;
                  return this.cheakAllPostAccount();

                case 6:
                case 'end':
                  return _context12.stop();
              }
            }
          }, _callee12, this);
        }));

        function handler(_x10) {
          return _ref5.apply(this, arguments);
        }

        return handler;
      }(),
      deep: true
    },
    citySelect: function citySelect() {
      var cityCode = parseInt(this.citySelect, 10);
      var cityElement = this.cityAreaList.find(function (e, i, o) {
        return e.city_code === cityCode;
      });
      var areaList = cityElement.area_list;
      this.areaOption = [];
      for (var i = 0; i < areaList.length; i++) {
        var option = { name: areaList[i].name, value: areaList[i].area_code };
        this.areaOption.push(option);
        if (i === 0 && (this.$route.name !== 'upStore' || this.areaTimes)) {
          this.areaSelect = option.value.toString();
        } else this.areaTimes = 1;
      }
    },
    'storeInfo.city_code': function storeInfoCity_code() {
      if (this.$route.name === 'upStore') this.areaSelect = this.storeInfo.area_code;
    },
    imgLogoSelect: function imgLogoSelect() {
      var self = this;
      if (self.imgLogoSelect) {
        var imgSrc = this.imgLogoOption.find(function (e) {
          return e.name === self.imgLogoSelect;
        }).value;
        this.storeInfo.image_name = imgSrc;
      }
    },
    imgBgSelect: function imgBgSelect() {
      var self = this;
      if (self.imgBgSelect) {
        var imgSrc = this.imgBgOption.find(function (e) {
          return e.name === self.imgBgSelect;
        }).value;
        this.storeInfo.bg_image_name = imgSrc;
      }
    },
    'tableNumber.sub_delivery_type': function tableNumberSub_delivery_type(val) {
      if (val === 1) {
        this.tableNumber.is_table_no_required = 0;
        this.tableNumber.show_table_no = 0;
      }
    },
    'copyInfo.productAlias': function copyInfoProductAlias(val) {
      this.copyInfo.productDescription = val;
      if (!val) {
        this.copyInfo.productAliasStoreId = null;
      }
    },
    'copyInfo.productAliasStoreId': function copyInfoProductAliasStoreId(val) {
      this.copyInfo.productDescriptionStoreId = val;
    },
    hasInvoiceSelected: function hasInvoiceSelected(val) {
      if (val) {
        this.isInvoiceException = 0;
      } else {
        this.isInvoiceException = 1;
      }
    },

    shippingInfo: {
      deep: true,
      handler: function handler(val) {
        if (typeof val.is_enable === 'string') {
          val.is_enable = Number(val.is_enable);
        }
        if (typeof val.is_support === 'string') {
          val.is_support = Number(val.is_support);
        }
      }
    },

    deliveryWaysInfo: {
      deep: true,
      handler: function handler(val) {
        if (typeof this.deliveryOther[0] !== 'undefined' && this.deliveryOther[0] !== null) {
          this.deliveryOther[0].price = val[2].price;
          if (!val[2].price) {
            val[2].price = 0;
            this.deliveryOther[0].price = 0;
          }
          this.deliveryOther[0].price = Number(this.deliveryOther[0].price);
          val[2].price = Number(val[2].price);
        }
      }
    },
    'urlRedirection.new_store_info': function urlRedirectionNew_store_info(val, oldVal) {
      if (val && Array.isArray(val) && val.length) {
        this.urlRedirection.new_store_id = val[0].store_id;
      } else {
        this.urlRedirection.new_store_id = 0;
      }
    },
    storeMethod: function storeMethod() {
      if (this.$route.name === 'upStore') {
        this.$router.replace({
          name: 'upStore',
          query: {
            'store-method': this.storeMethod
          },
          params: {
            brand_id: this.$route.params.brand_id,
            store_id: this.$route.params.store_id
          }
        });
      }
    }
  }
});

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_AdFormTemp_vue__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_AdFormTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_AdFormTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      info: {
        name: '光復店',
        des: '滿200外送'
      }
    };
  },

  components: {
    'ad-form': __WEBPACK_IMPORTED_MODULE_0__Temp_AdFormTemp_vue___default.a
  },
  computed: {
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    }
  }
});

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_BrandFormTemp_vue__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_BrandFormTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_BrandFormTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      info: {
        name: '迷客夏',
        type: '飲料'
      }
    };
  },

  components: {
    'brand-form': __WEBPACK_IMPORTED_MODULE_0__Temp_BrandFormTemp_vue___default.a
  },
  computed: {
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  }
});

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_BrandAdFormTemp_vue__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_BrandAdFormTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_BrandAdFormTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      info: {
        name: '光復店',
        des: '滿200外送'
      }
    };
  },

  components: {
    'ad-form': __WEBPACK_IMPORTED_MODULE_0__Temp_BrandAdFormTemp_vue___default.a
  },
  computed: {
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    }
  }
});

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_GroupFormTemp_vue__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_GroupFormTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_GroupFormTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      info: {}
    };
  },

  components: {
    'group-form': __WEBPACK_IMPORTED_MODULE_0__Temp_GroupFormTemp_vue___default.a
  },
  methods: {
    getGroupInfo: function getGroupInfo() {
      var self = this;
      var url = '/brand/' + this.$route.params.brand_id + '/storeGroup/' + this.$route.params.group_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.info = response.data.info;
        }
      });
    }
  },
  created: function created() {
    this.getGroupInfo();
  },

  computed: {
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  }
});

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_StoreFormTemp_vue__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_StoreFormTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_StoreFormTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      info: {
        name: '光復店',
        des: '滿200外送'
      },
      storeInfo: {
        brand_name: '',
        name_short: ''
      }
    };
  },

  components: {
    'store-form': __WEBPACK_IMPORTED_MODULE_0__Temp_StoreFormTemp_vue___default.a
  },
  computed: {
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    }
  },
  methods: {
    updateStoreInfo: function updateStoreInfo(storeInfo) {
      var brandName = storeInfo.brand_name,
          nameShort = storeInfo.name_short;

      this.storeInfo.brand_name = brandName;
      this.storeInfo.name_short = nameShort;
    }
  }
});

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__elements_Modal_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'store-group',
  components: {
    'm-modal': __WEBPACK_IMPORTED_MODULE_0__elements_Modal_vue___default.a
  },
  data: function data() {
    return {
      content: {
        bindingStoreList: []
      },
      show: {
        back: false
      },
      storeId: 0,
      info: {
        name: ''
      },
      addStoresSetting: {
        class: 'class-store',
        options: [],
        choose: []
      },
      storeClassList: [],
      curId: 0,
      reNew: 0,
      reSet: 0,
      storeBrief: [],
      delOption: {
        id: 'delModal',
        title: '刪除',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'del'
        }]
      }
    };
  },
  created: function created() {
    this.getStoreBrief();
  },
  mounted: function mounted() {},

  methods: {
    delModalOpen: function delModalOpen(bind) {
      this.delOption.title = '刪除' + this.info.name;
    },
    trigger: function trigger(event) {
      if (event === 'del') {
        this.del(this.info.name);
      }
    },
    del: function del(delName) {
      var self = this;
      var url = '/brand/' + this.$route.params.brand_id + '/storeClass/' + this.info.id;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '成功刪除' + delName,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.getStoreBrief();
        }
      });
    },
    getStoreBrief: function getStoreBrief(clear) {
      this.addStoresSetting.options = [];
      this.storeBrief = [];
      var self = this;
      var url = '/brand/' + this.$route.params.brand_id + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.addStoresSetting.options.push(obj);
            self.storeBrief.push(obj);
          }
          if (!clear) {
            self.getStoreClassList();
          }
          self.reNew++;
        }
      });
    },
    getStoreClassList: function getStoreClassList() {
      var self = this;
      var url = '/brand/' + this.$route.params.brand_id + '/storeClassList';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          self.storeClassList = sList;
          if (sList.length) self.clickOption(sList[0]);
        }
      });
    },
    clickOption: function clickOption(option) {
      var self = this;
      this.addStoresSetting.options = [];
      self.curId = option.id;
      if (self.curId) {
        self.$nextTick(function () {
          self.reSet++;
          self.addStoresSetting.options = self.storeBrief;
          self.getCurStoreClass();
        });
      }
    },
    getCurStoreClass: function getCurStoreClass() {
      this.addStoresSetting.choose = [];
      var self = this;
      var url = '/brand/' + this.$route.params.brand_id + '/storeClass/' + this.curId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var classInfo = response.data.class;
          self.info = classInfo;
          classInfo.store_list.forEach(function (s) {
            self.addStoresSetting.choose.push(s.id);
          });
        }
      });
    },
    checkStoreClass: function checkStoreClass(type) {
      var msg = '';
      if (!this.info.name) msg = '群組名稱未填';else if (!this.addStoresSetting.choose.length) msg = '店家未選擇';
      this.getToast(msg, type);
    },
    getToast: function getToast(msg, type) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else this.upStoreClass(type);
    },
    upStoreClass: function upStoreClass(type) {
      var self = this;
      var method = 'post';
      var url = '/brand/' + this.$route.params.brand_id + '/storeClass';
      if (type === 2) {
        method = 'put';
        url = url + '/' + this.curId;
      }
      var data = {
        name: this.info.name,
        store_id: []
      };
      self.addStoresSetting.choose.forEach(function (store) {
        data.store_id.push(store);
      });
      this.getDataH(method, url, data, function (response) {
        if (response.data.status === 200) {
          self.getStoreBrief();
        }
      });
    },
    clearCId: function clearCId() {
      this.curId = 0;
      this.addStoresSetting.choose = [];
      this.info = { name: '' };
      this.getStoreBrief(true);
    }
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  }
});

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_Chart_Temp_OrderLineCharts_vue__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_Chart_Temp_OrderLineCharts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_views_Chart_Temp_OrderLineCharts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);





var amountCompareChart, moneyCompareChart, moneyAverageChart, amountAverageChart, hourBriefChart, shopperBriefChart;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BrandDashboard',
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default.a,
    'order-line-charts': __WEBPACK_IMPORTED_MODULE_2__components_views_Chart_Temp_OrderLineCharts_vue___default.a
  },
  data: function data() {
    return {
      changeStore: false,
      storeStatusList: {},
      content: {
        bindingStoreList: []
      },
      oldUrl: '',
      storeBrief: [],
      brandBrief: [],

      hourBriefLabels: [],
      hourBrief: {
        total_order: [],
        total_money: [],
        total_amount: []
      },

      transactionLabels: [],
      transactions: {
        order_count_accum: [],
        order_count_day: [],
        order_count_day_normal: [],
        order_count_day_group: [],
        money_accum: [],
        money_accum_mean: [],
        money_day: [],
        money_day_normal: [],
        money_day_group: [],
        money_day_mean: [],
        item_count_accum: [],
        item_count_accum_mean: [],
        item_count_day: [],
        item_count_day_normal: [],
        item_count_day_group: [],
        item_count_day_mean: []
      },

      memberBriefLabels: [],
      memberBrief: {
        total_day: [],
        total_accum: []
      },

      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(1, 'days').format('YYYY-MM-DD')
        },
        storeTime: {
          time: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(-1, 'days').format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      startLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD')
      }],
      endLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(1, 'days').add(1, 'days').format('YYYY-MM-DD')
      }],
      storeLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD')
      }]
    };
  },

  methods: {
    checkLimit: function checkLimit(val) {
      if (this.content.bindingStoreList.length > 10) {
        this.content.bindingStoreList.shift();
      }
      if (this.content.bindingStoreList.length) {
        this.getStoresTransactions();
      } else {
        this.storeStatusList = {};
      }
    },
    clickSearch: function clickSearch() {
      if (this.content.bindingStoreList.length) this.getStoresTransactions();
    },
    getStoresTransactions: function getStoresTransactions() {
      var list = this.content.bindingStoreList;
      var day = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.storeTime.time, 'YYYY-MM-DD').format('YYYYMMDD');
      var ids = '';
      for (var i = 0; i < list.length; i++) {
        ids = ids + list[i].value + ',';
      }
      ids = ids.slice(0, -1);
      var self = this;
      var data = {
        start_time: day,
        end_time: day,
        ids: ids
      };
      var url = '';
      url = '/statistic/storeTransactions?start_date=' + data.start_time + '&end_date=' + data.end_time + '&store_ids=' + data.ids;
      if (this.oldUrl !== url) {
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            var resDay = __WEBPACK_IMPORTED_MODULE_3_moment___default()(day, 'YYYYMMDD').format('YYYY-MM-DD');
            if (response.data.statistics[resDay]) self.storeStatusList = response.data.statistics[resDay].store_info;
            self.oldUrl = url;
          }
        });
      }
    },
    getHourBrief: function getHourBrief(type, id) {
      this.hourBriefLabels = [];
      this.hourBrief = {
        total_order: [],
        total_money: [],
        total_amount: []
      };
      var self = this;
      var data = {
        result_type: 1
      };
      var url = '/statistic/storeHourBrief?result_type=' + data.result_type;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.brief;
          for (var i in bList) {
            if (typeof parseInt(i, 10) === 'number' && parseInt(i, 10)) {
              if (bList[i].hour < 10) self.hourBriefLabels.push('0' + bList[i].hour + ':00');else self.hourBriefLabels.push(bList[i].hour + ':00');
              self.hourBrief.total_order.push(bList[i].total_order);
              self.hourBrief.total_money.push(bList[i].total_money);
              self.hourBrief.total_amount.push(bList[i].total_amount);
            }
          }
          self.getShoppers(type, id);
          self.showHourBriefChart();
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      this.storeBrief = [];
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
          }
        }
      });
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          var brandIds = '';
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            self.brandBrief.push(obj);
            brandIds = brandIds + bList[i].brand_id + ',';
          }
          brandIds = brandIds.slice(0, -1);
          self.getTransactions('brand', brandIds);
          if (bList.length === 1) self.getStoreBrief(brandIds);
        }
      });
    },
    getTransactions: function getTransactions(type, id) {
      this.transactionLabels = [];
      this.transactions = {
        order_count_accum: [],
        order_count_day: [],
        order_count_day_normal: [],
        order_count_day_group: [],
        money_accum: [],
        money_accum_mean: [],
        money_day: [],
        money_day_normal: [],
        money_day_group: [],
        money_day_mean: [],
        item_count_accum: [],
        item_count_accum_mean: [],
        item_count_day: [],
        item_count_day_normal: [],
        item_count_day_group: [],
        item_count_day_mean: []
      };
      var self = this;
      var data = {
        start_time: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      };
      var url = '';
      if (type === 'brand') url = '/statistic/brandTransactions?start_date=' + data.start_time + '&end_date=' + data.end_time + '&brand_ids=' + id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var tList = response.data.statistics;
          var info;
          for (var i in tList) {
            if (type === 'brand') {
              info = 'brand_info';
            } else if (type === 'store') {
              info = 'store_info';
            }
            self.transactionLabels.push(__WEBPACK_IMPORTED_MODULE_3_moment___default()(i, 'YYYY-MM-DD').format('MM/DD'));
            self.transactions.order_count_accum.push(tList[i][info][id].order_count_accum);
            self.transactions.order_count_day.push(tList[i][info][id].order_count_day);
            self.transactions.order_count_day_normal.push(tList[i][info][id].order_count_day_normal);
            self.transactions.order_count_day_group.push(tList[i][info][id].order_count_day_group);
            self.transactions.money_accum.push(tList[i][info][id].money_accum);
            self.transactions.money_accum_mean.push(tList[i][info][id].money_accum_mean);
            self.transactions.money_day.push(tList[i][info][id].money_day);
            self.transactions.money_day_normal.push(tList[i][info][id].money_day_normal);
            self.transactions.money_day_group.push(tList[i][info][id].money_day_group);
            self.transactions.money_day_mean.push(tList[i][info][id].money_day_mean);
            self.transactions.item_count_accum.push(tList[i][info][id].item_count_accum);
            self.transactions.item_count_accum_mean.push(tList[i][info][id].item_count_accum_mean);
            self.transactions.item_count_day.push(tList[i][info][id].item_count_day);
            self.transactions.item_count_day_normal.push(tList[i][info][id].item_count_day_normal);
            self.transactions.item_count_day_group.push(tList[i][info][id].item_count_day_group);
          }
          self.getHourBrief(type, id);
          self.showTransactionsChart(type);
        }
      });
    },
    getShoppers: function getShoppers(type, id) {
      this.memberBriefLabels = [];
      this.memberBrief = {
        total_day: [],
        total_accum: []
      };
      var self = this;
      var data = {
        start_time: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      };
      var url = '';
      if (type === 'brand') url = '/statistic/brandShopperStatus?start_date=' + data.start_time + '&end_date=' + data.end_time + '&brand_ids=' + id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.brand_shopper_status_list;
          for (var i in bList) {
            self.memberBriefLabels.push(__WEBPACK_IMPORTED_MODULE_3_moment___default()(i, 'YYYY-MM-DD').format('MM/DD'));
            self.memberBrief.total_day.push(bList[i].total_day);
            self.memberBrief.total_accum.push(bList[i].total_accum);
          }
          self.showShopperChart(type);
        }
      });
    },
    showTransactionsChart: function showTransactionsChart(type) {
      var _this = this;

      this.$nextTick(function () {
        var datas = [{
          label: '當日訂單數量',
          fill: false,
          borderColor: '#00a65a',
          pointBackgroundColor: '#00a65a',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this.transactions.order_count_day,
          yAxisID: 'y-axis-2'
        }, {
          label: '當日成交份數',
          borderColor: '#f39c12',
          pointBackgroundColor: '#f39c12',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this.transactions.item_count_day,
          yAxisID: 'y-axis-1'
        }];
        var datas2 = [{
          label: '當日訂單數量',
          fill: false,
          borderColor: '#00a65a',
          pointBackgroundColor: '#00a65a',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this.transactions.order_count_day,
          yAxisID: 'y-axis-2'
        }, {
          label: '當日成交金額',
          borderColor: '#00c0ef',
          pointBackgroundColor: '#00c0ef',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this.transactions.money_day,
          yAxisID: 'y-axis-1'
        }];
        var datas3 = [{
          label: '當日平均金額',
          borderColor: '#dd4b39',
          pointBackgroundColor: '#dd4b39',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this.transactions.money_day_mean
        }];

        if (typeof amountCompareChart !== 'undefined') {
          amountCompareChart.destroy();
        }
        if (typeof moneyCompareChart !== 'undefined') {
          moneyCompareChart.destroy();
        }
        if (typeof moneyAverageChart !== 'undefined') {
          moneyAverageChart.destroy();
        }
        if (typeof amountAverageChart !== 'undefined') {
          amountAverageChart.destroy();
        }
        var ctx = document.getElementById('today-amount-compare').getContext('2d');
        var config = {
          type: 'line',
          data: {
            labels: _this.transactionLabels,
            datasets: datas
          },
          options: {
            responsive: true,
            maintainAspectRatio: !_this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            },
            scales: {
              yAxes: [{
                type: 'linear',
                display: true,
                position: 'left',
                id: 'y-axis-1'
              }, {
                type: 'linear',
                display: true,
                position: 'right',
                id: 'y-axis-2',
                gridLines: {
                  drawOnChartArea: false
                }
              }]
            }
          }
        };
        var ctx2 = document.getElementById('today-money-compare').getContext('2d');
        var config2 = {
          type: 'line',
          data: {
            labels: _this.transactionLabels,
            datasets: datas2
          },
          options: {
            responsive: true,
            maintainAspectRatio: !_this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            },
            scales: {
              yAxes: [{
                type: 'linear',
                display: true,
                position: 'left',
                id: 'y-axis-1'
              }, {
                type: 'linear',
                display: true,
                position: 'right',
                id: 'y-axis-2',
                gridLines: {
                  drawOnChartArea: false
                }
              }]
            }
          }
        };
        var ctx3 = document.getElementById('today-money-average').getContext('2d');
        var config3 = {
          type: 'line',
          data: {
            labels: _this.transactionLabels,
            datasets: datas3
          },
          options: {
            responsive: true,
            maintainAspectRatio: !_this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            }
          }
        };

        amountCompareChart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, config);
        moneyCompareChart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx2, config2);
        moneyAverageChart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx3, config3);
      });
    },
    showHourBriefChart: function showHourBriefChart() {
      var _this2 = this;

      this.$nextTick(function () {
        var datas = [{
          label: '每小時訂單數量',
          fill: false,
          borderColor: '#00a65a',
          pointBackgroundColor: '#00a65a',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this2.hourBrief.total_order,
          yAxisID: 'y-axis-2'
        }, {
          label: '每小時訂單金額',
          borderColor: '#f39c12',
          pointBackgroundColor: '#f39c12',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this2.hourBrief.total_money,
          yAxisID: 'y-axis-1'
        }];
        if (typeof hourBriefChart !== 'undefined') {
          hourBriefChart.destroy();
        }
        var ctx = document.getElementById('hour-brief').getContext('2d');
        var config = {
          type: 'line',
          data: {
            labels: _this2.hourBriefLabels,
            datasets: datas
          },
          options: {
            responsive: true,
            maintainAspectRatio: !_this2.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            },
            scales: {
              yAxes: [{
                type: 'linear',
                display: true,
                position: 'left',
                id: 'y-axis-1'
              }, {
                type: 'linear',
                display: true,
                position: 'right',
                id: 'y-axis-2',
                gridLines: {
                  drawOnChartArea: false
                }
              }]
            }
          }
        };
        hourBriefChart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, config);
      });
    },
    showShopperChart: function showShopperChart(type) {
      var _this3 = this;

      this.$nextTick(function () {
        var datas = [{
          label: '當日會員數量',
          fill: false,
          borderColor: '#00a65a',
          pointBackgroundColor: '#00a65a',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this3.memberBrief.total_day,
          yAxisID: 'y-axis-2'
        }, {
          label: '當日累積會員數量',
          borderColor: '#337ab7',
          pointBackgroundColor: '#337ab7',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this3.memberBrief.total_accum,
          yAxisID: 'y-axis-1'
        }];
        if (typeof shopperBriefChart !== 'undefined') {
          shopperBriefChart.destroy();
        }
        var ctx = document.getElementById('shopper-brief').getContext('2d');
        var config = {
          type: 'line',
          data: {
            labels: _this3.memberBriefLabels,
            datasets: datas
          },
          options: {
            responsive: true,
            maintainAspectRatio: !_this3.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            },
            scales: {
              yAxes: [{
                type: 'linear',
                display: true,
                position: 'left',
                id: 'y-axis-1'
              }, {
                type: 'linear',
                display: true,
                position: 'right',
                id: 'y-axis-2',
                gridLines: {
                  drawOnChartArea: false
                }
              }]
            }
          }
        };
        shopperBriefChart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, config);
      });
    }
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    }
  },
  created: function created() {
    var date = new Date();
    this.menuTime.start.time = __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).add(-30, 'days').format('YYYY-MM-DD');
    this.fixedH();
    this.getBrandBrief();
  },

  watch: {
    'content.bindingStoreList': function contentBindingStoreList() {
      this.checkLimit();
    },
    'menuTime.storeTime.time': function menuTimeStoreTimeTime() {
      this.checkLimit();
    }
  }
});

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      brandSelect: 0,
      storeSelect: 0,
      tradeTypeSelect: 707,
      storeBrief: [],
      brandBrief: [],
      info: {
        trade_no: ''
      },
      tradeInfo: {}
    };
  },

  methods: {
    checkInput: function checkInput() {
      var msg = '';
      if (!this.storeSelect) {
        msg = '請選擇店家';
      } else if (!this.info.trade_no) {
        msg = '請輸入交易序號';
      }
      this.getToast(msg);
    },
    getToast: function getToast(msg) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.searchAccount();
      }
    },
    searchAccount: function searchAccount() {
      var self = this;
      var url = '/accounting/tradeInfo?store_id=' + this.storeSelect + '&trade_no=' + this.info.trade_no + '&trade_type=' + this.tradeTypeSelect;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.tradeInfo = response.data.trade_info;
        }
      });
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&is_opening=1&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            self.brandBrief.push(obj);
            if (i === 0) self.brandSelect = obj.value;
          }
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      this.storeBrief = [];
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?status=2&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
            if (i === 0) self.storeSelect = obj.value;
          }
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getECtradeType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  }),
  created: function created() {
    this.getBrandBrief();
  },

  watch: {
    brandSelect: function brandSelect() {
      this.storeSelect = 0;
      if (this.brandSelect !== 0 && this.brandSelect !== '0') {
        this.getStoreBrief(this.brandSelect);
      }
    }
  }
});

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue___default.a
  },
  data: function data() {
    return {
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      total: 1,
      count: 10,
      searchSelect: 1,
      searchResult: '',
      accountList: [],
      statusSelect: 99,
      processedSelect: 99,

      menuTime: {
        tradeDate: {
          time: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(-1, 'days').format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      tradeLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD')
      }],
      confirmOption: {
        id: 'confirmModal',
        title: '修改評分狀態',
        body: '確認修改評分狀態？',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'upConfirmed'
        }]
      },
      selectOptions: {
        name: '帳務處理',
        options: [{ text: '已處理', value: 1 }, { text: '未處理', value: 0 }]
      },
      cAccount: {
        accountId: '',
        isConfirm: '',
        newIsConfirm: 0
      },
      isLoading: true
    };
  },
  mounted: function mounted() {},

  methods: {
    getCurrentId: function getCurrentId(accountId, isConfirm) {
      this.cAccount.accountId = accountId;
      this.cAccount.isConfirm = isConfirm;
    },
    upConfirmed: function upConfirmed() {
      var self = this;
      var url = '/accounting/error/' + this.cAccount.accountId;
      var data = {
        is_processed: this.cAccount.newIsConfirm
      };
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.getAccountList();
        }
      });
    },
    trigger: function trigger(event) {
      if (event === 'upConfirmed') {
        this.upConfirmed();
      }
    },
    selectOnChange: function selectOnChange(value) {
      this.cAccount.newIsConfirm = value;
    },
    printerType: function printerType(type) {
      switch (type) {
        case 1:
          return '熒埔';
        case 2:
          return '飛鵝';
      }
    },
    clickGroup: function clickGroup(type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1;
        this.tableIndex = this.groupAmount * this.pageGroup;
        this.clickPage(this.tableIndex);
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1;
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1;
        this.clickPage(this.tableIndex);
      }
    },
    clickEnd: function clickEnd(type) {
      if (type === 'pre') {
        this.clickPage(1);
        this.pageGroup = 1;
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount);else this.clickPage(1);
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount);
      }
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.getAccountList();
    },
    getAccountList: function getAccountList() {
      this.isLoading = true;
      var self = this;
      var data = {
        page: this.tableIndex,
        size: this.count
      };
      var url = '/accounting/error/list?page=' + data.page + '&size=' + data.size;
      if (this.statusSelect !== 99) url = url + '&status=' + this.statusSelect;
      if (this.processedSelect !== 99) url = url + '&is_processed=' + this.processedSelect;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.accountList = response.data.list;
          self.total = response.data.total;
          self.isLoading = false;
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  }),
  created: function created() {
    this.fixedH();
    this.getAccountList();
  },

  watch: {
    statusSelect: function statusSelect() {
      this.clickPage(1);
    },
    processedSelect: function processedSelect() {
      this.clickPage(1);
    }
  }
});

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      accountInfo: {},
      trackingList: [],
      orderInfo: {},
      orderGet: false
    };
  },
  mounted: function mounted() {},

  methods: {
    checkOrderInfo: function checkOrderInfo() {
      if (!this.orderGet) this.getOrderInfo();
    },
    printerType: function printerType(type) {
      switch (type) {
        case 1:
          return '熒埔';
        case 2:
          return '飛鵝';
      }
    },
    getAccountInfo: function getAccountInfo() {
      var self = this;
      var url = '/accounting/log/' + this.$route.params.accounting_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.accountInfo = response.data.log;
          self.trackingList = self.accountInfo.tracking_list;
        }
      });
    },
    getOrderInfo: function getOrderInfo() {
      var self = this;
      var url = '/accounting/orderTradeInfo/' + this.accountInfo.order_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.orderInfo = response.data.trade_info;
          self.orderGet = true;
          __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#order-info').html(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(self.orderInfo, null, 2));
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  }),
  created: function created() {
    this.fixedH();
    this.getAccountInfo();
  }
});

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue___default.a
  },
  data: function data() {
    return {
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      total: 1,
      count: 10,
      searchSelect: 3,
      searchResult: '',
      accountList: [],
      confirmedSelect: 99,
      vendorSelect: 999,

      menuTime: {
        tradeDate: {
          time: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(-1, 'days').format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      tradeLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD')
      }],
      confirmOption: {
        id: 'confirmModal',
        title: '修改評分狀態',
        body: '確認修改評分狀態？',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'upConfirmed'
        }]
      },
      selectOptions: {
        name: '對帳進度',
        options: [{ text: '已完成', value: 1 }, { text: '未完成', value: 0 }]
      },
      cAccount: {
        accountId: '',
        isConfirm: '',
        newIsConfirm: 0
      },
      isLoading: true
    };
  },
  mounted: function mounted() {},

  methods: {
    getCurrentId: function getCurrentId(accountId, isConfirm) {
      this.cAccount.accountId = accountId;
      this.cAccount.isConfirm = isConfirm;
    },
    upConfirmed: function upConfirmed() {
      var self = this;
      var url = '/accounting/log/' + this.cAccount.accountId;
      var data = {
        is_confirmed: this.cAccount.newIsConfirm
      };
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.getAccountList();
        }
      });
    },
    trigger: function trigger(event) {
      if (event === 'upConfirmed') {
        this.upConfirmed();
      }
    },
    selectOnChange: function selectOnChange(value) {
      this.cAccount.newIsConfirm = value;
    },
    printerType: function printerType(type) {
      switch (type) {
        case 1:
          return '熒埔';
        case 2:
          return '飛鵝';
      }
    },
    clickGroup: function clickGroup(type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1;
        this.tableIndex = this.groupAmount * this.pageGroup;
        this.clickPage(this.tableIndex);
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1;
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1;
        this.clickPage(this.tableIndex);
      }
    },
    clickEnd: function clickEnd(type) {
      if (type === 'pre') {
        this.clickPage(1);
        this.pageGroup = 1;
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount);else this.clickPage(1);
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount);
      }
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.getAccountList();
    },
    getAccountList: function getAccountList() {
      this.isLoading = true;
      var self = this;
      var data = {
        page: this.tableIndex,
        size: this.count
      };
      var url = '/accounting/log/list?page=' + data.page + '&size=' + data.size;
      if (this.searchSelect === 1 && this.searchResult) url = url + '&trade_no=' + this.searchResult;else if (this.searchSelect === 2 && this.menuTime.tradeDate) url = url + '&trade_date=' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.tradeDate.time, 'YYYY-MM-DD').format('YYYYMMDD');else if (this.searchSelect === 3 && this.searchResult) url = url + '&order_id=' + this.searchResult;
      if (this.confirmedSelect !== 99) url = url + '&is_confirmed=' + this.confirmedSelect;
      if (this.vendorSelect !== 999) url = url + '&vendor_type=' + this.vendorSelect;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.accountList = response.data.list;
          self.total = response.data.total;
          self.isLoading = false;
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType', 'getEtradeType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  }),
  created: function created() {
    this.fixedH();
    this.getAccountList();
  },

  watch: {
    confirmedSelect: function confirmedSelect() {
      this.clickPage(1);
    },
    vendorSelect: function vendorSelect() {
      this.clickPage(1);
    }
  }
});

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Temp_SystemChart_vue__ = __webpack_require__(2138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Temp_SystemChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Temp_SystemChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_BrandChart_vue__ = __webpack_require__(2135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_BrandChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Temp_BrandChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Temp_ChartShare_vue__ = __webpack_require__(2136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Temp_ChartShare_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Temp_ChartShare_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_js_shared_token_js__ = __webpack_require__(21);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'system-chart': __WEBPACK_IMPORTED_MODULE_1__Temp_SystemChart_vue___default.a,
    'brand-chart': __WEBPACK_IMPORTED_MODULE_2__Temp_BrandChart_vue___default.a,
    'chart-share': __WEBPACK_IMPORTED_MODULE_3__Temp_ChartShare_vue___default.a
  },
  data: function data() {
    return {
      roleType: 99
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    }
  }),
  created: function created() {
    var roleType = parseInt(this.getRoleType, 10);
    this.roleType = roleType;
  },

  methods: {
    goto: function goto() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__assets_js_shared_token_js__["c" /* setSharedToken */])(window.localStorage.getItem(this.$config.token));
      window.location.href = this.$config.bdms + 'report-center/downloads?mainTab=1&subTab=1';
    }
  }

});

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_datepicker_vue_datepicker_es6_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a,
    'm-modal': __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue___default.a,
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_5_vue_datepicker_vue_datepicker_es6_vue___default.a
  },
  data: function data() {
    return {
      searchStoreId: '',
      chartMethod: 1,
      menuState: 4,
      name: '迷客夏',
      total: 1,
      count: 10,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      menuList: [{ store_id: 1, store_name: '長春店', menu_name: '夏日菜單', menu_id: '1', status: 3, start_time: '2018/01/01', end_time: '2018/12/31' }, { store_id: 1, store_name: '中山店', menu_name: '夏日菜單', menu_id: '1', status: 3, start_time: '2018/01/01', end_time: '2018/12/31' }, { store_id: 1, store_name: '雙連店', menu_name: '菜單B', menu_id: '3', status: 3, start_time: '2018/01/01', end_time: '2018/12/31' }, { store_id: 1, store_name: '光復店', menu_name: '菜單A', menu_id: '2', status: 3, start_time: '2018/01/01', end_time: '2018/12/31' }, { store_id: 1, store_name: '民權西路店', menu_name: '菜單B', menu_id: '3', status: 3, start_time: '2018/01/01', end_time: '2018/12/31' }, { store_id: 1, store_name: '晶華店', menu_name: '菜單C', menu_id: '4', status: 3, start_time: '2018/01/01', end_time: '2018/12/31' }],
      info: {
        menuName: '夏日菜單',
        menu_id: 123323,
        start_time: '2017-03-31 12:22:32',
        end_time: '2017-03-31 12:22:32',
        update_time: '2017-03-31 12:22:32',
        create_time: '2017-03-31 12:22:32'
      },
      menu_schedule_list: [],
      scheduleList: [],
      curGroup: '',
      curSchedule: '',
      delMOption: {
        id: 'delModal',
        title: '刪除行銷',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delMarketing'
        }]
      },
      delAOption: {
        id: 'delModal',
        title: '刪除活動',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delActivity'
        }]
      },
      removeGNowOption: {
        id: 'removeGNowModal',
        title: '檔期群組下架',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'removeGNow'
        }]
      },
      saleGNowOption: {
        id: 'saleGNowModal',
        title: '檔期群組上架',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'saleGNow'
        }]
      },
      removeNowOption: {
        id: 'removeNowModal',
        title: '店家檔期下架',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'removeGNow'
        }]
      },
      saleNowOption: {
        id: 'delModal',
        title: '店家檔期上架',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'saleGNow'
        }]
      },

      brandBrief: [],
      storeBrief: [],
      brandSelect: { label: '== 所有品牌 ==', value: 0 },
      storeSelect: { label: '== 所有門市 ==', value: 0 },
      ownerTypeSelect: { label: '== 舉辦者類型 ==', value: 99 },
      ownerTypeList: [],
      statusSelect: { label: '== 行銷狀態 ==', value: 99 },
      timeMethodSelect: { label: '== 行銷時間狀態 ==', value: 99 },
      timeMethodList: [{ label: '== 行銷時間狀態 ==', value: 99 }, { label: '未開始', value: 'notyet' }, { label: '進行中', value: 'going' }, { label: '已結束', value: 'end' }],
      promotionList: [],
      curStoreId: '',
      ownerId: '',
      storeCouponList: [],
      curMarketingId: '',
      curActivityId: '',

      menuTime: {
        start: {
          time: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD')
        },
        end: {
          time: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      startLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(1, 'days').format('YYYY-MM-DD')
      }],
      endLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(1, 'days').add(1, 'days').format('YYYY-MM-DD')
      }],
      typeSelect: 1,

      sortMethod: '',
      sortToggle: false,
      preSortMethod: []
    };
  },

  methods: {
    reportPromotion: function reportPromotion() {
      if (this.chartMethod === 1) this.reportCouponChart();else if (this.chartMethod === 2) this.reportStoreCouponChart();
    },
    checkSort: function checkSort(method) {
      this.sortMethod = method;
      if (this.preSortMethod.length) {
        if (method === this.preSortMethod[0]) this.sortToggle = !this.sortToggle;else {
          this.tableIndex = 1;
          this.sortToggle = false;
        }
        this.preSortMethod.splice(0, 1);
      } else this.sortToggle = false;
      this.preSortMethod.push(method);
      this.clickPage(1);
    },
    setMarketing: function setMarketing(marketingId) {
      this.curMarketingId = marketingId;
    },
    setActivity: function setActivity(activityId) {
      this.curActivityId = activityId;
    },
    search: function search() {
      this.typeSelect = 2;
      this.clickPage(1);
    },
    getItemType: function getItemType(type) {
      switch (type) {
        case 10:
          return '消費贈送活動';
        case 11:
          return '會員註冊贈送活動';
        case 20:
          return '代碼兌換活動';
        case 99:
          return '後台發送';
      }
    },
    ownerTypeName: function ownerTypeName(type) {
      switch (type) {
        case 1:
          return '平台';
        case 2:
          return '品牌';
        case 3:
          return '門市';
      }
    },
    changeSelect: function changeSelect(input) {
      if (typeof input.value !== 'undefined') {
        this.clickPage(1);
      }
    },
    clickGroup: function clickGroup(type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1;
        this.tableIndex = this.groupAmount * this.pageGroup;
        this.clickPage(this.tableIndex);
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1;
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1;
        this.clickPage(this.tableIndex);
      }
    },
    clickEnd: function clickEnd(type) {
      if (type === 'pre') {
        this.clickPage(1);
        this.pageGroup = 1;
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount);else this.clickPage(1);
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount);
      }
    },
    getTime: function getTime(time) {
      if (time) {
        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(time, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm');
      }
    },
    trigger: function trigger(event) {
      if (event === 'delMarketing') {
        this.delMarketing();
      } else if (event === 'delActivity') {
        this.delActivity();
      }
    },
    delMarketing: function delMarketing() {
      var self = this;
      var url = '/promotion/' + this.curMarketingId;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '刪除行銷成功',
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.getCouponChart();
        }
      });
    },
    delActivity: function delActivity() {},
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    clickPage: function clickPage(index) {
      if (index) this.tableIndex = index;
      if (this.chartMethod === 1) this.getCouponChart();else if (this.chartMethod === 2) this.getStoreCouponChart();
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    },
    getPromotionInfo: function getPromotionInfo() {
      this.storeBrief = [];
      var self = this;
      var url = '/promotion/' + this.$route.params.promotion_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.info.attend_stores;
          if (self.roleType !== 10) self.storeBrief.push({ label: '== 所有門市 ==', value: 0 });
          for (var j = 0; j < bList.length; j++) {
            var sList = bList[j].store_list;
            for (var i = 0; i < sList.length; i++) {
              var sName = sList[i].store_name;
              if (bList.length > 1) sName = bList[j].brand_name + '-' + sName;
              var obj = { label: sName, value: sList[i].store_id };
              self.storeBrief.push(obj);
            }
          }
          self.getCouponChart();
          self.getStoreCouponChart();
        }
      });
    },
    getCouponChart: function getCouponChart(page) {
      var self = this;
      if (page) {
        this.tableIndex = page;
        if (page === 1) this.pageGroup = 1;
      }
      var url = '/statistic/promotionCouponGroupGiveType?';
      var data = {
        promotion_id: this.$route.params.promotion_id,
        page: this.tableIndex,
        size: this.count,
        start_date: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_date: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      };
      for (var key in data) {
        url = url + key + '=' + data[key] + '&';
      }
      url = url.slice(0, -1);

      if (this.sortMethod) {
        var newMethod = this.sortMethod;
        if (this.typeSelect === 2) newMethod = newMethod + '_seg';
        url = url + '&list_sort=' + newMethod + ' ';
        if (this.sortToggle) url = url + 'ASC';else url = url + 'DESC';
      }
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.promotionList = response.data.promotion_statistic;
          self.total = response.data.promotion_statistic_list_total;
        }
      });
    },
    getStoreCouponChart: function getStoreCouponChart(page) {
      var self = this;
      if (page) {
        this.tableIndex = page;
        if (page === 1) this.pageGroup = 1;
      }
      var url = '/statistic/promotionCouponStoreUse?';
      var roleType = this.roleType;
      var data = {
        promotion_id: this.$route.params.promotion_id,
        page: this.tableIndex,
        size: this.count,
        start_date: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_date: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      };

      if (this.storeSelect.value) {
        if ((roleType === 99 || roleType === 30) && this.storeSelect.value !== 0) data.store_id = this.storeSelect.value;else if (roleType === 10) data.store_id = this.storeSelect.value;
      }
      for (var key in data) {
        url = url + key + '=' + data[key] + '&';
      }
      url = url.slice(0, -1);

      if (this.sortMethod) {
        var newMethod = this.sortMethod;
        if (this.typeSelect === 2) newMethod = newMethod + '_seg';
        url = url + '&list_sort=' + newMethod + ' ';
        if (this.sortToggle) url = url + 'ASC';else url = url + 'DESC';
      }
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.storeCouponList = response.data.promotion_statistic;
          self.total = response.data.promotion_statistic_list_total;
        }
      });
    },
    reportCouponChart: function reportCouponChart() {
      var url = '/statistic/promotionCouponGroupGiveTypeSheets?';
      var data = {
        promotion_id: this.$route.params.promotion_id,
        start_date: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_date: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      };
      for (var key in data) {
        url = url + key + '=' + data[key] + '&';
      }
      url = url.slice(0, -1);

      if (this.sortMethod) {
        var newMethod = this.sortMethod;
        if (this.typeSelect === 2) newMethod = newMethod + '_seg';
        url = url + '&list_sort=' + newMethod + ' ';
        if (this.sortToggle) url = url + 'ASC';else url = url + 'DESC';
      }
      this.getFile('get', url, null, function (response) {
        var url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.ms-excel' }));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', '行銷各優惠券贈送統計表_' + __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY_MM_DD') + '.xlsx');
        document.body.appendChild(link);
        link.click();
      });
    },
    reportStoreCouponChart: function reportStoreCouponChart() {
      var url = '/statistic/promotionCouponStoreUseSheets?';
      var roleType = this.roleType;
      var data = {
        promotion_id: this.$route.params.promotion_id,
        start_date: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_date: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      };

      if (this.storeSelect.value) {
        if ((roleType === 99 || roleType === 30) && this.storeSelect.value !== 0) data.store_id = this.storeSelect.value;else if (roleType === 10) data.store_id = this.storeSelect.value;
      }
      for (var key in data) {
        url = url + key + '=' + data[key] + '&';
      }
      url = url.slice(0, -1);

      if (this.sortMethod) {
        var newMethod = this.sortMethod;
        if (this.typeSelect === 2) newMethod = newMethod + '_seg';
        url = url + '&list_sort=' + newMethod + ' ';
        if (this.sortToggle) url = url + 'ASC';else url = url + 'DESC';
      }
      this.getFile('get', url, null, function (response) {
        var url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.ms-excel' }));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', '行銷各優惠券贈送統計表_' + __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY_MM_DD') + '.xlsx');
        document.body.appendChild(link);
        link.click();
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getRoleType']), {
    statusList: function statusList() {
      if (this.chartMethod === 2) {
        return [{ label: '== 活動狀態 ==', value: 99 }, { label: '初始化', value: 0 }, { label: '編輯中', value: 1 }, { label: '待上架', value: 3 }, { label: '已上架', value: 4 }, { label: '已下架', value: 5 }];
      } else {
        return [{ label: '== 行銷狀態 ==', value: 99 }, { label: '未發佈', value: 0 }, { label: '已發佈', value: 4 }, { label: '已下架', value: 9 }];
      }
    },
    scheduleListNew: function scheduleListNew() {
      var menuList = {};
      var oldList = this.menu_schedule_list;
      for (var key in oldList) {
        menuList[oldList[key].menu_id] = {
          menu_id: oldList[key].menu_id,
          storeList: []
        };
      }
      for (var k in oldList) {
        menuList[oldList[k].menu_id].storeList.push({
          store_id: oldList[k].store_id,
          store_name: oldList[k].store_name,
          start_time: oldList[k].start_time,
          end_time: oldList[k].end_time,
          status: oldList[k].status,
          update_time: oldList[k].update_time,
          create_time: oldList[k].create_time,
          schedule_id: oldList[k].schedule_id,
          menu_id: oldList[key].menu_id
        });
      }
      return menuList;
    },
    getFile: function getFile() {
      return this.$parent.getFile;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    },
    searchPlaceholder: function searchPlaceholder() {
      var value = this.ownerTypeSelect.value;
      switch (value) {
        case 99:
        case 1:
          return '不用填入';
        case 2:
          return '請填入品牌id';
        case 3:
          return '請填入門市id';
      }
    }
  }),
  watch: {
    typeSelect: function typeSelect() {
      this.sortMethod = '';
      this.sortToggle = false;
      this.clickPage();
    },
    menuState: function menuState() {
      this.tableIndex = 1;
      this.pageGroup = 1;
    },
    chartMethod: function chartMethod() {
      this.sortMethod = '';
      this.sortToggle = false;
      this.sortMethod = '';
      this.tableIndex = 1;
      this.pageGroup = 1;
      this.clickPage(1);
      window.sessionStorage.setItem('Nidin_coupon_chart', this.chartMethod);
    },
    'menuTime.end.time': function menuTimeEndTime() {
      var lastDay = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
      if (this.menuTime.start.time > lastDay) this.menuTime.start.time = lastDay;
      this.startLimit = [{
        type: 'fromto',
        to: lastDay
      }];
    },
    'menuTime.start.time': function menuTimeStartTime() {
      var lastDay = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.start.time).add('90', 'days');
      if (lastDay < __WEBPACK_IMPORTED_MODULE_3_moment___default()()) this.menuTime.end.time = lastDay.format('YYYY-MM-DD');else this.menuTime.end.time = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD');
      this.endLimit = [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.start.time).subtract(1, 'days'),
        to: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.end.time).add(1, 'days')
      }];
    }
  },
  created: function created() {
    this.roleType = parseInt(this.getRoleType, 10);
    var sMethod = window.sessionStorage.getItem('Nidin_coupon_chart');
    if (sMethod) this.chartMethod = parseInt(sMethod, 10);

    this.getPromotionInfo();
  }
});

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Temp_SearchMapTemp_vue__ = __webpack_require__(2137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Temp_SearchMapTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Temp_SearchMapTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'search-map': __WEBPACK_IMPORTED_MODULE_1__Temp_SearchMapTemp_vue___default.a
  },
  data: function data() {
    return {
      roleType: 99
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    }
  }),
  created: function created() {
    var roleType = parseInt(this.getRoleType, 10);
    this.roleType = roleType;
  }
});

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);




var amountCompareChart, moneyCompareChart, moneyAverageChart, amountAverageChart, shopperBriefChart;

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default.a
  },
  data: function data() {
    return {
      brandIds: '',
      changeStore: false,
      storeStatusList: {},
      content: {
        bindingStoreList: []
      },
      oldUrl: '',
      storeIds: 'all',
      storeBrief: [],
      brandBrief: [],

      transactionLabels: [],
      transactions: {
        order_count_accum: [],
        order_count_day: [],
        order_count_day_normal: [],
        order_count_day_group: [],
        money_accum: [],
        money_accum_mean: [],
        money_day: [],
        money_day_normal: [],
        money_day_group: [],
        money_day_mean: [],
        item_count_accum: [],
        item_count_accum_mean: [],
        item_count_day: [],
        item_count_day_normal: [],
        item_count_day_group: [],
        item_count_day_mean: []
      },

      memberBriefLabels: [],
      memberBrief: {
        total_day: [],
        total_accum: []
      },

      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(1, 'days').format('YYYY-MM-DD')
        },
        storeTime: {
          time: __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(-1, 'days').format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      startLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD')
      }],
      endLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(1, 'days').add(1, 'days').format('YYYY-MM-DD')
      }],
      storeLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD')
      }]
    };
  },

  methods: {
    getChart: function getChart() {
      var storeSelect = parseInt(this.storeIds, 10);
      if (storeSelect) this.getTransactions('store', this.storeIds);else this.getTransactions('brand', this.brandIds);
    },
    checkLimit: function checkLimit(val) {
      if (this.content.bindingStoreList.length > 10) {
        this.content.bindingStoreList.shift();
      }
      if (this.content.bindingStoreList.length) {
        this.getStoresTransactions();
      } else {
        this.storeStatusList = {};
      }
    },
    clickSearch: function clickSearch() {
      if (this.content.bindingStoreList.length) this.getStoresTransactions();
    },
    getStoresTransactions: function getStoresTransactions() {
      var list = this.content.bindingStoreList;
      var day = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.menuTime.storeTime.time, 'YYYY-MM-DD').format('YYYYMMDD');
      var ids = '';
      for (var i = 0; i < list.length; i++) {
        ids = ids + list[i].value + ',';
      }
      ids = ids.slice(0, -1);
      var self = this;
      var data = {
        start_time: day,
        end_time: day,
        ids: ids
      };
      var url = '';
      url = '/statistic/storeTransactions?start_date=' + data.start_time + '&end_date=' + data.end_time + '&store_ids=' + data.ids;
      if (this.oldUrl !== url) {
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            var resDay = __WEBPACK_IMPORTED_MODULE_2_moment___default()(day, 'YYYYMMDD').format('YYYY-MM-DD');
            if (response.data.statistics[resDay]) self.storeStatusList = response.data.statistics[resDay].store_info;
            self.oldUrl = url;
          }
        });
      }
    },
    getStoreBrief: function getStoreBrief(brandId) {
      this.storeBrief = [];
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
          }
        }
      });
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          var brandIds = '';
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            self.brandBrief.push(obj);
            brandIds = brandIds + bList[i].brand_id + ',';
          }
          brandIds = brandIds.slice(0, -1);
          self.brandIds = brandIds;
          self.getTransactions('brand', brandIds);
          self.getStoreBrief(brandIds);
        }
      });
    },
    getTransactions: function getTransactions(type, id) {
      this.transactionLabels = [];
      this.transactions = {
        order_count_accum: [],
        order_count_day: [],
        order_count_day_normal: [],
        order_count_day_group: [],
        money_accum: [],
        money_accum_mean: [],
        money_day: [],
        money_day_normal: [],
        money_day_group: [],
        money_day_mean: [],
        item_count_accum: [],
        item_count_accum_mean: [],
        item_count_day: [],
        item_count_day_normal: [],
        item_count_day_group: [],
        item_count_day_mean: []
      };
      var self = this;
      var data = {
        start_time: __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      };
      var url = '';
      if (type === 'brand') url = '/statistic/brandTransactions?start_date=' + data.start_time + '&end_date=' + data.end_time + '&brand_ids=' + id;else if (type === 'store') url = '/statistic/storeTransactions?start_date=' + data.start_time + '&end_date=' + data.end_time + '&store_ids=' + id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var tList = response.data.statistics;
          var info;
          for (var i in tList) {
            if (type === 'brand') {
              info = 'brand_info';
            } else if (type === 'store') {
              info = 'store_info';
            }
            self.transactionLabels.push(__WEBPACK_IMPORTED_MODULE_2_moment___default()(i, 'YYYY-MM-DD').format('MM/DD'));
            self.transactions.order_count_accum.push(tList[i][info][id].order_count_accum);
            self.transactions.order_count_day.push(tList[i][info][id].order_count_day);
            self.transactions.order_count_day_normal.push(tList[i][info][id].order_count_day_normal);
            self.transactions.order_count_day_group.push(tList[i][info][id].order_count_day_group);
            self.transactions.money_accum.push(tList[i][info][id].money_accum);
            self.transactions.money_accum_mean.push(tList[i][info][id].money_accum_mean);
            self.transactions.money_day.push(tList[i][info][id].money_day);
            self.transactions.money_day_normal.push(tList[i][info][id].money_day_normal);
            self.transactions.money_day_group.push(tList[i][info][id].money_day_group);
            self.transactions.money_day_mean.push(tList[i][info][id].money_day_mean);
            self.transactions.item_count_accum.push(tList[i][info][id].item_count_accum);
            self.transactions.item_count_accum_mean.push(tList[i][info][id].item_count_accum_mean);
            self.transactions.item_count_day.push(tList[i][info][id].item_count_day);
            self.transactions.item_count_day_normal.push(tList[i][info][id].item_count_day_normal);
            self.transactions.item_count_day_group.push(tList[i][info][id].item_count_day_group);
          }
          self.getShoppers(type, id);
          self.showTransactionsChart(type);
        }
      });
    },
    getShoppers: function getShoppers(type, id) {
      this.memberBriefLabels = [];
      this.memberBrief = {
        total_day: [],
        total_accum: []
      };
      var self = this;
      var data = {
        start_time: __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      };
      var url = '';
      if (type === 'brand') url = '/statistic/brandShopperStatus?start_date=' + data.start_time + '&end_date=' + data.end_time + '&brand_ids=' + id;else if (type === 'store') url = '/statistic/storeShopperStatus?start_date=' + data.start_time + '&end_date=' + data.end_time + '&store_ids=' + id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList;
          if (type === 'brand') bList = response.data.brand_shopper_status_list;else if (type === 'store') bList = response.data.store_shopper_status_list;
          for (var i in bList) {
            self.memberBriefLabels.push(__WEBPACK_IMPORTED_MODULE_2_moment___default()(i, 'YYYY-MM-DD').format('MM/DD'));
            self.memberBrief.total_day.push(bList[i].total_day);
            self.memberBrief.total_accum.push(bList[i].total_accum);
          }
          self.showShopperChart(type);
        }
      });
    },
    showTransactionsChart: function showTransactionsChart(type) {
      var _this = this;

      this.$nextTick(function () {
        var datas = [{
          label: '當日訂單數量',
          fill: false,
          borderColor: '#00a65a',
          pointBackgroundColor: '#00a65a',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this.transactions.order_count_day,
          yAxisID: 'y-axis-2'
        }, {
          label: '當日成交杯數',
          borderColor: '#f39c12',
          pointBackgroundColor: '#f39c12',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this.transactions.item_count_day,
          yAxisID: 'y-axis-1'
        }];
        var datas2 = [{
          label: '當日訂單數量',
          fill: false,
          borderColor: '#00a65a',
          pointBackgroundColor: '#00a65a',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this.transactions.order_count_day,
          yAxisID: 'y-axis-2'
        }, {
          label: '當日成交金額',
          borderColor: '#00c0ef',
          pointBackgroundColor: '#00c0ef',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this.transactions.money_day,
          yAxisID: 'y-axis-1'
        }];
        var datas3 = [{
          label: '當日平均金額',
          borderColor: '#dd4b39',
          pointBackgroundColor: '#dd4b39',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this.transactions.money_day_mean
        }];

        if (typeof amountCompareChart !== 'undefined') {
          amountCompareChart.destroy();
        }
        if (typeof moneyCompareChart !== 'undefined') {
          moneyCompareChart.destroy();
        }
        if (typeof moneyAverageChart !== 'undefined') {
          moneyAverageChart.destroy();
        }
        if (typeof amountAverageChart !== 'undefined') {
          amountAverageChart.destroy();
        }
        var ctx = document.getElementById('today-amount-compare').getContext('2d');
        var config = {
          type: 'line',
          data: {
            labels: _this.transactionLabels,
            datasets: datas
          },
          options: {
            responsive: true,
            maintainAspectRatio: !_this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            },
            scales: {
              yAxes: [{
                type: 'linear',
                display: true,
                position: 'left',
                id: 'y-axis-1'
              }, {
                type: 'linear',
                display: true,
                position: 'right',
                id: 'y-axis-2',
                gridLines: {
                  drawOnChartArea: false
                }
              }]
            }
          }
        };
        var ctx2 = document.getElementById('today-money-compare').getContext('2d');
        var config2 = {
          type: 'line',
          data: {
            labels: _this.transactionLabels,
            datasets: datas2
          },
          options: {
            responsive: true,
            maintainAspectRatio: !_this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            },
            scales: {
              yAxes: [{
                type: 'linear',
                display: true,
                position: 'left',
                id: 'y-axis-1'
              }, {
                type: 'linear',
                display: true,
                position: 'right',
                id: 'y-axis-2',
                gridLines: {
                  drawOnChartArea: false
                }
              }]
            }
          }
        };
        var ctx3 = document.getElementById('today-money-average').getContext('2d');
        var config3 = {
          type: 'line',
          data: {
            labels: _this.transactionLabels,
            datasets: datas3
          },
          options: {
            responsive: true,
            maintainAspectRatio: !_this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            }
          }
        };

        amountCompareChart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, config);
        moneyCompareChart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx2, config2);
        moneyAverageChart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx3, config3);
      });
    },
    showShopperChart: function showShopperChart(type) {
      var _this2 = this;

      this.$nextTick(function () {
        var datas = [{
          label: '當日會員數量',
          fill: false,
          borderColor: '#00a65a',
          pointBackgroundColor: '#00a65a',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this2.memberBrief.total_day,
          yAxisID: 'y-axis-2'
        }, {
          label: '當日累積會員數量',
          borderColor: '#337ab7',
          pointBackgroundColor: '#337ab7',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this2.memberBrief.total_accum,
          yAxisID: 'y-axis-1'
        }];
        if (typeof shopperBriefChart !== 'undefined') {
          shopperBriefChart.destroy();
        }
        var ctx = document.getElementById('shopper-brief').getContext('2d');
        var config = {
          type: 'line',
          data: {
            labels: _this2.memberBriefLabels,
            datasets: datas
          },
          options: {
            responsive: true,
            maintainAspectRatio: !_this2.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            },
            scales: {
              yAxes: [{
                type: 'linear',
                display: true,
                position: 'left',
                id: 'y-axis-1'
              }, {
                type: 'linear',
                display: true,
                position: 'right',
                id: 'y-axis-2',
                gridLines: {
                  drawOnChartArea: false
                }
              }]
            }
          }
        };
        shopperBriefChart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, config);
      });
    }
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    }
  },
  created: function created() {
    var date = new Date();
    this.menuTime.start.time = __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).add(-30, 'days').format('YYYY-MM-DD');
    this.fixedH();
    this.getBrandBrief();
  },

  watch: {
    'content.bindingStoreList': function contentBindingStoreList() {
      this.checkLimit();
    },
    'menuTime.end.time': function menuTimeEndTime() {
      var lastDay = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
      if (this.menuTime.start.time > lastDay) this.menuTime.start.time = lastDay;
      this.startLimit = [{
        type: 'fromto',
        to: lastDay
      }];
    },
    'menuTime.start.time': function menuTimeStartTime() {
      var lastDay = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.menuTime.start.time).add('31', 'days');
      if (lastDay < __WEBPACK_IMPORTED_MODULE_2_moment___default()()) this.menuTime.end.time = lastDay.format('YYYY-MM-DD');else this.menuTime.end.time = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD');
      this.endLimit = [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.menuTime.start.time).subtract(1, 'days'),
        to: __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.menuTime.end.time).add(1, 'days')
      }];
    },
    storeIds: function storeIds() {
      this.getChart();
    }
  }
});

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      roleType: 0,
      brandBrief: [],
      storeBrief: [],
      brandSelect: {
        value: 0,
        label: ''
      },
      storeSelect: 0,
      yearSelect: 2018,
      currentYear: 2018,
      statementList: [],
      expSecs: 0,
      timer: 0,
      isLoading: true
    };
  },
  mounted: function mounted() {},

  methods: {
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&is_opening=1&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            self.brandBrief.push(obj);
            if (i === 0) self.brandSelect = obj;
          }
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      this.storeBrief = [];
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
            if (i === 0) {
              self.storeSelect = obj.value;
            }
          }
        }
      });
    },
    getBrandStatement: function getBrandStatement() {
      this.isLoading = true;
      var self = this;
      var url = '/statistic/brandMonthlyStatement?brand_id=' + this.brandSelect.value + '&year=' + this.yearSelect;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.statementList = response.data.download_info.links;
          self.expSecs = response.data.download_info.meta.acl_limit;
          if (self.timer) clearInterval(self.timer);
          self.afterGet();
          self.isLoading = false;
        }
      });
    },
    afterGet: function afterGet() {
      var self = this;
      var num = this.expSecs;
      this.timer = window.setInterval(function () {
        num = num - 1;
        self.expSecs = num;
      }, 1000);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    },
    yearList: function yearList() {
      var currentYear = parseInt(__WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY'), 10);
      this.currentYear = this.yearSelect = currentYear;
      if (currentYear > 2017) {
        var list = [];
        for (var i = currentYear; i >= 2017; i--) {
          var o = {
            label: i.toString(),
            value: i
          };
          if (i === currentYear) this.yearSelect = i;
          list.push(o);
        }
        return list;
      } else {
        return [{
          label: '2017',
          value: 2017
        }];
      }
    }
  }),
  created: function created() {
    this.roleType = parseInt(this.getRoleType, 10);
    this.fixedH();
    this.getBrandBrief();
  },

  watch: {
    'brandSelect.value': function brandSelectValue() {
      if (this.brandSelect.value) this.getBrandStatement();
    },
    yearSelect: function yearSelect() {
      if (this.yearSelect && this.brandSelect.value) this.getBrandStatement();
    },
    expSecs: function expSecs() {
      if (this.expSecs === 1 && this.brandSelect.value) this.getBrandStatement();
    }
  }
});

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'OrderLineCharts',
  data: function data() {
    return {
      start_date: __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(15, 'days').format('YYYY-MM-DD'),
      end_date: __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(1, 'days').format('YYYY-MM-DD'),
      roleType: 0,
      chartData: {
        labels: [],
        amount: [],
        money: []
      },
      amountChart: null,
      moneyChart: null };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  }),
  created: function created() {
    this.roleType = parseInt(this.getRoleType, 10);
    this.getOrderSummary();
  },

  methods: {
    getOrderSummary: function getOrderSummary() {
      var _this = this;

      var query = {
        list_type: 'daily',
        start_date: this.start_date.replace(/-/g, ''),
        end_date: this.end_date.replace(/-/g, '')
      };
      var searchParams = new URLSearchParams(query);
      var url = '/statistic/orderSummary?' + searchParams.toString();
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this.chartData.labels = [];
          _this.chartData.amount = [];
          _this.chartData.money = [];

          var list = response.data.list;
          for (var i in list) {
            _this.chartData.labels.push(__WEBPACK_IMPORTED_MODULE_1_moment___default()(list[i].date).format('MM/DD'));
            _this.chartData.amount.push(list[i].order_amount_accepted);
            _this.chartData.money.push(list[i].order_money_accepted);
          }
          _this.showOrderChart();
        }
      });
    },
    showOrderChart: function showOrderChart() {
      var _this2 = this;

      this.$nextTick(function () {
        var type = ['amount', 'money'];
        type.forEach(function (item) {
          if (_this2[item + 'Chart'] !== null) {
            _this2[item + 'Chart'].destroy();
          }

          var ctx = document.getElementById(item + '-chart').getContext('2d');
          var config = {
            type: 'line',
            data: {
              labels: _this2.chartData.labels,
              datasets: [{
                label: item === 'amount' ? '訂單數量' : '訂單金額',
                data: _this2.chartData[item],
                fill: false,
                borderColor: '#dd4b39',
                pointBackgroundColor: '#dd4b39',
                tension: 0.3
              }]
            },
            options: {
              responsive: true,
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  display: true,
                  ticks: {
                    min: 0
                  }
                }]
              }
            }
          };
          _this2[item + 'Chart'] = new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a(ctx, config);
        });
      });
    }
  }
});

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_datepicker_vue_datepicker_es6_vue__);






var map, markerCluster;
var markers = [];

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_3_vue_datepicker_vue_datepicker_es6_vue___default.a
  },
  data: function data() {
    return {
      roleType: 0,
      brandBrief: [],
      storeBrief: [],
      brandSelect: 0,
      storeSelect: 0,
      positionList: [],

      mapName: 'map',

      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: __WEBPACK_IMPORTED_MODULE_1_moment___default()().add(1, 'days').format('YYYY-MM-DD')
        },
        week: {
          time: __WEBPACK_IMPORTED_MODULE_1_moment___default()().add(-1, 'weeks').format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      startLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD')
      }],
      endLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_1_moment___default()().add(1, 'days').add(1, 'days').format('YYYY-MM-DD')
      }],
      weekLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_1_moment___default()().add(-1, 'weeks').day(7).format('YYYY-MM-DD')
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    }
  }),
  created: function created() {
    var date = new Date();
    var y = date.getFullYear();
    var m = date.getMonth();
    var firstDay = new Date(y, m, 1);
    this.menuTime.start.time = __WEBPACK_IMPORTED_MODULE_1_moment___default()(firstDay).add(-1, 'month').format('YYYY-MM-DD');
    this.fixedH();
    var roleType = parseInt(this.getRoleType, 10);
    this.roleType = roleType;
    if (roleType === 99) {
      this.getBrandBrief();
    } else if (roleType === 30) this.getBrandBrief();else if (roleType === 10) this.getBrandBrief();
  },

  methods: {
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          var brandIds = '';
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            self.brandBrief.push(obj);
            brandIds = brandIds + bList[i].brand_id + ',';
          }
          brandIds = brandIds.slice(0, -1);
          if (self.roleType === 30) self.brandSelect = brandIds;
          if (self.roleType !== 99) self.getStoreBrief(brandIds);else self.getSearchPosition();
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      this.storeBrief = [];
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          var storeIds = '';
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
            storeIds = storeIds + sList[i].store_id + ',';
          }
          storeIds = storeIds.slice(0, -1);
          if (self.roleType === 10) self.storeSelect = storeIds;
          self.getSearchPosition();
        }
      });
    },
    getSearchPosition: function getSearchPosition() {
      this.positionList = [];
      var self = this;
      var url;
      var brandSelect = parseInt(this.brandSelect, 10);
      var storeSelect = parseInt(this.storeSelect, 10);
      if (this.roleType === 99) {
        if (brandSelect === 0) url = '/shopper/searchPosition';else if (storeSelect === 0) url = '/brand/' + this.brandSelect + '/shopperSearchPosition';else url = '/store/' + this.storeSelect + '/shopperSearchPosition';
      } else if (this.roleType === 30) {
        if (storeSelect === 0) url = '/brand/' + this.brandSelect + '/shopperSearchPosition';else url = '/store/' + this.storeSelect + '/shopperSearchPosition';
      } else url = '/store/' + this.storeSelect + '/shopperSearchPosition';
      var data = {
        start_time: __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      };
      url = url + '?start_time=' + data.start_time + '&end_time=' + data.end_time;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var positionList = response.data.position_list;
          for (var i = 0; i < positionList.length; i++) {
            var pos = positionList[i].split(',');
            var o = {
              lat: Number(pos[0]),
              lng: Number(pos[1])
            };
            self.positionList.push(o);
          }
          self.setMap();
        }
      });
    },
    initMap: function initMap() {
      map = new window.google.maps.Map(document.getElementById(this.mapName), {
        zoom: 9,
        center: { lat: 23, lng: 121 }
      });
    },
    clearMarkers: function clearMarkers() {
      if (markerCluster) markerCluster.clearMarkers(markers);
      markers = [];
    },
    addMarker: function addMarker(position) {
      markerCluster = new window.MarkerClusterer(map, markers, { imagePath: 'https://panel.nidin.shop/static/img/m' });
    },
    setMap: function setMap() {
      this.clearMarkers();
      var averageLat = 0;
      var averageLng = 0;
      var totalLat = 0;
      var totalLng = 0;
      for (var i = 0; i < this.positionList.length; i++) {
        var beach = this.positionList[i];
        totalLat = totalLat + beach.lat;
        totalLng = totalLng + beach.lng;
      }
      markers = this.positionList.map(function (location, i) {
        return new window.google.maps.Marker({
          position: location
        });
      });
      this.addMarker();
      if (this.positionList.length) {
        averageLat = totalLat / this.positionList.length;
        averageLng = totalLng / this.positionList.length;
        map.setCenter({ lat: averageLat, lng: averageLng });
      }
    }
  },
  mounted: function mounted() {
    this.initMap();
  },

  watch: {
    'menuTime.end.time': function menuTimeEndTime() {
      var lastDay = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
      if (this.menuTime.start.time > lastDay) this.menuTime.start.time = lastDay;
      this.startLimit = [{
        type: 'fromto',
        to: lastDay
      }];
    },
    'menuTime.start.time': function menuTimeStartTime() {
      var lastDay = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.menuTime.start.time).add('60', 'days');
      if (lastDay < __WEBPACK_IMPORTED_MODULE_1_moment___default()()) this.menuTime.end.time = lastDay.format('YYYY-MM-DD');else this.menuTime.end.time = __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD');
      this.endLimit = [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.menuTime.start.time).subtract(1, 'days'),
        to: __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.menuTime.end.time).add(1, 'days')
      }];
    },
    brandSelect: function brandSelect() {
      this.storeSelect = 0;
      if (this.brandSelect !== 0 && this.brandSelect !== '0') {
        this.getStoreBrief(this.brandSelect);
      } else {
        this.getSearchPosition();
      }
    },
    storeSelect: function storeSelect() {
      this.getSearchPosition();
    }
  }
});

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_datepicker_vue_datepicker_es6_vue__);








var todayChart, totalChart, shopperActiveChart, transactionsOrderChart, transactionsMoneyChart, transactionsAmountChart, rejectedChart;
var rejectStatus = 120;
var systemRStatus = 121;
var storeCancelStatus = 122;
var orderDestroyStatus = 140;
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_5_vue_datepicker_vue_datepicker_es6_vue___default.a
  },
  data: function data() {
    return {
      productSaleList: [],
      isMobile: false,
      roleType: 99,
      info: '',
      usersInfo: '',
      disAmount: 0,
      ordersAmount: 0,
      todaySuccess: 0,
      errorAmount: 0,
      shoppersAmount: 0,
      topOrderAmount: {},
      brandSelect: 0,
      storeSelect: 0,
      brandBrief: [],
      storeBrief: [],

      topBLabels: [],
      topBData: [],

      topSLabels: [],
      topSData: [],

      labels: [],
      shopperState: {
        today: {
          total: [],
          certify: [],
          fb: [],
          google: []
        },
        total: {
          total: [],
          certify: [],
          fb: [],
          google: []
        }
      },

      activeLabels: [],
      shopperActive: {
        cr: [],
        cancel: [],
        search: [],
        read: [],
        feedback: []
      },

      transactionLabels: [],
      transactions: {
        order_count_accum: [],
        order_count_day: [],
        order_count_day_normal: [],
        order_count_day_group: [],
        money_accum: [],
        money_accum_mean: [],
        money_day: [],
        money_day_normal: [],
        money_day_group: [],
        money_day_mean: [],
        item_count_accum: [],
        item_count_accum_mean: [],
        item_count_day: [],
        item_count_day_normal: [],
        item_count_day_group: [],
        item_count_day_mean: []
      },

      rejectedOrderList: [],
      rejectedLabels: [],
      rejected: {
        120: [],
        121: [],
        122: [],
        140: []
      },

      productSaleLabels: [],
      productSaleData: [],

      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(1, 'days').format('YYYY-MM-DD')
        },
        week: {
          time: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(-1, 'weeks').format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      startLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD')
      }],
      endLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(1, 'days').add(1, 'days').format('YYYY-MM-DD')
      }],
      weekLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(-1, 'weeks').day(7).format('YYYY-MM-DD')
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    },
    total: function total() {
      var tOrder = 0;
      var tItem = 0;
      var tMoney = 0;
      for (var i = 0; i < this.rejectedOrderList.length; i++) {
        tOrder = tOrder + this.rejectedOrderList[i].order_count;
        tItem = tItem + this.rejectedOrderList[i].item_count;
        tMoney = tMoney + this.rejectedOrderList[i].money;
      }
      return {
        orderCount: tOrder,
        itemCount: tItem,
        money: tMoney
      };
    }
  }),
  created: function created() {
    var date = new Date();
    var y = date.getFullYear();
    var m = date.getMonth();
    var firstDay = new Date(y, m, 1);
    this.menuTime.start.time = __WEBPACK_IMPORTED_MODULE_3_moment___default()(firstDay).format('YYYY-MM-DD');
    this.fixedH();
    var roleType = parseInt(this.getRoleType, 10);
    this.roleType = roleType;
    if (roleType === 99) {
      this.initSystem();
      this.getBrandBrief();
      this.getShopperStatus();
    } else if (roleType === 30) this.getBrandBrief();else if (roleType === 10) this.getBrandBrief();
  },

  methods: {
    initSystem: function initSystem() {
      var self = this;
      var url = '/statistic/matcher';
      this.topBLabels = [];
      this.topBData = [];
      this.topSLabels = [];
      this.topSData = [];
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var info = self.info = response.data.platform_statistic;
          self.ordersAmount = info.order_amount.total;
          self.topOrderAmount = info.top_order_amount.total;
          for (var b = 0; b < self.topOrderAmount.brand.length; b++) {
            self.topBLabels.push(self.topOrderAmount.brand[b].brand_name);
            self.topBData.push(self.topOrderAmount.brand[b].amount);
          }
          for (var s = 0; s < self.topOrderAmount.store.length; s++) {
            self.topSLabels.push(self.topOrderAmount.store[s].store_name);
            self.topSData.push(self.topOrderAmount.store[s].amount);
          }

          if (info.trade_money.today[130]) self.todaySuccess = info.trade_money.today[130].money;

          self.errorAmount = info.abnormal_amount.total;
          self.showTopChart();
        }
      });
      var usersUrl = '/statistic/shopper';
      this.getDataH('get', usersUrl, null, function (response) {
        if (response.data.status === 200) {
          var usersInfo = self.usersInfo = response.data.shopper_statistic;
          self.shoppersAmount = usersInfo.shopper_amount.total.active;
        }
      });
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          var brandIds = '';
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            self.brandBrief.push(obj);
            brandIds = brandIds + bList[i].brand_id + ',';
          }
          brandIds = brandIds.slice(0, -1);
          if (self.roleType === 30) self.initBrand(brandIds);else if (self.roleType === 10) self.getStoreBrief(brandIds);
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      this.storeBrief = [];
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          var storeIds = '';
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
            storeIds = storeIds + sList[i].store_id + ',';
          }
          storeIds = storeIds.slice(0, -1);
          if (storeIds) self.initStore(storeIds);
        }
      });
    },
    initBrand: function initBrand(brandIds) {
      var self = this;
      var url = '/statistic/brand?brand_ids=' + brandIds;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var info = self.info = response.data.brand_statistic;
          self.ordersAmount = info.order_amount.total;
          self.topOrderAmount = info.top_order_amount.total;

          if (info.trade_money.today[130]) self.todaySuccess = info.trade_money.today[130].money;

          var disAmount = 0;
          if (info.trade_money.today[120]) disAmount = disAmount + info.trade_money.today[120].money;
          if (info.trade_money.today[121]) disAmount = disAmount + info.trade_money.today[121].money;
          if (info.trade_money.today[122]) disAmount = disAmount + info.trade_money.today[122].money;
          if (info.trade_money.today[39]) disAmount = disAmount + info.trade_money.today[39].money;
          self.disAmount = disAmount;

          self.errorAmount = info.abnormal_amount.total;
        }
      });
    },
    initStore: function initStore(storeIds) {
      var self = this;
      var url = '/statistic/store?store_ids=' + storeIds;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var info = self.info = response.data.store_statistic;

          if (info.trade_money.today[130]) self.todaySuccess = info.trade_money.today[130].money;

          var disAmount = 0;
          if (info.trade_money.today[120]) disAmount = disAmount + info.trade_money.today[120].money;
          if (info.trade_money.today[121]) disAmount = disAmount + info.trade_money.today[121].money;
          if (info.trade_money.today[122]) disAmount = disAmount + info.trade_money.today[122].money;
          if (info.trade_money.today[39]) disAmount = disAmount + info.trade_money.today[39].money;
          self.disAmount = disAmount;

          self.errorAmount = info.abnormal_amount.total;
        }
      });
    },
    getShopperStatus: function getShopperStatus() {
      this.labels = [];
      this.shopperState = {
        today: {
          total: [],
          certify: [],
          fb: [],
          google: []
        },
        total: {
          total: [],
          certify: [],
          fb: [],
          google: []
        }
      };
      var self = this;
      var data = {
        start_time: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      };
      var url = '/statistic/shopperStatus?start_date=' + data.start_time + '&end_date=' + data.end_time;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.shopper_status_list;
          for (var i in sList) {
            self.labels.push(__WEBPACK_IMPORTED_MODULE_3_moment___default()(sList[i].date, 'YYYY-MM-DD').format('MM/DD'));
            self.shopperState.today.total.push(sList[i].total_day);
            self.shopperState.today.certify.push(sList[i].verified_day);
            self.shopperState.today.fb.push(sList[i].from_facebook_day);
            self.shopperState.today.google.push(sList[i].from_google_day);
            self.shopperState.total.total.push(sList[i].total_accum);
            self.shopperState.total.certify.push(sList[i].verified_accum);
            self.shopperState.total.fb.push(sList[i].from_facebook_accum);
            self.shopperState.total.google.push(sList[i].from_google_accum);
          }
          self.getShopperActivity();
          self.showShopperChart();
        }
      });
    },
    getShopperActivity: function getShopperActivity(type, id) {
      this.activeLabels = [];
      this.shopperActive = {
        cr: [],
        cancel: [],
        search: [],
        read: [],
        feedback: []
      };
      var self = this;
      var data = {
        start_time: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      };
      var url = '';
      if (type === 'brand') url = '/statistic/brandShopperActivity?start_date=' + data.start_time + '&end_date=' + data.end_time + '&brand_id=' + id;else if (type === 'store') url = '/statistic/storeShopperActivity?start_date=' + data.start_time + '&end_date=' + data.end_time + '&store_id=' + id;else url = '/statistic/shopperActivity?start_date=' + data.start_time + '&end_date=' + data.end_time;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var aList = response.data.shopper_activity_list;
          for (var i in aList) {
            if (!type) {
              self.activeLabels.push(__WEBPACK_IMPORTED_MODULE_3_moment___default()(aList[i].date, 'YYYY-MM-DD').format('MM/DD'));
              self.shopperActive.cr.push(aList[i].create_order);
              self.shopperActive.cancel.push(aList[i].cancel_order);
              self.shopperActive.search.push(aList[i].search_store);
              self.shopperActive.read.push(aList[i].read_notification);
              self.shopperActive.feedback.push(aList[i].create_feedback);
            } else {
              self.activeLabels.push(__WEBPACK_IMPORTED_MODULE_3_moment___default()(aList[i][0].date, 'YYYY-MM-DD').format('MM/DD'));
              self.shopperActive.cr.push(aList[i][0].create_order);
              self.shopperActive.cancel.push(aList[i][0].cancel_order);
              self.shopperActive.search.push(aList[i][0].search_store);
              self.shopperActive.read.push(aList[i][0].read_notification);
              self.shopperActive.feedback.push(aList[i][0].create_feedback);
            }
          }
          self.showShopperActiveChart();
          if ((self.brandSelect !== 0 || self.brandSelect !== '0') && (self.storeSelect === 0 || self.storeSelect === '0')) self.getTransactions('brand', self.brandSelect);else if (self.storeSelect !== 0 && self.storeSelect !== '0') self.getTransactions('store', self.storeSelect);else self.getTransactions(type, id);
        }
      });
    },
    getTransactions: function getTransactions(type, id) {
      this.transactionLabels = [];
      this.transactions = {
        order_count_accum: [],
        order_count_day: [],
        order_count_day_normal: [],
        order_count_day_group: [],
        money_accum: [],
        money_accum_mean: [],
        money_day: [],
        money_day_normal: [],
        money_day_group: [],
        money_day_mean: [],
        item_count_accum: [],
        item_count_accum_mean: [],
        item_count_day: [],
        item_count_day_normal: [],
        item_count_day_group: [],
        item_count_day_mean: []
      };
      var self = this;
      var data = {
        start_time: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      };
      var url = '';
      if (type === 'brand') url = '/statistic/brandTransactions?start_date=' + data.start_time + '&end_date=' + data.end_time + '&brand_ids=' + id;else if (type === 'store') url = '/statistic/storeTransactions?start_date=' + data.start_time + '&end_date=' + data.end_time + '&store_ids=' + id;
      if (this.brandSelect === 0 || this.brandSelect === '0') {
        this.showTransactionsChart(type);
        this.showRejectedChart('nodata');
      } else {
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            var tList = response.data.statistics;
            var info;
            for (var i in tList) {
              if (type === 'brand') {
                info = 'brand_info';
              } else if (type === 'store') {
                info = 'store_info';
              }
              self.transactionLabels.push(__WEBPACK_IMPORTED_MODULE_3_moment___default()(i, 'YYYY-MM-DD').format('MM/DD'));
              self.transactions.order_count_accum.push(tList[i][info][id].order_count_accum);
              self.transactions.order_count_day.push(tList[i][info][id].order_count_day);
              self.transactions.order_count_day_normal.push(tList[i][info][id].order_count_day_normal);
              self.transactions.order_count_day_group.push(tList[i][info][id].order_count_day_group);
              self.transactions.money_accum.push(tList[i][info][id].money_accum);
              self.transactions.money_accum_mean.push(tList[i][info][id].money_accum_mean);
              self.transactions.money_day.push(tList[i][info][id].money_day);
              self.transactions.money_day_normal.push(tList[i][info][id].money_day_normal);
              self.transactions.money_day_group.push(tList[i][info][id].money_day_group);
              self.transactions.money_day_mean.push(tList[i][info][id].money_day_mean);
              self.transactions.item_count_accum.push(tList[i][info][id].item_count_accum);
              self.transactions.item_count_accum_mean.push(tList[i][info][id].item_count_accum_mean);
              self.transactions.item_count_day.push(tList[i][info][id].item_count_day);
              self.transactions.item_count_day_normal.push(tList[i][info][id].item_count_day_normal);
              self.transactions.item_count_day_group.push(tList[i][info][id].item_count_day_group);
            }
            if ((self.brandSelect !== 0 || self.brandSelect !== '0') && (self.storeSelect === 99 || self.storeSelect === '99')) self.getRejected('brand', self.brandSelect);else if (self.storeSelect !== 0 && self.storeSelect !== '0') self.getRejected('store', self.storeSelect);else self.getRejected(type, id);
            self.showTransactionsChart(type);
          }
        });
      }
    },
    getRejected: function getRejected(type, id) {
      this.rejectedLabels = [];
      this.rejected = {
        120: [],
        121: [],
        122: [],
        140: []
      };
      this.rejectedOrderList = [];
      var self = this;
      var data = {
        start_time: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      };
      var url = '';
      if (type === 'brand') url = '/statistic/brandRejectedOrders?start_date=' + data.start_time + '&end_date=' + data.end_time + '&brand_ids=' + id;else if (type === 'store') url = '/statistic/storeRejectedOrders?start_date=' + data.start_time + '&end_date=' + data.end_time + '&store_ids=' + id;
      if (this.brandSelect === 0 || this.brandSelect === '0') this.showRejectedChart(type);else {
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            var rList = response.data.rejected_order;
            var info;
            for (var i in rList) {
              if (type === 'brand') {
                info = 'brand_info';
              } else if (type === 'store') {
                info = 'store_info';
              }
              for (var n = 0; n < rList[i][info].length; n++) {
                if (n === 0) {
                  rList[i][info][n]['date'] = i;
                  rList[i][info][n]['reasonAmount'] = rList[i][info].length;
                }
                self.rejectedOrderList.push(rList[i][info][n]);
              }
              self.rejectedLabels.push(__WEBPACK_IMPORTED_MODULE_3_moment___default()(i, 'YYYY-MM-DD').format('MM/DD'));
              var rejectCount = rList[i][info].filter(function (e, i, o) {
                return e.reject_status === rejectStatus;
              });
              var systemRCount = rList[i][info].filter(function (e, i, o) {
                return e.reject_status === systemRStatus;
              });
              var storeCancelCount = rList[i][info].filter(function (e, i, o) {
                return e.reject_status === storeCancelStatus;
              });
              var orderDestroy = rList[i][info].filter(function (e, i, o) {
                return e.reject_status === orderDestroyStatus;
              });
              var rejectTotal = 0;
              var systemRTotal = 0;
              var storeCancelTotal = 0;
              var orderDestroyTotal = 0;
              for (var j = 0; j < rejectCount.length; j++) {
                rejectTotal = rejectTotal + rejectCount[j].order_count;
              }
              for (var k = 0; k < systemRCount.length; k++) {
                systemRTotal = systemRTotal + systemRCount[k].order_count;
              }
              for (var l = 0; l < storeCancelCount.length; l++) {
                storeCancelTotal = storeCancelTotal + storeCancelCount[l].order_count;
              }
              for (var m = 0; m < orderDestroy.length; m++) {
                orderDestroyTotal = orderDestroyTotal + orderDestroy[m].order_count;
              }
              self.rejected[rejectStatus].push(rejectTotal);
              self.rejected[systemRStatus].push(systemRTotal);
              self.rejected[storeCancelStatus].push(storeCancelTotal);
              self.rejected[orderDestroyStatus].push(orderDestroyTotal);
            }
            self.showRejectedChart();
            if ((self.brandSelect !== 0 || self.brandSelect !== '0') && (self.storeSelect === 0 || self.storeSelect === '0')) self.getProductSale('brand', self.brandSelect);else if (self.storeSelect !== 0 && self.storeSelect !== '0') self.getProductSale('store', self.storeSelect);else self.getProductSale(type, id);
          }
        });
      }
    },
    setProductSale: function setProductSale() {
      if ((this.storeSelect === 0 || this.storeSelect === '0') && this.brandSelect !== 0 && this.brandSelect !== '0') {
        this.getProductSale('brand', this.brandSelect);
      } else if (this.storeSelect !== 0 && this.storeSelect !== '0') {
        this.getProductSale('store', this.storeSelect);
      } else {
        this.productSaleList = [];
      }
    },
    getProductSale: function getProductSale(type, id) {
      this.productSaleList = [];
      var self = this;
      var searchWeek = __WEBPACK_IMPORTED_MODULE_3_moment___default()(self.menuTime.week.time, 'YYYY-MM-DD').week();
      var data = {
        year: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.week.time, 'YYYY-MM-DD').format('YYYY'),
        start_week: searchWeek,
        end_week: searchWeek
      };
      var url = '';
      if (type === 'brand') url = '/statistic/brandProductSale?year=' + data.year + '&start_week=' + data.start_week + '&end_week=' + data.end_week + '&brand_id=' + id;else if (type === 'store') url = '/statistic/storeProductSale?year=' + data.year + '&start_week=' + data.start_week + '&end_week=' + data.end_week + '&store_id=' + id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          if (response.data.product_sale_list && response.data.product_sale_list[searchWeek]) self.productSaleList = response.data.product_sale_list[searchWeek][id];
        }
      });
    },
    showTopChart: function showTopChart() {
      var _this = this;

      this.$nextTick(function () {
        var ctx = document.getElementById('today-brand-top').getContext('2d');
        var config = {
          type: 'pie',
          data: {
            datasets: [{
              data: _this.topBData,
              backgroundColor: ['#dd4b39', '#f39c12', '#00c0ef', '#00a65a', '#337ab7']
            }],

            labels: _this.topBLabels
          },
          options: {
            responsive: true,
            maintainAspectRatio: !_this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            }
          }
        };
        new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a(ctx, config);

        var ctx2 = document.getElementById('today-store-top').getContext('2d');
        var config2 = {
          type: 'pie',
          data: {
            datasets: [{
              data: _this.topSData,
              backgroundColor: ['#dd4b39', '#f39c12', '#00c0ef', '#00a65a', '#337ab7']
            }],

            labels: _this.topSLabels
          },
          options: {
            responsive: true,
            maintainAspectRatio: !_this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            }
          }
        };
        new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a(ctx2, config2);
      });
    },
    showShopperChart: function showShopperChart() {
      var _this2 = this;

      this.$nextTick(function () {
        if (typeof todayChart !== 'undefined') {
          todayChart.destroy();
        }
        if (typeof totalChart !== 'undefined') {
          totalChart.destroy();
        }

        var ctx = document.getElementById('today-shopper').getContext('2d');
        var config = {
          type: 'line',
          data: {
            labels: _this2.labels,
            datasets: [{
              label: '當日註冊人數',
              fill: false,
              borderColor: '#00a65a',
              pointBackgroundColor: '#00a65a',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: _this2.shopperState.today.total
            }, {
              label: '當日的通過手機驗證人數',
              borderColor: '#f39c12',
              pointBackgroundColor: '#f39c12',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: _this2.shopperState.today.certify
            }, {
              label: '當日Facebook註冊人數',
              borderColor: '#00c0ef',
              pointBackgroundColor: '#00c0ef',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: _this2.shopperState.today.fb
            }, {
              label: '當日Google註冊人數',
              borderColor: '#dd4b39',
              pointBackgroundColor: '#dd4b39',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: _this2.shopperState.today.google
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: !_this2.isMobile,

            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            }
          }
        };
        todayChart = new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a(ctx, config);
        var ctx2 = document.getElementById('total-shopper').getContext('2d');
        var config2 = {
          type: 'line',
          data: {
            labels: _this2.labels,
            datasets: [{
              label: '當日註冊人數',
              fill: false,
              borderColor: '#00a65a',
              pointBackgroundColor: '#00a65a',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: _this2.shopperState.total.total
            }, {
              label: '當日的通過手機驗證人數',
              borderColor: '#f39c12',
              pointBackgroundColor: '#f39c12',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: _this2.shopperState.total.certify
            }, {
              label: '當日Facebook註冊人數',
              borderColor: '#00c0ef',
              pointBackgroundColor: '#00c0ef',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: _this2.shopperState.total.fb
            }, {
              label: '當日Google註冊人數',
              borderColor: '#dd4b39',
              pointBackgroundColor: '#dd4b39',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: _this2.shopperState.total.google
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: !_this2.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            }
          }
        };
        totalChart = new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a(ctx2, config2);
      });
    },
    showShopperActiveChart: function showShopperActiveChart(type) {
      var _this3 = this;

      var datas = [];
      if (typeof shopperActiveChart !== 'undefined') {
        shopperActiveChart.destroy();
      }
      if (!type) {
        datas = [{
          label: '當日送出訂單人數',
          fill: false,
          borderColor: '#00a65a',
          pointBackgroundColor: '#00a65a',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.shopperActive.cr
        }, {
          label: '當日取消訂單人數',
          borderColor: '#f39c12',
          pointBackgroundColor: '#f39c12',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.shopperActive.cancel
        }, {
          label: '當日以位置查詢店家人數',
          borderColor: '#00c0ef',
          pointBackgroundColor: '#00c0ef',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.shopperActive.search
        }, {
          label: '有閱讀網頁通知人數',
          borderColor: '#dd4b39',
          pointBackgroundColor: '#dd4b39',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.shopperActive.read
        }, {
          label: '有送出意見人數',
          borderColor: '#337ab7',
          pointBackgroundColor: '#337ab7',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.shopperActive.feedback
        }];
      } else {
        datas = [{
          label: '當日送出訂單人數',
          fill: false,
          borderColor: '#00a65a',
          pointBackgroundColor: '#00a65a',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.shopperActive.cr
        }, {
          label: '當日取消訂單人數',
          borderColor: '#f39c12',
          pointBackgroundColor: '#f39c12',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.shopperActive.cancel
        }];
      }
      this.$nextTick(function () {
        var ctx = document.getElementById('shopper-active').getContext('2d');
        var config = {
          type: 'line',
          data: {
            labels: _this3.activeLabels,
            datasets: datas
          },
          options: {
            responsive: true,
            maintainAspectRatio: !_this3.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            }
          }
        };
        shopperActiveChart = new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a(ctx, config);
      });
    },
    showRejectedChart: function showRejectedChart(type) {
      var _this4 = this;

      if (typeof rejectedChart !== 'undefined') {
        rejectedChart.destroy();
      }
      if (type === 'nodata') {
        this.rejectedLabels = [];
        this.rejected = {
          120: [],
          121: [],
          122: [],
          140: []
        };
      }
      this.$nextTick(function () {
        var ctx = document.getElementById('rejected-orders').getContext('2d');
        var config = {
          type: 'bar',
          data: {
            labels: _this4.rejectedLabels,
            datasets: [{
              label: '店家退訂',
              data: _this4.rejected[rejectStatus],
              backgroundColor: ['#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a']
            }, {
              label: '系統退訂',
              data: _this4.rejected[systemRStatus],
              backgroundColor: ['#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12']
            }, {
              label: '店家取消',
              data: _this4.rejected[storeCancelStatus],
              backgroundColor: ['#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef']
            }, {
              label: '訂單作廢',
              data: _this4.rejected[orderDestroyStatus],
              backgroundColor: ['#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39']
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: !_this4.isMobile,
            scales: {
              xAxes: [{
                stacked: true
              }],
              yAxes: [{
                stacked: true
              }]
            },
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            }
          }
        };
        rejectedChart = new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a(ctx, config);
      });
    },
    showTransactionsChart: function showTransactionsChart(type) {
      var _this5 = this;

      this.$nextTick(function () {
        var datas = [{
          label: '累積訂單數量',
          fill: false,
          borderColor: '#00a65a',
          pointBackgroundColor: '#00a65a',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this5.transactions.order_count_accum,
          yAxisID: 'y-axis-2'
        }, {
          label: '當日訂單數量',
          borderColor: '#f39c12',
          pointBackgroundColor: '#f39c12',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this5.transactions.order_count_day,
          yAxisID: 'y-axis-1'
        }, {
          label: '當日一般單數量',
          borderColor: '#00c0ef',
          pointBackgroundColor: '#00c0ef',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this5.transactions.order_count_day_normal,
          yAxisID: 'y-axis-1'
        }, {
          label: '當日揪團單數量',
          borderColor: '#dd4b39',
          pointBackgroundColor: '#dd4b39',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this5.transactions.order_count_day_group,
          yAxisID: 'y-axis-1'
        }];
        var datas2 = [{
          label: '累積成交金額',
          fill: false,
          borderColor: '#00a65a',
          pointBackgroundColor: '#00a65a',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this5.transactions.money_accum,
          yAxisID: 'y-axis-2'
        }, {
          label: '平均成交金額',
          borderColor: '#f39c12',
          pointBackgroundColor: '#f39c12',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this5.transactions.money_accum_mean,
          yAxisID: 'y-axis-1'
        }, {
          label: '當日成交金額',
          borderColor: '#00c0ef',
          pointBackgroundColor: '#00c0ef',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this5.transactions.money_day,
          yAxisID: 'y-axis-1'
        }, {
          label: '當日平均成交金額',
          borderColor: '#dd4b39',
          pointBackgroundColor: '#dd4b39',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this5.transactions.money_day_mean,
          yAxisID: 'y-axis-1'
        }, {
          label: '當日一般單交金額',
          borderColor: '#337ab7',
          pointBackgroundColor: '#337ab7',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this5.transactions.money_day_normal,
          yAxisID: 'y-axis-1'
        }, {
          label: '當日揪團單成交金額',
          borderColor: '#605ca8',
          pointBackgroundColor: '#605ca8',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this5.transactions.money_day_group,
          yAxisID: 'y-axis-1'
        }];
        var datas3 = [{
          label: '累積杯數',
          fill: false,
          borderColor: '#00a65a',
          pointBackgroundColor: '#00a65a',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this5.transactions.item_count_accum,
          yAxisID: 'y-axis-2'
        }, {
          label: '平均杯數',
          borderColor: '#f39c12',
          pointBackgroundColor: '#f39c12',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this5.transactions.item_count_accum_mean,
          yAxisID: 'y-axis-1'
        }, {
          label: '當日杯數',
          borderColor: '#00c0ef',
          pointBackgroundColor: '#00c0ef',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this5.transactions.item_count_day,
          yAxisID: 'y-axis-1'
        }, {
          label: '當日平均杯數',
          borderColor: '#dd4b39',
          pointBackgroundColor: '#dd4b39',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this5.transactions.item_count_day_mean,
          yAxisID: 'y-axis-1'
        }, {
          label: '當日一般單杯數',
          borderColor: '#337ab7',
          pointBackgroundColor: '#337ab7',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this5.transactions.item_count_day_normal,
          yAxisID: 'y-axis-1'
        }, {
          label: '當日揪團單杯數',
          borderColor: '#605ca8',
          pointBackgroundColor: '#605ca8',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this5.transactions.item_count_day_group,
          yAxisID: 'y-axis-1'
        }];
        if (typeof transactionsOrderChart !== 'undefined') {
          transactionsOrderChart.destroy();
        }
        if (typeof transactionsMoneyChart !== 'undefined') {
          transactionsMoneyChart.destroy();
        }
        if (typeof transactionsAmountChart !== 'undefined') {
          transactionsAmountChart.destroy();
        }

        var ctx = document.getElementById('order-transactions').getContext('2d');
        var config = {
          type: 'line',
          data: {
            labels: _this5.transactionLabels,
            datasets: datas
          },
          options: {
            responsive: true,
            maintainAspectRatio: !_this5.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            },
            scales: {
              yAxes: [{
                type: 'linear',
                display: true,
                position: 'left',
                id: 'y-axis-1'
              }, {
                type: 'linear',
                display: true,
                position: 'right',
                id: 'y-axis-2',
                gridLines: {
                  drawOnChartArea: false
                }
              }]
            }
          }
        };

        var ctx2 = document.getElementById('money-transactions').getContext('2d');
        var config2 = {
          type: 'line',
          data: {
            labels: _this5.transactionLabels,
            datasets: datas2
          },
          options: {
            responsive: true,
            maintainAspectRatio: !_this5.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            },
            scales: {
              yAxes: [{
                type: 'linear',
                display: true,
                position: 'left',
                id: 'y-axis-1'
              }, {
                type: 'linear',
                display: true,
                position: 'right',
                id: 'y-axis-2',
                gridLines: {
                  drawOnChartArea: false
                }
              }]
            }
          }
        };

        var ctx3 = document.getElementById('amount-transactions').getContext('2d');
        var config3 = {
          type: 'line',
          data: {
            labels: _this5.transactionLabels,
            datasets: datas3
          },
          options: {
            responsive: true,
            maintainAspectRatio: !_this5.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            },
            scales: {
              yAxes: [{
                type: 'linear',
                display: true,
                position: 'left',
                id: 'y-axis-1'
              }, {
                type: 'linear',
                display: true,
                position: 'right',
                id: 'y-axis-2',
                gridLines: {
                  drawOnChartArea: false
                }
              }]
            }
          }
        };
        transactionsOrderChart = new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a(ctx, config);
        transactionsMoneyChart = new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a(ctx2, config2);
        transactionsAmountChart = new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a(ctx3, config3);
      });
    },
    handelResize: function handelResize() {
      var self = this;
      var w = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).innerWidth();
      if (w >= 1000) self.isMobile = false;else self.isMobile = true;
    },
    getMonthDay: function getMonthDay(date) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date, 'YYYY-MM-DD').format('MM/DD');
    }
  },
  beforeDestory: function beforeDestory() {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).off('resize');
  },
  mounted: function mounted() {
    var self = this;
    this.handelResize();
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).resize(function () {
      self.handelResize();
    });
    this.$nextTick(function () {
      if (!self.isMobile) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#rejected-orders').attr('height', 80);
      }
    });
  },

  watch: {
    'menuTime.end.time': function menuTimeEndTime() {
      var lastDay = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
      if (this.menuTime.start.time > lastDay) this.menuTime.start.time = lastDay;
      this.startLimit = [{
        type: 'fromto',
        to: lastDay
      }];
    },
    'menuTime.start.time': function menuTimeStartTime() {
      var lastDay = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.start.time).add('31', 'days');
      if (lastDay < __WEBPACK_IMPORTED_MODULE_3_moment___default()()) this.menuTime.end.time = lastDay.format('YYYY-MM-DD');else this.menuTime.end.time = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD');
      this.endLimit = [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.start.time).subtract(1, 'days'),
        to: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.end.time).add(1, 'days')
      }];
    },
    brandSelect: function brandSelect() {
      this.storeSelect = 0;
      if (this.brandSelect !== 0 && this.brandSelect !== '0') {
        this.getStoreBrief(this.brandSelect);
        this.getShopperActivity('brand', this.brandSelect);
      } else {
        this.getShopperActivity();
        this.productSaleList = [];
      }
    },
    storeSelect: function storeSelect() {
      if (this.storeSelect !== 0 && this.storeSelect !== '0') this.getShopperActivity('store', this.storeSelect);else this.getShopperActivity('brand', this.brandSelect);
    }
  }
});

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      roleType: 0,
      brandBrief: [],
      storeBrief: [],
      brandSelect: {
        value: 0,
        label: ''
      },
      storeSelect: 0,
      yearSelect: 2018,
      currentYear: 2018,
      statementList: [],
      expSecs: 0,
      timer: 0,
      isLoading: true
    };
  },
  mounted: function mounted() {},

  methods: {
    endDate: function endDate(start) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(start, 'YYYY-MM-DD').add(6, 'days').format('YYYY-MM-DD');
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&is_opening=1&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            self.brandBrief.push(obj);
            if (i === 0) self.brandSelect = obj;
          }
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      this.storeBrief = [];
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
            if (i === 0) {
              self.storeSelect = obj.value;
            }
          }
        }
      });
    },
    getBrandStatement: function getBrandStatement() {
      this.isLoading = true;
      var self = this;
      var url = '/statistic/brandWeeklyStatement?brand_id=' + this.brandSelect.value + '&year=' + this.yearSelect;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.statementList = response.data.download_info.list;
          self.expSecs = response.data.download_info.meta.acl_limit;
          if (self.timer) clearInterval(self.timer);
          self.afterGet();
          self.isLoading = false;
        }
      });
    },
    afterGet: function afterGet() {
      var self = this;
      var num = this.expSecs;
      this.timer = window.setInterval(function () {
        num = num - 1;
        self.expSecs = num;
      }, 1000);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    },
    yearList: function yearList() {
      var currentYear = parseInt(__WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY'), 10);
      this.currentYear = this.yearSelect = currentYear;
      if (currentYear > 2017) {
        var list = [];
        for (var i = currentYear; i >= 2017; i--) {
          var o = {
            label: i.toString(),
            value: i
          };
          if (i === currentYear) this.yearSelect = i;
          list.push(o);
        }
        return list;
      } else {
        return [{
          label: '2017',
          value: 2017
        }];
      }
    }
  }),
  created: function created() {
    this.roleType = parseInt(this.getRoleType, 10);
    this.fixedH();
    this.getBrandBrief();
  },

  watch: {
    brandSelect: function brandSelect() {
      if (this.brandSelect.value) this.getBrandStatement();
    },
    yearSelect: function yearSelect() {
      if (this.yearSelect && this.brandSelect.value) this.getBrandStatement();
    },
    expSecs: function expSecs() {
      if (this.expSecs === 1 && this.brandSelect.value) this.getBrandStatement();
    }
  }
});

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Temp_WeekChartShare_vue__ = __webpack_require__(2139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Temp_WeekChartShare_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Temp_WeekChartShare_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_shared_token_js__ = __webpack_require__(21);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'w-chart-share': __WEBPACK_IMPORTED_MODULE_1__Temp_WeekChartShare_vue___default.a
  },
  data: function data() {
    return {
      roleType: 99
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    }
  }),
  created: function created() {
    var roleType = parseInt(this.getRoleType, 10);
    this.roleType = roleType;
  },

  methods: {
    goto: function goto() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__assets_js_shared_token_js__["c" /* setSharedToken */])(window.localStorage.getItem(this.$config.token));
      window.location.href = this.$config.bdms + 'report-center/downloads?mainTab=1&subTab=0';
    }
  }
});

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AAAA',
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default.a
  },
  data: function data() {
    return {
      roleType: 99,
      brandSelect: 0,
      storeSelect: 0,

      transitTime: 0,
      brandBrief: [],
      storeBrief: [],
      rejectedOrderList: [],
      transitTimeList: [],

      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(1, 'days').format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      startLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD')
      }],
      endLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(1, 'days').add(1, 'days').format('YYYY-MM-DD')
      }]
    };
  },

  methods: {
    clickSearch: function clickSearch() {
      if (this.brandSelect !== 0 && this.brandSelect !== '0') this.getTransitTime();
      if (this.roleType === 10) this.getTransitTime();
    },
    getStoreBrief: function getStoreBrief(brandId) {
      this.storeBrief = [];
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
            if (self.roleType === 10 && i === 0) self.storeSelect = sList[i].store_id;
          }
        }
      });
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          var brandIds = '';
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            self.brandBrief.push(obj);
            brandIds = brandIds + bList[i].brand_id + ',';
          }
          brandIds = brandIds.slice(0, -1);
          if (self.roleType === 30) self.brandSelect = brandIds;else if (self.roleType === 10) self.getStoreBrief(brandIds);
        }
      });
    },
    getTransitTime: function getTransitTime() {
      var self = this;
      this.transitTimeList = [];
      var data = {
        start: __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.menuTime.start.time).format('YYYYMMDD'),
        end: __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.menuTime.end.time).format('YYYYMMDD'),
        brandId: parseInt(this.brandSelect),
        storeId: parseInt(this.storeSelect)
      };
      var url = '';
      var infoType = '';
      if (data.brandId !== 99 && data.storeId === 99) {
        url = '/statistic/brandOrderTransitTime?start_date=' + data.start + '&end_date=' + data.end + '&brand_ids=' + data.brandId;
        infoType = 'brand_info';
      } else if (data.brandId !== 99 && data.storeId !== 99) {
        url = '/statistic/storeOrderTransitTime?start_date=' + data.start + '&end_date=' + data.end + '&store_ids=' + data.storeId;
        infoType = 'store_info';
      } else if (this.roleType === 10) {
        url = '/statistic/storeOrderTransitTime?start_date=' + data.start + '&end_date=' + data.end + '&store_ids=' + data.storeId;
        infoType = 'store_info';
      }
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var tList = response.data.statistics;
          for (var key in tList) {
            for (var n in tList[key][infoType]) {
              if (n === 0) {
                tList[key][infoType][n]['date'] = key;
                tList[key][infoType][n]['reasonAmount'] = tList[key][infoType].length;
              }
              self.transitTimeList.push(tList[key][infoType][n]);
            }
          }
        }
      });
    },
    getMonthDay: function getMonthDay(date) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date, 'YYYY-MM-DD').format('MM/DD');
    },
    getTimeString: function getTimeString(sec) {
      var min = Math.floor(sec / 60);
      var hour = Math.floor(sec / 3600);
      if (sec) {
        if (min === 0) return sec + ' 秒';else {
          if (hour === 0) return min + ' 分';else return hour + ' 小' + Math.floor(sec % 3600) + ' 分';
        }
      } else return '';
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    }
  }),
  created: function created() {
    this.menuTime.start.time = __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(-1, 'weeks').format('YYYY-MM-DD');
    this.fixedH();
    var roleType = parseInt(this.getRoleType, 10);
    this.roleType = roleType;
    this.getBrandBrief();
  },

  watch: {
    brandSelect: function brandSelect() {
      this.storeSelect = 0;
      if (this.brandSelect !== 0 && this.brandSelect !== '0') {
        this.getStoreBrief(this.brandSelect);
        if (this.storeSelect === 0 || this.storeSelect === '0') {
          this.transitTime = 1;
          this.getTransitTime();
        }
      } else {
        this.transitTimeList = [];
      }
    },
    storeSelect: function storeSelect() {
      if (this.storeSelect !== 0 && this.storeSelect !== '0') this.getTransitTime();else if (this.transitTime === 0 && this.brandSelect !== 0 && this.brandSelect !== '0') this.getTransitTime();
      this.transitTime = 0;
    },
    'menuTime.end.time': function menuTimeEndTime() {
      var lastDay = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
      if (this.menuTime.start.time > lastDay) this.menuTime.start.time = lastDay;
      this.startLimit = [{
        type: 'fromto',
        to: lastDay
      }];
    },
    'menuTime.start.time': function menuTimeStartTime() {
      var lastDay = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.menuTime.start.time).add('31', 'days');
      if (lastDay < __WEBPACK_IMPORTED_MODULE_2_moment___default()()) this.menuTime.end.time = lastDay.format('YYYY-MM-DD');else this.menuTime.end.time = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD');
      this.endLimit = [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.menuTime.start.time).subtract(1, 'days'),
        to: __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.menuTime.end.time).add(1, 'days')
      }];
    }
  }
});

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_Chart_Temp_OrderLineCharts_vue__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_Chart_Temp_OrderLineCharts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_views_Chart_Temp_OrderLineCharts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BrandDashboard_vue__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BrandDashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__BrandDashboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SystemDashboard_vue__ = __webpack_require__(2279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SystemDashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__SystemDashboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Dash_RejectReason__ = __webpack_require__(2141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Dash_RejectReason___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Dash_RejectReason__);












/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_5_vue_datepicker_vue_datepicker_es6_vue___default.a,
    'brand-dashboard': __WEBPACK_IMPORTED_MODULE_7__BrandDashboard_vue___default.a,
    'system-dashboard': __WEBPACK_IMPORTED_MODULE_8__SystemDashboard_vue___default.a,
    'reject-reason': __WEBPACK_IMPORTED_MODULE_9__Dash_RejectReason___default.a,
    'order-line-charts': __WEBPACK_IMPORTED_MODULE_6__components_views_Chart_Temp_OrderLineCharts_vue___default.a
  },
  data: function data() {
    return {
      isMobile: false,
      roleType: 99,
      info: '',
      usersInfo: '',
      disAmount: {
        today: 0,
        total: 0
      },
      ordersAmount: {
        today: {
          amount: 0,
          money: 0
        },
        total: {
          amount: 0,
          money: 0
        }
      },
      successItem: {
        today: 0,
        total: 0
      },
      todaySuccess: 0,
      errorAmount: {
        today: 0,
        total: 0
      },
      shoppersAmount: 0,
      topOrderAmount: {},
      topTradeMoney: {},
      topRejectedMoney: {},
      brandBrief: [],
      storeBrief: [],

      topBLabels: [],
      topBData: [],

      topSLabels: [],
      topSData: [],

      allStatistic: {
        total: {
          amount: 0,
          money: 0
        },
        refuse: {
          amount: 0,
          money: 0
        },
        noAccept: {
          amount: 0,
          money: 0
        },
        accept: {
          amount: 0,
          money: 0
        },
        storeRefuse: {
          amount: 0,
          money: 0
        },
        systemRefuse: {
          amount: 0,
          money: 0
        },
        storeCancel: {
          amount: 0,
          money: 0
        },
        done: {
          amount: 0,
          money: 0
        },
        del: {
          amount: 0,
          money: 0
        }
      },
      schema: {
        noAccept: 100,
        accept: 110,
        storeRefuse: 120,
        systemRefuse: 121,
        storeCancel: 122,
        done: 130,
        del: 140 },

      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(1, 'days').format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      startLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD')
      }],
      endLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(1, 'days').add(1, 'days').format('YYYY-MM-DD')
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getRoleType', 'getUserId']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    }
  }),
  created: function created() {
    var date = new Date();

    this.getSubordinate();
    this.menuTime.start.time = __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).add(-30, 'days').format('YYYY-MM-DD');
    this.fixedH();
    var roleType = parseInt(this.getRoleType, 10);
    this.roleType = roleType;
    if (roleType === 99) {
      this.initSystem();
    } else if (roleType === 30) this.getBrandBrief();else if (roleType === 10) this.getBrandBrief();
  },

  methods: {
    getSubordinate: function getSubordinate() {
      var self = this;
      var roleTypeName = '';
      if (self.getRoleType === 99) {
        roleTypeName = 'admin';
      } else if (self.getRoleType === 30) {
        roleTypeName = 'brand';
      } else if (self.getRoleType === 10) {
        roleTypeName = 'store';
      }

      var url = '/manager/' + roleTypeName + '/' + self.getUserId + '/subordinate';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var restricList = [];
          var denyList = [];
          if (response.data.subordinate.allowed_restricted_function_list) {
            restricList = response.data.subordinate.allowed_restricted_function_list;
          }
          if (response.data.subordinate.denied_restricted_function_list) {
            denyList = response.data.subordinate.denied_restricted_function_list;
          }
          self.$store.commit('SET_RESTRICT', restricList);
          self.$store.commit('SET_DENYLIST', denyList);
        }
      });
    },
    initSystem: function initSystem() {
      var sc = this.schema;
      var self = this;
      var url = '/statistic/matcher';
      this.topBLabels = [];
      this.topBData = [];
      this.topSLabels = [];
      this.topSData = [];
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var info = self.info = response.data.platform_statistic;
          self.ordersAmount = info.order_amount;
          self.topOrderAmount = info.top_order_amount.total;
          for (var b = 0; b < self.topOrderAmount.brand.length; b++) {
            self.topBLabels.push(self.topOrderAmount.brand[b].brand_name);
            self.topBData.push(self.topOrderAmount.brand[b].amount);
          }
          for (var s = 0; s < self.topOrderAmount.store.length; s++) {
            self.topSLabels.push(self.topOrderAmount.store[s].store_name);
            self.topSData.push(self.topOrderAmount.store[s].amount);
          }

          if (info.trade_money.today[sc.done] !== null && typeof info.trade_money.today[sc.done] !== 'undefined') {
            self.successItem.today = info.trade_money.today[sc.done].items;
          }
          if (info.trade_money.total[sc.done] !== null && typeof info.trade_money.total[sc.done] !== 'undefined') {
            self.successItem.total = info.trade_money.total[sc.done].items;
          }
          var disAmount = {
            today: 0,
            total: 0
          };
          if (info.trade_money.today[sc.storeRefuse] !== null && typeof info.trade_money.today[sc.storeRefuse] !== 'undefined') {
            disAmount.today = disAmount.today + info.trade_money.today[sc.storeRefuse].money;
            disAmount.total = disAmount.total + info.trade_money.total[sc.storeRefuse].money;
          }
          if (info.trade_money.today[sc.systemRefuse] !== null && typeof info.trade_money.today[sc.systemRefuse] !== 'undefined') {
            disAmount.today = disAmount.today + info.trade_money.today[sc.systemRefuse].money;
            disAmount.total = disAmount.total + info.trade_money.total[sc.systemRefuse].money;
          }
          if (info.trade_money.today[sc.storeCancel] !== null && typeof info.trade_money.today[sc.storeCancel] !== 'undefined') {
            disAmount.today = disAmount.today + info.trade_money.today[sc.storeCancel].money;
            disAmount.total = disAmount.total + info.trade_money.total[sc.storeCancel].money;
          }
          if (info.trade_money.today[39] !== null && typeof info.trade_money.today[39] !== 'undefined') {
            disAmount.today = disAmount.today + info.trade_money.today[39].money;
            disAmount.total = disAmount.total + info.trade_money.total[39].money;
          }
          self.disAmount = disAmount;
          self.errorAmount.total = info.abnormal_amount.total;
          if (info.status_amount.today[sc.accept] !== null && typeof info.status_amount.today[sc.accept] !== 'undefined') {
            self.errorAmount.today = info.status_amount.today[sc.accept].amount;
          }
          var all = self.allStatistic;
          for (var _s in sc) {
            var status = sc[_s];
            if (info.status_amount.today[status] !== null && typeof info.status_amount.today[status] !== 'undefined') {
              all[_s].amount = info.status_amount.today[status].amount;
              all.total.amount = all.total.amount + info.status_amount.today[status].amount;
            }
            if (info.trade_money.today[status] !== null && typeof info.trade_money.today[status] !== 'undefined') {
              all[_s].money = info.trade_money.today[status].money;
              all.total.money = all.total.money + info.trade_money.today[status].money;
            }
          }
          all.refuse.amount = all.storeRefuse.amount + all.systemRefuse.amount + all.storeCancel.amount;
          all.refuse.money = all.storeRefuse.money + all.systemRefuse.money + all.storeCancel.money;
          self.showAllBriefChart();
        }
      });
      var usersUrl = '/statistic/shopper';
      this.getDataH('get', usersUrl, null, function (response) {
        if (response.data.status === 200) {
          var usersInfo = self.usersInfo = response.data.shopper_statistic;
          self.shoppersAmount = usersInfo.shopper_amount.total.active;
        }
      });
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          var brandIds = '';
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            self.brandBrief.push(obj);
            brandIds = brandIds + bList[i].brand_id + ',';
          }
          brandIds = brandIds.slice(0, -1);
          if (bList > 1) self.show.brandDash = false;
          if (self.roleType === 30) self.initBrand(brandIds);else if (self.roleType === 10) self.getStoreBrief(brandIds);
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      this.storeBrief = [];
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          var storeIds = '';
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
            storeIds = storeIds + sList[i].store_id + ',';
          }
          storeIds = storeIds.slice(0, -1);
          self.initStore(storeIds);
        }
      });
    },
    initBrand: function initBrand(brandIds) {
      var sc = this.schema;
      var self = this;
      var url = '/statistic/brand?brand_ids=' + brandIds;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var info = self.info = response.data.brand_statistic;
          self.ordersAmount = info.order_amount;
          self.topOrderAmount = info.top_order_amount.today;
          self.topTradeMoney = info.top_trade_money.today;
          self.topRejectedMoney = info.top_rejected_money.today;
          if (info.trade_money.today[sc.done] !== null && typeof info.trade_money.today[sc.done] !== 'undefined') {
            self.successItem.today = info.trade_money.today[sc.done].items;
          }
          if (info.trade_money.total[sc.done] !== null && typeof info.trade_money.total[sc.done] !== 'undefined') {
            self.successItem.total = info.trade_money.total[sc.done].items;
          }
          var disAmount = {
            today: 0,
            total: 0
          };
          if (info.trade_money.today[sc.storeRefuse] !== null && typeof info.trade_money.today[sc.storeRefuse] !== 'undefined') {
            disAmount.today = disAmount.today + info.trade_money.today[sc.storeRefuse].money;
          }
          if (info.trade_money.total[sc.storeRefuse] !== null && typeof info.trade_money.total[sc.storeRefuse] !== 'undefined') {
            disAmount.total = disAmount.total + info.trade_money.total[sc.storeRefuse].money;
          }
          if (info.trade_money.today[sc.systemRefuse] !== null && typeof info.trade_money.today[sc.systemRefuse] !== 'undefined') {
            disAmount.today = disAmount.today + info.trade_money.today[sc.systemRefuse].money;
          }
          if (info.trade_money.total[sc.systemRefuse] !== null && typeof info.trade_money.total[sc.systemRefuse] !== 'undefined') {
            disAmount.total = disAmount.total + info.trade_money.total[sc.systemRefuse].money;
          }
          if (info.trade_money.today[sc.storeCancel] !== null && typeof info.trade_money.today[sc.storeCancel] !== 'undefined') {
            disAmount.today = disAmount.today + info.trade_money.today[sc.storeCancel].money;
          }
          if (info.trade_money.total[sc.storeCancel] !== null && typeof info.trade_money.total[sc.storeCancel] !== 'undefined') {
            disAmount.total = disAmount.total + info.trade_money.total[sc.storeCancel].money;
          }

          if (info.trade_money.today[sc.del] !== null && typeof info.trade_money.today[sc.del] !== 'undefined') {
            disAmount.today = disAmount.today + info.trade_money.today[sc.del].money;
          }
          if (info.trade_money.total[sc.del] !== null && typeof info.trade_money.total[sc.del] !== 'undefined') {
            disAmount.total = disAmount.total + info.trade_money.total[sc.del].money;
          }
          self.disAmount = disAmount;
          self.errorAmount.total = info.abnormal_amount.total;
          if (info.status_amount.today[sc.accept] !== null && typeof info.status_amount.today[sc.accept] !== 'undefined') {
            self.errorAmount.today = info.status_amount.today[sc.accept].amount;
          }
          var all = self.allStatistic;
          for (var s in sc) {
            var status = sc[s];
            if (info.status_amount.today[status] !== null && typeof info.status_amount.today[status] !== 'undefined') {
              all[s].amount = info.status_amount.today[status].amount;
              all.total.amount = all.total.amount + info.status_amount.today[status].amount;
            }
            if (info.trade_money.today[status] !== null && typeof info.trade_money.today[status] !== 'undefined') {
              all[s].money = info.trade_money.today[status].money;
              all.total.money = all.total.money + info.trade_money.today[status].money;
            }
          }
          all.refuse.amount = all.storeRefuse.amount + all.systemRefuse.amount + all.storeCancel.amount;
          all.refuse.money = all.storeRefuse.money + all.systemRefuse.money + all.storeCancel.money;
          self.showAllBriefChart();
        }
      });
    },
    initStore: function initStore(storeIds) {
      var sc = this.schema;
      var self = this;
      var url = '/statistic/store?store_ids=' + storeIds;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var info = self.info = response.data.store_statistic;
          self.ordersAmount = info.order_amount;
          self.topOrderAmount = info.top_order_amount;
          if (info.trade_money.today[sc.done] !== null && typeof info.trade_money.today[sc.done] !== 'undefined') {
            self.successItem.today = info.trade_money.today[sc.done].items;
          }
          if (info.trade_money.total[sc.done] !== null && typeof info.trade_money.total[sc.done] !== 'undefined') {
            self.successItem.total = info.trade_money.total[sc.done].items;
          }

          var disAmount = {
            today: 0,
            total: 0
          };
          if (info.trade_money.today[sc.storeRefuse] !== null && typeof info.trade_money.today[sc.storeRefuse] !== 'undefined') {
            disAmount.today = disAmount.today + info.trade_money.today[sc.storeRefuse].money;
          }
          if (info.trade_money.total[sc.storeRefuse] !== null && typeof info.trade_money.total[sc.storeRefuse] !== 'undefined') {
            disAmount.total = disAmount.total + info.trade_money.total[sc.storeRefuse].money;
          }
          if (info.trade_money.today[sc.systemRefuse] !== null && typeof info.trade_money.today[sc.systemRefuse] !== 'undefined') {
            disAmount.today = disAmount.today + info.trade_money.today[sc.systemRefuse].money;
          }
          if (info.trade_money.total[sc.systemRefuse] !== null && typeof info.trade_money.total[sc.systemRefuse] !== 'undefined') {
            disAmount.total = disAmount.total + info.trade_money.total[sc.systemRefuse].money;
          }
          if (info.trade_money.today[sc.storeCancel] !== null && typeof info.trade_money.today[sc.storeCancel] !== 'undefined') {
            disAmount.today = disAmount.today + info.trade_money.today[sc.storeCancel].money;
          }
          if (info.trade_money.total[sc.storeCancel] !== null && typeof info.trade_money.total[sc.storeCancel] !== 'undefined') {
            disAmount.total = disAmount.total + info.trade_money.total[sc.storeCancel].money;
          }
          if (info.trade_money.today[39] !== null && typeof info.trade_money.today[39] !== 'undefined') {
            disAmount.today = disAmount.today + info.trade_money.today[39].money;
          }
          if (info.trade_money.total[39] !== null && typeof info.trade_money.total[39] !== 'undefined') {
            disAmount.total = disAmount.total + info.trade_money.total[39].money;
          }
          self.disAmount = disAmount;
          self.errorAmount.total = info.abnormal_amount.total;
          if (info.status_amount.today[sc.accept] !== null && typeof info.status_amount.today[sc.accept] !== 'undefined') {
            self.errorAmount.today = info.status_amount.today[sc.accept].amount;
          }
          var all = self.allStatistic;
          for (var s in sc) {
            var status = sc[s];
            if (info.status_amount.today[status] !== null && typeof info.status_amount.today[status] !== 'undefined') {
              all[s].amount = info.status_amount.today[status].amount;
              all.total.amount = all.total.amount + info.status_amount.today[status].amount;
            }
            if (info.trade_money.today[status] !== null && typeof info.trade_money.today[status] !== 'undefined') {
              all[s].money = info.trade_money.today[status].money;
              all.total.money = all.total.money + info.trade_money.today[status].money;
            }
          }
          all.refuse.amount = all.storeRefuse.amount + all.systemRefuse.amount + all.storeCancel.amount;
          all.refuse.money = all.storeRefuse.money + all.systemRefuse.money + all.storeCancel.money;
          self.showAllBriefChart();
        }
      });
    },
    showTopChart: function showTopChart() {
      var ctx = document.getElementById('today-brand-top').getContext('2d');
      var config = {
        type: 'pie',
        data: {
          datasets: [{
            data: this.topBData,
            backgroundColor: ['#dd4b39', '#f39c12', '#00c0ef', '#00a65a', '#337ab7']
          }],

          labels: this.topBLabels
        },
        options: {
          responsive: true,
          maintainAspectRatio: !this.isMobile,
          legend: {
            position: 'bottom',
            display: true
          },
          tooltips: {
            mode: 'label',
            xPadding: 10,
            yPadding: 10,
            bodySpacing: 10
          }
        }
      };
      new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a(ctx, config);

      var ctx2 = document.getElementById('today-store-top').getContext('2d');
      var config2 = {
        type: 'pie',
        data: {
          datasets: [{
            data: this.topSData,
            backgroundColor: ['#dd4b39', '#f39c12', '#00c0ef', '#00a65a', '#337ab7']
          }],

          labels: this.topSLabels
        },
        options: {
          responsive: true,
          maintainAspectRatio: !this.isMobile,
          legend: {
            position: 'bottom',
            display: true
          },
          tooltips: {
            mode: 'label',
            xPadding: 10,
            yPadding: 10,
            bodySpacing: 10
          }
        }
      };
      new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a(ctx2, config2);
    },
    showAllBriefChart: function showAllBriefChart() {
      var _this = this;

      this.$nextTick(function () {
        var all = _this.allStatistic;
        var ctx = document.getElementById('all-amount-brief').getContext('2d');
        var data = [];
        data.push(all.noAccept.amount);
        data.push(all.accept.amount);
        data.push(all.refuse.amount);
        data.push(all.done.amount);
        data.push(all.del.amount);
        var config = {
          type: 'pie',
          data: {
            datasets: [{
              data: data,
              backgroundColor: ['#dd4b39', '#f39c12', '#00c0ef', '#00a65a', '#337ab7']
            }],

            labels: ['未接單', '已接單', '被退訂', '已完成', '已作廢']
          },
          options: {
            responsive: true,
            maintainAspectRatio: !_this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            }
          }
        };
        new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a(ctx, config);

        var ctx2 = document.getElementById('all-money-brief').getContext('2d');
        var data2 = [];
        data2.push(all.noAccept.money);
        data2.push(all.accept.money);
        data2.push(all.refuse.money);
        data2.push(all.done.money);
        data2.push(all.del.money);
        var config2 = {
          type: 'pie',
          data: {
            datasets: [{
              data: data2,
              backgroundColor: ['#dd4b39', '#f39c12', '#00c0ef', '#00a65a', '#337ab7']
            }],

            labels: ['未接單', '已接單', '被退訂', '已完成', '已作廢']
          },
          options: {
            responsive: true,
            maintainAspectRatio: !_this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            }
          }
        };
        new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a(ctx2, config2);
      });
    },
    handelResize: function handelResize() {
      var self = this;
      var w = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).innerWidth();
      if (w >= 1000) self.isMobile = false;else self.isMobile = true;
    },
    reload: function reload() {
      window.location.reload();
    }
  },
  beforeDestory: function beforeDestory() {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).off('resize');
  },
  mounted: function mounted() {
    var self = this;
    this.handelResize();
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).resize(function () {
      self.handelResize();
    });
  },

  watch: {
    'menuTime.end.time': function menuTimeEndTime() {
      var lastDay = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
      if (this.menuTime.start.time > lastDay) this.menuTime.start.time = lastDay;
      this.startLimit = [{
        type: 'fromto',
        to: lastDay
      }];
    },
    'menuTime.start.time': function menuTimeStartTime() {
      var lastDay = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.start.time).add('31', 'days');
      if (lastDay < __WEBPACK_IMPORTED_MODULE_3_moment___default()()) this.menuTime.end.time = lastDay.format('YYYY-MM-DD');else this.menuTime.end.time = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD');
      this.endLimit = [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.start.time).subtract(1, 'days'),
        to: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.end.time).add(1, 'days')
      }];
    }
  }
});

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_designatedForm_vue__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_designatedForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_designatedForm_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'designated-form': __WEBPACK_IMPORTED_MODULE_0__Temp_designatedForm_vue___default.a
  },
  data: function data() {
    return {
      info: {
        attend_stores: [],
        give_coupons: [],
        strategy_data: {},
        info: {}
      }
    };
  },

  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    }
  },
  created: function created() {},

  methods: {
    getActivity: function getActivity() {
      var self = this;
      var url = 'activity/' + this.$route.params.activity_id + '/orderCouponComplete';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.info = response.data;
        }
      });
    }
  }
});

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Temp_DesignatedTableTemp_vue__ = __webpack_require__(2145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Temp_DesignatedTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Temp_DesignatedTableTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      tableIndex: 1
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#example1').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      });
    });
  },

  methods: {
    payType: function payType(type) {
      if (type === 10) {
        return '線上支付';
      } else if (type === 50) {
        return '店家支付';
      }
    },
    payStateName: function payStateName(state) {
      if (state === 11) {
        return '尚未付款';
      } else if (state === 12) {
        return '付款處理中';
      } else if (state === 13) {
        return '已收款';
      } else if (state === 21) {
        return '退款處理中';
      } else if (state === 22) {
        return '已退款';
      }
    },
    orderState: function orderState(state) {
      if (state === 0) {
        return '訂單尚未確認';
      } else if (state === 1) {
        return '訂單已送出，尚未付款';
      } else if (state === 2) {
        return '付款中';
      } else if (state === 3) {
        return '訂單已付款，尚未通知店家';
      } else if (state === 99) {
        return '使用者取消訂單';
      } else if (state === 100) {
        return '未接單';
      } else if (state === 110) {
        return '已接單';
      } else if (state === 120) {
        return '被店家退訂';
      } else if (state === 121) {
        return '被系統退訂';
      } else if (state === 122) {
        return '已取消';
      } else if (state === 130) {
        return '已完成';
      } else if (state === 140) {
        return '已作廢';
      }
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    }
  },
  components: {
    'designated-table': __WEBPACK_IMPORTED_MODULE_4__Temp_DesignatedTableTemp_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  })
});

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue___default.a
  },
  data: function data() {
    return {
      roleType: '',
      total: 1,
      count: 20,
      designatedList: [],
      shopperId: 0,
      unit: '',
      branch: '',
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      searchSelect: 1,
      brandSelect: 0,
      storeSelect: 0,
      typeSelect: 0,
      ownerSelect: 0,
      deTypeSelect: 999,
      isCreatedTime: false,
      isCreatedStore: false,
      brandBrief: [],
      storeBrief: [],
      brandDefault: 0,
      typeList: [{ label: '== 公司型態 ==', value: 0 }, { label: '民營企業', value: 1 }, { label: '公家機關', value: 2 }, { label: '企業內部規劃', value: 3 }],
      ownerList: [{ label: '== 擁有者 ==', value: 0 }, { label: '平台', value: 3 }, { label: '品牌', value: 1 }, { label: '門市', value: 2 }]
    };
  },

  methods: {
    ownerName: function ownerName(owner) {
      switch (owner) {
        case 1:
          return '品牌';
        case 2:
          return '門市';
        case 3:
        default:
          return '平台';
      }
    },
    search: function search(method) {
      if (method === 1 && this.unit) {
        this.getDesignatedList(1);
      } else if (method === 2 && this.branch) {
        this.getDesignatedList(1);
      } else this.getDesignatedList();
    },
    clickGroup: function clickGroup(type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1;
        this.tableIndex = this.groupAmount * this.pageGroup;
        this.clickPage(this.tableIndex);
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1;
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1;
        this.clickPage(this.tableIndex);
      }
    },
    clickEnd: function clickEnd(type) {
      if (type === 'pre') {
        this.clickPage(1);
        this.pageGroup = 1;
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount);else this.clickPage(1);
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount);
      }
    },
    payType: function payType(type) {
      if (type === 10) {
        return '線上支付';
      } else if (type === 50) {
        return '店家支付';
      }
    },
    labelColor: function labelColor(type) {
      if (type === 1) {
        return 'label-default';
      } else if (type === 707 || type === 701) {
        return 'label-success';
      } else if (type === 709) {
        return 'label-danger';
      } else if (type === 710) {
        return 'label-info';
      }
    },
    stateColor: function stateColor(state) {
      if (state === 11) {
        return 'label-default';
      } else if (state === 12) {
        return 'label-primary';
      } else if (state === 13) {
        return 'label-success';
      } else if (state === 21) {
        return 'label-danger';
      } else if (state === 22) {
        return 'label-danger';
      }
    },
    tradeType: function tradeType(type) {
      if (type === 1) {
        return '現金';
      } else if (type === 707) {
        return 'LINE PAY';
      } else if (type === 701) {
        return 'iPASS MONEY';
      } else if (type === 709) {
        return '信用卡(台新)';
      } else if (type === 710) {
        return '信用卡';
      }
    },
    payStateName: function payStateName(state) {
      if (state === 11) {
        return '未付款';
      } else if (state === 12) {
        return '付款中';
      } else if (state === 13) {
        return '已收款';
      } else if (state === 21) {
        return '退款中';
      } else if (state === 22) {
        return '已退款';
      }
    },
    orderStateColor: function orderStateColor(state) {
      switch (state) {
        case 140:
        case 120:
        case 121:
        case 122:
        case 99:
          return 'label-danger';
        case 100:
          return 'label-default';
        case 110:
          return 'label-primary';
        case 130:
          return 'label-success';
        default:
          return 'label-warning';
      }
    },
    orderState: function orderState(state) {
      if (state === 0) {
        return '訂單尚未確認';
      } else if (state === 1) {
        return '訂單已送出，尚未付款';
      } else if (state === 2) {
        return '付款中';
      } else if (state === 3) {
        return '訂單已付款，尚未通知店家';
      } else if (state === 99) {
        return '客人取消';
      } else if (state === 100) {
        return '未接單';
      } else if (state === 110) {
        return '已接單';
      } else if (state === 120) {
        return '店家退訂';
      } else if (state === 121) {
        return '系統退訂';
      } else if (state === 122) {
        return '已取消';
      } else if (state === 130) {
        return '已完成';
      } else if (state === 140) {
        return '已作廢';
      }
    },
    shippingStateColor: function shippingStateColor(state) {
      switch (state) {
        case 19:
        case 59:
        case 900:
        case 901:
        case 910:
        case 920:
        case 921:
        case 930:
        case 940:
          return 'text-danger';
        case 0:
          return 'text-default';
        case 10:
        case 50:
        case 100:
        case 110:
        case 120:
        case 130:
          return 'text-primary';
        case 140:
          return 'text-success';
        default:
          return '';
      }
    },
    shippingStateColorBg: function shippingStateColorBg(state) {
      switch (state) {
        case 19:
        case 59:
        case 900:
        case 901:
        case 910:
        case 920:
        case 921:
        case 930:
        case 940:
          return 'bg-danger';
        case 0:
          return 'bg-default';
        case 10:
        case 50:
        case 100:
        case 110:
        case 120:
        case 130:
          return 'bg-primary';
        case 140:
          return 'bg-success';
        default:
          return '';
      }
    },
    shippingState: function shippingState(state) {
      if (state === 0) {
        return '叫件開案';
      } else if (state === 10) {
        return '已報價';
      } else if (state === 19) {
        return '報價失敗';
      } else if (state === 50) {
        return '叫件中';
      } else if (state === 59) {
        return '叫件失敗';
      } else if (state === 100) {
        return '成立物流單';
      } else if (state === 110) {
        return '物流接單';
      } else if (state === 120) {
        return '已分派外送員';
      } else if (state === 130) {
        return '已取貨';
      } else if (state === 140) {
        return '已送達';
      } else if (state === 900 || state === 901 || state === 910 || state === 921 || state === 930 || state === 940) {
        return '門市取消叫件';
      } else if (state === 920) {
        return '媒合失敗';
      }
    },
    selectStyle: function selectStyle(item) {
      var self = this;
      this.$nextTick(function () {
        this.designatedList.forEach(function (item) {
          self.$set(item, 'active', false);
        });
        this.$set(item, 'active', true);
      });
    },
    outStyle: function outStyle(item) {
      this.$set(item, 'active', false);
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      if (index === 1) this.pageGroup = 1;
      this.getDesignatedList();
    },
    getDesignatedList: function getDesignatedList(page) {
      if (page) {
        this.tableIndex = page;
        if (page === 1) this.pageGroup = 1;
      }
      var self = this;
      var url = '/brand/' + this.brandSelect + '/designatedUnit/list?';
      if (this.storeSelect) url = url + '&store_id=' + this.storeSelect;
      if (this.ownerSelect) url = url + '&owner=' + this.ownerSelect;
      if (this.typeSelect) url = url + '&type=' + this.typeSelect;
      if (this.searchSelect === 1 && this.unit) url = url + '&unit=' + this.unit;
      if (this.searchSelect === 2 && this.branch) url = url + '&branch=' + this.branch;
      if (url) {
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.designatedList = response.data.list;
          }
        });
      }
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&is_opening=1&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            if (!bList[i].is_visible) obj.label = obj.label + ' (測)';
            self.brandBrief.push(obj);
            if (i === 0) self.brandSelect = obj.value;
          }
          self.getDesignatedList();
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      this.storeBrief = [];
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?status=2&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
            if (!self.isCreatedStore) {
              self.isCreatedStore = true;
            } else if (i === 0) {
              self.getDesignatedList(1);
            }
          }
        }
      });
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    },
    checkMemberShow: function checkMemberShow(status) {
      if (this.roleType === 30) {
        if (status === 130 || status === 140) return true;else return false;
      } else return true;
    },
    getTime: function getTime(time) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(time, 'YYYY-MM-DD HH:mm:ss').format('MM/DD HH:mm');
    }
  },
  created: function created() {
    this.getBrandBrief();
    this.roleType = parseInt(this.getRoleType, 10);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  }),
  watch: {
    brandSelect: function brandSelect() {
      this.storeSelect = 0;
      if (this.$route.name === 'storeInfo') {
        this.storeSelect = this.$route.params.store_id;
        this.getStoreBrief(this.brandSelect);
      }if (this.brandSelect !== 0 && this.brandSelect !== '0') {
        this.getStoreBrief(this.brandSelect);
      } else {
        this.getDesignatedList(1);
      }
      window.sessionStorage.setItem('Nidin_orderTable_brandS', this.brandSelect);
    },
    storeSelect: function storeSelect() {
      this.getDesignatedList(1);
      window.sessionStorage.setItem('Nidin_orderTable_storeS', this.storeSelect);
    },
    typeSelect: function typeSelect() {
      this.getDesignatedList(1);
    },
    ownerSelect: function ownerSelect() {
      this.getDesignatedList(1);
    }
  }
});

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    info: Object
  },
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default.a
  },
  data: function data() {
    return {
      delOption: {
        id: 'delModal',
        title: '刪除活動',
        body: '確定刪除活動?<br>',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delActivity'
        }]
      },
      up: false,
      activityMethod: 1,

      orderType: [{ label: '一般單', value: 1 }, { label: '團購單 - 團長', value: 2 }, { label: '團購單 - 團員', value: 3 }],
      orderMethod: [{ label: '當日單', value: 1 }, { label: '預訂單', value: 2 }],
      coupon: {
        type: { label: '固定起迄時間', value: 1 },
        price_type: { label: '免稅', value: 1 },
        discount_type: { label: '折扣金額', value: 1 },
        setting: { label: '依訂單購買商品數設定', value: 1 },
        useType: { label: '品牌型', value: 2 }
      },
      otherCoupon: [],

      otherCouponList: [{ label: 'Nidin優惠券', value: 1, code: '1231231dz' }, { label: '柴犬優惠券', value: 2, code: '324efxde' }, { label: '你好優惠券', value: 3, code: '654trrgxx' }],
      addStoresSetting: {
        class: 'buy-add-store',
        options: [],
        choose: []
      },

      deadType: [{ label: '固定起迄時間', value: 'all_fixed' }, { label: '固定結束時間', value: 'day_fixed' }, { label: '發送日幾天後', value: 'day_day' }],
      discountType: [{ label: '折扣金額', value: 1 }],
      couponSetting: [{ label: '依訂單購買商品數設定', value: 'SC00001' }, { label: '依個人訂單消費特定商品數', value: 'SC00002' }, { label: '依個人訂單購買金額', value: 'SC00003' }],
      useType: [{ label: '品牌型', value: 2 }, { label: '門市型', value: 3 }],
      typeOption: [{ label: '民營機關', value: 1 }, { label: '公家機關', value: 2 }, { label: '企業內部規劃', value: 3 }],
      usageValue: [],
      brandList: [],
      content: {
        bindingStoreList: [],
        bindingBrandList: [],
        bindingProdList: []
      },
      brandDefault: '',
      brandBrief: [],
      storeBrief: [],
      scheduleTime: '',
      show: {
        back: false
      },
      menuId: 0,
      menuName: '',
      storeId: 0,
      designated: {
        owner: { label: '品牌', value: 1 },
        unit: '',
        branch: '',
        tel: '',
        address: '',
        type: { label: '民營機關', value: 1 },
        ein: '',
        contact_name: '',
        contact_phone: '',
        contact_email: ''
      },
      productBrief: [],
      productChoseBrief: [],
      nowTime: __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD HH:mm'),

      ownerTypeOptions: [{ label: '品牌', value: 1 }, { label: '門市', value: 2 }, { label: '平台', value: 3 }],
      aStoreList: [],
      aStoreOption: [],
      brandSelect: {
        label: '',
        value: ''
      },
      storeSelect: {},
      brandSelectMuti: [],
      setInfoTimes: 0
    };
  },
  created: function created() {
    this.getBrandBrief();
    if (this.$route.name.indexOf('up') > -1) this.up = true;

    if (this.getRoleType === 30) this.designated.owner = { label: '品牌', value: 1 };else if (this.getRoleType === 10) {
      this.designated.owner = { label: '門市', value: 2 };
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['setMenuStartTime', 'setMenuEndTime']), {
    trigger: function trigger(event) {
      if (event === 'delActivity') this.delActivity();
    },
    delActivity: function delActivity() {
      var self = this;
      var url = '/activity/' + this.$route.params.activity_id + '/orderCouponComplete';
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.replace('/upCouponTable');
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId, last) {
      var self = this;
      if (self.designated.owner.value !== 2) self.addStoresSetting.options = [{ label: '全部', value: 0 }];else self.addStoresSetting.options = [];
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
            self.addStoresSetting.options.push(obj);
            if (self.getRoleType === 10) self.storeSelect = obj;
          }
          if (self.info.id && self.setInfoTimes && last) self.setStore();else if (self.getRoleType === 10) {
            self.addStoresSetting.choose.push(self.addStoresSetting.options[0].value);
          }
        }
      });
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            self.brandBrief.push(obj);
          }
          if (self.$route.name.indexOf('up') > -1 && self.info.id && !self.setInfoTimes) {
            self.setInfo();
          } else if (self.getRoleType === 10 || self.getRoleType === 30) {
            self.brandSelect = self.brandBrief[0];
            self.getStore();
          }
        }
      });
    },
    getStore: function getStore() {
      this.aStoreOption = [];
      this.storeBrief = [];
      this.addStoresSetting.options = [];
      this.addStoresSetting.choose = [];
      this.brandList = [];
      if (this.brandSelect.value) this.getStoreBrief(this.brandSelect.value, true);
      this.brandList.push(this.brandSelect);
    },
    checkDesigned: function checkDesigned() {
      var dInfo = this.designated;
      var msg = '';
      if (!dInfo.unit) msg = '單位名稱未填';else if (!dInfo.branch) msg = '廠區名稱未填';else if (!dInfo.tel) msg = '電話未填';else if (!dInfo.address) msg = '地址未填';else if (!dInfo.type.value) msg = '公司型態未填';else if (!dInfo.owner.value) msg = '擁有者未填';else if (!dInfo.ein) msg = '統一編號未填';else if (this.checkEin) msg = '統一編號格式錯誤';else if (!dInfo.contact_name) msg = '窗口名稱未填';else if (!dInfo.contact_phone) msg = '窗口電話未填';else if (!dInfo.contact_email) msg = '窗口email未填';
      this.getToast(msg);
    },
    setInfo: function setInfo() {
      var self = this;
      this.designated = {
        owner: this.ownerTypeOptions.find(function (ot) {
          return ot.value === self.info.owner;
        }),
        unit: this.info.unit,
        branch: this.info.branch,
        tel: this.info.tel,
        address: this.info.address,
        type: this.typeOption.find(function (t) {
          return t.value === self.info.type;
        }),
        ein: this.info.ein,
        contact_name: this.info.contact_name,
        contact_phone: this.info.contact_phone,
        contact_email: this.info.contact_email
      };
      this.brandBrief.find(function (brand) {
        if (brand.value === self.info.brand_id) self.brandSelect = brand;
      });
      this.addStoresSetting.options.find(function (store) {
        if (store.value === self.info.store_id) self.storeSelect = store;
      });
      this.setInfoTimes++;
    },
    getToast: function getToast(msg) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else this.setData();
    },
    setData: function setData() {
      var dInfo = this.designated;
      var data = {
        owner: dInfo.owner.value,
        unit: dInfo.unit,
        branch: dInfo.branch,
        tel: dInfo.tel,
        address: dInfo.address,
        type: dInfo.type.value,
        ein: dInfo.ein,
        contact_name: dInfo.contact_name,
        contact_phone: dInfo.contact_phone,
        contact_email: dInfo.contact_email
      };
      if (this.storeSelect.value) data.store_id = this.storeSelect.value;
      if (this.up) {
        this.upDesignated(data);
      } else {
        this.crDesignated(data);
      }
    },
    upDesignated: function upDesignated(data) {},
    crDesignated: function crDesignated(data) {
      var self = this;
      var url = '/brand/' + this.brandSelect.value + '/designatedUnit';
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.replace('/designatedTable');
        }
      });
    },
    setStore: function setStore() {
      var self = this;
      var brands = this.info.attend_stores;
      if (brands.length) {
        brands.forEach(function (brand) {
          brand.store_list.forEach(function (store) {
            self.addStoresSetting.choose.push(store.store_id);
          });
        });
      }
    },
    calculate: function calculate(product) {
      var ones = product % 10;
      var tens = (product - ones) / 10;
      return ones + tens;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getRoleType']), {
    checkEin: function checkEin() {
      var ein = this.designated.ein;
      var einN = [];
      var validateOperator = [1, 2, 1, 2, 1, 2, 4, 1];
      if (this.designated.ein) {
        if (ein.length === 8) {
          for (var i = 0; i < ein.length; i++) {
            einN.push(parseInt(ein[i], 10));
          }
          var sum = 0;
          for (var j = 0; j < validateOperator.length; j++) {
            sum += this.calculate(einN[j] * validateOperator[j]);
          }
          if (sum % 10 === 0) {
            return false;
          } else {
            if (einN[6] === 7 && (sum + 1) % 10 === 0) {
              return false;
            } else {
              return true;
            }
          }
        } else {
          return true;
        }
      } else return false;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    }
  }),
  watch: {
    'info.id': function infoId() {
      if (!this.setInfoTimes) this.setInfo();
    },
    'brandSelect.value': function brandSelectValue() {
      if (this.designated.owner.value !== 2) this.storeSelect = { label: '全部', value: 0 };else this.storeSelect = {};
    },
    'designated.owner.value': function designatedOwnerValue() {
      var isAll = this.addStoresSetting.options.find(function (store) {
        return store.value === 0;
      });
      if (this.designated.owner.value === 2) {
        if (isAll) this.addStoresSetting.options.splice(0, 1);
        if (this.storeSelect.value === 0) this.storeSelect = {};
      } else {
        if (typeof isAll === 'undefined') this.addStoresSetting.options.splice(0, 0, { label: '全部', value: 0 });
      }
    }
  }
});

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_designatedForm_vue__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_designatedForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_designatedForm_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'designated-form': __WEBPACK_IMPORTED_MODULE_0__Temp_designatedForm_vue___default.a
  },
  data: function data() {
    return {
      info: {
        attend_stores: [],
        give_coupons: [],
        strategy_data: {},
        info: {}
      }
    };
  },

  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    }
  },
  created: function created() {
    if (this.$route.name === 'upDesignated') this.getDesignated();
  },

  methods: {
    getDesignated: function getDesignated() {
      var self = this;
      var url = 'brand/' + this.$route.params.brand_id + '/designatedUnit/' + this.$route.params.unit_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.info = response.data.unit;
        }
      });
    }
  }
});

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      activityMethod: 1,
      list: [{
        title: '指定商品X份折Y元',
        desciption: '範例 : 買「綠茶」2杯，可折5元',
        color: 'warning',
        link: 'SD00002'
      }, {
        title: '買X份商品送Y份商品',
        desciption: '範例 : 買5杯送1杯(滿6杯贈送最低價那杯)',
        color: 'danger',
        link: 'SD00003'
      }, {
        title: '訂單打X折',
        desciption: '範例 : 訂單打8折',
        color: 'success',
        link: 'SD00004'
      }, {
        title: '買X份商品折Y元',
        desciption: '範例 : 買5份商品折20元',
        color: 'primary',
        link: 'SD00005'
      }]
    };
  },

  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  }
});

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_DiscountForm_vue__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_DiscountForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_DiscountForm_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'discount-form': __WEBPACK_IMPORTED_MODULE_0__Temp_DiscountForm_vue___default.a
  },
  data: function data() {
    return {
      activityMethod: 1
    };
  },

  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    }
  }
});

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_DiscountInfo_vue__ = __webpack_require__(2151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_DiscountInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_DiscountInfo_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'discount-info': __WEBPACK_IMPORTED_MODULE_0__Temp_DiscountInfo_vue___default.a
  },
  data: function data() {
    return {
      isUp: true
    };
  },

  methods: {},
  created: function created() {},

  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    }
  }
});

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_shared_token_js__ = __webpack_require__(21);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      roleType: 0,
      brandBrief: [],
      storeBrief: [],
      brandSelect: {
        label: '== 品牌 ==',
        value: 999999
      },
      storeSelect: {
        label: '== 門市 ==',
        value: 999999
      },
      ruleCodeSelect: 999999,
      timeMethodSelect: 999999,
      isEnableSelect: 999999,
      discountList: [],
      total: 1,
      count: 20,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      current: {
        store_list: [],
        name: ''
      },
      preSortMethod: [],
      sortToggle: false,
      sortMethod: '',
      isLoading: true,
      ruleCode: [{
        name: '買X送一依金額個位數取固定折抵規則',
        rule_code: 'SD00001'
      }, {
        name: '買指定商品買X份可折Y元',
        rule_code: 'SD00002'
      }, {
        name: '買X送Y依消費商品最低價折抵規則',
        rule_code: 'SD00003'
      }, {
        name: '全品項折扣規則',
        rule_code: 'SD00004'
      }, {
        name: '購買X數量滿額可折Y元折抵規則',
        rule_code: 'SD00005'
      }]
    };
  },
  mounted: function mounted() {},

  methods: {
    canEdit: function canEdit(discount) {
      var list = this.ruleCode.map(function (item) {
        return item.rule_code;
      });
      return list.includes(discount.rule_code);
    },
    checkSort: function checkSort(method) {
      this.sortMethod = method;
      if (this.preSortMethod.length) {
        if (method === this.preSortMethod[0]) this.sortToggle = !this.sortToggle;else {
          this.tableIndex = 1;
          this.sortToggle = false;
        }
        this.preSortMethod.splice(0, 1);
      } else this.sortToggle = false;
      this.preSortMethod.push(method);
      this.getAttendDiscount();
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            if (!bList[i].is_visible) obj.label = obj.label + ' (測)';
            self.brandBrief.push(obj);
            if (i === 0) self.brandSelect = obj;
          }
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      this.storeBrief = [{ label: '==門市==', value: 999999 }];
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
            if (i === 0 && self.getRoleType === 10) {
              self.storeSelect = obj;
            } else if (i === 0) self.storeSelect.value = 999999;
          }
          if (!sList.length) {
            self.discountList = [];
            self.total = 0;
          }
          self.getAttendDiscount();
        }
      });
    },
    getAttendDiscount: function getAttendDiscount() {
      this.isLoading = true;
      var self = this;
      var url = '/discount/listForAttend?page=' + this.tableIndex + '&size=' + this.count + '&attend_brand_id=' + this.brandSelect.value;
      if (this.storeSelect.value !== 999999) url = url + '&attend_store_id=' + this.storeSelect.value;
      if (this.ruleCodeSelect !== 999999) url = url + '&rule_code=' + this.ruleCodeSelect;
      if (this.timeMethodSelect !== 999999) url = url + '&time_method=' + this.timeMethodSelect;
      if (this.isEnableSelect !== 999999) url = url + '&is_enable=' + this.isEnableSelect;
      if (this.sortMethod) {
        url = url + '&list_sort=' + this.sortMethod + ' ';
        if (this.sortToggle) url = url + 'ASC';else url = url + 'DESC';
      }
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.discountList = response.data.list;
          self.total = response.data.list_total;
          self.isLoading = false;
        }
      });
    },
    clickCurrent: function clickCurrent(menu) {
      this.current = menu;
    },
    clickGroup: function clickGroup(type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1;
        this.tableIndex = this.groupAmount * this.pageGroup;
        this.clickPage(this.tableIndex);
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1;
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1;
        this.clickPage(this.tableIndex);
      }
    },
    clickEnd: function clickEnd(type) {
      if (type === 'pre') {
        this.clickPage(1);
        this.pageGroup = 1;
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount);else this.clickPage(1);
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount);
      }
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      if (index === 1) this.pageGroup = 1;
      this.getAttendDiscount();
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    goto: function goto() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__assets_js_shared_token_js__["c" /* setSharedToken */])(window.localStorage.getItem(this.$config.token));
      window.location.href = this.$config.bdms + 'promotions/discount';
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  }),
  created: function created() {
    this.roleType = parseInt(this.getRoleType, 10);
    this.fixedH();
    this.getBrandBrief();
  },

  watch: {
    'brandSelect.value': function brandSelectValue() {
      this.storeSelect = {
        value: 999999,
        label: '== 門市 =='
      };
      this.getStoreBrief(this.brandSelect.value);
    },
    'storeSelect.value': function storeSelectValue() {
      this.getAttendDiscount();
    }
  }
});

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MenuDiscountTemp_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MenuDiscountTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MenuDiscountTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['isUp'],
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default.a,
    'menu-discount': __WEBPACK_IMPORTED_MODULE_2__MenuDiscountTemp_vue___default.a
  },
  data: function data() {
    return {
      setInfoTimes: 0,
      info: {
        info: {}
      },
      reNew: 0,
      reSet: 0,
      ruleCode: 'SD00002',
      brandSelect: {
        label: '',
        value: ''
      },
      menuSelect: {
        label: '',
        value: 0
      },

      ownerTypeOptions: [{ label: '品牌', value: 2 }, { label: '門市', value: 3 }, { label: '平台', value: 1 }],
      enableOptions: [{ label: '啟用', value: 1 }, { label: '停用', value: 0 }],
      timeTypeOption: [{ label: '全時段', value: 1 }, { label: '指定時段', value: 2 }],
      orderType: [{ label: '一般單', value: 1 }, { label: '團購單', value: 2 }],
      orderMethod: [{ label: '當日單', value: 1 }, { label: '預訂單', value: 2 }],
      deliveryType: [{ label: '自取', value: 1 }, { label: '內用', value: 2 }, { label: '外送', value: 3 }, { label: '內用-桌邊掃碼', value: 21 }],
      tradeType: [],
      menuList: [],
      addStoresSetting: {
        class: 'buy-add-store',
        options: [],
        choose: []
      },
      priceType: [{ label: '免稅', value: 1 }, { label: '未稅', value: 2 }, { label: '含稅', value: 3 }],
      couponSetting: [{ label: '依訂單購買商品數設定', value: 'SC00001' }, { label: '依個人訂單消費特定商品數', value: 'SC00002' }, { label: '依個人訂單購買金額', value: 'SC00003' }],
      useType: [{ label: '品牌型', value: 2 }, { label: '門市型', value: 3 }],
      usageValue: [],
      brandList: [],
      content: {
        bindingStoreList: [],
        bindingBrandList: [],
        bindingProdList: []
      },
      brandDefault: '',
      brandBrief: [],
      storeBrief: [],
      scheduleTime: '',
      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: ''
        }
      },
      show: {
        back: false
      },
      tableIndex: 1,
      count: 20,
      menuId: 0,
      menuName: '',
      storeId: 0,
      startTime: {
        time: ''
      },
      endtime: {
        time: ''
      },
      timeoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      startLimit: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_6_moment___default()().add(-1, 'days').format('YYYY-MM-DD')
      }],
      endLimit: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_6_moment___default()().add(-1, 'days').format('YYYY-MM-DD')
      }],
      offdaySetting: {
        date: [],
        weekDay: [],
        monthDay: [],
        options: {
          date: [],
          weekDay: [{ label: '週日', value: 1 }, { label: '週一', value: 2 }, { label: '週二', value: 3 }, { label: '週三', value: 4 }, { label: '週四', value: 5 }, { label: '週五', value: 6 }, { label: '週六', value: 7 }],
          month: [{ label: '一月', value: 1 }, { label: '二月', value: 2 }, { label: '三月', value: 3 }, { label: '四月', value: 4 }, { label: '五月', value: 5 }, { label: '六月', value: 6 }, { label: '七月', value: 7 }, { label: '八月', value: 8 }, { label: '九月', value: 9 }, { label: '十月', value: 10 }, { label: '十一月', value: 11 }, { label: '十二月', value: 12 }],
          monthDay: []
        }
      },
      timeSettingList: [{ value_type: 0, start_value: 0, end_value: 0, time_type: 1, time_interval: [] }],
      activity: {
        name: '',
        description: '',
        rule_code: 'SD00002',
        start_date: '',
        end_date: '',
        is_enable: { label: '啟用', value: 1 },
        owner_type: { label: '品牌', value: 2 },
        owner_id: 0,
        aTime: {
          type: null,
          start: { time: '' },
          end: { time: '' }
        },
        is_platform_visible: { label: '啟用', value: 1 },
        dedicated_visible_setting: { label: '停用', value: 0 },
        time_setting: [],
        store_ids: [],
        strategy_data: {
          limit: {
            delivery_types: [],
            order_types: [],
            trade_types: [],
            order_methods: [],
            min_product_money: '',
            min_product_amount: '',
            min_sub_order_amount: ''
          },
          setting: {
            one_max_discount: '',
            product_info: [],

            amount_unit: '',

            lowest_unit_price: 0,
            ratio: '',
            exception_products: [],

            percent_value: '',
            ignore_allowance: { label: '不忽略折讓(A+B)金額，商品總額扣除折讓計算', value: 0 },
            round_policy: { label: '小數四折五入', value: 'round' },

            discount_unit: ''
          },

          store_exception_items: [{
            products: [],
            store_ids: []
          }]
        }
      },
      productBrief: [],
      productChoseBrief: [],
      nowTime: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD HH:mm'),
      storeList: [],
      storeSelect: { label: '', value: '' },
      delOption: {
        id: 'delModal',
        title: '刪除折扣活動',
        body: '刪除折扣活動，將活動標註為刪除',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delDiscount'
        }]
      },
      storeClassList: [],
      curId: 0,
      storeProdList: [],
      curVCID: '',
      ignoreAllowance: [{ label: '不忽略折讓(A+B)金額，商品總額扣除折讓計算', value: 0 }, { label: '忽略折讓(A+B)金額，商品總額不扣除折讓計算', value: 1 }],
      roundPolicy: [{ label: '小數四折五入', value: 'round' }, { label: '小數無條件捨去', value: 'floor' }, { label: '小數無條件進位', value: 'ceil' }]
    };
  },
  created: function created() {
    if (this.$route.query.rule_code) {
      this.activity.rule_code = this.$route.query.rule_code;
      this.ruleCode = this.$route.query.rule_code;
    }
    this.getBrandBrief();
    this.getTradeTypeList();

    if (this.getRoleType === 10) {
      this.useType = [{ label: '品牌型', value: 2 }, { label: '門市型', value: 3 }];
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapActions */])(['setMenuStartTime', 'setMenuEndTime']), {
    getStoreProd: function getStoreProd(prod) {
      this.curVCID = prod.vendor_custom_id;
      var self = this;
      var vcId = prod.vendor_custom_id;
      var url = '/discount/' + this.$route.params.activity_id + '/storeOnlineProduct?vendor_custom_id=' + vcId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.storeProdList = response.data.list;
        }
      });
    },
    getStoreClassList: function getStoreClassList(brandId) {
      var self = this;
      var url = '/brand/' + brandId + '/storeClassList';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          self.storeClassList = sList;
        }
      });
    },
    clickOption: function clickOption(option) {
      var self = this;
      this.addStoresSetting.options = [];
      self.curId = option.id;
      if (self.curId) {
        self.$nextTick(function () {
          self.reSet++;
          self.addStoresSetting.options = self.storeBrief;
          self.getCurStoreClass();
        });
      }
    },
    getCurStoreClass: function getCurStoreClass() {
      this.addStoresSetting.choose = [];
      var self = this;
      var url = '/brand/' + this.brandSelect.value + '/storeClass/' + this.curId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var classInfo = response.data.class;
          classInfo.store_list.forEach(function (s) {
            self.addStoresSetting.choose.push(s.id);
          });
        }
      });
    },
    trigger: function trigger(event) {
      if (event === 'delDiscount') {
        this.delDiscount();
      }
    },
    delDiscount: function delDiscount() {
      var self = this;
      var url = '/discount/' + this.$route.params.activity_id;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.replace('/upDiscountList');
        }
      });
    },
    returnNum: function returnNum(e) {
      var charCode = e.which ? e.which : e.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        e.preventDefault();
      } else {
        return true;
      }
    },
    addProdToList: function addProdToList(addPInfo) {
      var self = this;
      var pInfo = this.activity.strategy_data.setting.product_info;
      addPInfo.forEach(function (addP) {
        var isSame = pInfo.find(function (prod) {
          return addP.vendor_custom_id === prod.vendor_custom_id;
        });
        if (!isSame) pInfo.push(addP);else {
          self.$notify({
            title: '提醒',
            text: addP.product_name + '已加入過',
            duration: 3000,
            width: 400
          });
        }
      });
    },
    addExProdToList: function addExProdToList(addPInfo) {
      var self = this;
      var pInfo = this.activity.strategy_data.store_exception_items[0].products;
      addPInfo.forEach(function (addP) {
        var isSame = pInfo.find(function (prod) {
          return addP.vendor_custom_id === prod.vendor_custom_id;
        });
        if (!isSame) {
          pInfo.push(addP);
        } else {
          self.$notify({
            title: '提醒',
            text: addP.product_name + '已加入過',
            duration: 3000,
            width: 400
          });
        }
      });
    },
    addExProdToList3: function addExProdToList3(addPInfo) {
      var self = this;
      var pInfo = this.activity.strategy_data.setting.exception_products;
      addPInfo.forEach(function (addP) {
        var isSame = pInfo.find(function (prod) {
          return addP.vendor_custom_id === prod.vendor_custom_id;
        });
        if (!isSame) pInfo.push(addP);else {
          self.$notify({
            title: '提醒',
            text: addP.product_name + '已加入過',
            duration: 3000,
            width: 400
          });
        }
      });
    },
    sameItem: function sameItem(list, index) {
      var getAmount = list[index].amount_unit;
      var getDiscount = list[index].discount;
      list.forEach(function (o) {
        o.amount_unit = getAmount;
        o.discount = getDiscount;
      });
    },
    removeListItem: function removeListItem(list, index) {
      list.splice(index, 1);
    },
    clearProcess: function clearProcess(process) {
      process.end_value = '';
      process.start_value = '';
    },
    changeTimeType: function changeTimeType(process) {
      if (process.time_type === 2) {
        var item = {
          start_time: '',
          end_time: ''
        };
        if (!process.time_interval.length) process.time_interval.push(item);
      } else {
        process.time_interval = [];
      }
    },
    addProcessTime: function addProcessTime() {
      var timeSetting = { value_type: 0, start_value: 0, end_value: 0, time_type: 1, time_interval: [] };
      this.timeSettingList.push(timeSetting);
    },
    addChooseTag: function addChooseTag(newTag) {
      var tag = {
        name: newTag,
        id: ''
      };
      this.productChoseBrief.push(tag);
      this.activity.setting.vendorCustomProductList.push(tag);
    },
    addItemTime: function addItemTime(process) {
      var item = {
        start_time: '',
        end_time: ''
      };
      process.time_interval.push(item);
    },
    addStartMonthDayTag: function addStartMonthDayTag(newTag, id) {
      var tag = {
        label: newTag,
        value: newTag
      };
      this.offdaySetting.options.monthDay.push(tag);
    },
    addEndMonthDayTag: function addEndMonthDayTag(newTag, id) {
      var tag = {
        label: newTag,
        value: newTag
      };
      this.offdaySetting.options.monthDay.push(tag);
    },
    getStoreBrief: function getStoreBrief(brandId) {
      this.storeBrief = [];
      this.addStoresSetting.options = [];
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
            self.addStoresSetting.options.push(obj);
          }
          if (self.$route.name.indexOf('up') > -1 && !self.setInfoTimes) self.getDiscountInfo();else if (self.info.info.activity_id && self.setInfoTimes === 1) self.setStore();
          self.reNew++;
        }
      });
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            self.brandBrief.push(obj);
            if (i === 0) self.brandSelect = obj;
          }
        }
      });
    },
    getDiscountInfo: function getDiscountInfo() {
      var self = this;
      var url = '/discount/' + this.$route.params.activity_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.info = response.data;
          self.setInfo();
        }
      });
    },
    setStore: function setStore() {
      var self = this;
      var stores = this.info.attend_stores;

      if (stores.length) {
        stores[0].store_list.forEach(function (store) {
          self.addStoresSetting.choose.push(store.store_id);
        });
      }
    },
    setInfo: function setInfo() {
      this.setInfoTimes++;
      var a = this.activity;
      var i = this.info.info;
      var times = this.info.time_setting;
      var strategy = this.info.strategy_data[0];
      var stores = this.info.attend_stores;
      var self = this;
      a.name = i.name;
      a.description = i.description;
      a.rule_code = this.ruleCode = i.rule_code;

      a.aTime.type = i.time_src_type;
      a.aTime.start.time = i.start_date;
      a.aTime.end.time = i.end_date;
      a.is_enable = this.enableOptions.find(function (o) {
        return o.value === i.is_enable;
      });
      a.is_platform_visible = this.enableOptions.find(function (o) {
        return o.value === i.is_platform_visible;
      });
      if (i.dedicated_visible_setting.length > 0) {
        a.dedicated_visible_setting = this.enableOptions.find(function (o) {
          return o.value === i.dedicated_visible_setting[0];
        });
      }
      a.owner_type = this.ownerTypeOptions.find(function (o) {
        return o.value === i.owner_type;
      });
      this.brandSelect = this.brandBrief.find(function (o) {
        return o.value === stores[0].brand_id;
      });
      if (this.brandSelect.value === this.brandBrief[0].value) this.setStore();
      this.timeSettingList = [];
      times.forEach(function (time) {
        var option = {};
        if (time.value_type === 2) {
          option = {
            end_value: self.offdaySetting.options.weekDay.find(function (wd) {
              return wd.value === time.end_value;
            }),
            start_value: self.offdaySetting.options.weekDay.find(function (wd) {
              return wd.value === time.start_value;
            }),
            time_type: time.time_type,
            value_type: time.value_type,
            time_interval: time.time_interval
          };
          self.timeSettingList.push(option);
        } else {
          option = {
            end_value: time.end_value,
            start_value: time.start_value,
            time_type: time.time_type,
            value_type: time.value_type,
            time_interval: time.time_interval
          };
          self.timeSettingList.push(option);
        }
      });
      if (a.rule_code === 'SD00001') {
        var iLimit = strategy.limit;
        var aLimit = a.strategy_data.limit;

        if (iLimit.delivery_types) {
          iLimit.delivery_types.forEach(function (dType) {
            aLimit.delivery_types.push(self.deliveryType.find(function (o) {
              return o.value === dType;
            }));
          });
        }
        if (iLimit.order_types) {
          iLimit.order_types.forEach(function (oType) {
            aLimit.order_types.push(self.orderType.find(function (o) {
              return o.value === oType;
            }));
          });
        }
        if (iLimit.trade_types) {
          iLimit.trade_types.forEach(function (tType) {
            aLimit.trade_types.push(self.tradeType.find(function (o) {
              return o.value === tType;
            }));
          });
        }
        if (iLimit.order_methods) {
          iLimit.order_methods.forEach(function (oMethod) {
            aLimit.order_methods.push(self.orderMethod.find(function (o) {
              return o.value === oMethod;
            }));
          });
        }
        if (iLimit.min_product_money) aLimit.min_product_money = iLimit.min_product_money;
        if (iLimit.min_product_amount) aLimit.min_product_amount = iLimit.min_product_amount;
        if (iLimit.min_sub_order_amount) aLimit.min_sub_order_amount = iLimit.min_sub_order_amount;

        if (strategy.setting.amount_unit) a.strategy_data.setting.amount_unit = strategy.setting.amount_unit;
        if (strategy.store_exception_items.length) {
          a.strategy_data.store_exception_items = strategy.store_exception_items;
          a.strategy_data.store_exception_items[0].products.forEach(function (prod) {
            self.$set(prod, 'product_name', prod.name);
          });
        }
      } else if (a.rule_code === 'SD00002') {
        var _iLimit = strategy.limit;
        var _aLimit = a.strategy_data.limit;

        if (_iLimit.delivery_types) {
          _iLimit.delivery_types.forEach(function (dType) {
            _aLimit.delivery_types.push(self.deliveryType.find(function (o) {
              return o.value === dType;
            }));
          });
        }
        if (_iLimit.order_types) {
          _iLimit.order_types.forEach(function (oType) {
            _aLimit.order_types.push(self.orderType.find(function (o) {
              return o.value === oType;
            }));
          });
        }
        if (_iLimit.trade_types) {
          _iLimit.trade_types.forEach(function (tType) {
            _aLimit.trade_types.push(self.tradeType.find(function (o) {
              return o.value === tType;
            }));
          });
        }
        if (_iLimit.order_methods) {
          _iLimit.order_methods.forEach(function (oMethod) {
            _aLimit.order_methods.push(self.orderMethod.find(function (o) {
              return o.value === oMethod;
            }));
          });
        }
        if (_iLimit.min_product_money) _aLimit.min_product_money = _iLimit.min_product_money;
        if (_iLimit.min_product_amount) _aLimit.min_product_amount = _iLimit.min_product_amount;
        if (_iLimit.min_sub_order_amount) _aLimit.min_sub_order_amount = _iLimit.min_sub_order_amount;

        if (strategy.setting.one_max_discount) a.strategy_data.setting.one_max_discount = strategy.setting.one_max_discount;
        a.strategy_data.setting.product_info = strategy.setting.product_info;
      } else if (a.rule_code === 'SD00004') {
        var _iLimit2 = strategy.limit;
        var _aLimit2 = a.strategy_data.limit;

        if (_iLimit2.delivery_types) {
          _iLimit2.delivery_types.forEach(function (dType) {
            _aLimit2.delivery_types.push(self.deliveryType.find(function (o) {
              return o.value === dType;
            }));
          });
        }
        if (_iLimit2.order_types) {
          _iLimit2.order_types.forEach(function (oType) {
            _aLimit2.order_types.push(self.orderType.find(function (o) {
              return o.value === oType;
            }));
          });
        }
        if (_iLimit2.trade_types) {
          _iLimit2.trade_types.forEach(function (tType) {
            _aLimit2.trade_types.push(self.tradeType.find(function (o) {
              return o.value === tType;
            }));
          });
        }
        if (_iLimit2.order_methods) {
          _iLimit2.order_methods.forEach(function (oMethod) {
            _aLimit2.order_methods.push(self.orderMethod.find(function (o) {
              return o.value === oMethod;
            }));
          });
        }
        if (_iLimit2.min_product_money) _aLimit2.min_product_money = _iLimit2.min_product_money;
        if (_iLimit2.min_product_amount) _aLimit2.min_product_amount = _iLimit2.min_product_amount;
        if (_iLimit2.min_sub_order_amount) _aLimit2.min_sub_order_amount = _iLimit2.min_sub_order_amount;

        console.log(strategy.setting);
        if (strategy.setting.percent_value) a.strategy_data.setting.percent_value = strategy.setting.percent_value;
        if (strategy.setting.ignore_allowance !== '') {
          a.strategy_data.setting.ignore_allowance = this.ignoreAllowance.find(function (option) {
            return option.value === strategy.setting.ignore_allowance;
          });
        }
        if (strategy.setting.round_policy) {
          a.strategy_data.setting.round_policy = this.roundPolicy.find(function (option) {
            return option.value === strategy.setting.round_policy;
          });
        }
        if (strategy.store_exception_items.length) {
          a.strategy_data.store_exception_items = strategy.store_exception_items;
          a.strategy_data.store_exception_items[0].products.forEach(function (prod) {
            self.$set(prod, 'product_name', prod.name);
          });
        }
      } else if (a.rule_code === 'SD00005') {
        var _iLimit3 = strategy.limit;
        var _aLimit3 = a.strategy_data.limit;

        if (_iLimit3.delivery_types) {
          _iLimit3.delivery_types.forEach(function (dType) {
            _aLimit3.delivery_types.push(self.deliveryType.find(function (o) {
              return o.value === dType;
            }));
          });
        }
        if (_iLimit3.order_types) {
          _iLimit3.order_types.forEach(function (oType) {
            _aLimit3.order_types.push(self.orderType.find(function (o) {
              return o.value === oType;
            }));
          });
        }
        if (_iLimit3.trade_types) {
          _iLimit3.trade_types.forEach(function (tType) {
            _aLimit3.trade_types.push(self.tradeType.find(function (o) {
              return o.value === tType;
            }));
          });
        }
        if (_iLimit3.order_methods) {
          _iLimit3.order_methods.forEach(function (oMethod) {
            _aLimit3.order_methods.push(self.orderMethod.find(function (o) {
              return o.value === oMethod;
            }));
          });
        }
        if (_iLimit3.min_product_money) _aLimit3.min_product_money = _iLimit3.min_product_money;
        if (_iLimit3.min_product_amount) _aLimit3.min_product_amount = _iLimit3.min_product_amount;
        if (_iLimit3.min_sub_order_amount) _aLimit3.min_sub_order_amount = _iLimit3.min_sub_order_amount;

        console.log(strategy.setting);
        if (strategy.setting.amount_unit) a.strategy_data.setting.amount_unit = strategy.setting.amount_unit;
        if (strategy.setting.lowest_unit_price) a.strategy_data.setting.lowest_unit_price = strategy.setting.lowest_unit_price;
        if (strategy.setting.discount_unit) a.strategy_data.setting.discount_unit = strategy.setting.discount_unit;

        if (strategy.store_exception_items.length) {
          a.strategy_data.store_exception_items = strategy.store_exception_items;
          a.strategy_data.store_exception_items[0].products.forEach(function (prod) {
            self.$set(prod, 'product_name', prod.name);
          });
        }
      } else if (a.rule_code === 'SD00003') {
        var _iLimit4 = strategy.limit;
        var _aLimit4 = a.strategy_data.limit;

        if (_iLimit4.delivery_types) {
          _iLimit4.delivery_types.forEach(function (dType) {
            _aLimit4.delivery_types.push(self.deliveryType.find(function (o) {
              return o.value === dType;
            }));
          });
        }
        if (_iLimit4.order_types) {
          _iLimit4.order_types.forEach(function (oType) {
            _aLimit4.order_types.push(self.orderType.find(function (o) {
              return o.value === oType;
            }));
          });
        }
        if (_iLimit4.trade_types) {
          _iLimit4.trade_types.forEach(function (tType) {
            _aLimit4.trade_types.push(self.tradeType.find(function (o) {
              return o.value === tType;
            }));
          });
        }
        if (_iLimit4.order_methods) {
          _iLimit4.order_methods.forEach(function (oMethod) {
            _aLimit4.order_methods.push(self.orderMethod.find(function (o) {
              return o.value === oMethod;
            }));
          });
        }
        if (_iLimit4.min_product_money) _aLimit4.min_product_money = _iLimit4.min_product_money;
        if (_iLimit4.min_product_amount) _aLimit4.min_product_amount = _iLimit4.min_product_amount;
        if (_iLimit4.min_sub_order_amount) _aLimit4.min_sub_order_amount = _iLimit4.min_sub_order_amount;

        if (strategy.setting.amount_unit) a.strategy_data.setting.amount_unit = strategy.setting.amount_unit;
        if (strategy.setting.lowest_unit_price) a.strategy_data.setting.lowest_unit_price = strategy.setting.lowest_unit_price;
        if (strategy.setting.ratio) a.strategy_data.setting.ratio = strategy.setting.ratio;
        if (strategy.setting.exception_products.length) {
          a.strategy_data.setting.exception_products = strategy.setting.exception_products;
          strategy.setting.exception_products.forEach(function (prod, pIndex) {
            self.$set(a.strategy_data.setting.exception_products[pIndex], 'product_name', prod.name);
          });
        }
      }
    },
    getTradeTypeList: function getTradeTypeList() {
      var self = this;
      var url = '/platform/tradeTypeList';
      this.getData('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.tradeInfo = [];
          var list = response.data.list;
          for (var i = 0; i < list.length; i++) {
            if (list[i].is_valid && list[i].is_enable) {
              var option = {
                label: list[i].name,
                value: parseInt(list[i].type, 10)
              };
              self.tradeType.push(option);
            }
          }
        }
      });
    },
    checkActivity: function checkActivity() {
      var a = this.activity;
      var sD = a.strategy_data;
      var msg = '';
      if (!a.name) msg = '活動名稱未填';else if (!a.aTime.type) msg = '活動時間類型尚未選擇';else if (!a.aTime.start.time) msg = '活動開始時間未填';else if (!a.aTime.end.time) msg = '活動結束時間未填';else if (!a.owner_type.value) msg = '活動擁有者未選';else if (!a.is_enable) msg = '活動啟用未選';else if (!a.is_platform_visible) msg = '你訂平台啟用未選';else if (!a.dedicated_visible_setting) msg = '街口平台啟用未選';else if (!a.description) msg = '活動描述未填';else if (!this.timeSettingList.length) msg = '折扣生效日未填';else if (!this.addStoresSetting.choose.length) msg = '參與活動店家未選';else if (this.addStoresSetting.choose.length > 1 && a.owner_type === 3) msg = '品牌擁有者只可選擇一家店家';else if (a.rule_code === 'SD00002') {
        if (!sD.setting.product_info.length) msg = '折扣商品選擇未選';else if (sD.setting.product_info.length) {
          sD.setting.product_info.forEach(function (pInfo) {
            if (!pInfo.discount) msg = '折扣商品 - ' + pInfo.product_name + ' 折扣金額未填';
            if (!pInfo.amount_unit) msg = '折扣商品 - ' + pInfo.product_name + ' 折扣購買數量未填';
          });
        }
      } else if (a.rule_code === 'SD00001') {
        if (!sD.setting.amount_unit) msg = '買幾份送一數值未填';
      } else if (a.rule_code === 'SD00003') {
        if (!sD.setting.amount_unit) msg = '買X份送Y，X數值未填';else if (!sD.setting.amount_unit) msg = '買X份送Y，Y數值未填';else if (sD.setting.lowest_unit_price === '') msg = '折抵最低單價未填';
      } else if (a.rule_code === 'SD00004') {
        if (!sD.setting.percent_value) msg = '折扣數值未填';
        if (sD.setting.ignore_allowance.value === '') msg = '是否忽略折讓(A+B)金額未選';
        if (sD.setting.round_policy.value === '') msg = '折扣金額小數點進位方式未選';
      } else if (a.rule_code === 'SD00005') {
        if (!sD.setting.amount_unit) msg = '累積達成數量單位未填';
        if (sD.setting.lowest_unit_price === '') msg = '商品限制最低單價未填';
        if (!sD.setting.discount_unit) msg = '每達到數量贈送的金額未填';
      }

      this.getToast(msg);
    },
    getToast: function getToast(msg) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.setData();
      }
    },
    setData: function setData(type) {
      var act = this.activity;
      var data = {
        name: act.name,
        description: act.description,
        rule_code: act.rule_code,
        time_src_type: act.aTime.type,
        start_date: act.aTime.start.time,
        end_date: act.aTime.end.time,
        is_enable: act.is_enable.value,
        is_platform_visible: act.is_platform_visible.value,
        dedicated_visible_setting: [],
        time_setting: [],
        store_ids: this.addStoresSetting.choose
      };

      if (act.dedicated_visible_setting.value === 1) {
        data.dedicated_visible_setting.push(act.dedicated_visible_setting.value);
      }

      if (!this.info.info.activity_id || this.getRoleType === 99) {
        data.owner_type = act.owner_type.value;
        if (this.getRoleType === 30) data.owner_type = 2;else if (this.getRoleType === 10) data.owner_type = 3;
        data.owner_id = 0;
        if (data.owner_type === 1) data.owner_id = 0;else if (data.owner_type === 2) data.owner_id = this.brandSelect.value;else if (data.owner_type === 3) data.owner_id = data.store_ids[0];
      }

      this.timeSettingList.forEach(function (time) {
        var o = {
          value_type: 0,
          start_value: 0,
          end_value: 0,
          time_type: time.time_type,
          time_interval: time.time_interval
        };
        if (time.value_type) o.value_type = time.value_type;
        if (time.value_type === 2) {
          if (time.start_value.value) o.start_value = time.start_value.value;
          if (time.end_value.value) o.end_value = time.end_value.value;
        } else if (time.value_type === 1) {
          if (time.start_value) o.start_value = time.start_value;
          if (time.end_value) o.end_value = time.end_value;
        }
        data.time_setting.push(o);
      });

      if (!this.info.info.has_used) {
        data.strategy_data = {};
        var aSD = act.strategy_data;
        if (act.rule_code === 'SD00001') {
          data.strategy_data = {
            limit: {},
            setting: {
              amount_unit: aSD.setting.amount_unit
            },
            store_exception_items: []
          };
          var dSD = data.strategy_data;

          if (aSD.limit.delivery_types.length) {
            dSD.limit.delivery_types = [];
            aSD.limit.delivery_types.forEach(function (dType) {
              dSD.limit.delivery_types.push(dType.value);
            });
          }
          if (aSD.limit.order_types.length) {
            dSD.limit.order_types = [];
            aSD.limit.order_types.forEach(function (oType) {
              dSD.limit.order_types.push(oType.value);
            });
          }
          if (aSD.limit.trade_types.length) {
            dSD.limit.trade_types = [];
            aSD.limit.trade_types.forEach(function (tType) {
              dSD.limit.trade_types.push(tType.value);
            });
          }
          if (aSD.limit.order_methods.length) {
            dSD.limit.order_methods = [];
            aSD.limit.order_methods.forEach(function (oMethod) {
              dSD.limit.order_methods.push(oMethod.value);
            });
          }
          if (aSD.limit.min_product_money) dSD.limit.min_product_money = aSD.limit.min_product_money;
          if (aSD.limit.min_product_amount) dSD.limit.min_product_amount = aSD.limit.min_product_amount;
          if (aSD.limit.min_sub_order_amount) dSD.limit.min_sub_order_amount = aSD.limit.min_sub_order_amount;

          if (aSD.store_exception_items[0].products.length) {
            var o = {
              products: [],
              store_ids: this.addStoresSetting.choose
            };
            aSD.store_exception_items[0].products.forEach(function (product) {
              var pO = {
                vendor_custom_id: product.vendor_custom_id,
                name: product.product_name
              };
              o.products.push(pO);
            });
            dSD.store_exception_items = [o];
          }
        } else if (act.rule_code === 'SD00002') {
          data.strategy_data = {
            limit: {},
            setting: {
              one_max_discount: null,
              product_info: aSD.setting.product_info
            }
          };
          var _dSD = data.strategy_data;

          if (aSD.limit.delivery_types.length) {
            _dSD.limit.delivery_types = [];
            aSD.limit.delivery_types.forEach(function (dType) {
              _dSD.limit.delivery_types.push(dType.value);
            });
          }
          if (aSD.limit.order_types.length) {
            _dSD.limit.order_types = [];
            aSD.limit.order_types.forEach(function (oType) {
              _dSD.limit.order_types.push(oType.value);
            });
          }
          if (aSD.limit.trade_types.length) {
            _dSD.limit.trade_types = [];
            aSD.limit.trade_types.forEach(function (tType) {
              _dSD.limit.trade_types.push(tType.value);
            });
          }
          if (aSD.limit.order_methods.length) {
            _dSD.limit.order_methods = [];
            aSD.limit.order_methods.forEach(function (oMethod) {
              _dSD.limit.order_methods.push(oMethod.value);
            });
          }
          if (aSD.limit.min_product_money) _dSD.limit.min_product_money = aSD.limit.min_product_money;
          if (aSD.limit.min_product_amount) _dSD.limit.min_product_amount = aSD.limit.min_product_amount;
          if (aSD.limit.min_sub_order_amount) _dSD.limit.min_sub_order_amount = aSD.limit.min_sub_order_amount;

          if (aSD.setting.one_max_discount) _dSD.setting.one_max_discount = aSD.setting.one_max_discount;
        } else if (act.rule_code === 'SD00003') {
          data.strategy_data = {
            limit: {},
            setting: {
              amount_unit: aSD.setting.amount_unit,
              lowest_unit_price: aSD.setting.lowest_unit_price,
              ratio: aSD.setting.ratio,
              exception_products: []
            }
          };
          var _dSD2 = data.strategy_data;

          if (aSD.limit.delivery_types.length) {
            _dSD2.limit.delivery_types = [];
            aSD.limit.delivery_types.forEach(function (dType) {
              _dSD2.limit.delivery_types.push(dType.value);
            });
          }
          if (aSD.limit.order_types.length) {
            _dSD2.limit.order_types = [];
            aSD.limit.order_types.forEach(function (oType) {
              _dSD2.limit.order_types.push(oType.value);
            });
          }
          if (aSD.limit.trade_types.length) {
            _dSD2.limit.trade_types = [];
            aSD.limit.trade_types.forEach(function (tType) {
              _dSD2.limit.trade_types.push(tType.value);
            });
          }
          if (aSD.limit.order_methods.length) {
            _dSD2.limit.order_methods = [];
            aSD.limit.order_methods.forEach(function (oMethod) {
              _dSD2.limit.order_methods.push(oMethod.value);
            });
          }
          if (aSD.limit.min_product_money) _dSD2.limit.min_product_money = aSD.limit.min_product_money;
          if (aSD.limit.min_product_amount) _dSD2.limit.min_product_amount = aSD.limit.min_product_amount;
          if (aSD.limit.min_sub_order_amount) _dSD2.limit.min_sub_order_amount = aSD.limit.min_sub_order_amount;

          if (aSD.setting.exception_products.length) {
            aSD.setting.exception_products.forEach(function (product) {
              var pO = {
                vendor_custom_id: product.vendor_custom_id,
                name: product.product_name
              };
              _dSD2.setting.exception_products.push(pO);
            });
          }
        } else if (act.rule_code === 'SD00004') {
          data.strategy_data = {
            limit: {},
            setting: {
              percent_value: aSD.setting.percent_value,
              ignore_allowance: aSD.setting.ignore_allowance.value,
              round_policy: aSD.setting.round_policy.value
            },
            store_exception_items: []
          };
          var _dSD3 = data.strategy_data;

          if (aSD.limit.delivery_types.length) {
            _dSD3.limit.delivery_types = [];
            aSD.limit.delivery_types.forEach(function (dType) {
              _dSD3.limit.delivery_types.push(dType.value);
            });
          }
          if (aSD.limit.order_types.length) {
            _dSD3.limit.order_types = [];
            aSD.limit.order_types.forEach(function (oType) {
              _dSD3.limit.order_types.push(oType.value);
            });
          }
          if (aSD.limit.trade_types.length) {
            _dSD3.limit.trade_types = [];
            aSD.limit.trade_types.forEach(function (tType) {
              _dSD3.limit.trade_types.push(tType.value);
            });
          }
          if (aSD.limit.order_methods.length) {
            _dSD3.limit.order_methods = [];
            aSD.limit.order_methods.forEach(function (oMethod) {
              _dSD3.limit.order_methods.push(oMethod.value);
            });
          }
          if (aSD.limit.min_product_money) _dSD3.limit.min_product_money = aSD.limit.min_product_money;
          if (aSD.limit.min_product_amount) _dSD3.limit.min_product_amount = aSD.limit.min_product_amount;
          if (aSD.limit.min_sub_order_amount) _dSD3.limit.min_sub_order_amount = aSD.limit.min_sub_order_amount;

          if (aSD.store_exception_items[0].products.length) {
            var _o = {
              products: [],
              store_ids: this.addStoresSetting.choose
            };
            aSD.store_exception_items[0].products.forEach(function (product) {
              var pO = {
                vendor_custom_id: product.vendor_custom_id,
                name: product.product_name
              };
              _o.products.push(pO);
            });
            _dSD3.store_exception_items = [_o];
          }
        } else if (act.rule_code === 'SD00005') {
          data.strategy_data = {
            limit: {},
            setting: {
              amount_unit: aSD.setting.amount_unit,
              lowest_unit_price: aSD.setting.lowest_unit_price,
              discount_unit: aSD.setting.discount_unit
            },
            store_exception_items: []
          };
          var _dSD4 = data.strategy_data;

          if (aSD.limit.delivery_types.length) {
            _dSD4.limit.delivery_types = [];
            aSD.limit.delivery_types.forEach(function (dType) {
              _dSD4.limit.delivery_types.push(dType.value);
            });
          }
          if (aSD.limit.order_types.length) {
            _dSD4.limit.order_types = [];
            aSD.limit.order_types.forEach(function (oType) {
              _dSD4.limit.order_types.push(oType.value);
            });
          }
          if (aSD.limit.trade_types.length) {
            _dSD4.limit.trade_types = [];
            aSD.limit.trade_types.forEach(function (tType) {
              _dSD4.limit.trade_types.push(tType.value);
            });
          }
          if (aSD.limit.order_methods.length) {
            _dSD4.limit.order_methods = [];
            aSD.limit.order_methods.forEach(function (oMethod) {
              _dSD4.limit.order_methods.push(oMethod.value);
            });
          }
          if (aSD.limit.min_product_money) _dSD4.limit.min_product_money = aSD.limit.min_product_money;
          if (aSD.limit.min_product_amount) _dSD4.limit.min_product_amount = aSD.limit.min_product_amount;
          if (aSD.limit.min_sub_order_amount) _dSD4.limit.min_sub_order_amount = aSD.limit.min_sub_order_amount;

          if (aSD.store_exception_items[0].products.length) {
            var _o2 = {
              products: [],
              store_ids: this.addStoresSetting.choose
            };
            aSD.store_exception_items[0].products.forEach(function (product) {
              var pO = {
                vendor_custom_id: product.vendor_custom_id,
                name: product.product_name
              };
              _o2.products.push(pO);
            });
            _dSD4.store_exception_items = [_o2];
          }
        }
      }

      if (this.info.info.activity_id) this.upDiscount(data);else this.crDiscount(data);
    },
    crDiscount: function crDiscount(data) {
      var self = this;
      var url = '/discount';
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.replace('/upDiscountList');
        }
      });
    },
    upDiscount: function upDiscount(data) {
      var self = this;
      var url = '/discount/' + this.$route.params.activity_id;
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });

          self.$router.go(-1);
        }
      });
    },
    getOnlineMenu: function getOnlineMenu() {
      var self = this;
      self.menuList = [];
      var url = '/onlineMenu/list?page=' + this.tableIndex + '&size=' + this.count + '&brand_id=' + this.brandSelect.value + '&store_id=' + this.storeSelect.value;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var mList = response.data.menu_list;
          mList.forEach(function (menu, index) {
            var option = { label: menu.name, value: menu.id };
            self.menuList.push(option);
            if (index === 0) self.menuSelect = option;
          });
          if (!mList.length) self.menuSelect = { label: '', value: '' };
        }
      });
    },
    getPlaceholder: function getPlaceholder() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (!Array.isArray(val)) return [];
      return val.map(function (i) {
        return i.label;
      }).join('、');
    },
    showWarning: function showWarning() {
      if (this.getRoleType !== 99) {
        this.$refs.warnModal.click();
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    },
    selectStorePadding: function selectStorePadding() {
      if (this.$route.query.rule_code === 'SD00003') {
        return 'padding-right: 165px';
      } else if (this.$route.query.rule_code === 'SD00004') {
        return 'padding-right: 190px';
      } else if (this.$route.query.rule_code === 'SD00005') {
        return 'padding-right: 45px';
      }
      return '';
    },
    activityInfo: function activityInfo() {
      var temp = {
        title: '',
        info: '',
        description: '',
        strategyDataLimitOrderTypes: '',
        strategyDataSettingLowestUnitPriceTips: '',
        strategyDataSettingPercentValueTips: '',
        strategyDataSettingIgnoreAllowanceTips: '',
        strategyDataSettingRoundPolicyTips: '',
        strategyDataSettingAmountUnitTips: '',
        strategyDataSettingDiscountUnitTips: ''
      };
      var ruleCode = this.$route.query.rule_code || this.activity.rule_code;
      switch (ruleCode) {
        case 'SD00002':
          temp.title = '指定商品X份折Y元';
          temp.description = '請寫出活動日期與詳細折扣規則，如：3/1~3/30 自取訂單滿100元(含)以上，奶茶系列商品折5元，品牌擁有做最後說明調整的權利，你訂線上訂餐專屬優惠，此優惠不與其他優惠折扣併用。';
          temp.strategyDataSettingOneMaxDiscountTips = '整筆訂單最大總折扣金額，如填寫100，最多可折100元';
          break;
        case 'SD00003':
          temp.title = '買X份商品送Y份商品';
          temp.info = '如設定買5送1活動為買5送1、買10送2，以此類推無折抵上限，折扣方式：買5杯送1杯，滿6杯折抵最低價那1杯的商品金額。';
          temp.description = '請寫出活動日期與詳細折扣規則，如：3/1~3/30 自取訂單買5送1，訂單需滿6份商品，折抵最低價商品金額，鮮奶茶系列商品不列入優惠折扣計算，品牌擁有做最後說明調整的權利，你訂線上訂餐專屬優惠，此優惠不與其他優惠折扣併用。';
          temp.strategyDataLimitOrderTypes = '如：買5送1，X數值請填5，Y數值請填1';
          temp.strategyDataSettingLowestUnitPriceTips = '可能使用情境：選購30元以上商品，即可參與買5送1活動，則會使用此限制做排除。舉例說明：填寫30，低於30元的品項不列入買X份的份數計算';
          break;
        case 'SD00004':
          temp.title = '訂單打X折';
          temp.description = '請寫出活動日期與詳細折扣規則，如：3/1~3/30 自取訂單滿100元(含)以上享9折優惠，鮮奶茶系列商品不列入優惠折扣計算，品牌擁有做最後說明調整的權利，你訂線上訂餐專屬優惠，此優惠不與其他優惠折扣併用。';
          temp.strategyDataSettingPercentValueTips = '如85折為15%，請輸入15、9折為10%，請輸入10';
          temp.strategyDataSettingIgnoreAllowanceTips = '特殊POS使用，不需做任何調整';
          temp.strategyDataSettingRoundPolicyTips = '如：全品項85折，消費者買75元飲品，折扣金額為75*(1-0.85)=11.25，選擇四捨五入訂單折扣折11元，小數無條件進位折12元，小數無條件捨去折11元';
          break;
        case 'SD00005':
          temp.title = '買X份商品折Y元';
          temp.info = '如：設定買5份商品折20元，折扣活動為買5份商品折20元、買10份商品折40元，以此類推無折抵上限。';
          temp.description = '請寫出活動日期與詳細折扣規則，如：3/1~3/30 自取訂單滿5份商品折20元、滿10份商品折40元，以此類推，鮮奶茶系列商品不列入優惠折扣計算，品牌擁有做最後說明調整的權利，你訂線上訂餐專屬優惠，此優惠不與其他優惠折扣併用。';
          temp.strategyDataSettingAmountUnitTips = '如買5份商品折20元，請輸入5';
          temp.strategyDataSettingLowestUnitPriceTips = '可能使用情境：選購30元以上商品，即可參與買X商品折Y元活動，則會使用此限制做排除。舉例說明：填寫30，低於30元的品項不列入買X份的份數計算';
          temp.strategyDataSettingDiscountUnitTips = '如買5份商品折20元，請輸入20';
          break;
        default:
          break;
      }
      return temp;
    }
  }),
  watch: {
    'menuTime.start.time': function menuTimeStartTime() {
      this.endLimit = [{
        type: 'fromto',
        from: this.menuTime.start.time
      }];
      this.setMenuStartTime(this.menuTime.start.time);
    },
    'menuTime.end.time': function menuTimeEndTime() {
      this.startLimit = [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD HH:mm:ss'),
        to: this.menuTime.end.time
      }];
      this.setMenuEndTime(this.menuTime.end.time);
    },
    'content.bindingBrandList': function contentBindingBrandList() {
      var self = this;
      this.storeBrief = [];
      this.content.bindingStoreList = [];
      this.content.bindingBrandList.forEach(function (array) {
        var brandId = array.value;
        self.getStoreBrief(brandId);
      });
    },
    'addStoresSetting.choose': function addStoresSettingChoose() {
      var self = this;
      this.activity.store_ids = this.addStoresSetting.choose;
      this.storeList = [];
      this.addStoresSetting.choose.forEach(function (id) {
        self.addStoresSetting.options.find(function (o) {
          if (o.value === id) self.storeList.push(o);
        });
      });
      if (this.storeList.length) this.storeSelect = this.storeList[0];
    },
    'brandSelect.value': function brandSelectValue() {
      this.getStoreBrief(this.brandSelect.value);
      this.addStoresSetting.choose = [];
      if (this.brandSelect.value && this.getRoleType !== 10) {
        this.curId = 0;
        this.getStoreClassList(this.brandSelect.value);
      }
    },
    'storeSelect.value': function storeSelectValue() {
      if (this.storeSelect.value) this.getOnlineMenu();
    }
  }
});

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MenuDiscountTemp_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MenuDiscountTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MenuDiscountTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['isUp'],
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default.a,
    'menu-discount': __WEBPACK_IMPORTED_MODULE_2__MenuDiscountTemp_vue___default.a
  },
  data: function data() {
    return {
      setInfoTimes: 0,
      info: {},
      reSet: 0,
      ruleCode: 'SD00002',
      brandSelect: {
        label: '',
        value: ''
      },
      menuSelect: {
        label: '',
        value: 0
      },

      ownerTypeOptions: [{ label: '品牌', value: 2 }, { label: '門市', value: 3 }, { label: '平台', value: 1 }],
      enableOptions: [{ label: '啟用', value: 1 }, { label: '停用', value: 0 }],
      timeTypeOption: [{ label: '全時段', value: 1 }, { label: '指定時段', value: 2 }],
      orderType: [{ label: '一般單', value: 1 }, { label: '團購單 - 團長', value: 2 }, { label: '團購單 - 團員', value: 3 }],
      orderMethod: [{ label: '當日單', value: 1 }, { label: '預訂單', value: 2 }],
      deliveryType: [{ label: '自取', value: 1 }, { label: '內用', value: 2 }, { label: '外送', value: 3 }, { label: '內用-桌邊掃碼', value: 21 }],
      tradeType: [],
      menuList: [],
      addStoresSetting: {
        class: 'buy-add-store',
        options: [],
        choose: []
      },
      priceType: [{ label: '免稅', value: 1 }, { label: '未稅', value: 2 }, { label: '含稅', value: 3 }],
      couponSetting: [{ label: '依訂單購買商品數設定', value: 'SC00001' }, { label: '依個人訂單消費特定商品數', value: 'SC00002' }, { label: '依個人訂單購買金額', value: 'SC00003' }],
      useType: [{ label: '品牌型', value: 2 }, { label: '門市型', value: 3 }],
      usageValue: [],
      brandList: [],
      content: {
        bindingStoreList: [],
        bindingBrandList: [],
        bindingProdList: []
      },
      brandDefault: '',
      brandBrief: [],
      storeBrief: [],
      scheduleTime: '',
      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: ''
        }
      },
      show: {
        back: false,
        info: false
      },
      tableIndex: 1,
      count: 20,
      menuId: 0,
      menuName: '',
      storeId: 0,
      startTime: {
        time: ''
      },
      endtime: {
        time: ''
      },
      timeoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      startLimit: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_6_moment___default()().add(-1, 'days').format('YYYY-MM-DD')
      }],
      endLimit: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_6_moment___default()().add(-1, 'days').format('YYYY-MM-DD')
      }],
      offdaySetting: {
        date: [],
        weekDay: [],
        monthDay: [],
        options: {
          date: [],
          weekDay: [{ label: '週日', value: 1 }, { label: '週一', value: 2 }, { label: '週二', value: 3 }, { label: '週三', value: 4 }, { label: '週四', value: 5 }, { label: '週五', value: 6 }, { label: '週六', value: 7 }],
          month: [{ label: '一月', value: 1 }, { label: '二月', value: 2 }, { label: '三月', value: 3 }, { label: '四月', value: 4 }, { label: '五月', value: 5 }, { label: '六月', value: 6 }, { label: '七月', value: 7 }, { label: '八月', value: 8 }, { label: '九月', value: 9 }, { label: '十月', value: 10 }, { label: '十一月', value: 11 }, { label: '十二月', value: 12 }],
          monthDay: []
        }
      },
      timeSettingList: [{ value_type: 0, start_value: 0, end_value: 0, time_type: 1, time_interval: [] }],
      activity: {
        name: '',
        description: '',
        rule_code: 'SD00002',
        start_date: '',
        end_date: '',
        is_enable: { label: '啟用', value: 1 },
        owner_type: { label: '品牌', value: 2 },
        owner_id: 0,
        owner_brand_name: '',
        owner_store_name: '',
        aTime: {
          start: { time: '' },
          end: { time: '' }
        },
        time_setting: [],
        store_ids: [],
        strategy_data: {
          limit: {
            delivery_types: [],
            order_types: [],
            trade_types: [],
            order_methods: [],
            min_product_money: '',
            min_product_amount: '',
            min_sub_order_amount: ''
          },
          setting: {
            one_max_discount: '',
            product_info: [],

            amount_unit: '',

            lowest_unit_price: 0,
            ratio: '',
            exception_products: [],

            percent_value: '',
            ignore_allowance: { label: '不忽略折讓(A+B)金額，商品總額扣除折讓計算', value: 0 },
            round_policy: { label: '小數四折五入', value: 'round' },

            discount_unit: ''
          },

          store_exception_items: [{
            products: [],
            store_ids: []
          }]
        }
      },
      productBrief: [],
      productChoseBrief: [],
      nowTime: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD HH:mm'),
      storeList: [],
      storeSelect: { label: '', value: '' },
      storeProdList: [],
      curVCID: '',
      ignoreAllowance: [{ label: '不忽略折讓(A+B)金額，商品總額扣除折讓計算', value: 0 }, { label: '忽略折讓(A+B)金額，商品總額不扣除折讓計算', value: 1 }],
      roundPolicy: [{ label: '小數四折五入', value: 'round' }, { label: '小數無條件捨去', value: 'floor' }, { label: '小數無條件進位', value: 'ceil' }]
    };
  },
  created: function created() {
    this.getBrandBrief();
    this.getTradeTypeList();

    if (this.getRoleType === 10) {
      this.useType = [{ label: '品牌型', value: 2 }, { label: '門市型', value: 3 }];
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapActions */])(['setMenuStartTime', 'setMenuEndTime']), {
    getStoreProd: function getStoreProd(prod) {
      this.curVCID = prod.vendor_custom_id;
      var self = this;
      var vcId = prod.vendor_custom_id;
      var url = '/discount/' + this.$route.params.activity_id + '/storeOnlineProduct?vendor_custom_id=' + vcId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.storeProdList = response.data.list;
        }
      });
    },
    getWeekDay: function getWeekDay(value) {
      return this.offdaySetting.options.weekDay.find(function (week) {
        return value === week.value;
      }).label;
    },
    returnNum: function returnNum(e) {
      var charCode = e.which ? e.which : e.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        e.preventDefault();
      } else {
        return true;
      }
    },
    addProdToList: function addProdToList(addPInfo) {
      var self = this;
      var pInfo = this.activity.strategy_data.setting.product_info;
      addPInfo.forEach(function (addP) {
        var isSame = pInfo.find(function (prod) {
          return addP.vendor_custom_id === prod.vendor_custom_id;
        });
        if (!isSame) pInfo.push(addP);else {
          self.$notify({
            title: '提醒',
            text: addP.product_name + '已加入過',
            duration: 3000,
            width: 400
          });
        }
      });
    },
    sameItem: function sameItem(list, index) {
      var getAmount = list[index].amount_unit;
      var getDiscount = list[index].discount;
      list.forEach(function (o) {
        o.amount_unit = getAmount;
        o.discount = getDiscount;
      });
    },
    removeListItem: function removeListItem(list, index) {
      list.splice(index, 1);
    },
    clearProcess: function clearProcess(process) {
      process.end_value = '';
      process.start_value = '';
    },
    changeTimeType: function changeTimeType(process) {
      if (process.time_type === 2) {
        var item = {
          start_time: '',
          end_time: ''
        };
        if (!process.time_interval.length) process.time_interval.push(item);
      } else {
        process.time_interval = [];
      }
    },
    addProcessTime: function addProcessTime() {
      var timeSetting = { value_type: 0, start_value: 0, end_value: 0, time_type: 1, time_interval: [] };
      this.timeSettingList.push(timeSetting);
    },
    addChooseTag: function addChooseTag(newTag) {
      var tag = {
        name: newTag,
        id: ''
      };
      this.productChoseBrief.push(tag);
      this.activity.setting.vendorCustomProductList.push(tag);
    },
    addItemTime: function addItemTime(process) {
      var item = {
        start_time: '',
        end_time: ''
      };
      process.time_interval.push(item);
    },
    addTag: function addTag(newTag) {
      var tag = {
        name: newTag,
        vendor_custom_id: ''
      };
      this.productBrief.push(tag);
      this.activity.store_exception_items[0].products.push(tag);
    },
    addStartMonthDayTag: function addStartMonthDayTag(newTag, id) {
      var tag = {
        label: newTag,
        value: newTag
      };
      this.offdaySetting.options.monthDay.push(tag);
    },
    addEndMonthDayTag: function addEndMonthDayTag(newTag, id) {
      var tag = {
        label: newTag,
        value: newTag
      };
      this.offdaySetting.options.monthDay.push(tag);
    },
    getStoreBrief: function getStoreBrief(brandId) {
      this.storeBrief = [];
      this.addStoresSetting.options = [];
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
            self.addStoresSetting.options.push(obj);
          }
          if (self.info && !self.setInfoTimes) self.getDiscountInfo();else if (self.info && self.setInfoTimes === 1) self.setStore();
        }
      });
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            self.brandBrief.push(obj);
            if (i === 0) self.brandSelect = obj;
          }
        }
      });
    },
    getDiscountInfo: function getDiscountInfo() {
      var self = this;
      var url = '/discount/' + this.$route.params.activity_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.info = response.data;
          self.setInfo();
        }
      });
    },
    setStore: function setStore() {
      var self = this;
      var stores = this.info.attend_stores;
      if (stores.length) {
        stores[0].store_list.forEach(function (store) {
          self.addStoresSetting.choose.push(store.store_id);
        });
      }
    },
    setInfo: function setInfo() {
      this.setInfoTimes++;
      var a = this.activity;
      var i = this.info.info;
      var times = this.info.time_setting;
      var strategy = this.info.strategy_data[0];
      var stores = this.info.attend_stores;
      var self = this;
      a.name = i.name;
      a.description = i.description;
      a.rule_code = this.ruleCode = i.rule_code;
      a.owner_brand_name = i.owner_brand_name;
      a.owner_store_name = i.owner_store_name;

      a.aTime.start.time = i.start_date;
      a.aTime.end.time = i.end_date;
      a.is_enable = this.enableOptions.find(function (o) {
        return o.value === i.is_enable;
      });
      a.owner_type = this.ownerTypeOptions.find(function (o) {
        return o.value === i.owner_type;
      });
      this.brandSelect = this.brandBrief.find(function (o) {
        return o.value === stores[0].brand_id;
      });
      this.timeSettingList = [];

      times.forEach(function (time) {
        var option = {
          end_value: { label: time.end_value, value: time.end_value },
          start_value: { label: time.start_value, value: time.start_value },
          time_type: time.time_type,
          value_type: time.value_type,
          time_interval: time.time_interval
        };
        self.timeSettingList.push(option);
      });
      if (a.rule_code === 'SD00001') {
        var iLimit = strategy.limit;
        var aLimit = a.strategy_data.limit;

        if (iLimit.delivery_types) {
          iLimit.delivery_types.forEach(function (dType) {
            aLimit.delivery_types.push(self.deliveryType.find(function (o) {
              return o.value === dType;
            }));
          });
        }
        if (iLimit.order_types) {
          iLimit.order_types.forEach(function (oType) {
            aLimit.order_types.push(self.orderType.find(function (o) {
              return o.value === oType;
            }));
          });
        }
        if (iLimit.trade_types) {
          iLimit.trade_types.forEach(function (tType) {
            aLimit.trade_types.push(self.tradeType.find(function (o) {
              return o.value === tType;
            }));
          });
        }
        if (iLimit.order_methods) {
          iLimit.order_methods.forEach(function (oMethod) {
            aLimit.order_methods.push(self.orderMethod.find(function (o) {
              return o.value === oMethod;
            }));
          });
        }
        if (iLimit.min_product_money) aLimit.min_product_money = iLimit.min_product_money;
        if (iLimit.min_product_amount) aLimit.min_product_amount = iLimit.min_product_amount;
        if (iLimit.min_sub_order_amount) aLimit.min_sub_order_amount = iLimit.min_sub_order_amount;

        if (strategy.setting.amount_unit) a.strategy_data.setting.amount_unit = strategy.setting.amount_unit;
        if (strategy.store_exception_items.length) {
          a.strategy_data.store_exception_items = strategy.store_exception_items;
          a.strategy_data.store_exception_items[0].products.forEach(function (prod) {
            self.$set(prod, 'product_name', prod.name);
          });
        }
      } else if (a.rule_code === 'SD00002') {
        var _iLimit = strategy.limit;
        var _aLimit = a.strategy_data.limit;

        if (_iLimit.delivery_types) {
          _iLimit.delivery_types.forEach(function (dType) {
            _aLimit.delivery_types.push(self.deliveryType.find(function (o) {
              return o.value === dType;
            }));
          });
        }
        if (_iLimit.order_types) {
          _iLimit.order_types.forEach(function (oType) {
            _aLimit.order_types.push(self.orderType.find(function (o) {
              return o.value === oType;
            }));
          });
        }
        if (_iLimit.trade_types) {
          _iLimit.trade_types.forEach(function (tType) {
            _aLimit.trade_types.push(self.tradeType.find(function (o) {
              return o.value === tType;
            }));
          });
        }
        if (_iLimit.order_methods) {
          _iLimit.order_methods.forEach(function (oMethod) {
            _aLimit.order_methods.push(self.orderMethod.find(function (o) {
              return o.value === oMethod;
            }));
          });
        }
        if (_iLimit.min_product_money) _aLimit.min_product_money = _iLimit.min_product_money;
        if (_iLimit.min_product_amount) _aLimit.min_product_amount = _iLimit.min_product_amount;
        if (_iLimit.min_sub_order_amount) _aLimit.min_sub_order_amount = _iLimit.min_sub_order_amount;

        if (strategy.setting.one_max_discount) a.strategy_data.setting.one_max_discount = strategy.setting.one_max_discount;
        a.strategy_data.setting.product_info = strategy.setting.product_info;
      } else if (a.rule_code === 'SD00003') {
        var _iLimit2 = strategy.limit;
        var _aLimit2 = a.strategy_data.limit;

        if (_iLimit2.delivery_types) {
          _iLimit2.delivery_types.forEach(function (dType) {
            _aLimit2.delivery_types.push(self.deliveryType.find(function (o) {
              return o.value === dType;
            }));
          });
        }
        if (_iLimit2.order_types) {
          _iLimit2.order_types.forEach(function (oType) {
            _aLimit2.order_types.push(self.orderType.find(function (o) {
              return o.value === oType;
            }));
          });
        }
        if (_iLimit2.trade_types) {
          _iLimit2.trade_types.forEach(function (tType) {
            _aLimit2.trade_types.push(self.tradeType.find(function (o) {
              return o.value === tType;
            }));
          });
        }
        if (_iLimit2.order_methods) {
          _iLimit2.order_methods.forEach(function (oMethod) {
            _aLimit2.order_methods.push(self.orderMethod.find(function (o) {
              return o.value === oMethod;
            }));
          });
        }
        if (_iLimit2.min_product_money) _aLimit2.min_product_money = _iLimit2.min_product_money;
        if (_iLimit2.min_product_amount) _aLimit2.min_product_amount = _iLimit2.min_product_amount;
        if (_iLimit2.min_sub_order_amount) _aLimit2.min_sub_order_amount = _iLimit2.min_sub_order_amount;

        if (strategy.setting.amount_unit) a.strategy_data.setting.amount_unit = strategy.setting.amount_unit;
        if (strategy.setting.lowest_unit_price) a.strategy_data.setting.lowest_unit_price = strategy.setting.lowest_unit_price;
        if (strategy.setting.ratio) a.strategy_data.setting.ratio = strategy.setting.ratio;
        if (strategy.setting.exception_products.length) {
          a.strategy_data.setting.exception_products = strategy.setting.exception_products;
          strategy.setting.exception_products.forEach(function (prod, pIndex) {
            self.$set(a.strategy_data.setting.exception_products[pIndex], 'product_name', prod.name);
          });
        }
      } else if (a.rule_code === 'SD00004') {
        var _iLimit3 = strategy.limit;
        var _aLimit3 = a.strategy_data.limit;

        if (_iLimit3.delivery_types) {
          _iLimit3.delivery_types.forEach(function (dType) {
            _aLimit3.delivery_types.push(self.deliveryType.find(function (o) {
              return o.value === dType;
            }));
          });
        }
        if (_iLimit3.order_types) {
          _iLimit3.order_types.forEach(function (oType) {
            _aLimit3.order_types.push(self.orderType.find(function (o) {
              return o.value === oType;
            }));
          });
        }
        if (_iLimit3.trade_types) {
          _iLimit3.trade_types.forEach(function (tType) {
            _aLimit3.trade_types.push(self.tradeType.find(function (o) {
              return o.value === tType;
            }));
          });
        }
        if (_iLimit3.order_methods) {
          _iLimit3.order_methods.forEach(function (oMethod) {
            _aLimit3.order_methods.push(self.orderMethod.find(function (o) {
              return o.value === oMethod;
            }));
          });
        }
        if (_iLimit3.min_product_money) _aLimit3.min_product_money = _iLimit3.min_product_money;
        if (_iLimit3.min_product_amount) _aLimit3.min_product_amount = _iLimit3.min_product_amount;
        if (_iLimit3.min_sub_order_amount) _aLimit3.min_sub_order_amount = _iLimit3.min_sub_order_amount;

        console.log(strategy.setting);
        if (strategy.setting.percent_value) a.strategy_data.setting.percent_value = strategy.setting.percent_value;
        if (strategy.setting.ignore_allowance !== '') {
          a.strategy_data.setting.ignore_allowance = this.ignoreAllowance.find(function (option) {
            return option.value === strategy.setting.ignore_allowance;
          });
        }
        if (strategy.setting.round_policy) {
          a.strategy_data.setting.round_policy = this.roundPolicy.find(function (option) {
            return option.value === strategy.setting.round_policy;
          });
        }
        if (strategy.store_exception_items.length) {
          a.strategy_data.store_exception_items = strategy.store_exception_items;
          a.strategy_data.store_exception_items[0].products.forEach(function (prod) {
            self.$set(prod, 'product_name', prod.name);
          });
        }
      } else if (a.rule_code === 'SD00005') {
        var _iLimit4 = strategy.limit;
        var _aLimit4 = a.strategy_data.limit;

        if (_iLimit4.delivery_types) {
          _iLimit4.delivery_types.forEach(function (dType) {
            _aLimit4.delivery_types.push(self.deliveryType.find(function (o) {
              return o.value === dType;
            }));
          });
        }
        if (_iLimit4.order_types) {
          _iLimit4.order_types.forEach(function (oType) {
            _aLimit4.order_types.push(self.orderType.find(function (o) {
              return o.value === oType;
            }));
          });
        }
        if (_iLimit4.trade_types) {
          _iLimit4.trade_types.forEach(function (tType) {
            _aLimit4.trade_types.push(self.tradeType.find(function (o) {
              return o.value === tType;
            }));
          });
        }
        if (_iLimit4.order_methods) {
          _iLimit4.order_methods.forEach(function (oMethod) {
            _aLimit4.order_methods.push(self.orderMethod.find(function (o) {
              return o.value === oMethod;
            }));
          });
        }
        if (_iLimit4.min_product_money) _aLimit4.min_product_money = _iLimit4.min_product_money;
        if (_iLimit4.min_product_amount) _aLimit4.min_product_amount = _iLimit4.min_product_amount;
        if (_iLimit4.min_sub_order_amount) _aLimit4.min_sub_order_amount = _iLimit4.min_sub_order_amount;

        console.log(strategy.setting);
        if (strategy.setting.amount_unit) a.strategy_data.setting.amount_unit = strategy.setting.amount_unit;
        a.strategy_data.setting.lowest_unit_price = strategy.setting.lowest_unit_price;
        if (strategy.setting.discount_unit) a.strategy_data.setting.discount_unit = strategy.setting.discount_unit;

        if (strategy.store_exception_items.length) {
          a.strategy_data.store_exception_items = strategy.store_exception_items;
          a.strategy_data.store_exception_items[0].products.forEach(function (prod) {
            self.$set(prod, 'product_name', prod.name);
          });
        }
      }
      self.show.info = true;
    },
    getTradeTypeList: function getTradeTypeList() {
      var self = this;
      var url = '/platform/tradeTypeList';
      this.getData('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.tradeInfo = [];
          var list = response.data.list;
          for (var i = 0; i < list.length; i++) {
            if (list[i].is_valid && list[i].is_enable) {
              var option = {
                label: list[i].name,
                value: parseInt(list[i].type, 10)
              };
              self.tradeType.push(option);
            }
          }
        }
      });
    },
    checkActivity: function checkActivity() {
      var a = this.activity;
      var sD = a.strategy_data;
      var msg = '';
      if (!a.name) msg = '活動名稱未填';else if (!a.aTime.start.time) msg = '活動開始時間未填';else if (!a.aTime.end.time) msg = '活動結束時間未填';else if (!a.owner_type.value) msg = '活動擁有者未選';else if (!a.is_enable) msg = '活動啟用未選';else if (!a.description) msg = '活動描述未填';else if (!this.timeSettingList.length) msg = '折扣生效日未填';else if (!this.addStoresSetting.choose.length) msg = '參與活動店家未選';else if (this.addStoresSetting.choose.length > 1 && a.owner_type === 3) msg = '品牌擁有者只可選擇一家店家';else if (a.rule_code === 'SD00001') {} else if (a.rule_code === 'SD00002') {
        if (!sD.setting.product_info.length) msg = '扣商品選擇未選';
      }
      this.getToast(msg);
    },
    getToast: function getToast(msg) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.setData();
      }
    },
    setData: function setData(type) {
      var act = this.activity;
      var data = {
        name: act.name,
        description: act.description,
        rule_code: act.rule_code,
        start_date: act.aTime.start.time,
        end_date: act.aTime.end.time,
        is_enable: act.is_enable.value,
        owner_type: act.owner_type.value,
        owner_id: 0,
        time_setting: [],
        store_ids: this.addStoresSetting.choose,
        strategy_data: {}
      };

      if (data.owner_type === 1) data.owner_id = 0;else if (data.owner_type === 2) data.owner_id = this.brandSelect.value;else if (data.owner_type === 3) data.owner_id = data.store_ids[0];

      this.timeSettingList.forEach(function (time) {
        var o = {
          value_type: 0,
          start_value: 0,
          end_value: 0,
          time_type: 1,
          time_interval: time.time_interval
        };
        if (time.value_type) o.value_type = time.value_type.value;
        if (time.start_value) o.value_type = time.start_value.value;
        if (time.end_value) o.value_type = time.end_value.value;
        data.time_setting.push(o);
      });
      if (act.rule_code === 'SD00002') {
        var aSD = act.strategy_data;
        data.strategy_data = {
          limit: {},
          setting: {
            one_max_discount: null,
            product_info: aSD.setting.product_info
          }
        };
        var dSD = data.strategy_data;

        if (aSD.limit.delivery_types.length) {
          dSD.limit.delivery_types = [];
          aSD.limit.delivery_types.forEach(function (dType) {
            dSD.limit.delivery_types.push(dType.value);
          });
        }
        if (aSD.limit.order_types.length) {
          dSD.limit.order_types = [];
          aSD.limit.order_types.forEach(function (oType) {
            dSD.limit.order_types.push(oType.value);
          });
        }
        if (aSD.limit.trade_types.length) {
          dSD.limit.trade_types = [];
          aSD.limit.trade_types.forEach(function (tType) {
            dSD.limit.trade_types.push(tType.value);
          });
        }
        if (aSD.limit.order_methods.length) {
          dSD.limit.order_methods = [];
          aSD.limit.order_methods.forEach(function (oMethod) {
            dSD.limit.order_methods.push(oMethod.value);
          });
        }
        if (aSD.limit.min_product_money) dSD.limit.min_product_money = aSD.limit.min_product_money;
        if (aSD.limit.min_product_amount) dSD.limit.min_product_amount = aSD.limit.min_product_amount;
        if (aSD.limit.min_sub_order_amount) dSD.limit.min_sub_order_amount = aSD.limit.min_sub_order_amount;

        if (aSD.setting.one_max_discount) dSD.setting.one_max_discount = aSD.setting.one_max_discount;
      }
      if (this.info.info) this.upDiscount(data);else this.crDiscount(data);
    },
    crDiscount: function crDiscount(data) {
      var self = this;
      var url = '/discount';
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.replace('/upDiscountList');
        }
      });
    },
    upDiscount: function upDiscount(data) {
      var self = this;
      var url = '/discount/' + this.$route.params.activity_id;
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.replace('/upDiscountList');
        }
      });
    },
    getOnlineMenu: function getOnlineMenu() {
      var self = this;
      self.menuList = [];
      var url = '/onlineMenu/list?page=' + this.tableIndex + '&size=' + this.count + '&brand_id=' + this.brandSelect.value + '&store_id=' + this.storeSelect.value;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var mList = response.data.menu_list;
          mList.forEach(function (menu, index) {
            var option = { label: menu.name, value: menu.id };
            self.menuList.push(option);
            if (index === 0) self.menuSelect = option;
          });
          if (!mList.length) self.menuSelect = { label: '', value: '' };
        }
      });
    }
  }),
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    }
  },
  watch: {
    'menuTime.start.time': function menuTimeStartTime() {
      this.endLimit = [{
        type: 'fromto',
        from: this.menuTime.start.time
      }];
      this.setMenuStartTime(this.menuTime.start.time);
    },
    'menuTime.end.time': function menuTimeEndTime() {
      this.startLimit = [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD HH:mm:ss'),
        to: this.menuTime.end.time
      }];
      this.setMenuEndTime(this.menuTime.end.time);
    },
    'content.bindingBrandList': function contentBindingBrandList() {
      var self = this;
      this.storeBrief = [];
      this.content.bindingStoreList = [];
      this.content.bindingBrandList.forEach(function (array) {
        var brandId = array.value;
        self.getStoreBrief(brandId);
      });
    },
    'addStoresSetting.choose': function addStoresSettingChoose() {
      var self = this;
      this.activity.store_ids = this.addStoresSetting.choose;
      this.storeList = [];
      this.addStoresSetting.choose.forEach(function (id) {
        self.addStoresSetting.options.find(function (o) {
          if (o.value === id) self.storeList.push(o);
        });
      });
      if (this.storeList.length) this.storeSelect = this.storeList[0];
    },
    'brandSelect.value': function brandSelectValue() {
      this.getStoreBrief(this.brandSelect.value);
      this.addStoresSetting.choose = [];
    },
    'storeSelect.value': function storeSelectValue() {
      if (this.storeSelect.value) this.getOnlineMenu();
    }
  }
});

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MenuDiscountTemp_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MenuDiscountTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MenuDiscountTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['isUp'],
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default.a,
    'menu-discount': __WEBPACK_IMPORTED_MODULE_2__MenuDiscountTemp_vue___default.a
  },
  data: function data() {
    return {
      info: {
        info: {}
      },
      storeInfo: [],
      enableOption: [{ label: '啟用', value: 1 }, { label: '不啟用', value: 0 }]
    };
  },
  created: function created() {
    this.getDiscountInfo();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['setMenuStartTime', 'setMenuEndTime']), {
    changeSelect: function changeSelect(store) {
      store.is_enable = store.is_enable_obj.value;
    },
    getDiscountInfo: function getDiscountInfo() {
      this.storeInfo = [];
      var self = this;
      var url = '/discount/' + this.$route.params.activity_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.info = response.data;
          self.info.attend_stores.forEach(function (brand) {
            brand.store_list.forEach(function (store) {
              var newObj = store;
              self.$set(newObj, 'brand_name', brand.brand_name);
              self.$set(newObj, 'brand_id', brand.brand_id);
              self.$set(newObj, 'is_enable_obj', self.enableOption.find(function (o) {
                return store.is_enable === o.value;
              }));
              self.storeInfo.push(newObj);
            });
          });
        }
      });
    },
    setData: function setData() {
      var data = {
        enable_store_ids: [],
        disable_store_ids: []
      };
      this.storeInfo.forEach(function (store) {
        if (!store.is_enable) data.disable_store_ids.push(store.store_id);else data.enable_store_ids.push(store.store_id);
      });
      this.upDiscount(data);
    },
    upDiscount: function upDiscount(data) {
      var self = this;
      var url = '/discount/' + this.$route.params.activity_id;
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.replace('/upDiscountList');
        }
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    }
  })
});

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_masonry_layout__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_masonry_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_masonry_layout__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    'info': {
      type: Object
    },
    menuId: {
      type: [Number, String]
    },
    showWord: {
      type: String
    },
    className: String
  },
  data: function data() {
    return {
      first: true,
      noMenu: false,
      isAdd: false,
      brandId: this.$route.params.brand_id,
      current: {
        productName: '',
        productId: 0
      },
      count: 20,
      brandName: '',
      brandType: '',
      amount: {
        adjust: 1,
        option: 1,
        product: 1,
        category: 1,
        resource: 1,
        others: 1
      },
      adjustNumList: [],
      adjust: [],
      option: [],
      cateNumList: [],
      category: [],
      product: [],
      prodNumList: {},
      all: {
        category: [],
        product: [],
        adjust: [],
        option: [],
        combination: []
      },
      menuInfo: {},
      menuList: '',

      created: false,
      getTimes: 0,
      time: 0,
      accessory: [],
      currentMenuJson: '',
      schema: {
        category: {},
        product: {},
        block: {},
        adjust: {},
        option: {},
        combine: {}
      },
      addStoresSetting: {
        class: 'add-store',
        options: [],
        choose: []
      },
      disTableList: []
    };
  },

  methods: {
    init: function init() {
      this.getMenuInfo();
    },
    isActive: function isActive(index) {
      if (index === 1) return true;else return false;
    },
    showMenu: function showMenu() {
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.grid') && __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.grid-item')) {
        var m = new __WEBPACK_IMPORTED_MODULE_1_masonry_layout___default.a('.grid', {
          itemSelector: '.grid-item',
          columnWidth: '.grid-item'
        });
        m.reloadItems();
        m.layout();
      }
    },
    getProduct: function getProduct(index) {
      return this.product[index];
    },
    gotoFrom: function gotoFrom() {
      if (this.menuId) this.$router.push('/upMenu/' + this.brandId + '/' + this.menuId);else this.$router.push('/crOption');
    },
    gotoNext: function gotoNext() {
      if (!this.addStoresSetting.choose.length && !this.$route.params.store_id) {
        this.$notify({
          title: '錯誤',
          text: '未選擇停賣店家',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else this.disProductList();
    },
    setChoose: function setChoose() {
      var self = this;
      var array = [];
      if (self.$route.name.indexOf('up') > -1) {
        self.marketing.attend_stores.forEach(function (brand) {
          brand.store_list.forEach(function (store) {
            var curStore = store.store_id;
            array.push(curStore);
          });
        });
        self.addStoresSetting.choose = array;
      }
    },
    getMenuInfo: function getMenuInfo() {
      var self = this;
      var url = '/onlineMenu/' + this.menuId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          if (response.data.json_menu) {
            self.currentMenuJson = response.data.json_menu;

            var sList = response.data.store_list;
            for (var i = 0; i < sList.length; i++) {
              var obj = { label: sList[i].name, value: sList[i].id };
              self.addStoresSetting.options.push(obj);
            }
            self.setSelectAndMenu();
            if (self.$route.params.store_id) self.getDisItemList();
          }
        }
      });
    },
    setSelectAndMenu: function setSelectAndMenu() {
      var self = this;
      this.currentMenuJson = JSON.parse(this.currentMenuJson);
      this.schema.category = this.currentMenuJson.category_list_json.schema;
      this.schema.product = this.currentMenuJson.product_list_json.schema;
      var cSchema = this.schema.category;
      var pSchema = this.schema.product;
      var category = this.currentMenuJson.category_list_json.data;
      this.product = this.currentMenuJson.product_list_json.data;

      var menu = [];
      var newMenu = [];
      for (var key in category) {
        menu.push(category[key]);
      }
      menu.forEach(function (category) {
        var obj = {
          category_id: category[cSchema.product_id],
          name: category[cSchema.name],
          sort: category[cSchema.sort],
          is_disabled: self.created,
          pList: category[cSchema.product_list],
          product_list: [],
          package_list: []
        };
        category[cSchema.product_list].forEach(function (pId) {
          var prod = self.getProduct(pId);
          var pObj = {
            product_id: prod[pSchema.product_id],
            vendor_custom_id: prod[pSchema.vendor_custom_id],
            name: prod[pSchema.name],
            sort: prod[pSchema.sort],
            is_disabled: self.created,
            product_type: prod[pSchema.type]
          };
          var paObj = {
            package_id: prod[pSchema.product_id],
            vendor_custom_id: prod[pSchema.vendor_custom_id],
            name: prod[pSchema.name],
            sort: prod[pSchema.sort],
            is_disabled: self.created,
            product_type: prod[pSchema.type]
          };
          if (prod[pSchema.type] === 1) obj.product_list.push(pObj);else if (prod[pSchema.type] === 3) obj.package_list.push(paObj);
        });
        newMenu.push(obj);
      });
      newMenu.sort(function (a, b) {
        return a.sort - b.sort;
      });
      this.category = newMenu;
    },
    addProduct: function addProduct() {
      var productInfo = [];
      var caList = this.category;
      for (var c = 0; c < caList.length; c++) {
        var pList = caList[c].product_list;
        for (var p = 0; p < pList.length; p++) {
          var pOption = {
            product_type: pList[p].product_type,
            amount_unit: 1,
            vendor_custom_id: '',
            product_name: pList[p].name,
            discount: ''
          };
          if (pList[p].vendor_custom_id) {
            pOption.vendor_custom_id = pList[p].vendor_custom_id;
            if (pList[p].is_disabled) productInfo.push(pOption);
          } else if (pList[p].is_disabled) {
            this.$notify({
              title: '訊息',
              text: '加入商品失敗，' + pList[p].name + '無商品料號',
              duration: 3000,
              type: 'danger',
              width: 400
            });
          }
        }

        var paList = caList[c].package_list;
        for (var pa = 0; pa < paList.length; pa++) {
          var paOption = {
            product_type: paList[pa].product_type,
            amount_unit: 1,
            vendor_custom_id: '',
            product_name: paList[pa].name,
            discount: ''
          };
          if (paList[pa].vendor_custom_id) {
            paOption.vendor_custom_id = paList[pa].vendor_custom_id;
            if (paList[pa].is_disabled) productInfo.push(paOption);
          } else if (paList[pa].is_disabled) {
            this.$notify({
              title: '訊息',
              text: '加入商品失敗，' + paList[pa].name + '無商品料號',
              duration: 3000,
              type: 'danger',
              width: 400
            });
          }
        }
      }
      try {
        this.$emit('addProdToList', productInfo);

        this.isAdd = true;
        this.clearChoose();
      } catch (e) {
        this.$notify({
          title: '訊息',
          text: '加入商品失敗',
          duration: 3000,
          type: 'danger',
          width: 400
        });
        this.isAdd = false;
      }
    },
    clearChoose: function clearChoose() {
      var caList = this.category;
      for (var c = 0; c < caList.length; c++) {
        var pList = caList[c].product_list;
        for (var p = 0; p < pList.length; p++) {
          pList[p].is_disabled = this.created;
        }

        var paList = caList[c].package_list;
        for (var pa = 0; pa < paList.length; pa++) {
          paList[pa].is_disabled = this.created;
        }
      }
    },
    disProductList: function disProductList() {
      var self = this;
      var data = {
        store_list: [],
        setting: {
          product_list: {
            enable: [],
            disable: []
          },
          package_list: {
            enable: [],
            disable: []
          },
          category_list: {
            enable: [],
            disable: []
          }
        }
      };
      if (this.addStoresSetting.choose.length) data.store_list = this.addStoresSetting.choose;else if (this.$route.params.store_id) data.store_list = [this.$route.params.store_id];
      var caList = this.category;
      for (var c = 0; c < caList.length; c++) {
        if (caList[c].is_disabled) data.setting.category_list.disable.push(caList[c].category_id);else data.setting.category_list.enable.push(caList[c].category_id);

        var pList = caList[c].product_list;
        for (var p = 0; p < pList.length; p++) {
          if (pList[p].is_disabled) data.setting.product_list.disable.push(pList[p].product_id);else data.setting.product_list.enable.push(pList[p].product_id);
        }

        var paList = caList[c].package_list;
        for (var pa = 0; pa < paList.length; pa++) {
          if (paList[pa].is_disabled) data.setting.package_list.disable.push(paList[pa].package_id);else data.setting.package_list.enable.push(paList[pa].package_id);
        }
      }
      var url = '/onlineMenu/' + this.menuId + '/productListStatus';
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '訊息',
            text: '成功更新停賣資訊',
            duration: 3000,
            type: 'success',
            width: 400
          });
        }
      });
    },
    getDisItemList: function getDisItemList() {
      this.disTableList = [];
      var self = this;
      var url = '/store/' + this.$route.params.store_id + '/disableItemList';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.disTableList = response.data.item_list;
          var disCategory = self.disTableList.category;
          disCategory.forEach(function (c) {
            c.id_list.forEach(function (cId) {
              self.category.find(function (category) {
                if (category.category_id === cId) category.is_disabled = true;
              });
            });
          });
          var disProd = self.disTableList.product;
          disProd.forEach(function (p) {
            p.id_list.forEach(function (pId) {
              self.category.forEach(function (cc) {
                cc.product_list.find(function (prod) {
                  if (prod.product_id === pId) prod.is_disabled = true;
                });
              });
            });
          });
        }
      });
    },
    choseAllProduct: function choseAllProduct(category) {
      this.category.filter(function (elem, index, obj) {
        if (elem.category_id === category.category_id) {
          elem.is_disabled = true;
          if (elem.product_list.length) {
            for (var i = 0; i < elem.product_list.length; i++) {
              var product = elem.product_list[i];

              product['is_disabled'] = true;
            }
          }
          if (elem.package_list.length) {
            for (var j = 0; j < elem.package_list.length; j++) {
              var pa = elem.package_list[j];

              pa['is_disabled'] = true;
            }
          }
        }
      });
    },
    cancelAllProduct: function cancelAllProduct(category) {
      this.category.filter(function (elem, index, obj) {
        if (elem.category_id === category.category_id) {
          elem.is_disabled = false;
          if (elem.product_list.length) {
            for (var i = 0; i < elem.product_list.length; i++) {
              var product = elem.product_list[i];
              product['is_disabled'] = false;
            }
          }
          if (elem.package_list.length) {
            for (var j = 0; j < elem.package_list.length; j++) {
              var pa = elem.package_list[j];
              pa['is_disabled'] = false;
            }
          }
        }
      });
    },
    changeCategoryAdd: function changeCategoryAdd(category) {
      category.is_disabled = !category.is_disabled;
      category.product_list.forEach(function (product) {
        product['is_disabled'] = category.is_disabled;
        if (product.combine_list) {
          product.combine_list.forEach(function (combine) {
            combine['is_disabled'] = category.is_disabled;
          });
        }
      });
      if (category.package_list) {
        category.package_list.forEach(function (pa) {
          pa['is_disabled'] = category.is_disabled;
        });
      }
    },
    changeProductAdd: function changeProductAdd(category, product) {
      product.is_disabled = !product.is_disabled;
      if (product.combine_list) {
        for (var j = 0; j < product.combine_list.length; j++) {
          var combine = product.combine_list[j];
          combine['is_disabled'] = product.is_disabled;
        }
      }

      if (!product.is_disabled) {
        category.is_disabled = product.is_disabled;
      }
    }
  },
  mounted: function mounted() {
    this.showMenu();
  },
  updated: function updated() {
    this.showMenu();
  },

  computed: {
    menuClass: function menuClass() {
      if (this.className) return this.className + '-';
      return '';
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    storeName: function storeName() {
      var sId = parseInt(this.$route.params.store_id, 10);
      if (sId) {
        var sName = this.addStoresSetting.options.find(function (o) {
          return sId === o.value;
        });
        if (sName) return sName.label + '菜單';
      }
      return '';
    }
  },
  watch: {
    menuId: function menuId() {
      if (this.menuId) {
        this.init();
        if (this.$route.name.indexOf('up') === -1 || !this.first) this.isAdd = false;else this.isAdd = true;
        this.noMenu = false;
      } else {
        this.noMenu = true;
      }
    }
  }
});

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_DiscountForm_vue__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_DiscountForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_DiscountForm_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'discount-form': __WEBPACK_IMPORTED_MODULE_0__Temp_DiscountForm_vue___default.a
  },
  data: function data() {
    return {
      isUp: true
    };
  },

  methods: {},
  created: function created() {},

  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    }
  }
});

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_DiscountStoreEnableTemp_vue__ = __webpack_require__(2152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_DiscountStoreEnableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_DiscountStoreEnableTemp_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'discount-form': __WEBPACK_IMPORTED_MODULE_0__Temp_DiscountStoreEnableTemp_vue___default.a
  },
  data: function data() {
    return {
      isUp: true
    };
  },

  methods: {},
  created: function created() {},

  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    }
  }
});

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      roleType: 0,
      brandBrief: [],
      storeBrief: [],
      brandSelect: {
        value: 999999,
        label: '== 品牌 =='
      },
      storeSelect: {
        value: 999999,
        label: '== 門市 =='
      },
      ruleCodeSelect: 999999,
      timeMethodSelect: 999999,
      isEnableSelect: 999999,
      ownerTypeSelect: 999999,
      ownerType: [{ label: '== 擁有者 ==', value: 999999 }, { label: '品牌', value: 2 }, { label: '門市', value: 3 }, { label: '平台', value: 1 }],
      discountList: [],
      total: 1,
      count: 20,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      current: {
        store_list: [],
        name: ''
      },
      preSortMethod: [],
      sortToggle: false,
      sortMethod: '',
      ruleCode: [{
        name: '買X送一依金額個位數取固定折抵規則',
        rule_code: 'SD00001'
      }, {
        name: '買指定商品買X份可折Y元',
        rule_code: 'SD00002'
      }, {
        name: '買X送Y依消費商品最低價折抵規則',
        rule_code: 'SD00003'
      }, {
        name: '全品項折扣規則',
        rule_code: 'SD00004'
      }, {
        name: '購買X數量滿額可折Y元折抵規則',
        rule_code: 'SD00005'
      }]
    };
  },
  mounted: function mounted() {},

  methods: {
    canEdit: function canEdit(discount) {
      var list = this.ruleCode.map(function (item) {
        return item.rule_code;
      });
      return list.includes(discount.rule_code);
    },
    getStoreInfo: function getStoreInfo(storeID) {
      var self = this;
      var url = '/store/' + storeID + '/info';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.brandSelect.value = Number(response.data.info.brand_id);
          self.brandSelect.label = response.data.info.brand_name;
        }
      });
    },
    checkSort: function checkSort(method) {
      this.sortMethod = method;
      if (this.preSortMethod.length) {
        if (method === this.preSortMethod[0]) this.sortToggle = !this.sortToggle;else {
          this.tableIndex = 1;
          this.sortToggle = false;
        }
        this.preSortMethod.splice(0, 1);
      } else this.sortToggle = false;
      this.preSortMethod.push(method);
      this.getAttendDiscount();
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      this.brandBrief = [{ label: '== 品牌 ==', value: 999999 }];
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            if (!bList[i].is_visible) obj.label = obj.label + ' (測)';
            if (i === 0 && self.getRoleType === 10) self.brandSelect = obj;
            if (self.$route.query.brand) {
              var brand = Number(self.$route.query.brand);
              if (brand === obj.value) {
                self.brandSelect = obj;
                self.getAttendDiscount();
              }
            }
            self.brandBrief.push(obj);
          }
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          self.storeBrief = [{ label: '== 門市 ==', value: 999999 }];
          self.storeSelect = {
            value: 999999,
            label: '== 門市 =='
          };
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);

            if (self.$route.query.store) {
              var store = Number(self.$route.query.store);
              if (store === obj.value) {
                self.storeSelect = obj;
                self.getAttendDiscount();
              }
            }
          }
          if (!sList.length) {
            self.discountList = [];
            self.total = 0;
          }
        }
      });
    },
    getAttendDiscount: function getAttendDiscount() {
      var self = this;
      var url = '/discount/list?&size=' + this.count;
      var queryValue = {};
      if (this.storeSelect.value !== 999999 && this.getRoleType !== 30) {
        if (this.$route.query.store !== this.storeSelect.value) {
          queryValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, queryValue, { store: this.storeSelect.value });
          this.tableIndex = 1;
        } else queryValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, queryValue, { store: this.storeSelect.value });
        url = url + '&owner_id=' + this.storeSelect.value;
        url = url + '&owner_type=' + 3;
      } else if (this.brandSelect.value !== 999999 && this.getRoleType !== 10) {
        if (this.$route.query.brand !== this.brandSelect.value) {
          this.tableIndex = 1;
          queryValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, queryValue, { brand: this.brandSelect.value, page: 1 });
        } else queryValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, queryValue, { brand: this.brandSelect.value });
        url = url + '&owner_id=' + this.brandSelect.value;
        url = url + '&owner_type=' + 2;
      }
      if (this.ruleCodeSelect !== 999999) {
        if (this.$route.query.rule_code !== this.ruleCodeSelect) this.tableIndex = 1;
        queryValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, queryValue, { rule_code: this.ruleCodeSelect, page: 1 });
        url = url + '&rule_code=' + this.ruleCodeSelect;
      }
      if (this.timeMethodSelect !== 999999) {
        if (this.$route.query.time_method !== this.timeMethodSelect) this.tableIndex = 1;
        queryValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, queryValue, { time_method: this.timeMethodSelect, page: 1 });
        url = url + '&time_method=' + this.timeMethodSelect;
      }
      if (this.isEnableSelect !== 999999) {
        if (this.$route.query.is_enable !== this.isEnableSelect) this.tableIndex = 1;
        queryValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, queryValue, { is_enable: this.isEnableSelect, page: 1 });
        url = url + '&is_enable=' + this.isEnableSelect;
      }
      if (this.tableIndex) {
        queryValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, queryValue, { page: this.tableIndex });
        url = url + '&page=' + this.tableIndex;
      }
      if (this.sortMethod) {
        url = url + '&list_sort=' + this.sortMethod + ' ';
        if (this.sortToggle) {
          url = url + 'ASC';
          queryValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, queryValue, { list_sort: this.sortMethod, sortToggle: 1 });
        } else {
          queryValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, queryValue, { list_sort: this.sortMethod, sortToggle: 0 });
          url = url + 'DESC';
        }
      }
      this.$router.push({ query: queryValue });
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.discountList = response.data.list;
          self.total = response.data.list_total;
        }
      });
    },
    clickCurrent: function clickCurrent(menu) {
      this.current = menu;
    },
    clickGroup: function clickGroup(type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1;
        this.tableIndex = this.groupAmount * this.pageGroup;
        this.clickPage(this.tableIndex);
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1;
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1;
        this.clickPage(this.tableIndex);
      }
    },
    clickEnd: function clickEnd(type) {
      if (type === 'pre') {
        this.clickPage(1);
        this.pageGroup = 1;
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount);else this.clickPage(1);
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount);
      }
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      if (index === 1) this.pageGroup = 1;
      this.getAttendDiscount();
    },
    isActive: function isActive(index) {
      if (Number(this.tableIndex) === index) return true;else return false;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  }),
  created: function created() {
    if (this.getRoleType === 10) {
      this.ownerTypeSelect = 3;
    }
    this.roleType = parseInt(this.getRoleType, 10);
    this.fixedH();
    this.getBrandBrief();
    if (this.$route.query.store) {
      this.storeSelect.value = this.$route.query.store;
      this.getStoreInfo(this.$route.query.store);
    }
    if (this.$route.query.brand) this.brandSelect.value = this.$route.query.brand;

    if (this.$route.query.rule_code) this.ruleCodeSelect = this.$route.query.rule_code;
    if (this.$route.query.time_method) this.timeMethodSelect = this.$route.query.time_method;
    if (this.$route.query.is_enable) this.isEnableSelect = this.$route.query.is_enable;
    if (this.$route.query.list_sort) this.sortMethod = this.$route.query.list_sort;
    if (this.$route.query.page) this.tableIndex = this.$route.query.page;
    if (this.$route.query.sortToggle) this.sortToggle = this.$route.query.sortToggle;
    if (!this.$route.query.brand && !this.$route.query.store) this.getAttendDiscount();
  },

  watch: {
    'brandSelect.value': function brandSelectValue() {
      this.ownerTypeSelect = 2;
      if (this.brandSelect.value !== 999999 && this.brandSelect) this.getStoreBrief(this.brandSelect.value);
    },
    'storeSelect.value': function storeSelectValue() {
      this.ownerTypeSelect = 3;
      this.getAttendDiscount();
    }
  }
});

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Brand_Temp_BrandTableTemp_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Brand_Temp_BrandTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Brand_Temp_BrandTableTemp_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      tableIndex: 1
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#example1').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      });
    });
  },

  methods: {
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    }
  },
  components: {
    'brand-table': __WEBPACK_IMPORTED_MODULE_3__Brand_Temp_BrandTableTemp_vue___default.a
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  }
});

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      productList: []
    };
  },

  methods: {
    getOrderInfo: function getOrderInfo() {
      var self = this;
      var orderId = this.$route.params.order_id;
      var url = '/history/orderBriefHistory/' + orderId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.productList = response.data.product_list;
        }
      });
    }
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  },
  created: function created() {
    this.getOrderInfo();
  }
});

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_OneDayHistoryTableTemp__ = __webpack_require__(2163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_OneDayHistoryTableTemp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Temp_OneDayHistoryTableTemp__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      tableIndex: 1
    };
  },
  mounted: function mounted() {},

  methods: {
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    }
  },
  components: {
    'history-table': __WEBPACK_IMPORTED_MODULE_2__Temp_OneDayHistoryTableTemp___default.a
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getFile: function getFile() {
      return this.$parent.getFile;
    }
  }
});

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_HistoryTableTemp__ = __webpack_require__(2162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_HistoryTableTemp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Temp_HistoryTableTemp__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      tableIndex: 1
    };
  },
  mounted: function mounted() {},

  methods: {
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    }
  },
  components: {
    'history-table': __WEBPACK_IMPORTED_MODULE_2__Temp_HistoryTableTemp___default.a
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getFile: function getFile() {
      return this.$parent.getFile;
    }
  }
});

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      orderSn: ''
    };
  },
  mounted: function mounted() {},

  methods: {
    goToOneDatHistoryTable: function goToOneDatHistoryTable() {
      this.$router.push('/oneDayHistory/' + this.orderSn);
    }
  },
  components: {}
});

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Brand_StoreTable_vue__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Brand_StoreTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Brand_StoreTable_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      tableIndex: 1
    };
  },
  mounted: function mounted() {},

  methods: {
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    }
  },
  components: {
    'store-table': __WEBPACK_IMPORTED_MODULE_2__Brand_StoreTable_vue___default.a
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  }
});

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_0_vue_datepicker_vue_datepicker_es6_vue___default.a
  },
  data: function data() {
    return {
      total: 1,
      count: 31,
      historyList: [],
      tableIndex: 1,
      searchSelect: 1,
      storeId: this.$route.params.store_id,
      info: {
        brandId: '',
        brandName: '',
        storeId: '',
        storeName: ''
      },

      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: __WEBPACK_IMPORTED_MODULE_1_moment___default()().add(1, 'days').format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      startLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD')
      }],
      endLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_1_moment___default()().add(1, 'days').add(1, 'days').format('YYYY-MM-DD')
      }]
    };
  },

  methods: {
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    getRangeHistory: function getRangeHistory(index) {
      var self = this;
      var info = self.info;
      if (index) this.tableIndex = index;
      var date = {
        start: __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end: __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      };
      var url = 'history/rangeHistory' + '?start_date=' + date.start + '&end_date=' + date.end + '&store_id=' + this.storeId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.historyList = response.data.history_list;

          if (self.historyList.length) {
            for (var key in self.historyList) {
              info.brandId = self.historyList[key].brand_id;
              info.brandName = self.historyList[key].brand_name;
              info.storeId = self.historyList[key].store_id;
              info.storeName = self.historyList[key].store_name;
              break;
            }
          }
        }
      });
    },
    outputList: function outputList() {
      var date = {
        start: __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end: __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      };
      var url = 'history/rangeHistorySheets' + '?page=' + this.tableIndex + '&size=' + this.count + '&start_date=' + date.start + '&end_date=' + date.end + '&store_id=' + this.storeId;
      this.getFile('get', url, null, function (response) {
        var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        var objectUrl = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = objectUrl;
        a.download = 'report.xls';
        document.body.appendChild(a);
        a.click();
      });
    }
  },
  created: function created() {
    var date = new Date();
    var y = date.getFullYear();
    var m = date.getMonth();
    var firstDay = new Date(y, m, 1);
    this.menuTime.start.time = __WEBPACK_IMPORTED_MODULE_1_moment___default()(firstDay).format('YYYY-MM-DD');
    this.getRangeHistory();
  },

  watch: {
    'menuTime.end.time': function menuTimeEndTime() {
      var lastDay = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
      if (this.menuTime.start.time > lastDay) this.menuTime.start.time = lastDay;
      this.startLimit = [{
        type: 'fromto',
        to: lastDay
      }];
    },
    'menuTime.start.time': function menuTimeStartTime() {
      var lastDay = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.menuTime.start.time).add('31', 'days');
      if (lastDay < __WEBPACK_IMPORTED_MODULE_1_moment___default()()) this.menuTime.end.time = lastDay.format('YYYY-MM-DD');else this.menuTime.end.time = __WEBPACK_IMPORTED_MODULE_1_moment___default()().add(1, 'days').format('YYYY-MM-DD');
      this.endLimit = [{
        type: 'fromto',
        from: this.menuTime.start.time,
        to: this.menuTime.end.time
      }];
    }
  },
  computed: {
    getFile: function getFile() {
      return this.$parent.getFile;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  }
});

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      orderSn: this.$route.params.order_sn,
      total: 1,
      count: 20,
      historyList: [],
      tableIndex: 1,
      searchSelect: 1,
      storeId: this.$route.params.store_id,
      date: this.$route.params.date,
      info: {
        brandId: '',
        brandName: '',
        storeId: '',
        storeName: ''
      }
    };
  },

  methods: {
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    getDailyHistory: function getDailyHistory(index) {
      var self = this;
      var info = this.info;
      if (index) this.tableIndex = index;
      var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.date, 'YYYY-MM-DD').format('YYYYMMDD');
      var url = 'history/dailyHistory' + '?page=' + this.tableIndex + '&size=' + this.count + '&date=' + date + '&store_id=' + this.storeId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.historyList = response.data.history_list;
          self.total = response.data.total;
          if (self.historyList.length) {
            for (var key in self.historyList) {
              info.brandId = self.historyList[key].brand_id;
              info.brandName = self.historyList[key].brand_name;
              info.storeId = self.historyList[key].store_id;
              info.storeName = self.historyList[key].store_name;
              break;
            }
          }
        }
      });
    },
    getOrderHistory: function getOrderHistory() {
      var self = this;
      var info = this.info;
      var url = 'history/orderHistory/' + this.orderSn;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var historyList = [response.data.history];
          self.historyList = historyList;

          if (self.historyList.length) {
            info.brandId = self.historyList[0].brand_id;
            info.brandName = self.historyList[0].brand_name;
            info.storeId = self.historyList[0].store_id;
            info.storeName = self.historyList[0].store_name;
          }
        }
      });
    },
    outputList: function outputList() {
      var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.date, 'YYYY-MM-DD').format('YYYYMMDD');
      var url;
      var path = this.$route.name;
      if (path === 'oneDayHistory') url = 'history/orderHistorySheets/' + this.orderSn;else url = 'history/dailyHistorySheets' + '?page=' + this.tableIndex + '&size=' + this.count + '&date=' + date + '&store_id=' + this.storeId;
      this.getFile('get', url, null, function (response) {
        var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        var objectUrl = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = objectUrl;
        if (path === 'oneDayHistory') a.download = '單日店家所有拆帳.xls';else a.download = '單筆訂單拆帳.xls';
        document.body.appendChild(a);
        a.click();
      });
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      var path = this.$route.name;
      if (path === 'oneDayHistory') this.getOrderHistory();else this.getDailyHistory();
    }
  },
  created: function created() {
    var path = this.$route.name;
    if (path === 'oneDayHistory') this.getOrderHistory();else this.getDailyHistory();
  },

  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    },
    getFile: function getFile() {
      return this.$parent.getFile;
    }
  }
});

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Temp_LineNotifyTableTemp_vue__ = __webpack_require__(2165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Temp_LineNotifyTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Temp_LineNotifyTableTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Temp_StoreNotifyTableTemp_vue__ = __webpack_require__(2166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Temp_StoreNotifyTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Temp_StoreNotifyTableTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      tableIndex: 1
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#example1').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      });
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapActions */])(['setSelManagerId']), {
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    }
  }),
  components: {
    'line-notify-table': __WEBPACK_IMPORTED_MODULE_4__Temp_LineNotifyTableTemp_vue___default.a,
    'store-notify-table': __WEBPACK_IMPORTED_MODULE_5__Temp_StoreNotifyTableTemp_vue___default.a
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.setSelManagerId(0);
    next();
  }
});

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__elements_Modal_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'm-modal': __WEBPACK_IMPORTED_MODULE_4__elements_Modal_vue___default.a
  },
  data: function data() {
    return {
      count: 10,
      notifyList: [],
      show: {
        brand: false,
        menu: false,
        schedule: false,
        cr: true
      },
      type: '',
      selectRoleType: '',
      total: {},
      maxTotal: 0,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      delOption: {
        id: 'delModal',
        title: '刪除綁定',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delManager'
        }]
      },
      sendMsgOption: {
        id: 'sendMsgModal',
        title: '發送訊息',
        body: '確定發送通知訊息給此使用者？',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'sendMsg'
        }],
        input: {
          name: '訊息內容'
        }
      },
      lineUserId: '',
      lineUserName: '',
      toggleSelect: 1,
      managerId: '',
      current: {
        notify_ids: 0,
        manager_id: 0,
        name: ''
      },
      brandBrief: [],
      storeBrief: [],
      managerList: [],
      managerSelect: 99,
      selectManagerId: 99,

      binding: {
        brandSelect: 99,
        storeSelect: 99,
        methodSelect: 42,
        toggleSelect: 1,
        brandBrief: [],
        storeBrief: [],
        managerId: 0
      },
      send: {
        msg: '',
        notify_method: 42
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['setSelManagerId', 'setSelRoleType']), {
    trigger: function trigger(event) {
      if (event === 'delManager') {
        this.delBinding();
      } else if (event === 'sendMsg') {
        this.sendMsg();
      }
    },
    delBinding: function delBinding() {
      var self = this;
      var url = '/manager/' + self.selectRoleType + '/' + self.current.manager_id + '/notifyBinding?notify_ids=' + self.current.notify_ids;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.getNotifyBindingList(1);
        }
      });
    },
    showSelect: function showSelect(type) {
      if (this.selectRoleType === 'all') return true;else {
        if (this.selectRoleType === type) return true;else return false;
      }
    },
    getNotifyBindingList: function getNotifyBindingList(index) {
      this.tableIndex = index;
      this.notifyList = [];
      var self = this;
      var data = {
        page: this.tableIndex,
        count: this.count
      };
      var url = '/manager/' + self.selectRoleType + '/' + self.selectManagerId + '/notifyBinding/list?page=' + data.page + '&size=' + data.count;
      this.getDataH('get', url, data, function (response) {
        if (response.data.status === 200) {
          self.notifyList = response.data.notify_list;
          self.maxTotal = response.data.total;
        }
      });
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    isType: function isType(type) {
      if (this.selectRoleType === type) return true;else return false;
    },
    roleName: function roleName(type) {
      if (type === 'admin') {
        return '系統';
      } else if (type === 'brand') {
        return '品牌';
      } else if (type === 'store') {
        return '店家';
      }
    },
    notifyMethodName: function notifyMethodName(type) {
      if (type === 41) {
        return 'LineLogin';
      } else if (type === 42) {
        return 'LineNotify';
      }
    },
    getCurrent: function getCurrent(managerId, name, notifyId, notifyMethod) {
      this.current.manager_id = managerId;
      this.current.name = name;
      this.current.notify_ids = notifyId;
      this.send.notify_method = notifyMethod;
      this.delOption.body = '確定刪除 ' + name + ' ?<br>刪除此綁定，將無法收到通知！';
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    },
    bindLineId: function bindLineId() {
      var data = {
        manager_id: this.getUserId,
        mc_token: this.getToken,
        unique_key: '',
        alias_name: this.lineUserName
      };
      var dataJson = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
      var url = 'https://notify-bot.line.me/oauth/authorize?';
      url += 'response_type=code';
      url += '&client_id=wG3GONbq22mKz06g1kyIF0';
      url += '&redirect_uri=' + this.$config.baseURL + '/manager/lineNotifyCallback';
      url += '&scope=notify';
      url += '&state=' + encodeURI(dataJson);
      window.location.href = url;
    },
    toggleModal: function toggleModal(type, notify) {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#addNotifyModal').modal('toggle');
      this.lineUserId = '';
      this.lineUserName = '';
      this.toggleSelect = 1;
      this.managerId = '';
      if (type === 'cr') this.show.cr = true;else {
        this.lineUserId = notify.notify_id;
        this.managerId = notify.manager_id;
        this.lineUserName = notify.alias_name;
        this.toggleSelect = notify.toggle;
        this.show.cr = false;
      }
    },
    checkInput: function checkInput(type) {
      if (!this.lineUserName) {
        this.$notify({
          title: '提醒',
          text: '請輸入管理者名稱',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        if (type === 'cr') {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#addNotifyModal').modal('toggle');
          this.bindLineId();
        } else this.updateLineId();
      }
    },
    updateLineId: function updateLineId() {
      var self = this;
      var data = {
        notify_id: this.lineUserId,
        alias_name: this.lineUserName,
        toggle: this.toggleSelect
      };
      var url = '/manager/' + self.selectRoleType + '/' + self.managerId + '/notifyBinding';
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#addNotifyModal').modal('toggle');
          self.getNotifyBindingList(1);
        }
      });
    },
    storeCombine: function storeCombine(managerId) {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#addStoreNotifyModal').modal('toggle');
      this.binding.toggleSelect = 1;
      this.binding.managerId = managerId;
      this.show.cr = true;
    },
    crStoreCombine: function crStoreCombine() {
      var self = this;
      var url = '/store/' + this.binding.storeSelect + '/notifyBinding';
      var data = {
        notify_method: this.binding.methodSelect,
        manager_id: this.binding.managerId
      };
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#addStoreNotifyModal').modal('toggle');
        }
      });
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            self.brandBrief.push(obj);
            self.binding.brandBrief.push(obj);
            if (i === 0) self.binding.brandSelect = obj.value;
          }
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId, method) {
      if (!method) this.storeBrief = [];
      this.binding.storeBrief = [];
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            if (!method) {
              self.storeBrief.push(obj);
              self.binding.storeBrief.push(obj);
            } else self.binding.storeBrief.push(obj);
            if (i === 0) self.binding.storeSelect = obj.value;
          }
        }
      });
    },
    inputOnChange: function inputOnChange(value) {
      this.send.msg = value;
    },
    sendMsg: function sendMsg() {
      var self = this;
      var data = {
        notify_method: this.send.notify_method,
        message: this.send.msg
      };
      var url = '/manager/' + this.selectRoleType + '/' + this.current.manager_id + '/sendNotify';
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
        }
      });
    },
    getSubordinate: function getSubordinate() {
      var self = this;
      var url = '/manager/' + this.selectRoleType + '/' + this.selectManagerId + '/subordinate';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.managerList = [];
          var mList = response.data.subordinate.manager_list;
          for (var i = 0; i < mList.length; i++) {
            if (mList[i].manager_id !== parseInt(self.getUserId, 10)) self.managerList.push(mList[i]);
          }
        }
      });
    },
    getNewList: function getNewList(managerId) {
      var list = this.managerList.find(function (o) {
        return o.manager_id === parseInt(managerId, 10);
      });
      if (!list) {
        list = {
          manager_id: this.getUserId,
          name: '',
          role_type: parseInt(this.getRoleType, 10)
        };
      }
      if (list.role_type === 99) this.selectRoleType = 'admin';else if (list.role_type === 50) this.selectRoleType = 'pos';else if (list.role_type === 30) this.selectRoleType = 'brand';else if (list.role_type === 10) this.selectRoleType = 'store';
      this.selectManagerId = list.manager_id;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getRoleType', 'getUserId', 'getToken']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.maxTotal / this.count);
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    }
  }),
  created: function created() {
    this.fixedH();
    var roleType = parseInt(this.getRoleType, 10);
    if (roleType === 99) this.selectRoleType = 'admin';else if (roleType === 30) this.selectRoleType = 'brand';else if (roleType === 10) this.selectRoleType = 'store';
    this.selectManagerId = this.getUserId;
    this.getSubordinate();
    this.getBrandBrief();
  },

  watch: {
    'binding.brandSelect': function bindingBrandSelect() {
      this.getStoreBrief(this.binding.brandSelect, 'modal');
    },
    selectManagerId: function selectManagerId() {
      this.getNotifyBindingList(1);
      var managerId = this.selectManagerId;
      var roleType = this.selectRoleType;
      this.setSelManagerId(managerId);
      this.setSelRoleType(roleType);
    }
  }
});

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__elements_Modal_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'm-modal': __WEBPACK_IMPORTED_MODULE_3__elements_Modal_vue___default.a
  },
  data: function data() {
    return {
      count: 10,
      notifyList: [],
      show: {
        brand: false,
        menu: false,
        schedule: false
      },
      type: 'admin',
      selectRoleType: 'admin',
      total: {},
      maxTotal: 0,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      roleType: 0,
      brandBrief: [],
      storeBrief: [],
      brandSelect: 0,
      storeSelect: 0,

      binding: {
        brandSelect: 0,
        storeSelect: 0,
        methodSelect: 42,
        toggleSelect: 1,
        brandBrief: [],
        storeBrief: []
      },

      delOption: {
        id: 'delStoreModal',
        title: '刪除綁定',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delManager'
        }]
      },
      current: {
        alarm_id: 0,
        name: ''
      }
    };
  },

  methods: {
    trigger: function trigger(event) {
      if (event === 'delManager') {
        this.delBinding();
      }
    },
    delBinding: function delBinding() {
      var self = this;
      var url = '/store/' + self.storeSelect + '/notifyBinding?alarm_id=' + self.current.alarm_id;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.getNotifyBindingList(1);
        }
      });
    },
    showSelect: function showSelect(type) {
      if (this.selectRoleType === 'all') return true;else {
        if (this.selectRoleType === type) return true;else return false;
      }
    },
    getNotifyBindingList: function getNotifyBindingList(index) {
      this.tableIndex = index;
      this.notifyList = [];
      var self = this;
      var data = {
        page: this.tableIndex,
        count: this.count
      };
      var url = '/store/' + self.storeSelect + '/notifyBinding/list?page=' + data.page + '&size=' + data.count;
      this.getDataH('get', url, data, function (response) {
        if (response.data.status === 200) {
          self.notifyList = response.data.list;
          self.maxTotal = response.data.list_total;
        }
      });
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    isType: function isType(type) {
      if (this.selectRoleType === type) return true;else return false;
    },
    roleName: function roleName(type) {
      if (type === 'admin') {
        return '系統';
      } else if (type === 'brand') {
        return '品牌';
      } else if (type === 'store') {
        return '店家';
      }
    },
    notifyMethodName: function notifyMethodName(type) {
      if (type === 41) {
        return 'LineLogin';
      } else if (type === 42) {
        return 'LineNotify';
      }
    },
    targetTypeName: function targetTypeName(type) {
      if (type === 1) {
        return 'Shopper';
      } else if (type === 2) {
        return 'Manager';
      } else if (type === 3) {
        return 'POS';
      }
    },
    targetRoleName: function targetRoleName(type) {
      if (type === 1) {
        return '一般使用者';
      } else if (type === 10) {
        return '門市';
      } else if (type === 20) {
        return '經銷商';
      } else if (type === 30) {
        return '品牌';
      } else if (type === 40) {
        return '總公司';
      } else if (type === 50) {
        return 'POS廠';
      } else if (type === 99) {
        return '系統管理員';
      }
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    },
    getBrandBrief: function getBrandBrief(changeStore) {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            self.brandBrief.push(obj);
            self.binding.brandBrief.push(obj);
            if (i === 0) {
              if (changeStore && obj.value === self.brandSelect) self.getStoreBrief(self.brandSelect);
              self.brandSelect = obj.value;
            }
          }
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId, method) {
      this.storeBrief = [];
      this.binding.storeBrief = [];
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            if (!method) {
              self.storeBrief.push(obj);
              self.binding.storeBrief.push(obj);
            } else self.binding.storeBrief.push(obj);
            if (i === 0) {
              if (!method) self.storeSelect = obj.value;else self.binding.storeSelect = obj.value;
              if (self.brandSelect === self.binding.brandSelect) self.binding.storeSelect = self.storeSelect;
            }
          }
        }
      });
    },
    toggleModal: function toggleModal(type, notify) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#editStoreNotifyModal').modal('toggle');
      this.binding.brandSelect = '';
      this.binding.storeSelect = '';
      this.binding.toggleSelect = 1;
      if (type === 'cr') {
        this.binding.brandSelect = this.brandSelect;
        this.binding.storeSelect = this.storeSelect;
        this.show.cr = true;
      } else {
        this.binding.brandSelect = this.brandSelect;
        this.binding.storeSelect = this.storeSelect;
        this.binding.toggleSelect = notify.toggle;
        this.current = {
          alarm_id: notify.alarm_id,
          name: notify.name
        };
        this.show.cr = false;
      }
    },
    notifyBinding: function notifyBinding(type) {
      var self = this;
      var url = '/store/' + this.binding.storeSelect + '/notifyBinding';
      var data = void 0;
      if (type === 'cr') {
        data = {
          notify_method: this.binding.methodSelect,
          manager_id: this.getUserId
        };
      } else {
        data = {
          alarm_id: this.current.alarm_id,
          toggle: this.binding.toggleSelect
        };
      }
      var method = void 0;
      if (type === 'cr') method = 'post';else method = 'put';
      this.getDataH(method, url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#editStoreNotifyModal').modal('toggle');
          self.getNotifyBindingList(1);
        }
      });
    },
    getCurrent: function getCurrent(alarmId, name) {
      this.current.alarm_id = alarmId;
      this.current.name = name;
      this.delOption.body = '確定刪除 ' + name + ' ?<br>刪除此綁定，將無法收到通知！';
    },
    getSubordinate: function getSubordinate() {
      this.brandBrief = [];
      this.binding.brandBrief = [];
      this.storeBrief = [];
      this.binding.storeBrief = [];
      var self = this;
      var url = '/manager/' + this.getSelRoleType + '/' + this.getSelManagerId + '/subordinate';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.subordinate.binding_brand_list;
          var sList = response.data.subordinate.store_list;
          if (bList) {
            for (var i = 0; i < bList.length; i++) {
              var obj = { label: bList[i].brand_name, value: bList[i].brand_id };
              self.brandBrief.push(obj);
              self.binding.brandBrief.push(obj);
              if (i === 0) {
                if (obj.value === self.brandSelect) self.getStoreBrief(self.brandSelect);
                self.brandSelect = obj.value;
              }
            }
          } else if (sList) {
            for (var j = 0; j < sList.length; j++) {
              var ssList = sList[j].binding_store_list;
              for (var k = 0; k < ssList.length; k++) {
                var _obj = { label: ssList[k].store_name, value: ssList[k].store_id };
                self.storeBrief.push(_obj);
                self.binding.storeBrief.push(_obj);
                if (j === 0 && k === 0) {
                  if (_obj.value === self.storeSelect) self.getNotifyBindingList(1);
                  self.storeSelect = _obj.value;
                }
              }
            }
          } else self.getBrandBrief(true);
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getRoleType', 'getUserId', 'getSelRoleType', 'getSelManagerId']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.maxTotal / this.count);
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    },
    brandSelectShow: function brandSelectShow() {
      return this.brandBrief.length > 1 && this.$route.name !== 'storeInfo';
    },
    storeSelectShow: function storeSelectShow() {
      return this.brandSelect !== 0 && this.brandSelect !== '0' && this.storeBrief.length >= 1;
    }
  }),
  created: function created() {
    this.fixedH();
    this.roleType = parseInt(this.getRoleType, 10);
  },

  watch: {
    brandSelect: function brandSelect() {
      this.getStoreBrief(this.brandSelect);
    },
    storeSelect: function storeSelect() {
      this.getNotifyBindingList(1);
    },
    'binding.brandSelect': function bindingBrandSelect() {},
    getSelManagerId: function getSelManagerId() {
      if (this.getSelRoleType && this.getSelManagerId) this.getSubordinate();
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.setSelManagerId('');
    next;
  }
});

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_ActivityInfo_vue__ = __webpack_require__(2176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_ActivityInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_ActivityInfo_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'activity-info': __WEBPACK_IMPORTED_MODULE_0__Temp_ActivityInfo_vue___default.a
  },
  data: function data() {
    return {
      info: {
        attend_stores: [],
        give_coupons: [],
        strategy_data: {},
        info: {}
      }
    };
  },

  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    },
    getFile: function getFile() {
      return this.$parent.getFile;
    }
  },
  created: function created() {
    this.getActivity();
  },

  methods: {
    getActivity: function getActivity() {
      var self = this;
      var url = 'activity/' + this.$route.params.activity_id + '/orderCouponComplete';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.info = response.data;
        }
      });
    }
  }
});

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_ActivityForm_vue__ = __webpack_require__(2175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_ActivityForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_ActivityForm_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'activity-form': __WEBPACK_IMPORTED_MODULE_0__Temp_ActivityForm_vue___default.a
  },
  data: function data() {
    return {
      info: {
        attend_stores: [],
        give_coupons: [],
        strategy_data: {},
        info: {}
      }
    };
  },

  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    }
  },
  created: function created() {
    if (this.$route.name === 'upActivity') this.getActivity();
  },

  methods: {
    getActivity: function getActivity() {
      var self = this;
      var url = 'activity/' + this.$route.params.activity_id + '/orderCouponComplete';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.info = response.data;
        }
      });
    }
  }
});

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      roleType: 0,
      brandBrief: [],
      storeBrief: [],
      brandSelect: 999999,
      storeSelect: 999999,
      ruleCodeSelect: 999999,
      timeMethodSelect: 999999,
      statusSelect: 999999,
      sTimeMethodSelect: 999999,
      couponList: [],
      total: 1,
      count: 20,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      current: {
        store_list: [],
        name: ''
      },
      preSortMethod: [],
      sortToggle: false,
      sortMethod: ''
    };
  },
  mounted: function mounted() {},

  methods: {
    getRuleName: function getRuleName(ruleCode) {
      switch (ruleCode) {
        case 'SA00001':
          return '消費滿X元贈送Y張優惠券';
        case 'SA00002':
          return '消費滿X個贈送Y張優惠券';
        case 'SA00003':
          return '買指定商品贈送Y張優惠券';
      }
    },
    getDate: function getDate(datetime) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(datetime, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
    },
    checkSort: function checkSort(method) {
      this.sortMethod = method;
      if (this.preSortMethod.length) {
        if (method === this.preSortMethod[0]) this.sortToggle = !this.sortToggle;else {
          this.tableIndex = 1;
          this.sortToggle = false;
        }
        this.preSortMethod.splice(0, 1);
      } else this.sortToggle = false;
      this.preSortMethod.push(method);
      this.getAttendCoupon();
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            self.brandBrief.push(obj);
            if (i === 0) self.brandSelect = obj.value;
          }
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      this.storeBrief = [{ label: '==門市==', value: 999999 }];
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
            if (i === 0 && self.getRoleType === 10) {
              self.storeSelect = obj.value;
            } else if (i === 0) self.storeSelect = 999999;
          }
          if (!sList.length) {
            self.couponList = [];
            self.total = 0;
          }
          self.getAttendCoupon();
        }
      });
    },
    getAttendCoupon: function getAttendCoupon() {
      var self = this;
      var url = '/activity/orderCouponListForAttend?page=' + this.tableIndex + '&size=' + this.count + '&attend_brand_id=' + this.brandSelect;
      if (this.storeSelect !== 999999) url = url + '&attend_store_id=' + this.storeSelect;
      if (this.ruleCodeSelect !== 999999) url = url + '&rule_code=' + this.ruleCodeSelect;
      if (this.timeMethodSelect !== 999999) url = url + '&time_method=' + this.timeMethodSelect;
      if (this.statusSelect !== 999999) url = url + '&status=' + this.statusSelect;
      if (this.sTimeMethodSelect !== 999999) url = url + '&strategy_time_method=' + this.sTimeMethodSelect;
      if (this.sortMethod) {
        url = url + '&list_sort=' + this.sortMethod + ' ';
        if (this.sortToggle) url = url + 'ASC';else url = url + 'DESC';
      }
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.couponList = response.data.list;
          self.total = response.data.list_total;
        }
      });
    },
    clickCurrent: function clickCurrent(menu) {
      this.current = menu;
    },
    clickGroup: function clickGroup(type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1;
        this.tableIndex = this.groupAmount * this.pageGroup;
        this.clickPage(this.tableIndex);
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1;
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1;
        this.clickPage(this.tableIndex);
      }
    },
    clickEnd: function clickEnd(type) {
      if (type === 'pre') {
        this.clickPage(1);
        this.pageGroup = 1;
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount);else this.clickPage(1);
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount);
      }
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      if (index === 1) this.pageGroup = 1;
      this.getAttendCoupon();
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  }),
  created: function created() {
    this.roleType = parseInt(this.getRoleType, 10);
    this.fixedH();
    this.getBrandBrief();
  },

  watch: {
    brandSelect: function brandSelect() {
      this.getStoreBrief(this.brandSelect);
    },
    storeSelect: function storeSelect() {
      this.getAttendCoupon();
    }
  }
});

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_ActivityBuyForm_vue__ = __webpack_require__(2174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_ActivityBuyForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_ActivityBuyForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Temp_ActivityRegisterForm_vue__ = __webpack_require__(2178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Temp_ActivityRegisterForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Temp_ActivityRegisterForm_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'activity-buy-form': __WEBPACK_IMPORTED_MODULE_0__Temp_ActivityBuyForm_vue___default.a,
    'activity-register-form': __WEBPACK_IMPORTED_MODULE_1__Temp_ActivityRegisterForm_vue___default.a
  },
  data: function data() {
    return {
      activityMethod: 1
    };
  },

  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  }
});

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a,
    'm-modal': __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue___default.a
  },
  data: function data() {
    return {
      isChart: false,
      searchStoreId: '',
      scheduleMethod: 1,
      menuState: 4,
      name: '迷客夏',
      total: 1,
      count: 10,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      menuList: [{ store_id: 1, store_name: '長春店', menu_name: '夏日菜單', menu_id: '1', status: 3, start_time: '2018/01/01', end_time: '2018/12/31' }, { store_id: 1, store_name: '中山店', menu_name: '夏日菜單', menu_id: '1', status: 3, start_time: '2018/01/01', end_time: '2018/12/31' }, { store_id: 1, store_name: '雙連店', menu_name: '菜單B', menu_id: '3', status: 3, start_time: '2018/01/01', end_time: '2018/12/31' }, { store_id: 1, store_name: '光復店', menu_name: '菜單A', menu_id: '2', status: 3, start_time: '2018/01/01', end_time: '2018/12/31' }, { store_id: 1, store_name: '民權西路店', menu_name: '菜單B', menu_id: '3', status: 3, start_time: '2018/01/01', end_time: '2018/12/31' }, { store_id: 1, store_name: '晶華店', menu_name: '菜單C', menu_id: '4', status: 3, start_time: '2018/01/01', end_time: '2018/12/31' }],
      info: {
        menuName: '夏日菜單',
        menu_id: 123323,
        start_time: '2017-03-31 12:22:32',
        end_time: '2017-03-31 12:22:32',
        update_time: '2017-03-31 12:22:32',
        create_time: '2017-03-31 12:22:32'
      },
      menu_schedule_list: [],
      scheduleList: [],
      curGroup: '',
      curSchedule: '',
      delMOption: {
        id: 'delModal',
        title: '刪除行銷',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delMarketing'
        }]
      },
      delAOption: {
        id: 'delModal',
        title: '刪除活動',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delActivity'
        }]
      },
      removeGNowOption: {
        id: 'removeGNowModal',
        title: '檔期群組下架',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'removeGNow'
        }]
      },
      saleGNowOption: {
        id: 'saleGNowModal',
        title: '檔期群組上架',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'saleGNow'
        }]
      },
      removeNowOption: {
        id: 'removeNowModal',
        title: '店家檔期下架',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'removeGNow'
        }]
      },
      saleNowOption: {
        id: 'delModal',
        title: '店家檔期上架',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'saleGNow'
        }]
      },

      brandBrief: [],
      storeBrief: [],
      brandSelect: { label: '== 所有品牌 ==', value: 0 },
      storeSelect: { label: '== 所有門市 ==', value: 0 },
      ownerTypeSelect: { label: '== 舉辦者類型 ==', value: 99 },
      ownerTypeList: [],
      statusSelect: { label: '== 行銷狀態 ==', value: 99 },
      timeMethodSelect: { label: '== 行銷時間狀態 ==', value: 99 },
      timeMethodList: [{ label: '== 行銷時間狀態 ==', value: 99 }, { label: '未開始', value: 'notyet' }, { label: '進行中', value: 'going' }, { label: '已結束', value: 'end' }],
      marketingList: [],
      curStoreId: '',
      ownerId: '',
      activityList: [],
      curMarketingId: '',
      curActivityId: '',
      isLoading: true
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {});
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['setBrandId', 'setStoreId']), {
    setMarketing: function setMarketing(marketingId) {
      this.curMarketingId = marketingId;
    },
    setActivity: function setActivity(activityId) {
      this.curActivityId = activityId;
    },
    search: function search() {
      if (this.ownerId || this.ownerTypeSelect.value === 99 || this.ownerTypeSelect.value === 1) this.getMarketing(1);
    },
    ownerTypeName: function ownerTypeName(type) {
      switch (type) {
        case 1:
          return '平台';
        case 2:
          return '品牌';
        case 3:
          return '門市';
      }
    },
    changeBrand: function changeBrand(input) {
      var self = this;
      this.storeBrief = [];
      this.storeSelect = [];
      this.select;
      var brandId = input.value;
      if (input.value !== 99 && input.value !== 0) {
        self.getStoreBrief(brandId);
      }
      if (typeof input.value !== 'undefined') {
        if (this.scheduleMethod === 1) this.getMarketing(1);else this.getActivity(1);
      }
    },
    changeSelect: function changeSelect(input) {
      if (typeof input.value !== 'undefined') {
        if (this.scheduleMethod === 1) this.getMarketing(1);else this.getActivity(1);
      }
    },
    changeStore: function changeStore(input) {
      if (typeof input.value !== 'undefined') {
        if (this.scheduleMethod === 1) this.getMarketing(1);else this.getActivity(1);
      }
    },
    changeOwnerType: function changeOwnerType(input) {
      if (typeof input.value !== 'undefined') {
        if (this.scheduleMethod === 1) this.getMarketing(1);else this.getActivity(1);
      }
    },
    clickGroup: function clickGroup(type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1;
        this.tableIndex = this.groupAmount * this.pageGroup;
        this.clickPage(this.tableIndex);
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1;
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1;
        this.clickPage(this.tableIndex);
      }
    },
    clickEnd: function clickEnd(type) {
      if (type === 'pre') {
        this.clickPage(1);
        this.pageGroup = 1;
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount);else this.clickPage(1);
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount);
      }
    },
    getTime: function getTime(time) {
      if (time) {
        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(time, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm');
      }
    },
    trigger: function trigger(event) {
      if (event === 'delMarketing') {
        this.delMarketing();
      } else if (event === 'delActivity') {
        this.delActivity();
      }
    },
    delMarketing: function delMarketing() {
      var self = this;
      var url = '/promotion/' + this.curMarketingId;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '刪除行銷成功',
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.getMarketing();
        }
      });
    },
    delActivity: function delActivity() {},
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      if (this.scheduleMethod === 1) this.getMarketing();else if (this.scheduleMethod === 2) this.getActivity();
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          if (self.roleType === 99) {
            var defaultBrand = { label: '== 所有品牌 ==', value: 0 };
            self.brandBrief.push(defaultBrand);
            self.brandSelect = defaultBrand;
          }
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            self.brandBrief.push(obj);
            if (self.roleType === 30 && i === 0) {
              self.brandSelect = obj;
              self.setBrandId(obj.value);
            } else if (self.roleType === 10 && i === 0) {
              self.brandSelect = obj;
              self.getStoreBrief(self.brandSelect.value);
            }
          }
          if ((self.roleType === 30 || self.roleType === 99) && self.scheduleMethod === 1) self.getMarketing(1);
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      this.storeBrief = [];
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          if (self.roleType !== 10) self.storeBrief.push({ label: '== 所有門市 ==', value: 0 });
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
            if (i === 0) {
              self.curStoreId = sList[i].store_id;
              if (self.roleType === 10) self.setStoreId(self.curStoreId);
            }
          }
        }
      });
    },
    getMarketing: function getMarketing(page) {
      this.isLoading = true;
      var self = this;
      if (page) {
        this.tableIndex = page;
        if (page === 1) this.pageGroup = 1;
      }
      var roleType = self.roleType;
      var url = '/promotion/list?';
      var data = {
        page: this.tableIndex,
        size: this.count,
        type: 1
      };

      if (roleType === 10) {
        this.data.owner_type = 3;
      } else if ((roleType === 30 || roleType === 99) && self.ownerTypeSelect.value !== 99) {
        data.owner_type = self.ownerTypeSelect.value;
      }

      if (this.brandSelect.value) {
        if (roleType === 30) data.brand_id = this.brandSelect.value;else if (roleType === 99 && this.brandSelect.value !== 0) data.brand_id = this.brandSelect.value;
      }

      if (this.storeSelect.value) {
        if ((roleType === 99 || roleType === 30) && this.storeSelect.value !== 0) data.store_id = this.storeSelect.value;else if (roleType === 10) data.store_id = this.storeSelect.value;
      }

      var status = [{ label: '== 行銷狀態 ==', value: 99 }, { label: '未發佈', value: 0 }, { label: '已發佈', value: 4 }, { label: '已下架', value: 9 }];
      if (this.statusSelect.value !== 99 && status.find(function (o) {
        return o.value === self.statusSelect.value;
      })) data.status = this.statusSelect.value;

      if (this.timeMethodSelect.value !== 99 && this.timeMethodSelect.value) data.time_method = this.timeMethodSelect.value;
      for (var key in data) {
        url = url + key + '=' + data[key] + '&';
      }
      url = url.slice(0, -1);
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.marketingList = response.data.list;
          self.total = response.data.list_total;
          self.isLoading = false;
        }
      });
    },
    getActivity: function getActivity(page) {
      var self = this;
      if (page) {
        this.tableIndex = page;
        if (page === 1) this.pageGroup = 1;
      }
      var url = '/activity/list?';
      var roleType = this.roleType;
      var data = {
        page: this.tableIndex,
        size: this.count
      };

      if (this.timeMethodSelect.value !== 99 && this.timeMethodSelect.value) data.time_method = this.timeMethodSelect.value;

      var status = [{ label: '== 活動狀態 ==', value: 99 }, { label: '初始化', value: 0 }, { label: '編輯中', value: 1 }, { label: '待上架', value: 3 }, { label: '已上架', value: 4 }, { label: '已下架', value: 5 }];
      if (this.statusSelect.value !== 99 && status.find(function (o) {
        return o.value === self.statusSelect.value;
      })) data.status = this.statusSelect.value;

      if (roleType === 99 && typeof this.brandSelect.value !== 'undefined' && this.brandSelect.value !== 0) data.brand_id = this.brandSelect.value;else if (roleType === 30) data.brand_id = this.brandSelect.value;

      if (this.storeSelect.value) {
        if ((roleType === 99 || roleType === 30) && this.storeSelect.value !== 0) data.store_id = this.storeSelect.value;else if (roleType === 10) data.store_id = this.storeSelect.value;
      }

      if (roleType === 10) {
        this.data.owner_type = 3;
      } else if ((roleType === 30 || roleType === 99) && self.ownerTypeSelect.value !== 99) {
        data.owner_type = self.ownerTypeSelect.value;
      }

      for (var key in data) {
        url = url + key + '=' + data[key] + '&';
      }
      url = url.slice(0, -1);
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.activityList = response.data.list;
          self.total = response.data.list_total;
        }
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getRoleType']), {
    statusList: function statusList() {
      if (this.scheduleMethod === 2) {
        return [{ label: '== 活動狀態 ==', value: 99 }, { label: '初始化', value: 0 }, { label: '編輯中', value: 1 }, { label: '待上架', value: 3 }, { label: '已上架', value: 4 }, { label: '已下架', value: 5 }];
      } else {
        return [{ label: '== 行銷狀態 ==', value: 99 }, { label: '未發佈', value: 0 }, { label: '已發佈', value: 4 }, { label: '已下架', value: 9 }];
      }
    },
    scheduleListNew: function scheduleListNew() {
      var menuList = {};
      var oldList = this.menu_schedule_list;
      for (var key in oldList) {
        menuList[oldList[key].menu_id] = {
          menu_id: oldList[key].menu_id,
          storeList: []
        };
      }
      for (var k in oldList) {
        menuList[oldList[k].menu_id].storeList.push({
          store_id: oldList[k].store_id,
          store_name: oldList[k].store_name,
          start_time: oldList[k].start_time,
          end_time: oldList[k].end_time,
          status: oldList[k].status,
          update_time: oldList[k].update_time,
          create_time: oldList[k].create_time,
          schedule_id: oldList[k].schedule_id,
          menu_id: oldList[key].menu_id
        });
      }
      return menuList;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    },
    searchPlaceholder: function searchPlaceholder() {
      var value = this.ownerTypeSelect.value;
      switch (value) {
        case 99:
        case 1:
          return '不用填入';
        case 2:
          return '請填入品牌id';
        case 3:
          return '請填入門市id';
      }
    }
  }),
  watch: {
    menuState: function menuState() {
      this.tableIndex = 1;
      this.pageGroup = 1;
    },
    scheduleMethod: function scheduleMethod() {
      this.tableIndex = 1;
      this.pageGroup = 1;
      if (this.scheduleMethod === 1) this.statusSelect = { label: '== 行銷狀態 ==', value: 99 };
      if (this.scheduleMethod === 2) this.statusSelect = { label: '== 活動狀態 ==', value: 99 };
      this.clickPage(1);
      window.sessionStorage.setItem('Nidin_marketing_table', this.scheduleMethod);
    },
    '$route.name': function $routeName() {
      if (this.$route.name === 'marketingChart') this.isChart = true;else this.isChart = false;
    }
  },
  created: function created() {
    this.roleType = parseInt(this.getRoleType, 10);
    var sMethod = window.sessionStorage.getItem('Nidin_marketing_table');
    if (sMethod) this.scheduleMethod = parseInt(sMethod, 10);
    this.getBrandBrief();
    if (this.$route.name === 'marketingChart') this.isChart = true;
    if (this.roleType === 99) {
      this.ownerTypeList = [{ label: '== 舉辦者類型 ==', value: 99 }, { label: '平台', value: 1 }, { label: '品牌', value: 2 }, { label: '門市', value: 3 }];
    } else if (this.roleType === 30) {
      this.ownerTypeList = [{ label: '== 舉辦者類型 ==', value: 99 }, { label: '品牌', value: 2 }, { label: '門市', value: 3 }];
    }
  }
});

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_datepicker_index_css__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_datepicker_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_datepicker_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_spinner_src_ClipLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_spinner_src_ClipLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_js_shared_token_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(3);














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'OperatingChart',
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker__["a" /* default */],
    'Clip': __WEBPACK_IMPORTED_MODULE_7_vue_spinner_src_ClipLoader_vue___default.a
  },
  data: function data() {
    return {
      roleType: 0,
      selectTab: 'daily',
      isChangeBrand: false,
      brandBrief: [],
      storeBrief: [],
      brandSelect: { label: '== 品牌 ==', value: 0 },
      storeSelect: { label: '== 門市 ==', value: 0 },

      dailySearch: {
        start_date: null,
        end_date: null,
        data: {}
      },

      month: 0,

      monthlyOptions: [],

      monthlySearch: {
        start_date: null,
        end_date: null,
        data: {}
      },

      tableSearch: {
        start_date: null,
        end_date: null
      },

      chartData: {
        labels: [],
        amount: [],
        money: []
      },
      tableData: {},
      tableMeta: {},
      paginate: {
        count: 10,
        total: 0,
        tableIndex: 1,
        groupAmount: 10
      },
      amountChart: null,
      moneyChart: null,
      isDownloading: false,
      storesInfo: []
    };
  },

  filters: {
    date: function date(data) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(data).format('MM/DD');
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getFile: function getFile() {
      return this.$parent.getFile;
    },
    maxEndMonth: function maxEndMonth() {
      var lastMonth = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.monthlySearch.start_date).add('23', 'months').format('YYYY-MM');
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()().isBefore(lastMonth) ? __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM') : lastMonth;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.paginate.total / this.paginate.count);
    },
    ein: function ein() {
      var _this = this;

      if (this.storeSelect.value) {
        return this.storesInfo.filter(function (x) {
          return x.store_id === _this.storeSelect.value;
        })[0].ein;
      }
      return '';
    },
    storeName: function storeName() {
      var _this2 = this;

      if (this.storeSelect.value) {
        return this.storesInfo.filter(function (x) {
          return x.store_id === _this2.storeSelect.value;
        })[0].bl_name;
      }
      return '';
    }
  }),
  created: function created() {
    this.roleType = parseInt(this.getRoleType, 10);
    this.getBrandBrief();
    this.initDate();
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapActions */])(['setBrandId', 'setStoreId']), {
    isActive: function isActive(index) {
      if (this.paginate.tableIndex === index) return true;else return false;
    },
    initDate: function initDate() {
      this.dailySearch.start_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(15, 'days').format('YYYY-MM-DD');
      this.dailySearch.end_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, 'days').format('YYYY-MM-DD');

      this.monthlySearch.start_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(6, 'months').format('YYYY-MM');
      this.monthlySearch.end_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM');

      this.tableSearch.start_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(20, 'days').format('YYYY-MM-DD');
      this.tableSearch.end_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, 'days').format('YYYY-MM-DD');
    },
    maxEndDate: function maxEndDate(type) {
      var startDate = type === 'chart' ? 'dailySearch' : 'tableSearch';
      var yesterDay = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, 'days').format('YYYY-MM-DD');
      var lastDay = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this[startDate].start_date).add(type === 'chart' ? '365' : '180', 'days').format('YYYY-MM-DD');
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(yesterDay).isBefore(lastDay) ? yesterDay : lastDay;
    },
    setDate: function setDate(type) {
      switch (type) {
        case 'year':
          this.monthlySearch.start_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(12, 'months').format('YYYY-MM');
          this.monthlySearch.end_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM');
          break;
        case 'month':
          this.dailySearch.start_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(30, 'days').format('YYYY-MM-DD');
          this.dailySearch.end_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, 'days').format('YYYY-MM-DD');
          break;
        case 'week':
          this.dailySearch.start_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(7, 'days').format('YYYY-MM-DD');
          this.dailySearch.end_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, 'days').format('YYYY-MM-DD');
          break;
      }
      this.searchOrderSummary();
    },
    changeBrand: function changeBrand(input) {
      this.storeBrief = [];
      this.storeSelect = [];
      this.paginate.tableIndex = 1;
      var brandId = input.value;
      if (input.value !== 99 && input.value !== 0) {
        this.getStoreBrief(brandId);
      }
      if (typeof input.value !== 'undefined') {
        this.isChangeBrand = true;
        this.dailySearch.data = [];
        this.monthlySearch.data = [];
        this.searchOrderSummary();
        this.searchTable();
      }
    },
    changeStore: function changeStore(input) {
      this.paginate.tableIndex = 1;
      if (typeof input.value !== 'undefined' && !this.isChangeBrand) {
        this.dailySearch.data = [];
        this.monthlySearch.data = [];
        this.searchOrderSummary();
        this.searchTable();
      }
      this.isChangeBrand = false;
    },
    changeMonth: function changeMonth() {
      this.showOrderChart(this.dailySearch.data[this.month]);
    },
    getBrandBrief: function getBrandBrief() {
      var _this3 = this;

      this.brandBrief = [];
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;

          if (bList.length > 1) {
            if ([99, 30].includes(_this3.roleType)) {
              var defaultBrand = { label: '== 品牌 ==', value: 0 };
              _this3.brandBrief.push(defaultBrand);
              _this3.brandSelect = defaultBrand;
              for (var i = 0; i < bList.length; i++) {
                var obj = { label: bList[i].name, value: bList[i].brand_id };
                _this3.brandBrief.push(obj);
              }
              _this3.searchOrderSummary();
              _this3.searchTable();
            }
          } else if (bList.length === 1) {
            if ([10, 30].includes(_this3.roleType)) {
              var val = bList[0].brand_id;
              _this3.getStoreBrief(val, true);
              _this3.setBrandId(val);
            }
          }
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      var _this4 = this;

      var first = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.storeBrief = [];
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          if (sList.length > 1) {
            _this4.storeBrief.push({ label: '== 所有門市 ==', value: 0 });
            for (var i = 0; i < sList.length; i++) {
              var obj = { label: sList[i].name, value: sList[i].store_id };
              _this4.storeBrief.push(obj);
            }
          }
          if (_this4.roleType !== 99 && first) {
            _this4.searchOrderSummary();
            _this4.searchTable();
          }
          if (_this4.roleType === 10) {
            _this4.setStoreId(_this4.storeSelect.value);
          }
          _this4.storesInfo = sList;
        }
      });
    },
    setMonthSelectOptions: function setMonthSelectOptions(start, end) {
      this.monthlyOptions = [];
      var startMonth = start + '/01';
      var endMonth = end + '/01';
      var year = 0;

      while (__WEBPACK_IMPORTED_MODULE_3_moment___default()(startMonth).isSameOrBefore(endMonth)) {
        if (year && year !== __WEBPACK_IMPORTED_MODULE_3_moment___default()(startMonth).year()) {
          this.monthlyOptions.push({
            value: null,
            name: '--' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(startMonth).year() + '--',
            disable: true
          });
        }
        this.monthlyOptions.push({
          value: '' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(startMonth).format('YYYY-MM'),
          name: __WEBPACK_IMPORTED_MODULE_3_moment___default()(startMonth).month() + 1 + ' \u6708',
          disable: false
        });
        year = __WEBPACK_IMPORTED_MODULE_3_moment___default()(startMonth).year();
        startMonth = __WEBPACK_IMPORTED_MODULE_3_moment___default()(startMonth).add(1, 'months');
      }
      this.month = this.monthlyOptions[0].value || 0;
    },
    setQuery: function setQuery(type) {
      var changeTable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var name = changeTable ? 'tableMeta' : type + 'Search';
      var query = {
        start_date: this[name].start_date.replace(/-/g, ''),
        end_date: this[name].end_date.replace(/-/g, '')
      };
      switch (type) {
        case 'table':
          query.list_type = 'daily';
          break;
        case 'daily':
          query.list_type = 'daily_group_by_month';
          break;
        case 'monthly':
          query.list_type = 'monthly';
          break;
      }
      if (this.brandSelect.value && this.roleType !== 10) query.brand_ids = this.brandSelect.value;
      if (this.storeSelect.value) query.store_ids = this.storeSelect.value;

      return query;
    },
    searchOrderSummary: function searchOrderSummary() {
      var _this5 = this;

      var switchTab = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var query = this.setQuery(this.selectTab);
      var searchParams = new URLSearchParams(query);
      var url = '/statistic/orderSummary?' + searchParams.toString();
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var start = response.data.meta.start_date;
          var end = response.data.meta.end_date;
          if (!switchTab && _this5.selectTab === 'daily' && start && end) {
            _this5.setMonthSelectOptions(__WEBPACK_IMPORTED_MODULE_3_moment___default()(start).format('YYYY/MM'), __WEBPACK_IMPORTED_MODULE_3_moment___default()(end).format('YYYY/MM'));
          }

          _this5[_this5.selectTab + 'Search'].data = response.data.list;
          var list = _this5.selectTab === 'daily' ? response.data.list[_this5.month] : response.data.list;
          _this5.showOrderChart(list);
        }
      });
    },
    searchTable: function searchTable() {
      var _this6 = this;

      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var query = this.setQuery('table', type === 'changePage');
      var pageObj = {
        return_type: 'page',
        page: this.paginate.tableIndex || 1,
        size: this.paginate.count || 10
      };
      query = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, query, pageObj);
      var searchParams = new URLSearchParams(query);
      var url = '/statistic/orderSummary?' + searchParams.toString();
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this6.tableData = response.data.list;
          _this6.tableMeta = response.data.meta;
          _this6.paginate.total = response.data.meta.total;
          _this6.paginate.tableIndex = response.data.meta.page;
          _this6.paginate.count = response.data.meta.size;
        }
      });
    },
    showOrderChart: function showOrderChart() {
      var _this7 = this;

      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      for (var key in this.chartData) {
        this.chartData[key] = [];
      }

      for (var i in list) {
        var date = list[i].date;
        if (this.selectTab === 'daily') {
          date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format('MM/DD');
        } else {
          date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format('YYYY/MM');
        }
        this.chartData.labels.push(date);
        this.chartData.amount.push(list[i].order_amount_accepted);
        this.chartData.money.push(list[i].order_money_accepted);
      }

      this.$nextTick(function () {
        var type = ['amount', 'money'];
        type.forEach(function (item) {
          if (_this7[item + 'Chart'] !== null) {
            _this7[item + 'Chart'].destroy();
          }

          var ctx = document.getElementById(item + '-chart').getContext('2d');
          var config = {
            type: 'line',
            data: {
              labels: _this7.chartData.labels,
              datasets: [{
                label: item === 'amount' ? '訂單數量' : '訂單金額',
                data: _this7.chartData[item],
                fill: false,
                borderColor: '#dd4b39',
                pointBackgroundColor: '#dd4b39',
                tension: 0.3
              }]
            },
            options: {
              responsive: true,
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  display: true,
                  ticks: {
                    min: 0
                  }
                }]
              }
            }
          };
          _this7[item + 'Chart'] = new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a(ctx, config);
        });
      });
    },
    exportFile: function exportFile(type) {
      var _this8 = this;

      this.isDownloading = true;
      var query = type === 'table' ? this.setQuery('table', true) : this.setQuery(this.selectTab);
      var searchParams = new URLSearchParams(query);
      var url = '/statistic/orderSummarySheets?' + searchParams.toString();
      this.getFile('get', url, null, function (response) {
        _this8.isDownloading = false;
        var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        var objectUrl = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = objectUrl;
        a.download = '\u8A02\u55AE\u5217\u8868_' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(query.start_date).format('YYYYMMDD') + '_' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(query.end_date).format('YYYYMMDD') + '.xlsx';
        document.body.appendChild(a);
        a.click();
      });
    },
    startDateLimit: function startDateLimit(date) {
      return date > __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, 'days');
    },
    endDateLimit: function endDateLimit(date) {
      return date > __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.maxEndDate('chart')) || date < __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.dailySearch.start_date);
    },
    startMonthLimit: function startMonthLimit(date) {
      return date > __WEBPACK_IMPORTED_MODULE_3_moment___default()();
    },
    endMonthLimit: function endMonthLimit(date) {
      return date > __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.maxEndMonth) || date < __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.monthlySearch.start_date);
    },
    tableEndDateLimit: function tableEndDateLimit(date) {
      return date > __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.maxEndDate('table')) || date < __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.tableSearch.start_date);
    },
    isType: function isType(type) {
      if (this.selectTab === type) return true;else return false;
    },
    clickPage: function clickPage(index) {
      this.paginate.tableIndex = index;
      this.searchTable('changePage');
    },
    goto: function goto() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__assets_js_shared_token_js__["c" /* setSharedToken */])(window.localStorage.getItem(this.$config.token));
      window.location.href = this.$config.bdms + 'analytics/trend';
    }
  }),
  watch: {
    'dailySearch.start_date': function dailySearchStart_date(val) {
      if (__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.dailySearch.end_date).isAfter(this.maxEndDate('chart')) || __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.dailySearch.end_date).isBefore(val)) {
        this.dailySearch.end_date = this.maxEndDate('chart');
      }
      this.endDateLimit();
    },
    'monthlySearch.start_date': function monthlySearchStart_date(val) {
      if (__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.monthlySearch.end_date).isAfter(this.maxEndMonth) || __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.monthlySearch.end_date).isBefore(val)) {
        this.monthlySearch.end_date = this.maxEndMonth;
      }
      this.endMonthLimit();
    },
    'tableSearch.start_date': function tableSearchStart_date(val) {
      if (__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.tableSearch.end_date).isAfter(this.maxEndDate('table')) || __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.tableSearch.end_date).isBefore(val)) {
        this.tableSearch.end_date = this.maxEndDate('table');
      }
      this.tableEndDateLimit();
    },
    selectTab: function selectTab(val) {
      var list = this[val + 'Search'].data;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(list).length) {
        var data = val === 'daily' ? list[this.month] : list;
        this.showOrderChart(data);
      } else {
        this.searchOrderSummary(true);
      }
    }
  }
});

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_js_shared_token_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_datepicker__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_datepicker_index_css__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_datepicker_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue2_datepicker_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(3);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'OperatingChart',
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_6_vue2_datepicker__["a" /* default */]
  },
  data: function data() {
    return {
      roleType: 0,
      selectTab: 'daily',
      isChangeBrand: false,
      brandBrief: [],
      storeBrief: [],
      brandSelect: { label: '== 品牌 ==', value: 0 },
      storeSelect: { label: '== 門市 ==', value: 0 },

      dailySearch: {
        start_date: null,
        end_date: null,
        data: {}
      },

      month: 0,

      monthlyOptions: [],

      monthlySearch: {
        start_date: null,
        end_date: null,
        data: {}
      },

      tableSearch: {
        start_date: null,
        end_date: null
      },

      chartData: {
        labels: [],
        order: [],
        crm: [],
        data: []
      },
      tableData: {},
      tableMeta: {},
      paginate: {
        count: 10,
        total: 0,
        tableIndex: 1,
        groupAmount: 10
      },
      orderChart: null,
      crmChart: null,
      dataChart: null,
      storesInfo: []
    };
  },

  filters: {
    date: function date(data) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(data).format('MM/DD');
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getFile: function getFile() {
      return this.$parent.getFile;
    },
    maxEndMonth: function maxEndMonth() {
      var lastMonth = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.monthlySearch.start_date).add('23', 'months').format('YYYY-MM');
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()().isBefore(lastMonth) ? __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM') : lastMonth;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.paginate.total / this.paginate.count);
    },
    ein: function ein() {
      var _this = this;

      if (this.storeSelect.value) {
        return this.storesInfo.filter(function (x) {
          return x.store_id === _this.storeSelect.value;
        })[0].ein;
      }
      return '';
    },
    storeName: function storeName() {
      var _this2 = this;

      if (this.storeSelect.value) {
        return this.storesInfo.filter(function (x) {
          return x.store_id === _this2.storeSelect.value;
        })[0].bl_name;
      }
      return '';
    }
  }),
  created: function created() {
    this.roleType = parseInt(this.getRoleType, 10);
    this.getBrandBrief();
    this.initDate();
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapActions */])(['setBrandId', 'setStoreId']), {
    isActive: function isActive(index) {
      if (this.paginate.tableIndex === index) return true;else return false;
    },
    initDate: function initDate() {
      this.dailySearch.start_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(15, 'days').format('YYYY-MM-DD');
      this.dailySearch.end_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, 'days').format('YYYY-MM-DD');

      this.monthlySearch.start_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(6, 'months').format('YYYY-MM');
      this.monthlySearch.end_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM');

      this.tableSearch.start_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(20, 'days').format('YYYY-MM-DD');
      this.tableSearch.end_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, 'days').format('YYYY-MM-DD');
    },
    maxEndDate: function maxEndDate(type) {
      var startDate = type === 'chart' ? 'dailySearch' : 'tableSearch';
      var yesterDay = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, 'days').format('YYYY-MM-DD');
      var lastDay = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this[startDate].start_date).add(type === 'chart' ? '365' : '180', 'days').format('YYYY-MM-DD');
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(yesterDay).isBefore(lastDay) ? yesterDay : lastDay;
    },
    setDate: function setDate(type) {
      switch (type) {
        case 'year':
          this.monthlySearch.start_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(12, 'months').format('YYYY-MM');
          this.monthlySearch.end_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM');
          break;
        case 'month':
          this.dailySearch.start_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(30, 'days').format('YYYY-MM-DD');
          this.dailySearch.end_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, 'days').format('YYYY-MM-DD');
          break;
        case 'week':
          this.dailySearch.start_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(7, 'days').format('YYYY-MM-DD');
          this.dailySearch.end_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, 'days').format('YYYY-MM-DD');
          break;
      }
      this.searchOrderSummary();
    },
    changeBrand: function changeBrand(input) {
      this.storeBrief = [];
      this.storeSelect = [];
      this.paginate.tableIndex = 1;
      var brandId = input.value;
      if (input.value !== 99 && input.value !== 0) {
        this.getStoreBrief(brandId);
      }
      if (typeof input.value !== 'undefined') {
        this.isChangeBrand = true;
        this.dailySearch.data = [];
        this.monthlySearch.data = [];
        this.searchOrderSummary();
      }
    },
    changeStore: function changeStore(input) {
      this.paginate.tableIndex = 1;
      if (typeof input.value !== 'undefined' && !this.isChangeBrand) {
        this.dailySearch.data = [];
        this.monthlySearch.data = [];
        this.searchOrderSummary();
      }
      this.isChangeBrand = false;
    },
    changeMonth: function changeMonth() {
      this.showOrderChart(this.dailySearch.data[this.month]);
    },
    getBrandBrief: function getBrandBrief() {
      var _this3 = this;

      this.brandBrief = [];
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;

          if (bList.length > 1) {
            if ([99, 30].includes(_this3.roleType)) {
              var defaultBrand = { label: '== 品牌 ==', value: 0 };
              _this3.brandBrief.push(defaultBrand);
              _this3.brandSelect = defaultBrand;
              for (var i = 0; i < bList.length; i++) {
                var obj = { label: bList[i].name, value: bList[i].brand_id };
                _this3.brandBrief.push(obj);
              }
              _this3.searchOrderSummary();
            }
          } else if (bList.length === 1) {
            if ([10, 30].includes(_this3.roleType)) {
              var val = bList[0].brand_id;
              _this3.getStoreBrief(val, true);
              _this3.setBrandId(val);
            }
          }
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      var _this4 = this;

      var first = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.storeBrief = [];
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          if (sList.length > 1) {
            _this4.storeBrief.push({ label: '== 所有門市 ==', value: 0 });
            for (var i = 0; i < sList.length; i++) {
              var obj = { label: sList[i].name, value: sList[i].store_id };
              _this4.storeBrief.push(obj);
            }
          }
          if (_this4.roleType !== 99 && first) {
            _this4.searchOrderSummary();
          }
          if (_this4.roleType === 10) {
            _this4.setStoreId(_this4.storeSelect.value);
          }
          _this4.storesInfo = sList;
        }
      });
    },
    setMonthSelectOptions: function setMonthSelectOptions(start, end) {
      this.monthlyOptions = [];
      var startMonth = start + '/01';
      var endMonth = end + '/01';
      var year = 0;

      while (__WEBPACK_IMPORTED_MODULE_3_moment___default()(startMonth).isSameOrBefore(endMonth)) {
        if (year && year !== __WEBPACK_IMPORTED_MODULE_3_moment___default()(startMonth).year()) {
          this.monthlyOptions.push({
            value: null,
            name: '--' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(startMonth).year() + '--',
            disable: true
          });
        }
        this.monthlyOptions.push({
          value: '' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(startMonth).format('YYYY-MM'),
          name: __WEBPACK_IMPORTED_MODULE_3_moment___default()(startMonth).month() + 1 + ' \u6708',
          disable: false
        });
        year = __WEBPACK_IMPORTED_MODULE_3_moment___default()(startMonth).year();
        startMonth = __WEBPACK_IMPORTED_MODULE_3_moment___default()(startMonth).add(1, 'months');
      }
      this.month = this.monthlyOptions[0].value || 0;
    },
    setQuery: function setQuery(type) {
      var changeTable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var name = changeTable ? 'tableMeta' : type + 'Search';
      var query = {
        start_date: this[name].start_date.replace(/-/g, ''),
        end_date: this[name].end_date.replace(/-/g, '')
      };
      switch (type) {
        case 'table':
          query.list_type = 'daily';
          break;
        case 'daily':
          query.list_type = 'daily_group_by_month';
          break;
        case 'monthly':
          query.list_type = 'monthly';
          break;
      }
      if (this.brandSelect.value && this.roleType !== 10) query.brand_ids = this.brandSelect.value;
      if (this.storeSelect.value) query.store_ids = this.storeSelect.value;

      return query;
    },
    searchOrderSummary: function searchOrderSummary() {
      var _this5 = this;

      var switchTab = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var query = this.setQuery(this.selectTab);
      var searchParams = new URLSearchParams(query);
      var url = '/statistic/operateApiSummary?' + searchParams.toString();
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var start = response.data.meta.start_date;
          var end = response.data.meta.end_date;
          if (!switchTab && _this5.selectTab === 'daily' && start && end) {
            _this5.setMonthSelectOptions(__WEBPACK_IMPORTED_MODULE_3_moment___default()(start).format('YYYY/MM'), __WEBPACK_IMPORTED_MODULE_3_moment___default()(end).format('YYYY/MM'));
          }

          _this5[_this5.selectTab + 'Search'].data = response.data.list;
          var list = _this5.selectTab === 'daily' ? response.data.list[_this5.month] : response.data.list;
          _this5.showOrderChart(list);
        }
      });
    },
    showOrderChart: function showOrderChart() {
      var _this6 = this;

      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      for (var key in this.chartData) {
        this.chartData[key] = [];
      }

      for (var i in list) {
        var date = list[i].date;
        if (this.selectTab === 'daily') {
          date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format('MM/DD');
        } else {
          date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format('YYYY/MM');
        }
        this.chartData.labels.push(date);
        this.chartData.order.push(list[i].operate_api_order);
        this.chartData.crm.push(list[i].operate_api_crm);
        this.chartData.data.push(list[i].operate_api_data);
      }
      console.log(this.chartData);
      this.$nextTick(function () {
        var type = ['order', 'crm', 'data'];
        type.forEach(function (item) {
          if (_this6[item + 'Chart'] !== null) {
            _this6[item + 'Chart'].destroy();
          }

          var ctx = document.getElementById(item + '-chart').getContext('2d');
          var config = {
            type: 'line',
            data: {
              labels: _this6.chartData.labels,
              datasets: [{
                label: item,
                data: _this6.chartData[item],
                fill: false,
                borderColor: '#dd4b39',
                pointBackgroundColor: '#dd4b39',
                tension: 0.3
              }]
            },
            options: {
              responsive: true,
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  display: true,
                  ticks: {
                    min: 0
                  }
                }]
              }
            }
          };
          _this6[item + 'Chart'] = new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a(ctx, config);
        });
      });
    },
    exportFile: function exportFile(type) {
      var query = type === 'table' ? this.setQuery('table', true) : this.setQuery(this.selectTab);
      var searchParams = new URLSearchParams(query);
      var url = '/statistic/operateApiSummarySheets?' + searchParams.toString();
      this.getFile('get', url, null, function (response) {
        var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        var objectUrl = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = objectUrl;
        a.download = '\u7CFB\u7D71\u4F7F\u7528\u7387_' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(query.start_date).format('YYYYMMDD') + '_' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(query.end_date).format('YYYYMMDD') + '.xlsx';
        document.body.appendChild(a);
        a.click();
      });
    },
    startDateLimit: function startDateLimit(date) {
      return date > __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, 'days');
    },
    endDateLimit: function endDateLimit(date) {
      return date > __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.maxEndDate('chart')) || date < __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.dailySearch.start_date);
    },
    startMonthLimit: function startMonthLimit(date) {
      return date > __WEBPACK_IMPORTED_MODULE_3_moment___default()();
    },
    endMonthLimit: function endMonthLimit(date) {
      return date > __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.maxEndMonth) || date < __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.monthlySearch.start_date);
    },
    tableEndDateLimit: function tableEndDateLimit(date) {
      return date > __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.maxEndDate('table')) || date < __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.tableSearch.start_date);
    },
    isType: function isType(type) {
      if (this.selectTab === type) return true;else return false;
    },
    clickPage: function clickPage(index) {
      this.paginate.tableIndex = index;
    },
    goto: function goto() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__assets_js_shared_token_js__["c" /* setSharedToken */])(window.localStorage.getItem(this.$config.token));
      window.location.href = this.$config.bdms + 'analytics/trend';
    }
  }),
  watch: {
    'dailySearch.start_date': function dailySearchStart_date(val) {
      if (__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.dailySearch.end_date).isAfter(this.maxEndDate('chart')) || __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.dailySearch.end_date).isBefore(val)) {
        this.dailySearch.end_date = this.maxEndDate('chart');
      }
      this.endDateLimit();
    },
    'monthlySearch.start_date': function monthlySearchStart_date(val) {
      if (__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.monthlySearch.end_date).isAfter(this.maxEndMonth) || __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.monthlySearch.end_date).isBefore(val)) {
        this.monthlySearch.end_date = this.maxEndMonth;
      }
      this.endMonthLimit();
    },
    'tableSearch.start_date': function tableSearchStart_date(val) {
      if (__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.tableSearch.end_date).isAfter(this.maxEndDate('table')) || __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.tableSearch.end_date).isBefore(val)) {
        this.tableSearch.end_date = this.maxEndDate('table');
      }
      this.tableEndDateLimit();
    },
    selectTab: function selectTab(val) {
      var list = this[val + 'Search'].data;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(list).length) {
        var data = val === 'daily' ? list[this.month] : list;
        this.showOrderChart(data);
      } else {
        this.searchOrderSummary(true);
      }
    }
  }
});

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue___default.a
  },
  data: function data() {
    return {
      activityMethod: 1,

      orderType: [{ label: '一般單', value: 1 }, { label: '團購單 - 團長', value: 2 }, { label: '團購單 - 團員', value: 3 }],
      orderMethod: [{ label: '當日單', value: 1 }, { label: '預訂單', value: 2 }],
      deliveryType: [{ label: '自取', value: 1 }, { label: '內用', value: 2 }, { label: '外送', value: 3 }, { label: '內用-桌邊掃碼', value: 21 }],
      payPlaceType: [{ label: '線上結帳', value: 10 }, { label: 'POS店家結帳', value: 50 }],
      coupon: {
        type: { label: '固定起迄時間', value: 1 },
        price_type: { label: '免稅', value: 1 },
        discount_type: { label: '折扣金額', value: 1 },
        setting: { label: '依訂單購買商品數設定', value: 1 },
        useType: { label: '品牌型', value: 2 }
      },
      otherCoupon: [],

      otherCouponList: [{ label: 'Nidin優惠券', value: 1, code: '1231231dz' }, { label: '柴犬優惠券', value: 2, code: '324efxde' }, { label: '你好優惠券', value: 3, code: '654trrgxx' }],
      addStoresSetting: {
        class: 'buy-add-store',
        options: [],
        choose: []
      },
      addCouponStoresSetting: {
        class: 'coupon-store',
        options: [],
        choose: []
      },

      deadType: [{ label: '固定起迄時間', value: 'all_fixed' }, { label: '固定結束時間', value: 'day_fixed' }, { label: '發送日幾天後', value: 'day_day' }],
      priceType: [{ label: '免稅', value: 1 }, { label: '未稅', value: 2 }, { label: '含稅', value: 3 }],
      discountType: [{ label: '折扣金額', value: 1 }],
      couponSetting: [{ label: '依訂單購買商品數設定', value: 'SC00001' }, { label: '依個人訂單消費特定商品數', value: 'SC00002' }, { label: '依個人訂單購買金額', value: 'SC00003' }],
      useType: [{ label: '品牌型', value: 2 }, { label: '門市型', value: 3 }],
      usageValue: [],
      brandList: [],
      content: {
        bindingStoreList: [],
        bindingBrandList: [],
        bindingProdList: []
      },
      brandDefault: '',
      brandBrief: [],
      storeBrief: [],
      scheduleTime: '',
      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: ''
        }
      },
      show: {
        back: false
      },
      giftSelect: 0,
      tableIndex: 1,
      menuId: 0,
      menuName: '',
      storeId: 0,
      startTime: {
        time: ''
      },
      endtime: {
        time: ''
      },
      giftList: [{ label: '依店家訂單消費金額滿額送', value: 1 }, { label: '依店家訂單商品個數滿額送', value: 2 }, { label: '依店家訂單消費指定商品數量滿額送', value: 3 }],
      timeoption: {
        type: 'min',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD HH:mm:ss',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      startLimit: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD HH:mm:ss')
      }],
      endLimit: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD HH:mm:ss')
      }],
      info: {
        menuName: '夏日菜單',
        menu_id: 123323,
        start_time: '2017-03-31 12:22:32',
        end_time: '2017-03-31 12:22:32',
        update_time: '2017-03-31 12:22:32',
        create_time: '2017-03-31 12:22:32'
      },
      menu_schedule_list: [{
        'schedule_id': 122,
        'store_id': 1,
        'store_name': '金山店',
        'menu_id': 1,
        'start_time': '2017-07-24 08:00:00',
        'end_time': '2017-08-01 00:00:00',
        'status': 1,
        'update_time': '2017-01-14 16:09:16',
        'create_time': '2017-01-14 16:09:16'
      }, {
        'schedule_id': 123,
        'store_id': 2,
        'store_name': '中山店',
        'menu_id': 2,
        'start_time': '2017-07-24 08:00:00',
        'end_time': '2017-08-01 00:00:00',
        'status': 1,
        'update_time': '2017-01-14 16:09:16',
        'create_time': '2017-01-14 16:09:16'
      }],
      couponList: [{
        coupon_info: { set_name: '', set_description: '', name: '', description: '', remark: '', discount_type: '', discountType: { label: '折扣金額', value: 1 }, discount_value: '', priceType: { label: '免稅', value: 1 }, price_type: '' },
        usage_store_config: { isFollowStore: true, usageStoreType: { label: '品牌型', value: 2 }, usage_store_type: '', usageStoreValue: '', usage_store_value: '', usage_method: 'manual', manual_store_ids: [] },
        time_config: { timeType: { label: '固定起迄時間', value: 'all_fixed' }, time_type: '', startTime: { time: '' }, endTime: { time: '' }, start_time: '', end_time: '', use_start_day: '', use_tolerance_day: '' },
        is_group_usage: 1,
        isGroupUsage: true,
        amount_unit: 1,
        coupon_strategy: {
          ruleCode: { label: '依訂單購買商品數設定', value: 'SC00001' },
          rule_code: '',
          name: '',
          description: '',
          limit: {
            min_amount: 1,
            min_money: '',
            order_method: '',
            orderMethod: '',
            order_types: [],
            orderTypes: [],
            delivery_types: [],
            deliveryTypes: []
          },
          setting: {
            one_max_amount: null,
            ratio: 1,
            lowest_unit_price: 0,
            money_unit: ''
          },
          store_exception_items: [{
            products: [],
            store_ids: []
          }]
        }
      }],
      activity: {
        name: '',
        description: '',
        title: '',
        content: '',
        remark: '',
        sort: 1,
        start_time: '',
        end_time: '',
        aTime: {
          start: { time: '' },
          end: { time: '' }
        },
        store_ids: [],
        strategy_data: [{
          ruleCode: 'SA00001',
          rule_code: 'SA00001',
          limit: {
            order_type: [],
            order_method: [],
            delivery_type: [],
            pay_place_type: [],
            min_total_paid_money: '',
            min_total_money: '',
            min_total_amount: '',
            min_paid_money: '',
            min_money: '',
            min_amount: '',
            min_sub_order_amount: ''
          },
          setting: {
            money_unit: '',
            max_count: '',
            vendorCustomProductList: [],
            vendor_custom_product_list: [],
            vendorList: [],
            amount_unit: 1
          },
          store_exception_items: [{
            products: [],
            productList: [],
            store_ids: []
          }]
        }]
      },
      productBrief: [],
      productChoseBrief: [],
      nowTime: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD HH:mm')
    };
  },
  created: function created() {
    this.getMarketingStores();
    this.giftSelect = 1;

    if (this.getRoleType === 10) {
      this.useType = [{ label: '品牌型', value: 2 }, { label: '門市型', value: 3 }];
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapActions */])(['setMenuStartTime', 'setMenuEndTime']), {
    addChooseTag: function addChooseTag(newTag) {
      var tag = {
        name: newTag,
        id: ''
      };
      this.productChoseBrief.push(tag);
      this.activity.setting.vendorCustomProductList.push(tag);
    },
    addCouponChooseTag: function addCouponChooseTag(newTag) {
      var tag = {
        name: newTag,
        id: ''
      };
      this.productChoseBrief.push(tag);
      this.couponList.forEach(function (coupon) {
        var type = coupon.coupon_strategy.ruleCode.value;
        var vcpList = coupon.coupon_strategy.setting.vendorCustomProductList;
        if (vcpList && type === 'SC00002') vcpList.push(tag);
      });
    },
    addCouponTag: function addCouponTag(newTag) {
      var tag = {
        name: newTag,
        vendor_custom_id: ''
      };
      this.productBrief.push(tag);
      this.couponList.forEach(function (coupon) {
        var type = coupon.coupon_strategy.ruleCode.value;
        var pList = coupon.coupon_strategy.store_exception_items[0].products;
        if (pList && type !== 'SC00002') pList.push(tag);
      });
    },
    addTag: function addTag(newTag) {
      var tag = {
        name: newTag,
        vendor_custom_id: ''
      };
      this.productBrief.push(tag);
      this.activity.store_exception_items[0].products.push(tag);
    },
    setCoupon: function setCoupon(type, callback) {
      var couponSet = {
        coupon_info: { set_name: '', set_description: '', name: '', description: '', remark: '', discount_type: '', discountType: { label: '折扣金額', value: 1 }, discount_value: '', priceType: { label: '免稅', value: 1 }, price_type: '' },
        usage_store_config: { isFollowStore: true, usageStoreType: { label: '品牌型', value: 2 }, usage_store_type: '', usageStoreValue: '', usage_store_value: '', usage_method: 'manual', manual_store_ids: [] },
        time_config: { timeType: { label: '固定起迄時間', value: 'all_fixed' }, time_type: '', startTime: { time: '' }, endTime: { time: '' }, start_time: '', end_time: '', use_start_day: '', use_tolerance_day: '' },
        is_group_usage: 1,
        isGroupUsage: true,
        amount_unit: 1,
        coupon_strategy: {
          ruleCode: { label: '依訂單購買商品數設定', value: 'SC00001' },
          name: '',
          description: '',
          limit: {
            min_amount: 1,
            min_money: '',
            order_method: '',
            orderMethod: '',
            order_types: [],
            orderTypes: [],
            delivery_types: [],
            deliveryTypes: []
          },
          setting: {
            one_max_amount: null,
            ratio: 1,
            lowest_unit_price: 0,
            vendorCustomProductList: [],
            vendor_custom_product_list: [],
            money_unit: 100
          },
          store_exception_items: [{
            products: [],
            store_ids: []
          }]
        }
      };
      var coupon = couponSet;
      if (type === 1 || type === 'SC00001') coupon.coupon_strategy.ruleCode = { label: '依訂單購買商品數設定', value: 'SC00001' };else if (type === 2 || type === 'SC00002') {
        coupon.coupon_strategy.ruleCode = { label: '依個人訂單消費特定商品數', value: 'SC00002' };
        coupon.coupon_strategy.store_exception_items = [];
      } else if (type === 3 || type === 'SC00003') coupon.coupon_strategy.ruleCode = { label: '依個人訂單購買金額', value: 'SC00003' };
      callback(coupon);
    },
    addCoupon: function addCoupon() {
      var self = this;
      this.setCoupon(this.giftSelect, function (coupon) {
        self.couponList.push(coupon);
      });
    },
    clickCoupon: function clickCoupon() {},
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    getStoreBrief: function getStoreBrief(brandId) {
      this.storeBrief = [];
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
          }
        }
      });
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            self.brandBrief.push(obj);
          }
        }
      });
    },
    changeOtherCoupon: function changeOtherCoupon(current) {
      this.couponList.push(current);
    },
    removeOtherCoupon: function removeOtherCoupon(current) {
      var self = this;
      var removeId = '';
      this.couponList.find(function (coupon, index) {
        if (coupon.code) {
          if (current.code === coupon.code) {
            removeId = index;
            return;
          }
        }
      });
      if (removeId) self.couponList.splice(removeId, 1);
    },
    getMarketingStores: function getMarketingStores() {
      this.addStoresSetting.options = [];
      this.addStoresSetting.choose = [];
      this.addCouponStoresSetting.options = [];
      this.addCouponStoresSetting.choose = [];

      var self = this;
      var url = '/promotion/' + this.$route.params.marketing_id + '/storeList?&list_sort=store_name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var list = response.data.list;

          var _loop = function _loop(i) {
            var obj = { label: list[i].store_name, value: list[i].store_id };
            self.addStoresSetting.options.push(obj);
            self.addCouponStoresSetting.options.push(obj);

            if (!self.brandList.find(function (brand) {
              return brand.value === list[i].brand_id;
            })) self.brandList.push({ label: list[i].brand_name, value: list[i].brand_id });
          };

          for (var i = 0; i < list.length; i++) {
            _loop(i);
          }
          self.usageValue = self.brandList;
        }
      });
    },
    changeStoreType: function changeStoreType(select, id) {
      var index = id.split('-')[2];
      console.log(index);
      if (select.value === 2) {
        this.usageValue = this.brandList;
        this.couponList[index].usage_store_config.usageStoreValue = this.usageValue[0];
      } else if (select.value === 3) {
        this.usageValue = this.addStoresSetting.options;
        this.couponList[index].usage_store_config.usageStoreValue = this.usageValue[0];
      }
    },
    checkActivity: function checkActivity() {
      console.log(this.activity);
      console.log(this.couponList);
      var a = this.activity;

      var sD = a.strategy_data[0];
      var msg = '';
      if (!a.name) msg = '活動名稱(後台)未填';else if (!a.title) msg = '活動名稱(前台)未填';else if (!a.sort) msg = '活動排序未填';else if (!a.content) msg = '活動說明(前台)未填';else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(a.sort) !== Number) msg = '活動排序非數字';else if (!a.aTime.start.time) msg = '活動開始時間未填';else if (!a.aTime.end.time) msg = '活動結束時間未填';else if (!this.addStoresSetting.choose.length) msg = '參與活動店家未選';else if (!sD.ruleCode) msg = '贈送規則未選';else if (sD.ruleCode === 'SA00001') {
        if (!sD.setting.money_unit) msg = '活動累積滿多少金額，送一份優惠券未填';else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(sD.setting.money_unit) !== Number) msg = '活動累積滿多少金額，送一份優惠券非數字';else if (!sD.setting.max_count) msg = '活動最高贈送份數未填';else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(sD.setting.max_count) !== Number) msg = '活動最高贈送份數非數字';
      } else if (sD.ruleCode === 'SA00002') {
        if (sD.setting.amount_unit === '') msg = '活動達成多少商品數量，送優惠券未填';else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(sD.setting.amount_unit) !== Number) msg = '活動達成多少商品數量，送優惠券非數字';else if (!sD.setting.lowest_unit_price) msg = '活動最高贈送份數未填';else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(sD.setting.lowest_unit_price) !== Number) msg = '活動最高贈送份數未填非數字';else if (!sD.setting.max_count) msg = '活動最高贈送份數未填';else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(sD.setting.max_count) !== Number) msg = '活動最高贈送份數非數字';
      } else if (sD.ruleCode === 'SA00003') {
        if (sD.setting.amount_unit === '') msg = '活動達成多少商品數量，送優惠券未填';else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(sD.setting.amount_unit) !== Number) msg = '活動達成多少商品數量，送優惠券非數字';else if (!sD.setting.max_count) msg = '活動最高贈送份數未填';else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(sD.setting.max_count) !== Number) msg = '活動最高贈送份數非數字';else if (sD.setting.vendorCustomProductList) msg = '活動購買指定商品未選擇';
      } else {}
      console.log(msg);
    }
  }),
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    scheduleListNew: function scheduleListNew() {
      var menuList = {};
      var oldList = this.menu_schedule_list;
      for (var key in oldList) {
        menuList[oldList[key].menu_id] = {
          menu_id: oldList[key].menu_id,
          storeList: []
        };
      }
      for (var k in oldList) {
        menuList[oldList[k].menu_id].storeList.push({
          store_id: oldList[k].store_id,
          store_name: oldList[k].store_name,
          start_time: oldList[k].start_time,
          end_time: oldList[k].end_time,
          status: oldList[k].status,
          update_time: oldList[k].update_time,
          create_time: oldList[k].create_time,
          schedule_id: oldList[k].schedule_id
        });
      }
      return menuList;
    },
    getList: function getList() {
      if (this.$route.name === 'upScheduleOne') {
        var oneList = this.scheduleListNew[this.menuId].storeList;
        this.menuTime.start.time = oneList[0].start_time;
        this.menuTime.end.time = oneList[0].end_time;
        return oneList;
      } else {
        var list = [];
        for (var key in this.scheduleListNew) {
          for (var k in this.scheduleListNew[key].storeList) {
            list.push(this.scheduleListNew[key].storeList[k]);
          }
        }
        return list;
      }
    }
  },
  watch: {
    'menuTime.start.time': function menuTimeStartTime() {
      this.endLimit = [{
        type: 'fromto',
        from: this.menuTime.start.time
      }];
      this.setMenuStartTime(this.menuTime.start.time);
    },
    'menuTime.end.time': function menuTimeEndTime() {
      this.startLimit = [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD HH:mm:ss'),
        to: this.menuTime.end.time
      }];
      this.setMenuEndTime(this.menuTime.end.time);
    },
    'content.bindingBrandList': function contentBindingBrandList() {
      var self = this;
      this.storeBrief = [];
      this.content.bindingStoreList = [];
      this.content.bindingBrandList.forEach(function (array) {
        var brandId = array.value;
        self.getStoreBrief(brandId);
      });
    },
    giftSelect: function giftSelect() {
      var self = this;
      this.setCoupon(this.giftSelect, function (coupon) {
        self.couponList = [coupon];
      });
    },
    'addStoresSetting.choose': function addStoresSettingChoose() {
      this.activity.store_ids = this.addStoresSetting.choose;
    }
  }
});

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CouponList_vue__ = __webpack_require__(2182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CouponList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__CouponList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CouponStrategy_vue__ = __webpack_require__(2184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CouponStrategy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__CouponStrategy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ActivityStrategy_vue__ = __webpack_require__(2179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ActivityStrategy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ActivityStrategy_vue__);












/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    info: Object
  },
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default.a,
    'coupon-list': __WEBPACK_IMPORTED_MODULE_6__CouponList_vue___default.a,
    'coupon-strategy': __WEBPACK_IMPORTED_MODULE_7__CouponStrategy_vue___default.a,
    'activity-strategy': __WEBPACK_IMPORTED_MODULE_8__ActivityStrategy_vue___default.a
  },
  data: function data() {
    return {
      delOption: {
        id: 'delModal',
        title: '刪除活動',
        body: '確定刪除活動?<br>',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delActivity'
        }]
      },
      cMethod: 1,
      activityMethod: 1,

      orderType: [{ label: '一般單', value: 1 }, { label: '團購單 - 團長', value: 2 }, { label: '團購單 - 團員', value: 3 }],
      orderMethod: [{ label: '當日單', value: 1 }, { label: '預訂單', value: 2 }],
      deliveryType: [{ label: '自取', value: 1 }, { label: '內用', value: 2 }, { label: '外送', value: 3 }, { label: '內用-桌邊掃碼', value: 21 }],
      coupon: {
        type: { label: '固定起迄時間', value: 1 },
        price_type: { label: '免稅', value: 1 },
        discount_type: { label: '折扣金額', value: 1 },
        setting: { label: '依訂單購買商品數設定', value: 1 },
        useType: { label: '品牌型', value: 2 }
      },
      otherCoupon: [],

      otherCouponList: [{ label: 'Nidin優惠券', value: 1, code: '1231231dz' }, { label: '柴犬優惠券', value: 2, code: '324efxde' }, { label: '你好優惠券', value: 3, code: '654trrgxx' }],
      addStoresSetting: {
        class: 'buy-add-store',
        options: [],
        choose: []
      },

      deadType: [{ label: '固定起迄時間', value: 'all_fixed' }, { label: '固定結束時間', value: 'day_fixed' }, { label: '發送日幾天後', value: 'day_day' }],
      discountType: [{ label: '折扣金額', value: 1 }],
      couponSetting: [{ label: '依訂單購買商品數設定', value: 'SC00001' }, { label: '依個人訂單消費特定商品數', value: 'SC00002' }, { label: '依個人訂單購買金額', value: 'SC00003' }],
      useType: [{ label: '品牌型', value: 2 }, { label: '門市型', value: 3 }],
      usageValue: [],
      brandList: [],
      content: {
        bindingStoreList: [],
        bindingBrandList: [],
        bindingProdList: []
      },
      brandDefault: '',
      brandBrief: [],
      storeBrief: [],
      scheduleTime: '',
      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: ''
        }
      },
      show: {
        back: false
      },
      tableIndex: 1,
      menuId: 0,
      menuName: '',
      storeId: 0,
      startTime: {
        time: ''
      },
      endtime: {
        time: ''
      },
      giftList: [{ label: '依店家訂單消費金額滿額送', value: 1 }, { label: '依店家訂單商品個數滿額送', value: 2 }, { label: '依店家訂單消費指定商品數量滿額送', value: 3 }],
      timeoption: {
        type: 'min',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD HH:mm:ss',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      startLimit: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_5_moment___default()().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss')
      }],
      endLimit: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_5_moment___default()().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss')
      }],
      couponList: [{
        coupon_info: { set_name: '', set_description: '', name: '', description: '', remark: '', discount_type: '', discountType: { label: '折扣金額', value: 1 }, discount_value: '', priceType: { label: '免稅', value: 1 }, price_type: '' },
        usage_store_config: { isFollowStore: true, usageStoreType: { label: '品牌型', value: 2 }, usage_store_type: '', usageStoreValue: '', usage_store_value: '', usage_method: 'manual', manual_store_ids: [] },
        time_config: { timeType: { label: '固定起迄時間', value: 'all_fixed' }, time_type: '', startTime: { time: '' }, endTime: { time: '' }, start_time: '', end_time: '', use_start_day: '', use_tolerance_day: '' },
        is_group_usage: 1,
        isGroupUsage: true,
        amount_unit: 1,
        coupon_strategy: {
          ruleCode: { label: '依訂單購買商品數設定', value: 'SC00001' },
          rule_code: '',
          name: '',
          description: '',
          limit: {
            min_amount: 1,
            min_money: '',
            order_method: '',
            orderMethod: '',
            order_types: [],
            orderTypes: [],
            delivery_types: [],
            deliveryTypes: []
          },
          setting: {
            one_max_amount: null,
            ratio: 1,
            lowest_unit_price: 0,
            money_unit: ''
          },
          store_exception_items: [{
            products: [],
            store_ids: []
          }]
        }
      }],
      activity: {
        status: 0,
        rule_code: 'SA00001',
        owner_type: { label: '品牌', value: 2 },
        name: '',
        description: '',
        title: '',
        content: '',
        remark: '',
        sort: 1,
        start_time: '',
        end_time: '',
        aTime: {
          start: { time: '' },
          end: { time: '' }
        },
        store_ids: [],
        strategy_data: {
          ruleCode: 'SA00001',
          rule_code: 'SA00001',
          limit: {
            order_type: [],
            order_method: [],
            delivery_type: [],
            pay_place_type: [],
            min_total_paid_money: '',
            min_total_money: '',
            min_total_amount: '',
            min_paid_money: '',
            min_money: '',
            min_amount: '',
            min_sub_order_amount: ''
          },
          setting: {
            money_unit: '',
            max_count: '',
            vendorCustomProductList: [],
            vendor_custom_product_list: [],
            vendorList: [],
            amount_unit: 1
          },
          store_exception_items: [{
            products: [],
            productList: [],
            store_ids: []
          }]
        }
      },
      productBrief: [],
      productChoseBrief: [],
      nowTime: __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD HH:mm'),

      ownerTypeOptions: [{ label: '品牌', value: 2 }, { label: '門市', value: 3 }, { label: '平台', value: 1 }],
      giveCoupons: {
        coupon_strategy: {},
        coupon_set_list: []
      },
      curId: 0,
      reNew: 0,
      reSet: 0,
      aStoreList: [],
      aStoreOption: [],
      brandSelect: {
        label: '',
        value: ''
      },
      brandSelectMuti: [],
      tradeType: [],
      tradeTypePlace: [{ label: '線上結帳', value: 10 }, { label: 'POS店家結帳', value: 50 }],
      setInfoTimes: 0
    };
  },
  created: function created() {
    if (this.$route.query.rule_code) {
      this.activity.strategy_data.ruleCode = this.$route.query.rule_code;
      this.activity.strategy_data.rule_code = this.$route.query.rule_code;
      this.activity.rule_code = this.$route.query.rule_code;
    } else if (this.info.info.rule_code) {
      this.activity.strategy_data.ruleCode = this.info.info.rule_code;
      this.activity.strategy_data.rule_code = this.info.info.rule_code;
      this.activity.rule_code = this.info.info.rule_code;
    }
    if (this.$route.name.indexOf('up') === -1) this.getBrandBrief();
    this.getTradeTypeList();

    if (this.getRoleType === 30) this.activity.owner_type = { label: '品牌', value: 2 };else if (this.getRoleType === 10) {
      this.activity.owner_type = { label: '門市', value: 3 };
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['setMenuStartTime', 'setMenuEndTime']), {
    trigger: function trigger(event) {
      if (event === 'delActivity') this.delActivity();
    },
    delActivity: function delActivity() {
      var self = this;
      var url = '/activity/' + this.$route.params.activity_id + '/orderCouponComplete';
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.replace('/upCouponTable');
        }
      });
    },
    addChooseTag: function addChooseTag(newTag) {
      var tag = {
        name: newTag,
        id: ''
      };
      this.productChoseBrief.push(tag);
      this.activity.setting.vendorCustomProductList.push(tag);
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    getStoreBrief: function getStoreBrief(brandId, last) {
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
            self.addStoresSetting.options.push(obj);
          }
          if (self.info.info.activity_id && self.setInfoTimes && last) self.setStore();else if (self.getRoleType === 10) {
            self.addStoresSetting.choose.push(self.addStoresSetting.options[0].value);
          }
        }
      });
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;

          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            self.brandBrief.push(obj);
          }
          if (self.$route.name.indexOf('up') > -1 && !self.setInfoTimes && self.info.info) {
            self.setInfo();
          } else if (self.getRoleType === 10 || self.getRoleType === 30) {
            self.brandSelect = self.brandBrief[0];

            self.getStore();
          }
        }
      });
    },
    getTradeTypeList: function getTradeTypeList() {
      var self = this;
      var url = '/platform/tradeTypeList';
      this.getData('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.tradeInfo = [];
          var list = response.data.list;
          for (var i = 0; i < list.length; i++) {
            if (list[i].is_valid && list[i].is_enable) {
              var option = {
                label: list[i].name,
                value: parseInt(list[i].type, 10)
              };
              self.tradeType.push(option);
            }
          }
        }
      });
    },
    getMutiStore: function getMutiStore() {
      this.aStoreOption = [];
      this.storeBrief = [];
      this.addStoresSetting.options = [];
      this.addStoresSetting.choose = [];
      this.brandList = [];
      var self = this;
      this.brandSelectMuti.forEach(function (brand, index) {
        if (index + 1 === self.brandSelectMuti.length) self.getStoreBrief(brand.value, true);else self.getStoreBrief(brand.value);
        self.brandList.push(brand);
      });
    },
    getStore: function getStore() {
      this.aStoreOption = [];
      this.storeBrief = [];
      this.addStoresSetting.options = [];
      this.addStoresSetting.choose = [];
      this.brandList = [];
      if (this.brandSelect.value) this.getStoreBrief(this.brandSelect.value, true);
      this.brandList.push(this.brandSelect);
    },
    checkActivity: function checkActivity(tab, index) {
      var a = this.activity;
      var sD = a.strategy_data;
      var aD = this.giveCoupons.coupon_strategy;
      var cD = this.giveCoupons.coupon_set_list;
      var self = this;
      var msg = '';
      if (this.cMethod === 1) {
        if (!a.title) msg = '活動名稱(前台)未填';else if (!a.name) msg = '活動名稱(後台)未填';else if (!a.sort) msg = '活動排序未填';else if (!a.content) msg = '活動說明(前台)未填';else if (this.checkNumber(a.sort)) msg = '活動排序非數字';else if (!a.aTime.start.time) msg = '活動開始時間未填';else if (!__WEBPACK_IMPORTED_MODULE_5_moment___default()(a.aTime.start.time, 'YYYY-MM-DD HH:mm:ss').isValid()) msg = '活動開始時間格式錯誤';else if (!a.aTime.end.time) msg = '活動結束時間未填';else if (!__WEBPACK_IMPORTED_MODULE_5_moment___default()(a.aTime.end.time, 'YYYY-MM-DD HH:mm:ss').isValid()) msg = '活動結束時間格式錯誤';else if (!this.addStoresSetting.choose.length) msg = '參與活動店家未選';else if (this.addStoresSetting.choose.length > 1 && a.owner_type.value === 3) msg = '參與活動店家應只能選擇一家';else if (!sD.ruleCode) msg = '贈送規則未選';
      } else if (this.cMethod === 2) {
        if (sD.ruleCode === 'SA00001') {
          if (!sD.setting.money_unit) msg = '贈送條件達成金額未填';else if (this.checkNumber(sD.setting.money_unit)) msg = '贈送條件達成金額非數字';
        } else if (sD.ruleCode === 'SA00002') {
          if (sD.setting.amount_unit === '') msg = '贈送條件達成商品數未填';else if (this.checkNumber(sD.setting.amount_unit)) msg = '贈送條件達成商品數非數字';else if (sD.setting.lowest_unit_price && this.checkNumber(sD.setting.lowest_unit_price)) msg = '商品限制最低單價非數字';
        } else if (sD.ruleCode === 'SA00003') {
          if (sD.setting.amount_unit === '') msg = '贈送條件達成商品數未填';else if (this.checkNumber(sD.setting.amount_unit)) msg = '贈送條件達成商品數非數字';else if (!sD.setting.vendor_custom_product_list.length) msg = '請選擇參與店家菜單並新增指定商品';
        }
      } else if (this.cMethod === 3) {
        if (aD.rule_code === 'SC00002') {
          if (!aD.setting.vendor_custom_product_list.length) msg = '請選擇參與店家菜單並新增指定商品';
        } else if (aD.rule_code === 'SC00003') {
          if (!aD.setting.money_unit) msg = '滿足商品金額未填';else if (this.checkNumber(aD.setting.money_unit)) msg = '滿足商品金額非數字';
        }

        if (!aD.rule_code) msg = '優惠券折抵規則未選';else if (!aD.name) msg = '折抵策略名稱未填';else if (!aD.description) msg = '折抵描述未填';else if (!aD.limit.min_amount) msg = '限制主單(或團長)最低購買數未填';
      } else if (this.cMethod === 4) {
        if (!cD.length) msg = '請新增優惠券';else {
          cD.forEach(function (coupon, index) {
            msg = self.checkCoupon(coupon, index);
          });
        }
      }
      this.getToast(msg, tab, index);
    },
    getToast: function getToast(msg, tab, index) {
      if (tab && this.cMethod > index) {
        this.cMethod = index;
      } else if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (tab) {
        this.cMethod = index;
      } else if (this.cMethod !== 4) {
        this.cMethod++;
      } else {
        this.setData();
      }
    },
    checkCoupon: function checkCoupon(coupon, index) {
      var c = coupon;
      var cInfo = coupon.coupon_info;
      var usConfig = coupon.usage_store_config;
      var tConfig = coupon.time_config;
      var msg = '';
      if (!cInfo.name) msg = '第' + index + '張優惠券名稱(前台)未填';else if (!cInfo.set_name) msg = cInfo.name + '的優惠券名稱(後台)未填';else if (!cInfo.description) msg = cInfo.name + '的優惠券說明(前台)未填';else if (!cInfo.set_description) msg = cInfo.name + '的優惠券說明(後台)未填';else if (!cInfo.remark) msg = cInfo.name + '的優惠券備註未填';else if (!cInfo.discount_value) msg = cInfo.name + '的優惠券折扣金額未填';else if (this.checkNumber(cInfo.discount_value)) msg = cInfo.name + '的優惠券折扣金額非數字';else if (!c.amount_unit) msg = cInfo.name + '的一次發送張數未填';else if (this.checkNumber(c.amount_unit)) msg = cInfo.name + '的一次發送張數非數字';else if (!cInfo.price_type.value) msg = cInfo.name + '的優惠券稅制未選';else if (!usConfig.usage_store_type.value) msg = cInfo.name + '的優惠券類型未選';else if (!usConfig.usage_method.value) msg = cInfo.name + '的優惠券類型未選';else if (usConfig.usage_store_type.value === 2 && !usConfig.usage_store_value) msg = cInfo.name + '的適用對象未填';else if (usConfig.usage_method.value === 'manual' && !usConfig.usage_store_value) msg = cInfo.name + '的適用對象未填';else if (!tConfig.time_type.value) msg = cInfo.name + '的適用門市方式未選';else if (tConfig.time_type.value === 'all_fixed' && !tConfig.start_time) msg = cInfo.name + '的開始時間未填';else if (tConfig.time_type.value === 'all_fixed' && !__WEBPACK_IMPORTED_MODULE_5_moment___default()(tConfig.start_time, 'YYYY-MM-DD HH:mm:ss').isValid()) msg = cInfo.name + '的開始時間格式錯誤';else if (tConfig.time_type.value === 'all_fixed' && !tConfig.end_time) msg = cInfo.name + '的結束時間未填';else if (tConfig.time_type.value === 'all_fixed' && !__WEBPACK_IMPORTED_MODULE_5_moment___default()(tConfig.end_time, 'YYYY-MM-DD HH:mm:ss').isValid()) msg = cInfo.name + '的結束時間格式錯誤';else if (tConfig.time_type.value === 'day_fixed' && !tConfig.use_start_day && tConfig.use_start_day !== 0) msg = cInfo.name + '的拿到優惠券後幾天開始未填';else if (tConfig.time_type.value === 'day_fixed' && this.checkNumber(tConfig.use_start_day)) msg = cInfo.name + '的拿到優惠券後幾天開始非數字';else if (tConfig.time_type.value === 'day_fixed' && !tConfig.end_time) msg = cInfo.name + '的結束時間未填';else if (tConfig.time_type.value === 'day_fixed' && !__WEBPACK_IMPORTED_MODULE_5_moment___default()(tConfig.end_time, 'YYYY-MM-DD HH:mm:ss').isValid()) msg = cInfo.name + '的結束時間格式錯誤';else if (tConfig.time_type.value === 'day_day' && !tConfig.use_start_day.length && tConfig.use_start_day !== 0) msg = cInfo.name + '的拿到優惠券後幾天開始未填';else if (tConfig.time_type.value === 'day_day' && this.checkNumber(tConfig.use_start_day)) msg = cInfo.name + '的拿到優惠券後幾天開始非數字';else if (tConfig.time_type.value === 'day_day' && !tConfig.use_tolerance_day) msg = cInfo.name + '的開始後幾天結束未填';else if (tConfig.time_type.value === 'day_day' && this.checkNumber(tConfig.use_tolerance_day)) msg = cInfo.name + '的開始後幾天結束非數字';else if (usConfig.usage_method.value === 'manual' && !usConfig.manual_store_ids.length) msg = cInfo.name + '的優惠券可用店家未新增';
      return msg;
    },
    checkNumber: function checkNumber(val) {
      if (isNaN(parseInt(val, 10))) return true;else if (typeof parseInt(val, 10) !== 'number') return true;
      return false;
    },
    setData: function setData() {
      var self = this;
      var data = {
        strategy_data: {},
        give_coupons: []
      };
      var s = {
        setting: {},
        limit: {}
      };
      var cS = {
        coupon_strategy: {
          setting: {},
          limit: {}
        },
        coupon_set_list: []
      };
      var a = this.activity;
      var sD = a.strategy_data;
      var gD = this.giveCoupons;
      var cr = this.$route.name === 'crActivityInfoForm';
      var up = this.$route.name === 'upActivity';
      var ruleCode = 'SA00001';
      if (this.$route.query.rule_code) ruleCode = this.$route.query.rule_code;else if (this.info.info.rule_code) ruleCode = this.info.info.rule_code;
      if (this.cMethod === 1 || cr || up) {
        data.rule_code = ruleCode;
        if (cr || up && self.getRoleType === 99) {
          data.owner_type = a.owner_type.value;

          data.owner_id = 0;
          if (data.owner_type === 1) data.owner_id = 0;else if (data.owner_type === 2) data.owner_id = this.brandSelect.value;else if (data.owner_type === 3) data.owner_id = this.addStoresSetting.choose[0];
        }
        data.name = a.name;
        if (a.description) data.description = a.description;
        data.title = a.title;
        data.content = a.content;
        if (a.remark) data.remark = a.remark;
        data.sort = a.sort;
        data.start_time = a.aTime.start.time;
        data.end_time = a.aTime.end.time;
        data.store_ids = this.addStoresSetting.choose;
      }
      if (this.cMethod === 2 || cr || up) {
        var sLimit = s.limit;
        var sDLimit = sD.limit;
        var sSetting = s.setting;
        var sDSetting = sD.setting;

        if (sDLimit.delivery_type.length) {
          sLimit.delivery_type = [];
          sDLimit.delivery_type.forEach(function (dType) {
            sLimit.delivery_type.push(self.deliveryType.find(function (o) {
              return o.value === dType.value;
            }).value);
          });
        }
        if (sDLimit.order_type.length) {
          sLimit.order_type = [];
          sDLimit.order_type.forEach(function (oType) {
            sLimit.order_type.push(self.orderType.find(function (o) {
              return o.value === oType.value;
            }).value);
          });
        }
        if (sDLimit.pay_place_type.length) {
          sLimit.pay_place_type = [];
          sDLimit.pay_place_type.forEach(function (tTypePlace) {
            sLimit.pay_place_type.push(self.tradeTypePlace.find(function (o) {
              return o.value === tTypePlace.value;
            }).value);
          });
        }
        if (sDLimit.order_method.length) {
          sLimit.order_method = [];
          sDLimit.order_method.forEach(function (oMethod) {
            sLimit.order_method.push(self.orderMethod.find(function (o) {
              return o.value === oMethod.value;
            }).value);
          });
        }
        if (sDLimit.min_total_paid_money) sLimit.min_total_paid_money = sDLimit.min_total_paid_money;
        if (sDLimit.min_total_money) sLimit.min_total_money = sDLimit.min_total_money;
        if (sDLimit.min_total_amount) sLimit.min_total_amount = sDLimit.min_total_amount;
        if (sDLimit.min_paid_money) sLimit.min_paid_money = sDLimit.min_paid_money;
        if (sDLimit.min_money) sLimit.min_money = sDLimit.min_money;
        if (sDLimit.min_amount) sLimit.min_amount = sDLimit.min_amount;
        if (sDLimit.min_sub_order_amount) sLimit.min_sub_order_amount = sDLimit.min_sub_order_amount;

        if (data.rule_code === 'SA00001') {
          sSetting.money_unit = sDSetting.money_unit;

          if (sDSetting.max_count) sSetting.max_count = sDSetting.max_count;else sSetting.max_count = null;

          s.store_exception_items = [{ products: [], store_ids: [] }];
          if (sD.store_exception_items[0].products.length) {
            sD.store_exception_items[0].products.forEach(function (exProd) {
              var prod = {
                vendor_custom_id: exProd.vendor_custom_id,
                name: exProd.product_name
              };
              s.store_exception_items[0].products.push(prod);
            });
            s.store_exception_items[0].store_ids = this.addStoresSetting.choose;
          }
        } else if (data.rule_code === 'SA00002') {
          sSetting.amount_unit = sDSetting.amount_unit;
          if (sDSetting.lowest_unit_price) sSetting.lowest_unit_price = sDSetting.lowest_unit_price;else sSetting.lowest_unit_price = 0;

          if (sDSetting.max_count) sSetting.max_count = sDSetting.max_count;else sSetting.max_count = null;

          s.store_exception_items = [{ products: [], store_ids: [] }];
          if (sD.store_exception_items[0].products.length) {
            sD.store_exception_items[0].products.forEach(function (exProd) {
              var prod = {
                vendor_custom_id: exProd.vendor_custom_id,
                name: exProd.product_name
              };
              s.store_exception_items[0].products.push(prod);
            });
            s.store_exception_items[0].store_ids = this.addStoresSetting.choose;
          }
        } else if (data.rule_code === 'SA00003') {
          sSetting.amount_unit = sDSetting.amount_unit;

          if (sDSetting.max_count) sSetting.max_count = sDSetting.max_count;else sSetting.max_count = null;

          sSetting.vendor_custom_product_list = [];
          sDSetting.vendor_custom_product_list.forEach(function (vendorProd) {
            var vProd = {
              id: vendorProd.vendor_custom_id,
              name: vendorProd.product_name
            };
            sSetting.vendor_custom_product_list.push(vProd);
          });
          s.store_exception_items = [];
        }
      }
      if (this.cMethod === 3 || cr || up) {
        cS.coupon_strategy.rule_code = gD.coupon_strategy.rule_code;
        cS.coupon_strategy.name = gD.coupon_strategy.name;
        cS.coupon_strategy.description = gD.coupon_strategy.description;
        var cLimit = cS.coupon_strategy.limit;
        var gCLimit = gD.coupon_strategy.limit;
        var cSetting = cS.coupon_strategy.setting;
        var gSetting = gD.coupon_strategy.setting;

        cLimit.min_amount = gCLimit.min_amount;
        if (gCLimit.min_money) cLimit.min_money = gCLimit.min_money;
        if (gCLimit.delivery_types.length) {
          cLimit.delivery_types = [];
          gCLimit.delivery_types.forEach(function (dType) {
            cLimit.delivery_types.push(self.deliveryType.find(function (o) {
              return o.value === dType.value;
            }).value);
          });
        }
        if (gCLimit.order_types.length) {
          cLimit.order_types = [];
          gCLimit.order_types.forEach(function (oType) {
            cLimit.order_types.push(self.orderType.find(function (o) {
              return o.value === oType.value;
            }).value);
          });
        }
        if (gCLimit.order_method) {
          cLimit.order_method = gCLimit.order_method.value;
        }

        var cStrategy = cS.coupon_strategy;
        if (cStrategy.rule_code === 'SC00001') {
          if (gSetting.one_max_amount) cSetting.one_max_amount = gSetting.one_max_amount;else cSetting.one_max_amount = null;
          cSetting.ratio = 1;
          if (gSetting.lowest_unit_price) cSetting.lowest_unit_price = gSetting.lowest_unit_price;else cSetting.lowest_unit_price = 0;

          cStrategy.store_exception_items = [{ products: [], store_ids: [] }];
          gD.coupon_strategy.store_exception_items[0].products.forEach(function (exProd) {
            var prod = {
              vendor_custom_id: exProd.vendor_custom_id,
              name: exProd.product_name
            };
            cStrategy.store_exception_items[0].products.push(prod);
          });

          cStrategy.store_exception_items[0].store_ids = self.addStoresSetting.choose;
        } else if (cStrategy.rule_code === 'SC00002') {
          if (gSetting.one_max_amount) cSetting.one_max_amount = gSetting.one_max_amount;else cSetting.one_max_amount = null;
          cSetting.ratio = 1;

          cSetting.vendor_custom_product_list = [];
          gSetting.vendor_custom_product_list.forEach(function (vendorProd) {
            var vProd = {
              id: vendorProd.vendor_custom_id,
              name: vendorProd.product_name
            };
            cSetting.vendor_custom_product_list.push(vProd);
          });
          cStrategy.store_exception_items = [];
        } else if (cStrategy.rule_code === 'SC00003') {
          if (gSetting.one_max_amount) cSetting.one_max_amount = gSetting.one_max_amount;else cSetting.one_max_amount = null;
          cSetting.ratio = 1;
          cSetting.money_unit = gSetting.money_unit;

          cStrategy.store_exception_items = [{ products: [], store_ids: [] }];
          gD.coupon_strategy.store_exception_items[0].products.forEach(function (exProd) {
            var prod = {
              vendor_custom_id: exProd.vendor_custom_id,
              name: exProd.product_name
            };
            cStrategy.store_exception_items[0].products.push(prod);
          });
          cStrategy.store_exception_items[0].store_ids = gD.coupon_strategy.store_exception_items[0].store_ids;
        }
      }
      if (this.cMethod === 4 || cr || up) {
        var cList = gD.coupon_set_list;
        cList.forEach(function (c) {
          var cInfo = c.coupon_info;
          var cConfig = c.usage_store_config;
          var tConfig = c.time_config;

          var coupon = {
            coupon_info: {
              set_name: cInfo.set_name,
              set_description: cInfo.set_description,
              name: cInfo.name,
              description: cInfo.description,
              remark: cInfo.remark,
              discount_type: 1,
              discount_value: cInfo.discount_value,
              price_type: cInfo.price_type.value
            },
            usage_store_config: {
              usage_store_type: cConfig.usage_store_type.value,
              usage_method: cConfig.usage_method.value
            },
            time_config: {
              time_type: tConfig.time_type.value
            },
            is_group_usage: 1,
            amount_unit: c.amount_unit
          };

          if (coupon.usage_store_config.usage_store_type === 1) coupon.usage_store_config.usage_store_value = null;else if (coupon.usage_store_config.usage_store_type === 2) coupon.usage_store_config.usage_store_value = cConfig.usage_store_value.value;else if (coupon.usage_store_config.usage_store_type === 3 && coupon.usage_store_config.usage_method === 'order_store') coupon.usage_store_config.usage_store_value = null;else if (coupon.usage_store_config.usage_store_type === 3) coupon.usage_store_config.usage_store_value = cConfig.usage_store_value.value;

          if (coupon.usage_store_config.usage_method === 'manual') {
            if (coupon.usage_store_config.usage_store_type === 3) coupon.usage_store_config.manual_store_ids = [cConfig.usage_store_value.value];else coupon.usage_store_config.manual_store_ids = cConfig.manual_store_ids;
          }

          if (coupon.time_config.time_type === 'all_fixed') {
            coupon.time_config.start_time = tConfig.start_time;
            coupon.time_config.end_time = tConfig.end_time;
          } else if (coupon.time_config.time_type === 'day_fixed') {
            coupon.time_config.use_start_day = tConfig.use_start_day;
            coupon.time_config.end_time = tConfig.end_time;
          } else if (coupon.time_config.time_type === 'day_day') {
            coupon.time_config.use_start_day = tConfig.use_start_day;
            coupon.time_config.use_tolerance_day = tConfig.use_tolerance_day;
          }
          cS.coupon_set_list.push(coupon);
        });
      }
      data.strategy_data = s;
      data.give_coupons.push(cS);
      if (cr) this.crActivity(data);else this.upActivity(data);
    },
    setInfo: function setInfo() {
      var self = this;

      var info = this.info.info;
      var attend = this.info.attend_stores;
      var strategy = this.info.strategy_data;
      this.activity = {
        status: info.status,
        rule_code: info.rule_code,
        owner_type: this.ownerTypeOptions.find(function (option) {
          return option.value === info.owner_type;
        }),
        name: info.name,
        description: info.description,
        title: info.title,
        content: info.content,
        remark: info.remark,
        sort: info.sort,
        start_time: info.start_time,
        end_time: info.end_time,
        aTime: {
          start: { time: info.start_time },
          end: { time: info.end_time }
        },
        store_ids: [],
        strategy_data: {
          ruleCode: info.rule_code,
          rule_code: info.rule_code,
          limit: {
            order_type: [],
            order_method: [],
            delivery_type: [],
            pay_place_type: [],
            min_total_paid_money: strategy.limit.min_total_paid_money,
            min_total_money: strategy.limit.min_total_money,
            min_total_amount: strategy.limit.min_total_amount,
            min_paid_money: strategy.limit.min_paid_money,
            min_money: strategy.limit.min_money,
            min_amount: strategy.limit.min_amount,
            min_sub_order_amount: strategy.limit.min_sub_order_amount
          },
          setting: {
            money_unit: strategy.setting.money_unit,
            max_count: strategy.setting.max_count,
            vendorCustomProductList: [],
            vendor_custom_product_list: [],
            vendorList: [],
            amount_unit: 1,
            lowest_unit_price: ''
          },
          store_exception_items: [{
            products: [],
            productList: [],
            store_ids: []
          }]
        }
      };

      if (info.owner_type === 1) {
        attend.forEach(function (brand) {
          var bId = brand.brand_id;

          var brandOption = self.brandBrief.find(function (brand) {
            return bId === brand.value;
          });
          self.brandSelectMuti.push(brandOption);
        });
        self.getMutiStore();
      } else if (info.owner_type === 2) {
        this.brandSelect = this.brandBrief.find(function (brand) {
          return info.owner_id === brand.value;
        });
        self.getStore();
      } else if (info.owner_type === 3) {
        self.brandSelect = self.brandBrief.find(function (brand) {
          return attend[0].brand_id === brand.value;
        });

        self.getStore();
      }

      if (strategy.setting.lowest_unit_price) this.activity.strategy_data.setting.lowest_unit_price = strategy.setting.lowest_unit_price;

      if (strategy.setting.amount) this.activity.strategy_data.setting.amount_unit = strategy.setting.amount;else if (strategy.setting.amount_unit) this.activity.strategy_data.setting.amount_unit = strategy.setting.amount_unit;

      this.setInfoTimes++;
    },
    setStore: function setStore() {
      var self = this;
      var brands = this.info.attend_stores;
      if (brands.length) {
        brands.forEach(function (brand) {
          brand.store_list.forEach(function (store) {
            self.addStoresSetting.choose.push(store.store_id);
          });
        });
      }
    },
    crActivity: function crActivity(data) {
      var self = this;
      var url = '/activity/orderCouponComplete';
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.replace('/upCouponTable');
        }
      });
    },
    upActivity: function upActivity(data) {
      var self = this;
      var url = '/activity/' + this.$route.params.activity_id + '/orderCouponComplete';
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.replace('/upCouponTable');
        }
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    }
  }),
  watch: {
    'activity.aTime.start.time': function activityATimeStartTime() {
      this.endLimit = [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.activity.aTime.start.time).subtract(1, 'days')
      }];
    },
    'content.bindingBrandList': function contentBindingBrandList() {
      var self = this;
      this.storeBrief = [];
      this.content.bindingStoreList = [];
      this.content.bindingBrandList.forEach(function (array) {
        var brandId = array.value;
        self.getStoreBrief(brandId);
      });
    },
    'addStoresSetting.choose': function addStoresSettingChoose() {
      this.activity.store_ids = this.addStoresSetting.choose;
      this.aStoreList = [];
      var self = this;
      if (this.addStoresSetting.choose.length) {
        this.addStoresSetting.choose.forEach(function (sId) {
          var store = self.addStoresSetting.options.find(function (obj) {
            return obj.value === sId;
          });
          self.aStoreList.push(store);
        });
      }
    },
    'activity.title': function activityTitle() {
      if (this.$route.name.indexOf('cr') > -1) this.activity.name = this.activity.title;
    },
    'activity.content': function activityContent() {
      if (this.$route.name.indexOf('cr') > -1) this.activity.description = this.activity.content;
    },
    'info.info': function infoInfo() {
      var self = this;
      if (self.$route.name.indexOf('up') > -1 && !self.setInfoTimes && self.info.info.activity_id) self.getBrandBrief();
    }
  }
});

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CouponListInfo_vue__ = __webpack_require__(2183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CouponListInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__CouponListInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CouponStrategyInfo_vue__ = __webpack_require__(2185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CouponStrategyInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__CouponStrategyInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ActivityStrategyInfo_vue__ = __webpack_require__(2180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ActivityStrategyInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ActivityStrategyInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ActivitySummary_vue__ = __webpack_require__(2181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ActivitySummary_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ActivitySummary_vue__);













/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    info: Object
  },
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default.a,
    'coupon-list': __WEBPACK_IMPORTED_MODULE_6__CouponListInfo_vue___default.a,
    'coupon-strategy': __WEBPACK_IMPORTED_MODULE_7__CouponStrategyInfo_vue___default.a,
    'activity-strategy': __WEBPACK_IMPORTED_MODULE_8__ActivityStrategyInfo_vue___default.a,
    'activity-summary': __WEBPACK_IMPORTED_MODULE_9__ActivitySummary_vue___default.a
  },
  data: function data() {
    return {
      cMethod: 1,
      activityMethod: 1,

      orderType: [{ label: '一般單', value: 1 }, { label: '團購單 - 團長', value: 2 }, { label: '團購單 - 團員', value: 3 }],
      orderMethod: [{ label: '當日單', value: 1 }, { label: '預訂單', value: 2 }],
      deliveryType: [{ label: '自取', value: 1 }, { label: '內用', value: 2 }, { label: '外送', value: 3 }, { label: '內用-桌邊掃碼', value: 21 }],
      coupon: {
        type: { label: '固定起迄時間', value: 1 },
        price_type: { label: '免稅', value: 1 },
        discount_type: { label: '折扣金額', value: 1 },
        setting: { label: '依訂單購買商品數設定', value: 1 },
        useType: { label: '品牌型', value: 2 }
      },
      otherCoupon: [],

      otherCouponList: [{ label: 'Nidin優惠券', value: 1, code: '1231231dz' }, { label: '柴犬優惠券', value: 2, code: '324efxde' }, { label: '你好優惠券', value: 3, code: '654trrgxx' }],
      addStoresSetting: {
        class: 'buy-add-store',
        options: [],
        choose: []
      },

      deadType: [{ label: '固定起迄時間', value: 'all_fixed' }, { label: '固定結束時間', value: 'day_fixed' }, { label: '發送日幾天後', value: 'day_day' }],
      discountType: [{ label: '折扣金額', value: 1 }],
      couponSetting: [{ label: '依訂單購買商品數設定', value: 'SC00001' }, { label: '依個人訂單消費特定商品數', value: 'SC00002' }, { label: '依個人訂單購買金額', value: 'SC00003' }],
      useType: [{ label: '品牌型', value: 2 }, { label: '門市型', value: 3 }],
      usageValue: [],
      brandList: [],
      content: {
        bindingStoreList: [],
        bindingBrandList: [],
        bindingProdList: []
      },
      brandDefault: '',
      brandBrief: [],
      storeBrief: [],
      scheduleTime: '',
      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: ''
        }
      },
      show: {
        back: false
      },
      tableIndex: 1,
      menuId: 0,
      menuName: '',
      storeId: 0,
      startTime: {
        time: ''
      },
      endtime: {
        time: ''
      },
      giftList: [{ label: '依店家訂單消費金額滿額送', value: 1 }, { label: '依店家訂單商品個數滿額送', value: 2 }, { label: '依店家訂單消費指定商品數量滿額送', value: 3 }],
      timeoption: {
        type: 'min',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD HH:mm:ss',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      startLimit: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD HH:mm:ss')
      }],
      endLimit: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD HH:mm:ss')
      }],
      couponList: [{
        coupon_info: { set_name: '', set_description: '', name: '', description: '', remark: '', discount_type: '', discountType: { label: '折扣金額', value: 1 }, discount_value: '', priceType: { label: '免稅', value: 1 }, price_type: '' },
        usage_store_config: { isFollowStore: true, usageStoreType: { label: '品牌型', value: 2 }, usage_store_type: '', usageStoreValue: '', usage_store_value: '', usage_method: 'manual', manual_store_ids: [] },
        time_config: { timeType: { label: '固定起迄時間', value: 'all_fixed' }, time_type: '', startTime: { time: '' }, endTime: { time: '' }, start_time: '', end_time: '', use_start_day: '', use_tolerance_day: '' },
        is_group_usage: 1,
        isGroupUsage: true,
        amount_unit: 1,
        coupon_strategy: {
          ruleCode: { label: '依訂單購買商品數設定', value: 'SC00001' },
          rule_code: '',
          name: '',
          description: '',
          limit: {
            min_amount: 1,
            min_money: '',
            order_method: '',
            orderMethod: '',
            order_types: [],
            orderTypes: [],
            delivery_types: [],
            deliveryTypes: []
          },
          setting: {
            one_max_amount: null,
            ratio: 1,
            lowest_unit_price: 0,
            money_unit: ''
          },
          store_exception_items: [{
            products: [],
            store_ids: []
          }]
        }
      }],
      activity: {
        rule_code: 'SA00001',
        owner_type: { label: '品牌', value: 2 },
        name: '',
        description: '',
        title: '',
        content: '',
        remark: '',
        sort: 1,
        start_time: '',
        end_time: '',
        aTime: {
          start: { time: '' },
          end: { time: '' }
        },
        store_ids: [],
        strategy_data: {
          ruleCode: 'SA00001',
          rule_code: 'SA00001',
          limit: {
            order_type: [],
            order_method: [],
            delivery_type: [],
            pay_place_type: [],
            min_total_paid_money: '',
            min_total_money: '',
            min_total_amount: '',
            min_paid_money: '',
            min_money: '',
            min_amount: '',
            min_sub_order_amount: ''
          },
          setting: {
            money_unit: '',
            max_count: '',
            vendorCustomProductList: [],
            vendor_custom_product_list: [],
            vendorList: [],
            amount_unit: 1
          },
          store_exception_items: [{
            products: [],
            productList: [],
            store_ids: []
          }]
        }
      },
      productBrief: [],
      productChoseBrief: [],
      nowTime: __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD HH:mm'),

      ownerTypeOptions: [{ label: '品牌', value: 2 }, { label: '門市', value: 3 }, { label: '平台', value: 1 }],
      giveCoupons: {
        coupon_strategy: {},
        coupon_set_list: []
      },
      curId: 0,
      reNew: 0,
      reSet: 0,
      aStoreList: [],
      aStoreOption: [],
      brandSelect: {
        label: '',
        value: ''
      },
      brandSelectMuti: [],
      tradeType: [],
      tradeTypePlace: [{ label: '線上結帳', value: 10 }, { label: 'POS店家結帳', value: 50 }],
      setInfoTimes: 0
    };
  },
  created: function created() {
    if (this.$route.query.rule_code) {
      this.activity.strategy_data.ruleCode = this.$route.query.rule_code;
      this.activity.strategy_data.rule_code = this.$route.query.rule_code;
      this.activity.rule_code = this.$route.query.rule_code;
    } else if (this.info.info.rule_code) {
      this.activity.strategy_data.ruleCode = this.info.info.rule_code;
      this.activity.strategy_data.rule_code = this.info.info.rule_code;
      this.activity.rule_code = this.info.info.rule_code;
    }
    if (this.$route.name.indexOf('up') === -1) this.getBrandBrief();
    this.getTradeTypeList();

    if (this.getRoleType === 30) this.activity.owner_type = { label: '品牌', value: 2 };else if (this.getRoleType === 10) this.activity.owner_type = { label: '門市', value: 3 };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['setMenuStartTime', 'setMenuEndTime']), {
    getStoreName: function getStoreName(sId) {
      if (this.addStoresSetting.options) return this.addStoresSetting.options.find(function (stores) {
        return sId === stores.value;
      }).label;
    },
    addChooseTag: function addChooseTag(newTag) {
      var tag = {
        name: newTag,
        id: ''
      };
      this.productChoseBrief.push(tag);
      this.activity.setting.vendorCustomProductList.push(tag);
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    getStoreBrief: function getStoreBrief(brandId, last) {
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
            self.addStoresSetting.options.push(obj);
          }
          if (self.info.info.activity_id && self.setInfoTimes && last) self.setStore();
        }
      });
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;

          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            self.brandBrief.push(obj);
          }
          if (self.$route.name.indexOf('up') > -1 && !self.setInfoTimes && self.info.info) {
            self.setInfo();
          }
        }
      });
    },
    getTradeTypeList: function getTradeTypeList() {
      var self = this;
      var url = '/platform/tradeTypeList';
      this.getData('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.tradeInfo = [];
          var list = response.data.list;
          for (var i = 0; i < list.length; i++) {
            if (list[i].is_valid && list[i].is_enable) {
              var option = {
                label: list[i].name,
                value: parseInt(list[i].type, 10)
              };
              self.tradeType.push(option);
            }
          }
        }
      });
    },
    getMutiStore: function getMutiStore() {
      this.aStoreOption = [];
      this.storeBrief = [];
      this.addStoresSetting.options = [];
      this.addStoresSetting.choose = [];
      this.brandList = [];
      var self = this;
      this.brandSelectMuti.forEach(function (brand, index) {
        if (index + 1 === self.brandSelectMuti.length) self.getStoreBrief(brand.value, true);else self.getStoreBrief(brand.value);
        self.brandList.push(brand);
      });
    },
    getStore: function getStore() {
      this.aStoreOption = [];
      this.storeBrief = [];
      this.addStoresSetting.options = [];
      this.addStoresSetting.choose = [];
      this.brandList = [];
      if (this.brandSelect.value) this.getStoreBrief(this.brandSelect.value, true);
      this.brandList.push(this.brandSelect);
    },
    getIndex: function getIndex(tab, index) {
      if (tab && this.cMethod > index) {
        this.cMethod = index;
      } else if (tab) {
        this.cMethod = index;
      } else if (this.cMethod !== 4) {
        this.cMethod++;
      }
    },
    checkCoupon: function checkCoupon(coupon, index) {
      var c = coupon;
      var cInfo = coupon.coupon_info;
      var usConfig = coupon.usage_store_config;
      var tConfig = coupon.time_config;
      var msg = '';
      if (!cInfo.name) msg = '第' + index + '張優惠券名稱(前台)未填';else if (!cInfo.set_name) msg = cInfo.name + '的優惠券名稱(後台)未填';else if (!cInfo.description) msg = cInfo.name + '的優惠券說明(前台)未填';else if (!cInfo.set_description) msg = cInfo.name + '的優惠券說明(後台)未填';else if (!cInfo.remark) msg = cInfo.name + '的優惠券備註未填';else if (!cInfo.discount_value) msg = cInfo.name + '的優惠券折扣金額未填';else if (this.checkNumber(cInfo.discount_value)) msg = cInfo.name + '的優惠券折扣金額非數字';else if (!c.amount_unit) msg = cInfo.name + '的一次發送張數未填';else if (this.checkNumber(c.amount_unit)) msg = cInfo.name + '的一次發送張數非數字';else if (!cInfo.price_type.value) msg = cInfo.name + '的優惠券稅制未選';else if (!usConfig.usage_store_type.value) msg = cInfo.name + '的優惠券類型未選';else if (!usConfig.usage_method.value) msg = cInfo.name + '的優惠券類型未選';else if (usConfig.usage_store_type.value === 2 && !usConfig.usage_store_value) msg = cInfo.name + '的適用對象未填';else if (usConfig.usage_method.value === 'manual' && !usConfig.usage_store_value) msg = cInfo.name + '的適用對象未填';else if (!tConfig.time_type.value) msg = cInfo.name + '的適用門市方式未選';else if (tConfig.time_type.value === 'all_fixed' && !tConfig.start_time) msg = cInfo.name + '的開始時間未填';else if (tConfig.time_type.value === 'all_fixed' && !__WEBPACK_IMPORTED_MODULE_5_moment___default()(tConfig.start_time, 'YYYY-MM-DD HH:mm:ss').isValid()) msg = cInfo.name + '的開始時間格式錯誤';else if (tConfig.time_type.value === 'all_fixed' && !tConfig.end_time) msg = cInfo.name + '的結束時間未填';else if (tConfig.time_type.value === 'all_fixed' && !__WEBPACK_IMPORTED_MODULE_5_moment___default()(tConfig.end_time, 'YYYY-MM-DD HH:mm:ss').isValid()) msg = cInfo.name + '的結束時間格式錯誤';else if (tConfig.time_type.value === 'day_fixed' && !tConfig.use_start_day) msg = cInfo.name + '的拿到優惠券後幾天開始未填';else if (tConfig.time_type.value === 'day_fixed' && this.checkNumber(tConfig.use_start_day)) msg = cInfo.name + '的拿到優惠券後幾天開始非數字';else if (tConfig.time_type.value === 'day_fixed' && !tConfig.end_time) msg = cInfo.name + '的結束時間未填';else if (tConfig.time_type.value === 'day_fixed' && !__WEBPACK_IMPORTED_MODULE_5_moment___default()(tConfig.end_time, 'YYYY-MM-DD HH:mm:ss').isValid()) msg = cInfo.name + '的結束時間格式錯誤';else if (tConfig.time_type.value === 'day_day' && !tConfig.use_start_day) msg = cInfo.name + '的拿到優惠券後幾天開始未填';else if (tConfig.time_type.value === 'day_day' && this.checkNumber(tConfig.use_start_day)) msg = cInfo.name + '的拿到優惠券後幾天開始非數字';else if (tConfig.time_type.value === 'day_day' && !tConfig.use_tolerance_day) msg = cInfo.name + '的開始後幾天結束未填';else if (tConfig.time_type.value === 'day_day' && this.checkNumber(tConfig.use_tolerance_day)) msg = cInfo.name + '的開始後幾天結束非數字';else if (usConfig.usage_method.value === 'manual' && !usConfig.manual_store_ids.length) msg = cInfo.name + '的優惠券可用店家未新增';
      return msg;
    },
    checkNumber: function checkNumber(val) {
      if (isNaN(parseInt(val, 10))) return true;else if (typeof parseInt(val, 10) !== 'number') return true;
      return false;
    },
    setData: function setData() {
      var self = this;
      var data = {
        strategy_data: {},
        give_coupons: []
      };
      var s = {
        setting: {},
        limit: {}
      };
      var cS = {
        coupon_strategy: {
          setting: {},
          limit: {}
        },
        coupon_set_list: []
      };
      var a = this.activity;
      var sD = a.strategy_data;
      var gD = this.giveCoupons;
      var cr = this.$route.name === 'crActivityInfoForm';
      var up = this.$route.name === 'upActivity';
      var ruleCode = 'SA00001';
      if (this.$route.query.rule_code) ruleCode = this.$route.query.rule_code;else if (this.info.info.rule_code) ruleCode = this.info.info.rule_code;
      if (this.cMethod === 1 || cr || up) {
        data.rule_code = ruleCode;

        data.owner_type = a.owner_type.value;

        data.owner_id = 0;
        if (data.owner_type === 1) data.owner_id = 0;else if (data.owner_type === 2) data.owner_id = this.brandSelect.value;else if (data.owner_type === 3) data.owner_id = this.addStoresSetting.choose[0];
        data.name = a.name;
        if (a.description) data.description = a.description;
        data.title = a.title;
        data.content = a.content;
        if (a.remark) data.remark = a.remark;
        data.sort = a.sort;
        data.start_time = a.aTime.start.time;
        data.end_time = a.aTime.end.time;
        data.store_ids = this.addStoresSetting.choose;
      }
      if (this.cMethod === 2 || cr || up) {
        var sLimit = s.limit;
        var sDLimit = sD.limit;
        var sSetting = s.setting;
        var sDSetting = sD.setting;

        if (sDLimit.delivery_type.length) {
          sLimit.delivery_type = [];
          sDLimit.delivery_type.forEach(function (dType) {
            sLimit.delivery_type.push(self.deliveryType.find(function (o) {
              return o.value === dType.value;
            }).value);
          });
        }
        if (sDLimit.order_type.length) {
          sLimit.order_type = [];
          sDLimit.order_type.forEach(function (oType) {
            sLimit.order_type.push(self.orderType.find(function (o) {
              return o.value === oType.value;
            }).value);
          });
        }
        if (sDLimit.pay_place_type.length) {
          sLimit.pay_place_type = [];
          sDLimit.pay_place_type.forEach(function (tTypePlace) {
            sLimit.pay_place_type.push(self.tradeTypePlace.find(function (o) {
              return o.value === tTypePlace.value;
            }).value);
          });
        }
        if (sDLimit.order_method.length) {
          sLimit.order_method = [];
          sDLimit.order_method.forEach(function (oMethod) {
            sLimit.order_method.push(self.orderMethod.find(function (o) {
              return o.value === oMethod.value;
            }).value);
          });
        }
        if (sDLimit.min_total_paid_money) sLimit.min_total_paid_money = sDLimit.min_total_paid_money;
        if (sDLimit.min_total_money) sLimit.min_total_money = sDLimit.min_total_money;
        if (sDLimit.min_total_amount) sLimit.min_total_amount = sDLimit.min_total_amount;
        if (sDLimit.min_paid_money) sLimit.min_paid_money = sDLimit.min_paid_money;
        if (sDLimit.min_money) sLimit.min_money = sDLimit.min_money;
        if (sDLimit.min_amount) sLimit.min_amount = sDLimit.min_amount;
        if (sDLimit.min_sub_order_amount) sLimit.min_sub_order_amount = sDLimit.min_sub_order_amount;

        if (data.rule_code === 'SA00001') {
          sSetting.money_unit = sDSetting.money_unit;

          if (sDSetting.max_count) sSetting.max_count = sDSetting.max_count;else sSetting.max_count = null;

          s.store_exception_items = [{ products: [], store_ids: [] }];
          sD.store_exception_items[0].products.forEach(function (exProd) {
            var prod = {
              vendor_custom_id: exProd.vendor_custom_id,
              name: exProd.name
            };
            s.store_exception_items[0].products.push(prod);
          });
          s.store_exception_items[0].store_ids = this.addStoresSetting.choose;
        } else if (data.rule_code === 'SA00002') {
          sSetting.amount_unit = sDSetting.amount_unit;
          sSetting.lowest_unit_price = sDSetting.lowest_unit_price;

          if (sDSetting.max_count) sSetting.max_count = sDSetting.max_count;else sSetting.max_count = null;

          s.store_exception_items = [{ products: [], store_ids: [] }];
          sD.store_exception_items[0].products.forEach(function (exProd) {
            var prod = {
              vendor_custom_id: exProd.vendor_custom_id,
              name: exProd.name
            };
            s.store_exception_items[0].products.push(prod);
          });
          s.store_exception_items[0].store_ids = this.addStoresSetting.choose;
        } else if (data.rule_code === 'SA00003') {
          sSetting.amount_unit = sDSetting.amount_unit;

          if (sDSetting.max_count) sSetting.max_count = sDSetting.max_count;else sSetting.max_count = null;

          sSetting.vendor_custom_product_list = [];
          sDSetting.vendor_custom_product_list.forEach(function (vendorProd) {
            var vProd = {
              id: vendorProd.id,
              name: vendorProd.name
            };
            sSetting.vendor_custom_product_list.push(vProd);
          });
          s.store_exception_items = [];
        }
      }
      if (this.cMethod === 3 || cr || up) {
        cS.coupon_strategy.rule_code = gD.coupon_strategy.rule_code;
        cS.coupon_strategy.name = gD.coupon_strategy.name;
        cS.coupon_strategy.description = gD.coupon_strategy.description;
        var cLimit = cS.coupon_strategy.limit;
        var gCLimit = gD.coupon_strategy.limit;
        var cSetting = cS.coupon_strategy.setting;
        var gSetting = gD.coupon_strategy.setting;

        cLimit.min_amount = gCLimit.min_amount;
        if (gCLimit.min_money) cLimit.min_money = gCLimit.min_money;
        if (gCLimit.delivery_types.length) {
          cLimit.delivery_types = [];
          gCLimit.delivery_types.forEach(function (dType) {
            cLimit.delivery_types.push(self.deliveryType.find(function (o) {
              return o.value === dType.value;
            }).value);
          });
        }
        if (gCLimit.order_types.length) {
          cLimit.order_types = [];
          gCLimit.order_types.forEach(function (oType) {
            cLimit.order_types.push(self.orderType.find(function (o) {
              return o.value === oType.value;
            }).value);
          });
        }
        if (gCLimit.order_method) {
          cLimit.order_method = gCLimit.order_method.value;
        }

        var cStrategy = cS.coupon_strategy;
        if (cStrategy.rule_code === 'SC00001') {
          if (gSetting.one_max_amount) cSetting.one_max_amount = gSetting.one_max_amount;else cSetting.one_max_amount = null;
          cSetting.ratio = 1;
          if (gSetting.lowest_unit_price) cSetting.lowest_unit_price = gSetting.lowest_unit_price;else cSetting.lowest_unit_price = 0;

          cStrategy.store_exception_items = [{ products: [], store_ids: [] }];
          gD.coupon_strategy.store_exception_items[0].products.forEach(function (exProd) {
            var prod = {
              vendor_custom_id: exProd.vendor_custom_id,
              name: exProd.name
            };
            cStrategy.store_exception_items[0].products.push(prod);
          });
          cStrategy.store_exception_items[0].store_ids = gD.coupon_strategy.store_exception_items[0].store_ids;
        } else if (cStrategy.rule_code === 'SC00002') {
          if (gSetting.one_max_amount) cSetting.one_max_amount = gSetting.one_max_amount;else cSetting.one_max_amount = null;
          cSetting.ratio = 1;

          cSetting.vendor_custom_product_list = [];
          gSetting.vendor_custom_product_list.forEach(function (vendorProd) {
            var vProd = {
              id: vendorProd.id,
              name: vendorProd.name
            };
            cSetting.vendor_custom_product_list.push(vProd);
          });
          cStrategy.store_exception_items = [];
        } else if (cStrategy.rule_code === 'SC00003') {
          if (gSetting.one_max_amount) cSetting.one_max_amount = gSetting.one_max_amount;else cSetting.one_max_amount = null;
          cSetting.ratio = 1;
          cSetting.money_unit = gSetting.money_unit;

          cStrategy.store_exception_items = [{ products: [], store_ids: [] }];
          gD.coupon_strategy.store_exception_items[0].products.forEach(function (exProd) {
            var prod = {
              vendor_custom_id: exProd.vendor_custom_id,
              name: exProd.name
            };
            cStrategy.store_exception_items[0].products.push(prod);
          });
          cStrategy.store_exception_items[0].store_ids = gD.coupon_strategy.store_exception_items[0].store_ids;
        }
      }
      if (this.cMethod === 4 || cr || up) {
        var cList = gD.coupon_set_list;
        cList.forEach(function (c) {
          var cInfo = c.coupon_info;
          var cConfig = c.usage_store_config;
          var tConfig = c.time_config;

          var coupon = {
            coupon_info: {
              set_name: cInfo.set_name,
              set_description: cInfo.set_description,
              name: cInfo.set_description,
              description: cInfo.description,
              remark: cInfo.remark,
              discount_type: 1,
              discount_value: cInfo.discount_value,
              price_type: cInfo.price_type.value
            },
            usage_store_config: {
              usage_store_type: cConfig.usage_store_type.value,
              usage_method: cConfig.usage_method.value
            },
            time_config: {
              time_type: tConfig.time_type.value
            },
            is_group_usage: 1,
            amount_unit: c.amount_unit
          };

          if (coupon.usage_store_config.usage_store_type === 1) coupon.usage_store_config.usage_store_value = null;else if (coupon.usage_store_config.usage_store_type === 2) coupon.usage_store_config.usage_store_value = cConfig.usage_store_value.value;else if (coupon.usage_store_config.usage_store_type === 3 && coupon.usage_store_config.usage_method === 'order_store') coupon.usage_store_config.usage_store_value = null;else if (coupon.usage_store_config.usage_store_type === 3) coupon.usage_store_config.usage_store_value = cConfig.usage_store_value.value;

          if (coupon.usage_store_config.usage_method === 'manual') {
            if (coupon.usage_store_config.usage_store_type === 3) coupon.usage_store_config.manual_store_ids = [cConfig.usage_store_value.value];else coupon.usage_store_config.manual_store_ids = cConfig.manual_store_ids;
          }

          if (coupon.time_config.time_type === 'all_fixed') {
            coupon.time_config.start_time = tConfig.start_time;
            coupon.time_config.end_time = tConfig.end_time;
          } else if (coupon.time_config.time_type === 'day_fixed') {
            coupon.time_config.use_start_day = tConfig.use_start_day;
            coupon.time_config.end_time = tConfig.end_time;
          } else if (coupon.time_config.time_type === 'day_day') {
            coupon.time_config.use_start_day = tConfig.use_start_day;
            coupon.time_config.use_tolerance_day = tConfig.use_tolerance_day;
          }
          cS.coupon_set_list.push(coupon);
        });
      }
      data.strategy_data = s;
      data.give_coupons.push(cS);
      if (cr) this.crActivity(data);else this.upActivity(data);
    },
    setInfo: function setInfo() {
      var self = this;
      var info = this.info.info;
      var attend = this.info.attend_stores;
      var strategy = this.info.strategy_data;
      this.activity = {
        rule_code: info.rule_code,
        owner_type: this.ownerTypeOptions.find(function (option) {
          return option.value === info.owner_type;
        }),
        name: info.name,
        description: info.description,
        title: info.title,
        content: info.content,
        remark: info.remark,
        sort: info.sort,
        start_time: info.start_time,
        end_time: info.end_time,
        aTime: {
          start: { time: info.start_time },
          end: { time: info.end_time }
        },
        store_ids: [],
        strategy_data: {
          ruleCode: info.rule_code,
          rule_code: info.rule_code,
          limit: {
            order_type: [],
            order_method: [],
            delivery_type: [],
            pay_place_type: [],
            min_total_paid_money: strategy.limit.min_total_paid_money,
            min_total_money: strategy.limit.min_total_money,
            min_total_amount: strategy.limit.min_total_amount,
            min_paid_money: strategy.limit.min_paid_money,
            min_money: strategy.limit.min_money,
            min_amount: strategy.limit.min_amount,
            min_sub_order_amount: strategy.limit.min_sub_order_amount
          },
          setting: {
            money_unit: strategy.setting.money_unit,
            max_count: strategy.setting.max_count,
            vendorCustomProductList: [],
            vendor_custom_product_list: [],
            vendorList: [],
            amount_unit: 1,
            lowest_unit_price: ''
          },
          store_exception_items: [{
            products: [],
            productList: [],
            store_ids: []
          }]
        }
      };

      if (info.owner_type === 1) {
        attend.forEach(function (brand) {
          var bId = brand.brand_id;
          var brandOption = self.brandBrief.find(function (brand) {
            return bId === brand.value;
          });
          self.brandSelectMuti.push(brandOption);
        });
        self.getMutiStore();
      } else if (info.owner_type === 2) {
        this.brandSelect = this.brandBrief.find(function (brand) {
          return info.owner_id === brand.value;
        });
        self.getStore();
      } else if (info.owner_type === 3) {
        self.brandSelect = self.brandBrief.find(function (brand) {
          return attend[0].brand_id === brand.value;
        });

        self.getStore();
      }

      if (strategy.setting.lowest_unit_price) this.activity.strategy_data.setting.lowest_unit_price = strategy.setting.lowest_unit_price;

      if (strategy.setting.amount) this.activity.strategy_data.setting.amount_unit = strategy.setting.amount;else if (strategy.setting.amount_unit) this.activity.strategy_data.setting.amount_unit = strategy.setting.amount_unit;

      this.setInfoTimes++;
    },
    setStore: function setStore() {
      var self = this;
      var brands = this.info.attend_stores;
      if (brands.length) {
        brands.forEach(function (brand) {
          brand.store_list.forEach(function (store) {
            self.addStoresSetting.choose.push(store.store_id);
          });
        });
      }
    },
    crActivity: function crActivity(data) {
      var self = this;
      var url = '/activity/orderCouponComplete';
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.replace('/couponTable');
        }
      });
    },
    upActivity: function upActivity(data) {
      var self = this;
      var url = '/activity/' + this.$route.params.activity_id + '/orderCouponComplete';
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.replace('/upCouponTable');
        }
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    },
    getFile: function getFile() {
      return this.$parent.getFile;
    }
  }),
  watch: {
    'activity.aTime.start.time': function activityATimeStartTime() {
      this.endLimit = [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.activity.aTime.start.time).subtract(1, 'days')
      }];
    },
    'content.bindingBrandList': function contentBindingBrandList() {
      var self = this;
      this.storeBrief = [];
      this.content.bindingStoreList = [];
      this.content.bindingBrandList.forEach(function (array) {
        var brandId = array.value;
        self.getStoreBrief(brandId);
      });
    },
    'addStoresSetting.choose': function addStoresSettingChoose() {
      this.activity.store_ids = this.addStoresSetting.choose;
      this.aStoreList = [];
      var self = this;
      if (this.addStoresSetting.choose.length) {
        this.addStoresSetting.choose.forEach(function (sId) {
          var store = self.addStoresSetting.options.find(function (obj) {
            return obj.value === sId;
          });
          self.aStoreList.push(store);
        });
      }
    },
    'activity.title': function activityTitle() {
      if (this.$route.name.indexOf('cr') > -1) this.activity.name = this.activity.title;
    },
    'activity.content': function activityContent() {
      if (this.$route.name.indexOf('cr') > -1) this.activity.description = this.activity.content;
    },
    'info.info.activity_id': function infoInfoActivity_id() {
      this.setInfo();
    }
  }
});

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue___default.a
  },
  data: function data() {
    return {
      activityMethod: 1,

      orderType: '',
      orderMethod: '',
      delivery: '',
      payplace: '',
      memberLimit: [],
      coupon: {
        type: { label: '固定起迄時間', value: 1 },
        price_type: { label: '免稅', value: 1 },
        discount_type: { label: '折扣金額', value: 1 },
        setting: { label: '依訂單購買商品數設定', value: 1 },
        useType: { label: '品牌型', value: 1 }
      },
      otherCoupon: [],

      otherCouponList: [{ label: 'Nidin優惠券', value: 1, code: '1231231dz' }, { label: '柴犬優惠券', value: 2, code: '324efxde' }, { label: '你好優惠券', value: 3, code: '654trrgxx' }],
      addStoresSetting: {
        class: 'add-store',
        options: [{ label: '台北', value: 1 }, { label: '新竹', value: 2 }, { label: '苗栗', value: 3 }, { label: '台中', value: 4 }, { label: '彰化', value: 5 }, { label: '台南', value: 6 }, { label: '高雄', value: 7 }, { label: '屏東', value: 8 }],
        choose: []
      },
      deadType: [{ label: '固定起迄時間', value: 1 }, { label: '固定結束時間', value: 2 }, { label: '發送日幾天後', value: 3 }],
      priceType: [{ label: '免稅', value: 1 }, { label: '未稅', value: 2 }, { label: '含稅', value: 3 }],
      discountType: [{ label: '折扣金額', value: 1 }],
      couponSetting: [{ label: '依訂單購買商品數設定', value: 1 }, { label: '依個人訂單消費特定商品數', value: 2 }, { label: '依個人訂單購買金額', value: 3 }],
      memberType: [{ label: 'FB', value: 1 }, { label: 'Google', value: 2 }, { label: 'LINE', value: 3 }],
      useType: [{ label: '品牌型', value: 1 }, { label: '店家型', value: 2 }],
      content: {
        bindingStoreList: [],
        bindingBrandList: []
      },
      brandDefault: '',
      brandBrief: [],
      storeBrief: [],
      oldScheduleTime: '',
      scheduleTime: '',
      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: ''
        }
      },
      show: {
        back: false
      },
      giftSelect: 1,
      tableIndex: 1,
      menuId: 0,
      menuName: '',
      storeId: 0,
      startTime: {
        time: ''
      },
      endtime: {
        time: ''
      },
      giftList: [{ label: '依店家訂單消費金額滿額送', value: 1 }, { label: '依店家訂單商品個數滿額送', value: 2 }, { label: '依店家訂單消費指定商品數量滿額送', value: 3 }],
      timeoption: {
        type: 'min',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD HH:mm:ss',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      startLimit: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD HH:mm:ss')
      }],
      endLimit: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD HH:mm:ss')
      }],
      info: {
        menuName: '夏日菜單',
        menu_id: 123323,
        start_time: '2017-03-31 12:22:32',
        end_time: '2017-03-31 12:22:32',
        update_time: '2017-03-31 12:22:32',
        create_time: '2017-03-31 12:22:32'
      },
      menu_schedule_list: [{
        'schedule_id': 122,
        'store_id': 1,
        'store_name': '金山店',
        'menu_id': 1,
        'start_time': '2017-07-24 08:00:00',
        'end_time': '2017-08-01 00:00:00',
        'status': 1,
        'update_time': '2017-01-14 16:09:16',
        'create_time': '2017-01-14 16:09:16'
      }, {
        'schedule_id': 123,
        'store_id': 2,
        'store_name': '中山店',
        'menu_id': 2,
        'start_time': '2017-07-24 08:00:00',
        'end_time': '2017-08-01 00:00:00',
        'status': 1,
        'update_time': '2017-01-14 16:09:16',
        'create_time': '2017-01-14 16:09:16'
      }],
      couponList: [{ name: 'Nidin優惠券' }, { name: 'Nidin優惠券' }]
    };
  },
  created: function created() {
    this.getBrandBrief();

    console.log(this.$route.query);
    if (this.$route.name === 'upScheduleOne') {
      this.menuId = this.$route.params.menu_id;
      this.storeId = this.$route.params.store_id;
    } else if (this.$route.query.menu_id) {
      this.menuId = this.$route.query.menu_id;
      this.menuName = this.$route.query.menu_name;
    }
  },
  mounted: function mounted() {
    var self = this;
    self.oldScheduleTime = self.scheduleTime = '2015-01-01 01:30:00 - 2015-01-02 01:30:00';
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#example1_wrapper').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      });
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapActions */])(['setMenuStartTime', 'setMenuEndTime']), {
    addCoupon: function addCoupon() {
      this.couponList.push({ name: 'Nidin優惠券' });
    },
    clickCoupon: function clickCoupon() {},
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    getNewList: function getNewList(index) {
      console.log('LOVE' + index);
    },
    getStoreBrief: function getStoreBrief(brandId) {
      this.storeBrief = [];
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
          }
        }
      });
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            self.brandBrief.push(obj);
          }
        }
      });
    },
    crSchedule: function crSchedule() {
      var self = this;
      var data = {
        store_id: [],
        menu_id: self.menuId,
        start_time: self.menuTime.start.time,
        end_time: self.menuTime.end.time
      };
      self.content.bindingStoreList.forEach(function (store) {
        data.store_id.push(store.value);
      });
      var url = '/brand/' + this.$route.params.brand_id + '/menu/schedule/group';
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          console.log(response.data);
          self.$notify({
            title: '提醒',
            text: '新增菜單成功',
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.replace('/brandScheduleTable/' + self.$route.params.brand_id);
        }
      });
    },
    changeOtherCoupon: function changeOtherCoupon(current) {
      this.couponList.push(current);
      console.log(current);
    },
    removeOtherCoupon: function removeOtherCoupon(current) {
      var self = this;
      var removeId = '';
      this.couponList.find(function (coupon, index) {
        if (coupon.code) {
          if (current.code === coupon.code) {
            console.log(index);
            removeId = index;
            return;
          }
        }
      });
      if (removeId) self.couponList.splice(removeId, 1);
    }
  }),
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    scheduleListNew: function scheduleListNew() {
      var menuList = {};
      var oldList = this.menu_schedule_list;
      for (var key in oldList) {
        menuList[oldList[key].menu_id] = {
          menu_id: oldList[key].menu_id,
          storeList: []
        };
      }
      for (var k in oldList) {
        menuList[oldList[k].menu_id].storeList.push({
          store_id: oldList[k].store_id,
          store_name: oldList[k].store_name,
          start_time: oldList[k].start_time,
          end_time: oldList[k].end_time,
          status: oldList[k].status,
          update_time: oldList[k].update_time,
          create_time: oldList[k].create_time,
          schedule_id: oldList[k].schedule_id
        });
      }
      return menuList;
    },
    getList: function getList() {
      if (this.$route.name === 'upScheduleOne') {
        var oneList = this.scheduleListNew[this.menuId].storeList;
        this.menuTime.start.time = oneList[0].start_time;
        this.menuTime.end.time = oneList[0].end_time;
        return oneList;
      } else {
        var list = [];
        for (var key in this.scheduleListNew) {
          for (var k in this.scheduleListNew[key].storeList) {
            list.push(this.scheduleListNew[key].storeList[k]);
          }
        }
        return list;
      }
    }
  },
  watch: {
    'menuTime.start.time': function menuTimeStartTime() {
      this.endLimit = [{
        type: 'fromto',
        from: this.menuTime.start.time
      }];
      this.setMenuStartTime(this.menuTime.start.time);
    },
    'menuTime.end.time': function menuTimeEndTime() {
      this.startLimit = [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD HH:mm:ss'),
        to: this.menuTime.end.time
      }];
      this.setMenuEndTime(this.menuTime.end.time);
    },
    'content.bindingBrandList': function contentBindingBrandList() {
      var self = this;
      this.storeBrief = [];
      this.content.bindingStoreList = [];
      this.content.bindingBrandList.forEach(function (array) {
        var brandId = array.value;
        self.getStoreBrief(brandId);
      });
    }
  }
});

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue___default.a
  },
  data: function data() {
    return {
      activityMethod: 1,

      orderType: '',
      orderMethod: '',
      delivery: '',
      payplace: '',
      memberLimit: [],
      coupon: {
        type: { label: '固定起迄時間', value: 1 },
        price_type: { label: '免稅', value: 1 },
        discount_type: { label: '折扣金額', value: 1 },
        setting: { label: '依訂單購買商品數設定', value: 1 },
        useType: { label: '品牌型', value: 1 }
      },
      otherCoupon: [],

      otherCouponList: [{ label: 'Nidin優惠券', value: 1, code: '1231231dz' }, { label: '柴犬優惠券', value: 2, code: '324efxde' }, { label: '你好優惠券', value: 3, code: '654trrgxx' }],
      addStoresSetting: {
        class: 'add-store',
        options: [{ label: '台北', value: 1 }, { label: '新竹', value: 2 }, { label: '苗栗', value: 3 }, { label: '台中', value: 4 }, { label: '彰化', value: 5 }, { label: '台南', value: 6 }, { label: '高雄', value: 7 }, { label: '屏東', value: 8 }],
        choose: []
      },
      deadType: [{ label: '固定起迄時間', value: 1 }, { label: '固定結束時間', value: 2 }, { label: '發送日幾天後', value: 3 }],
      priceType: [{ label: '免稅', value: 1 }, { label: '未稅', value: 2 }, { label: '含稅', value: 3 }],
      discountType: [{ label: '折扣金額', value: 1 }],
      couponSetting: [{ label: '依訂單購買商品數設定', value: 1 }, { label: '依個人訂單消費特定商品數', value: 2 }, { label: '依個人訂單購買金額', value: 3 }],
      memberType: [{ label: 'FB', value: 1 }, { label: 'Google', value: 2 }, { label: 'LINE', value: 3 }],
      useType: [{ label: '品牌型', value: 1 }, { label: '店家型', value: 2 }],
      content: {
        bindingStoreList: [],
        bindingBrandList: []
      },
      brandDefault: '',
      brandBrief: [],
      storeBrief: [],
      oldScheduleTime: '',
      scheduleTime: '',
      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: ''
        }
      },
      show: {
        back: false
      },
      giftSelect: 1,
      tableIndex: 1,
      menuId: 0,
      menuName: '',
      storeId: 0,
      startTime: {
        time: ''
      },
      endtime: {
        time: ''
      },
      giftList: [{ label: '依店家訂單消費金額滿額送', value: 1 }, { label: '依店家訂單商品個數滿額送', value: 2 }, { label: '依店家訂單消費指定商品數量滿額送', value: 3 }],
      timeoption: {
        type: 'min',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD HH:mm:ss',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      startLimit: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD HH:mm:ss')
      }],
      endLimit: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD HH:mm:ss')
      }],
      info: {
        menuName: '夏日菜單',
        menu_id: 123323,
        start_time: '2017-03-31 12:22:32',
        end_time: '2017-03-31 12:22:32',
        update_time: '2017-03-31 12:22:32',
        create_time: '2017-03-31 12:22:32'
      },
      menu_schedule_list: [{
        'schedule_id': 122,
        'store_id': 1,
        'store_name': '金山店',
        'menu_id': 1,
        'start_time': '2017-07-24 08:00:00',
        'end_time': '2017-08-01 00:00:00',
        'status': 1,
        'update_time': '2017-01-14 16:09:16',
        'create_time': '2017-01-14 16:09:16'
      }, {
        'schedule_id': 123,
        'store_id': 2,
        'store_name': '中山店',
        'menu_id': 2,
        'start_time': '2017-07-24 08:00:00',
        'end_time': '2017-08-01 00:00:00',
        'status': 1,
        'update_time': '2017-01-14 16:09:16',
        'create_time': '2017-01-14 16:09:16'
      }],
      couponList: [{ name: 'Nidin優惠券' }, { name: 'Nidin優惠券' }]
    };
  },
  created: function created() {
    this.getBrandBrief();

    console.log(this.$route.query);
    if (this.$route.name === 'upScheduleOne') {
      this.menuId = this.$route.params.menu_id;
      this.storeId = this.$route.params.store_id;
    } else if (this.$route.query.menu_id) {
      this.menuId = this.$route.query.menu_id;
      this.menuName = this.$route.query.menu_name;
    }
  },
  mounted: function mounted() {
    var self = this;
    self.oldScheduleTime = self.scheduleTime = '2015-01-01 01:30:00 - 2015-01-02 01:30:00';
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#example1_wrapper').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      });
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapActions */])(['setMenuStartTime', 'setMenuEndTime']), {
    addCoupon: function addCoupon() {
      this.couponList.push({ name: 'Nidin優惠券' });
    },
    clickCoupon: function clickCoupon() {},
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    getNewList: function getNewList(index) {
      console.log('LOVE' + index);
    },
    getStoreBrief: function getStoreBrief(brandId) {
      this.storeBrief = [];
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
          }
        }
      });
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            self.brandBrief.push(obj);
          }
        }
      });
    },
    crSchedule: function crSchedule() {
      var self = this;
      var data = {
        store_id: [],
        menu_id: self.menuId,
        start_time: self.menuTime.start.time,
        end_time: self.menuTime.end.time
      };
      self.content.bindingStoreList.forEach(function (store) {
        data.store_id.push(store.value);
      });
      var url = '/brand/' + this.$route.params.brand_id + '/menu/schedule/group';
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          console.log(response.data);
          self.$notify({
            title: '提醒',
            text: '新增菜單成功',
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.replace('/brandScheduleTable/' + self.$route.params.brand_id);
        }
      });
    },
    changeOtherCoupon: function changeOtherCoupon(current) {
      this.couponList.push(current);
      console.log(current);
    },
    removeOtherCoupon: function removeOtherCoupon(current) {
      var self = this;
      var removeId = '';
      this.couponList.find(function (coupon, index) {
        if (coupon.code) {
          if (current.code === coupon.code) {
            console.log(index);
            removeId = index;
            return;
          }
        }
      });
      if (removeId) self.couponList.splice(removeId, 1);
    }
  }),
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    scheduleListNew: function scheduleListNew() {
      var menuList = {};
      var oldList = this.menu_schedule_list;
      for (var key in oldList) {
        menuList[oldList[key].menu_id] = {
          menu_id: oldList[key].menu_id,
          storeList: []
        };
      }
      for (var k in oldList) {
        menuList[oldList[k].menu_id].storeList.push({
          store_id: oldList[k].store_id,
          store_name: oldList[k].store_name,
          start_time: oldList[k].start_time,
          end_time: oldList[k].end_time,
          status: oldList[k].status,
          update_time: oldList[k].update_time,
          create_time: oldList[k].create_time,
          schedule_id: oldList[k].schedule_id
        });
      }
      return menuList;
    },
    getList: function getList() {
      if (this.$route.name === 'upScheduleOne') {
        var oneList = this.scheduleListNew[this.menuId].storeList;
        this.menuTime.start.time = oneList[0].start_time;
        this.menuTime.end.time = oneList[0].end_time;
        return oneList;
      } else {
        var list = [];
        for (var key in this.scheduleListNew) {
          for (var k in this.scheduleListNew[key].storeList) {
            list.push(this.scheduleListNew[key].storeList[k]);
          }
        }
        return list;
      }
    }
  },
  watch: {
    'menuTime.start.time': function menuTimeStartTime() {
      this.endLimit = [{
        type: 'fromto',
        from: this.menuTime.start.time
      }];
      this.setMenuStartTime(this.menuTime.start.time);
    },
    'menuTime.end.time': function menuTimeEndTime() {
      this.startLimit = [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD HH:mm:ss'),
        to: this.menuTime.end.time
      }];
      this.setMenuEndTime(this.menuTime.end.time);
    },
    'content.bindingBrandList': function contentBindingBrandList() {
      var self = this;
      this.storeBrief = [];
      this.content.bindingStoreList = [];
      this.content.bindingBrandList.forEach(function (array) {
        var brandId = array.value;
        self.getStoreBrief(brandId);
      });
    }
  }
});

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Discount_Temp_MenuDiscountTemp_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Discount_Temp_MenuDiscountTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Discount_Temp_MenuDiscountTemp_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'menu-discount': __WEBPACK_IMPORTED_MODULE_0__Discount_Temp_MenuDiscountTemp_vue___default.a
  },
  props: {
    activity: Object,
    info: Object,
    brandList: Array,
    addStoresSetting: Object,
    storeList: Array,
    aStoreOption: Array,
    setInfoTimes: Number
  },
  data: function data() {
    return {
      ruleCode: '',
      payPlaceType: [{ label: '線上結帳', value: 10 }, { label: 'POS店家結帳', value: 50 }],
      ruleCodeOptions: [{ label: '商品數量', value: 'SA00001' }, { label: '指定商品數量', value: 'SA00002' }, { label: '商品金額', value: 'SA00003' }],
      orderType: [{ label: '一般單', value: 1 }, { label: '團購單', value: 2 }],
      orderMethod: [{ label: '當日單', value: 1 }, { label: '預訂單', value: 2 }],
      deliveryType: [{ label: '自取', value: 1 }, { label: '內用', value: 2 }, { label: '外送', value: 3 }, { label: '內用-桌邊掃碼', value: 21 }],
      dStrategy: {
        limit: {
          delivery_types: [],
          order_types: [],
          order_method: [],
          min_money: '',
          min_amount: ''
        },
        setting: {
          one_max_amount: '',
          ratio: 1,
          lowest_unit_price: 0,

          vendor_custom_product_list: [],

          money_unit: []
        },

        store_exception_items: [{
          products: [],
          store_ids: []
        }]
      },
      storeSelect: { label: '', value: '', brand_id: '' },
      menuSelect: {
        label: '',
        value: 0
      },
      tableIndex: 1,
      count: 20,
      menuList: []
    };
  },

  methods: {
    getOnlineMenu: function getOnlineMenu() {
      var self = this;
      self.menuList = [];
      var select = this.storeSelect;
      var url = '/onlineMenu/list?page=' + this.tableIndex + '&size=' + this.count + '&brand_id=' + select.brand_id + '&store_id=' + select.value;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var mList = response.data.menu_list;
          mList.forEach(function (menu, index) {
            var option = { label: menu.name, value: menu.id };
            self.menuList.push(option);
            if (index === 0) self.menuSelect = option;
          });
          if (!mList.length) self.menuSelect = { label: '', value: '' };
        }
      });
    },
    clickOption: function clickOption(option) {
      var self = this;
      this.addStoresSetting.options = [];
      self.curId = option.id;
      if (self.curId) {
        self.$nextTick(function () {
          self.reSet++;
          self.addStoresSetting.options = self.storeBrief;
          self.getCurStoreClass();
        });
      }
    },
    getCurStoreClass: function getCurStoreClass() {
      this.addStoresSetting.choose = [];
      var self = this;
      var url = '/brand/' + this.brandSelect.value + '/storeClass/' + this.curId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var classInfo = response.data.class;
          classInfo.store_list.forEach(function (s) {
            self.addStoresSetting.choose.push(s.id);
          });
        }
      });
    },
    setStore: function setStore() {
      var self = this;
      var stores = this.info.attend_stores;

      if (stores.length) {
        stores[0].store_list.forEach(function (store) {
          self.addStoresSetting.choose.push(store.store_id);
        });
      }
    },
    addProdToList: function addProdToList(addPInfo) {
      var self = this;
      var pInfo = this.activity.strategy_data.setting.vendor_custom_product_list;

      addPInfo.forEach(function (addP) {
        var isSame = pInfo.find(function (prod) {
          return addP.vendor_custom_id === prod.vendor_custom_id;
        });
        if (!isSame) pInfo.push(addP);else {
          self.$notify({
            title: '提醒',
            text: addP.product_name + '已加入過',
            duration: 3000,
            width: 400
          });
        }
      });
    },
    addExProdToList: function addExProdToList(addPInfo) {
      var self = this;
      var pInfo = this.activity.strategy_data.store_exception_items[0].products;

      addPInfo.forEach(function (addP) {
        var isSame = pInfo.find(function (prod) {
          return addP.vendor_custom_id === prod.vendor_custom_id;
        });
        if (!isSame) {
          pInfo.push(addP);
        } else {
          self.$notify({
            title: '提醒',
            text: addP.product_name + '已加入過',
            duration: 3000,
            width: 400
          });
        }
      });
    },
    addExProdToList2: function addExProdToList2(addPInfo) {
      var self = this;
      var pInfo = this.activity.strategy_data.store_exception_items[0].products;

      addPInfo.forEach(function (addP) {
        var isSame = pInfo.find(function (prod) {
          return addP.vendor_custom_id === prod.vendor_custom_id;
        });
        if (!isSame) pInfo.push(addP);else {
          self.$notify({
            title: '提醒',
            text: addP.product_name + '已加入過',
            duration: 3000,
            width: 400
          });
        }
      });
    },
    removeListItem: function removeListItem(list, index) {
      list.splice(index, 1);
    },
    returnNum: function returnNum(e) {
      var charCode = e.which ? e.which : e.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        e.preventDefault();
      } else {
        return true;
      }
    },
    setInfo: function setInfo() {
      var self = this;

      var aLimit = this.activity.strategy_data.limit;
      var iLimit = this.info.strategy_data.limit;

      if (iLimit.order_type) {
        iLimit.order_type.forEach(function (orderType) {
          var otop = self.orderType.find(function (ot) {
            return ot.value === orderType;
          });
          aLimit.order_type.push(otop);
        });
      }

      if (iLimit.order_method) {
        iLimit.order_method.forEach(function (orderMethod) {
          var omop = self.orderMethod.find(function (om) {
            return om.value === orderMethod;
          });
          aLimit.order_method.push(omop);
        });
      }

      if (iLimit.delivery_type) {
        iLimit.delivery_type.forEach(function (deliveryType) {
          var dtop = self.deliveryType.find(function (dt) {
            return dt.value === deliveryType;
          });
          aLimit.delivery_type.push(dtop);
        });
      }

      if (iLimit.pay_place_type) {
        iLimit.pay_place_type.forEach(function (payPlaceType) {
          var pptop = self.payPlaceType.find(function (ppt) {
            return ppt.value === payPlaceType;
          });
          aLimit.pay_place_type.push(pptop);
        });
      }

      if (this.info.strategy_data.store_exception_items[0]) {
        this.info.strategy_data.store_exception_items[0].products.forEach(function (prod) {
          var obj = { product_name: prod.name, vendor_custom_id: prod.vendor_custom_id };
          self.activity.strategy_data.store_exception_items[0].products.push(obj);
        });
      }

      if (this.info.strategy_data.setting.vendor_custom_product_list) {
        this.info.strategy_data.setting.vendor_custom_product_list.forEach(function (prod) {
          var o = { product_name: prod.name, vendor_custom_id: prod.id };
          self.activity.strategy_data.setting.vendor_custom_product_list.push(o);
        });
      }
    }
  },
  created: function created() {
    if (this.$route.query.rule_code) this.ruleCode = this.$route.query.rule_code;else if (this.info.info.rule_code) this.ruleCode = this.info.info.rule_code;
  },

  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  },
  watch: {
    'storeSelect.value': function storeSelectValue() {
      if (this.storeSelect.value) {
        this.getOnlineMenu();
      }
    },
    setInfoTimes: function setInfoTimes() {
      this.ruleCode = this.info.info.rule_code;
      this.setInfo();
    }
  }
});

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Discount_Temp_MenuDiscountTemp_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Discount_Temp_MenuDiscountTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Discount_Temp_MenuDiscountTemp_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'menu-discount': __WEBPACK_IMPORTED_MODULE_0__Discount_Temp_MenuDiscountTemp_vue___default.a
  },
  props: {
    activity: Object,
    info: Object,
    brandList: Array,
    addStoresSetting: Object,
    storeList: Array,
    aStoreOption: Array,
    setInfoTimes: Number
  },
  data: function data() {
    return {
      ruleCode: '',
      payPlaceType: [{ label: '線上結帳', value: 10 }, { label: 'POS店家結帳', value: 50 }],
      ruleCodeOptions: [{ label: '商品數量', value: 'SA00001' }, { label: '指定商品數量', value: 'SA00002' }, { label: '商品金額', value: 'SA00003' }],
      orderType: [{ label: '一般單', value: 1 }, { label: '團購單', value: 2 }],
      orderMethod: [{ label: '當日單', value: 1 }, { label: '預訂單', value: 2 }],
      deliveryType: [{ label: '自取', value: 1 }, { label: '內用', value: 2 }, { label: '外送', value: 3 }, { label: '內用-桌邊掃碼', value: 21 }],
      dStrategy: {
        limit: {
          delivery_types: [],
          order_types: [],
          order_method: [],
          min_money: '',
          min_amount: ''
        },
        setting: {
          one_max_amount: '',
          ratio: 1,
          lowest_unit_price: 0,

          vendor_custom_product_list: [],

          money_unit: []
        },

        store_exception_items: [{
          products: [],
          store_ids: []
        }]
      },
      storeSelect: { label: '', value: '', brand_id: '' },
      menuSelect: {
        label: '',
        value: 0
      },
      tableIndex: 1,
      count: 20,
      menuList: []
    };
  },

  methods: {
    getOnlineMenu: function getOnlineMenu() {
      var self = this;
      self.menuList = [];
      var select = this.storeSelect;
      var url = '/onlineMenu/list?page=' + this.tableIndex + '&size=' + this.count + '&brand_id=' + select.brand_id + '&store_id=' + select.value;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var mList = response.data.menu_list;
          mList.forEach(function (menu, index) {
            var option = { label: menu.name, value: menu.id };
            self.menuList.push(option);
            if (index === 0) self.menuSelect = option;
          });
          if (!mList.length) self.menuSelect = { label: '', value: '' };
        }
      });
    },
    clickOption: function clickOption(option) {
      var self = this;
      this.addStoresSetting.options = [];
      self.curId = option.id;
      if (self.curId) {
        self.$nextTick(function () {
          self.reSet++;
          self.addStoresSetting.options = self.storeBrief;
          self.getCurStoreClass();
        });
      }
    },
    getCurStoreClass: function getCurStoreClass() {
      this.addStoresSetting.choose = [];
      var self = this;
      var url = '/brand/' + this.brandSelect.value + '/storeClass/' + this.curId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var classInfo = response.data.class;
          classInfo.store_list.forEach(function (s) {
            self.addStoresSetting.choose.push(s.id);
          });
        }
      });
    },
    setStore: function setStore() {
      var self = this;
      var stores = this.info.attend_stores;

      if (stores.length) {
        stores[0].store_list.forEach(function (store) {
          self.addStoresSetting.choose.push(store.store_id);
        });
      }
    },
    addProdToList: function addProdToList(addPInfo) {
      var self = this;
      var pInfo = this.activity.strategy_data.setting.vendor_custom_product_list;
      addPInfo.forEach(function (addP) {
        var isSame = pInfo.find(function (prod) {
          return addP.vendor_custom_id === prod.vendor_custom_id;
        });
        if (!isSame) pInfo.push(addP);else {
          self.$notify({
            title: '提醒',
            text: addP.product_name + '已加入過',
            duration: 3000,
            width: 400
          });
        }
      });
    },
    addExProdToList: function addExProdToList(addPInfo) {
      var self = this;
      var pInfo = this.activity.strategy_data.store_exception_items[0].products;

      addPInfo.forEach(function (addP) {
        var isSame = pInfo.find(function (prod) {
          return addP.vendor_custom_id === prod.vendor_custom_id;
        });
        if (!isSame) {
          pInfo.push(addP);
        } else {
          self.$notify({
            title: '提醒',
            text: addP.product_name + '已加入過',
            duration: 3000,
            width: 400
          });
        }
      });
    },
    addExProdToList2: function addExProdToList2(addPInfo) {
      var self = this;
      var pInfo = this.activity.strategy_data.store_exception_items[0].products;
      addPInfo.forEach(function (addP) {
        var isSame = pInfo.find(function (prod) {
          return addP.vendor_custom_id === prod.vendor_custom_id;
        });
        if (!isSame) pInfo.push(addP);else {
          self.$notify({
            title: '提醒',
            text: addP.product_name + '已加入過',
            duration: 3000,
            width: 400
          });
        }
      });
    },
    removeListItem: function removeListItem(list, index) {
      list.splice(index, 1);
    },
    returnNum: function returnNum(e) {
      var charCode = e.which ? e.which : e.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        e.preventDefault();
      } else {
        return true;
      }
    },
    setInfo: function setInfo() {
      var self = this;

      var aLimit = this.activity.strategy_data.limit;
      var iLimit = this.info.strategy_data.limit;

      if (iLimit.order_type) {
        iLimit.order_type.forEach(function (orderType) {
          var otop = self.orderType.find(function (ot) {
            return ot.value === orderType;
          });
          aLimit.order_type.push(otop);
        });
      }

      if (iLimit.order_method) {
        iLimit.order_method.forEach(function (orderMethod) {
          var omop = self.orderMethod.find(function (om) {
            return om.value === orderMethod;
          });
          aLimit.order_method.push(omop);
        });
      }

      if (iLimit.delivery_type) {
        iLimit.delivery_type.forEach(function (deliveryType) {
          var dtop = self.deliveryType.find(function (dt) {
            return dt.value === deliveryType;
          });
          aLimit.delivery_type.push(dtop);
        });
      }

      if (iLimit.pay_place_type) {
        iLimit.pay_place_type.forEach(function (payPlaceType) {
          var pptop = self.payPlaceType.find(function (ppt) {
            return ppt.value === payPlaceType;
          });
          aLimit.pay_place_type.push(pptop);
        });
      }

      if (this.info.strategy_data.store_exception_items[0]) {
        this.info.strategy_data.store_exception_items[0].products.forEach(function (prod) {
          var obj = { product_name: prod.name, vendor_custom_id: prod.vendor_custom_id };
          self.activity.strategy_data.store_exception_items[0].products.push(obj);
        });
      }

      if (this.info.strategy_data.setting.vendor_custom_product_list) {
        this.info.strategy_data.setting.vendor_custom_product_list.forEach(function (prod) {
          var o = { product_name: prod.name, vendor_custom_id: prod.id };
          self.activity.strategy_data.setting.vendor_custom_product_list.push(o);
        });
      }
    }
  },
  created: function created() {
    if (this.$route.query.rule_code) this.ruleCode = this.$route.query.rule_code;else if (this.info.info.rule_code) this.ruleCode = this.info.info.rule_code;
  },

  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    showNoLimit: function showNoLimit() {
      var activity = this.activity;
      if (!activity.strategy_data.limit.order_type.length && !activity.strategy_data.limit.order_method.length && !activity.strategy_data.limit.min_total_paid_money && !activity.strategy_data.limit.min_total_money && !activity.strategy_data.limit.min_total_amount && !activity.strategy_data.limit.delivery_type.length && !activity.strategy_data.limit.pay_place_type.length && !activity.strategy_data.limit.min_money && !activity.strategy_data.limit.min_amount && !activity.strategy_data.limit.min_sub_order_amount && !activity.strategy_data.limit.min_paid_money) {
        return true;
      }
      return false;
    }
  },
  watch: {
    'storeSelect.value': function storeSelectValue() {
      if (this.storeSelect.value) {
        this.getOnlineMenu();
      }
    },
    setInfoTimes: function setInfoTimes() {
      this.ruleCode = this.info.info.rule_code;
      this.setInfo();
    }
  }
});

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_datepicker_vue_datepicker_es6_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a,
    'm-modal': __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue___default.a,
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_5_vue_datepicker_vue_datepicker_es6_vue___default.a
  },
  props: {
    storeBrief: Array,
    getStoreName: Function
  },
  data: function data() {
    return {
      searchStoreId: '',
      chartMethod: 1,
      menuState: 4,
      name: '迷客夏',
      total: 1,
      count: 10,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,

      brandBrief: [],
      brandSelect: { label: '== 所有品牌 ==', value: 0 },
      storeSelect: { label: '== 所有門市 ==', value: 0 },
      ownerTypeSelect: { label: '== 舉辦者類型 ==', value: 99 },
      ownerTypeList: [],
      statusSelect: { label: '== 行銷狀態 ==', value: 99 },
      timeMethodSelect: { label: '== 行銷時間狀態 ==', value: 99 },
      timeMethodList: [{ label: '== 行銷時間狀態 ==', value: 99 }, { label: '未開始', value: 'notyet' }, { label: '進行中', value: 'going' }, { label: '已結束', value: 'end' }],
      promotionList: [],
      curStoreId: '',
      ownerId: '',
      storeCouponList: [],
      curMarketingId: '',
      curActivityId: '',

      menuTime: {
        start: {
          time: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD')
        },
        end: {
          time: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      startLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(1, 'days').format('YYYY-MM-DD')
      }],
      endLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(1, 'days').add(1, 'days').format('YYYY-MM-DD')
      }],
      typeSelect: 1,

      sortMethod: '',
      sortToggle: false,
      preSortMethod: []
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {});
  },

  methods: {
    reportPromotion: function reportPromotion() {
      this.reportCouponChart();
    },
    checkSort: function checkSort(method) {
      this.sortMethod = method;
      if (this.preSortMethod.length) {
        if (method === this.preSortMethod[0]) this.sortToggle = !this.sortToggle;else {
          this.tableIndex = 1;
          this.sortToggle = false;
        }
        this.preSortMethod.splice(0, 1);
      } else this.sortToggle = false;
      this.preSortMethod.push(method);
      this.clickPage(1);
    },
    setMarketing: function setMarketing(marketingId) {
      this.curMarketingId = marketingId;
    },
    setActivity: function setActivity(activityId) {
      this.curActivityId = activityId;
    },
    search: function search() {
      this.typeSelect = 2;
      this.clickPage(1);
    },
    getItemType: function getItemType(type) {
      switch (type) {
        case 10:
          return '消費贈送活動';
        case 11:
          return '會員註冊贈送活動';
        case 20:
          return '代碼兌換活動';
        case 99:
          return '後台發送';
      }
    },
    ownerTypeName: function ownerTypeName(type) {
      switch (type) {
        case 1:
          return '平台';
        case 2:
          return '品牌';
        case 3:
          return '門市';
      }
    },
    changeSelect: function changeSelect(input) {
      if (typeof input.value !== 'undefined') {
        this.clickPage(1);
      }
    },
    clickGroup: function clickGroup(type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1;
        this.tableIndex = this.groupAmount * this.pageGroup;
        this.clickPage(this.tableIndex);
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1;
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1;
        this.clickPage(this.tableIndex);
      }
    },
    clickEnd: function clickEnd(type) {
      if (type === 'pre') {
        this.clickPage(1);
        this.pageGroup = 1;
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount);else this.clickPage(1);
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount);
      }
    },
    getTime: function getTime(time) {
      if (time) {
        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(time, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm');
      }
    },
    trigger: function trigger(event) {
      if (event === 'delMarketing') {
        this.delMarketing();
      } else if (event === 'delActivity') {
        this.delActivity();
      }
    },
    delMarketing: function delMarketing() {
      var self = this;
      var url = '/promotion/' + this.curMarketingId;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '刪除行銷成功',
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.getCouponChart();
        }
      });
    },
    delActivity: function delActivity() {},
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    clickPage: function clickPage(index) {
      if (index) this.tableIndex = index;
      this.getOrderCouponStoreUse();
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    },
    getOrderCouponStoreUse: function getOrderCouponStoreUse(page) {
      var self = this;
      if (page) {
        this.tableIndex = page;
        if (page === 1) this.pageGroup = 1;
      }
      var url = '/statistic/activityOrderCouponStoreUse?';
      var roleType = this.roleType;
      var data = {
        activity_id: this.$route.params.activity_id,
        page: this.tableIndex,
        size: this.count,
        start_date: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_date: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      };

      if (this.storeSelect.value) {
        if ((roleType === 99 || roleType === 30) && this.storeSelect.value !== 0) data.store_id = this.storeSelect.value;else if (roleType === 10) data.store_id = this.storeSelect.value;
      }
      for (var key in data) {
        url = url + key + '=' + data[key] + '&';
      }
      url = url.slice(0, -1);

      if (this.sortMethod) {
        var newMethod = this.sortMethod;
        if (this.typeSelect === 2) newMethod = newMethod + '_seg';
        url = url + '&list_sort=' + newMethod + ' ';
        if (this.sortToggle) url = url + 'ASC';else url = url + 'DESC';
      }
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.storeCouponList = response.data.list;
          self.total = response.data.list_total;
        }
      });
    },
    reportCouponChart: function reportCouponChart() {
      var url = '/statistic/activityOrderCouponStoreUseSheets?';
      var roleType = this.roleType;
      var data = {
        activity_id: this.$route.params.activity_id,
        start_date: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_date: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      };

      if (this.storeSelect.value) {
        if ((roleType === 99 || roleType === 30) && this.storeSelect.value !== 0) data.store_id = this.storeSelect.value;else if (roleType === 10) data.store_id = this.storeSelect.value;
      }
      for (var key in data) {
        url = url + key + '=' + data[key] + '&';
      }
      url = url.slice(0, -1);

      if (this.sortMethod) {
        var newMethod = this.sortMethod;
        if (this.typeSelect === 2) newMethod = newMethod + '_seg';
        url = url + '&list_sort=' + newMethod + ' ';
        if (this.sortToggle) url = url + 'ASC';else url = url + 'DESC';
      }
      this.getFile('get', url, null, function (response) {
        var url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.ms-excel' }));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', '消費贈送優惠券統計表_' + __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY_MM_DD') + '.xlsx');
        document.body.appendChild(link);
        link.click();
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getRoleType']), {
    newStoreBrief: function newStoreBrief() {
      var allStore = this.storeBrief;
      allStore.splice(0, 0, { label: '== 所有門市 ==', value: 0 });
      return allStore;
    },
    statusList: function statusList() {
      if (this.chartMethod === 2) {
        return [{ label: '== 活動狀態 ==', value: 99 }, { label: '初始化', value: 0 }, { label: '編輯中', value: 1 }, { label: '待上架', value: 3 }, { label: '已上架', value: 4 }, { label: '已下架', value: 5 }];
      } else {
        return [{ label: '== 行銷狀態 ==', value: 99 }, { label: '未發佈', value: 0 }, { label: '已發佈', value: 4 }, { label: '已下架', value: 9 }];
      }
    },
    getFile: function getFile() {
      return this.$parent.getFile;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    },
    searchPlaceholder: function searchPlaceholder() {
      var value = this.ownerTypeSelect.value;
      switch (value) {
        case 99:
        case 1:
          return '不用填入';
        case 2:
          return '請填入品牌id';
        case 3:
          return '請填入門市id';
      }
    }
  }),
  watch: {
    typeSelect: function typeSelect() {
      this.sortMethod = '';
      this.sortToggle = false;
      this.clickPage();
    },
    menuState: function menuState() {
      this.tableIndex = 1;
      this.pageGroup = 1;
    },
    chartMethod: function chartMethod() {
      this.sortMethod = '';
      this.sortToggle = false;
      this.sortMethod = '';
      this.tableIndex = 1;
      this.pageGroup = 1;
      this.clickPage(1);
      window.sessionStorage.setItem('Nidin_coupon_chart', this.chartMethod);
    },
    'menuTime.end.time': function menuTimeEndTime() {
      var lastDay = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
      if (this.menuTime.start.time > lastDay) this.menuTime.start.time = lastDay;
      this.startLimit = [{
        type: 'fromto',
        to: lastDay
      }];
    },
    'menuTime.start.time': function menuTimeStartTime() {
      var lastDay = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.start.time).add('90', 'days');
      if (lastDay < __WEBPACK_IMPORTED_MODULE_3_moment___default()()) this.menuTime.end.time = lastDay.format('YYYY-MM-DD');else this.menuTime.end.time = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD');
      this.endLimit = [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.start.time).subtract(1, 'days'),
        to: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.end.time).add(1, 'days')
      }];
    }
  },
  created: function created() {
    this.roleType = parseInt(this.getRoleType, 10);
    var sMethod = window.sessionStorage.getItem('Nidin_coupon_chart');
    if (sMethod) this.chartMethod = parseInt(sMethod, 10);

    this.getOrderCouponStoreUse();
  }
});

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CouponModal_vue__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CouponModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CouponModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    brandList: Array,
    storeList: Array,
    giveCoupons: Object,
    info: Object,
    activity: Object
  },
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default.a,
    'coupon-modal': __WEBPACK_IMPORTED_MODULE_2__CouponModal_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getRoleType']), {
    couponValue: function couponValue() {
      var couponType = '';
      if (this.curCoupon.coupon_info) {
        couponType = this.curCoupon.usage_store_config.usage_store_type;
        if (couponType.value === 2) {
          return this.brandList;
        } else if (couponType.value === 3) {
          return this.storeList;
        }
      }
      return [];
    },
    usageMethod: function usageMethod() {
      var couponType = '';
      if (this.curCoupon.coupon_info) {
        couponType = this.curCoupon.usage_store_config.usage_store_type;
        if (couponType.value === 2) {
          return [{ label: '設定優惠券適用門市', value: 'manual' }];
        } else if (couponType.value === 3) {
          return [{ label: '設定優惠券適用門市', value: 'manual' }, { label: '限下訂門市使用', value: 'order_store' }];
        }
      }
      return [];
    }
  }),
  data: function data() {
    return {
      setInfoTimes: 0,
      addStoresSetting: {
        class: 'coupon-store',
        options: [],
        choose: []
      },
      reNew: 0,
      reSet: 0,
      timeType: [{ label: '限定時段', value: 'all_fixed' }, { label: '獲取後～某時段結束', value: 'day_fixed' }, { label: '獲取後～獲取幾日後結束', value: 'day_day' }],
      couponType: [{ label: '品牌', value: 2 }, { label: '門市', value: 3 }],
      priceType: [{ label: '免稅', value: 1 }, { label: '未稅', value: 2 }, { label: '含稅', value: 3 }],
      newCouponType: { label: '商品數量', value: 'SC00001' },
      delOption: {
        id: 'delCouponModal',
        title: '刪除贈送優惠券',
        body: '刪除此優惠券，設定的內容將被刪除',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delCoupon'
        }]
      },
      curIndex: 0,
      curCoupon: {},
      ruleCodeOptions: [{ label: '商品數量', value: 'SC00001' }, { label: '指定商品數量', value: 'SC00002' }, { label: '商品金額', value: 'SC00003' }],
      dCouponType: '',
      startLimit: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss')
      }],
      endLimit: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss')
      }],
      timeoption: {
        type: 'min',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD HH:mm:ss',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      oldIndex: ''
    };
  },

  methods: {
    trigger: function trigger(event) {
      if (event === 'delCoupon') {
        this.delCoupon();
      }
    },
    addNewCoupon: function addNewCoupon() {
      var num = this.giveCoupons.coupon_set_list.length + 1;
      var obj = {
        coupon_info: {
          set_name: '優惠券' + num,
          set_description: '',
          name: '優惠券' + num,
          description: '',
          remark: '',
          discount_type: 1,
          discount_value: '',
          price_type: { label: '含稅', value: 3 }
        },
        usage_store_config: {
          usage_store_type: { label: '品牌', value: 2 },
          usage_store_value: null,
          usage_method: { label: '設定優惠券適用門市', value: 'manual' },
          manual_store_ids: [] },
        time_config: {
          time_type: { label: '限定時段', value: 'all_fixed' },
          start_time: '',
          end_time: '',
          use_start_day: '',
          use_tolerance_day: '',
          time: {
            start: { time: '' },
            end: { time: '' }
          }
        },
        is_group_usage: 1,
        amount_unit: 1
      };

      if (this.dCouponType && this.dCouponType === 2) obj.usage_store_config.usage_store_type = this.brandList[0];
      if (this.dCouponType && this.dCouponType === 3) obj.usage_store_config.usage_store_type = { label: '門市', value: 3 };
      if (this.getRoleType === 10) {
        obj.usage_store_config.usage_store_value = this.storeList[0];
        obj.usage_store_config.usage_store_type = { label: '門市', value: 3 };
        obj.usage_store_config.usage_method = { label: '限下訂門市使用', value: 'order_store' };
      }
      this.giveCoupons.coupon_set_list.push(obj);

      this.changeCur(obj);
    },
    changeCur: function changeCur(coupon, index) {
      if (this.oldIndex !== index) {
        this.curCoupon = coupon;
        this.addStoresSetting.choose = this.curCoupon.usage_store_config.manual_store_ids;
        if (this.$refs.couponStoresMuti) this.$refs.couponStoresMuti.init();
        this.oldIndex = index;
      }
    },
    selectUSValue: function selectUSValue(obj) {
      if (this.curCoupon.usage_store_config.usage_store_type.value === 3 && this.curCoupon.usage_store_config.usage_method.value === 'manual') {
        this.curCoupon.usage_store_config.manual_store_ids = [obj.value];
      }
    },
    selectUSType: function selectUSType() {
      this.curCoupon.usage_store_config.usage_store_value = null;
    },
    changeUSType: function changeUSType() {
      if (this.curCoupon.usage_store_config.usage_store_type.value === 2) this.curCoupon.usage_store_config.usage_method = { label: '設定優惠券適用門市', value: 'manual' };
    },
    delCoupon: function delCoupon() {
      this.giveCoupons.coupon_set_list.splice(this.curIndex, 1);
    },
    setInfo: function setInfo() {
      this.setInfoTimes++;
      var self = this;
      var iList = this.info.give_coupons[0].coupon_set_list;
      iList.forEach(function (coupon) {
        var obj = {
          coupon_info: {
            set_name: coupon.set_name,
            set_description: coupon.set_description,
            name: coupon.name,
            description: coupon.description,
            remark: coupon.remark,
            discount_type: 1,
            discount_value: coupon.discount_value,
            price_type: self.priceType.find(function (pt) {
              return pt.value === coupon.price_type;
            })
          },
          usage_store_config: {
            usage_store_type: self.couponType.find(function (ct) {
              return ct.value === coupon.usage_store_config.usage_store_type;
            }),
            usage_store_value: null,
            usage_method: '',
            manual_store_ids: [] },
          time_config: {
            time_type: self.timeType.find(function (tt) {
              return tt.value === coupon.time_config.time_type;
            }),
            start_time: '',
            end_time: '',
            use_start_day: '',
            use_tolerance_day: '',
            time: {
              start: { time: '' },
              end: { time: '' }
            }
          },
          is_group_usage: 1,
          amount_unit: coupon.amount_unit
        };
        var cusConfig = coupon.usage_store_config;
        var oCusConfig = obj.usage_store_config;
        var ctConfig = coupon.time_config;
        var oTConfig = obj.time_config;

        var usageMethod = [];
        if (cusConfig.usage_store_type === 2) {
          usageMethod = [{ label: '設定優惠券適用門市', value: 'manual' }];
        } else if (cusConfig.usage_store_type === 3) {
          usageMethod = [{ label: '設定優惠券適用門市', value: 'manual' }, { label: '限下訂門市使用', value: 'order_store' }];
        }
        oCusConfig.usage_method = usageMethod.find(function (um) {
          return um.value === cusConfig.usage_store_method;
        });

        if (cusConfig.usage_store_value) {
          var couponValue = [];
          if (cusConfig.usage_store_type === 2) {
            couponValue = self.brandList;
          } else if (cusConfig.usage_store_type === 3) {
            couponValue = self.storeList;
          }

          oCusConfig.usage_store_value = couponValue.find(function (cv) {
            return cv.value === cusConfig.usage_store_value;
          });
        }

        if (cusConfig.manual_stores) {
          cusConfig.manual_stores.forEach(function (brand) {
            brand.store_list.forEach(function (store) {
              oCusConfig.manual_store_ids.push(store.store_id);
            });
          });
        }

        if (ctConfig.valid_start_time) {
          oTConfig.start_time = ctConfig.valid_start_time;
          oTConfig.time.start.time = ctConfig.valid_start_time;
        }
        if (ctConfig.valid_end_time) {
          oTConfig.end_time = ctConfig.valid_end_time;
          oTConfig.time.end.time = ctConfig.valid_end_time;
        }
        if (ctConfig.use_start_day || ctConfig.use_start_day === 0) oTConfig.use_start_day = ctConfig.use_start_day;
        if (ctConfig.use_tolerance_day || ctConfig.use_tolerance_day === 0) oTConfig.use_tolerance_day = ctConfig.use_tolerance_day;

        self.giveCoupons.coupon_set_list.push(obj);
      });
    }
  },
  watch: {
    'activity.owner_type.value': function activityOwner_typeValue() {
      this.dCouponType = this.activity.owner_type.value;
      if (this.dCouponType === 3) {
        this.giveCoupons.coupon_set_list.forEach(function (coupon) {
          coupon.usage_store_config.usage_store_type = { label: '門市', value: 3 };
          coupon.usage_store_config.usage_store_value = null;
        });
      }
    },
    'curCoupon.coupon_info.name': function curCouponCoupon_infoName() {
      if (this.$route.name.indexOf('cr') > -1) this.curCoupon.coupon_info.set_name = this.curCoupon.coupon_info.name;
    },
    'curCoupon.coupon_info.description': function curCouponCoupon_infoDescription() {
      if (this.$route.name.indexOf('cr') > -1) this.curCoupon.coupon_info.set_description = this.curCoupon.coupon_info.description;
    },
    'curCoupon.time_config.time.start.time': function curCouponTime_configTimeStartTime() {
      this.curCoupon.time_config.start_time = this.curCoupon.time_config.time.start.time;
      this.endLimit = [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.curCoupon.time_config.time.start.time).subtract(1, 'days')
      }];
    },
    'curCoupon.time_config.time.end.time': function curCouponTime_configTimeEndTime() {
      this.curCoupon.time_config.end_time = this.curCoupon.time_config.time.end.time;
    },
    storeList: function storeList() {
      this.addStoresSetting.options = this.storeList;
      this.addStoresSetting.choose = [];
      if (this.$route.name === 'upActivity' && !this.setInfoTimes && this.storeList.length) {
        this.setInfo();
      }
    },
    'addStoresSetting.choose': function addStoresSettingChoose() {
      if (this.curCoupon.usage_store_config) {
        this.curCoupon.usage_store_config.manual_store_ids = this.addStoresSetting.choose;
      }
    },
    setInfoTimes: function setInfoTimes() {},
    curCoupon: function curCoupon() {
      var self = this;
      setTimeout(function () {
        if (self.$refs.couponStoresMuti) {
          self.$refs.couponStoresMuti.init();
        }
      }, 1000);
    }
  }
});

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CouponModal_vue__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CouponModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CouponModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    brandList: Array,
    storeList: Array,
    giveCoupons: Object,
    info: Object,
    activity: Object
  },
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_0_vue_datepicker_vue_datepicker_es6_vue___default.a,
    'coupon-modal': __WEBPACK_IMPORTED_MODULE_1__CouponModal_vue___default.a
  },
  computed: {
    couponValue: function couponValue() {
      var couponType = '';
      if (this.curCoupon.coupon_info) {
        couponType = this.curCoupon.usage_store_config.usage_store_type;
        if (couponType.value === 2) {
          return this.brandList;
        } else if (couponType.value === 3) {
          return this.storeList;
        }
      }
      return [];
    },
    usageMethod: function usageMethod() {
      var couponType = '';
      if (this.curCoupon.coupon_info) {
        couponType = this.curCoupon.usage_store_config.usage_store_type;
        if (couponType.value === 2) {
          return [{ label: '設定優惠券適用門市', value: 'manual' }];
        } else if (couponType.value === 3) {
          return [{ label: '設定優惠券適用門市', value: 'manual' }, { label: '限下訂門市使用', value: 'order_store' }];
        }
      }
      return [];
    }
  },
  data: function data() {
    return {
      setInfoTimes: 0,
      addStoresSetting: {
        class: 'coupon-store',
        options: [],
        choose: []
      },
      reNew: 0,
      reSet: 0,
      timeType: [{ label: '限定時段', value: 'all_fixed' }, { label: '獲取後～某時段結束', value: 'day_fixed' }, { label: '獲取後～獲取幾日後結束', value: 'day_day' }],
      couponType: [{ label: '品牌', value: 2 }, { label: '門市', value: 3 }],
      priceType: [{ label: '免稅', value: 1 }, { label: '未稅', value: 2 }, { label: '含稅', value: 3 }],
      newCouponType: { label: '商品數量', value: 'SC00001' },
      delOption: {
        id: 'delModal',
        title: '刪除贈送優惠券',
        body: '刪除此優惠券，設定的內容將被刪除',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delCoupon'
        }]
      },
      curIndex: 0,
      curCoupon: {},
      ruleCodeOptions: [{ label: '商品數量', value: 'SC00001' }, { label: '指定商品數量', value: 'SC00002' }, { label: '商品金額', value: 'SC00003' }],
      dCouponType: '',
      startLimit: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD HH:mm:ss')
      }],
      endLimit: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD HH:mm:ss')
      }],
      timeoption: {
        type: 'min',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD HH:mm:ss',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      oldIndex: ''
    };
  },

  methods: {
    getStoreName: function getStoreName(sId) {
      if (this.addStoresSetting.options) return this.addStoresSetting.options.find(function (stores) {
        return sId === stores.value;
      }).label;
    },
    trigger: function trigger(event) {
      if (event === 'delCoupon') {
        this.delCoupon();
      }
    },
    addNewCoupon: function addNewCoupon() {
      var num = this.giveCoupons.coupon_set_list.length + 1;
      var obj = {
        coupon_info: {
          set_name: '優惠券' + num,
          set_description: '',
          name: '優惠券' + num,
          description: '',
          remark: '',
          discount_type: 1,
          discount_value: '',
          price_type: { label: '含稅', value: 3 }
        },
        usage_store_config: {
          usage_store_type: { label: '品牌', value: 2 },
          usage_store_value: null,
          usage_method: { label: '設定優惠券適用門市', value: 'manual' },
          manual_store_ids: [] },
        time_config: {
          time_type: { label: '限定時段', value: 'all_fixed' },
          start_time: '',
          end_time: '',
          use_start_day: '',
          use_tolerance_day: '',
          time: {
            start: { time: '' },
            end: { time: '' }
          }
        },
        is_group_usage: 1,
        amount_unit: 1
      };

      if (this.dCouponType && this.dCouponType === 2) obj.usage_store_config.usage_store_type = this.brandList[0];
      if (this.dCouponType && this.dCouponType === 3) obj.usage_store_config.usage_store_type = { label: '門市', value: 3 };
      if (this.getRoleType === 10) obj.usage_store_config.usage_store_type = { label: '門市', value: 3 };
      this.giveCoupons.coupon_set_list.push(obj);

      this.changeCur(obj);
    },
    changeCur: function changeCur(coupon, index) {
      if (this.oldIndex !== index) {
        this.curCoupon = coupon;
        this.addStoresSetting.choose = this.curCoupon.usage_store_config.manual_store_ids;
        if (this.$refs.couponStoresMuti) this.$refs.couponStoresMuti.init();
        this.oldIndex = index;
      }
    },
    selectUSType: function selectUSType() {
      this.curCoupon.usage_store_config.usage_store_value = null;
    },
    changeUSType: function changeUSType() {
      if (this.curCoupon.usage_store_config.usage_store_type.value === 2) this.curCoupon.usage_store_config.usage_method = { label: '設定優惠券適用門市', value: 'manual' };
    },
    delCoupon: function delCoupon() {
      this.giveCoupons.coupon_set_list.splice(this.curIndex, 1);
    },
    setInfo: function setInfo() {
      this.setInfoTimes++;
      var self = this;
      var iList = this.info.give_coupons[0].coupon_set_list;
      iList.forEach(function (coupon) {
        var obj = {
          coupon_info: {
            set_name: coupon.set_name,
            set_description: coupon.set_description,
            name: coupon.name,
            description: coupon.description,
            remark: coupon.remark,
            discount_type: 1,
            discount_value: coupon.discount_value,
            price_type: self.priceType.find(function (pt) {
              return pt.value === coupon.price_type;
            })
          },
          usage_store_config: {
            usage_store_type: self.couponType.find(function (ct) {
              return ct.value === coupon.usage_store_config.usage_store_type;
            }),
            usage_store_value: null,
            usage_method: '',
            manual_store_ids: [] },
          time_config: {
            time_type: self.timeType.find(function (tt) {
              return tt.value === coupon.time_config.time_type;
            }),
            start_time: '',
            end_time: '',
            use_start_day: '',
            use_tolerance_day: '',
            time: {
              start: { time: '' },
              end: { time: '' }
            }
          },
          is_group_usage: 1,
          amount_unit: coupon.amount_unit
        };
        var cusConfig = coupon.usage_store_config;
        var oCusConfig = obj.usage_store_config;
        var ctConfig = coupon.time_config;
        var oTConfig = obj.time_config;

        var usageMethod = [];
        if (cusConfig.usage_store_type === 2) {
          usageMethod = [{ label: '設定優惠券適用門市', value: 'manual' }];
        } else if (cusConfig.usage_store_type === 3) {
          usageMethod = [{ label: '設定優惠券適用門市', value: 'manual' }, { label: '限下訂門市使用', value: 'order_store' }];
        }
        oCusConfig.usage_method = usageMethod.find(function (um) {
          return um.value === cusConfig.usage_store_method;
        });

        if (cusConfig.usage_store_value) {
          var couponValue = [];
          if (cusConfig.usage_store_type === 2) {
            couponValue = self.brandList;
          } else if (cusConfig.usage_store_type === 3) {
            couponValue = self.storeList;
          }
          setTimeout(function () {
            self.$set(oCusConfig, 'usage_store_value', couponValue.find(function (cv) {
              return cv.value === cusConfig.usage_store_value;
            }));
          }, 1000);
        }

        if (cusConfig.manual_stores) {
          cusConfig.manual_stores.forEach(function (brand) {
            brand.store_list.forEach(function (store) {
              oCusConfig.manual_store_ids.push(store.store_id);
            });
          });
        }

        if (ctConfig.valid_start_time) {
          oTConfig.start_time = ctConfig.valid_start_time;
          oTConfig.time.start.time = ctConfig.valid_start_time;
        }
        if (ctConfig.valid_end_time) {
          oTConfig.end_time = ctConfig.valid_end_time;
          oTConfig.time.end.time = ctConfig.valid_end_time;
        }
        if (ctConfig.use_start_day || ctConfig.use_start_day === 0) oTConfig.use_start_day = ctConfig.use_start_day;
        if (ctConfig.use_tolerance_day || ctConfig.use_tolerance_day === 0) oTConfig.use_tolerance_day = ctConfig.use_tolerance_day;
        self.giveCoupons.coupon_set_list.push(obj);
      });
    }
  },
  watch: {
    'activity.owner_type.value': function activityOwner_typeValue() {
      this.dCouponType = this.activity.owner_type.value;
      if (this.dCouponType === 3) {
        this.giveCoupons.coupon_set_list.forEach(function (coupon) {
          coupon.usage_store_config.usage_store_type = { label: '門市', value: 3 };
          coupon.usage_store_config.usage_store_value = null;
        });
      }
    },
    'curCoupon.time_config.time.start.time': function curCouponTime_configTimeStartTime() {
      this.curCoupon.time_config.start_time = this.curCoupon.time_config.time.start.time;
      this.endLimit = [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.curCoupon.time_config.time.start.time).subtract(1, 'days')
      }];
    },
    'curCoupon.time_config.time.end.time': function curCouponTime_configTimeEndTime() {
      this.curCoupon.time_config.end_time = this.curCoupon.time_config.time.end.time;
    },
    storeList: function storeList() {
      this.addStoresSetting.options = this.storeList;
      this.addStoresSetting.choose = [];
      if (!this.setInfoTimes && this.storeList.length) this.setInfo();
    },
    'addStoresSetting.choose': function addStoresSettingChoose() {
      if (this.curCoupon.usage_store_config) {
        this.curCoupon.usage_store_config.manual_store_ids = this.addStoresSetting.choose;
      }
    },
    setInfoTimes: function setInfoTimes() {},
    curCoupon: function curCoupon() {
      var self = this;
      setTimeout(function () {
        if (self.$refs.couponStoresMuti) {
          self.$refs.couponStoresMuti.init();
        }
      }, 1000);
    }
  }
});

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    coupon: Object
  },
  data: function data() {
    return {
      newCouponType: '',
      orderType: [{ label: '一般單', value: 1 }, { label: '團購單 - 團長', value: 2 }, { label: '團購單 - 團員', value: 3 }],
      delOption: {
        id: 'delModal',
        title: '刪除贈送優惠券',
        body: '刪除此優惠券，設定的內容將被刪除',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delCoupon'
        }]
      }
    };
  },

  methods: {
    trigger: function trigger(event) {
      if (event === 'delCoupon') {
        this.delCoupon();
      }
    },
    addNewCoupon: function addNewCoupon() {
      var obj = {
        coupon_strategy: {},
        coupon_set_list: [{
          coupon_info: {
            set_name: '',
            set_description: '',
            name: '',
            description: '',
            remark: '',
            discount_type: 1,
            discount_value: '',
            price_type: 3,
            usage_store_config: {
              usage_store_type: 2,
              usage_store_value: null,
              usage_method: 'order_store',
              manual_store_ids: [] },
            time_config: {
              time_type: 'all_fixed',
              start_time: '',
              end_time: '',
              use_start_day: '',
              use_tolerance_day: ''
            },
            is_group_usage: 1,
            amount_unit: 1
          }
        }]
      };
      if (this.newCouponType === 'SC00001') {
        obj.coupon_strategy = {
          rule_code: 'SC00001',
          name: '優惠券',
          description: '',
          limit: {
            min_amount: 1,
            min_money: '',
            order_method: '',
            orderMethod: '',
            order_types: [],
            orderTypes: [],
            delivery_types: [],
            deliveryTypes: []
          },
          setting: {
            one_max_amount: null,
            ratio: 1,
            lowest_unit_price: 0
          },
          store_exception_items: [{
            products: [],
            store_ids: []
          }]
        };
      } else if (this.newCouponType === 'SC00002') {
        obj.coupon_strategy = {
          rule_code: 'SC00002',
          name: '優惠券',
          description: '',
          limit: {
            min_amount: 1,
            min_money: '',
            order_method: '',
            orderMethod: '',
            order_types: [],
            orderTypes: [],
            delivery_types: [],
            deliveryTypes: []
          },
          setting: {
            one_max_amount: null,
            ratio: 1,
            vendorCustomProductList: [],
            vendor_custom_product_list: []
          },
          store_exception_items: []
        };
      } else if (this.newCouponType === 'SC00003') {
        obj.coupon_strategy = {
          rule_code: 'SC00002',
          name: '優惠券',
          description: '',
          limit: {
            min_amount: 1,
            min_money: '',
            order_method: '',
            orderMethod: '',
            order_types: [],
            orderTypes: [],
            delivery_types: [],
            deliveryTypes: []
          },
          setting: {
            one_max_amount: null,
            ratio: 1,
            money_unit: 100
          },
          store_exception_items: [{
            products: [],
            store_ids: []
          }]
        };
      }
      this.couponSet.push(obj);
    },
    delCoupon: function delCoupon() {}
  },
  created: function created() {}
});

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Discount_Temp_MenuDiscountTemp_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Discount_Temp_MenuDiscountTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Discount_Temp_MenuDiscountTemp_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'menu-discount': __WEBPACK_IMPORTED_MODULE_0__Discount_Temp_MenuDiscountTemp_vue___default.a
  },
  props: {
    giveCoupons: Object,
    info: Object,
    brandList: Array,
    storeList: Array,
    aStoreOption: Array,
    setInfoTimes: Number
  },
  data: function data() {
    return {
      addStoresSetting: {
        class: 'coupon-store',
        options: [],
        choose: []
      },
      ruleCode: '',
      newCouponType: { label: '消費商品數量滿額 (SC00001)', value: 'SC00001' },
      ruleCodeOptions: [{ label: '消費商品數量滿額 (SC00001)', value: 'SC00001' }, { label: '消費指定商品滿額 (SC00002)', value: 'SC00002' }, { label: '消費金額滿額 (SC00003)', value: 'SC00003' }],
      orderType: [{ label: '一般單', value: 1 }, { label: '團購單 - 團長', value: 2 }, { label: '團購單 - 團員', value: 3 }],
      orderMethod: [{ label: '當日單', value: 1 }, { label: '預訂單', value: 2 }],
      deliveryType: [{ label: '自取', value: 1 }, { label: '內用', value: 2 }, { label: '外送', value: 3 }, { label: '內用-桌邊掃碼', value: 21 }],
      dStrategy: {
        rule_code: '',
        name: '',
        description: '',
        limit: {
          delivery_types: [],
          order_types: [],
          order_method: '',
          min_money: '',
          min_amount: ''
        },
        setting: {
          one_max_amount: '',
          ratio: 1,
          lowest_unit_price: 0,

          vendor_custom_product_list: [],

          money_unit: ''
        },

        store_exception_items: [{
          products: [],
          store_ids: []
        }]
      },
      storeSelect: { label: '', value: '', brand_id: '' },
      menuSelect: {
        label: '',
        value: 0
      },
      tableIndex: 1,
      count: 20,
      menuList: []
    };
  },

  methods: {
    getOnlineMenu: function getOnlineMenu() {
      var self = this;
      self.menuList = [];
      var select = this.storeSelect;
      var url = '/onlineMenu/list?page=' + this.tableIndex + '&size=' + this.count + '&brand_id=' + select.brand_id + '&store_id=' + select.value;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var mList = response.data.menu_list;
          mList.forEach(function (menu, index) {
            var option = { label: menu.name, value: menu.id };
            self.menuList.push(option);
            if (index === 0) self.menuSelect = option;
          });
          if (!mList.length) self.menuSelect = { label: '', value: '' };
        }
      });
    },
    clickOption: function clickOption(option) {
      var self = this;
      this.addStoresSetting.options = [];
      self.curId = option.id;
      if (self.curId) {
        self.$nextTick(function () {
          self.reSet++;
          self.addStoresSetting.options = self.storeBrief;
          self.getCurStoreClass();
        });
      }
    },
    getCurStoreClass: function getCurStoreClass() {
      this.addStoresSetting.choose = [];
      var self = this;
      var url = '/brand/' + this.brandSelect.value + '/storeClass/' + this.curId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var classInfo = response.data.class;
          classInfo.store_list.forEach(function (s) {
            self.addStoresSetting.choose.push(s.id);
          });
        }
      });
    },
    setStore: function setStore() {
      var self = this;
      var stores = this.info.attend_stores;

      if (stores.length) {
        stores[0].store_list.forEach(function (store) {
          self.addStoresSetting.choose.push(store.store_id);
        });
      }
    },
    addProdToList: function addProdToList(addPInfo) {
      var self = this;
      var pInfo = this.giveCoupons.coupon_strategy.setting.vendor_custom_product_list;

      addPInfo.forEach(function (addP) {
        var isSame = pInfo.find(function (prod) {
          return addP.vendor_custom_id === prod.vendor_custom_id;
        });
        if (!isSame) pInfo.push(addP);else {
          self.$notify({
            title: '提醒',
            text: addP.product_name + '已加入過',
            duration: 3000,
            width: 400
          });
        }
      });
    },
    addExProdToList: function addExProdToList(addPInfo) {
      var self = this;
      var pInfo = this.giveCoupons.coupon_strategy.store_exception_items[0].products;
      addPInfo.forEach(function (addP) {
        var isSame = pInfo.find(function (prod) {
          return addP.vendor_custom_id === prod.vendor_custom_id;
        });
        if (!isSame) {
          pInfo.push(addP);
        } else {
          self.$notify({
            title: '提醒',
            text: addP.product_name + '已加入過',
            duration: 3000,
            width: 400
          });
        }
      });
    },
    addExProdToList3: function addExProdToList3(addPInfo) {
      var self = this;
      var pInfo = this.giveCoupons.coupon_strategy.store_exception_items[0].products;
      addPInfo.forEach(function (addP) {
        var isSame = pInfo.find(function (prod) {
          return addP.vendor_custom_id === prod.vendor_custom_id;
        });
        if (!isSame) pInfo.push(addP);else {
          self.$notify({
            title: '提醒',
            text: addP.product_name + '已加入過',
            duration: 3000,
            width: 400
          });
        }
      });
    },
    removeListItem: function removeListItem(list, index) {
      list.splice(index, 1);
    },
    returnNum: function returnNum(e) {
      var charCode = e.which ? e.which : e.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        e.preventDefault();
      } else {
        return true;
      }
    },
    setInfo: function setInfo() {
      var self = this;

      var iStrategy = this.info.give_coupons[0].coupon_strategy;
      var iLimit = iStrategy.limit;
      var iSetting = iStrategy.setting;
      this.ruleCode = iStrategy.rule_code;

      var cStrategy = {
        rule_code: iStrategy.rule_code,
        name: iStrategy.strategy_name,
        description: iStrategy.strategy_description,
        limit: {
          delivery_types: [],
          order_types: [],
          order_method: '',
          min_money: iLimit.min_money,
          min_amount: iLimit.min_amount
        },
        setting: {
          one_max_amount: '',
          ratio: 1,
          lowest_unit_price: 0,

          vendor_custom_product_list: [],

          money_unit: ''
        },

        store_exception_items: [{
          products: [],
          store_ids: []
        }]
      };
      var cLimit = cStrategy.limit;
      var cSetting = cStrategy.setting;
      this.newCouponType = this.ruleCodeOptions.find(function (rc) {
        return rc.value === iStrategy.rule_code;
      });

      if (iLimit.order_type) {
        iLimit.order_type.forEach(function (orderType) {
          var otop = self.orderType.find(function (ot) {
            return ot.value === orderType;
          });
          cLimit.order_types.push(otop);
        });
      }

      if (iLimit.order_method) {
        var omop = self.orderMethod.find(function (om) {
          return om.value === iLimit.order_method;
        });
        cLimit.order_method = omop;
      }

      if (iLimit.delivery_type) {
        iLimit.delivery_type.forEach(function (deliveryType) {
          var dtop = self.deliveryType.find(function (dt) {
            return dt.value === deliveryType;
          });
          cLimit.delivery_types.push(dtop);
        });
      }
      if (iSetting.one_max_amount) cSetting.one_max_amount = iSetting.one_max_amount;
      if (iSetting.lowest_unit_price) cSetting.lowest_unit_price = iSetting.lowest_unit_price;
      if (iSetting.vendor_custom_product_list) {
        iSetting.vendor_custom_product_list.forEach(function (item) {
          var obj = { vendor_custom_id: item.id, product_name: item.name };
          cSetting.vendor_custom_product_list.push(obj);
        });
      }
      if (iSetting.money_unit) cSetting.money_unit = iSetting.money_unit;
      if (iStrategy.store_exception_items.length) {
        iStrategy.store_exception_items[0].products.forEach(function (item) {
          var obj = { vendor_custom_id: item.vendor_custom_id, product_name: item.name };
          cStrategy.store_exception_items[0].products.push(obj);
        });
        iStrategy.store_exception_items[0].stores[0].store_list.forEach(function (store) {
          cStrategy.store_exception_items[0].store_ids.push(store.store_id);
        });
      }
      this.giveCoupons.coupon_strategy = cStrategy;
    },
    reNewMenu: function reNewMenu(select) {
      this.ruleCode = this.giveCoupons.coupon_strategy.rule_code = select.value;
      this.giveCoupons.coupon_strategy.store_exception_items[0].products = [];
      this.giveCoupons.coupon_strategy.setting.vendor_custom_product_list = [];
      this.storeSelect = { label: '', value: '', brand_id: '' };
      this.menuSelect = { label: '', value: 0 };
    }
  },
  created: function created() {
    this.giveCoupons.coupon_strategy = this.dStrategy;
    this.ruleCode = this.giveCoupons.coupon_strategy.rule_code = this.newCouponType.value;
  },

  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  },
  watch: {
    'storeSelect.value': function storeSelectValue() {
      if (this.storeSelect.value) {
        this.getOnlineMenu();
      }
    },
    setInfoTimes: function setInfoTimes() {
      this.setInfo();
    }
  }
});

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Discount_Temp_MenuDiscountTemp_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Discount_Temp_MenuDiscountTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Discount_Temp_MenuDiscountTemp_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'menu-discount': __WEBPACK_IMPORTED_MODULE_0__Discount_Temp_MenuDiscountTemp_vue___default.a
  },
  props: {
    giveCoupons: Object,
    info: Object,
    brandList: Array,
    storeList: Array,
    aStoreOption: Array,
    setInfoTimes: Number
  },
  data: function data() {
    return {
      addStoresSetting: {
        class: 'coupon-store',
        options: [],
        choose: []
      },
      ruleCode: '',
      newCouponType: { label: '消費商品數量滿額', value: 'SC00001' },
      ruleCodeOptions: [{ label: '消費商品數量滿額', value: 'SC00001' }, { label: '消費指定商品滿額', value: 'SC00002' }, { label: '消費金額滿額', value: 'SC00003' }],
      orderType: [{ label: '一般單', value: 1 }, { label: '團購單 - 團長', value: 2 }, { label: '團購單 - 團員', value: 3 }],
      orderMethod: [{ label: '當日單', value: 1 }, { label: '預訂單', value: 2 }],
      deliveryType: [{ label: '自取', value: 1 }, { label: '內用', value: 2 }, { label: '外送', value: 3 }, { label: '內用-桌邊掃碼', value: 21 }],
      dStrategy: {
        rule_code: '',
        name: '',
        description: '',
        limit: {
          delivery_types: [],
          order_types: [],
          order_method: '',
          min_money: '',
          min_amount: ''
        },
        setting: {
          one_max_amount: '',
          ratio: 1,
          lowest_unit_price: 0,

          vendor_custom_product_list: [],

          money_unit: ''
        },

        store_exception_items: [{
          products: [],
          store_ids: []
        }]
      },
      storeSelect: { label: '', value: '', brand_id: '' },
      menuSelect: {
        label: '',
        value: 0
      },
      tableIndex: 1,
      count: 20,
      menuList: []
    };
  },

  methods: {
    getOnlineMenu: function getOnlineMenu() {
      var self = this;
      self.menuList = [];
      var select = this.storeSelect;
      var url = '/onlineMenu/list?page=' + this.tableIndex + '&size=' + this.count + '&brand_id=' + select.brand_id + '&store_id=' + select.value;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var mList = response.data.menu_list;
          mList.forEach(function (menu, index) {
            var option = { label: menu.name, value: menu.id };
            self.menuList.push(option);
            if (index === 0) self.menuSelect = option;
          });
          if (!mList.length) self.menuSelect = { label: '', value: '' };
        }
      });
    },
    clickOption: function clickOption(option) {
      var self = this;
      this.addStoresSetting.options = [];
      self.curId = option.id;
      if (self.curId) {
        self.$nextTick(function () {
          self.reSet++;
          self.addStoresSetting.options = self.storeBrief;
          self.getCurStoreClass();
        });
      }
    },
    getCurStoreClass: function getCurStoreClass() {
      this.addStoresSetting.choose = [];
      var self = this;
      var url = '/brand/' + this.brandSelect.value + '/storeClass/' + this.curId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var classInfo = response.data.class;
          classInfo.store_list.forEach(function (s) {
            self.addStoresSetting.choose.push(s.id);
          });
        }
      });
    },
    setStore: function setStore() {
      var self = this;
      var stores = this.info.attend_stores;

      if (stores.length) {
        stores[0].store_list.forEach(function (store) {
          self.addStoresSetting.choose.push(store.store_id);
        });
      }
    },
    addProdToList: function addProdToList(addPInfo) {
      var self = this;
      var pInfo = this.giveCoupons.coupon_strategy.setting.vendor_custom_product_list;

      addPInfo.forEach(function (addP) {
        var isSame = pInfo.find(function (prod) {
          return addP.vendor_custom_id === prod.vendor_custom_id;
        });
        if (!isSame) pInfo.push(addP);else {
          self.$notify({
            title: '提醒',
            text: addP.product_name + '已加入過',
            duration: 3000,
            width: 400
          });
        }
      });
    },
    addExProdToList: function addExProdToList(addPInfo) {
      var self = this;
      var pInfo = this.giveCoupons.coupon_strategy.store_exception_items[0].products;

      addPInfo.forEach(function (addP) {
        var isSame = pInfo.find(function (prod) {
          return addP.vendor_custom_id === prod.vendor_custom_id;
        });
        if (!isSame) {
          pInfo.push(addP);
        } else {
          self.$notify({
            title: '提醒',
            text: addP.product_name + '已加入過',
            duration: 3000,
            width: 400
          });
        }
      });
    },
    addExProdToList3: function addExProdToList3(addPInfo) {
      var self = this;
      var pInfo = this.giveCoupons.coupon_strategy.store_exception_items[0].products;
      addPInfo.forEach(function (addP) {
        var isSame = pInfo.find(function (prod) {
          return addP.vendor_custom_id === prod.vendor_custom_id;
        });
        if (!isSame) pInfo.push(addP);else {
          self.$notify({
            title: '提醒',
            text: addP.product_name + '已加入過',
            duration: 3000,
            width: 400
          });
        }
      });
    },
    removeListItem: function removeListItem(list, index) {
      list.splice(index, 1);
    },
    returnNum: function returnNum(e) {
      var charCode = e.which ? e.which : e.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        e.preventDefault();
      } else {
        return true;
      }
    },
    setInfo: function setInfo() {
      var self = this;

      var iStrategy = this.info.give_coupons[0].coupon_strategy;
      var iLimit = iStrategy.limit;
      var iSetting = iStrategy.setting;
      this.ruleCode = iStrategy.rule_code;

      var cStrategy = {
        rule_code: iStrategy.rule_code,
        name: iStrategy.strategy_name,
        description: iStrategy.strategy_description,
        limit: {
          delivery_types: [],
          order_types: [],
          order_method: '',
          min_money: iLimit.min_money,
          min_amount: iLimit.min_amount
        },
        setting: {
          one_max_amount: '',
          ratio: 1,
          lowest_unit_price: 0,

          vendor_custom_product_list: [],

          money_unit: ''
        },

        store_exception_items: [{
          products: [],
          store_ids: []
        }]
      };
      var cLimit = cStrategy.limit;
      var cSetting = cStrategy.setting;
      this.newCouponType = this.ruleCodeOptions.find(function (rc) {
        return rc.value === iStrategy.rule_code;
      });

      if (iLimit.order_type) {
        iLimit.order_type.forEach(function (orderType) {
          var otop = self.orderType.find(function (ot) {
            return ot.value === orderType;
          });
          cLimit.order_types.push(otop);
        });
      }

      if (iLimit.order_method) {
        var omop = self.orderMethod.find(function (om) {
          return om.value === iLimit.order_method;
        });
        cLimit.order_method = omop;
      }

      if (iLimit.delivery_type) {
        iLimit.delivery_type.forEach(function (deliveryType) {
          var dtop = self.deliveryType.find(function (dt) {
            return dt.value === deliveryType;
          });
          cLimit.delivery_types.push(dtop);
        });
      }
      if (iSetting.one_max_amount) cSetting.one_max_amount = iSetting.one_max_amount;
      if (iSetting.lowest_unit_price) cSetting.lowest_unit_price = iSetting.lowest_unit_price;
      if (iSetting.vendor_custom_product_list) {
        iSetting.vendor_custom_product_list.forEach(function (item) {
          var obj = { vendor_custom_id: item.id, product_name: item.name };
          cSetting.vendor_custom_product_list.push(obj);
        });
      }
      if (iSetting.money_unit) cSetting.money_unit = iSetting.money_unit;
      if (iStrategy.store_exception_items.length) {
        iStrategy.store_exception_items[0].products.forEach(function (item) {
          var obj = { vendor_custom_id: item.vendor_custom_id, product_name: item.name };
          cStrategy.store_exception_items[0].products.push(obj);
        });
        iStrategy.store_exception_items[0].stores[0].store_list.forEach(function (store) {
          cStrategy.store_exception_items[0].store_ids.push(store.store_id);
        });
      }

      this.giveCoupons.coupon_strategy = cStrategy;
    },
    reNewMenu: function reNewMenu(select) {
      this.ruleCode = this.giveCoupons.coupon_strategy.rule_code = select.value;
      this.giveCoupons.coupon_strategy.store_exception_items[0].products = [];
      this.giveCoupons.coupon_strategy.setting.vendor_custom_product_list = [];
      this.storeSelect = { label: '', value: '', brand_id: '' };
      this.menuSelect = { label: '', value: 0 };
    }
  },
  created: function created() {
    this.giveCoupons.coupon_strategy = this.dStrategy;
    this.ruleCode = this.giveCoupons.coupon_strategy.rule_code = this.newCouponType.value;
  },

  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  },
  watch: {
    'storeSelect.value': function storeSelectValue() {
      if (this.storeSelect.value) {
        this.getOnlineMenu();
      }
    },
    setInfoTimes: function setInfoTimes() {
      this.setInfo();
    }
  }
});

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      roleType: 0,
      brandBrief: [],
      storeBrief: [],
      brandSelect: 999999,
      storeSelect: 999999,
      ruleCodeSelect: 999999,
      timeMethodSelect: 999999,
      statusSelect: 999999,
      sTimeMethodSelect: 999999,
      ownerTypeSelect: 999999,
      ownerType: [{ label: '== 擁有者 ==', value: 999999 }, { label: '品牌', value: 2 }, { label: '門市', value: 3 }, { label: '平台', value: 1 }],
      couponList: [],
      total: 1,
      count: 20,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      current: {
        store_list: [],
        name: ''
      },
      preSortMethod: [],
      sortToggle: false,
      sortMethod: '',
      curCoupon: {},
      stopOption: {
        id: 'stopModal',
        title: '活動下架',
        body: '確定下架活動?<br>',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'stopActivity'
        }]
      }
    };
  },
  mounted: function mounted() {},

  methods: {
    trigger: function trigger(event) {
      if (event === 'stopActivity') this.orderCouponStop();
    },
    orderCouponEdit: function orderCouponEdit(coupon) {
      var self = this;
      var url = '/activity/' + coupon.activity_id + '/orderCouponEdit';
      this.getDataH('put', url, null, function (response) {
        if (response.data.status === 200) {
          self.$router.push('/upActivity/' + coupon.activity_id);
        }
      });
    },
    orderCouponStop: function orderCouponStop() {
      var self = this;
      var url = '/activity/' + this.curCoupon.activity_id + '/orderCouponStop';
      this.getDataH('put', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.getAttendCoupon();
        }
      });
    },
    orderCouponPush: function orderCouponPush(coupon) {
      console.log(coupon.activity_id);
      var self = this;
      var url = '/activity/' + coupon.activity_id + '/orderCouponPush';
      this.getDataH('put', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.getAttendCoupon();
        }
      });
    },
    checkSort: function checkSort(method) {
      this.sortMethod = method;
      if (this.preSortMethod.length) {
        if (method === this.preSortMethod[0]) this.sortToggle = !this.sortToggle;else {
          this.tableIndex = 1;
          this.sortToggle = false;
        }
        this.preSortMethod.splice(0, 1);
      } else this.sortToggle = false;
      this.preSortMethod.push(method);
      this.getAttendCoupon();
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      this.brandBrief = [{ label: '== 品牌 ==', value: 999999 }];
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            self.brandBrief.push(obj);
            if (i === 0 && self.getRoleType === 10) self.brandSelect = obj.value;
          }
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      this.storeBrief = [{ label: '== 門市 ==', value: 999999 }];
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);

            self.storeSelect = 999999;
          }
          if (!sList.length) {
            self.couponList = [];
            self.total = 0;
          }
        }
      });
    },
    getAttendCoupon: function getAttendCoupon() {
      var self = this;
      var url = '/activity/orderCouponList?page=' + this.tableIndex + '&size=' + this.count;
      if (this.storeSelect !== 999999 && this.getRoleType !== 30) {
        url = url + '&owner_id=' + this.storeSelect;
        url = url + '&owner_type=' + 3;
      } else if (this.brandSelect !== 999999 && this.getRoleType !== 10) {
        url = url + '&owner_id=' + this.brandSelect;
        url = url + '&owner_type=' + 2;
      }
      if (this.ruleCodeSelect !== 999999) url = url + '&rule_code=' + this.ruleCodeSelect;
      if (this.timeMethodSelect !== 999999) url = url + '&time_method=' + this.timeMethodSelect;
      if (this.statusSelect !== 999999) url = url + '&status=' + this.statusSelect;
      if (this.sTimeMethodSelect !== 999999) url = url + '&strategy_time_method=' + this.sTimeMethodSelect;
      if (this.sortMethod) {
        url = url + '&list_sort=' + this.sortMethod + ' ';
        if (this.sortToggle) url = url + 'ASC';else url = url + 'DESC';
      }
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.couponList = response.data.list;
          self.total = response.data.list_total;
        }
      });
    },
    clickCurrent: function clickCurrent(menu) {
      this.current = menu;
    },
    clickGroup: function clickGroup(type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1;
        this.tableIndex = this.groupAmount * this.pageGroup;
        this.clickPage(this.tableIndex);
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1;
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1;
        this.clickPage(this.tableIndex);
      }
    },
    clickEnd: function clickEnd(type) {
      if (type === 'pre') {
        this.clickPage(1);
        this.pageGroup = 1;
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount);else this.clickPage(1);
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount);
      }
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      if (index === 1) this.pageGroup = 1;
      this.getAttendCoupon();
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  }),
  created: function created() {
    if (this.getRoleType === 10) {
      this.ownerTypeSelect = 3;
    }
    this.roleType = parseInt(this.getRoleType, 10);
    this.fixedH();
    this.getBrandBrief();
    this.getAttendCoupon();
  },

  watch: {
    brandSelect: function brandSelect() {
      this.ownerTypeSelect = 2;
      if (this.brandSelect !== 999999 && this.brandSelect) this.getStoreBrief(this.brandSelect);
    },
    storeSelect: function storeSelect() {
      this.ownerTypeSelect = 3;
      this.getAttendCoupon();
    }
  }
});

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Temp_MemberIdentityTableTemp_vue__ = __webpack_require__(2194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Temp_MemberIdentityTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Temp_MemberIdentityTableTemp_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      tableIndex: 1
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#example1').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      });
    });
  },

  methods: {
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    }
  },
  components: {
    'identity-table': __WEBPACK_IMPORTED_MODULE_3__Temp_MemberIdentityTableTemp_vue___default.a
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  }
});

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      memberInfo: {},
      roleType: 99,
      couponShallowList: [],

      count: 20,
      total: 0,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      stateType: 'avail',

      brandSelect: {
        label: '== 品牌 ==',
        vlaue: 0
      },
      storeSelect: {
        label: '== 門市 ==',
        vlaue: 0
      },
      brandBrief: [],
      storeBrief: []
    };
  },

  methods: {
    getList: function getList(index) {
      this.gteCouponSummary(index);
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.getList(index);
    },
    clickGroup: function clickGroup(type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1;
        this.tableIndex = this.groupAmount * this.pageGroup;
        this.clickPage(this.tableIndex);
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1;
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1;
        this.clickPage(this.tableIndex);
      }
    },
    clickEnd: function clickEnd(type) {
      if (type === 'pre') {
        this.clickPage(1);
        this.pageGroup = 1;
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount);else this.clickPage(1);
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount);
      }
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    },
    getSourceMethodName: function getSourceMethodName(method) {
      switch (method) {
        case 'order':
          return '訂單';
        case 'transfer':
          return '轉贈';
        case 'register':
          return '註冊';
        case 'other':
          return '其他';
      }
    },
    getDate: function getDate(datetime) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(datetime, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
    },
    getMemberById: function getMemberById() {
      var self = this;
      if (this.$route.params.user_id) {
        var url = '/shopper/' + this.$route.params.user_id;
        this.loginType = 99;
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.memberInfo = response.data.shopper_info;
            if (self.getRoleType === 99) self.getList(1);
          }
        });
      }
    },
    gteCouponSummary: function gteCouponSummary(index) {
      var self = this;
      if (index) this.tableIndex = index;
      var data = {
        page: this.tableIndex,
        count: this.count
      };
      var url = '/shopper/' + this.$route.params.user_id + '/couponShallowList?page=' + data.page + '&count=' + data.count;
      if (this.stateType) url = url + '&state=' + this.stateType;
      if (this.brandSelect.value && !this.storeSelect.value) url = url + '&usage_store_type=2&usage_store_value=' + this.brandSelect.value;else if (this.storeSelect.value) url = url + '&usage_store_type=3&usage_store_value=' + this.storeSelect.value;

      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.total = response.data.meta.total;
          self.couponShallowList = response.data.coupon_list;
        }
      });
    },
    getBrandMemberById: function getBrandMemberById() {
      var self = this;
      if (this.$route.params.user_id) {
        var url = '/shopper/' + this.$route.params.user_id + '/basic';
        this.loginType = 99;
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.memberInfo = response.data.shopper_info;
          }
        });
      }
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      self.brandBrief = [{ label: '== 品牌 ==', vlaue: 0 }];
      var url = '/brand/listBrief?is_delete=0&is_opening=1&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            self.brandBrief.push(obj);
          }
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      console.log('getStoreBrief | MemberInfo');
      var self = this;
      self.storeBrief = [{ label: '== 門市 ==', vlaue: 0 }];
      var url = '/brand/' + brandId + '/storeListBrief?status=2&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
          }
        }
      });
    },
    changeBrand: function changeBrand() {
      this.storeSelect = {
        value: 0,
        label: '== 門市 =='
      };
      if (this.brandSelect.value) this.getStoreBrief(this.brandSelect.value);
      this.getList(1);
    }
  },
  created: function created() {
    this.roleType = parseInt(this.getRoleType, 10);
    if (this.roleType === 99) this.getMemberById();else if (this.roleType === 30) this.getBrandMemberById();
    this.getBrandBrief();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  })
});

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Order_Temp_OrderTableTemp_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Order_Temp_OrderTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Order_Temp_OrderTableTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      roleType: 99,
      memberInfo: {}
    };
  },
  mounted: function mounted() {},

  methods: {
    getMemberById: function getMemberById() {
      var self = this;
      if (this.$route.params.user_id) {
        var url = '/shopper/' + this.$route.params.user_id;
        this.loginType = 99;
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.memberInfo = response.data.shopper_info;
          }
        });
      }
    },
    getBrandMemberById: function getBrandMemberById() {
      var self = this;
      if (this.$route.params.user_id) {
        var url = '/shopper/' + this.$route.params.user_id + '/basic';
        this.loginType = 99;
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.memberInfo = response.data.shopper_info;
          }
        });
      }
    }
  },
  components: {
    'order-table': __WEBPACK_IMPORTED_MODULE_2__Order_Temp_OrderTableTemp_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    realName: function realName() {
      return this.memberInfo.last_name + this.memberInfo.first_name;
    }
  }),
  created: function created() {
    this.roleType = parseInt(this.getRoleType, 10);
    if (this.roleType === 99) this.getMemberById();else if (this.roleType === 30 || this.roleType === 10) this.getBrandMemberById();
  }
});

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_MemberTableTemp_vue__ = __webpack_require__(2195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_MemberTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_MemberTableTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      roleType: 99
    };
  },

  components: {
    'member-table': __WEBPACK_IMPORTED_MODULE_0__Temp_MemberTableTemp_vue___default.a
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  }
});

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Temp_ShopperMoneyTableTemp_vue__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Temp_ShopperMoneyTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Temp_ShopperMoneyTableTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      roleType: 99,
      tableIndex: 1,
      memberAmount: 0
    };
  },
  mounted: function mounted() {},

  methods: {},
  components: {
    'shopper-money-table': __WEBPACK_IMPORTED_MODULE_1__Temp_ShopperMoneyTableTemp_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    }
  }),
  created: function created() {
    this.roleType = parseInt(this.getRoleType, 10);
  }
});

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Temp_ShopperMoneyTableTemp_vue__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Temp_ShopperMoneyTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Temp_ShopperMoneyTableTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      roleType: 99,
      tableIndex: 1,
      memberAmount: 0
    };
  },
  mounted: function mounted() {},

  methods: {},
  components: {
    'shopper-money-table': __WEBPACK_IMPORTED_MODULE_1__Temp_ShopperMoneyTableTemp_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    }
  }),
  created: function created() {
    this.roleType = parseInt(this.getRoleType, 10);
  }
});

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__elements_Modal_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    'info': {
      type: Object
    }
  },
  components: {
    'm-modal': __WEBPACK_IMPORTED_MODULE_1__elements_Modal_vue___default.a
  },
  data: function data() {
    return {
      areaSelect: '',
      cityAreaList: [],
      citySelect: '',
      cityOption: [],
      v_code: '',
      memberInfo: {},
      reMessageVerityOption: {
        id: 'reMessageVerityModal',
        title: '簡訊驗證次數歸零',
        body: '使用者將可在一天內重新發送三次手機驗證',
        btns: [{
          name: '取消'
        }, {
          name: '歸零',
          event: 'reMessageVerity'
        }]
      },
      reMessageWrongOption: {
        id: 'reMessageWrongModal',
        title: '驗證錯誤次數歸零',
        body: '使用者將可重新輸入三次手機驗證碼',
        btns: [{
          name: '取消'
        }, {
          name: '歸零',
          event: 'reMessageWrong'
        }]
      },
      sendMessageOption: {
        id: 'sendMessageModal',
        title: '產生驗證碼',
        body: '重置使用者驗證次數與重試次數，並直接產生認證碼',
        btns: [{
          name: '取消'
        }, {
          name: '產生',
          event: 'sendMessage'
        }]
      }
    };
  },

  methods: {
    cityAreaName: function cityAreaName(cityCode, areaCode) {
      if (!cityCode || !areaCode) return '無居住地資料';
      var city = this.cityAreaList.find(function (item) {
        return item.city_code === cityCode;
      });
      var area = city.area_list.find(function (item) {
        return item.area_code === areaCode;
      }) || { name: '' };
      return city.name + area.name;
    },
    copySuccess: function copySuccess() {
      this.$notify({
        title: '已複製驗證碼',
        duration: 3000,
        type: 'success',
        width: 400
      });
    },
    verityPhone: function verityPhone() {
      var e = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#phone');
      this.memberInfo.phone = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    trigger: function trigger(event) {
      if (event === 'reMessageVerity') {
        this.reMessageVerity();
      } else if (event === 'reMessageWrong') {
        this.reMessageWrong();
      } else if (event === 'sendMessage') {
        this.checkPhone();
      }
    },
    checkPhone: function checkPhone() {
      if (!this.getInput.phone) {
        this.$notify({
          title: '提醒',
          text: '請填寫手機號碼！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (this.getInput.phone.length !== 10) {
        this.$notify({
          title: '提醒',
          text: '請填寫正確的手機號碼！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else this.sendMessage();
    },
    sendMessage: function sendMessage() {
      var self = this;
      var data = {
        phone: this.getInput.phone,
        skip_send_sms: 1
      };
      var url = '/shopper/verifyPhoneCode/' + this.$route.params.user_id;
      if (data) {
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: '產生成功',
              text: '驗證碼產生成功',
              duration: 3000,
              type: 'success',
              width: 400
            });
            self.v_code = response.data.verify_code;
          }
        });
      }
    },
    reMessageVerity: function reMessageVerity() {
      var self = this;
      var data = {
        clear_phone_valid_history: 1
      };
      var url = '/shopper/' + this.$route.params.user_id;
      if (data) {
        this.getDataH('put', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: '更新成功',
              text: '簡訊驗證次數歸零',
              duration: 3000,
              type: 'success',
              width: 400
            });
          }
        });
      }
    },
    reMessageWrong: function reMessageWrong() {
      var self = this;
      var data = {
        clear_phone_valid_fail_history: 1
      };
      var url = '/shopper/' + this.$route.params.user_id;
      if (data) {
        this.getDataH('put', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: '更新成功',
              text: '簡訊驗證次數歸零',
              duration: 3000,
              type: 'success',
              width: 400
            });
          }
        });
      }
    },
    getCityAreaList: function getCityAreaList() {
      var self = this;
      var url = '/platform/cityAreaList';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.cityAreaList = response.data.list;
          for (var i = 0; i < self.cityAreaList.length; i++) {
            var option = { name: self.cityAreaList[i].name, value: self.cityAreaList[i].city_code };
            self.cityOption.push(option);
          }
        }
      });
    },
    getMemberById: function getMemberById() {
      var self = this;
      if (this.$route.params.user_id) {
        var url = '/shopper/' + this.$route.params.user_id;
        this.loginType = 99;
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.memberInfo = response.data.shopper_info;
            self.citySelect = self.memberInfo.city_code;
            self.areaSelect = self.memberInfo.area_code;
          }
        });
      }
    },
    checkInputEmpty: function checkInputEmpty() {
      if (typeof this.memberInfo.daily_trade_limit !== 'number' && !this.memberInfo.daily_trade_limit) {
        this.$notify({
          title: '請填寫交易金額',
          text: '交易金額限制為0~200000',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (this.getInput.phone.length !== 10) {
        this.$notify({
          title: '提醒',
          text: '請填寫正確的手機號碼',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.updateMemberInfo();
      }
    },
    updateMemberInfo: function updateMemberInfo() {
      var memberInfo = this.memberInfo;
      var self = this;
      var data = {
        is_phone_valid: memberInfo.is_phone_valid,
        is_suspend: memberInfo.is_suspend,
        is_active: memberInfo.is_active,
        daily_trade_limit: parseInt(this.getInput.daily_trade_limit, 10)
      };
      if (memberInfo.create_account_type === 1) {
        data.is_phone_valid = memberInfo.is_active;
      }

      var url = '/shopper/' + this.$route.params.user_id;
      if (data) {
        this.getDataH('put', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: '更新成功',
              text: '已更新會員資訊',
              duration: 3000,
              type: 'success',
              width: 400
            });
            self.$router.push('/memberTable');
          }
        });
      }
    },
    goBack: function goBack() {
      this.$router.push('/memberTable');
    }
  },
  created: function created() {
    this.getMemberById();
  },
  mounted: function mounted() {
    this.getCityAreaList();
  },

  computed: {
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getInput: function getInput() {
      var mInfo = this.memberInfo;
      var phone = '';
      if (mInfo.phone) phone = mInfo.phone.toString();
      return {
        daily_trade_limit: this.checkInput(mInfo.daily_trade_limit.toString()),
        phone: this.checkInput(phone.toString())
      };
    }
  }
});

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      identityList: []
    };
  },

  methods: {
    getIdentityList: function getIdentityList() {
      var self = this;
      var url = '/shopper/' + this.$route.params.shopper_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.identityList = response.data.shopper_info.identity_list;
        }
      });
    }
  },
  created: function created() {
    this.getIdentityList();
  },

  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  }
});

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      roleType: 99,
      memberList: [],
      count: 20,
      total: 0,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      show: {
        brand: false,
        menu: false,
        schedule: false
      },
      loginType: 99,
      search: {
        result: ''
      },
      searchSelect: 1,
      brandId: '',
      storeId: '',
      isLoading: true,
      hasExistingMember: 0
    };
  },

  methods: {
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.getList(index);
    },
    clickGroup: function clickGroup(type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1;
        this.tableIndex = this.groupAmount * this.pageGroup;
        this.clickPage(this.tableIndex);
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1;
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1;
        this.clickPage(this.tableIndex);
      }
    },
    clickEnd: function clickEnd(type) {
      if (type === 'pre') {
        this.clickPage(1);
        this.pageGroup = 1;
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount);else this.clickPage(1);
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount);
      }
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    getMemberList: function getMemberList(index) {
      this.isLoading = true;
      var self = this;
      if (index) this.tableIndex = index;
      var data = {
        page: this.tableIndex,
        size: this.count,
        login_type: parseInt(this.loginType, 10),
        search: this.search.result
      };
      var searchSelect = parseInt(this.searchSelect, 10);
      var url = '/shopper/list' + '?page=' + data.page + '&size=' + data.size;
      if (searchSelect === 3 && data.search) url = url + '&nickname=' + data.search;else if (searchSelect === 2 && data.search) url = url + '&phone=' + data.search;else if (searchSelect === 4 && data.search) url = url + '&shopper_id=' + data.search;else if (searchSelect === 1 && data.search) url = url + '&email=' + data.search;else if (searchSelect === 5 && data.search) url = url + '&user_no=' + data.search;
      if (data.login_type !== 99) url = url + '&login_type=' + data.login_type;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.isLoading = false;
          self.memberList = response.data.shopper_list;
          self.total = response.data.total;
        }
      });
      this.$router.push({ query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$route.query, {
          login_type: parseInt(this.loginType, 10)
        }) });
    },
    getBrandMemberList: function getBrandMemberList(index) {
      this.isLoading = true;
      var self = this;
      if (index) this.tableIndex = index;
      var data = {
        page: this.tableIndex,
        size: this.count,
        search: this.search.result
      };
      var searchSelect = parseInt(this.searchSelect, 10);
      var url = '/brand/' + this.brandId + '/shopperList' + '?page=' + data.page + '&size=' + data.size;
      if (searchSelect === 5 && data.search) url = url + '&user_no=' + data.search;else if (searchSelect === 2 && data.search) url = url + '&phone=' + data.search;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.memberList = response.data.shopper_list;
          self.total = response.data.list_total;
          self.isLoading = false;
          self.hasExistingMember = response.data.has_existing_member;
        }
      });
    },
    getStoreMemberList: function getStoreMemberList(index) {
      this.isLoading = true;
      var self = this;
      if (index) this.tableIndex = index;
      var data = {
        page: this.tableIndex,
        size: this.count,
        search: this.search.result
      };
      var searchSelect = parseInt(this.searchSelect, 10);
      var url = '/store/' + this.storeId + '/shopperList' + '?page=' + data.page + '&size=' + data.size;
      if (searchSelect === 5 && data.search) url = url + '&user_no=' + data.search;else if (searchSelect === 2 && data.search) url = url + '&phone=' + data.search;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.memberList = response.data.shopper_list;
          self.total = response.data.list_total;
          self.isLoading = false;
        }
      });
    },
    getBrand: function getBrand() {
      var self = this;
      var url = 'brand/listBrief';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          if (response.data.list.length) {
            self.brandId = response.data.list[0].brand_id;
            if (self.roleType === 30) self.getBrandMemberList(1);else self.getStore();
          }
        }
      });
    },
    getStore: function getStore() {
      console.log('getStore | MemberTableTemp');
      var self = this;
      var url = '/brand/' + this.brandId + '/storeListBrief';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          if (response.data.list.length) {
            self.storeId = response.data.list[0].store_id;
            self.getStoreMemberList(1);
          }
        }
      });
    },
    clickSearch: function clickSearch() {
      if (this.roleType === 99) {
        this.getMemberList(1);
      } else if (this.roleType === 30 || this.roleType === 10) {
        this.getBrand(1);
      }
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    },
    getList: function getList(index) {
      if (this.roleType === 99) this.getMemberList(index);else if (this.roleType === 30) this.getBrandMemberList(index);else if (this.roleType === 10) this.getStoreMemberList(index);
    }
  },
  created: function created() {
    if (this.$route.name === 'brandTable') this.show.brand = true;else if (this.$route.name === 'menuTable') this.show.menu = true;else if (this.$route.name === 'scheduleTable') this.show.schedule = true;
    this.roleType = parseInt(this.getRoleType, 10);
    if (this.$route.query.login_type) this.loginType = parseInt(this.$route.query.login_type, 10);
    if (this.roleType === 99) this.getMemberList();else if (this.roleType === 30 || this.roleType === 10) {
      this.getBrand();
      this.searchSelect = 2;
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      if (Math.ceil(this.total / this.count) > 1000) {
        return 1000;
      } else {
        return Math.ceil(this.total / this.count);
      }
    }
  })
});

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default.a
  },
  data: function data() {
    return {
      roleType: 99,
      shopperMoney: {},
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      total: 1,
      count: 20,
      platformMoney: {},
      shopperMoneyList: [],
      sortToggle: false,
      sortMethod: '',
      preSortMethod: [],
      brandIds: '',
      storeIds: '',
      shopperInfo: {},

      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(1, 'days').format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      startLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD')
      }],
      endLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(1, 'days').add(1, 'days').format('YYYY-MM-DD')
      }],
      brandBrief: [],
      storeBrief: [],
      brandSelect: 0,
      storeSelect: 0,
      isLoading: true
    };
  },

  methods: {
    clickGroup: function clickGroup(type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1;
        this.tableIndex = this.groupAmount * this.pageGroup;
        this.clickPage(this.tableIndex);
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1;
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1;
        this.clickPage(this.tableIndex);
      }
    },
    clickEnd: function clickEnd(type) {
      if (type === 'pre') {
        this.clickPage(1);
        this.pageGroup = 1;
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount);else this.clickPage(1);
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount);
      }
    },
    getPercent: function getPercent(son, mom) {
      var p = son / mom;
      var result = Math.ceil(p * 10000) / 100;
      if (isNaN(result)) return 0;
      return result;
    },
    openModal: function openModal(shopper) {
      this.shopperInfo = shopper;
    },
    checkSort: function checkSort(method) {
      this.sortMethod = method;
      if (this.preSortMethod.length) {
        if (method === this.preSortMethod[0]) this.sortToggle = !this.sortToggle;else {
          this.tableIndex = 1;
          this.sortToggle = false;
        }
        this.preSortMethod.splice(0, 1);
      } else this.sortToggle = false;
      this.preSortMethod.push(method);
      this.getShopperMoney();
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.getShopperMoney();
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    },
    getShopperMoney: function getShopperMoney() {
      this.isLoading = true;
      var self = this;
      var data = {
        page: this.tableIndex,
        count: this.count,
        start_date: __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_date: __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      };
      var domain = '';
      if (this.roleType === 99) domain = 'shopperMoney?';else if (this.roleType === 30) domain = 'brandShopperMoney?brand_id=' + this.brandSelect + '&';else if (this.roleType === 10) domain = 'storeShopperMoney?store_id=' + this.storeSelect + '&';
      var url = 'statistic/' + domain + 'page=' + data.page + '&size=' + data.count + '&start_date=' + data.start_date + '&end_date=' + data.end_date;
      if (this.sortMethod) {
        url = url + '&list_sort=' + this.sortMethod + ' ';
        if (this.sortToggle) url = url + 'ASC';else url = url + 'DESC';
      }
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          if (self.roleType === 99) {
            self.total = response.data.shopper_statistic.shopper_money_list_total;
            self.platformMoney = response.data.shopper_statistic.platform_money;
            self.shopperMoneyList = response.data.shopper_statistic.shopper_money_list;
          } else if (self.roleType === 30) {
            self.total = response.data.brand_shopper_statistic.shopper_money_list_total;
            self.platformMoney = response.data.brand_shopper_statistic.brand_money;
            self.shopperMoneyList = response.data.brand_shopper_statistic.shopper_money_list;
          } else if (self.roleType === 10) {
            self.total = response.data.store_shopper_statistic.shopper_money_list_total;
            self.platformMoney = response.data.store_shopper_statistic.store_money;
            self.shopperMoneyList = response.data.store_shopper_statistic.shopper_money_list;
          }
          self.isLoading = false;
        }
      });
    },
    clickSearch: function clickSearch() {
      this.tableIndex = 1;
      this.pageGroup = 1;
      this.getShopperMoney();
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          var brandIds = '';
          for (var i = 0; i < bList.length; i++) {
            brandIds = brandIds + bList[i].brand_id + ',';
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            self.brandBrief.push(obj);
            if (i === 0) self.brandSelect = obj.value;
          }
          brandIds = brandIds.slice(0, -1);
          self.brandIds = brandIds;
          if (self.roleType === 30) self.getShopperMoney();else self.getStoreBrief(brandIds);
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      console.log('getStoreBrief | ShopperMoneyTableTemp');
      this.storeBrief = [];
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          var storeIds = '';
          for (var i = 0; i < sList.length; i++) {
            storeIds = storeIds + sList[i].store_id + ',';
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
            if (i === 0) self.storeSelect = obj.value;
          }
          storeIds = storeIds.slice(0, -1);
          self.storeIds = storeIds;
          self.getShopperMoney();
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  }),
  created: function created() {
    var date = new Date();
    var y = date.getFullYear();
    var m = date.getMonth();
    var firstDay = new Date(y, m, 1);
    this.menuTime.start.time = __WEBPACK_IMPORTED_MODULE_2_moment___default()(firstDay).format('YYYY-MM-DD');
    this.fixedH();
    var roleType = parseInt(this.getRoleType, 10);
    this.roleType = roleType;
    if (roleType === 30 || roleType === 10) this.getBrandBrief();else this.getShopperMoney();
  },

  watch: {
    'menuTime.end.time': function menuTimeEndTime() {
      var lastDay = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
      if (this.menuTime.start.time > lastDay) this.menuTime.start.time = lastDay;
      this.startLimit = [{
        type: 'fromto',
        to: lastDay
      }];
    },
    'menuTime.start.time': function menuTimeStartTime() {
      var lastDay = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.menuTime.start.time).add('31', 'days');
      if (lastDay < __WEBPACK_IMPORTED_MODULE_2_moment___default()()) this.menuTime.end.time = lastDay.format('YYYY-MM-DD');else this.menuTime.end.time = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD');
      this.endLimit = [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.menuTime.start.time).subtract(1, 'days'),
        to: __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.menuTime.end.time).add(1, 'days')
      }];
    }
  }
});

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_MemberFormTemp_vue__ = __webpack_require__(2193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_MemberFormTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_MemberFormTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      info: {
        name: '迷客夏',
        type: '飲料'
      }
    };
  },

  components: {
    'member-form': __WEBPACK_IMPORTED_MODULE_0__Temp_MemberFormTemp_vue___default.a
  },
  methods: {},
  computed: {
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  }
});

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      memberInfo: {},
      roleType: 99,
      integrateMemberList: [],

      count: 20,
      total: 0,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      stateType: 'avail',

      brandSelect: {
        label: '== 品牌 ==',
        vlaue: 0
      },
      storeSelect: {
        label: '== 門市 ==',
        vlaue: 0
      },
      brandBrief: [],
      storeBrief: []
    };
  },

  methods: {
    getList: function getList(index) {
      this.gteCouponSummary(index);
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.getList(index);
    },
    clickGroup: function clickGroup(type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1;
        this.tableIndex = this.groupAmount * this.pageGroup;
        this.clickPage(this.tableIndex);
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1;
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1;
        this.clickPage(this.tableIndex);
      }
    },
    clickEnd: function clickEnd(type) {
      if (type === 'pre') {
        this.clickPage(1);
        this.pageGroup = 1;
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount);else this.clickPage(1);
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount);
      }
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    },
    getSourceMethodName: function getSourceMethodName(method) {
      switch (method) {
        case 'order':
          return '訂單';
        case 'transfer':
          return '轉贈';
        case 'register':
          return '註冊';
        case 'other':
          return '其他';
      }
    },
    getDate: function getDate(datetime) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(datetime, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
    },
    getMemberById: function getMemberById() {
      var self = this;
      if (this.$route.params.user_id) {
        var url = '/shopper/' + this.$route.params.user_id;
        this.loginType = 99;
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.memberInfo = response.data.shopper_info;
            self.integrateMemberList = self.memberInfo.integrated_shopper_list;
            if (self.getRoleType === 99) self.getList(1);
          }
        });
      }
    },
    getBrandMemberById: function getBrandMemberById() {
      var self = this;
      if (this.$route.params.user_id) {
        var url = '/shopper/' + this.$route.params.user_id + '/basic';
        this.loginType = 99;
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.memberInfo = response.data.shopper_info;
          }
        });
      }
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      self.brandBrief = [{ label: '== 品牌 ==', vlaue: 0 }];
      var url = '/brand/listBrief?is_delete=0&is_opening=1&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            self.brandBrief.push(obj);
          }
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      console.log('getStoreBrief | UpgradeMemberInfo');
      var self = this;
      self.storeBrief = [{ label: '== 門市 ==', vlaue: 0 }];
      var url = '/brand/' + brandId + '/storeListBrief?status=2&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
          }
        }
      });
    },
    changeBrand: function changeBrand() {
      this.storeSelect = {
        value: 0,
        label: '== 門市 =='
      };
      if (this.brandSelect.value) this.getStoreBrief(this.brandSelect.value);
      this.getList(1);
    }
  },
  created: function created() {
    this.roleType = parseInt(this.getRoleType, 10);
    if (this.roleType === 99) this.getMemberById();else if (this.roleType === 30) this.getBrandMemberById();
    this.getBrandBrief();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  })
});

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_BindingTable_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_BindingTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Temp_BindingTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extends_nd_extend_handle_menu_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extends_nd_extend_handle_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__extends_nd_extend_handle_menu_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cr-binding',
  extends: __WEBPACK_IMPORTED_MODULE_3__extends_nd_extend_handle_menu_vue___default.a,
  components: {
    'binding-table': __WEBPACK_IMPORTED_MODULE_2__Temp_BindingTable_vue___default.a
  },
  data: function data() {
    return {
      storeName: '',
      menuState: 4,
      name: '迷客夏',
      total: 1,
      count: 20,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      scheduleList: [],
      bindList: [],
      elementList: [{ name: '', vendor_custom_id: '', remark: '' }, { name: '', vendor_custom_id: '', remark: '' }, { name: '', vendor_custom_id: '', remark: '' }, { name: '', vendor_custom_id: '', remark: '' }, { name: '', vendor_custom_id: '', remark: '' }],
      addElementList: [],
      addAmount: 5
    };
  },

  methods: {
    gotoOut: function gotoOut() {
      this.$router.go(-1);
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.getBindingList();
    },
    checkDoubleStore: function checkDoubleStore(storeIdList) {
      console.log(storeIdList);
      var newScheduleList = [];
      for (var key in storeIdList) {
        newScheduleList.push(storeIdList[key][0]);
      }
      console.log(newScheduleList);
      this.setGantt(newScheduleList);
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    },
    getBindingList: function getBindingList() {
      switch (this.tab) {
        case 2:
          this.bindList = this.optionList;
          break;
        case 20:
          this.bindList = this.adjustList;
          break;
        case 10:
          this.bindList = this.categoryList;
          break;
        case 1:
          this.bindList = this.productList;
          break;
        case 11:
          this.bindList = this.blockList;
          break;
        case 3:
          this.bindList = this.packageList;
          break;
      }
    },
    addElement: function addElement() {
      for (var i = 0; i < this.addAmount; i++) {
        this.elementList.push({ name: '', vendor_custom_id: '', remark: '' });
      }
    },
    randomString: function randomString() {
      var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz';
      var stringLength = Math.random() * (10 - 8) + 8;
      var randomString = '';
      for (var i = 0; i < stringLength; i++) {
        var rNum = Math.floor(Math.random() * chars.length);
        randomString += chars.substring(rNum, rNum + 1);
      }
      return randomString;
    },
    checkAddBinding: function checkAddBinding() {
      var self = this;
      var addList = [];
      this.elementList.find(function (o) {
        if (o.name) {
          if (!o.vendor_custom_id) {
            var random = self.randomString();
            o.vendor_custom_id = 'Nidin' + random;
            addList.push(o);
          } else addList.push(o);
        }
      });
      if (addList.length) {
        self.addElementList = addList;
        self.addBindingItem();
      } else {
        self.$notify({
          title: '提醒',
          text: '無任何' + self.tabName + '被新增',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      }
    },
    addBindingItem: function addBindingItem() {
      var _this = this;

      console.log('addBindingItem');
      var data = {
        list: this.addElementList,
        type: this.tab
      };
      var url = this.base + this.id + '/itemBinding';
      this.getDataH('post', url, data, function (res) {
        console.log(res.data);
        _this.$notify({
          title: '提醒',
          text: '已新增' + _this.tabName,
          duration: 3000,
          type: 'success',
          width: 400
        });

        if (_this.isStore && _this.getRoleType !== 10) {
          _this.$router.push({
            name: 'StoreMenuBindingPos',
            params: {
              brand_id: _this.$route.params.brand_id,
              store_id: _this.$route.params.store_id
            },
            query: {
              tab: _this.tab
            }
          });
        } else {
          _this.$router.push({
            name: 'BindingPos',
            params: {
              brand_id: _this.$route.params.brand_id
            },
            query: {
              tab: _this.tab
            }
          });
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    tab: function tab() {
      var name = this.$route.name;
      switch (name) {
        case 'crAdjusts':
        case 'StoreMenuAdjustCreate':
          return 20;
        case 'crBlocks':
        case 'StoreMenuBlockCreate':
          return 11;
        case 'crCategories':
        case 'StoreMenuCategoryCreate':
          return 10;
        case 'crOptions':
        case 'StoreMenuOptionCreate':
          return 2;
        case 'crPackages':
        case 'StoreMenuPackageCreate':
          return 3;
        case 'crProducts':
        case 'StoreMenuProductCreate':
          return 1;
      }
    },
    tabName: function tabName() {
      switch (this.tab) {
        case 2:
          return '配料';
        case 20:
          return '配料群組';
        case 10:
          return '商品分類';
        case 1:
          return '商品';
        case 11:
          return '品項選擇區';
        case 3:
          return '套餐';
      }
    },
    tabNamePlaceholder: function tabNamePlaceholder() {
      switch (this.tab) {
        case 2:
          return '配料名稱';
        case 20:
          return '配料群組名稱';
        case 10:
          return '商品分類名稱';
        case 1:
          return '商品名稱';
        case 11:
          return '品項選擇區名稱';
        case 3:
          return '套餐名稱';
      }
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  }),
  watch: {
    menuState: function menuState() {
      this.tableIndex = 1;
      this.pageGroup = 1;
      this.getBindingList();
    },
    tab: function tab() {
      this.getBindingList();
    }
  },
  created: function created() {
    this.getBindingList();
  },
  mounted: function mounted() {
    this.getExtendHandleMenuInfo();
  }
});

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_CrCombinationTemp_vue__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_CrCombinationTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_CrCombinationTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  components: {
    'cr-combine': __WEBPACK_IMPORTED_MODULE_0__Temp_CrCombinationTemp_vue___default.a
  },
  methods: {}
});

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_timepicker__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);










/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      img: {
        width: 0,
        height: 0
      },
      iconList: [],
      iconInfo: {
        name: '',
        image_file: '',
        sort: 1,
        is_visible: 1,
        description: ''
      },
      storeInfo: {},

      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: ''
        }
      },
      startTime: {
        time: ''
      },
      endtime: {
        time: ''
      },
      delIconOption: {
        id: 'delIconModal',
        title: '刪除菜單圖示',
        body: '確定刪除菜單圖示？',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delIcon'
        }]
      }
    };
  },

  methods: {
    trigger: function trigger(event) {
      if (event === 'delIcon') {
        this.delIcon();
      }
    },
    delIcon: function delIcon() {
      var self = this;
      var url = 'store/' + this.$route.params.store_id + '/productIcon/' + this.$route.params.icon_id;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: '圖片刪除成功',
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.replace({ path: self.returnPage });
        }
      });
    },
    init: function init() {
      if (this.$route.name === 'upProductIcon') this.getProductIconList();
    },
    veritySort: function veritySort() {
      var e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.sort);
      this.iconInfo.sort = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    getProductIconList: function getProductIconList() {
      var self = this;

      var url = 'store/' + this.$route.params.store_id + '/productIconList';
      this.getDataH('get', url, null, function (response) {
        self.iconList = response.data.list;
        self.iconInfo = self.iconList.find(function (iconObj) {
          return iconObj.icon_id === parseInt(self.$route.params.icon_id, 10);
        });
        console.log(self.iconInfo.url);
        self.$set(self.iconInfo, 'image_file', self.iconInfo.url);
      });
    },
    onFileChange: function onFileChange(e) {
      this.imgLogoSelect = '';
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var imgName = files[0].name.split('.');
      var imgSize = Math.round(files[0].size / 1000);
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (imgSize > 512) {
        this.$notify({
          title: '提醒',
          text: '圖片檔案為' + imgSize + 'KB，請上傳小於512KB之圖片',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.createImage(files[0]);
      }
    },
    createImage: function createImage(file) {
      var reader = new FileReader();
      var self = this;
      reader.onload = function (e) {
        var img = new Image();
        img.src = e.target.result;
        self.iconInfo.image_file = img.src;
        img.onload = function () {
          self.img.width = img.width;
          self.img.height = img.height;
          self.checkImgSize();
        };
      };
      reader.readAsDataURL(file);
    },
    checkImgSize: function checkImgSize(type) {
      var self = this;
      if ((this.img.width > 200 || this.img.height > 200) && this.img.width !== 0 && this.img.height !== 0) {
        this.$notify({
          title: '提醒',
          text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳200x200以下之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      }
    },
    checkBeforeSend: function checkBeforeSend(type) {
      var all = this.getInput;
      var msg = '';
      if (!all.name) {
        msg = '請輸入圖示名稱';
      } else if (!all.sort) {
        msg = '請輸入排序';
      } else if (!__WEBPACK_IMPORTED_MODULE_2_jquery___default()('#brand-img-load')[0].files[0] && type === 'cr') {
        msg = '請上傳一張圖片';
      }
      this.getToast(msg, type);
    },
    getToast: function getToast(msg, type) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        if (type === 'cr') this.createdIcon();else if (type === 'up') this.updatedIcon();
      }
    },
    createdIcon: function createdIcon() {
      var self = this;
      var data = new FormData();
      var info = this.getInput;
      var name = info.name;
      var description = info.description;
      var picUrl = info.url;
      var sort = parseInt(info.sort, 10);
      if (!picUrl) picUrl = ' ';
      data.append('name', name);
      data.append('sort', sort);
      data.append('is_visible', this.iconInfo.is_visible);
      if (description) data.append('description', description);

      data.append('image_file', __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#brand-img-load')[0].files[0]);
      var url = 'store/' + this.$route.params.store_id + '/newProductIcon';
      if (data) {
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            });
            self.$router.replace({ path: self.returnPage });
          }
        });
      }
    },
    updatedIcon: function updatedIcon() {
      var self = this;
      var data = new FormData();
      var info = this.getInput;
      var name = info.name;
      var description = info.description;
      var picUrl = info.url;
      var sort = parseInt(info.sort, 10);
      if (!picUrl) picUrl = ' ';
      data.append('name', name);
      data.append('sort', sort);
      data.append('is_visible', this.iconInfo.is_visible);
      if (description) data.append('description', description);

      if (__WEBPACK_IMPORTED_MODULE_2_jquery___default()('#brand-img-load')[0].files[0]) {
        data.append('image_file', __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#brand-img-load')[0].files[0]);
      }
      var url = 'store/' + this.$route.params.store_id + '/productIcon/' + this.$route.params.icon_id;
      if (data) {
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            });
            self.$router.replace({ path: self.returnPage });
          }
        });
      }
    }
  },
  created: function created() {
    this.init();
  },

  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_3_vue_datepicker_vue_datepicker_es6_vue___default.a,
    VueTimepicker: __WEBPACK_IMPORTED_MODULE_4_vue2_timepicker___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['getRoleType']), {
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    },
    getInput: function getInput() {
      var aInfo = this.iconInfo;
      for (var key in aInfo) {
        if (!aInfo[key] && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(aInfo[key]) === 'object') aInfo[key] = ' ';
      }
      return {
        name: this.checkInput(aInfo.name.toString()),
        sort: this.checkInput(aInfo.sort.toString()),
        description: this.checkInput(aInfo.description.toString())
      };
    },
    returnPage: function returnPage() {
      return '/storeTable/productImage/' + this.$route.params.brand_id + '/' + this.$route.params.store_id + '?tab=99';
    }
  })
});

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Temp_BindingTable__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Temp_BindingTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Temp_BindingTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Temp_ImgUpdateTemp__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Temp_ImgUpdateTemp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Temp_ImgUpdateTemp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Temp_ImgUpdateDropTemp__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Temp_ImgUpdateDropTemp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Temp_ImgUpdateDropTemp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_elements_ChooseProductModal_vue__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_elements_ChooseProductModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_elements_ChooseProductModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(3);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'choose-product-modal': __WEBPACK_IMPORTED_MODULE_7__components_elements_ChooseProductModal_vue___default.a,
    'binding-table': __WEBPACK_IMPORTED_MODULE_4__Temp_BindingTable___default.a,
    'img-update': __WEBPACK_IMPORTED_MODULE_5__Temp_ImgUpdateTemp___default.a,
    'img-up-drop': __WEBPACK_IMPORTED_MODULE_6__Temp_ImgUpdateDropTemp___default.a
  },
  data: function data() {
    return {
      brandName: '',
      storeName: '',
      menuState: 4,
      total: 1,
      count: 2,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      scheduleList: [],
      bindList: [],
      elementList: [{ name: '', img_url: '', sort: '', description: '', file: '', isloading: false }, { name: '', img_url: '', sort: '', description: '', file: '', isloading: false }, { name: '', img_url: '', sort: '', description: '', file: '', isloading: false }, { name: '', img_url: '', sort: '', description: '', file: '', isloading: false }, { name: '', img_url: '', sort: '', description: '', file: '', isloading: false }],
      is_enabled: { label: '啟用', value: 1 },
      product_name: '',
      vendor_custom_id: '',
      switchType: 'choose',
      product: {
        input: {
          item: {
            name: '',
            id: ''
          },
          isItemCanCreate: false
        },
        choose: {
          item: {},
          isItemCanCreate: false
        }
      },
      optionsList: [],
      addElementList: [],
      addAmount: 5,
      settingId: '',
      type: 1,
      currentId: '',
      smImgSrc: '',
      up: false,

      enableOption: [{ label: '啟用', value: 1 }, { label: '停用', value: 0 }],
      delOption: {
        id: 'delModal',
        title: '刪除大圖',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delBigImg'
        }]
      },
      delSmImgOption: {
        id: 'delSmModal',
        title: '刪除小圖',
        body: '確定刪除小圖？',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delSmImg'
        }]
      },
      imgList: {
        smImgList: [],
        lgImgList: []
      }
    };
  },

  methods: {
    checkVenderId: function checkVenderId() {
      var _this = this;

      var id = this.product[this.switchType].item.id;
      if (id !== '') {
        var url = 'store/' + this.$route.params.store_id + '/productImageSetting/list?size=1' + '&type=' + this.tab + '&page=1' + '&vendor_custom_id_full=' + id;
        this.getDataH('get', url, null, function (response) {
          _this.product[_this.switchType].isItemCanCreate = response.data.list.length <= 0;
        });
      } else {
        this.product[this.switchType].isItemCanCreate = false;
      }
    },
    checkLoading: function checkLoading(index, isloading) {
      this.elementList[index].isloading = isloading;
    },
    trigger: function trigger(event) {
      if (event === 'delBigImg') {
        this.delBigImg();
      } else if (event === 'delSmImg') {
        this.delSmImg();
      }
    },
    clickCurrent: function clickCurrent(itemId, index) {
      this.currentId = itemId;
      this.delOption.body = '是否刪除第' + (index + 1) + '張大圖？';
    },
    delSmImg: function delSmImg() {
      var self = this;
      var url = 'store/' + this.$route.params.store_id + '/productImageSetting/' + this.$route.params.setting_id;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: '圖片刪除成功',
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.push({ path: self.returnPage });
        }
      });
    },
    delBigImg: function delBigImg(index) {
      var self = this;
      var url = 'store/' + this.$route.params.store_id + '/productImageSetting/' + this.$route.params.setting_id + '/sub/' + this.currentId;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.currentId = '';
          self.$notify({
            title: '成功',
            text: '圖片刪除成功',
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.elementList = [{ name: '', img_url: '', sort: '', description: '', isloading: false }, { name: '', img_url: '', sort: '', description: '', isloading: false }, { name: '', img_url: '', sort: '', description: '', isloading: false }, { name: '', img_url: '', sort: '', description: '', isloading: false }, { name: '', img_url: '', sort: '', description: '', isloading: false }];

          self.getImgSetting();
        }
      });
    },
    checkImg: function checkImg() {
      var msg = '';
      if (!this.product[this.switchType].item.id) {
        msg = '請輸入商品料號';
      }

      if (!this.product[this.switchType].item.name && !this.up) {
        msg = '請輸入商品名稱';
      }

      if (!this.imgList.smImgList.length && !this.elementList.length && !this.smImgSrc && !this.up) {
        msg = '請上傳小圖或大圖';
      }

      for (var i = 0; i < this.elementList.length; i++) {
        if (this.elementList[i].sort === '' && this.elementList[i].isloading) {
          msg = '請輸入第' + (i + 1) + '個大圖的順序';
          break;
        }
        if (this.elementList[i].sort !== '' && !this.elementList[i].isloading) {
          msg = '請上傳第' + (i + 1) + '個大圖';
        }
      }
      this.getToast(msg);
    },
    getToast: function getToast(msg) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        if (this.$route.name.indexOf('ProductImg') > -1) this.crSmallImg(1);else if (this.$route.name.indexOf('PackageImg') > -1) this.crSmallImg(3);else if (this.$route.name.indexOf('CategoryImg') > -1) this.crSmallImg(10);
        console.log(this.$route.name.indexOf('CategoryImg') > -1);
      }
    },
    crSmallImg: function crSmallImg(prodType) {
      var self = this;
      var url = 'store/' + this.$route.params.store_id + '/productImageSetting';
      if (this.up) url = url + '/' + this.$route.params.setting_id;
      var data = new FormData();

      data.append('type', prodType);
      data.append('vendor_custom_id', this.product[this.switchType].item.id);
      data.append('is_enabled', 1);
      data.append('src_id_type', 1);
      data.append('product_name', this.product[this.switchType].item.name);
      if (this.imgList.smImgList.length) data.append('image', this.imgList.smImgList[0].file);else if (__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#file-upload-99-1')[0]) {
        if (__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#file-upload-99-1')[0].files[0]) data.append('image', __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#file-upload-99-1')[0].files[0]);
      }
      if (this.up) data.append('is_enabled', this.is_enabled.value);
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          if (self.up) self.settingId = self.$route.params.setting_id;else self.settingId = response.data.setting_id;
          if (self.settingId || self.up) self.checkBigImg();
        }
      });
    },
    checkBigImg: function checkBigImg() {
      var self = this;
      var text = '圖片新增成功';
      if (this.elementList.length) {
        for (var i = 0; i < this.elementList.length; i++) {
          if (this.elementList[i].sort) {
            this.crBigImg(i, this.elementList[i]);
          } else if (self.elementList.length - 1 === i) {
            if (this.up) text = '圖片更新成功';
            self.$notify({
              title: '成功',
              text: text,
              duration: 3000,
              type: 'success',
              width: 400
            });
            self.$router.go(-1);
          }
        }
      } else {
        if (this.up) text = '圖片更新成功';
        self.$notify({
          title: '成功',
          text: text,
          duration: 3000,
          type: 'success',
          width: 400
        });
        self.$router.push({ path: self.returnPage });
      }
    },
    crBigImg: function crBigImg(index, img) {
      var self = this;
      var url = 'store/' + this.$route.params.store_id + '/productImageSetting/' + this.settingId + '/sub';
      if (img.id) url = url + '/' + img.id;
      var data = new FormData();

      var element = this.elementList[index];
      data.append('description', element.description);
      data.append('sort', element.sort);
      if (this.elementList[index].file) data.append('image', this.elementList[index].file);else if (__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#file-upload-' + index + '-2')[0]) {
        if (__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#file-upload-' + index + '-2')[0].files[0]) data.append('image', __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#file-upload-' + index + '-2')[0].files[0]);
      }
      this.getDataH('post', url, data, function (response) {
        console.log(response.data);
        if (response.data.status === 200) {
          if (self.elementList.length - 1 === index) {
            var text = '圖片新增成功';
            if (self.up) text = '圖片更新成功';
            self.$notify({
              title: '成功',
              text: text,
              duration: 3000,
              type: 'success',
              width: 400
            });
            console.log(2, self.tab);
            self.$router.push({ path: self.returnPage });
          }
        }
      });
    },
    getImgSetting: function getImgSetting() {
      var _this2 = this;

      var url = 'store/' + this.$route.params.store_id + '/productImageSetting/' + this.$route.params.setting_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var res = response.data.setting;
          _this2.product['input'].item.name = res.product_name || '';
          _this2.product['input'].item.id = res.vendor_custom_id;

          var sameOption = _this2.optionsList.find(function (item) {
            return item.id === res.vendor_custom_id && item.name === res.product_name;
          });
          if (sameOption) {
            _this2.$nextTick(function () {
              _this2.product['choose'].item = {
                id: res.vendor_custom_id,
                name: res.product_name
              };
            });
          } else {
            _this2.switchType = 'input';
          }

          _this2.is_enabled = _this2.enableOption.find(function (item) {
            return item.value === res.is_enabled;
          });
          _this2.elementList = [{ name: '', img_url: '', sort: '', description: '', isloading: false }, { name: '', img_url: '', sort: '', description: '', isloading: false }, { name: '', img_url: '', sort: '', description: '', isloading: false }, { name: '', img_url: '', sort: '', description: '', isloading: false }, { name: '', img_url: '', sort: '', description: '', isloading: false }];
          res.sub_image_list.forEach(function (o, index) {
            _this2.elementList[index] = o;
            if (_this2.elementList[index].img_url) {
              _this2.elementList[index].isloading = true;
            } else {
              _this2.elementList[index].isloading = false;
            }
          });
          _this2.smImgSrc = res.main_image.img_url;
          _this2.is_enabled = _this2.enableList.find(function (o) {
            if (o.label === res.is_enabled) return o;
          });
        }
      });
    },
    getMenuId: function getMenuId() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = 'onlineMenu/list?page=1&size=1&store_id=' + _this3.$route.params.store_id;
                _context.next = 3;
                return _this3.getDataH('get', url, null, function (response) {
                  if (response.data.status === 200) {
                    var result = response.data.menu_list ? response.data.menu_list[0] ? response.data.menu_list[0].id : null : null;
                    if (result) {
                      _this3.getProductInfoList(result);
                    } else {
                      _this3.setUpAdd();
                    }
                  }
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    getProductInfoList: function getProductInfoList(menuId) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                url = 'onlineMenu/' + menuId + '/productBrief';
                _context2.next = 3;
                return _this4.getDataH('get', url, null, function (response) {
                  if (response.data.status === 200) {
                    _this4.optionsList = [];
                    var menu = response.data.brief;
                    menu.category_list.forEach(function (category) {
                      if (_this4.tab === 10) {
                        var data = {
                          name: category.name,
                          id: category.vendor_custom_id
                        };
                        _this4.optionsList.push(data);
                      } else {
                        category.child_list.forEach(function (prod) {
                          if (prod.type === _this4.tab) {
                            var _data = {
                              name: prod.name,
                              id: prod.vendor_custom_id
                            };
                            _this4.optionsList.push(_data);
                          }
                        });
                      }
                    });
                  }
                });

              case 3:
                _this4.setUpAdd();

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    setUpAdd: function setUpAdd() {
      if (this.$route.name.indexOf('up') > -1) {
        this.up = true;
        this.getImgSetting();
      } else {
        this.elementList = [];
      }
    },
    getStoreInfo: function getStoreInfo() {
      var _this5 = this;

      var url = '/store/' + this.$route.params.store_id + '/info';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var storeInfo = response.data.info;
          _this5.brandName = storeInfo.brand_name;
          _this5.storeName = storeInfo.name;
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapGetters */])(['getRoleType']), {
    tab: function tab() {
      var rName = this.$route.name;
      switch (rName) {
        case 'crProductImg':
        case 'upProductImg':
          return 1;
        case 'crPackageImg':
        case 'upPackageImg':
          return 3;
        case 'crCategoryImg':
        case 'upCategoryImg':
          return 10;
      }
    },
    tabName: function tabName() {
      switch (this.tab) {
        case 2:
          return '配料';
        case 20:
          return '配料群組';
        case 10:
          return '商品分類';
        case 1:
          return '商品';
        case 11:
          return '品項選擇區';
        case 3:
          return '套餐';
      }
    },
    tabNamePlaceholder: function tabNamePlaceholder() {
      switch (this.tab) {
        case 2:
          return '配料名稱';
        case 20:
          return '配料群組名稱';
        case 10:
          return '商品分類名稱';
        case 1:
          return '商品名稱';
        case 11:
          return '品項選擇區名稱';
        case 3:
          return '套餐名稱';
      }
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    },
    returnPage: function returnPage() {
      return '/storeTable/productImage/' + this.$route.params.brand_id + '/' + this.$route.params.store_id + '?tab=' + this.tab;
    }
  }),
  watch: {
    menuState: function menuState() {
      this.tableIndex = 1;
      this.pageGroup = 1;
    },
    tab: function tab() {},
    'imgList.lgImgList': function imgListLgImgList() {
      var self = this;
      if (this.$route.name.indexOf('up') === -1) {
        this.elementList = [];
      }
      this.imgList.lgImgList.forEach(function (lgImg, index) {
        var o = { name: lgImg.name, img_url: lgImg.src, sort: index + 1, description: '', file: lgImg.file, isloading: true };
        self.elementList.push(o);
      });
    }
  },
  created: function created() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this6.getMenuId();

            case 2:
              if (!_this6.$route.query.brand_name || !_this6.$route.query.store_name) {
                _this6.getStoreInfo();
              } else {
                _this6.brandName = _this6.$route.query.brand_name;
                _this6.storeName = _this6.$route.query.store_name;
              }

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this6);
    }))();
  }
});

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_CrJoinMenuTemp_vue__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_CrJoinMenuTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_CrJoinMenuTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  components: {
    'cr-join-menu': __WEBPACK_IMPORTED_MODULE_0__Temp_CrJoinMenuTemp_vue___default.a
  },
  methods: {}
});

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_MenuInfoFormTemp_vue__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_MenuInfoFormTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Temp_MenuInfoFormTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extends_nd_extend_handle_menu_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extends_nd_extend_handle_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__extends_nd_extend_handle_menu_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CrMenu',
  extends: __WEBPACK_IMPORTED_MODULE_3__extends_nd_extend_handle_menu_vue___default.a,
  components: {
    'menu-info-form': __WEBPACK_IMPORTED_MODULE_2__Temp_MenuInfoFormTemp_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    }
  }),
  mounted: function mounted() {
    this.getExtendHandleMenuInfo();
  }
});

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_CrOptionTemp_vue__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_CrOptionTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_CrOptionTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  components: {
    'cr-option': __WEBPACK_IMPORTED_MODULE_0__Temp_CrOptionTemp_vue___default.a
  },
  methods: {}
});

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_CrProductTemp_vue__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_CrProductTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_CrProductTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  components: {
    'cr-product': __WEBPACK_IMPORTED_MODULE_0__Temp_CrProductTemp_vue___default.a
  },
  methods: {}
});

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Temp_BindingTable__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Temp_BindingTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Temp_BindingTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Temp_ImgUpdateTemp__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Temp_ImgUpdateTemp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Temp_ImgUpdateTemp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Temp_ImgUpdateDropTemp__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Temp_ImgUpdateDropTemp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Temp_ImgUpdateDropTemp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_elements_ChooseProductModal_vue__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_elements_ChooseProductModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_elements_ChooseProductModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(3);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CrProductSetting',
  components: {
    'choose-product-modal': __WEBPACK_IMPORTED_MODULE_7__components_elements_ChooseProductModal_vue___default.a,
    'binding-table': __WEBPACK_IMPORTED_MODULE_4__Temp_BindingTable___default.a,
    'img-update': __WEBPACK_IMPORTED_MODULE_5__Temp_ImgUpdateTemp___default.a,
    'img-up-drop': __WEBPACK_IMPORTED_MODULE_6__Temp_ImgUpdateDropTemp___default.a
  },
  data: function data() {
    return {
      prod_list: [],
      emptyProd: {
        type: 'choose',
        input: {
          item: {
            name: '',
            id: ''
          },
          discriptionSettingId: 0,
          aliasSettingId: 0
        },
        choose: {
          item: {},
          discriptionSettingId: 0,
          aliasSettingId: 0
        },
        alias_name: '',
        prod_description_list: [{ prod_description: '' }],
        prod_warning_list: [{ prod_warning: '' }]
      },
      optionsList: [],
      brandName: '',
      storeName: '',
      menuState: 4,
      name: '迷客夏',
      total: 1,
      count: 20,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      scheduleList: [],
      bindList: [],
      is_enabled: 1,
      vendor_custom_id: '',
      product_name: '',
      alias_name: '',
      prod_description: '',
      prod_description_list: [{ prod_description: '' }],
      prod_warning_list: [{ prod_warning: '' }],
      addAmount: 5,
      settingId: '',
      type: 1,
      currentId: '',
      smImgSrc: '',
      up: false,
      add_prod: false,
      enableOption: [{ label: '啟用', value: 1 }, { label: '關閉', value: 0 }],
      delOption: {
        id: 'delModal',
        title: '刪除描述/別名/警語',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delProductSetting'
        }]
      }
    };
  },

  methods: {
    checkVenderId: function checkVenderId(prod) {
      var id = prod[prod.type].item.id;
      if (id !== '') {
        var durl = 'store/' + this.$route.params.store_id + '/productDescriptionSetting/list?size=1' + '&type=' + this.tab + '&page=1' + '&vendor_custom_id_full=' + id;
        this.getDataH('get', durl, null, function (response) {
          var list = response.data.list;
          var prodDescriptionList = [];
          var prodWarningList = [];
          prod[prod.type].discriptionSettingId = list.length ? list[0].id : 0;
          if (list.length) {
            list[0].item_list.forEach(function (item) {
              if (item.type === 1) {
                prodDescriptionList.push({ prod_description: item.description });
              } else if (item.type === 2) {
                prodWarningList.push({ prod_warning: item.description });
              }
            });
          }
          prod.prod_description_list = prodDescriptionList.length ? prodDescriptionList : [{ prod_description: '' }];
          prod.prod_warning_list = prodWarningList.length ? prodWarningList : [{ prod_warning: '' }];
        });

        var aurl = 'store/' + this.$route.params.store_id + '/productAliasSetting/list?size=1' + '&type=' + this.tab + '&page=1' + '&vendor_custom_id_full=' + id;
        this.getDataH('get', aurl, null, function (response) {
          if (response.data.list.length) {
            prod[prod.type].aliasSettingId = response.data.list[0].id;
            prod.alias_name = response.data.list[0].item_list[0].name;
          }
        });
      } else {
        prod[prod.type].discriptionSettingId = 0;
        prod[prod.type].aliasSettingId = 0;
        prod.alias_name = '';
        prod.prod_description_list = [{ prod_description: '' }];
        prod.prod_warning_list = [{ prod_warning: '' }];
      }
    },
    trigger: function trigger(event) {
      if (event === 'delProductSetting') {
        if (this.$route.name === 'upProductAlias') this.delProductAlias();
        if (this.$route.name === 'upProductDescription') this.delProductDescription();
      }
    },
    checkSetting: function checkSetting() {
      var _this = this;

      var msg = '';
      var arr = this.prod_list;
      var idList = arr.map(function (item) {
        return item[item.type].item.id;
      });
      var repeatIds = idList.filter(function (id, index) {
        return idList.indexOf(id) !== index;
      });
      if (repeatIds.length) {
        msg = '\u5546\u54C1\u6599\u865F' + repeatIds.join('、') + '\u5DF2\u91CD\u8907';
      } else {
        arr.every(function (item, i) {
          if (!item[item.type].item.id) {
            msg = (_this.add_prod ? '\u7B2C' + (i + 1) + '\u500B\u5546\u54C1' : '') + '請輸入商品料號';
            return;
          } else if (!item[item.type].item.name && _this.add_prod) {
            msg = (_this.add_prod ? '\u7B2C' + (i + 1) + '\u500B\u5546\u54C1' : '') + '請輸入商品名稱';
            return;
          } else if (!item.alias_name && !(item.prod_description_list[0].prod_description || item.prod_warning_list[0].prod_warning) && !_this.up) {
            msg = (_this.add_prod ? '\u7B2C' + (i + 1) + '\u500B\u5546\u54C1' : '') + '請輸入商品別名或描述或警語';
            return;
          } else if (_this.$route.name === 'upProductAlias' && !item.alias_name) {
            msg = (_this.add_prod ? '\u7B2C' + (i + 1) + '\u500B\u5546\u54C1' : '') + '商品請輸入商品別名';
            return;
          } else if (_this.add_prod && item[item.type].aliasSettingId && !item.alias_name) {
            msg = (_this.add_prod ? '\u7B2C' + (i + 1) + '\u500B\u5546\u54C1' : '') + '商品請輸入商品別名，若需刪除請至編輯。';
            return;
          } else if (_this.add_prod && item[item.type].discriptionSettingId && !item.prod_description_list.length && !item.prod_warning_list.length) {
            msg = (_this.add_prod ? '\u7B2C' + (i + 1) + '\u500B\u5546\u54C1' : '') + '商品請輸入商品描述或警語，若需刪除請至編輯。';
            return;
          }
        });
      }
      this.getToast(msg);
    },
    getToast: function getToast(msg) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        if (this.$route.name === 'crProductSetting') {
          if (this.add_prod) this.add_multi_prod();else {
            if (this.alias_name) this.crProductAlias();else if (this.prod_description_list[0].prod_description || this.prod_warning_list[0].prod_warning) this.crProductDescription();
          }
        } else if (this.$route.name === 'upProductAlias') this.upProductAlias();else if (this.$route.name === 'upProductDescription') this.upProductDescription();
      }
    },
    add_multi_prod: function add_multi_prod() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var arr;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                arr = _this2.prod_list;
                _context2.next = 3;
                return arr.reduce(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(i, item) {
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _this2.vendor_custom_id = item[item.type].item.id;
                            _this2.product_name = item[item.type].item.name;
                            _this2.alias_name = item.alias_name;

                            if (_this2.alias_name !== '') {
                              item[item.type].aliasSettingId ? _this2.upProductAlias(item, item[item.type].aliasSettingId) : _this2.crProductAlias();
                            }
                            if (item.prod_description_list[0].prod_description || item.prod_warning_list[0].prod_warning) {
                              _this2.prod_description_list = item.prod_description_list;
                              _this2.prod_warning_list = item.prod_warning_list;
                              item[item.type].discriptionSettingId ? _this2.upProductDescription(item, item[item.type].discriptionSettingId) : _this2.crProductDescription();
                            }

                          case 5:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this2);
                  }));

                  return function (_x, _x2) {
                    return _ref.apply(this, arguments);
                  };
                }(), undefined);

              case 3:
                _this2.goProductSetting();

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    delProductDescription: function delProductDescription() {
      var self = this;
      var url = 'store/' + this.$route.params.store_id + '/productDescriptionSetting/' + this.$route.params.setting_id;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.goProductSetting();
        }
      });
    },
    delProductAlias: function delProductAlias() {
      var self = this;
      var url = 'store/' + this.$route.params.store_id + '/productAliasSetting/' + this.$route.params.setting_id;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.goProductSetting();
        }
      });
    },
    upProductDescription: function upProductDescription() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var self = this;
      var items = [];
      var warningItems = [];
      var settingId = id || this.$route.params.setting_id;
      var url = 'store/' + this.$route.params.store_id + '/productDescriptionSetting/' + settingId;
      var prod = item || this.prod_list[0];
      prod.prod_description_list.forEach(function (item, i) {
        if (item.prod_description) items.push(item.prod_description);
      });
      prod.prod_warning_list.forEach(function (item) {
        if (item.prod_warning) warningItems.push(item.prod_warning);
      });
      var data = {
        vendor_custom_id: prod[prod.type].item.id,
        product_name: prod[prod.type].item.name,
        is_enabled: prod.is_enabled,
        item_list: items,
        warning_list: warningItems,
        src_id_type: 1,
        type: this.tab
      };
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.goProductSetting();
        }
      });
    },
    upProductAlias: function upProductAlias() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var self = this;
      var prod = item || this.prod_list[0];
      var settingId = id || this.$route.params.setting_id;
      var items = [prod.alias_name];
      var url = 'store/' + this.$route.params.store_id + '/productAliasSetting/' + settingId;
      var data = {
        vendor_custom_id: prod[prod.type].item.id,
        product_name: prod[prod.type].item.name,
        is_enabled: prod.is_enabled,
        item_list: items,
        src_id_type: 1,
        type: this.tab
      };
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.goProductSetting();
        }
      });
    },
    crProductDescription: function crProductDescription() {
      var self = this;
      var url = 'store/' + this.$route.params.store_id + '/productDescriptionSetting';
      var items = [];
      var warningItem = [];
      this.prod_description_list.forEach(function (item, i) {
        if (item.prod_description) items.push(item.prod_description);
      });
      this.prod_warning_list.forEach(function (item, i) {
        if (item.prod_warning) warningItem.push(item.prod_warning);
      });
      var data = {
        type: this.tab,
        src_id_type: 1,
        vendor_custom_id: this.vendor_custom_id,
        product_name: this.product_name,
        item_list: items,
        warning_list: warningItem
      };
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          if (!this.add_multi_prod) self.goProductSetting();
        }
      });
    },
    crProductAlias: function crProductAlias() {
      var self = this;
      var url = 'store/' + this.$route.params.store_id + '/productAliasSetting';
      var items = [this.alias_name];
      var data = {
        type: this.tab,
        src_id_type: 1,
        vendor_custom_id: this.vendor_custom_id,
        product_name: this.product_name,
        item_list: items
      };
      self.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          if (!self.prod_description_list[0].prod_description) {
            self.$notify({
              title: '成功',
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            });
          }
        }
      });
    },
    getProductDescription: function getProductDescription() {
      var _this3 = this;

      var url = 'store/' + this.$route.params.store_id + '/productDescriptionSetting/' + this.$route.params.setting_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var setting = response.data.setting;
          var prod = _this3.prod_list[0];
          prod.is_enabled = _this3.is_enabled;
          prod['input'].item.id = setting.vendor_custom_id;
          prod['input'].item.name = setting.product_name;

          setting.item_list.forEach(function (item) {
            if (item.description) {
              if (item.type === 1) {
                if (prod.prod_description_list[0].prod_description) {
                  prod.prod_description_list.push({ prod_description: item.description });
                } else {
                  prod.prod_description_list[0].prod_description = item.description;
                }
              } else if (item.type === 2) {
                if (prod.prod_warning_list[0].prod_warning) {
                  prod.prod_warning_list.push({ prod_warning: item.description });
                } else {
                  prod.prod_warning_list[0].prod_warning = item.description;
                }
              }
            }
          });

          var sameOption = _this3.optionsList.find(function (item) {
            return item.id === setting.vendor_custom_id && item.name === setting.product_name;
          });
          if (sameOption) {
            _this3.$nextTick(function () {
              prod['choose'].item = {
                id: setting.vendor_custom_id,
                name: setting.product_name
              };
            });
          } else {
            prod['type'] = 'input';
          }
        }
      });
    },
    getProductAlias: function getProductAlias() {
      var _this4 = this;

      var url = 'store/' + this.$route.params.store_id + '/productAliasSetting/' + this.$route.params.setting_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var setting = response.data.setting;
          var prod = _this4.prod_list[0];
          prod.alias_name = setting.item_list[0].name;
          prod.is_enabled = _this4.is_enabled;
          prod['input'].item.id = setting.vendor_custom_id;
          prod['input'].item.name = setting.product_name;

          var sameOption = _this4.optionsList.find(function (item) {
            return item.id === setting.vendor_custom_id && item.name === setting.product_name;
          });
          if (sameOption) {
            _this4.$nextTick(function () {
              prod['choose'].item = {
                id: setting.vendor_custom_id,
                name: setting.product_name
              };
            });
          } else {
            prod['type'] = 'input';
          }
        }
      });
    },
    goProductSetting: function goProductSetting() {
      this.$router.push({ path: '/storeTable/productSetting/' + this.$route.params.brand_id + '/' + this.$route.params.store_id, query: this.$route.query });
    },
    getMenuId: function getMenuId() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                url = 'onlineMenu/list?page=1&size=1&store_id=' + _this5.$route.params.store_id;
                _context3.next = 3;
                return _this5.getDataH('get', url, null, function (response) {
                  if (response.data.status === 200) {
                    var result = response.data.menu_list ? response.data.menu_list[0] ? response.data.menu_list[0].id : null : null;
                    if (result) {
                      _this5.getProductInfoList(result);
                    } else {
                      _this5.setUpAdd();
                    }
                  }
                });

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    getProductInfoList: function getProductInfoList(menuId) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                url = 'onlineMenu/' + menuId + '/productBrief';
                _context4.next = 3;
                return _this6.getDataH('get', url, null, function (response) {
                  if (response.data.status === 200) {
                    _this6.optionsList = [];
                    var menu = response.data.brief;
                    menu.category_list.forEach(function (category) {
                      if (_this6.tab === 10 && _this6.optionsList.findIndex(function (x) {
                        return x.id === category.vendor_custom_id;
                      }) < 0) {
                        var data = {
                          name: category.name,
                          id: category.vendor_custom_id
                        };
                        _this6.optionsList.push(data);
                      } else {
                        category.child_list.forEach(function (prod) {
                          if (prod.type === _this6.tab && _this6.optionsList.findIndex(function (x) {
                            return x.id === prod.vendor_custom_id;
                          }) < 0) {
                            var _data = {
                              name: prod.name,
                              id: prod.vendor_custom_id
                            };
                            _this6.optionsList.push(_data);
                          }
                        });
                      }
                    });
                  }
                });

              case 3:
                _this6.setUpAdd();

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    setUpAdd: function setUpAdd() {
      if (this.$route.name === 'upProductAlias') {
        this.up = true;
        this.getProductAlias();
      } else if (this.$route.name === 'upProductDescription') {
        this.up = true;
        this.getProductDescription();
      } else if (this.$route.name === 'crProductSetting') {
        this.add_prod = true;
      }
    },
    getStoreInfo: function getStoreInfo() {
      var _this7 = this;

      var url = '/store/' + this.$route.params.store_id + '/info';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var storeInfo = response.data.info;
          _this7.brandName = storeInfo.brand_name;
          _this7.storeName = storeInfo.name;
        }
      });
    },
    goToBack: function goToBack() {
      this.$router.go(-1);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    },
    tab: function tab() {
      return this.$route.query.tab ? parseInt(this.$route.query.tab, 10) : 1;
    }
  }),
  watch: {
    menuState: function menuState() {
      this.tableIndex = 1;
      this.pageGroup = 1;
    }
  },
  created: function created() {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this8.prod_list.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this8.emptyProd)));
              _context5.next = 3;
              return _this8.getMenuId();

            case 3:
              if (!_this8.$route.query.brand_name || !_this8.$route.query.store_name) {
                _this8.getStoreInfo();
              } else {
                _this8.brandName = _this8.$route.query.brand_name;
                _this8.storeName = _this8.$route.query.store_name;
              }

            case 4:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this8);
    }))();
  }
});

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__elements_Modal_vue__);


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'm-modal': __WEBPACK_IMPORTED_MODULE_0__elements_Modal_vue___default.a
  },
  data: function data() {
    return {
      content: {
        bindingStoreList: []
      },
      show: {
        back: false
      },
      storeId: 0,
      info: {
        name: ''
      },
      addStoresSetting: {
        class: 'class-store',
        options: [],
        choose: []
      },
      storeClassList: [],
      curId: 0,
      reNew: 0,
      reSet: 0,
      storeBrief: [],
      delOption: {
        id: 'delModal',
        title: '刪除',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'del'
        }]
      }
    };
  },
  created: function created() {
    this.getStoreBrief();
  },
  mounted: function mounted() {},

  methods: {
    delModalOpen: function delModalOpen(bind) {
      this.delOption.title = '刪除' + this.info.name;
    },
    trigger: function trigger(event) {
      if (event === 'del') {
        this.del(this.info.name);
      }
    },
    del: function del(delName) {
      var self = this;
      var url = '/brand/' + this.$route.params.brand_id + '/storeClass/' + this.info.id;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '成功刪除' + delName,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.getStoreBrief();
        }
      });
    },
    getStoreBrief: function getStoreBrief(clear) {
      console.log('getStoreBrief | CrStoreClass');
      this.addStoresSetting.options = [];
      this.storeBrief = [];
      var self = this;
      var url = '/brand/' + this.$route.params.brand_id + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.addStoresSetting.options.push(obj);
            self.storeBrief.push(obj);
          }
          if (!clear) {
            self.getStoreClassList();
          }
          self.reNew++;
        }
      });
    },
    getStoreClassList: function getStoreClassList() {
      var self = this;
      var url = '/brand/' + this.$route.params.brand_id + '/storeClassList';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          self.storeClassList = sList;
          if (sList.length) self.clickOption(sList[0]);
        }
      });
    },
    clickOption: function clickOption(option) {
      var self = this;
      this.addStoresSetting.options = [];
      self.curId = option.id;
      if (self.curId) {
        self.$nextTick(function () {
          self.reSet++;
          self.addStoresSetting.options = self.storeBrief;
          self.getCurStoreClass();
        });
      }
    },
    getCurStoreClass: function getCurStoreClass() {
      this.addStoresSetting.choose = [];
      var self = this;
      var url = '/brand/' + this.$route.params.brand_id + '/storeClass/' + this.curId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var classInfo = response.data.class;
          self.info = classInfo;
          classInfo.store_list.forEach(function (s) {
            self.addStoresSetting.choose.push(s.id);
          });
        }
      });
    },
    checkStoreClass: function checkStoreClass(type) {
      var msg = '';
      if (!this.info.name) msg = '群組名稱未填';else if (!this.addStoresSetting.choose.length) msg = '店家未選擇';
      this.getToast(msg, type);
    },
    getToast: function getToast(msg, type) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else this.upStoreClass(type);
    },
    upStoreClass: function upStoreClass(type) {
      var self = this;
      var method = 'post';
      var url = '/brand/' + this.$route.params.brand_id + '/storeClass';
      if (type === 2) {
        method = 'put';
        url = url + '/' + this.curId;
      }
      var data = {
        name: this.info.name,
        store_id: []
      };
      self.addStoresSetting.choose.forEach(function (store) {
        data.store_id.push(store);
      });
      this.getDataH(method, url, data, function (response) {
        if (response.data.status === 200) {
          self.getStoreBrief();
        }
      });
    },
    clearCId: function clearCId() {
      this.curId = 0;
      this.addStoresSetting.choose = [];
      this.info = { name: '' };
      this.getStoreBrief(true);
    }
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  }
});

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_shared_token_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__extends_nd_extend_handle_menu_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__extends_nd_extend_handle_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__extends_nd_extend_handle_menu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CupDiscountTable',
  extends: __WEBPACK_IMPORTED_MODULE_2__extends_nd_extend_handle_menu_vue___default.a,

  data: function data() {
    return {
      isLoading: true
    };
  },
  mounted: function mounted() {
    this.getExtendHandleMenuInfo();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  }),
  methods: {
    goto: function goto() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_shared_token_js__["c" /* setSharedToken */])(window.localStorage.getItem(this.$config.token));
      window.location.href = this.$config.bdms + 'product-center/products/cup-discount';
    }
  }
});

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Brand_Temp_BrandTableTemp_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Brand_Temp_BrandTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Brand_Temp_BrandTableTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_handle_config_js__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MenuDetailTable',
  data: function data() {
    return {
      tableIndex: 1
    };
  },

  methods: {
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    }
  },
  components: {
    'brand-table': __WEBPACK_IMPORTED_MODULE_1__Brand_Temp_BrandTableTemp_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  }),
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var url = 'brand/list?page=1&size=10';
    var roleType = window.localStorage.getItem('Nidin_wb_role_type');
    var token = window.localStorage.getItem('Nidin_wb_token');
    if (roleType === '30') {
      __WEBPACK_IMPORTED_MODULE_4_axios___default()({
        baseURL: __WEBPACK_IMPORTED_MODULE_2__assets_js_handle_config_js__["a" /* default */].baseURL,
        method: 'get',
        url: url,
        headers: {
          'MC-API-Token': token
        }
      }).then(function (response) {
        if (response.data.list.length === 1) {
          var branId = response.data.list[0].id;
          next('/brandMenu/' + branId);
        } else next();
      });
    } else next();
  }
});

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_ClipLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_ClipLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_masonry_layout__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_masonry_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_masonry_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Temp_MenuModalNew_vue__ = __webpack_require__(2221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Temp_MenuModalNew_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Temp_MenuModalNew_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Temp_MenuPackageModalNew_vue__ = __webpack_require__(2222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Temp_MenuPackageModalNew_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Temp_MenuPackageModalNew_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Temp_MenuLogic_vue__ = __webpack_require__(2220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Temp_MenuLogic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Temp_MenuLogic_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__extends_nd_extend_handle_menu_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__extends_nd_extend_handle_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__extends_nd_extend_handle_menu_vue__);














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MenuInfo',
  components: {
    ClipLoader: __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_ClipLoader_vue___default.a,
    MenuModal: __WEBPACK_IMPORTED_MODULE_7__Temp_MenuModalNew_vue___default.a,
    MenuLogic: __WEBPACK_IMPORTED_MODULE_9__Temp_MenuLogic_vue___default.a,
    PackageModal: __WEBPACK_IMPORTED_MODULE_8__Temp_MenuPackageModalNew_vue___default.a
  },
  extends: __WEBPACK_IMPORTED_MODULE_10__extends_nd_extend_handle_menu_vue___default.a,
  data: function data() {
    return {
      current: {
        productId: 0,
        product: []
      },
      tableIndex: 1,
      info: {},
      menu: {
        categoryList: [],
        productList: [],
        adjustList: [],
        optionList: [],
        combineList: [],
        productNewList: [],
        blockList: [],
        packageList: []
      },
      currentMenuJson: '',
      show: {
        download: false,
        noMenu: false
      },
      schema: {
        category: {},
        product: {},
        block: {},
        adjust: {},
        option: {},
        combine: {}
      },
      layout: 1,
      showProductIcon: false,
      disableItems: [],
      disable: {
        product: {},
        category: [],
        option: {},
        adjust: [],
        block: {},
        item: {},
        pBlock: {}
      },
      isSearch: false,
      showMenuIcon: 0,
      loading: {
        menu: true
      },
      minPrice: {},
      currentProduct: []
    };
  },
  mounted: function mounted() {
    this.$nextTick().then(function () {
      if (__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.grid') && __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.grid-item')) {
        var m = new __WEBPACK_IMPORTED_MODULE_5_masonry_layout___default.a('.grid', {
          itemSelector: '.grid-item',
          columnWidth: '.grid-item'
        });
        m.reloadItems();
        m.layout();
      }
    });
    if (this.getRoleType === 99) {
      this.getExtendHandleMenuInfo();
    }
  },
  updated: function updated() {
    this.$nextTick().then(function () {
      if (__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.grid') && __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.grid-item')) {
        var m = new __WEBPACK_IMPORTED_MODULE_5_masonry_layout___default.a('.grid', {
          itemSelector: '.grid-item',
          columnWidth: '.grid-item'
        });
        m.reloadItems();
        m.layout();
      }
    });
  },

  methods: {
    changeToProductList: function changeToProductList(number) {
      return this.menu.productList[number];
    },
    checkDisableItem: function checkDisableItem(productId, categoryId) {
      return true;
    },
    openModal: function openModal(productListNumber, noDis) {
      var newProduct = this.changeToProductList(productListNumber);
      this.$set(this, 'currentProduct', newProduct);
    },
    getIcon: function getIcon(pId) {
      return [];
    },
    openProductModal: function openProductModal(product, index) {
      this.current.productId = index;
      this.current.product = product;
    },
    setSelectAndMenu: function setSelectAndMenu() {
      this.$set(this, 'currentMenuJson', JSON.parse(this.currentMenuJson));
      this.menu.categoryList = this.currentMenuJson.category_list_json.data;

      var menu = [];
      for (var key in this.menu.categoryList) {
        menu.push(this.menu.categoryList[key]);
      }
      menu.sort(function (a, b) {
        return a[1] - b[1];
      });
      this.menu.categoryList = menu;
      this.menu.productList = this.currentMenuJson.product_list_json.data;
      this.menu.adjustList = this.currentMenuJson.adjust_list_json.data;
      this.menu.optionList = this.currentMenuJson.option_list_json.data;
      this.menu.combineList = this.currentMenuJson.combine_list_json.data;
      this.schema.category = this.currentMenuJson.category_list_json.schema;
      this.schema.product = this.currentMenuJson.product_list_json.schema;
      if (this.currentMenuJson.block_list_json) this.schema.block = this.currentMenuJson.block_list_json.schema;
      this.schema.adjust = this.currentMenuJson.adjust_list_json.schema;
      this.schema.option = this.currentMenuJson.option_list_json.schema;
      this.schema.combine = this.currentMenuJson.combine_list_json.schema;
    },
    getCommonPrice: function getCommonPrice(combineNumList) {
      var combineList = [];
      var commonPriceList = [];
      for (var i = 0; i < combineNumList.length; i++) {
        if (this.menu.combineList[combineNumList[i]][4]) combineList.push(this.menu.combineList[combineNumList[i]]);
      }
      for (var j = 0; j < combineList.length; j++) {
        if (combineList[j][2]) {
          commonPriceList.push({
            cold: {
              name: combineList[j][1], price: combineList[j][2]
            },
            hot: {
              name: combineList[j][1], price: combineList[j][2]
            }
          });
        } else {
          var common = this.getSumPrice(combineList[j][5]);
          commonPriceList.push(common);
        }
      }
      var minCommonPrice = [];
      minCommonPrice.push(this.checkLowerPrice(commonPriceList));
      return minCommonPrice;
    },
    getSumPrice: function getSumPrice(edgeNumList) {
      var priceList = [];
      var aList = this.menu.adjustList;
      var oList = this.menu.optionList;
      var pList = this.menu.productList;
      var priceObj = {
        cold: {
          name: '',
          price: 0
        },

        hot: {
          name: '',
          price: 0
        },

        temp: false
      };
      for (var key in edgeNumList) {
        var id = edgeNumList[key][0];
        var edgePrice = edgeNumList[key][2];

        if (typeof aList[id] !== 'undefined' && aList[id][11]) {
          var aPrice = aList[id][4];
          if (edgePrice) aPrice = edgePrice;
          if (aList[id][4]) priceList.push({ id: aList[id][0], name: aList[id][2], price: aPrice, sub_type: aList[id][7] });else {
            for (var j = 0; j < aList[id][14].length; j++) {
              var oListNum;
              oListNum = aList[id][14][j];
              if ((typeof oListNum === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(oListNum)) === 'object') oListNum = aList[id][14][j][0];
              var aoPrice = oList[oListNum][4];
              if (edgePrice) aoPrice = edgePrice;
              if (typeof oList[oListNum] !== 'undefined' && oList[oListNum][4] && oList[oListNum][11]) {
                priceList.push({ id: oList[oListNum][0], name: oList[oListNum][2], price: aoPrice, sub_type: oList[oListNum][7] });
              }
            }
          }
        } else if (typeof oList[id] !== 'undefined' && oList[id][4] && oList[id][11]) {
          var oPrice = oList[id][4];
          if (edgePrice) oPrice = edgePrice;
          priceList.push({ id: oList[id][0], name: oList[id][2], price: oPrice, sub_type: oList[id][7] });
        } else if (typeof pList[id] !== 'undefined' && pList[id][4] && pList[id][11]) {
          var pPrice = pList[id][4];
          if (edgePrice) pPrice = edgePrice;
          priceList.push({ id: pList[id][0], name: pList[id][2], price: pPrice, sub_type: pList[id][7] });
        }
        if (typeof aList[id] !== 'undefined') {
          if (aList[id][7] === 40) priceObj.temp = true;
        } else if (typeof oList[id] !== 'undefined') {
          var isTemp = oList[id][7];
          if (isTemp === 41 || isTemp === 42 || isTemp === 43 || isTemp === 44 || isTemp === 45 || isTemp === 46 || isTemp === 47 || isTemp === 48 || isTemp === 49) {
            priceObj.temp = true;
          }
        }
      }
      for (var i = 0; i < priceList.length; i++) {
        var temp = priceList[i].sub_type;
        if (temp === 41 || temp === 42 || temp === 43) {
          priceObj.cold.name = priceObj.cold.name + priceList[i].name;
          priceObj.cold.price = priceObj.cold.price + priceList[i].price;
        } else if (temp === 44 || temp === 45 || temp === 46 || temp === 47 || temp === 48 || temp === 49) {
          priceObj.hot.name = priceObj.hot.name + priceList[i].name;
          priceObj.hot.price = priceObj.hot.price + priceList[i].price;
        } else {
          priceObj.cold.name = priceObj.cold.name + priceList[i].name;
          priceObj.cold.price = priceObj.cold.price + priceList[i].price;
          priceObj.hot.name = priceObj.hot.name + priceList[i].name;
          priceObj.hot.price = priceObj.hot.price + priceList[i].price;
        }
      }
      return priceObj;
    },
    exportFile: function exportFile() {
      var _this = this;

      this.show.download = true;
      var name = this.info.name;
      var url = this.base + this.id + '/menu/' + this.$route.params.menu_id + '/exportProductBrief';
      this.getFile('get', url, null, function (response) {
        _this.show.download = false;
        var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        var objectUrl = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = objectUrl;
        a.download = name + '_' + __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYYMMDD') + '.csv';
        document.body.appendChild(a);
        a.click();
      });
    },
    checkLowerPrice: function checkLowerPrice(commonPriceList) {
      var coldPrice = [];
      var hotPrice = [];
      var minPriceObj = {
        cold: {
          price: 0
        },
        hot: {
          price: 0
        },
        temp: false
      };
      for (var i = 0; i < commonPriceList.length; i++) {
        coldPrice.push(commonPriceList[i].cold.price);
        hotPrice.push(commonPriceList[i].hot.price);
        minPriceObj.temp = commonPriceList[i].temp;
      }
      minPriceObj.cold.price = Math.min.apply(Math, coldPrice);
      minPriceObj.hot.price = Math.min.apply(Math, hotPrice);
      return minPriceObj;
    },
    getMenuInfo: function getMenuInfo(lockState) {
      var _this2 = this;

      var url = this.base + this.id + '/menu/' + this.$route.params.menu_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this2.info = response.data.menu;
          if (!lockState) {
            if (response.data.json_menu) {
              _this2.currentMenuJson = response.data.json_menu;
              window.sessionStorage.setItem('Nidin_ecms_menu', response.data.json_menu);
              _this2.setSelectAndMenu();
            } else {
              _this2.show.noMenu = true;
            }
          }
        }
      });
    },
    goToCrSchedule: function goToCrSchedule() {
      var info = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      console.log('goToCrSchedule');
      var name = '';
      var params = {
        brand_id: this.$route.params.brand_id,
        store_id: ''
      };
      var query = {
        menu_id: info.menu_id,
        menu_name: info.name
      };

      if (this.isStore && this.getRoleType !== 10) {
        name = 'StoreMenuScheduleCreate';
        params.store_id = this.$route.params.store_id;
      } else {
        name = 'crSchedule';
      }

      this.$router.push({ name: name, params: params, query: query });
    },
    menuUnlock: function menuUnlock() {
      var _this3 = this;

      var url = this.base + this.id + '/menu/' + this.$route.params.menu_id + '/unlock';
      this.getDataH('put', url, null, function (response) {
        if (response.data.status === 200) {
          _this3.$notify({
            title: '訊息',
            text: '成功解除菜單鎖定',
            duration: 3000,
            type: 'success',
            width: 400
          });
          _this3.getMenuInfo('unlock');
        }
      });
    },
    menuLock: function menuLock() {
      var _this4 = this;

      var url = this.base + this.id + '/menu/' + this.$route.params.menu_id + '/lock';
      this.getDataH('put', url, null, function (response) {
        if (response.data.status === 200) {
          _this4.$notify({
            title: '訊息',
            text: '成功鎖定菜單',
            duration: 3000,
            type: 'success',
            width: 400
          });
          _this4.getMenuInfo('lock');
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getRoleType']), {
    sortCategoryList: function sortCategoryList() {
      var category = this.menu.categoryList;
      var products = [];
      category.sort(function (a, b) {
        return a[1] - b[1];
      });
      for (var i = 0; i < category.length; i++) {
        var product = [];
        for (var j = 0; j < category[i][6].length; j++) {
          product.push(this.menu.productList[category[i][6][j]]);
        }

        product.sort(function (a, b) {
          return a[1] - b[1];
        });
        products[category[i][0]] = product;
      }

      this.menu.productNewList = products;
      return category;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getFile: function getFile() {
      return this.$parent.getFile;
    }
  }),
  created: function created() {
    this.getMenuInfo();
  }
});

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_elements_Modal__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MenuSettingRuleStoreUpdate',
  components: {
    'nd-modal': __WEBPACK_IMPORTED_MODULE_4__components_elements_Modal___default.a
  },
  data: function data() {
    return {
      black: {
        option: {
          id: 'blackModal',
          title: '黑名單設定',
          btns: [{
            name: '取消'
          }, {
            name: '確定',
            event: 'update'
          }]
        },
        temp: []
      },
      setting: {
        blacklist: [],
        whitelist: []
      }
    };
  },

  methods: {
    getList: function getList() {
      var _this = this;

      var brandId = this.$route.params.brand_id;
      var url = '/brand/' + brandId + '/storeMenuCopySetting';
      this.getDataH('get', url, null, function (res) {
        if (res.data.status === 200) {
          var blacklist = _this.handleList(res.data.setting.blacklist);
          var whitelist = _this.handleList(res.data.setting.whitelist);
          _this.black.temp = blacklist;
          _this.setting.blacklist = blacklist;
          _this.setting.whitelist = whitelist;
        }
      });
    },
    handleList: function handleList() {
      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return list.map(function (i) {
        var temp = {
          id: i.id,
          name: i.name
        };
        if (!i.name) {
          temp.name = '[' + i.id + '][\u7121\u9580\u5E02\u540D\u7A31]';
        }
        return temp;
      });
    },
    trigger: function trigger(event) {
      if (event === 'update') {
        this.update();
      }
    },
    update: function update() {
      var _this2 = this;

      console.log('update');
      var brandId = this.$route.params.brand_id;
      var url = '/brand/' + brandId + '/storeMenuCopySetting';
      this.getDataH('post', url, this.updateInfo, function (res) {
        if (res.data.status === 200) {
          _this2.$notify({
            title: '設定成功',
            text: '已設定黑名單!',
            duration: 1000,
            type: 'success',
            width: 400
          });
          _this2.getList();
        }
      });
    }
  },
  created: function created() {
    this.getList();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    blacklist: function blacklist() {
      var temp = this.setting.blacklist.map(function (i) {
        return i.name;
      });
      return temp.join('、');
    },
    blackTempId: function blackTempId() {
      var temp = this.black.temp.map(function (i) {
        return i.id;
      });
      return temp;
    },
    updateInfo: function updateInfo() {
      return {
        blacklist: this.blackTempId
      };
    },
    whitelist: function whitelist() {
      var temp = this.setting.whitelist.map(function (i) {
        return i.name;
      });
      return temp.join('、');
    }
  })
});

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_elements_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MenuSettingRuleStoreCopyLogs',
  components: {
    'm-modal': __WEBPACK_IMPORTED_MODULE_4__components_elements_Modal___default.a
  },
  data: function data() {
    return {
      black: {
        option: {
          id: 'editModal',
          title: '黑名單設定',
          btns: [{
            name: '取消'
          }, {
            name: '確定',
            event: 'update'
          }]
        },
        temp: []
      },
      list: []
    };
  },

  methods: {
    getList: function getList() {
      var _this = this;

      var brandId = this.$route.params.brand_id;
      var url = '/brand/' + brandId + '/storeMenuCopySetting/history';
      this.getDataH('get', url, null, function (res) {
        if (res.data.status === 200) {
          var newList = res.data.list.map(function (i) {
            var temp = i;
            temp.action.add = _this.handleList(i.action.add);
            temp.action.remove = _this.handleList(i.action.remove);
            temp.action.result = _this.handleList(i.action.result);
            return temp;
          });
          _this.list = newList;
        }
      });
    },
    handleName: function handleName() {
      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var temp = list.map(function (i) {
        return i.name;
      });
      return temp.join('、') || '無';
    },
    handleList: function handleList() {
      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return list.map(function (i) {
        var temp = {
          id: i.id,
          name: i.name
        };
        if (!i.name) {
          temp.name = '[' + i.id + '][\u7121\u9580\u5E02\u540D\u7A31]';
        }
        return temp;
      });
    },

    moment: __WEBPACK_IMPORTED_MODULE_5_moment___default.a
  },
  created: function created() {
    this.getList();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  })
});

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_elements_Modal__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MenuSettingRuleStoreUpdate',
  components: {
    'm-modal': __WEBPACK_IMPORTED_MODULE_4__components_elements_Modal___default.a
  },
  data: function data() {
    return {
      black: {
        label: 'name',
        option: {
          id: 'editModal',
          title: '不可編輯菜單門市設定',
          btns: [{
            name: '取消'
          }, {
            name: '確定',
            event: 'update'
          }]
        },
        placeholder: '請輸入或選擇門市',
        temp: [],
        trackBy: 'id'
      },
      setting: {
        blacklist: [],
        whitelist: []
      }
    };
  },

  methods: {
    getList: function getList() {
      var _this = this;

      var brandId = this.$route.params.brand_id;
      var url = '/brand/' + brandId + '/storeMenuUpdateSetting';
      this.getDataH('get', url, null, function (res) {
        if (res.data.status === 200) {
          var blacklist = _this.handleList(res.data.setting.blacklist);
          var whitelist = _this.handleList(res.data.setting.whitelist);
          _this.black.temp = blacklist;
          _this.setting.blacklist = blacklist;
          _this.setting.whitelist = whitelist;
        }
      });
    },
    handleList: function handleList() {
      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return list.map(function (i) {
        var temp = {
          id: i.id,
          name: i.name
        };
        if (!i.name) {
          temp.name = '[' + i.id + '][\u7121\u9580\u5E02\u540D\u7A31]';
        }
        return temp;
      });
    },
    trigger: function trigger(event) {
      if (event === 'update') {
        this.update();
      }
    },
    update: function update() {
      var _this2 = this;

      console.log('update');
      var brandId = this.$route.params.brand_id;
      var url = '/brand/' + brandId + '/storeMenuUpdateSetting';
      this.getDataH('post', url, this.updateInfo, function (res) {
        if (res.data.status === 200) {
          _this2.$notify({
            title: '設定成功',
            text: '已設定不可編輯門市！',
            duration: 1000,
            type: 'success',
            width: 400
          });
          _this2.getList();
        }
      });
    }
  },
  created: function created() {
    this.getList();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    blacklist: function blacklist() {
      var temp = this.setting.blacklist.map(function (i) {
        return i.name;
      });
      return temp.join('、');
    },
    blackTempId: function blackTempId() {
      var temp = this.black.temp.map(function (i) {
        return i.id;
      });
      return temp;
    },
    updateInfo: function updateInfo() {
      return {
        blacklist: this.blackTempId
      };
    },
    whitelist: function whitelist() {
      var temp = this.setting.whitelist.map(function (i) {
        return i.name;
      });
      return temp.join('、');
    }
  })
});

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_elements_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MenuSettingRuleStoreCopyLogs',
  components: {
    'm-modal': __WEBPACK_IMPORTED_MODULE_4__components_elements_Modal___default.a
  },
  data: function data() {
    return {
      black: {
        option: {
          id: 'editModal',
          title: '黑名單設定',
          btns: [{
            name: '取消'
          }, {
            name: '確定',
            event: 'update'
          }]
        },
        temp: []
      },
      list: []
    };
  },

  methods: {
    getList: function getList() {
      var _this = this;

      var brandId = this.$route.params.brand_id;
      var url = '/brand/' + brandId + '/storeMenuUpdateSetting/history';
      this.getDataH('get', url, null, function (res) {
        if (res.data.status === 200) {
          var newList = res.data.list.map(function (i) {
            var temp = i;
            temp.action.add = _this.handleList(i.action.add);
            temp.action.remove = _this.handleList(i.action.remove);
            temp.action.result = _this.handleList(i.action.result);
            return temp;
          });
          _this.list = newList;
        }
      });
    },
    handleName: function handleName() {
      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var temp = list.map(function (i) {
        return i.name;
      });
      return temp.join('、') || '無';
    },
    handleList: function handleList() {
      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return list.map(function (i) {
        var temp = {
          id: i.id,
          name: i.name
        };
        if (!i.name) {
          temp.name = '[' + i.id + '][\u7121\u9580\u5E02\u540D\u7A31]';
        }
        return temp;
      });
    },

    moment: __WEBPACK_IMPORTED_MODULE_5_moment___default.a
  },
  created: function created() {
    this.getList();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  })
});

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Brand_Temp_BrandTableTemp_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Brand_Temp_BrandTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Brand_Temp_BrandTableTemp_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      tableIndex: 1
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#example1').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      });
    });
  },

  methods: {
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    }
  },
  components: {
    'brand-table': __WEBPACK_IMPORTED_MODULE_3__Brand_Temp_BrandTableTemp_vue___default.a
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  }
});

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_ProdImgTable_vue__ = __webpack_require__(2225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_ProdImgTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Temp_ProdImgTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Temp_ProdIconTable_vue__ = __webpack_require__(2224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Temp_ProdIconTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Temp_ProdIconTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__extends_nd_extend_handle_menu_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__extends_nd_extend_handle_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__extends_nd_extend_handle_menu_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductImage',
  extends: __WEBPACK_IMPORTED_MODULE_5__extends_nd_extend_handle_menu_vue___default.a,
  components: {
    'prod-img-table': __WEBPACK_IMPORTED_MODULE_2__Temp_ProdImgTable_vue___default.a,
    'prod-icon-table': __WEBPACK_IMPORTED_MODULE_3__Temp_ProdIconTable_vue___default.a
  },
  data: function data() {
    return {
      brandName: '',
      storeName: '',
      total: 1,
      count: 20,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      scheduleList: [],

      tab: 1,
      imgList: [],
      iconList: [],
      imgMeta: {
        total: 0,
        size: 20
      },
      page: 1
    };
  },

  methods: {
    updateQuery: function updateQuery(tab) {
      this.$router.push({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.$route.query, {
          page: 1,
          tab: tab
        })
      });
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    editStores: function editStores(menuId) {
      this.$router.push('/upSchedule/all/' + menuId);
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.getProductImageList();
    },
    checkDoubleStore: function checkDoubleStore(storeIdList) {
      console.log('checkDoubleStore', storeIdList);
      var newScheduleList = [];
      for (var key in storeIdList) {
        newScheduleList.push(storeIdList[key][0]);
      }
      this.setGantt(newScheduleList);
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    },
    getProductImageList: function getProductImageList(page) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var search = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      var self = this;
      if (page) this.page = page;

      var url = 'store/' + this.$route.params.store_id + '/productImageSetting/list?size=' + this.count + '&type=' + this.tab + '&page=' + this.page;
      if (type && search.trim()) {
        url = url + (type === 'name' ? '&product_name=' : '&vendor_custom_id=') + search.trim();
      }
      this.getDataH('get', url, null, function (response) {
        self.imgList = response.data.list;
        self.imgMeta = response.data.meta;
      });
    },
    getProductIconList: function getProductIconList() {
      var self = this;

      var url = 'store/' + this.$route.params.store_id + '/productIconSetting/list?size=' + this.count + '&page=' + this.page + '&type=1';
      this.getDataH('get', url, null, function (response) {
        self.iconList = response.data.list;
      });
    },
    getStoreInfo: function getStoreInfo() {
      var _this = this;

      var url = '/store/' + this.$route.params.store_id + '/info';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var _$router;

          var storeInfo = response.data.info;
          _this.brandName = storeInfo.brand_name;
          _this.storeName = storeInfo.name;
          (_$router = _this.$router).replace.apply(_$router, [{
            query: {
              brand_name: storeInfo.brand_name,
              store_name: storeInfo.name
            }
          }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.$route.query)));
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getRoleType', 'getStores']), {
    scheduleListNew: function scheduleListNew() {
      var menuList = {};
      var oldList = this.menu_schedule_list;
      for (var key in oldList) {
        menuList[oldList[key].menu_id] = {
          menu_id: oldList[key].menu_id,
          storeList: []
        };
      }
      for (var k in oldList) {
        menuList[oldList[k].menu_id].storeList.push({
          store_id: oldList[k].store_id,
          store_name: oldList[k].store_name,
          start_time: oldList[k].start_time,
          end_time: oldList[k].end_time,
          status: oldList[k].status,
          update_time: oldList[k].update_time,
          create_time: oldList[k].create_time,
          schedule_id: oldList[k].schedule_id,
          menu_id: oldList[key].menu_id
        });
      }
      return menuList;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  }),
  created: function created() {
    if (!this.$route.query.brand_name || !this.$route.query.store_name) {
      this.getStoreInfo();
    } else {
      this.brandName = this.$route.query.brand_name;
      this.storeName = this.$route.query.store_name;
    }
  },

  watch: {
    tab: function tab() {
      this.page = Number(this.$route.query.page) || 1;
      if (this.tab !== 99) this.getProductImageList(this.page);else this.getProductIconList();
    },
    '$route.query.tab': function $routeQueryTab() {
      var defaultTab = this.$route.query.tab;
      if (defaultTab) this.tab = parseInt(defaultTab, 10);
    }
  },
  mounted: function mounted() {
    var defaultTab = this.$route.query.tab;
    if (defaultTab) this.tab = parseInt(defaultTab, 10);
    this.page = Number(this.$route.query.page) || 1;
    if (this.tab !== 99) this.getProductImageList(this.page);else this.getProductIconList(this.page);
    this.getExtendHandleMenuInfo();
  }
});

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Temp_ProdSettingTable__ = __webpack_require__(2226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Temp_ProdSettingTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Temp_ProdSettingTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_elements_chooseStoreModal_vue__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_elements_chooseStoreModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_elements_chooseStoreModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__extends_nd_extend_handle_menu_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__extends_nd_extend_handle_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__extends_nd_extend_handle_menu_vue__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductSetting',
  data: function data() {
    return {
      brandName: '',
      storeName: '',
      total: 1,
      count: 20,
      pageGroup: 1,
      groupAmount: 10,
      scheduleList: [],

      tab: 1,
      list: [],
      iconList: [],
      meta: {
        total: 0,
        size: 20
      },
      delDesAlisOption: {
        id: 'delDesAlisModal',
        title: '刪除描述/別名/警語',
        body: '',
        btns: [{
          name: '取消',
          event: 'close'
        }, {
          name: '確定',
          event: 'delProductSetting'
        }]
      },
      storeOption: {
        id: 'copyModal'
      },
      delDesAlisId: 0,
      page: 1,
      searchType: 'name',
      searchText: '',
      selectItems: [],

      subMenu: 'alias',
      subMenuList: [{
        value: 'alias',
        text: '商品別名'
      }, {
        value: 'description',
        text: '商品描述/警語'
      }]
    };
  },

  extends: __WEBPACK_IMPORTED_MODULE_7__extends_nd_extend_handle_menu_vue___default.a,
  components: {
    'prod-setting-table': __WEBPACK_IMPORTED_MODULE_5__Temp_ProdSettingTable___default.a,
    'choose-store-modal': __WEBPACK_IMPORTED_MODULE_6__components_elements_chooseStoreModal_vue___default.a
  },
  methods: {
    setDeleteItem: function setDeleteItem() {
      this.delDesAlisOption.btns[1].event = 'deleteSeleteItem';
    },
    updateQuery: function updateQuery(tab) {
      this.tab = tab;
      this.page = 1;
      this.setRouterQuery();
    },
    setRouterQuery: function setRouterQuery() {
      var query = {
        tab: this.tab,
        page: this.page,
        subMenu: this.subMenu
      };
      if (this.brandName && this.storeName) {
        query.brand_name = this.brandName;
        query.store_name = this.storeName;
      }
      if (this.searchType && this.searchText) {
        query.search_type = this.searchType;
        query.search_text = this.searchText;
      }
      this.$router.replace({ path: this.$route.path, query: query });
    },
    isActive: function isActive(index) {
      if (this.page === index) return true;else return false;
    },
    editStores: function editStores(menuId) {
      this.$router.push('/upSchedule/all/' + menuId);
    },
    checkDoubleStore: function checkDoubleStore(storeIdList) {
      var newScheduleList = [];
      for (var key in storeIdList) {
        newScheduleList.push(storeIdList[key][0]);
      }
      this.setGantt(newScheduleList);
    },
    setSearchQuery: function setSearchQuery() {
      var text = 'size=' + this.count + '&type=' + this.tab + '&page=' + this.page;
      if (this.searchType && this.searchText && this.searchText.trim()) {
        text = text + (this.searchType === 'name' ? '&product_name=' : '&vendor_custom_id=') + this.searchText.trim();
      }
      return text;
    },
    getList: function getList() {
      var _this = this;

      var urlName = this.subMenu === 'alias' ? 'productAliasSetting' : 'productDescriptionSetting';
      var url = 'store/' + this.$route.params.store_id + '/' + urlName + '/list?' + this.setSearchQuery();
      this.getDataH('get', url, null, function (response) {
        _this.list = response.data.list;
        _this.meta = response.data.meta;
      });
    },
    updatePagination: function updatePagination(page) {
      this.page = page;
      this.setRouterQuery();
      this.getList();
    },
    trigger: function trigger(event) {
      if (event === 'close') {
        return;
      } else if (event === 'delProductSetting') {
        this.delProductDesAlias();
      } else {
        this.batchDelet();
      }
    },
    setSelectItem: function setSelectItem(val) {
      this.selectItems = val;
    },
    updateDelElement: function updateDelElement(id) {
      this.delDesAlisId = id;
      this.delDesAlisOption.btns[1].event = 'delProductSetting';
    },
    batchDelet: function batchDelet() {
      var _this2 = this;

      if (this.selectItems.length) {
        var urlType = this.subMenu === 'alias' ? 'productAliasSetting' : 'productDescriptionSetting';
        var url = 'store/' + this.$route.params.store_id + '/' + urlType + '/batchDelete?setting_ids=' + this.selectItems.toString();
        this.getDataH('delete', url, null, function (response) {
          if (response.data.status === 200) {
            _this2.$notify({
              title: '成功',
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            });
            _this2.getList();
          }
          _this2.clearSelect();
        });
      }
    },
    search: function search() {
      this.page = 1;
      this.setRouterQuery();
      this.getList();
    },
    crElement: function crElement() {
      var bId = this.$route.params.brand_id;
      var sId = this.$route.params.store_id;
      this.$router.push('/crProductSetting/' + bId + '/' + sId + '?tab=' + this.tab);
    },
    delProductDesAlias: function delProductDesAlias() {
      var _this3 = this;

      if (this.delDesAlisId) {
        var urlType = this.subMenu === 'alias' ? 'productAliasSetting' : 'productDescriptionSetting';
        var url = 'store/' + this.$route.params.store_id + '/' + urlType + '/' + this.delDesAlisId;
        this.getDataH('delete', url, null, function (response) {
          if (response.data.status === 200) {
            _this3.$notify({
              title: '成功',
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            });
            _this3.getList();
          }
          _this3.clearSelect();
        });
      }
    },
    clearSelect: function clearSelect() {
      this.delDesAlisId = null;
      this.list.forEach(function (element) {
        element.selectItem = false;
      });
    },
    copyStore: function copyStore(storeList) {
      var _this4 = this;

      var urlName = this.subMenu === 'alias' ? 'productAliasSetting' : 'productDescriptionSetting';
      if (storeList.length) {
        var url = '/store/' + this.$route.params.store_id + '/' + urlName + '/storeSync';
        var data = {
          store_id_list: storeList,
          setting_id_list: this.selectItems,
          type: this.tab
        };
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            _this4.$notify({
              title: '\u8907\u88FD' + (_this4.subMenu === 'alias' ? '別名' : '描述/警語') + '\u6210\u529F',
              duration: 3000,
              type: 'success',
              width: 400
            });
            _this4.clearSelect();
          }
        });
      }
    },
    clickSubMenu: function clickSubMenu(val) {
      this.subMenu = val;
      this.list = [];
      this.updatePagination(1);
    },
    getStoreInfo: function getStoreInfo() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = '/store/' + _this5.$route.params.store_id + '/info';
                _context.next = 3;
                return _this5.getDataH('get', url, null, function (response) {
                  if (response.data.status === 200) {
                    var storeInfo = response.data.info;
                    _this5.brandName = storeInfo.brand_name;
                    _this5.storeName = storeInfo.name;
                    _this5.$router.replace({
                      query: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this5.$route.query, {
                        brand_name: _this5.brandName,
                        store_name: _this5.storeName
                      })
                    });
                  }
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getRoleType', 'getStores']), {
    tabName: function tabName() {
      switch (this.tab) {
        case 2:
          return '配料';
        case 20:
          return '配料群組';
        case 10:
          return '商品分類';
        case 1:
          return '商品';
        case 11:
          return '品項選擇區';
        case 3:
          return '套餐';
      }
    },
    scheduleListNew: function scheduleListNew() {
      var menuList = {};
      var oldList = this.menu_schedule_list;
      for (var key in oldList) {
        menuList[oldList[key].menu_id] = {
          menu_id: oldList[key].menu_id,
          storeList: []
        };
      }
      for (var k in oldList) {
        menuList[oldList[k].menu_id].storeList.push({
          store_id: oldList[k].store_id,
          store_name: oldList[k].store_name,
          start_time: oldList[k].start_time,
          end_time: oldList[k].end_time,
          status: oldList[k].status,
          update_time: oldList[k].update_time,
          create_time: oldList[k].create_time,
          schedule_id: oldList[k].schedule_id,
          menu_id: oldList[key].menu_id
        });
      }
      return menuList;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  }),
  watch: {
    $route: {
      handler: function handler() {
        if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$route.query).length) {
          this.updateQuery(1);
        }
      },

      immediate: true
    },
    '$route.query.tab': function $routeQueryTab(val) {
      this.tab = parseInt(val, 10);
      this.page = 1;
      this.searchText = '';
      this.getList();
    }
  },
  created: function created() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this6.$route.query).length) {
                _context2.next = 15;
                break;
              }

              _this6.page = parseInt(_this6.$route.query.page, 10) || 1;
              _this6.tab = parseInt(_this6.$route.query.tab, 10);
              _this6.subMenu = _this6.$route.query.subMenu || 'alias';

              if (!(!_this6.$route.query.brand_name || !_this6.$route.query.store_name)) {
                _context2.next = 9;
                break;
              }

              _context2.next = 7;
              return _this6.getStoreInfo();

            case 7:
              _context2.next = 11;
              break;

            case 9:
              _this6.brandName = _this6.$route.query.brand_name;
              _this6.storeName = _this6.$route.query.store_name;

            case 11:
              _this6.searchType = _this6.$route.query.search_type || 'name';
              _this6.searchText = _this6.$route.query.search_text || '';
              _this6.setRouterQuery();
              _this6.getList();

            case 15:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this6);
    }))();
  },
  mounted: function mounted() {
    this.getExtendHandleMenuInfo();
  }
});

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdjustModal',
  props: {
    modalId: {
      type: String,
      required: true
    },

    state: {
      type: Number
    },
    adjustId: {
      type: Number
    },
    adjustName: {
      type: String
    }
  },
  data: function data() {
    return {
      editState: false,
      show: {
        delNotify: false
      },
      adjustInfo: {
        name: '',
        sort: 1,
        description: '',
        remark: '',
        price: '',
        price_type: '3',
        calorie: '',
        min_limit: '0',
        max_limit: '0',
        adjust_custom_id: '',
        is_mandatory: '0',
        is_common: '0',
        sub_type: '0'
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['setUpAdjust', 'setModal']), {
    toggle: function toggle() {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.infoAdjustModal).css('display');
    },
    maxAmount: function maxAmount(max) {
      if (!max) return '無限制';else return max;
    },
    getSubType: function getSubType(type) {
      if (type === 10) {
        return '大小';
      } else if (type === 20) {
        return '容器';
      } else if (type === 30) {
        return '甜度';
      } else if (type === 40) {
        return '溫度';
      } else {
        return '其他';
      }
    },
    getPriceType: function getPriceType(type) {
      if (type === 1) return '免稅價格';else if (type === 3) return '含稅價格';
    },
    veritySort: function veritySort() {
      var e;
      if (this.state === 1) e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.sort1);else if (this.state === 3) e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.sort3);
      this.adjustInfo.sort = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityMinLimit: function verityMinLimit() {
      var e;
      if (this.state === 1) e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.minLimit1);else if (this.state === 3) e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.minLimit3);
      this.adjustInfo.min_limit = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityMaxLimit: function verityMaxLimit() {
      var e;
      if (this.state === 1) e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.maxLimit1);else if (this.state === 3) e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.maxLimit3);
      this.adjustInfo.max_limit = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityPrice: function verityPrice() {
      var e;
      if (this.state === 1) e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.price1);else if (this.state === 3) e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.price3);
      this.adjustInfo.price = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityCalorie: function verityCalorie() {
      var e;
      if (this.state === 1) e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.calorie1);else if (this.state === 3) e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.calorie3);
      this.adjustInfo.calorie = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    getAdjustInfo: function getAdjustInfo() {
      var self = this;
      var url = 'brand/' + this.$route.params.brand_id + '/adjust/' + this.adjustId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.adjustInfo = response.data.adjust;
        }
      });
    },
    checkInputEmpty: function checkInputEmpty() {
      if (!this.adjustInfo.sub_type && parseInt(this.adjustInfo.sub_type, 10) !== 0) {
        this.$notify({
          title: '提醒',
          text: '請選擇分類',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!this.allInput.name) {
        this.$notify({
          title: '提醒',
          text: '請填寫調整類別名稱',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!this.allInput.sort) {
        this.$notify({
          title: '提醒',
          text: '請填寫排序',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!parseInt(this.allInput.sort, 10)) {
        this.$notify({
          title: '請填寫正確排序',
          text: '排序範圍為1~9999',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!this.allInput.min_limit) {
        this.$notify({
          title: '提醒',
          text: '請填寫最低購買數',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!this.allInput.max_limit) {
        this.$notify({
          title: '提醒',
          text: '請填寫最高購買數',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.updateAdjust();
      }
    },
    updateAdjust: function updateAdjust() {
      var self = this;
      var url = 'brand/' + this.$route.params.brand_id + '/adjust';
      var data = {
        name: this.allInput.name,
        sort: this.allInput.sort,
        min_limit: this.allInput.min_limit,
        max_limit: this.allInput.max_limit,
        price: this.allInput.price,
        price_type: this.adjustInfo.price_type,
        sub_type: this.adjustInfo.sub_type,
        is_mandatory: this.adjustInfo.is_mandatory,
        is_common: this.adjustInfo.is_common
      };
      if (!data.price.length) data.price = null;
      if (this.adjustId) data['adjust_id'] = this.adjustId;
      if (this.allInput.calorie) data['calorie'] = this.allInput.calorie;
      if (this.allInput.vendor_custom_id) data['vendor_custom_id'] = this.allInput.vendor_custom_id;
      if (this.allInput.description) data['description'] = this.allInput.description;
      if (this.allInput.remark) data['remark'] = this.allInput.remark;
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '成功新增調整類別',
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.editState = false;
          var id = self.modalId;
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#' + id).modal('toggle');
          self.setUpAdjust(true);
        }
      });
    },
    delAdjust: function delAdjust() {
      var self = this;
      var url = 'brand/' + this.$route.params.brand_id + '/adjust?adjust_id=' + this.adjustId;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '成功刪除調整類別',
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.editState = false;
          var id = self.modalId;
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#' + id).modal('toggle');
          self.setUpAdjust(true);
        }
      });
    },
    clearData: function clearData() {
      this.adjustInfo = {
        name: '',
        sort: 1,
        description: '',
        remark: '',
        price: '',
        price_type: '3',
        calorie: '',
        min_limit: '0',
        max_limit: '0',
        adjust_custom_id: '',
        is_mandatory: '0',
        is_common: '0',
        sub_type: '0'
      };
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getModal']), {
    modalState: function modalState() {
      if (this.state === 3 && !this.editState) return this.adjustInfo.name;
      if (this.editState) return '編輯' + this.adjustInfo.name;else return '新增調整類別';
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    allInput: function allInput() {
      return {
        name: this.checkInput(this.adjustInfo.name),
        sort: this.checkInput(this.adjustInfo.sort),
        vendor_custom_id: this.checkInput(this.adjustInfo.adjust_custom_id),
        description: this.checkInput(this.adjustInfo.description),
        remark: this.checkInput(this.adjustInfo.remark),
        price: this.checkInput(this.adjustInfo.price),
        calorie: this.checkInput(this.adjustInfo.calorie),
        min_limit: this.checkInput(this.adjustInfo.min_limit),
        max_limit: this.checkInput(this.adjustInfo.max_limit)
      };
    }
  }),
  mounted: function mounted() {
    var self = this;
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.modal').on('hidden.bs.modal', function () {
      self.setModal(false);
      self.clearData();
    });
  },

  watch: {
    getModal: function getModal() {
      if (this.getModal) {
        this.$nextTick(function () {
          this.$set(this.adjustInfo, 'is_mandatory', '0');
          this.$set(this.adjustInfo, 'is_common', '0');
        });
        this.editState = false;
        this.show.delNotify = false;
        if (this.adjustId && this.state !== 1) {
          this.getAdjustInfo();
        }
      }
    }
  }
});

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_nd_copy_options_store_vue__ = __webpack_require__(2094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_nd_copy_options_store_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_elements_nd_copy_options_store_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__extends_nd_extend_handle_menu_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__extends_nd_extend_handle_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__extends_nd_extend_handle_menu_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NdBindingTable',
  props: {
    bindList: Array,
    bindMeta: Object,
    getBindingList: Function,
    input: String,
    isDeleteStatus: Boolean,
    sPage: Number,
    selectAll: Boolean,
    skey: String,
    tab: Number
  },
  extends: __WEBPACK_IMPORTED_MODULE_4__extends_nd_extend_handle_menu_vue___default.a,
  components: {
    'nd-copy-options-store': __WEBPACK_IMPORTED_MODULE_3__components_elements_nd_copy_options_store_vue___default.a,
    'nd-modal': __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue___default.a
  },
  data: function data() {
    return {
      brandId: 0,
      copyOptionsChoose: [],
      copyOptionsConf: {
        id: 'copy-option-modal',
        title: '複製配料庫',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'copyOptions'
        }]
      },
      copyOptionsConfChecked: {
        id: 'copy-option-modal-checked',
        title: '提醒',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'copyOptionsChecked'
        }]
      },
      count: 20,
      curId: 0,
      delOption: {
        id: 'delModal',
        title: '刪除綁定',
        body: '刪除綁定，此處刪除等同刪除該項目所有關聯！<br>刪除時，若被上架中的菜單使用中，則會被阻擋',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delBind'
        }]
      },
      deletestatus: false,
      groupAmount: 10,
      pageGroup: 1,
      searchInput: '',
      searchKey: 'name',
      selectActive: 99,
      selectall: false,
      show: {
        brand: false,
        menu: false,
        schedule: false,
        history: false,
        menuDetail: false
      },
      storeId: 0,
      tableIndex: 1,
      total: 0,
      process: false
    };
  },

  methods: {
    selectItemAll: function selectItemAll() {
      var _this = this;

      this.selectall = !this.selectall;
      this.bindList.forEach(function (item) {
        item['selectItem'] = _this.selectall;
      });
    },
    deleteProducts: function deleteProducts() {
      this.delOption.btns[1].event = 'delBinds';
      this.delOption.title = '刪除綁定';
    },
    copyOptions: function copyOptions() {
      console.log('copyOptions');

      if (!this.copyOptionsChoose.length) {
        window.$('#copy-option-modal').modal('hide');
      } else {
        window.$('#copy-option-modal-checked').modal('show');
      }
    },
    copyOptionsChecked: function copyOptionsChecked() {
      var _this2 = this;

      console.log('copyOptionsChecked');
      var url = '' + this.base + this.id + '/menu/copyToStore';
      var data = {
        store_list: this.copyOptionsChoose
      };

      if (!this.copyOptionsChoose.length) return;

      try {
        if (this.process) return;
        this.process = true;
        this.getDataH('post', url, data, function (res) {
          if (res.data.status === 200) {
            _this2.$notify({
              title: '提醒',
              text: '已複製成功！',
              duration: 1000,
              type: 'success',
              width: 400
            });
            _this2.process = false;
          }
        });
      } catch (e) {
        console.error(e);
        this.process = false;
      }
    },
    getList: function getList() {
      this.tableIndex = 1;
      this.getBindingList(1, this.searchKey, this.searchInput);
    },
    delModalOpen: function delModalOpen(bind) {
      console.log(bind);
      this.delOption.title = '刪除' + bind.name + '綁定';
      this.delOption.btns[1].event = 'delBind';
      this.curId = bind.item_id;
    },
    trigger: function trigger(event) {
      if (event === 'copyOptions') {
        this.copyOptions();
      } else if (event === 'copyOptionsChecked') {
        this.copyOptionsChecked();
      } else if (event === 'delBind') {
        this.delBind();
      } else if (event === 'delBinds') {
        this.delBind('batch');
      }
    },
    delBind: function delBind(type) {
      var _this3 = this;

      var deleteQuery = '';
      if (type === 'batch') {
        var deleteItems = this.bindList.filter(function (i) {
          return i.selectItem;
        }).map(function (i) {
          return i.item_id;
        });
        if (deleteItems.length === this.bindList.length && this.tableIndex !== 1) {
          this.tableIndex = this.tableIndex - 1;
        }
        deleteQuery = deleteItems.toString();
      } else {
        deleteQuery = this.curId;
      }
      var url = this.base + this.id + '/itemBinding?item_id=' + deleteQuery + '&type=' + this.tab;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          _this3.curId = 0;
          _this3.$notify({
            title: '提醒',
            text: '已成功刪除',
            duration: 3000,
            type: 'success',
            width: 400
          });
          if (_this3.searchInput && _this3.searchKey) {
            _this3.getBindingList(_this3.tableIndex, _this3.searchKey, _this3.searchInput);
            _this3.selectall = false;
            _this3.deletestatus = false;
          } else {
            _this3.getBindingList(_this3.tableIndex);
            _this3.selectall = false;
            _this3.deletestatus = false;
          }
        }
      });
    },
    goToEditElement: function goToEditElement() {
      var to = {
        name: '',
        params: {
          brand_id: this.$route.params.brand_id
        }
      };
      switch (this.tab) {
        case 2:
          if (this.isStore && this.getRoleType !== 10) {
            to.name = 'StoreMenuOption';
            to.params.store_id = this.$route.params.store_id;
          } else {
            to.name = 'upOption';
          }
          break;

        case 20:
          if (this.isStore && this.getRoleType !== 10) {
            to.name = 'StoreMenuAdjust';
            to.params.store_id = this.$route.params.store_id;
          } else {
            to.name = 'upAdjust';
          }
          break;

        case 10:
          if (this.isStore && this.getRoleType !== 10) {
            to.name = 'StoreMenuCategory';
            to.params.store_id = this.$route.params.store_id;
          } else {
            to.name = 'upCategory';
          }
          break;

        case 1:
          if (this.isStore && this.getRoleType !== 10) {
            to.name = 'StoreMenuProduct';
            to.params.store_id = this.$route.params.store_id;
          } else {
            to.name = 'upProduct';
          }
          break;

        case 11:
          if (this.isStore && this.getRoleType !== 10) {
            to.name = 'StoreMenuBlock';
            to.params.store_id = this.$route.params.store_id;
          } else {
            to.name = 'upBlock';
          }
          break;

        case 3:
          if (this.isStore && this.getRoleType !== 10) {
            to.name = 'StoreMenuPackage';
            to.params.store_id = this.$route.params.store_id;
          } else {
            to.name = 'upPackage';
          }
          break;
      }
      this.$router.push({
        name: to.name,
        params: to.params
      });
    },
    crElement: function crElement() {
      var to = {
        name: '',
        params: {
          brand_id: this.$route.params.brand_id
        }
      };
      switch (this.tab) {
        case 2:
          if (this.isStore && this.getRoleType !== 10) {
            to.name = 'StoreMenuOptionCreate';
            to.params.store_id = this.$route.params.store_id;
          } else {
            to.name = 'crOptions';
          }
          break;
        case 20:
          if (this.isStore && this.getRoleType !== 10) {
            to.name = 'StoreMenuAdjustCreate';
            to.params.store_id = this.$route.params.store_id;
          } else {
            to.name = 'crAdjusts';
          }
          break;
        case 10:
          if (this.isStore && this.getRoleType !== 10) {
            to.name = 'StoreMenuCategoryCreate';
            to.params.store_id = this.$route.params.store_id;
          } else {
            to.name = 'crCategories';
          }
          break;
        case 1:
          if (this.isStore && this.getRoleType !== 10) {
            to.name = 'StoreMenuProductCreate';
            to.params.store_id = this.$route.params.store_id;
          } else {
            to.name = 'crProducts';
          }
          break;
        case 11:
          if (this.isStore && this.getRoleType !== 10) {
            to.name = 'StoreMenuBlockCreate';
            to.params.store_id = this.$route.params.store_id;
          } else {
            to.name = 'crBlocks';
          }
          break;
        case 3:
          if (this.isStore && this.getRoleType !== 10) {
            to.name = 'StoreMenuPackageCreate';
            to.params.store_id = this.$route.params.store_id;
          } else {
            to.name = 'crPackages';
          }
          break;
      }
      this.$router.push({
        name: to.name,
        params: to.params
      });
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.getBindingList(index, this.searchKey, this.searchInput);
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    },
    upElement: function upElement(bind) {
      var _this4 = this;

      var url = this.base + this.id + '/itemBinding/' + bind.item_id;
      var data = {
        name: bind.edit_name,
        remark: bind.remark,
        type: this.tab,
        vendor_custom_id: bind.edit_vendor_custom_id
      };
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          bind.edit_state = !bind.edit_state;
          bind.vendor_custom_id = bind.edit_vendor_custom_id;
          bind.remark = bind.remark;
          bind.name = bind.edit_name;
          _this4.$notify({
            title: '提醒',
            text: '已更新' + bind.name,
            duration: 3000,
            type: 'success',
            width: 400
          });
        }
      });
    },
    updateChoose: function updateChoose(val) {
      console.log('updateChoose', val);
      this.copyOptionsChoose = val;
    },
    setEditDefault: function setEditDefault() {
      for (var i = 0; i < this.bindList.length; i++) {
        this.$set(this.bindList[i], 'edit_name', this.bindList[i].name);
        this.$set(this.bindList[i], 'edit_vendor_custom_id', this.bindList[i].vendor_custom_id);
        this.$set(this.bindList[i], 'remark', this.bindList[i].remark);
        this.$set(this.bindList[i], 'edit_state', false);
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    tabName: function tabName() {
      switch (this.tab) {
        case 2:
          return '配料';
        case 20:
          return '配料群組';
        case 10:
          return '商品分類';
        case 1:
          return '商品';
        case 11:
          return '品項選擇區';
        case 3:
          return '套餐';
      }
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  }),
  watch: {
    selectActive: function selectActive() {
      this.tableIndex = 1;
      this.searchInput = '';
    },
    tab: function tab() {
      this.tableIndex = 1;
      this.searchInput = '';
      this.searchKey = 'name';
      this.selectall = false;
      this.deletestatus = false;
      this.setEditDefault();
    },
    bindList: function bindList() {
      this.setEditDefault();
    },
    bindMeta: function bindMeta() {
      this.total = this.bindMeta.total;
      this.count = this.bindMeta.size;
    },
    key: function key() {
      this.searchKey = this.key;
    },
    input: function input() {
      this.searchInput = this.input;
    },
    tableIndex: function tableIndex() {
      this.selectall = false;
    }
  },
  created: function created() {
    if (this.input !== '') {
      this.searchInput = this.input;
    }
    if (this.skey !== '') {
      this.searchKey = this.skey;
    }
    if (this.sPage !== 1) {
      this.tableIndex = Number(this.sPage);
    }
  },
  mounted: function mounted() {
    console.log('mounted');
    if (this.getRoleType === 10) {
      this.storeId = Number(this.$route.params.brand_id);
    } else {
      this.brandId = Number(this.$route.params.brand_id);
    }
  }
});

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CombineModal',
  props: {
    modalId: {
      type: String,
      required: true
    },

    state: {
      type: Number
    },
    productId: {
      type: Number,
      required: true
    },
    productName: {
      type: String
    },
    type: {
      type: String
    }
  },
  data: function data() {
    return {
      editState: false,
      page: 1,
      tabIndex: 1,
      tableIndex: 1,
      adjustIndex: 1,
      count: 20,
      maxTotal: 0,
      maxAdjustTotal: 0,
      show: {
        delNotify: false
      },
      buff: {},
      optionsAmount: {},
      chooseOptions: {},
      adjustNumList: [],
      changePriceList: {},
      isAdjust: [],
      isOption: [],
      isAdjustNumList: [],
      adjust: [],
      option: [],
      combineInfo: {},
      combineDetail: {
        name: '',
        is_common: '0',
        price: '',
        price_type: '3',
        description: '',
        remark: '',
        combine_id: ''
      },
      chosen: {
        adjust: '',
        option: ''
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['setUpCategory', 'setModal']), {
    init: function init() {
      if (typeof this.info !== 'undefined') {
        this.brandName = this.info.name;
        this.brandType = this.info.type;
      }
    },
    toggle: function toggle() {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.infoCategoryModal).css('display');
    },
    getPriceType: function getPriceType(type) {
      if (type === 1) return '免稅價格';else if (type === 3) return '含稅價格';
    },
    maxAmount: function maxAmount(max) {
      if (!max) return '無限制';else return max;
    },
    getOption: function getOption(index) {
      return this.option[index];
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    isTabActive: function isTabActive(index) {
      if (this.tabIndex === index) return true;else return false;
    },
    isAdjustActive: function isAdjustActive(index) {
      if (this.adjustIndex === index) return true;else return false;
    },
    getCombineInfo: function getCombineInfo(index) {
      var self = this;
      if (index) this.tableIndex = index;
      var url = 'brand/' + this.$route.params.brand_id + '/product/' + this.productId + '/combinationlist?page=' + this.tableIndex + '&size=' + this.count;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.combineInfo = response.data.combination_list;
          self.maxTotal = response.data.meta.total;
          if (self.combineInfo.length) {
            self.clickCombine(self.combineInfo[0], 0);
          }
        }
      });
    },
    clickCombine: function clickCombine(combine, index) {
      this.tabIndex = index + 1;
      this.getCombineDetail(combine.combine_id);
    },
    getCombineDetail: function getCombineDetail(comId) {
      var self = this;
      comId = parseInt(comId, 10);
      var url = 'brand/' + this.$route.params.brand_id + '/combination/' + comId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.combineDetail = response.data.combination;
          self.isAdjust = self.combineDetail.adjust_list;
          self.isOption = self.combineDetail.option_list;
          for (var i = 0; i < self.isAdjust.length; i++) {
            self.isAdjustNumList.push(self.isAdjust[i].adjust_id);
          }
          self.getOptions('info');
        }
      });
    },
    getOptions: function getOptions(type) {
      if (type) {
        if (this.isAdjustNumList.length) {
          for (var i = 0; i < this.isAdjustNumList.length; i++) {
            this.optionByAId(this.isAdjustNumList[i], null, type);
          }
        }
      } else {
        if (this.adjustNumList.length) {
          for (var j = 0; j < this.adjustNumList.length; j++) {
            this.optionByAId(this.adjustNumList[j], null, type);
          }
        }
      }
    },
    optionByAId: function optionByAId(adjustId, index, type) {
      var page = 1;
      if (index) page = index;
      var self = this;
      if (adjustId) {
        var url = 'brand/' + this.$route.params.brand_id + '/adjust/' + adjustId + '/optionlist?page=' + page + '&size=' + this.count;
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            var adjustId = response.data.meta.adjust_id;
            var oList = response.data.option_list;
            self.optionsAmount[adjustId] = oList.length;
            for (var i in oList) {
              oList[i]['tag'] = false;
            }
            if (!type) {
              self.adjust.filter(function (elem, index, obj) {
                if (elem.adjust_id === adjustId) {
                  self.$set(elem, 'option_list', oList);
                  self.$set(elem, 'option_total', response.data.meta.total);
                  self.$set(elem, 'page', page);
                }
                return elem.adjust_id === adjustId;
              });
            } else {
              self.isAdjust.filter(function (elem, index, obj) {
                if (elem.adjust_id === adjustId) {
                  self.$set(elem, 'option_list', oList);
                  self.$set(elem, 'option_total', response.data.meta.total);
                  self.$set(elem, 'page', page);
                }
                return elem.adjust_id === adjustId;
              });
            }
          }
        });
      }
    },
    clickEdit: function clickEdit() {
      this.editState = true;
      this.showActiveOption();
    },
    showActiveOption: function showActiveOption() {
      var self = this;
      for (var m in self.adjust) {
        var aa = self.adjust[m];
        for (var n in aa.option_list) {
          aa.option_list[n].tag = false;
          for (var k in self.isOption) {
            if (aa.option_list[n].option_id === self.isOption[k].option_id) {
              self.chooseOption(self.isOption[k], aa);
            }
          }
        }
      }
      for (var i in self.isAdjust) {
        var a = self.isAdjust[i];
        for (var j in a.option_list) {
          self.chooseOption(a.option_list[j], a);
        }
      }
    },
    getAllAdjust: function getAllAdjust(index) {
      var self = this;
      if (index) this.adjustIndex = index;
      var url = 'brand/' + this.$route.params.brand_id + '/adjust/list?page=' + this.adjustIndex + '&size=' + this.count;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.maxAdjustTotal = response.data.meta.total;
          for (var i = 0; i < response.data.adjust_list.length; i++) {
            self.adjust.push(response.data.adjust_list[i]);
            self.adjustNumList.push(response.data.adjust_list[i].adjust_id);
            self.chooseOptions[response.data.adjust_list[i].adjust_id] = {
              active_count: 0,
              active_options: []
            };
          }
          if (response.data.adjust_list.length) {
            self.adjustIndex = self.adjustIndex + 1;
            self.getAllAdjust(self.adjustIndex);
          } else self.getOptions();
        }
      });
    },
    clearData: function clearData() {
      this.page = 1;
      this.tabIndex = 1;
      this.tableIndex = 1;
      this.adjustIndex = 1;
      this.maxTotal = 0;
      this.maxAdjustTotal = 0;
      this.show = {
        delNotify: false
      };
      this.buff = {};
      this.optionsAmount = {};
      this.chooseOptions = {};
      this.adjustNumList = [];
      this.isAdjust = [];
      this.isOption = [];
      this.adjust = [];
      this.option = [];
      this.combineInfo = {};
      this.combineDetail = {
        name: '',
        is_common: '0',
        price: '',
        price_type: '3',
        description: '',
        remark: '',
        combine_id: ''
      };
      this.chosen = {
        adjust: '',
        option: ''
      };
    },
    chooseOption: function chooseOption(o, a, allType) {
      var self = this;

      self.adjust.filter(function (elem, index, obj) {
        if (elem.adjust_id === a.adjust_id) {
          elem.option_list.filter(function (e, i, options) {
            if (e.option_id === o.option_id) {
              if (!o.tag && allType !== 'remove') {
                self.chooseOptions[a.adjust_id]['active_count'] = self.chooseOptions[a.adjust_id]['active_count'] + 1;
                self.chooseOptions[a.adjust_id]['active_options'].push(o.option_id);
              } else if (allType === 'all') {} else {
                self.chooseOptions[a.adjust_id]['active_count'] = self.chooseOptions[a.adjust_id]['active_count'] - 1;
                if (self.chooseOptions[a.adjust_id]['active_options'].length) {
                  var _index = self.chooseOptions[a.adjust_id]['active_options'].indexOf(o.option_id);
                  self.chooseOptions[a.adjust_id]['active_options'].splice(_index, 1);
                }
                if (self.chooseOptions[a.adjust_id]['active_count'] < 0) self.chooseOptions[a.adjust_id]['active_count'] = 0;
              }
              if (allType === 'all') self.$set(e, 'tag', true);else if (allType === 'remove') self.$set(e, 'tag', false);else self.$set(e, 'tag', !e.tag);
            }
          });
        }
      });
    },
    chooseOptionsByAdjust: function chooseOptionsByAdjust(a) {
      var self = this;
      var optionList = a.option_list;
      for (var i in optionList) {
        var o = optionList[i];
        self.chooseOption(o, a, 'all');
      }
    },
    removeOptionsByAdjust: function removeOptionsByAdjust(a) {
      var self = this;
      var optionList = a.option_list;
      for (var i in optionList) {
        var o = optionList[i];
        self.chooseOption(o, a, 'remove');
      }
    },
    checkInputEmpty: function checkInputEmpty() {
      if (!this.allInput.name) {
        this.$notify({
          title: '提醒',
          text: '請填寫組合名稱',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.pickChosen();
      }
    },
    pickChosen: function pickChosen() {
      this.chosen = {
        adjust: [],
        option: []
      };
      var self = this;
      for (var i in this.chooseOptions) {
        if (self.chooseOptions[i].active_count === self.optionsAmount[i]) {
          self.chosen.adjust.push(i + '/');
        } else if (self.chooseOptions[i].active_count !== 0) {
          for (var j = 0; j < self.chooseOptions[i].active_options.length; j++) {
            self.chosen.option.push(self.chooseOptions[i].active_options[j] + '/');
          }
        }
      }
      if (!this.chosen.adjust.length && !this.chosen.option.length) {
        this.$notify({
          title: '提醒',
          text: '請選擇此商品的組合選項',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.updateCombine();
      }
    },
    updateCombine: function updateCombine() {
      var self = this;
      var url = 'brand/' + this.$route.params.brand_id + '/combination';
      var data = {
        product_id: this.productId,
        name: this.allInput.name,
        price: this.allInput.price,
        price_type: this.combineDetail.price_type,
        is_common: this.combineDetail.is_common,
        adjust: this.chosen.adjust,
        option: this.chosen.option
      };
      if (!data.price.length) data.price = null;
      if (this.combineDetail.combine_id) data['combine_id'] = this.combineDetail.combine_id;
      if (this.allInput.remark) data['remark'] = this.allInput.remark;

      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '成功新增組合',
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.editState = false;
          var id = self.modalId;
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#' + id).modal('toggle');
        }
      });
    },
    getPrice: function getPrice(price) {
      return price;
    },
    verityPrice: function verityPrice() {
      var e;
      if (this.state === 1) e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.price1);else if (this.state === 3) e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.price3);
      this.combineDetail.price = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    delCombine: function delCombine() {
      var self = this;
      var url = 'brand/' + this.$route.params.brand_id + '/combination?combine_id=' + this.combineDetail.combine_id;

      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '成功刪除組合',
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.editState = false;
          var id = self.modalId;
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#' + id).modal('toggle');
          self.setUpCategory(true);
        }
      });
    }
  }),
  created: function created() {
    this.init();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getModal']), {
    modalState: function modalState() {
      if (this.state === 3 && !this.editState) return this.productName + '組合';
      if (this.editState) return '編輯' + '一般組合';else return '新增組合';
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    allInput: function allInput() {
      return {
        name: this.checkInput(this.combineDetail.name),
        description: this.checkInput(this.combineDetail.description),
        remark: this.checkInput(this.combineDetail.remark),
        price: this.checkInput(this.combineDetail.price)
      };
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.maxTotal / this.count);
    }
  }),
  mounted: function mounted() {
    var self = this;
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.modal').on('hidden.bs.modal', function () {
      self.setModal(false);
      self.clearData();
    });
  },

  watch: {
    getModal: function getModal() {
      if (this.getModal) {
        this.page = 1;
        this.editState = false;
        this.show.delNotify = false;
        if (this.type === 'info') {
          this.getCombineInfo();
        }
        this.getAllAdjust();
      }
    }
  }
});

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PriceInput_vue__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PriceInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__PriceInput_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CombinePriceModal',
  props: {
    modalId: {
      type: String,
      required: true
    },

    state: {
      type: Number
    },
    productId: {
      type: Number,
      required: true
    },
    productName: {
      type: String
    },
    type: {
      type: String
    }
  },
  components: {
    'price-input': __WEBPACK_IMPORTED_MODULE_6__PriceInput_vue___default.a
  },
  data: function data() {
    return {
      editState: false,
      page: 1,
      tabIndex: 1,
      tableIndex: 1,
      adjustIndex: 1,
      count: 20,
      maxTotal: 0,
      maxAdjustTotal: 0,
      show: {
        delNotify: false
      },
      buff: {},
      optionsAmount: {},
      chooseOptions: {},
      adjustNumList: [],
      changePriceList: {},
      oldAdjust: [],
      oldOption: [],
      adjust: [],
      option: [],
      combineInfo: {},
      combineDetail: {},
      chosen: {
        adjust: [],
        option: []
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['setUpCategory', 'setModal']), {
    trigger: function trigger(obj) {
      if (obj.method === 'cancelChange') {
        this.cancelChange(obj.priceList);
      } else if (obj.method === 'changePrice') {
        this.changePrice(obj.priceList);
      }
    },
    init: function init() {
      if (typeof this.info !== 'undefined') {
        this.brandName = this.info.name;
        this.brandType = this.info.type;
      }
    },
    toggle: function toggle() {
      __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.$refs.infoCategoryModal).css('display');
    },
    getPriceType: function getPriceType(type) {
      if (type === 1) return '免稅價格';else if (type === 3) return '含稅價格';
    },
    getPrice: function getPrice(edgePrice, price) {
      if (!edgePrice && (typeof edgePrice === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(edgePrice)) === 'object') {
        return price;
      } else if (typeof edgePrice === 'undefined') {
        return price;
      } else {
        return edgePrice;
      }
    },
    maxAmount: function maxAmount(max) {
      if (!max) return '無限制';else return max;
    },
    getOption: function getOption(index) {
      return this.option[index];
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    isTabActive: function isTabActive(index) {
      if (this.tabIndex === index) return true;else return false;
    },
    isAdjustActive: function isAdjustActive(index) {
      if (this.adjustIndex === index) return true;else return false;
    },
    getCombineInfo: function getCombineInfo(index) {
      var self = this;
      if (index) this.tableIndex = index;
      var url = 'brand/' + this.$route.params.brand_id + '/product/' + this.productId + '/combinationlist?page=' + this.tableIndex + '&size=' + this.count;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.combineInfo = response.data.combination_list;
          self.maxTotal = response.data.meta.total;
          if (self.combineInfo.length) {
            self.clickCombine(self.combineInfo[0], 0);
          }
        }
      });
    },
    clickCombine: function clickCombine(combine, index) {
      this.oldOption = [];
      this.oldAdjust = [];
      this.tabIndex = index + 1;
      this.getCombineDetail(combine.combine_id);
    },
    getCombineDetail: function getCombineDetail(comId) {
      var self = this;
      comId = parseInt(comId, 10);
      var url = 'brand/' + this.$route.params.brand_id + '/combination/' + comId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.combineDetail = response.data.combination;
          self.adjust = self.combineDetail.adjust_list;
          self.option = self.combineDetail.option_list;
          for (var i = 0; i < self.adjust.length; i++) {
            self.adjustNumList.push(self.adjust[i].adjust_id);
            self.oldAdjust.push({
              adjust_id: self.adjust[i].adjust_id,
              price: self.adjust[i].price
            });
          }
          for (var j = 0; j < self.option.length; j++) {
            self.oldOption.push({
              option_id: self.option[j].option_id,
              price: self.option[j].price
            });
          }
          self.getOptions();
        }
      });
    },
    getOptions: function getOptions() {
      var self = this;

      for (var i = 0; i < self.adjust.length; i++) {
        var aPrice = self.adjust[i].price;
        if (self.adjust[i].edge_price) aPrice = self.adjust[i].edge_price;
        self.oldAdjust.push({
          adjust_id: self.adjust[i].adjust_id,
          price: aPrice
        });
      }
      for (var j = 0; j < self.option.length; j++) {
        var oPrice = self.option[j].price;
        if (self.option[j].edge_price) oPrice = self.option[j].edge_price;
        self.oldOption.push({
          adjust_id: self.option[j].option_id,
          price: oPrice
        });
      }
      if (this.adjustNumList.length) {
        for (var _i = 0; _i < this.adjustNumList.length; _i++) {
          this.optionByAId(this.adjustNumList[_i]);
        }
      }
    },
    optionByAId: function optionByAId(adjustId, index) {
      var page = 1;
      if (index) page = index;
      var self = this;
      if (adjustId) {
        var url = 'brand/' + this.$route.params.brand_id + '/adjust/' + adjustId + '/optionlist?page=' + page + '&size=' + this.count;
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            var adjustId = response.data.meta.adjust_id;
            var oList = response.data.option_list;
            self.optionsAmount[adjustId] = oList.length;
            for (var i in oList) {
              oList[i]['tag'] = false;
            }
            self.oldAdjust.filter(function (elem, index, obj) {
              if (elem.adjust_id === adjustId) {
                self.$set(elem, 'option_old_list', []);
                for (var j in oList) {
                  var oPrice = oList[j].price;
                  if (oList[j].edge_price) oPrice = oList[j].edge_price;
                  var o = {
                    option_id: oList[j].option_id,
                    price: oPrice
                  };
                  elem.option_old_list.push(o);
                }
              }
            });
            self.adjust.filter(function (elem, index, obj) {
              if (elem.adjust_id === adjustId) {
                self.$set(elem, 'option_list', oList);
              }
            });
            self.stOldAdjust(adjustId, oList);
          }
        });
      }
    },
    stOldAdjust: function stOldAdjust(adjustId, oList) {
      var self = this;
      self.oldAdjust.filter(function (elem, index, obj) {
        if (elem.adjust_id === adjustId) {
          self.$set(elem, 'option_old_list', []);
          for (var j in oList) {
            var o = {
              option_id: oList[j].option_id,
              price: oList[j].price
            };
            elem.option_old_list.push(o);
          }
        }
      });
    },
    getAllAdjust: function getAllAdjust(index) {
      var self = this;
      if (index) this.adjustIndex = index;
      var url = 'brand/' + this.$route.params.brand_id + '/adjust/list?page=' + this.adjustIndex + '&size=' + this.count;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.maxAdjustTotal = response.data.meta.total;
          for (var i = 0; i < response.data.adjust_list.length; i++) {
            self.adjust.push(response.data.adjust_list[i]);
            self.adjustNumList.push(response.data.adjust_list[i].adjust_id);
            self.chooseOptions[response.data.adjust_list[i].adjust_id] = {
              active_count: 0,
              active_options: []
            };
          }
          if (response.data.adjust_list.length) {
            self.adjustIndex = self.adjustIndex + 1;
            self.getAllAdjust(self.adjustIndex);
          } else self.getOptions();
        }
      });
    },
    clearData: function clearData() {
      this.adjust = [];
      this.option = [];
      this.adjustNumList = [];
      this.oldOption = [];
      this.oldAdjust = [];
    },
    chooseOption: function chooseOption(o, a, allType) {
      var self = this;

      self.adjust.filter(function (elem, index, obj) {
        if (elem.adjust_id === a.adjust_id) {
          elem.option_list.filter(function (e, i, options) {
            if (e.option_id === o.option_id) {
              if (!o.tag && allType !== 'remove') {
                self.chooseOptions[a.adjust_id]['active_count'] = self.chooseOptions[a.adjust_id]['active_count'] + 1;
                self.chooseOptions[a.adjust_id]['active_options'].push(o.option_id);
              } else if (allType === 'all') {} else {
                self.chooseOptions[a.adjust_id]['active_count'] = self.chooseOptions[a.adjust_id]['active_count'] - 1;
                if (self.chooseOptions[a.adjust_id]['active_options'].length) {
                  var _index = self.chooseOptions[a.adjust_id]['active_options'].indexOf(o.option_id);
                  self.chooseOptions[a.adjust_id]['active_options'].splice(_index, 1);
                }
                if (self.chooseOptions[a.adjust_id]['active_count'] < 0) self.chooseOptions[a.adjust_id]['active_count'] = 0;
              }
              if (allType === 'all') o.tag = true;else if (allType === 'remove') o.tag = false;else o.tag = !o.tag;
            }
          });
        }
      });
    },
    chooseOptionsByAdjust: function chooseOptionsByAdjust(a) {
      var self = this;
      var optionList = a.option_list;
      for (var i in optionList) {
        var o = optionList[i];
        self.chooseOption(o, a, 'all');
      }
    },
    removeOptionsByAdjust: function removeOptionsByAdjust(a) {
      var self = this;
      var optionList = a.option_list;
      for (var i in optionList) {
        var o = optionList[i];
        self.chooseOption(o, a, 'remove');
      }
    },
    cancelChange: function cancelChange(priceList) {
      for (var key in this.changePriceList) {
        if (key === __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(priceList)) this.changePriceList.splice(key, 1);
      }
      if (!this.changePriceList.length) this.changePriceList = {};
    },
    changePrice: function changePrice(priceList) {
      if (parseInt(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(priceList), 10)) {
        this.changePriceList[__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(priceList)] = parseInt(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(priceList), 10);
      }
      var adjustId = '';

      var optionList = {};
      for (var i = 0; i < this.adjust.length; i++) {
        if (this.adjust[i].adjust_id === parseInt(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(priceList), 10)) {
          adjustId = this.adjust[i].adjust_id;
          optionList = this.adjust[i].option_list;
        }
      }

      for (var j = 0; j < optionList.length; j++) {
        for (var key in this.changePriceList) {
          if (parseInt(key, 10) === optionList[j].option_id) {
            if (!this.buff[adjustId]) this.buff[adjustId] = {};
            this.buff[adjustId][key] = this.changePriceList[key];
            delete this.changePriceList[key];
          }
        }
      }
    },
    checkInputEmpty: function checkInputEmpty() {
      this.chosen = {
        adjust: [],
        option: []
      };
      for (var i = 0; i < this.adjust.length; i++) {
        if (this.adjust[i].price !== this.oldAdjust[i].price) {
          this.chosen.adjust.push(this.adjust[i].adjust_id + '/' + this.adjust[i].price);
        } else {
          var tag = false;
          var oList = this.adjust[i].option_list;
          var oldOList = this.oldAdjust[i].option_old_list;

          if (oList.length) {
            for (var j = 0; j < oList.length; j++) {
              if (oList[j].price !== oldOList[j].price) {
                tag = true;
                break;
              }
            }
          }
          if (!tag) {
            this.chosen.adjust.push(this.adjust[i].adjust_id + '/');
          } else {
            for (var k = 0; k < oList.length; k++) {
              if (oList[k].price !== oldOList[k].price) {
                this.chosen.option.push(oList[k].option_id + '/' + oList[k].price);
              } else {
                this.chosen.option.push(oList[k].option_id + '/');
              }
            }
          }
        }
      }
      for (var m = 0; m < this.option.length; m++) {
        if (this.option[m].price !== this.oldOption[m].price) {
          this.chosen.option.push(this.option[m].option_id + '/' + this.option[m].price);
        } else {
          this.chosen.option.push(this.option[m].option_id + '/');
        }
      }

      this.updateCombine();
    },
    updateCombine: function updateCombine() {
      var self = this;
      var url = 'brand/' + this.$route.params.brand_id + '/combination';
      var data = {
        combine_id: this.combineDetail.combine_id,
        adjust: this.chosen.adjust,
        option: this.chosen.option,
        product_id: this.productId,

        name: this.combineDetail.name,
        price: this.combineDetail.price,
        price_type: this.combineDetail.price_type,
        is_common: this.combineDetail.is_common
      };

      if (this.combineDetail.remark) data['remark'] = this.combineDetail.remark;

      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '成功修改組合價格',
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.editState = false;
          var id = self.modalId;
          __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#' + id).modal('toggle');
        }
      });
    }
  }),
  created: function created() {
    this.init();
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getModal']), {
    modalState: function modalState() {
      if (this.state === 3 && !this.editState) return this.productName + '組合';
      if (this.editState) return '編輯' + '一般組合';else return '新增組合';
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    allInput: function allInput() {
      return {
        name: this.checkInput(this.productInfo.name),
        sort: this.checkInput(this.productInfo.sort),
        vendor_custom_id: this.checkInput(this.productInfo.product_custom_id),
        description: this.checkInput(this.productInfo.description),
        remark: this.checkInput(this.productInfo.remark),
        price: this.checkInput(this.productInfo.price),
        calorie: this.checkInput(this.productInfo.calorie),
        min_limit: this.checkInput(this.productInfo.min_limit),
        max_limit: this.checkInput(this.productInfo.max_limit)
      };
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.maxTotal / this.count);
    }
  }),
  mounted: function mounted() {
    var self = this;
    __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.modal').on('hidden.bs.modal', function () {
      self.setModal(false);
      self.clearData();
    });
  },

  watch: {
    getModal: function getModal() {
      if (this.getModal) {
        this.page = 1;
        this.editState = false;
        this.show.delNotify = false;
        if (this.type === 'info') {
          this.getCombineInfo();
        }
      }
    }
  }
});

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      storeBrief: [],
      addStoresSetting: {
        class: 'copy-store',
        options: [],
        choose: []
      },
      storeClassList: [],
      curId: 0,
      reNew: 0,
      reSet: 0
    };
  },

  methods: {
    getStoreBrief: function getStoreBrief() {
      console.log('getStoreBrief | CopyStoreTemp');
      this.storeBrief = [];
      this.addStoresSetting.options = [];
      var self = this;
      var url = '/brand/' + this.$route.params.brand_id + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.getStoreClassList();
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            if (parseInt(sList[i].store_id, 10) !== parseInt(self.$route.params.store_id, 10)) {
              self.storeBrief.push(obj);
              self.addStoresSetting.options.push(obj);
            }
          }
          self.reNew++;
        }
      });
    },
    getStoreClassList: function getStoreClassList() {
      if (this.getRoleType === 10) return;
      var self = this;
      var url = 'brand/' + this.$route.params.brand_id + '/storeClassList';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          self.storeClassList = sList;
        }
      });
    },
    copySetting: function copySetting() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = {
                  store_id_list: _this.addStoresSetting.choose
                };

                if (!_this.$route.name.includes('ProductSetting')) {
                  _context.next = 9;
                  break;
                }

                _context.next = 4;
                return _this.productAliasStoreSync(data);

              case 4:
                _context.next = 6;
                return _this.productDescriptionStoreSync(data);

              case 6:
                _this.$router.push({ path: '/storeTable/productSetting/' + _this.$route.params.brand_id });
                _context.next = 13;
                break;

              case 9:
                if (!_this.$route.name.includes('ProductImage')) {
                  _context.next = 13;
                  break;
                }

                _context.next = 12;
                return _this.productImageStoreSync(data);

              case 12:
                _this.$router.push({ path: '/storeTable/productImage/' + _this.$route.params.brand_id });

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    productAliasStoreSync: function productAliasStoreSync(data) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var self, url;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                self = _this2;
                url = '/store/' + _this2.$route.params.store_id + '/productAliasSetting/storeSync';
                _context2.next = 4;
                return _this2.getDataH('post', url, data, function (response) {
                  if (response.data.status === 200) {
                    self.$notify({
                      title: '複製門市別名成功',
                      duration: 3000,
                      type: 'success',
                      width: 400
                    });
                  }
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    productDescriptionStoreSync: function productDescriptionStoreSync(data) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var self, url;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                self = _this3;
                url = '/store/' + _this3.$route.params.store_id + '/productDescriptionSetting/storeSync';
                _context3.next = 4;
                return _this3.getDataH('post', url, data, function (response) {
                  if (response.data.status === 200) {
                    self.$notify({
                      title: '複製門市描述成功',
                      duration: 3000,
                      type: 'success',
                      width: 400
                    });
                  }
                });

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    productImageStoreSync: function productImageStoreSync(data) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var self, url;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                self = _this4;
                url = '/store/' + _this4.$route.params.store_id + '/productImageSetting/storeSync';
                _context4.next = 4;
                return _this4.getDataH('post', url, data, function (response) {
                  if (response.data.status === 200) {
                    self.$notify({
                      title: '複製門市圖片成功',
                      duration: 3000,
                      type: 'success',
                      width: 400
                    });
                  }
                });

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    clickOption: function clickOption(option) {
      var self = this;
      this.addStoresSetting.options = [];
      self.curId = option.id;
      if (self.curId) {
        self.$nextTick(function () {
          self.reSet++;
          self.addStoresSetting.options = self.storeBrief;
          self.getCurStoreClass();
        });
      }
    },
    getCurStoreClass: function getCurStoreClass() {
      var _this5 = this;

      this.addStoresSetting.choose = [];
      var url = 'brand/' + this.$route.params.brand_id + '/storeClass/' + this.curId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var classInfo = response.data.class;
          classInfo.store_list.forEach(function (s) {
            if (s.id !== parseInt(_this5.$route.params.store_id, 10)) {
              _this5.addStoresSetting.choose.push(s.id);
            }
          });
        }
      });
    }
  },
  created: function created() {
    this.getStoreBrief();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  })
});

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AdjustModal_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AdjustModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AdjustModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OptionModal_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OptionModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__OptionModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_ChooseModal_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_ChooseModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__elements_ChooseModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__extends_nd_extend_handle_menu_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__extends_nd_extend_handle_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__extends_nd_extend_handle_menu_vue__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CrAdjustTemp',
  props: {
    'info': {
      type: Object
    }
  },
  extends: __WEBPACK_IMPORTED_MODULE_8__extends_nd_extend_handle_menu_vue___default.a,
  components: {
    'adjust-modal': __WEBPACK_IMPORTED_MODULE_4__AdjustModal_vue___default.a,
    'option-modal': __WEBPACK_IMPORTED_MODULE_5__OptionModal_vue___default.a,
    'c-modal': __WEBPACK_IMPORTED_MODULE_7__elements_ChooseModal_vue___default.a,
    'm-modal': __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue___default.a
  },
  data: function data() {
    return {
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      menuId: this.$route.params.menu_id,
      brandId: this.$route.params.brand_id,
      show: {
        easy: true
      },
      current: {
        option: 0,
        adjust: 0,
        adjustId: 0,
        adjustName: '',
        adjustSubType: 0
      },
      brandName: '',
      brandType: '',
      adjustNumList: [],
      adjust: [],
      option: [],
      amount: {
        adjust: 1,
        option: 1
      },
      count: 20,
      maxTotal: 0,
      adjustList: [],
      optionList: [],
      adjustInfo: {
        name: '',
        sort: 1,
        description: '',
        remark: '',
        price: '',
        price_type: '3',
        calorie: '',
        min_limit: 0,
        max_limit: 1,
        vendor_custom_id: '',
        is_mandatory: '0',
        is_common: '0',
        sub_type: '0'
      },
      choseOption: {
        id: 'choseModal',
        title: '選擇配料',
        event: 'chooseElement'
      },
      curId: 0,
      oldInfo: {},
      isLoad: false,
      defaultIndex: 1,
      delOption: {
        id: 'delModal',
        title: '刪除配料群組',
        body: '刪除時，若被上架中的菜單使用中，則會被阻擋',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'del'
        }]
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapActions */])(['setUpAdjust', 'setModal']), {
    delModalOpen: function delModalOpen(bind) {
      this.delOption.title = '刪除' + this.adjustInfo.name;
    },
    trigger: function trigger(event) {
      if (event === 'del') {
        this.del(this.adjustInfo.name);
      }
    },
    del: function del(delName) {
      var _this = this;

      var url = this.base + this.id + '/adjust?adjust_id=' + this.adjustInfo.adjust_id;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          _this.$notify({
            title: '提醒',
            text: '成功刪除' + delName,
            duration: 3000,
            type: 'success',
            width: 400
          });
          _this.getMenuAdjust('delete');
        }
      });
    },
    toggle: function toggle() {
      __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$refs.infoAdjustModal).css('display');
    },
    maxAmount: function maxAmount(max) {
      if (!max) return '無限制';else return max;
    },
    getSubType: function getSubType(type) {
      if (type === 10) {
        return '大小';
      } else if (type === 20) {
        return '容器';
      } else if (type === 30) {
        return '甜度';
      } else if (type === 40) {
        return '溫度';
      } else {
        return '其他';
      }
    },
    getPriceType: function getPriceType(type) {
      if (type === 1) return '免稅價格';else if (type === 3) return '含稅價格';
    },
    veritySort: function veritySort() {
      var e = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$refs.sort);
      this.adjustInfo.sort = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityMinLimit: function verityMinLimit() {
      var e = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$refs.minLimit);
      this.adjustInfo.min_limit = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityMaxLimit: function verityMaxLimit() {
      var e = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$refs.maxLimit);
      this.adjustInfo.max_limit = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityPrice: function verityPrice() {
      var e = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$refs.price);
      this.adjustInfo.price = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityCalorie: function verityCalorie() {
      var e = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$refs.calorie);
      this.adjustInfo.calorie = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    clickAdjust: function clickAdjust(adjust, index) {
      this.isLoad = true;
      this.curId = adjust.item_id;
      this.defaultIndex = index + 1;
      this.getMenuAdjust();
    },
    getAdjustInfo: function getAdjustInfo() {
      var url = this.base + this.id + '/adjust/' + this.adjustId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          url.adjustInfo = response.data.adjust;
        }
      });
    },
    checkInputEmpty: function checkInputEmpty() {
      if (!this.adjustInfo.sub_type && parseInt(this.adjustInfo.sub_type, 10) !== 0) {
        this.$notify({
          title: '提醒',
          text: '請選擇分類',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!this.allInput.name) {
        this.$notify({
          title: '提醒',
          text: '請填寫調整類別名稱',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!this.allInput.sort) {
        this.$notify({
          title: '提醒',
          text: '請填寫排序',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!parseInt(this.allInput.sort, 10)) {
        this.$notify({
          title: '請填寫正確排序',
          text: '排序範圍為1~9999',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!this.allInput.min_limit) {
        this.$notify({
          title: '提醒',
          text: '請填寫最低購買數',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!this.allInput.max_limit) {
        this.$notify({
          title: '提醒',
          text: '請填寫最高購買數',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.upAdjust();
        return true;
      }
    },
    upAdjust: function upAdjust(type) {
      var _this2 = this;

      var url = this.base + this.id + '/adjust/' + this.curId;
      var data = {};
      var aInfo = this.adjustInfo;
      var oldInfo = this.oldInfo;
      if (type === 'sort') {
        data.sort = aInfo.sort;
        data.price = aInfo.price;
        data.max_limit = aInfo.max_limit;
      } else {
        var cList = [];
        this.optionList.forEach(function (element) {
          if (element.active) cList.push(element.item_id);
        });
        var aList = [];
        aInfo.option_list.forEach(function (element) {
          aList.push(element.option_id);
        });
        if (aInfo.sub_type !== oldInfo.sub_type) data.sub_type = aInfo.sub_type;
        if (aInfo.sort !== oldInfo.sort) data.sort = aInfo.sort;
        if (aInfo.name !== oldInfo.name) data.name = aInfo.name;
        if (aInfo.vendor_custom_id !== oldInfo.vendor_custom_id) data.vendor_custom_id = aInfo.vendor_custom_id;
        if (aInfo.description !== oldInfo.description) data.description = aInfo.description;
        if (aInfo.remark !== oldInfo.remark) data.remark = aInfo.remark;
        if (aInfo.price !== oldInfo.price) data.price = aInfo.price;
        if (aInfo.price_type !== oldInfo.price_type) data.price_type = aInfo.price_type;
        if (aInfo.calorie !== oldInfo.calorie) data.calorie = aInfo.calorie;
        if (aInfo.is_mandatory !== oldInfo.is_mandatory) data.is_mandatory = aInfo.is_mandatory;
        if (aInfo.min_limit !== oldInfo.min_limit) data.min_limit = aInfo.min_limit;
        if (aInfo.max_limit !== oldInfo.max_limit) data.max_limit = aInfo.max_limit;
        if (aInfo.is_common !== oldInfo.is_common) data.is_common = aInfo.is_common;
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(aList) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(cList)) {
          data.option_list = cList;
        }
      }
      if (data.price === '') data.price = null;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data) !== '{}') {
        this.getDataH('put', url, data, function (response) {
          if (response.data.status === 200) {
            if (!type) {
              _this2.$notify({
                title: '提醒',
                text: '已更新' + aInfo.name,
                duration: 3000,
                type: 'success',
                width: 400
              });
            }
            if (aInfo.name !== oldInfo.name) {
              _this2.getMenuAdjust('reload', aInfo.adjust_id);
            }
          }
        });
      }
    },
    delAdjust: function delAdjust() {
      var _this3 = this;

      var url = this.base + this.id + '/adjust?adjust_id=' + this.adjustId;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          _this3.$notify({
            title: '提醒',
            text: '成功刪除調整類別',
            duration: 3000,
            type: 'success',
            width: 400
          });
          _this3.editState = false;
          var id = _this3.modalId;
          __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#' + id).modal('toggle');
          _this3.setUpAdjust(true);
        }
      });
    },
    clearData: function clearData() {
      this.adjustInfo = {
        name: '',
        sort: 1,
        description: '',
        remark: '',
        price: '',
        price_type: '3',
        calorie: '',
        min_limit: '0',
        max_limit: '0',
        adjust_custom_id: '',
        is_mandatory: '0',
        is_common: '0',
        sub_type: '0'
      };
    },
    gotoCrAdjusts: function gotoCrAdjusts() {
      console.log('gotoCrAdjusts');
      var name = '';
      var params = {
        brand_id: this.$route.params.brand_id,
        store_id: ''
      };

      if (this.isStore && this.getRoleType !== 10) {
        name = 'StoreMenuAdjustCreate';
        params.store_id = this.$route.params.store_id;
      } else {
        name = 'crAdjusts';
      }

      this.$router.push({ name: name, params: params });
    },
    gotoOut: function gotoOut() {
      this.$router.go(-1);
    },
    gotoNext: function gotoNext() {
      this.$router.push('/upCategory/' + this.brandId);
    },
    getMenuAdjust: function getMenuAdjust(type) {
      var _this4 = this;

      var url = this.base + this.id + '/adjust/briefList';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var adjustList = response.data.list;
          _this4.adjustList = adjustList;
          if (adjustList.length && !_this4.curId || type === 'delete') {
            if (_this4.$route.query.aId) _this4.curId = parseInt(_this4.$route.query.aId, 10);else _this4.curId = adjustList[0].item_id;
          }
          _this4.getMenuOption();
        }
      });
    },
    getMenuOption: function getMenuOption() {
      var _this5 = this;

      this.optionList = [];
      var url = this.base + this.id + '/option/briefList?type=2';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          if (response.data.list.length) {
            var optionList = response.data.list[0].child_list;
            optionList.forEach(function (element) {
              element.active = false;
              _this5.optionList.push(element);
            });
            _this5.getAdjust();
          } else if (_this5.curId) {
            _this5.getAdjust();
          }
        }
      });
    },
    setActiveOption: function setActiveOption() {
      var _this6 = this;

      if (this.adjustInfo.option_list.length) {
        this.adjustInfo.option_list.forEach(function (o) {
          var option = {
            active: true,
            description: o.description,
            item_id: o.option_id,
            name: o.name,
            price: o.price,
            remark: o.remark,
            vendor_custom_id: o.vendor_custom_id
          };
          _this6.optionList.push(option);
          _this6.isLoad = false;
        });
      } else {
        this.isLoad = false;
      }
    },
    getAdjust: function getAdjust() {
      var _this7 = this;

      var url = this.base + this.id + '/adjust/' + this.curId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.each(response.data.adjust, function (index, value) {
            _this7.$set(_this7.oldInfo, index, value);
          });
          _this7.adjustInfo = response.data.adjust;
          if (!_this7.adjustInfo.sort || !_this7.adjustInfo.price && parseInt(_this7.adjustInfo.price, 10) !== 0) {
            if (!_this7.adjustInfo.sort) _this7.adjustInfo.sort = _this7.defaultIndex;
            if (!_this7.adjustInfo.price && parseInt(_this7.adjustInfo.price, 10) !== 0) _this7.adjustInfo.price = '';
            if (!_this7.adjustInfo.max_limit && parseInt(_this7.adjustInfo.max_limit, 10) !== 0) _this7.adjustInfo.max_limit = 1;
            _this7.upAdjust('sort');
          }
          _this7.setActiveOption();
        }
      });
    }
  }),
  created: function created() {
    this.getMenuAdjust();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['getUpAdjust', 'getModal', 'getRoleType']), {
    modalState: function modalState() {
      if (this.state === 3 && !this.editState) return this.adjustInfo.name;
      if (this.editState) return '編輯' + this.adjustInfo.name;else return '新增調整類別';
    },
    allInput: function allInput() {
      return {
        name: this.checkInput(this.adjustInfo.name),
        sort: this.checkInput(this.adjustInfo.sort),
        vendor_custom_id: this.checkInput(this.adjustInfo.vendor_custom_id),
        description: this.checkInput(this.adjustInfo.description),
        remark: this.checkInput(this.adjustInfo.remark),
        price: this.checkInput(this.adjustInfo.price),
        calorie: this.checkInput(this.adjustInfo.calorie),
        min_limit: this.checkInput(this.adjustInfo.min_limit),
        max_limit: this.checkInput(this.adjustInfo.max_limit)
      };
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    productNew: function productNew() {
      var product = this.product;
      return product;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.maxTotal / this.count);
    }
  })
});

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AdjustModal_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AdjustModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AdjustModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OptionModal_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OptionModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__OptionModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_ChooseModal_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_ChooseModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__elements_ChooseModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_ProductInfoModal_vue__ = __webpack_require__(2092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_ProductInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__elements_ProductInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__extends_nd_extend_handle_menu_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__extends_nd_extend_handle_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__extends_nd_extend_handle_menu_vue__);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CrBlockTemp',

  components: {
    AdjustModal: __WEBPACK_IMPORTED_MODULE_4__AdjustModal_vue___default.a,
    OptionModal: __WEBPACK_IMPORTED_MODULE_5__OptionModal_vue___default.a,
    CModal: __WEBPACK_IMPORTED_MODULE_7__elements_ChooseModal_vue___default.a,
    MModal: __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue___default.a,
    PIModal: __WEBPACK_IMPORTED_MODULE_8__elements_ProductInfoModal_vue___default.a
  },

  extends: __WEBPACK_IMPORTED_MODULE_9__extends_nd_extend_handle_menu_vue___default.a,

  props: {
    'info': {
      type: Object
    }
  },

  data: function data() {
    return {
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      menuId: this.$route.params.menu_id,
      brandId: this.$route.params.brand_id,
      show: {
        easy: true
      },

      current: {
        option: 0,
        adjust: 0,
        adjustId: 0,
        adjustName: '',
        adjustSubType: 0
      },

      brandName: '',
      brandType: '',
      adjustNumList: [],
      adjust: [],
      option: [],
      amount: {
        adjust: 1,
        option: 1
      },

      count: 20,
      maxTotal: 0,
      blockList: [],
      productList: [],
      packageList: [],
      blockInfo: {
        name: '',
        sort: 1,
        is_mandatory: 1,
        category_custom_id: '',
        description: '',
        remark: '',
        min_limit: '0',
        max_limit: '0'
      },

      choseProduct: {
        id: 'choseProdModal',
        title: '選擇商品',
        event: 'chooseProduct'
      },

      chosePackage: {
        id: 'chosePackModal',
        title: '選擇套餐',
        event: 'choosePackage'
      },

      curId: 0,
      oldInfo: {},
      defaultIndex: 1,
      isLoad: false,
      delOption: {
        id: 'delModal',
        title: '刪除商品分類',
        body: '刪除時，若被上架中的菜單使用中，則會被阻擋',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'del'
        }]
      },

      moneyOption: {
        id: 'choseMoneyModal',
        title: '更改商品在套餐內的金額',
        event: 'chooseMoney'
      },

      blockChoseList: [],
      choseOption: {
        id: 'choseModal',
        title: '選擇選擇區',
        event: 'chooseElement'
      }
    };
  },


  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapActions */])(['setUpAdjust', 'setModal']), {
    toggle: function toggle() {
      __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$refs.infoAdjustModal).css('display');
    },
    maxAmount: function maxAmount(max) {
      if (!max) return '無限制';else return max;
    },
    getSubType: function getSubType(type) {
      if (type === 10) {
        return '大小';
      } else if (type === 20) {
        return '容器';
      } else if (type === 30) {
        return '甜度';
      } else if (type === 40) {
        return '溫度';
      } else {
        return '其他';
      }
    },
    getPriceType: function getPriceType(type) {
      if (type === 1) return '免稅價格';else if (type === 3) return '含稅價格';
    },
    veritySort: function veritySort() {
      var e;
      if (this.state === 1) e = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$refs.sort1);else if (this.state === 3) e = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$refs.sort3);
      this.adjustInfo.sort = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityMinLimit: function verityMinLimit() {
      var e = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$refs.minLimit);
      this.blockInfo.min_limit = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityMaxLimit: function verityMaxLimit() {
      var e = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$refs.maxLimit);
      this.blockInfo.max_limit = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityPrice: function verityPrice() {
      var e;
      if (this.state === 1) e = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$refs.price1);else if (this.state === 3) e = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$refs.price3);
      this.adjustInfo.price = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityCalorie: function verityCalorie() {
      var e;
      if (this.state === 1) e = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$refs.calorie1);else if (this.state === 3) e = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$refs.calorie3);
      this.adjustInfo.calorie = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    getAdjustInfo: function getAdjustInfo() {
      var _this = this;

      var url = this.base + this.id + '/adjust/' + this.adjustId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this.adjustInfo = response.data.adjust;
        }
      });
    },
    checkInputEmpty: function checkInputEmpty() {
      if (!this.allInput.name) {
        this.$notify({
          title: '提醒',
          text: '請填寫選擇區名稱',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!this.allInput.sort) {
        this.$notify({
          title: '提醒',
          text: '請填寫排序',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!parseInt(this.allInput.sort, 10)) {
        this.$notify({
          title: '請填寫正確排序',
          text: '排序範圍為1~9999',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!this.allInput.min_limit) {
        this.$notify({
          title: '提醒',
          text: '請填寫最低購買數',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!this.allInput.max_limit) {
        this.$notify({
          title: '提醒',
          text: '請填寫最高購買數',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.upBlock();
        return true;
      }
    },
    delAdjust: function delAdjust() {
      var _this2 = this;

      var url = this.base + this.id + '/adjust?adjust_id=' + this.adjustId;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          _this2.$notify({
            title: '提醒',
            text: '成功刪除調整類別',
            duration: 3000,
            type: 'success',
            width: 400
          });
          _this2.editState = false;
          var id = _this2.modalId;
          __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#' + id).modal('toggle');
          _this2.setUpAdjust(true);
        }
      });
    },
    clearData: function clearData() {
      this.blockInfo = {
        name: '',
        sort: 1,
        category_custom_id: '',
        description: '',
        remark: '',
        min_limit: '0',
        max_limit: '0'
      };
    },
    gotoCrBlocks: function gotoCrBlocks() {
      console.log('gotoCrBlocks');
      var name = '';
      var params = {
        brand_id: this.$route.params.brand_id,
        store_id: ''
      };

      if (this.isStore && this.getRoleType !== 10) {
        name = 'StoreMenuBlockCreate';
        params.store_id = this.$route.params.store_id;
      } else {
        name = 'crBlocks';
      }

      this.$router.push({ name: name, params: params });
    },
    gotoOut: function gotoOut() {
      this.$router.go(-1);
    },
    gotoNext: function gotoNext() {
      this.$router.push('/upProduct/' + this.brandId);
    },
    trigger: function trigger(event) {
      if (event === 'del') {
        this.del(this.blockInfo.name);
      } else if (event === 'chooseElement') {
        this.copyProductContent();
      }
    },
    del: function del(delName) {
      var _this3 = this;

      var url = this.base + this.id + '/block?block_id=' + this.blockInfo.block_id;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          _this3.$notify({
            title: '提醒',
            text: '成功刪除' + delName,
            duration: 3000,
            type: 'success',
            width: 400
          });
          _this3.getMenuBlock('delete');
        }
      });
    },
    getMenuBlock: function getMenuBlock(type, cId) {
      var _this4 = this;

      this.blockList = [];
      var url = this.base + this.id + '/block/briefList?type=0';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var packageList = response.data.list;
          packageList.forEach(function (pa) {
            pa.child_list.forEach(function (block) {
              _this4.blockList.push(block);
            });
          });
          if (_this4.blockList.length && !_this4.curId || type === 'delete') {
            if (_this4.$route.query.cId) _this4.curId = parseInt(_this4.$route.query.cId, 10);else _this4.curId = _this4.blockList[0].item_id;
          }
          if (type === 'clickOther') {
            _this4.curId = cId;
            var scrollHeight = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this4.$refs.selectBlock).height();
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this4.$refs.selectBlock).scrollTop(scrollHeight, 200);
          }
          _this4.blockList = _this4.blockList.reverse();

          var categoryList = response.data.list;
          categoryList.forEach(function (element) {
            var blockList = element.child_list;
            blockList.forEach(function (element) {
              _this4.blockChoseList.push(element);
            });
          });
          _this4.getMenuProduct();
        }
      });
    },
    getMenuProduct: function getMenuProduct() {
      var _this5 = this;

      this.productList = [];
      var url = this.base + this.id + '/product/briefList?type=0';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          if (response.data.list.length) {
            var categoryList = response.data.list;
            categoryList.forEach(function (element) {
              var productList = element.child_list;
              productList.forEach(function (prod) {
                prod.active = false;
                prod.sort = '';
                prod.newPrice = '';
                prod.is_mandatory = '';
                prod.min_limit = '';
                prod.max_limit = '';
                prod.is_default = '';
                _this5.productList.push(prod);
              });
            });
            if (_this5.curId) _this5.getBlock();
          } else if (_this5.curId) _this5.getBlock();
        }
      });
    },
    copyBlock: function copyBlock() {
      var _this6 = this;

      var url = this.base + this.id + '/block/' + this.curId + '/duplicate';
      this.getDataH('post', url, null, function (response) {
        if (response.data.status === 200) {
          _this6.$notify({
            title: '提醒',
            text: '成功複製選擇區',
            duration: 3000,
            type: 'success',
            width: 400
          });
          _this6.getMenuBlock('clickOther', response.data.new_block_id);
        }
      });
    },
    getBlock: function getBlock() {
      var _this7 = this;

      var url = this.base + this.id + '/block/' + this.curId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.each(response.data.block, function (index, value) {
            _this7.$set(_this7.oldInfo, index, value);
          });
          _this7.blockInfo = response.data.block;
          if (!_this7.blockInfo.sort) {
            _this7.blockInfo.sort = _this7.defaultIndex;
            _this7.upBlock('sort');
          }
          _this7.setActiveProduct();
        }
      });
    },
    clickBlock: function clickBlock(block, index) {
      this.isLoad = true;
      this.curId = block.item_id;
      this.defaultIndex = index + 1;
      this.getMenuProduct();
    },
    copyProductContent: function copyProductContent() {
      var bActiveList = [];
      this.blockChoseList.forEach(function (block) {
        if (block.active) {
          bActiveList.push(block);
        }
      });
      for (var i = 0; i < bActiveList.length; i++) {
        if (i === bActiveList.length - 1) this.upProduct(bActiveList[i].item_id, true);else this.upProduct(bActiveList[i].item_id, false);
      }
    },
    upProduct: function upProduct(cId, isLast) {
      var _this8 = this;

      var data = {};
      var pList = [];
      this.productList.forEach(function (element) {
        var obj = {
          product_id: element.item_id
        };
        if (element.newPrice) obj.price = element.newPrice;
        if (element.sort) obj.sort = element.sort;
        if (element.is_mandatory) obj.is_mandatory = element.is_mandatory;
        if (element.min_limit) obj.min_limit = element.min_limit;
        if (element.max_limit) obj.max_limit = element.max_limit;
        if (element.active) pList.push(obj);
      });
      data.product_list = pList;
      var url = this.base + this.id + '/block/' + cId;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data) !== '{}') {
        this.getDataH('put', url, data, function (response) {
          if (response.data.status === 200) {
            if (isLast) {
              _this8.$notify({
                title: '提醒',
                text: '已複製商品內容到其他選擇區',
                duration: 3000,
                type: 'success',
                width: 400
              });
            }
            _this8.clearAllActive(_this8.blockList);
          }
        });
      }
    },
    upBlock: function upBlock(type) {
      var _this9 = this;

      var url = this.base + this.id + '/block/' + this.curId;
      var data = {};
      var bInfo = this.blockInfo;
      var oldInfo = this.oldInfo;
      if (type === 'sort') {
        data.sort = bInfo.sort;
      } else {
        var pList = [];
        this.productList.forEach(function (element) {
          var obj = {
            product_id: element.item_id
          };
          if (element.newPrice) obj.price = element.newPrice;
          if (element.sort) obj.sort = element.sort;
          if (element.is_default) obj.is_default = element.is_default;
          if (element.is_mandatory) obj.is_mandatory = element.is_mandatory;
          if (element.min_limit) obj.min_limit = element.min_limit;
          if (element.max_limit) obj.max_limit = element.max_limit;
          if (element.active) pList.push(obj);
        });
        var cList = [];
        bInfo.product_list.forEach(function (element) {
          cList.push(element.product_id);
        });
        if (bInfo.sort !== oldInfo.sort) data.sort = bInfo.sort;
        if (bInfo.name !== oldInfo.name) data.name = bInfo.name;
        if (bInfo.vendor_custom_id !== oldInfo.vendor_custom_id) data.vendor_custom_id = bInfo.vendor_custom_id;
        if (bInfo.description !== oldInfo.description) data.description = bInfo.description;
        if (bInfo.remark !== oldInfo.remark) data.remark = bInfo.remark;
        if (bInfo.is_mandatory !== oldInfo.is_mandatory) data.is_mandatory = bInfo.is_mandatory;
        if (bInfo.min_limit !== oldInfo.min_limit) data.min_limit = bInfo.min_limit;
        if (bInfo.max_limit !== oldInfo.max_limit) data.max_limit = bInfo.max_limit;
        data.product_list = pList;
      }
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data) !== '{}') {
        this.getDataH('put', url, data, function (response) {
          if (response.data.status === 200) {
            if (!type) {
              _this9.$notify({
                title: '提醒',
                text: '已更新' + bInfo.name,
                duration: 3000,
                type: 'success',
                width: 400
              });
            }
            if (bInfo.name !== oldInfo.name) {
              _this9.getMenuBlock('reload', bInfo.block_id);
            }
          }
        });
      }
    },
    setActiveProduct: function setActiveProduct() {
      var _this10 = this;

      if (this.blockInfo.product_list.length) {
        this.blockInfo.product_list.forEach(function (o) {
          _this10.productList.find(function (prod) {
            if (prod.item_id === o.product_id) {
              prod.active = true;
              prod.newPrice = o.price;
              prod.price = o.price;
              if (o.min_limit || o.min_limit === 0) prod.min_limit = o.min_limit;
              if (o.max_limit || o.max_limit === 0) prod.max_limit = o.max_limit;
              if (o.sort) prod.sort = o.sort;
              if (o.is_mandatory || o.is_mandatory === 0) prod.is_mandatory = o.is_mandatory;
              if (o.is_default || o.is_default === 0) prod.is_default = o.is_default;
            }
          });
          _this10.isLoad = false;
        });
      } else {
        this.isLoad = false;
      }
    },
    delModalOpen: function delModalOpen() {
      this.delOption.title = '\u522A\u9664' + this.blockInfo.name;
    },
    clearAllActive: function clearAllActive(list) {
      var _this11 = this;

      list.forEach(function (element) {
        _this11.$set(element, 'active', false);
      });
    }
  }),

  created: function created() {
    this.getMenuBlock();
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['getUpAdjust', 'getModal', 'getRoleType']), {
    allInput: function allInput() {
      var info = this.blockInfo;
      return {
        name: this.checkInput(info.name),
        sort: this.checkInput(info.sort),
        vendor_custom_id: this.checkInput(info.vendor_custom_id),
        description: this.checkInput(info.description),
        remark: this.checkInput(info.remark),
        min_limit: this.checkInput(info.min_limit),
        max_limit: this.checkInput(info.max_limit)
      };
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    productNew: function productNew() {
      var product = this.product;
      return product;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.maxTotal / this.count);
    },
    blockChoseListWithoutCurrent: function blockChoseListWithoutCurrent() {
      var _this12 = this;

      return this.blockChoseList.filter(function (item) {
        return item.item_id !== _this12.curId;
      });
    }
  })
});

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AdjustModal_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AdjustModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AdjustModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_ChooseModal_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_ChooseModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__elements_ChooseModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__elements_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__OptionModal_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__OptionModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__OptionModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__extends_nd_extend_handle_menu_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__extends_nd_extend_handle_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__extends_nd_extend_handle_menu_vue__);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CrCategoryTemp',
  extends: __WEBPACK_IMPORTED_MODULE_8__extends_nd_extend_handle_menu_vue___default.a,
  components: {
    'adjust-modal': __WEBPACK_IMPORTED_MODULE_4__AdjustModal_vue___default.a,
    'option-modal': __WEBPACK_IMPORTED_MODULE_7__OptionModal_vue___default.a,
    'c-modal': __WEBPACK_IMPORTED_MODULE_5__elements_ChooseModal_vue___default.a,
    'm-modal': __WEBPACK_IMPORTED_MODULE_6__elements_Modal_vue___default.a
  },
  props: {
    'info': {
      type: Object
    }
  },
  data: function data() {
    return {
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      menuId: this.$route.params.menu_id,
      brandId: this.$route.params.brand_id,
      show: {
        easy: true
      },
      current: {
        option: 0,
        adjust: 0,
        adjustId: 0,
        adjustName: '',
        adjustSubType: 0
      },
      brandName: '',
      brandType: '',
      adjustNumList: [],
      adjust: [],
      option: [],
      amount: {
        adjust: 1,
        option: 1
      },
      count: 20,
      maxTotal: 0,
      categoryList: [],
      productList: [],
      packageList: [],
      categoryInfo: {
        name: '',
        sort: 1,
        vendor_custom_id: '',
        description: '',
        remark: ''
      },
      choseProduct: {
        id: 'choseProdModal',
        title: '選擇商品',
        event: 'chooseProduct'
      },
      chosePackage: {
        id: 'chosePackModal',
        title: '選擇套餐',
        event: 'choosePackage'
      },
      curId: 0,
      oldInfo: {},
      isLoad: false,
      defaultIndex: 1,
      delOption: {
        id: 'delModal',
        title: '刪除商品分類',
        body: '刪除時，若被上架中的菜單使用中，則會被阻擋<br>刪除分類時，不會刪除底下的商品，只是需要將失去分類的商品重新放到某個分類下面',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'del'
        }]
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['setUpAdjust', 'setModal']), {
    delModalOpen: function delModalOpen() {
      this.delOption.title = '刪除' + this.categoryInfo.name;
    },
    trigger: function trigger(event) {
      if (event === 'del') {
        this.del(this.categoryInfo.name);
      }
    },
    del: function del(delName) {
      var _this = this;

      var url = this.base + this.id + '/category?category_id=' + this.categoryInfo.category_id;
      this.getDataH('delete', url, null, function (res) {
        if (res.data.status === 200) {
          _this.$notify({
            title: '提醒',
            text: '成功刪除' + delName,
            duration: 3000,
            type: 'success',
            width: 400
          });
          _this.getMenuCategory('delete');
        }
      });
    },
    toggle: function toggle() {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.infoAdjustModal).css('display');
    },
    maxAmount: function maxAmount(max) {
      if (!max) return '無限制';else return max;
    },
    getSubType: function getSubType(type) {
      if (type === 10) {
        return '大小';
      } else if (type === 20) {
        return '容器';
      } else if (type === 30) {
        return '甜度';
      } else if (type === 40) {
        return '溫度';
      } else {
        return '其他';
      }
    },
    getPriceType: function getPriceType(type) {
      if (type === 1) return '免稅價格';else if (type === 3) return '含稅價格';
    },
    veritySort: function veritySort() {
      var e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.sort);
      this.categoryInfo.sort = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    getAdjustInfo: function getAdjustInfo() {
      var _this2 = this;

      var url = this.base + this.id + '/adjust/' + this.adjustId;
      this.getDataH('get', url, null, function (res) {
        if (res.data.status === 200) {
          _this2.adjustInfo = res.data.adjust;
        }
      });
    },
    checkInputEmpty: function checkInputEmpty() {
      if (!this.allInput.name) {
        this.$notify({
          title: '提醒',
          text: '請填寫商品分類名稱',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!this.allInput.sort) {
        this.$notify({
          title: '提醒',
          text: '請填寫排序',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!parseInt(this.allInput.sort, 10)) {
        this.$notify({
          title: '請填寫正確排序',
          text: '排序範圍為1~9999',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.upCategory();
        return true;
      }
    },
    clearData: function clearData() {
      this.adjustInfo = {
        name: '',
        sort: 1,
        description: '',
        remark: '',
        price: '',
        price_type: '3',
        calorie: '',
        min_limit: '0',
        max_limit: '0',
        adjust_custom_id: '',
        is_mandatory: '0',
        is_common: '0',
        sub_type: '0'
      };
    },
    gotoCrCategories: function gotoCrCategories() {
      console.log('gotoCrCategories');
      var name = '';
      var params = {
        brand_id: this.$route.params.brand_id,
        store_id: ''
      };

      if (this.isStore && this.getRoleType !== 10) {
        name = 'StoreMenuCategoryCreate';
        params.store_id = this.$route.params.store_id;
      } else {
        name = 'crCategories';
      }

      this.$router.push({ name: name, params: params });
    },
    gotoOut: function gotoOut() {
      this.$router.go(-1);
    },
    gotoNext: function gotoNext() {
      this.$router.push('/upProduct/' + this.brandId);
    },
    getMenuCategory: function getMenuCategory(type) {
      var _this3 = this;

      var url = this.base + this.id + '/category/briefList';
      this.getDataH('get', url, null, function (res) {
        if (res.data.status === 200) {
          var categoryList = res.data.list;
          _this3.categoryList = categoryList;
          if (categoryList.length && !_this3.curId || type === 'delete') {
            if (_this3.$route.query.cId) _this3.curId = parseInt(_this3.$route.query.cId, 10);else _this3.curId = categoryList[0].item_id;
          }
          _this3.getMenuPackage();
        }
      });
    },
    getMenuPackage: function getMenuPackage() {
      var _this4 = this;

      this.packageList = [];
      var url = this.base + this.id + '/package/briefList?type=2';
      this.getDataH('get', url, null, function (res) {
        if (res.data.status === 200) {
          if (res.data.list.length) {
            var categoryList = res.data.list;
            categoryList.forEach(function (i) {
              i.child_list.forEach(function (e) {
                e.active = false;
                _this4.packageList.push(e);
              });
            });
          }
          _this4.getMenuProduct();
        }
      });
    },
    getMenuProduct: function getMenuProduct() {
      var _this5 = this;

      this.productList = [];
      var url = this.base + this.id + '/product/briefList?type=2';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          if (response.data.list.length) {
            var categoryList = response.data.list[0].child_list;
            categoryList.forEach(function (element) {
              element.active = false;
              _this5.productList.push(element);
            });
            _this5.getCategory();
          } else if (_this5.curId) _this5.getCategory();
        }
      });
    },
    getCategory: function getCategory() {
      var _this6 = this;

      var url = this.base + this.id + '/category/' + this.curId;
      this.getDataH('get', url, null, function (res) {
        if (res.data.status === 200) {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.each(res.data.category, function (index, value) {
            _this6.$set(_this6.oldInfo, index, value);
          });
          _this6.categoryInfo = res.data.category;
          if (!_this6.categoryInfo.sort) {
            _this6.categoryInfo.sort = _this6.defaultIndex;
            _this6.upCategory('sort');
          }
          _this6.setActiveProduct();
        }
      });
    },
    upCategory: function upCategory(type) {
      var _this7 = this;

      var url = this.base + this.id + '/category/' + this.curId;
      var data = {};
      var cInfo = this.categoryInfo;
      var oldInfo = this.oldInfo;
      if (type === 'sort') {
        data.sort = cInfo.sort;
      } else {
        var pList = [];
        this.productList.forEach(function (element) {
          if (element.active) pList.push(element.item_id);
        });
        var cList = [];
        cInfo.product_list.forEach(function (element) {
          cList.push(element.product_id);
        });

        var paList = [];
        this.packageList.forEach(function (element) {
          if (element.active) paList.push(element.item_id);
        });
        var cPaList = [];
        cInfo.package_list.forEach(function (element) {
          cPaList.push(element.package_id);
        });
        if (cInfo.sort !== oldInfo.sort) data.sort = cInfo.sort;
        if (cInfo.name !== oldInfo.name) data.name = cInfo.name;
        if (cInfo.vendor_custom_id !== oldInfo.vendor_custom_id) data.vendor_custom_id = cInfo.vendor_custom_id;
        if (cInfo.description !== oldInfo.description) data.description = cInfo.description;
        if (cInfo.remark !== oldInfo.remark) data.remark = cInfo.remark;
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(pList) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(cList)) {
          data.product_list = pList;
          data.package_list = paList;
        }
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(paList) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(cPaList)) {
          data.product_list = pList;
          data.package_list = paList;
        }
      }
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data) !== '{}') {
        this.getDataH('put', url, data, function (response) {
          if (response.data.status === 200) {
            if (!type) {
              _this7.$notify({
                title: '提醒',
                text: '已更新' + cInfo.name,
                duration: 3000,
                type: 'success',
                width: 400
              });
            }
            if (cInfo.name !== oldInfo.name) {
              _this7.getMenuCategory('reload', cInfo.category_id);
            }
          }
        });
      }
    },
    setActiveProduct: function setActiveProduct() {
      var self = this;
      if (self.categoryInfo.product_list.length) {
        self.categoryInfo.product_list.forEach(function (o) {
          var product = {
            active: true,
            description: o.description,
            item_id: o.product_id,
            name: o.name,
            price: o.price,
            remark: o.remark,
            vendor_custom_id: o.vendor_custom_id
          };
          self.productList.push(product);
        });
      }
      self.setActivePackage();
    },
    setActivePackage: function setActivePackage() {
      var self = this;
      if (self.categoryInfo.package_list.length) {
        self.categoryInfo.package_list.forEach(function (o) {
          var pa = {
            active: true,
            description: o.description,
            item_id: o.package_id,
            name: o.name,
            price: o.price,
            remark: o.remark,
            vendor_custom_id: o.vendor_custom_id
          };
          self.packageList.push(pa);
        });
      }
      self.isLoad = false;
    },
    clickCategory: function clickCategory(category, index) {
      this.isLoad = true;
      this.curId = category.item_id;
      this.defaultIndex = index + 1;
      this.getMenuCategory();
    }
  }),
  created: function created() {
    this.getMenuCategory();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getUpAdjust', 'getModal', 'getRoleType']), {
    modalState: function modalState() {
      if (this.state === 3 && !this.editState) return this.adjustInfo.name;
      if (this.editState) return '編輯' + this.adjustInfo.name;else return '新增調整類別';
    },
    allInput: function allInput() {
      var info = this.categoryInfo;
      return {
        name: this.checkInput(info.name),
        sort: this.checkInput(info.sort),
        vendor_custom_id: this.checkInput(info.vendor_custom_id),
        description: this.checkInput(info.description),
        remark: this.checkInput(info.remark)
      };
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    productNew: function productNew() {
      var product = this.product;
      return product;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.maxTotal / this.count);
    }
  })
});

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_masonry_layout__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_masonry_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_masonry_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CombinePriceModal_vue__ = __webpack_require__(2212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CombinePriceModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CombinePriceModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'combine-price-modal': __WEBPACK_IMPORTED_MODULE_3__CombinePriceModal_vue___default.a
  },
  props: {
    'info': {
      type: Object
    }
  },
  data: function data() {
    return {
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      menuId: this.$route.params.menu_id,
      brandId: this.$route.params.brand_id,
      current: {
        productId: 0,
        category: 0,
        categoryId: 0,
        categoryName: '',
        type: ''
      },
      category: [],
      cateNumList: [],
      product: {},
      amount: {
        category: 1,
        product: 1
      },
      count: 20,
      maxTotal: 0
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['setUpCategory', 'setModal']), {
    init: function init() {
      if (typeof this.info !== 'undefined') {
        this.brandName = this.info.name;
        this.brandType = this.info.type;
      }
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    showMenu: function showMenu() {
      if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.grid') && __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.grid-item')) {
        var m = new __WEBPACK_IMPORTED_MODULE_2_masonry_layout___default.a('.grid', {
          itemSelector: '.grid-item',
          columnWidth: '.grid-item'
        });
        m.reloadItems();
        m.layout();
      }
    },
    getProduct: function getProduct(index) {
      return this.product[index];
    },
    openCombineModal: function openCombineModal(type, name, pId) {
      this.setModal(true);
      this.current.productId = parseInt(pId, 10);
      this.current.productName = name;
      this.current.type = type;
      if (type === 'cr') __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#crCombineModal').modal('toggle');else if (type === 'info') __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#infoCombineModal').modal('toggle');
    },
    gotoFrom: function gotoFrom() {
      this.$router.push('/upCombination/' + this.brandId);
    },
    gotoNext: function gotoNext() {
      this.$router.push('/brandMenu/' + this.brandId);
    },
    getMenuCategory: function getMenuCategory(index) {
      var self = this;
      if (index) this.tableIndex = this.amount.category = index;
      var url = 'brand/' + this.$route.params.brand_id + '/category/list?page=' + this.amount.category + '&size=' + this.count;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.category = response.data.category_list;
          self.maxTotal = response.data.meta.total;
          for (var i = 0; i < response.data.category_list.length; i++) {
            self.cateNumList.push(response.data.category_list[i].category_id);
          }
          self.getProducts();
          self.setUpCategory(false);
        }
      });
    },
    getProducts: function getProducts() {
      if (this.cateNumList.length) {
        for (var i = 0; i < this.cateNumList.length; i++) {
          this.productByCId(this.cateNumList[i], 0);
        }
      }
    },
    productByCId: function productByCId(categoryId, index) {
      var page = 1;
      if (index) page = index;
      var self = this;
      if (categoryId) {
        var url = 'brand/' + this.$route.params.brand_id + '/category/' + categoryId + '/productlist?page=' + page + '&size=' + this.count;
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            var categoryId = response.data.meta.category_id;
            self.category.filter(function (elem, index, obj) {
              if (elem.category_id === categoryId) {
                self.$set(elem, 'product_list', response.data.product_list);
                self.$set(elem, 'product_total', response.data.meta.total);
                self.$set(elem, 'page', page);
              }
              return elem.category_id === categoryId;
            });
          }
        });
      }
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    }
  }),
  created: function created() {
    this.getMenuCategory();
  },
  mounted: function mounted() {
    this.showMenu();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getUpCategory', 'getModal']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    productNew: function productNew() {
      var product = this.product;
      return product;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.maxTotal / this.count);
    }
  }),
  updated: function updated() {
    var self = this;
    this.showMenu();
    setTimeout(function () {
      self.showMenu();
    }, 1000);
  },

  watch: {
    getUpCategory: function getUpCategory() {
      if (this.getUpCategory) {
        this.cateNumList = [];
        this.getMenuCategory(1);
      }
    },
    getModal: function getModal() {
      if (!this.getModal) {
        this.current = {
          productId: 0,
          category: 0,
          categoryId: 0,
          categoryName: ''
        };
      }
    }
  }
});

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_masonry_layout__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_masonry_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_masonry_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CombineModal_vue__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CombineModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CombineModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'combine-modal': __WEBPACK_IMPORTED_MODULE_3__CombineModal_vue___default.a
  },
  props: {
    'info': {
      type: Object
    }
  },
  data: function data() {
    return {
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      menuId: this.$route.params.menu_id,
      brandId: this.$route.params.brand_id,
      current: {
        productId: 0,
        category: 0,
        categoryId: 0,
        categoryName: '',
        type: ''
      },
      category: [],
      cateNumList: [],
      product: {},
      amount: {
        category: 1,
        product: 1
      },
      count: 20,
      maxTotal: 0
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['setUpCategory', 'setModal']), {
    init: function init() {
      if (typeof this.info !== 'undefined') {
        this.brandName = this.info.name;
        this.brandType = this.info.type;
      }
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    showMenu: function showMenu() {
      if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.grid') && __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.grid-item')) {
        var m = new __WEBPACK_IMPORTED_MODULE_2_masonry_layout___default.a('.grid', {
          itemSelector: '.grid-item',
          columnWidth: '.grid-item'
        });
        m.reloadItems();
        m.layout();
      }
    },
    getProduct: function getProduct(index) {
      return this.product[index];
    },
    openCombineModal: function openCombineModal(type, name, pId) {
      this.setModal(true);
      this.current.productId = parseInt(pId, 10);
      this.current.productName = name;
      this.current.type = type;
      if (type === 'cr') __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#crCombineModal').modal('toggle');else if (type === 'info') __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#infoCombineModal').modal('toggle');
    },
    gotoOut: function gotoOut() {
      this.$router.push('/brandMenu/' + this.brandId);
    },
    gotoFrom: function gotoFrom() {
      this.$router.push('/upOption/' + this.brandId);
    },
    gotoNext: function gotoNext() {
      this.$router.push('/upCombinationPrice/' + this.brandId);
    },
    getMenuCategory: function getMenuCategory(index) {
      var self = this;
      if (index) this.tableIndex = this.amount.category = index;
      var url = 'brand/' + this.$route.params.brand_id + '/category/list?page=' + this.amount.category + '&size=' + this.count;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.category = response.data.category_list;
          self.maxTotal = response.data.meta.total;
          for (var i = 0; i < response.data.category_list.length; i++) {
            self.cateNumList.push(response.data.category_list[i].category_id);
          }
          self.getProducts();
          self.setUpCategory(false);
        }
      });
    },
    getProducts: function getProducts() {
      if (this.cateNumList.length) {
        for (var i = 0; i < this.cateNumList.length; i++) {
          this.productByCId(this.cateNumList[i], 0);
        }
      }
    },
    productByCId: function productByCId(categoryId, index) {
      var page = 1;
      if (index) page = index;
      var self = this;
      if (categoryId) {
        var url = 'brand/' + this.$route.params.brand_id + '/category/' + categoryId + '/productlist?page=' + page + '&size=' + this.count;
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            var categoryId = response.data.meta.category_id;
            self.category.filter(function (elem, index, obj) {
              if (elem.category_id === categoryId) {
                self.$set(elem, 'product_list', response.data.product_list);
                self.$set(elem, 'product_total', response.data.meta.total);
                self.$set(elem, 'page', page);
              }
              return elem.category_id === categoryId;
            });
          }
        });
      }
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    }
  }),
  created: function created() {
    this.getMenuCategory();
  },
  mounted: function mounted() {
    this.showMenu();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getUpCategory', 'getModal']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    productNew: function productNew() {
      var product = this.product;
      return product;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.maxTotal / this.count);
    }
  }),
  updated: function updated() {
    var self = this;
    this.showMenu();
    setTimeout(function () {
      self.showMenu();
    }, 1000);
  },

  watch: {
    getUpCategory: function getUpCategory() {
      if (this.getUpCategory) {
        this.cateNumList = [];
        this.getMenuCategory(1);
      }
    },
    getModal: function getModal() {
      if (!this.getModal) {
        this.current = {
          productId: 0,
          category: 0,
          categoryId: 0,
          categoryName: ''
        };
      }
    }
  }
});

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_masonry_layout__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_masonry_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_masonry_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CombineModal_vue__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CombineModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CombineModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__extends_nd_extend_handle_menu_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__extends_nd_extend_handle_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__extends_nd_extend_handle_menu_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CrJoinMenuTemp',
  extends: __WEBPACK_IMPORTED_MODULE_5__extends_nd_extend_handle_menu_vue___default.a,
  components: {
    'combine-modal': __WEBPACK_IMPORTED_MODULE_3__CombineModal_vue___default.a
  },
  props: {
    'info': {
      type: Object
    }
  },
  data: function data() {
    return {
      menuId: this.$route.params.menu_id,
      brandId: this.$route.params.brand_id,
      current: {
        productName: '',
        productId: 0
      },
      count: 20,
      brandName: '',
      brandType: '',
      amount: {
        adjust: 1,
        option: 1,
        product: 1,
        category: 1,
        resource: 1,
        others: 1
      },
      adjustNumList: [],
      adjust: [],
      option: [],
      cateNumList: [],
      category: [],
      product: [],
      prodNumList: {},
      all: {
        category: [],
        product: [],
        adjust: [],
        option: [],
        combination: []
      },
      menuInfo: {},
      menuList: '',
      created: false,
      getTimes: 0,
      time: 0,
      accessory: []
    };
  },

  methods: {
    init: function init() {
      this.getMenuResource();
    },
    isActive: function isActive(index) {
      if (index === 1) return true;else return false;
    },
    showMenu: function showMenu() {
      if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.grid') && __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.grid-item')) {
        var m = new __WEBPACK_IMPORTED_MODULE_2_masonry_layout___default.a('.grid', {
          itemSelector: '.grid-item',
          columnWidth: '.grid-item'
        });
        m.reloadItems();
        m.layout();
      }
    },
    getProduct: function getProduct(index) {
      return this.product[index];
    },
    openCombineModal: function openCombineModal(name, index) {
      this.current.productId = index;
      this.current.productName = name;
    },
    gotoFrom: function gotoFrom() {
      var name = '';
      var params = {
        brand_id: this.$route.params.brand_id,
        store_id: ''
      };
      var query = {
        copy_menu_id: this.$route.query.copy_menu_id
      };

      if (this.menuId && this.isStore) {
        name = 'StoreMenuEdite';
        params.store_id = this.$route.params.store_id;
      } else if (this.menuId) {
        name = 'upMenu';
      } else if (!this.menuId && this.isStore) {
        name = 'StoreMenuOptionCreateView';
      } else if (!this.menuId) {
        name = 'crOption';
      }

      this.$router.push({ name: name, params: params, query: query });
    },
    gotoNext: function gotoNext() {
      this.joinMenu();
    },
    getMenuResource: function getMenuResource(index) {
      var _this = this;

      if (index) this.amount.resource = index;
      var url = this.base + this.id + '/menu/resource?page=' + this.amount.resource + '&size=' + this.count;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          response.data.resource_list.forEach(function (category) {
            _this.$set(category, 'is_enable', _this.created);
            _this.$set(category, 'is_visible', _this.created);
            _this.$set(category, 'is_remove', _this.created);
            category.package_list.forEach(function (pack) {
              _this.$set(pack, 'is_enable', _this.created);
              _this.$set(pack, 'is_visible', _this.created);
              _this.$set(pack, 'is_remove', _this.created);
            });
            category.product_list.forEach(function (product) {
              _this.$set(product, 'is_enable', _this.created);
              _this.$set(product, 'is_visible', _this.created);
              _this.$set(product, 'is_remove', _this.created);
              product.combine_list.forEach(function (combine) {
                _this.$set(combine, 'is_enable', _this.created);
                _this.$set(combine, 'is_visible', _this.created);
                _this.$set(combine, 'is_remove', _this.created);
              });
            });
            _this.category.push(category);
          });
          if (response.data.resource_list.length) {
            var i = _this.amount.resource + 1;
            _this.getMenuResource(i);
          } else _this.getMenuAccessoryResource();
        }
      });
    },
    getMenuAccessoryResource: function getMenuAccessoryResource(index) {
      var _this2 = this;

      if (index) this.amount.others = index;
      var url = this.base + this.id + '/menu/accessoryResource?page=' + this.amount.others + '&size=' + this.count;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this2.getMenuInfo();
          var resList = [];
          resList.push(response.data.resource_list);
          resList.forEach(function (category) {
            _this2.$set(category, 'is_enable', _this2.created);
            _this2.$set(category, 'is_visible', _this2.created);
            _this2.$set(category, 'is_remove', _this2.created);
            category.product_list.forEach(function (product) {
              _this2.$set(product, 'is_enable', _this2.created);
              _this2.$set(product, 'is_visible', _this2.created);
              _this2.$set(product, 'is_remove', _this2.created);
            });
            _this2.accessory.push(category);
          });
        }
      });
    },
    getMenuInfo: function getMenuInfo() {
      var _this3 = this;

      var url = this.base + this.id + '/menu/' + this.$route.params.menu_id;
      if (this.getRoleType === 10) {
        if (this.$route.params.menu_id) url = this.base + this.id + '/menu/' + this.$route.params.menu_id;
      }
      if (this.$route.query.copy_menu_id) url = this.base + this.id + '/menu/' + this.$route.query.copy_menu_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          if (response.data.menu.src_join_param) {
            _this3.category.forEach(function (category) {
              _this3.$set(category, 'is_enable', true);
              _this3.$set(category, 'is_visible', true);
              _this3.$set(category, 'is_remove', true);
              category.package_list.forEach(function (pack) {
                _this3.$set(pack, 'is_enable', true);
                _this3.$set(pack, 'is_visible', true);
                _this3.$set(pack, 'is_remove', true);
              });
              category.product_list.forEach(function (product) {
                _this3.$set(product, 'is_enable', true);
                _this3.$set(product, 'is_visible', true);
                _this3.$set(product, 'is_remove', true);
                product.combine_list.forEach(function (combine) {
                  _this3.$set(combine, 'is_enable', true);
                  _this3.$set(combine, 'is_visible', true);
                  _this3.$set(combine, 'is_remove', true);
                });
              });
            });
            _this3.accessory.forEach(function (category) {
              category.product_list.forEach(function (product) {
                _this3.$set(product, 'is_enable', true);
                _this3.$set(product, 'is_visible', true);
                _this3.$set(product, 'is_remove', true);
              });
            });
            var menu = response.data.menu.src_join_param;
            _this3.category.find(function (category) {
              for (var c = 0; c < menu.category.length; c++) {
                var cKey = menu.category[c];
                if (category.category_id === parseInt(cKey, 10)) {
                  category.is_enable = false;
                  category.is_visible = false;
                  category.is_remove = false;
                }
              }
              category.package_list.find(function (pack) {
                for (var pa = 0; pa < menu.package.length; pa++) {
                  var paKey = menu.package[pa];
                  if (pack.package_id === parseInt(paKey, 10)) {
                    pack.is_enable = false;
                    pack.is_visible = false;
                    pack.is_remove = false;
                  }
                }
              });
              category.product_list.find(function (prod) {
                for (var p = 0; p < menu.product.length; p++) {
                  var pKey = menu.product[p];
                  if (prod.product_id === parseInt(pKey, 10)) {
                    prod.is_enable = false;
                    prod.is_visible = false;
                    prod.is_remove = false;
                  }
                }
                prod.combine_list.find(function (combine) {
                  for (var co = 0; co < menu.combination.length; co++) {
                    var coKey = menu.combination[co];
                    if (combine.combine_id === parseInt(coKey, 10)) {
                      combine.is_enable = false;
                      combine.is_visible = false;
                      combine.is_remove = false;
                    }
                  }
                });
              });
            });
            _this3.accessory.find(function (category) {
              category.product_list.find(function (prod) {
                for (var ap = 0; ap < menu.accessory.length; ap++) {
                  var apKey = menu.accessory[ap];
                  if (prod.product_id === parseInt(apKey, 10)) {
                    prod.is_enable = false;
                    prod.is_visible = false;
                    prod.is_remove = false;
                  }
                }
              });
            });
          }
        }
      });
    },
    joinMenu: function joinMenu() {
      var _this4 = this;

      this.all = {
        category: [],
        product: [],
        combination: [],
        package: [],
        accessory: []
      };
      var caList = this.category;
      for (var c = 0; c < caList.length; c++) {
        if (!caList[c].is_remove) this.all.category.push(caList[c].category_id + '/' + this.booToNum(caList[c].is_remove) + '/' + this.booToNum(caList[c].is_remove));

        var pList = caList[c].product_list;
        for (var p = 0; p < pList.length; p++) {
          if (!pList[p].is_remove) this.all.product.push(pList[p].product_id + '/' + this.booToNum(pList[p].is_remove) + '/' + this.booToNum(pList[p].is_remove));
          if (pList[p].combine_list) {
            var comList = pList[p].combine_list;
            for (var com = 0; com < comList.length; com++) {
              if (!comList[com].is_remove) this.all.combination.push(comList[com].combine_id + '/' + this.booToNum(comList[com].is_remove) + '/' + this.booToNum(comList[com].is_remove));
            }
          }
        }

        var paList = caList[c].package_list;
        for (var pa = 0; pa < paList.length; pa++) {
          if (!paList[pa].is_remove) this.all.package.push(paList[pa].package_id + '/' + this.booToNum(paList[pa].is_remove) + '/' + this.booToNum(paList[pa].is_remove));
        }
      }

      var aList = this.accessory;
      for (var a = 0; a < aList.length; a++) {
        var apList = aList[a].product_list;
        for (var ap = 0; ap < apList.length; ap++) {
          if (!apList[ap].is_remove) this.all.accessory.push(apList[ap].product_id + '/' + this.booToNum(apList[ap].is_remove) + '/' + this.booToNum(apList[ap].is_remove));
        }
      }

      var url = this.base + this.id + '/menu/' + this.$route.params.menu_id + '/join';
      this.getDataH('put', url, this.all, function (response) {
        if (response.data.status === 200) {
          var name = '';
          var params = {
            brand_id: _this4.$route.params.brand_id,
            menu_id: _this4.$route.params.menu_id,
            store_id: ''
          };

          if (_this4.isStore && _this4.getRoleType !== 10) {
            name = 'StoreMenuInfo';
            params.store_id = _this4.$route.params.store_id;
          } else {
            name = 'menuInfo';
          }

          _this4.$router.push({ name: name, params: params });
        }
      });
    },
    booToNum: function booToNum(boo) {
      if (boo === true) {
        return 0;
      } else {
        return 1;
      }
    },
    choseAllOption: function choseAllOption(adjust) {
      this.adjust.filter(function (elem) {
        if (elem.adjust_id === adjust.adjust_id) {
          elem.is_enable = true;
          elem.is_visible = true;
          elem.is_remove = true;
          if (elem.option_list.length) {
            for (var i = 0; i < elem.option_list.length; i++) {
              var option = elem.option_list[i];
              option['is_enable'] = true;
              option['is_visible'] = true;
              option['is_remove'] = true;
            }
          }
        }
      });
    },
    cancelAllOption: function cancelAllOption(adjust) {
      this.adjust.filter(function (elem) {
        if (elem.adjust_id === adjust.adjust_id) {
          elem.is_enable = false;
          elem.is_visible = false;
          elem.is_remove = false;
          if (elem.option_list.length) {
            for (var i = 0; i < elem.option_list.length; i++) {
              var option = elem.option_list[i];
              option['is_enable'] = false;
              option['is_visible'] = false;
              option['is_remove'] = false;
            }
          }
        }
      });
    },
    changeAdjustAdd: function changeAdjustAdd(adjust) {
      this.adjust.filter(function (elem) {
        if (elem.adjust_id === adjust.adjust_id) {
          if (elem.option_list.length) {
            for (var i = 0; i < elem.option_list.length; i++) {
              var option = elem.option_list[i];
              option['is_remove'] = elem.is_remove;
            }
          }
        }
      });
    },
    changeCategoryAdd: function changeCategoryAdd(category) {
      var isChecked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (isChecked !== null) {
        category.is_remove = isChecked;
      }
      category.is_remove = !category.is_remove;
      category.product_list.forEach(function (product) {
        product['is_remove'] = category.is_remove;
        if (product.combine_list) {
          product.combine_list.forEach(function (combine) {
            combine['is_remove'] = category.is_remove;
          });
        }
      });
      if (category.package_list) {
        category.package_list.forEach(function (pa) {
          pa['is_remove'] = category.is_remove;
        });
      }
    },
    changeProductAdd: function changeProductAdd(category, product) {
      product.is_remove = !product.is_remove;
      if (product.combine_list) {
        for (var j = 0; j < product.combine_list.length; j++) {
          var combine = product.combine_list[j];
          combine['is_remove'] = product.is_remove;
        }
      }

      if (!product.is_remove) {
        category.is_remove = product.is_remove;
      }
    },
    changeCombineAdd: function changeCombineAdd(category, product, combination) {
      combination.is_remove = !combination.is_remove;
      if (!combination.is_remove) {
        product.is_remove = combination.is_remove;
        category.is_remove = combination.is_remove;
      }
    }
  },
  created: function created() {
    this.init();
  },
  mounted: function mounted() {
    this.showMenu();
  },
  updated: function updated() {
    this.showMenu();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    }
  })
});

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__elements_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AdjustModal_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AdjustModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__AdjustModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OptionModal_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OptionModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__OptionModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__extends_nd_extend_handle_menu_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__extends_nd_extend_handle_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__extends_nd_extend_handle_menu_vue__);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CrOptionTemp',
  props: {
    'info': {
      type: Object
    }
  },
  components: {
    'adjust-modal': __WEBPACK_IMPORTED_MODULE_5__AdjustModal_vue___default.a,
    'option-modal': __WEBPACK_IMPORTED_MODULE_6__OptionModal_vue___default.a,
    'm-modal': __WEBPACK_IMPORTED_MODULE_4__elements_Modal_vue___default.a
  },
  extends: __WEBPACK_IMPORTED_MODULE_7__extends_nd_extend_handle_menu_vue___default.a,
  data: function data() {
    return {
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      menuId: this.$route.params.menu_id,
      brandId: this.$route.params.brand_id,
      show: {
        easy: true
      },
      current: {
        option: 0,
        adjust: 0,
        adjustId: 0,
        adjustName: '',
        adjustSubType: 0
      },
      brandName: '',
      brandType: '',
      adjustNumList: [],
      adjust: [],
      option: [],
      amount: {
        adjust: 1,
        option: 1
      },
      count: 20,
      maxTotal: 0,
      optionList: [],
      optionInfo: {
        sort: 0,
        name: '',
        vendor_custom_id: '',
        description: '',
        remark: '',
        price: '',
        price_type: '3',
        calorie: '',
        sub_type: 0,
        is_mandatory: '0',
        min_limit: 0,
        max_limit: 1,
        is_common: 0
      },
      subTypeList: [{ value: 10, label: '大小(通用)' }, { value: 12, label: 'S' }, { value: 14, label: 'M' }, { value: 16, label: 'L' }, { value: 18, label: 'XL' }, { value: 20, label: '容器(通用)' }, { value: 30, label: '甜度(通用)' }, { value: 31, label: '無糖' }, { value: 33, label: '微糖' }, { value: 35, label: '半糖' }, { value: 37, label: '少糖' }, { value: 39, label: '全糖' }, { value: 40, label: '溫度(通用)' }, { value: 42, label: '冰' }, { value: 45, label: '溫' }, { value: 48, label: '熱' }, { value: 0, label: '未定義' }, { value: 1, label: '自定義1' }, { value: 2, label: '自定義2' }, { value: 3, label: '自定義3' }, { value: 4, label: '自定義4' }, { value: 5, label: '自定義5' }],
      oldInfo: {},
      curId: 0,
      delOption: {
        id: 'delModal',
        title: '刪除配料',
        body: '刪除時，若被上架中的菜單使用中，則會被阻擋',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'del'
        }]
      },
      defaultIndex: 1
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['setUpAdjust', 'setModal']), {
    clickOption: function clickOption(option, index) {
      this.curId = option.item_id;
      this.defaultIndex = index + 1;
    },
    delModalOpen: function delModalOpen() {
      this.delOption.title = '\u522A\u9664' + this.optionInfo.name;
    },
    trigger: function trigger(event) {
      if (event === 'del') {
        this.del(this.optionInfo.name);
      }
    },
    del: function del(delName) {
      var _this = this;

      var url = this.base + this.id + '/option?option_id=' + this.optionInfo.option_id;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          _this.$notify({
            title: '提醒',
            text: '成功刪除' + delName,
            duration: 3000,
            type: 'success',
            width: 400
          });
          _this.getMenuOption('delete');
        }
      });
    },
    goAdjust: function goAdjust() {
      var name = '';
      var params = {
        aId: this.optionInfo.adjust_id,
        brand_id: this.$route.params.brand_id,
        store_id: ''
      };

      if (this.isStore && this.getRoleType !== 10) {
        name = 'StoreMenuAdjust';
        params.store_id = this.$route.params.store_id;
      } else {
        name = 'upAdjust';
      }

      this.$router.push({ name: name, params: params });
    },
    goCrOptions: function goCrOptions() {
      console.log('goCrOptions');
      var name = '';
      var params = {
        brand_id: this.$route.params.brand_id,
        store_id: ''
      };

      if (this.isStore && this.getRoleType !== 10) {
        name = 'StoreMenuOptionCreate';
        params.store_id = this.$route.params.store_id;
      } else {
        name = 'crOptions';
      }

      this.$router.push({ name: name, params: params });
    },
    init: function init() {
      if (typeof this.info !== 'undefined') {
        this.brandName = this.info.name;
        this.brandType = this.info.type;
      }
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    openAdjustModal: function openAdjustModal(adjust) {
      this.setModal(true);
      this.current.adjust = parseInt(adjust.adjust_id, 10);
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#infoAdjustModal').modal('toggle');
    },
    openOptionModal: function openOptionModal(type, name, aId, oId, aSubType) {
      this.setModal(true);
      this.current.adjustId = parseInt(aId, 10);
      this.current.adjustName = name;
      this.current.optionId = parseInt(oId, 10);
      this.current.adjustSubType = aSubType;
      this.setModal(true);
      if (type === 'cr') __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#crOptionModal').modal('toggle');else if (type === 'info') __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#infoOptionModal').modal('toggle');
    },
    gotoOut: function gotoOut() {
      this.$router.go(-1);
    },
    checkInputEmpty: function checkInputEmpty() {
      if (!this.allInput.name) {
        this.$notify({
          title: '提醒',
          text: '請填寫配料名稱',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!this.allInput.sort) {
        this.$notify({
          title: '提醒',
          text: '請填寫排序',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!parseInt(this.allInput.sort, 10)) {
        this.$notify({
          title: '請填寫正確排序',
          text: '排序範圍為1~9999',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!this.allInput.min_limit) {
        this.$notify({
          title: '提醒',
          text: '請填寫最低購買數',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!this.allInput.max_limit) {
        this.$notify({
          title: '提醒',
          text: '請填寫最高購買數',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.upOption();
        return true;
      }
    },
    upOption: function upOption(type) {
      var _this2 = this;

      var url = this.base + this.id + '/option/' + this.curId;
      var data = {};
      var oInfo = this.optionInfo;
      var oldInfo = this.oldInfo;
      if (type === 'sort') {
        data.sort = oInfo.sort;
        data.price = oInfo.price;
        data.max_limit = oInfo.max_limit;
      } else {
        if (oInfo.sort !== oldInfo.sort) data.sort = oInfo.sort;
        if (oInfo.name !== oldInfo.name) data.name = oInfo.name;
        if (oInfo.vendor_custom_id !== oldInfo.vendor_custom_id) data.vendor_custom_id = oInfo.vendor_custom_id;
        if (oInfo.description !== oldInfo.description) data.description = oInfo.description;
        if (oInfo.remark !== oldInfo.remark) data.remark = oInfo.remark;
        if (oInfo.price !== oldInfo.price) data.price = oInfo.price;
        if (oInfo.price_type !== oldInfo.price_type) data.price_type = oInfo.price_type;
        if (oInfo.sub_type !== oldInfo.sub_type) data.sub_type = oInfo.sub_type;
        if (oInfo.calorie !== oldInfo.calorie) data.calorie = oInfo.calorie;
        if (oInfo.is_mandatory !== oldInfo.is_mandatory) data.is_mandatory = oInfo.is_mandatory;
        if (oInfo.min_limit !== oldInfo.min_limit) data.min_limit = oInfo.min_limit;
        if (oInfo.max_limit !== oldInfo.max_limit) data.max_limit = oInfo.max_limit;
        if (oInfo.is_common !== oldInfo.is_common) data.is_common = oInfo.is_common;
      }
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data) !== '{}') {
        this.getDataH('put', url, data, function (response) {
          if (response.data.status === 200) {
            if (!type) {
              _this2.$notify({
                title: '提醒',
                text: '成功更新' + oInfo.name,
                duration: 3000,
                type: 'success',
                width: 400
              });
            }
            if (oInfo.name !== oldInfo.name) {
              _this2.getMenuOption('reload', oInfo.option_id);
              _this2.getOption();
            }
          }
        });
      }
    },
    copyOption: function copyOption() {
      var _this3 = this;

      var url = this.base + this.id + '/option/' + this.curId + '/duplicate';
      this.getDataH('post', url, null, function (response) {
        if (response.data.status === 200) {
          _this3.$notify({
            title: '提醒',
            text: '成功複製配料',
            duration: 3000,
            type: 'success',
            width: 400
          });
          _this3.getMenuOption('clickOther', response.data.new_option_id);
        }
      });
    },
    getMenuOption: function getMenuOption(type, oId) {
      var _this4 = this;

      this.optionList = [];
      var url = this.base + this.id + '/option/briefList?type=2';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          if (response.data.list.length) {
            var optionList = response.data.list[0].child_list;
            optionList.forEach(function (o2) {
              o2.type = 2;
              _this4.optionList.push(o2);
            });
            if (optionList.length || type === 'delete') {
              _this4.curId = optionList[0].item_id;
            }
            if (type === 'clickOther') _this4.curId = oId;
            _this4.getMenuOption2(type, oId);
          } else _this4.getMenuOption2(type, oId);
        }
      });
    },
    getMenuOption2: function getMenuOption2(oId) {
      var _this5 = this;

      var url = this.base + this.id + '/option/briefList?type=1';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          if (response.data.list.length) {
            var adjustList = response.data.list;
            adjustList.forEach(function (a) {
              var optionList = a.child_list;
              optionList.forEach(function (o) {
                o.type = 1;
                _this5.optionList.push(o);
              });
            });
            if (!_this5.curId) {
              if (oId) _this5.curId = parseInt(oId, 10);else _this5.curId = adjustList[0].child_list[0].item_id;
            }
          }
        }
      });
    },
    getOption: function getOption() {
      var _this6 = this;

      var url = this.base + this.id + '/option/' + this.curId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.each(response.data.option, function (index, value) {
            _this6.$set(_this6.oldInfo, index, value);
          });
          _this6.optionInfo = response.data.option;
          if (!_this6.optionInfo.sort || !_this6.optionInfo.price && parseInt(_this6.optionInfo.price, 10) !== 0) {
            _this6.optionInfo.sort = _this6.defaultIndex;
            _this6.optionInfo.price = 0;
            _this6.optionInfo.max_limit = 1;
            _this6.upOption('sort');
          }
        }
      });
    },
    optionByAId: function optionByAId(adjustId, index) {
      var _this7 = this;

      var page = 1;
      if (index) page = index;
      if (adjustId) {
        var url = this.base + this.id + '/adjust/' + adjustId + '/optionlist?page=' + page + '&size=' + this.count;
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            var adjustId = response.data.meta.adjust_id;
            _this7.adjust.filter(function (elem) {
              if (elem.adjust_id === adjustId) {
                _this7.$set(elem, 'option_list', response.data.option_list);
                _this7.$set(elem, 'option_total', response.data.meta.total);
                _this7.$set(elem, 'page', page);
              }
              return elem.adjust_id === adjustId;
            });
          }
        });
      }
    },
    checkAllOptions: function checkAllOptions(adjust) {
      var aMin = adjust.min_limit;
      var oList = void 0;
      var oAllMax = 0;
      if (adjust.option_list) {
        oList = adjust.option_list;
        for (var i = 0; i < oList.length; i++) {
          oAllMax = oAllMax + oList[i].max_limit;
        }
      }
      if (aMin > oAllMax) return aMin - oAllMax;else return false;
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    },
    veritySort: function veritySort() {
      var e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.sort);
      this.optionInfo.sort = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityMinLimit: function verityMinLimit() {
      var e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.minLimit);
      this.optionInfo.min_limit = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityMaxLimit: function verityMaxLimit() {
      var e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.maxLimit);
      this.optionInfo.max_limit = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityPrice: function verityPrice() {
      var e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.price);
      this.optionInfo.price = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[-]?[0-9]*/));
      }
    },
    verityCalorie: function verityCalorie() {
      var e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.calorie);
      this.optionInfo.calorie = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    }
  }),
  created: function created() {
    this.getMenuOption();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getUpAdjust', 'getModal', 'getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    productNew: function productNew() {
      var product = this.product;
      return product;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.maxTotal / this.count);
    },
    allInput: function allInput() {
      var info = this.optionInfo;
      return {
        name: this.checkInput(info.name),
        sort: this.checkInput(info.sort),
        vendor_custom_id: this.checkInput(info.vendor_custom_id),
        description: this.checkInput(info.description),
        remark: this.checkInput(info.remark),
        price: this.checkInput(info.price),
        price_type: parseInt(info.price_type, 10),
        calorie: this.checkInput(info.calorie),
        min_limit: this.checkInput(info.min_limit),
        max_limit: this.checkInput(info.max_limit)
      };
    }
  }),
  watch: {
    getUpAdjust: function getUpAdjust() {
      if (this.getUpAdjust) {
        this.adjustNumList = [];
        this.getMenuAdjust(1);
      }
    },
    getModal: function getModal() {
      if (!this.getModal) {
        this.current = {
          option: 0,
          adjust: 0,
          adjustId: 0,
          adjustName: '',
          adjustSubType: 0
        };
      }
    },
    curId: function curId() {
      this.getOption();
    }
  }
});

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AdjustModal_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AdjustModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AdjustModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OptionModal_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OptionModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__OptionModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_ChooseModal_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_ChooseModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__elements_ChooseModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__extends_nd_extend_handle_menu_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__extends_nd_extend_handle_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__extends_nd_extend_handle_menu_vue__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CrPackageTemp',
  extends: __WEBPACK_IMPORTED_MODULE_8__extends_nd_extend_handle_menu_vue___default.a,
  components: {
    'adjust-modal': __WEBPACK_IMPORTED_MODULE_4__AdjustModal_vue___default.a,
    'option-modal': __WEBPACK_IMPORTED_MODULE_5__OptionModal_vue___default.a,
    'c-modal': __WEBPACK_IMPORTED_MODULE_7__elements_ChooseModal_vue___default.a,
    'm-modal': __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue___default.a
  },
  props: {
    'info': {
      type: Object
    }
  },
  data: function data() {
    return {
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      menuId: this.$route.params.menu_id,
      brandId: this.$route.params.brand_id,
      show: {
        easy: true
      },
      current: {
        option: 0,
        adjust: 0,
        adjustId: 0,
        adjustName: '',
        adjustSubType: 0
      },
      brandName: '',
      brandType: '',
      adjustNumList: [],
      adjust: [],
      option: [],
      amount: {
        adjust: 1,
        option: 1
      },
      count: 20,
      maxTotal: 0,
      categoryList: [{ label: '愛茶的牛', val: 1 }, { label: '茶類', val: 2 }, { label: '鮮奶類', val: 3 }, { label: '小餐點', val: 4 }, { label: '點心', val: 5 }, { label: '套餐', val: 6 }, { label: '單點', val: 7 }, { label: '無酒精類', val: 8 }, { label: '比薩', val: 9 }, { label: '鮮果汁', val: 10 }, { label: '未分類', val: 11 }],
      packageList: [],
      adjustList: [{ name: '尺寸' }, { name: '尺寸' }, { name: '甜度' }, { name: '甜度' }, { name: '冰度' }, { name: '冰度' }, { name: '冰度' }, { name: '冰度' }, { name: '配料' }, { name: '加料' }, { name: '配料' }],
      blockList: [],
      optionList: [{ name: '布丁', id: 1, active: false, remark: '加料1用' }, { name: '燒仙草', id: 2, active: false, remark: '加料2用' }, { name: '仙人掌珍珠', id: 3, active: false, remark: '' }, { name: '波霸', id: 4, active: false, remark: '' }, { name: '黑糖珍珠', id: 5, active: false, remark: '加料3用' }, { name: '椰果', id: 6, active: false, remark: '' }, { name: '珍珠', id: 7, active: false, remark: '加料1用' }],
      packageInfo: {
        name: '',
        sort: 1,
        description: '',
        remark: '',
        price: 0,
        price_type: '3',
        calorie: '',
        min_limit: '0',
        max_limit: '0',
        adjust_custom_id: '',
        is_mandatory: '0',
        is_common: '0',
        sub_type: '0'
      },
      choseOption: {
        id: 'choseModal',
        title: '選擇選擇區',
        event: 'chooseElement'
      },
      select: {
        category: ''
      },
      curId: 0,
      oldInfo: {},
      defaultIndex: 1,
      isLoad: false,
      delOption: {
        id: 'delModal',
        title: '刪除套餐',
        body: '刪除時，若被上架中的菜單使用中，則會被阻擋',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'del'
        }]
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapActions */])(['setUpAdjust', 'setModal']), {
    toggle: function toggle() {
      __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$refs.infoAdjustModal).css('display');
    },
    maxAmount: function maxAmount(max) {
      if (!max) return '無限制';else return max;
    },
    getSubType: function getSubType(type) {
      if (type === 10) {
        return '大小';
      } else if (type === 20) {
        return '容器';
      } else if (type === 30) {
        return '甜度';
      } else if (type === 40) {
        return '溫度';
      } else {
        return '其他';
      }
    },
    getPriceType: function getPriceType(type) {
      if (type === 1) return '免稅價格';else if (type === 3) return '含稅價格';
    },
    veritySort: function veritySort() {
      var e = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$refs.sort);
      this.packageInfo.sort = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityMinLimit: function verityMinLimit() {
      var e = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$refs.minLimit);
      this.packageInfo.min_limit = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityMaxLimit: function verityMaxLimit() {
      var e = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$refs.maxLimit);
      this.packageInfo.max_limit = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityPrice: function verityPrice() {
      var e = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$refs.price);
      this.packageInfo.price = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityCalorie: function verityCalorie() {
      var e;
      if (this.state === 1) e = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$refs.calorie1);else if (this.state === 3) e = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$refs.calorie3);
      this.packageInfo.calorie = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    checkInputEmpty: function checkInputEmpty() {
      if (!this.allInput.name) {
        this.$notify({
          title: '提醒',
          text: '請填寫套餐名稱',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!this.allInput.sort) {
        this.$notify({
          title: '提醒',
          text: '請填寫排序',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!parseInt(this.allInput.sort, 10)) {
        this.$notify({
          title: '請填寫正確排序',
          text: '排序範圍為1~9999',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!this.allInput.min_limit) {
        this.$notify({
          title: '提醒',
          text: '請填寫最低購買數',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!this.allInput.max_limit) {
        this.$notify({
          title: '提醒',
          text: '請填寫最高購買數',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.upPackage();
        return true;
      }
    },
    delAdjust: function delAdjust() {
      var _this = this;

      var url = this.base + this.id + '/adjust?adjust_id=' + this.adjustId;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          _this.$notify({
            title: '提醒',
            text: '成功刪除調整類別',
            duration: 3000,
            type: 'success',
            width: 400
          });
          _this.editState = false;
          var id = _this.modalId;
          __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#' + id).modal('toggle');
          _this.setUpAdjust(true);
        }
      });
    },
    clearData: function clearData() {
      this.packageInfo = {
        name: '',
        sort: 1,
        description: '',
        remark: '',

        calorie: '',
        min_limit: '0',
        max_limit: '0',
        adjust_custom_id: '',
        is_mandatory: '0',
        is_common: '0',
        sub_type: '0'
      };
    },
    gotoCrPackages: function gotoCrPackages() {
      console.log('gotoCrPackages');
      var name = '';
      var params = {
        brand_id: this.$route.params.brand_id,
        store_id: ''
      };

      if (this.isStore && this.getRoleType !== 10) {
        name = 'StoreMenuPackageCreate';
        params.store_id = this.$route.params.store_id;
      } else {
        name = 'crPackages';
      }

      this.$router.push({ name: name, params: params });
    },
    gotoOut: function gotoOut() {
      this.$router.go(-1);
    },
    gotoNext: function gotoNext() {
      this.$router.push('/upCategory/' + this.brandId);
    },
    trigger: function trigger(event) {
      if (event === 'del') {
        this.del(this.packageInfo.name);
      }
    },
    del: function del(delName) {
      var _this2 = this;

      var url = this.base + this.id + '/package?package_id=' + this.packageInfo.package_id;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          _this2.$notify({
            title: '提醒',
            text: '成功刪除' + delName,
            duration: 3000,
            type: 'success',
            width: 400
          });
          _this2.getAllMenuPackage('delete');
        }
      });
    },
    getMenuCategory: function getMenuCategory() {
      var _this3 = this;

      var url = this.base + this.id + '/category/briefList';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var categoryList = response.data.list;
          _this3.categoryList = categoryList;
          var select = {
            name: '未分類',
            item_id: 0
          };
          _this3.categoryList.push(select);
          if (!_this3.select.category) _this3.select.category = categoryList[0].item_id;
        }
      });
    },
    getAllMenuPackage: function getAllMenuPackage(type) {
      var _this4 = this;

      this.packageList = [];
      var url = this.base + this.id + '/package/briefList?type=0';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var categoryList = response.data.list;
          categoryList.forEach(function (c) {
            var pList = c.child_list;
            pList.forEach(function (p) {
              _this4.$set(p, 'active', false);
              _this4.packageList.push(p);
            });
          });
          if (_this4.packageList.length && !_this4.curId || type === 'delete') {
            if (_this4.$route.query.cId) _this4.curId = parseInt(_this4.$route.query.cId, 10);else _this4.curId = _this4.packageList[0].item_id;
          }
          _this4.getMenuBlock();
        }
      });
    },
    getPackage: function getPackage() {
      var _this5 = this;

      this.packageInfo.sort = 0;
      var url = this.base + this.id + '/package/' + this.curId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.each(response.data.package, function (index, value) {
            _this5.$set(_this5.oldInfo, index, value);
          });
          _this5.packageInfo = response.data.package;
          if (!_this5.packageInfo.sort) {
            _this5.packageInfo.sort = _this5.defaultIndex;
            _this5.packageInfo.price = 0;
            _this5.upPackage('sort');
          }
          _this5.setActiveBlock();
        }
      });
    },
    setActiveBlock: function setActiveBlock() {
      var _this6 = this;

      if (this.packageInfo.block_list.length) {
        var cList = this.packageInfo.block_list;
        cList.forEach(function (e) {
          var block = {
            active: true,
            description: e.description,
            item_id: e.block_id,
            name: e.name,
            price: e.price,
            remark: e.remark,
            vendor_custom_id: e.vendor_custom_id
          };
          _this6.blockList.push(block);
          _this6.isLoad = false;
        });
      } else {
        this.isLoad = false;
      }
    },
    upPackage: function upPackage(type) {
      var _this7 = this;

      var url = this.base + this.id + '/package/' + this.curId;
      var data = {};
      var pInfo = this.packageInfo;
      var oldInfo = this.oldInfo;
      if (type === 'sort') {
        data.sort = pInfo.sort;
        data.price = pInfo.price;
      } else {
        var newPList = [];
        this.blockList.forEach(function (element) {
          if (element.active) newPList.push(element.item_id);
        });
        var bList = [];
        pInfo.block_list.forEach(function (element) {
          bList.push(element.block_id);
        });
        if (pInfo.sort !== oldInfo.sort) data.sort = pInfo.sort;
        if (pInfo.name !== oldInfo.name) data.name = pInfo.name;
        if (pInfo.vendor_custom_id !== oldInfo.vendor_custom_id) data.vendor_custom_id = pInfo.vendor_custom_id;
        if (pInfo.description !== oldInfo.description) data.description = pInfo.description;
        if (pInfo.remark !== oldInfo.remark) data.remark = pInfo.remark;
        data.price = pInfo.price;
        if (pInfo.price_type !== oldInfo.price_type) data.price_type = pInfo.price_type;
        if (pInfo.min_limit !== oldInfo.min_limit) data.min_limit = pInfo.min_limit;
        if (pInfo.max_limit !== oldInfo.max_limit) data.max_limit = pInfo.max_limit;
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newPList) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(bList)) {
          data.block_list = newPList;
        }
      }
      if (!data.price && data.price !== 0) data.price = null;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data) !== '{}') {
        this.getDataH('put', url, data, function (response) {
          if (response.data.status === 200) {
            if (!type) {
              _this7.$notify({
                title: '提醒',
                text: '已更新' + pInfo.name,
                duration: 3000,
                type: 'success',
                width: 400
              });
            }
            if (pInfo.name !== oldInfo.name) {
              _this7.getMenuBlock('reload', pInfo.block_id);
            }
          }
        });
      }
    },
    getMenuBlock: function getMenuBlock() {
      var _this8 = this;

      this.blockList = [];
      var url = this.base + this.id + '/block/briefList?type=2';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          if (response.data.list.length) {
            var categoryList = response.data.list;
            categoryList.forEach(function (element) {
              var blockList = element.child_list;
              blockList.forEach(function (element) {
                _this8.$set(element, 'active', false);
                _this8.blockList.push(element);
              });
            });
            _this8.getPackage();
          } else if (_this8.curId) _this8.getPackage();
        }
      });
    },
    clickPackage: function clickPackage(p, index) {
      this.isLoad = true;
      this.curId = p.item_id;
      this.defaultIndex = index + 1;
      this.getMenuBlock();
    },
    delModalOpen: function delModalOpen() {
      this.delOption.title = '\u522A\u9664' + this.packageInfo.name;
    }
  }),
  created: function created() {
    this.getAllMenuPackage();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['getUpAdjust', 'getModal', 'getRoleType']), {
    allInput: function allInput() {
      return {
        name: this.checkInput(this.packageInfo.name),
        sort: this.checkInput(this.packageInfo.sort),
        vendor_custom_id: this.checkInput(this.packageInfo.adjust_custom_id),
        description: this.checkInput(this.packageInfo.description),
        remark: this.checkInput(this.packageInfo.remark),
        price: this.checkInput(this.packageInfo.price),
        calorie: this.checkInput(this.packageInfo.calorie),
        min_limit: this.checkInput(this.packageInfo.min_limit),
        max_limit: this.checkInput(this.packageInfo.max_limit)
      };
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    productNew: function productNew() {
      var product = this.product;
      return product;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.maxTotal / this.count);
    }
  })
});

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AdjustModal_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AdjustModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AdjustModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OptionModal_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OptionModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__OptionModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_ChooseModal_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_ChooseModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__elements_ChooseModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_ChooseOptionModal_vue__ = __webpack_require__(2091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_ChooseOptionModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__elements_ChooseOptionModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_ChooseMoneyModal_vue__ = __webpack_require__(2090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_ChooseMoneyModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__elements_ChooseMoneyModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__elements_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__extends_nd_extend_handle_menu_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__extends_nd_extend_handle_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__extends_nd_extend_handle_menu_vue__);














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CrProductTemp',
  extends: __WEBPACK_IMPORTED_MODULE_10__extends_nd_extend_handle_menu_vue___default.a,
  components: {
    'adjust-modal': __WEBPACK_IMPORTED_MODULE_3__AdjustModal_vue___default.a,
    'option-modal': __WEBPACK_IMPORTED_MODULE_4__OptionModal_vue___default.a,
    'c-modal': __WEBPACK_IMPORTED_MODULE_6__elements_ChooseModal_vue___default.a,
    'c-o-modal': __WEBPACK_IMPORTED_MODULE_7__elements_ChooseOptionModal_vue___default.a,
    'c-m-modal': __WEBPACK_IMPORTED_MODULE_8__elements_ChooseMoneyModal_vue___default.a,
    'm-modal': __WEBPACK_IMPORTED_MODULE_9__elements_Modal_vue___default.a
  },
  props: {
    'info': {
      type: Object
    }
  },
  data: function data() {
    return {
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      menuId: this.$route.params.menu_id,
      brandId: this.$route.params.brand_id,
      show: {
        easy: true
      },
      tab: 1,
      current: {
        option: 0,
        adjust: 0,
        adjustId: 0,
        adjustName: '',
        adjustSubType: 0
      },
      brandName: '',
      brandType: '',
      adjustNumList: [],
      adjust: [],
      option: [],
      amount: {
        adjust: 1,
        option: 1
      },
      count: 20,
      maxTotal: 0,
      select: {
        category: 0
      },
      categoryList: [],
      adjustList: [],
      productList: [],
      allProductList: [],
      packageList: [{ name: '比薩套餐', id: 1, active: false, remark: '' }, { name: '你訂A餐', id: 2, active: false, remark: '' }, { name: '你訂B餐', id: 3, active: false, remark: '' }, { name: '牛丼套餐', id: 4, active: false, remark: '' }, { name: '牛雞雙寶套餐', id: 5, active: false, remark: '' }, { name: '帕尼尼A餐', id: 6, active: false, remark: '' }],
      combineDetail: {
        name: '',
        is_common: '0',
        price: '',
        price_type: 3,
        description: '',
        remark: '',
        combine_id: '',
        product: { edge_price: '' }
      },
      productInfo: {
        name: '',
        sort: 1,
        description: '',
        remark: '',
        price: 0,
        price_type: 3,
        calorie: '',
        min_limit: 0,
        max_limit: 0,
        vendor_custom_id: ''
      },
      choseProdOption: {
        id: 'choseProdModal',
        title: '選擇商品',
        event: 'copyCombine'
      },
      choseOption: {
        id: 'choseModal',
        title: '選擇配料群組',
        event: 'chooseElement'
      },
      optionOption: {
        id: 'choseOptionModal',
        title: '單選配料',
        event: 'chooseOption'
      },
      moneyOption: {
        id: 'choseMoneyModal',
        title: '單選配料',
        event: 'chooseMoney'
      },
      curId: 0,
      curCId: 0,
      oldInfo: {},
      cOldInfo: {},
      isLoad: false,
      defaultIndex: 1,
      delProductOption: {
        id: 'delModal',
        title: '刪除商品',
        body: '刪除時，若被上架中的菜單使用中，則會被阻擋<br>刪除商品時，會一併刪除商品的做法限制與定價規則',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delProduct'
        }]
      },
      delCombineOption: {
        id: 'delCombineModal',
        title: '刪除組合',
        body: '刪除時，若被上架中的菜單使用中，則會被阻擋',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delCombine'
        }]
      },
      combinationList: []
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapActions */])(['setUpAdjust', 'setModal']), {
    toggle: function toggle() {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.infoAdjustModal).css('display');
    },
    maxAmount: function maxAmount(max) {
      if (!max) return '無限制';else return max;
    },
    getSubType: function getSubType(type) {
      if (type === 10) {
        return '大小';
      } else if (type === 20) {
        return '容器';
      } else if (type === 30) {
        return '甜度';
      } else if (type === 40) {
        return '溫度';
      } else {
        return '其他';
      }
    },
    getPriceType: function getPriceType(type) {
      if (type === 1) return '免稅價格';else if (type === 3) return '含稅價格';
    },
    veritySort: function veritySort() {
      var e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.sort);
      this.productInfo.sort = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityMinLimit: function verityMinLimit() {
      var e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.minLimit);
      this.productInfo.min_limit = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityMaxLimit: function verityMaxLimit() {
      var e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.maxLimit);
      this.productInfo.max_limit = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityPrice: function verityPrice() {
      var e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.price);
      this.productInfo.price = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityPriceProduct: function verityPriceProduct() {
      var e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.priceProduct);
      this.combineDetail.product.edge_price = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityPriceCombine: function verityPriceCombine() {
      var e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.priceCombine);
      this.combineDetail.price = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityCalorie: function verityCalorie() {
      var e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.calorie);
      this.productInfo.calorie = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    clickSave: function clickSave() {
      if (this.tab === 2) {
        this.checkCombineInput();
      } else this.checkInputEmpty();
    },
    checkCombineInput: function checkCombineInput() {
      if (!this.allInput.cName) {
        this.$notify({
          title: '提醒',
          text: '請填寫組合名稱',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.upCombine();
        return true;
      }
    },
    checkInputEmpty: function checkInputEmpty() {
      if (!this.allInput.name) {
        this.$notify({
          title: '提醒',
          text: '請填寫商品名稱',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!this.allInput.sort) {
        this.$notify({
          title: '提醒',
          text: '請填寫排序',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!parseInt(this.allInput.sort, 10)) {
        this.$notify({
          title: '請填寫正確排序',
          text: '排序範圍為1~9999',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!this.allInput.min_limit) {
        this.$notify({
          title: '提醒',
          text: '請填寫最低購買數',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!this.allInput.max_limit) {
        this.$notify({
          title: '提醒',
          text: '請填寫最高購買數',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.upProduct();
        return true;
      }
    },
    upProduct: function upProduct(type) {
      var _this = this;

      var url = this.base + this.id + '/product/' + this.curId;
      var data = {};
      var pInfo = this.productInfo;
      var oldInfo = this.oldInfo;
      if (type === 'sort') {
        data.sort = pInfo.sort;
        data.price = pInfo.price;
      } else {
        if (pInfo.sort !== oldInfo.sort) data.sort = pInfo.sort;
        if (pInfo.name !== oldInfo.name) data.name = pInfo.name;
        if (pInfo.vendor_custom_id !== oldInfo.vendor_custom_id) data.vendor_custom_id = pInfo.vendor_custom_id;
        if (pInfo.description !== oldInfo.description) data.description = pInfo.description;
        if (pInfo.remark !== oldInfo.remark) data.remark = pInfo.remark;
        if (pInfo.price !== oldInfo.price) data.price = pInfo.price;
        if (pInfo.price_type !== oldInfo.price_type) data.price_type = pInfo.price_type;
        if (pInfo.calorie !== oldInfo.calorie) data.calorie = pInfo.calorie;
        if (pInfo.min_limit !== oldInfo.min_limit) data.min_limit = pInfo.min_limit;
        if (pInfo.max_limit !== oldInfo.max_limit) data.max_limit = pInfo.max_limit;
        if (pInfo.sub_type !== oldInfo.sub_type) data.sub_type = pInfo.sub_type;
      }
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data) !== '{}') {
        this.getDataH('put', url, data, function (response) {
          if (response.data.status === 200) {
            if (!type) {
              _this.$notify({
                title: '提醒',
                text: '已更新' + pInfo.name,
                duration: 3000,
                type: 'success',
                width: 400
              });
            }
            if (pInfo.name !== oldInfo.name) {
              _this.getMenuProduct('reload', pInfo.product_id);
            }
          }
        });
      }
    },
    upCombine: function upCombine() {
      var _this2 = this;

      var cDetail = this.combineDetail;
      var oldInfo = this.cOldInfo;
      var url = this.base + this.id + '/combination';
      var data = {};
      var aList = [];
      var oList = [];
      var adjust = this.adjustList.filter(function (o) {
        return o.active;
      });
      adjust.forEach(function (a) {
        var aPrice = a.price;
        var aLength = a.child_list.length;
        var option = a.child_list.filter(function (op) {
          return op.active;
        });
        var oLength = option.length;
        if (aLength === oLength) {
          var aItem = a.item_id + '/';
          var isOPrice = a.child_list.find(function (opt1) {
            return opt1.price;
          });
          if (aPrice) {
            aItem = aItem + parseInt(a.price, 10);
            aList.push(aItem);
          } else if (isOPrice) {
            a.child_list.forEach(function (opt) {
              if (opt.active) {
                var oItem = opt.item_id + '/';
                var oPrice = opt.price;
                if (oPrice) oItem = oItem + parseInt(oPrice, 10);
                oList.push(oItem);
              }
            });
          } else {
            aList.push(aItem);
          }
        } else {
          a.child_list.forEach(function (option) {
            if (option.active) {
              var optItem = option.item_id + '/';
              var optPrice = option.price;
              if (aPrice) optItem = optItem + parseInt(aPrice, 10);else if (optPrice) optItem = optItem + parseInt(optPrice, 10);
              oList.push(optItem);
            }
          });
        }
      });
      if (this.curCId) {
        url = url + '/' + cDetail.combine_id;
        if (cDetail.name !== oldInfo.name) data.name = cDetail.name;
        if (cDetail.price !== oldInfo.price) data.price = cDetail.price;
        if (!cDetail.price) data.price = null;
        if (cDetail.price_type !== oldInfo.price_type) data.price_type = cDetail.price_type;
        if (cDetail.is_common !== oldInfo.is_common) data.is_common = cDetail.is_common;
        data.product_id = this.curId + '/';
        if (cDetail.product.edge_price) data.product_id += cDetail.product.edge_price;
        data.adjust = aList;
        data.option = oList;
      } else {
        data = {
          name: cDetail.name,
          price: cDetail.price,
          price_type: cDetail.price_type,
          is_common: cDetail.is_common,
          product_id: this.curId + '/',
          adjust: aList,
          option: oList
        };
        if (cDetail.product.edge_price) data.product_id += cDetail.product.edge_price;
      }
      if (!data.price) data.price = null;
      if (cDetail.remark !== oldInfo.remark) data.remark = cDetail.remark;
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          if (_this2.curCId) {
            _this2.$notify({
              title: '提醒',
              text: '已更新' + _this2.productInfo.name + '的' + data.name,
              duration: 3000,
              type: 'success',
              width: 400
            });
          } else {
            _this2.$notify({
              title: '提醒',
              text: '已新增' + data.name,
              duration: 3000,
              type: 'success',
              width: 400
            });
            _this2.getCombineList();
          }
        }
      });
    },
    delAdjust: function delAdjust() {
      var _this3 = this;

      var url = this.base + this.id + '/adjust?adjust_id=' + this.adjustId;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          _this3.$notify({
            title: '提醒',
            text: '成功刪除調整類別',
            duration: 3000,
            type: 'success',
            width: 400
          });
          _this3.editState = false;
          var id = _this3.modalId;
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#' + id).modal('toggle');
          _this3.setUpAdjust(true);
        }
      });
    },
    clearData: function clearData() {
      this.adjustInfo = {
        name: '',
        sort: 1,
        description: '',
        remark: '',
        price: '',
        price_type: 3,
        calorie: '',
        min_limit: '0',
        max_limit: '0',
        adjust_custom_id: '',
        is_mandatory: '0',
        is_common: '0',
        sub_type: '0'
      };
    },
    gotoCrProducts: function gotoCrProducts() {
      console.log('gotoCrProducts');
      var name = '';
      var params = {
        brand_id: this.$route.params.brand_id,
        store_id: ''
      };

      if (this.isStore && this.getRoleType !== 10) {
        name = 'StoreMenuProductCreate';
        params.store_id = this.$route.params.store_id;
      } else {
        name = 'crProducts';
      }

      this.$router.push({ name: name, params: params });
    },
    gotoOut: function gotoOut() {
      this.$router.go(-1);
    },
    trigger: function trigger(event) {
      if (event === 'delProduct') {
        this.delProduct(this.productInfo.name);
      } else if (event === 'delCombine') {
        this.delCombine(this.combineDetail.name);
      } else if (event === 'copyCombine') {
        var copyList = [];
        this.allProductList.forEach(function (prod) {
          if (prod.active) {
            copyList.push(prod.item_id);
          }
        });
        this.copyCombine(copyList);
      }
    },
    copyCombine: function copyCombine(list) {
      var _this4 = this;

      var url = this.base + this.id + '/combination/' + this.curCId + '/copy';
      var data = {
        product_list: list
      };
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          _this4.$notify({
            title: '提醒',
            text: '已複製組合至其他商品',
            duration: 3000,
            type: 'success',
            width: 400
          });
          _this4.allProductList.forEach(function (prod) {
            prod.active = false;
          });
        }
      });
    },
    delProduct: function delProduct(delName) {
      var _this5 = this;

      var url = this.base + this.id + '/product?product_id=' + this.curId;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          _this5.$notify({
            title: '提醒',
            text: '已刪除' + delName,
            duration: 3000,
            type: 'success',
            width: 400
          });
          _this5.curId = '';
          _this5.curCId = '';
          _this5.getMenuProduct();
        }
      });
    },
    delCombine: function delCombine(delName) {
      var _this6 = this;

      var url = this.base + this.id + '/combination?combine_id=' + this.curCId;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          _this6.$notify({
            title: '提醒',
            text: '已刪除' + delName,
            duration: 3000,
            type: 'success',
            width: 400
          });
          _this6.curCId = '';
          _this6.getCombineList();
        }
      });
    },
    getMenuCategory: function getMenuCategory() {
      var _this7 = this;

      var url = this.base + this.id + '/category/briefList';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var categoryList = response.data.list;
          _this7.categoryList = categoryList;
          var select = {
            name: '未分類',
            item_id: 0
          };
          _this7.categoryList.push(select);
          if (!_this7.select.category) _this7.select.category = categoryList[0].item_id;
        }
      });
    },
    getAllMenuProduct: function getAllMenuProduct() {
      var _this8 = this;

      this.allProductList = [];
      var url = this.base + this.id + '/product/briefList?type=0';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var list = response.data.list;
          list.forEach(function (category) {
            category.child_list.forEach(function (prod) {
              _this8.$set(prod, 'active', false);
              _this8.allProductList.push(prod);
            });
          });
        }
      });
    },
    copyProduct: function copyProduct() {
      var _this9 = this;

      var url = this.base + this.id + '/product/' + this.curId + '/duplicate';
      this.getDataH('post', url, null, function (response) {
        if (response.data.status === 200) {
          _this9.$notify({
            title: '提醒',
            text: '成功複製商品到未分類',
            duration: 3000,
            type: 'success',
            width: 400
          });
          _this9.getMenuProduct('clickOther', response.data.new_product_id);
        }
      });
    },
    getMenuProduct: function getMenuProduct() {
      var _this10 = this;

      this.curCId = 0;
      this.combinationList = [];
      var url = this.base + this.id + '/product/briefList';
      if (this.select.category) url = url + '?type=3&parent_item_id=' + this.select.category;else url = url + '?type=2';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this10.isLoad = false;
          if (response.data.list.length) {
            _this10.productList = response.data.list[0].child_list;
            if (_this10.productList.length) {
              if (!_this10.curId) _this10.curId = _this10.productList[0].item_id;
              _this10.getProduct();
            }
          } else _this10.productList = [];
        }
      });
    },
    clickProduct: function clickProduct(product, index) {
      this.isLoad = true;
      this.curId = product.item_id;
      this.defaultIndex = index + 1;
      this.productInfo = {};
      this.combineDetail = {
        name: '',
        is_common: 0,
        price: '',
        price_type: 3,
        description: '',
        remark: '',
        combine_id: '',
        product: { edge_price: '' }
      };
      this.adjustList = [];
      this.getMenuProduct();
    },
    getProduct: function getProduct() {
      var _this11 = this;

      var url = this.base + this.id + '/product/' + this.curId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this11.productInfo = response.data.product;
          __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.each(response.data.product, function (index, value) {
            _this11.$set(_this11.oldInfo, index, value);
          });
          if (!_this11.productInfo.sort || !_this11.productInfo.price && parseInt(_this11.productInfo.price, 10) !== 0) {
            _this11.productInfo.sort = _this11.defaultIndex;
            _this11.productInfo.price = 1;
            _this11.upProduct('sort');
          }
          _this11.getCombineList();
        }
      });
    },
    getCombineList: function getCombineList() {
      var _this12 = this;

      var url = this.base + this.id + '/product/' + this.curId + '/combinationlist?page=1&size=20';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this12.combinationList = response.data.combination_list;
          if (!_this12.curCId && _this12.combinationList.length) {
            _this12.curCId = _this12.combinationList[0].combine_id;
          }
          _this12.getMenuOption();
        }
      });
    },
    newCombine: function newCombine() {
      this.combineDetail = {
        name: '',
        is_common: 0,
        price: '',
        price_type: 3,
        description: '',
        remark: '',
        combine_id: '',
        product: { edge_price: '' }
      };
      this.curCId = 0;
    },
    getMenuOption: function getMenuOption() {
      var _this13 = this;

      var url = this.base + this.id + '/option/briefList?type=1';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var adjustList = response.data.list;
          adjustList.forEach(function (element) {
            element.active = false;
            element.price = '';
            element.child_list.forEach(function (option) {
              option.active = false;
              option.price = '';
            });
          });
          _this13.adjustList = adjustList;
          _this13.clickCombine(_this13.curCId);
        }
      });
    },
    clickCombine: function clickCombine(cId) {
      this.curCId = cId;
      if (this.curCId) this.getCombine();else this.newCombine();
    },
    getCombine: function getCombine() {
      var _this14 = this;

      var url = this.base + this.id + '/combination/' + this.curCId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this14.combineDetail = response.data.combination;
          _this14.setCombine();
        }
      });
    },
    setCombine: function setCombine() {
      var _this15 = this;

      this.adjustList.forEach(function (clearA) {
        clearA.active = false;
        clearA.price = '';
        clearA.child_list.forEach(function (clearO) {
          clearO.active = false;
          clearO.price = '';
        });
      });
      this.combineDetail.adjust_list.forEach(function (cAdjust) {
        _this15.adjustList.forEach(function (a) {
          if (a.item_id === cAdjust.adjust_id) {
            a.active = true;
            if (typeof cAdjust.edge_price !== 'undefined') a.price = cAdjust.edge_price;
            a.child_list.forEach(function (o) {
              o.active = true;
            });
          }
        });
      });
      this.combineDetail.option_list.forEach(function (cOption) {
        _this15.adjustList.forEach(function (adjust) {
          adjust.child_list.forEach(function (option) {
            if (option.item_id === cOption.option_id) {
              adjust.active = true;
              option.active = true;
              if (typeof cOption.edge_price !== 'undefined') option.price = cOption.edge_price;
            }
          });
        });
      });
    }
  }),
  mounted: function mounted() {
    this.getMenuCategory();
    this.getAllMenuProduct();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['getUpAdjust', 'getModal', 'getRoleType']), {
    checkAdjustActive: function checkAdjustActive() {
      var active = this.adjustList.find(function (o) {
        return o.active;
      });
      return active;
    },
    modalState: function modalState() {
      if (this.state === 3 && !this.editState) return this.adjustInfo.name;
      if (this.editState) return '編輯' + this.adjustInfo.name;else return '新增調整類別';
    },
    allInput: function allInput() {
      var info = this.productInfo;
      return {
        name: this.checkInput(info.name),
        cName: this.checkInput(this.combineDetail.name),
        sort: this.checkInput(info.sort),
        vendor_custom_id: this.checkInput(info.vendor_custom_id),
        description: this.checkInput(info.description),
        remark: this.checkInput(info.remark),
        price: this.checkInput(info.price),
        calorie: this.checkInput(info.calorie),
        min_limit: this.checkInput(info.min_limit),
        max_limit: this.checkInput(info.max_limit)
      };
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    productNew: function productNew() {
      var product = this.product;
      return product;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.maxTotal / this.count);
    }
  }),
  watch: {
    getModal: function getModal() {
      if (this.getModal) {
        this.$nextTick(function () {
          this.$set(this.adjustInfo, 'is_mandatory', '0');
          this.$set(this.adjustInfo, 'is_common', '0');
        });
        this.editState = false;
        this.show.delNotify = false;
        if (this.adjustId && this.state !== 1) {
          this.getAdjustInfo();
        }
      }
    },
    'select.category': function selectCategory() {
      this.curId = 0;
      this.getMenuProduct();
    }
  }
});

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_dropzone__ = __webpack_require__(2575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone_dist_vue2Dropzone_min_css__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone_dist_vue2Dropzone_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_dropzone_dist_vue2Dropzone_min_css__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id', 'type', 'amount', 'imgList'],
  components: {
    vueDropzone: __WEBPACK_IMPORTED_MODULE_0_vue2_dropzone___default.a
  },
  data: function data() {
    return {
      image: [],
      img: {
        width: 0,
        height: 0
      },
      ok: true,
      example: '測試測試測試',
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 150,
        maxFilesize: 2,
        maxFiles: this.amount,
        addRemoveLinks: true,
        uploadMultiple: false,
        timeout: 3000
      },
      fileAdded: false,
      filesAdded: false,
      success: false,
      error: false,
      removedFile: false,
      sending: false,
      successMultiple: false,
      sendingMultiple: false,
      queueComplete: false,
      uploadProgress: false,
      progress: false,
      myProgress: 0,
      isMounted: false,
      dDrop: false,
      dStarted: false,
      dEnded: false,
      dEntered: false,
      dOver: false,
      dLeave: false,
      dDuplicate: false
    };
  },

  methods: {
    vfileAdded: function vfileAdded(file) {
      this.fileAdded = true;
    },
    vfilesAdded: function vfilesAdded(file) {
      this.filesAdded = true;
    },
    vsuccess: function vsuccess(file, response) {
      this.success = true;
    },
    verror: function verror(file, message, xhr) {
      this.error = true;
      console.log('error', file);

      if (xhr && file.previewElement) file.previewElement.classList.remove('dz-error');
      var alreadyAdded = this.image.some(function (o) {
        return o.name === file.name;
      });
      if (!alreadyAdded) this.createImage(file);
    },
    vremoved: function vremoved(file, xhr, error) {
      var _this = this;

      this.removedFile = true;
      this.$nextTick(function () {
        return _this.removeImage(file);
      });
    },
    vsending: function vsending(file, xhr, formData) {
      this.sending = true;
      console.log('send', file);
      this.createImage(file);
    },
    vsuccessMuliple: function vsuccessMuliple(files, response) {
      this.successMultiple = true;
      console.log('vsuccessMuliple');
    },
    vsendingMuliple: function vsendingMuliple(file, xhr, formData) {
      this.sendingMultiple = true;
      console.log('vsendingMuliple', file);
    },
    vqueueComplete: function vqueueComplete(file, xhr, formData) {
      this.queueComplete = true;
      console.log('complete', file);
    },
    vprogress: function vprogress(totalProgress, totalBytes, totalBytesSent) {
      this.progress = true;
      this.myProgress = Math.floor(totalProgress);
      console.log('vprogress');
    },
    vmounted: function vmounted() {
      console.log('vmounted');
      this.isMounted = true;
    },
    vddrop: function vddrop() {
      this.dDrop = true;
    },
    vdstart: function vdstart() {
      this.dStarted = true;
    },
    vdend: function vdend() {
      this.dEnded = true;
    },
    vdenter: function vdenter() {
      this.dEntered = true;
    },
    vdover: function vdover() {
      this.dOver = true;
    },
    vdleave: function vdleave() {
      this.dLeave = true;
    },
    vdduplicate: function vdduplicate() {
      this.dDuplicate = true;
      alert('請勿上傳相同檔名！');
    },
    removeImage: function removeImage(file) {
      if (!this.dDuplicate) {
        var index = this.image.findIndex(function (o) {
          return o.name === file.name;
        });
        if (index > -1) this.image.splice(index, 1);
      }
    },
    createImage: function createImage(file) {
      var _this2 = this;

      var reader = new FileReader();
      var self = this;
      reader.onload = function (e) {
        var img = new Image();
        img.src = e.target.result;
        var obj = { name: file.name, src: img.src, file: file };

        img.onload = function () {
          self.img.width = img.width;
          self.img.height = img.height;
          var valid = self.checkImgSize();

          if (valid) self.image.push(obj);else _this2.$refs.myVueDropzone.removeFile(file);
        };
      };

      reader.readAsDataURL(file);
    },
    checkImgSize: function checkImgSize() {
      var valid = true;
      var self = this;
      if (this.type === 1) {
        if ((this.img.width !== 80 || this.img.height !== 60) && this.img.width !== 0 && this.img.height !== 0 && this.$route.name !== 'crCategoryImg') {
          this.$notify({
            title: '提醒',
            text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳80x60之圖片！',
            duration: 3000,
            type: 'danger',
            width: 400
          });
          valid = false;
        }
      } else if (this.type === 2) {
        if ((this.img.width !== 800 || this.img.height !== 600) && this.img.width !== 0 && this.img.height !== 0) {
          this.$notify({
            title: '提醒',
            text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳800x600之圖片！',
            duration: 3000,
            type: 'danger',
            width: 400
          });
          valid = false;
        }
      }

      return valid;
    }
  },
  watch: {
    fileAdded: function fileAdded() {
      var that = this;
      setTimeout(function () {
        that.fileAdded = false;
      }, 2000);
    },
    filesAdded: function filesAdded() {
      var that = this;
      setTimeout(function () {
        that.filesAdded = false;
      }, 2000);
    },
    success: function success() {
      var that = this;
      setTimeout(function () {
        that.success = false;
      }, 2000);
    },
    error: function error() {
      var that = this;
      setTimeout(function () {
        that.error = false;
      }, 2000);
    },
    removedFile: function removedFile() {
      var that = this;
      setTimeout(function () {
        that.removedFile = false;
      }, 2000);
    },
    sending: function sending() {
      var that = this;
      setTimeout(function () {
        that.sending = false;
      }, 2000);
    },
    successMultiple: function successMultiple() {
      var that = this;
      setTimeout(function () {
        that.successMultiple = false;
      }, 2000);
    },
    sendingMultiple: function sendingMultiple() {
      var that = this;
      setTimeout(function () {
        that.sendingMultiple = false;
      }, 2000);
    },
    queueComplete: function queueComplete() {
      var that = this;
      setTimeout(function () {
        that.queueComplete = false;
      }, 2000);
    },
    progress: function progress() {
      var that = this;
      setTimeout(function () {
        that.progress = false;
      }, 2000);
    },
    isMounted: function isMounted() {
      var that = this;
      setTimeout(function () {
        that.isMounted = false;
      }, 2000);
    },
    dDrop: function dDrop() {
      var that = this;
      setTimeout(function () {
        that.dDrop = false;
      }, 2000);
    },
    dStarted: function dStarted() {
      var that = this;
      setTimeout(function () {
        that.dStarted = false;
      }, 2000);
    },
    dEnded: function dEnded() {
      var that = this;
      setTimeout(function () {
        that.dEnded = false;
      }, 2000);
    },
    dEntered: function dEntered() {
      var that = this;
      setTimeout(function () {
        that.dEntered = false;
      }, 2000);
    },
    dOver: function dOver() {
      var that = this;
      setTimeout(function () {
        that.dOver = false;
      }, 2000);
    },
    dLeave: function dLeave() {
      var that = this;
      setTimeout(function () {
        that.dLeave = false;
      }, 2000);
    },
    dDuplicate: function dDuplicate() {
      var that = this;
      setTimeout(function () {
        that.dDuplicate = false;
      }, 2000);
    },
    image: function image() {
      if (typeof this.imgList !== 'undefined') {
        if (this.type === 1) this.imgList.smImgList = this.image;else if (this.type === 2) this.imgList.lgImgList = this.image;
      }
    }
  }
});

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    index: Number,
    type: Number,
    imgSrc: String,
    checkLoading: Function
  },
  data: function data() {
    return {
      image: '',
      img: {
        width: 0,
        height: 0
      }
    };
  },

  methods: {
    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var imgName = files[0].name.split('.');
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.createImage(files[0]);
      }
    },
    createImage: function createImage(file) {
      var _this = this;

      var reader = new FileReader();
      var self = this;
      reader.onload = function (e) {
        var img = new Image();
        img.src = e.target.result;
        self.image = img.src;

        img.onload = function () {
          self.img.width = img.width;
          self.img.height = img.height;
          var valid = self.checkImgSize();
          if (valid) self.checkLoading(_this.index, true);else self.image = null;
        };
      };
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.img-size').css('background', 'white');
      reader.readAsDataURL(file);
    },
    checkImgSize: function checkImgSize() {
      var valid = true;
      var self = this;
      if (this.type === 1) {
        if ((this.img.width !== 80 || this.img.height !== 60) && this.img.width !== 0 && this.img.height !== 0 && this.$route.name !== 'upCategoryImg') {
          this.$notify({
            title: '提醒',
            text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳80x60之圖片！',
            duration: 3000,
            type: 'danger',
            width: 400
          });
          valid = false;
        }
      } else if (this.type === 2) {
        if ((this.img.width !== 800 || this.img.height !== 600) && this.img.width !== 0 && this.img.height !== 0) {
          this.$notify({
            title: '提醒',
            text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳800x600之圖片！',
            duration: 3000,
            type: 'danger',
            width: 400
          });
          valid = false;
        }
      }
      return valid;
    }
  },
  watch: {
    imgSrc: function imgSrc() {
      if (typeof this.imgSrc !== 'undefined') {
        this.image = this.imgSrc;
      }
    }
  }
});

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extends_nd_extend_handle_menu_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extends_nd_extend_handle_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__extends_nd_extend_handle_menu_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MenuInfoFormTemp',
  props: {
    'info': {
      type: Object
    }
  },
  data: function data() {
    return {
      brandName: '',
      brandType: '',
      menuInfo: {
        name: '',
        description: '',
        remark: ''
      },
      delMenuOption: {
        id: 'delMenuModal',
        title: '刪除菜單',
        body: '1. 實際品項內容不會被刪除，仍可被重複利用<br>2. 菜單目前鎖定中或是上架中，無法執行更新<br><br>',
        btns: [{
          name: '取消'
        }, {
          name: '刪除',
          event: 'delMenu'
        }]
      }
    };
  },

  extends: __WEBPACK_IMPORTED_MODULE_3__extends_nd_extend_handle_menu_vue___default.a,
  components: {
    'm-modal': __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    menuInfoNew: function menuInfoNew() {
      return {
        name: this.checkInput(this.menuInfo.name),
        description: this.checkInput(this.menuInfo.description),
        remark: this.checkInput(this.menuInfo.remark)
      };
    }
  }),
  created: function created() {
    this.init();
  },

  methods: {
    checkInputEmpty: function checkInputEmpty(type) {
      if (!this.menuInfoNew.name) {
        this.$notify({
          title: '菜單名稱為空',
          text: '請填寫菜單名稱',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        if (type === 'cr') this.crMenu();else if (type === 'up') this.upMenu();
      }
    },
    crMenu: function crMenu() {
      var _this = this;

      var menuInfo = this.menuInfoNew;
      var url = this.base + this.id + '/menu';
      var data = {
        name: menuInfo.name
      };
      if (menuInfo.description) data['description'] = menuInfo.description;
      if (menuInfo.remark) data['remark'] = menuInfo.remark;
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          var name = '';
          var params = {
            brand_id: _this.$route.params.brand_id,
            menu_id: response.data.menu_id,
            store_id: ''
          };
          var query = {
            copy_menu_id: _this.$route.query.copy_menu_id
          };

          if (_this.isStore && _this.getRoleType !== 10) {
            name = 'StoreMenuEditeUpJoin';
            params.store_id = _this.$route.params.store_id;
          } else {
            name = 'upJoinMenu';
          }

          _this.$router.push({ name: name, params: params, query: query });
        }
      });
    },
    delMenu: function delMenu() {
      var _this2 = this;

      var url = this.base + this.id + '/menu/' + this.$route.params.menu_id;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          _this2.$notify({
            title: '訊息',
            text: '成功刪除菜單',
            duration: 3000,
            type: 'success',
            width: 400
          });

          var name = '';
          var params = {
            brand_id: _this2.$route.params.brand_id,
            store_id: ''
          };

          if (_this2.isStore && _this2.getRoleType !== 10) {
            name = 'StoreMenuBuild';
            params.store_id = _this2.$route.params.store_id;
          } else {
            name = 'brandMenuTable';
          }

          _this2.$router.push({ name: name, params: params });
        }
      });
    },
    init: function init() {
      switch (this.$route.name) {
        case 'upMenu':
        case 'StoreMenuEdite':
          this.getMenuContainer();
          break;
        default:
          break;
      }
    },
    goToBack: function goToBack() {
      console.log('goToBack');
      this.$router.go(-1);
    },
    getMenuContainer: function getMenuContainer() {
      var _this3 = this;

      var url = this.base + this.id + '/menu/' + this.$route.params.menu_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this3.menuInfo = response.data.menu;
        }
      });
    },
    trigger: function trigger(event) {
      if (event === 'delMenu') {
        this.delMenu();
      }
    },
    upMenu: function upMenu() {
      var _this4 = this;

      var menuInfo = this.menuInfoNew;
      var url = this.base + this.id + '/menu/' + this.$route.params.menu_id;
      var data = {
        name: menuInfo.name,
        description: menuInfo.description,
        remark: menuInfo.remark
      };
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          var name = '';
          var params = {
            brand_id: _this4.$route.params.brand_id,
            menu_id: _this4.$route.params.menu_id,
            store_id: ''
          };
          var query = {
            copy_menu_id: _this4.$route.query.copy_menu_id
          };

          if (_this4.isStore && _this4.getRoleType !== 10) {
            name = 'StoreMenuEditeUpJoin';
            params.store_id = _this4.$route.params.store_id;
          } else {
            name = 'upJoinMenu';
          }

          _this4.$router.push({ name: name, params: params, query: query });
        }
      });
    }
  }
});

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    menu: Object,
    schema: Object,
    showMenuIcon: Number,
    getElement: Function,
    changeToProductList: Function,
    checkDisableItem: Function,
    layout: [Number, Boolean],
    showProductIcon: [Number, Boolean],
    getLower: Function,
    openModal: Function,
    getIcon: Function,
    getTempE: Function,
    prodImgList: Object
  },
  data: function data() {
    return {};
  },

  methods: {
    getMainImage: function getMainImage(pId) {
      if (this.prodImgList[pId]) return this.prodImgList[pId].main_image.url;
    }
  },
  computed: {
    showXsImg: function showXsImg() {
      var layout = this.layout;
      switch (layout) {
        case 1:
          return false;
        case 2:
          return true;
        case 3:
          return true;
        case 4:
          return false;
        default:
          return false;
      }
    }
  }
});

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_js_parse_menu_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MenuList_vue__ = __webpack_require__(2219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MenuList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MenuList_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    type: String,
    menu: Object,
    schema: Object,
    layout: [Number, Boolean],
    showProductIcon: [Number, Boolean],
    changeToProductList: Function,
    checkDisableItem: Function,
    openModal: Function,
    getIcon: Function,
    isSearch: Boolean,
    showMenuIcon: [Boolean, Number],
    loading: Object,
    minPrice: Object,
    prodImgList: Object
  },
  data: function data() {
    return {};
  },

  components: {
    'menu-list': __WEBPACK_IMPORTED_MODULE_1__MenuList_vue___default.a
  },
  methods: {
    getProduct: function getProduct(productId) {
      return this.menu.productList[productId];
    },
    changeToCombineList: function changeToCombineList(number) {
      return this.menu.combineList[number];
    },
    getElement: function getElement(list, index) {
      var element;

      if (index === 2) {
        element = 0;
        for (var i = 0; i < list.length; i++) {
          element = element + parseInt(list[i][index]);
        }
      } else if (index === 1) {
        element = 0;
        for (var k = 0; k < list.length; k++) {
          var t = list[k][index];
          if (t === 41 || t === 42 || t === 43 || t === 44 || t === 45 || t === 46 || t === 47 || t === 48 || t === 49) {
            element = element + parseInt(list[k][index]);
          }
        }
      } else {
        element = '';
        for (var j = 0; j < list.length; j++) {
          element = list[j][index];
        }
      }
      return element;
    },
    getLower: function getLower(result) {
      var pSchema = this.schema.product;
      var prod = this.getProduct(result);
      var price = [prod[pSchema.name], 0, prod[pSchema.price], 3];
      if (prod[pSchema.type] === 3) {
        return [[price]];
      } else {
        return this.checkLowerPrice(this.parsePrice(result), result);
      }
    },
    checkLowerPrice: function checkLowerPrice(priceList, number) {
      var priceHot = [];
      var priceCold = [];
      var cold = [];
      var hot = [];
      var def = [];
      var newPriceList = [];
      var priceDefault = [];
      for (var k = 0; k < priceList.length; k++) {
        var tag = 0;
        for (var j = 0; j < priceList[k].length; j++) {
          var type = priceList[k][j][1];
          if (type === 41 || type === 42 || type === 43) {
            priceCold.push(this.getElement(priceList[k], 2));
            cold.push(priceList[k]);
            tag = 1;
          } else if (type === 44 || type === 45 || type === 46 || type === 47 || type === 48 || type === 49) {
            priceHot.push(this.getElement(priceList[k], 2));
            hot.push(priceList[k]);
            tag = 1;
          }
        }
        if (tag === 0) {
          priceDefault.push(this.getElement(priceList[k], 2));
          def.push(priceList[k]);
        }
      }
      for (var l = 0; l < priceList.length; l++) {
        for (var g = 0; g < priceList[l].length; g++) {
          var type2 = priceList[l][g][1];
          if (type2 === 41 || type2 === 42 || type2 === 43) {
            if (this.getElement(priceList[l], 2) === Math.min.apply(Math, priceCold)) {
              newPriceList.push(priceList[l]);
            }
          } else if (type2 === 44 || type2 === 45 || type2 === 46 || type2 === 47 || type2 === 48 || type2 === 49) {
            if (this.getElement(priceList[l], 2) === Math.min.apply(Math, priceHot)) {
              newPriceList.push(priceList[l]);
            }
          } else {
            if (this.getElement(priceList[l], 2) === Math.min.apply(Math, priceDefault)) {
              newPriceList.push(priceList[l]);
            }
          }
        }
      }
      var allMinPrice = [];
      for (var c = 0; c < priceList.length; c++) {
        var allMin = 0;
        for (var p = 0; p < priceList[c].length; p++) {
          if (priceList[c][p][2]) allMin = allMin + priceList[c][p][2];
        }
        allMinPrice.push(allMin);
      }
      this.minPrice[number] = Math.min.apply(Math, allMinPrice);
      if (this.showMenuIcon === 2 && newPriceList.length) {
        for (var n = 0; n < newPriceList.length; n++) {
          if (n === 0) {
            var noIconPriceList = [];
            var noIconP = [];
            var noIcon = newPriceList[n][0];
            noIconP.push(noIcon);
            noIconPriceList.push(noIconP);
            return noIconPriceList;
          }
        }
      }

      return newPriceList;
    },
    parsePrice: function parsePrice(number) {
      var pSchema = this.schema.product;
      var cSchema = this.schema.combine;
      var combinations = this.changeToProductList(number)[pSchema.combine_list];
      var combination = __WEBPACK_IMPORTED_MODULE_0__assets_js_parse_menu_js__["a" /* default */].divideList(combinations, this.changeToCombineList);
      var allMethods = [];
      var buffer = [];
      if (combinations) {
        this.loading.menu = false;
        for (var q = 0; q < combination.length; q++) {
          buffer.push(__WEBPACK_IMPORTED_MODULE_0__assets_js_parse_menu_js__["a" /* default */].getCommons(combination[q][cSchema.common_list]));
        }
        for (var h = 0; h < buffer.length; h++) {
          for (var b = 0; b < buffer[h].length; b++) {
            allMethods.push(buffer[h][b]);
          }
        }
        return allMethods;
      }
    },
    getTempE: function getTempE(price, index) {
      return this.checkTemp(this.getElement(price, index));
    },
    checkTemp: function checkTemp(temp) {
      if (this.showMenuIcon === 2) {
        return 'text-light-gray';
      } else if (temp === 42) {
        return 'text-blue';
      } else if (temp === 48) {
        return 'text-light-pink';
      } else if (temp === 40) {
        return 'text-light-pink';
      } else {
        if (!this.showMenuIcon) return 'text-light-gray';else return 'text-blue';
      }
    }
  }
});

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_parse_menu_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MenuOptions_vue__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MenuOptions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MenuOptions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'menu-options': __WEBPACK_IMPORTED_MODULE_2__MenuOptions_vue___default.a
  },
  props: {
    modalView: {
      type: Boolean
    },
    currentProduct: {
      type: [Array]
    },
    brandId: {
      type: Number
    },
    menuJson: {
      type: [Object, String]
    }
  },
  data: function data() {
    return {
      isVisible: [],
      tags: 0,
      isOption: [],
      isShow: [],
      cartMount: 0,
      totalPrice: function totalPrice() {
        return parseInt(this.number, 10) * this.price;
      },

      combineId: '',
      adjusts: [],
      adjustsIndexMapping: {},
      optionsIndexMapping: {},
      counter: 0,
      limitList: [],
      productCombineIds: [],
      number: 1,
      price: 0,
      currentMenuJson: '',
      storeId: this.$route.params.storeId,
      schema: {
        category: {},
        product: {},
        icon: {},
        image: {},
        tag: {},
        adjust: {},
        option: {},
        combine: {},
        edge: {},
        common: {},
        block: {}
      },
      menu: {
        categoryList: {},
        productList: {},
        adjustList: {},
        optionList: {},
        combineList: {}
      },
      show: {
        reChoose: false,
        picDetail: false
      },
      swiperOption: {
        autoplay: 4000,
        setWrapperSize: true,
        pagination: '.img-pagination',
        paginationClickable: true,

        observeParents: true,
        prevButton: '.img-button-prev',
        nextButton: '.img-button-next',
        loop: true,
        paginationElement: 'li'
      },

      addPrice: {},
      addDetail: {},

      optionStyle: false
    };
  },

  methods: {
    clickAdd: function clickAdd() {
      var pSchema = this.schema.product;
      if (this.$refs['menu-options-' + this.currentProduct[pSchema.product_id]].clickAdd()) this.addProduct();
    },
    addProduct: function addProduct() {
      var pSchema = this.schema.product;
      var aSchema = this.schema.adjust;
      var oSchema = this.schema.option;

      var products = {
        items: this.addDetail[this.currentProduct[pSchema.product_id]].items
      };
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.adjusts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var adjust = _step.value;

          if (adjust.activeCount > 0) {
            var adjustP = {
              adjust_id: parseInt(adjust[aSchema.product_id], 10),
              options: []
            };
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(adjust[aSchema.option_list]), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var option = _step2.value;

                if (option.activeCount > 0) {
                  adjustP.options.push({ option_id: parseInt(option[oSchema.product_id], 10), amount: 1 });
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            products.items[0].adjusts.push(adjustP);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.$notify({
        title: '成功',
        text: '成功加入商品',
        duration: 2500,
        type: 'success'
      });
    },
    adjustsOfProduct: function adjustsOfProduct(productId) {
      return this.getProduct(productId)[this.schema.product.adjust_list];
    },
    optionsOfAdjust: function optionsOfAdjust(adjustId) {
      return this.getAdjust(adjustId)[this.schema.adjust.option_list];
    },
    combinesOfProduct: function combinesOfProduct(productId) {
      return this.getProduct(productId)[this.schema.product.combine_list];
    },
    getProduct: function getProduct(productId) {
      return this.menu.productList[productId];
    },
    getAdjust: function getAdjust(adjustId) {
      return this.menu.adjustList[adjustId];
    },
    getOption: function getOption(optionId) {
      return this.menu.optionList[optionId];
    },
    getCombine: function getCombine(combineId) {
      return this.menu.combineList[combineId];
    },
    showOption: function showOption(aIndex, isMandatory) {
      var self = this;
      if (typeof isMandatory === 'undefined' || isMandatory) {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.options-' + aIndex).slideToggle(function () {
          var visible = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this).is(':visible');
          if (visible) self.isVisible.push(aIndex);else self.removeArray(self.isVisible, aIndex);
        });
      }
    },
    parsePrice: function parsePrice(product) {
      var pSchema = this.schema.product;
      var aSchema = this.schema.adjust;
      var oSchema = this.schema.option;
      var productId = product[pSchema.product_id];
      var price;
      var type;
      var checkP = this.getProduct(productId);
      var checkA = this.getAdjust(productId);
      var checkO = this.getOption(productId);
      var isOption = [];
      var minPrice = [];
      if (checkP) {
        price = checkP[pSchema.price];
        type = 'p';
        var aList = checkP[pSchema.adjust_list];
        aList = __WEBPACK_IMPORTED_MODULE_1__assets_js_parse_menu_js__["a" /* default */].divideList(aList, this.getAdjust);
        for (var j = 0; j < aList.length; j++) {
          var aListPrice = [];
          var tag = 0;
          for (var k = 0; k < aList[j][aSchema.option_list].length; k++) {
            tag++;
            aListPrice.push(aList[j][aSchema.option_list][k][oSchema.price]);
            if (tag === aList[j][aSchema.option_list].length) minPrice.push(Math.min.apply(Math, aListPrice));
          }
        }
        for (var m = 0; m < aList.length; m++) {
          var max = aList[m][aSchema.max_limit];
          var tags = 1;
          for (var n = 0; n < aList[m][aSchema.option_list].length; n++) {
            if (aList[m][aSchema.option_list][n][oSchema.price] === minPrice[m] && tags <= max) {
              tags++;
              if (aList[m][aSchema.is_mandatory]) isOption.push({ adjust: aList[m], option: aList[m][aSchema.option_list][n] });
            }
          }
        }
      } else if (checkA) {
        price = checkA[aSchema.price];
        type = 'a';
        if (price === null) {
          for (var i = 0; i < checkA[aSchema.option_list].length; i++) {
            if (checkA[aSchema.option_list][i][oSchema.is_mandatory]) {
              price = price + checkA[aSchema.option_list][i][oSchema.price];
            }
          }
        }
      } else if (checkO) {
        price = checkO[oSchema.price];
        type = 'o';
      }
      if (isOption.length) this.isOption = isOption;
      return { price: price, type: type };
    },
    showAll: function showAll(product, combines) {
      var pSchema = this.schema.product;
      var aSchema = this.schema.adjust;
      var oSchema = this.schema.option;

      var adjustIds = product[pSchema.adjust_list];
      var result = [];

      for (var adjustIndex = 0; adjustIndex < adjustIds.length; adjustIndex++) {
        var adjust = __WEBPACK_IMPORTED_MODULE_1__assets_js_parse_menu_js__["a" /* default */].divideList(adjustIds, this.getAdjust)[adjustIndex];
        if (adjust) {
          adjust.activeCount = 0;
          adjust.activeOptionIds = [];
          for (var optionIndex = 0; optionIndex < adjust[aSchema.option_list].length; optionIndex++) {
            if (typeof adjust[aSchema.option_list][optionIndex] === 'number') {
              adjust[aSchema.option_list][optionIndex] = this.getOption(adjust[aSchema.option_list][optionIndex]);
              adjust[aSchema.option_list][optionIndex].activeCount = 0;
            }
          }
          adjust[aSchema.option_list].sort(function (a, b) {
            if (a[oSchema.sort] > b[oSchema.sort]) {
              return 1;
            }
            if (a[oSchema.sort] < b[oSchema.sort]) {
              return -1;
            }

            return 0;
          });
          result.push(adjust);
        }
      }

      result.push([]);
      result.sort(function (a, b) {
        return b[aSchema.sub_type] - a[aSchema.sub_type];
      });
      result.splice(-1, 1);
      var result2 = result;

      var sizeIndex = result.findIndex(function (adjust) {
        return adjust[aSchema.sub_type] === 10;
      });
      var size = result.find(function (adjust) {
        return adjust[aSchema.sub_type] === 10;
      });
      if (sizeIndex > -1) {
        result2.splice(sizeIndex, 1);
        result2.splice(0, 0, size);
      }
      return result2;
    },
    filterCombine: function filterCombine(combines) {
      var oSchema = this.schema.option;
      var cSchema = this.schema.combine;
      var eSchema = this.schema.edge;
      var aSchema = this.schema.adjust;
      this.isShow = [];

      __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.btn-option').css('display', 'none');
      var combine = __WEBPACK_IMPORTED_MODULE_1__assets_js_parse_menu_js__["a" /* default */].divideList(combines, this.getCombine);
      for (var cIndex = 0; cIndex < combine.length; cIndex++) {
        for (var oIndex in combine[cIndex][cSchema.edge_list]) {
          this.isShow.push(combine[cIndex][cSchema.edge_list][oIndex][eSchema.product_id]);
        }
      }
      this.isShow = this.isShow.filter(function (elem, index, self) {
        return self.indexOf(elem) === index;
      });
      for (var id = 0; id < this.isShow.length; id++) {
        var num = this.isShow[id];
        if (this.getOption(num)) {
          __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#option-' + this.getOption(num)[oSchema.product_id]).css('display', 'inline-block');
        } else if (this.getAdjust(num)) {
          var options = this.getAdjust(num)[aSchema.option_list];
          for (var o = 0; o < options.length; o++) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#option-' + options[o][oSchema.product_id]).css('display', 'inline-block');
          }
        }
      }
    },
    createMapping: function createMapping(arrayData, idIndex) {
      var mapping = {};
      for (var i = 0; i < arrayData.length; i++) {
        mapping[arrayData[i][idIndex]] = i;
      }

      return mapping;
    },
    createOptionMapping: function createOptionMapping(adjusts) {
      var aSchema = this.schema.adjust;
      var oSchema = this.schema.option;

      var mapping = {};
      for (var i = 0; i < adjusts.length; i++) {
        for (var j = 0; j < adjusts[i][aSchema.option_list].length; j++) {
          mapping[adjusts[i][aSchema.option_list][j][oSchema.product_id]] = {
            adjustIndex: i,
            optionIndex: j
          };
        }
      }

      return mapping;
    },
    search: function search(id, adjusts, productId) {
      var result = [];
      var aSchema = this.schema.adjust;

      var adjust = this.getAdjust(id);
      var option = this.getOption(id);
      if (option) {
        result.push(option);
        return result;
      } else {
        if (adjust) {
          option = __WEBPACK_IMPORTED_MODULE_1__assets_js_parse_menu_js__["a" /* default */].divideList(adjust[aSchema.option_list], this.getOption);
          for (var i = 0; i < option.length; i++) {
            result.push(option[i]);
          }

          return result;
        }
      }
    },
    clickOption: function clickOption(clickedOption, clickedOptionIndex, clickedAdjust, clickedAdjustIndex) {
      var pSchema = this.schema.product;
      var aSchema = this.schema.adjust;
      var oSchema = this.schema.option;

      __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#option-' + clickedOption[oSchema.product_id]).unbind('mouseenter mouseleave');

      var clickedAdjustId = clickedAdjust[aSchema.product_id];
      var clickedOptionId = clickedOption[oSchema.product_id];
      var productAdjustIds = this.currentProduct[pSchema.adjust_list];

      var adjustIndex = 0;
      var adjust = null;

      var option = null;
      var blockedOptionIds = [];
      var bOptionId;

      for (adjustIndex = 0; adjustIndex < productAdjustIds.length; adjustIndex++) {
        adjust = this.getAdjust(productAdjustIds[adjustIndex]);
        if (adjust[aSchema.is_mandatory] === true) {
          __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.adjust-' + productAdjustIds[adjustIndex]).addClass('mandatory');
        }
      }

      if (__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#option-' + clickedOptionId).attr('active')) {
        this.removeArray(clickedAdjust.activeOptionIds, clickedOptionId);
        clickedAdjust.activeCount -= clickedOption.activeCount;
        clickedOption.activeCount = 0;
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#option-' + clickedOptionId).removeAttr('active', false);
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#option-' + clickedOptionId).removeClass('active');
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.adjusts), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            adjust = _step3.value;

            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.adjust-' + adjust[aSchema.product_id] + ' div').removeClass('btn-blocked');
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        var passCombinations = this.ruleValidation();
        blockedOptionIds = this.getBlockedOptionIds(passCombinations);
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(blockedOptionIds), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            bOptionId = _step4.value;

            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#option-' + bOptionId).addClass('btn-blocked');
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        this.price = this.calculatePriceBySelectedOptions(passCombinations);

        return;
      }

      clickedAdjust.activeOptionIds.push(clickedOptionId);
      clickedAdjust.activeCount++;
      clickedOption.activeCount++;
      __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#option-' + clickedOptionId).attr('active', true);

      passCombinations = this.ruleValidation();
      if (passCombinations.length === 0) {
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.adjusts), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            adjust = _step5.value;

            adjust.activeOptionIds = [];
            adjust.activeCount = 0;
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
              for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(adjust[aSchema.option_list]), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                option = _step6.value;

                option.activeCount = 0;
              }
            } catch (err) {
              _didIteratorError6 = true;
              _iteratorError6 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                  _iterator6.return();
                }
              } finally {
                if (_didIteratorError6) {
                  throw _iteratorError6;
                }
              }
            }

            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.adjust-' + adjust[aSchema.product_id] + ' div').removeAttr('active');
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.adjust-' + adjust[aSchema.product_id] + ' div').removeClass('active');
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.adjust-' + adjust[aSchema.product_id] + ' div').removeClass('btn-blocked');
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }

        clickedAdjust.activeOptionIds.push(clickedOptionId);
        clickedAdjust.activeCount = 1;
        clickedOption.activeCount = 1;
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#option-' + clickedOptionId).attr('active', true);
      }

      if (clickedAdjust.activeCount > clickedAdjust[aSchema.max_limit] && clickedAdjust[aSchema.max_limit]) {
        clickedAdjust.activeOptionIds = [];
        clickedAdjust.activeCount = 0;
        var _iteratorNormalCompletion7 = true;
        var _didIteratorError7 = false;
        var _iteratorError7 = undefined;

        try {
          for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(clickedAdjust[aSchema.option_list]), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
            option = _step7.value;

            option.activeCount = 0;
          }
        } catch (err) {
          _didIteratorError7 = true;
          _iteratorError7 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion7 && _iterator7.return) {
              _iterator7.return();
            }
          } finally {
            if (_didIteratorError7) {
              throw _iteratorError7;
            }
          }
        }

        __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.adjust-' + clickedAdjustId + ' div').removeAttr('active');
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.adjust-' + clickedAdjustId + ' div').removeClass('active');
        var _iteratorNormalCompletion8 = true;
        var _didIteratorError8 = false;
        var _iteratorError8 = undefined;

        try {
          for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.adjusts), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
            adjust = _step8.value;

            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.adjust-' + adjust[aSchema.product_id] + ' div').removeClass('btn-blocked');
          }
        } catch (err) {
          _didIteratorError8 = true;
          _iteratorError8 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion8 && _iterator8.return) {
              _iterator8.return();
            }
          } finally {
            if (_didIteratorError8) {
              throw _iteratorError8;
            }
          }
        }

        clickedAdjust.activeOptionIds.push(clickedOptionId);
        clickedAdjust.activeCount = 1;
        clickedOption.activeCount = 1;
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#option-' + clickedOptionId).attr('active', true);
      }

      passCombinations = this.ruleValidation();
      blockedOptionIds = this.getBlockedOptionIds(passCombinations);
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(blockedOptionIds), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          bOptionId = _step9.value;

          __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#option-' + bOptionId).addClass('btn-blocked');
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      this.price = this.calculatePriceBySelectedOptions(passCombinations);
    },
    ruleValidation: function ruleValidation() {
      var aSchema = this.schema.adjust;
      var oSchema = this.schema.option;
      var cSchema = this.schema.combine;
      var eSchema = this.schema.edge;

      var constrainCombList = [];
      var adjust = null;
      var option = null;
      var combineId = null;
      var combine = null;
      var edge = null;
      var isExist = false;
      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.productCombineIds), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          combineId = _step10.value;

          combine = this.menu.combineList[combineId];

          var allInGraph = true;
          var _iteratorNormalCompletion11 = true;
          var _didIteratorError11 = false;
          var _iteratorError11 = undefined;

          try {
            for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.adjusts), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
              adjust = _step11.value;
              var _iteratorNormalCompletion12 = true;
              var _didIteratorError12 = false;
              var _iteratorError12 = undefined;

              try {
                for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(adjust[aSchema.option_list]), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                  option = _step12.value;

                  if (option.activeCount > 0) {
                    isExist = false;
                    for (var edgeId in combine[cSchema.edge_list]) {
                      edge = combine[cSchema.edge_list][edgeId];
                      switch (edge[eSchema.product_type]) {
                        case 2:
                          if (edge[eSchema.product_id] === option[oSchema.product_id]) {
                            isExist = true;
                          }
                          break;

                        case 20:
                          if (edge[eSchema.product_id] === adjust[aSchema.product_id]) {
                            isExist = true;
                          }
                          break;
                      }
                      if (isExist) {
                        break;
                      }
                    }
                    if (!isExist) {
                      allInGraph = false;
                      break;
                    }
                  }
                }
              } catch (err) {
                _didIteratorError12 = true;
                _iteratorError12 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion12 && _iterator12.return) {
                    _iterator12.return();
                  }
                } finally {
                  if (_didIteratorError12) {
                    throw _iteratorError12;
                  }
                }
              }

              if (!allInGraph) {
                break;
              }
            }
          } catch (err) {
            _didIteratorError11 = true;
            _iteratorError11 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion11 && _iterator11.return) {
                _iterator11.return();
              }
            } finally {
              if (_didIteratorError11) {
                throw _iteratorError11;
              }
            }
          }

          if (allInGraph) {
            constrainCombList.push(combine);
          }
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }

      return constrainCombList;
    },
    getBlockedOptionIds: function getBlockedOptionIds(constrainCombList) {
      var aSchema = this.schema.adjust;
      var oSchema = this.schema.option;
      var cSchema = this.schema.combine;
      var eSchema = this.schema.edge;

      var blockedOptionIds = [];
      var adjust = null;
      var option = null;
      var combine = null;
      var edge = null;
      var edgeId = null;
      var isExist = false;

      var _iteratorNormalCompletion13 = true;
      var _didIteratorError13 = false;
      var _iteratorError13 = undefined;

      try {
        for (var _iterator13 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.adjusts), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
          adjust = _step13.value;
          var _iteratorNormalCompletion14 = true;
          var _didIteratorError14 = false;
          var _iteratorError14 = undefined;

          try {
            for (var _iterator14 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(adjust[aSchema.option_list]), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
              option = _step14.value;

              isExist = false;
              var _iteratorNormalCompletion15 = true;
              var _didIteratorError15 = false;
              var _iteratorError15 = undefined;

              try {
                for (var _iterator15 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(constrainCombList), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                  combine = _step15.value;

                  for (edgeId in combine[cSchema.edge_list]) {
                    edge = combine[cSchema.edge_list][edgeId];
                    switch (edge[eSchema.product_type]) {
                      case 2:
                        if (edge[eSchema.product_id] === option[oSchema.product_id]) {
                          isExist = true;
                        }
                        break;

                      case 20:
                        if (edge[eSchema.product_id] === adjust[aSchema.product_id]) {
                          isExist = true;
                        }
                        break;
                    }
                    if (isExist) {
                      break;
                    }
                  }
                  if (isExist) {
                    break;
                  }
                }
              } catch (err) {
                _didIteratorError15 = true;
                _iteratorError15 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion15 && _iterator15.return) {
                    _iterator15.return();
                  }
                } finally {
                  if (_didIteratorError15) {
                    throw _iteratorError15;
                  }
                }
              }

              if (!isExist) {
                blockedOptionIds.push(option[oSchema.product_id]);
              }
            }
          } catch (err) {
            _didIteratorError14 = true;
            _iteratorError14 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion14 && _iterator14.return) {
                _iterator14.return();
              }
            } finally {
              if (_didIteratorError14) {
                throw _iteratorError14;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError13 = true;
        _iteratorError13 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion13 && _iterator13.return) {
            _iterator13.return();
          }
        } finally {
          if (_didIteratorError13) {
            throw _iteratorError13;
          }
        }
      }

      return blockedOptionIds;
    },
    calculatePriceBySelectedOptions: function calculatePriceBySelectedOptions(constrainCombList) {
      var pSchema = this.schema.product;
      var aSchema = this.schema.adjust;
      var oSchema = this.schema.option;
      var cSchema = this.schema.combine;
      var eSchema = this.schema.edge;

      var minPrice = 0;
      var maxCombineId = 0;
      var maxPrice = 0;
      var adjustIndex = null;
      var adjust = null;
      var optionMapping = null;
      var option = null;

      var _iteratorNormalCompletion16 = true;
      var _didIteratorError16 = false;
      var _iteratorError16 = undefined;

      try {
        for (var _iterator16 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(constrainCombList), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
          var combine = _step16.value;

          var price = 0;
          if (combine[cSchema.price] !== null) {
            price = combine[cSchema.price];
            if (price < minPrice) {
              minPrice = price;
            }
            if (price > maxPrice) {
              maxPrice = price;
              maxCombineId = combine[cSchema.combine_id];
            }
            continue;
          }
          for (var edgeId in combine[cSchema.edge_list]) {
            var edge = combine[cSchema.edge_list][edgeId];
            switch (edge[eSchema.product_type]) {
              case 1:
                price += this.getProduct(edge[eSchema.product_id])[pSchema.price];
                break;

              case 2:
                optionMapping = this.optionsIndexMapping[edge[eSchema.product_id]];
                option = this.adjusts[optionMapping.adjustIndex][aSchema.option_list][optionMapping.optionIndex];
                if (option.activeCount > 0) {
                  if (edge[eSchema.price] === null) {
                    price += Number(option[oSchema.price]) * option.activeCount;
                  } else {
                    price += edge[eSchema.price] * option.activeCount;
                  }
                }
                break;

              case 20:
                adjustIndex = this.adjustsIndexMapping[edge[eSchema.product_id]];
                adjust = this.adjusts[adjustIndex];
                var isActiveAdjust = false;
                var adjustPrice = 0;
                var _iteratorNormalCompletion17 = true;
                var _didIteratorError17 = false;
                var _iteratorError17 = undefined;

                try {
                  for (var _iterator17 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(adjust[aSchema.option_list]), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
                    option = _step17.value;

                    if (option.activeCount > 0) {
                      isActiveAdjust = true;
                      adjustPrice += option[oSchema.price] * option.activeCount;
                    }
                  }
                } catch (err) {
                  _didIteratorError17 = true;
                  _iteratorError17 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion17 && _iterator17.return) {
                      _iterator17.return();
                    }
                  } finally {
                    if (_didIteratorError17) {
                      throw _iteratorError17;
                    }
                  }
                }

                if (isActiveAdjust) {
                  if (edge[eSchema.price] !== null) {
                    price += edge[eSchema.price];
                  } else if (adjust[aSchema.price] !== null) {
                    price += adjust[aSchema.price];
                  } else {
                    price += adjustPrice;
                  }
                }
                break;
            }
          }
          if (price < minPrice) {
            minPrice = price;
          }
          if (price > maxPrice) {
            maxPrice = price;
            maxCombineId = combine[cSchema.combine_id];
          }
        }
      } catch (err) {
        _didIteratorError16 = true;
        _iteratorError16 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion16 && _iterator16.return) {
            _iterator16.return();
          }
        } finally {
          if (_didIteratorError16) {
            throw _iteratorError16;
          }
        }
      }

      this.combineId = maxCombineId;
      return maxPrice;
    },
    getSessionName: function getSessionName(type, storeId) {
      if (type === 'version') {
        return 'Nidin_' + storeId + '_menuVersion';
      } else if (type === 'menu') {
        return 'Nidin_' + storeId + '_menu';
      } else {
        return false;
      }
    },
    removeArray: function removeArray(arr, value) {
      var index = arr.indexOf(value);
      if (index > -1) {
        arr.splice(index, 1);
      }
    },
    checkPrice: function checkPrice(price, product) {
      var pSchema = this.schema.product;
      this.addPrice[product[pSchema.product_id]] = price;
      var newPrice = this.currentProduct[pSchema.price];
      for (var key in this.addPrice) {
        newPrice = this.addPrice[key];
      }
      this.price = newPrice;
    },
    checkAddProduct: function checkAddProduct(item) {
      this.addDetail[item.items[0].product_id] = item;
    },
    checkAddDifProduct: function checkAddDifProduct(item, pIndex) {},
    init: function init() {
      if (this.menuJson !== undefined) {
        this.currentMenuJson = this.menuJson;
        this.menu.categoryList = this.currentMenuJson.category_list_json.data;
        this.menu.productList = this.currentMenuJson.product_list_json.data;
        this.menu.adjustList = this.currentMenuJson.adjust_list_json.data;
        this.menu.optionList = this.currentMenuJson.option_list_json.data;
        this.menu.combineList = this.currentMenuJson.combine_list_json.data;

        this.schema.category = this.currentMenuJson.category_list_json.schema;
        this.schema.product = this.currentMenuJson.product_list_json.schema;
        this.schema.icon = this.currentMenuJson.product_list_json.icon_schema;
        this.schema.img = this.currentMenuJson.product_list_json.img_schema;
        this.schema.tag = this.currentMenuJson.product_list_json.tag_schema;
        this.schema.adjust = this.currentMenuJson.adjust_list_json.schema;
        this.schema.option = this.currentMenuJson.option_list_json.schema;
        this.schema.combine = this.currentMenuJson.combine_list_json.schema;
        this.schema.edge = this.currentMenuJson.combine_list_json.edge_schema;
        this.schema.common = this.currentMenuJson.combine_list_json.common_schema;
        this.productCombineIds = this.currentProduct[this.schema.product.combine_list];
        if (this.currentMenuJson.block_list_json) this.schema.block = this.currentMenuJson.block_list_json.schema;
      }
      this.initOptions();
    },
    clearOption: function clearOption() {
      var aSchema = this.schema.adjust;
      var pSchema = this.schema.product;

      this.limitList = {};
      var _iteratorNormalCompletion18 = true;
      var _didIteratorError18 = false;
      var _iteratorError18 = undefined;

      try {
        for (var _iterator18 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.adjusts), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
          var adjust = _step18.value;

          adjust.activeOptionIds = [];
          adjust.activeCount = 0;
          var _iteratorNormalCompletion19 = true;
          var _didIteratorError19 = false;
          var _iteratorError19 = undefined;

          try {
            for (var _iterator19 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(adjust[aSchema.option_list]), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
              var option = _step19.value;

              option.activeCount = 0;
            }
          } catch (err) {
            _didIteratorError19 = true;
            _iteratorError19 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion19 && _iterator19.return) {
                _iterator19.return();
              }
            } finally {
              if (_didIteratorError19) {
                throw _iteratorError19;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError18 = true;
        _iteratorError18 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion18 && _iterator18.return) {
            _iterator18.return();
          }
        } finally {
          if (_didIteratorError18) {
            throw _iteratorError18;
          }
        }
      }

      this.number = 1;

      this.price = this.currentProduct[pSchema.price];
    },
    initOptions: function initOptions() {
      var pSchema = this.schema.product;
      var cSchema = this.schema.combine;

      this.price = this.currentProduct[pSchema.price];
      this.combineId = this.currentProduct[pSchema.combine_list][cSchema.combine_id];
      this.productCombineIds = this.currentProduct[this.schema.product.combine_list];
      this.adjusts = this.showAll(this.currentProduct, this.productCombineIds);
      this.adjustsIndexMapping = this.createMapping(this.adjusts, this.schema.adjust.product_id);
      this.optionsIndexMapping = this.createOptionMapping(this.adjusts);
      this.clearOption();

      this.addPrice = {};
      this.addDetail = {};
      this.addAdjust = {};

      this.optionCheck = 0;
      this.$nextTick(function () {});
    },
    checkAdjustDis: function checkAdjustDis(aId) {
      var dis = this.disAdjust.find(function (o) {
        return o === aId;
      });
      if (dis) {
        return false;
      } else return true;
    },
    checkOptionDis: function checkOptionDis(oId, aId) {
      if (this.disOption[aId]) {
        var dis = this.disOption[aId].find(function (o) {
          return o.product_id === oId;
        });
        if (dis) {
          return false;
        } else return true;
      } else {
        return true;
      }
    },
    getSubImages: function getSubImages(pId) {
      if (this.prodImgList[pId]) return this.prodImgList[pId].sub_image_list;
      return [];
    }
  },
  ready: function ready() {},

  computed: {
    cheeseWording: function cheeseWording() {
      var name = this.currentProduct[this.schema.product.name];
      if (name) name = name.trim();
      switch (name) {
        case '日式燒肉堡':
        case '雙層起司雞腿堡':
        case '法式紅酒牛肉堡':
        case '墨西哥辣椒豬肉堡':
        case '墨西哥辣椒牛肉堡':
        case '豬肉起司瑪芬堡':
        case '豬肉瑪芬堡加蛋':
        case '雙層豬肉瑪芬堡':
        case '雙層豬肉瑪芬堡加蛋':
        case '義式磚壓-薑汁燒肉':
        case '口袋歐姆蛋-起士歐姆蛋':
        case '口袋歐姆蛋-肉醬歐姆蛋':
        case '口袋歐姆蛋-培根歐姆蛋':
        case '口袋歐姆蛋-蔬菜歐姆蛋':
        case '口袋歐姆蛋-鮪魚歐姆蛋':
        case '磚壓-法式紅酒牛肉':
        case '磚壓-墨西哥辣椒豬肉':
        case '磚壓-墨西哥辣椒牛肉':
          return true;
        default:
          return false;
      }
    },
    showLgImg: function showLgImg() {
      var layout = this.layout;
      switch (layout) {
        case 1:
          return false;
        case 2:
          return true;
        case 3:
          return true;
        case 4:
          return false;
        default:
          return false;
      }
    },
    storeStateName: function storeStateName() {
      var state = this.storeState;
      if (state === 0) return '門市未營業';else if (state === 1) return '門市籌備中';else if (state === 3) return '門市休息中';else if (state === 9) return '門市已歇業';
    },
    minCombinePrice: function minCombinePrice() {
      var oSchema = this.schema.option;
      var price = 0;

      for (var i in this.isOption.length) {
        price = price + this.isOption[i].option[oSchema.price];
      }
      return price;
    },
    combinePrice: function combinePrice() {
      var minPrice;
      var self = this;
      var priceCombine = [];
      var priceList = [];
      if (this.productCombineIds.length) {
        for (var i = 0; i < this.productCombineIds.length; i++) {
          var item;
          var price = this.getCombine(this.productCombineIds[i])[this.schema.combine.price];
          if (price === null) {
            var edgeList = this.getCombine(this.productCombineIds[i])[this.schema.combine.edge_list];
            for (var key in edgeList) {
              this.parsePrice(edgeList[key]);
              if (this.parsePrice(edgeList[key]).type === 'p') price = this.parsePrice(edgeList[key]).price;
            }

            item = { price: price + self.minCombinePrice, combine: this.getCombine(this.productCombineIds[i]) };
            priceCombine.push(item);
          } else {
            item = { price: price, combine: this.getCombine(this.productCombineIds[i]) };
            priceCombine.push(item);
          }
        }
      }

      for (var o in priceCombine) {
        priceList.push(priceCombine[o].price);
      }
      minPrice = Math.min.apply(Math, priceList);
      return minPrice;
    },
    isBigMilk: function isBigMilk() {
      var pSchema = this.schema.product;
      var product = this.currentProduct;
      var productName = product[pSchema.name];
      if (productName) {
        if (productName.trim() === '綠光純鮮奶家庭號') return true;
      }
      return false;
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.q-numeric input').attr('maxlength', '2');
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.q-numeric input').attr('type', 'tel');
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.q-numeric input').keyup(function () {
      var e = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.q-numeric input');
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    });
  },

  watch: {
    currentProduct: {
      handler: function handler() {
        this.init();
      },

      deep: true
    },
    cartMount: function cartMount() {
      this.setCartAmount(this.cartMount);
    },
    number: function number() {
      if (!this.number) this.number = 1;
    }
  }
});

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_parse_menu_js__ = __webpack_require__(63);
var require;






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    currentProduct: [Object, Array],
    checkPrice: Function,
    checkAddProduct: Function,
    checkAddDifProduct: Function,
    optionCheck: Object,
    productAmount: Number,
    pAIndex: Number,
    menuJson: [Object, String],
    isInit: Boolean,
    paAdjusts: Array,
    layout: String,
    prodType: String,
    clickProduct: Function
  },
  data: function data() {
    return {
      isVisible: [],
      tags: 0,
      isOption: [],
      isShow: [],
      cartMount: 0,
      orderInfo: {
        orderId: 0,
        storeId: parseInt(this.$route.params.storeId, 10),
        version: 0,

        orderType: 1,
        isEmpty: 0
      },
      totalPrice: function totalPrice() {
        return parseInt(this.number, 10) * parseInt(this.price, 10);
      },

      combineId: '',
      adjusts: [],
      adjustsIndexMapping: {},
      optionsIndexMapping: {},
      counter: 0,
      limitList: [],
      productCombineIds: [],
      number: 1,
      price: 0,
      currentMenuJson: '',
      storeId: this.$route.params.storeId,
      schema: {
        category: {},
        product: {},
        icon: {},
        image: {},
        tag: {},
        adjust: {},
        option: {},
        combine: {},
        edge: {},
        common: {},
        block: {}
      },
      menu: {
        categoryList: {},
        productList: {},
        adjustList: {},
        optionList: {},
        combineList: {}
      },

      optionNum: {},
      optionNumList: [{}],
      optionCurr: [],

      passCombinations: []
    };
  },

  methods: {
    adjustsOfProduct: function adjustsOfProduct(productId) {
      return this.getProduct(productId)[this.schema.product.adjust_list];
    },
    optionsOfAdjust: function optionsOfAdjust(adjustId) {
      return this.getAdjust(adjustId)[this.schema.adjust.option_list];
    },
    combinesOfProduct: function combinesOfProduct(productId) {
      return this.getProduct(productId)[this.schema.product.combine_list];
    },
    getProduct: function getProduct(productId) {
      return this.menu.productList[productId];
    },
    getAdjust: function getAdjust(adjustId) {
      return this.menu.adjustList[adjustId];
    },
    getOption: function getOption(optionId) {
      return this.menu.optionList[optionId];
    },
    getCombine: function getCombine(combineId) {
      return this.menu.combineList[combineId];
    },
    isActive: function isActive(optionId) {
      return this.optionCurr.includes(optionId);
    },
    isHOption: function isHOption(adjust) {
      var aSchema = this.schema.adjust;
      if (adjust[aSchema.sub_type] === 0) {
        if (adjust[aSchema.name].indexOf('溫') > -1) return false;else if (adjust[aSchema.name].indexOf('甜') > -1) return false;else if (adjust[aSchema.name].indexOf('糖') > -1) return false;else if (adjust[aSchema.name].indexOf('冰') > -1) return false;
        return true;
      } else if (adjust[aSchema.sub_type] === 10) return true;else if (adjust[aSchema.sub_type] === 20) return true;
      return false;
    },
    optionPrice: function optionPrice(option, adjust) {
      var _this = this;

      try {
        if (!option || !this.schema) {
          return 0;
        }

        var _schema = this.schema,
            aSchema = _schema.adjust,
            cSchema = _schema.combine,
            oSchema = _schema.option,
            eSchema = _schema.edge;

        var oPrice = option[oSchema.price];

        var formatPrice = function formatPrice(price) {
          if (price === undefined || price === null) return 0;
          if (price > 0) return '+' + price + '\u5143';
          if (price < 0) return price + '\u5143';
          return '+0元';
        };

        if (this.isHOption(adjust) && this.passCombinations && this.passCombinations[0]) {
          var combination = this.passCombinations.find(function (obj) {
            return _this.combineId === obj[cSchema.combine_id];
          });

          if (combination && !combination.edge_list) {
            return formatPrice(oPrice);
          }

          var productPrice = void 0;
          var adjustPrice = void 0;

          if (combination && combination.edge_list && option && option[oSchema.product_id]) {
            var edgeList = combination.edge_list[option[oSchema.product_id]];
            if (edgeList) {
              productPrice = edgeList[eSchema.price];
            }
          }

          if (combination && combination.edge_list && adjust && adjust[aSchema.product_id]) {
            var _edgeList = combination.edge_list[adjust[aSchema.product_id]];
            if (_edgeList) {
              adjustPrice = _edgeList[eSchema.price];
            }
          }

          if (productPrice !== undefined) {
            return formatPrice(productPrice);
          }

          if (adjustPrice !== undefined) {
            return formatPrice(adjustPrice);
          }
        }

        return formatPrice(oPrice);
      } catch (error) {
        console.error('價格計算錯誤:', error);
        return 0;
      }
    },
    showOption: function showOption(aIndex, isMandatory) {
      var self = this;
      if (typeof isMandatory === 'undefined' || isMandatory) {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.index' + this.pAIndex + ' .options-' + this.currentProduct[this.schema.product.product_id] + '-' + aIndex).slideToggle(function () {
          var visible = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).is(':visible');
          if (visible) self.isVisible.push(aIndex);else self.removeArray(self.isVisible, aIndex);
        });
      }
    },
    parsePrice: function parsePrice(product) {
      var pSchema = this.schema.product;
      var aSchema = this.schema.adjust;
      var oSchema = this.schema.option;
      var productId = product[pSchema.product_id];
      var price;
      var type;
      var checkP = this.getProduct(productId);
      var checkA = this.getAdjust(productId);
      var checkO = this.getOption(productId);
      var isOption = [];
      var minPrice = [];
      if (checkP) {
        price = checkP[pSchema.price];
        type = 'p';
        var aList = checkP[pSchema.adjust_list];
        aList = __WEBPACK_IMPORTED_MODULE_3__assets_js_parse_menu_js__["a" /* default */].divideList(aList, this.getAdjust);
        for (var j = 0; j < aList.length; j++) {
          var aListPrice = [];
          var tag = 0;
          for (var k = 0; k < aList[j][aSchema.option_list].length; k++) {
            tag++;
            aListPrice.push(aList[j][aSchema.option_list][k][oSchema.price]);
            if (tag === aList[j][aSchema.option_list].length) minPrice.push(Math.min.apply(Math, aListPrice));
          }
        }
        for (var m = 0; m < aList.length; m++) {
          var max = aList[m][aSchema.max_limit];
          var tags = 1;
          for (var n = 0; n < aList[m][aSchema.option_list].length; n++) {
            if (aList[m][aSchema.option_list][n][oSchema.price] === minPrice[m] && tags <= max) {
              tags++;
              if (aList[m][aSchema.is_mandatory]) isOption.push({ adjust: aList[m], option: aList[m][aSchema.option_list][n] });
            }
          }
        }
      } else if (checkA) {
        price = checkA[aSchema.price];
        type = 'a';
        if (price === null) {
          for (var i = 0; i < checkA[aSchema.option_list].length; i++) {
            if (checkA[aSchema.option_list][i][oSchema.is_mandatory]) {
              price = price + checkA[aSchema.option_list][i][oSchema.price];
            }
          }
        }
      } else if (checkO) {
        price = checkO[oSchema.price];
        type = 'o';
      }
      if (isOption.length) this.isOption = isOption;
      return { price: price, type: type };
    },
    showAll: function showAll(product, combines) {
      var pSchema = this.schema.product;
      var aSchema = this.schema.adjust;
      var oSchema = this.schema.option;

      var adjustIds = product[pSchema.adjust_list];
      var result = [];

      for (var adjustIndex = 0; adjustIndex < adjustIds.length; adjustIndex++) {
        var adjust = __WEBPACK_IMPORTED_MODULE_3__assets_js_parse_menu_js__["a" /* default */].divideList(adjustIds, this.getAdjust)[adjustIndex];
        if (adjust) {
          adjust.activeCount = 0;
          adjust.activeOptionIds = [];
          for (var optionIndex = 0; optionIndex < adjust[aSchema.option_list].length; optionIndex++) {
            if (typeof adjust[aSchema.option_list][optionIndex] === 'number') {
              adjust[aSchema.option_list][optionIndex] = this.getOption(adjust[aSchema.option_list][optionIndex]);
              adjust[aSchema.option_list][optionIndex].activeCount = 0;
            }
          }
          adjust[aSchema.option_list].sort(function (a, b) {
            if (a[oSchema.sort] > b[oSchema.sort]) {
              return 1;
            }
            if (a[oSchema.sort] < b[oSchema.sort]) {
              return -1;
            }

            return 0;
          });
          result.push(adjust);
        }
      }

      var size = result.filter(function (adjust) {
        return adjust[aSchema.sub_type] === 10;
      }).sort(function (a, b) {
        return a[aSchema.sort] - b[aSchema.sort];
      });

      var system = result.filter(function (adjust) {
        return adjust[aSchema.sub_type] && adjust[aSchema.sub_type] !== 10;
      }).sort(function (a, b) {
        return b[aSchema.sub_type] - a[aSchema.sub_type];
      }).sort(function (a, b) {
        return a[aSchema.sort] - b[aSchema.sort];
      });

      var others = result.filter(function (adjust) {
        return !adjust[aSchema.sub_type];
      }).sort(function (a, b) {
        return a[aSchema.sort] - b[aSchema.sort];
      });

      return size.concat(system, others);
    },
    filterCombine: function filterCombine(combines) {
      var oSchema = this.schema.option;
      var cSchema = this.schema.combine;
      var eSchema = this.schema.edge;
      var aSchema = this.schema.adjust;
      var pSchema = this.schema.product;
      var pId = this.currentProduct[pSchema.product_id];
      this.isShow = [];

      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.option-' + pId + '-index' + this.pAIndex).css('display', 'none');
      var combine = __WEBPACK_IMPORTED_MODULE_3__assets_js_parse_menu_js__["a" /* default */].divideList(combines, this.getCombine);
      for (var cIndex = 0; cIndex < combine.length; cIndex++) {
        for (var oIndex in combine[cIndex][cSchema.edge_list]) {
          this.isShow.push(combine[cIndex][cSchema.edge_list][oIndex][eSchema.product_id]);
        }
      }
      this.isShow = this.isShow.filter(function (elem, index, self) {
        return self.indexOf(elem) === index;
      });
      for (var id = 0; id < this.isShow.length; id++) {
        var num = this.isShow[id];
        if (this.getOption(num)) {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.index' + this.pAIndex + ' #option-' + pId + '-' + this.getOption(num)[oSchema.product_id]).css('display', 'inline-block');
        } else if (this.getAdjust(num)) {
          var options = this.getAdjust(num)[aSchema.option_list];
          for (var o = 0; o < options.length; o++) {
            __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.index' + this.pAIndex + ' #option-' + pId + '-' + options[o][oSchema.product_id]).css('display', 'inline-block');
          }
        }
      }
    },
    createMapping: function createMapping(arrayData, idIndex) {
      var mapping = {};
      for (var i = 0; i < arrayData.length; i++) {
        mapping[arrayData[i][idIndex]] = i;
      }

      return mapping;
    },
    createOptionMapping: function createOptionMapping(adjusts) {
      var aSchema = this.schema.adjust;
      var oSchema = this.schema.option;

      var mapping = {};
      for (var i = 0; i < adjusts.length; i++) {
        for (var j = 0; j < adjusts[i][aSchema.option_list].length; j++) {
          mapping[adjusts[i][aSchema.option_list][j][oSchema.product_id]] = {
            adjustIndex: i,
            optionIndex: j
          };
        }
      }

      return mapping;
    },
    search: function search(id, adjusts, productId) {
      var result = [];
      var aSchema = this.schema.adjust;

      var adjust = this.getAdjust(id);
      var option = this.getOption(id);
      if (option) {
        result.push(option);
        return result;
      } else {
        if (adjust) {
          option = __WEBPACK_IMPORTED_MODULE_3__assets_js_parse_menu_js__["a" /* default */].divideList(adjust[aSchema.option_list], this.getOption);
          for (var i = 0; i < option.length; i++) {
            result.push(option[i]);
          }

          return result;
        }
      }
    },
    setOptionNum: function setOptionNum(id, count) {
      this.$set(this.optionNum, id, count);
      this.$set(this, 'optionNumList', [this.optionNum]);
    },
    clickOption: function clickOption(clickedOption, clickedOptionIndex, clickedAdjust, clickedAdjustIndex) {
      var pSchema = this.schema.product;
      var aSchema = this.schema.adjust;
      var oSchema = this.schema.option;
      var currentProduct = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.currentProduct);
      var pId = currentProduct[pSchema.product_id];

      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.index' + this.pAIndex + ' #option-' + pId + '-' + clickedOption[oSchema.product_id]).unbind('mouseenter mouseleave');

      var clickedAdjustId = clickedAdjust[aSchema.product_id];
      var clickedOptionId = clickedOption[oSchema.product_id];
      var productAdjustIds = this.currentProduct[pSchema.adjust_list];

      var adjustIndex = 0;
      var adjust = null;

      var option = null;
      var blockedOptionIds = [];
      var bOptionId;
      var oId = clickedOptionId;

      for (adjustIndex = 0; adjustIndex < productAdjustIds.length; adjustIndex++) {
        adjust = this.getAdjust(productAdjustIds[adjustIndex]);
        if (adjust[aSchema.is_mandatory] === true) {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.index' + this.pAIndex + ' .adjust-' + pId + '-' + productAdjustIds[adjustIndex]).addClass('mandatory');
        }
      }
      var pdAdOpId = pId + '-' + clickedAdjustId + '-' + clickedOptionId;
      var opIndex = this.optionCurr.findIndex(function (item) {
        return item === pdAdOpId;
      });
      if (opIndex === -1) {
        this.optionCurr.push(pdAdOpId);
      } else {
        this.optionCurr.splice(opIndex, 1);
      }

      var passCombinations = this.ruleValidation();

      clickedAdjust.activeOptionIds.push(clickedOptionId);
      clickedAdjust.activeCount++;
      clickedOption.activeCount++;
      this.setOptionNum(oId, clickedOption.activeCount);
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.index' + this.pAIndex + ' #option-' + pId + '-' + clickedOptionId).attr('active', true);

      var maxLimit = 1;

      var aMaxLimit = clickedAdjust[aSchema.max_limit];
      if (maxLimit > aMaxLimit && aMaxLimit) maxLimit = aMaxLimit;
      if (clickedOption.activeCount > maxLimit && maxLimit) {
        if (__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.index' + this.pAIndex + ' #option-' + pId + '-' + clickedOptionId).attr('active')) {
          this.removeArray(clickedAdjust.activeOptionIds, clickedOptionId);
          clickedAdjust.activeCount -= clickedOption.activeCount;
          clickedOption.activeCount = 0;
          this.setOptionNum(oId, 0);
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.index' + this.pAIndex + ' #option-' + pId + '-' + clickedOptionId).removeAttr('active', false);
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.index' + this.pAIndex + ' #option-' + pId + '-' + clickedOptionId).removeClass('active');
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.adjusts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              adjust = _step.value;

              __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.index' + this.pAIndex + ' .adjust-' + pId + '-' + adjust[aSchema.product_id] + ' div').removeClass('btn-blocked');
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          blockedOptionIds = this.getBlockedOptionIds(passCombinations);
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(blockedOptionIds), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              bOptionId = _step2.value;

              __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.index' + this.pAIndex + ' #option-' + pId + '-' + bOptionId).addClass('btn-blocked');
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          this.price = this.calculatePriceBySelectedOptions(passCombinations);
          this.addProduct();
          if (clickedOption[oSchema.is_mandatory]) {
            this.clickOption(clickedOption, clickedOptionIndex, clickedAdjust, clickedAdjustIndex);
          }
          return;
        }
      }

      passCombinations = this.ruleValidation();
      if (passCombinations.length === 0) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.adjusts), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            adjust = _step3.value;

            adjust.activeOptionIds = [];
            adjust.activeCount = 0;
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
              for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(adjust[aSchema.option_list]), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                option = _step4.value;

                option.activeCount = 0;
                this.optionNumList[0][option[oSchema.product_id]] = 0;
              }
            } catch (err) {
              _didIteratorError4 = true;
              _iteratorError4 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }
              } finally {
                if (_didIteratorError4) {
                  throw _iteratorError4;
                }
              }
            }

            __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.index' + this.pAIndex + ' .adjust-' + pId + '-' + adjust[aSchema.product_id] + ' div').removeAttr('active');
            __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.index' + this.pAIndex + ' .adjust-' + pId + '-' + adjust[aSchema.product_id] + ' div').removeClass('active');
            __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.index' + this.pAIndex + ' .adjust-' + pId + '-' + adjust[aSchema.product_id] + ' div').removeClass('btn-blocked');
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        clickedAdjust.activeOptionIds.push(clickedOptionId);
        clickedAdjust.activeCount = 1;
        clickedOption.activeCount = 1;
        this.setOptionNum(oId, 1);
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.index' + this.pAIndex + ' #option-' + pId + '-' + clickedOptionId).attr('active', true);
      }

      if (clickedAdjust.activeCount > clickedAdjust[aSchema.max_limit] && clickedAdjust[aSchema.max_limit]) {
        clickedAdjust.activeOptionIds = [];
        clickedAdjust.activeCount = 0;
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(clickedAdjust[aSchema.option_list]), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            option = _step5.value;

            if (option[oSchema.product_id] !== oId) {
              option.activeCount = 0;
              var removeOId = option[oSchema.product_id];
              this.setOptionNum(removeOId, 0);
            }
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }

        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.index' + this.pAIndex + ' .adjust-' + pId + '-' + clickedAdjustId + ' div').removeAttr('active');
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.index' + this.pAIndex + ' .adjust-' + pId + '-' + clickedAdjustId + ' div').removeClass('active');
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.adjusts), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            adjust = _step6.value;

            __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.index' + this.pAIndex + ' .adjust-' + pId + '-' + adjust[aSchema.product_id] + ' div').removeClass('btn-blocked');
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }

        clickedAdjust.activeOptionIds.push(clickedOptionId);
        clickedAdjust.activeCount = this.optionNum[oId];
        clickedOption.activeCount = this.optionNum[oId];
        this.setOptionNum(oId, this.optionNum[oId]);
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.index' + this.pAIndex + ' #option-' + pId + '-' + clickedOptionId).attr('active', true);
      }

      passCombinations = this.ruleValidation();
      blockedOptionIds = this.getBlockedOptionIds(passCombinations);
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(blockedOptionIds), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          bOptionId = _step7.value;

          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.index' + this.pAIndex + ' #option-' + pId + '-' + bOptionId).addClass('btn-blocked');
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      this.addProduct();
      this.price = this.calculatePriceBySelectedOptions(passCombinations);
      this.checkMandatory(clickedOption, clickedOptionIndex, clickedAdjust, clickedAdjustIndex);
      this.passCombinations = passCombinations;
    },
    checkMandatory: function checkMandatory(clickedOption, clickedOptionIndex, clickedAdjust, clickedAdjustIndex) {
      var self = this;
      var aSchema = this.schema.adjust;
      var oSchema = this.schema.option;

      clickedAdjust[aSchema.option_list].forEach(function (option, oIndex) {
        if (option[oSchema.is_mandatory] && option[oSchema.product_id] !== clickedOption[oSchema.product_id]) {
          self.clickOption(option, oIndex, clickedAdjust, clickedAdjustIndex);
        }
      });
    },
    ruleValidation: function ruleValidation() {
      var aSchema = this.schema.adjust;
      var oSchema = this.schema.option;
      var cSchema = this.schema.combine;
      var eSchema = this.schema.edge;

      var constrainCombList = [];
      var adjust = null;
      var option = null;
      var combineId = null;
      var combine = null;
      var edge = null;
      var isExist = false;
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.productCombineIds), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          combineId = _step8.value;

          combine = this.menu.combineList[combineId];

          var allInGraph = true;
          var _iteratorNormalCompletion9 = true;
          var _didIteratorError9 = false;
          var _iteratorError9 = undefined;

          try {
            for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.adjusts), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
              adjust = _step9.value;
              var _iteratorNormalCompletion10 = true;
              var _didIteratorError10 = false;
              var _iteratorError10 = undefined;

              try {
                for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(adjust[aSchema.option_list]), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                  option = _step10.value;

                  if (option.activeCount > 0) {
                    isExist = false;
                    for (var edgeId in combine[cSchema.edge_list]) {
                      edge = combine[cSchema.edge_list][edgeId];
                      switch (edge[eSchema.product_type]) {
                        case 2:
                          if (edge[eSchema.product_id] === option[oSchema.product_id]) {
                            isExist = true;
                          }
                          break;

                        case 20:
                          if (edge[eSchema.product_id] === adjust[aSchema.product_id]) {
                            isExist = true;
                          }
                          break;
                      }
                      if (isExist) {
                        break;
                      }
                    }
                    if (!isExist) {
                      allInGraph = false;
                      break;
                    }
                  }
                }
              } catch (err) {
                _didIteratorError10 = true;
                _iteratorError10 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion10 && _iterator10.return) {
                    _iterator10.return();
                  }
                } finally {
                  if (_didIteratorError10) {
                    throw _iteratorError10;
                  }
                }
              }

              if (!allInGraph) {
                break;
              }
            }
          } catch (err) {
            _didIteratorError9 = true;
            _iteratorError9 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion9 && _iterator9.return) {
                _iterator9.return();
              }
            } finally {
              if (_didIteratorError9) {
                throw _iteratorError9;
              }
            }
          }

          if (allInGraph) {
            constrainCombList.push(combine);
          }
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      return constrainCombList;
    },
    getBlockedOptionIds: function getBlockedOptionIds(constrainCombList) {
      var aSchema = this.schema.adjust;
      var oSchema = this.schema.option;
      var cSchema = this.schema.combine;
      var eSchema = this.schema.edge;

      var blockedOptionIds = [];
      var adjust = null;
      var option = null;
      var combine = null;
      var edge = null;
      var edgeId = null;
      var isExist = false;

      var _iteratorNormalCompletion11 = true;
      var _didIteratorError11 = false;
      var _iteratorError11 = undefined;

      try {
        for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.adjusts), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
          adjust = _step11.value;
          var _iteratorNormalCompletion12 = true;
          var _didIteratorError12 = false;
          var _iteratorError12 = undefined;

          try {
            for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(adjust[aSchema.option_list]), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
              option = _step12.value;

              isExist = false;
              var _iteratorNormalCompletion13 = true;
              var _didIteratorError13 = false;
              var _iteratorError13 = undefined;

              try {
                for (var _iterator13 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(constrainCombList), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                  combine = _step13.value;

                  for (edgeId in combine[cSchema.edge_list]) {
                    edge = combine[cSchema.edge_list][edgeId];
                    switch (edge[eSchema.product_type]) {
                      case 2:
                        if (edge[eSchema.product_id] === option[oSchema.product_id]) {
                          isExist = true;
                        }
                        break;

                      case 20:
                        if (edge[eSchema.product_id] === adjust[aSchema.product_id]) {
                          isExist = true;
                        }
                        break;
                    }
                    if (isExist) {
                      break;
                    }
                  }
                  if (isExist) {
                    break;
                  }
                }
              } catch (err) {
                _didIteratorError13 = true;
                _iteratorError13 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion13 && _iterator13.return) {
                    _iterator13.return();
                  }
                } finally {
                  if (_didIteratorError13) {
                    throw _iteratorError13;
                  }
                }
              }

              if (!isExist) {
                blockedOptionIds.push(option[oSchema.product_id]);
              }
            }
          } catch (err) {
            _didIteratorError12 = true;
            _iteratorError12 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion12 && _iterator12.return) {
                _iterator12.return();
              }
            } finally {
              if (_didIteratorError12) {
                throw _iteratorError12;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError11 = true;
        _iteratorError11 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion11 && _iterator11.return) {
            _iterator11.return();
          }
        } finally {
          if (_didIteratorError11) {
            throw _iteratorError11;
          }
        }
      }

      return blockedOptionIds;
    },
    calculatePriceBySelectedOptions: function calculatePriceBySelectedOptions(constrainCombList) {
      var pSchema = this.schema.product;
      var aSchema = this.schema.adjust;
      var oSchema = this.schema.option;
      var cSchema = this.schema.combine;
      var eSchema = this.schema.edge;

      var minPrice = 0;
      var maxCombineId = 0;
      var maxPrice = 0;
      var adjustIndex = null;
      var adjust = null;
      var optionMapping = null;
      var option = null;

      var _iteratorNormalCompletion14 = true;
      var _didIteratorError14 = false;
      var _iteratorError14 = undefined;

      try {
        for (var _iterator14 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(constrainCombList), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
          var combine = _step14.value;

          var price = 0;
          if (combine[cSchema.price] !== null) {
            price = combine[cSchema.price];
            if (price < minPrice) {
              minPrice = price;
            }
            if (price > maxPrice) {
              maxPrice = price;
              maxCombineId = combine[cSchema.combine_id];
            }
            continue;
          }
          for (var edgeId in combine[cSchema.edge_list]) {
            var edge = combine[cSchema.edge_list][edgeId];
            switch (edge[eSchema.product_type]) {
              case 1:
                if (edge[eSchema.price]) price += edge[eSchema.price];else price += this.getProduct(edge[eSchema.product_id])[pSchema.price];
                break;

              case 2:
                optionMapping = this.optionsIndexMapping[edge[eSchema.product_id]];
                option = this.adjusts[optionMapping.adjustIndex][aSchema.option_list][optionMapping.optionIndex];
                if (option.activeCount > 0) {
                  if (edge[eSchema.price] === null) {
                    price += Number(option[oSchema.price]) * option.activeCount;
                  } else {
                    price += edge[eSchema.price] * option.activeCount;
                  }
                }
                break;

              case 20:
                adjustIndex = this.adjustsIndexMapping[edge[eSchema.product_id]];
                adjust = this.adjusts[adjustIndex];
                var isActiveAdjust = false;
                var adjustPrice = 0;
                var _iteratorNormalCompletion15 = true;
                var _didIteratorError15 = false;
                var _iteratorError15 = undefined;

                try {
                  for (var _iterator15 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(adjust[aSchema.option_list]), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                    option = _step15.value;

                    if (option.activeCount > 0) {
                      isActiveAdjust = true;
                      adjustPrice += option[oSchema.price] * option.activeCount;
                    }
                  }
                } catch (err) {
                  _didIteratorError15 = true;
                  _iteratorError15 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion15 && _iterator15.return) {
                      _iterator15.return();
                    }
                  } finally {
                    if (_didIteratorError15) {
                      throw _iteratorError15;
                    }
                  }
                }

                if (isActiveAdjust) {
                  if (edge[eSchema.price] !== null) {
                    price += edge[eSchema.price];
                  } else if (adjust[aSchema.price] !== null) {
                    price += adjust[aSchema.price];
                  } else {
                    price += adjustPrice;
                  }
                }
                break;
            }
          }
          if (price < minPrice) {
            minPrice = price;
          }
          if (price > maxPrice) {
            maxPrice = price;
            maxCombineId = combine[cSchema.combine_id];
          } else maxCombineId = this.currentProduct[pSchema.combine_list][cSchema.combine_id];
        }
      } catch (err) {
        _didIteratorError14 = true;
        _iteratorError14 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion14 && _iterator14.return) {
            _iterator14.return();
          }
        } finally {
          if (_didIteratorError14) {
            throw _iteratorError14;
          }
        }
      }

      this.combineId = maxCombineId;
      return maxPrice;
    },
    getSessionName: function getSessionName(type, storeId) {
      if (type === 'version') {
        return 'Nidin_' + storeId + '_menuVersion';
      } else if (type === 'menu') {
        return 'Nidin_' + storeId + '_menu';
      } else {
        return false;
      }
    },
    removeArray: function removeArray(arr, value) {
      var index = arr.indexOf(value);
      if (index > -1) {
        arr.splice(index, 1);
      }
    },
    init: function init() {
      if (this.menuJson !== undefined) {
        this.currentMenuJson = this.menuJson;
        this.menu.categoryList = this.currentMenuJson.category_list_json.data;
        this.menu.productList = this.currentMenuJson.product_list_json.data;
        this.menu.adjustList = this.currentMenuJson.adjust_list_json.data;
        this.menu.optionList = this.currentMenuJson.option_list_json.data;
        this.menu.combineList = this.currentMenuJson.combine_list_json.data;

        this.schema.category = this.currentMenuJson.category_list_json.schema;
        this.schema.product = this.currentMenuJson.product_list_json.schema;
        this.schema.icon = this.currentMenuJson.product_list_json.icon_schema;
        this.schema.img = this.currentMenuJson.product_list_json.img_schema;
        this.schema.tag = this.currentMenuJson.product_list_json.tag_schema;
        this.schema.adjust = this.currentMenuJson.adjust_list_json.schema;
        this.schema.option = this.currentMenuJson.option_list_json.schema;
        this.schema.combine = this.currentMenuJson.combine_list_json.schema;
        this.schema.edge = this.currentMenuJson.combine_list_json.edge_schema;
        this.schema.common = this.currentMenuJson.combine_list_json.common_schema;
        if (this.currentMenuJson.block_list_json) this.schema.block = this.currentMenuJson.block_list_json.schema;
      }
      this.initOptions();
    },
    clickAdd: function clickAdd() {
      var self = this;

      var pSchema = this.schema.product;
      var aSchema = this.schema.adjust;
      var oSchema = this.schema.option;

      var pId = this.currentProduct[pSchema.product_id];

      var mandatoryLack = false;
      var minLack = false;

      var _iteratorNormalCompletion16 = true;
      var _didIteratorError16 = false;
      var _iteratorError16 = undefined;

      try {
        for (var _iterator16 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.adjusts), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
          var adjust = _step16.value;

          var pName = this.currentProduct[pSchema.name] + '的';
          var noChose = adjust[aSchema.name] + '未選';
          var atLeast = adjust[aSchema.name] + '至少要選 ' + adjust[aSchema.min_limit] + ' 項';
          if (this.prodType === 'package') {
            noChose = pName + noChose;
            atLeast = pName + atLeast;
          }

          if (adjust[aSchema.is_mandatory] && adjust.activeCount === 0) {
            mandatoryLack = true;

            self.$notify({
              title: '訊息',
              text: noChose,
              duration: 3000,
              type: 'danger',
              width: 400
            });
            if (this.prodType === 'package') {
              self.clickProduct(self.currentProduct);
            }

            break;
          }
          if (adjust[aSchema.min_limit] > 0 && adjust.activeCount > 0 && adjust.activeCount < adjust[aSchema.min_limit]) {
            minLack = true;

            self.$notify({
              title: '訊息',
              text: atLeast,
              duration: 3000,
              type: 'danger',
              width: 400
            });
            if (this.prodType === 'package') {
              self.clickProduct(self.currentProduct);
            }

            break;
          }
          var _iteratorNormalCompletion17 = true;
          var _didIteratorError17 = false;
          var _iteratorError17 = undefined;

          try {
            for (var _iterator17 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(adjust[aSchema.option_list]), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
              var option = _step17.value;

              var require = option[oSchema.name] + '是' + adjust[aSchema.name] + '的必選項目';
              var atLeastO = option[oSchema.name] + '從 ' + option[oSchema.min_limit] + ' 份起跳';
              if (this.prodType === 'package') {
                require = pName + require;
                atLeastO = pName + atLeastO;
              }

              var isShow = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.index' + this.pAIndex + ' #option-' + pId + '-' + option[oSchema.product_id]).css('display');
              if (adjust.activeCount > 0 && option[oSchema.is_mandatory] && option.activeCount === 0 && isShow !== 'none') {
                mandatoryLack = true;

                self.$notify({
                  title: '訊息',
                  text: require,
                  duration: 3000,
                  type: 'danger',
                  width: 400
                });
                if (this.prodType === 'package') {
                  self.clickProduct(self.currentProduct);
                }

                break;
              }
              if (adjust.activeCount > 0 && option[aSchema.min_limit] > 0 && option.activeCount > 0 && option.activeCount < option[aSchema.min_limit]) {
                minLack = true;

                self.$notify({
                  title: '訊息',
                  text: atLeastO,
                  duration: 3000,
                  type: 'danger',
                  width: 400
                });
                if (this.prodType === 'package') {
                  self.clickProduct(self.currentProduct);
                }

                break;
              }
            }
          } catch (err) {
            _didIteratorError17 = true;
            _iteratorError17 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion17 && _iterator17.return) {
                _iterator17.return();
              }
            } finally {
              if (_didIteratorError17) {
                throw _iteratorError17;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError16 = true;
        _iteratorError16 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion16 && _iterator16.return) {
            _iterator16.return();
          }
        } finally {
          if (_didIteratorError16) {
            throw _iteratorError16;
          }
        }
      }

      if (!mandatoryLack && !minLack) {
        return true;
      }

      return false;
    },
    clearOption: function clearOption() {
      var aSchema = this.schema.adjust;
      var pSchema = this.schema.product;
      var oSchema = this.schema.option;
      var pId = this.currentProduct[this.schema.product.product_id];

      this.limitList = {};
      var _iteratorNormalCompletion18 = true;
      var _didIteratorError18 = false;
      var _iteratorError18 = undefined;

      try {
        for (var _iterator18 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.adjusts), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
          var adjust = _step18.value;

          adjust.activeOptionIds = [];
          adjust.activeCount = 0;
          var _iteratorNormalCompletion19 = true;
          var _didIteratorError19 = false;
          var _iteratorError19 = undefined;

          try {
            for (var _iterator19 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(adjust[aSchema.option_list]), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
              var option = _step19.value;

              option.activeCount = 0;
              this.optionNum[option[oSchema.product_id]] = 0;
            }
          } catch (err) {
            _didIteratorError19 = true;
            _iteratorError19 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion19 && _iterator19.return) {
                _iterator19.return();
              }
            } finally {
              if (_didIteratorError19) {
                throw _iteratorError19;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError18 = true;
        _iteratorError18 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion18 && _iterator18.return) {
            _iterator18.return();
          }
        } finally {
          if (_didIteratorError18) {
            throw _iteratorError18;
          }
        }
      }

      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.index' + this.pAIndex + ' .adjust-' + pId + ' .btn-option').removeAttr('active');
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.index' + this.pAIndex + ' .adjust-' + pId + ' .btn-option').removeClass('active');
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.index' + this.pAIndex + ' .adjust-' + pId + ' .btn-option').attr('disabled', false);
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.index' + this.pAIndex + ' .adjust-' + pId + ' .btn-option').removeClass('disabled');
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.index' + this.pAIndex + ' .adjust-' + pId + ' .btn-option').removeClass('btn-blocked');
      });
      this.number = 1;

      if (this.prodType === 'package') this.price = 0;else if (this.combineProductPrice) this.price = this.combineProductPrice;else this.price = this.currentProduct[pSchema.price];
      this.optionNum = {};
      this.optionNumList = Array.isArray(this.optionNumList) ? this.optionNumList.slice(0, this.optionNumList.length - 1) : [];
      this.optionNumList.push(this.optionNum);
      this.addProduct();
    },
    addProduct: function addProduct() {
      var pSchema = this.schema.product;
      var aSchema = this.schema.adjust;
      var oSchema = this.schema.option;

      var products = {
        items: [{
          product_id: this.currentProduct[pSchema.product_id],
          type: 1,
          amount: this.number,
          combine_id: this.combineId,
          options: [],
          adjusts: []
        }]
      };

      var product = {
        items: [{
          product_id: this.currentProduct[pSchema.product_id],
          type: 1,
          amount: 1,
          combine_id: this.combineId,
          options: [],
          adjusts: []
        }]
      };
      var _iteratorNormalCompletion20 = true;
      var _didIteratorError20 = false;
      var _iteratorError20 = undefined;

      try {
        for (var _iterator20 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.adjusts), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
          var adjust = _step20.value;

          if (adjust.activeCount > 0) {
            var adjustP = {
              adjust_id: parseInt(adjust[aSchema.product_id], 10),
              options: []
            };
            var _iteratorNormalCompletion21 = true;
            var _didIteratorError21 = false;
            var _iteratorError21 = undefined;

            try {
              for (var _iterator21 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(adjust[aSchema.option_list]), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
                var option = _step21.value;

                if (option.activeCount > 0) {
                  var oAmount = this.optionNumList[0][option[oSchema.product_id]];
                  adjustP.options.push({ option_id: parseInt(option[oSchema.product_id], 10), amount: oAmount });
                }
              }
            } catch (err) {
              _didIteratorError21 = true;
              _iteratorError21 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion21 && _iterator21.return) {
                  _iterator21.return();
                }
              } finally {
                if (_didIteratorError21) {
                  throw _iteratorError21;
                }
              }
            }

            products.items[0].adjusts.push(adjustP);
            product.items[0].adjusts.push(adjustP);
          }
        }
      } catch (err) {
        _didIteratorError20 = true;
        _iteratorError20 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion20 && _iterator20.return) {
            _iterator20.return();
          }
        } finally {
          if (_didIteratorError20) {
            throw _iteratorError20;
          }
        }
      }

      this.checkAddProduct(products);

      if (this.pAIndex) this.checkAddDifProduct(product, this.pAIndex);
    },
    initOptions: function initOptions() {
      var self = this;
      var pSchema = this.schema.product;
      var cSchema = this.schema.combine;
      var aSchema = this.schema.adjust;
      var oSchema = this.schema.option;

      if (this.prodType === 'package') {
        var passCombinations = this.ruleValidation();
        this.price = this.calculatePriceBySelectedOptions(passCombinations);
      } else if (this.combineProductPrice) this.price = this.combineProductPrice;else this.price = this.currentProduct[pSchema.price];
      this.combineId = this.currentProduct[pSchema.combine_list][cSchema.combine_id];
      this.productCombineIds = this.currentProduct[this.schema.product.combine_list];
      this.adjusts = this.showAll(this.currentProduct, this.productCombineIds);
      this.adjustsIndexMapping = this.createMapping(this.adjusts, this.schema.adjust.product_id);
      this.optionsIndexMapping = this.createOptionMapping(this.adjusts);
      this.clearOption();
      this.$nextTick(function () {
        this.filterCombine(this.productCombineIds);

        this.adjusts.forEach(function (adjust, aIndex) {
          adjust[aSchema.option_list].forEach(function (option, oIndex) {
            if (option[oSchema.is_mandatory]) {
              self.clickOption(option, oIndex, adjust, aIndex);
            }
          });
        });
      });
    },
    initUpOptions: function initUpOptions() {
      var pSchema = this.schema.product;
      var cSchema = this.schema.combine;
      var self = this;

      this.clearOption();

      if (this.prodType === 'package') {
        var passCombinations = this.ruleValidation();
        this.price = this.calculatePriceBySelectedOptions(passCombinations);
      } else if (this.combineProductPrice) this.price = this.combineProductPrice;else this.price = this.currentProduct[pSchema.price];
      this.combineId = this.currentProduct[pSchema.combine_list][cSchema.combine_id];
      this.productCombineIds = this.currentProduct[this.schema.product.combine_list];
      this.adjusts = this.showAll(this.currentProduct, this.productCombineIds);
      this.adjustsIndexMapping = this.createMapping(this.adjusts, this.schema.adjust.product_id);
      this.optionsIndexMapping = this.createOptionMapping(this.adjusts);
      this.$nextTick(function () {
        this.filterCombine(this.productCombineIds);

        if (this.checkDisOption) {
          this.show.reChoose = true;
        } else if (this.curOrderInfo) {
          this.show.reChoose = false;

          if (this.curOrderInfo.adjusts) {
            for (var i = 0; i < this.curOrderInfo.adjusts.length; i++) {
              for (var j = 0; j < this.curOrderInfo.adjusts[i].options.length; j++) {
                var option = self.getOption(this.curOrderInfo.adjusts[i].options[j].option_id);
                var adjust = self.getAdjust(this.curOrderInfo.adjusts[i].adjust_id);
                var oAmount = this.curOrderInfo.adjusts[i].options[j].amount;
                for (var a = 0; a < oAmount; a++) {
                  self.clickOption(option, j, adjust, i);
                }
              }
            }
          }
        }
      });
    },
    checkAdjustDis: function checkAdjustDis(aId) {
      var dis = this.disAdjust.find(function (o) {
        return o === aId;
      });
      if (dis) {
        return false;
      } else return true;
    },
    checkOptionDis: function checkOptionDis(oId, aId) {
      if (this.disOption[aId]) {
        var dis = this.disOption[aId].find(function (o) {
          return o.product_id === oId;
        });
        if (dis) {
          return false;
        } else return true;
      } else {
        return true;
      }
    }
  },
  ready: function ready() {},

  computed: {
    checkDisOption: function checkDisOption() {
      var list = this.curOrderInfo;
      var disOption = 0;
      if (list) {
        for (var i = 0; i < list.length; i++) {
          if (list.type === 1) {
            var aList = list[i].adjusts;
            for (var _i = 0; _i < aList.length; _i++) {
              if (aList[_i].is_disabled) {
                disOption = 1;
                break;
              }

              if (!disOption) {
                var oaList = aList[_i].options;
                for (var j = 0; j < oaList.length; j++) {
                  if (oaList[j].is_disabled) {
                    disOption = 1;
                    break;
                  }
                }
              }
            }
          }
        }
      }
      return disOption;
    },
    minCombinePrice: function minCombinePrice() {
      var oSchema = this.schema.option;
      var price = 0;

      for (var i in this.isOption.length) {
        price = price + this.isOption[i].option[oSchema.price];
      }
      return price;
    },
    combinePrice: function combinePrice() {
      var minPrice;
      var self = this;
      var priceCombine = [];
      var priceList = [];
      if (this.productCombineIds.length) {
        for (var i = 0; i < this.productCombineIds.length; i++) {
          var item;
          var price = this.getCombine(this.productCombineIds[i])[this.schema.combine.price];
          if (price === null) {
            var edgeList = this.getCombine(this.productCombineIds[i])[this.schema.combine.edge_list];
            for (var key in edgeList) {
              this.parsePrice(edgeList[key]);
              if (this.parsePrice(edgeList[key]).type === 'p') price = this.parsePrice(edgeList[key]).price;
            }

            item = { price: price + self.minCombinePrice, combine: this.getCombine(this.productCombineIds[i]) };
            priceCombine.push(item);
          } else {
            item = { price: price, combine: this.getCombine(this.productCombineIds[i]) };
            priceCombine.push(item);
          }
        }
      }

      for (var o in priceCombine) {
        priceList.push(priceCombine[o].price);
      }
      minPrice = Math.min.apply(Math, priceList);
      return minPrice;
    },
    isBigMilk: function isBigMilk() {
      var pSchema = this.schema.product;
      var product = this.currentProduct;
      var productName = product[pSchema.name];
      if (productName) {
        if (productName.trim() === '綠光純鮮奶家庭號') return true;
      }
      return false;
    },
    isIce: function isIce() {
      var pSchema = this.schema.product;
      var product = this.currentProduct;
      var productName = product[pSchema.name];
      if (productName) {
        if (productName.trim().indexOf('冰萃檸檬') > -1) return true;
        if (productName.trim().indexOf('冰萃柳丁') > -1) return true;
        if (productName.trim().indexOf('仙人掌冰茶') > -1) return true;
        if (productName.trim().indexOf('綠豆鮮奶冰沙') > -1) return true;
      }
      return false;
    },
    combineProductPrice: function combineProductPrice() {
      var minPrice;
      var priceCombine = [];
      var priceList = [];
      var cSchema = this.schema.combine;
      var eSchema = this.schema.edge;
      if (this.productCombineIds.length) {
        for (var i = 0; i < this.productCombineIds.length; i++) {
          var item;
          var price = null;
          var edgeList = this.getCombine(this.productCombineIds[i])[cSchema.edge_list];
          for (var key in edgeList) {
            if (edgeList[key][eSchema.product_type] === 1) {
              price = edgeList[key][eSchema.price];
              item = { price: price, combine: this.getCombine(this.productCombineIds[i]) };
              priceCombine.push(item);
            }
          }
        }
      }

      for (var o in priceCombine) {
        priceList.push(priceCombine[o].price);
      }
      minPrice = Math.min.apply(Math, priceList);
      return minPrice;
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.q-numeric input').attr('maxlength', '2');
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.q-numeric input').attr('type', 'tel');
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.q-numeric input').keyup(function () {
      var e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.q-numeric input');
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    });
  },
  created: function created() {
    if (this.currentProduct.length) {
      this.clearOption();
      this.init();
      this.addProduct();
    }
  },

  watch: {
    currentProduct: {
      handler: function handler() {
        this.clearOption();
        this.init();
      },

      deep: true
    },
    number: function number() {
      if (!this.number) this.number = 1;
    },
    price: function price() {
      if (this.pAIndex) this.checkPrice(this.price, this.currentProduct, this.pAIndex);else this.checkPrice(this.price, this.currentProduct);
    },
    productAmount: function productAmount() {
      this.number = this.productAmount;

      this.addProduct();
    },
    aSameCheck: function aSameCheck() {
      this.addProduct();
      this.checkPrice(this.price, this.currentProduct);
    },
    combineId: function combineId() {
      this.addProduct();
    }
  }
});

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_parse_menu_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MenuOptions_vue__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MenuOptions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MenuOptions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MutiProduct_vue__ = __webpack_require__(2223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MutiProduct_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__MutiProduct_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'menu-options': __WEBPACK_IMPORTED_MODULE_3__MenuOptions_vue___default.a,
    'muti-prod': __WEBPACK_IMPORTED_MODULE_5__MutiProduct_vue___default.a
  },
  props: {
    modalView: {
      type: Boolean
    },
    currentProduct: {
      type: [Array]
    },
    brandId: {
      type: Number
    },
    menuJson: {
      type: [Object, String]
    }
  },
  data: function data() {
    return {
      isVisible: [],
      tags: 0,
      isOption: [],
      isShow: [],
      cartMount: 0,
      totalPrice: function totalPrice() {
        return parseInt(this.number, 10) * this.price;
      },

      combineId: '',
      adjusts: [],
      schema: {
        category: {},
        product: {},
        icon: {},
        image: {},
        tag: {},
        adjust: {},
        option: {},
        combine: {},
        edge: {},
        common: {},
        block: {}
      },
      currentMenuJson: '',
      storeId: this.$route.params.storeId,
      productCombineIds: [],
      menu: {
        categoryList: {},
        productList: {},
        adjustList: {},
        optionList: {},
        combineList: {}
      },
      show: {
        reChoose: false,
        picDetail: false
      },
      swiperOption: {
        autoplay: 4000,
        setWrapperSize: true,
        pagination: '.img-pagination',
        paginationClickable: true,

        observeParents: true,
        prevButton: '.img-button-prev',
        nextButton: '.img-button-next',
        loop: true,
        paginationElement: 'li'
      },
      number: 1,
      price: 0,

      optionStyle: false,

      packageLayer: {
        show: true
      },

      bActiveList: [],
      otherActiveList: [],
      pActiveList: [],
      allProduct: {},

      errorMenu: false,

      choseCurProd: 0,

      addPrice: {},
      addPrices: {},
      addDetail: {},
      addDetails: {},
      addAdjust: {},

      optionCheck: {
        id: 0,
        num: 0
      },

      optionNum: {},
      optionNumList: [{}],

      adjustSame: {},
      checkTest: true
    };
  },

  methods: {
    sortObj: function sortObj(obj) {
      var pSchema = this.schema.product;
      var newO = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(obj).sort(function (a, b) {
        return a.product[pSchema.sort] - b.product[pSchema.sort];
      });

      return newO;
    },
    sortProd: function sortProd(array) {
      var newA = array.sort(function (a, b) {
        return a.sort - b.sort;
      });

      return newA;
    },
    pShow: function pShow(product) {
      var pSchema = this.schema.product;
      var pId = product[pSchema.product_id];
      var show = this.pActiveList.find(function (o) {
        if (pId === o.id) {
          if (o.show) return true;else return false;
        }
      });
      return show;
    },
    adjustsOfProduct: function adjustsOfProduct(productId) {
      return this.getProduct(productId)[this.schema.product.adjust_list];
    },
    optionsOfAdjust: function optionsOfAdjust(adjustId) {
      return this.getAdjust(adjustId)[this.schema.adjust.option_list];
    },
    combinesOfProduct: function combinesOfProduct(productId) {
      return this.getProduct(productId)[this.schema.product.combine_list];
    },
    getProduct: function getProduct(productId) {
      return this.menu.productList[productId];
    },
    getAdjust: function getAdjust(adjustId) {
      return this.menu.adjustList[adjustId];
    },
    getOption: function getOption(optionId) {
      return this.menu.optionList[optionId];
    },
    getCombine: function getCombine(combineId) {
      return this.menu.combineList[combineId];
    },
    getBlock: function getBlock(blockId) {
      return this.menu.blockList[blockId];
    },
    getPAmount: function getPAmount(prod) {
      var pSchema = this.schema.product;
      var pId = prod[pSchema.product_id];
      if (!this.getModalView) return 1;else if (this.optionNumList[0][pId]) return this.optionNumList[0][pId];else return 1;
    },
    clickChoseP: function clickChoseP() {
      this.choseCurProd = 0;
      this.packageLayer.show = true;
    },
    clickAdd: function clickAdd() {
      var self = this;
      var mandatoryLack = false;
      var bSchema = this.schema.block;
      for (var b = 0; b < this.bActiveList.length; b++) {
        var block = this.bActiveList[b];
        if (block.block.product[bSchema.is_mandatory]) {
          if (block.activeList.length < block[bSchema.min_limit] || !block.activeList.length) {
            self.$notify({
              title: '提醒',
              text: block.block.product[bSchema.name] + '未選',
              duration: 2500,
              type: 'danger'
            });
            self.clickChoseP();
            mandatoryLack = true;
            break;
          }
        }
        if (block.block.product[bSchema.min_limit] && block.block.product[bSchema.min_limit] > block.activeList.length) {
          self.$notify({
            title: '提醒',
            text: block.block.product[bSchema.name] + '未選' + block.block.product[bSchema.min_limit] + '項',
            duration: 2500,
            type: 'danger'
          });
          self.clickChoseP();
          mandatoryLack = true;
          break;
        }
        if (b === this.bActiveList.length - 1) this.checkPActive(mandatoryLack);
      }
    },
    checkPActive: function checkPActive(mandatoryLack) {
      for (var p = 0; p < this.pActiveList.length; p++) {
        var pA = this.pActiveList[p];
        if (pA.show) {
          if (!this.$refs['menu-options-' + pA.id][0].clickAdd()) {
            mandatoryLack = true;
            break;
          }
        }
        if (p === this.pActiveList.length - 1) this.checkError(mandatoryLack);
      }
    },
    checkError: function checkError(mandatoryLack) {
      if (!mandatoryLack) {
        this.$notify({
          title: '成功',
          text: '成功加入商品',
          duration: 2500,
          type: 'success'
        });
      }
    },
    parsePrice: function parsePrice(product) {
      var pSchema = this.schema.product;
      var aSchema = this.schema.adjust;
      var oSchema = this.schema.option;
      var productId = product[pSchema.product_id];
      var price;
      var type;
      var checkP = this.getProduct(productId);
      var checkA = this.getAdjust(productId);
      var checkO = this.getOption(productId);
      var isOption = [];
      var minPrice = [];
      if (checkP) {
        price = checkP[pSchema.price];
        type = 'p';
        var aList = checkP[pSchema.adjust_list];
        aList = __WEBPACK_IMPORTED_MODULE_2__assets_js_parse_menu_js__["a" /* default */].divideList(aList, this.getAdjust);
        for (var j = 0; j < aList.length; j++) {
          var aListPrice = [];
          var tag = 0;
          for (var k = 0; k < aList[j][aSchema.option_list].length; k++) {
            tag++;
            aListPrice.push(aList[j][aSchema.option_list][k][oSchema.price]);
            if (tag === aList[j][aSchema.option_list].length) minPrice.push(Math.min.apply(Math, aListPrice));
          }
        }
        for (var m = 0; m < aList.length; m++) {
          var max = aList[m][aSchema.max_limit];
          var tags = 1;
          for (var n = 0; n < aList[m][aSchema.option_list].length; n++) {
            if (aList[m][aSchema.option_list][n][oSchema.price] === minPrice[m] && tags <= max) {
              tags++;
              if (aList[m][aSchema.is_mandatory]) isOption.push({ adjust: aList[m], option: aList[m][aSchema.option_list][n] });
            }
          }
        }
      } else if (checkA) {
        price = checkA[aSchema.price];
        type = 'a';
        if (price === null) {
          for (var i = 0; i < checkA[aSchema.option_list].length; i++) {
            if (checkA[aSchema.option_list][i][oSchema.is_mandatory]) {
              price = price + checkA[aSchema.option_list][i][oSchema.price];
            }
          }
        }
      } else if (checkO) {
        price = checkO[oSchema.price];
        type = 'o';
      }
      if (isOption.length) this.isOption = isOption;
      return { price: price, type: type };
    },
    showAll: function showAll(product, combines) {
      var pSchema = this.schema.product;
      var aSchema = this.schema.adjust;
      var oSchema = this.schema.option;

      var adjustIds = product[pSchema.adjust_list];
      var result = [];

      for (var adjustIndex = 0; adjustIndex < adjustIds.length; adjustIndex++) {
        var adjust = __WEBPACK_IMPORTED_MODULE_2__assets_js_parse_menu_js__["a" /* default */].divideList(adjustIds, this.getAdjust)[adjustIndex];
        if (adjust) {
          adjust.activeCount = 0;
          adjust.activeOptionIds = [];
          for (var optionIndex = 0; optionIndex < adjust[aSchema.option_list].length; optionIndex++) {
            if (typeof adjust[aSchema.option_list][optionIndex] === 'number') {
              adjust[aSchema.option_list][optionIndex] = this.getOption(adjust[aSchema.option_list][optionIndex]);
              adjust[aSchema.option_list][optionIndex].activeCount = 0;
            }
          }
          adjust[aSchema.option_list].sort(function (a, b) {
            if (a[oSchema.sort] > b[oSchema.sort]) {
              return 1;
            }
            if (a[oSchema.sort] < b[oSchema.sort]) {
              return -1;
            }

            return 0;
          });
          result.push(adjust);
        }
      }

      result.push([]);
      result.sort(function (a, b) {
        if (a[aSchema.sub_type] && b[aSchema.sub_type]) return b[aSchema.sub_type] - a[aSchema.sub_type];else return b[aSchema.sub_type] - a[aSchema.sub_type];
      });
      result.splice(-1, 1);
      return result;
    },
    filterCombine: function filterCombine(combines) {
      var oSchema = this.schema.option;
      var cSchema = this.schema.combine;
      var eSchema = this.schema.edge;
      var aSchema = this.schema.adjust;
      this.isShow = [];

      __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.btn-option').css('display', 'none');
      var combine = __WEBPACK_IMPORTED_MODULE_2__assets_js_parse_menu_js__["a" /* default */].divideList(combines, this.getCombine);
      for (var cIndex = 0; cIndex < combine.length; cIndex++) {
        for (var oIndex in combine[cIndex][cSchema.edge_list]) {
          this.isShow.push(combine[cIndex][cSchema.edge_list][oIndex][eSchema.product_id]);
        }
      }
      this.isShow = this.isShow.filter(function (elem, index, self) {
        return self.indexOf(elem) === index;
      });
      for (var id = 0; id < this.isShow.length; id++) {
        var num = this.isShow[id];
        if (this.getOption(num)) {
          __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#option-' + this.getOption(num)[oSchema.product_id]).css('display', 'inline-block');
        } else if (this.getAdjust(num)) {
          var options = this.getAdjust(num)[aSchema.option_list];
          for (var o = 0; o < options.length; o++) {
            __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#option-' + options[o][oSchema.product_id]).css('display', 'inline-block');
          }
        }
      }
    },
    createMapping: function createMapping(arrayData, idIndex) {
      var mapping = {};
      for (var i = 0; i < arrayData.length; i++) {
        mapping[arrayData[i][idIndex]] = i;
      }

      return mapping;
    },
    createOptionMapping: function createOptionMapping(adjusts) {
      var aSchema = this.schema.adjust;
      var oSchema = this.schema.option;

      var mapping = {};
      for (var i = 0; i < adjusts.length; i++) {
        for (var j = 0; j < adjusts[i][aSchema.option_list].length; j++) {
          mapping[adjusts[i][aSchema.option_list][j][oSchema.product_id]] = {
            adjustIndex: i,
            optionIndex: j
          };
        }
      }

      return mapping;
    },
    search: function search(id, adjusts, productId) {
      var result = [];
      var aSchema = this.schema.adjust;

      var adjust = this.getAdjust(id);
      var option = this.getOption(id);
      if (option) {
        result.push(option);
        return result;
      } else {
        if (adjust) {
          option = __WEBPACK_IMPORTED_MODULE_2__assets_js_parse_menu_js__["a" /* default */].divideList(adjust[aSchema.option_list], this.getOption);
          for (var i = 0; i < option.length; i++) {
            result.push(option[i]);
          }

          return result;
        }
      }
    },
    clickOption: function clickOption(clickedOption, clickedOptionIndex, clickedAdjust, clickedAdjustIndex) {
      var pSchema = this.schema.product;
      var aSchema = this.schema.adjust;
      var oSchema = this.schema.option;

      __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#option-' + clickedOption[oSchema.product_id]).unbind('mouseenter mouseleave');

      var clickedAdjustId = clickedAdjust[aSchema.product_id];
      var clickedOptionId = clickedOption[oSchema.product_id];
      var productAdjustIds = this.currentProduct[pSchema.adjust_list];

      var adjustIndex = 0;
      var adjust = null;

      var option = null;
      var blockedOptionIds = [];
      var bOptionId;

      for (adjustIndex = 0; adjustIndex < productAdjustIds.length; adjustIndex++) {
        adjust = this.getAdjust(productAdjustIds[adjustIndex]);
        if (adjust[aSchema.is_mandatory] === true) {
          __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.adjust-' + productAdjustIds[adjustIndex]).addClass('mandatory');
        }
      }

      if (__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#option-' + clickedOptionId).attr('active')) {
        this.removeArray(clickedAdjust.activeOptionIds, clickedOptionId);
        clickedAdjust.activeCount -= clickedOption.activeCount;
        clickedOption.activeCount = 0;
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#option-' + clickedOptionId).removeAttr('active', false);
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#option-' + clickedOptionId).removeClass('active');
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.adjusts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            adjust = _step.value;

            __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.adjust-' + adjust[aSchema.product_id] + ' div').removeClass('btn-blocked');
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        var passCombinations = this.ruleValidation();
        blockedOptionIds = this.getBlockedOptionIds(passCombinations);
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(blockedOptionIds), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            bOptionId = _step2.value;

            __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#option-' + bOptionId).addClass('btn-blocked');
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        this.price = this.calculatePriceBySelectedOptions(passCombinations);

        return;
      }

      clickedAdjust.activeOptionIds.push(clickedOptionId);
      clickedAdjust.activeCount++;
      clickedOption.activeCount++;
      __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#option-' + clickedOptionId).attr('active', true);

      passCombinations = this.ruleValidation();
      if (passCombinations.length === 0) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.adjusts), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            adjust = _step3.value;

            adjust.activeOptionIds = [];
            adjust.activeCount = 0;
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
              for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(adjust[aSchema.option_list]), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                option = _step4.value;

                option.activeCount = 0;
              }
            } catch (err) {
              _didIteratorError4 = true;
              _iteratorError4 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }
              } finally {
                if (_didIteratorError4) {
                  throw _iteratorError4;
                }
              }
            }

            __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.adjust-' + adjust[aSchema.product_id] + ' div').removeAttr('active');
            __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.adjust-' + adjust[aSchema.product_id] + ' div').removeClass('active');
            __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.adjust-' + adjust[aSchema.product_id] + ' div').removeClass('btn-blocked');
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        clickedAdjust.activeOptionIds.push(clickedOptionId);
        clickedAdjust.activeCount = 1;
        clickedOption.activeCount = 1;
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#option-' + clickedOptionId).attr('active', true);
      }

      if (clickedAdjust.activeCount > clickedAdjust[aSchema.max_limit] && clickedAdjust[aSchema.max_limit]) {
        clickedAdjust.activeOptionIds = [];
        clickedAdjust.activeCount = 0;
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(clickedAdjust[aSchema.option_list]), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            option = _step5.value;

            option.activeCount = 0;
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }

        __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.adjust-' + clickedAdjustId + ' div').removeAttr('active');
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.adjust-' + clickedAdjustId + ' div').removeClass('active');
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.adjusts), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            adjust = _step6.value;

            __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.adjust-' + adjust[aSchema.product_id] + ' div').removeClass('btn-blocked');
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }

        clickedAdjust.activeOptionIds.push(clickedOptionId);
        clickedAdjust.activeCount = 1;
        clickedOption.activeCount = 1;
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#option-' + clickedOptionId).attr('active', true);
      }

      passCombinations = this.ruleValidation();
      blockedOptionIds = this.getBlockedOptionIds(passCombinations);
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(blockedOptionIds), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          bOptionId = _step7.value;

          __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#option-' + bOptionId).addClass('btn-blocked');
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      this.price = this.calculatePriceBySelectedOptions(passCombinations);
    },
    ruleValidation: function ruleValidation() {
      var aSchema = this.schema.adjust;
      var oSchema = this.schema.option;
      var cSchema = this.schema.combine;
      var eSchema = this.schema.edge;

      var constrainCombList = [];
      var adjust = null;
      var option = null;
      var combineId = null;
      var combine = null;
      var edge = null;
      var isExist = false;
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.productCombineIds), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          combineId = _step8.value;

          combine = this.menu.combineList[combineId];

          var allInGraph = true;
          var _iteratorNormalCompletion9 = true;
          var _didIteratorError9 = false;
          var _iteratorError9 = undefined;

          try {
            for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.adjusts), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
              adjust = _step9.value;
              var _iteratorNormalCompletion10 = true;
              var _didIteratorError10 = false;
              var _iteratorError10 = undefined;

              try {
                for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(adjust[aSchema.option_list]), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                  option = _step10.value;

                  if (option.activeCount > 0) {
                    isExist = false;
                    for (var edgeId in combine[cSchema.edge_list]) {
                      edge = combine[cSchema.edge_list][edgeId];
                      switch (edge[eSchema.product_type]) {
                        case 2:
                          if (edge[eSchema.product_id] === option[oSchema.product_id]) {
                            isExist = true;
                          }
                          break;

                        case 20:
                          if (edge[eSchema.product_id] === adjust[aSchema.product_id]) {
                            isExist = true;
                          }
                          break;
                      }
                      if (isExist) {
                        break;
                      }
                    }
                    if (!isExist) {
                      allInGraph = false;
                      break;
                    }
                  }
                }
              } catch (err) {
                _didIteratorError10 = true;
                _iteratorError10 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion10 && _iterator10.return) {
                    _iterator10.return();
                  }
                } finally {
                  if (_didIteratorError10) {
                    throw _iteratorError10;
                  }
                }
              }

              if (!allInGraph) {
                break;
              }
            }
          } catch (err) {
            _didIteratorError9 = true;
            _iteratorError9 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion9 && _iterator9.return) {
                _iterator9.return();
              }
            } finally {
              if (_didIteratorError9) {
                throw _iteratorError9;
              }
            }
          }

          if (allInGraph) {
            constrainCombList.push(combine);
          }
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      return constrainCombList;
    },
    getBlockedOptionIds: function getBlockedOptionIds(constrainCombList) {
      var aSchema = this.schema.adjust;
      var oSchema = this.schema.option;
      var cSchema = this.schema.combine;
      var eSchema = this.schema.edge;

      var blockedOptionIds = [];
      var adjust = null;
      var option = null;
      var combine = null;
      var edge = null;
      var edgeId = null;
      var isExist = false;

      var _iteratorNormalCompletion11 = true;
      var _didIteratorError11 = false;
      var _iteratorError11 = undefined;

      try {
        for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.adjusts), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
          adjust = _step11.value;
          var _iteratorNormalCompletion12 = true;
          var _didIteratorError12 = false;
          var _iteratorError12 = undefined;

          try {
            for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(adjust[aSchema.option_list]), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
              option = _step12.value;

              isExist = false;
              var _iteratorNormalCompletion13 = true;
              var _didIteratorError13 = false;
              var _iteratorError13 = undefined;

              try {
                for (var _iterator13 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(constrainCombList), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                  combine = _step13.value;

                  for (edgeId in combine[cSchema.edge_list]) {
                    edge = combine[cSchema.edge_list][edgeId];
                    switch (edge[eSchema.product_type]) {
                      case 2:
                        if (edge[eSchema.product_id] === option[oSchema.product_id]) {
                          isExist = true;
                        }
                        break;

                      case 20:
                        if (edge[eSchema.product_id] === adjust[aSchema.product_id]) {
                          isExist = true;
                        }
                        break;
                    }
                    if (isExist) {
                      break;
                    }
                  }
                  if (isExist) {
                    break;
                  }
                }
              } catch (err) {
                _didIteratorError13 = true;
                _iteratorError13 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion13 && _iterator13.return) {
                    _iterator13.return();
                  }
                } finally {
                  if (_didIteratorError13) {
                    throw _iteratorError13;
                  }
                }
              }

              if (!isExist) {
                blockedOptionIds.push(option[oSchema.product_id]);
              }
            }
          } catch (err) {
            _didIteratorError12 = true;
            _iteratorError12 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion12 && _iterator12.return) {
                _iterator12.return();
              }
            } finally {
              if (_didIteratorError12) {
                throw _iteratorError12;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError11 = true;
        _iteratorError11 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion11 && _iterator11.return) {
            _iterator11.return();
          }
        } finally {
          if (_didIteratorError11) {
            throw _iteratorError11;
          }
        }
      }

      return blockedOptionIds;
    },
    calculatePriceBySelectedOptions: function calculatePriceBySelectedOptions(constrainCombList) {
      var pSchema = this.schema.product;
      var aSchema = this.schema.adjust;
      var oSchema = this.schema.option;
      var cSchema = this.schema.combine;
      var eSchema = this.schema.edge;

      var minPrice = 0;
      var maxCombineId = 0;
      var maxPrice = 0;
      var adjustIndex = null;
      var adjust = null;
      var optionMapping = null;
      var option = null;

      var _iteratorNormalCompletion14 = true;
      var _didIteratorError14 = false;
      var _iteratorError14 = undefined;

      try {
        for (var _iterator14 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(constrainCombList), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
          var combine = _step14.value;

          var price = 0;
          if (combine[cSchema.price] !== null) {
            price = combine[cSchema.price];
            if (price < minPrice) {
              minPrice = price;
            }
            if (price > maxPrice) {
              maxPrice = price;
              maxCombineId = combine[cSchema.combine_id];
            }
            continue;
          }
          for (var edgeId in combine[cSchema.edge_list]) {
            var edge = combine[cSchema.edge_list][edgeId];
            switch (edge[eSchema.product_type]) {
              case 1:
                price += this.getProduct(edge[eSchema.product_id])[pSchema.price];
                break;

              case 2:
                optionMapping = this.optionsIndexMapping[edge[eSchema.product_id]];
                option = this.adjusts[optionMapping.adjustIndex][aSchema.option_list][optionMapping.optionIndex];
                if (option.activeCount > 0) {
                  if (edge[eSchema.price] === null) {
                    price += Number(option[oSchema.price]) * option.activeCount;
                  } else {
                    price += edge[eSchema.price] * option.activeCount;
                  }
                }
                break;

              case 20:
                adjustIndex = this.adjustsIndexMapping[edge[eSchema.product_id]];
                adjust = this.adjusts[adjustIndex];
                var isActiveAdjust = false;
                var adjustPrice = 0;
                var _iteratorNormalCompletion15 = true;
                var _didIteratorError15 = false;
                var _iteratorError15 = undefined;

                try {
                  for (var _iterator15 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(adjust[aSchema.option_list]), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                    option = _step15.value;

                    if (option.activeCount > 0) {
                      isActiveAdjust = true;
                      adjustPrice += option[oSchema.price] * option.activeCount;
                    }
                  }
                } catch (err) {
                  _didIteratorError15 = true;
                  _iteratorError15 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion15 && _iterator15.return) {
                      _iterator15.return();
                    }
                  } finally {
                    if (_didIteratorError15) {
                      throw _iteratorError15;
                    }
                  }
                }

                if (isActiveAdjust) {
                  if (edge[eSchema.price] !== null) {
                    price += edge[eSchema.price];
                  } else if (adjust[aSchema.price] !== null) {
                    price += adjust[aSchema.price];
                  } else {
                    price += adjustPrice;
                  }
                }
                break;
            }
          }
          if (price < minPrice) {
            minPrice = price;
          }
          if (price > maxPrice) {
            maxPrice = price;
            maxCombineId = combine[cSchema.combine_id];
          }
        }
      } catch (err) {
        _didIteratorError14 = true;
        _iteratorError14 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion14 && _iterator14.return) {
            _iterator14.return();
          }
        } finally {
          if (_didIteratorError14) {
            throw _iteratorError14;
          }
        }
      }

      this.combineId = maxCombineId;
      return maxPrice;
    },
    getSessionName: function getSessionName(type, storeId) {
      if (type === 'version') {
        return 'Nidin_' + storeId + '_menuVersion';
      } else if (type === 'menu') {
        return 'Nidin_' + storeId + '_menu';
      } else {
        return false;
      }
    },
    removeArray: function removeArray(arr, value) {
      var index = arr.indexOf(value);
      if (index > -1) {
        arr.splice(index, 1);
      }
    },
    checkPrice: function checkPrice(price, product, pIndex) {
      var pSchema = this.schema.product;

      var newPrice = this.currentProduct[pSchema.price];
      if (product) {
        this.addPrice[product[pSchema.product_id]] = price;
      }
      if (pIndex && product) {
        if (!this.addPrices[product[pSchema.product_id]]) this.addPrices[product[pSchema.product_id]] = {};
        this.addPrices[product[pSchema.product_id]][pIndex] = price;
      }
      for (var key in this.addPrice) {
        var num = 1;
        if (this.optionNumList[0][key]) num = this.optionNumList[0][key];
        if (this.adjustSame[key]) {
          newPrice = newPrice + this.addPrice[key] * num;
        }
      }
      for (var key2 in this.addPrices) {
        if (!this.adjustSame[key2]) {
          for (var pIndex2 in this.addPrices[key2]) {
            newPrice = newPrice + this.addPrices[key2][pIndex2] * 1;
          }
        }
      }
      this.price = newPrice;
    },
    checkAddProduct: function checkAddProduct(item) {
      if (item.items[0].product_id) {
        this.addDetail[item.items[0].product_id] = item;
      }
    },
    checkAddDifProduct: function checkAddDifProduct(item, pIndex) {
      if (item.items[0].product_id) {
        if (!this.addDetails[item.items[0].product_id]) this.addDetails[item.items[0].product_id] = {};
        if (pIndex) {
          this.addDetails[item.items[0].product_id][pIndex] = item;
        }
      }
    },
    init: function init() {
      if (this.menuJson !== undefined) {
        this.currentMenuJson = this.menuJson;

        this.menu.categoryList = this.currentMenuJson.category_list_json.data;
        this.menu.productList = this.currentMenuJson.product_list_json.data;
        this.menu.adjustList = this.currentMenuJson.adjust_list_json.data;
        this.menu.optionList = this.currentMenuJson.option_list_json.data;
        this.menu.combineList = this.currentMenuJson.combine_list_json.data;
        if (this.currentMenuJson.block_list_json) this.menu.blockList = this.currentMenuJson.block_list_json.data;

        this.schema.category = this.currentMenuJson.category_list_json.schema;
        this.schema.product = this.currentMenuJson.product_list_json.schema;
        this.schema.icon = this.currentMenuJson.product_list_json.icon_schema;
        this.schema.img = this.currentMenuJson.product_list_json.img_schema;
        this.schema.tag = this.currentMenuJson.product_list_json.tag_schema;
        this.schema.adjust = this.currentMenuJson.adjust_list_json.schema;
        this.schema.option = this.currentMenuJson.option_list_json.schema;
        this.schema.combine = this.currentMenuJson.combine_list_json.schema;
        this.schema.edge = this.currentMenuJson.combine_list_json.edge_schema;
        this.schema.common = this.currentMenuJson.combine_list_json.common_schema;
        if (this.currentMenuJson.block_list_json) this.schema.block = this.currentMenuJson.block_list_json.schema;
        this.productContainer = [];
      }
      this.initOptions();
    },
    clearOption: function clearOption() {
      var aSchema = this.schema.adjust;
      var pSchema = this.schema.product;

      this.limitList = {};
      var _iteratorNormalCompletion16 = true;
      var _didIteratorError16 = false;
      var _iteratorError16 = undefined;

      try {
        for (var _iterator16 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.adjusts), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
          var adjust = _step16.value;

          adjust.activeOptionIds = [];
          adjust.activeCount = 0;
          var _iteratorNormalCompletion17 = true;
          var _didIteratorError17 = false;
          var _iteratorError17 = undefined;

          try {
            for (var _iterator17 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(adjust[aSchema.option_list]), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
              var option = _step17.value;

              option.activeCount = 0;
            }
          } catch (err) {
            _didIteratorError17 = true;
            _iteratorError17 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion17 && _iterator17.return) {
                _iterator17.return();
              }
            } finally {
              if (_didIteratorError17) {
                throw _iteratorError17;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError16 = true;
        _iteratorError16 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion16 && _iterator16.return) {
            _iterator16.return();
          }
        } finally {
          if (_didIteratorError16) {
            throw _iteratorError16;
          }
        }
      }

      this.number = 1;

      this.price = this.currentProduct[pSchema.price];
      this.optionNum = {};
      this.optionNumList = [{}];
      this.choseCurProd = 0;
      this.show.cantOrder = false;
    },
    initOptions: function initOptions() {
      var pSchema = this.schema.product;
      var cSchema = this.schema.combine;

      this.price = this.currentProduct[pSchema.price];
      this.combineId = this.currentProduct[pSchema.combine_list][cSchema.combine_id];
      this.productCombineIds = this.currentProduct[this.schema.product.combine_list];

      this.adjustsIndexMapping = this.createMapping(this.adjusts, this.schema.adjust.product_id);
      this.optionsIndexMapping = this.createOptionMapping(this.adjusts);
      this.packageLayer = {
        show: true
      };
      this.productLayer = {
        show: false
      };
      this.productContainer = [];

      this.bActiveList = [];
      this.otherActiveList = [];

      this.pActiveList = [];

      this.errorMenu = false;

      this.choseCurProd = 0;

      this.addPrice = {};
      this.addPrices = {};
      this.addDetail = {};
      this.addDetails = {};
      this.addAdjust = {};

      this.optionCheck.id = 0;
      this.allProduct = {};
      this.clearOption();
      this.$nextTick(function () {});
    },
    checkAdjustDis: function checkAdjustDis(aId) {
      var dis = this.disAdjust.find(function (o) {
        return o === aId;
      });
      if (dis) {
        return false;
      } else return true;
    },
    checkOptionDis: function checkOptionDis(oId, aId) {
      if (this.disOption[aId]) {
        var dis = this.disOption[aId].find(function (o) {
          return o.product_id === oId;
        });
        if (dis) {
          return false;
        } else return true;
      } else {
        return true;
      }
    },
    getSubImages: function getSubImages(pId) {
      if (this.prodImgList[pId]) return this.prodImgList[pId].sub_image_list;
      return [];
    },
    checkDisableItem: function checkDisableItem(itemId, blockId) {
      if (typeof this.disItem !== 'undefined') {
        var pBDis = this.disItem[blockId];
        if (pBDis) {
          var pDis = this.disItem[blockId].find(function (o) {
            return o.product_id === itemId;
          });
          if (pDis) return false;
        }
        return true;
      }
      return true;
    },
    checkDisableBlock: function checkDisableBlock(blockId, packageId) {
      if (typeof this.disBlock !== 'undefined') {
        var bPDis = this.disBlock[packageId];
        if (bPDis) {
          var bDis = this.disBlock[packageId].find(function (o) {
            return o.product_id === blockId;
          });
          if (bDis) return false;
        }
        return true;
      }
      return true;
    },
    clickChangeOption: function clickChangeOption() {
      var prodId = this.pActiveList.find(function (o) {
        if (o.show) return o;
      }).id;
      this.clickProduct(this.getProduct(prodId));
    },
    checkDefault: function checkDefault() {
      var self = this;
      var bSchema = this.schema.block;
      var pSchema = this.schema.product;

      for (var i = 0; i < this.bActiveList.length; i++) {
        var blocks = this.bActiveList[i];
        if (this.up) {
          var obj = {};
          for (var o = 0; o < self.curOrderInfo.blocks.length; o++) {
            var bItem = self.curOrderInfo.blocks[o].items;
            for (var it = 0; it < bItem.length; it++) {
              var pId = bItem[it].product_id;
              var amount = bItem[it].amount;
              if (!obj[pId]) obj[pId] = true;else self.$set(self.adjustSame, pId, false);
              for (var am = 1; am <= amount; am++) {
                if (self.curOrderInfo.blocks[o].block_id === blocks.block.product[bSchema.product_id] && self.checkDisableItem(parseInt(pId, 10), blocks.block.product[bSchema.product_id]) && self.checkDisableBlock(blocks.block.product[bSchema.product_id], self.currentProduct[pSchema.product_id])) {
                  self.clickBlock(parseInt(pId, 10), blocks);
                }
              }
            }
          }
        } else {
          var aProd = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(blocks.prod);
          var prodBlock = blocks.sortList.map(function (e) {
            return aProd[e.index];
          });
          var bIsMandatory = blocks.block.product[bSchema.is_mandatory];
          for (var index = 0; index < prodBlock.length; index++) {
            var key = prodBlock[index].product[pSchema.product_id];
            this.$set(this.adjustSame, key, true);
            if (blocks.prod[key].product[pSchema.is_default] && self.checkDisableItem(parseInt(key, 10), blocks.block.product[pSchema.product_id]) && self.checkDisableBlock(blocks.block.product[pSchema.product_id], self.currentProduct[pSchema.product_id])) {
              self.clickBlock(parseInt(key, 10), blocks);
            } else if (blocks.prod[key].noChange && self.checkDisableItem(parseInt(key, 10), blocks.block.product[pSchema.product_id]) && self.checkDisableBlock(blocks.block.product[pSchema.product_id], self.currentProduct[pSchema.product_id])) {
              self.clickBlock(parseInt(key, 10), blocks);
            } else if (!blocks.default && bIsMandatory) {
              blocks.default = key;
            }
            if (index + 1 === prodBlock.length && !blocks.activeList.length && blocks.default) {
              self.clickBlock(parseInt(blocks.default, 10), blocks);
            }
          }
        }
      }
    },
    cheeseWording: function cheeseWording(pcName) {
      var name = pcName;
      if (name) name = name.trim();
      switch (name) {
        case '日式燒肉堡':
        case '雙層起司雞腿堡':
        case '法式紅酒牛肉堡':
        case '墨西哥辣椒豬肉堡':
        case '墨西哥辣椒牛肉堡':
        case '豬肉起司瑪芬堡':
        case '豬肉瑪芬堡加蛋':
        case '雙層豬肉瑪芬堡':
        case '雙層豬肉瑪芬堡加蛋':
        case '義式磚壓-薑汁燒肉':
        case '口袋歐姆蛋-起士歐姆蛋':
        case '口袋歐姆蛋-肉醬歐姆蛋':
        case '口袋歐姆蛋-培根歐姆蛋':
        case '口袋歐姆蛋-蔬菜歐姆蛋':
        case '口袋歐姆蛋-鮪魚歐姆蛋':
        case '磚壓-法式紅酒牛肉':
        case '磚壓-墨西哥辣椒豬肉':
        case '磚壓-墨西哥辣椒牛肉':
          return true;
        default:
          return false;
      }
    },
    clickBlock: function clickBlock(curId, pre) {
      this.choseCurProd = 0;
      var self = this;
      var curActive = false;
      var pSchema = this.schema.product;
      var bSchema = this.schema.block;
      var curP = this.getProduct(curId);

      if (!this.optionNumList[0][curId]) this.checkPrice(curP[pSchema.price], curP);else this.checkPrice();

      for (var i = 0; i < this.bActiveList.length; i++) {
        var b = this.bActiveList[i];
        var pId = b.prod[curId];
        if (b.prod[curId]) {
          var active = pId.active;

          var amount = 0;
          var bAmount = self.optionNum[pId.product[pSchema.product_id]];
          if (bAmount) amount = bAmount;
          var maxLimit = curP[pSchema.max_limit];

          var bMaxLimit = pre.block.product[bSchema.max_limit];
          if (maxLimit > bMaxLimit && bMaxLimit) maxLimit = bMaxLimit;else if (bMaxLimit && !maxLimit) maxLimit = bMaxLimit;

          amount++;
          this.setOptionNum(curId, amount, curP);
          bAmount = amount;

          if (bAmount > maxLimit && maxLimit) {
            if (!pId.noChange) {
              active = !active;

              if (!active) {
                amount = 0;
                delete self.addPrice[pId.product[pSchema.product_id]];
                delete self.addPrices[pId.product[pSchema.product_id]];
                this.setOptionNum(curId, amount, curP);
              }
            } else {
              amount = 1;
              this.setOptionNum(curId, amount, curP);
            }
          } else if (!active) {
            active = true;
          }

          if (pId.noChange || amount > 1) {
            self.removeString(pre.activeList, curId);
          }
          self.checkPrice();
          curActive = active;

          if (curActive) pre.block.pActive.push(curId);else pre.block.pActive = this.removeString(pre.block.pActive, curId);

          var prod = this.getProduct(curId);
          if (prod) {
            if (prod[pSchema.type] === 1) {
              this.pActiveList.find(function (o) {
                if (o.id === curId) {
                  if (curActive) {
                    o.show = true;
                    pre.activeList.push(o.id);
                  } else {
                    o.show = false;
                    self.optionCheck.id = curId;
                    self.optionCheck.num++;
                    self.removeString(pre.activeList, o.id);
                  }
                }
              });
            }
          }
          pId.active = active;
        }
      }
      this.allProduct[curId] = true;
      this.checkPackageLimit(pre, curP);
    },
    removeString: function removeString(arr, str) {
      var what, ax;
      var a = arguments;
      var L = a.length;
      while (L > 1 && arr.length) {
        what = a[--L];
        while ((ax = arr.indexOf(what)) !== -1) {
          arr.splice(ax, 1);
        }
      }
      return arr;
    },
    checkPackageLimit: function checkPackageLimit(pre, curP) {
      var self = this;
      var pSchema = this.schema.product;

      var removeIds = {};
      for (var i = 0; i < pre.activeList.length; i++) {
        if (i + 1 < pre.activeList.length) {
          var rKey = pre.activeList[i];
          if (!removeIds[rKey]) removeIds[rKey] = 1;else removeIds[rKey] = removeIds[rKey] + 1;
        }
      }

      var allActiveAmount = 0;
      for (var a = 0; a < pre.activeList.length; a++) {
        allActiveAmount = allActiveAmount + self.optionNum[pre.activeList[a]];
      }

      if (allActiveAmount > pre.block.product[this.schema.block.max_limit] && pre.block.product[this.schema.block.max_limit]) {
        this.pActiveList.find(function (o) {
          if (typeof removeIds[o.id] !== 'undefined') {
            if (o.id !== curP[pSchema.product_id]) {
              pre.prod[o.id].active = false;
              o.show = false;
              self.removeString(pre.activeList, o.id);
              delete self.addPrice[o.id];
              delete self.addPrices[o.id];
              self.setOptionNum(o.id, 0, curP);
              self.checkPrice();
            } else if (o.id !== curP[pSchema.product_id] && pre.activeList < removeIds[o.id] + 1) {
              pre.prod[o.id].active = false;
              o.show = false;
              self.removeString(pre.activeList, o.id);
              delete self.addPrice[o.id];
              delete self.addPrices[o.id];
              self.setOptionNum(o.id, 0, curP);
              self.checkPrice();
            }
          }
        });
      }
    },
    clickProduct: function clickProduct(prod) {
      var pSchema = this.schema.product;
      this.packageLayer.show = false;
      this.choseCurProd = prod[pSchema.product_id];
    },
    curProduct: function curProduct(prod) {
      var pSchema = this.schema.product;
      if (prod[pSchema.product_id] === this.choseCurProd) return true;
      return false;
    },
    setOptionNum: function setOptionNum(id, count, curP) {
      this.optionNum[id] = count;
      this.optionNumList = [this.optionNum];
    }
  },
  created: function created() {},

  computed: {
    isUpList: function isUpList() {
      var list = {};
      for (var i = 0; i < this.curOrderInfo.blocks.length; i++) {
        var items = this.curOrderInfo.blocks[i].items;
        for (var j = 0; j < items.length; j++) {
          if (!list[items[j].product_id]) list[items[j].product_id] = [];
          list[items[j].product_id].push(items[j]);
        }
      }
      return list;
    },
    getProductContainer: function getProductContainer() {
      this.clearOption();
      var pContainer = [];
      var pSchema = this.schema.product;
      var bSchema = this.schema.block;
      if (Array.isArray(this.currentProduct)) {
        var pList = this.currentProduct[pSchema.product_list];
        var bList = this.currentProduct[pSchema.block_list];
        if (pList) {
          for (var i = 0; i < pList.length; i++) {
            var prod = this.getProduct(pList[i]);
            if (prod) {
              if (prod[pSchema.type] === 1) {
                if (prod[pSchema.is_enable] && prod[pSchema.is_visible]) {
                  this.allProduct[pList[i]] = false;
                  this.$set(this.adjustSame, pList[i], true);
                  if (this.up) {
                    if (prod[pSchema.is_mandatory]) {
                      this.pActiveList.push({ id: prod[pSchema.product_id], active: false, show: true });
                      this.otherActiveList.push({ id: prod[pSchema.product_id], active: true, show: true, noChange: true });
                      this.allProduct[pList[i]] = true;
                    } else {
                      this.pActiveList.push({ id: prod[pSchema.product_id], active: false, show: false });
                      this.otherActiveList.push({ id: prod[pSchema.product_id], active: false, show: true, noChange: false });
                      this.allProduct[pList[i]] = true;
                    }
                    pContainer.push(prod);
                  } else {
                    if (prod[pSchema.is_mandatory]) {
                      this.pActiveList.push({ id: prod[pSchema.product_id], active: false, show: true });
                      this.otherActiveList.push({ id: prod[pSchema.product_id], active: true, show: true, noChange: true });
                      this.allProduct[pList[i]] = true;
                    } else {
                      this.pActiveList.push({ id: prod[pSchema.product_id], active: false, show: false });
                      this.otherActiveList.push({ id: prod[pSchema.product_id], active: false, show: true, noChange: false });
                      this.allProduct[pList[i]] = true;
                    }
                    pContainer.push(prod);
                  }
                }
              } else if (prod[pSchema.type] === 3) {
                this.errorMenu = true;
              }
              if (prod[pSchema.block_list].length) this.errorMenu = true;
            }
          }
        }
        if (bList) {
          var bActiveList = [];
          for (var j = 0; j < bList.length; j++) {
            var activeObj = {
              block: {
                pActive: [],
                product: this.getBlock(bList[j])
              },
              prod: {},
              activeList: [],
              sortList: []
            };

            var pIds = this.getBlock(bList[j])[bSchema.product_list];

            for (var k = 0; k < pIds.length; k++) {
              var bProd = this.getProduct(pIds[k]);
              if (bProd[pSchema.type] === 1) {
                if (this.getProduct(pIds[k])[pSchema.is_enable] && this.getProduct(pIds[k])[pSchema.is_visible]) {
                  if (this.up) {
                    if (pIds.length === 1 && this.getBlock(bList[j])[bSchema.is_mandatory] || bProd[pSchema.is_mandatory]) {
                      activeObj.prod[bProd[pSchema.product_id]] = { active: false, noChange: true, product: bProd };
                      if (this.checkDisableItem(bProd[pSchema.product_id], bList[j]) && this.checkDisableBlock(bList[j], this.currentProduct[pSchema.product_id])) {
                        this.pActiveList.push({ id: bProd[pSchema.product_id], active: false, show: false, disable: false });
                        this.allProduct[pIds[k]] = true;
                      } else {
                        this.pActiveList.push({ id: bProd[pSchema.product_id], active: false, show: false, disable: false });
                        this.allProduct[pIds[k]] = false;
                        this.show.cantOrder = true;
                      }
                    } else {
                      activeObj.prod[bProd[pSchema.product_id]] = { active: false, noChange: false, product: bProd };
                      this.pActiveList.push({ id: bProd[pSchema.product_id], active: false, show: false, disable: false });
                      this.allProduct[pIds[k]] = false;
                    }
                    this.$set(this.adjustSame, pIds[k], true);
                    pContainer.push(bProd);
                  } else {
                    if (pIds.length === 1 && this.getBlock(bList[j])[bSchema.is_mandatory] || bProd[pSchema.is_mandatory]) {
                      activeObj.prod[bProd[pSchema.product_id]] = { active: true, noChange: true, product: bProd };
                      if (this.checkDisableItem(bProd[pSchema.product_id], bList[j]) && this.checkDisableBlock(bList[j], this.currentProduct[pSchema.product_id])) {
                        this.pActiveList.push({ id: bProd[pSchema.product_id], active: true, show: true, disable: false });
                        activeObj.activeList.push(bProd[pSchema.product_id]);
                        this.allProduct[pIds[k]] = true;
                      } else {
                        this.pActiveList.push({ id: bProd[pSchema.product_id], active: false, show: false, disable: false });
                        this.allProduct[pIds[k]] = false;
                        this.show.cantOrder = true;
                      }
                    } else {
                      activeObj.prod[bProd[pSchema.product_id]] = { active: false, noChange: false, product: bProd };
                      this.pActiveList.push({ id: bProd[pSchema.product_id], active: false, show: false, disable: false });
                      this.allProduct[pIds[k]] = false;
                    }
                    this.$set(this.adjustSame, pIds[k], true);
                    pContainer.push(bProd);
                  }
                }
              } else if (bProd[pSchema.type] === 3) {
                this.errorMenu = true;
              }

              if (bProd[pSchema.block_list].length) this.errorMenu = true;

              if (k + 1 === pIds.length) {
                var aProd = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(activeObj.prod);
                var map = aProd.map(function (p, i) {
                  return { index: i, sort: p.product[pSchema.sort] };
                });
                map.sort(function (a, b) {
                  return a.sort - b.sort;
                });
                activeObj.sortList = map;
              }
            }
            bActiveList.push(activeObj);
            this.bActiveList = bActiveList;
          }
        }
      }
      this.$nextTick(function () {
        this.checkDefault();

        if (!this.packageLayer.show && !this.choseCurProd) {
          for (var i = 0; i < pContainer.length; i++) {
            var prod = pContainer[i];
            if (this.allProduct[prod[pSchema.product_id]]) {
              this.clickProduct(prod);
              break;
            }
          }
        }
      });
      return pContainer;
    },
    showLgImg: function showLgImg() {
      var layout = this.layout;
      switch (layout) {
        case 1:
          return false;
        case 2:
          return true;
        case 3:
          return true;
        case 4:
          return false;
        default:
          return false;
      }
    },
    storeStateName: function storeStateName() {
      var state = this.storeState;
      if (state === 0) return '門市未營業';else if (state === 1) return '門市籌備中';else if (state === 3) return '門市休息中';else if (state === 9) return '門市已歇業';
    },
    minCombinePrice: function minCombinePrice() {
      var oSchema = this.schema.option;
      var price = 0;

      for (var i in this.isOption.length) {
        price = price + this.isOption[i].option[oSchema.price];
      }
      return price;
    },
    combinePrice: function combinePrice() {
      var minPrice;
      var self = this;
      var priceCombine = [];
      var priceList = [];
      if (this.productCombineIds.length) {
        for (var i = 0; i < this.productCombineIds.length; i++) {
          var item;
          var price = this.getCombine(this.productCombineIds[i])[this.schema.combine.price];
          if (price === null) {
            var edgeList = this.getCombine(this.productCombineIds[i])[this.schema.combine.edge_list];
            for (var key in edgeList) {
              this.parsePrice(edgeList[key]);
              if (this.parsePrice(edgeList[key]).type === 'p') price = this.parsePrice(edgeList[key]).price;
            }

            item = { price: price + self.minCombinePrice, combine: this.getCombine(this.productCombineIds[i]) };
            priceCombine.push(item);
          } else {
            item = { price: price, combine: this.getCombine(this.productCombineIds[i]) };
            priceCombine.push(item);
          }
        }
      }

      for (var o in priceCombine) {
        priceList.push(priceCombine[o].price);
      }
      minPrice = Math.min.apply(Math, priceList);
      return minPrice;
    },
    isBigMilk: function isBigMilk() {
      var pSchema = this.schema.product;
      var product = this.currentProduct;
      var productName = product[pSchema.name];
      if (productName) {
        if (productName.trim() === '綠光純鮮奶家庭號') return true;
      }
      return false;
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.q-numeric input').attr('maxlength', '2');
    __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.q-numeric input').attr('type', 'tel');
    __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.q-numeric input').keyup(function () {
      var e = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.q-numeric input');
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    });
  },

  watch: {
    currentProduct: function currentProduct() {
      this.clearOption();
      this.init();
    },
    cartMount: function cartMount() {
      this.setCartAmount(this.cartMount);
    },
    number: function number() {
      if (!this.number) this.number = 1;
    }
  }
});

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MenuOptions_vue__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MenuOptions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MenuOptions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_parse_menu_js__ = __webpack_require__(63);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    menuJson: [Object, String],
    storeState: Number,
    modalView: Boolean,
    currentProduct: [Object, Array],
    brandId: Number,
    prodType: String,
    checkPrice: Function,
    checkAddProduct: Function,
    checkAddDifProduct: Function,
    optionCheck: Object,
    productAmount: Number,

    show: Object,
    productShow: [Boolean, Object],

    adjustSame: Object,
    isInit: Boolean,
    clickProduct: Function
  },
  data: function data() {
    return {
      adjusts: [],
      schema: {
        category: {},
        product: {},
        icon: {},
        image: {},
        tag: {},
        adjust: {},
        option: {},
        combine: {},
        edge: {},
        common: {},
        block: {}
      },
      tags: 0,
      currentMenuJson: '',
      storeId: this.$route.params.storeId,
      productCombineIds: [],
      menu: {
        categoryList: {},
        productList: {},
        adjustList: {},
        optionList: {},
        combineList: {}
      }
    };
  },

  methods: {
    getOption: function getOption(optionId) {
      return this.menu.optionList[optionId];
    },
    getAdjust: function getAdjust(adjustId) {
      return this.menu.adjustList[adjustId];
    },
    getSessionName: function getSessionName(type, storeId) {
      if (type === 'version') {
        return 'Nidin_' + storeId + '_menuVersion';
      } else if (type === 'menu') {
        return 'Nidin_' + storeId + '_menu';
      } else {
        return false;
      }
    },
    getCurOrderInfo: function getCurOrderInfo(index) {
      if (this.curOrderInfo) return this.curOrderInfo[index - 1];
    },
    clickAdd: function clickAdd() {
      var add = true;
      var pSchema = this.schema.product;
      for (var p = 1; p <= this.pAmountShow; p++) {
        if (!this.$refs['menu-options-' + this.currentProduct[pSchema.product_id] + '-index' + p][0].clickAdd()) {
          add = false;
          return add;
        }
      }
      return add;
    },
    init: function init() {
      if (this.menuJson !== undefined) {
        this.currentMenuJson = this.menuJson;
        this.menu.categoryList = this.currentMenuJson.category_list_json.data;
        this.menu.productList = this.currentMenuJson.product_list_json.data;
        this.menu.adjustList = this.currentMenuJson.adjust_list_json.data;
        this.menu.optionList = this.currentMenuJson.option_list_json.data;
        this.menu.combineList = this.currentMenuJson.combine_list_json.data;

        this.schema.category = this.currentMenuJson.category_list_json.schema;
        this.schema.product = this.currentMenuJson.product_list_json.schema;
        this.schema.icon = this.currentMenuJson.product_list_json.icon_schema;
        this.schema.img = this.currentMenuJson.product_list_json.img_schema;
        this.schema.tag = this.currentMenuJson.product_list_json.tag_schema;
        this.schema.adjust = this.currentMenuJson.adjust_list_json.schema;
        this.schema.option = this.currentMenuJson.option_list_json.schema;
        this.schema.combine = this.currentMenuJson.combine_list_json.schema;
        this.schema.edge = this.currentMenuJson.combine_list_json.edge_schema;
        this.schema.common = this.currentMenuJson.combine_list_json.common_schema;
        if (this.currentMenuJson.block_list_json) this.schema.block = this.currentMenuJson.block_list_json.schema;
      }
      this.initOptions();
    },
    initOptions: function initOptions() {
      this.productCombineIds = this.currentProduct[this.schema.product.combine_list];
      this.adjusts = this.showAll(this.currentProduct, this.productCombineIds);
    },
    showAll: function showAll(product, combines) {
      var pSchema = this.schema.product;
      var aSchema = this.schema.adjust;
      var oSchema = this.schema.option;

      var adjustIds = product[pSchema.adjust_list];
      var result = [];

      for (var adjustIndex = 0; adjustIndex < adjustIds.length; adjustIndex++) {
        var adjust = __WEBPACK_IMPORTED_MODULE_1__assets_js_parse_menu_js__["a" /* default */].divideList(adjustIds, this.getAdjust)[adjustIndex];
        if (adjust) {
          adjust.activeCount = 0;
          adjust.activeOptionIds = [];
          for (var optionIndex = 0; optionIndex < adjust[aSchema.option_list].length; optionIndex++) {
            if (typeof adjust[aSchema.option_list][optionIndex] === 'number') {
              adjust[aSchema.option_list][optionIndex] = this.getOption(adjust[aSchema.option_list][optionIndex]);
              adjust[aSchema.option_list][optionIndex].activeCount = 0;
            }
          }
          adjust[aSchema.option_list].sort(function (a, b) {
            if (a[oSchema.sort] > b[oSchema.sort]) {
              return 1;
            }
            if (a[oSchema.sort] < b[oSchema.sort]) {
              return -1;
            }

            return 0;
          });
          result.push(adjust);
        }
      }

      result.push([]);
      result.sort(function (a, b) {
        if (a[aSchema.sub_type] && b[aSchema.sub_type]) return b[aSchema.sub_type] - a[aSchema.sub_type];else return b[aSchema.sub_type] - a[aSchema.sub_type];
      });
      result.splice(-1, 1);
      return result;
    }
  },
  created: function created() {
    this.init();
  },

  computed: {
    pAmountShow: function pAmountShow() {
      if (this.aSameCheck) return 1;else if (this.adjusts.length) return this.productAmount;
      return 1;
    },
    aSameCheck: function aSameCheck() {
      var pSchema = this.schema.product;
      return this.adjustSame[this.currentProduct[pSchema.product_id]];
    }
  },
  components: {
    'menu-options': __WEBPACK_IMPORTED_MODULE_0__MenuOptions_vue___default.a
  },
  watch: {
    currentProduct: function currentProduct() {
      this.init();
    }
  }
});

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    modalId: {
      type: String,
      required: true
    },

    state: {
      type: Number
    },
    adjustId: {
      type: Number,
      required: true
    },
    adjustName: {
      type: String,
      required: true
    },
    adjustSubType: {
      type: Number
    },
    optionId: {
      type: Number
    }
  },
  data: function data() {
    return {
      editState: false,
      show: {
        delNotify: false
      },
      optionInfo: {
        sort: 1,
        name: '',
        option_custom_id: '',
        description: '',
        remark: '',
        price: 0,
        price_type: '3',
        calorie: '',
        sub_type: '0',
        is_mandatory: '0',
        min_limit: '0',
        max_limit: '1',
        is_common: '0'
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['setUpAdjust', 'setModal']), {
    init: function init() {
      if (typeof this.info !== 'undefined') {
        this.brandName = this.info.name;
        this.brandType = this.info.type;
      }
    },
    toggle: function toggle() {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.infoCategoryModal).css('display');
    },
    maxAmount: function maxAmount(max) {
      if (!max) return '無限制';else return max;
    },
    getOptionInfo: function getOptionInfo() {
      var self = this;
      var url = 'brand/' + this.$route.params.brand_id + '/option/' + this.optionId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.optionInfo = response.data.option;
        }
      });
    },
    getSubType: function getSubType(type) {
      if (type === 10) {
        return '大小(含未知大小)';
      } else if (type === 12) {
        return 'S';
      } else if (type === 14) {
        return 'M';
      } else if (type === 16) {
        return 'L';
      } else if (type === 18) {
        return 'XL';
      } else if (type === 20) {
        return '容器(含未知容器)';
      } else if (type === 30) {
        return '甜度(含未知甜度)';
      } else if (type === 41 || type === 42 || type === 43) {
        return '冰';
      } else if (type === 44 || type === 45 || type === 46) {
        return '溫';
      } else if (type === 47 || type === 48 || type === 49) {
        return '熱';
      } else {
        return '未定義';
      }
    },
    getPriceType: function getPriceType(type) {
      if (type === 1) return '免稅價格';else if (type === 3) return '含稅價格';
    },
    veritySort: function veritySort() {
      var e;
      if (this.state === 1) e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.sort1);else if (this.state === 3) e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.sort3);
      this.optionInfo.sort = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityMinLimit: function verityMinLimit() {
      var e;
      if (this.state === 1) e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.minLimit1);else if (this.state === 3) e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.minLimit3);
      this.optionInfo.min_limit = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityMaxLimit: function verityMaxLimit() {
      var e;
      if (this.state === 1) e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.maxLimit1);else if (this.state === 3) e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.maxLimit3);
      this.optionInfo.max_limit = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityPrice: function verityPrice() {
      var e;
      if (this.state === 1) e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.price1);else if (this.state === 3) e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.price3);
      this.optionInfo.price = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    verityCalorie: function verityCalorie() {
      var e;
      if (this.state === 1) e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.calorie1);else if (this.state === 3) e = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.calorie3);
      this.optionInfo.calorie = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    clearData: function clearData() {
      this.optionInfo = {
        sort: 1,
        name: '',
        option_custom_id: '',
        description: '',
        remark: '',
        price: 0,
        price_type: '3',
        calorie: '',
        sub_type: '0',
        is_mandatory: '0',
        min_limit: '0',
        max_limit: '1',
        is_common: '0'
      };
    },
    checkInputEmpty: function checkInputEmpty() {
      if (!this.optionInfo.sub_type && parseInt(this.optionInfo.sub_type, 10) !== 0) {
        this.$notify({
          title: '提醒',
          text: '請選擇分類',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!this.allInput.name) {
        this.$notify({
          title: '提醒',
          text: '請填寫調整類別名稱',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!this.allInput.sort) {
        this.$notify({
          title: '提醒',
          text: '請填寫排序',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!parseInt(this.allInput.sort, 10)) {
        this.$notify({
          title: '請填寫正確排序',
          text: '排序範圍為1~9999',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!this.allInput.min_limit) {
        this.$notify({
          title: '提醒',
          text: '請填寫最低購買數',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!this.allInput.max_limit) {
        this.$notify({
          title: '提醒',
          text: '請填寫最高購買數',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (!this.allInput.price) {
        this.$notify({
          title: '提醒',
          text: '請填寫價格',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.updateOption();
      }
    },
    updateOption: function updateOption() {
      var self = this;
      var url = 'brand/' + this.$route.params.brand_id + '/option';
      var data = {
        adjust_id: this.adjustId,
        name: this.allInput.name,
        sort: this.allInput.sort,
        min_limit: this.allInput.min_limit,
        max_limit: this.allInput.max_limit,
        price: this.allInput.price,
        price_type: this.optionInfo.price_type,
        sub_type: this.optionInfo.sub_type,
        is_mandatory: this.optionInfo.is_mandatory,
        is_common: this.optionInfo.is_common
      };
      if (this.optionId) data['option_id'] = this.optionId;
      if (this.allInput.calorie) data['calorie'] = this.allInput.calorie;
      if (this.allInput.vendor_custom_id) data['vendor_custom_id'] = this.allInput.vendor_custom_id;
      if (this.allInput.description) data['description'] = this.allInput.description;
      if (this.allInput.remark) data['remark'] = this.allInput.remark;
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '成功新增選項',
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.editState = false;
          var id = self.modalId;
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#' + id).modal('toggle');
          self.setUpAdjust(true);
        }
      });
    },
    delOption: function delOption() {
      var self = this;
      var url = 'brand/' + this.$route.params.brand_id + '/option?option_id=' + this.optionId;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '成功刪除選項',
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.editState = false;
          var id = self.modalId;
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#' + id).modal('toggle');
          self.setUpAdjust(true);
        }
      });
    }
  }),
  created: function created() {
    this.init();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getModal']), {
    modalState: function modalState() {
      if (this.state === 3 && !this.editState) return this.optionInfo.name;
      if (this.editState) return '編輯' + this.optionInfo.name;else return '新增選項';
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    allInput: function allInput() {
      return {
        name: this.checkInput(this.optionInfo.name),
        sort: this.checkInput(this.optionInfo.sort),
        vendor_custom_id: this.checkInput(this.optionInfo.option_custom_id),
        description: this.checkInput(this.optionInfo.description),
        remark: this.checkInput(this.optionInfo.remark),
        price: this.checkInput(this.optionInfo.price),
        calorie: this.checkInput(this.optionInfo.calorie),
        min_limit: this.checkInput(this.optionInfo.min_limit),
        max_limit: this.checkInput(this.optionInfo.max_limit)
      };
    },
    optionList: function optionList() {
      var options = [];
      if (this.adjustSubType === 0) {
        options = [{ label: '未定義', value: 0 }];
      } else if (this.adjustSubType === 10) {
        options = [{ label: '大小(含未知大小)', value: 10 }, { label: 'S', value: 12 }, { label: 'M', value: 14 }, { label: 'L', value: 16 }, { label: 'XL', value: 18 }, { label: '未定義', value: 0 }];
      } else if (this.adjustSubType === 20) {
        options = [{ label: '容器(含未知容器)', value: 20 }, { label: '未定義', value: 0 }];
      } else if (this.adjustSubType === 30) {
        options = [{ label: '甜度(含未知甜度)', value: 30 }, { label: '無糖', value: 31 }, { label: '微糖', value: 33 }, { label: '半糖', value: 35 }, { label: '少糖', value: 37 }, { label: '全糖', value: 39 }, { label: '未定義', value: 0 }];
      } else if (this.adjustSubType === 40) {
        options = [{ label: '溫度(含未知溫度)', value: 40 }, { label: '冰', value: 42 }, { label: '溫', value: 45 }, { label: '熱', value: 48 }, { label: '未定義', value: 0 }];
      }
      return options;
    }
  }),
  mounted: function mounted() {
    var self = this;
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.modal').on('hidden.bs.modal', function () {
      self.setModal(false);
      self.clearData();
    });
  },

  watch: {
    getModal: function getModal() {
      if (this.getModal) {
        this.$nextTick(function () {
          this.$set(this.optionInfo, 'is_mandatory', '0');
          this.$set(this.optionInfo, 'is_common', '0');
        });
        this.editState = false;
        this.show.delNotify = false;
        if (this.optionId && this.state !== 1) {
          this.getOptionInfo();
        }
      }
    }
  }
});

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    item: {
      type: [Object, String]
    },
    id: {
      type: Number
    }
  },
  data: function data() {
    return {
      priceArray: [],
      show: {
        check: false
      }
    };
  },

  methods: {
    verityPrice: function verityPrice() {
      var e = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$refs['price' + this.id]);
      if (isNaN(e.val())) {
        e.val(e.val().match(/[-]?[0-9]*/));
      }
      this.item.price = e.val();
    }
  }
});

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    imgList: Array,
    imgMeta: Object,
    tab: Number,
    getProductImageList: Function
  },
  components: {
    'm-modal': __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue___default.a
  },
  data: function data() {
    return {
      selectActive: 99,
      show: {
        brand: false,
        menu: false,
        schedule: false,
        history: false,
        menuDetail: false
      },
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      total: 0,
      count: 20,
      searchInput: '',
      delOption: {
        id: 'delModal',
        title: '刪除綁定',
        body: '刪除綁定，此處刪除等同刪除該項目所有關聯！<br>刪除時，若被上架中的菜單使用中，則會被阻擋',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delBind'
        }]
      },
      curId: 0
    };
  },

  methods: {
    clickGroup: function clickGroup(type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1;
        this.tableIndex = this.groupAmount * this.pageGroup;
        this.clickPage(this.tableIndex);
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1;
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1;
        this.clickPage(this.tableIndex);
      }
    },
    clickEnd: function clickEnd(type) {
      if (type === 'pre') {
        this.clickPage(1);
        this.pageGroup = 1;
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount);else this.clickPage(1);
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount);
      }
    },
    delModalOpen: function delModalOpen(img) {
      this.delOption.title = '刪除' + img.name + '綁定';
      this.curId = img.item_id;
    },
    trigger: function trigger(event) {
      if (event === 'delBind') {
        this.delBind();
      }
    },
    delBind: function delBind() {
      var self = this;
      var url = 'store/' + this.$route.params.store_id + '/itemBinding?item_id=' + this.curId + '&type=' + this.tab;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.curId = 0;
          self.getProductImageList();
        }
      });
    },
    upElement: function upElement(settingId) {
      var bId = this.$route.params.brand_id;
      var sId = this.$route.params.store_id;
      switch (this.tab) {
        case 99:
          this.$router.push('/upProductIcon/' + bId + '/' + sId + '/' + settingId);
          break;
      }
    },
    crElement: function crElement() {
      var bId = this.$route.params.brand_id;
      var sId = this.$route.params.store_id;
      switch (this.tab) {
        case 99:
          this.$router.push('/crProductIcon/' + bId + '/' + sId);
          break;
      }
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.getProductImageList(index);
    },
    getAdList: function getAdList() {
      var self = this;
      var data = {
        page: this.tableIndex,
        size: this.count
      };
      var url = '/store/' + this.$route.params.store_id + '/bannerList?list_sort=end_time DESC,sort ASC&page=' + data.page + '&size=' + data.size;
      if (parseInt(this.selectActive, 10) !== 99) url = url + '&is_active=' + this.selectActive;
      if (this.searchInput.trim()) url = url + '&name=' + this.searchInput;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.adList = response.data.list;
          self.total = response.data.list_total;
        }
      });
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    tabName: function tabName() {
      switch (this.tab) {
        case 2:
          return '配料';
        case 20:
          return '配料群組';
        case 10:
          return '商品分類';
        case 1:
          return '商品';
        case 11:
          return '品項選擇區';
        case 3:
          return '套餐';
      }
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  }),
  watch: {
    selectActive: function selectActive() {
      this.tableIndex = 1;
      this.searchInput = '';
    },
    tab: function tab() {
      this.tableIndex = 1;
    },
    imgMeta: function imgMeta() {
      this.total = this.imgMeta.total;
      this.count = this.imgMeta.size;
    }
  }
});

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_chooseStoreModal_vue__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_chooseStoreModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_elements_chooseStoreModal_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    imgList: Array,
    imgMeta: Object,
    tab: Number,
    getProductImageList: Function
  },
  components: {
    'm-modal': __WEBPACK_IMPORTED_MODULE_2__elements_Modal_vue___default.a,
    'choose-store-modal': __WEBPACK_IMPORTED_MODULE_3__components_elements_chooseStoreModal_vue___default.a
  },
  data: function data() {
    return {
      query: {},
      querySearch: {
        type: '',
        val: ''
      },
      prodImgList: [],
      selectActive: 99,
      searchType: 'name',
      searchInput: {
        name: '',
        id: ''
      },
      show: {
        brand: false,
        menu: false,
        schedule: false,
        history: false,
        menuDetail: false
      },
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      total: 0,
      count: 20,
      delOption: {
        id: 'delModal',
        title: '刪除綁定',
        body: '刪除綁定，此處刪除等同刪除該項目所有關聯！<br>刪除時，若被上架中的菜單使用中，則會被阻擋',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delBind'
        }]
      },
      storeOption: {
        id: 'copyModal'
      },
      curId: 0,
      checkBoxSelectAll: false
    };
  },

  methods: {
    selectAll: function selectAll() {
      var _this = this;

      this.imgList = this.imgList.map(function (x) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, x, {
          selectItem: _this.checkBoxSelectAll
        });
      });
    },
    deleteSelectItem: function deleteSelectItem() {
      var _this2 = this;

      if (!this.selectItems.length) return;
      var url = 'store/' + this.$route.params.store_id + '/productImageSetting/batchDelete?setting_ids=' + this.selectItems.toString();
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          _this2.getProductImageList();
        }
      });
    },
    setDeleteModal: function setDeleteModal() {
      this.delOption.btns[1].event = 'batchDelete';
    },
    search: function search() {
      this.querySearch.type = this.searchType;
      this.querySearch.val = this.searchInput[this.searchType];
      this.clickPage(1);
    },
    clickGroup: function clickGroup(type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1;
        this.tableIndex = this.groupAmount * this.pageGroup;
        this.clickPage(this.tableIndex);
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1;
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1;
        this.clickPage(this.tableIndex);
      }
    },
    clickEnd: function clickEnd(type) {
      if (type === 'pre') {
        this.clickPage(1);
        this.pageGroup = 1;
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount);else this.clickPage(1);
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount);
      }
    },
    delModalOpen: function delModalOpen(img) {
      this.delOption.title = '刪除' + img.name + '綁定';
      this.curId = img.item_id;
    },
    trigger: function trigger(event) {
      if (event === 'delBind') {
        this.delBind();
      } else if (event === 'batchDelete') {
        this.deleteSelectItem();
      }
    },
    clickCurrent: function clickCurrent(id) {
      this.delOption.btns[1].event = 'delBind';
      this.curId = id;
    },
    delBind: function delBind() {
      var self = this;
      var url = 'store/' + this.$route.params.store_id + '/productImageSetting/' + this.curId;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.curId = 0;
          self.getProductImageList();
        }
      });
    },
    upElement: function upElement(settingId) {
      var bId = this.$route.params.brand_id;
      var sId = this.$route.params.store_id;
      switch (this.tab) {
        case 1:
          this.$router.push({ path: '/upProductImg/' + bId + '/' + sId + '/' + settingId, query: this.query });
          break;
        case 3:
          this.$router.push({ path: '/upPackageImg/' + bId + '/' + sId + '/' + settingId, query: this.query });
          break;
        case 10:
          this.$router.push({ path: '/upCategoryImg/' + bId + '/' + sId + '/' + settingId, query: this.query });
          break;
      }
    },
    crElement: function crElement() {
      var bId = this.$route.params.brand_id;
      var sId = this.$route.params.store_id;
      console.log(this.query);
      switch (this.tab) {
        case 1:
          this.$router.push({ path: '/crProductImg/' + bId + '/' + sId, query: this.query });
          break;
        case 3:
          this.$router.push({ path: '/crPackageImg/' + bId + '/' + sId, query: this.query });
          break;
        case 10:
          this.$router.push({ path: '/crCategoryImg/' + bId + '/' + sId, query: this.query });
          break;
      }
    },
    isActive: function isActive(index) {
      if (Number(this.tableIndex) === index) return true;else return false;
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      var query = this.$route.query;
      if (query) {
        query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, query, {
          page: index
        });
      } else {
        query = {
          page: index
        };
      }
      this.$router.push({ query: query });
      this.getProductImageList(index, this.querySearch.type, this.querySearch.val);
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    },
    copyStore: function copyStore(storeList) {
      var _this3 = this;

      if (storeList.length) {
        var url = '/store/' + this.$route.params.store_id + '/productImageSetting/storeSync';
        var data = {
          store_id_list: storeList,
          setting_id_list: this.selectItems,
          type: this.tab
        };
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            _this3.$notify({
              title: '複製成功',
              duration: 3000,
              type: 'success',
              width: 400
            });

            _this3.imgList.forEach(function (element) {
              element.selectItem = false;
            });
          }
        });
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType', 'getStores']), {
    tabName: function tabName() {
      switch (this.tab) {
        case 2:
          return '配料';
        case 20:
          return '配料群組';
        case 10:
          return '商品分類';
        case 1:
          return '商品';
        case 11:
          return '品項選擇區';
        case 3:
          return '套餐';
      }
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    },
    selectItems: function selectItems() {
      return this.imgList.filter(function (x) {
        return x.selectItem;
      }).map(function (x) {
        return x.id;
      });
    }
  }),
  created: function created() {
    if (this.$route.query.brand_name && this.$route.query.store_name) {
      this.query = {
        brand_name: this.$route.query.brand_name,
        stroe_name: this.$route.query.store_name
      };
    }
    console.log(this.query);
  },

  watch: {
    selectActive: function selectActive() {
      this.tableIndex = 1;
      this.searchInput.name = '';
      this.searchInput.id = '';
    },
    tab: function tab() {
      this.searchInput.name = '';
      this.searchInput.id = '';
      this.querySearch.type = '';
      this.querySearch.val = '';
      var page = this.$route.query.page || 1;
      this.tableIndex = page;
      this.checkBoxSelectAll = false;
    },
    imgMeta: function imgMeta() {
      this.total = this.imgMeta.total;
      this.count = this.imgMeta.size;
    }
  },
  mounted: function mounted() {
    var page = this.$route.query.page || 1;
    this.tableIndex = page;
    this.prodImgList = this.imgList;
  }
});

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    settingList: Array,
    meta: Object,
    tab: Number,
    getProductSettingList: Function,
    type: String,
    searchText: String,
    tableIndex: Number
  },
  data: function data() {
    return {
      selectAllItem: false,
      vendorId: 'vendor_custom_id',
      show: {
        brand: false,
        menu: false,
        schedule: false,
        history: false,
        menuDetail: false
      },
      pageGroup: 1,
      groupAmount: 10,
      total: 0,
      count: 20
    };
  },

  methods: {
    selectAll: function selectAll() {
      var _this = this;

      var data = this.settingList.map(function (x) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, x, {
          selectItem: _this.selectAllItem
        });
      });
      this.$emit('update:setting-list', data);
    },
    checkEmptyBtnShow: function checkEmptyBtnShow(ary, type) {
      var description = ary.filter(function (x) {
        return x.type === 1;
      });
      var warning = ary.filter(function (x) {
        return x.type === 2;
      });
      if (type === 1 && warning.length === 0) {
        return false;
      } else if (type === 1 && description.length === 0) {
        return false;
      } else if (type === 2 && description.length === 0) {
        return false;
      } else if (type === 2 && warning.length === 0) {
        return false;
      }
      return true;
    },
    emptyDescrption: function emptyDescrption(ary, id) {
      var warningItems = ary.filter(function (x) {
        return x.type === 2;
      }).map(function (x) {
        return x.description;
      });
      var data = {
        vendor_custom_id: this.vendor_custom_id,
        is_enabled: this.is_enabled,
        item_list: [],
        warning_list: warningItems
      };
      this.upProductDescription(data, id);
    },
    emptyWarning: function emptyWarning(ary, id) {
      var descriptionItems = ary.filter(function (x) {
        return x.type === 1;
      }).map(function (x) {
        return x.description;
      });
      var data = {
        vendor_custom_id: this.vendor_custom_id,
        is_enabled: this.is_enabled,
        item_list: descriptionItems,
        warning_list: []
      };
      this.upProductDescription(data, id);
    },
    upProductDescription: function upProductDescription(data, id) {
      var _this2 = this;

      var url = 'store/' + this.$route.params.store_id + '/productDescriptionSetting/' + id;
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          _this2.$notify({
            title: '成功',
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          window.location.reload();
        }
      });
    },
    delElement: function delElement(settingId, type) {
      this.$emit('updateDel', settingId, type);
    },
    upElement: function upElement(settingId, type) {
      var bId = this.$route.params.brand_id;
      var sId = this.$route.params.store_id;
      var url = '';
      if (type === 'alias') url = 'upProductAlias';else if (type === 'description') url = 'upProductDescription';
      this.$router.push({ path: '/' + url + '/' + bId + '/' + sId + '/' + settingId, query: this.$route.query });
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    clickPage: function clickPage(index) {
      this.$emit('updatePagination', index);
    }
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  },
  watch: {
    tab: function tab() {
      this.$emit('update:tableIndex', 1);
      this.selectAllItem = false;
    },
    meta: function meta() {
      this.total = this.meta.total;
      this.count = this.meta.size;
    },
    settingList: function settingList(val) {
      var data = val.filter(function (x) {
        return x.selectItem;
      }).map(function (x) {
        return x.id;
      });
      this.$emit('selectItem', data);
    }
  }
});

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__extends_nd_extend_handle_menu_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__extends_nd_extend_handle_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__extends_nd_extend_handle_menu_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StoreMenuTable',
  data: function data() {
    return {
      name: '迷客夏',
      tableIndex: 1,
      groupAmount: 10,
      total: 1,
      count: 10,
      history: false,
      storeList: [],
      searchSelect: 1,
      searchInput: '',
      statusSelect: 99,
      trTypeSelect: 999,
      orderStatusSelect: 99,
      isSearchSelect: 99,
      searchQuery: {} };
  },

  extends: __WEBPACK_IMPORTED_MODULE_5__extends_nd_extend_handle_menu_vue___default.a,
  mounted: function mounted() {
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#example1').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      });
    });
    this.getExtendHandleMenuInfo();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['setStoreId', 'setStores']), {
    getDTypeInfo: function getDTypeInfo(dInfo, dIndex) {
      return dInfo.find(function (obj) {
        return obj.delivery_type === dIndex;
      });
    },
    isActive: function isActive(index) {
      if (Number(this.tableIndex) === index) return true;else return false;
    },
    getStoreList: function getStoreList() {
      var _this = this;

      var data = {
        page: this.tableIndex,
        size: this.count,
        searchSelect: parseInt(this.searchSelect, 10),
        inputVal: this.searchInput.trim()
      };
      var url = '/brand/' + this.$route.params.brand_id + '/storeList?size=' + data.size;
      var queryValue = {};
      if (data.searchSelect === 1 && data.inputVal) {
        if (this.$route.query.name !== data.inputVal) this.tableIndex = 1;
        queryValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, queryValue, { name: data.inputVal });
        url = url + '&name=' + data.inputVal;
      }
      if (parseInt(this.statusSelect, 10) !== 99) {
        if (this.$route.query.status !== this.statusSelect) this.tableIndex = 1;
        queryValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, queryValue, { status: this.statusSelect });
        url = url + '&status=' + this.statusSelect;
      }
      if (parseInt(this.orderStatusSelect, 10) !== 99) {
        if (this.$route.query.is_search !== this.isSearchSelect) this.tableIndex = 1;
        queryValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, queryValue, { order_status: this.orderStatusSelect });
        url = url + '&order_status=' + this.orderStatusSelect;
      }
      if (parseInt(this.trTypeSelect, 10) !== 999) {
        if (this.$route.query.is_search !== this.isSearchSelect) this.tableIndex = 1;
        queryValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, queryValue, { trade_type: this.trTypeSelect });
        url = url + '&trade_type=' + this.trTypeSelect;
      }
      if (parseInt(this.isSearchSelect, 10) !== 99) {
        if (this.$route.query.is_search !== this.isSearchSelect) this.tableIndex = 1;
        queryValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, queryValue, { is_search: this.isSearchSelect });
        url = url + '&is_search=' + this.isSearchSelect;
      }
      if (this.tableIndex) {
        queryValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, queryValue, { page: this.tableIndex });
        url = url + '&page=' + this.tableIndex;
      }
      this.searchQuery = queryValue;
      this.$router.replace({ query: queryValue });
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this.storeList = response.data.list;
          if (response.data.list.length) {
            _this.setStoreId(response.data.list[0].id);
            _this.setStores(response.data.list);
          }
          _this.total = response.data.list_total;
        }
      });
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.getStoreList();
    },
    searchStore: function searchStore() {
      this.tableIndex = 1;
      this.getStoreList();
    },
    copyStore: function copyStore(id) {
      var url = this.$route.path.replace('storeTable', 'copy') + '/' + id;
      this.$router.push({ path: url });
    }
  }),
  created: function created() {
    var path = this.$route.name;
    if (path === 'storeHistoryTable') this.history = true;
    if (this.$route.query.page) this.tableIndex = this.$route.query.page;
    if (this.$route.query.name) this.searchInput = this.$route.query.name;
    if (this.$route.query.status) this.statusSelect = this.$route.query.status;
    if (this.$route.query.order_status) this.orderStatusSelect = this.$route.query.order_status;
    if (this.$route.query.is_search) this.isSearchSelect = this.$route.query.is_search;
    if (this.$route.query.trade_type) this.trTypeSelect = this.$route.query.trade_type;
    this.getStoreList();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getRoleType', 'getPickupType', 'getStores', 'getBrands']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    },
    webDomain: function webDomain() {
      return this.$config.web;
    }
  }),
  watch: {
    statusSelect: function statusSelect() {
      this.searchStore();
    },
    orderStatusSelect: function orderStatusSelect() {
      this.searchStore();
    },
    isSearchSelect: function isSearchSelect() {
      this.searchStore();
    },
    trTypeSelect: function trTypeSelect() {
      this.searchStore();
    }
  }
});

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_CrCombinationTemp_vue__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_CrCombinationTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_CrCombinationTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  components: {
    'cr-combine': __WEBPACK_IMPORTED_MODULE_0__Temp_CrCombinationTemp_vue___default.a
  },
  methods: {},
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    }
  }
});

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_CrCombinationPriceTemp_vue__ = __webpack_require__(2217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_CrCombinationPriceTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_CrCombinationPriceTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  components: {
    'cr-combine-price': __WEBPACK_IMPORTED_MODULE_0__Temp_CrCombinationPriceTemp_vue___default.a
  },
  methods: {},
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    }
  }
});

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_CrJoinMenuTemp_vue__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_CrJoinMenuTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Temp_CrJoinMenuTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extends_nd_extend_handle_menu_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extends_nd_extend_handle_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__extends_nd_extend_handle_menu_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UpJoinMenu',
  extends: __WEBPACK_IMPORTED_MODULE_3__extends_nd_extend_handle_menu_vue___default.a,
  components: {
    'cr-join-menu': __WEBPACK_IMPORTED_MODULE_2__Temp_CrJoinMenuTemp_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    }
  }),
  mounted: function mounted() {
    this.getExtendHandleMenuInfo();
  }
});

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_MenuInfoFormTemp_vue__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_MenuInfoFormTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Temp_MenuInfoFormTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extends_nd_extend_handle_menu_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extends_nd_extend_handle_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__extends_nd_extend_handle_menu_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UpMenu',
  data: function data() {
    return {
      menuInfo: {
        info: true
      }
    };
  },

  extends: __WEBPACK_IMPORTED_MODULE_3__extends_nd_extend_handle_menu_vue___default.a,
  components: {
    'menu-info-form': __WEBPACK_IMPORTED_MODULE_2__Temp_MenuInfoFormTemp_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    }
  }),
  mounted: function mounted() {
    this.getExtendHandleMenuInfo();
  }
});

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_CrBlockTemp_vue__ = __webpack_require__(2215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_CrBlockTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_CrBlockTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extends_nd_extend_handle_menu_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extends_nd_extend_handle_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__extends_nd_extend_handle_menu_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UpMenuBlock',

  components: {
    CrBlock: __WEBPACK_IMPORTED_MODULE_0__Temp_CrBlockTemp_vue___default.a
  },

  extends: __WEBPACK_IMPORTED_MODULE_1__extends_nd_extend_handle_menu_vue___default.a,

  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    }
  },

  mounted: function mounted() {
    this.getExtendHandleMenuInfo();
  }
});

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_CrCategoryTemp_vue__ = __webpack_require__(2216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_CrCategoryTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_CrCategoryTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extends_nd_extend_handle_menu_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extends_nd_extend_handle_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__extends_nd_extend_handle_menu_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UpMenuCategory',
  components: {
    'cr-category': __WEBPACK_IMPORTED_MODULE_0__Temp_CrCategoryTemp_vue___default.a
  },
  extends: __WEBPACK_IMPORTED_MODULE_1__extends_nd_extend_handle_menu_vue___default.a,
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    }
  },
  mounted: function mounted() {
    this.getExtendHandleMenuInfo();
  }
});

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_CrPackageTemp_vue__ = __webpack_require__(2218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_CrPackageTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_CrPackageTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extends_nd_extend_handle_menu_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extends_nd_extend_handle_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__extends_nd_extend_handle_menu_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UpMenuPackage',
  extends: __WEBPACK_IMPORTED_MODULE_1__extends_nd_extend_handle_menu_vue___default.a,
  components: {
    'cr-package': __WEBPACK_IMPORTED_MODULE_0__Temp_CrPackageTemp_vue___default.a
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    }
  },
  mounted: function mounted() {
    this.getExtendHandleMenuInfo();
  }
});

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_CrProductTemp_vue__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_CrProductTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_CrProductTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extends_nd_extend_handle_menu_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extends_nd_extend_handle_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__extends_nd_extend_handle_menu_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UpMenuProduct',
  extends: __WEBPACK_IMPORTED_MODULE_1__extends_nd_extend_handle_menu_vue___default.a,
  components: {
    'cr-product': __WEBPACK_IMPORTED_MODULE_0__Temp_CrProductTemp_vue___default.a
  },
  methods: {},
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    }
  },
  mounted: function mounted() {
    this.getExtendHandleMenuInfo();
  }
});

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_BindingTable_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_BindingTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Temp_BindingTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extends_nd_extend_handle_menu_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extends_nd_extend_handle_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__extends_nd_extend_handle_menu_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'nd-binding-pos',
  extends: __WEBPACK_IMPORTED_MODULE_3__extends_nd_extend_handle_menu_vue___default.a,
  components: {
    'nd-binding-table': __WEBPACK_IMPORTED_MODULE_2__Temp_BindingTable_vue___default.a
  },
  data: function data() {
    return {
      storeName: '',
      name: '迷客夏',
      total: 1,
      count: 20,
      groupAmount: 10,
      scheduleList: [],

      tab: 2,
      bindList: [],
      bindMeta: {
        total: 0,
        size: 20
      },
      page: 1,
      selectAll: false,
      isDeleteStatus: false,
      skey: '',
      input: '',
      sPage: 1
    };
  },

  methods: {
    getBindingList: function getBindingList(page, searchKey, searchInput) {
      var _this = this;

      this.selectAll = false;
      this.isDeleteStatus = false;
      var queryValue = {};

      if (page) {
        this.page = page;
        queryValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, queryValue, {
          page: this.page
        });
      }

      var url = this.base + this.id + '/itemBinding/list?size=' + this.count + '&type=' + this.tab + '&page=' + this.page;

      queryValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, queryValue, {
        tab: this.tab
      });

      if (searchInput) {
        queryValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, queryValue, {
          searchKey: searchKey,
          searchInput: searchInput
        });
        url += '&' + searchKey + '=' + searchInput;
      }

      this.$router.replace({
        query: queryValue
      });

      this.getDataH('get', url, null, function (response) {
        _this.bindList = response.data.list;
        _this.bindMeta = response.data.meta;
      });
    },
    updateQuery: function updateQuery(tab) {
      this.$router.push({
        query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$route.query, {
          tab: tab
        })
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType', 'getStoreId']), {
    scheduleListNew: function scheduleListNew() {
      var menuList = {};
      var oldList = this.menu_schedule_list;
      for (var key in oldList) {
        menuList[oldList[key].menu_id] = {
          menu_id: oldList[key].menu_id,
          storeList: []
        };
      }
      for (var k in oldList) {
        menuList[oldList[k].menu_id].storeList.push({
          store_id: oldList[k].store_id,
          store_name: oldList[k].store_name,
          start_time: oldList[k].start_time,
          end_time: oldList[k].end_time,
          status: oldList[k].status,
          update_time: oldList[k].update_time,
          create_time: oldList[k].create_time,
          schedule_id: oldList[k].schedule_id,
          menu_id: oldList[key].menu_id
        });
      }
      return menuList;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  }),
  watch: {
    tab: function tab() {
      var sKey = this.$route.query.searchKey;
      var sInput = this.$route.query.searchInput;
      var sPage = this.$route.query.page;
      if (sKey && sInput) {
        this.skey = sKey;
        this.input = sInput;
        this.getBindingList(sPage, sKey, sInput);
      } else {
        this.getBindingList(1);
      }
    },
    '$route.query.tab': function $routeQueryTab() {
      var defaultTab = this.$route.query.tab;
      if (defaultTab) this.tab = parseInt(defaultTab, 10);
    }
  },
  created: function created() {
    var defaultTab = this.$route.query.tab;
    var sKey = this.$route.query.searchKey;
    var sInput = this.$route.query.searchInput;
    var sPage = this.$route.query.page;
    if (defaultTab) this.tab = parseInt(defaultTab, 10);

    if (sKey && sInput) {
      this.skey = sKey;
      this.input = sInput;
      if (sPage) {
        this.sPage = sPage;
        this.getBindingList(sPage, sKey, sInput);
      } else {
        this.getBindingList(1, sKey, sInput);
      }
    } else {
      this.getBindingList(1);
    }
  },
  mounted: function mounted() {
    this.getExtendHandleMenuInfo();
  }
});

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__extends_nd_extend_handle_menu_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__extends_nd_extend_handle_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__extends_nd_extend_handle_menu_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MenuBuild',
  data: function data() {
    return {
      name: '迷客夏',
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      count: 20,
      menuList: [],
      maxTotal: 0
    };
  },

  extends: __WEBPACK_IMPORTED_MODULE_4__extends_nd_extend_handle_menu_vue___default.a,
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.maxTotal / this.count);
    },
    goStepViewInfo: function goStepViewInfo() {
      var name = '';
      var params = {};
      var query = {};
      var title = '';
      if (this.isStore && this.getRoleType !== 10) {
        switch (this.$route.name) {
          case 'StoreMenuBuild':
            name = 'StoreMenuStep';
            params.brand_id = this.$route.params.brand_id;
            params.store_id = this.$route.params.store_id;
            title = '配料庫';
            break;
          default:
            console.log('default');
            break;
        }
      } else {
        name = 'brandMenu';
        params.brand_id = this.$route.params.brand_id;
        title = '配料庫';
      }
      return {
        name: name,
        params: params,
        query: query,
        title: title
      };
    }
  }),
  created: function created() {
    this.getMenuList();
  },
  mounted: function mounted() {
    this.getExtendHandleMenuInfo();
  },

  methods: {
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    getMenuList: function getMenuList(index) {
      var _this = this;

      if (index) this.tableIndex = index;
      var url = this.base + this.id + '/menu/list?size=' + this.count + '&page=' + this.tableIndex;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this.maxTotal = response.data.meta.total;
          _this.menuList = response.data.menu_list;
        }
      });
    },
    goToCrSchedule: function goToCrSchedule(menu) {
      console.log('goToCrSchedule');
      var name = '';
      var params = {
        brand_id: this.$route.params.brand_id,
        menu_id: menu.menu_id,
        store_id: ''
      };
      var query = {
        menu_name: menu.name
      };

      if (this.isStore && this.getRoleType !== 10) {
        name = 'StoreMenuScheduleCreate';
        params.store_id = this.$route.params.store_id;
      } else {
        name = 'crSchedule';
      }

      this.$router.push({ name: name, params: params, query: query });
    },
    goToCrMenu: function goToCrMenu() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$menu = _ref.menu,
          menu = _ref$menu === undefined ? {} : _ref$menu,
          _ref$type = _ref.type,
          type = _ref$type === undefined ? 0 : _ref$type;

      var test = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      console.log('goToCrMenu');
      var name = '';
      var params = {
        brand_id: this.$route.params.brand_id,
        store_id: ''
      };

      var query = {};
      if (type === 1) {
        query.copy_menu_id = menu.menu_id;
      }

      if (this.isStore && this.getRoleType !== 10) {
        name = 'StoreMenuBuildCreate';
        params.store_id = this.$route.params.store_id;
      } else {
        name = 'crMenu';
      }

      this.$router.push({ name: name, params: params, query: query });
    },
    goToMenuInfo: function goToMenuInfo() {
      var menuId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      console.log('goToMenuInfo');
      var name = '';
      var params = {
        brand_id: this.$route.params.brand_id,
        menu_id: menuId,
        store_id: ''
      };

      if (this.isStore && this.getRoleType !== 10) {
        name = 'StoreMenuInfo';
        params.store_id = this.$route.params.store_id;
      } else {
        name = 'menuInfo';
      }

      this.$router.push({ name: name, params: params });
    },
    goToUpMenu: function goToUpMenu() {
      var menuId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      console.log('goToUpMenu');
      var name = '';
      var params = {
        brand_id: this.$route.params.brand_id,
        menu_id: menuId,
        store_id: ''
      };

      if (this.isStore && this.getRoleType !== 10) {
        name = 'StoreMenuEdite';
        params.store_id = this.$route.params.store_id;
      } else {
        name = 'upMenu';
      }

      this.$router.push({ name: name, params: params });
    },
    menuUnlock: function menuUnlock(menuId) {
      var _this2 = this;

      var url = this.base + this.id + '/menu/' + menuId + '/unlock';
      this.getDataH('put', url, null, function (response) {
        if (response.data.status === 200) {
          _this2.$notify({
            title: '訊息',
            text: '成功解除菜單鎖定',
            duration: 3000,
            type: 'success',
            width: 400
          });
          _this2.getMenuList();
        }
      });
    },
    menuLock: function menuLock(menuId) {
      var _this3 = this;

      var url = this.base + this.id + '/menu/' + menuId + '/lock';
      this.getDataH('put', url, null, function (response) {
        if (response.data.status === 200) {
          _this3.$notify({
            title: '訊息',
            text: '成功鎖定菜單',
            duration: 3000,
            type: 'success',
            width: 400
          });
          _this3.getMenuList();
        }
      });
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    }
  }
});

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__extends_nd_extend_handle_menu_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__extends_nd_extend_handle_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__extends_nd_extend_handle_menu_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MenuStep',
  data: function data() {
    return {
      goToMap: [{
        name: 'BindingPos',
        type: 1
      }, {
        name: 'brandMenuTable',
        type: 1
      }, {
        name: 'StoreMenuBindingPos',
        type: 2
      }, {
        name: 'StoreMenuBuild',
        type: 2
      }, {
        name: 'StoreMenuOption',
        type: 2
      }, {
        name: 'upOption',
        type: 1
      }]
    };
  },

  extends: __WEBPACK_IMPORTED_MODULE_2__extends_nd_extend_handle_menu_vue___default.a,
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    goToAdjust: function goToAdjust() {
      var to = {
        name: '',
        params: {},
        query: {}
      };
      if (this.isStore && this.getRoleType === 99) {
        to.name = 'StoreMenuAdjust';
        to.params.brand_id = this.$route.params.brand_id;
        to.params.store_id = this.$route.params.store_id;
      } else {
        to.name = 'upAdjust';
        to.params.brand_id = this.$route.params.brand_id;
      }
      return to;
    },
    goToBindingPos: function goToBindingPos() {
      var to = {
        name: '',
        params: {},
        query: {}
      };
      if (this.isStore && this.getRoleType === 99) {
        to.name = 'StoreMenuBindingPos';
        to.params.brand_id = this.$route.params.brand_id;
        to.params.store_id = this.$route.params.store_id;
      } else {
        to.name = 'BindingPos';
        to.params.brand_id = this.$route.params.brand_id;
      }
      return to;
    },
    goToBlock: function goToBlock() {
      var to = {
        name: '',
        params: {},
        query: {}
      };
      if (this.isStore && this.getRoleType === 99) {
        to.name = 'StoreMenuBlock';
        to.params.brand_id = this.$route.params.brand_id;
        to.params.store_id = this.$route.params.store_id;
      } else {
        to.name = 'upBlock';
        to.params.brand_id = this.$route.params.brand_id;
      }
      return to;
    },
    goToBuild: function goToBuild() {
      var to = {
        name: '',
        params: {},
        query: {}
      };
      if (this.isStore && this.getRoleType === 99) {
        to.name = 'StoreMenuBuild';
        to.params.brand_id = this.$route.params.brand_id;
        to.params.store_id = this.$route.params.store_id;
      } else {
        to.name = 'brandMenuTable';
        to.params.brand_id = this.$route.params.brand_id;
      }
      return to;
    },
    goToCategory: function goToCategory() {
      var to = {
        name: '',
        params: {},
        query: {}
      };
      if (this.isStore && this.getRoleType === 99) {
        to.name = 'StoreMenuCategory';
        to.params.brand_id = this.$route.params.brand_id;
        to.params.store_id = this.$route.params.store_id;
      } else {
        to.name = 'upCategory';
        to.params.brand_id = this.$route.params.brand_id;
      }
      return to;
    },
    goToOption: function goToOption() {
      var to = {
        name: '',
        params: {},
        query: {}
      };
      if (this.isStore && this.getRoleType === 99) {
        to.name = 'StoreMenuOption';
        to.params.brand_id = this.$route.params.brand_id;
        to.params.store_id = this.$route.params.store_id;
      } else {
        to.name = 'upOption';
        to.params.brand_id = this.$route.params.brand_id;
      }
      return to;
    },
    goToPackage: function goToPackage() {
      var to = {
        name: '',
        params: {},
        query: {}
      };
      if (this.isStore && this.getRoleType === 99) {
        to.name = 'StoreMenuPackage';
        to.params.brand_id = this.$route.params.brand_id;
        to.params.store_id = this.$route.params.store_id;
      } else {
        to.name = 'upPackage';
        to.params.brand_id = this.$route.params.brand_id;
      }
      return to;
    },
    goToProduct: function goToProduct() {
      var to = {
        name: '',
        params: {},
        query: {}
      };
      if (this.isStore && this.getRoleType === 99) {
        to.name = 'StoreMenuProduct';
        to.params.brand_id = this.$route.params.brand_id;
        to.params.store_id = this.$route.params.store_id;
      } else {
        to.name = 'upProduct';
        to.params.brand_id = this.$route.params.brand_id;
      }
      return to;
    }
  }),
  mounted: function mounted() {
    this.getExtendHandleMenuInfo();
  }
});

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__(2058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_elements_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__extends_nd_extend_handle_menu_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__extends_nd_extend_handle_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__extends_nd_extend_handle_menu_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StoreMenu',
  components: {
    'nd-modal': __WEBPACK_IMPORTED_MODULE_3__components_elements_Modal___default.a
  },
  data: function data() {
    return {
      paginate: {
        count: 10,
        pageGroup: 1,
        tableIndex: 1,
        total: 1
      },
      list: [],
      searchKeyword: ''
    };
  },

  extends: __WEBPACK_IMPORTED_MODULE_4__extends_nd_extend_handle_menu_vue___default.a,
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.paginate.total / this.paginate.count);
    },
    webDomain: function webDomain() {
      return this.$config.web;
    }
  }),
  mounted: function mounted() {
    this.setPaginate();
    this.getList();
    this.getExtendHandleMenuInfo();
  },

  methods: {
    isActive: function isActive(index) {
      return Number(this.paginate.tableIndex) === index;
    },
    clickPage: function clickPage(index) {
      this.paginate.tableIndex = index;
      this.getList();
    },
    getList: function getList() {
      var _this = this;

      var brandId = this.$route.params.brand_id;
      var data = {
        allow_copy_menu: 0,
        page: this.paginate.tableIndex,
        size: this.paginate.count,
        name: this.searchKeyword
      };
      var url = 'brand/' + brandId + '/storeList?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(data);

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$route.query, {
          page: this.paginate.tableIndex,
          size: this.paginate.count
        })
      });
      this.getDataH('get', url, null, function (res) {
        if (res.data.status === 200) {
          _this.list = res.data.list;
          _this.paginate.total = res.data.list_total;
        }
      });
    },
    setPaginate: function setPaginate() {
      if (this.$route.query.page) {
        this.paginate.tableIndex = Number(this.$route.query.page);
      }
      if (this.$route.query.size) {
        this.paginate.count = Number(this.$route.query.size);
      }
      this.$refs.brandPaginate.pageGroup = this.paginate.pageGroup;
      this.$refs.brandPaginate.tableIndex = this.paginate.tableIndex;
    }
  }
});

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_CrAdjustTemp_vue__ = __webpack_require__(2214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_CrAdjustTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_CrAdjustTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extends_nd_extend_handle_menu__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extends_nd_extend_handle_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__extends_nd_extend_handle_menu__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'up-menu-adjust',
  components: {
    'cr-adjust': __WEBPACK_IMPORTED_MODULE_0__Temp_CrAdjustTemp_vue___default.a
  },
  extends: __WEBPACK_IMPORTED_MODULE_1__extends_nd_extend_handle_menu___default.a,
  methods: {},
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    }
  },
  mounted: function mounted() {
    this.getExtendHandleMenuInfo();
  }
});

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_CrOptionTemp_vue__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_CrOptionTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_CrOptionTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extends_nd_extend_handle_menu__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extends_nd_extend_handle_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__extends_nd_extend_handle_menu__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'up-menu-option',
  components: {
    'cr-option': __WEBPACK_IMPORTED_MODULE_0__Temp_CrOptionTemp_vue___default.a
  },
  extends: __WEBPACK_IMPORTED_MODULE_1__extends_nd_extend_handle_menu___default.a,
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    }
  },
  mounted: function mounted() {
    this.getExtendHandleMenuInfo();
  }
});

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_shared_token_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_BlackListTableTemp_vue__ = __webpack_require__(2235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_BlackListTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Temp_BlackListTableTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  components: {
    'order-table': __WEBPACK_IMPORTED_MODULE_2__Temp_BlackListTableTemp_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  }),
  methods: {
    goto: function goto() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_shared_token_js__["c" /* setSharedToken */])(window.localStorage.getItem(this.$config.token));
      window.location.href = this.$config.bdms + 'order-manage/black-list';
    }
  }
});

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_shared_token_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Temp_OrderTableTemp_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Temp_OrderTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Temp_OrderTableTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Temp_OrderExceptionTableTemp_vue__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Temp_OrderExceptionTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Temp_OrderExceptionTableTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      tableIndex: 1
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#example1').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      });
    });
  },

  methods: {
    payType: function payType(type) {
      if (type === 10) {
        return '線上支付';
      } else if (type === 50) {
        return '店家支付';
      }
    },
    payStateName: function payStateName(state) {
      if (state === 11) {
        return '尚未付款';
      } else if (state === 12) {
        return '付款處理中';
      } else if (state === 13) {
        return '已收款';
      } else if (state === 21) {
        return '退款處理中';
      } else if (state === 22) {
        return '已退款';
      }
    },
    orderState: function orderState(state) {
      if (state === 0) {
        return '訂單尚未確認';
      } else if (state === 1) {
        return '訂單已送出，尚未付款';
      } else if (state === 2) {
        return '付款中';
      } else if (state === 3) {
        return '訂單已付款，尚未通知店家';
      } else if (state === 99) {
        return '使用者取消訂單';
      } else if (state === 100) {
        return '未接單';
      } else if (state === 110) {
        return '已接單';
      } else if (state === 120) {
        return '被店家退訂';
      } else if (state === 121) {
        return '被系統退訂';
      } else if (state === 122) {
        return '已取消';
      } else if (state === 130) {
        return '已完成';
      } else if (state === 140) {
        return '已作廢';
      }
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    goto: function goto() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__assets_js_shared_token_js__["c" /* setSharedToken */])(window.localStorage.getItem(this.$config.token));
      window.location.href = this.$config.bdms + 'order-manage/exception';
    }
  },
  components: {
    'order-table': __WEBPACK_IMPORTED_MODULE_5__Temp_OrderTableTemp_vue___default.a,
    'order-exception-table': __WEBPACK_IMPORTED_MODULE_6__Temp_OrderExceptionTableTemp_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  })
});

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__elements_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_jquery__);














/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'm-modal': __WEBPACK_IMPORTED_MODULE_9__elements_Modal_vue___default.a
  },
  data: function data() {
    return {
      shippingCaseList: [],
      memberCardDiscount: null,
      isOfflineOrder: false,
      tradeInfo: {},
      roleType: 0,
      bindingShipping: null,
      driverTimeDialog: null,
      ratingList: [],
      ratingInfo: {},
      orderList: {
        notify_history: [],
        allowance: [],
        coupon_list: [],
        voucher_list: [],
        discount: {},
        point: {
          payment: {
            total_money: 0
          }
        },
        membership_discount: {
          total_discount: 0
        }
      },
      info: {
        allowance: [],
        coupon_list: [],
        voucher_list: []
      },
      productList: [],
      couponList: [],
      getCouponList: [],
      voucherList: [],
      getVoucherList: [],
      getPointList: [],
      productCouponList: [],
      productCouponMap: {},
      productVoucherList: [],
      productVoucherMap: {},
      selectBlackReason: '',
      bSelectOptions: {
        name: '黑名單原因',
        options: []
      },
      blackOption: {
        id: 'blackModal',
        title: '標註黑名單',
        body: '確定標注使用者為黑名單？',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'markBlack'
        }]
      },
      resendOrderNotifyOption: {
        id: 'resendOrderNotifyModal',
        title: '重新發送通知給店家',
        body: '1. 使用者已完成付款，尚未通知店家<br>2. 已通知店家，店家尚未處理<br><br><small>如果狀態為「已付款尚未通知」則會更改訂單狀態為「已通知店家」</small>',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'resendOrderNotify'
        }]
      },
      refundOrderOption: {
        id: 'refundOrderModal',
        title: '訂單退款',
        body: '1. 使用者付款中<br>2. 使用者已完成付款，尚未通知店家<br><br><small>將目前還在使用者身上的訂單退款並回復成購物車狀態</small>',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'refundOrder'
        }]
      },
      cancelShopperOrderOption: {
        id: 'cancelShopperOrderModal',
        title: '重新發送通知給店家',
        body: '1. 使用者已送出訂單，尚未付款<br>2. 使用者付款中<br>3. 使用者已完成付款，尚未通知店家<br><br><small>後該訂單會被退款，並轉換至「系統已取消」狀態，使用者無法再更新訂單</small>',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'cancelShopperOrder'
        }]
      },
      cancelPosOrderOption: {
        id: 'cancelPosOrderModal',
        title: '重新發送通知給店家',
        body: '1. 已通知店家，店家尚未處理<br>2. 店家已接受訂單<br>3. 店家已拒絕訂單<br>4. 店家已取消訂單<br>5. 店家已完成訂單<br>6. 店家已作廢訂單<br><br><small>該訂單會被退款，並轉換至「系統已取消」狀態，使用者與店家皆無法再更新訂單</small>',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'cancelPosOrder'
        }]
      },
      forceRefundOption: {
        id: 'forceRefundModal',
        title: '訂單強制退款',
        body: '<span class="text-danger">(危險) 此功能為訂單強制退款，不修改相關狀態！</span><br><br>',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'forceRefundOrder'
        }]
      },
      editOrderStateOption: {
        id: 'editOrderStateModal',
        title: '修改訂單狀態',
        body: '<span class="text-danger">(危險) 此功能為強制修改訂單狀態！</span><br><br>',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'editOrderState'
        }],
        input: {
          name: '備註'
        }
      },
      selectOptions: {
        name: '訂單狀態',
        options: [{ text: '請選擇', value: null }, { text: '已被接受', value: 110 }, { text: '已被店家拒絕', value: 120 }, { text: '已取消', value: 122 }, { text: '已完成', value: 130 }, { text: '已作廢', value: 140 }]
      },
      order: {
        newState: null,
        remark: ''
      },
      showCouponVoucherModal: false,
      showCouponModal: false,
      showVoucherModal: false,
      showProductModal: false,
      getMembershipScore: [],
      combineCouponList: [],
      combineVoucherList: []

    };
  },

  filters: {
    discountText: function discountText(discount, isMember) {
      var text = isMember ? '會員卡折扣' : '';

      if (!discount || !discount.discount_value) return text;
      text += ' | ';

      if (discount.membership_name) text += discount.membership_name;

      var price = discount.discount_value;
      var percent = Math.round((100 - price) / 100 * 10);

      switch (discount.discount_type) {
        case 1:
          text += '\u4EAB\u5168\u55AE\u6298\u62B5 ' + price + ' \u5143';
          break;
        case 2:
          text += '\u4EAB\u5168\u55AE ' + percent + ' \u6298';
          break;
        case 101:
          text += '\u4EAB\u5546\u54C1\u6298\u62B5 ' + price + ' \u5143';
          break;
        case 102:
          text += '\u4EAB\u5546\u54C1 ' + percent + ' \u6298';
          break;
        case 103:
          text += '享商品金額兌換';
          break;
        default:
          text += discount.name;
          break;
      }

      return text;
    }
  },
  methods: {
    getMembershipDiscountInfo: function getMembershipDiscountInfo() {
      var _this = this;

      var discount = this.membershipDiscount[0];
      var url = '/membership/' + discount.membership_id + '/discount/' + discount.discount_id + '/info';
      this.getDataH('get', url, null, function (res) {
        _this.memberCardDiscount = res.data.info;
        _this.memberCardDiscount.membership_name = discount.membership_name;
        _this.memberCardDiscount.membership_id = discount.membership_id;
      });
    },
    orderSource: function orderSource(type) {
      switch (type) {
        case 1:
          return '平台';
        case 2:
          return '專屬';
        case 3:
          return '平台LIFF';
        case 4:
          return '專屬LIFF';
        case 5:
          return '街口支付';
        case 6:
          return '你訂APP';
        default:
          return '其他';
      }
    },
    defaultComment: function defaultComment(type) {
      if (type === 1) {
        this.ratingInfo.reply_comment = '感謝您的支持與購買！希望下次能再為您服務喔 ^^';
      } else if (type === 2) {
        this.ratingInfo.reply_comment = '抱歉造成您的困擾，我們會再多注意細節的！謝謝您的體諒 ^^';
      } else if (type === 3) {
        this.ratingInfo.reply_comment = '已請客服聯絡，希望能解決您的問題！歡迎再次訂購 ^^';
      }
    },
    reply: function reply() {
      if (!this.ratingInfo.reply_comment) {
        this.$notify({
          title: '提醒',
          text: '回覆內容未填！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (this.ratingInfo.is_replied) this.updateReplay();else this.createReplay();
    },
    updateReplay: function updateReplay() {
      var _this2 = this;

      var url = this.replyUrl + this.ratingInfo.rating_id + '/reply';
      var data = {
        comment: this.ratingInfo.reply_comment
      };
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          _this2.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          _this2.getOrderInfo();
        }
      });
    },
    createReplay: function createReplay() {
      var _this3 = this;

      var url = this.replyUrl + this.ratingInfo.rating_id + '/reply';
      var data = {
        comment: this.ratingInfo.reply_comment
      };
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          _this3.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          _this3.getOrderInfo();
          _this3.ratingInfo.is_replied = 1;
        }
      });
    },
    openModal: function openModal(rating) {
      var self = this;
      var url = this.replyUrl + rating.rating_id + '/info';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.ratingInfo = response.data.info;
        }
      });
    },
    getInfo: function getInfo() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this4.getOrderInfo();

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    getTradeInfo: function getTradeInfo() {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var self = _this5;
        var url = '/accounting/orderTradeInfo/' + _this5.$route.params.order_id;
        _this5.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.tradeInfo = response.data.trade_info;
            __WEBPACK_IMPORTED_MODULE_11_jquery___default()('#trade-info').html(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(self.tradeInfo, null, 2));
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    getShortAddress: function getShortAddress(address) {
      if (!address) return null;
      var sAddress = address.split('(');
      return 'https://www.google.com/maps/place/' + sAddress[0];
    },
    valueName: function valueName(value, type) {
      if (type === 1) return '$' + value;else if (type === 2) {
          var discount = 100 - value;
          if (discount < 0) throw new Error('Type:2 | 全單折價券 | 錯誤的折扣值');
          var discountStr = discount < 10 ? '0.' + discount : discount.toString();
          var result = void 0;
          if (value === 0) result = '無折扣';else if (discountStr.length === 2 && discountStr.endsWith('0')) result = discountStr[0] + '折';else result = discountStr + '折';
          return result;
        } else if (type === 101) return '$' + value;else if (type === 102) {
            var _discount = 100 - value;
            if (_discount < 0) throw new Error('Type:102 | 單品折價券 | 錯誤的折扣值');
            var _discountStr = _discount < 10 ? '0.' + _discount : _discount.toString();
            var _result = void 0;
            if (value === 0) _result = '無折扣';else if (_discountStr.length === 2 && _discountStr.endsWith('0')) _result = _discountStr[0] + '折';else _result = _discountStr + '折';
            return _result;
          } else if (type === 103) return '-';else return '-';
    },
    trigger: function trigger(event) {
      if (event === 'resendOrderNotify') {
        this.resendOrderNotify();
      } else if (event === 'refundOrder') {
        this.refundOrder();
      } else if (event === 'cancelShopperOrder') {
        this.cancelShopperOrder();
      } else if (event === 'cancelPosOrder') {
        this.cancelPosOrder();
      } else if (event === 'editOrderState') {
        this.editOrderState();
      } else if (event === 'forceRefundOrder') {
        this.forceRefundOrder();
      } else if (event === 'markBlack') {
        this.markBlack();
      }
    },
    getBReasonText: function getBReasonText(id) {
      var reason = this.getBlackReason.find(function (o) {
        return o.reason_type_id === id;
      });
      if (reason) return reason.reason;
      return '其他原因';
    },
    getBStatusText: function getBStatusText(type) {
      if (type === 0) {
        return '無狀態';
      } else if (type === 9) {
        return '尚未確認';
      } else if (type === 10) {
        return '門市確認';
      } else if (type === 19) {
        return '門市取消';
      } else if (type === 50) {
        return '總部確認';
      } else if (type === 59) {
        return '總部取消';
      }
    },
    setBlackReason: function setBlackReason() {
      var self = this;
      this.getBlackReason.forEach(function (o) {
        var obj = { text: o.reason, value: o.reason_type_id };
        self.bSelectOptions.options.push(obj);
      });
    },
    markBlack: function markBlack() {
      var self = this;
      var orderId = this.$route.params.order_id;
      var url = '/order/markShopperBlack/' + orderId;
      var data = {
        reason_type_id: this.selectBlackReason
      };
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功標記黑名單',
            text: '成功標記黑名單',
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.getOrderInfo();
        }
      });
    },
    resendOrderNotify: function resendOrderNotify() {
      var self = this;
      var orderId = this.$route.params.order_id;
      var url = '/order/resendOrderNotify/' + orderId;
      this.getDataH('post', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
        }
      });
    },
    forceRefundOrder: function forceRefundOrder() {
      var self = this;
      var orderId = this.$route.params.order_id;
      var url = '/accounting/forceRefundOrder';
      var data = {
        order_id: orderId
      };
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.getOrderInfo();
        }
      });
    },
    refundOrder: function refundOrder() {
      var self = this;
      var orderId = this.$route.params.order_id;
      var url = '/order/refundOrder/' + orderId;
      this.getDataH('put', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
        }
      });
    },
    cancelShopperOrder: function cancelShopperOrder() {
      var self = this;
      var orderId = this.$route.params.order_id;
      var url = '/order/cancelShopperOrder/' + orderId;
      this.getDataH('put', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
        }
      });
    },
    cancelPosOrder: function cancelPosOrder() {
      var self = this;
      var orderId = this.$route.params.order_id;
      var url = '/order/cancelPosOrder/' + orderId;
      this.getDataH('put', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
        }
      });
    },
    priceTypeName: function priceTypeName(type) {
      if (type === 1) {
        return '免稅';
      } else if (type === 2) {
        return '未稅價格';
      } else if (type === 3) {
        return '含稅價格';
      }
    },
    payType: function payType(type) {
      if (type === 10) {
        return '線上支付';
      } else if (type === 50) {
        return '店家支付';
      }
    },
    tradeType: function tradeType(type) {
      if (type === 1) {
        return '現金';
      } else if (type === 701) {
        return 'iPASS MONEY';
      } else if (type === 706) {
        return '信用卡';
      } else if (type === 707) {
        return 'LINE PAY';
      } else if (type === 709) {
        return '信用卡(台新)';
      } else if (type === 710) {
        return '信用卡';
      } else if (type === 713) {
        return '台灣Pay';
      } else if (type === 716) {
        return '全盈+PAY';
      } else if (type === 717) {
        return '悠遊付';
      } else if (type === 718) {
        return 'Pi 拍錢包';
      } else if (type === 719) {
        return '全支付';
      } else if (type === 720) {
        return 'icash Pay';
      } else if (type === 908) {
        return '街口支付';
      } else if (type === 909) {
        return '遠傳電信代收';
      }
    },
    invoiceType: function invoiceType(type, email) {
      if (email) {
        return 'Email 載具';
      } else {
        if (type === 10) return '紙本';else if (type === 20) return '載具';else if (type === 21) return 'POS載具';else if (type === 30) return '捐贈';else return '無發票/未指定';
      }
    },
    payStateName: function payStateName(state) {
      if (state === 11) {
        return '尚未付款';
      } else if (state === 12) {
        return '付款處理中';
      } else if (state === 13) {
        return '已收款';
      } else if (state === 21) {
        return '退款處理中';
      } else if (state === 22) {
        return '已退款';
      }
    },
    orderStateColor: function orderStateColor(state) {
      switch (state) {
        case 140:
        case 120:
        case 121:
        case 122:
        case 99:
          return 'label-danger';
        case 100:
          return 'label-default';
        case 110:
          return 'label-primary';
        case 130:
          return 'label-success';
        default:
          return 'label-warning';
      }
    },
    orderState: function orderState(state) {
      if (state === 0) {
        return '訂單尚未確認';
      } else if (state === 1) {
        return '訂單已送出，尚未付款';
      } else if (state === 2) {
        return '付款中';
      } else if (state === 3) {
        return '訂單已付款，尚未通知店家';
      } else if (state === 99) {
        return '使用者取消訂單';
      } else if (state === 100) {
        return '未接單';
      } else if (state === 110) {
        return '已接單';
      } else if (state === 120) {
        return '被店家退訂';
      } else if (state === 121) {
        return '被系統退訂';
      } else if (state === 122) {
        return '已取消';
      } else if (state === 130) {
        return '已完成';
      } else if (state === 140) {
        return '已作廢';
      }
    },
    notifyType: function notifyType(type) {
      if (type === 1) {
        return '新訂單';
      } else if (type === 2) {
        return '使用者取消';
      } else if (type === 3) {
        return '系統自動拒絕';
      }
    },
    vendorType: function vendorType(type) {
      switch (type) {
        case 1:
          return '快遞';
        case 2:
          return '宅配';
      }
    },
    shippingStateColor: function shippingStateColor(state) {
      switch (state) {
        case 19:
        case 59:
        case 900:
        case 901:
        case 910:
        case 920:
        case 921:
        case 930:
        case 940:
          return 'label-danger';
        case 0:
        case 10:
        case 50:
        case 100:
          return 'label-default';
        case 110:
          return 'label-pink';
        case 120:
          return 'label-warning';
        case 130:
          return 'label-primary';
        case 140:
          return 'label-success';
        default:
          return 'label-warning';
      }
    },
    shippingState: function shippingState(state) {
      if (state === 0) {
        return '叫件開案';
      } else if (state === 10) {
        return '已報價';
      } else if (state === 19) {
        return '報價失敗';
      } else if (state === 50) {
        return '叫件處理中';
      } else if (state === 59) {
        return '叫件處理失敗';
      } else if (state === 100) {
        return '成立物流單';
      } else if (state === 110) {
        return '物流接單';
      } else if (state === 120) {
        return '已分派外送員';
      } else if (state === 130) {
        return '已取貨';
      } else if (state === 140) {
        return '已送達';
      } else if (state === 900) {
        return '門市取消叫件';
      } else if (state === 901) {
        return '系統/門市取消';
      } else if (state === 910) {
        return '物流拒絕接單';
      } else if (state === 920) {
        return '媒合失敗';
      } else if (state === 921) {
        return '物流分派司機失敗';
      } else if (state === 930) {
        return '司機取餐失敗';
      } else if (state === 940) {
        return '司機送餐失敗';
      }
    },
    quotedStateColor: function quotedStateColor(state) {
      switch (state) {
        case 99:
        case 90:
        case 91:
        case 92:
        case 93:
        case 94:
          return 'label-danger';
        case 0:
          return 'label-default';
        case 10:
          return 'label-success';
        default:
          return 'label-danger';
      }
    },
    quotedState: function quotedState(state) {
      switch (state) {
        case 1:
          return '報價中';
        case 99:
          return '報價發生錯誤';
        case 90:
          return '拒絕報價';
        case 91:
          return '無法服務';
        case 92:
          return '非運送時段';
        case 93:
          return '運送範圍不符';
        case 94:
          return '運送距離不符';
        case 0:
          return '未報價';
        case 10:
          return '已報價';
        default:
          return '';
      }
    },
    getOrderInfo: function getOrderInfo() {
      var _this6 = this;

      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var orderId = _this6.$route.params.order_id;
        var roleType = _this6.roleType;
        var url = '';
        var orderType = _this6.isOffline ? 'offlineOrder' : 'order';
        if (_this6.isGuest) url = '/' + orderType + '/caseInfo/' + orderId;else if (roleType === 99) url = '/' + orderType + '/orderInfo/' + orderId;else if (roleType === 30) url = '/' + orderType + '/brandOrderInfo/' + orderId;else if (roleType === 10) url = '/' + orderType + '/storeOrderInfo/' + orderId;
        _this6.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            var data = response.data;
            _this6.orderList = data.order;
            _this6.orderList = _this6.isGuest ? data.case || {} : data.order || {};
            if (_this6.isGuest && _this6.orderList.offline_order_id) {
              _this6.$router.replace({ path: '/onSiteOrderTableInfo/' + _this6.orderList.offline_order_id });
              return;
            }
            _this6.productList = _this6.orderList.product_list || null;

            _this6.bindingShipping = _this6.orderList.binding_shipping_case;
            if (_this6.bindingShipping) _this6.getShippingCaseList(orderId);
            if (_this6.orderList.coupon_list) _this6.couponList = _this6.orderList.coupon_list;
            if (_this6.orderList.get_coupon_list) _this6.getCouponList = _this6.orderList.get_coupon_list;
            if (_this6.orderList.voucher_list) _this6.voucherList = _this6.orderList.voucher_list;
            if (_this6.orderList.point.income.list) _this6.getPointList = _this6.orderList.point.income.list;

            if (_this6.orderList.product_coupon_list) {
              _this6.productCouponList = _this6.orderList.product_coupon_list.item_list;
              if (!Array.isArray(_this6.productCouponList)) _this6.productCouponList = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(_this6.productCouponList);
              _this6.productCouponMap = {};
              _this6.productCouponList.forEach(function (item) {
                _this6.productCouponMap[item.item_set_uid] = item;
              });
            }

            if (_this6.orderList.product_voucher_list) {
              _this6.productVoucherList = _this6.orderList.product_voucher_list.item_list;
              if (!Array.isArray(_this6.productVoucherList)) _this6.productVoucherList = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(_this6.productVoucherList);
              _this6.productVoucherMap = {};
              _this6.productVoucherList.forEach(function (item) {
                _this6.productVoucherMap[item.item_set_uid] = item;
              });
            }

            if (_this6.orderList.rating) _this6.ratingList = _this6.orderList.rating;
            if (_this6.orderList.membership_score) _this6.getMembershipScore = _this6.orderList.membership_score.income.list;
            _this6.isOfflineOrder = _this6.orderList.pay_place_type !== 10;
            _this6.getMembershipDiscountInfo();
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    offlineCouponList: function offlineCouponList() {
      var _this7 = this;

      this.combineCouponList = [];
      if (this.couponList.length) {
        this.couponList.forEach(function (coupon) {
          _this7.combineCouponList.push(coupon);
        });
      }
      this.totalOfflineCouponMoney = this.combineCouponList.reduce(function (sum, item) {
        if (item.money !== undefined) {
          return sum + item.money;
        }
        return sum;
      }, 0);
    },
    offlineVoucherList: function offlineVoucherList() {
      var _this8 = this;

      this.combineVoucherList = [];
      if (this.voucherList.length) {
        this.voucherList.forEach(function (voucher) {
          _this8.combineVoucherList.push(voucher);
        });
      }
      this.totalOfflineVoucherMoney = this.combineVoucherList.reduce(function (sum, item) {
        if (item.money !== undefined) {
          return sum + item.money;
        }
        return sum;
      }, 0);
    },
    selectOnChange: function selectOnChange(value) {
      this.order.newState = value;
    },
    changeBlackReason: function changeBlackReason(value) {
      this.selectBlackReason = value;
    },
    inputOnChange: function inputOnChange(value) {
      this.order.remark = value;
    },
    editOrderState: function editOrderState() {
      if (this.order.newState === null) {
        this.$notify({
          title: '請選擇訂單狀態',
          duration: 3000,
          type: 'warn',
          width: 400
        });
        return;
      }
      var self = this;
      var orderId = this.$route.params.order_id;
      var url = '/order/updateOrderStatus/' + orderId;
      var data = {
        status: this.order.newState
      };
      if (this.order.remark) data['remark'] = this.order.remark;
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.getOrderInfo();
        }
      });
    },
    checkMemberShow: function checkMemberShow(status) {
      if (!this.isOffline) {
        if (this.roleType === 30) {
          if (status === 130 || status === 140) return true;else return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    getShippingCaseList: function getShippingCaseList(orderId) {
      var _this9 = this;

      var orderType = this.isOffline ? this.isGuest ? 'directCase' : 'offlineOrder' : 'order';
      var url = '/shippingCase/' + orderType + '/' + orderId + '/list';
      this.getDataH('get', url, null, function (res) {
        if (res.data.status === 200) {
          if (_this9.bindingShipping.vendor_code === 'glo') _this9.shippingCaseList = [res.data.list[0]];else _this9.shippingCaseList = res.data.list;
        }
      });
    },
    getSrcTypeName: function getSrcTypeName(source, type) {
      if (source === 'point') {
        if (type === '10') {
          return '消費贈點';
        } else if (type === '60') {
          return '指定商品贈點';
        } else if (type === '61') {
          return '點數加碼活動';
        } else {
          return '未知';
        }
      } else if (source === 'memberScore') {
        if (type === '10') {
          return '消費贈積分';
        } else if (type === '60') {
          return '指定商品贈積分';
        } else if (type === '61') {
          return '積分加碼活動';
        } else {
          return '未知';
        }
      }
    },
    formatCouponVoucherList: function formatCouponVoucherList(source) {
      if (!source.item_list || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(source.item_list) !== 'object') return null;
      var formatArray = [];
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(source.item_list).forEach(function (value) {
        var product = value;
        var productName = product.list[0].product_name || '未知商品';
        var itemMap = {};
        if (product.list && Array.isArray(product.list)) {
          product.list.forEach(function (item) {
            var itemName = item.name.toString() || '';
            if (itemMap[itemName]) {
              itemMap[itemName].count += 1;
            } else {
              itemMap[itemName] = {
                count: 1,
                name: itemName,
                productName: productName,
                unitDiscount: item.unit_discount || 0
              };
            }
          });
        }
        formatArray.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, product, {
          productName: productName,
          formatList: itemMap
        }));
      });
      return formatArray;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapGetters */])(['getRoleType', 'getBlackReason']), {
    allCouponList: function allCouponList() {
      var list = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.couponList));
      if (this.orderList.group_buy_follower_order_list) {
        this.orderList.group_buy_follower_order_list.forEach(function (order) {
          list = list.concat(order.coupon_list);
        });
      }
      return list;
    },
    allVoucherList: function allVoucherList() {
      var list = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.voucherList));
      if (this.orderList.group_buy_follower_order_list) {
        this.orderList.group_buy_follower_order_list.forEach(function (order) {
          list = list.concat(order.voucher_list);
        });
      }
      return list;
    },
    subSrcType: function subSrcType() {
      switch (this.orderList.sub_src_type) {
        case 2:
          return 'LINE';
        case 3:
          return 'Messenger';
        case 4:
          return 'LINE LIFF';
        case 1:
        default:
          return '網頁';
      }
    },
    membershipDiscount: function membershipDiscount() {
      if (this.orderList.membership_discount) {
        return this.orderList.membership_discount.list;
      }
      return [];
    },
    showTradeInfo: function showTradeInfo() {
      var temp = true;
      if (this.getRoleType !== 99) {
        temp = false;
      }
      if (this.isOfflineOrder) {
        temp = false;
      }
      if (this.orderList.trade_type === 1) {
        temp = false;
      }
      return temp;
    },
    totalCouponMoney: function totalCouponMoney() {
      var couponList = this.couponList;
      if (couponList.length) {
        var total = 0;
        couponList.forEach(function (coupon) {
          total = total + coupon.money;
        });
        return total;
      }
      return 0;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    reservEndTime: function reservEndTime() {
      var time = __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.orderList.delivery_reserv_time, 'YYYY-MM-DD HH:mm:ss').add(this.orderList.delivery_reserv_tolerance, 'm').format('HH:mm:ss');
      return time;
    },
    isOffline: function isOffline() {
      return this.$route.name.includes('onSite');
    },
    isGuest: function isGuest() {
      return this.$route.query.is_guest === '1';
    },
    replyUrl: function replyUrl() {
      return this.isOffline ? '/ratingOfflineOrder/' : '/rating/';
    },
    groupedPoints: function groupedPoints() {
      var grouped = {};

      this.getPointList.forEach(function (point) {
        var srcType = point.src_type;
        if (!grouped[srcType]) {
          grouped[srcType] = [];
        }
        grouped[srcType].push(point);
      });

      return grouped;
    },
    groupedMembershipScore: function groupedMembershipScore() {
      var grouped = {};

      this.getMembershipScore.forEach(function (item) {
        var srcType = item.src_type;
        if (!grouped[srcType]) {
          grouped[srcType] = [];
        }
        grouped[srcType].push(item);
      });

      return grouped;
    },
    productCouponListFormat: function productCouponListFormat() {
      return this.formatCouponVoucherList(this.orderList.product_coupon_list);
    },
    voucherCouponListFormat: function voucherCouponListFormat() {
      return this.formatCouponVoucherList(this.orderList.product_voucher_list);
    },
    gbProductCouponListFormat: function gbProductCouponListFormat() {
      var _this10 = this;

      if (!this.orderList.group_buy_follower_order_list) return null;
      var concatArray = this.orderList.group_buy_follower_order_list.map(function (order) {
        return order.product_coupon_list;
      });
      var formatList = [];
      concatArray.forEach(function (item) {
        var formatted = _this10.formatCouponVoucherList(item);
        if (formatted) {
          formatList.push.apply(formatList, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(formatted));
        }
      });
      return formatList;
    },
    gbVoucherCouponListFormat: function gbVoucherCouponListFormat() {
      var _this11 = this;

      if (!this.orderList.group_buy_follower_order_list) return null;
      var concatArray = this.orderList.group_buy_follower_order_list.map(function (order) {
        return order.product_voucher_list;
      });
      var formatList = [];
      concatArray.forEach(function (item) {
        var formatted = _this11.formatCouponVoucherList(item);
        if (formatted) {
          formatList.push.apply(formatList, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(formatted));
        }
      });
      return formatList;
    },
    infoProductCouponFormat: function infoProductCouponFormat() {
      return this.formatCouponVoucherList(this.info.product_coupon_list);
    },
    infoVoucherCouponFormat: function infoVoucherCouponFormat() {
      return this.formatCouponVoucherList(this.info.product_voucher_list);
    },
    couponListWithoutProduct: function couponListWithoutProduct() {
      return this.allCouponList.filter(function (coupon) {
        return !coupon.product_name;
      });
    }
  }),
  created: function created() {
    this.roleType = parseInt(this.getRoleType, 10);
    this.getInfo();
  },

  watch: {
    '$route.query': function $routeQuery() {
      this.getOrderInfo();
    },
    getBlackReason: function getBlackReason() {
      this.setBlackReason();
    }
  }
});

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_shared_token_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Temp_OrderTableTemp_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Temp_OrderTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Temp_OrderTableTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Temp_OrderExceptionTableTemp_vue__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Temp_OrderExceptionTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Temp_OrderExceptionTableTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      tableIndex: 1,

      routeToBdmsType: {
        orderTable: 'online',
        onSiteOrderTable: 'offline',
        onSiteOrderMemberTable: 'offline',
        onSiteOrderGuestTable: 'offline'
      },

      moveToBdmsConfigMap: {
        online: {
          text: '線上訂單',
          linkText: '訂單管理 > 線上訂單',
          url: 'order-manage/online'
        },
        offline: {
          text: '線下訂單',
          linkText: '訂單管理 > 線下訂單',
          url: 'order-manage/offline'
        }
      }
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#example1').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      });
    });
  },

  methods: {
    payType: function payType(type) {
      if (type === 10) {
        return '線上支付';
      } else if (type === 50) {
        return '店家支付';
      }
    },
    payStateName: function payStateName(state) {
      if (state === 11) {
        return '尚未付款';
      } else if (state === 12) {
        return '付款處理中';
      } else if (state === 13) {
        return '已收款';
      } else if (state === 21) {
        return '退款處理中';
      } else if (state === 22) {
        return '已退款';
      }
    },
    orderState: function orderState(state) {
      if (state === 0) {
        return '訂單尚未確認';
      } else if (state === 1) {
        return '訂單已送出，尚未付款';
      } else if (state === 2) {
        return '付款中';
      } else if (state === 3) {
        return '訂單已付款，尚未通知店家';
      } else if (state === 99) {
        return '使用者取消訂單';
      } else if (state === 100) {
        return '未接單';
      } else if (state === 110) {
        return '已接單';
      } else if (state === 120) {
        return '被店家退訂';
      } else if (state === 121) {
        return '被系統退訂';
      } else if (state === 122) {
        return '已取消';
      } else if (state === 130) {
        return '已完成';
      } else if (state === 140) {
        return '已作廢';
      }
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    goto: function goto() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_shared_token_js__["c" /* setSharedToken */])(window.localStorage.getItem(this.$config.token));
      window.location.href = '' + this.$config.bdms + this.moveToBdmsConfig.url;
    }
  },
  components: {
    'order-table': __WEBPACK_IMPORTED_MODULE_5__Temp_OrderTableTemp_vue___default.a,
    'order-exception-table': __WEBPACK_IMPORTED_MODULE_6__Temp_OrderExceptionTableTemp_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getFile: function getFile() {
      return this.$parent.getFile;
    },
    moveToBdmsConfig: function moveToBdmsConfig() {
      var bdmsType = this.routeToBdmsType[this.$route.name];
      return this.moveToBdmsConfigMap[bdmsType] || this.moveToBdmsConfigMap.online;
    }
  })
});

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue___default.a
  },
  data: function data() {
    return {
      roleType: '',
      total: 1,
      count: 20,
      orderList: [],
      searchResult: '',
      shopper: '',
      orderSn: '',
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      searchSelect: 1,
      brandSelect: {
        value: 0,
        label: '== 品牌 =='
      },
      storeSelect: {
        value: 0,
        label: '== 門市 =='
      },
      typeSelect: 999,
      statusSelect: 999,
      deTypeSelect: 999,
      scoreOption: {
        id: 'scoreModal',
        title: '修改評分狀態',
        body: '確認修改評分狀態？',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'scoreStatus'
        }]
      },
      brandBrief: [],
      storeBrief: [],
      brandDefault: 0,
      typeList: [{ label: '== 評分狀態 ==', value: 999 }, { label: '無狀態', value: 0 }, { label: '尚未確認', value: 9 }, { label: '門市確認', value: 10 }, { label: '門市取消', value: 19 }, { label: '總部確認', value: 50 }, { label: '總部取消', value: 59 }],
      order: {
        newState: 0,
        scoreId: 0,
        scoreStatus: ''
      },
      selectOptions: {
        name: '評分狀態',
        options: []
      },
      isLoading: true
    };
  },

  methods: {
    clickGroup: function clickGroup(type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1;
        this.tableIndex = this.groupAmount * this.pageGroup;
        this.clickPage(this.tableIndex);
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1;
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1;
        this.clickPage(this.tableIndex);
      }
    },
    clickEnd: function clickEnd(type) {
      if (type === 'pre') {
        this.clickPage(1);
        this.pageGroup = 1;
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount);else this.clickPage(1);
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount);
      }
    },
    trigger: function trigger(event) {
      if (event === 'scoreStatus') {
        this.scoreStatus();
      }
    },
    payType: function payType(type) {
      if (type === 10) {
        return '線上支付';
      } else if (type === 50) {
        return '店家支付';
      }
    },
    payStateName: function payStateName(state) {
      if (state === 11) {
        return '尚未付款';
      } else if (state === 12) {
        return '付款處理中';
      } else if (state === 13) {
        return '已收款';
      } else if (state === 21) {
        return '退款處理中';
      } else if (state === 22) {
        return '已退款';
      }
    },
    orderState: function orderState(state) {
      if (state === 0) {
        return '訂單尚未確認';
      } else if (state === 1) {
        return '訂單已送出，尚未付款';
      } else if (state === 2) {
        return '付款中';
      } else if (state === 3) {
        return '訂單已付款，尚未通知店家';
      } else if (state === 99) {
        return '客人取消';
      } else if (state === 100) {
        return '未接單';
      } else if (state === 110) {
        return '已接單';
      } else if (state === 120) {
        return '店家退訂';
      } else if (state === 121) {
        return '系統退訂';
      } else if (state === 122) {
        return '已取消';
      } else if (state === 130) {
        return '已完成';
      } else if (state === 140) {
        return '已作廢';
      }
    },
    scoreStatusName: function scoreStatusName(type) {
      if (type === 0) {
        return '無狀態';
      } else if (type === 9) {
        return '尚未確認';
      } else if (type === 10) {
        return '門市確認';
      } else if (type === 19) {
        return '門市取消';
      } else if (type === 50) {
        return '總部確認';
      } else if (type === 59) {
        return '總部取消';
      }
    },
    statusColor: function statusColor(type) {
      if (type === 0) {
        return 'label-default';
      } else if (type === 9) {
        return 'label-default';
      } else if (type === 10) {
        return 'label-success';
      } else if (type === 19) {
        return 'label-danger';
      } else if (type === 50) {
        return 'label-success';
      } else if (type === 59) {
        return 'label-danger';
      }
    },
    getCurrentId: function getCurrentId(scoreId, scoreStatus) {
      this.order.scoreId = scoreId;
      this.order.scoreStatus = scoreStatus.toString();
    },
    selectOnChange: function selectOnChange(value) {
      this.order.newState = value;
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.getOrderList();
    },
    scoreStatus: function scoreStatus() {
      var self = this;
      var url = '/score/' + this.order.scoreId + '/status';
      var data = {
        score_status: this.order.newState
      };
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.getOrderList(1);
        }
      });
    },
    getOrderList: function getOrderList(page) {
      this.isLoading = true;
      if (page) {
        this.tableIndex = page;
        if (page === 1) this.pageGroup = 1;
      }
      var self = this;
      var roleType = parseInt(this.getRoleType, 10);
      var url;
      var data = {
        page: this.tableIndex,
        size: this.count
      };
      if (roleType === 99) {
        url = '/order/blackOrderList?page=' + data.page + '&size=' + data.size + '&list_sort=create_time DESC';
      } else if (roleType === 30) {
        url = '/order/brandBlackOrderList?page=' + data.page + '&size=' + data.size + '&list_sort=create_time DESC';
      }
      if (this.searchResult && parseInt(this.searchSelect, 10) === 1) url = url + '&order_sn=' + this.searchResult;else if (this.searchResult && parseInt(this.searchSelect, 10) === 2) url = url + '&shopper_id=' + this.searchResult;
      if (this.brandSelect.value !== '0' && this.brandSelect.value !== 0 && url) url = url + '&brand_id=' + this.brandSelect.value;
      if (this.storeSelect.value !== '0' && this.storeSelect.value !== 0 && url) url = url + '&store_id=' + this.storeSelect.value;
      if (this.typeSelect !== '999' && this.typeSelect !== 999 && url) url = url + '&score_status=' + this.typeSelect;
      if (url) {
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.orderList = response.data.order_list;
            self.total = response.data.total;
            if (self.orderList.length) __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.odd').css('display', 'none');
            self.isLoading = false;
          }
        });
      }
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      self.brandBrief = [{ label: '== 品牌 ==', value: 0 }];
      var url = '/brand/listBrief?is_delete=0&is_opening=1&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            if (!bList[i].is_visible) obj.label = obj.label + ' (測)';
            self.brandBrief.push(obj);
            if (i === 0 && self.roleType === 10) self.brandSelect = obj;else if (i === 0 && bList.length === 1) self.brandSelect = obj;
          }
          if (self.roleType === 30 || self.roleType === 99) self.getOrderList();
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      console.log('getStoreBrief | BlackListTableTemp');
      this.storeBrief = [];
      var self = this;
      self.storeBrief = [{ label: '== 門市 ==', value: 0 }];
      var url = '/brand/' + brandId + '/storeListBrief?status=2&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i <= sList.length; i++) {
            if (sList.length > 0) {
              var obj = { label: sList[i].name, value: sList[i].store_id };
              self.storeBrief.push(obj);
            }
            if (i === 0) {
              self.getOrderList(1);
            }
          }
        }
      });
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    }
  },
  created: function created() {
    this.getBrandBrief();
    this.roleType = parseInt(this.getRoleType, 10);
    if (this.roleType === 99) {
      this.order.newState = '0';
      this.selectOptions.options = [{ text: '無狀態', value: 0 }, { text: '尚未確認', value: 9 }, { text: '門市確認', value: 10 }, { text: '門市取消', value: 19 }, { text: '總部確認', value: 50 }, { text: '總部取消', value: 59 }];
    } else {
      this.order.newState = '50';
      this.selectOptions.options = [{ text: '總部確認', value: 50 }, { text: '總部取消', value: 59 }];
    }
  },

  watch: {
    'menuTime.end.time': function menuTimeEndTime() {
      var lastDay = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
      if (this.menuTime.start.time > lastDay) this.menuTime.start.time = lastDay;
      this.startLimit = [{
        type: 'fromto',
        to: lastDay
      }];
    },
    'menuTime.start.time': function menuTimeStartTime() {
      var lastDay = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.start.time).add('31', 'days');
      if (lastDay < __WEBPACK_IMPORTED_MODULE_3_moment___default()()) this.menuTime.end.time = lastDay.format('YYYY-MM-DD');else this.menuTime.end.time = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD');
      this.endLimit = [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.start.time).subtract(1, 'days'),
        to: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.end.time).add(1, 'days')
      }];
    },
    'brandSelect.value': function brandSelectValue() {
      this.storeSelect = { value: 0, label: '== 門市 ==' };
      if (this.$route.name === 'storeInfo') {
        this.storeSelect.value = this.$route.params.store_id;
        this.getStoreBrief(this.brandSelect.value);
      }if (this.brandSelect.value !== 0 && this.brandSelect.value !== '0') {
        this.getStoreBrief(this.brandSelect.value);
      } else {
        this.getOrderList(1);
      }
    },
    'storeSelect.value': function storeSelectValue() {
      this.getOrderList(1);
    },
    typeSelect: function typeSelect() {
      this.getOrderList(1);
    },
    statusSelect: function statusSelect() {
      this.getOrderList(1);
    },
    deTypeSelect: function deTypeSelect() {
      this.getOrderList(1);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  })
});

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'OrderExceptionTableTemp',
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default.a
  },
  data: function data() {
    return {
      roleType: 0,
      total: 0,
      orderList: [],
      show: {
        brand: false,
        menu: false,
        schedule: false
      },
      count: 20,
      orderSn: '',
      shopper: '',
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      searchSelect: 1,
      processSelect: 99,
      timeSearch: false,

      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      startLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD')
      }],
      endLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(1, 'days').format('YYYY-MM-DD')
      }],
      isLoading: true
    };
  },

  methods: {
    clickGroup: function clickGroup(type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1;
        this.tableIndex = this.groupAmount * this.pageGroup;
        this.clickPage(this.tableIndex);
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1;
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1;
        this.clickPage(this.tableIndex);
      }
    },
    clickEnd: function clickEnd(type) {
      if (type === 'pre') {
        this.clickPage(1);
        this.pageGroup = 1;
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount);else this.clickPage(1);
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount);
      }
    },
    payType: function payType(type) {
      if (type === 10) {
        return '線上支付';
      } else if (type === 50) {
        return '店家支付';
      }
    },
    payStateName: function payStateName(state) {
      if (state === 11) {
        return '尚未付款';
      } else if (state === 12) {
        return '付款處理中';
      } else if (state === 13) {
        return '已收款';
      } else if (state === 21) {
        return '退款處理中';
      } else if (state === 22) {
        return '已退款';
      }
    },
    orderStateColor: function orderStateColor(state) {
      switch (state) {
        case 140:
        case 120:
        case 121:
        case 122:
        case 99:
          return 'label-danger';
        case 100:
          return 'label-default';
        case 110:
          return 'label-primary';
        case 130:
          return 'label-success';
        default:
          return 'label-warning';
      }
    },
    orderState: function orderState(state) {
      if (state === 0) {
        return '訂單尚未確認';
      } else if (state === 1) {
        return '訂單已送出，尚未付款';
      } else if (state === 2) {
        return '付款中';
      } else if (state === 3) {
        return '訂單已付款，尚未通知店家';
      } else if (state === 99) {
        return '客人取消';
      } else if (state === 100) {
        return '未接單';
      } else if (state === 110) {
        return '已接單';
      } else if (state === 120) {
        return '店家退訂';
      } else if (state === 121) {
        return '系統退訂';
      } else if (state === 122) {
        return '已取消';
      } else if (state === 130) {
        return '已完成';
      } else if (state === 140) {
        return '已作廢';
      }
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.getAbnormalOrderList();
    },
    getAbnormalOrderList: function getAbnormalOrderList(type) {
      this.isLoading = true;
      var self = this;
      if (type) {
        this.tableIndex = 1;
        this.pageGroup = 1;
        this.timeSearch = true;
      }
      var data = {
        page: this.tableIndex,
        count: this.count,
        start_time: __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        order_sn: this.orderSn,
        shopper_name: this.shopper
      };
      var urlType = '';
      if (parseInt(this.getRoleType, 10) === 99) urlType = 'abnormalOrderList';else if (parseInt(this.getRoleType, 10) === 30) urlType = 'brandAbnormalOrderList';else if (parseInt(this.getRoleType, 10) === 10) urlType = 'storeAbnormalOrderList';
      var url;
      if (parseInt(this.searchSelect, 10) === 1) {
        url = '/order/' + urlType + '?page=' + data.page + '&size=' + data.count;
      } else if (parseInt(this.searchSelect, 10) === 2 && data.order_sn) {
        url = '/order/' + urlType + '?page=' + data.page + '&size=' + data.count + '&order_sn=' + data.order_sn;
      } else if (parseInt(this.searchSelect, 10) === 3 && data.shopper_name) {
        url = '/order/' + urlType + '?page=' + data.page + '&size=' + data.count + '&shopper_name=' + data.shopper_name;
      }
      if (parseInt(this.processSelect, 10) !== 99) url = url + '&is_processed=' + this.processSelect;
      if (this.timeSearch) url = url + '&start_time=' + data.start_time + '&end_time=' + data.end_time;
      if (url) {
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.orderList = response.data.order_list;
            self.total = response.data.total;
            self.isLoading = false;
          }
        });
      }
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    },
    getTime: function getTime(time) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(time, 'YYYY-MM-DD HH:mm:ss').format('MM/DD HH:mm');
    }
  },
  created: function created() {
    var date = new Date();
    var y = date.getFullYear();
    var m = date.getMonth();
    var firstDay = new Date(y, m, 1);
    this.menuTime.start.time = __WEBPACK_IMPORTED_MODULE_2_moment___default()(firstDay).format('YYYY-MM-DD');
    if (this.$route.name === 'brandTable') this.show.brand = true;else if (this.$route.name === 'menuTable') this.show.menu = true;else if (this.$route.name === 'scheduleTable') this.show.schedule = true;
    this.getAbnormalOrderList('search');
    this.roleType = parseInt(this.getRoleType, 10);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  }),
  watch: {
    'menuTime.end.time': function menuTimeEndTime() {
      var lastDay = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
      if (this.menuTime.start.time > lastDay) this.menuTime.start.time = lastDay;
      this.startLimit = [{
        type: 'fromto',
        to: lastDay
      }];
    },
    'menuTime.start.time': function menuTimeStartTime() {
      var lastDay = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.menuTime.start.time).add('31', 'days');
      if (lastDay < __WEBPACK_IMPORTED_MODULE_2_moment___default()()) this.menuTime.end.time = lastDay.format('YYYY-MM-DD');else this.menuTime.end.time = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD');
      this.endLimit = [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.menuTime.start.time).subtract(1, 'days'),
        to: __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.menuTime.end.time).add(1, 'days')
      }];
    },
    processSelect: function processSelect() {
      this.getAbnormalOrderList();
    }
  }
});

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_elements_nd_date_picker_vue__ = __webpack_require__(2095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_elements_nd_date_picker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_elements_nd_date_picker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_spinner_src_ClipLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_spinner_src_ClipLoader_vue__);













/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_7__components_elements_nd_date_picker_vue___default.a,
    'Clip': __WEBPACK_IMPORTED_MODULE_10_vue_spinner_src_ClipLoader_vue___default.a
  },
  data: function data() {
    return {
      roleType: '',
      total: 1,
      count: 20,
      orderList: [],
      shopperId: 0,
      shopper: '',
      orderSn: '',
      subOrderAmount: '',
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      searchSelect: 1,
      brandSelect: {
        label: '== 品牌 ==',
        value: 0
      },
      storeSelect: {
        label: '== 門市 ==',
        value: 0
      },
      typeSelect: 99,
      statusSelect: 999,
      deTypeSelect: 999,
      trTypeSelect: 999,
      isCreatedTime: false,
      isCreatedStore: false,

      menuTime: {
        start: {
          time: __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY-MM-DD')
        },
        end: {
          time: __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      startLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_8_moment___default()().add(1, 'days').format('YYYY-MM-DD')
      }],
      endLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_8_moment___default()().add(1, 'days').add(1, 'days').format('YYYY-MM-DD')
      }],
      brandBrief: [],
      storeBrief: [],
      brandDefault: 0,
      statusList: [{ label: '== 訂單狀態 ==', value: 999 }, { label: '訂單已送出，尚未付款', value: 1 }, { label: '付款中', value: 2 }, { label: '訂單已付款，尚未通知店家', value: 3 }, { label: '客人取消', value: 99 }, { label: '未接單', value: 100 }, { label: '已接單', value: 110 }, { label: '店家退訂', value: 120 }, { label: '系統退訂', value: 121 }, { label: '已取消', value: 122 }, { label: '已完成', value: 130 }, { label: '已作廢', value: 140 }],
      deliveryTypeList: [{ label: '== 取餐類型 ==', value: 999 }, { label: '自取', value: 1 }, { label: '外送', value: 3 }, { label: '內用', value: 2 }, { label: '外帶', value: 4 }, { label: '內用-桌邊掃碼', value: 21 }],

      exportMaxLimit: 0,
      isLoading: false,
      isDownloading: false,
      retry: 0,
      retryTimer: null,
      retryFrequency: 0
    };
  },

  methods: {
    queryChange: function queryChange(event, type) {
      var query = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, this.$route.query);
      var value = event.target ? event.target.value : event.value === 0 ? event.value : event.value || event;

      if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(value) === '{}') return;
      if (value && value !== 999) query[type] = value;else delete query[type];
      this.$router.replace({ query: query });
    },
    search: function search(method) {
      if (method === 1 && this.menuTime.start.time && this.menuTime.end.time) {
        this.getOrderList(1);
      } else if (method === 2 && this.orderSn) {
        this.getOrderList(1);
      } else if (method === 3 && this.shopper) {
        this.getOrderList(1);
      } else if (method === 4 && parseInt(this.subOrderAmount, 10)) {
        this.getOrderList(1);
      } else {
        this.$notify({
          title: '請輸入搜尋條件',
          duration: 1000,
          type: 'danger',
          width: 400
        });
      }
    },
    clickGroup: function clickGroup(type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1;
        this.tableIndex = this.groupAmount * this.pageGroup;
        this.changePage(this.tableIndex);
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1;
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1;
        this.changePage(this.tableIndex);
      }
    },
    clickEnd: function clickEnd(type) {
      if (type === 'pre') {
        this.changePage(1);
        this.pageGroup = 1;
      } else if (type === 'forward') {
        if (this.pageAmount) this.changePage(this.pageAmount);else this.changePage(1);
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount);
      }
    },
    payType: function payType(type) {
      if (type === 10) {
        return '線上支付';
      } else if (type === 50) {
        return '店家支付';
      }
    },
    labelColor: function labelColor(type) {
      if (type === 1) {
        return 'label-default';
      } else if (type === 707 || type === 701) {
        return 'label-success';
      } else if (type === 709) {
        return 'label-danger';
      } else if (type === 710) {
        return 'label-info';
      }
    },
    stateColor: function stateColor(state) {
      if (state === 11) {
        return 'label-default';
      } else if (state === 12) {
        return 'label-primary';
      } else if (state === 13) {
        return 'label-success';
      } else if (state === 21) {
        return 'label-danger';
      } else if (state === 22) {
        return 'label-danger';
      }
    },
    payStateName: function payStateName(state) {
      if (state === 11) {
        return '未付款';
      } else if (state === 12) {
        return '付款中';
      } else if (state === 13) {
        return '已收款';
      } else if (state === 21) {
        return '退款中';
      } else if (state === 22) {
        return '已退款';
      }
    },
    orderStateColor: function orderStateColor(state) {
      switch (state) {
        case 140:
        case 120:
        case 121:
        case 122:
        case 99:
          return 'label-danger';
        case 100:
          return 'label-default';
        case 110:
          return 'label-primary';
        case 130:
          return 'label-success';
        default:
          return 'label-warning';
      }
    },
    orderState: function orderState(state) {
      if (state === 0) {
        return '訂單尚未確認';
      } else if (state === 1) {
        return '訂單已送出，尚未付款';
      } else if (state === 2) {
        return '付款中';
      } else if (state === 3) {
        return '訂單已付款，尚未通知店家';
      } else if (state === 99) {
        return '客人取消';
      } else if (state === 100) {
        return '未接單';
      } else if (state === 110) {
        return '已接單';
      } else if (state === 120) {
        return '店家退訂';
      } else if (state === 121) {
        return '系統退訂';
      } else if (state === 122) {
        return '已取消';
      } else if (state === 130) {
        return '已完成';
      } else if (state === 140) {
        return '已作廢';
      }
    },
    shippingStateColor: function shippingStateColor(state) {
      switch (state) {
        case 19:
        case 59:
        case 900:
        case 901:
        case 910:
        case 920:
        case 921:
        case 930:
        case 940:
          return 'text-danger';
        case 0:
          return 'text-default';
        case 10:
        case 50:
        case 100:
        case 110:
        case 120:
        case 130:
          return 'text-primary';
        case 140:
          return 'text-success';
        default:
          return '';
      }
    },
    shippingStateColorBg: function shippingStateColorBg(state) {
      switch (state) {
        case 19:
        case 59:
        case 900:
        case 901:
        case 910:
        case 920:
        case 921:
        case 930:
        case 940:
          return 'bg-danger';
        case 0:
          return 'bg-default';
        case 10:
        case 50:
        case 100:
        case 110:
        case 120:
        case 130:
          return 'bg-primary';
        case 140:
          return 'bg-success';
        default:
          return '';
      }
    },
    shippingState: function shippingState(state) {
      if (state === 0) {
        return '叫件開案';
      } else if (state === 10) {
        return '已報價';
      } else if (state === 19) {
        return '報價失敗';
      } else if (state === 50) {
        return '叫件中';
      } else if (state === 59) {
        return '叫件失敗';
      } else if (state === 100) {
        return '成立物流單';
      } else if (state === 110) {
        return '物流接單';
      } else if (state === 120) {
        return '已分派外送員';
      } else if (state === 130) {
        return '已取貨';
      } else if (state === 140) {
        return '已送達';
      } else if (state === 900 || state === 901 || state === 920 || state === 921 || state === 930 || state === 940) {
        return '門市取消叫件';
      } else if (state === 920) {
        return '媒合失敗';
      }
    },
    selectStyle: function selectStyle(item) {
      var self = this;
      self.$nextTick(function () {
        self.orderList.forEach(function (item) {
          self.$set(item, 'active', false);
        });
        self.$set(item, 'active', true);
      });
    },
    outStyle: function outStyle(item) {
      this.$set(item, 'active', false);
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    changePage: function changePage(index) {
      this.tableIndex = index;
      if (index === 1) this.pageGroup = 1;
      this.getOrderList();
    },
    getOrderList: function getOrderList(page) {
      this.isLoading = true;
      if (page) {
        this.tableIndex = page;
        if (page === 1) this.pageGroup = 1;
      }
      var self = this;
      var roleType = parseInt(this.getRoleType, 10);
      var url;
      var data = {
        page: this.tableIndex,
        count: this.count,
        start_time: __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        order_sn: this.orderSn,
        shopper_name: this.shopper,
        sub_order_amount: this.subOrderAmount
      };

      var orderType = '';
      if (this.isOffline) {
        orderType = 'offlineOrder';
      } else {
        orderType = 'order';
      }

      if (this.isGuestTab) {
        url = '/' + orderType + '/shippingCaseList?page=' + data.page + '&size=' + data.count;
      } else if (roleType === 99) {
        url = '/' + orderType + '/orderList?page=' + data.page + '&size=' + data.count;
      } else if (roleType === 30) {
        url = '/' + orderType + '/brandOrderList?page=' + data.page + '&size=' + data.count;
      } else if (roleType === 10) {
        url = '/' + orderType + '/storeOrderList?page=' + data.page + '&size=' + data.count;
      }
      if (parseInt(this.searchSelect, 10) === 1) {
        url = url + '&start_time=' + data.start_time + '&end_time=' + data.end_time;
      } else if (parseInt(this.searchSelect, 10) === 2 && data.order_sn) {
        url = url + '&order_sn=' + data.order_sn;
      } else if (parseInt(this.searchSelect, 10) === 3 && data.shopper_name) {
        url = url + '&shopper_name=' + data.shopper_name;
      } else if (parseInt(this.searchSelect, 10) === 4 && data.sub_order_amount) {
        url = url + '&sub_order_amount=' + data.sub_order_amount;
      }
      if (this.$route.name === 'memberOrderTable' && this.shopperId) {
        url = url + '&integrate_shopper_id=' + this.shopperId;
      }
      if (this.brandSelect.value !== '0' && this.brandSelect.value !== 0 && url) url = url + '&brand_id=' + this.brandSelect.value;
      if (this.storeSelect.value !== '0' && this.storeSelect.value !== 0 && url) url = url + '&store_id=' + this.storeSelect.value;
      if (this.typeSelect !== '99' && this.typeSelect !== 99 && url) url = url + '&order_type=' + this.typeSelect;
      if (this.statusSelect !== '999' && this.statusSelect !== 999 && url) url = url + '&status=' + this.statusSelect;
      if (this.deTypeSelect !== '999' && this.deTypeSelect !== 999 && url) url = url + '&delivery_type=' + this.deTypeSelect;
      if (parseInt(this.trTypeSelect, 10) !== 999 && url) url = url + '&trade_type=' + this.trTypeSelect;
      if (this.isGuestTab) url = url + '&is_guest_order=1';else if (this.isOffline) url = url + '&is_guest_order=0';

      if (url) {
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.isLoading = false;
            self.orderList = self.isGuestTab ? response.data.case_list : response.data.order_list;
            self.total = response.data.total;
            self.exportMaxLimit = response.data.export_max_limit;
            if (self.orderList.length) __WEBPACK_IMPORTED_MODULE_9_jquery___default()('.odd').css('display', 'none');
          }
        }, function (error) {
          self.isLoading = false;
          self.orderList = [];
          self.total = 0;
          self.exportMaxLimit = 0;
          self.$notify({
            title: error.response.data.message,
            text: error.response.data.description,
            duration: 3000,
            type: 'danger',
            width: 400
          });
        });
      } else {
        self.isLoading = false;
      }
    },
    exportFile: function exportFile() {
      var _this = this;

      this.isDownloading = true;

      var orderType = 'order';
      if (this.isOffline) orderType = 'offlineOrder';

      var url = orderType + '/orderListSheetsSchedule?';
      if (this.isGuestTab) url = orderType + '/caseListSheetsSchedule?';

      var data = {
        count: this.count,
        start_time: __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        order_sn: this.orderSn,
        shopper_name: this.shopper,
        sub_order_amount: this.subOrderAmount
      };
      if (parseInt(this.searchSelect, 10) === 1) {
        url = url + 'start_time=' + data.start_time + '&end_time=' + data.end_time;
      } else if (parseInt(this.searchSelect, 10) === 2 && data.order_sn) {
        url = url + '&order_sn=' + data.order_sn;
      } else if (parseInt(this.searchSelect, 10) === 3 && data.shopper_name) {
        url = url + '&shopper_name=' + data.shopper_name;
      } else if (parseInt(this.searchSelect, 10) === 4 && data.sub_order_amount) {
        url = url + '&sub_order_amount=' + data.sub_order_amount;
      }

      if (this.$route.name === 'memberOrderTable' && this.shopperId) {
        url = url + '&integrate_shopper_id=' + this.shopperId;
      }

      if (this.brandSelect.value !== '0' && this.brandSelect.value !== 0 && url) url = url + '&brand_id=' + this.brandSelect.value;
      if (this.storeSelect.value !== '0' && this.storeSelect.value !== 0 && url) url = url + '&store_id=' + this.storeSelect.value;
      if (this.typeSelect !== '99' && this.typeSelect !== 99 && url) url = url + '&order_type=' + this.typeSelect;
      if (this.statusSelect !== '999' && this.statusSelect !== 999 && url) url = url + '&status=' + this.statusSelect;
      if (this.deTypeSelect !== '999' && this.deTypeSelect !== 999 && url) url = url + '&delivery_type=' + this.deTypeSelect;
      if (parseInt(this.trTypeSelect, 10) !== 999 && url) url = url + '&trade_type=' + this.trTypeSelect;
      if (this.retry === 1) {
        url = url + '&retry=1';
      }
      if (url) {
        this.getDataH('get', url, null, function (response) {
          if (response.data.sche_info.status === 3) {
            _this.isDownloading = false;
            _this.retry = 0;
            var a = document.createElement('a');
            a.href = response.data.sche_info.file_url;
            a.download = '訂單列表_' + __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY_MM_DD') + '.zip';
            document.body.appendChild(a);
            a.click();
            clearTimeout(_this.retryTimer);
            _this.retryFrequency = 0;
          } else if (response.data.sche_info.status === 9) {
            _this.isDownloading = false;
            if (_this.retryFrequency > 3) {
              alert('請聯絡客服或等24小時候再試');
              return false;
            }
            var yes = confirm('輸出未完成，請聯絡客服或再試一次。');
            if (yes) {
              _this.retryFrequency++;
            }
            clearTimeout(_this.retryTimer);
          } else {
            _this.retry = 1;
            _this.retryTimer = setTimeout(_this.exportFile, 6000);
          }
        });
      }
    },
    getBrandBrief: function getBrandBrief() {
      var _this2 = this;

      var url = '/brand/listBrief?is_delete=0&is_opening=1&list_sort=name ASC';
      this.brandBrief = [{ label: '== 品牌 ==', value: 0 }];
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            if (!bList[i].is_visible) obj.label = obj.label + ' (測)';
            _this2.brandBrief.push(obj);
            if (i === 0 && (_this2.roleType === 10 || bList.length === 1)) {
              _this2.brandSelect = { label: obj.label, value: obj.value };
            }
          }

          var brandId = _this2.$route.query.brand_id;
          if (brandId) {
            var brandSelect = _this2.brandBrief.find(function (brand) {
              return brand.value === brandId * 1;
            });
            if (brandSelect) _this2.brandSelect = brandSelect;
          }

          if (_this2.roleType === 30 || _this2.roleType === 99) _this2.getOrderList();
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.storeBrief = [];
        _this3.storeBrief = [{ label: '== 門市 ==', value: 0 }];

        var url = '/brand/' + brandId + '/storeListBrief?status=2&list_sort=name ASC';
        _this3.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            var sList = response.data.list;

            if (sList.length === 0) {
              _this3.getOrderList();
            } else {
              for (var i = 0; i < sList.length; i++) {
                var obj = { label: sList[i].name, value: sList[i].store_id };
                _this3.storeBrief.push(obj);
              }
            }

            var storeId = _this3.$route.query.store_id;
            if (!storeId) resolve();

            var storeSelect = _this3.storeBrief.find(function (store) {
              return store.value === storeId * 1;
            });

            if (storeSelect) _this3.storeSelect = storeSelect;else {
                _this3.queryChange(0, 'store_id');
                _this3.storeSelect = { label: '== 門市 ==', value: 0 };
              }

            resolve();
          } else {
            reject();
          }
        });
      });
    },
    getStoreBriefOffline: function getStoreBriefOffline(brandId) {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var url = '/brand/' + brandId + '/storeListBrief?status=3,9&list_sort=name ASC';
        _this4.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            var sList = response.data.list;
            for (var i = 0; i < sList.length; i++) {
              var obj = {
                label: sList[i].name + '\uFF08\u5DF2\u4E0B\u67B6\uFF09',
                value: sList[i].store_id
              };
              _this4.storeBrief.push(obj);
            }
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    },
    checkMemberShow: function checkMemberShow(status) {
      if (this.$route.name !== 'onSiteOrderTable') {
        if (this.roleType === 30) {
          if (status === 130 || status === 140) return true;else return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    getTime: function getTime(time) {
      if (!time) return '';
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()(time, 'YYYY-MM-DD HH:mm:ss').format('MM/DD HH:mm');
    },
    hasPaidMoneyChanged: function hasPaidMoneyChanged(order) {
      return order.paid_money !== null && order.paid_money !== undefined && order.paid_money !== order.money;
    },
    setConfig: function setConfig() {
      var query = this.$route.query;
      if (query.brand_id && this.brandBrief) {
        var brandSelect = this.brandBrief.find(function (brand) {
          return brand.value === query.brand_id * 1;
        });
        if (brandSelect) this.brandSelect = brandSelect;
      }
      if (query.store_id && this.storeBrief) {
        var storeSelect = this.storeBrief.find(function (store) {
          return store.value === query.store_id * 1;
        });
        if (storeSelect) this.storeSelect = storeSelect;
      }
      this.deTypeSelect = query.delivery_type * 1 || 999;
      this.statusSelect = query.status * 1 || 999;
      this.trTypeSelect = query.trade_type * 1 || 999;
      this.searchSelect = query.search_select * 1 || 1;
      this.typeSelect = query.order_type * 1 || 99;
      this.menuTime.start.time = __WEBPACK_IMPORTED_MODULE_8_moment___default()(query.start_time || new Date()).format('YYYY-MM-DD');
      this.menuTime.end.time = __WEBPACK_IMPORTED_MODULE_8_moment___default()(query.end_time || new Date()).format('YYYY-MM-DD');
      this.orderSn = query.order_sn || '';
      this.shopper = query.shopper_name || '';
      this.subOrderAmount = query.sub_order_amount || '';
    }
  },
  created: function created() {
    this.getBrandBrief();
    this.roleType = parseInt(this.getRoleType, 10);
    if (this.$route.name === 'memberOrderTable') this.shopperId = this.$route.params.user_id;
    if (this.$route.name === 'storeInfo') {
      this.brandSelect.value = this.$route.params.brand_id;
      this.count = 10;
    }
  },
  mounted: function mounted() {
    this.$refs.orderPaginate.tableIndex = this.tableIndex;
    this.$refs.orderPaginate.pageGroup = this.pageGroup;
    if (!this.$route.query.search_select) this.queryChange(this.searchSelect, 'search_select');
    if (this.$route.query.search_select * 1 === 1) {
      if (!this.$route.query.start_time) this.queryChange(this.menuTime.start.time, 'start_time');
      if (!this.$route.query.end_time) this.queryChange(this.menuTime.end.time, 'end_time');
    }

    this.setConfig();
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['getRoleType', 'getTradeType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getFile: function getFile() {
      return this.$parent.getFile;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    },
    isOnline: function isOnline() {
      return ['memberOrderTable', 'storeInfo', 'orderTable'].includes(this.$route.name);
    },
    isOffline: function isOffline() {
      return ['onSiteOrderMemberTable', 'onSiteOrderGuestTable', 'onSiteOrderTable'].includes(this.$route.name);
    },
    isGuestTab: function isGuestTab() {
      return this.$route.name === 'onSiteOrderGuestTable';
    }
  }),
  watch: {
    isOffline: function isOffline() {
      this.queryChange(0, 'brand_id');
      this.brandSelect = {
        label: '== 品牌 ==',
        value: 0
      };
    },
    $route: function $route(to, from) {
      if (this.$route.name === 'onSiteOrderTable') {
        this.$router.replace({ name: 'onSiteOrderMemberTable' });
        return;
      }

      if (!this.$route.query.search_select) this.queryChange(this.searchSelect, 'search_select');
      if (this.$route.query.search_select * 1 === 1) {
        if (!this.$route.query.start_time) this.queryChange(this.menuTime.start.time, 'start_time');
        if (!this.$route.query.end_time) this.queryChange(this.menuTime.end.time, 'end_time');
      }

      this.setConfig();

      if (from.name !== to.name) {
        this.orderList = [];
        this.getBrandBrief();
      }
    },
    'brandSelect.value': function brandSelectValue() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this5.$route.name === 'storeInfo')) {
                  _context.next = 6;
                  break;
                }

                _this5.storeSelect.value = _this5.$route.params.store_id;
                _context.next = 4;
                return _this5.getStoreBrief(_this5.brandSelect.value);

              case 4:
                _context.next = 6;
                return _this5.getStoreBriefOffline(_this5.brandSelect.value);

              case 6:
                if (!(_this5.brandSelect.value !== 0 && _this5.brandSelect.value !== '0')) {
                  _context.next = 11;
                  break;
                }

                _context.next = 9;
                return _this5.getStoreBrief(_this5.brandSelect.value);

              case 9:
                _context.next = 11;
                return _this5.getStoreBriefOffline(_this5.brandSelect.value);

              case 11:

                _this5.getOrderList(1);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    },
    'storeSelect.value': function storeSelectValue() {
      this.getOrderList(1);
    },
    typeSelect: function typeSelect() {
      this.getOrderList(1);
    },
    statusSelect: function statusSelect() {
      this.getOrderList(1);
    },
    deTypeSelect: function deTypeSelect() {
      this.getOrderList(1);
    },
    trTypeSelect: function trTypeSelect() {
      this.getOrderList(1);
    },
    'menuTime.end.time': function menuTimeEndTime() {
      var lastDay = __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
      if (this.menuTime.start.time > lastDay) this.menuTime.start.time = lastDay;
      this.startLimit = [{
        type: 'fromto',
        to: lastDay
      }];
    },
    'menuTime.start.time': function menuTimeStartTime() {
      var lastDay = __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.menuTime.start.time).add('90', 'days');
      if (lastDay < __WEBPACK_IMPORTED_MODULE_8_moment___default()()) this.menuTime.end.time = lastDay.format('YYYY-MM-DD');else this.menuTime.end.time = __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY-MM-DD');
      this.endLimit = [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.menuTime.start.time).subtract(1, 'days').format('YYYY-MM-DD'),
        to: __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.menuTime.end.time).add(1, 'days').format('YYYY-MM-DD')
      }];
    }
  }
});

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_clipboard2__ = __webpack_require__(2082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_clipboard2__);










__WEBPACK_IMPORTED_MODULE_6_vue_clipboard2___default.a.config.autoSetContainer = true;
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_clipboard2___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'QueryStringTemp',
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue___default.a
  },
  data: function data() {
    return {
      roleType: '',
      total: 1,
      count: 20,
      orderList: [],
      shopperId: 0,
      shopper: '',
      orderSn: '',
      subOrderAmount: '',
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      searchSelect: 1,

      brandSelect: {
        value: 0,
        label: '== 品牌 =='
      },
      storeSelect: {
        value: 0,
        label: '== 門市 =='
      },
      brand_query: {
        value: 0,
        label: '== 品牌 =='
      },
      store_query: {
        value: 0,
        label: '== 門市 =='
      },
      name_query: null,
      code_query: null,
      sourceSelect: 999,

      typeSelect: 99,
      statusSelect: 999,
      deTypeSelect: 999,
      trTypeSelect: 999,
      isCreatedTime: false,
      isCreatedStore: false,

      isCreatedStoreQ: false,

      menuTime: {
        start: {
          time: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD')
        },
        end: {
          time: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      startLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(1, 'days').format('YYYY-MM-DD')
      }],
      endLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(1, 'days').add(1, 'days').format('YYYY-MM-DD')
      }],
      brandBrief: [],
      storeBrief: [],
      storeBriefQ: [],

      brandDefault: 0,
      sourceList: [{ label: '== 來源 ==', value: 999 }, { label: '品牌入口', value: 4 }, { label: '門市入口', value: 5 }, { label: '菜單入口', value: 3 }],
      isLoading: true
    };
  },

  methods: {
    statePosition: function statePosition() {
      var roleType = parseInt(this.getRoleType, 10);
      if (roleType === 99) {
        return 'platform';
      } else if (roleType === 30) {
        return 'brand';
      } else if (roleType === 10) {
        return 'store';
      }
    },
    click_add: function click_add() {
      var self = this;
      var state = self.statePosition();
      console.log(self.storeBriefQ.length);
      if (state === 'platform') {
        if (self.brand_query.value === 0) {
          this.$notify({
            title: '請選擇品牌',
            duration: 3000,
            type: 'danger',
            width: 400
          });
        } else if (!self.name_query) {
          this.$notify({
            title: '請填寫項目名稱',
            duration: 3000,
            type: 'danger',
            width: 400
          });
        } else if (!self.code_query) {
          this.$notify({
            title: '請填寫追蹤碼',
            duration: 3000,
            type: 'danger',
            width: 400
          });
        } else if (self.sourceSelect === 999) {
          this.$notify({
            title: '請選擇入口',
            duration: 3000,
            type: 'danger',
            width: 400
          });
        } else {
          if (self.sourceSelect === 3 || self.sourceSelect === 5) {
            if (self.storeBriefQ.length === 0) {
              this.$notify({
                title: '此店家無門市',
                duration: 3000,
                type: 'danger',
                width: 400
              });
            } else if (self.store_query.value === 0) {
              this.$notify({
                title: '尚未選擇店家',
                duration: 3000,
                type: 'danger',
                width: 400
              });
            } else {
              self.postVendorCode();
            }
          } else {
            self.postVendorCode();
          }
        }
      } else if (state === 'brand') {
        if (!self.name_query) {
          this.$notify({
            title: '請填寫項目名稱',
            duration: 3000,
            type: 'danger',
            width: 400
          });
        } else if (!self.code_query) {
          this.$notify({
            title: '請填寫追蹤碼',
            duration: 3000,
            type: 'danger',
            width: 400
          });
        } else if (self.sourceSelect === 999) {
          this.$notify({
            title: '請選擇入口',
            duration: 3000,
            type: 'danger',
            width: 400
          });
        } else {
          if (self.sourceSelect === 3 || self.sourceSelect === 5) {
            if (self.storeBriefQ.length === 0) {
              this.$notify({
                title: '此店家無門市',
                duration: 3000,
                type: 'danger',
                width: 400
              });
            } else if (self.store_query.value === 0) {
              this.$notify({
                title: '尚未選擇店家',
                duration: 3000,
                type: 'danger',
                width: 400
              });
            } else {
              self.postVendorCode();
            }
          } else {
            self.postVendorCode();
          }
        }
      } else if (state === 'store') {
        if (!self.name_query) {
          this.$notify({
            title: '請填寫項目名稱',
            duration: 3000,
            type: 'danger',
            width: 400
          });
        } else if (!self.code_query) {
          this.$notify({
            title: '請填寫追蹤碼',
            duration: 3000,
            type: 'danger',
            width: 400
          });
        } else if (self.sourceSelect === 999) {
          this.$notify({
            title: '請選擇入口',
            duration: 3000,
            type: 'danger',
            width: 400
          });
        } else {
          if (self.sourceSelect === 5 || self.sourceSelect === 1 && self.store_query.value !== 0) {
            self.postVendorCode();
          } else {
            this.$notify({
              title: '請選擇門市入口',
              duration: 3000,
              type: 'danger',
              width: 400
            });
          }
        }
      }
    },
    copySuccess: function copySuccess() {
      this.$notify('已複製連結');
    },
    sourceTypeName: function sourceTypeName(type) {
      if (type === 1) {
        return '菜單入口';
      } else if (type === 2) {
        return '品牌入口';
      } else if (type === 3) {
        return '菜單入口';
      } else if (type === 4) {
        return '品牌入口';
      } else if (type === 5) {
        return '門市入口';
      }
    },
    isActive: function isActive(index) {
      if (Number(this.tableIndex) === index) return true;else return false;
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      if (index === 1) this.pageGroup = 1;
      this.getOrderList();
    },
    getOrderList: function getOrderList(page) {
      this.isLoading = true;
      if (page) {
        this.tableIndex = page;
        if (page === 1) this.pageGroup = 1;
      }
      var self = this;
      var roleType = parseInt(this.getRoleType, 10);
      var url;
      var data = {
        page: this.tableIndex,
        count: this.count,
        start_time: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        order_sn: this.orderSn,
        shopper_name: this.shopper,
        sub_order_amount: this.subOrderAmount
      };
      if (roleType === 99) {
        url = '/vendor/srcVendorCode/list?page=' + data.page + '&size=' + data.count;
      } else if (roleType === 30) {
        url = '/brand/' + self.brandSelect.value + '/srcVendorCode/list?page=' + data.page + '&size=' + data.count;
      } else if (roleType === 10) {
        url = '/store/' + self.storeSelect.value + '/srcVendorCode/list?page=' + data.page + '&size=' + data.count;
      }
      if (parseInt(this.searchSelect, 10) === 1) {
        url = url + '&start_time=' + data.start_time + '&end_time=' + data.end_time;
      } else if (parseInt(this.searchSelect, 10) === 2 && data.order_sn) {
        url = url + '&order_sn=' + data.order_sn;
      } else if (parseInt(this.searchSelect, 10) === 3 && data.shopper_name) {
        url = url + '&shopper_name=' + data.shopper_name;
      } else if (parseInt(this.searchSelect, 10) === 4 && data.sub_order_amount) {
        url = url + '&sub_order_amount=' + data.sub_order_amount;
      }
      if (this.shopperId && this.$route.name === 'memberOrderTable') url = url + '&shopper_id=' + this.shopperId;
      if (this.brandSelect.value !== '0' && this.brandSelect.value !== 0 && url) url = url + '&brand_id=' + this.brandSelect.value;
      if (this.storeSelect.value !== '0' && this.storeSelect.value !== 0 && url) url = url + '&store_id=' + this.storeSelect.value;

      if (url) {
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.orderList = response.data.list;
            console.log(self.orderList);
            self.total = response.data.total;
            if (self.orderList.length) __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.odd').css('display', 'none');
            self.isLoading = false;
          }
        });
      }
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&is_opening=1&list_sort=name ASC';
      self.brandBrief = [{ value: 0, label: '== 品牌 ==' }];
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            if (!bList[i].is_visible) obj.label = obj.label + ' (測)';
            self.brandBrief.push(obj);
            if (i === 0 && self.roleType === 10) {
              self.brandSelect = obj;
              self.brand_query = obj;
            } else if (i === 0 && bList.length === 1) {
              self.brandSelect = obj;
              self.brand_query = obj;
            }
          }
          if (self.roleType === 30 || self.roleType === 99) self.getOrderList();
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      console.log('getStoreBrief | QueryStringTemp');
      this.storeBrief = [{ value: 0, label: '==門市==' }];
      var self = this;
      var storeS = window.sessionStorage.getItem('Nidin_orderTable_storeS');
      var url = '/brand/' + brandId + '/storeListBrief?status=2&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
            if (storeS && !self.isCreatedStore) {
              self.storeSelect.value = storeS;
              self.isCreatedStore = true;
            } else if (i === 0) {
              if (self.getRoleType === '10' || self.getRoleType === 10) self.storeSelect = obj;
              self.getOrderList(1);
            }
          }
        }
      });
    },
    getStoreBriefQ: function getStoreBriefQ(brandId) {
      console.log('getStoreBriefQ | QueryStringTemp');
      this.storeBriefQ = [{ value: 0, label: '==門市==' }];
      var self = this;
      var storeS = window.sessionStorage.getItem('Nidin_orderTable_storeS');
      var url = '/brand/' + brandId + '/storeListBrief?status=2&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBriefQ.push(obj);
            if (storeS && !self.isCreatedStoreQ) {
              self.store_query.value = storeS;
              self.isCreatedStoreQ = true;
            } else if (i === 0) {
              self.getOrderList(1);
            }
            if (sList.length === 1) {
              self.store_query.value = sList[0].store_id;
            }
          }
        }
      });
    },
    delcode: function delcode(code, brand, store) {
      var self = this;
      var roleType = parseInt(self.getRoleType, 10);
      var url;
      if (roleType === 99) {
        url = '/brand/' + brand + '/srcVendorCode/' + code;
      } else if (roleType === 30) {
        url = '/brand/' + brand + '/srcVendorCode/' + code;
      } else if (roleType === 10) {
        url = '/store/' + store + '/srcVendorCode/' + code;
      }
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '刪除成功',
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.getOrderList(1);
        }
      });
    },
    postVendorCode: function postVendorCode() {
      var self = this;
      var senddata;
      var url;
      if (self.brand_query.value) var brandId = self.brand_query.value;
      if (self.store_query.value) var storeId = self.store_query.value;
      if (self.name_query) var nameQ = self.name_query;
      if (self.code_query) var codeQ = self.code_query;
      if (self.sourceSelect) var sourceQ = self.sourceSelect;

      if (storeId) {
        url = '/store/' + storeId + '/srcVendorCode';
        senddata = {
          name: nameQ,
          code: codeQ,
          url_type: sourceQ
        };
      }
      if (brandId && !storeId) {
        url = '/brand/' + brandId + '/srcVendorCode';
        senddata = {
          name: nameQ,
          code: codeQ,
          url_type: sourceQ
        };
      }
      this.getDataH('post', url, senddata, function (response) {
        if (response.data.status === 200) {
          if (self.roleType !== 10) {
            self.store_query.value = 0;
          }
          self.name_query = null;
          self.code_query = null;
          self.sourceSelect = 999;
          self.$notify('成功新增');
          self.getOrderList(1);
        }
      });
    },
    postStoreVendorCode: function postStoreVendorCode(storeId) {
      this.storeBrief = [];

      var brandId = window.sessionStorage.getItem('Nidin_orderTable_storeS');
      var url = '/brand/' + brandId + '/srcVendorCode';
      this.getDataH('post', url, null, function (response) {
        if (response.data.status === 200) {}
      });
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    },
    checkMemberShow: function checkMemberShow(status) {
      if (this.roleType === 30) {
        if (status === 130 || status === 140) return true;else return false;
      } else return true;
    },
    getTime: function getTime(time) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(time, 'YYYY-MM-DD HH:mm:ss').format('YYYY/MM/DD');
    }
  },
  created: function created() {
    this.getBrandBrief();
    this.roleType = parseInt(this.getRoleType, 10);
    if (this.$route.name === 'memberOrderTable') this.shopperId = this.$route.params.user_id;
    if (this.$route.name === 'storeInfo') {
      this.brandSelect = this.$route.params.brand_id;
      this.count = 10;
    }
    var tIndex = window.sessionStorage.getItem('Nidin_orderTable_tIndex');
    var pGroup = window.sessionStorage.getItem('Nidin_orderTable_pGroup');
    var brandS = window.sessionStorage.getItem('Nidin_orderTable_brandS');
    var storeS = window.sessionStorage.getItem('Nidin_orderTable_storeS');
    var typeS = window.sessionStorage.getItem('Nidin_orderTable_typeS');
    var statusS = window.sessionStorage.getItem('Nidin_orderTable_statusS');
    var deTypeS = window.sessionStorage.getItem('Nidin_orderTable_deTypeS');
    var trTypeS = window.sessionStorage.getItem('Nidin_orderTable_trTypeS');
    var searchS = window.sessionStorage.getItem('Nidin_orderTable_searchS');

    var orderSn = window.sessionStorage.getItem('Nidin_orderTable_orderSn');
    var shopper = window.sessionStorage.getItem('Nidin_orderTable_shopper');
    var subOrderAmount = window.sessionStorage.getItem('Nidin_orderTable_subOrderAmount');

    if (tIndex && pGroup) {}
    if (brandS && !isNaN(brandS)) this.brandSelect.value = parseInt(brandS, 10);
    if (storeS && !isNaN(storeS)) this.storeSelect.value = parseInt(storeS, 10);
    if (typeS && this.$route.name === 'orderTable' && !isNaN(typeS)) this.typeSelect = parseInt(typeS, 10);
    if (statusS && !isNaN(statusS)) this.statusSelect = parseInt(statusS, 10);
    if (deTypeS && !isNaN(deTypeS)) this.deTypeSelect = parseInt(deTypeS, 10);
    if (trTypeS && !isNaN(trTypeS)) this.trTypeSelect = parseInt(trTypeS, 10);
    if (searchS && !isNaN(searchS)) {
      this.searchSelect = parseInt(searchS, 10);
      if (this.searchSelect === 1) {} else if (this.searchSelect === 2) {
        if (orderSn) this.orderSn = orderSn;
      } else if (this.searchSelect === 3) {
        if (shopper) this.shopper = shopper;
      } else if (this.searchSelect === 4) {
        if (subOrderAmount) this.subOrderAmount = subOrderAmount;
      }
    }
  },
  mounted: function mounted() {
    this.$refs.orderPaginate.tableIndex = this.tableIndex;
    this.$refs.orderPaginate.pageGroup = this.pageGroup;
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  }),
  watch: {
    'brand_query.value': function brand_queryValue() {
      this.store_query = {
        value: 0,
        label: '== 門市 =='
      };
      if (this.$route.name === 'storeInfo') {
        this.store_query.value = this.$route.params.store_id;
        this.getStoreBriefQ(this.brand_query.value);
      }if (this.brand_query.value !== 0 && this.brand_query.value !== '0') {
        this.getStoreBriefQ(this.brand_query.value);
      } else {}
    },
    'brandSelect.value': function brandSelectValue() {
      this.storeSelect = {
        value: 0,
        label: '== 門市 =='
      };
      if (this.$route.name === 'storeInfo') {
        this.storeSelect.value = this.$route.params.store_id;
        this.getStoreBrief(this.brandSelect.value);
      }if (this.brandSelect.value !== 0 && this.brandSelect.value !== '0') {
        this.getStoreBrief(this.brandSelect.value);
      } else {
        this.getOrderList(1);
      }
      window.sessionStorage.setItem('Nidin_orderTable_brandS', this.brandSelect.value);
    },
    'storeSelect.value': function storeSelectValue() {
      this.getOrderList(1);
      window.sessionStorage.setItem('Nidin_orderTable_storeS', this.storeSelect.value);
    },
    typeSelect: function typeSelect() {
      this.getOrderList(1);
      window.sessionStorage.setItem('Nidin_orderTable_typeS', this.typeSelect);
    },
    statusSelect: function statusSelect() {
      this.getOrderList(1);
      window.sessionStorage.setItem('Nidin_orderTable_statusS', this.statusSelect);
    },
    deTypeSelect: function deTypeSelect() {
      this.getOrderList(1);
      window.sessionStorage.setItem('Nidin_orderTable_deTypeS', this.deTypeSelect);
    },
    trTypeSelect: function trTypeSelect() {
      this.getOrderList(1);
      window.sessionStorage.setItem('Nidin_orderTable_trTypeS', this.trTypeSelect);
    }
  }
});

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Temp_OrderTableTemp_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Temp_OrderTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Temp_OrderTableTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Temp_QueryStringTemp_vue__ = __webpack_require__(2236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Temp_QueryStringTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Temp_QueryStringTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Temp_OrderExceptionTableTemp_vue__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Temp_OrderExceptionTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Temp_OrderExceptionTableTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      tableIndex: 1
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#example1').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      });
    });
  },

  methods: {
    payType: function payType(type) {
      if (type === 10) {
        return '線上支付';
      } else if (type === 50) {
        return '店家支付';
      }
    },
    payStateName: function payStateName(state) {
      if (state === 11) {
        return '尚未付款';
      } else if (state === 12) {
        return '付款處理中';
      } else if (state === 13) {
        return '已收款';
      } else if (state === 21) {
        return '退款處理中';
      } else if (state === 22) {
        return '已退款';
      }
    },
    orderState: function orderState(state) {
      if (state === 0) {
        return '訂單尚未確認';
      } else if (state === 1) {
        return '訂單已送出，尚未付款';
      } else if (state === 2) {
        return '付款中';
      } else if (state === 3) {
        return '訂單已付款，尚未通知店家';
      } else if (state === 99) {
        return '使用者取消訂單';
      } else if (state === 100) {
        return '未接單';
      } else if (state === 110) {
        return '已接單';
      } else if (state === 120) {
        return '被店家退訂';
      } else if (state === 121) {
        return '被系統退訂';
      } else if (state === 122) {
        return '已取消';
      } else if (state === 130) {
        return '已完成';
      } else if (state === 140) {
        return '已作廢';
      }
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    }
  },
  components: {
    'order-table': __WEBPACK_IMPORTED_MODULE_4__Temp_OrderTableTemp_vue___default.a,
    'order-exception-table': __WEBPACK_IMPORTED_MODULE_6__Temp_OrderExceptionTableTemp_vue___default.a,
    'queryString-table': __WEBPACK_IMPORTED_MODULE_5__Temp_QueryStringTemp_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  })
});

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Temp_AdTableTemp_vue__ = __webpack_require__(2243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Temp_AdTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Temp_AdTableTemp_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      tableIndex: 1,
      show: {
        menu: false,
        menuDetail: false
      }
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#example1').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      });
    });
  },

  methods: {
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    }
  },
  components: {
    'ad-table': __WEBPACK_IMPORTED_MODULE_3__Temp_AdTableTemp_vue___default.a
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  }
});

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_AdFormTemp_vue__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_AdFormTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_AdFormTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  components: {
    'ad-form': __WEBPACK_IMPORTED_MODULE_0__Temp_AdFormTemp_vue___default.a
  },
  methods: {},
  computed: {
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    }
  }
});

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_MealTagFormTemp_vue__ = __webpack_require__(2244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_MealTagFormTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_MealTagFormTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  components: {
    'meal-tag-form': __WEBPACK_IMPORTED_MODULE_0__Temp_MealTagFormTemp_vue___default.a
  },
  methods: {},
  computed: {
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    }
  }
});

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Temp_MealTagTableTemp_vue__ = __webpack_require__(2245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Temp_MealTagTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Temp_MealTagTableTemp_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      tableIndex: 1,
      show: {
        menu: false,
        menuDetail: false
      }
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#example1').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      });
    });
  },

  methods: {
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    }
  },
  components: {
    'meal-tag-table': __WEBPACK_IMPORTED_MODULE_3__Temp_MealTagTableTemp_vue___default.a
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  }
});

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Temp_PlatformTableTemp_vue__ = __webpack_require__(2246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Temp_PlatformTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Temp_PlatformTableTemp_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      tableIndex: 1,
      show: {
        menu: false,
        menuDetail: false
      }
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#example1').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      });
    });
  },

  methods: {
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    }
  },
  components: {
    'platform-table': __WEBPACK_IMPORTED_MODULE_3__Temp_PlatformTableTemp_vue___default.a
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  }
});

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ImgUploadTemp_vue__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ImgUploadTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ImgUploadTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_timepicker__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue2_timepicker__);













/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    'info': {
      type: Object
    }
  },
  components: {
    'img-upload': __WEBPACK_IMPORTED_MODULE_6__ImgUploadTemp_vue___default.a,
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_7_vue_datepicker_vue_datepicker_es6_vue___default.a,
    VueTimepicker: __WEBPACK_IMPORTED_MODULE_8_vue2_timepicker___default.a
  },
  data: function data() {
    return {
      bannerType: Number(this.$route.query.tab) || 12,
      img: {
        width: 0,
        height: 0
      },
      adInfo: {
        city_code_list: [],
        end_time: '',
        foreverShow: 0,
        image_web_file: '',
        is_active: 1,
        is_limit_location: 0,
        name: '',
        sort: 1,
        start_time: '',
        tag_list: [{
          description: '',
          name: ''
        }],
        url: ''
      },
      storeInfo: {},

      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: ''
        }
      },
      startTime: {
        time: ''
      },
      endtime: {
        time: ''
      },
      timeoption: {
        type: 'min',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD HH:mm:ss',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      startLimit: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(-1, 'day').format('YYYY-MM-DD HH:mm:ss')
      }],
      endLimit: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD HH:mm:ss')
      }]
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['setCityList']), {
    init: function init() {
      if (this.$route.name === 'upPlatformAd') this.getAdInfo();
    },
    veritySort: function veritySort() {
      var e = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.$refs.sort);
      this.adInfo.sort = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    getAdInfo: function getAdInfo() {
      var self = this;
      var url = '/banner/websiteBanner/' + this.$route.params.ad_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var adInfo = response.data.info;
          self.adInfo = {
            name: adInfo.name,
            url: adInfo.url.trim(),
            start_time: adInfo.start_time,
            end_time: adInfo.end_time,
            is_active: adInfo.is_active,
            image_web_file: adInfo.image_web,
            sort: adInfo.sort,
            foreverShow: 0,
            is_limit_location: adInfo.is_limit_location || 0,
            city_code_list: adInfo.city_code_list || []
          };
          if (adInfo.tag_list && Array.isArray(adInfo.tag_list) && adInfo.tag_list.length) {
            self.adInfo.tag_list = adInfo.tag_list;
          } else {
            self.adInfo.tag_list = [{
              description: '',
              name: ''
            }];
          }
          self.menuTime.start.time = self.adInfo.start_time;
          self.menuTime.end.time = self.adInfo.end_time;
        }
      });
    },
    onFileChange: function onFileChange(e) {
      this.imgLogoSelect = '';
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var imgName = files[0].name.split('.');
      var imgSize = Math.round(files[0].size / 1000);
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (imgSize > 1024) {
        this.$notify({
          title: '提醒',
          text: '圖片檔案為' + imgSize + 'KB，請上傳小於1024KB之圖片',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.createImage(files[0]);
      }
    },
    createImage: function createImage(file) {
      var reader = new FileReader();
      var self = this;
      reader.onload = function (e) {
        var img = new Image();
        img.src = e.target.result;
        self.adInfo.image_web_file = img.src;
        img.onload = function () {
          self.img.width = img.width;
          self.img.height = img.height;
          self.checkImgSize();
        };
      };
      reader.readAsDataURL(file);
    },
    checkImgSize: function checkImgSize(type) {
      var self = this;
      if ((this.img.width !== 1000 || this.img.height !== 460) && this.img.width !== 0 && this.img.height !== 0 && this.bannerType === 12) {
        this.$notify({
          title: '提醒',
          text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳1000x460之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if ((this.img.width !== 720 || this.img.height !== 240) && this.img.width !== 0 && this.img.height !== 0 && this.bannerType === 31) {
        this.$notify({
          title: '提醒',
          text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳720x240之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if ((this.img.width !== 480 || this.img.height !== 530) && this.img.width !== 0 && this.img.height !== 0 && this.bannerType === 41) {
        this.$notify({
          title: '提醒',
          text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳480x530之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      }
    },
    checkBeforeSend: function checkBeforeSend(type) {
      var all = this.getInput;
      var msg = '';
      if (!all.name) {
        msg = '請輸入廣告名稱';
      } else if (!this.menuTime.start.time) {
        msg = '請輸入開始時間';
      } else if (!this.menuTime.end.time) {
        msg = '請輸入結束時間';
      } else if (!__WEBPACK_IMPORTED_MODULE_5_jquery___default()('#brand-img-load')[0].files[0] && type === 'cr') {
        msg = '請上傳一張圖片';
      } else if (all.tag_list[0].name.length !== 4 && this.bannerType === 12) {
        msg = '請輸入完整4字標籤名稱';
      } else if ((all.tag_list[0].description.length < 10 || all.tag_list[0].description.length > 17) && this.bannerType === 12) {
        msg = '請輸入10 ~ 17字廣告文案';
      }
      this.getToast(msg, type);
    },
    getToast: function getToast(msg, type) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        if (type === 'cr') this.createdAd();else if (type === 'up') this.updatedAd();
      }
    },
    getBrandImgList: function getBrandImgList() {
      var self = this;
      var url = '/brand/' + this.$route.params.brand_id + '/storesImage?image_type=1';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var logoList = response.data.list;
          for (var i = 0; i < logoList.length; i++) {
            var option = { name: logoList[i].image_name, value: logoList[i].image_url };
            self.imgLogoOption.push(option);
          }
        }
      });
      var url2 = '/brand/' + this.$route.params.brand_id + '/storesImage?image_type=3';
      this.getDataH('get', url2, null, function (response) {
        if (response.data.status === 200) {
          var bgList = response.data.list;
          for (var j = 0; j < bgList.length; j++) {
            var option2 = { name: bgList[j].image_name, value: bgList[j].image_url };
            self.imgBgOption.push(option2);
          }
        }
      });
    },
    createdAd: function createdAd() {
      console.log('createdAd');
      var self = this;
      var data = new FormData();
      var info = this.getInput;
      var name = info.name;
      var picUrl = info.url;
      var startTime = this.menuTime.start.time;
      var endTime = this.menuTime.end.time;
      var tagList = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(info.tag_list);
      if (!picUrl) picUrl = ' ';
      data.append('banner_type', this.bannerType);
      data.append('name', name);
      data.append('url', picUrl);
      data.append('start_time', startTime);
      data.append('end_time', endTime);
      data.append('sort', 1);
      data.append('is_active', this.adInfo.is_active);
      if (this.bannerType === 12) {
        data.append('tag_list', tagList);
      }

      data.append('image_web_file', __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#brand-img-load')[0].files[0]);

      data.append('is_limit_location', this.adInfo.is_limit_location);
      if (this.adInfo.is_limit_location && this.adInfo.city_code_list.length) {
        var city = this.adInfo.city_code_list.map(function (item) {
          return item.code;
        });
        if (city.length) data.append('city_code_list', city.join(','));
      }
      var url = '/banner/newWebsiteBanner';
      if (data) {
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            });
            self.$router.push({
              name: 'platformAdTable',
              query: {
                tab: self.bannerType
              }
            });
          }
        }, function (err) {
          self.handleError(err);
        });
      }
    },
    updatedAd: function updatedAd() {
      var self = this;
      var data = new FormData();
      var info = this.getInput;
      var name = info.name;
      var picUrl = info.url;
      var startTime = this.menuTime.start.time;
      var endTime = this.menuTime.end.time;
      var sort = parseInt(info.sort, 10);
      var tagList = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(info.tag_list);
      data.append('banner_type', this.bannerType);
      data.append('name', name);
      if (!picUrl) picUrl = ' ';
      data.append('url', picUrl);
      data.append('start_time', startTime);
      data.append('end_time', endTime);
      data.append('sort', sort);
      data.append('is_active', self.adInfo.is_active);
      if (this.bannerType === 12) {
        data.append('tag_list', tagList);
      }

      if (__WEBPACK_IMPORTED_MODULE_5_jquery___default()('#brand-img-load')[0].files[0]) {
        data.append('image_web_file', __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#brand-img-load')[0].files[0]);
      }

      data.append('is_limit_location', this.adInfo.is_limit_location);
      if (this.adInfo.is_limit_location && this.adInfo.city_code_list.length) {
        var city = this.adInfo.city_code_list.map(function (item) {
          return item.code;
        });
        if (city.length) data.append('city_code_list', city.join(','));
      }
      var url = '/banner/websiteBanner/' + this.$route.params.ad_id;
      if (data) {
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            });
            self.$router.push({
              name: 'platformAdTable',
              query: {
                tab: self.bannerType
              }
            });
          }
        }, function (err) {
          self.handleError(err);
        });
      }
    },
    handleError: function handleError(err) {
      var title = '';
      var text = '';
      if (err.response.data.status === 90055) {
        title = '錯誤訊息';
        text = '目前已有一進行中的蓋版廣告，若需更換廣告，請將進行中的廣告停用，再將欲上架的廣告啟用。';
      } else {
        title = err.response.data.message;
        text = err.response.data.description;
      }
      this.$notify({
        title: title,
        text: text,
        duration: 3000,
        type: 'danger',
        width: 400
      });
    }
  }),
  created: function created() {
    if (!this.getCityOption.length) {
      this.setCityList();
    }
    this.init();
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getCityOption']), {
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    },
    getInput: function getInput() {
      var aInfo = this.adInfo;
      for (var key in aInfo) {
        if (!aInfo[key] && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(aInfo[key]) === 'object') aInfo[key] = ' ';
      }
      return {
        name: this.checkInput(aInfo.name.toString()),
        url: this.checkInput(aInfo.url.toString()),
        sort: this.checkInput(aInfo.sort.toString()),
        tag_list: aInfo.tag_list
      };
    },
    defaultImage: function defaultImage() {
      var url = '';
      switch (this.bannerType) {
        case 12:
        case 31:
        case 41:
          url = '';
          break;
        default:
          break;
      }
      return url;
    },
    tipsImage: function tipsImage() {
      var size = '';
      var kb = '512';
      switch (this.bannerType) {
        case 12:
          size = '1000x460';
          break;
        case 31:
          size = '720x240';
          break;
        case 41:
          size = '480x530';
          kb = '256';
          break;
        default:
          break;
      }
      return '\u5716\u7247\u5927\u5C0F\u70BA ' + size + ' ' + kb + 'KB \u5167';
    },
    title: function title() {
      var title = '';
      switch (this.bannerType) {
        case 12:
          title = '橫幅';
          break;
        case 31:
          title = '活動Bar';
          break;
        case 41:
          title = '蓋版';
          break;
        default:
          break;
      }
      return title + '\u5EE3\u544A\u8CC7\u8A0A';
    }
  }),
  watch: {
    'menuTime.start.time': function menuTimeStartTime() {
      this.endLimit = [{
        type: 'fromto',
        from: this.menuTime.start.time
      }];
    },
    'menuTime.end.time': function menuTimeEndTime() {
      this.startLimit = [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(-1, 'day').format('YYYY-MM-DD HH:mm:ss'),
        to: this.menuTime.end.time
      }];
    },
    'adInfo.foreverShow': function adInfoForeverShow(val) {
      if (val) {
        this.menuTime.end.time = '2099-12-31 00:00:00';
      }
    }
  }
});

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_More_vue__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_More_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_elements_More_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default.a,
    More: __WEBPACK_IMPORTED_MODULE_4__components_elements_More_vue___default.a
  },
  filters: {
    status: function status(val) {
      switch (val) {
        case 'notyet':
          return '尚未開始';
        case 'going':
          return '進行中';
        case 'end':
          return '結束';
        default:
          return '';
      }
    }
  },
  data: function data() {
    return {
      bannerType: 12,
      selectActive: 99,
      show: {
        brand: false,
        menu: false,
        schedule: false,
        history: false,
        menuDetail: false
      },
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      total: 1,
      count: 20,
      adList: [],
      searchInput: '',
      isDraggable: false,
      isBatchDelete: false,

      searchType: 1,
      selectCity: []
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapActions */])(['setCityList']), {
    BatchDelete: function BatchDelete(type) {
      var _this = this;

      this.isBatchDelete = false;
      if (type) {
        var formData = this.adList.filter(function (x) {
          return x.selectItem;
        }).map(function (x) {
          return x.id;
        });
        var url = '/banner/batchDeleteWebsiteBanner?banner_ids=' + formData.toString();
        this.getDataH('delete', url, null, function (response) {
          if (response.data.status === 200) {
            _this.$notify({
              title: '提醒',
              text: '刪除平台網站廣告成功',
              duration: 3000,
              type: 'success',
              width: 400
            });
            _this.clickPage(1);
          }
        });
      }
    },
    startBatchDelete: function startBatchDelete() {
      this.isDraggable = false;
      this.isBatchDelete = true;
    },
    timeMethodColor: function timeMethodColor(val) {
      switch (val) {
        case 'notyet':
          return 'label label-default';
        case 'going':
          return 'label label-success';
        case 'end':
          return 'label label-danger';
        default:
          return '';
      }
    },
    changeBannerType: function changeBannerType(val) {
      this.$router.replace({ query: { tab: val } });
      this.bannerType = val;
      this.tableIndex = 1;
      this.getAdList();
    },
    setListOrder: function setListOrder() {
      var _this2 = this;

      var url = '/banner/sortWebsiteBanner';
      var data = {
        banner_id_list: this.adList.map(function (x) {
          return x.id;
        })
      };
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          _this2.$notify({
            title: '提醒',
            text: '編輯平台網站廣告成功',
            duration: 3000,
            type: 'success',
            width: 400
          });
          _this2.getAdList();
        }
      });
    },
    stopDrag: function stopDrag(val) {
      if (val) {
        this.setListOrder();
      } else {
        this.getAdList();
      }
      this.isDraggable = false;
    },
    startDrag: function startDrag() {
      this.isBatchDelete = false;
      this.isDraggable = true;
      this.tableIndex = 1;
      this.getAdList();
    },
    deleteBanner: function deleteBanner(id) {
      var _this3 = this;

      var url = '/banner/websiteBanner/' + id;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          _this3.$notify({
            title: '提醒',
            text: '刪除平台網站廣告成功',
            duration: 3000,
            type: 'success',
            width: 400
          });
          _this3.clickPage(1);
        }
      });
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.getAdList();
    },
    getAdList: function getAdList() {
      var self = this;
      var data = {
        page: this.tableIndex,
        size: this.count
      };
      var url = '/banner/websiteBanner/list?page=' + data.page + '&size=' + data.size + '&banner_type=' + this.bannerType;
      if (parseInt(this.selectActive, 10) !== 99) url = url + '&is_active=' + this.selectActive;
      if (this.bannerType !== 41 && this.searchType === 1 && this.searchInput.trim()) {
        url = url + '&name=' + this.searchInput;
      }
      if (this.bannerType !== 41 && this.searchType === 2 && this.selectCity.length) {
        var cityCode = this.selectCity.map(function (item) {
          return item.code;
        });
        url = url + '&city_code=' + cityCode.join(',');
      }
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.adList = response.data.list.map(function (x, index) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, x, {
              index: index + 1
            });
          });
          self.total = response.data.list_total;
        }
      });
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    }
  }),
  created: function created() {
    if (this.$route.query.tab) {
      this.bannerType = Number(this.$route.query.tab);
    }
    this.getAdList(1);
    if (!this.getCityOption.length) {
      this.setCityList();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getRoleType', 'getCityOption']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    },
    cityOption: function cityOption() {
      return [{
        name: '不限',
        code: 999
      }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.getCityOption));
    }
  }),
  watch: {
    selectActive: function selectActive() {
      this.tableIndex = 1;
      this.searchInput = '';
      this.getAdList();
    }
  }
});

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['index', 'type'],
  data: function data() {
    return {
      image: '',
      img: {
        width: 0,
        height: 0
      }
    };
  },

  methods: {
    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var imgName = files[0].name.split('.');
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.createImage(files[0]);
      }
    },
    createImage: function createImage(file) {
      var reader = new FileReader();
      var self = this;
      reader.onload = function (e) {
        var img = new Image();
        img.src = e.target.result;
        self.image = img.src;

        img.onload = function () {
          self.img.width = img.width;
          self.img.height = img.height;
        };
      };
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.img-size').css('background', 'white');
      reader.readAsDataURL(file);
    }
  }
});

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__elements_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ImgUploadTemp_vue__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ImgUploadTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ImgUploadTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_timepicker__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_timepicker__);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    'info': {
      type: Object
    }
  },
  data: function data() {
    return {
      icon: {
        width: 0,
        height: 0
      },
      img: {
        width: 0,
        height: 0
      },
      mealTagInfo: {
        name: '',
        icon_file: '',
        image_file: '',
        sort: 1,
        is_visible: 1
      },
      delOption: {
        id: 'delModal',
        title: '刪除餐點種類',
        body: '確定刪除?<br>刪除此餐點種類！',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delMealTag'
        }]
      }
    };
  },

  methods: {
    init: function init() {
      if (this.$route.name === 'upMealTag') this.getMealTagInfo();
    },
    veritySort: function veritySort() {
      var e = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$refs.sort);
      this.mealTagInfo.sort = e.val();
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/));
      }
    },
    getMealTagInfo: function getMealTagInfo() {
      var self = this;
      var url = '/mealTag/' + this.$route.params.tag_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var mealTagInfo = response.data.info;
          self.mealTagInfo = {
            name: mealTagInfo.name,
            is_visible: mealTagInfo.is_visible,
            image_file: mealTagInfo.image,
            icon_file: mealTagInfo.icon,
            sort: mealTagInfo.sort
          };
        }
      });
    },
    onIconChange: function onIconChange(e) {
      this.onFileChange(e, 'icon');
    },
    onImageChange: function onImageChange(e) {
      this.onFileChange(e, 'img');
    },
    onFileChange: function onFileChange(e, type) {
      this.imgLogoSelect = '';
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var imgName = files[0].name.split('.');
      var imgSize = Math.round(files[0].size / 1000);
      var rule = /(jpg|jpeg|png)$/i;
      if (type === 'icon') rule = /(jpg|jpeg|png|svg)$/i;
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(rule)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (imgSize > 1024) {
        this.$notify({
          title: '提醒',
          text: '圖片檔案為' + imgSize + 'KB，請上傳小於1024KB之圖片',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        this.createImage(files[0], type);
      }
    },
    createImage: function createImage(file, type) {
      var reader = new FileReader();
      var self = this;
      reader.onload = function (e) {
        var img = new Image();
        img.src = e.target.result;
        if (type === 'img') self.mealTagInfo.image_file = img.src;else if (type === 'icon') self.mealTagInfo.icon_file = img.src;
        img.onload = function () {
          if (type === 'img') {
            self.img.width = img.width;
            self.img.height = img.height;
            self.checkImgSize(type);
          } else if (type === 'icon') {
            self.icon.width = img.width;
            self.icon.height = img.height;
            console.log('icon_info', self.icon);
            self.checkImgSize(type);
          }
        };
      };
      reader.readAsDataURL(file);
    },
    checkImgSize: function checkImgSize(type) {
      var widthRule = 800;
      var heightRule = 460;
      var img = this.img;
      if (type === 'img') {
        if ((img.width !== widthRule || img.height !== heightRule) && img.width !== 0 && img.height !== 0) {
          this.$notify({
            title: '提醒',
            text: '底圖尺寸為' + img.width + 'x' + img.height + '，請上傳' + widthRule + 'x' + heightRule + '之圖片！',
            duration: 3000,
            type: 'danger',
            width: 400
          });
        }
      } else if (type === 'icon') {
        widthRule = 40;
        heightRule = 200;
        img = this.icon;
        console.log(this.icon);
        if ((img.width < widthRule || img.width > heightRule || img.height < widthRule || img.height > heightRule) && img.width !== 0 && img.height !== 0) {
          this.$notify({
            title: '提醒',
            text: '圖示為' + img.width + 'x' + img.height + '，請上傳' + widthRule + 'x' + widthRule + '~' + heightRule + 'x' + heightRule + '之圖片！',
            duration: 3000,
            type: 'danger',
            width: 400
          });
        }
      }
    },
    checkBeforeSend: function checkBeforeSend(type) {
      var all = this.getInput;
      var msg = '';
      if (!all.name) {
        msg = '請輸入餐點種類名稱';
      } else if (!__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#meal-tag-icon-load')[0].files[0] && type === 'cr') {
        msg = '請上傳圖示';
      }
      this.getToast(msg, type);
    },
    getToast: function getToast(msg, type) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        if (type === 'cr') this.createdMealTag();else if (type === 'up') this.updateMealTag();
      }
    },
    getBrandImgList: function getBrandImgList() {
      var self = this;
      var url = '/brand/' + this.$route.params.brand_id + '/storesImage?image_type=1';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var logoList = response.data.list;
          for (var i = 0; i < logoList.length; i++) {
            var option = { name: logoList[i].image_name, value: logoList[i].image_url };
            self.imgLogoOption.push(option);
          }
        }
      });
      var url2 = '/brand/' + this.$route.params.brand_id + '/storesImage?image_type=3';
      this.getDataH('get', url2, null, function (response) {
        if (response.data.status === 200) {
          var bgList = response.data.list;
          for (var j = 0; j < bgList.length; j++) {
            var option2 = { name: bgList[j].image_name, value: bgList[j].image_url };
            self.imgBgOption.push(option2);
          }
        }
      });
    },
    createdMealTag: function createdMealTag() {
      var self = this;
      var data = new FormData();
      var info = this.getInput;
      var name = info.name;
      var sort = info.sort;
      data.append('name', name);
      data.append('is_visible', this.mealTagInfo.is_visible);
      if (sort) data.append('sort', parseInt(sort, 10));

      var iconFile = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#meal-tag-icon-load')[0].files[0];
      var imgFile = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#meal-tag-img-load')[0].files[0];
      if (iconFile) data.append('icon_file', iconFile);
      if (imgFile) data.append('image_file', imgFile);
      var url = '/mealTag';
      if (data) {
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            });
            self.$router.replace('/mealTagTable');
          }
        });
      }
    },
    updateMealTag: function updateMealTag() {
      var self = this;
      var data = new FormData();
      var info = this.getInput;
      var name = info.name;
      var sort = info.sort;
      data.append('name', name);
      data.append('is_visible', this.mealTagInfo.is_visible);
      if (sort) data.append('sort', parseInt(sort, 10));

      var iconFile = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#meal-tag-icon-load')[0].files[0];
      var imgFile = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#meal-tag-img-load')[0].files[0];
      if (iconFile) data.append('icon_file', iconFile);
      if (imgFile) data.append('image_file', imgFile);
      var url = '/mealTag/' + this.$route.params.tag_id + '/syncInfo';
      if (data) {
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            });
            self.$router.replace('/mealTagTable');
          }
        });
      }
    },
    trigger: function trigger(event) {
      if (event === 'delMealTag') {
        this.delMealTag();
      }
    },
    delMealTag: function delMealTag() {
      var self = this;
      var url = '/mealTag/' + this.$route.params.tag_id;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.replace('/mealTagTable');
        }
      });
    }
  },
  created: function created() {
    this.init();
  },

  components: {
    'm-modal': __WEBPACK_IMPORTED_MODULE_1__elements_Modal_vue___default.a,
    'img-upload': __WEBPACK_IMPORTED_MODULE_4__ImgUploadTemp_vue___default.a,
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_5_vue_datepicker_vue_datepicker_es6_vue___default.a,
    VueTimepicker: __WEBPACK_IMPORTED_MODULE_6_vue2_timepicker___default.a
  },
  computed: {
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    },
    getInput: function getInput() {
      var aInfo = this.mealTagInfo;
      for (var key in aInfo) {
        if (!aInfo[key] && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(aInfo[key]) === 'object') aInfo[key] = ' ';
      }
      return {
        name: this.checkInput(aInfo.name.toString()),
        sort: this.checkInput(aInfo.sort.toString())
      };
    }
  },
  watch: {
    'menuTime.start.time': function menuTimeStartTime() {
      this.endLimit = [{
        type: 'fromto',
        from: this.menuTime.start.time
      }];
    },
    'menuTime.end.time': function menuTimeEndTime() {
      this.startLimit = [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(-1, 'day').format('YYYY-MM-DD HH:mm:ss'),
        to: this.menuTime.end.time
      }];
    }
  }
});

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      selectActive: 99,
      show: {
        brand: false,
        menu: false,
        schedule: false,
        history: false,
        menuDetail: false
      },
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      total: 1,
      count: 10,
      mealTagList: [],
      searchInput: ''
    };
  },

  methods: {
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.getmealTagList();
    },
    getmealTagList: function getmealTagList() {
      var self = this;
      var data = {
        page: this.tableIndex,
        size: this.count
      };
      var url = '/mealTag/list?page=' + data.page + '&size=' + data.size;
      if (parseInt(this.selectActive, 10) !== 99) url = url + '&is_visible=' + this.selectActive;
      if (this.searchInput.trim()) url = url + '&name=' + this.searchInput;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.mealTagList = response.data.list;
          self.total = response.data.list_total;
        }
      });
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    }
  },
  created: function created() {
    this.getmealTagList(1);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  }),
  watch: {
    selectActive: function selectActive() {
      this.tableIndex = 1;
      this.searchInput = '';
      this.getmealTagList();
    }
  }
});

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_AdFormTemp_vue__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_AdFormTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_AdFormTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      info: {
        name: '光復店',
        des: '滿200外送'
      }
    };
  },

  components: {
    'ad-form': __WEBPACK_IMPORTED_MODULE_0__Temp_AdFormTemp_vue___default.a
  },
  computed: {
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    }
  }
});

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_shared_token_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Temp_RatingTableTemp_vue__ = __webpack_require__(2249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Temp_RatingTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Temp_RatingTableTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      tableIndex: 1
    };
  },

  methods: {
    payType: function payType(type) {
      if (type === 10) {
        return '線上支付';
      } else if (type === 50) {
        return '店家支付';
      }
    },
    payStateName: function payStateName(state) {
      if (state === 11) {
        return '尚未付款';
      } else if (state === 12) {
        return '付款處理中';
      } else if (state === 13) {
        return '已收款';
      } else if (state === 21) {
        return '退款處理中';
      } else if (state === 22) {
        return '已退款';
      }
    },
    orderState: function orderState(state) {
      if (state === 0) {
        return '訂單尚未確認';
      } else if (state === 1) {
        return '訂單已送出，尚未付款';
      } else if (state === 2) {
        return '付款中';
      } else if (state === 3) {
        return '訂單已付款，尚未通知店家';
      } else if (state === 99) {
        return '使用者取消訂單';
      } else if (state === 100) {
        return '未接單';
      } else if (state === 110) {
        return '已接單';
      } else if (state === 120) {
        return '被店家退訂';
      } else if (state === 121) {
        return '被系統退訂';
      } else if (state === 122) {
        return '已取消';
      } else if (state === 130) {
        return '已完成';
      } else if (state === 140) {
        return '已作廢';
      }
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    goto: function goto() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_shared_token_js__["c" /* setSharedToken */])(window.localStorage.getItem(this.$config.token));
      window.location.href = this.$config.bdms + 'order-manage/rating';
    }
  },
  components: {
    'rating-table': __WEBPACK_IMPORTED_MODULE_4__Temp_RatingTableTemp_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  })
});

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_2_vue_datepicker_vue_datepicker_es6_vue___default.a
  },
  data: function data() {
    return {
      roleType: '',
      total: 1,
      count: 20,
      ratingList: [],
      ratingInfo: {},
      shopperId: 0,
      shopper: '',
      orderSn: '',
      subOrderAmount: '',
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      searchSelect: 1,
      brandSelect: {
        value: 0,
        label: '== 品牌 =='
      },
      storeSelect: {
        value: 0,
        label: '== 門市 =='
      },
      typeSelect: 99,
      repliedSelect: 99,
      starSelect: 0,
      mainSelect: 1,
      isCreatedTime: false,

      menuTime: {
        start: {
          time: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD')
        },
        end: {
          time: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      startLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(1, 'days').format('YYYY-MM-DD')
      }],
      endLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(1, 'days').add(1, 'days').format('YYYY-MM-DD')
      }],
      brandBrief: [],
      storeBrief: [],
      brandDefault: 0,
      mainList: [{ label: '== 所有評價 ==', value: 99 }, { label: '最新評價', value: 1 }, { label: '過去評價', value: 0 }],
      starList: [{ label: '== 星數 ==', value: 0 }, { label: '五星', value: 5 }, { label: '四星', value: 4 }, { label: '三星', value: 3 }, { label: '二星', value: 2 }, { label: '一星', value: 1 }],
      repliedList: [{ label: '== 回覆狀態 ==', value: 99 }, { label: '已回覆', value: 1 }, { label: '未回覆', value: 0 }],
      isLoading: true
    };
  },

  methods: {
    defaultComment: function defaultComment(type) {
      if (type === 1) {
        this.ratingInfo.reply_comment = '感謝您的支持與購買！希望下次能再為您服務喔 ^^';
      } else if (type === 2) {
        this.ratingInfo.reply_comment = '抱歉造成您的困擾，我們會再多注意細節的！謝謝您的體諒 ^^';
      } else if (type === 3) {
        this.ratingInfo.reply_comment = '已請客服聯絡，希望能解決您的問題！歡迎再次訂購 ^^';
      }
    },
    reply: function reply() {
      if (!this.ratingInfo.reply_comment) {
        this.$notify({
          title: '提醒',
          text: '回覆內容未填！',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (this.ratingInfo.is_replied) this.updateReplay();else this.createReplay();
    },
    updateReplay: function updateReplay() {
      var self = this;
      var url = '/rating/' + this.ratingInfo.rating_id + '/reply';
      var data = {
        comment: this.ratingInfo.reply_comment
      };
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
        }
      });
    },
    createReplay: function createReplay() {
      var self = this;
      var url = '/rating/' + this.ratingInfo.rating_id + '/reply';
      var data = {
        comment: this.ratingInfo.reply_comment
      };
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.getRatingList();
          self.ratingInfo.is_replied = 1;
        }
      });
    },
    openModal: function openModal(rating) {
      var self = this;
      var url = '/rating/' + rating.rating_id + '/info';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.ratingInfo = response.data.info;
        }
      });
    },
    brandName: function brandName(brandId) {
      var brand = this.brandBrief.find(function (brand) {
        return brandId === brand.value;
      });
      if (brand) return brand.label;
      return '';
    },
    search: function search(method) {
      if (method === 1 && this.menuTime.start.time && this.menuTime.end.time) {
        window.sessionStorage.removeItem('Nidin_orderTable_orderSn');
        window.sessionStorage.removeItem('Nidin_orderTable_shopper');
        window.sessionStorage.removeItem('Nidin_orderTable_subOrderAmount');
        this.getRatingList(1);
        window.sessionStorage.setItem('Nidin_orderTable_searchS', method);
      } else if (method === 2 && this.orderSn) {
        window.sessionStorage.removeItem('Nidin_orderTable_shopper');
        window.sessionStorage.removeItem('Nidin_orderTable_subOrderAmount');
        window.sessionStorage.setItem('Nidin_orderTable_orderSn', this.orderSn);
        this.getRatingList(1);
        window.sessionStorage.setItem('Nidin_orderTable_searchS', method);
      } else if (method === 3 && this.shopper) {
        window.sessionStorage.removeItem('Nidin_orderTable_subOrderAmount');
        window.sessionStorage.setItem('Nidin_orderTable_shopper', this.shopper);
        this.getRatingList(1);
        window.sessionStorage.setItem('Nidin_orderTable_searchS', method);
      } else if (method === 4 && parseInt(this.subOrderAmount, 10)) {
        window.sessionStorage.removeItem('Nidin_orderTable_shopper');
        window.sessionStorage.setItem('Nidin_orderTable_subOrderAmount', this.subOrderAmount);
        this.getRatingList(1);
        window.sessionStorage.setItem('Nidin_orderTable_searchS', method);
      }
    },
    clickGroup: function clickGroup(type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1;
        this.tableIndex = this.groupAmount * this.pageGroup;
        this.clickPage(this.tableIndex);
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1;
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1;
        this.clickPage(this.tableIndex);
      }
    },
    clickEnd: function clickEnd(type) {
      if (type === 'pre') {
        this.clickPage(1);
        this.pageGroup = 1;
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount);else this.clickPage(1);
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount);
      }
    },
    payType: function payType(type) {
      if (type === 10) {
        return '線上支付';
      } else if (type === 50) {
        return '店家支付';
      }
    },
    labelColor: function labelColor(type) {
      if (type === 1) {
        return 'label-default';
      } else if (type === 707 || type === 701) {
        return 'label-success';
      } else if (type === 709) {
        return 'label-danger';
      } else if (type === 710) {
        return 'label-info';
      }
    },
    stateColor: function stateColor(state) {
      if (state === 11) {
        return 'label-default';
      } else if (state === 12) {
        return 'label-primary';
      } else if (state === 13) {
        return 'label-success';
      } else if (state === 21) {
        return 'label-danger';
      } else if (state === 22) {
        return 'label-danger';
      }
    },
    tradeType: function tradeType(type) {
      if (type === 1) {
        return '現金';
      } else if (type === 707) {
        return 'LINE PAY';
      } else if (type === 701) {
        return 'iPASS MONEY';
      } else if (type === 709) {
        return '信用卡(台新)';
      } else if (type === 710) {
        return '信用卡';
      }
    },
    payStateName: function payStateName(state) {
      if (state === 11) {
        return '未付款';
      } else if (state === 12) {
        return '付款中';
      } else if (state === 13) {
        return '已收款';
      } else if (state === 21) {
        return '退款中';
      } else if (state === 22) {
        return '已退款';
      }
    },
    orderStateColor: function orderStateColor(state) {
      switch (state) {
        case 140:
        case 120:
        case 121:
        case 122:
        case 99:
          return 'label-danger';
        case 100:
          return 'label-default';
        case 110:
          return 'label-primary';
        case 130:
          return 'label-success';
        default:
          return 'label-warning';
      }
    },
    orderState: function orderState(state) {
      if (state === 0) {
        return '訂單尚未確認';
      } else if (state === 1) {
        return '訂單已送出，尚未付款';
      } else if (state === 2) {
        return '付款中';
      } else if (state === 3) {
        return '訂單已付款，尚未通知店家';
      } else if (state === 99) {
        return '客人取消';
      } else if (state === 100) {
        return '未接單';
      } else if (state === 110) {
        return '已接單';
      } else if (state === 120) {
        return '店家退訂';
      } else if (state === 121) {
        return '系統退訂';
      } else if (state === 122) {
        return '已取消';
      } else if (state === 130) {
        return '已完成';
      } else if (state === 140) {
        return '已作廢';
      }
    },
    shippingStateColor: function shippingStateColor(state) {
      switch (state) {
        case 19:
        case 59:
        case 900:
        case 901:
        case 910:
        case 920:
        case 921:
        case 930:
        case 940:
          return 'text-danger';
        case 0:
          return 'text-default';
        case 10:
        case 50:
        case 100:
        case 110:
        case 120:
        case 130:
          return 'text-primary';
        case 140:
          return 'text-success';
        default:
          return '';
      }
    },
    shippingStateColorBg: function shippingStateColorBg(state) {
      switch (state) {
        case 19:
        case 59:
        case 900:
        case 901:
        case 910:
        case 920:
        case 921:
        case 930:
        case 940:
          return 'bg-danger';
        case 0:
          return 'bg-default';
        case 10:
        case 50:
        case 100:
        case 110:
        case 120:
        case 130:
          return 'bg-primary';
        case 140:
          return 'bg-success';
        default:
          return '';
      }
    },
    shippingState: function shippingState(state) {
      if (state === 0) {
        return '叫件開案';
      } else if (state === 10) {
        return '已報價';
      } else if (state === 19) {
        return '報價失敗';
      } else if (state === 50) {
        return '叫件中';
      } else if (state === 59) {
        return '叫件失敗';
      } else if (state === 100) {
        return '成立物流單';
      } else if (state === 110) {
        return '物流接單';
      } else if (state === 120) {
        return '已分派外送員';
      } else if (state === 130) {
        return '已取貨';
      } else if (state === 140) {
        return '已送達';
      } else if (state === 900 || state === 901 || state === 910 || state === 921 || state === 930 || state === 940) {
        return '門市取消叫件';
      } else if (state === 920) {
        return '媒合失敗';
      }
    },
    selectStyle: function selectStyle(item) {
      var self = this;
      this.$nextTick(function () {
        this.ratingList.forEach(function (item) {
          self.$set(item, 'active', false);
        });
        this.$set(item, 'active', true);
      });
    },
    outStyle: function outStyle(item) {
      this.$set(item, 'active', false);
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      if (index === 1) this.pageGroup = 1;
      this.getRatingList();
    },
    getRatingList: function getRatingList(page) {
      this.isLoading = true;
      if (page) {
        this.tableIndex = page;
        if (page === 1) this.pageGroup = 1;
      }
      var self = this;
      var data = {
        start_time: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      };
      var url = '/rating/list?page=' + this.tableIndex + '&size=' + this.count;
      if (this.brandSelect.value && this.getRoleType === 99) url = url + '&brand_id=' + this.brandSelect.value;
      if (this.storeSelect.value) url = url + '&store_id=' + this.storeSelect.value;
      if (this.starSelect) url = url + '&star=' + this.starSelect;
      if (this.repliedSelect !== 99) url = url + '&is_replied=' + this.repliedSelect;
      if (this.mainSelect !== 99) url = url + '&is_main=' + this.mainSelect;
      if (parseInt(this.searchSelect, 10) === 1) {
        url = url + '&start_time=' + data.start_time + '&end_time=' + data.end_time;
      }
      if (url) {
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.ratingList = response.data.list;
            self.total = response.data.list_total;
            self.isLoading = false;
          }
        });
      }
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      self.brandBrief = [{ label: '== 品牌 ==', value: 0 }];
      var url = '/brand/listBrief?is_delete=0&is_opening=1&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };

            if (!bList[i].is_visible) obj.label = obj.label + ' (測)';
            self.brandBrief.push(obj);
            if (i === 0 && (self.roleType === 10 || bList.length === 1)) self.brandSelect = obj;
          }
          if (self.roleType === 30 || self.roleType === 99) self.getRatingList();
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      this.storeBrief = [];
      var self = this;
      self.storeBrief = [{ label: '== 門市 ==', value: 0 }];
      var url = '/brand/' + brandId + '/storeListBrief?status=1,2&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
            if (i === 0) {
              if (self.getRoleType === '10' || self.getRoleType === 10) {
                self.storeSelect.label = obj.label;
                self.storeSelect.value = obj.value;
              }
              self.getRatingList(1);
            }
          }
        }
      });
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    },
    checkMemberShow: function checkMemberShow(status) {
      if (this.roleType === 30) {
        if (status === 130 || status === 140) return true;else return false;
      } else return true;
    },
    getTime: function getTime(time) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(time, 'YYYY-MM-DD HH:mm:ss').format('MM/DD HH:mm');
    }
  },
  created: function created() {
    this.getBrandBrief();
    this.roleType = parseInt(this.getRoleType, 10);
  },
  mounted: function mounted() {
    this.$refs.orderPaginate.tableIndex = this.tableIndex;
    this.$refs.orderPaginate.pageGroup = this.pageGroup;
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  }),
  watch: {
    'brandSelect.value': function brandSelectValue() {
      this.storeSelect = { value: 0, label: '== 門市 ==' };
      if (this.$route.name === 'storeInfo') {
        this.storeSelect.value = this.$route.params.store_id;
        this.getStoreBrief(this.brandSelect.value);
      }if (this.brandSelect.value !== 0 && this.brandSelect.value !== '0') {
        this.getStoreBrief(this.brandSelect.value);
      } else {
        this.getRatingList(1);
      }
    },
    'storeSelect.value': function storeSelectValue() {
      this.getRatingList(1);
    },
    repliedSelect: function repliedSelect() {
      this.getRatingList(1);
    },
    starSelect: function starSelect() {
      this.getRatingList(1);
    },
    mainSelect: function mainSelect() {
      this.getRatingList(1);
    },
    'menuTime.end.time': function menuTimeEndTime() {
      var lastDay = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
      if (this.menuTime.start.time > lastDay) this.menuTime.start.time = lastDay;
      this.startLimit = [{
        type: 'fromto',
        to: lastDay
      }];
    },
    'menuTime.start.time': function menuTimeStartTime() {
      var lastDay = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.start.time).add('90', 'days');
      if (lastDay < __WEBPACK_IMPORTED_MODULE_3_moment___default()()) this.menuTime.end.time = lastDay.format('YYYY-MM-DD');else this.menuTime.end.time = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD');
      this.endLimit = [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.start.time).subtract(1, 'days'),
        to: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.end.time).add(1, 'days')
      }];
    }
  }
});

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_CopyScheduleProdTemp_vue__ = __webpack_require__(2268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_CopyScheduleProdTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_CopyScheduleProdTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  components: {
    'copy-prod': __WEBPACK_IMPORTED_MODULE_0__Temp_CopyScheduleProdTemp_vue___default.a
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    }
  }
});

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_DisScheduleProdTemp_vue__ = __webpack_require__(2270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_DisScheduleProdTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_DisScheduleProdTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  components: {
    'dis-prod': __WEBPACK_IMPORTED_MODULE_0__Temp_DisScheduleProdTemp_vue___default.a
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    }
  }
});

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_PrinterFormTemp_vue__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_PrinterFormTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_PrinterFormTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  components: {
    'printer-form': __WEBPACK_IMPORTED_MODULE_0__Temp_PrinterFormTemp_vue___default.a
  },
  methods: {},
  computed: {
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    }
  }
});

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_PrinterStoreFormTemp_vue__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_PrinterStoreFormTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_PrinterStoreFormTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  components: {
    'printer-form': __WEBPACK_IMPORTED_MODULE_0__Temp_PrinterStoreFormTemp_vue___default.a
  },
  methods: {},
  computed: {
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getData: function getData() {
      return this.$parent.getData;
    }
  }
});

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_LimScheduleProdTemp_vue__ = __webpack_require__(2271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_LimScheduleProdTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_LimScheduleProdTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  components: {
    'lim-prod': __WEBPACK_IMPORTED_MODULE_0__Temp_LimScheduleProdTemp_vue___default.a
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    }
  }
});

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_DisItemTableTemp_vue__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_DisItemTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Temp_DisItemTableTemp_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      roleType: 0,
      brandBrief: [],
      storeBrief: [],
      brandSelect: {
        value: 999999,
        label: ''
      },
      storeSelect: {
        value: 999999,
        label: '==門市=='
      },
      menuList: [],
      total: 1,
      count: 20,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      current: {
        store_list: [],
        name: ''
      },
      isLoading: true
    };
  },
  mounted: function mounted() {},

  components: {
    'dis-item-table': __WEBPACK_IMPORTED_MODULE_2__Temp_DisItemTableTemp_vue___default.a
  },
  methods: {
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            if (!bList[i].is_visible) obj.label = obj.label + ' (測)';
            self.brandBrief.push(obj);
            if (i === 0) self.brandSelect = obj;
          }
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      console.log('getStoreBrief | DisItemTable');
      this.storeBrief = [{ label: '==門市==', value: 999999 }];
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
            if (i === 0 && self.getRoleType === 10) {
              self.storeSelect = obj;
            } else if (i === 0) self.storeSelect.value = 999999;
          }
          if (!sList.length) {
            self.menuList = [];
            self.total = 0;
          }
          self.getOnlineMenu();
        }
      });
    },
    getOnlineMenu: function getOnlineMenu() {
      this.isLoading = true;
      var self = this;
      var url = '/onlineMenu/list?page=' + this.tableIndex + '&size=' + this.count + '&brand_id=' + this.brandSelect.value;
      if (this.storeSelect.value !== 999999) url = url + '&store_id=' + this.storeSelect.value;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.menuList = response.data.menu_list;
          self.total = response.data.total;
          self.isLoading = false;
        }
      });
    },
    clickCurrent: function clickCurrent(menu) {
      this.current = menu;
    },
    clickGroup: function clickGroup(type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1;
        this.tableIndex = this.groupAmount * this.pageGroup;
        this.clickPage(this.tableIndex);
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1;
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1;
        this.clickPage(this.tableIndex);
      }
    },
    clickEnd: function clickEnd(type) {
      if (type === 'pre') {
        this.clickPage(1);
        this.pageGroup = 1;
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount);else this.clickPage(1);
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount);
      }
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      if (index === 1) this.pageGroup = 1;
      this.getOnlineMenu();
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    goPage: function goPage() {
      if (this.storeSelect.value !== 999999) {
        this.$router.push('/disItemTable/' + this.brandSelect.value + '/' + this.storeSelect.value);
      } else if (this.brandSelect.value && this.storeSelect.value === 999999) {
        this.$router.push('/disItemTable/' + this.brandSelect.value);
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  }),
  created: function created() {
    this.roleType = parseInt(this.getRoleType, 10);
    this.fixedH();
    this.getBrandBrief();
  },

  watch: {
    'brandSelect.value': function brandSelectValue() {
      this.storeSelect = {
        value: 999999,
        label: '==門市=='
      };
      this.getStoreBrief(this.brandSelect.value);
    },
    'storeSelect.value': function storeSelectValue() {
      this.getOnlineMenu();
    }
  }
});

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_DisItemTableHistoryTemp_vue__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_DisItemTableHistoryTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_DisItemTableHistoryTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DisItemTableBrand',
  components: {
    'dis-item-table-history': __WEBPACK_IMPORTED_MODULE_0__Temp_DisItemTableHistoryTemp_vue___default.a
  },
  data: function data() {
    return {
      tableIndex: 1
    };
  },

  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  },
  methods: {},
  watch: {}
});

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_DisItemTableTemp_vue__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_DisItemTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Temp_DisItemTableTemp_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      roleType: 0,
      brandBrief: [],
      storeBrief: [],
      brandSelect: 99,
      storeSelect: 99
    };
  },
  mounted: function mounted() {},

  components: {
    'dis-item-table': __WEBPACK_IMPORTED_MODULE_2__Temp_DisItemTableTemp_vue___default.a
  },
  methods: {
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            self.brandBrief.push(obj);
            if (i === 0) self.brandSelect = obj.value;
          }
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      console.log('getStoreBrief | DisItemTableOld');
      this.storeBrief = [];
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
            if (i === 0) {
              self.storeSelect = obj.value;
            }
          }
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    }
  }),
  created: function created() {
    this.roleType = parseInt(this.getRoleType, 10);
    this.fixedH();
    this.getBrandBrief();
  },

  watch: {
    brandSelect: function brandSelect() {
      this.getStoreBrief(this.brandSelect);
    }
  }
});

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_DisItemTableHistoryTemp_vue__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_DisItemTableHistoryTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_DisItemTableHistoryTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DisItemTableStore',
  components: {
    'dis-item-table-history': __WEBPACK_IMPORTED_MODULE_0__Temp_DisItemTableHistoryTemp_vue___default.a
  },
  data: function data() {
    return {
      tableIndex: 1
    };
  },

  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  },
  methods: {},
  watch: {}
});

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_DisProdTemp_vue__ = __webpack_require__(2269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_DisProdTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_DisProdTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  components: {
    'dis-prod': __WEBPACK_IMPORTED_MODULE_0__Temp_DisProdTemp_vue___default.a
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    }
  }
});

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Temp_DisItemTableTemp_vue__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Temp_DisItemTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Temp_DisItemTableTemp_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      roleType: 0,
      brandBrief: [],
      storeBrief: [],
      brandSelect: {
        value: 999999,
        label: ''
      },
      storeSelect: {
        value: 999999,
        label: '==門市=='
      },
      settingList: [],
      total: 1,
      count: 20,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      current: {
        store_list: [],
        name: ''
      },
      isLoading: true
    };
  },
  mounted: function mounted() {},

  components: {
    'dis-item-table': __WEBPACK_IMPORTED_MODULE_5__Temp_DisItemTableTemp_vue___default.a
  },
  methods: {
    getStoreInfo: function getStoreInfo(storeID) {
      var self = this;
      var url = '/store/' + storeID + '/info';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.brandSelect.value = Number(response.data.info.brand_id);
          if (response.data.info.is_visible === 1) {
            self.brandSelect.label = response.data.info.brand_name + ' (測)';
          } else {
            self.brandSelect.label = response.data.info.brand_name;
          }
        }
      });
    },
    getBrandBrief: function getBrandBrief() {
      var _this = this;

      var self = this;
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      var roleType = parseInt(this.getRoleType, 10);
      var brand = Number(self.$route.query.brand);
      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            var bList = response.data.list;
            for (var i = 0; i < bList.length; i++) {
              var obj = { label: bList[i].name, value: bList[i].brand_id };
              if (!bList[i].is_visible) obj.label = obj.label + ' (測)';
              self.brandBrief.push(obj);
              if (i === 0 && !brand) {
                self.brandSelect = obj;
              }
              if (roleType !== 99 && roleType !== 30) {
                self.getStoreBrief(self.brandSelect.value);
              } else if (self.$route.query.brand) {
                if (brand === obj.value) {
                  self.brandSelect.label = obj.label;
                  self.getOnlineMenu();
                }
              }
            }
            return resolve();
          }
        });
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      console.log('getStoreBrief | DisScheduleItemTable');
      if (this.roleType !== 10) this.storeBrief = [{ label: '==門市==', value: 999999 }];else this.storeBrief = [];
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          if (self.roleType !== 10) {
            self.storeSelect = {
              value: 999999,
              label: '== 門市 =='
            };
          }
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);

            if (i === 0 && self.getRoleType === 10) {
              self.storeSelect = obj;
              self.getOnlineMenu();
            } else if (self.$route.query.store) {
              var store = Number(self.$route.query.store);
              if (store === obj.value) {
                self.storeSelect = obj;
                self.getOnlineMenu();
              }
            }
          }
          if (!sList.length) {
            self.settingList = [];
            self.total = 0;
          }
        }
      });
    },
    getOnlineMenu: function getOnlineMenu(type) {
      var _this2 = this;

      this.isLoading = true;
      var self = this;

      var url = '/productDisableScheduleSetting/group/list?&size=' + this.count;
      var queryValue = {};
      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (type !== 'useBrand' && _this2.storeSelect.value !== 999999 && (self.getRoleType === 99 || self.getRoleType === 30)) {
          if (_this2.$route.query.store !== _this2.storeSelect.value) {
            queryValue = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, queryValue, { store: _this2.storeSelect.value });
            _this2.tableIndex = 1;
          } else queryValue = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, queryValue, { store: _this2.storeSelect.value });
          url = '/brand/' + _this2.brandSelect.value + url + '&apply_store_id=' + _this2.storeSelect.value;
        } else if (_this2.brandSelect.value !== 999999 && (self.getRoleType === 99 || self.getRoleType === 30)) {
          if (_this2.$route.query.brand !== _this2.brandSelect.value) {
            _this2.tableIndex = 1;
            queryValue = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, queryValue, { brand: _this2.brandSelect.value, page: 1 });
          } else queryValue = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, queryValue, { brand: _this2.brandSelect.value });
          url = '/brand/' + _this2.brandSelect.value + url;
        }
        if (_this2.tableIndex) {
          queryValue = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, queryValue, { page: _this2.tableIndex });
          url = url + '&page=' + _this2.tableIndex;
        }

        if (!_this2.$route.query.brand && !_this2.$route.query.store && _this2.getRoleType !== 10) {}
        if (_this2.getRoleType === 10 && _this2.storeSelect.value !== 999999) {
          url = '/store/' + _this2.storeSelect.value + url;
        }
        _this2.$router.push({ query: queryValue });
        _this2.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.settingList = response.data.list;
            self.isLoading = false;
            self.total = response.data.meta.total;
            return resolve();
          }
        });
      });
    },
    clickCurrent: function clickCurrent(menu) {
      this.current = menu;
    },
    clickGroup: function clickGroup(type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1;
        this.tableIndex = this.groupAmount * this.pageGroup;
        this.clickPage(this.tableIndex);
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1;
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1;
        this.clickPage(this.tableIndex);
      }
    },
    clickEnd: function clickEnd(type) {
      if (type === 'pre') {
        this.clickPage(1);
        this.pageGroup = 1;
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount);else this.clickPage(1);
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount);
      }
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      if (index === 1) this.pageGroup = 1;
      this.getOnlineMenu();
    },
    isActive: function isActive(index) {
      if (Number(this.tableIndex) === index) return true;else return false;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  }),
  created: function created() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this3.roleType = parseInt(_this3.getRoleType, 10);
              _this3.fixedH();

              if (!_this3.$route.query.brand) {
                _context.next = 6;
                break;
              }

              _context.next = 5;
              return _this3.$route.query.brand;

            case 5:
              _this3.brandSelect.value = _context.sent;

            case 6:
              if (!_this3.$route.query.page) {
                _context.next = 10;
                break;
              }

              _context.next = 9;
              return _this3.$route.query.page;

            case 9:
              _this3.tableIndex = _context.sent;

            case 10:
              _context.next = 12;
              return _this3.getBrandBrief();

            case 12:
              if (!(_this3.$route.query.store && _this3.roleType !== 10)) {
                _context.next = 16;
                break;
              }

              if (_this3.roleType === 30) {
                _this3.storeSelect.value = _this3.$route.query.store;
              }
              _context.next = 16;
              return _this3.getStoreInfo(_this3.$route.query.store);

            case 16:
              if (!(!_this3.$route.query.brand && !_this3.$route.query.store && _this3.roleType !== 10)) {
                _context.next = 19;
                break;
              }

              _context.next = 19;
              return _this3.getOnlineMenu();

            case 19:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  },

  watch: {
    'brandSelect.value': function brandSelectValue() {
      if (this.brandSelect.value !== 999999 && this.brandSelect && (this.roleType === 99 || this.roleType === 30)) {
        this.getStoreBrief(this.brandSelect.value);
      }
    }
  }
});

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Temp_DisItemTableTemp_vue__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Temp_DisItemTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Temp_DisItemTableTemp_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LimitedScheduleItemTable',
  data: function data() {
    return {
      roleType: 0,
      brandBrief: [],
      storeBrief: [],
      brandSelect: {
        value: 999999,
        label: ''
      },
      storeSelect: {
        value: 999999,
        label: '==門市=='
      },
      settingList: [],
      total: 1,
      count: 20,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      current: {
        store_list: [],
        name: ''
      },
      checkBoxSelectAll: false,
      del_fun: false,
      delLimitAmountOption: {
        id: 'limiModal',
        title: '刪除勾選的限時限量設定',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delSelectedLimit'
        }]
      },
      enable_add: false,
      selectAllItem: false,
      isLoading: true
    };
  },
  mounted: function mounted() {},

  components: {
    'dis-item-table': __WEBPACK_IMPORTED_MODULE_5__Temp_DisItemTableTemp_vue___default.a
  },
  methods: {
    trigger: function trigger(event) {
      if (event === 'delSelectedLimit') {
        this.deleteLimitAmount();
      }
    },
    deleteLimitAmount: function deleteLimitAmount() {
      var _this = this;

      var deleteItem = this.settingList.filter(function (x) {
        return x.selectItem;
      }).map(function (x) {
        return x.setting_id;
      });
      if (deleteItem.length > 0) {
        var url = 'storeOrderAmountLimitSetting/batchDelete?setting_ids=' + deleteItem.toString();
        this.getDataH('delete', url, null, function (response) {
          if (response.data.status === 200) {
            _this.del_fun = false;
            _this.getAmountLimitSetting();
          }
        });
      }
    },
    del_item: function del_item() {
      this.del_fun = true;
    },
    enable_limit: function enable_limit() {
      if (this.storeSelect.value === 999999 || !this.storeSelect) {
        this.$notify({
          title: '請選擇門市',
          text: '請選擇門市',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else if (this.enable_add) {
        this.$router.push('/crLimitScheduleItem?store_id=' + this.storeSelect.value + '&brand_id=' + this.brandSelect.value);
      } else {
        this.$notify({
          title: '設定已啟用',
          text: '設定已啟用',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      }
    },
    selectAll: function selectAll() {
      var _this2 = this;

      this.settingList = this.settingList.map(function (x) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, x, {
          selectItem: _this2.selectAllItem
        });
      });
    },
    getStoreInfo: function getStoreInfo(storeID) {
      var self = this;
      var url = '/store/' + storeID + '/info';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.brandSelect.value = Number(response.data.info.brand_id);
          if (response.data.info.is_visible === 1) {
            self.brandSelect.label = response.data.info.brand_name + ' (測)';
          } else {
            self.brandSelect.label = response.data.info.brand_name;
          }
        }
      });
    },
    getBrandBrief: function getBrandBrief() {
      var _this3 = this;

      var self = this;
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      var roleType = parseInt(this.getRoleType, 10);
      var brand = Number(self.$route.query.brand);
      var store = Number(self.$route.query.store);
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            var bList = response.data.list;
            for (var i = 0; i < bList.length; i++) {
              var obj = { label: bList[i].name, value: bList[i].brand_id };
              if (!bList[i].is_visible) obj.label = obj.label + ' (測)';
              self.brandBrief.push(obj);

              if (i === 0 && !brand && !store) {
                self.brandSelect = obj;
              }
              if (roleType !== 99 && roleType !== 30) {
                self.getStoreBrief(self.brandSelect.value);
              } else if (self.$route.query.brand) {
                if (brand === obj.value) {
                  self.brandSelect.label = obj.label;
                  self.getAmountLimitSetting();
                }
              }
            }
            return resolve();
          }
        });
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      console.log('getStoreBrief | LimitedScheduleItemTable');
      if (this.roleType !== 10) this.storeBrief = [{ label: '==門市==', value: 999999 }];else this.storeBrief = [];
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          if (self.roleType !== 10) {
            self.storeSelect = {
              value: 999999,
              label: '== 門市 =='
            };
          }
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);

            if (i === 0 && self.getRoleType === 10) {
              self.storeSelect = obj;
              self.getAmountLimitSetting();
            } else if (self.$route.query.store) {
              var store = Number(self.$route.query.store);
              if (store === obj.value) {
                self.storeSelect = obj;
                self.getAmountLimitSetting();
              }
            }
          }
          if (!sList.length) {
            self.settingList = [];
            self.total = 0;
          }
        }
      });
    },
    getAmountLimitSetting: function getAmountLimitSetting(type) {
      var _this4 = this;

      this.isLoading = true;
      var self = this;

      var url = '/storeOrderAmountLimitSetting/list?size=' + this.count;
      var queryValue = {};
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (type !== 'useBrand' && _this4.storeSelect.value !== 999999 && (self.getRoleType === 99 || self.getRoleType === 30)) {
          if (_this4.$route.query.store !== _this4.storeSelect.value) {
            queryValue = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, queryValue, { store: _this4.storeSelect.value });
            _this4.tableIndex = 1;
          } else queryValue = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, queryValue, { store: _this4.storeSelect.value });
          url = url + '&brand_id=' + _this4.brandSelect.value + '&store_id=' + _this4.storeSelect.value;
        } else if (_this4.brandSelect.value !== 999999 && (self.getRoleType === 99 || self.getRoleType === 30)) {
          if (_this4.$route.query.brand !== _this4.brandSelect.value) {
            _this4.tableIndex = 1;
            queryValue = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, queryValue, { brand: _this4.brandSelect.value, page: 1 });
          } else queryValue = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, queryValue, { brand: _this4.brandSelect.value });
          url = url + '&brand_id=' + _this4.brandSelect.value;
        }
        if (self.tableIndex) {
          queryValue = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, queryValue, { page: _this4.tableIndex });
          url = url + '&page=' + _this4.tableIndex;
        }

        if (!_this4.$route.query.brand && !_this4.$route.query.store && _this4.getRoleType !== 10) {}
        if (self.getRoleType === 10 && self.storeSelect.value !== 999999) {
          url = url + '&brand_id=' + _this4.brandSelect.value + '&store_id=' + _this4.storeSelect.value;
        }
        _this4.$router.push({ query: queryValue });
        _this4.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.enable_add = false;
            self.settingList = response.data.list;
            self.isLoading = false;
            if (self.settingList.length === 0 && self.storeSelect.value && self.storeSelect.value !== 999999) {
              self.enable_add = true;
            }
            self.total = response.data.meta.total;
            return resolve();
          }
        });
      });
    },
    clickCurrent: function clickCurrent(menu) {
      this.current = menu;
    },
    clickGroup: function clickGroup(type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1;
        this.tableIndex = this.groupAmount * this.pageGroup;
        this.clickPage(this.tableIndex);
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1;
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1;
        this.clickPage(this.tableIndex);
      }
    },
    clickEnd: function clickEnd(type) {
      if (type === 'pre') {
        this.clickPage(1);
        this.pageGroup = 1;
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount);else this.clickPage(1);
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount);
      }
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      if (index === 1) this.pageGroup = 1;
      this.getAmountLimitSetting();
    },
    isActive: function isActive(index) {
      if (Number(this.tableIndex) === index) return true;else return false;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  }),
  created: function created() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this5.roleType = parseInt(_this5.getRoleType, 10);
              _this5.fixedH();

              if (!_this5.$route.query.brand) {
                _context.next = 6;
                break;
              }

              _context.next = 5;
              return _this5.$route.query.brand;

            case 5:
              _this5.brandSelect.value = _context.sent;

            case 6:
              if (!_this5.$route.query.page) {
                _context.next = 10;
                break;
              }

              _context.next = 9;
              return _this5.$route.query.page;

            case 9:
              _this5.tableIndex = _context.sent;

            case 10:
              _context.next = 12;
              return _this5.getBrandBrief();

            case 12:
              if (!(_this5.$route.query.store && _this5.roleType !== 10)) {
                _context.next = 16;
                break;
              }

              if (_this5.roleType === 30) {
                _this5.storeSelect.value = _this5.$route.query.store;
              }
              _context.next = 16;
              return _this5.getStoreInfo(_this5.$route.query.store);

            case 16:
              if (!(!_this5.$route.query.brand && !_this5.$route.query.store && _this5.roleType !== 10)) {
                _context.next = 19;
                break;
              }

              _context.next = 19;
              return _this5.getAmountLimitSetting();

            case 19:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this5);
    }))();
  },

  watch: {
    'brandSelect.value': function brandSelectValue() {
      if (this.brandSelect.value !== 999999 && this.brandSelect && (this.roleType === 99 || this.roleType === 30)) {
        this.getStoreBrief(this.brandSelect.value);
      }
    },
    'storeSelect.value': function storeSelectValue() {
      if (this.storeSelect.value === 999999) {
        this.enable_add = false;
      }
    }
  }
});

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_MqttSearchTemp_vue__ = __webpack_require__(2272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_MqttSearchTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Temp_MqttSearchTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_datepicker_vue_datepicker_es6_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      roleType: 0,
      name: '',
      statusSelect: 99,
      isSearch: {
        active: false
      },

      date: {
        time: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD')
      },
      dateLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(1, 'days').format('YYYY-MM-DD')
      }],
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true }
    };
  },

  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_4_vue_datepicker_vue_datepicker_es6_vue___default.a,
    'mqtt-table': __WEBPACK_IMPORTED_MODULE_2__Temp_MqttSearchTemp_vue___default.a
  },
  methods: {
    clickSearch: function clickSearch() {
      this.isSearch.active = true;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    }
  }),
  mounted: function mounted() {
    this.clickSearch();
  }
});

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_MqttTableTemp_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_MqttTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Temp_MqttTableTemp_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      roleType: 0,
      brandBrief: [],
      storeBrief: [],
      brandSelect: {
        value: 99,
        label: '==品牌=='
      },
      storeSelect: 99,
      searchSelect: 1,
      search: {
        status: false,
        val: '',
        type: 1
      }
    };
  },
  mounted: function mounted() {},

  components: {
    'mqtt-table': __WEBPACK_IMPORTED_MODULE_2__Temp_MqttTableTemp_vue___default.a
  },
  methods: {
    clickSearch: function clickSearch() {
      this.search.type = this.searchSelect;
      this.search.status = true;
    },
    getBrandBrief: function getBrandBrief(type) {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            if (!bList[i].is_visible) obj.label = obj.label + ' (測)';
            self.brandBrief.push(obj);
            if (i === 0) self.brandSelect = obj;
          }
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      console.log('getStoreBrief | MqttTable');
      this.storeBrief = [];
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
            if (i === 0) {
              self.storeSelect = obj.value;
            }
          }
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    }
  }),
  created: function created() {
    this.roleType = parseInt(this.getRoleType, 10);
    this.fixedH();
    this.getBrandBrief();
  },

  watch: {
    'brandSelect.value': function brandSelectValue() {
      this.getStoreBrief(this.brandSelect.value);
    }
  }
});

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_MqttTableTemp_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_MqttTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Temp_MqttTableTemp_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      printerInfo: {},
      storeList: []
    };
  },
  mounted: function mounted() {},

  components: {
    'mqtt-table': __WEBPACK_IMPORTED_MODULE_2__Temp_MqttTableTemp_vue___default.a
  },
  methods: {
    printerType: function printerType(type) {
      switch (type) {
        case 1:
          return '熒埔';
        case 2:
          return '飛鵝';
      }
    },
    getPrinterInfo: function getPrinterInfo() {
      var self = this;
      var url = '/printer/' + this.$route.params.printer_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.printerInfo = response.data.printer;
          self.storeList = self.printerInfo.store_list;
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  }),
  created: function created() {
    this.fixedH();
    this.getPrinterInfo();
  }
});

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_MqttTableTemp_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_MqttTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Temp_MqttTableTemp_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      total: 1,
      count: 10,
      searchResult: '',
      printerList: []
    };
  },
  mounted: function mounted() {},

  components: {
    'mqtt-table': __WEBPACK_IMPORTED_MODULE_2__Temp_MqttTableTemp_vue___default.a
  },
  methods: {
    printerType: function printerType(type) {
      switch (type) {
        case 1:
          return '熒埔';
        case 2:
          return '飛鵝';
      }
    },
    clickGroup: function clickGroup(type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1;
        this.tableIndex = this.groupAmount * this.pageGroup;
        this.clickPage(this.tableIndex);
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1;
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1;
        this.clickPage(this.tableIndex);
      }
    },
    clickEnd: function clickEnd(type) {
      if (type === 'pre') {
        this.clickPage(1);
        this.pageGroup = 1;
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount);else this.clickPage(1);
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount);
      }
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.getPrinterList();
    },
    getPrinterList: function getPrinterList() {
      var self = this;
      var url = '/printer/storePrinterList/' + this.$route.params.store_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.printerList = response.data.list;
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  }),
  created: function created() {
    this.fixedH();
    this.getPrinterList();
  }
});

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_MqttTableTemp_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_MqttTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Temp_MqttTableTemp_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      total: 1,
      count: 10,
      searchResult: '',
      printerList: [],
      isLoading: true
    };
  },
  mounted: function mounted() {},

  components: {
    'mqtt-table': __WEBPACK_IMPORTED_MODULE_2__Temp_MqttTableTemp_vue___default.a
  },
  methods: {
    printerType: function printerType(type) {
      switch (type) {
        case 1:
          return '熒埔';
        case 2:
          return '飛鵝';
      }
    },
    clickGroup: function clickGroup(type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1;
        this.tableIndex = this.groupAmount * this.pageGroup;
        this.clickPage(this.tableIndex);
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1;
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1;
        this.clickPage(this.tableIndex);
      }
    },
    clickEnd: function clickEnd(type) {
      if (type === 'pre') {
        this.clickPage(1);
        this.pageGroup = 1;
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount);else this.clickPage(1);
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount);
      }
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.getPrinterList();
    },
    getPrinterList: function getPrinterList() {
      this.isLoading = true;
      var self = this;
      var data = {
        page: this.tableIndex,
        size: this.count
      };
      var url = '/printer/list?page=' + data.page + '&size=' + data.size;
      if (this.searchResult) url = url + '&identity=' + this.searchResult;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.printerList = response.data.list;
          self.isLoading = false;
          self.total = response.data.total;
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  }),
  created: function created() {
    this.fixedH();
    this.getPrinterList();
  }
});

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_TableSettingTemp_vue__ = __webpack_require__(2273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Temp_TableSettingTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Temp_TableSettingTemp_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      roleType: 0,
      brandBrief: [],
      storeBrief: [],
      brandSelect: 0,
      storeSelect: 0
    };
  },
  mounted: function mounted() {},

  components: {
    'table-setting-table': __WEBPACK_IMPORTED_MODULE_2__Temp_TableSettingTemp_vue___default.a
  },
  methods: {
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            self.brandBrief.push(obj);
            if (i === 0) self.brandSelect = obj.value;
          }
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      console.log('getStoreBrief | TableSetting');
      this.storeBrief = [];
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
            if (i === 0) {
              self.storeSelect = obj.value;
            }
          }
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    }
  }),
  created: function created() {
    this.roleType = parseInt(this.getRoleType, 10);
    this.fixedH();
    this.getBrandBrief();
  },

  watch: {
    brandSelect: function brandSelect() {
      this.getStoreBrief(this.brandSelect);
    }
  }
});

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_timepicker__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_timepicker__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default.a,
    VueTimepicker: __WEBPACK_IMPORTED_MODULE_2_vue2_timepicker___default.a
  },
  data: function data() {
    return {
      menuState: 4,
      name: '',
      description: '',
      total: 1,
      count: 20,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      scheduleList: [],
      bindList: [],
      is_enabled: 1,
      vendor_custom_id: '',
      alias_name: '',
      prod_description: '',
      prod_description_list: [{ prod_description: '' }],
      addAmount: 5,
      settingId: '',
      type: 1,
      currentId: '',
      smImgSrc: '',
      up: false,
      enableOption: [{ label: '啟用', value: 1 }, { label: '關閉', value: 0 }],
      delOption: {
        id: 'delModal',
        title: '刪除時段停賣設定',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delDisableSchedule'
        }]
      },
      delItemOption: {
        id: 'delModal',
        title: '刪除商品設定',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delDisableScheduleItem'
        }]
      },

      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: ''
        }
      },
      startTime: {
        time: ''
      },
      endtime: {
        time: ''
      },
      dateoption_rule: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px 12px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555',
          'width': '248px',
          'min-width': '248px',
          'text-align': 'left'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px 12px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555',
          'width': '280px',
          'min-width': '280px',
          'text-align': 'left'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      startLimit: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(-1, 'day').format('YYYY-MM-DD HH:mm:ss')
      }],
      endLimit: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD HH:mm:ss')
      }],
      limit_rule: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(-1, 'day').format('YYYY-MM-DD HH:mm:ss')
      }],
      prodTypeOptions: [{ label: '商品', value: 1 }, { label: '套餐', value: 3 }, { label: '配料', value: 2 }, { label: '商品分類', value: 10 }, { label: '品項選擇區', value: 11 }, { label: '配料群組', value: 20 }],
      srcIdTypeOptions: [{ label: '廠商料號', value: 1 }, { label: '平台商品ID', value: 2 }],
      item_list: [],
      rule_list: [],
      ruleTypeOptions: [{ label: '每日', value: 0 }, { label: '指定日期', value: 1 }, { label: '指定星期', value: 2 }, { label: '每月幾號', value: 3 }],
      offdaySetting: {
        options: {
          weekDay: [{ label: '週日', value: 1 }, { label: '週一', value: 2 }, { label: '週二', value: 3 }, { label: '週三', value: 4 }, { label: '週四', value: 5 }, { label: '週五', value: 6 }, { label: '週六', value: 7 }]
        }
      },

      brandSelect: {
        value: 999999,
        label: '==品牌=='
      },
      storeSelect: {
        value: 999999,
        label: '所有門市'
      },

      brandBrief: [],
      storeBrief: [],
      addStoresSetting: {
        options: [],
        choose: []
      },

      menuId: null,
      brandId: null,
      category: [],
      product: [],
      prodNumList: {},
      menuInfo: {},
      menuList: '',

      created: false,
      getTimes: 0,
      time: 0,
      accessory: [],
      disTableList: [],
      adjustCheckbox: false,
      options: [],

      trigger_load_menu: true,
      loadmenu_id: null
    };
  },

  methods: {
    getStoreLimitSetting: function getStoreLimitSetting(brandId) {
      var self = this;
      self.storeBrief = [];
      var url = '/storeOrderAmountLimitSetting/getStoreList?brand_id=' + brandId + '&type=create';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.store_list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].store_name, value: sList[i].store_id };
            self.storeBrief.push(obj);
            if (i === 0 && self.getRoleType === 10) {
              self.storeSelect = obj;
            } else if (i === 0) self.storeSelect.value = 999999;
          }


          self.addStoresSetting.options = sList.map(function (x) {
            return {
              value: x.store_id,
              label: x.store_name
            };
          });
          self.addStoresSetting.choose = [];
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      console.log('getStoreBrief | CopyScheduleProdTemp');
      var self = this;
      self.storeBrief = [];
      var storeID = Number(self.$route.query.store_id);
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            var objOption = { label: sList[i].name, value: sList[i].store_id };
            if (obj.value !== storeID) {
              self.addStoresSetting.options.push(objOption);
            }
            self.storeBrief.push(obj);
          }

          self.addStoresSetting.choose = [];
        }
      });
    },
    checkSetting: function checkSetting() {
      var msg = '';
      if (this.addStoresSetting.choose.length === 0) {
        msg = '請選擇門市';
        this.getToast(msg);
      } else {
        this.getToast(msg);
      }
    },
    getToast: function getToast(msg) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        var data = {
          store_id_list: []
        };

        this.addStoresSetting.choose.forEach(function (store) {
          data.store_id_list.push(store);
        });
        console.log(data);
        this.copyStoreSync(data);
      }
    },
    copyStoreSync: function copyStoreSync(data) {
      var self = this;
      var brandId = this.$route.query.brand_id;

      var settingId = this.$route.params.setting_id;
      var url = '/storeOrderAmountLimitSetting/' + settingId + '/storeSync';
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          if (brandId) {
            self.$router.push('/limitedItemScheduleTable?brand=' + brandId);
          } else {
            self.$router.push('/limitedItemScheduleTable');
          }
        }
      });
    }
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  },
  watch: {
    menuState: function menuState() {
      this.tableIndex = 1;
      this.pageGroup = 1;
    }
  },
  created: function created() {
    this.getStoreBrief(this.$route.query.brand_id);
  }
});

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);











/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_5_vue_datepicker_vue_datepicker_es6_vue___default.a
  },
  data: function data() {
    return {
      paginate: {
        count: 10,
        groupAmount: 10,
        page: 1,
        total: 1
      },
      isLoading: false,

      menuTime: {
        start: {
          time: __WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract(7, 'days').format('YYYY-MM-DD')
        },
        end: {
          time: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD')
        }
      },
      searchSelect: 1,
      storeBtnNavs: [{ text: '永久停賣', value: 1 }, { text: '當日停賣', value: 2 }, { text: '多店停賣', value: 3 }, { text: '多店解除停賣', value: 4 }],
      brandBtnNavs: [{ text: '多店停賣', value: 3 }, { text: '多店解除停賣', value: 4 }],
      startLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_6_moment___default()().add(1, 'day').format('YYYY-MM-DD') }],
      endLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD')
      }],
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555',
          'height': '38px'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      roleType: '',
      orderList: [],
      action_type: 99,
      status: 99,
      product_name: '',
      vendor_custom_id: '',
      account: '',
      store_name: '',
      brandInfo: {},
      storeInfo: {}
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getTableList();

              if (!(_this.$route.params.store_id && _this.$route.params.store_id !== 999999)) {
                _context.next = 6;
                break;
              }

              _context.next = 4;
              return _this.getStoreInfo(_this.$route.params.store_id);

            case 4:
              _context.next = 8;
              break;

            case 6:
              _context.next = 8;
              return _this.getBrandInfo(_this.$route.params.brand_id);

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    paginateAmount: function paginateAmount() {
      return Math.ceil(this.paginate.total / this.paginate.count);
    },
    storeHistory: function storeHistory() {
      var storeId = Number(this.$route.params.store_id) || '';
      if (storeId && storeId !== 999999) {
        return true;
      }return false;
    },
    brandHistory: function brandHistory() {
      var brandId = Number(this.$route.params.brand_id) || '';
      var storeId = Number(this.$route.params.store_id) || '';

      if (brandId && brandId !== 999999 && (!storeId || storeId === 999999)) {
        return true;
      }return false;
    }
  }),
  methods: {
    paginateClickPage: function paginateClickPage(index) {
      this.paginate.page = index;
      this.getTableList(index);
    },
    paginateIsActive: function paginateIsActive(index) {
      if (Number(this.paginate.page) === index) return true;else return false;
    },
    queryChange: function queryChange(event, type) {
      var query = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$route.query);
      var value = event.target ? event.target.value : event.value === 0 ? event.value : event.value || event;

      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value) === '{}') return;
      if (value && value !== 999) query[type] = value;else delete query[type];
      this.$router.replace({ query: query });
    },
    getTableList: function getTableList(page) {
      var _this2 = this;

      if (page) {
        this.paginate.page = page;
        if (page === 1) this.pageGroup = 1;
      }

      var storeId = Number(this.$route.params.store_id) || '';
      var brandId = Number(this.$route.params.brand_id) || '';
      var url = '';

      var data = {
        page: this.paginate.page,
        size: this.paginate.count,
        start_date: __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_date: __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        status: this.status,
        action_type: this.action_type,
        product_name: this.product_name,
        vendor_custom_id: this.vendor_custom_id,
        store_id: storeId,
        account: this.account,
        store_name: this.store_name };

      if (storeId && storeId !== 999999) {
        url = '/store/' + storeId + '/productDisableLog';
      } else if (brandId && brandId !== 999999) {
        url = '/brand/' + brandId + '/productBatchDisableLog';
      }
      url = url + ('?page=' + data.page + '&size=' + data.size + '&start_date=' + data.start_date + '&end_date=' + data.end_date);

      if (this.status && this.status !== 99 && this.status !== '99') {
        url = url + '&status=' + this.status;
      } else if (this.action_type && this.action_type !== 99 && this.action_type !== '99') {
        url = url + '&action_type=' + this.action_type;
      }
      if (parseInt(this.searchSelect, 10) === 1 && data.product_name) {
        url = url + '&product_name=' + data.product_name;
      } else if (parseInt(this.searchSelect, 10) === 2 && data.vendor_custom_id) {
        url = url + '&vendor_custom_id=' + data.vendor_custom_id;
      } else if (parseInt(this.searchSelect, 10) === 3 && data.account) {
        url = url + '&account=' + data.account;
      } else if (parseInt(this.searchSelect, 10) === 4 && data.store_name) {
        url = url + '&store_name=' + data.store_name;
      }

      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this2.isLoading = false;
          _this2.orderList = response.data.list;
          _this2.paginate.total = response.data.meta.total_rows;
        }
      });
    },
    search: function search(method) {
      if (method === 1 && this.product_name) {
        this.getTableList(1);
      } else if (method === 2 && this.vendor_custom_id) {
        this.getTableList(1);
      } else if (method === 3 && this.account) {
        this.getTableList(1);
      } else if (method === 4 && this.store_name) {
        this.getTableList(1);
      } else if (!this.product_name && !this.vendor_custom_id && !this.account && !this.store_name) {
        this.getTableList(1);
      } else {
        this.$notify({
          title: '請輸入搜尋條件',
          duration: 1000,
          type: 'danger',
          width: 400
        });
      }
    },
    goPage: function goPage() {
      var brandId = Number(this.$route.params.brand_id) || '';
      if (brandId && brandId !== 999999) {
        this.$router.push('/disItemTable/' + brandId);
      }
    },
    getTime: function getTime(time) {
      if (!time) return '';
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()(time, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm');
    },
    getBrandInfo: function getBrandInfo(brandId) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var self, url;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                self = _this3;
                url = '/brand/' + brandId;
                _context2.next = 4;
                return _this3.getDataH('get', url, null, function (response) {
                  if (response.status === 200) {
                    self.brandInfo = response.data.brand_info;
                  }
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    getStoreInfo: function getStoreInfo(storeId) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var self, url;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                self = _this4;
                url = '/store/' + storeId + '/info';
                _context3.next = 4;
                return _this4.getDataH('get', url, null, function (response) {
                  if (response.data.status === 200) {
                    self.storeInfo = response.data.info;
                  }
                });

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    }
  },
  watch: {
    'menuTime.end.time': function menuTimeEndTime(val) {
      var lastDay = __WEBPACK_IMPORTED_MODULE_6_moment___default()(val, 'YYYY-MM-DD').format('YYYY-MM-DD');
      if (this.menuTime.start.time > lastDay) this.menuTime.start.time = lastDay;

      this.startLimit = [{
        type: 'fromto',
        to: lastDay
      }];

      if (val) {
        this.getTableList();
      }
    },
    'menuTime.start.time': function menuTimeStartTime(val) {
      var startTime = __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.menuTime.start.time, 'YYYY-MM-DD');
      var endTime = __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD');

      if (startTime.isAfter(endTime)) {
        this.menuTime.end.time = this.menuTime.start.time;
      }

      this.endLimit = [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD')
      }];

      if (val) {
        this.getTableList();
      }
    },
    'status': function status() {
      this.getTableList(1);
    },
    'action_type': function action_type() {
      this.getTableList(1);
    },
    searchSelect: function searchSelect(newVal) {
      this.product_name = '';
      this.vendor_custom_id = '';
      this.account = '';
      this.store_name = '';
    },
    product_name: function product_name(newVal) {
      if (newVal === '') this.search(1);
    },
    vendor_custom_id: function vendor_custom_id(newVal) {
      if (newVal === '') this.search(2);
    },
    account: function account(newVal) {
      if (newVal === '') this.search(3);
    },
    store_name: function store_name(newVal) {
      if (newVal === '') this.search(4);
    }
  }
});

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['storeId'],
  data: function data() {
    return {
      disTableList: {
        category: [],
        product: [],
        adjust: [],
        option: [],
        combination: []
      },
      show: {
        category: false,
        product: false,
        adjust: false,
        option: false,
        combination: false
      }
    };
  },

  methods: {
    getDisItemList: function getDisItemList() {
      this.disTableList = [];
      this.show = {
        category: false,
        product: false,
        adjust: false,
        option: false,
        combination: false
      };
      var self = this;
      var url = '/store/' + this.storeId + '/disableItemList';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.disTableList = response.data.item_list;
          if (self.disTableList.category.length) self.show.category = true;
          if (self.disTableList.product.length) self.show.product = true;
          if (self.disTableList.adjust.length) self.show.adjust = true;
          if (self.disTableList.option.length) self.show.option = true;
          if (self.disTableList.combination.length) self.show.combination = true;
        }
      });
    }
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  },
  watch: {
    storeId: function storeId() {
      this.getDisItemList();
    }
  }
});

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_masonry_layout__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_masonry_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_masonry_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    'info': {
      type: Object
    }
  },
  data: function data() {
    return {
      menuId: this.$route.params.menu_id,
      brandId: this.$route.params.brand_id,
      storeId: this.$route.params.store_id,
      menus: {
        category_list: [],
        adjust_list: [],
        option_list: {
          option_map: {},
          vendor_map: {}
        }
      },
      category: [],
      optionsAll: [],
      product: [],

      created: false,
      getTimes: 0,
      time: 0,
      addStoresSetting: {
        class: 'add-store',
        options: [],
        choose: []
      },
      offdayInfo: {
        date: [],
        month_day: [],
        week_day: []
      },
      startTime: '',
      endTime: '',
      dailyDisabledList: []
    };
  },

  methods: {
    menuInit: function menuInit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.getMenuInfo();

              case 2:
                if (!_this.isDaily) {
                  _context.next = 7;
                  break;
                }

                _context.next = 5;
                return _this.getStoreInfo();

              case 5:
                _context.next = 7;
                return _this.getDailyDisabledList();

              case 7:
                _this.disabledInit();

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    changeAdjustAddAll: function changeAdjustAddAll(op) {
      op.is_disabled = !op.is_disabled;
      op.child_list.forEach(function (o) {
        o['is_disabled'] = op.is_disabled;
      });
    },
    checkAdjustAll: function checkAdjustAll(o, ot) {
      o.is_disabled = !o.is_disabled;
      var isDisabled = ot.child_list.filter(function (x) {
        return x.is_disabled === 0;
      });
      if (isDisabled.length === 0) {
        ot.is_disabled = false;
      }
    },
    showMenu: function showMenu() {
      if (__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.grid') && __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.grid-item')) {
        var m = new __WEBPACK_IMPORTED_MODULE_5_masonry_layout___default.a('.grid', {
          itemSelector: '.grid-item',
          columnWidth: '.grid-item'
        });
        m.reloadItems();
        m.layout();
      }
    },
    showIngred: function showIngred() {
      if (__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.gridI') && __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.grid-itemI')) {
        var m = new __WEBPACK_IMPORTED_MODULE_5_masonry_layout___default.a('.gridI', {
          itemSelector: '.grid-itemI',
          columnWidth: '.grid-itemI'
        });
        m.reloadItems();
        m.layout();
      }
    },
    gotoNext: function gotoNext() {
      if (!this.addStoresSetting.choose.length && !this.storeId) {
        if (this.$route.name === 'disProduct') {
          this.$notify({
            title: '請選擇停賣商品',
            text: '請選擇停賣商品',
            duration: 3000,
            type: 'danger',
            width: 400
          });
        } else if (this.$route.name === 'reDisProduct') {
          this.$notify({
            title: '請選擇解除停賣商品',
            text: '請選擇解除停賣商品',
            duration: 3000,
            type: 'danger',
            width: 400
          });
        }
      } else this.disProductList();
    },
    getMenuInfo: function getMenuInfo() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                url = '/onlineMenu/' + _this2.menuId + '/productBrief';

                if (_this2.storeId) {
                  url += '?store_id=' + _this2.storeId;
                }
                _context2.next = 4;
                return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                  _this2.getDataH('get', url, null, function (response) {
                    if (response.data.status === 200) {
                      _this2.menus = response.data.brief;
                      _this2.addStoresSetting.options = response.data.store_list.map(function (x) {
                        return {
                          value: x.id,
                          label: x.name
                        };
                      });
                    }
                    resolve();
                  });
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    disProductList: function disProductList() {
      var _this3 = this;

      var stores = this.addStoresSetting.choose.length > 0 ? this.addStoresSetting.choose : [Number(this.storeId)];
      var productAry = [];
      var packageAry = [];
      var optionAry = [];
      this.category.forEach(function (k) {
        var product = k.child_list.filter(function (x) {
          return x.type === 1 && x.is_disabled;
        }).map(function (j) {
          return j.product_id;
        });
        if (product.length > 0) {
          productAry = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(productAry), [product]);
        }
        var packages = k.child_list.filter(function (x) {
          return x.type === 3 && x.is_disabled;
        }).map(function (j) {
          return j.product_id;
        });
        if (packages.length > 0) {
          packageAry = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(packageAry), [packages]);
        }
      });
      this.optionsAll.forEach(function (z) {
        z.child_list.forEach(function (zi) {
          if (zi.is_disabled) {
            optionAry.push(zi.product_id);
          }
        });
      });
      var data = {};
      if (this.$route.name === 'reDisProduct') {
        data = {
          store_list: stores,
          setting: {
            product_list: {
              enable: productAry.flat()
            },
            package_list: {
              enable: packageAry.flat()
            },
            option_list: {
              enable: optionAry.flat()
            }
          },
          keep_product_status: 0
        };
      } else {
        data = {
          store_list: stores,
          setting: {
            product_list: {
              disable: productAry.flat()
            },
            package_list: {
              disable: packageAry.flat()
            },
            option_list: {
              disable: optionAry.flat()
            }
          },
          keep_product_status: 0
        };
      }
      if (this.$route.name === 'reDisProduct' || this.$route.name === 'disProduct') {
        data.keep_product_status = 1;
      }
      var url = '/onlineMenu/' + this.$route.params.menu_id + '/productListStatus';

      if (this.isDaily) {
        if (this.storeId) url = '/store/' + this.storeId + '/productDisableTodayScheduleSetting';
        var disabledList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(productAry.flat()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(optionAry.flat()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(packageAry.flat()));
        data = { item_list: [] };

        disabledList.forEach(function (id) {
          var typeKeys = ['adjust_list', 'category_list'];
          typeKeys.forEach(function (key) {
            var menuTypes = _this3.menus[key];
            menuTypes.forEach(function (group) {
              var itemList = group.child_list;
              itemList.forEach(function (item) {
                if (item.product_id !== id) return;
                var obj = {
                  product_type: item.type,
                  src_id_type: item.vendor_custom_id ? 1 : 2,
                  vendor_custom_id: item.vendor_custom_id,
                  product_id: id
                };
                data.item_list.push(obj);
              });
            });
          });
        });
      }

      this.getDataH('post', url, data, function (response) {
        _this3.$router.go(-1);
        if (response.data.status === 200) {
          _this3.$notify({
            title: '訊息',
            text: '成功更新停賣資訊',
            duration: 3000,
            type: 'success',
            width: 400
          });
        }
      });
    },
    changeCategoryAdd: function changeCategoryAdd(category) {
      category.is_disabled = !category.is_disabled;
      category.child_list.forEach(function (product) {
        product['is_disabled'] = category.is_disabled;
      });
    },
    changeProductAdd: function changeProductAdd(category, product) {
      product.is_disabled = !product.is_disabled;
      this.category.forEach(function (x) {
        x.child_list.forEach(function (y) {
          if (y.vendor_custom_id === product.vendor_custom_id && y.product_id !== product.product_id) {
            y.is_disabled = product.is_disabled;
          }
        });
      });
      var isDisabled = category.child_list.filter(function (x) {
        return x.is_disabled === 0;
      });
      if (isDisabled.length === 0) {
        category.is_disabled = false;
      }
    },
    getDailyDisabledList: function getDailyDisabledList() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var url, date;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.dailyDisabledList = [];

                if (_this4.storeId) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt('return');

              case 3:
                url = '/store/' + _this4.storeId + '/productDisableTodayScheduleSetting';
                date = __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD');
                _context3.next = 7;
                return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                  _this4.getDataH('get', url, { date: date }, function (response) {
                    if (response.data.status === 200) {
                      var _date = __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD');
                      var startTime = _this4.startTime.split(' ')[1];
                      var endTime = _this4.endTime.split(' ')[1];
                      var disabledData = response.data.list.find(function (item) {
                        return item.date === _date && item.start_time === startTime && item.end_time === endTime;
                      });
                      if (!disabledData && response.data.list.length) disabledData = response.data.list[0];
                      if (disabledData) _this4.dailyDisabledList = disabledData.item_list;
                    }
                    resolve();
                  });
                });

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    getStoreInfo: function getStoreInfo() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (_this5.storeId) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt('return');

              case 2:
                url = '/store/' + _this5.storeId + '/info';
                _context4.next = 5;
                return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                  _this5.getDataH('get', url, null, function (response) {
                    if (response.data.status === 200) {
                      var info = response.data.info;
                      _this5.$store.commit('SET_STORE_INFO', info);
                      var openInfo = info.opening_info;


                      var todayOpenInfo = openInfo.find(function (day) {
                        return day.week_day === __WEBPACK_IMPORTED_MODULE_6_moment___default()().day() + 1;
                      });
                      _this5.offdayInfo = info.offday_info;
                      _this5.startTime = __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD ') + todayOpenInfo.start_time;
                      _this5.endTime = __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD ') + todayOpenInfo.end_time;
                    }
                    resolve();
                  });
                });

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    disabledInit: function disabledInit() {
      var _this6 = this;

      var typeKeys = ['adjust_list', 'category_list'];

      if (this.isDaily) {
        console.log(this.dailyDisabledList);
        typeKeys.forEach(function (key) {
          var menuTypes = _this6.menus[key];
          menuTypes.forEach(function (group) {
            var itemList = group.child_list;
            itemList.forEach(function (itemA) {
              var isDisabled = _this6.dailyDisabledList.find(function (itemB) {
                return itemA.vendor_custom_id === itemB.vendor_custom_id;
              });
              if (isDisabled && !_this6.isDayOff) itemA.is_disabled = 1;else itemA.is_disabled = 0;
            });
          });
        });
      }

      this.category = this.menus.category_list.map(function (category) {
        var allDisabled = category.child_list.every(function (k) {
          return k.is_disabled;
        });
        if (allDisabled) category.is_disabled = true;else category.is_disabled = false;
        return category;
      });

      this.optionsAll = this.menus.adjust_list.filter(function (adjust) {
        return adjust.sub_type === 0;
      }).map(function (adjust) {
        var allDisabled = adjust.child_list.every(function (k) {
          return k.is_disabled;
        });
        if (allDisabled) adjust.is_disabled = true;else adjust.is_disabled = false;
        return adjust;
      });
    }
  },
  created: function created() {
    this.menuInit();
  },
  mounted: function mounted() {
    this.showMenu();
    this.showIngred();
  },
  updated: function updated() {
    this.showMenu();
    this.showIngred();
  },

  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    storeName: function storeName() {
      var sId = parseInt(this.$route.params.store_id, 10);
      if (sId) {
        var sName = this.addStoresSetting.options.find(function (o) {
          return sId === o.value;
        });
        if (sName) return sName.label + '菜單';
      }
      return '';
    },
    isDaily: function isDaily() {
      var name = this.$route.name;
      return name === 'disProductStoreDaily';
    },
    isDayOff: function isDayOff() {
      if (!this.isDaily) return '';
      var now = __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD HH:mm:ss');
      var isAfterEnd = __WEBPACK_IMPORTED_MODULE_6_moment___default()(now).isAfter(this.endTime);
      if (isAfterEnd) return '門市今日已打烊，請於明日再進行設定。';

      var today = __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD');
      var weekDay = __WEBPACK_IMPORTED_MODULE_6_moment___default()().day() + 1;
      var monthDay = __WEBPACK_IMPORTED_MODULE_6_moment___default()().date();
      var _offdayInfo = this.offdayInfo,
          date = _offdayInfo.date,
          week_day = _offdayInfo.week_day,
          month_day = _offdayInfo.month_day;

      var isOffday = date.includes(today) || week_day.includes(weekDay) || month_day.includes(monthDay);
      if (isOffday) return '門市公休中，請於非公休時間進行設定。';

      return '';
    },
    timeType: function timeType() {
      if (this.isDaily) return '當日';
      return '永久';
    }
  }
});

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_timepicker__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_masonry_layout__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_masonry_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_masonry_layout__);













/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_7_vue_datepicker_vue_datepicker_es6_vue___default.a,
    VueTimepicker: __WEBPACK_IMPORTED_MODULE_8_vue2_timepicker___default.a
  },
  data: function data() {
    return {
      menuState: 4,
      name: '',
      description: '',
      total: 1,
      count: 20,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      scheduleList: [],
      bindList: [],
      is_enabled: 1,
      vendor_custom_id: '',
      alias_name: '',
      prod_description: '',
      prod_description_list: [{ prod_description: '' }],
      addAmount: 5,
      settingId: '',
      type: 1,
      currentId: '',
      smImgSrc: '',
      up: false,
      enableOption: [{ label: '啟用', value: 1 }, { label: '關閉', value: 0 }],
      delOption: {
        id: 'delModal',
        title: '刪除時段停賣設定',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delDisableSchedule'
        }]
      },
      delItemOption: {
        id: 'delModal',
        title: '刪除商品設定',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delDisableScheduleItem'
        }]
      },

      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: ''
        }
      },
      startTime: {
        time: ''
      },
      endtime: {
        time: ''
      },
      dateoption_rule: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px 12px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555',
          'width': '248px',
          'min-width': '248px',
          'text-align': 'left'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px 12px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555',
          'width': '280px',
          'min-width': '280px',
          'text-align': 'left'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      startLimit: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_6_moment___default()().add(-1, 'day').format('YYYY-MM-DD HH:mm:ss')
      }],
      endLimit: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD HH:mm:ss')
      }],
      limit_rule: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_6_moment___default()().add(-1, 'day').format('YYYY-MM-DD HH:mm:ss')
      }],
      prodTypeOptions: [{ label: '商品', value: 1 }, { label: '套餐', value: 3 }, { label: '配料', value: 2 }, { label: '商品分類', value: 10 }, { label: '品項選擇區', value: 11 }, { label: '配料群組', value: 20 }],
      srcIdTypeOptions: [{ label: '廠商料號', value: 1 }, { label: '平台商品ID', value: 2 }],
      item_list: [],
      rule_list: [],
      ruleTypeOptions: [{ label: '每日', value: 0 }, { label: '指定日期', value: 1 }, { label: '指定星期', value: 2 }, { label: '每月幾號', value: 3 }],
      offdaySetting: {
        options: {
          weekDay: [{ label: '週日', value: 1 }, { label: '週一', value: 2 }, { label: '週二', value: 3 }, { label: '週三', value: 4 }, { label: '週四', value: 5 }, { label: '週五', value: 6 }, { label: '週六', value: 7 }]
        }
      },
      offdateSetting: {
        options: {
          dateDay: [{ label: '1號', value: 1 }, { label: '2號', value: 2 }, { label: '3號', value: 3 }, { label: '4號', value: 4 }, { label: '5號', value: 5 }, { label: '6號', value: 6 }, { label: '7號', value: 7 }, { label: '8號', value: 8 }, { label: '9號', value: 9 }, { label: '10號', value: 10 }, { label: '11號', value: 11 }, { label: '12號', value: 12 }, { label: '13號', value: 13 }, { label: '14號', value: 14 }, { label: '15號', value: 15 }, { label: '16號', value: 16 }, { label: '17號', value: 17 }, { label: '18號', value: 18 }, { label: '19號', value: 19 }, { label: '20號', value: 20 }, { label: '21號', value: 21 }, { label: '22號', value: 22 }, { label: '23號', value: 23 }, { label: '24號', value: 24 }, { label: '25號', value: 25 }, { label: '26號', value: 26 }, { label: '27號', value: 27 }, { label: '28號', value: 28 }, { label: '29號', value: 29 }, { label: '30號', value: 30 }, { label: '31號', value: 31 }]
        }
      },
      brandSelect: {
        value: 999999,
        label: '==品牌=='
      },
      storeSelect: {
        value: 999999,
        label: '所有門市'
      },

      brandBrief: [],
      storeBrief: [],
      addStoresSetting: {
        options: [],
        choose: []
      },

      menuId: null,
      brandId: null,
      category: [],
      product: [],
      prodNumList: {},
      menuInfo: {},
      menuList: '',

      created: false,
      getTimes: 0,
      time: 0,
      accessory: [],
      disTableList: [],
      adjustCheckbox: false,
      options: [],

      trigger_load_menu: true,
      loadmenu_id: null
    };
  },

  methods: {
    getOnlineMenu: function getOnlineMenu() {
      var self = this;
      var url = '/onlineMenu/list?page=' + this.tableIndex + '&size=' + this.count + '&brand_id=' + this.brandSelect.value;
      if (this.$route.query.usage_type === '2') {
        if (self.loadmenu_id) {
          url = '/onlineMenu/list?page=' + this.tableIndex + '&size=' + this.count + '&store_id=' + this.loadmenu_id;
        } else {
          url = '/onlineMenu/list?page=' + this.tableIndex + '&size=' + this.count + '&store_id=' + this.$route.query.store_id;
        }
      } else if (this.$route.query.usage_type === '1') {
        if (self.loadmenu_id) {
          url = '/onlineMenu/list?page=' + this.tableIndex + '&size=' + this.count + '&store_id=' + this.loadmenu_id;
        } else {
          url = '/onlineMenu/list?page=' + this.tableIndex + '&size=' + this.count + '&brand_id=' + this.$route.query.brand_id;
        }
      }
      if (this.storeSelect.value !== 999999 && this.storeSelect.value !== null && !this.$route.query.usage_type) url = '/onlineMenu/list?page=' + this.tableIndex + '&size=' + this.count + '&store_id=' + this.storeSelect.value;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.menuList = response.data.menu_list;
          self.total = response.data.total;
          if (self.storeSelect.value === 999999) {
            self.menuId = self.menuList[0].id;
            self.getMenuInfo(self.menuList[0].id);
          } else if (self.storeSelect.value !== 999999 && self.storeSelect.value !== null) {
            self.menuId = self.menuList[0].id;
            self.getMenuInfo(self.menuList[0].id);
          }
        }
      });
    },
    init: function init() {},
    isActive: function isActive(index) {
      if (index === 1) return true;else return false;
    },
    changeAdjustAdd: function changeAdjustAdd() {
      var _this = this;

      this.options.forEach(function (a) {
        a.is_disabled = _this.adjustCheckbox;
        if (a.is_disabled === true) {
          var obj = {
            product_type: _this.prodTypeOptions.find(function (opt) {
              return opt.value === a.type;
            }),
            src_id_type: { label: '廠商料號', value: 1 },
            product_id: a.optionIds[0]
          };
          _this.item_list.push(obj);
        } else {
          var index = _this.item_list.findIndex(function (item) {
            return item.product_id === a.optionIds[0];
          });
          if (index > -1) {
            _this.item_list.splice(index, 1);
          }

          var pindex = _this.item_list.findIndex(function (pitem) {
            return pitem.product_id === a.optionIds[0];
          });
          if (pindex > -1) {
            _this.item_list.splice(pindex, 1);
          }
        }
      });
    },
    checkAdjust: function checkAdjust(adjust) {
      var _this2 = this;

      this.adjustCheckbox = true;
      this.options.forEach(function (a) {
        if (!a.is_disabled) {
          _this2.adjustCheckbox = false;
          return false;
        }
      });
      if (adjust.is_disabled === true) {
        var obj = {
          product_type: this.prodTypeOptions.find(function (opt) {
            return opt.value === adjust.type;
          }),
          src_id_type: { label: '廠商料號', value: 1 },
          product_id: adjust.optionIds[0]
        };
        this.item_list.push(obj);
      } else {
        var index = this.item_list.findIndex(function (item) {
          return item.product_id === adjust.optionIds[0];
        });
        if (index > -1) {
          this.item_list.splice(index, 1);
        }

        var pindex = this.item_list.findIndex(function (pitem) {
          return pitem.product_id === adjust.optionIds[0];
        });
        if (pindex > -1) {
          this.item_list.splice(pindex, 1);
        }
      }
    },
    showMenu: function showMenu() {
      if (__WEBPACK_IMPORTED_MODULE_9_jquery___default()('.grid') && __WEBPACK_IMPORTED_MODULE_9_jquery___default()('.grid-item')) {
        var m = new __WEBPACK_IMPORTED_MODULE_10_masonry_layout___default.a('.grid', {
          itemSelector: '.grid-item',
          columnWidth: '.grid-item'
        });
        m.reloadItems();
        m.layout();
      }
    },
    getProduct: function getProduct(index) {
      return this.product[index];
    },
    gotoFrom: function gotoFrom() {
      if (this.menuId) this.$router.push('/upMenu/' + this.brandId + '/' + this.menuId);else this.$router.push('/crOption');
    },
    gotoNext: function gotoNext() {
      if (!this.addStoresSetting.choose.length && !this.$route.params.store_id) {
        this.$notify({
          title: '錯誤',
          text: '未選擇停賣店家',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else this.disProductList();
    },
    setChoose: function setChoose() {
      var self = this;
      var array = [];
      if (self.$route.name.indexOf('up') > -1) {
        self.marketing.attend_stores.forEach(function (brand) {
          brand.store_list.forEach(function (store) {
            var curStore = store.store_id;
            array.push(curStore);
          });
        });
        self.addStoresSetting.choose = array;
      }
    },
    getMenuInfo: function getMenuInfo(menuId) {
      var _this3 = this;

      var url = '/onlineMenu/' + menuId + '/productBrief';

      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var menu = response.data.brief;
          _this3.category = menu.category_list;
          var optionList = [];
          _this3.category.forEach(function (j) {
            _this3.item_list.forEach(function (item) {
              j.child_list.forEach(function (jc) {
                if (item.src_id_type.value === 1) {
                  if (jc.vendor_custom_id === item.product_id) {
                    jc.is_disabled = 1;
                  }
                } else if (item.src_id_type.value === 2) {
                  if (jc.product_id === item.product_id) {
                    jc.is_disabled = 1;
                  }
                }
              });
            });
            var index = j.child_list.findIndex(function (k) {
              return k.is_disabled === 0;
            });
            if (index === -1) {
              j.is_disabled = true;
            }
          });
          menu.adjust_list.forEach(function (e) {
            e.child_list.forEach(function (a) {
              if (a.sub_type === 0) {
                _this3.item_list.forEach(function (item) {
                  if (item.src_id_type.value === 1) {
                    if (a.vendor_custom_id === item.product_id) {
                      a.is_disabled = 1;
                    }
                  } else if (item.src_id_type.value === 2) {
                    if (a.product_id === item.product_id) {
                      a.is_disabled = 1;
                    }
                  }
                });
                optionList.push(a);
              }
            });
          });
          _this3.options = optionList.map(function (q) {
            return {
              name: q.name,
              is_disabled: q.is_disabled,
              optionIds: [q.vendor_custom_id],
              remark: q.remark,
              sub_type: q.sub_type,
              type: q.type
            };
          });
          var index = _this3.options.findIndex(function (k) {
            return !k.is_disabled;
          });
          if (index === -1) {
            _this3.adjustCheckbox = true;
          }

          if (response.data.store_list.length > 0) {
            _this3.addStoresSetting.options = response.data.store_list.map(function (x) {
              return {
                value: x.id,
                label: x.name
              };
            });
          }

          if (_this3.$route.query.usage_type === '1' && _this3.$route.query.store_id === '0' && _this3.addStoresSetting.choose.length === 0) {
            _this3.addStoresSetting.choose = response.data.store_list.map(function (x) {
              return x.id;
            });
          }
        }
      });
    },
    disProductList: function disProductList() {
      var _this4 = this;

      var stores = this.addStoresSetting.choose.length > 0 ? this.addStoresSetting.choose : [Number(this.$route.params.store_id)];
      var productAry = [];
      var packageAry = [];
      this.category.forEach(function (k) {
        var product = k.child_list.filter(function (x) {
          return x.type === 1 && x.is_disabled;
        }).map(function (j) {
          return j.product_id;
        });
        if (product.length > 0) {
          productAry = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(productAry), [product]);
        }
        var packages = k.child_list.filter(function (x) {
          return x.type === 3 && x.is_disabled;
        }).map(function (j) {
          return j.product_id;
        });
        if (packages.length > 0) {
          packageAry = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(packageAry), [packages]);
        }
      });
      var optionAry = [];
      this.options.forEach(function (z) {
        if (z.is_disabled) {
          optionAry.push(z.optionIds);
        }
      });
      var data = {
        store_list: stores,
        setting: {
          product_list: {
            disable: productAry.flat()
          },
          package_list: {
            disable: packageAry.flat()
          },
          option_list: {
            disable: optionAry.flat()
          }
        }
      };
      var url = '/onlineMenu/' + this.$route.params.menu_id + '/productListStatus';
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          _this4.$notify({
            title: '訊息',
            text: '成功更新停賣資訊',
            duration: 3000,
            type: 'success',
            width: 400
          });
        }
      });
    },
    getDisItemList: function getDisItemList() {
      this.disTableList = [];
      var self = this;
      var url = '/store/' + this.$route.params.store_id + '/disableItemList';
      var adjust = this.adjust;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.disTableList = response.data.item_list;
          var disCategory = self.disTableList.category;
          disCategory.forEach(function (c) {
            c.id_list.forEach(function (cId) {
              self.category.find(function (category) {
                if (category.category_id === cId) category.is_disabled = true;
              });
            });
          });
          var disProd = self.disTableList.product;
          disProd.forEach(function (p) {
            p.id_list.forEach(function (pId) {
              self.category.forEach(function (cc) {
                cc.product_list.find(function (prod) {
                  if (prod.product_id === pId) prod.is_disabled = true;
                });
              });
            });
          });
          var disOption = self.disTableList.option;
          disOption.forEach(function (e) {
            e.id_list.forEach(function (l) {
              var index = adjust.findIndex(function (x) {
                return x.adjustIds.indexOf(l) > -1;
              });
              adjust[index].is_disabled = true;
            });
          });
        }
      });
    },
    choseAllProduct: function choseAllProduct(category) {
      this.category.filter(function (elem, index, obj) {
        if (elem.category_id === category.category_id) {
          elem.is_enable = true;
          elem.is_visible = true;
          elem.is_disabled = true;
          if (elem.product_list.length) {
            for (var i = 0; i < elem.product_list.length; i++) {
              var product = elem.product_list[i];
              product['is_enable'] = true;
              product['is_visible'] = true;
              product['is_disabled'] = true;
              if (product.combine_list) {
                for (var j = 0; j < product.combine_list.length; j++) {
                  var combine = product.combine_list[j];
                  combine['is_enable'] = true;
                  combine['is_visible'] = true;
                  combine['is_disabled'] = true;
                }
              }
            }
          }
        }
      });
    },
    changeCategoryAdd: function changeCategoryAdd(category) {
      var self = this;
      category.is_disabled = !category.is_disabled;
      category.child_list.forEach(function (product) {
        product['is_disabled'] = category.is_disabled;
        if (product['is_disabled'] === true) {
          var obj = {
            product_type: self.prodTypeOptions.find(function (opt) {
              return opt.value === product.type;
            }),
            src_id_type: { label: '廠商料號', value: 1 },
            product_id: product.vendor_custom_id
          };
          self.item_list.push(obj);
        } else {
          var index = self.item_list.findIndex(function (item) {
            return item.product_id === product.vendor_custom_id;
          });
          if (index > -1) {
            self.item_list.splice(index, 1);
          }

          var pindex = self.item_list.findIndex(function (pitem) {
            return pitem.product_id === product.vendor_custom_id;
          });
          if (pindex > -1) {
            self.item_list.splice(pindex, 1);
          }
        }
      });
    },
    changeProductAdd: function changeProductAdd(category, product) {
      product.is_disabled = !product.is_disabled;
      if (product.is_disabled === true) {
        var obj = {
          product_type: this.prodTypeOptions.find(function (opt) {
            return opt.value === product.type;
          }),
          src_id_type: { label: '廠商料號', value: 1 },
          product_id: product.vendor_custom_id
        };
        this.item_list.push(obj);
      } else {
        var index = this.item_list.findIndex(function (item) {
          return item.product_id === product.vendor_custom_id;
        });
        if (index > -1) {
          this.item_list.splice(index, 1);
        }

        var pindex = this.item_list.findIndex(function (pitem) {
          return pitem.product_id === product.product_id;
        });
        if (pindex > -1) {
          this.item_list.splice(pindex, 1);
        }
      }
      var isDisabled = category.child_list.filter(function (x) {
        return x.is_disabled === 0;
      });
      if (isDisabled.length === 0) {
        category.is_disabled = false;
      }
    },
    getBrandBrief: function getBrandBrief() {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        try {
          var self = _this5;
          var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
          _this5.getDataH('get', url, null, function (response) {
            if (response.data.status === 200) {
              var bList = response.data.list;
              for (var i = 0; i < bList.length; i++) {
                var obj = { label: bList[i].name, value: bList[i].brand_id };
                if (!bList[i].is_visible) obj.label = obj.label + ' (測)';
                self.brandBrief.push(obj);
                if (self.$route.name === 'crDisableSchedule' && self.getRoleType === 99) {
                  if (Number(self.$route.query.brand_id) === obj.value) {
                    self.brandSelect = obj;
                  }
                } else if (i === 0 && self.$route.params.usage_type !== 2) {
                  self.brandSelect = obj;
                }
              }
            }
            resolve();
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      var self = this;
      self.storeBrief = [];
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
            if (i === 0 && self.getRoleType === 10) {
              self.storeSelect = obj;
            } else if (i === 0) self.storeSelect.value = 999999;
          }

          if (!self.$route.query.usage_type) {
            self.addStoresSetting.options = sList.map(function (x) {
              return {
                value: x.store_id,
                label: x.name
              };
            });
          }
          if (self.$route.name === 'upDisableSchedule') {
            self.getOnlineMenu();
          }
        }
      });
    },
    removeListItem: function removeListItem(list, index) {
      list.splice(index, 1);
    },
    addRule: function addRule() {
      var rule = { rule_type: { label: '每日', value: 0 }, rule_date: { time: '' }, rule_day: '', rule_month_day: '', rule_start_time: '', rule_end_time: '' };
      this.rule_list.push(rule);
    },
    removeItem: function removeItem(index) {
      this.item_list.splice(index, 1);
    },
    addItem: function addItem() {
      var newItem = { product_type: { label: '商品', value: 1 }, src_id_type: { label: '廠商料號', value: 1 }, product_id: '' };
      this.item_list.push(newItem);
    },
    trigger: function trigger(event) {
      if (event === 'delDisableSchedule') {
        if (this.$route.name === 'upDisableSchedule') this.delDisableSchedule();
      } else if (event === 'delDisableScheduleItem') this.delDisableScheduleItem();
    },
    clickCurrent: function clickCurrent(itemId, index) {
      this.currentId = itemId;
      this.delOption.body = '是否刪除第' + (index + 1) + '張大圖？';
    },
    checkSetting: function checkSetting() {
      var msg = '';
      if (!this.menuTime.start.time) {
        msg = '請選擇開始時間';
        this.getToast(msg);
      } else if (!this.menuTime.end.time) {
        msg = '請選擇結束時間';
        this.getToast(msg);
      } else if (this.rule_list.length === 0) {
        msg = '請新增規則';
        this.getToast(msg);
      } else if (this.item_list.length > 0) {
        var firstItem = this.item_list[0];

        if (this.addStoresSetting.choose.length === 0) {
          msg = '請選擇門市';
        } else if (!firstItem.product_id.trim()) {
          if (firstItem.src_id_type === 1) msg = '請輸入廠商料號';else msg = '請輸入平台商品ID';
        }
        this.getToast(msg);
      } else if (this.addStoresSetting.choose.length === 0) {
        msg = '請選擇門市';
        this.getToast(msg);
      } else {
        msg = '請選擇停賣商品，或選擇其他門市';
        this.getToast(msg);
      }
    },
    getToast: function getToast(msg) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        var rName = this.$route.name;

        var data = {
          item_list: [],
          store_list: [],
          start_date: this.menuTime.start.time,
          end_date: this.menuTime.end.time
        };
        if (this.name) data.name = this.name;
        if (this.description) data.description = this.description;

        this.item_list.forEach(function (item) {
          var obj = {
            product_type: item.product_type.value,
            src_id_type: item.src_id_type.value
          };
          if (obj.src_id_type === 1) obj.vendor_custom_id = item.product_id;else obj.product_id = item.product_id;
          data.item_list.push(obj);
        });

        this.addStoresSetting.choose.forEach(function (store) {
          data.store_list.push(store);
        });

        data.rule_list = [];
        if (this.rule_list.length) {
          this.rule_list.forEach(function (rule) {
            var obj = {
              rule_type: rule.rule_type.value
            };
            if (obj.rule_type === 1) obj.rule_date = rule.rule_date.time;else if (obj.rule_type === 2) obj.rule_day = rule.rule_day.value;else if (obj.rule_type === 3) obj.rule_day = rule.rule_month_day.value;

            if (rule.rule_start_time && rule.rule_end_time) {
              obj.rule_start_time = rule.rule_start_time;
              obj.rule_end_time = rule.rule_end_time;
            }
            data.rule_list.push(obj);
          });
        }
        if (rName === 'crDisableSchedule') this.crDisableSchedule(data);else if (rName === 'upDisableSchedule') this.crDisableSchedule(data);
      }
    },
    crDisableSchedule: function crDisableSchedule(data) {
      var self = this;
      var rName = this.$route.name;
      var brandId = null;
      if (rName === 'crDisableSchedule') {
        brandId = this.brandSelect.value;
      } else if (rName === 'upDisableSchedule') {
        brandId = this.$route.query.brand_id;
      }
      var storeId = this.storeSelect.value;
      var url = '/brand/' + brandId + '/productDisableScheduleSetting/group';
      if (storeId !== 999999 && this.getRoleType === 10) url = '/store/' + storeId + '/productDisableScheduleSetting/group';
      if (this.$route.params.setting_id) url = url + '/' + this.$route.params.setting_id;
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          if (self.getRoleType === 99 || self.getRoleType === 30) {
            self.$router.push('/disItemScheduleTable?brand=' + brandId);
          } else if (self.getRoleType === 10 && storeId !== 999999) {
            self.$router.push('/disItemScheduleTable?store=' + storeId);
          } else {
            self.$router.push('/disItemScheduleTable');
          }
        }
      });
    },
    delDisableScheduleItem: function delDisableScheduleItem() {
      var self = this;
      var url = '/brand/' + this.$route.query.brand_id + '/productDisableScheduleSetting/' + this.$route.params.setting_id;
      if (this.$route.query.usage_type === '2') url = '/store/' + this.$route.query.store_id + '/productDisableScheduleSetting/' + this.$route.params.setting_id;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.go(-1);
        }
      });
    },
    delDisableSchedule: function delDisableSchedule() {
      var self = this;
      var url = '/brand/' + this.$route.query.brand_id + '/productDisableScheduleSetting/group/' + this.$route.params.setting_id;
      if (this.$route.query.usage_type === '2') url = '/store/' + this.$route.query.store_id + '/productDisableScheduleSetting/group/' + this.$route.params.setting_id;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.go(-1);
        }
      });
    },
    delProductAlias: function delProductAlias() {
      var self = this;
      var brandId = this.$route.params.brand_id;
      var url = '/brand/' + this.$route.params.brand_id + '/productAliasSetting/' + this.$route.params.setting_id;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.push('/brandProductSetting/' + brandId);
        }
      });
    },
    upProductDescription: function upProductDescription() {
      var self = this;
      var brandId = this.$route.params.brand_id;
      var items = [];
      this.prod_description_list.forEach(function (item, i) {
        if (item.prod_description) items.push(item.prod_description);
      });
      var url = '/brand/' + this.$route.params.brand_id + '/productDescriptionSetting/' + this.$route.params.setting_id;
      var data = {
        vendor_custom_id: this.vendor_custom_id,
        is_enabled: this.is_enabled,
        item_list: items
      };
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.push('/brandProductSetting/' + brandId);
        }
      });
    },
    upProductAlias: function upProductAlias() {
      var self = this;
      var brandId = this.$route.params.brand_id;
      var items = [this.alias_name];
      var url = '/brand/' + this.$route.params.brand_id + '/productAliasSetting/' + this.$route.params.setting_id;
      var data = {
        vendor_custom_id: this.vendor_custom_id,
        is_enabled: this.is_enabled,
        item_list: items
      };
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.push('/brandProductSetting/' + brandId);
        }
      });
    },
    getDisableSchedule: function getDisableSchedule() {
      var _this6 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        try {
          var self = _this6;

          var url = '/brand/' + _this6.$route.query.brand_id + '/productDisableScheduleSetting/group/' + _this6.$route.params.setting_id;
          if (_this6.$route.query.usage_type === '2') url = '/store/' + _this6.$route.query.store_id + '/productDisableScheduleSetting/group/' + _this6.$route.params.setting_id;

          self.item_list = [];
          _this6.getDataH('get', url, null, function (response) {
            if (response.data.status === 200) {
              var sInfo = response.data.group;

              if (sInfo.store_list.length > 0) self.loadmenu_id = sInfo.store_list[0].store_id;
              if (sInfo.store_id) self.storeSelect.value = sInfo.store_id;
              self.name = sInfo.name;
              self.description = sInfo.description;
              self.menuTime.start.time = sInfo.start_date;
              self.menuTime.end.time = sInfo.end_date;

              if (self.$route.query.usage_type === '1') {
                if (sInfo.store_list.length > 0) {
                  self.addStoresSetting.choose = sInfo.store_list.map(function (x) {
                    return x.store_id;
                  });
                }
              } else if (self.$route.query.usage_type === '2') {
                if (sInfo.store_list.length > 0) {
                  self.addStoresSetting.choose = sInfo.store_list.map(function (x) {
                    return x.store_id;
                  });
                } else {
                  self.addStoresSetting.choose = sInfo.store_list.map(function (x) {
                    return x.store_id;
                  });
                }
              }
              sInfo.item_list.forEach(function (item) {
                var obj = {
                  product_type: self.prodTypeOptions.find(function (opt) {
                    return opt.value === item.product_type;
                  }),
                  src_id_type: self.srcIdTypeOptions.find(function (opt) {
                    return opt.value === item.src_id_type;
                  }),
                  product_id: item.vendor_custom_id || item.product_id
                };
                self.item_list.push(obj);
              });
              sInfo.rule_list.forEach(function (rule) {
                if (rule.rule_start_time === null) {
                  rule.rule_start_time = '';
                }
                if (rule.rule_end_time === null) {
                  rule.rule_end_time = '';
                }
                var obj = {
                  rule_type: self.ruleTypeOptions.find(function (opt) {
                    return rule.rule_type === opt.value;
                  }),
                  rule_date: { time: '' },
                  rule_day: '',
                  rule_month_day: { label: '', value: null },
                  rule_start_time: rule.rule_start_time,
                  rule_end_time: rule.rule_end_time
                };
                if (rule.rule_date) obj.rule_date.time = rule.rule_date;
                if (rule.rule_type === 2 && rule.rule_day) obj.rule_day = self.offdaySetting.options.weekDay.find(function (week) {
                  return week.value === rule.rule_day;
                });else if (rule.rule_type === 3 && rule.rule_day) {
                  obj.rule_month_day.value = rule.rule_day;
                  obj.rule_month_day.label = rule.rule_day + '號';
                }
                self.rule_list.push(obj);
              });
            }
            resolve();
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    getProductAlias: function getProductAlias() {
      var self = this;
      var url = '/brand/' + this.$route.params.brand_id + '/productAliasSetting/' + this.$route.params.setting_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var setting = response.data.setting;
          self.vendor_custom_id = setting.vendor_custom_id;
          self.alias_name = setting.item_list[0].name;
          if (!setting.is_enabled) self.is_enabled = 0;
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['getRoleType']), {
    checkSelectAll: function checkSelectAll() {
      if (this.$route.name === 'upDisableSchedule') {
        return true;
      } else if (this.$route.name === 'crDisableSchedule') {
        if (this.addStoresSetting.choose.length > 0) {
          return true;
        } else {
          return false;
        }
      }
    },
    checkInput: function checkInput() {
      return this.$parent.checkInput;
    },
    storeName: function storeName() {
      var sId = parseInt(this.$route.params.store_id, 10);
      if (sId) {
        var sName = this.addStoresSetting.options.find(function (o) {
          return sId === o.value;
        });
        if (sName) return sName.label + '菜單';
      }
      return '';
    },
    tab: function tab() {
      var rName = this.$route.name;
      switch (rName) {
        case 'crProductImg':
        case 'upProductImg':
          return 1;
        case 'crPackageImg':
        case 'upPackageImg':
          return 3;
        case 'crCategoryImg':
        case 'upCategoryImg':
          return 10;
      }
    },
    tabName: function tabName() {
      switch (this.tab) {
        case 2:
          return '配料';
        case 20:
          return '配料群組';
        case 10:
          return '商品分類';
        case 1:
          return '商品';
        case 11:
          return '品項選擇區';
        case 3:
          return '套餐';
      }
    },
    tabNamePlaceholder: function tabNamePlaceholder() {
      switch (this.tab) {
        case 2:
          return '配料名稱';
        case 20:
          return '配料群組名稱';
        case 10:
          return '商品分類名稱';
        case 1:
          return '商品名稱';
        case 11:
          return '品項選擇區名稱';
        case 3:
          return '套餐名稱';
      }
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  }),
  watch: {
    menuState: function menuState() {
      this.tableIndex = 1;
      this.pageGroup = 1;
    },
    'brandSelect.value': function brandSelectValue() {
      this.storeBrief = [];
      this.addStoresSetting = {
        options: [],
        choose: []
      };
      this.category = [];
      this.options = [];
      this.item_list = [];
      this.rule_list = [];
      this.trigger_load_menu = true;
      this.getStoreBrief(this.brandSelect.value);
    },
    'addStoresSetting.choose': function addStoresSettingChoose() {
      if (this.addStoresSetting.choose.length === 1 && this.trigger_load_menu === true && !this.$route.query.usage_type) {
        this.storeSelect.value = this.addStoresSetting.choose[0];
        this.getOnlineMenu();
        this.trigger_load_menu = false;
      } else if (this.addStoresSetting.choose.length === 0) {
        if (!this.$route.query.usage_type) {
          this.addStoresSetting.options = this.storeBrief.map(function (x) {
            return {
              value: x.value,
              label: x.label
            };
          });

          this.trigger_load_menu = true;
        }
      }
    },
    'menuTime.start.time': function menuTimeStartTime() {
      var date = new Date(this.menuTime.start.time);
      var startdate = new Date(date);
      startdate.setDate(startdate.getDate() - 1);
      this.limit_rule[0].from = startdate.toISOString().split('T')[0];
    },
    'menuTime.end.time': function menuTimeEndTime() {
      var date = new Date(this.menuTime.end.time);
      var enddate = new Date(date);
      enddate.setDate(enddate.getDate() + 1);
      this.limit_rule[0].to = enddate.toISOString().split('T')[0];
    }
  },
  created: function created() {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this7.getBrandBrief();

            case 2:
              if (!(_this7.$route.name === 'upDisableSchedule')) {
                _context.next = 8;
                break;
              }

              _this7.up = true;
              _context.next = 6;
              return _this7.getDisableSchedule();

            case 6:
              _context.next = 9;
              break;

            case 8:
              if (_this7.$route.name === 'upProductDescription') {
                _this7.up = true;
                _this7.getProductDescription();
              }

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this7);
    }))();
  },
  mounted: function mounted() {
    this.showMenu();
  },
  updated: function updated() {
    this.showMenu();
  }
});

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_timepicker__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_timepicker__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_3_vue_datepicker_vue_datepicker_es6_vue___default.a,
    VueTimepicker: __WEBPACK_IMPORTED_MODULE_4_vue2_timepicker___default.a
  },
  data: function data() {
    return {
      menuState: 4,
      name: '',
      description: '',
      total: 1,
      count: 20,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      scheduleList: [],
      bindList: [],
      is_enabled: 1,
      vendor_custom_id: '',
      alias_name: '',
      prod_description: '',
      prod_description_list: [{ prod_description: '' }],
      addAmount: 5,
      settingId: '',
      type: 1,
      currentId: '',
      smImgSrc: '',
      up: false,
      enableOption: [{ label: '啟用', value: 1 }, { label: '關閉', value: 0 }],
      delOption: {
        id: 'delModal',
        title: '刪除限時限量設定',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delLimitAmount'
        }]
      },
      delItemOption: {
        id: 'delModal',
        title: '刪除商品設定',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delDisableScheduleItem'
        }]
      },

      sectionTime: {
        start: {
          time: ''
        },
        end: {
          time: ''
        }
      },
      startTime: {
        time: ''
      },
      endtime: {
        time: ''
      },
      dateoption_rule: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: 'YYYYMM-DD',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px 12px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555',
          'width': '248px',
          'min-width': '248px',
          'text-align': 'left'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: 'YYYY-MM-DD',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px 0px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'width': '97px',
          'min-width': '97px',
          'text-align': 'center'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      startLimit: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(-1, 'day').format('YYYY-MM-DD')
      }],
      endLimit: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(-1, 'day').format('YYYY-MM-DD')
      }],
      limit_rule: [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(-1, 'day').format('YYYY-MM-DD HH:mm:ss')
      }],
      deliveryTypeOption: [{ label: '全部', value: 0 }, { label: '自取', value: 1 }, { label: '內用', value: 2 }, { label: '外送', value: 3 }, { label: '外帶', value: 4 }, { label: '吧台', value: 5 }, { label: '內用-桌邊掃碼', value: 21 }],
      srcIdTypeOptions: [{ label: '廠商料號', value: 1 }, { label: '平台商品ID', value: 2 }],
      item_list: [],
      rule_list: [],
      rule_section_list: [],
      rule_week_list: [],
      ruleTypeOptions: [{ label: '每日', value: 0 }, { label: '指定日期', value: 1 }, { label: '指定星期', value: 2 }, { label: '每月幾號', value: 3 }],
      offdaySetting: {
        options: {
          weekDay: [{ label: '週日', value: 1 }, { label: '週一', value: 2 }, { label: '週二', value: 3 }, { label: '週三', value: 4 }, { label: '週四', value: 5 }, { label: '週五', value: 6 }, { label: '週六', value: 7 }]
        }
      },
      brandSelect: {
        value: 999999,
        label: '==品牌=='
      },
      storeSelect: {
        value: null,
        label: ''
      },

      brandBrief: [],
      storeBrief: [],
      addStoresSetting: {
        options: [],
        choose: []
      },

      menuId: null,
      brandId: null,
      category: [],
      product: [],
      prodNumList: {},
      menuInfo: {},
      menuList: '',

      created: false,
      getTimes: 0,
      time: 0,
      accessory: [],
      disTableList: [],
      adjustCheckbox: false,
      options: [],
      show_section_overlap: false,
      show_week_overlap: false,
      store_deliveryInfo: [],
      checkedForm: false,
      checkedFormModal: false,
      checkedFormModalOption: {
        id: 'checkedFormModal',
        title: '設定重複，請確認紅框處。',
        body: '',
        btns: [{
          name: '確定',
          event: 'checkedFormSubmit'
        }]
      }
    };
  },

  methods: {
    validateHhMm: function validateHhMm(inputField) {
      var isValid = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(inputField.value);
      return isValid;
    },
    changeDate: function changeDate(event, from, index) {
      if (from === 'start') {
        var sdate = new Date(this.rule_section_list[index].sectionTime.start.time);
        var startdate = new Date(sdate);
        startdate.setDate(startdate.getDate() - 1);
        this.rule_section_list[index].endLimit[0].from = startdate.toISOString().split('T')[0];
        if (this.rule_section_list[index].sectionTime.end.time !== '') {
          if (this.rule_section_list[index].sectionTime.end.time < this.rule_section_list[index].sectionTime.start.time) {
            var date = new Date(this.rule_section_list[index].sectionTime.start.time);
            var enddate = new Date(date);
            enddate.setDate(enddate.getDate() + 1);
            this.rule_section_list[index].sectionTime.end.time = enddate.toISOString().split('T')[0];
          }
        }
      }
    },
    routerEvent: function routerEvent(event) {
      if (event === 'brand') {
        this.storeBrief = [];
        this.rule_section_list = [];
        this.rule_week_list = [];
        this.storeSelect = {
          value: null,
          label: ''
        };
        var queryValue = {};
        queryValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, queryValue, { brand_id: this.brandSelect.value });
        this.$router.push({ query: queryValue });
        this.getStoreLimitSetting(this.brandSelect.value);
      } else if (event === 'store') {
        var _queryValue = {};
        _queryValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _queryValue, { store_id: this.storeSelect.value, brand_id: this.brandSelect.value });
        this.$router.push({ query: _queryValue });
        if (this.storeSelect.value) {
          this.getStoreInfo(this.$route.query.store_id);
        }
      }
    },
    getStoreInfo: function getStoreInfo(storeID) {
      var self = this;
      var url = '/store/' + storeID + '/info';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.store_deliveryInfo = response.data.info.delivery_info;
          self.store_deliveryInfo = self.store_deliveryInfo.filter(function (value, index, self) {
            return index === self.findIndex(function (t) {
              return t.delivery_type === value.delivery_type;
            });
          });
        }
      });
    },
    delLimitAmount: function delLimitAmount() {
      var self = this;
      var url = '/storeOrderAmountLimitSetting/' + this.$route.params.setting_id;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.go(-1);
        }
      });
    },
    trigger: function trigger(event) {
      if (event === 'delLimitAmount') {
        if (this.$route.name === 'upLimitScheduleItem') this.delLimitAmount();
      }
      if (event === 'checkedFormSubmit') {
        this.checkedFormModal = false;
      }
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            if (!bList[i].is_visible) obj.label = obj.label + ' (測)';
            self.brandBrief.push(obj);
            if (self.$route.name === 'crLimitScheduleItem' && (self.getRoleType === 99 || self.getRoleType === 30 || self.getRoleType === 10)) {
              if (Number(self.$route.query.brand_id) === obj.value) {
                self.brandSelect = obj;
                self.getStoreLimitSetting(self.$route.query.brand_id);
              }
            } else if (i === 0 && self.$route.params.usage_type !== 2) {
              self.brandSelect = obj;
            }
          }
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      console.log('getStoreBrief | LimScheduleProdTemp');
      var self = this;
      self.storeBrief = [];
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
            if (self.$route.name === 'crLimitScheduleItem' && (self.getRoleType === 99 || self.getRoleType === 30 || self.getRoleType === 10)) {
              if (Number(self.$route.query.store_id) === obj.value) {
                self.storeSelect = obj;
                self.getStoreInfo(obj.value);
              }
            }
          }
        }
      });
    },
    getStoreLimitSetting: function getStoreLimitSetting(brandId) {
      var self = this;
      self.storeBrief = [];
      var url = '/storeOrderAmountLimitSetting/getStoreList?brand_id=' + brandId + '&type=create';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.store_list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].store_name, value: sList[i].store_id };
            self.storeBrief.push(obj);
            if (self.$route.name === 'crLimitScheduleItem' && (self.getRoleType === 99 || self.getRoleType === 30 || self.getRoleType === 10)) {
              if (Number(self.$route.query.store_id) === obj.value) {
                self.storeSelect = obj;
                self.getStoreInfo(obj.value);
              }
            }
          }
        }
      });
    },
    addSectionSetting: function addSectionSetting() {
      if (this.storeSelect.value) {
        var setting = {
          rule_type: 1,
          rule_start_date: null,
          rule_end_date: null,
          rule_start_time: '',
          rule_end_time: '',
          amount: 1,
          is_enabled: 1,
          sectionTime: {
            start: {
              time: ''
            },
            end: {
              time: ''
            }
          },
          show_overlap: false,
          src_type: 2,
          delivery_type: 0,
          startLimit: [{
            type: 'fromto',
            from: __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(-1, 'day').format('YYYY-MM-DD')
          }],
          endLimit: [{
            type: 'fromto',
            from: __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(-1, 'day').format('YYYY-MM-DD')
          }]
        };

        this.rule_section_list.push(setting);
      } else {
        this.$notify({
          title: '提醒',
          text: '請選擇門市',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      }
    },
    addWeekSetting: function addWeekSetting() {
      if (this.storeSelect.value) {
        var setting = {
          rule_type: 2,
          rule_day: '',
          rule_start_time: '',
          rule_end_time: '',
          amount: 1,
          is_enabled: 1,
          show_overlap: false,
          src_type: 2,
          delivery_type: 0,
          id: this.rule_week_list.length
        };
        this.rule_week_list.push(setting);
      } else {
        this.$notify({
          title: '提醒',
          text: '請選擇門市',
          duration: 3000,
          type: 'danger',
          width: 400
        });
      }
    },
    removeListItem: function removeListItem(list, index) {
      list.splice(index, 1);
    },
    addRule: function addRule() {
      var rule = { rule_type: { label: '每日', value: 0 }, rule_date: { time: '' }, rule_day: '', rule_month_day: '', rule_start_time: '', rule_end_time: '' };
      this.rule_list.push(rule);
    },
    checkSetting: function checkSetting() {
      if (this.checkedForm) {
        this.submit();
        return;
      }

      var msg = '';
      var self = this;
      if (!this.storeSelect.value) {
        msg = '請選擇門市';
        this.getToast(msg);
      } else if (this.rule_section_list.length === 0 && this.rule_week_list.length === 0) {
        msg = '" 新增指定區間設定或者週期設定 " 未新增 請填寫';
        this.getToast(msg);
      } else {
        if (self.rule_section_list) {
          self.rule_section_list.forEach(function (item) {
            item.show_overlap = false;
            self.show_section_overlap = false;
          });
        }
        if (self.rule_week_list) {
          self.rule_week_list.forEach(function (item) {
            if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(item.rule_start_time, 'HH:mm', true).isValid()) item.rule_start_time = __WEBPACK_IMPORTED_MODULE_2_moment___default()(item.rule_start_time, 'HH:mm', true).format('HH:mm:ss');
            if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(item.rule_end_time, 'HH:mm', true).isValid()) item.rule_end_time = __WEBPACK_IMPORTED_MODULE_2_moment___default()(item.rule_end_time, 'HH:mm', true).format('HH:mm:ss');
            item.show_overlap = false;
            self.show_week_overlap = false;
          });
        }
        if (self.rule_section_list) {
          self.rule_section_list.forEach(function (item, i) {
            if (!item.sectionTime.start.time) {
              msg = ' " 指定區間 " 未填寫 請填寫';
              self.show_section_overlap = true;
              item.show_overlap = true;
            } else if (!item.sectionTime.end.time) {
              msg = ' " 指定區間 " 未填寫 請填寫';
              self.show_section_overlap = true;
              item.show_overlap = true;
            } else if (!item.rule_start_time || !__WEBPACK_IMPORTED_MODULE_2_moment___default()(item.rule_start_time, 'HH:mm', true).isValid()) {
              msg = ' " 開始時間 " 未填寫 請填寫';
              self.show_section_overlap = true;
              item.show_overlap = true;
            } else if (!item.rule_end_time || !__WEBPACK_IMPORTED_MODULE_2_moment___default()(item.rule_end_time, 'HH:mm', true).isValid()) {
              msg = ' " 結束時間 " 未填寫 請填寫';
              self.show_section_overlap = true;
              item.show_overlap = true;
            } else if (!item.amount || item.amount === 0) {
              msg = ' " 數量上限 " 未填寫 請填寫';
              self.show_section_overlap = true;
              item.show_overlap = true;
            } else if (item.sectionTime.start.time > item.sectionTime.end.time) {
              msg = '開始日大於結束日';
              self.show_section_overlap = true;
              item.show_overlap = true;
            } else if (item.rule_start_time > item.rule_end_time) {
              msg = '開始時間大於結束時間';
              self.show_section_overlap = true;
              item.show_overlap = true;
            }

            if (item.is_enabled === 1 || item.is_enabled === '1') {
              var date1 = item.sectionTime.start.time;
              var date2 = item.sectionTime.end.time;
              var time1 = item.rule_start_time;
              var time2 = item.rule_end_time;
              for (var step = self.rule_section_list.length - 1; step > i; step--) {
                if (!self.rule_section_list[step].sectionTime.start.time) {
                  msg = ' " 指定時間 " 未填寫 請填寫';
                  self.show_section_overlap = true;
                  self.rule_section_list[step].show_overlap = true;
                } else if (!self.rule_section_list[step].sectionTime.end.time) {
                  msg = ' " 指定時間 " 未填寫 請填寫';
                  self.show_section_overlap = true;
                  self.rule_section_list[step].show_overlap = true;
                } else if (!self.rule_section_list[step].rule_start_time || !__WEBPACK_IMPORTED_MODULE_2_moment___default()(self.rule_section_list[step].rule_start_time, 'HH:mm', true).isValid()) {
                  msg = ' " 開始時間 " 未填寫 請填寫';
                  self.show_section_overlap = true;
                  self.rule_section_list[step].show_overlap = true;
                } else if (!self.rule_section_list[step].rule_end_time || !__WEBPACK_IMPORTED_MODULE_2_moment___default()(self.rule_section_list[step].rule_end_time, 'HH:mm', true).isValid()) {
                  msg = ' " 結束時間 " 未填寫 請填寫';
                  self.show_section_overlap = true;
                  self.rule_section_list[step].show_overlap = true;
                } else if (!self.rule_section_list[step].amount || self.rule_section_list[step].amount === 0) {
                  msg = ' " 數量上限 " 未填寫 請填寫';
                  self.show_section_overlap = true;
                  self.rule_section_list[step].show_overlap = true;
                } else {
                  if (self.rule_section_list[step].is_enabled === 1 || self.rule_section_list[step].is_enabled === '1') {
                    if (self.rule_section_list[step].delivery_type === item.delivery_type || self.rule_section_list[step].delivery_type === 0 || item.delivery_type === 0) {
                      var edate1 = self.rule_section_list[step].sectionTime.start.time;
                      var edate2 = self.rule_section_list[step].sectionTime.end.time;
                      var etime1 = self.rule_section_list[step].rule_start_time;
                      var etime2 = self.rule_section_list[step].rule_end_time;
                      if (self.dateRangeOverlaps(date1, date2, edate1, edate2) === true) {
                        if (self.dateRangeOverlaps(time1, time2, etime1, etime2) === true) {
                          msg = '';
                          self.show_section_overlap = true;
                          self.rule_section_list[step].show_overlap = true;
                          self.rule_section_list[i].show_overlap = true;
                          self.checkedFormEvnet();
                        }
                      }
                    }
                  }
                }
              }
              self.rule_week_list.forEach(function (itemW, wi) {
                if (!itemW.rule_day) {
                  msg = ' " 星期 " 未填寫 請填寫';
                  self.show_week_overlap = true;
                  itemW.show_overlap = true;
                } else if (!itemW.rule_start_time || !__WEBPACK_IMPORTED_MODULE_2_moment___default()(itemW.rule_start_time, 'HH:mm', true).isValid()) {
                  msg = ' " 開始時間 " 未填寫 請填寫';
                  self.show_week_overlap = true;
                  itemW.show_overlap = true;
                } else if (!itemW.rule_end_time || !__WEBPACK_IMPORTED_MODULE_2_moment___default()(itemW.rule_end_time, 'HH:mm', true).isValid()) {
                  msg = ' " 結束時間 " 未填寫 請填寫';
                  self.show_week_overlap = true;
                  itemW.show_overlap = true;
                } else if (!itemW.amount || !item.amount === 0) {
                  msg = ' " 數量上限 " 未填寫 請填寫';
                  self.show_week_overlap = true;
                  itemW.show_overlap = true;
                } else {
                  if (itemW.is_enabled === 1 || itemW.is_enabled === '1') {
                    if (itemW.delivery_type === item.delivery_type || itemW.delivery_type === 0 || item.delivery_type === 0) {
                      var date1a = new Date(date1);
                      var date2a = new Date(date2);
                      if (self.weekRange(date1a, date2a, Number(itemW.rule_day)) === true) {
                        if (self.dateRangeOverlaps(time1, time2, itemW.rule_start_time, itemW.rule_end_time) === true) {
                          msg = '';
                          self.show_week_overlap = true;
                          self.show_section_overlap = true;
                          self.rule_week_list[wi].show_overlap = true;
                          self.rule_section_list[i].show_overlap = true;
                          self.checkedFormEvnet();
                        }
                      }
                    }
                  }
                }
              });
            }
          });
        }

        if (this.rule_week_list) {
          this.rule_week_list.forEach(function (item, wi) {
            if (!item.rule_day) {
              msg = ' " 星期 " 未填寫 請填寫';
              self.show_week_overlap = true;
              item.show_overlap = true;
            } else if (!item.rule_start_time || !__WEBPACK_IMPORTED_MODULE_2_moment___default()(item.rule_start_time, 'HH:mm:ss', true).isValid()) {
              msg = ' " 開始時間 " 未填寫 請填寫';
              self.show_week_overlap = true;
              item.show_overlap = true;
            } else if (!item.rule_end_time || !__WEBPACK_IMPORTED_MODULE_2_moment___default()(item.rule_end_time, 'HH:mm:ss', true).isValid()) {
              msg = ' " 結束時間 " 未填寫 請填寫';
              self.show_week_overlap = true;
              item.show_overlap = true;
            } else if (!item.amount || !item.amount === 0) {
              msg = ' " 數量上限 " 未填寫 請填寫';
              self.show_week_overlap = true;
              item.show_overlap = true;
            } else if (item.rule_start_time > item.rule_end_time) {
              msg = '開始時間大於結束時間';
              self.show_week_overlap = true;
              item.show_overlap = true;
            } else {
              if (item.is_enabled === 1 || item.is_enabled === '1') {
                var firstTime = {
                  start: item.rule_start_time,
                  end: item.rule_end_time
                };
                for (var step = self.rule_week_list.length - 1; step > wi; step--) {
                  if (self.rule_week_list[step].is_enabled === 1 || self.rule_week_list[step].is_enabled === '1') {
                    if (self.rule_week_list[step].delivery_type === item.delivery_type || self.rule_week_list[step].delivery_type === 0 || item.delivery_type === 0) {
                      if (Number(item.rule_day) === Number(self.rule_week_list[step].rule_day)) {
                        var compareTime = {
                          start: self.rule_week_list[step].rule_start_time,
                          end: self.rule_week_list[step].rule_end_time
                        };
                        if (self.overlappingTime(firstTime, compareTime)) {
                          console.log('here');
                          console.log(firstTime);
                          console.log(compareTime);
                          console.log(self.rule_week_list[step].amount);
                          console.log(item.amount);
                          console.log(wi);
                          console.log(step);

                          msg = '';
                          self.show_week_overlap = true;
                          self.rule_week_list[wi].show_overlap = true;
                          self.rule_week_list[step].show_overlap = true;
                          self.checkedFormEvnet();
                        }
                      }
                    }
                  }
                }
              }
            }
          });
        }
        self.getToast(msg);
        if (!this.show_section_overlap) {
          self.submit();
        }
      }
    },
    getToast: function getToast(msg) {
      if (!msg) return;
      this.$notify({
        title: '設定格式重複',
        text: msg,
        duration: 3000,
        type: 'danger',
        width: 400
      });
    },
    checkedFormEvnet: function checkedFormEvnet() {
      this.checkedForm = true;
      this.checkedFormModal = true;
    },
    submit: function submit() {
      var rName = this.$route.name;
      var data = {
        brand_id: this.brandSelect.value,
        store_id: this.storeSelect.value,
        item_list: []
      };
      if (this.name) data.name = this.name;else data.name = ' ';
      if (this.description) data.description = this.description;else data.description = ' ';

      this.rule_section_list.forEach(function (item) {
        var obj = {
          delivery_type: Number(item.delivery_type),
          src_type: Number(item.src_type),
          rule_type: 1,
          rule_start_date: item.sectionTime.start.time,
          rule_end_date: item.sectionTime.end.time,
          rule_start_time: item.rule_start_time + ':00',
          rule_end_time: item.rule_end_time + ':59',
          amount: Number(item.amount),
          is_enabled: Number(item.is_enabled)
        };
        data.item_list.push(obj);
      });
      this.rule_week_list.forEach(function (item) {
        var obj = {
          delivery_type: Number(item.delivery_type),
          src_type: Number(item.src_type),
          rule_type: 2,
          rule_day: item.rule_day,
          rule_start_time: item.rule_start_time,
          rule_end_time: item.rule_end_time,
          amount: Number(item.amount),
          is_enabled: Number(item.is_enabled)
        };
        data.item_list.push(obj);
      });

      if (rName === 'crLimitScheduleItem') this.crLimitSchedule(data);else if (rName === 'upLimitScheduleItem') this.crLimitSchedule(data);
    },
    overlappingTime: function overlappingTime(a, b) {
      var getMinutes = function getMinutes(s) {
        var p = s.split(':').map(Number);
        return p[0] * 60 + p[1];
      };
      return getMinutes(a.end) > getMinutes(b.start) && getMinutes(b.end) > getMinutes(a.start);
    },
    dateRangeOverlaps: function dateRangeOverlaps(startA, endA, startB, endB) {
      if (startA === endA && startB === endB) {
        return startA === startB;
      } else if (startA === endA && startB !== endB) {
        return startA >= startB && startA <= endB;
      } else if (startA !== endA && startB === endB) {
        return startB >= startA && startB <= endA;
      } else {
        return startA <= endB && startB < endA;
      }
    },
    weekRange: function weekRange(startA, endA, weekday) {
      var start = startA.getDay() + 1;
      var end = endA.getDay() + 1;
      if (start < end) {
        if (weekday < start || weekday > end) {
          return false;
        } else {
          return true;
        }
      } else if (start > end) {
        if (weekday < start && weekday > end) {
          return false;
        } else {
          return true;
        }
      } else {
        if (weekday !== start) {
          return false;
        } else {
          return true;
        }
      }
    },
    crLimitSchedule: function crLimitSchedule(data) {
      var self = this;
      var brandId = this.$route.query.brand_id;
      var storeId = this.$route.query.store_id;

      var connectType = 'post';
      var url = '/storeOrderAmountLimitSetting/create';

      if (this.$route.params.setting_id) {
        connectType = 'put';
        url = '/storeOrderAmountLimitSetting/' + this.$route.params.setting_id;
      }
      this.getDataH(connectType, url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          if (storeId) {
            self.$router.push('/limitedItemScheduleTable?brand=' + brandId + '&store=' + storeId);
          } else if (brandId) {
            self.$router.push('/limitedItemScheduleTable?brand=' + brandId);
          } else {
            self.$router.push('/limitedItemScheduleTable');
          }
        }
      });
    },
    getAmountlimitSetting: function getAmountlimitSetting() {
      var self = this;

      var url = '/storeOrderAmountLimitSetting/' + this.$route.params.setting_id;

      self.item_list = [];
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sInfo = response.data.info;
          self.brandSelect.value = sInfo.brand_id;
          self.brandSelect.label = sInfo.brand_name;
          self.storeSelect.value = sInfo.store_id;
          self.storeSelect.label = sInfo.store_name;
          self.name = sInfo.name;
          self.description = sInfo.description;
          sInfo.item_list.forEach(function (item, index) {
            if (item.rule_type === 1) {
              var obj = {
                rule_type: item.rule_type,
                rule_start_date: item.rule_start_date,
                rule_end_date: item.rule_end_date,
                rule_start_time: item.rule_start_time,
                rule_end_time: item.rule_end_time,
                amount: item.amount,
                is_enabled: item.is_enabled,
                sectionTime: {
                  start: {
                    time: item.rule_start_date
                  },
                  end: {
                    time: item.rule_end_date
                  }
                },
                show_overlap: false,
                src_type: item.src_type,
                delivery_type: item.delivery_type,
                endLimit: [{
                  type: 'fromto',
                  from: __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(-1, 'day').format('YYYY-MM-DD')
                }],
                startLimit: [{
                  type: 'fromto',
                  from: __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(-1, 'day').format('YYYY-MM-DD')
                }]
              };
              var sdate = new Date(item.rule_start_date);
              var startdate = new Date(sdate);
              startdate.setDate(startdate.getDate() - 1);
              obj.endLimit[0].from = startdate.toISOString().split('T')[0];
              self.rule_section_list.push(obj);
            } else if (item.rule_type === 2) {
              var _obj = {
                rule_type: item.rule_type,
                rule_day: Number(item.rule_day),
                rule_start_time: item.rule_start_time,
                rule_end_time: item.rule_end_time,
                amount: item.amount,
                is_enabled: item.is_enabled,
                show_overlap: false,
                src_type: item.src_type,
                delivery_type: item.delivery_type,
                id: index
              };
              self.rule_week_list.push(_obj);
            }
          });
        }
      });
    },
    getProductAlias: function getProductAlias() {
      var self = this;
      var url = '/brand/' + this.$route.params.brand_id + '/productAliasSetting/' + this.$route.params.setting_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var setting = response.data.setting;
          self.vendor_custom_id = setting.vendor_custom_id;
          self.alias_name = setting.item_list[0].name;
          if (!setting.is_enabled) self.is_enabled = 0;
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    checkSelectAll: function checkSelectAll() {
      if (this.$route.name === 'upDisableSchedule') {
        return true;
      } else if (this.$route.name === 'crDisableSchedule') {
        if (this.addStoresSetting.choose.length > 0) {
          return true;
        } else {
          return false;
        }
      }
    },
    storedeliveryInfo: function storedeliveryInfo() {
      var self = this;
      var deliveryArray = [];
      this.store_deliveryInfo.forEach(function (deliveryI) {
        if (deliveryI.is_support === 1) {
          deliveryArray.push(self.deliveryTypeOption.find(function (delivery) {
            return delivery.value === deliveryI.delivery_type;
          }));
        }
      });
      return deliveryArray;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    },
    checkSettingText: function checkSettingText() {
      var text = '';
      if (this.up) {
        text = '更新';
      }
      if (this.up && this.checkedForm) {
        text = '確定更新';
      }
      if (!this.up) {
        text = '新增';
      }
      if (!this.up && this.checkedForm) {
        text = '確定新增';
      }
      return text;
    }
  }),
  watch: {},
  created: function created() {
    if (this.$route.name === 'upLimitScheduleItem') {
      this.up = true;
      this.getStoreLimitSetting(this.$route.query.brand_id);
      this.getStoreInfo(this.$route.query.store_id);
      this.getAmountlimitSetting();
    } else {
      this.getBrandBrief();
    }
  }
});

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['isSearch', 'date', 'statusSelect'],
  name: 'Tables',
  data: function data() {
    return {
      name: '迷客夏',
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      total: 1,
      count: 20,
      history: false,
      storeList: [],
      mqttList: [],
      storeInfo: {
        id: '',
        name: '',
        tel: ''
      }
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#example1').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      });
    });
  },

  methods: {
    getMqttTable: function getMqttTable() {
      var self = this;
      var date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date).format('YYYYMMDD');
      var url = 'store/' + this.$route.params.store_id + '/mqttHistory/?date=' + date;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          if (response.data.history.mqtt_info) self.mqttList = response.data.history.mqtt_info;else self.mqttList = [];
          self.storeInfo = {
            id: response.data.history.id,
            name: response.data.history.name,
            tel: response.data.history.tel
          };
        }
      });
      this.isSearch.active = false;
    },
    getTime: function getTime(time) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(time, 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss');
    }
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  },
  watch: {
    'isSearch.active': function isSearchActive() {
      if (this.isSearch.active) {
        this.getMqttTable();
      }
    },
    statusSelect: function statusSelect() {
      var select = parseInt(this.statusSelect, 10);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.td-status').each(function () {
        var sId = parseInt(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('status'), 10);
        if (select === 99) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).show();
        } else {
          if (select === sId) __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).show();else __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).hide();
        }
      });
    }
  }
});

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__elements_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);











/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['brandId', 'search'],
  name: 'Tables',
  components: {
    'm-modal': __WEBPACK_IMPORTED_MODULE_4__elements_Modal_vue___default.a
  },
  data: function data() {
    return {
      roleType: 0,
      name: '迷客夏',
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      total: 1,
      count: 20,
      history: false,
      storeList: [],
      current: {
        openList: {},
        deliveryList: {},
        payList: {},
        name: '',
        mqttInfo: [],
        storeId: 0
      },
      openStatusOption: {
        id: 'openStatusModal',
        title: '',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '開啟接單',
          event: 'openStatus'
        }]
      },
      closeStatusOption: {
        id: 'closeStatusModal',
        title: '',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '停止接單',
          event: 'closeStatus'
        }]
      },
      isLoading: true
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#example1').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      });
    });
  },

  methods: {
    trigger: function trigger(event) {
      if (event === 'openStatus') {
        this.changeStatus('open');
      } else if (event === 'closeStatus') {
        this.changeStatus('close');
      }
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    getStateName: function getStateName(state) {
      if (state === 0) {
        return '尚未營業';
      } else if (state === 1) {
        return '籌備中';
      } else if (state === 2) {
        return '營業中';
      } else if (state === 3) {
        return '休息中';
      } else if (state === 9) {
        return '已歇業';
      }
    },
    getDayName: function getDayName(day) {
      if (day === 1) {
        return '日';
      } else if (day === 2) {
        return '一';
      } else if (day === 3) {
        return '二';
      } else if (day === 4) {
        return '三';
      } else if (day === 5) {
        return '四';
      } else if (day === 6) {
        return '五';
      } else if (day === 7) {
        return '六';
      }
    },
    getStoreList: function getStoreList() {
      this.isLoading = true;
      var self = this;
      var data = {
        page: this.tableIndex,
        size: this.count
      };
      var url = '/brand/' + this.brandId + '/storeList?page=' + data.page + '&size=' + data.size;
      if (this.search.type === 1 && this.search.val) url = url + '&name=' + this.search.val;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.storeList = response.data.list;
          self.isLoading = false;
          self.total = response.data.list_total;
        }
      });
    },
    openModal: function openModal(store) {
      this.current.storeId = store.id;
      this.current.openList = store.opening_info;
      this.current.deliveryList = store.delivery_info;
      this.current.payList = store.trade_info;
      this.current.name = store.name;
      this.current.mqttInfo = store.mqtt_info;
      this.openStatusOption.title = '是否開啟' + this.current.name + '店家狀態？';
      this.closeStatusOption.title = '是否關閉' + this.current.name + '店家狀態？';
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.getStoreList();
    },
    getTime: function getTime(time) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(time, 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss');
    },
    gotoSearchMqtt: function gotoSearchMqtt(store) {
      this.$router.push({ path: 'mqttSearch/' + store.id });
    },
    changeStatus: function changeStatus(active) {
      var self = this;
      var data = {
        order_status: 10
      };
      if (active === 'close') {
        data.order_status = 20;
      }
      var url = '/store/' + this.current.storeId;
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: '接單狀態更新成功',
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.tableIndex = 1;
          self.getStoreList();
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  }),
  created: function created() {
    this.roleType = parseInt(this.getRoleType, 10);
  },

  watch: {
    brandId: function brandId() {
      if (this.brandId) {
        this.tableIndex = 1;
        this.getStoreList();
      }
    },
    'search.status': function searchStatus() {
      if (this.search.status) this.getStoreList();
      this.search.status = false;
    }
  }
});

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__elements_Modal_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    'info': {
      type: Object
    }
  },
  components: {
    'm-modal': __WEBPACK_IMPORTED_MODULE_0__elements_Modal_vue___default.a
  },
  data: function data() {
    return {
      phone: '',
      radioRoleType: 'admin',
      delOption: {
        id: 'delModal',
        title: '刪除出單機',
        body: '確定刪除?<br>刪除此出單機，將無法再用此帳號登入！',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delPrinter'
        }]
      },
      show: {
        delBtn: false
      },
      content: {
        identity: '',
        type: 1,
        is_enabled: 1
      }
    };
  },

  methods: {
    trigger: function trigger(event) {
      if (event === 'delPrinter') {
        this.delPrinter();
      }
    },
    checkPrinter: function checkPrinter(type) {
      var msg = '';
      if (!this.content.identity) {
        msg = '請輸入辨識碼';
      }
      this.getToast(msg, type);
    },
    getToast: function getToast(msg, type) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        if (type === 'cr') this.addPrinter();else if (type === 'up') this.upPointer();
      }
    },
    addPrinter: function addPrinter() {
      var self = this;
      var url = '/printer';
      var info = this.content;
      var data = {
        type: info.type,
        identity: info.identity
      };
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.replace('/printerTable');
        }
      });
    },
    upPointer: function upPointer() {
      var self = this;
      var url = '/printer/' + this.$route.params.printer_id;
      var info = this.content;
      var data = {
        type: info.type,
        identity: info.identity,
        is_enabled: info.is_enabled
      };
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.replace('/printerTable');
        }
      });
    },
    delPrinter: function delPrinter() {
      var self = this;
      var url = '/printer/' + this.$route.params.printer_id;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.replace('/printerTable');
        }
      });
    }
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  },
  watch: {
    info: function info() {
      var info = this.info;
      this.content = {
        identity: info.printer_identity,
        type: info.printer_type,
        is_enabled: info.printer_is_enabled
      };
      this.show.delBtn = true;
    }
  }
});

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__elements_Modal_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    'info': {
      type: Object
    },
    'current': {
      type: Object
    },
    'brandList': {
      type: Array
    },
    'storeList': {
      type: Array
    },
    'posList': {
      type: Array
    }
  },
  components: {
    'm-modal': __WEBPACK_IMPORTED_MODULE_0__elements_Modal_vue___default.a
  },
  data: function data() {
    return {
      phone: '',
      radioRoleType: 'admin',
      delOption: {
        id: 'delModal',
        title: '刪除店家綁定',
        body: '確定刪除?<br>刪除此店家綁定！',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delBinding'
        }]
      },
      show: {
        delBtn: false
      },
      select: {
        bindingBrandList: {},
        bindingStoreList: {},
        bindingPosList: {}
      },
      content: {
        name: '',
        is_enabled: 0,
        bindingBrandList: [],
        bindingStoreList: []
      },
      birth: {
        time: ''
      },
      brandName: '',
      brandType: '',
      brandBrief: [],
      storeBrief: [],
      brandDefault: 0
    };
  },

  methods: {
    init: function init() {
      if (!this.info) {
        this.getBrandBrief();
        this.getPosBrief();
      }
    },
    trigger: function trigger(event) {
      if (event === 'delBinding') {
        this.delBinding();
      }
    },
    checkPrinterStore: function checkPrinterStore(type) {
      var msg = '';
      if (!this.select.bindingStoreList.value && !this.info) {
        msg = '請選擇綁定店家';
      }
      this.getToast(msg, type);
    },
    getToast: function getToast(msg, type) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        });
      } else {
        if (type === 'cr') this.crPrinterStore();else if (type === 'up') this.upPointerStore();
      }
    },
    crPrinterStore: function crPrinterStore() {
      var self = this;
      var url = '/printer/storePrinter';
      var info = this.content;
      var data = {
        printer_id: this.$route.params.printer_id,
        store_id: this.select.bindingStoreList.value
      };
      if (this.content.name) data['name'] = info.name;
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.replace('/printerInfo/' + self.$route.params.printer_id);
        }
      });
    },
    upPrinterStore: function upPrinterStore() {
      var self = this;
      var url = '/printer/storePrinter/' + this.$route.params.binding_id;
      var info = this.content;
      var data = {
        is_enabled: info.is_enabled
      };
      if (this.content.name) data['name'] = info.name;
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.replace('/printerInfo/' + self.$route.params.printer_id);
        }
      });
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            self.brandBrief.push(obj);
            if (i === 0) {
              if (!self.storeList) self.brandDefault = obj.value;else {
                if (!self.storeList.length) self.brandDefault = obj.value;else self.brandDefault = self.storeList[0].brand_id;
              }
            }
          }
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      console.log('getStoreBrief | PrinterStoreFormTemp');
      this.storeBrief = [];
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
          }
        }
      });
    },
    delBinding: function delBinding() {
      var self = this;
      var url = '/printer/storePrinter/' + this.$route.params.binding_id;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.$router.replace('/printerInfo/' + self.$route.params.printer_id);
        }
      });
    },
    getPosBrief: function getPosBrief() {
      this.posBrief = [];
      var self = this;
      var url = '/pos/vendorBriefList';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var pList = response.data.list;
          for (var i = 0; i < pList.length; i++) {
            var obj = { label: pList[i].name, value: pList[i].po_vendor_id };
            self.posBrief.push(obj);
          }
        }
      });
    }
  },
  created: function created() {
    this.init();
  },

  watch: {
    'select.bindingBrandList': function selectBindingBrandList() {
      this.getStoreBrief(this.select.bindingBrandList.value);
      this.select.bindingStoreList = {};
      this.content.bindingBrandList = [this.select.bindingBrandList];
    },
    'select.bindingStoreList': function selectBindingStoreList() {
      this.content.bindingStoreList = [this.select.bindingStoreList];
    },
    'select.bindingPosList': function selectBindingPosList() {
      this.content.bindingPosList = [this.select.bindingPosList];
    },
    info: function info() {
      var info = this.info;
      var content = this.content;
      content.name = info.binding_name;
      content.is_enabled = info.binding_is_enabled;
    },
    brandDefault: function brandDefault() {
      this.storeBrief = [];
      this.bindingStoreList = [];
      this.content.bindingStoreList = [];
      this.getStoreBrief(this.brandDefault);
    },
    brandBrief: function brandBrief() {
      var contentBList = [];
      var bList = this.brandList;
      if (bList) {
        for (var i = 0; i < bList.length; i++) {
          this.brandBrief.filter(function (elem, index, obj) {
            if (elem.value === bList[i]) {
              contentBList.push(elem);
            }
          });
        }
        this.content.bindingBrandList = contentBList;
        this.select.bindingBrandList = contentBList;
      }
    },
    storeBrief: function storeBrief() {
      var contentSList = [];
      if (this.storeList) {
        if (this.storeList.length) {
          var sList = this.storeList[0].binding_store_list;
          if (sList) {
            for (var i = 0; i < sList.length; i++) {
              this.storeBrief.filter(function (elem, index, obj) {
                if (elem.value === sList[i]) {
                  contentSList.push(elem);
                }
              });
            }
            this.content.bindingStoreList = contentSList;
            this.select.bindingStoreList = contentSList[0];
          }
        }
      }
    },
    posBrief: function posBrief() {
      var contentPList = [];
      var pList = this.posList;
      if (pList) {
        for (var i = 0; i < pList.length; i++) {
          this.posBrief.filter(function (elem, index, obj) {
            if (elem.value === pList[i]) {
              contentPList.push(elem);
            }
          });
        }
        this.content.bindingPosList = contentPList;
        this.select.bindingPosList = contentPList;
      }
    }
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    bindStore: function bindStore() {
      var contentSList = [];
      var sList = this.storeList;
      if (sList) {
        for (var i = 0; i < sList.length; i++) {
          this.storeBrief.filter(function (elem, index, obj) {
            if (elem.value === sList[i]) {
              contentSList.push(elem);
            }
          });
        }
        return contentSList;
      }
    }
  }
});

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['storeId'],
  data: function data() {
    return {
      tableList: {
        id: '',
        create_time: '',
        item_list: []
      }
    };
  },

  methods: {
    getTableSetting: function getTableSetting() {
      this.tableItemList = [];
      var self = this;
      var url = '/store/' + this.storeId + '/tableSetting';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var tableSetting = response.data.setting;
          if (tableSetting) {
            self.tableList.id = tableSetting.id;
            self.tableList.create_time = tableSetting.create_time;
            self.tableList.item_list = tableSetting.item_list;
          } else {
            self.tableList = {
              id: '',
              create_time: '',
              item_list: []
            };
          }
        }
      });
    }
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  },
  watch: {
    storeId: function storeId() {
      this.getTableSetting();
    }
  }
});

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_PrinterFormTemp_vue__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_PrinterFormTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_PrinterFormTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      info: {}
    };
  },

  components: {
    'printer-form': __WEBPACK_IMPORTED_MODULE_0__Temp_PrinterFormTemp_vue___default.a
  },
  methods: {
    getPrinterInfo: function getPrinterInfo() {
      var self = this;
      var url = '/printer/' + this.$route.params.printer_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.info = response.data.printer;
        }
      });
    }
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  },
  created: function created() {
    this.getPrinterInfo();
  }
});

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_PrinterStoreFormTemp_vue__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Temp_PrinterStoreFormTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Temp_PrinterStoreFormTemp_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      info: {}
    };
  },

  components: {
    'printer-form': __WEBPACK_IMPORTED_MODULE_0__Temp_PrinterStoreFormTemp_vue___default.a
  },
  methods: {
    getBindingInfo: function getBindingInfo() {
      var self = this;
      var url = '/printer/storePrinter/' + this.$route.params.binding_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.info = response.data.printer;
        }
      });
    }
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  },
  created: function created() {
    this.getBindingInfo();
  }
});

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Temp_StoreListTemp_vue__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Temp_StoreListTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Temp_StoreListTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_vendor_Gantt_1_10_2_css_style_css__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_vendor_Gantt_1_10_2_css_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__static_vendor_Gantt_1_10_2_css_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_vendor_Gantt_1_10_2_js_jquery_fn_gantt_js__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_vendor_Gantt_1_10_2_js_jquery_fn_gantt_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__static_vendor_Gantt_1_10_2_js_jquery_fn_gantt_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__elements_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__extends_nd_extend_handle_menu_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__extends_nd_extend_handle_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__extends_nd_extend_handle_menu_vue__);















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BrandScheduleTable',
  extends: __WEBPACK_IMPORTED_MODULE_11__extends_nd_extend_handle_menu_vue___default.a,
  components: {
    'storelist-table': __WEBPACK_IMPORTED_MODULE_5__Temp_StoreListTemp_vue___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default.a,
    'm-modal': __WEBPACK_IMPORTED_MODULE_9__elements_Modal_vue___default.a
  },
  data: function data() {
    return {
      searchStoreId: '',
      scheduleMethod: 1,
      menuState: 4,
      name: '迷客夏',
      total: 1,
      count: 12,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      statusSelect: 99,
      statusList: [{ label: '全部', value: 99 }, { label: '上架中', value: 4 }, { label: '等待上架', value: 3 }, { label: '已下架', value: 5 }],
      menuList: [{ store_id: 1, store_name: '長春店', menu_name: '夏日菜單', menu_id: '1', status: 3, start_time: '2018/01/01', end_time: '2018/12/31' }, { store_id: 1, store_name: '中山店', menu_name: '夏日菜單', menu_id: '1', status: 3, start_time: '2018/01/01', end_time: '2018/12/31' }, { store_id: 1, store_name: '雙連店', menu_name: '菜單B', menu_id: '3', status: 3, start_time: '2018/01/01', end_time: '2018/12/31' }, { store_id: 1, store_name: '光復店', menu_name: '菜單A', menu_id: '2', status: 3, start_time: '2018/01/01', end_time: '2018/12/31' }, { store_id: 1, store_name: '民權西路店', menu_name: '菜單B', menu_id: '3', status: 3, start_time: '2018/01/01', end_time: '2018/12/31' }, { store_id: 1, store_name: '晶華店', menu_name: '菜單C', menu_id: '4', status: 3, start_time: '2018/01/01', end_time: '2018/12/31' }],
      info: {
        menuName: '夏日菜單',
        menu_id: 123323,
        start_time: '2017-03-31 12:22:32',
        end_time: '2017-03-31 12:22:32',
        update_time: '2017-03-31 12:22:32',
        create_time: '2017-03-31 12:22:32'
      },
      menu_schedule_list: [],
      scheduleList: [],
      curGroup: '',
      curSchedule: '',
      delOption: {
        id: 'delModal',
        title: '刪除檔期群組',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'delGroup'
        }]
      },
      removeGNowOption: {
        id: 'removeGNowModal',
        title: '檔期群組下架',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'removeGNow'
        }]
      },
      saleGNowOption: {
        id: 'saleGNowModal',
        title: '檔期群組上架',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'saleGNow'
        }]
      },
      removeNowOption: {
        id: 'removeNowModal',
        title: '店家檔期下架',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'removeNow'
        }]
      },
      saleNowOption: {
        id: 'saleNowModal',
        title: '店家檔期上架',
        body: '',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'saleNow'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.getExtendHandleMenuInfo();
  },

  methods: {
    clickGroup: function clickGroup(type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1;
        this.tableIndex = this.groupAmount * this.pageGroup;
        this.clickPage(this.tableIndex);
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1;
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1;
        this.clickPage(this.tableIndex);
      }
    },
    clickEnd: function clickEnd(type) {
      if (type === 'pre') {
        this.clickPage(1);
        this.pageGroup = 1;
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount);else this.clickPage(1);
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount);
      }
    },
    getTime: function getTime(time) {
      if (time) {
        return __WEBPACK_IMPORTED_MODULE_10_moment___default()(time, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm');
      }
    },
    trigger: function trigger(event) {
      if (event === 'delGroup') {
        this.delGroup();
      } else if (event === 'removeGNow') {
        this.removeGNow();
      } else if (event === 'saleGNow') {
        this.saleGNow();
      } else if (event === 'removeNow') {
        this.removeNow();
      } else if (event === 'saleNow') {
        this.saleNow();
      }
    },
    statusName: function statusName(type) {
      switch (type) {
        case 3:
          return '等待上架';
        case 4:
          return '上架中';
        case 5:
          return '已下架';
      }
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    editStores: function editStores(menuId) {
      this.$router.push('/upSchedule/all/' + menuId);
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.getList();
    },
    getScheduleGroupList: function getScheduleGroupList(page) {
      var _this = this;

      if (page) this.tableIndex = page;
      var data = {
        page: this.tableIndex,
        size: this.count
      };
      var url = this.base + this.id + '/menu/schedule/group/list?page=' + data.page + '&size=' + data.size + '&sortby=start_time DESC';
      if (this.statusSelect !== 99 && this.statusSelect) url = url + '&status=' + this.statusSelect;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this.total = response.data.meta.total;
          var sList = response.data.menu_schedule_group_list;
          _this.scheduleList = sList;
        }
      });
    },
    getScheduleList: function getScheduleList(page) {
      var self = this;
      if (page) this.tableIndex = page;
      var data = {
        page: this.tableIndex,
        size: this.count
      };
      var url = this.base + this.id + '/menu/schedule/list?page=' + data.page + '&size=' + data.size + '&sortby=start_time DESC';
      if (self.statusSelect !== 99 && self.statusSelect) url = url + '&status=' + self.statusSelect;
      if (self.searchStoreId) url = url + '&store_id=' + self.searchStoreId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.total = response.data.meta.total;
          var sList = response.data.menu_schedule_list;
          self.scheduleList = sList;
        }
      });
    },
    checkDoubleStore: function checkDoubleStore(storeIdList) {
      var newScheduleList = [];
      for (var key in storeIdList) {
        if (storeIdList[key].length === 1) {
          newScheduleList.push(storeIdList[key][0]);
        } else {
          var combineSchedule = {};
          for (var i = 0; i < storeIdList[key].length; i++) {
            if (i === 0) {
              combineSchedule = storeIdList[key][i];
            } else {
              combineSchedule.values.push(storeIdList[key][i].values[0]);
            }
          }
          newScheduleList.push(combineSchedule);
        }
      }
      this.setGantt(newScheduleList);
    },
    setGantt: function setGantt(scheduleList) {
      var self = this;
      if (scheduleList.length) {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.gantt').gantt({
          source: scheduleList,
          scale: 'months',
          minScale: 'months',
          navigate: 'scroll',
          waitText: '正在讀取菜單排程...',
          itemsPerPage: 12,
          onItemClick: function onItemClick(data) {
            self.$router.push({ path: '/storeScheduleTable/' + self.$route.params.brand_id + '/' + data.store_id });
          }
        });
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.gantt').css('display', 'block');
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('menu-info').css('display', 'block');
      } else {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.gantt').css('display', 'none');
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('menu-info').css('display', 'none');
      }
    },
    removeGNow: function removeGNow() {
      var self = this;
      var url = this.base + this.id + '/menu/schedule/group/' + self.curGroup + '/removenow';
      this.getDataH('put', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '下架成功',
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.getScheduleGroupList();
        }
      });
    },
    saleGNow: function saleGNow() {
      var self = this;
      var url = this.base + this.id + '/menu/schedule/group/' + self.curGroup + '/salenow';
      this.getDataH('put', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '上架成功',
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.getScheduleGroupList();
        }
      });
    },
    removeNow: function removeNow() {
      var self = this;
      var url = this.base + this.id + '/menu/schedule/' + self.curSchedule + '/removenow';
      this.getDataH('put', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '下架成功',
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.getScheduleList();
        }
      });
    },
    saleNow: function saleNow() {
      var self = this;
      var url = this.base + this.id + '/menu/schedule/' + self.curSchedule + '/salenow';
      this.getDataH('put', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '上架成功',
            duration: 3000,
            type: 'success',
            width: 400
          });
          self.getScheduleList();
        }
      });
    },
    delGroup: function delGroup() {
      var self = this;
      var url = this.base + this.id + '/menu/schedule/group/' + self.curGroup;
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '刪除成功',
            duration: 3000,
            type: 'success',
            width: 400
          });
          if (self.scheduleMethod === 1) {
            self.getScheduleGroupList();
          } else {
            self.getScheduleList();
          }
        }
      });
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    },
    getList: function getList(page) {
      if (page) {
        if (this.scheduleMethod === 1) this.getScheduleGroupList(1);else this.getScheduleList(1);
      } else {
        if (this.scheduleMethod === 1) this.getScheduleGroupList();else this.getScheduleList();
      }
    },
    goToStoreMenuScheduleEdit: function goToStoreMenuScheduleEdit(_ref) {
      var _ref$menu = _ref.menu,
          menu = _ref$menu === undefined ? {} : _ref$menu,
          _ref$type = _ref.type,
          type = _ref$type === undefined ? 0 : _ref$type;

      console.log('goToStoreMenuScheduleEdit', menu);
      var name = '';
      var params = {
        brand_id: this.$route.params.brand_id,
        store_id: ''
      };

      if (this.isStore && this.getRoleType !== 10) {
        if (type === 1) {
          name = 'StoreMenuScheduleEditG';
          params.group_id = menu.group_id;
        }
        if (type === 2) {
          name = 'StoreMenuScheduleEditS';
          params.schedule_id = menu.schedule_id;
        }
        params.store_id = this.$route.params.store_id;
      } else {
        if (type === 1) {
          name = 'upSchedule';
          params.group_id = menu.group_id;
        }
        if (type === 2) {
          name = 'upStoreSchedule';
          params.schedule_id = menu.schedule_id;
        }
      }

      this.$router.push({ name: name, params: params });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    scheduleListNew: function scheduleListNew() {
      var menuList = {};
      var oldList = this.menu_schedule_list;
      for (var key in oldList) {
        menuList[oldList[key].menu_id] = {
          menu_id: oldList[key].menu_id,
          storeList: []
        };
      }
      for (var k in oldList) {
        menuList[oldList[k].menu_id].storeList.push({
          store_id: oldList[k].store_id,
          store_name: oldList[k].store_name,
          start_time: oldList[k].start_time,
          end_time: oldList[k].end_time,
          status: oldList[k].status,
          update_time: oldList[k].update_time,
          create_time: oldList[k].create_time,
          schedule_id: oldList[k].schedule_id,
          menu_id: oldList[key].menu_id
        });
      }
      return menuList;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  }),
  watch: {
    statusSelect: function statusSelect() {
      this.getList();
    },
    menuState: function menuState() {
      this.tableIndex = 1;
      this.pageGroup = 1;
    },
    scheduleMethod: function scheduleMethod() {
      this.tableIndex = 1;
      this.pageGroup = 1;
      this.getList(1);
      window.sessionStorage.setItem('Nidin_scheduleTable_method', this.scheduleMethod);
    }
  },
  created: function created() {
    var method = window.sessionStorage.getItem('Nidin_scheduleTable_method');
    if (method) this.scheduleMethod = parseInt(method, 10);
    if (this.scheduleMethod === 1) this.getScheduleGroupList();else this.getScheduleList();
  }
});

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_datepicker__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__extends_nd_extend_handle_menu_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__extends_nd_extend_handle_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__extends_nd_extend_handle_menu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Temp_StoreListTemp_vue__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Temp_StoreListTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Temp_StoreListTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_elements_nd_multi_select_listbox_vue__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_elements_nd_multi_select_listbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_elements_nd_multi_select_listbox_vue__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CrSchedule',
  extends: __WEBPACK_IMPORTED_MODULE_4__extends_nd_extend_handle_menu_vue___default.a,
  components: {
    'storelist-table': __WEBPACK_IMPORTED_MODULE_5__Temp_StoreListTemp_vue___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_2_vue2_datepicker__["a" /* default */],
    'nd-multi-select-listbox': __WEBPACK_IMPORTED_MODULE_6__components_elements_nd_multi_select_listbox_vue___default.a
  },
  data: function data() {
    return {
      brandId: 0,
      content: {
        bindingStoreList: []
      },
      storeBrief: [],
      oldScheduleTime: '',
      scheduleTime: '',
      menuTime: {
        start: {
          time: __WEBPACK_IMPORTED_MODULE_3_moment___default()().set('second', 0).add(5, 'm').format('YYYY-MM-DD HH:mm:ss')
        }
      },
      show: {
        back: false
      },
      tableIndex: 1,
      menuId: 0,
      menuName: '',
      storeId: 0,
      startTime: {
        time: ''
      },
      endtime: {
        time: ''
      },
      info: {
        menuName: '夏日菜單',
        menu_id: 123323,
        start_time: '2017-03-31 12:22:32',
        end_time: '2017-03-31 12:22:32',
        update_time: '2017-03-31 12:22:32',
        create_time: '2017-03-31 12:22:32'
      },
      menu_schedule_list: [{
        'schedule_id': 122,
        'store_id': 1,
        'store_name': '金山店',
        'menu_id': 1,
        'start_time': '2017-07-24 08:00:00',
        'end_time': '2017-08-01 00:00:00',
        'status': 1,
        'update_time': '2017-01-14 16:09:16',
        'create_time': '2017-01-14 16:09:16'
      }, {
        'schedule_id': 123,
        'store_id': 2,
        'store_name': '中山店',
        'menu_id': 2,
        'start_time': '2017-07-24 08:00:00',
        'end_time': '2017-08-01 00:00:00',
        'status': 1,
        'update_time': '2017-01-14 16:09:16',
        'create_time': '2017-01-14 16:09:16'
      }],
      addStoresSetting: {
        class: 'add-store',
        options: [],
        choose: []
      },
      storeClassList: [],
      curId: 0,
      reNew: 0,
      reSet: 0
    };
  },
  mounted: function mounted() {
    this.oldScheduleTime = this.scheduleTime = '2015-01-01 01:30:00 - 2015-01-02 01:30:00';

    if (this.$route.params.brand_id) {
      this.brandId = Number(this.$route.params.brand_id);
    }
    if (this.$route.params.store_id) {
      this.storeId = Number(this.$route.params.store_id);
    }
    if (this.$route.params.menu_id) {
      this.menuId = Number(this.$route.params.menu_id);
    }
    if (this.$route.query.menu_name) {
      this.menuName = this.$route.query.menu_name;
    }

    if (this.getRoleType === 10) {
      this.storeId = Number(this.$route.params.brand_id);
    } else {
      this.brandId = Number(this.$route.params.brand_id);
    }
  },

  methods: {
    notBeforeToday: function notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    notBeforeTodayAddTwoMins: function notBeforeTodayAddTwoMins(date) {
      return date < new Date(__WEBPACK_IMPORTED_MODULE_3_moment___default()().set('second', 0).add(5, 'm').toString());
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    crSchedule: function crSchedule() {
      var _this = this;

      if (__WEBPACK_IMPORTED_MODULE_3_moment___default()() > __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.start.time)) {
        this.$notify({
          title: '提醒',
          text: '上架時間逾時，請重新選擇。',
          duration: 3000,
          type: 'danger',
          width: 400
        });
        return;
      }

      var data = {
        store_id: [],
        menu_id: this.menuId,
        start_time: this.menuTime.start.time
      };

      this.addStoresSetting.choose.forEach(function (store) {
        data.store_id.push(store);
      });

      var url = this.base + this.id + '/menu/schedule/group';

      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          _this.$notify({
            title: '提醒',
            text: '新增菜單成功',
            duration: 3000,
            type: 'success',
            width: 400
          });

          var name = '';
          var params = {
            brand_id: _this.$route.params.brand_id,
            store_id: ''
          };

          if (_this.isStore && _this.getRoleType !== 10) {
            name = 'StoreMenuSchedule';
            params.store_id = _this.$route.params.store_id;
          } else {
            name = 'brandScheduleTable';
          }

          _this.$router.push({ name: name, params: params });
        }
      });
    },
    getStoreClassList: function getStoreClassList() {
      var _this2 = this;

      var url = '/brand/' + this.$route.params.brand_id + '/storeClassList';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          _this2.storeClassList = sList;
        }
      });
    },
    updateChoose: function updateChoose(val) {
      console.log('updateChoose', val);
      this.addStoresSetting.choose = val;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    scheduleListNew: function scheduleListNew() {
      var menuList = {};
      var oldList = this.menu_schedule_list;
      for (var key in oldList) {
        menuList[oldList[key].menu_id] = {
          menu_id: oldList[key].menu_id,
          storeList: []
        };
      }
      for (var k in oldList) {
        menuList[oldList[k].menu_id].storeList.push({
          store_id: oldList[k].store_id,
          store_name: oldList[k].store_name,
          start_time: oldList[k].start_time,
          end_time: oldList[k].end_time,
          status: oldList[k].status,
          update_time: oldList[k].update_time,
          create_time: oldList[k].create_time,
          schedule_id: oldList[k].schedule_id
        });
      }
      return menuList;
    }
  })
});

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Brand_Temp_BrandTableTemp_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Brand_Temp_BrandTableTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Brand_Temp_BrandTableTemp_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  data: function data() {
    return {
      tableIndex: 1
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#example1').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      });
    });
  },

  methods: {
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    }
  },
  components: {
    'brand-table': __WEBPACK_IMPORTED_MODULE_3__Brand_Temp_BrandTableTemp_vue___default.a
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  }
});

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Temp_StoreListTemp_vue__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Temp_StoreListTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Temp_StoreListTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_vendor_Gantt_1_10_2_css_style_css__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_vendor_Gantt_1_10_2_css_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__static_vendor_Gantt_1_10_2_css_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_vendor_Gantt_1_10_2_js_jquery_fn_gantt_js__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_vendor_Gantt_1_10_2_js_jquery_fn_gantt_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__static_vendor_Gantt_1_10_2_js_jquery_fn_gantt_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Temp_StoreScheduleListTemp_vue__ = __webpack_require__(2278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Temp_StoreScheduleListTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Temp_StoreScheduleListTemp_vue__);














/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'storelist-table': __WEBPACK_IMPORTED_MODULE_4__Temp_StoreListTemp_vue___default.a,
    'store-schedule-list': __WEBPACK_IMPORTED_MODULE_8__Temp_StoreScheduleListTemp_vue___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default.a
  },
  data: function data() {
    return {
      storeName: '',
      menuState: 4,
      name: '迷客夏',
      total: 1,
      count: 20,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      info: {
        menuName: '夏日菜單',
        menu_id: 123323,
        start_time: '2017-03-31 12:22:32',
        end_time: '2017-03-31 12:22:32',
        update_time: '2017-03-31 12:22:32',
        create_time: '2017-03-31 12:22:32'
      },
      menu_schedule_list: [{
        'schedule_id': 122,
        'store_id': 1,
        'store_name': '金山店',
        'menu_id': 1,
        'start_time': '2017-04-24 08:00:00',
        'end_time': '2017-06-01 00:00:00',
        'status': 1,
        'update_time': '2017-01-14 16:09:16',
        'create_time': '2017-01-14 16:09:16'
      }, {
        'schedule_id': 123,
        'store_id': 2,
        'store_name': '民權店',
        'menu_id': 2,
        'start_time': '2017-04-24 08:00:00',
        'end_time': '2017-06-01 00:00:00',
        'status': 1,
        'update_time': '2017-01-14 16:09:16',
        'create_time': '2017-01-14 16:09:16'
      }, {
        'schedule_id': 124,
        'store_id': 3,
        'store_name': '中山店',
        'menu_id': 1,
        'start_time': '2017-04-24 08:00:00',
        'end_time': '2017-06-01 00:00:00',
        'status': 1,
        'update_time': '2017-01-14 16:09:16',
        'create_time': '2017-01-14 16:09:16'
      }],
      test: [{
        id: 1,
        name: 'Feature 1',
        series: [{ start: new Date('2010,05,01'), end: new Date('2010,05,03'), menu_id: '1' }]
      }, {
        id: 2,
        name: 'Feature 2',
        series: [{ start: new Date('2010,06,05'), end: new Date('2010,06,20'), menu_id: '2' }]
      }],
      scheduleList: []
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#example1_wrapper').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      });
    });
  },

  methods: {
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    editStores: function editStores(menuId) {
      this.$router.push('/upSchedule/all/' + menuId);
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.getScheduleList();
    },
    getScheduleList: function getScheduleList() {
      var self = this;
      var brandId = this.$route.params.brand_id;
      var data = {
        page: this.tableIndex,
        size: this.count
      };
      var url = '/brand/' + brandId + '/menu/schedule/list?page=' + data.page + '&size=' + data.size + '&sortby=start_time DESC' + '&store_id=' + this.$route.params.store_id + '&status=' + this.menuState;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.total = response.data.meta.total;
          console.log(self.total);
          var sList = response.data.menu_schedule_list;
          var newSList = [];
          var storeIdList = {};
          for (var i = 0; i < sList.length; i++) {
            self.storeName = sList[i].store_name;
            var _data = {
              name: sList[i].menu_name,
              desc: '',
              store_id: sList[i].store_id,
              values: [{
                from: '/Date(' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(sList[i].start_time, 'YYYY-MM-DD HH:mm:ss') + ')/',
                to: '/Date(' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(sList[i].end_time, 'YYYY-MM-DD HH:mm:ss') + ')/',
                label: '',
                desc: sList[i].store_name,
                dataObj: sList[i]
              }]
            };
            newSList.push(_data);
            if (!storeIdList[sList[i].store_id]) storeIdList[sList[i].store_id] = [];
            storeIdList[sList[i].store_id].push(_data);
          }
          self.scheduleList = newSList;
          self.checkDoubleStore(storeIdList);
        }
      });
    },
    checkDoubleStore: function checkDoubleStore(storeIdList) {
      console.log(storeIdList);
      var newScheduleList = [];
      for (var key in storeIdList) {
        newScheduleList.push(storeIdList[key][0]);
      }
      console.log(newScheduleList);
      this.setGantt(newScheduleList);
    },
    setGantt: function setGantt(scheduleList) {
      if (scheduleList.length) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.gantt').gantt({
          source: scheduleList,
          scale: 'months',
          minScale: 'months',
          navigate: 'scroll',
          waitText: '正在讀取菜單排程...',
          itemsPerPage: 12
        });
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.gantt').css('display', 'block');
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('menu-info').css('display', 'block');
      } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.gantt').css('display', 'none');
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('menu-info').css('display', 'none');
      }
    },
    pageShow: function pageShow(index) {
      var num = index / this.groupAmount;
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true;else return false;
    }
  },
  computed: {
    scheduleListNew: function scheduleListNew() {
      var menuList = {};
      var oldList = this.menu_schedule_list;
      for (var key in oldList) {
        menuList[oldList[key].menu_id] = {
          menu_id: oldList[key].menu_id,
          storeList: []
        };
      }
      for (var k in oldList) {
        menuList[oldList[k].menu_id].storeList.push({
          store_id: oldList[k].store_id,
          store_name: oldList[k].store_name,
          start_time: oldList[k].start_time,
          end_time: oldList[k].end_time,
          status: oldList[k].status,
          update_time: oldList[k].update_time,
          create_time: oldList[k].create_time,
          schedule_id: oldList[k].schedule_id,
          menu_id: oldList[key].menu_id
        });
      }
      return menuList;
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    }
  },
  watch: {
    menuState: function menuState() {
      this.tableIndex = 1;
      this.pageGroup = 1;
      this.getScheduleList();
    }
  },
  created: function created() {
    this.getScheduleList();
  }
});

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    storeList: {
      type: Array
    }
  },
  data: function data() {
    return {
      msg: 'hello vue',
      path: this.$route.name,
      newList: [],
      tableIndex: 1,
      checkStores: [0, 1],
      toggleChecked: true,
      count: 10
    };
  },

  methods: {
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    editStores: function editStores(menuId, storeId) {
      this.$router.push('/upSchedule/' + storeId + '/' + menuId);
    },
    changeTime: function changeTime(type) {
      for (var key in this.newList) {
        if (type === 's') this.newList[key].start_time = this.getMenuStartTime;
        if (type === 'e') this.newList[key].end_time = this.getMenuEndTime;
      }
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.$emit('getIndex', index);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getMenuStartTime', 'getMenuEndTime'])),
  created: function created() {
    this.newList = this.storeList;
  },

  watch: {
    getMenuStartTime: function getMenuStartTime() {
      this.changeTime('s');
    },
    getMenuEndTime: function getMenuEndTime() {
      this.changeTime('e');
    },
    toggleChecked: function toggleChecked() {
      if (this.toggleChecked) {
        this.checkStores = [0, 1];
      } else {
        this.checkStores = [];
      }
    },
    checkStores: function checkStores() {
      if (!this.checkStores.length) this.toggleChecked = false;else if (this.checkStores.length === 2) this.toggleChecked = true;
    }
  }
});

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    storeList: {
      type: Array
    }
  },
  data: function data() {
    return {
      msg: 'hello vue',
      path: this.$route.name,
      newList: [],
      tableIndex: 1,
      checkStores: [0, 1],
      toggleChecked: true,
      count: 10,
      menuList: [{ 'store_id': 1, 'start_time': '2017-04-24 08:00:00', 'end_time': '2017-06-01 00:00:00', 'status': 1, 'update_time': '2017-01-14 16:09:16', 'create_time': '2017-01-14 16:09:16', 'schedule_id': 122, 'menu_id': 1, 'menu_name': '夏日菜單' }, { 'store_id': 3, 'start_time': '2017-04-24 08:00:00', 'end_time': '2017-06-01 00:00:00', 'status': 1, 'update_time': '2017-01-14 16:09:16', 'create_time': '2017-01-14 16:09:16', 'schedule_id': 124, 'menu_id': 3, 'menu_name': '冬季菜單' }]
    };
  },

  methods: {
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    editStores: function editStores(menuId, storeId) {
      this.$router.push('/upSchedule/' + storeId + '/' + menuId);
    },
    changeTime: function changeTime(type) {
      for (var key in this.newList) {
        if (type === 's') this.newList[key].start_time = this.getMenuStartTime;
        if (type === 'e') this.newList[key].end_time = this.getMenuEndTime;
      }
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.$emit('getIndex', index);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getMenuStartTime', 'getMenuEndTime'])),
  created: function created() {
    this.newList = this.storeList;
  },

  watch: {
    getMenuStartTime: function getMenuStartTime() {
      this.changeTime('s');
    },
    getMenuEndTime: function getMenuEndTime() {
      this.changeTime('e');
    },
    toggleChecked: function toggleChecked() {
      if (this.toggleChecked) {
        this.checkStores = [0, 1];
      } else {
        this.checkStores = [];
      }
    },
    checkStores: function checkStores() {
      if (!this.checkStores.length) this.toggleChecked = false;else if (this.checkStores.length === 2) this.toggleChecked = true;
    }
  }
});

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_datepicker__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker_index_css__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_datepicker_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_datatables_net_bs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_datatables_net_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Temp_StoreListTemp_vue__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Temp_StoreListTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Temp_StoreListTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__extends_nd_extend_handle_menu_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__extends_nd_extend_handle_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__extends_nd_extend_handle_menu_vue__);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UpSchedule',
  extends: __WEBPACK_IMPORTED_MODULE_9__extends_nd_extend_handle_menu_vue___default.a,
  components: {
    'storelist-table': __WEBPACK_IMPORTED_MODULE_8__Temp_StoreListTemp_vue___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_2_vue2_datepicker__["a" /* default */]
  },
  data: function data() {
    return {
      content: {
        bindingStoreList: []
      },
      storeBrief: [],
      oldScheduleTime: '',
      scheduleTime: '',
      menuTime: {
        start: {
          time: ''
        }
      },
      show: {
        back: false
      },
      name: '迷客夏',
      tableIndex: 1,
      menuId: 0,
      scheduleId: 0,
      scheduleInfo: {},
      storeId: 0,
      startTime: {
        time: ''
      },
      endtime: {
        time: ''
      },
      info: {
        menuName: '夏日菜單',
        menu_id: 123323,
        start_time: '2017-03-31 12:22:32',
        end_time: '2017-03-31 12:22:32',
        update_time: '2017-03-31 12:22:32',
        create_time: '2017-03-31 12:22:32'
      },
      menu_schedule_list: [{
        'schedule_id': 122,
        'store_id': 1,
        'store_name': '金山店',
        'menu_id': 1,
        'start_time': '2017-07-24 08:00:00',
        'end_time': '2017-08-01 00:00:00',
        'status': 1,
        'update_time': '2017-01-14 16:09:16',
        'create_time': '2017-01-14 16:09:16'
      }, {
        'schedule_id': 123,
        'store_id': 2,
        'store_name': '中山店',
        'menu_id': 2,
        'start_time': '2017-07-24 08:00:00',
        'end_time': '2017-08-01 00:00:00',
        'status': 1,
        'update_time': '2017-01-14 16:09:16',
        'create_time': '2017-01-14 16:09:16'
      }],
      addStoresSetting: {
        class: 'add-store',
        options: [],
        choose: []
      },
      storeClassList: [],
      curId: 0,
      reNew: 0,
      reSet: 0
    };
  },
  created: function created() {
    if (this.getRoleType !== 10 && !this.isStore) this.getStoreBrief();else {
      if (this.$route.name === 'upSchedule' || this.$route.name === 'StoreMenuScheduleEditG') {
        this.menuId = this.$route.params.menu_id;
        this.getGroupSchedule();
      } else if (this.$route.params.schedule_id) {
        this.scheduleId = this.$route.params.schedule_id;
        this.getSchedule();
      }
    }
  },
  mounted: function mounted() {
    this.oldScheduleTime = this.scheduleTime = '2015-01-01 01:30:00 - 2015-01-02 01:30:00';
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#example1_wrapper').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      });
    });
  },

  methods: {
    notBeforeToday: function notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    notBeforeTodayAddTwoMins: function notBeforeTodayAddTwoMins(date) {
      return date < new Date(__WEBPACK_IMPORTED_MODULE_6_moment___default()().set('second', 0).add(5, 'm').toString());
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    getStoreBrief: function getStoreBrief() {
      var _this = this;

      console.log('getStoreBrief | UpSchedule');
      this.storeBrief = [];
      this.addStoresSetting.options = [];
      var url = 'brand/' + this.$route.params.brand_id + '/storeListBrief?&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this.getStoreClassList();
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            _this.storeBrief.push(obj);
            _this.addStoresSetting.options.push(obj);
          }
          if (_this.$route.name === 'upSchedule' || _this.$route.name === 'StoreMenuScheduleEditG') {
            _this.menuId = _this.$route.params.menu_id;
            _this.getGroupSchedule();
          } else if (_this.$route.params.schedule_id) {
            _this.scheduleId = _this.$route.params.schedule_id;
            _this.getSchedule();
          }
        }
      });
    },
    updateInfo: function updateInfo() {
      if (this.$route.name === 'upSchedule' || this.$route.name === 'StoreMenuScheduleEditG') {
        this.upGroupSchedule();
      } else if (this.$route.params.schedule_id) {
        this.upSchedule();
      }
    },
    upGroupSchedule: function upGroupSchedule() {
      var _this2 = this;

      if (__WEBPACK_IMPORTED_MODULE_6_moment___default()() > __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.menuTime.start.time)) {
        this.$notify({
          title: '提醒',
          text: '上架時間逾時，請重新選擇。',
          duration: 3000,
          type: 'danger',
          width: 400
        });
        return;
      }

      var data = {
        store_id: [],
        menu_id: this.menuId,
        start_time: this.menuTime.start.time
      };
      this.addStoresSetting.choose.forEach(function (store) {
        data.store_id.push(store);
      });

      if (this.getRoleType === 10) {
        data.store_id.push(this.$route.params.brand_id);
      }
      var url = this.base + this.id + '/menu/schedule/group/' + this.$route.params.group_id;
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          _this2.$notify({
            title: '提醒',
            text: '更新菜單成功',
            duration: 3000,
            type: 'success',
            width: 400
          });

          var name = '';
          var params = {
            brand_id: _this2.$route.params.brand_id,
            store_id: ''
          };

          if (_this2.isStore && _this2.getRoleType !== 10) {
            name = 'StoreMenuSchedule';
            params.store_id = _this2.$route.params.store_id;
          } else {
            name = 'brandScheduleTable';
          }

          _this2.$router.push({ name: name, params: params });
        }
      });
    },
    upSchedule: function upSchedule() {
      var _this3 = this;

      console.log('upSchedule');
      var data = {
        menu_id: this.menuId,
        start_time: this.menuTime.start.time
      };
      var url = this.base + this.id + '/menu/schedule/' + this.$route.params.schedule_id;
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          _this3.$notify({
            title: '提醒',
            text: '新增菜單成功',
            duration: 3000,
            type: 'success',
            width: 400
          });

          var name = '';
          var params = {
            brand_id: _this3.$route.params.brand_id,
            store_id: ''
          };

          if (_this3.isStore && _this3.getRoleType !== 10) {
            name = 'StoreMenuSchedule';
            params.store_id = _this3.$route.params.store_id;
          } else {
            name = 'brandScheduleTable';
          }

          _this3.$router.push({ name: name, params: params });
        }
      });
    },
    getSchedule: function getSchedule() {
      var _this4 = this;

      var url = this.base + this.id + '/menu/schedule/' + this.$route.params.schedule_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sInfo = response.data.schedule_info;
          _this4.menuTime.start.time = sInfo.start_time;
          _this4.menuId = sInfo.menu_id;
          _this4.scheduleInfo = response.data.schedule_info;
        }
      });
    },
    getGroupSchedule: function getGroupSchedule() {
      var _this5 = this;

      console.log('getGroupSchedule');
      var url = this.base + this.id + '/menu/schedule/group/' + this.$route.params.group_id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var gInfo = response.data.group_info;
          _this5.menuTime.start.time = gInfo.start_time;
          _this5.menuId = gInfo.menu_id;
          gInfo.store_list.forEach(function (s) {
            _this5.addStoresSetting.choose.push(s);
          });
        }
      });
    },
    clickOption: function clickOption(option) {
      var self = this;
      this.addStoresSetting.options = [];
      self.curId = option.id;
      if (self.curId) {
        self.$nextTick(function () {
          self.reSet++;
          self.addStoresSetting.options = self.storeBrief;
          self.getCurStoreClass();
        });
      }
    },
    getCurStoreClass: function getCurStoreClass() {
      this.addStoresSetting.choose = [];
      var self = this;
      var url = this.base + this.id + '/storeClass/' + this.curId;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var classInfo = response.data.class;
          classInfo.store_list.forEach(function (s) {
            self.addStoresSetting.choose.push(s.id);
          });
        }
      });
    },
    getStoreClassList: function getStoreClassList() {
      var self = this;
      var url = this.base + this.id + '/storeClassList';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          self.storeClassList = sList;
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])(['getRoleType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    scheduleListNew: function scheduleListNew() {
      var menuList = {};
      var oldList = this.menu_schedule_list;
      for (var key in oldList) {
        menuList[oldList[key].menu_id] = {
          menu_id: oldList[key].menu_id,
          storeList: []
        };
      }
      for (var k in oldList) {
        menuList[oldList[k].menu_id].storeList.push({
          store_id: oldList[k].store_id,
          store_name: oldList[k].store_name,
          start_time: oldList[k].start_time,
          end_time: oldList[k].end_time,
          status: oldList[k].status,
          update_time: oldList[k].update_time,
          create_time: oldList[k].create_time,
          schedule_id: oldList[k].schedule_id
        });
      }
      return menuList;
    },
    getList: function getList() {
      if (this.$route.name === 'upScheduleOne') {
        var oneList = this.scheduleListNew[this.menuId].storeList;
        this.menuTime.start.time = oneList[0].start_time;
        return oneList;
      } else {
        var list = [];
        for (var key in this.scheduleListNew) {
          for (var k in this.scheduleListNew[key].storeList) {
            list.push(this.scheduleListNew[key].storeList[k]);
          }
        }
        return list;
      }
    }
  })
});

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_Chart_Temp_OrderLineCharts_vue__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_Chart_Temp_OrderLineCharts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_views_Chart_Temp_OrderLineCharts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);






var todayChart, totalChart, shopperActiveChart, hourBriefChart;
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default.a,
    'order-line-charts': __WEBPACK_IMPORTED_MODULE_2__components_views_Chart_Temp_OrderLineCharts_vue___default.a
  },
  data: function data() {
    return {
      brandList: [],
      changeStore: false,
      storeStatusList: {},
      content: {
        bindingStoreList: [],
        bindingBrandList: []
      },
      oldUrl: '',
      storeBrief: [],
      brandBrief: [],

      transactionLabels: [],
      transactions: {
        order_count_accum: [],
        order_count_day: [],
        order_count_day_normal: [],
        order_count_day_group: [],
        money_accum: [],
        money_accum_mean: [],
        money_day: [],
        money_day_normal: [],
        money_day_group: [],
        money_day_mean: [],
        item_count_accum: [],
        item_count_accum_mean: [],
        item_count_day: [],
        item_count_day_normal: [],
        item_count_day_group: [],
        item_count_day_mean: []
      },

      hourBriefLabels: [],
      hourBrief: {
        total_order: [],
        total_money: [],
        total_amount: []
      },

      labels: [],
      shopperState: {
        today: {
          total: [],
          certify: [],
          fb: [],
          google: [],
          line: [],
          nidin: []
        },
        total: {
          total: [],
          certify: [],
          fb: [],
          google: [],
          line: [],
          nidin: []
        }
      },

      activeLabels: [],
      shopperActive: {
        cr: [],
        cancel: [],
        search: [],
        read: [],
        feedback: []
      },

      menuTime: {
        storeTime: {
          time: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(-1, 'days').format('YYYY-MM-DD')
        },
        start: {
          time: ''
        },
        end: {
          time: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(1, 'days').format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      storeLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD')
      }]
    };
  },

  methods: {
    checkLimit: function checkLimit(val) {
      if (this.content.bindingStoreList.length > 10) {
        this.content.bindingStoreList.shift();
      }
      if (this.content.bindingStoreList.length) {
        this.getStoresTransactions();
      } else {
        this.storeStatusList = {};
      }
    },
    clickSearch: function clickSearch() {
      if (this.content.bindingStoreList.length) this.getStoresTransactions();
    },
    getStoresTransactions: function getStoresTransactions() {
      var list = this.content.bindingStoreList;
      var day = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.storeTime.time, 'YYYY-MM-DD').format('YYYYMMDD');
      var ids = '';
      for (var i = 0; i < list.length; i++) {
        ids = ids + list[i].value + ',';
      }
      ids = ids.slice(0, -1);
      var self = this;
      var data = {
        start_time: day,
        end_time: day,
        ids: ids
      };
      var url = '';
      url = '/statistic/storeTransactions?start_date=' + data.start_time + '&end_date=' + data.end_time + '&store_ids=' + data.ids;
      if (this.oldUrl !== url) {
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            var resDay = __WEBPACK_IMPORTED_MODULE_3_moment___default()(day, 'YYYYMMDD').format('YYYY-MM-DD');
            if (response.data.statistics[resDay]) self.storeStatusList = response.data.statistics[resDay].store_info;
            self.oldUrl = url;
          }
        });
      }
    },
    getStoreBrief: function getStoreBrief(brandId) {
      console.log('getStoreBrief | SystemDashboard');
      var self = this;
      var url = '/brand/' + brandId + '/storeListBrief?&list_sortname ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            self.storeBrief.push(obj);
          }
        }
      });
    },
    getBrandBrief: function getBrandBrief() {
      var self = this;
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          var brandIds = '';
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            self.brandBrief.push(obj);
            brandIds = brandIds + bList[i].brand_id + ',';
          }
          brandIds = brandIds.slice(0, -1);
        }
      });
    },
    changeStoreBrief: function changeStoreBrief() {
      this.storeBrief = [];

      for (var i = 0; i < this.content.bindingBrandList.length; i++) {
        this.getStoreBrief(this.content.bindingBrandList[i].value);
      }
    },
    getTransactions: function getTransactions(type, id) {
      this.transactionLabels = [];
      this.transactions = {
        order_count_accum: [],
        order_count_day: [],
        order_count_day_normal: [],
        order_count_day_group: [],
        money_accum: [],
        money_accum_mean: [],
        money_day: [],
        money_day_normal: [],
        money_day_group: [],
        money_day_mean: [],
        item_count_accum: [],
        item_count_accum_mean: [],
        item_count_day: [],
        item_count_day_normal: [],
        item_count_day_group: [],
        item_count_day_mean: []
      };
      var self = this;
      var data = {
        start_time: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      };
      var url = '';
      if (type === 'brand') url = '/statistic/brandTransactions?start_date=' + data.start_time + '&end_date=' + data.end_time + '&brand_ids=' + id;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var tList = response.data.statistics;
          var info;
          for (var i in tList) {
            if (type === 'brand') {
              info = 'brand_info';
            } else if (type === 'store') {
              info = 'store_info';
            }
            self.transactionLabels.push(__WEBPACK_IMPORTED_MODULE_3_moment___default()(i, 'YYYY-MM-DD').format('MM/DD'));
            self.transactions.order_count_accum.push(tList[i][info][id].order_count_accum);
            self.transactions.order_count_day.push(tList[i][info][id].order_count_day);
            self.transactions.order_count_day_normal.push(tList[i][info][id].order_count_day_normal);
            self.transactions.order_count_day_group.push(tList[i][info][id].order_count_day_group);
            self.transactions.money_accum.push(tList[i][info][id].money_accum);
            self.transactions.money_accum_mean.push(tList[i][info][id].money_accum_mean);
            self.transactions.money_day.push(tList[i][info][id].money_day);
            self.transactions.money_day_normal.push(tList[i][info][id].money_day_normal);
            self.transactions.money_day_group.push(tList[i][info][id].money_day_group);
            self.transactions.money_day_mean.push(tList[i][info][id].money_day_mean);
            self.transactions.item_count_accum.push(tList[i][info][id].item_count_accum);
            self.transactions.item_count_accum_mean.push(tList[i][info][id].item_count_accum_mean);
            self.transactions.item_count_day.push(tList[i][info][id].item_count_day);
            self.transactions.item_count_day_normal.push(tList[i][info][id].item_count_day_normal);
            self.transactions.item_count_day_group.push(tList[i][info][id].item_count_day_group);
          }
          self.showTransactionsChart(type);
        }
      });
    },
    getShopperStatus: function getShopperStatus() {
      this.labels = [];
      this.shopperState = {
        today: {
          total: [],
          certify: [],
          fb: [],
          google: [],
          line: [],
          nidin: []
        },
        total: {
          total: [],
          certify: [],
          fb: [],
          google: [],
          line: [],
          nidin: []
        }
      };
      var self = this;
      var data = {
        start_time: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      };
      var url = '/statistic/shopperStatus?start_date=' + data.start_time + '&end_date=' + data.end_time;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.shopper_status_list;
          for (var i in sList) {
            self.labels.push(__WEBPACK_IMPORTED_MODULE_3_moment___default()(sList[i].date, 'YYYY-MM-DD').format('MM/DD'));
            self.shopperState.today.total.push(sList[i].total_day);
            self.shopperState.today.certify.push(sList[i].verified_day);
            self.shopperState.today.fb.push(sList[i].from_facebook_day);
            self.shopperState.today.google.push(sList[i].from_google_day);
            self.shopperState.total.total.push(sList[i].total_accum);
            self.shopperState.today.line.push(sList[i].from_line_day);
            self.shopperState.today.nidin.push(sList[i].from_phone_day);

            self.shopperState.total.certify.push(sList[i].verified_accum);
            self.shopperState.total.fb.push(sList[i].from_facebook_accum);
            self.shopperState.total.google.push(sList[i].from_google_accum);
            self.shopperState.total.line.push(sList[i].from_line_accum);
            self.shopperState.total.nidin.push(sList[i].from_phone_accum);
          }
          self.getShopperActivity();
          self.showShopperChart();
        }
      });
    },
    getShopperActivity: function getShopperActivity() {
      this.activeLabels = [];
      this.shopperActive = {
        cr: [],
        cancel: [],
        search: [],
        read: [],
        feedback: []
      };
      var self = this;
      var data = {
        start_time: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      };
      var url = '/statistic/shopperActivity?start_date=' + data.start_time + '&end_date=' + data.end_time;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var aList = response.data.shopper_activity_list;
          for (var i in aList) {
            self.activeLabels.push(__WEBPACK_IMPORTED_MODULE_3_moment___default()(aList[i].date, 'YYYY-MM-DD').format('MM/DD'));
            self.shopperActive.cr.push(aList[i].create_order);
            self.shopperActive.cancel.push(aList[i].cancel_order);
            self.shopperActive.search.push(aList[i].search_store);
            self.shopperActive.read.push(aList[i].read_notification);
            self.shopperActive.feedback.push(aList[i].create_feedback);
          }
          self.showShopperActiveChart();
        }
      });
    },
    showShopperChart: function showShopperChart() {
      var _this = this;

      this.$nextTick(function () {
        if (typeof todayChart !== 'undefined') {
          todayChart.destroy();
        }
        if (typeof totalChart !== 'undefined') {
          totalChart.destroy();
        }

        var ctx = document.getElementById('today-shopper').getContext('2d');
        var config = {
          type: 'line',
          data: {
            labels: _this.labels,
            datasets: [{
              label: '當日註冊人數',
              fill: false,
              borderColor: '#555555',
              pointBackgroundColor: '#555555',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: _this.shopperState.today.total
            }, {
              label: '當日的通過手機驗證人數',
              borderColor: '#f39c12',
              pointBackgroundColor: '#f39c12',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: _this.shopperState.today.certify
            }, {
              label: '當日Facebook註冊人數',
              borderColor: '#00c0ef',
              pointBackgroundColor: '#00c0ef',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: _this.shopperState.today.fb
            }, {
              label: '當日Google註冊人數',
              borderColor: '#dd4b39',
              pointBackgroundColor: '#dd4b39',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: _this.shopperState.today.google
            }, {
              label: '當日手機註冊人數',
              borderColor: '#3c8dbc',
              pointBackgroundColor: '#3c8dbc',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: _this.shopperState.today.nidin
            }, {
              label: '當日LINE註冊人數',
              borderColor: '#00a65a',
              pointBackgroundColor: '#00a65a',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: _this.shopperState.today.line
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: !_this.isMobile,

            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            }
          }
        };
        todayChart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, config);
        var ctx2 = document.getElementById('total-shopper').getContext('2d');
        var config2 = {
          type: 'line',
          data: {
            labels: _this.labels,
            datasets: [{
              label: '累積註冊人數',
              fill: false,
              borderColor: '#555555',
              pointBackgroundColor: '#555555',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: _this.shopperState.total.total
            }, {
              label: '累積的通過手機驗證人數',
              borderColor: '#f39c12',
              pointBackgroundColor: '#f39c12',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: _this.shopperState.total.certify
            }, {
              label: '累積Facebook註冊人數',
              borderColor: '#00c0ef',
              pointBackgroundColor: '#00c0ef',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: _this.shopperState.total.fb
            }, {
              label: '累積Google註冊人數',
              borderColor: '#dd4b39',
              pointBackgroundColor: '#dd4b39',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: _this.shopperState.total.google
            }, {
              label: '累積手機註冊人數',
              borderColor: '#3c8dbc',
              pointBackgroundColor: '#3c8dbc',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: _this.shopperState.total.nidin
            }, {
              label: '累積LINE註冊人數',
              borderColor: '#00a65a',
              pointBackgroundColor: '#00a65a',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: _this.shopperState.total.line
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: !_this.isMobile,

            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            }
          }
        };
        totalChart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx2, config2);
      });
    },
    showShopperActiveChart: function showShopperActiveChart() {
      var _this2 = this;

      if (typeof shopperActiveChart !== 'undefined') {
        shopperActiveChart.destroy();
      }
      this.$nextTick(function () {
        var ctx = document.getElementById('shopper-active').getContext('2d');
        var config = {
          type: 'line',
          data: {
            labels: _this2.activeLabels,
            datasets: [{
              label: '當日送出訂單人數',
              fill: false,
              borderColor: '#00a65a',
              pointBackgroundColor: '#00a65a',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: _this2.shopperActive.cr
            }, {
              label: '當日取消訂單人數',
              borderColor: '#f39c12',
              pointBackgroundColor: '#f39c12',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: _this2.shopperActive.cancel
            }, {
              label: '當日以位置查詢店家人數',
              borderColor: '#00c0ef',
              pointBackgroundColor: '#00c0ef',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: _this2.shopperActive.search
            }, {
              label: '有閱讀網頁通知人數',
              borderColor: '#dd4b39',
              pointBackgroundColor: '#dd4b39',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: _this2.shopperActive.read
            }, {
              label: '有送出意見人數',
              borderColor: '#337ab7',
              pointBackgroundColor: '#337ab7',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: _this2.shopperActive.feedback
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: !_this2.isMobile,

            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            }
          }
        };
        shopperActiveChart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, config);
      });
    },
    getHourBrief: function getHourBrief() {
      this.hourBriefLabels = [];
      this.hourBrief = {
        total_order: [],
        total_money: [],
        total_amount: []
      };
      var self = this;
      var data = {
        result_type: 1
      };
      var url = '/statistic/storeHourBrief?result_type=' + data.result_type;
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.brief;
          for (var i in bList) {
            if (typeof parseInt(i, 10) === 'number' && parseInt(i, 10)) {
              if (bList[i].hour < 10) self.hourBriefLabels.push('0' + bList[i].hour + ':00');else self.hourBriefLabels.push(bList[i].hour + ':00');
              self.hourBrief.total_order.push(bList[i].total_order);
              self.hourBrief.total_money.push(bList[i].total_money);
              self.hourBrief.total_amount.push(bList[i].total_amount);
            }
          }
          self.showHourBriefChart();
        }
      });
    },
    showHourBriefChart: function showHourBriefChart() {
      var _this3 = this;

      this.$nextTick(function () {
        var datas = [{
          label: '每小時訂單數量',
          fill: false,
          borderColor: '#00a65a',
          pointBackgroundColor: '#00a65a',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this3.hourBrief.total_order,
          yAxisID: 'y-axis-2'
        }, {
          label: '每小時訂單金額',
          borderColor: '#f39c12',
          pointBackgroundColor: '#f39c12',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: _this3.hourBrief.total_money,
          yAxisID: 'y-axis-1'
        }];
        if (typeof hourBriefChart !== 'undefined') {
          hourBriefChart.destroy();
        }
        var ctx = document.getElementById('hour-brief').getContext('2d');
        var config = {
          type: 'line',
          data: {
            labels: _this3.hourBriefLabels,
            datasets: datas
          },
          options: {
            responsive: true,
            maintainAspectRatio: !_this3.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            },
            scales: {
              yAxes: [{
                type: 'linear',
                display: true,
                position: 'left',
                id: 'y-axis-1'
              }, {
                type: 'linear',
                display: true,
                position: 'right',
                id: 'y-axis-2',
                gridLines: {
                  drawOnChartArea: false
                }
              }]
            }
          }
        };
        hourBriefChart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, config);
      });
    }
  },
  computed: {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    fixedH: function fixedH() {
      return this.$parent.fixedH;
    }
  },
  created: function created() {
    var date = new Date();
    this.menuTime.start.time = __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).add(-30, 'days').format('YYYY-MM-DD');
    this.fixedH();
    this.getBrandBrief();
    this.getShopperStatus();
    this.getHourBrief();
  },

  watch: {
    'content.bindingBrandList': function contentBindingBrandList() {
      this.changeStoreBrief();
    },
    'content.bindingStoreList': function contentBindingStoreList() {
      this.checkLimit();
    },
    'menuTime.storeTime.time': function menuTimeStoreTimeTime() {
      this.checkLimit();
    }
  }
});

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_ClipLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_ClipLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_elements_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_elements_nd_trade_apply_store_vue__ = __webpack_require__(2097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_elements_nd_trade_apply_store_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_elements_nd_trade_apply_store_vue__);














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TradeSettingView',
  components: {
    'clip': __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_ClipLoader_vue___default.a,
    'nd-modal': __WEBPACK_IMPORTED_MODULE_8__components_elements_Modal_vue___default.a,
    'nd-trade-apply-store': __WEBPACK_IMPORTED_MODULE_9__components_elements_nd_trade_apply_store_vue___default.a
  },
  data: function data() {
    return {
      brands: [],
      checkBoxSelectAll: false,
      formType: false,
      isDownloading: false,
      list: [],
      optionConfigApplyStoreModal: {
        id: 'trade-apply-store-modal',
        title: '門市申請網址',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'createApplyStore'
        }]
      },
      optionsConfCheckedBetchStore: {
        id: 'checked-betch-store-modal',
        title: '提醒',
        btns: [{
          name: '取消'
        }, {
          name: '確定',
          event: 'setBetchStore'
        }]
      },
      paginate: {
        count: 10,
        groupAmount: 10,
        page: 1,
        total: 1
      },
      query: {},
      select: {
        brand: {
          label: '== 品牌 ==',
          value: 0
        },
        is_enable: 999,
        status: 999,
        store: {
          label: '== 門市 ==',
          value: 0
        },
        trade_type: 720
      },
      stores: [],
      tempApplyInfo: {
        brand: 0,
        store: []
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['getRoleType', 'getPickupType', 'getTradeType']), {
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getFile: function getFile() {
      return this.$parent.getFile;
    },
    paginateAmount: function paginateAmount() {
      return Math.ceil(this.paginate.total / this.paginate.count);
    },
    storeIds: function storeIds() {
      var temp = [];
      var checked = this.list.filter(function (i) {
        return i.selectItem === true;
      }) || [];
      temp = checked.map(function (i) {
        return i.store_id;
      });
      return temp;
    }
  }),
  watch: {
    'select.brand.value': function selectBrandValue() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.stores = [];
                _this.select.store.label = '== 門市 ==';
                _this.select.store.value = 0;
                _context.next = 5;
                return _this.getStores(_this.select.brand.value);

              case 5:
                _this.getList(1);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    'select.is_enable': function selectIs_enable() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.getList(1);

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    'select.status': function selectStatus() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.getList(1);

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    'select.store.value': function selectStoreValue() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.getList(1);

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    'select.trade_type': function selectTrade_type() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.getList(1);

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    }
  },
  mounted: function mounted() {
    if (this.$route.query.status) this.select.status = Number(this.$route.query.status);
    if (this.$route.query.trade_type) this.select.trade_type = Number(this.$route.query.trade_type);
    if (this.$route.query.page) this.paginate.page = Number(this.$route.query.page);
    this.getBrands();
    this.getList();
  },

  methods: {
    createApplyStore: function createApplyStore() {
      var _this6 = this;

      console.log({
        component: this.$options.name,
        function: 'createApplyStore',
        payload: {},
        time: __WEBPACK_IMPORTED_MODULE_7_moment___default()().format('HH:mm:ss')
      });

      if (!this.tempApplyInfo.store.length) {
        return;
      }

      var url = '/tradeTypeBiz/create';
      var params = {
        trade_type: this.select.trade_type,
        brand_id: this.tempApplyInfo.brand,
        store_id: this.tempApplyInfo.store.join(',')
      };
      this.getDataH('post', url, params, function (res) {
        if (res.data.status === 200) {
          _this6.$notify({
            title: '產出完成',
            text: '已完成！',
            duration: 1000,
            type: 'success',
            width: 400
          });
          var brand = _this6.brands.find(function (i) {
            return i.value === _this6.tempApplyInfo.brand;
          });
          _this6.select.brand = brand;
          _this6.select.status = 0;
          _this6.getList();
        }
      });
    },
    exportFile: function exportFile() {
      var _this7 = this;

      console.log({
        component: this.$options.name,
        function: 'exportFile',
        payload: {},
        time: __WEBPACK_IMPORTED_MODULE_7_moment___default()().format('YYYY/MM/DD HH:mm:ss')
      });

      this.isDownloading = true;
      var query = this.query;
      var searchParams = '';
      if (query.page) {
        delete query.page;
      }
      if (query.size) {
        delete query.size;
      }
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(query).length) {
        searchParams = new URLSearchParams(query);
      }
      var url = '/tradeTypeBiz/listSheets?' + searchParams.toString();
      this.getFile('get', url, null, function (res) {
        _this7.isDownloading = false;
        var blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        var objectUrl = URL.createObjectURL(blob);
        var el = document.createElement('a');
        el.href = objectUrl;
        el.download = 'icash Pay \u8A3B\u518A\u8CC7\u8A0A_' + __WEBPACK_IMPORTED_MODULE_7_moment___default()().format('YYYYMMDD') + '.xlsx';
        document.body.appendChild(el);
        el.click();
      });
    },
    getBrands: function getBrands() {
      var _this8 = this;

      var url = '/brand/listBrief?is_delete=0&is_opening=1&list_sort=name ASC';
      this.brands = [{ label: '== 品牌 ==', value: 0 }];
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            if (!bList[i].is_visible) obj.label = obj.label + ' (測)';
            _this8.brands.push(obj);
          }
        }
      });
    },
    getList: function getList(page) {
      var _this9 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var url = '/tradeTypeBiz/list?size=' + _this9.paginate.count;
        if (page) _this9.paginate.page = page;
        var query = {};

        if (_this9.select.brand && _this9.select.brand.value) {
          if (_this9.$route.query.brand_id && _this9.$route.query.brand_id !== _this9.select.brand.value) _this9.paginate.page = 1;
          query = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, query, { brand_id: _this9.select.brand.value });
          url = url + '&brand_id=' + _this9.select.brand.value;
        }

        if (_this9.select.store && _this9.select.store.value) {
          if (_this9.$route.query.store_id && _this9.$route.query.store_id !== _this9.select.store.value) _this9.paginate.page = 1;
          query = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, query, { store_id: _this9.select.store.value });
          url = url + '&store_id=' + _this9.select.store.value;
        }

        if (_this9.select.trade_type && _this9.select.trade_type !== 999) {
          if (_this9.$route.query.trade_type && _this9.$route.query.trade_type !== _this9.select.trade_type) _this9.paginate.page = 1;
          query = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, query, { trade_type: _this9.select.trade_type });
          url = url + '&trade_type=' + _this9.select.trade_type;
        }

        if (typeof _this9.select.status !== 'undefined' && _this9.select.status !== null && _this9.select.status !== 999) {
          if (_this9.$route.query.status && _this9.$route.query.status !== _this9.select.status) _this9.paginate.page = 1;
          query = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, query, { status: _this9.select.status });
          url = url + '&status=' + _this9.select.status;
        }

        if (typeof _this9.select.is_enable !== 'undefined' && _this9.select.is_enable !== null && _this9.select.is_enable !== 999) {
          if (_this9.$route.query.is_enable && _this9.$route.query.is_enable !== _this9.select.is_enable) _this9.paginate.page = 1;
          query = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, query, { is_enable: _this9.select.is_enable });
          url = url + '&is_enable=' + _this9.select.is_enable;
        }

        if (_this9.paginate.page) {
          query = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, query, { page: _this9.paginate.page });
          url = url + '&page=' + _this9.paginate.page;
        }
        _this9.query = query;
        _this9.$router.replace({ query: query });
        _this9.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            _this9.list = response.data.list.map(function (i) {
              return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, i, {
                selectItem: false
              });
            });
            _this9.paginate.total = response.data.total;
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    getStores: function getStores(brandId) {
      var _this10 = this;

      console.log({
        component: this.$options.name,
        function: 'getStores',
        payload: {
          brandId: brandId
        },
        time: __WEBPACK_IMPORTED_MODULE_7_moment___default()().format('HH:mm:ss')
      });

      if (!brandId) return;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this10.stores = [{ label: '== 門市 ==', value: 0 }];
        var url = '/brand/' + brandId + '/storeListBrief?status=2&list_sort=name ASC';
        _this10.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            var sList = response.data.list;

            if (sList.length === 0) {
              _this10.getList();
            } else {
              for (var i = 0; i < sList.length; i++) {
                var obj = { label: sList[i].name, value: sList[i].store_id };
                _this10.stores.push(obj);
              }
            }
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    handleIsEnable: function handleIsEnable(val) {
      var temp = {
        class: '',
        text: ''
      };
      switch (val) {
        case 0:
          temp.class = 'label-default';
          temp.text = '未啟用';
          break;
        case 1:
          temp.class = 'label-success';
          temp.text = '啟用';
          break;
        default:
          temp.class = 'label-default';
          temp.text = '未知';
          break;
      }
      return temp;
    },
    handleStatus: function handleStatus(val) {
      var temp = {
        class: '',
        text: ''
      };
      switch (val) {
        case 0:
          temp.class = 'label-default';
          temp.text = '產出網址';
          break;
        case 1:
          temp.class = 'label-primary';
          temp.text = '審核完成';
          break;
        case 2:
          temp.class = 'label-success';
          temp.text = '已完成';
          break;
        default:
          temp.class = 'label-default';
          temp.text = '未知';
          break;
      }
      return temp;
    },
    onCopy: function onCopy() {
      this.$notify({
        title: '提示',
        text: '複製成功！',
        duration: 1000,
        type: 'success',
        width: 400
      });
    },
    onError: function onError() {
      this.$notify({
        title: '提示',
        text: '複製失敗！',
        duration: 1000,
        type: 'danger',
        width: 400
      });
    },
    paginateClickPage: function paginateClickPage(index) {
      this.paginate.page = index;
      this.getList();
    },
    paginateIsActive: function paginateIsActive(index) {
      if (Number(this.paginate.page) === index) return true;else return false;
    },
    selectAll: function selectAll() {
      var _this11 = this;

      this.list = this.list.map(function (i) {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, i, {
          selectItem: _this11.checkBoxSelectAll
        });
      });
    },
    setBetch: function setBetch(type) {
      if (type === 1) {
        window.$('#checked-betch-store-modal').modal('show');
      } else {
        this.formType = false;
      }
    },
    setBetchStore: function setBetchStore() {
      var _this12 = this;

      console.log({
        component: this.$options.name,
        function: 'setBetchStore',
        payload: {},
        time: __WEBPACK_IMPORTED_MODULE_7_moment___default()().format('HH:mm:ss')
      });

      if (!this.storeIds.length) {
        this.formType = false;
        return;
      }

      var url = '/tradeTypeBiz/batchEnable';
      var params = {
        trade_type: this.select.trade_type,
        store_id: this.storeIds.join(',')
      };
      this.getDataH('post', url, params, function (res) {
        if (res.data.status === 200) {
          _this12.$notify({
            title: '啟用成功',
            text: '已啟用成功！',
            duration: 1000,
            type: 'success',
            width: 400
          });
          _this12.formType = false;
          _this12.getList();
        }
      });
    },
    trigger: function trigger(event) {
      if (event === 'createApplyStore') {
        this.createApplyStore();
      } else if (event === 'setBetchStore') {
        this.setBetchStore();
      } else {
        console.log('trigger', event);
      }
    },
    updateChoose: function updateChoose(payload) {
      console.log({
        component: this.$options.name,
        function: 'updateChoose',
        payload: payload,
        time: __WEBPACK_IMPORTED_MODULE_7_moment___default()().format('HH:mm:ss')
      });
      this.tempApplyInfo.brand = payload.brand;
      this.tempApplyInfo.store = payload.store;
    }
  }
});

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__elements_Modal_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__elements_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__elements_Modal_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CommissionHistory',
  components: {
    'm-modal': __WEBPACK_IMPORTED_MODULE_0__elements_Modal_vue___default.a
  },
  data: function data() {
    return {
      total: 0,
      count: 10,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      isLoading: false,
      list: [],
      quarterList: ['1-3月', '4-6月', '7-9月', '10-12月'],
      aclLimit: 0,
      timer: null,
      refreshOption: {
        id: 'refreshModal',
        title: '下載連結已過期，點擊"確定"按鈕更新列表',
        body: '',
        btns: [{
          name: '確定',
          event: 'refresh'
        }]
      }
    };
  },

  computed: {
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    }
  },
  created: function created() {
    this.getList();
  },

  methods: {
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.getList();
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    trigger: function trigger(event) {
      if (event === 'refresh') {
        this.getList();
      }
    },
    getList: function getList() {
      var _this = this;

      this.isLoading = true;
      if (this.timer) {
        clearInterval(this.timer);
      }
      var type = '';
      var query = '';
      if (this.$route.query.store_id) {
        type = 'store';
        query = '&store_id=' + this.$route.query.store_id;
      } else {
        type = 'brand';
        query = '&brand_id=' + this.$route.query.brand_id;
      }
      var url = 'orderCommission/' + type + 'Statement?page=' + this.tableIndex + '&size=' + this.count + query;
      this.getDataH('get', url, null, function (response) {
        _this.list = response.data.download_info.links;
        _this.aclLimit = response.data.download_info.meta.acl_limit;
        _this.total = response.data.total;
        _this.isLoading = false;

        if (_this.list.length) {
          var time = _this.aclLimit;
          _this.timer = setInterval(function () {
            time = time - 1;
            if (time < 0) {
              _this.$refs.refreshModal.click();
              clearInterval(_this.timer);
            }
          }, 1000);
        }
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
});

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_ClipLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_ClipLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CommissionStore',
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_3_vue_datepicker_vue_datepicker_es6_vue___default.a,
    'Clip': __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_ClipLoader_vue___default.a
  },
  data: function data() {
    return {
      brandName: '',
      storeName: '',
      total: 0,
      count: 10,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      isLoading: false,
      list: [],
      totalCommissionMoney: 0,
      first: true,
      isDownloading: false,

      query: {},
      filterType: 1,
      orderSN: '',
      startDate: {
        time: __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD')
      },
      endDate: {
        time: __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD')
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '24px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      dateLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_5_moment___default()().add(1, 'days').format('YYYY-MM-DD')
      }],
      deTypeSelect: 999,
      deliveryTypeList: [{ label: '== 取餐類型 ==', value: 999 }, { label: '自取', value: 1 }, { label: '外送', value: 3 }, { label: '內用', value: 2 }, { label: '外帶', value: 4 }, { label: '內用-桌邊掃碼', value: 21 }],
      statusSelect: 999,
      statusList: [{ label: '== 訂單狀態 ==', value: 999 }, { label: '已完成', value: 130 }, { label: '已作廢', value: 140 }],
      trTypeSelect: 999
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getTradeType']), {
    pageAmount: function pageAmount() {
      return Math.ceil(this.total / this.count);
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    getFile: function getFile() {
      return this.$parent.getFile;
    }
  }),
  created: function created() {
    this.setDefault();
    this.setQuery();
    this.getStoreInfo();
  },

  methods: {
    setDefault: function setDefault() {
      if (this.$route.query && this.$route.query.year && this.$route.query.type && this.$route.query.period) {
        var type = '';
        var month = Number(this.$route.query.period);
        if (this.$route.query.type === 'quarterly') {
          month = month * 3;
          type = 'quarter';
        } else {
          type = 'month';
        }
        var time = this.$route.query.year + '-' + month.toString().padStart(2, '0') + '-01';
        this.startDate.time = __WEBPACK_IMPORTED_MODULE_5_moment___default()(time).startOf(type).format('YYYY-MM-DD');
        this.endDate.time = __WEBPACK_IMPORTED_MODULE_5_moment___default()().isBefore(__WEBPACK_IMPORTED_MODULE_5_moment___default()(time).endOf(type)) ? __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD') : __WEBPACK_IMPORTED_MODULE_5_moment___default()(time).endOf(type).format('YYYY-MM-DD');
      }
    },
    clickPage: function clickPage(index) {
      this.tableIndex = index;
      this.getList();
    },
    isActive: function isActive(index) {
      if (this.tableIndex === index) return true;else return false;
    },
    setQuery: function setQuery() {
      this.query = {
        start_date: __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.startDate.time).format('YYYYMMDD'),
        end_date: __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.endDate.time).format('YYYYMMDD')
      };
      if (this.filterType === 1 && this.orderSN.trim()) {
        this.query.order_sn = this.orderSN.trim();
      } else if (this.filterType === 2 && this.statusSelect !== 999) {
        this.query.order_status = this.statusSelect;
      } else if (this.filterType === 3 && this.deTypeSelect !== 999) {
        this.query.delivery_type = this.deTypeSelect;
      } else if (this.filterType === 4 && this.trTypeSelect !== 999) {
        this.query.trade_type = this.trTypeSelect;
      }
      this.clickPage(1);
    },
    getList: function getList() {
      var _this = this;

      this.isLoading = true;
      var url = 'orderCommission/order/list?page=' + this.tableIndex + '&size=' + this.count + '&store_id=' + this.$route.params.store_id;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.query).forEach(function (key) {
        url = url + ('&' + key + '=' + _this.query[key]);
      });
      this.getDataH('get', url, null, function (response) {
        _this.list = response.data.list;
        _this.totalCommissionMoney = response.data.total_commission_money;
        _this.total = response.data.total;
        _this.isLoading = false;
        if (_this.first) {
          _this.first = false;
        }
      });
    },
    getStoreInfo: function getStoreInfo() {
      var _this2 = this;

      var url = 'store/' + this.$route.params.store_id + '/info';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this2.brandName = response.data.info.brand_name;
          _this2.storeName = response.data.info.name;
        }
      });
    },
    exportFile: function exportFile() {
      var _this3 = this;

      this.isDownloading = true;
      var url = 'orderCommission/order/listSheets?store_id=' + this.$route.params.store_id;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.query).forEach(function (key) {
        url = url + ('&' + key + '=' + _this3.query[key]);
      });
      this.getFile('get', url, null, function (response) {
        _this3.isDownloading = false;
        var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        var objectUrl = URL.createObjectURL(blob);
        var a = document.createElement('a');
        var name = _this3.brandName + '_' + _this3.storeName + '_\u8CC7\u8A0A\u670D\u52D9\u8CBB\u62BD\u6210\u5C0D\u5E33\u5206\u5E97\u660E\u7D30\u8868_' + _this3.startDate.time + '~' + _this3.endDate.time + '.xlsx';

        a.download = name;
        a.href = objectUrl;
        document.body.appendChild(a);
        a.click();
      });
    },
    exportScheduleFile: function exportScheduleFile() {
      var _this4 = this;

      this.isDownloading = true;
      var url = 'orderCommission/order/listSheetsSchedule?store_id=' + this.$route.params.store_id;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.query).forEach(function (key) {
        url = url + ('&' + key + '=' + _this4.query[key]);
      });
      if (this.retry === 1) {
        url = url + '&retry=1';
      }
      this.getDataH('get', url, null, function (response) {
        if (response.data.sche_info.status === 3) {
          _this4.isDownloading = false;
          _this4.retry = 0;
          var a = document.createElement('a');
          a.href = response.data.sche_info.file_url;
          document.body.appendChild(a);
          a.click();
          clearTimeout(_this4.retryTimer);
          _this4.retryFrequency = 0;
        } else if (response.data.sche_info.status === 9) {
          _this4.isDownloading = false;
          if (_this4.retryFrequency > 3) {
            alert('請聯絡客服或等24小時候再試');
            return false;
          }
          var yes = confirm('輸出未完成，請聯絡客服或再試一次');
          if (yes) {
            _this4.retryFrequency++;
          }
          clearTimeout(_this4.retryTimer);
        } else {
          _this4.retry = 1;
          _this4.retryTimer = setTimeout(_this4.exportFile, 6000);
        }
      });
    }
  },
  watch: {
    'startDate.time': function startDateTime() {
      if (!this.first) {
        this.setQuery();
      }
    },
    'endDate.time': function endDateTime() {
      if (!this.first) {
        this.setQuery();
      }
    }
  }
});

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_shared_token_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_ClipLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_ClipLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VenderTradeTable',
  components: {
    'date-time-picker': __WEBPACK_IMPORTED_MODULE_3_vue_datepicker_vue_datepicker_es6_vue___default.a,
    'clip-loader': __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_ClipLoader_vue___default.a
  },
  data: function data() {
    return {
      searchType: 2,
      pagination: {
        paymentFlow: {
          total: 84,
          count: 10,
          tableIndex: 1,
          pageGroup: 1,
          groupAmount: 10
        },
        shippingFlow: {
          total: 10,
          count: 10,
          tableIndex: 1,
          pageGroup: 1,
          groupAmount: 10
        },
        commission: {
          total: 84,
          count: 10,
          tableIndex: 1,
          pageGroup: 1,
          groupAmount: 10
        }
      },
      history: [],
      isLoading: false,
      storeBrief: [],
      brandBrief: [],
      brandSelect: { label: '== 品牌 ==', value: 0 },
      storeSelect: { label: '== 門市 ==', value: 0 },
      accountingList: [{ label: '== 交易類型 ==', value: 999 }, { label: '收款', value: 1 }, { label: '退款', value: 2 }],
      reportType: [{ label: '== 報表類型 ==', value: 999 }, { label: '原始報表', value: 1 }, { label: '對外對帳單', value: 2 }],
      userTypeList: [{ label: '== 訂購人類型 ==', value: 999 }, { label: '會員', value: 1 }, { label: '訪客', value: 2 }],
      sourceTypeList: [{ label: '== 訂單來源 ==', value: 999 }, { label: '你訂', value: 1 }, { label: 'POS', value: 2 }],
      accountingSelect: 999,
      tradeTypeSelect: 999,
      reportSelect: 999,
      userType: 999,
      sourceType: 999,
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '24px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555',
          'text-align': 'left'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      menuTime: {
        start: {
          time: __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD')
        },
        end: {
          time: __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD')
        }
      },
      startLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_5_moment___default()().add(1, 'days').format('YYYY-MM-DD')
      }],
      endLimit: [{
        type: 'fromto',
        to: __WEBPACK_IMPORTED_MODULE_5_moment___default()().add(1, 'days').add(1, 'days').format('YYYY-MM-DD')
      }],
      typeSelect: 99,
      isDownloading: false,
      orderSN: null,
      venderOrderNo: null,
      retry: 0,
      retryTimer: null,
      retryFrequency: 0,
      sourceSelect: 999,
      hasIndependentReport: 0,
      shippingVendorSelect: 999,
      shippingVendorList: [],
      orderStatus: 999,
      orderStatusList: [{ label: '== 訂單狀態 ==', value: 999 }, { label: '訂單已送出，尚未付款', value: 1 }, { label: '付款中', value: 2 }, { label: '訂單已付款，尚未通知店家', value: 3 }, { label: '客人取消', value: 99 }, { label: '未接單', value: 100 }, { label: '已接單', value: 110 }, { label: '店家退訂', value: 120 }, { label: '系統退訂', value: 121 }, { label: '已取消', value: 122 }, { label: '已完成', value: 130 }, { label: '已作廢', value: 140 }],
      shippingStatus: 999,
      shippingStatusList: [{ label: '== 物流狀態 ==', value: 999 }, { label: '成立物流單', value: 100 }, { label: '物流接單', value: 110 }, { label: '已分派外送員', value: 120 }, { label: '已取貨', value: 130 }, { label: '已送達', value: 140 }, { label: '門市取消叫件', value: 900 }, { label: '媒合失敗', value: 920 }],
      shippingInfo: {},
      shippingTableList: [],

      commissionList: [],
      commissionInfo: {},
      timeType: 'monthly',
      timeTypeList: [{ name: '月', value: 'monthly' }, { name: '季', value: 'quarterly' }],
      year: null,
      yearList: [],
      month: 0,
      quarter: null,
      quarterList: [{ name: '1-3月 (Q1)', value: '1' }, { name: '4-6月 (Q2)', value: '2' }, { name: '7-9月 (Q3)', value: '3' }, { name: '10-12月 (Q4)', value: '4' }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getRoleType', 'getTradeType', 'getRestricted']), {
    paymentPageAmount: function paymentPageAmount() {
      return Math.ceil(this.pagination.paymentFlow.total / this.pagination.paymentFlow.count);
    },
    shippingPageAmount: function shippingPageAmount() {
      return Math.ceil(this.pagination.shippingFlow.total / this.pagination.shippingFlow.count);
    },
    commissionPageAmount: function commissionPageAmount() {
      return Math.ceil(this.pagination.commission.total / this.pagination.commission.count);
    },
    getDataH: function getDataH() {
      return this.$parent.getDataH;
    },
    traceTypeOption: function traceTypeOption() {
      return this.getTradeType.filter(function (x) {
        return x.value !== 1;
      });
    },
    getFile: function getFile() {
      return this.$parent.getFile;
    },
    showHistoryReport: function showHistoryReport() {
      if (this.typeSelect === 10) {
        if (this.getRoleType === 99) {
          return this.brandSelect.value && !this.storeSelect.value || this.storeSelect.value && this.hasIndependentReport;
        } else if (this.getRoleType === 30) {
          return this.brandSelect.value && !this.storeSelect.value;
        } else if (this.getRoleType === 10) {
          return this.storeSelect.value && this.hasIndependentReport;
        }
      }
      return false;
    }
  }),
  created: function created() {
    if (this.$route.query.typeSelect) {
      this.typeSelect = Number(this.$route.query.typeSelect);
    }
    this.getBrandBrief();
    this.setCommissionDefault();
    this.getShippingVendorList();
  },

  methods: {
    getBrandBrief: function getBrandBrief() {
      var _this = this;

      var url = '/brand/listBrief?is_delete=0&is_opening=1&list_sort=name ASC';
      this.brandBrief = [{ label: '== 品牌 ==', value: 0 }];
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list;
          for (var i = 0; i < bList.length; i++) {
            var obj = { label: bList[i].name, value: bList[i].brand_id };
            if (!bList[i].is_visible) {
              obj.label = obj.label + ' (測)';
            }
            _this.brandBrief.push(obj);
            if (i === 0) {
              if (_this.getRoleType === 10 || bList.length === 1) {
                _this.brandSelect.label = obj.label;
                _this.brandSelect.value = obj.value;
              }
            }
          }
          if (_this.getRoleType === 30 || _this.getRoleType === 99) {
            _this.changePage(1);
          }
        }
      });
    },
    getStoreBrief: function getStoreBrief(brandId) {
      var _this2 = this;

      console.log('getStoreBrief | VenderTradeTable');

      this.storeSelect = { label: '== 門市 ==', value: 0 };
      this.storeBrief = [{ label: '== 門市 ==', value: 0 }];
      if (!brandId) return;

      var url = '/brand/' + brandId + '/storeListBrief?list_sort=name ASC';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list;
          for (var i = 0; i < sList.length; i++) {
            var obj = { label: sList[i].name, value: sList[i].store_id };
            _this2.storeBrief.push(obj);
          }
          if (_this2.getRoleType === 10) {
            if (_this2.storeBrief.length === 2) {
              _this2.storeSelect.value = sList[0].store_id;
              _this2.getStoreInfo();
            }
            _this2.changePage(1);
          }
        }
      });
    },
    getShippingVendorList: function getShippingVendorList() {
      var _this3 = this;

      var url = '/platform/shippingVendorList?type=3';
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this3.shippingVendorList = response.data.list;
          _this3.shippingVendorList.sort(function (a, b) {
            return a.sort - b.sort;
          });
          _this3.shippingVendorList = _this3.shippingVendorList.map(function (item) {
            return { label: _this3.$options.filters.shippingVendorName(item.vendor_code), value: item.vendor_code };
          });
          _this3.shippingVendorList.unshift({ label: '== 物流廠商 == ', value: 999 });
        }
      });
    },
    changePage: function changePage(index) {
      if (this.typeSelect === 99) {
        this.pagination.paymentFlow.tableIndex = index;
        this.getList();
      } else if (this.typeSelect === 1) {
        this.pagination.shippingFlow.tableIndex = index;
        this.getShippintTableList();
      } else if (this.typeSelect === 10) {
        this.pagination.commission.tableIndex = index;
        this.getCommissionList();
      }
    },
    isActive: function isActive(index) {
      if (this.typeSelect === 99) {
        return this.pagination.paymentFlow.tableIndex === index;
      } else if (this.typeSelect === 1) {
        return this.pagination.shippingFlow.tableIndex === index;
      } else if (this.typeSelect === 10) {
        return this.pagination.commission.tableIndex === index;
      }
      return false;
    },
    getStoreInfo: function getStoreInfo() {
      var _this4 = this;

      if (this.storeSelect.value) {
        var url = 'store/' + this.storeSelect.value + '/info';
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            _this4.hasIndependentReport = response.data.info.order_commission_setting ? response.data.info.order_commission_setting.has_independent_report : 0;
          }
        });
      }
    },
    setQuery: function setQuery(noPage) {
      var query = {};
      if (this.brandSelect.value && this.getRoleType !== 10) {
        query.brand_id = this.brandSelect.value;
      }
      if (this.storeSelect.value && this.storeSelect.value !== 0) {
        query.store_id = this.storeSelect.value;
      }
      if (this.typeSelect === 99) {
        if (!noPage) {
          query.page = this.pagination.paymentFlow.tableIndex;
          query.size = this.pagination.paymentFlow.count;
        }
        if (this.menuTime.start.time) {
          query.start_trade_date = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.menuTime.start.time).format('YYYYMMDD');
        }
        if (this.menuTime.end.time) {
          query.end_trade_date = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.menuTime.end.time).format('YYYYMMDD');
        }
        if (this.searchType === 2 && this.orderSN) {
          query.order_sn = this.orderSN;
        }
        if (this.searchType === 3 && this.venderOrderNo) {
          query.customer_order_no = this.venderOrderNo;
        }
        if (this.accountingSelect && this.accountingSelect !== 999) {
          query.accounting_type = this.accountingSelect;
        }
        if (this.tradeTypeSelect && this.tradeTypeSelect !== 999) {
          query.trade_type = this.tradeTypeSelect;
        }
        if (this.sourceSelect && this.sourceSelect !== 999) {
          query.order_sub_src_type = this.sourceSelect;
        }
      } else if (this.typeSelect === 1) {
        if (!noPage) {
          query.page = this.pagination.shippingFlow.tableIndex;
          query.size = this.pagination.shippingFlow.count;
        }
        if (this.sourceType && this.sourceType !== 999) query.source_type = this.sourceType;
        if (this.userType && this.userType !== 999) query.user_type = this.userType;
        if (this.shippingVendorSelect && this.shippingVendorSelect !== 999) {
          query.vendor_code = this.shippingVendorSelect;
        }
        if (this.orderStatus && this.orderStatus !== 999) {
          query.order_status = this.orderStatus;
        }
        if (this.shippingStatus && this.shippingStatus !== 999) {
          query.shipping_status = this.shippingStatus;
        }
        if (this.menuTime.start.time) {
          query.start_date = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.menuTime.start.time).format('YYYY-MM-DD');
        }
        if (this.menuTime.end.time) {
          query.end_date = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.menuTime.end.time).format('YYYY-MM-DD');
        }
        if (this.searchType === 2 && this.orderSN) {
          query.order_sn = this.orderSN;
        }
        if (this.searchType === 3 && this.venderOrderNo) {
          query.customer_order_no = this.venderOrderNo;
        }
      } else if (this.typeSelect === 10) {
        if (!this.noPage) {
          query.page = this.pagination.commission.tableIndex;
          query.size = this.pagination.commission.count;
          query.list_type = this.timeType;
          query.year = this.year;
        }
        if (this.timeType === 'quarterly') {
          query.quarter = this.quarter;
        } else {
          query.month = this.month;
        }
      }
      return new URLSearchParams(query).toString();
    },
    getList: function getList() {
      var _this5 = this;

      if (!this.setQuery(false)) return;
      this.isLoading = true;
      var url = 'accounting/history/list?' + this.setQuery(false);
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this5.history = response.data.list;
          _this5.pagination.paymentFlow.total = response.data.total;
          _this5.$router.replace({ path: _this5.$route.path, query: { typeSelect: _this5.typeSelect } });
        }
        _this5.isLoading = false;
      });
    },
    getShippintTableList: function getShippintTableList() {
      var _this6 = this;

      if (!this.setQuery(false)) return;
      this.isLoading = true;
      var url = 'shipping/report/list?' + this.setQuery(false);
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this6.shippingInfo = response.data;
          _this6.shippingTableList = response.data.list;
          _this6.pagination.shippingFlow.total = response.data.total;
          _this6.$router.replace({ path: _this6.$route.path, query: { typeSelect: _this6.typeSelect } });
        }
        _this6.isLoading = false;
      });
    },
    getCommissionList: function getCommissionList() {
      var _this7 = this;

      if (!this.setQuery(false)) return;
      this.isLoading = true;
      var url = 'orderCommission/history/list?' + this.setQuery(false);
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          _this7.commissionInfo = response.data;
          _this7.commissionList = response.data.list;
          _this7.pagination.commission.total = response.data.total;
          _this7.$router.replace({ path: _this7.$route.path, query: { typeSelect: _this7.typeSelect } });
        }
        _this7.isLoading = false;
      });
    },
    download: function download() {
      if (this.typeSelect === 99) {
        this.exportScheduleFile();
      } else {
        this.exportFile();
      }
    },
    exportScheduleFile: function exportScheduleFile() {
      var _this8 = this;

      if (!this.setQuery(true)) return;
      this.isDownloading = true;
      var url = 'accounting/history/listSheetsSchedule?' + this.setQuery(true);

      this.getDataH('get', url, null, function (response) {
        if (response.data.sche_info.status === 3) {
          _this8.isDownloading = false;
          _this8.retry = 0;
          var a = document.createElement('a');
          a.href = response.data.sche_info.file_url;
          a.download = '訂單列表_' + __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY_MM_DD') + '.zip';
          document.body.appendChild(a);
          a.click();
          clearTimeout(_this8.retryTimer);
          _this8.retryFrequency = 0;
        } else if (response.data.sche_info.status === 9) {
          _this8.isDownloading = false;
          if (_this8.retryFrequency > 3) {
            alert('請聯絡客服或等24小時候再試');
            return false;
          }
          var yes = confirm('輸出未完成，請聯絡客服或再試一次。');
          if (yes) {
            _this8.retryFrequency++;
          }
          clearTimeout(_this8.retryTimer);
        } else {
          _this8.retry = 1;
          _this8.retryTimer = setTimeout(_this8.exportScheduleFile, 6000);
        }
      });
    },
    exportFile: function exportFile() {
      var _this9 = this;

      if (!this.setQuery(true)) return;

      this.isDownloading = true;
      var url = '';
      var text = '';
      if (this.typeSelect === 10) {
        url = 'orderCommission/history/listSheets?' + this.setQuery(true);
        var timeName = this.timeType === 'quarterly' ? 'Q' + this.quarter : this.month.toString().padStart(2, '0');
        var brandName = this.brandSelect.value ? this.brandSelect.label + '_' : '';
        text = brandName + ('\u8CC7\u8A0A\u670D\u52D9\u8CBB\u62BD\u6210\u5C0D\u5E33\u8868_' + this.year + '_' + timeName + '.xlsx');
      } else if (this.typeSelect === 1) {
        url = 'shipping/report/listSheets?' + this.setQuery(true);
        text = '廠商對帳紀錄表_物流.xlsx';
      }
      this.getFile('get', url, null, function (response) {
        _this9.isDownloading = false;
        var blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        var objectUrl = URL.createObjectURL(blob);
        var name = '';
        var a = document.createElement('a');
        name = text;
        a.download = name;
        a.href = objectUrl;
        document.body.appendChild(a);
        a.click();
      });
    },
    setCommissionDefault: function setCommissionDefault() {
      var nowYear = new Date().getFullYear();
      for (var y = nowYear; y >= 2022; y--) {
        this.yearList.push(y);
      }
      this.year = nowYear;
      this.month = new Date().getMonth() + 1;
      this.quarter = Math.ceil(this.month / 3);
    },
    goCommissionHistory: function goCommissionHistory() {
      var query = {};
      if (this.brandSelect.value) {
        query.brand_id = this.brandSelect.value;
      }
      if (this.storeSelect.value) {
        query.store_id = this.storeSelect.value;
      }
      this.$router.push({ name: 'commissionHistory', query: query });
    },
    goCommissionStore: function goCommissionStore(storeId) {
      if (!storeId) return;
      this.$router.push({ path: '/commissionStore/' + storeId });
    },
    openLink: function openLink() {
      window.open(this.shippingInfo.mete_portal_url, '_blank');
    },
    creditCardType: function creditCardType(val) {
      switch (val) {
        case 0:
          return '-';
        case 1:
          return '<img src="/static/img/visa.png">';
        case 2:
          return '<img src="/static/img/master-card.png">';
        case 3:
          return '<img src="/static/img/jcb.png">';
        case 4:
          return '<img src="/static/img/union-pay.png">';
        case 5:
          return '<img src="/static/img/american-express.png">';
        case 6:
          return '<img src="/static/img/debit-card.png">';
        default:
          return '-';
      }
    },
    tradeType: function tradeType(type) {
      if (type === 1) {
        return '現金';
      } else if (type === 706) {
        return '信用卡';
      } else if (type === 707) {
        return 'LINE PAY';
      } else if (type === 701) {
        return 'iPASS MONEY';
      } else if (type === 709) {
        return '信用卡(台新)';
      } else if (type === 710) {
        return '信用卡';
      } else if (type === 713) {
        return '台灣Pay';
      } else if (type === 716) {
        return '全盈+PAY';
      } else if (type === 717) {
        return '悠遊付';
      } else if (type === 718) {
        return 'Pi 拍錢包';
      } else if (type === 719) {
        return '全支付';
      } else if (type === 720) {
        return 'icash Pay';
      } else if (type === 908) {
        return '街口支付';
      } else if (type === 909) {
        return '遠傳電信代收';
      }
    },
    tradeTypeColor: function tradeTypeColor(name) {
      if (name.indexOf('現金') > -1) {
        return 'label-default';
      } else if (name.indexOf('LINE') > -1) {
        return 'label-success';
      } else if (name.indexOf('iP') > -1) {
        return 'label-success';
      } else if (name.indexOf('台新') > -1) {
        return 'label-primary';
      } else if (name.indexOf('國泰') > -1) {
        return 'label-primary';
      } else if (name.indexOf('街口') > -1) {
        return 'label-danger';
      } else if (name.indexOf('Pi') > -1) {
        return 'label-info';
      } else if (name.indexOf('全盈') > -1) {
        return 'label-primary';
      } else if (name.indexOf('台灣') > -1) {
        return 'label-warning';
      } else if (name.indexOf('icash') > -1) {
        return 'label-info';
      } else if (name.indexOf('遠傳') > -1) {
        return 'label-danger';
      } else if (name.indexOf('悠遊付') > -1) {
        return 'label-primary';
      } else {
        return 'label-warning';
      }
    },
    accountingType: function accountingType(val) {
      switch (val) {
        case 1:
          return 'label-success';
        case 2:
          return 'label-danger';
      }
    },
    goto: function goto() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__assets_js_shared_token_js__["c" /* setSharedToken */])(window.localStorage.getItem(this.$config.token));
      window.location.href = this.$config.bdms + 'financial/account-record/vender';
    }
  },
  watch: {
    'typeSelect': function typeSelect(val) {
      this.searchType = 2;
      switch (val) {
        case 99:
          this.getList();
          break;
        case 1:
          this.getShippintTableList();
          break;
        case 10:
          this.getCommissionList();
      }
    },
    'brandSelect.value': function brandSelectValue(val) {
      this.getStoreBrief(val);
      this.changePage(1);
    },
    'storeSelect.value': function storeSelectValue(val) {
      this.changePage(1);
      if (this.typeSelect === 10 && val) {
        this.getStoreInfo();
      }
    },
    'menuTime.end.time': function menuTimeEndTime() {
      var lastDay = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.menuTime.end.time, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
      if (this.menuTime.start.time > lastDay) this.menuTime.start.time = lastDay;
      this.startLimit = [{
        type: 'fromto',
        to: lastDay
      }];
      this.changePage(1);
    },
    'menuTime.start.time': function menuTimeStartTime() {
      var lastDay = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.menuTime.start.time).add('30', 'days');
      if (lastDay < __WEBPACK_IMPORTED_MODULE_5_moment___default()()) this.menuTime.end.time = lastDay.format('YYYY-MM-DD');else this.menuTime.end.time = __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD');
      this.endLimit = [{
        type: 'fromto',
        from: __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.menuTime.start.time).subtract(1, 'days'),
        to: __WEBPACK_IMPORTED_MODULE_5_moment___default()().add(1, 'days')
      }];
      this.changePage(1);
    },
    'tradeTypeSelect': function tradeTypeSelect(val) {
      if (val !== 713) {
        this.reportSelect = 1;
      }
      if (val !== 908) {
        this.sourceSelect = 1;
      }
    }
  }
});

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NdExtendHandleMenu',
  data: function data() {
    return {
      brand: {},
      store: {},
      storeMap: ['StoreMenu', 'StoreMenuAdjustCreate', 'StoreMenuAdjust', 'StoreMenuBindingPos', 'StoreMenuBuildCreate', 'StoreMenuBlockCreate', 'StoreMenuBlock', 'StoreMenuBuild', 'StoreMenuCategoryCreate', 'StoreMenuCategory', 'StoreMenuEdite', 'StoreMenuEditeUpJoin', 'StoreMenuInfo', 'StoreMenuImage', 'StoreMenuOptionCreate', 'StoreMenuOption', 'StoreMenuPackageCreate', 'StoreMenuPackage', 'StoreMenuProductCreate', 'StoreMenuProduct', 'StoreMenuScheduleCreate', 'StoreMenuScheduleEditG', 'StoreMenuScheduleEditS', 'StoreMenuSchedule', 'StoreMenuSetting', 'StoreMenuStep']
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getRoleType']), {
    base: function base() {
      var type = '';
      if (this.isStore) {
        type = 'store/';
      } else {
        type = 'brand/';
      }
      return type;
    },
    goBackInfo: function goBackInfo() {
      var name = '';
      var params = {};
      var query = {};
      var title = '';
      var subtitle = '';
      if (this.isStore && this.getRoleType !== 10) {
        switch (this.$route.name) {
          case 'StoreMenu':
            name = 'menuDetailTable';
            title = '菜單管理';
            query.name = this.brand.name;
            break;
          case 'StoreMenuBuild':
          case 'StoreMenuBuildCreate':
          case 'StoreMenuImage':
          case 'StoreMenuSchedule':
          case 'StoreMenuSetting':
          case 'StoreMenuStep':
            name = 'StoreMenu';
            params.brand_id = this.$route.params.brand_id;
            title = '菜單管理';
            break;
          case 'StoreMenuAdjust':
          case 'StoreMenuBindingPos':
          case 'StoreMenuBlock':
          case 'StoreMenuCategory':
          case 'StoreMenuOption':
          case 'StoreMenuPackage':
          case 'StoreMenuProduct':
            name = 'StoreMenuStep';
            params.brand_id = this.$route.params.brand_id;
            params.store_id = this.$route.params.store_id;
            title = '配料庫';
            break;
          case 'StoreMenuEdsite':
          case 'StoreMenuInfo':
            name = 'StoreMenuBuild';
            params.brand_id = this.$route.params.brand_id;
            params.store_id = this.$route.params.store_id;
            title = '菜單建置';
            break;
          default:
            console.log('default | 門市');
            break;
        }
      } else {
        switch (this.$route.name) {
          case 'BindingPos':
          case 'upAdjust':
          case 'upBlock':
          case 'upCategory':
          case 'upOption':
          case 'upPackage':
          case 'upProduct':
            name = 'brandMenu';
            title = '配料庫';
            break;
          case 'ProductSetting':
            name = 'storeTableProductSetting';
            title = '門市列表';
            break;
          case 'ProductImage':
            name = 'storeTableProductImage';
            title = '門市列表';
            break;
          case 'brandMenu':
          case 'brandMenuTable':
          case 'brandScheduleTable':
          case 'storeTableProductImage':
          case 'storeTableProductSetting':
          case 'cupDiscountTable':
            name = 'menuDetailTable';
            title = '品牌菜單管理';
            query.name = this.brand.name;
            break;
          case 'crMenu':
          case 'upMenu':
          case 'menuInfo':
            name = 'brandMenuTable';
            title = '菜單建置';
            query.name = this.brand.name;
            break;
          default:
            console.log('default | 品牌');
            break;
        }
      }
      return {
        name: name,
        params: params,
        query: query,
        title: title,
        subtitle: subtitle
      };
    },
    id: function id() {
      return this.isStore ? this.getRoleType === 10 ? this.$route.params.brand_id : this.$route.params.store_id : this.$route.params.brand_id;
    },
    isStore: function isStore() {
      var temp = false;
      temp = this.getRoleType === 10 || this.storeMap.indexOf(this.$route.name) !== -1;
      return temp;
    }
  }),
  methods: {
    getExtendHandleBrandInfo: function getExtendHandleBrandInfo() {
      var _this = this;

      console.log('getExtendHandleBrandInfo');
      if (!this.$route.params.brand_id) {
        console.log('params brand_id is null, cant get brand info.');
        return;
      }
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        var url = '/brand/' + _this.$route.params.brand_id;
        _this.getDataH('get', url, null, function (res) {
          _this.brand = res.data.brand_info;
          resolve();
        });
      });
    },
    getExtendHandleMenuInfo: function getExtendHandleMenuInfo() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this2.getRoleType === 10)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _context.next = 4;
                return _this2.getExtendHandleBrandInfo();

              case 4:
                _this2.getExtendHandleStoreInfo();

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    getExtendHandleStoreInfo: function getExtendHandleStoreInfo() {
      var _this3 = this;

      if (!this.isStore) return;
      if (!this.$route.params.store_id) {
        console.log('params store_id is null, cant get store info.');
        return;
      }
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        var url = '/store/' + _this3.$route.params.store_id + '/info';
        _this3.getDataH('get', url, null, function (res) {
          _this3.store = res.data.info;
          resolve();
        });
      });
    }
  }
});

/***/ }),
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */
/***/ (function(module, exports) {

module.exports = {"name":"elliptic","version":"6.5.4","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"},"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.5.4.tgz","_integrity":"sha512-iLhC6ULemrljPZb+QutR5TQGB+pdW6KGD5RSegS+8sorOZT+rdQFbsQFJgvN3eRqNALqJer4oQ16YvJHlU8hzQ==","_from":"elliptic@6.5.4"}

/***/ }),
/* 847 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 848 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 849 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 850 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 851 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 852 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 853 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 854 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 855 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 856 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 857 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 858 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 859 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 860 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 861 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 862 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 863 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 864 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 865 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 866 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 867 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 868 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 869 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 870 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 871 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 872 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 873 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 874 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 875 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 876 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 877 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 878 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 879 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 880 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 881 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 882 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 883 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 884 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 885 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 886 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 887 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 888 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 889 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 890 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 891 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 892 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 893 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 894 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 895 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 896 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 897 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 898 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 899 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 900 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 901 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 902 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 903 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 904 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 905 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 906 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 907 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 908 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 909 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 910 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 911 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 912 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 913 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 914 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 915 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 916 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 917 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 918 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 919 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 920 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 921 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 922 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 923 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 924 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 925 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 926 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 927 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 928 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 929 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 930 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 931 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 932 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 933 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 934 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 935 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 936 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 937 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 938 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 939 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 940 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 941 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 942 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 943 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 944 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 945 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 946 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 947 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 948 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 949 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 950 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 951 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 952 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 953 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 954 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 955 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 956 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 957 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 958 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 959 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 960 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 961 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 962 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 963 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 964 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 965 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 966 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 967 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 968 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 969 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 970 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 971 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 972 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 973 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 974 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 975 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 976 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 977 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 978 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 979 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 980 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 981 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 982 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 983 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 984 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 985 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 986 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 987 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 988 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 989 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 990 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 991 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 992 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 993 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 994 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 995 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 996 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 997 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 998 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 999 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */,
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */,
/* 1854 */,
/* 1855 */,
/* 1856 */,
/* 1857 */,
/* 1858 */,
/* 1859 */,
/* 1860 */,
/* 1861 */,
/* 1862 */,
/* 1863 */,
/* 1864 */,
/* 1865 */,
/* 1866 */,
/* 1867 */,
/* 1868 */,
/* 1869 */,
/* 1870 */,
/* 1871 */,
/* 1872 */,
/* 1873 */,
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */,
/* 1886 */,
/* 1887 */,
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */,
/* 1895 */,
/* 1896 */,
/* 1897 */,
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */,
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */,
/* 1933 */,
/* 1934 */,
/* 1935 */,
/* 1936 */,
/* 1937 */,
/* 1938 */,
/* 1939 */,
/* 1940 */,
/* 1941 */,
/* 1942 */,
/* 1943 */,
/* 1944 */,
/* 1945 */,
/* 1946 */,
/* 1947 */,
/* 1948 */,
/* 1949 */,
/* 1950 */,
/* 1951 */,
/* 1952 */,
/* 1953 */,
/* 1954 */,
/* 1955 */,
/* 1956 */,
/* 1957 */,
/* 1958 */,
/* 1959 */,
/* 1960 */,
/* 1961 */,
/* 1962 */,
/* 1963 */,
/* 1964 */,
/* 1965 */,
/* 1966 */,
/* 1967 */,
/* 1968 */,
/* 1969 */,
/* 1970 */,
/* 1971 */,
/* 1972 */,
/* 1973 */,
/* 1974 */,
/* 1975 */,
/* 1976 */,
/* 1977 */,
/* 1978 */,
/* 1979 */,
/* 1980 */,
/* 1981 */,
/* 1982 */,
/* 1983 */,
/* 1984 */,
/* 1985 */,
/* 1986 */,
/* 1987 */,
/* 1988 */,
/* 1989 */,
/* 1990 */,
/* 1991 */,
/* 1992 */,
/* 1993 */,
/* 1994 */,
/* 1995 */,
/* 1996 */,
/* 1997 */,
/* 1998 */,
/* 1999 */,
/* 2000 */,
/* 2001 */,
/* 2002 */,
/* 2003 */,
/* 2004 */,
/* 2005 */,
/* 2006 */,
/* 2007 */,
/* 2008 */,
/* 2009 */,
/* 2010 */,
/* 2011 */,
/* 2012 */,
/* 2013 */,
/* 2014 */,
/* 2015 */,
/* 2016 */,
/* 2017 */,
/* 2018 */,
/* 2019 */,
/* 2020 */,
/* 2021 */,
/* 2022 */,
/* 2023 */,
/* 2024 */,
/* 2025 */,
/* 2026 */,
/* 2027 */,
/* 2028 */,
/* 2029 */,
/* 2030 */,
/* 2031 */,
/* 2032 */,
/* 2033 */,
/* 2034 */,
/* 2035 */,
/* 2036 */,
/* 2037 */,
/* 2038 */,
/* 2039 */,
/* 2040 */,
/* 2041 */,
/* 2042 */,
/* 2043 */,
/* 2044 */,
/* 2045 */,
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 212,
	"./af.js": 212,
	"./ar": 219,
	"./ar-dz": 213,
	"./ar-dz.js": 213,
	"./ar-kw": 214,
	"./ar-kw.js": 214,
	"./ar-ly": 215,
	"./ar-ly.js": 215,
	"./ar-ma": 216,
	"./ar-ma.js": 216,
	"./ar-sa": 217,
	"./ar-sa.js": 217,
	"./ar-tn": 218,
	"./ar-tn.js": 218,
	"./ar.js": 219,
	"./az": 220,
	"./az.js": 220,
	"./be": 221,
	"./be.js": 221,
	"./bg": 222,
	"./bg.js": 222,
	"./bm": 223,
	"./bm.js": 223,
	"./bn": 225,
	"./bn-bd": 224,
	"./bn-bd.js": 224,
	"./bn.js": 225,
	"./bo": 226,
	"./bo.js": 226,
	"./br": 227,
	"./br.js": 227,
	"./bs": 228,
	"./bs.js": 228,
	"./ca": 229,
	"./ca.js": 229,
	"./cs": 230,
	"./cs.js": 230,
	"./cv": 231,
	"./cv.js": 231,
	"./cy": 232,
	"./cy.js": 232,
	"./da": 233,
	"./da.js": 233,
	"./de": 236,
	"./de-at": 234,
	"./de-at.js": 234,
	"./de-ch": 235,
	"./de-ch.js": 235,
	"./de.js": 236,
	"./dv": 237,
	"./dv.js": 237,
	"./el": 238,
	"./el.js": 238,
	"./en-au": 239,
	"./en-au.js": 239,
	"./en-ca": 240,
	"./en-ca.js": 240,
	"./en-gb": 241,
	"./en-gb.js": 241,
	"./en-ie": 242,
	"./en-ie.js": 242,
	"./en-il": 243,
	"./en-il.js": 243,
	"./en-in": 244,
	"./en-in.js": 244,
	"./en-nz": 245,
	"./en-nz.js": 245,
	"./en-sg": 246,
	"./en-sg.js": 246,
	"./eo": 247,
	"./eo.js": 247,
	"./es": 251,
	"./es-do": 248,
	"./es-do.js": 248,
	"./es-mx": 249,
	"./es-mx.js": 249,
	"./es-us": 250,
	"./es-us.js": 250,
	"./es.js": 251,
	"./et": 252,
	"./et.js": 252,
	"./eu": 253,
	"./eu.js": 253,
	"./fa": 254,
	"./fa.js": 254,
	"./fi": 255,
	"./fi.js": 255,
	"./fil": 256,
	"./fil.js": 256,
	"./fo": 257,
	"./fo.js": 257,
	"./fr": 260,
	"./fr-ca": 258,
	"./fr-ca.js": 258,
	"./fr-ch": 259,
	"./fr-ch.js": 259,
	"./fr.js": 260,
	"./fy": 261,
	"./fy.js": 261,
	"./ga": 262,
	"./ga.js": 262,
	"./gd": 263,
	"./gd.js": 263,
	"./gl": 264,
	"./gl.js": 264,
	"./gom-deva": 265,
	"./gom-deva.js": 265,
	"./gom-latn": 266,
	"./gom-latn.js": 266,
	"./gu": 267,
	"./gu.js": 267,
	"./he": 268,
	"./he.js": 268,
	"./hi": 269,
	"./hi.js": 269,
	"./hr": 270,
	"./hr.js": 270,
	"./hu": 271,
	"./hu.js": 271,
	"./hy-am": 272,
	"./hy-am.js": 272,
	"./id": 273,
	"./id.js": 273,
	"./is": 274,
	"./is.js": 274,
	"./it": 276,
	"./it-ch": 275,
	"./it-ch.js": 275,
	"./it.js": 276,
	"./ja": 277,
	"./ja.js": 277,
	"./jv": 278,
	"./jv.js": 278,
	"./ka": 279,
	"./ka.js": 279,
	"./kk": 280,
	"./kk.js": 280,
	"./km": 281,
	"./km.js": 281,
	"./kn": 282,
	"./kn.js": 282,
	"./ko": 283,
	"./ko.js": 283,
	"./ku": 284,
	"./ku.js": 284,
	"./ky": 285,
	"./ky.js": 285,
	"./lb": 286,
	"./lb.js": 286,
	"./lo": 287,
	"./lo.js": 287,
	"./lt": 288,
	"./lt.js": 288,
	"./lv": 289,
	"./lv.js": 289,
	"./me": 290,
	"./me.js": 290,
	"./mi": 291,
	"./mi.js": 291,
	"./mk": 292,
	"./mk.js": 292,
	"./ml": 293,
	"./ml.js": 293,
	"./mn": 294,
	"./mn.js": 294,
	"./mr": 295,
	"./mr.js": 295,
	"./ms": 297,
	"./ms-my": 296,
	"./ms-my.js": 296,
	"./ms.js": 297,
	"./mt": 298,
	"./mt.js": 298,
	"./my": 299,
	"./my.js": 299,
	"./nb": 300,
	"./nb.js": 300,
	"./ne": 301,
	"./ne.js": 301,
	"./nl": 303,
	"./nl-be": 302,
	"./nl-be.js": 302,
	"./nl.js": 303,
	"./nn": 304,
	"./nn.js": 304,
	"./oc-lnc": 305,
	"./oc-lnc.js": 305,
	"./pa-in": 306,
	"./pa-in.js": 306,
	"./pl": 307,
	"./pl.js": 307,
	"./pt": 309,
	"./pt-br": 308,
	"./pt-br.js": 308,
	"./pt.js": 309,
	"./ro": 310,
	"./ro.js": 310,
	"./ru": 311,
	"./ru.js": 311,
	"./sd": 312,
	"./sd.js": 312,
	"./se": 313,
	"./se.js": 313,
	"./si": 314,
	"./si.js": 314,
	"./sk": 315,
	"./sk.js": 315,
	"./sl": 316,
	"./sl.js": 316,
	"./sq": 317,
	"./sq.js": 317,
	"./sr": 319,
	"./sr-cyrl": 318,
	"./sr-cyrl.js": 318,
	"./sr.js": 319,
	"./ss": 320,
	"./ss.js": 320,
	"./sv": 321,
	"./sv.js": 321,
	"./sw": 322,
	"./sw.js": 322,
	"./ta": 323,
	"./ta.js": 323,
	"./te": 324,
	"./te.js": 324,
	"./tet": 325,
	"./tet.js": 325,
	"./tg": 326,
	"./tg.js": 326,
	"./th": 327,
	"./th.js": 327,
	"./tk": 328,
	"./tk.js": 328,
	"./tl-ph": 329,
	"./tl-ph.js": 329,
	"./tlh": 330,
	"./tlh.js": 330,
	"./tr": 331,
	"./tr.js": 331,
	"./tzl": 332,
	"./tzl.js": 332,
	"./tzm": 334,
	"./tzm-latn": 333,
	"./tzm-latn.js": 333,
	"./tzm.js": 334,
	"./ug-cn": 335,
	"./ug-cn.js": 335,
	"./uk": 336,
	"./uk.js": 336,
	"./ur": 337,
	"./ur.js": 337,
	"./uz": 339,
	"./uz-latn": 338,
	"./uz-latn.js": 338,
	"./uz.js": 339,
	"./vi": 340,
	"./vi.js": 340,
	"./x-pseudo": 341,
	"./x-pseudo.js": 341,
	"./yo": 342,
	"./yo.js": 342,
	"./zh-cn": 343,
	"./zh-cn.js": 343,
	"./zh-hk": 344,
	"./zh-hk.js": 344,
	"./zh-mo": 345,
	"./zh-mo.js": 345,
	"./zh-tw": 346,
	"./zh-tw.js": 346
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2046;

/***/ }),
/* 2047 */,
/* 2048 */,
/* 2049 */,
/* 2050 */
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),
/* 2051 */,
/* 2052 */,
/* 2053 */,
/* 2054 */,
/* 2055 */,
/* 2056 */,
/* 2057 */,
/* 2058 */,
/* 2059 */,
/* 2060 */,
/* 2061 */,
/* 2062 */,
/* 2063 */,
/* 2064 */,
/* 2065 */,
/* 2066 */,
/* 2067 */,
/* 2068 */,
/* 2069 */,
/* 2070 */,
/* 2071 */,
/* 2072 */,
/* 2073 */,
/* 2074 */,
/* 2075 */,
/* 2076 */,
/* 2077 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcgMC4yMTg3NUMzLjI1NDg0IDAuMjE4NzUgMC4yMTg3NSAzLjI1NDgxIDAuMjE4NzUgN0MwLjIxODc1IDEwLjc0NTIgMy4yNTQ4NCAxMy43ODEyIDcgMTMuNzgxMkMxMC43NDUyIDEzLjc4MTIgMTMuNzgxMiAxMC43NDUyIDEzLjc4MTIgN0MxMy43ODEyIDMuMjU0ODQgMTAuNzQ1MiAwLjIxODc1IDcgMC4yMTg3NVpNMTAuNTU3NiAzLjQ0MjM2QzEyLjM0NzIgNS4yMzE5NSAxMi40NzE3IDcuOTY3MjMgMTEuMTIzIDkuODg1NTZMNC4xMTQ0MSAyLjg3N0M2LjAzNDA1IDEuNTI3NDIgOC43NjkwMyAxLjY1Mzc4IDEwLjU1NzYgMy40NDIzNlpNMy40NDIzNiAxMC41NTc2QzEuNjUyNzcgOC43NjgwNSAxLjUyODMgNi4wMzI3NyAyLjg3Njk3IDQuMTE0NDRMOS44ODU1OSAxMS4xMjNDNy45NjU5NyAxMi40NzI2IDUuMjMwOTcgMTIuMzQ2MyAzLjQ0MjM2IDEwLjU1NzZaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"

/***/ }),
/* 2078 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2079 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2080 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEwNjkzXzUwMykiPgo8cGF0aCBkPSJNOS45OTk4OCAxNS42OTIzQzE0LjIwMzggMTUuNjkyMyAxNy42MTE4IDEyLjE3OTUgMTcuNjExOCA3Ljg0NjE1QzE3LjYxMTggMy41MTI4NCAxNC4yMDM4IDAgOS45OTk4OCAwQzUuNzk1OTIgMCAyLjM4Nzk0IDMuNTEyODQgMi4zODc5NCA3Ljg0NjE1QzIuMzg3OTQgMTIuMTc5NSA1Ljc5NTkyIDE1LjY5MjMgOS45OTk4OCAxNS42OTIzWiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTMuMjgzNTggMTEuNTM4NUwwIDE2TDQuNDc3NjEgMTUuMjMwOEw1LjA3NDYzIDIwTDguNTA3NDYgMTUuMzg0NkM2LjI2ODY2IDE0LjkyMzEgNC40Nzc2MSAxMy4zODQ2IDMuNDMyODQgMTEuMzg0NkwzLjI4MzU4IDExLjUzODVaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMTYuNzE2NSAxMS41Mzg1QzE1LjY3MTcgMTMuNTM4NSAxMy40MzI5IDE0LjkyMzEgMTEuMTk0MSAxNS4zODQ2TDE1LjA3NDcgMjAuMTUzOEwxNS42NzE3IDE1LjM4NDZMMjAuMTQ5MyAxNi4xNTM4TDE2Ljg2NTcgMTEuNTM4NUgxNi43MTY1WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTE1Ljg3MyA3LjkxODc1QzE1Ljg4OTkgNC42MDUwOCAxMy4yOTc0IDEuOTA0NzYgMTAuMDgyNyAxLjg4NzQxQzYuODY3OTUgMS44NzAwNiA0LjI0ODI0IDQuNTQyMjUgNC4yMzE0MSA3Ljg1NTkyQzQuMjE0NTcgMTEuMTY5NiA2LjgwNyAxMy44Njk5IDEwLjAyMTcgMTMuODg3M0MxMy4yMzY1IDEzLjkwNDYgMTUuODU2MiAxMS4yMzI0IDE1Ljg3MyA3LjkxODc1WiIgZmlsbD0iIzNDOERCQyIvPgo8cGF0aCBkPSJNMTIuNTM3NCA0LjkyMzEzVjEwLjc2OTNDMTIuNTM3NCAxMC43NjkzIDEyLjUzNzQgMTEuMDc3IDEyLjIzODkgMTEuMDc3QzExLjk0MDQgMTEuMDc3IDExLjY0MTkgMTEuMDc3IDExLjM0MzQgMTEuMDc3SDExLjA0NDlDMTAuNDQ3OSAxMC4wMDAxIDkuNzAxNjEgOC43NjkyOSA5LjEwNDYgNy42OTIzNlYxMC45MjMxQzkuMTA0NiAxMC45MjMxIDkuMTA0NiAxMS4yMzA4IDguODA2MDkgMTEuMjMwOEM4LjUwNzU4IDExLjIzMDggOC4yMDkwOCAxMS4yMzA4IDcuOTEwNTcgMTEuMjMwOEM3Ljc2MTMxIDExLjIzMDggNy42MTIwNiAxMS4yMzA4IDcuNjEyMDYgMTAuOTIzMVY1LjA3Njk4QzcuNjEyMDYgNS4wNzY5OCA3LjYxMjA2IDQuNzY5MjkgNy45MTA1NyA0Ljc2OTI5QzguMzU4MzMgNC43NjkyOSA4LjY1Njg0IDQuNzY5MjkgOS4xMDQ2IDQuNzY5MjlDOS4xMDQ2IDQuNzY5MjkgOS40MDMxMSA0Ljc2OTI5IDkuNDAzMTEgNC45MjMxM0MxMC4wMDAxIDYuMDAwMDYgMTAuNTk3MSA3LjA3Njk4IDExLjE5NDIgOC4xNTM5VjUuMDc2OThDMTEuMTk0MiA1LjA3Njk4IDExLjE5NDIgNC43NjkyOSAxMS40OTI3IDQuNzY5MjlDMTEuNzkxMiA0Ljc2OTI5IDExLjk0MDQgNC43NjkyOSAxMi4yMzg5IDQuNzY5MjlDMTIuMjM4OSA0Ljc2OTI5IDEyLjUzNzQgNC43NjkyOSAxMi41Mzc0IDUuMDc2OThWNC45MjMxM1oiIGZpbGw9IndoaXRlIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTA2OTNfNTAzIj4KPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo="

/***/ }),
/* 2081 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2082 */,
/* 2083 */,
/* 2084 */,
/* 2085 */,
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(962)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(2442),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(910)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(2376),
  /* scopeId */
  "data-v-30fdce3e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(991)
__webpack_require__(992)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(2473),
  /* scopeId */
  "data-v-6d01ba26",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(920)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(2389),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(904)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(484),
  /* template */
  __webpack_require__(2364),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(2529),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(960)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(2438),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(873)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(2324),
  /* scopeId */
  "data-v-13956d75",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(947)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(495),
  /* template */
  __webpack_require__(2419),
  /* scopeId */
  "data-v-52c5c505",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1059)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(496),
  /* template */
  __webpack_require__(2563),
  /* scopeId */
  "data-v-efd8b79c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(939)
__webpack_require__(938)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(498),
  /* template */
  __webpack_require__(2408),
  /* scopeId */
  "data-v-4aa2960f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(941)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(499),
  /* template */
  __webpack_require__(2411),
  /* scopeId */
  "data-v-4bc92084",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(500),
  /* template */
  __webpack_require__(2476),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(501),
  /* template */
  __webpack_require__(2406),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(2437),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(504),
  /* template */
  __webpack_require__(2294),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(915)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(505),
  /* template */
  __webpack_require__(2382),
  /* scopeId */
  "data-v-39c50a89",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1005)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(506),
  /* template */
  __webpack_require__(2490),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(2385),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(983)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(508),
  /* template */
  __webpack_require__(2464),
  /* scopeId */
  "data-v-67eb4c39",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(509),
  /* template */
  __webpack_require__(2447),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(510),
  /* template */
  __webpack_require__(2409),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(511),
  /* template */
  __webpack_require__(2434),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(512),
  /* template */
  __webpack_require__(2525),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(513),
  /* template */
  __webpack_require__(2430),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(514),
  /* template */
  __webpack_require__(2375),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(2526),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(516),
  /* template */
  __webpack_require__(2316),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(517),
  /* template */
  __webpack_require__(2567),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(2395),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(519),
  /* template */
  __webpack_require__(2519),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1025)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(520),
  /* template */
  __webpack_require__(2512),
  /* scopeId */
  "data-v-89eab82c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(988)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(523),
  /* template */
  __webpack_require__(2470),
  /* scopeId */
  "data-v-6a83ad99",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(993)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(525),
  /* template */
  __webpack_require__(2474),
  /* scopeId */
  "data-v-6dccdb0e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(528),
  /* template */
  __webpack_require__(2462),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(529),
  /* template */
  __webpack_require__(2570),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(535),
  /* template */
  __webpack_require__(2327),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(536),
  /* template */
  __webpack_require__(2391),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(537),
  /* template */
  __webpack_require__(2530),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(538),
  /* template */
  __webpack_require__(2330),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(539),
  /* template */
  __webpack_require__(2439),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(892)
__webpack_require__(891)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(540),
  /* template */
  __webpack_require__(2350),
  /* scopeId */
  "data-v-208e4aa4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(542),
  /* template */
  __webpack_require__(2361),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(543),
  /* template */
  __webpack_require__(2367),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(544),
  /* template */
  __webpack_require__(2369),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(545),
  /* template */
  __webpack_require__(2488),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2132 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1042)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(546),
  /* template */
  __webpack_require__(2539),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(955)
__webpack_require__(956)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(547),
  /* template */
  __webpack_require__(2431),
  /* scopeId */
  "data-v-57c6c72a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(870)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(548),
  /* template */
  __webpack_require__(2318),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1021)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(549),
  /* template */
  __webpack_require__(2508),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2136 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(899)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(550),
  /* template */
  __webpack_require__(2358),
  /* scopeId */
  "data-v-28acc0ae",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(888)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(552),
  /* template */
  __webpack_require__(2345),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2138 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(996)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(553),
  /* template */
  __webpack_require__(2480),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1030)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(554),
  /* template */
  __webpack_require__(2518),
  /* scopeId */
  "data-v-97e5a17c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1041)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(555),
  /* template */
  __webpack_require__(2537),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(556),
  /* template */
  __webpack_require__(2377),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2142 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1022)
__webpack_require__(1023)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(557),
  /* template */
  __webpack_require__(2509),
  /* scopeId */
  "data-v-88c53092",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(558),
  /* template */
  __webpack_require__(2341),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(872)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(559),
  /* template */
  __webpack_require__(2322),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(968)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(560),
  /* template */
  __webpack_require__(2449),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(562),
  /* template */
  __webpack_require__(2346),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2147 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1012)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(563),
  /* template */
  __webpack_require__(2501),
  /* scopeId */
  "data-v-7f7527ee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(564),
  /* template */
  __webpack_require__(2500),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(565),
  /* template */
  __webpack_require__(2444),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1053)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(566),
  /* template */
  __webpack_require__(2555),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2151 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(975)
__webpack_require__(977)
__webpack_require__(976)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(568),
  /* template */
  __webpack_require__(2456),
  /* scopeId */
  "data-v-64747bee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2152 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(859)
__webpack_require__(861)
__webpack_require__(860)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(569),
  /* template */
  __webpack_require__(2307),
  /* scopeId */
  "data-v-094310ad",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2153 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(571),
  /* template */
  __webpack_require__(2482),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2154 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(572),
  /* template */
  __webpack_require__(2547),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2155 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1016)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(573),
  /* template */
  __webpack_require__(2504),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2156 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(574),
  /* template */
  __webpack_require__(2465),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2157 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(575),
  /* template */
  __webpack_require__(2416),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2158 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(576),
  /* template */
  __webpack_require__(2506),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2159 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(577),
  /* template */
  __webpack_require__(2323),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2160 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(578),
  /* template */
  __webpack_require__(2522),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(579),
  /* template */
  __webpack_require__(2325),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2162 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(580),
  /* template */
  __webpack_require__(2491),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2163 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(581),
  /* template */
  __webpack_require__(2331),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(582),
  /* template */
  __webpack_require__(2311),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2165 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(583),
  /* template */
  __webpack_require__(2538),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(584),
  /* template */
  __webpack_require__(2425),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(585),
  /* template */
  __webpack_require__(2457),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2168 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(586),
  /* template */
  __webpack_require__(2390),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(953)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(587),
  /* template */
  __webpack_require__(2428),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1002)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(588),
  /* template */
  __webpack_require__(2485),
  /* scopeId */
  "data-v-77d001f4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2171 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(959)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(589),
  /* template */
  __webpack_require__(2436),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2172 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(918)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(590),
  /* template */
  __webpack_require__(2387),
  /* scopeId */
  "data-v-3d9749f3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(982)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(591),
  /* template */
  __webpack_require__(2463),
  /* scopeId */
  "data-v-662c184c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(934)
__webpack_require__(936)
__webpack_require__(935)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(592),
  /* template */
  __webpack_require__(2405),
  /* scopeId */
  "data-v-4881ae54",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2175 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(854)
__webpack_require__(856)
__webpack_require__(855)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(593),
  /* template */
  __webpack_require__(2302),
  /* scopeId */
  "data-v-061641f0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(901)
__webpack_require__(903)
__webpack_require__(902)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(594),
  /* template */
  __webpack_require__(2360),
  /* scopeId */
  "data-v-29579c1c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1018)
__webpack_require__(1020)
__webpack_require__(1019)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(595),
  /* template */
  __webpack_require__(2507),
  /* scopeId */
  "data-v-8758da34",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(876)
__webpack_require__(878)
__webpack_require__(877)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(596),
  /* template */
  __webpack_require__(2329),
  /* scopeId */
  "data-v-150c9a6a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2179 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(966)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(597),
  /* template */
  __webpack_require__(2446),
  /* scopeId */
  "data-v-5e8a5f92",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1056)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(598),
  /* template */
  __webpack_require__(2559),
  /* scopeId */
  "data-v-e31aaaf6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1024)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(599),
  /* template */
  __webpack_require__(2511),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(893)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(600),
  /* template */
  __webpack_require__(2351),
  /* scopeId */
  "data-v-20e41f39",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2183 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(858)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(601),
  /* template */
  __webpack_require__(2306),
  /* scopeId */
  "data-v-090eaef2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2184 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(917)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(603),
  /* template */
  __webpack_require__(2384),
  /* scopeId */
  "data-v-3ac6660e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2185 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(916)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(604),
  /* template */
  __webpack_require__(2383),
  /* scopeId */
  "data-v-3a817cdc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(898)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(605),
  /* template */
  __webpack_require__(2357),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(933)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(606),
  /* template */
  __webpack_require__(2404),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(926)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(607),
  /* template */
  __webpack_require__(2396),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2189 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(608),
  /* template */
  __webpack_require__(2498),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2190 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(897)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(609),
  /* template */
  __webpack_require__(2356),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(874)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(610),
  /* template */
  __webpack_require__(2326),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1035)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(611),
  /* template */
  __webpack_require__(2528),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2193 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(612),
  /* template */
  __webpack_require__(2398),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2194 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(613),
  /* template */
  __webpack_require__(2296),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(906)
__webpack_require__(907)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(614),
  /* template */
  __webpack_require__(2370),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(616),
  /* template */
  __webpack_require__(2373),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(929)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(617),
  /* template */
  __webpack_require__(2400),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2198 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1048)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(619),
  /* template */
  __webpack_require__(2546),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2199 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(869)
__webpack_require__(868)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(620),
  /* template */
  __webpack_require__(2315),
  /* scopeId */
  "data-v-0d61b576",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2200 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(850)
__webpack_require__(851)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(621),
  /* template */
  __webpack_require__(2297),
  /* scopeId */
  "data-v-02e0c062",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(883)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(622),
  /* template */
  __webpack_require__(2337),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(885)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(625),
  /* template */
  __webpack_require__(2343),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2203 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(864)
__webpack_require__(865)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(626),
  /* template */
  __webpack_require__(2310),
  /* scopeId */
  "data-v-09f55bba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(965)
__webpack_require__(964)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(627),
  /* template */
  __webpack_require__(2445),
  /* scopeId */
  "data-v-5dea52d9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(881)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(628),
  /* template */
  __webpack_require__(2335),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(629),
  /* template */
  __webpack_require__(2339),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1046)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(631),
  /* template */
  __webpack_require__(2544),
  /* scopeId */
  "data-v-bf11ec48",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1027)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(632),
  /* template */
  __webpack_require__(2514),
  /* scopeId */
  "data-v-8a12fbaa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1006)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(633),
  /* template */
  __webpack_require__(2492),
  /* scopeId */
  "data-v-7aeb1d20",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(943)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(634),
  /* template */
  __webpack_require__(2414),
  /* scopeId */
  "data-v-4f23ffbf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2211 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(635),
  /* template */
  __webpack_require__(2399),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(931)
__webpack_require__(932)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(641),
  /* template */
  __webpack_require__(2403),
  /* scopeId */
  "data-v-48648d1b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2213 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(642),
  /* template */
  __webpack_require__(2354),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2214 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1017)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(643),
  /* template */
  __webpack_require__(2505),
  /* scopeId */
  "data-v-8131362c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(940)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(644),
  /* template */
  __webpack_require__(2410),
  /* scopeId */
  "data-v-4b9a266a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(875)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(645),
  /* template */
  __webpack_require__(2328),
  /* scopeId */
  "data-v-14805399",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(879)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(646),
  /* template */
  __webpack_require__(2332),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(972)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(650),
  /* template */
  __webpack_require__(2453),
  /* scopeId */
  "data-v-633a7ce3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(979)
__webpack_require__(978)
__webpack_require__(980)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(655),
  /* template */
  __webpack_require__(2458),
  /* scopeId */
  "data-v-64b97f96",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(656),
  /* template */
  __webpack_require__(2467),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(986)
__webpack_require__(985)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(657),
  /* template */
  __webpack_require__(2468),
  /* scopeId */
  "data-v-6a1efd6c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(946)
__webpack_require__(945)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(659),
  /* template */
  __webpack_require__(2417),
  /* scopeId */
  "data-v-50c10ad2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(660),
  /* template */
  __webpack_require__(2401),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(905)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(663),
  /* template */
  __webpack_require__(2366),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(974)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(664),
  /* template */
  __webpack_require__(2455),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(998)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(665),
  /* template */
  __webpack_require__(2483),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(666),
  /* template */
  __webpack_require__(2365),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1061)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(667),
  /* template */
  __webpack_require__(2565),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(852)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(668),
  /* template */
  __webpack_require__(2299),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1057)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(678),
  /* template */
  __webpack_require__(2560),
  /* scopeId */
  "data-v-e7fb0a44",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1044)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(681),
  /* template */
  __webpack_require__(2541),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2232 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(924)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(682),
  /* template */
  __webpack_require__(2393),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(866)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(683),
  /* template */
  __webpack_require__(2312),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1051)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(684),
  /* template */
  __webpack_require__(2550),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1052)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(685),
  /* template */
  __webpack_require__(2552),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2236 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(848)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(688),
  /* template */
  __webpack_require__(2292),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1009)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(689),
  /* template */
  __webpack_require__(2496),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2238 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(690),
  /* template */
  __webpack_require__(2421),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2239 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(691),
  /* template */
  __webpack_require__(2553),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2240 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(692),
  /* template */
  __webpack_require__(2314),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2241 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(693),
  /* template */
  __webpack_require__(2418),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(694),
  /* template */
  __webpack_require__(2554),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2243 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(895)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(696),
  /* template */
  __webpack_require__(2353),
  /* scopeId */
  "data-v-2489d53a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2244 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1014)
__webpack_require__(1013)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(698),
  /* template */
  __webpack_require__(2502),
  /* scopeId */
  "data-v-7f950833",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2245 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(699),
  /* template */
  __webpack_require__(2342),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2246 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(700),
  /* template */
  __webpack_require__(2535),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2247 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(701),
  /* template */
  __webpack_require__(2494),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2248 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1033)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(702),
  /* template */
  __webpack_require__(2524),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2249 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(849)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(703),
  /* template */
  __webpack_require__(2293),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2250 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(995)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(704),
  /* template */
  __webpack_require__(2477),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2251 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(884)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(705),
  /* template */
  __webpack_require__(2338),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2252 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(706),
  /* template */
  __webpack_require__(2510),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2253 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(707),
  /* template */
  __webpack_require__(2432),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2254 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1050)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(708),
  /* template */
  __webpack_require__(2549),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2255 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1058)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(709),
  /* template */
  __webpack_require__(2561),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2256 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(710),
  /* template */
  __webpack_require__(2340),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2257 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(900)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(711),
  /* template */
  __webpack_require__(2359),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(712),
  /* template */
  __webpack_require__(2532),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2259 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(954)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(713),
  /* template */
  __webpack_require__(2429),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1028)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(714),
  /* template */
  __webpack_require__(2515),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(989)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(715),
  /* template */
  __webpack_require__(2471),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1062)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(716),
  /* template */
  __webpack_require__(2569),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2263 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1011)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(717),
  /* template */
  __webpack_require__(2499),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(718),
  /* template */
  __webpack_require__(2441),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(719),
  /* template */
  __webpack_require__(2452),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(720),
  /* template */
  __webpack_require__(2520),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2267 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(721),
  /* template */
  __webpack_require__(2551),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2268 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(886)
__webpack_require__(887)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(722),
  /* template */
  __webpack_require__(2344),
  /* scopeId */
  "data-v-1a39b65b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(908)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(725),
  /* template */
  __webpack_require__(2372),
  /* scopeId */
  "data-v-2e2088e5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(948)
__webpack_require__(949)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(726),
  /* template */
  __webpack_require__(2420),
  /* scopeId */
  "data-v-533d231c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(957)
__webpack_require__(958)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(727),
  /* template */
  __webpack_require__(2435),
  /* scopeId */
  "data-v-59342c1e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2272 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(728),
  /* template */
  __webpack_require__(2542),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1034)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(732),
  /* template */
  __webpack_require__(2527),
  /* scopeId */
  "data-v-a1493d4c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(733),
  /* template */
  __webpack_require__(2478),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2275 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(734),
  /* template */
  __webpack_require__(2300),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2276 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(737),
  /* template */
  __webpack_require__(2422),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(890)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(738),
  /* template */
  __webpack_require__(2348),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2278 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(740),
  /* template */
  __webpack_require__(2362),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2279 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(880)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(742),
  /* template */
  __webpack_require__(2334),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2280 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(969)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(743),
  /* template */
  __webpack_require__(2450),
  /* scopeId */
  "data-v-6059770e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2281 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(744),
  /* template */
  __webpack_require__(2516),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(745),
  /* template */
  __webpack_require__(2305),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2283 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(894)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(746),
  /* template */
  __webpack_require__(2352),
  /* scopeId */
  "data-v-23d96bec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2284 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(469),
  /* template */
  __webpack_require__(2304),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2285 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(967)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(2448),
  /* scopeId */
  "data-v-5f63531f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2286 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1029)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(471),
  /* template */
  __webpack_require__(2517),
  /* scopeId */
  "data-v-92892830",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2287 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(882)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(472),
  /* template */
  __webpack_require__(2336),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2288 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1036)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(2531),
  /* scopeId */
  "data-v-a54add64",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2289 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1049)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(474),
  /* template */
  __webpack_require__(2548),
  /* scopeId */
  "data-v-cb2ddeb8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2290 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1037)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(2533),
  /* scopeId */
  "data-v-a63784f0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2291 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1045)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(2543),
  /* scopeId */
  "data-v-be34f98e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2292 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-left"
  }, [(_vm.brandBrief.length > 2 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 品牌 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.brand_query),
      callback: function($$v) {
        _vm.brand_query = $$v
      },
      expression: "brand_query"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.brand_query.value !== 0 && _vm.brand_query.value !== '0' && _vm.storeBriefQ.length > 2 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.storeBriefQ,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 門市 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.store_query),
      callback: function($$v) {
        _vm.store_query = $$v
      },
      expression: "store_query"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            項目名稱\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name_query),
      expression: "name_query"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.name_query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name_query = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            追蹤碼\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code_query),
      expression: "code_query"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "僅大小寫英文和數字",
      "type": "text",
      "maxlength": "25"
    },
    domProps: {
      "value": (_vm.code_query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code_query = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            入口\n          ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sourceSelect),
      expression: "sourceSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sourceSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sourceList), function(source) {
    return _c('option', {
      domProps: {
        "value": source.value
      }
    }, [_vm._v("\n            " + _vm._s(source.label) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.click_add
    }
  }, [_vm._v("+新增")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.brandBrief.length > 2 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 品牌 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.storeBrief.length > 2 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.storeBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 門市 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(2), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(3)]) : (_vm.orderList.length === 0) ? _c('tbody', [_vm._m(4)]) : (_vm.orderList.length > 0) ? _c('tbody', _vm._l((_vm.orderList), function(order, index) {
    return _c('tr', {
      staticClass: "even",
      class: {
        'bg-pre-order': order.order_method === 2
      },
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(_vm.getTime(order.create_time)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.name) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.sourceTypeName(order.url_type)))]), _vm._v(" "), _c('td', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-6"
    }, [_vm._v(_vm._s(order.url))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "col-6"
    }, [_c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (order.url),
        expression: "order.url",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.copySuccess),
        expression: "copySuccess",
        arg: "success"
      }],
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button"
      }
    }, [_vm._v("複製")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.delcode(order.id, order.target_brand_id, order.target_store_id)
        }
      }
    }, [_vm._v("刪除")])])])])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('paginate', {
    ref: "orderPaginate",
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "12px",
      "color": "red"
    }
  }, [_vm._v("*項目名稱：最多可輸入10個字 "), _c('br'), _vm._v(" *追蹤碼：限25字內，僅限英數大小寫，不可符號")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info-bg"
  }, [_c('ul', [_c('li', [_vm._v("你訂團隊持續在進行系統優化，如有追蹤訂單來源需求，可自【新後台管理系統】-【成效數據中心】使用[自訂報表]下載報表分析。")]), _vm._v(" "), _c('li', [_vm._v("此追蹤碼功能於近期將不再進行相關維護，如需更進階數據分析需求，可洽你訂同仁詢問GA4數據分析，會有專人與您詳細說明完整方案。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("日期")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("項目名稱")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("追蹤碼")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("入口")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("網址")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
}]}

/***/ }),
/* 2293 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [(_vm.brandBrief.length > 2 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 品牌 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.brandSelect.value !== 0 && _vm.brandSelect.value !== '0' && _vm.storeBrief.length > 2 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.storeBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 門市 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.starSelect),
      expression: "starSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.starSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.starList), function(star) {
    return _c('option', {
      domProps: {
        "value": star.value
      }
    }, [_vm._v("\n            " + _vm._s(star.label) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repliedSelect),
      expression: "repliedSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.repliedSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.repliedList), function(replied) {
    return _c('option', {
      domProps: {
        "value": replied.value
      }
    }, [_vm._v("\n            " + _vm._s(replied.label) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mainSelect),
      expression: "mainSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mainSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.mainList), function(main) {
    return _c('option', {
      domProps: {
        "value": main.value
      }
    }, [_vm._v("\n            " + _vm._s(main.label) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchSelect),
      expression: "searchSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("時間")])])]), _vm._v(" "), (_vm.searchSelect == 1) ? _c('div', {
    staticClass: "form-group input-group time-box"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.dateoption,
      "limit": _vm.startLimit
    }
  }), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.dateoption,
      "limit": _vm.endLimit
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default submit-btn btn-search",
    staticStyle: {
      "height": "72px"
    },
    attrs: {
      "type": "button",
      "id": "search"
    },
    on: {
      "click": function($event) {
        return _vm.search(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])], 1) : _vm._e(), _vm._v(" "), (_vm.searchSelect == 2) ? _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderSn),
      expression: "orderSn"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.orderSn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orderSn = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.search(2)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.searchSelect == 3) ? _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shopper),
      expression: "shopper"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.shopper)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shopper = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.search(3)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.searchSelect == 4) ? _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subOrderAmount),
      expression: "subOrderAmount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.subOrderAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subOrderAmount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.search(4)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "th-fit",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }), _vm._v(" "), (_vm.roleType === 99) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("品牌(ID)")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99 || _vm.roleType === 30) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("分店(ID)")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "th-fit",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單編號")]), _vm._v(" "), _c('th', {
    staticClass: "th-fit",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂購人")]), _vm._v(" "), _c('th', {
    staticClass: "th-fit",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("實付金額")]), _vm._v(" "), _c('th', {
    staticClass: "th-fit",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("星級")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("留言")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])]), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(0)]) : (_vm.ratingList.length === 0) ? _c('tbody', [_vm._m(1)]) : (_vm.ratingList.length > 0) ? _c('tbody', _vm._l((_vm.ratingList), function(rating, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), (_vm.roleType === 99) ? _c('td', [_vm._v(_vm._s(rating.brand_name) + " (" + _vm._s(rating.brand_id) + ")")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99 || _vm.roleType === 30) ? _c('td', [_vm._v(_vm._s(rating.store_name) + "(" + _vm._s(rating.store_id) + ")")]) : _vm._e(), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/orderInfo/' + rating.order_id
        },
        "target": "_blank"
      }
    }, [_vm._v("\n              " + _vm._s(rating.order_sn) + "\n            ")])], 1), _vm._v(" "), _c('td', [(rating.delivery_type === 1) ? _c('i', {
      staticClass: "fa fa-hand-paper-o",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" "), (rating.delivery_type === 2) ? _c('i', {
      staticClass: "fa fa-inbox",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" "), (rating.delivery_type === 3) ? _c('i', {
      staticClass: "fa fa-motorcycle",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" "), (rating.delivery_type === 4) ? _c('i', {
      staticClass: "fa fa-shopping-bag",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" "), (rating.delivery_type === 5) ? _c('i', {
      staticClass: "fa fa-glass",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" "), (rating.delivery_type === 21) ? _c('i', {
      staticClass: "fa fa-qrcode",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(rating.shopper_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(rating.total_paid_money))]), _vm._v(" "), _c('td', {
      class: rating.star > 3 ? 'text-success' : 'text-danger'
    }, [_c('i', {
      staticClass: "fa fa-star",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(rating.star))]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(rating.comment))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-default",
      class: {
        'btn-success': !rating.is_replied
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#ratingModal"
      },
      on: {
        "click": function($event) {
          return _vm.openModal(rating)
        }
      }
    }, [(rating.is_replied) ? _c('span', [_vm._v("修改")]) : _c('span', [_vm._v("回覆")]), _vm._v("評價\n            ")])])])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('paginate', {
    ref: "orderPaginate",
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "ratingModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [(_vm.ratingInfo.is_replied) ? _c('span', [_vm._v("修改")]) : _c('span', [_vm._v("回覆")]), _vm._v("評價")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('p', {
    class: _vm.ratingInfo.star > 3 ? 'text-success' : 'text-danger'
  }, [_c('i', {
    staticClass: "fa fa-star",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.ratingInfo.star) + "\n              ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.ratingInfo.comment))]), _vm._v(" "), _c('p', {
    staticClass: "text-right"
  }, [_c('small', [_vm._v(_vm._s(_vm.ratingInfo.create_time))])]), _vm._v(" "), _c('div', {
    staticClass: "m-t-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ratingInfo.reply_comment),
      expression: "ratingInfo.reply_comment"
    }],
    staticClass: "w-100-p p-10",
    staticStyle: {
      "border": "1px solid #ddd",
      "min-height": "250px"
    },
    domProps: {
      "value": (_vm.ratingInfo.reply_comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ratingInfo, "reply_comment", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-right"
  }, [_c('small', [_vm._v(_vm._s(_vm.ratingInfo.reply_time))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.reply
    }
  }, [_vm._v("確定"), (_vm.ratingInfo.is_replied) ? _c('span', [_vm._v("修改")]) : _c('span', [_vm._v("回覆")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
}]}

/***/ }),
/* 2294 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('account-form', {
    attrs: {
      "info": _vm.info,
      "current": _vm.current,
      "brandList": _vm.brandList,
      "storeList": _vm.storeList,
      "posList": _vm.posList
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2295 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("每日訂單數量")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "amount-chart"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("每日訂單金額")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "money-chart"
    }
  })])])])])])
}]}

/***/ }),
/* 2296 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [(_vm.identityList.length) ? _c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.identityList), function(identity, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n            " + _vm._s(index + 1) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(identity.identity))]), _vm._v(" "), _c('td', [(identity.type == 1) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      attrs: {
        "src": "/static/img/icon/matcher.png"
      }
    })]) : _vm._e(), _vm._v(" "), (identity.type == 2) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      attrs: {
        "src": "/static/img/icon/fb.png"
      }
    })]) : _vm._e(), _vm._v(" "), (identity.type == 3) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      attrs: {
        "src": "/static/img/icon/google.png"
      }
    })]) : _vm._e(), _vm._v(" "), (identity.type == 4) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      attrs: {
        "src": "/static/img/icon/line.png"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', [(identity.is_active) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("啟動")]) : _vm._e(), _vm._v(" "), (!identity.is_active) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("未啟動")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(identity.edit_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(identity.create_time))])])
  }), 0)]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("識別碼")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("登入類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("啟動狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("更新時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("建立時間")])])])
}]}

/***/ }),
/* 2297 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.brandName && _vm.storeName) ? _c('h1', {
    staticStyle: {
      "position": "absolute",
      "top": "-39px",
      "left": "142px",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.brandName) + " - " + _vm._s(_vm.storeName))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body form"
  }, [_c('div', {
    staticClass: "flex justify-between"
  }, [_c('div', {
    staticClass: "flex m-b-10"
  }, [_c('label', {
    class: ['btn btn-left', _vm.switchType === 'choose' ? 'btn-primary' : 'btn-default'],
    attrs: {
      "for": "choose"
    }
  }, [_vm._v("搜尋商品")]), _vm._v(" "), _c('label', {
    class: ['btn btn-right', _vm.switchType === 'input' ? 'btn-primary' : 'btn-default'],
    attrs: {
      "for": "input"
    }
  }, [_vm._v(_vm._s(!_vm.up ? '新增' : '編輯') + "商品")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.switchType),
      expression: "switchType"
    }],
    attrs: {
      "type": "radio",
      "id": "choose",
      "name": "type",
      "value": "choose"
    },
    domProps: {
      "checked": _vm._q(_vm.switchType, "choose")
    },
    on: {
      "change": function($event) {
        _vm.switchType = "choose"
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.switchType),
      expression: "switchType"
    }],
    attrs: {
      "type": "radio",
      "id": "input",
      "name": "type",
      "value": "input"
    },
    domProps: {
      "checked": _vm._q(_vm.switchType, "input")
    },
    on: {
      "change": function($event) {
        _vm.switchType = "input"
      }
    }
  })]), _vm._v(" "), (_vm.up) ? _c('div', {
    staticClass: "pull-right m-b-10",
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "right": "0"
    }
  }, [_vm._m(1)]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group",
    staticStyle: {
      "max-width": "600px"
    }
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("商品名稱\n                "), (_vm.$route.name === 'crCategoryImg') ? _c('span', [_vm._v(" (分類)")]) : _vm._e()]), _vm._v(" "), (_vm.switchType === 'input') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.input.item.name),
      expression: "product.input.item.name"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "type": "text",
      "maxlength": "32"
    },
    domProps: {
      "value": (_vm.product.input.item.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product.input.item, "name", $event.target.value)
      }
    }
  }) : _c('multiselect', {
    attrs: {
      "options": _vm.optionsList,
      "searchable": true,
      "allow-empty": true,
      "close-on-select": true,
      "placeholder": "請輸入商品名稱",
      "show-labels": true,
      "multiple": false,
      "label": "name",
      "track-by": "id"
    },
    on: {
      "input": function($event) {
        return _vm.checkVenderId()
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(props.option.name))]), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(props.option.id) + ")")])]
      }
    }]),
    model: {
      value: (_vm.product.choose.item),
      callback: function($$v) {
        _vm.$set(_vm.product.choose, "item", $$v)
      },
      expression: "product.choose.item"
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group has-feedback",
    class: !_vm.up ? _vm.product[_vm.switchType].isItemCanCreate ? 'has-success' : 'has-error' : '',
    staticStyle: {
      "max-width": "600px"
    }
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("商品料號\n                "), (_vm.$route.name === 'crCategoryImg') ? _c('span', [_vm._v(" (分類)")]) : _vm._e()]), _vm._v(" "), (_vm.switchType === 'input') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.input.item.id),
      expression: "product.input.item.id"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "32"
    },
    domProps: {
      "value": (_vm.product.input.item.id)
    },
    on: {
      "focusout": _vm.checkVenderId,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product.input.item, "id", $event.target.value)
      }
    }
  }) : _c('multiselect', {
    attrs: {
      "options": _vm.optionsList,
      "searchable": true,
      "allow-empty": true,
      "close-on-select": true,
      "placeholder": "請輸入商品料號",
      "show-labels": true,
      "multiple": false,
      "label": "id",
      "track-by": "id"
    },
    on: {
      "input": function($event) {
        return _vm.checkVenderId()
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(props.option.name))]), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(props.option.id) + ")")])]
      }
    }]),
    model: {
      value: (_vm.product.choose.item),
      callback: function($$v) {
        _vm.$set(_vm.product.choose, "item", $$v)
      },
      expression: "product.choose.item"
    }
  }), _vm._v(" "), (!_vm.up) ? _c('span', {
    staticClass: "form-control-feedback",
    class: _vm.product[_vm.switchType].isItemCanCreate ? 'fa fa-check' : 'fa fa-times',
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.up) ? _c('span', {
    staticClass: "sr-only",
    attrs: {
      "id": "inputIconStatus"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("小圖 "), _c('br'), _vm._v(" "), (_vm.$route.name !== 'crCategoryImg') ? _c('span', [_vm._v("(80x60)")]) : _c('span', [_vm._v("(800x210)")])]), _vm._v(" "), (_vm.up) ? _c('img-update', {
    attrs: {
      "index": 99,
      "type": 1,
      "imgSrc": _vm.smImgSrc
    }
  }) : _c('img-up-drop', {
    attrs: {
      "id": "sm-image",
      "type": 1,
      "amount": 1,
      "imgList": _vm.imgList
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), (!_vm.up && _vm.$route.name !== 'crCategoryImg') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('img-up-drop', {
    attrs: {
      "id": "lg-image",
      "type": 2,
      "amount": 5,
      "imgList": _vm.imgList
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.up) ? _c('div', [_c('div', {
    staticClass: "input-group",
    staticStyle: {
      "max-width": "400px"
    }
  }, [_vm._m(3), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.enableOption,
      "label": "label",
      "searchable": false,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "啟用",
      "show-labels": false,
      "preselect-first": true
    },
    model: {
      value: (_vm.is_enabled),
      callback: function($$v) {
        _vm.is_enabled = $$v
      },
      expression: "is_enabled"
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.elementList.length && this.tab !== 10) ? _c('div', {
    staticClass: "row form-inline"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "th-thin",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("大圖 (800x600)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("排序")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("描述")]), _vm._v(" "), (_vm.up) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("刪除")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.elementList), function(element, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [(_vm.up) ? _c('img-update', {
      attrs: {
        "index": index,
        "type": 2,
        "imgSrc": element.img_url,
        "checkLoading": _vm.checkLoading
      }
    }) : _c('img', {
      staticClass: "h-auto img-responsive inline-block",
      attrs: {
        "src": element.img_url,
        "id": 'img-load' + index + '-' + _vm.type
      }
    })], 1), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "input-group has-feedback",
      class: {
        'has-error': element.isloading && element.sort === ''
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (element.sort),
        expression: "element.sort"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "數字",
        "aria-describedby": "inputError"
      },
      domProps: {
        "value": (element.sort)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(element, "sort", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "form-control-feedback",
      class: {
        'fa fa-times': element.isloading && element.sort === ''
      },
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "sr-only",
      attrs: {
        "id": "inputError"
      }
    })])]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (element.description),
        expression: "element.description"
      }],
      staticClass: "form-control",
      staticStyle: {
        "max-width": "250px",
        "width": "100%"
      },
      attrs: {
        "placeholder": "描述"
      },
      domProps: {
        "value": (element.description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(element, "description", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.up) ? _c('td', [(element.img_type) ? _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#delModal"
      },
      on: {
        "click": function($event) {
          return _vm.clickCurrent(element.id, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()]) : _vm._e()])
  }), 0)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-fail text-black",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n            返回\n          ")]), _vm._v(" "), (!_vm.up) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkImg()
      }
    }
  }, [_vm._v("\n            新增\n          ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkImg()
      }
    }
  }, [_vm._v("\n            更新\n          ")])])])])]), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delSmImgOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 相同料號的商品會一併新增、修改")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-danger inline-block",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delSmModal"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("大圖 "), _c('br'), _vm._v(" (800x600)\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("啟用\n              ")])
}]}

/***/ }),
/* 2298 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-10 flex align-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.goBackInfo.name,
        params: _vm.goBackInfo.params,
        query: _vm.goBackInfo.query
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default m-r-5 flex"
  }, [_c('span', [_vm._v("返回")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.title)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.subtitle)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex grey darken-1"
  }, [(_vm.brand.name || _vm.store.brand_name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s(_vm.brand.name ? _vm.brand.name : _vm.store.brand_name ? _vm.store.brand_name : '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s('/')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.store.name)
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('cr-product')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2299 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('cr-combine-price')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2300 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('printer-form', {
    attrs: {
      "info": _vm.info
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2301 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.price),
      expression: "item.price"
    }],
    ref: 'price' + _vm.id,
    staticClass: "input-option h-38",
    attrs: {
      "maxlength": "5"
    },
    domProps: {
      "value": (_vm.item.price)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityPrice()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "price", $event.target.value)
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 2302 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.$route.name === 'upActivity' && (_vm.activity.status === 0 || _vm.activity.status === 1)) ? _c('div', {
    staticClass: "text-right"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      'active': _vm.cMethod == 1
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.checkActivity(true, 1)
      }
    }
  }, [_c('a', [_vm._v("活動資訊")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.cMethod == 2
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.checkActivity(true, 2)
      }
    }
  }, [_c('a', [_vm._v("贈送規則")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.cMethod == 3
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.checkActivity(true, 3)
      }
    }
  }, [_c('a', [_vm._v("折抵規則")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.cMethod == 4
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.checkActivity(true, 4)
      }
    }
  }, [_c('a', [_vm._v("優惠券")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cMethod === 1),
      expression: "cMethod === 1"
    }],
    staticClass: "row m-b-15 center-block"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.title),
      expression: "activity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.name),
      expression: "activity.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.sort),
      expression: "activity.sort"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.activity.sort)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "sort", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.content),
      expression: "activity.content"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "活動說明",
      "maxlength": "256"
    },
    domProps: {
      "value": (_vm.activity.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "content", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動說明(後台)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.description),
      expression: "activity.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "活動說明",
      "maxlength": "256"
    },
    domProps: {
      "value": (_vm.activity.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [(_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.ownerTypeOptions,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "擁有者",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.owner_type),
      callback: function($$v) {
        _vm.$set(_vm.activity, "owner_type", $$v)
      },
      expression: "activity.owner_type"
    }
  })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getRoleType === 99 || (_vm.getRoleType === 30 && !_vm.info.info.activity_id)),
      expression: "getRoleType === 99 || (getRoleType === 30 && !info.info.activity_id)"
    }]
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), (_vm.activity.owner_type.value === 1) ? _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "label": "label",
      "track-by": "label",
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "clear-on-select": false,
      "placeholder": "品牌",
      "show-labels": false,
      "multiple": true
    },
    on: {
      "input": _vm.getMutiStore
    },
    model: {
      value: (_vm.brandSelectMuti),
      callback: function($$v) {
        _vm.brandSelectMuti = $$v
      },
      expression: "brandSelectMuti"
    }
  })], 1) : _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "品牌",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    on: {
      "input": _vm.getStore
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group cr-schedule"
  }, [_vm._m(7), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.activity.aTime.start,
      "option": _vm.timeoption,
      "limit": _vm.startLimit
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group cr-schedule"
  }, [_vm._m(8), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.activity.aTime.end,
      "option": _vm.timeoption,
      "limit": _vm.endLimit
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動備註")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.remark),
      expression: "activity.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "活動說明"
    },
    domProps: {
      "value": (_vm.activity.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])]), _vm._v(" "), (_vm.getRoleType !== 10) ? _c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_vm._m(9), _vm._v(" "), _c('muti-select-two', {
    attrs: {
      "setting": _vm.addStoresSetting,
      "reNew": _vm.reNew,
      "reSet": _vm.reSet
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cMethod === 2),
      expression: "cMethod === 2"
    }],
    staticClass: "row m-b-15 center-block"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('activity-strategy', {
    attrs: {
      "activity": _vm.activity,
      "info": _vm.info,
      "brandList": _vm.brandList,
      "addStoresSetting": _vm.addStoresSetting,
      "storeList": _vm.aStoreList,
      "aStoreOption": _vm.aStoreOption,
      "setInfoTimes": _vm.setInfoTimes
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cMethod === 3),
      expression: "cMethod === 3"
    }],
    staticClass: "row m-b-15 center-block"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('coupon-strategy', {
    attrs: {
      "giveCoupons": _vm.giveCoupons,
      "info": _vm.info,
      "brandList": _vm.brandList,
      "addStoresSetting": _vm.addStoresSetting,
      "storeList": _vm.aStoreList,
      "aStoreOption": _vm.aStoreOption,
      "setInfoTimes": _vm.setInfoTimes
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cMethod === 4),
      expression: "cMethod === 4"
    }],
    staticClass: "row m-b-15 center-block"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('coupon-list', {
    attrs: {
      "giveCoupons": _vm.giveCoupons,
      "info": _vm.info,
      "brandList": _vm.brandList,
      "storeList": _vm.aStoreList,
      "activity": _vm.activity,
      "setInfoTimes": _vm.setInfoTimes
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_vm._v("ˋ\n      "), (_vm.cMethod === 1) ? _c('button', {
    staticClass: "btn btn-fail",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n        取消\n      ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.cMethod--
      }
    }
  }, [_vm._v("\n        上一步\n      ")]), _vm._v(" "), (_vm.cMethod === 4 && _vm.$route.name === 'crActivityInfoForm') ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkActivity(false, 0)
      }
    }
  }, [_vm._v("\n        新增\n      ")]) : (_vm.cMethod === 4 && _vm.$route.name === 'upActivity') ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkActivity(false, 0)
      }
    }
  }, [_vm._v("\n        更新\n      ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkActivity(false, 0)
      }
    }
  }, [_vm._v("\n        下一步\n      ")])]), _vm._v(" "), _vm._l((_vm.couponList), function(cInfo, index) {
    return _c('div', [_c('div', {
      staticClass: "modal fade",
      attrs: {
        "id": 'couponRegisterModal' + index,
        "role": "dialog"
      }
    }, [_c('div', {
      staticClass: "modal-dialog choose-modal"
    }, [_c('div', {
      staticClass: "modal-content pull-left"
    }, [_vm._m(10, true), _vm._v(" "), (_vm.coupon.coupon_info) ? _c('div', {
      staticClass: "card m-y-1 pull-left m-y-10 c-pointer",
      staticStyle: {
        "width": "calc(100% - 80px)"
      },
      attrs: {
        "data-target": '#couponRegisterModal' + index,
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          return _vm.clickCoupon()
        }
      }
    }, [_c('div', {
      staticClass: "coupon-left p-10"
    }, [_c('h4', [(_vm.coupon.coupon_info.name) ? _c('span', [_vm._v(_vm._s(_vm.coupon.coupon_info.name))]) : _c('span', [_vm._v("優惠券名稱")])]), _vm._v(" "), _c('h5', [(_vm.coupon.coupon_info.description) ? _c('span', [_vm._v(_vm._s(_vm.coupon.coupon_info.description))]) : _c('span', [_vm._v("優惠券描述....")])]), _vm._v(" "), _c('h5', [_vm._v("到期："), (_vm.coupon.time_config.start_time.time) ? _c('span', [_vm._v(_vm._s(_vm.coupon.time_config.start_time.time) + " ~ " + _vm._s(_vm.coupon.time_config.end_time.time))]) : _c('span', [_vm._v(_vm._s(_vm.nowTime) + " ~ " + _vm._s(_vm.nowTime))])])]), _vm._v(" "), _c('div', {
      staticClass: "coupon-right p-10"
    }, [_c('div', {
      staticClass: "v-middle"
    }, [_vm._v("\n                  $"), (_vm.coupon.coupon_info.discount_value) ? _c('span', [_vm._v(_vm._s(_vm.coupon.coupon_info.discount_value))]) : _c('span', [_vm._v("10")])])])]) : _vm._e()])])])])
  })], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動名稱(前台)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動名稱(後台)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動順序")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動說明(前台)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("擁有者\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("參與品牌\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動開始時間\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動結束時間\n                      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("參與店家")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header pull-left w-100-p"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title text-left"
  }, [_vm._v("優惠券設定")])])
}]}

/***/ }),
/* 2303 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.modalId,
    staticClass: "modal fade",
    attrs: {
      "id": _vm.modalId,
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header text-left"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n          " + _vm._s(_vm.modalState) + "  \n          "), (_vm.state == 3 && !_vm.editState && _vm.optionInfo.is_mandatory) ? _c('label', {
    staticClass: "badge bg-red"
  }, [_vm._v("必選")]) : _vm._e(), _vm._v(" "), (_vm.state == 3 && !_vm.editState && _vm.optionInfo.is_common) ? _c('label', {
    staticClass: "badge bg-blue"
  }, [_vm._v("常見")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-right": "10px"
    }
  }, [(_vm.editState) ? _c('button', {
    staticClass: "btn btn-danger icon-modal-del",
    on: {
      "click": function($event) {
        _vm.show.delNotify = !_vm.show.delNotify
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.editState && _vm.state == 3) ? _c('button', {
    staticClass: "btn btn-primary icon-modal-edit",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.editState = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.editState) ? _c('button', {
    staticClass: "btn btn-primary icon-modal-edit",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.editState = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.show.delNotify) ? _c('div', {
    staticClass: "del-c-block"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.show.delNotify = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.delOption
    }
  }, [_vm._v("刪除")])])])])]) : _vm._e()]), _vm._v(" "), (_vm.state == 3 && !_vm.editState) ? _c('div', {
    staticClass: "box-body form"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("分類")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.optionInfo.sub_type))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("選項名稱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.getSubType(_vm.optionInfo.name)))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("調整類別名稱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.adjustName))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("排序")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.optionInfo.sort))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("購買數")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.optionInfo.min_limit) + " ～ " + _vm._s(_vm.maxAmount(_vm.optionInfo.max_limit)))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("價格")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v("$" + _vm._s(_vm.optionInfo.price) + " (" + _vm._s(_vm.getPriceType(_vm.optionInfo.price_type)) + ")")])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.optionInfo.calorie) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("熱量")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.optionInfo.calorie) + " cal")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.optionInfo.description) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("描述")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.optionInfo.description))])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.optionInfo.remark) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("備註")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.optionInfo.remark))])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.optionInfo.option_custom_id) ? _c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("POS廠自定義的ID")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.optionInfo.option_custom_id))])]), _vm._v(" "), _c('br')]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.state == 1 || _vm.editState) ? _c('div', {
    staticClass: "box-body form"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.sub_type),
      expression: "optionInfo.sub_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.optionInfo, "sub_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.optionList), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.label))])
  }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.name),
      expression: "optionInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "32"
    },
    domProps: {
      "value": (_vm.optionInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("調整類別名稱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.adjustName))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), (_vm.state == 1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.sort),
      expression: "optionInfo.sort"
    }],
    ref: "sort1",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.optionInfo.sort)
    },
    on: {
      "keyup": function($event) {
        return _vm.veritySort()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "sort", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.state == 3) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.sort),
      expression: "optionInfo.sort"
    }],
    ref: "sort3",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.optionInfo.sort)
    },
    on: {
      "keyup": function($event) {
        return _vm.veritySort()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "sort", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "radio text-left h-38",
    staticStyle: {
      "border-left": "1px solid #d2d6de"
    }
  }, [_c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.is_mandatory),
      expression: "optionInfo.is_mandatory"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "mandatoryRadio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.optionInfo.is_mandatory, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.optionInfo, "is_mandatory", "1")
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("是")])]), _vm._v(" "), _c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.is_mandatory),
      expression: "optionInfo.is_mandatory"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "mandatoryRadio",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.optionInfo.is_mandatory, "0")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.optionInfo, "is_mandatory", "0")
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("否")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "radio text-left h-38",
    staticStyle: {
      "border-left": "1px solid #d2d6de"
    }
  }, [_c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.is_common),
      expression: "optionInfo.is_common"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "commonRadio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.optionInfo.is_common, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.optionInfo, "is_common", "1")
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("是")])]), _vm._v(" "), _c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.is_common),
      expression: "optionInfo.is_common"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "commonRadio",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.optionInfo.is_common, "0")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.optionInfo, "is_common", "0")
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("否")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), (_vm.state == 1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.min_limit),
      expression: "optionInfo.min_limit"
    }],
    ref: "minLimit1",
    staticClass: "form-control c-auto",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "9",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.optionInfo.min_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityMinLimit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "min_limit", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.state == 3) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.min_limit),
      expression: "optionInfo.min_limit"
    }],
    ref: "minLimit3",
    staticClass: "form-control c-auto",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "9",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.optionInfo.min_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityMinLimit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "min_limit", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(9), _vm._v(" "), (_vm.state == 1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.max_limit),
      expression: "optionInfo.max_limit"
    }],
    ref: "maxLimit1",
    staticClass: "form-control c-auto",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "9",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.optionInfo.max_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityMaxLimit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "max_limit", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.state == 3) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.max_limit),
      expression: "optionInfo.max_limit"
    }],
    ref: "maxLimit3",
    staticClass: "form-control c-auto",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "9",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.optionInfo.max_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityMaxLimit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "max_limit", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(10), _vm._v(" "), (_vm.state == 1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.price),
      expression: "optionInfo.price"
    }],
    ref: "price1",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.optionInfo.price)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityPrice()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "price", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.state == 3) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.price),
      expression: "optionInfo.price"
    }],
    ref: "price3",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.optionInfo.price)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityPrice()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "price", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.price_type),
      expression: "optionInfo.price_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.optionInfo, "price_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("免稅價格")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("含稅價格")])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("(若無價格則無須更動)")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("熱量")]), _vm._v(" "), (_vm.state == 1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.calorie),
      expression: "optionInfo.calorie"
    }],
    ref: "calorie1",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.optionInfo.calorie)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityCalorie()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "calorie", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.state == 3) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.calorie),
      expression: "optionInfo.calorie"
    }],
    ref: "calorie3",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.optionInfo.calorie)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityCalorie()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "calorie", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("描述")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.description),
      expression: "optionInfo.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.optionInfo.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("備註")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.remark),
      expression: "optionInfo.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.optionInfo.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("POS廠自定義的ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.option_custom_id),
      expression: "optionInfo.option_custom_id"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.optionInfo.option_custom_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "option_custom_id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])]) : _vm._e()]), _vm._v(" "), (_vm.state != 3 || _vm.editState) ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.state == 1) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.checkInputEmpty()
      }
    }
  }, [_vm._v("新增")]) : _vm._e(), _vm._v(" "), (_vm.editState) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.checkInputEmpty()
      }
    }
  }, [_vm._v("編輯")]) : _vm._e()]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header text-left"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("提醒")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body text-left"
  }, [_c('p', [_vm._v("確定刪除此商品？")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("分類")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("選項名稱")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("排序")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("必選項目")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("常見價格")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("最低選擇項目個數")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("最高選擇項目個數")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("價格")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("價格類型")])
}]}

/***/ }),
/* 2304 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.oneArrows || _vm.manyArrows) ? _c('div', {
    staticClass: "vfc-separately-navigation-buttons",
    class: 'vfc-' + _vm.fConfigs.arrowsPosition
  }, [_c('div', {
    class: {
      'vfc-cursor-pointer': _vm.allowPreDate
    },
    on: {
      "click": function($event) {
        return _vm.$parent.PreMonth(_vm.oneArrows ? 0 : _vm.calendarKey)
      }
    }
  }, [_vm._t("navigationArrowLeft", function() {
    return [_c('div', {
      staticClass: "vfc-arrow-left",
      class: {
        'vfc-disabled': !_vm.allowPreDate
      }
    })]
  })], 2), _vm._v(" "), _c('div', {
    class: {
      'vfc-cursor-pointer': _vm.allowNextDate
    },
    on: {
      "click": function($event) {
        return _vm.$parent.NextMonth(_vm.oneArrows ? 0 : _vm.calendarKey)
      }
    }
  }, [_vm._t("navigationArrowRight", function() {
    return [_c('div', {
      staticClass: "vfc-arrow-right",
      class: {
        'vfc-disabled': !_vm.allowNextDate
      }
    })]
  })], 2)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2305 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-10"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n        返回抽成列表\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('select', {
    staticClass: "form-control h-38",
    staticStyle: {
      "max-width": "140px"
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("下訂時間")])]), _vm._v(" "), _c('div', {
    staticClass: "h-38 m-l-5 w-120"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.startDate,
      "enabled": _vm.isLoading,
      "option": _vm.dateoption,
      "limit": _vm.dateLimit
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "h-38 m-l-5 w-120"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.endDate,
      "enabled": _vm.isLoading,
      "option": _vm.dateoption,
      "limit": _vm.dateLimit
    }
  })], 1), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterType),
      expression: "filterType"
    }],
    staticClass: "form-control h-38 m-l-15",
    staticStyle: {
      "max-width": "140px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("訂單編號")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("訂單狀態")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("取餐類型")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 4
    }
  }, [_vm._v("付款類型")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group h-38"
  }, [(_vm.filterType === 1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderSN),
      expression: "orderSN"
    }],
    staticClass: "form-control h-38",
    staticStyle: {
      "min-width": "170px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.orderSN)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orderSN = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.filterType === 2) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelect),
      expression: "statusSelect"
    }],
    staticClass: "form-control h-38",
    staticStyle: {
      "min-width": "170px"
    },
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.statusSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.statusList), function(status) {
    return _c('option', {
      key: status.value,
      domProps: {
        "value": status.value
      }
    }, [_vm._v("\n                    " + _vm._s(status.label) + "\n                  ")])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.filterType === 3) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deTypeSelect),
      expression: "deTypeSelect"
    }],
    staticClass: "form-control h-38",
    staticStyle: {
      "min-width": "170px"
    },
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.deTypeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.deliveryTypeList), function(type) {
    return _c('option', {
      key: type.value,
      domProps: {
        "value": type.value
      }
    }, [_vm._v("\n                    " + _vm._s(type.label) + "\n                  ")])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.filterType === 4) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trTypeSelect),
      expression: "trTypeSelect"
    }],
    staticClass: "form-control h-38",
    staticStyle: {
      "min-width": "170px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.trTypeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.getTradeType), function(trade) {
    return _c('option', {
      key: trade.value,
      domProps: {
        "value": trade.value
      }
    }, [_vm._v("\n                    " + _vm._s(trade.label) + "\n                  ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": _vm.setQuery
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row form-inline m-t-10 flex align-end"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n                門市資訊服務費抽成原金額: $" + _vm._s(_vm.totalCommissionMoney) + "\n              ")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 m-b-10 text-right"
  }, [_c('button', {
    staticClass: "btn btn-default p-a-10",
    attrs: {
      "disabled": ""
    },
    on: {
      "click": _vm.exportFile
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }, [_vm._v("下載報表")]), _vm._v(" "), _c('Clip', {
    staticClass: "cliploading",
    attrs: {
      "loading": _vm.isDownloading,
      "color": '#528BB8',
      "size": '16px'
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(1), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(2)]) : (_vm.list.length === 0) ? _c('tbody', [_vm._m(3)]) : _c('tbody', _vm._l((_vm.list), function(row, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/orderInfo/' + row.order_id
        },
        "target": "_blank"
      }
    }, [_vm._v("\n                        " + _vm._s(row.order_sn) + "\n                      ")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.brand_name) + "(" + _vm._s(row.brand_id) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.store_name) + "(" + _vm._s(row.store_id) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("deliveryName")(row.delivery_type)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("tradeName")(row.trade_type)))]), _vm._v(" "), _c('td', [(row.src_type === 1 || row.src_type === 3) ? _c('span', {
      staticClass: "text-12 text-w-600 label-default",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("P")]) : _c('span', {
      staticClass: "text-12 text-w-600 label-warning",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("D")]), _vm._v(" "), (row.sub_src_type === 1) ? _c('span', {
      staticClass: "text-12 text-w-600 label-default",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("W")]) : (row.sub_src_type === 2) ? _c('span', {
      staticClass: "text-12 text-w-600 label-success",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("L")]) : (row.sub_src_type === 3) ? _c('span', {
      staticClass: "text-12 text-w-600 label-primary",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("M")]) : (row.sub_src_type === 4) ? _c('span', {
      staticClass: "text-12 text-w-600 label-success",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("LI")]) : (row.sub_src_type === 5) ? _c('span', {
      staticClass: "text-12 text-w-600 label-danger",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("J")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("orderStatusName")(row.order_status)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.order_time))]), _vm._v(" "), _c('td', [_vm._v("$ " + _vm._s(row.total_paid_money))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.commission_ratio) + "%")]), _vm._v(" "), _c('td', [_vm._v("$ " + _vm._s(row.total_finish_commission_money))]), _vm._v(" "), _c('td', [_vm._v("$ " + _vm._s(row.total_void_commission_money))]), _vm._v(" "), _c('td', [_vm._v("$ " + _vm._s(row.total_commission_money))])])
  }), 0)])]), _vm._v(" "), _c('paginate', {
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n                抽成金額為訂單實付金額 * 抽成 %；採四捨五入計算\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單編號")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("品牌 (ID)")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("分店 (ID)")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("取餐類型")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("付款類型")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單來源")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單狀態")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("下訂時間")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("實付金額")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("抽成％")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("已完成訂單資訊服務費抽成金額")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("已作廢訂單資訊服務費抽成金額")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("\n                      資訊服務費抽成金額\n                      "), _c('span', {
    staticClass: "tip-icon",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "已完成+已作廢訂單資訊服務費抽成金額"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "14"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "14"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
}]}

/***/ }),
/* 2306 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box-body form-center"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example2"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.giveCoupons.coupon_set_list), function(coupon, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(coupon.coupon_info.name) + "\n        ")]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          return _vm.changeCur(coupon, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info"
    })])])])
  }), 0)])]), _vm._v(" "), (_vm.curCoupon.coupon_info) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr', {
    staticClass: "box-body form-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body form-center"
  }, [_c('h4', [_vm._v(_vm._s(_vm.curCoupon.coupon_info.name))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("優惠券名稱(前台)")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.coupon_info.name))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("優惠券名稱(後台)")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.coupon_info.set_name))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("優惠券說明(前台)")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.coupon_info.description))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("優惠券說明(後台)")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.coupon_info.set_description))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("優惠券備註(前台)")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.coupon_info.remark))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("優惠券折扣金額")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.coupon_info.discount_value))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("一次發送張數")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.amount_unit))])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("優惠券稅制")]), _vm._v(" "), (_vm.curCoupon.coupon_info.price_type) ? _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.coupon_info.price_type.label))]) : _vm._e()]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("優惠券類型")]), _vm._v(" "), (_vm.curCoupon.usage_store_config.usage_store_type) ? _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.usage_store_config.usage_store_type.label))]) : _vm._e()]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("適用門市方式")]), _vm._v(" "), (_vm.curCoupon.usage_store_config.usage_method) ? _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.usage_store_config.usage_method.label))]) : _vm._e()]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curCoupon.usage_store_config.usage_method.value !== 'order_store'),
      expression: "curCoupon.usage_store_config.usage_method.value !== 'order_store'"
    }]
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("適用對象")]), _vm._v(" "), (_vm.curCoupon.usage_store_config.usage_store_value) ? _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.usage_store_config.usage_store_value.label))]) : _vm._e()]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.curCoupon.time_config.time_type) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("有效期間設定")]), _vm._v(" "), (_vm.curCoupon.time_config.time_type) ? _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.time_config.time_type.label))]) : _vm._e()]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.curCoupon.time_config.time_type.value === 'all_fixed') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("開始時間")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.time_config.time.start.time))])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.curCoupon.time_config.time_type.value === 'day_day' || _vm.curCoupon.time_config.time_type.value === 'day_fixed') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("拿到優惠券後幾天開始")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.time_config.use_start_day))])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.curCoupon.time_config.time_type.value === 'all_fixed' || _vm.curCoupon.time_config.time_type.value === 'day_fixed') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("結束時間")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.time_config.time.end.time))])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.curCoupon.time_config.time_type.value === 'day_day') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("開始後幾天結束")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.time_config.use_tolerance_day))])]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curCoupon.usage_store_config.usage_method.value === 'manual' && _vm.curCoupon.usage_store_config.usage_store_type.value !== 3),
      expression: "curCoupon.usage_store_config.usage_method.value === 'manual' && curCoupon.usage_store_config.usage_store_type.value !== 3"
    }],
    staticClass: "box-body form-center"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.addStoresSetting.choose), function(store) {
    return _c('label', {
      staticClass: "label-primary label m-r-5"
    }, [_vm._v(_vm._s(_vm.getStoreName(store)))])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('coupon-modal', {
    attrs: {
      "coupon": _vm.curCoupon
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("優惠券")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("優惠券可用店家")])
}]}

/***/ }),
/* 2307 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row m-b-15"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', {
    staticClass: "m-t-10"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.storeInfo), function(store, sIndex) {
    return _c('tr', [_c('td', [_vm._v("\n                      " + _vm._s(sIndex + 1) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(store.brand_name) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(store.store_name))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "is-enable-store pull-left m-r-5",
      class: [store.is_enable ? 'success' : 'danger'],
      staticStyle: {
        "top": "15px"
      }
    }), _vm._v(" "), _c('multiselect', {
      staticClass: "pull-left",
      staticStyle: {
        "width": "calc(100% - 30px)"
      },
      attrs: {
        "options": _vm.enableOption,
        "label": "label",
        "searchable": false,
        "allow-empty": false,
        "close-on-select": true,
        "placeholder": "啟用",
        "show-labels": false,
        "preselect-first": true
      },
      on: {
        "input": function($event) {
          return _vm.changeSelect(store)
        }
      },
      model: {
        value: (store.is_enable_obj),
        callback: function($$v) {
          _vm.$set(store, "is_enable_obj", $$v)
        },
        expression: "store.is_enable_obj"
      }
    })], 1)])
  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-fail",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n      取消\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.setData
    }
  }, [_vm._v("\n      確定\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("品牌")]), _vm._v(" "), _c('td', [_vm._v("店家")]), _vm._v(" "), _c('td', [_vm._v("活動啟用狀態")])])])
}]}

/***/ }),
/* 2308 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "chooseProd",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#searchProd"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.option.id,
      "role": "dialog"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeModal.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title text-left"
  }, [_vm._v(_vm._s(_vm.option.title))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body text-left"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "請輸入商品名稱"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-t-15 list-height"
  }, _vm._l((_vm.filterProductList), function(item, index) {
    return _c('div', {
      key: ("item-" + (index + 1)),
      staticClass: "form-check"
    }, [_c('label', {
      staticClass: "form-check-label m-y-0",
      attrs: {
        "for": ("check" + (index + 1))
      }
    }, [_vm._v(_vm._s(item.name) + " (" + _vm._s(item.vendor_custom_id) + ")")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.checked),
        expression: "item.checked"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox",
        "id": ("check" + (index + 1))
      },
      domProps: {
        "checked": Array.isArray(item.checked) ? _vm._i(item.checked, null) > -1 : (item.checked)
      },
      on: {
        "change": [function($event) {
          var $$a = item.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "checked", $$c)
          }
        }, function($event) {
          return _vm.checkSelect(item)
        }]
      }
    })])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.selectedProd
    }
  }, [_vm._v("\n            確定\n          ")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 2309 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.option.id,
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog choose-modal"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title text-left"
  }, [_vm._v(_vm._s(_vm.option.title) + "\n          "), _c('div', {
    staticClass: "input-group pull-right m-r-15",
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchLabel),
      expression: "searchLabel"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchLabel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchLabel = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body text-left"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_vm._l((_vm.filteredList), function(elem) {
    return (_vm.curId !== elem.item_id) ? _c('button', {
      staticClass: "btn btn-default btn-choose-element",
      class: {
        active: elem.active
      },
      on: {
        "click": function($event) {
          return _vm.clickElement(elem)
        },
        "mouseover": function($event) {
          return _vm.showRemark(elem)
        },
        "mouseleave": function($event) {
          return _vm.hideRemark()
        }
      }
    }, [_vm._v("\n            " + _vm._s(elem.name)), (_vm.showMoney) ? _c('span', [_vm._v("  $" + _vm._s(_vm.getPrice(elem.price)))]) : _vm._e(), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "text-remark-wrap"
    }, [_c('small', [_vm._v(" " + _vm._s(elem.remark) + " ")])])]) : _vm._e()
  }), _vm._v(" "), (!_vm.elementList.length) ? _c('p', {
    staticClass: "text-danger text-center"
  }, [_vm._v("無法" + _vm._s(_vm.option.title))]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.clearAll
    }
  }, [_vm._v("全取消")]), _vm._v(" "), (!_vm.hideCancel) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.trigger(_vm.option.event)
      }
    }
  }, [_vm._v("\n          確定\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])
}]}

/***/ }),
/* 2310 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.brandName && _vm.storeName) ? _c('h1', {
    staticStyle: {
      "position": "absolute",
      "top": "-39px",
      "font-size": "18px"
    },
    style: (_vm.$route.name === 'upProductDescription' ? 'left: 151px;' : _vm.$route.name === 'upProductAlias' ? 'left: 103px;' : 'left: 238px;')
  }, [_vm._v("\n    " + _vm._s(_vm.brandName) + " - " + _vm._s(_vm.storeName) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box text-center"
  }, [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-left max-800 m-b-10"
  }, [_vm._l((_vm.prod_list), function(prod, pIndex) {
    return _c('div', {
      staticClass: "form block border m-y-10",
      staticStyle: {
        "vertical-align": "top"
      }
    }, [(pIndex !== 0) ? _c('div', [_c('hr', {
      staticClass: "p-b-10"
    }), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "flex justify-between"
    }, [_c('div', {
      staticClass: "flex m-b-10"
    }, [_c('label', {
      class: ['btn btn-left', prod.type === 'choose' ? 'btn-primary' : 'btn-default'],
      attrs: {
        "for": ("choose" + pIndex)
      }
    }, [_vm._v("搜尋商品")]), _vm._v(" "), _c('label', {
      class: ['btn btn-right', prod.type === 'input' ? 'btn-primary' : 'btn-default'],
      attrs: {
        "for": ("input" + pIndex)
      }
    }, [_vm._v(_vm._s(!_vm.up ? '新增' : '編輯') + "商品")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }, {
        name: "model",
        rawName: "v-model",
        value: (prod.type),
        expression: "prod.type"
      }],
      attrs: {
        "type": "radio",
        "id": ("choose" + pIndex),
        "name": "type",
        "value": "choose"
      },
      domProps: {
        "checked": _vm._q(prod.type, "choose")
      },
      on: {
        "change": function($event) {
          return _vm.$set(prod, "type", "choose")
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }, {
        name: "model",
        rawName: "v-model",
        value: (prod.type),
        expression: "prod.type"
      }],
      attrs: {
        "type": "radio",
        "id": ("input" + pIndex),
        "name": "type",
        "value": "input"
      },
      domProps: {
        "checked": _vm._q(prod.type, "input")
      },
      on: {
        "change": function($event) {
          return _vm.$set(prod, "type", "input")
        }
      }
    })]), _vm._v(" "), (_vm.up) ? _c('div', {
      staticClass: "btn btn-danger m-b-10",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#delModal"
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : (pIndex !== 0) ? _c('div', {
      staticClass: "m-b-10 text-right"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.prod_list.splice(pIndex, 1)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v("商品名稱\n                    "), (_vm.tab === 10) ? _c('span', [_vm._v(" (分類)")]) : _vm._e()]), _vm._v(" "), (prod.type === 'input') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (prod.input.item.name),
        expression: "prod.input.item.name"
      }],
      staticClass: "form-control",
      staticStyle: {
        "height": "40px"
      },
      attrs: {
        "type": "text",
        "maxlength": "32"
      },
      domProps: {
        "value": (prod.input.item.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(prod.input.item, "name", $event.target.value)
        }
      }
    }) : _c('multiselect', {
      attrs: {
        "options": _vm.optionsList,
        "searchable": true,
        "allow-empty": true,
        "close-on-select": true,
        "placeholder": "請輸入商品名稱",
        "show-labels": true,
        "multiple": false,
        "label": "name",
        "track-by": "id"
      },
      on: {
        "input": function($event) {
          return _vm.checkVenderId(prod)
        }
      },
      scopedSlots: _vm._u([{
        key: "option",
        fn: function(props) {
          return [_c('span', [_vm._v(_vm._s(props.option.name))]), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(props.option.id) + ")")])]
        }
      }], null, true),
      model: {
        value: (prod.choose.item),
        callback: function($$v) {
          _vm.$set(prod.choose, "item", $$v)
        },
        expression: "prod.choose.item"
      }
    })], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', [_c('div', {
      staticClass: "input-group has-feedback max-800"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v("商品料號\n                    "), (_vm.tab === 10) ? _c('span', [_vm._v(" (分類)")]) : _vm._e()]), _vm._v(" "), (prod.type === 'input') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (prod.input.item.id),
        expression: "prod.input.item.id"
      }],
      staticClass: "form-control",
      staticStyle: {
        "height": "40px"
      },
      attrs: {
        "placeholder": "",
        "type": "text",
        "maxlength": "32"
      },
      domProps: {
        "value": (prod.input.item.id)
      },
      on: {
        "focusout": function($event) {
          return _vm.checkVenderId(prod)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(prod.input.item, "id", $event.target.value)
        }
      }
    }) : _c('multiselect', {
      attrs: {
        "options": _vm.optionsList,
        "searchable": true,
        "allow-empty": true,
        "close-on-select": true,
        "placeholder": "請輸入商品料號",
        "show-labels": true,
        "multiple": false,
        "label": "id",
        "track-by": "id"
      },
      on: {
        "input": function($event) {
          return _vm.checkVenderId(prod)
        }
      },
      scopedSlots: _vm._u([{
        key: "option",
        fn: function(props) {
          return [_c('span', [_vm._v(_vm._s(props.option.name))]), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(props.option.id) + ")")])]
        }
      }], null, true),
      model: {
        value: (prod.choose.item),
        callback: function($$v) {
          _vm.$set(prod.choose, "item", $$v)
        },
        expression: "prod.choose.item"
      }
    }), _vm._v(" "), (!_vm.up) ? _c('span', {
      staticClass: "sr-only",
      attrs: {
        "id": "inputIconStatus"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('br')])]), _vm._v(" "), (_vm.$route.name === 'upProductAlias' || !_vm.up) ? _c('div', [_c('div', {
      staticClass: "input-group max-800"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [(_vm.up) ? _c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]) : _vm._e(), _vm._v("別名\n                  "), (_vm.tab === 10) ? _c('span', [_vm._v(" (分類)")]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (prod.alias_name),
        expression: "prod.alias_name"
      }],
      staticClass: "form-control",
      staticStyle: {
        "height": "40px"
      },
      attrs: {
        "placeholder": "",
        "type": "text",
        "maxlength": "70"
      },
      domProps: {
        "value": (prod.alias_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(prod, "alias_name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'upProductDescription' || !_vm.up) ? _c('div', _vm._l((prod.prod_description_list), function(prodDes, dIndex) {
      return _c('div', {
        staticClass: "input-group m-b-10 max-800",
        staticStyle: {
          "margin-bottom": "10px"
        }
      }, [_c('span', {
        staticClass: "input-group-addon"
      }, [_vm._v("\n                  描述\n                  "), (_vm.tab === 10) ? _c('span', [_vm._v(" (分類)")]) : _vm._e(), _vm._v("\n                  （上限 500 字）\n                ")]), _vm._v(" "), _c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (prodDes.prod_description),
          expression: "prodDes.prod_description"
        }],
        staticClass: "form-control h-200",
        attrs: {
          "rows": "3",
          "placeholder": "",
          "type": "text",
          "maxlength": "500"
        },
        domProps: {
          "value": (prodDes.prod_description)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(prodDes, "prod_description", $event.target.value)
          }
        }
      }), _vm._v(" "), (dIndex === 0) ? _c('span', {
        staticClass: "c-pointer input-group-addon",
        on: {
          "click": function($event) {
            return prod.prod_description_list.push({
              prod_description: ''
            })
          }
        }
      }, [_vm._v("\n                  +\n                ")]) : _c('span', {
        staticClass: "c-pointer input-group-addon",
        on: {
          "click": function($event) {
            return prod.prod_description_list.splice(dIndex, 1)
          }
        }
      }, [_vm._v("\n                  -\n                ")])])
    }), 0) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$route.name === 'upProductDescription' || !_vm.up) ? _c('div', _vm._l((prod.prod_warning_list), function(prodDes, dIndex) {
      return _c('div', {
        staticClass: "input-group max-800",
        staticStyle: {
          "margin-bottom": "10px"
        }
      }, [_c('span', {
        staticClass: "input-group-addon"
      }, [_c('div', {
        staticClass: "warning"
      }, [_vm._v("\n                    警語\n                    "), (_vm.tab === 10) ? _c('span', [_vm._v(" (分類)")]) : _vm._e(), _vm._v("\n                    （上限 200 字）\n                  ")])]), _vm._v(" "), _c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (prodDes.prod_warning),
          expression: "prodDes.prod_warning"
        }],
        staticClass: "form-control h-200",
        attrs: {
          "rows": "3",
          "placeholder": "",
          "type": "text",
          "maxlength": "200"
        },
        domProps: {
          "value": (prodDes.prod_warning)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(prodDes, "prod_warning", $event.target.value)
          }
        }
      }), _vm._v(" "), (dIndex === 0) ? _c('span', {
        staticClass: "c-pointer input-group-addon",
        on: {
          "click": function($event) {
            return prod.prod_warning_list.push({
              prod_warning: ''
            })
          }
        }
      }, [_vm._v("\n                  +\n                ")]) : _c('span', {
        staticClass: "c-pointer input-group-addon",
        on: {
          "click": function($event) {
            return prod.prod_warning_list.splice(dIndex, 1)
          }
        }
      }, [_vm._v("\n                  -\n                ")])])
    }), 0) : _vm._e(), _vm._v(" "), _c('br')])
  }), _vm._v(" "), (_vm.add_prod) ? _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.prod_list.push(JSON.parse(JSON.stringify(_vm.emptyProd)))
      }
    }
  }, [_vm._v("\n              ＋新增設定\n            ")])]) : _vm._e(), _vm._v(" "), _c('br')], 2), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-fail text-black",
    on: {
      "click": _vm.goToBack
    }
  }, [_vm._v("\n            返回\n          ")]), _vm._v(" "), (!_vm.up) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkSetting()
      }
    }
  }, [_vm._v("\n            新增\n          ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkSetting()
      }
    }
  }, [_vm._v("\n            更新\n          ")])])])])]), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "max-800 text-left"
  }, [_c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 相同料號的商品會一併新增、修改")])])
}]}

/***/ }),
/* 2311 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('line-notify-table')], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('store-notify-table')], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("通知方式綁定列表")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("門市綁定列表")])])
}]}

/***/ }),
/* 2312 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [(!_vm.isOffline) ? _c('div', {
    staticClass: "box-header text-center hidden-xs"
  }, [_c('div', {
    staticClass: "process-elem",
    attrs: {
      "id": "process-1"
    }
  }, [_vm._v("\n            建立 "), _c('div', {
    staticClass: "p-t-50"
  }, [_vm._v(_vm._s(_vm.orderList.create_time))])]), _vm._v(" "), _c('div', {
    staticClass: "process-elem",
    attrs: {
      "id": "process-2"
    }
  }, [_vm._v("\n            下訂 "), _c('div', {
    staticClass: "p-t-50"
  }, [_vm._v(_vm._s(_vm.orderList.order_time))])]), _vm._v(" "), _c('div', {
    staticClass: "process-elem",
    attrs: {
      "id": "process-3"
    }
  }, [_c('span', {
    class: {
      'text-worning': !_vm.orderList.settle_time && _vm.orderList.invoice_issue_time
    }
  }, [_vm._v("結帳")]), _vm._v(" "), _c('div', {
    staticClass: "p-t-50"
  }, [_vm._v(_vm._s(_vm.orderList.settle_time))])]), _vm._v(" "), _c('div', {
    staticClass: "process-elem",
    attrs: {
      "id": "process-4"
    }
  }, [_c('span', {
    class: {
      'text-worning': _vm.orderList.settle_time && !_vm.orderList.invoice_issue_time
    }
  }, [_vm._v("開立發票")]), _vm._v(" "), _c('div', {
    staticClass: "p-t-50"
  }, [_vm._v(_vm._s(_vm.orderList.invoice_issue_time))])]), _vm._v(" "), _c('div', {
    staticClass: "progress-block"
  }, [_c('div', {
    staticClass: "progress"
  }, [(_vm.orderList.invoice_issue_time) ? _c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }) : (_vm.orderList.settle_time) ? _c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "calc(100% / 3 * 2)"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }) : _c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "calc(100% / 3)"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left p-l-10 p-r-10-p"
  }, [_c('br'), _vm._v(" "), (!_vm.isOffline) ? _c('div', [_vm._m(0), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.orderList.allowance && _vm.orderList.allowance.length) ? _c('div', [_vm._m(1), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getCouponList.length) ? _c('div', [_vm._m(2), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getPointList.length || _vm.getMembershipScore.length) ? _c('div', [_vm._m(3), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                " + _vm._s(_vm.isGuest ? 'POS機' : '') + "訂單編號\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.isGuest ? _vm.orderList.pos_order_sn : _vm.orderList.order_sn || '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), (!_vm.isGuest) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                訂單ID\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.order_id ? _vm.orderList.order_id : '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                訂單狀態\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('div', {
    staticClass: "status-light inline-block",
    class: _vm.orderStateColor(_vm.orderList.status)
  }), _vm._v(" "), _c('div', {
    staticClass: "inline-block",
    staticStyle: {
      "line-height": "23px"
    }
  }, [_vm._v(" " + _vm._s(_vm.orderState(_vm.orderList.status)) + "(" + _vm._s(_vm.orderList.status) + ") ")]), _vm._v(" "), (_vm.roleType === 99 && !_vm.isOffline) ? _c('button', {
    staticClass: "btn btn-danger m-r-5 m-y-5",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#editOrderStateModal"
    }
  }, [_vm._v("\n                  修改訂單狀態\n                ")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                訂購者"), (_vm.isGuest) ? _c('span', [_vm._v("姓名")]) : (_vm.roleType === 99) ? _c('span', [_vm._v("(ID)")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info",
    class: {
      'text-red': _vm.orderList.shopper_black_info
    }
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.name ? _vm.orderList.name : '無資料')), (_vm.roleType === 99 && !_vm.isGuest) ? _c('span', [_vm._v("(" + _vm._s(_vm.orderList.shopper_id) + ")")]) : _vm._e(), _vm._v("  \n                "), (!_vm.isGuest) ? [_c('i', {
    staticClass: "fa c-pointer text-25",
    class: [_vm.orderList.shopper_black_info ? 'fa-frown-o' : 'fa-smile-o text-yellow'],
    staticStyle: {
      "top": "2.5px"
    },
    attrs: {
      "aria-hidden": "true",
      "data-toggle": "modal",
      "data-target": "#openModal"
    }
  })] : _vm._e(), _vm._v("\n                  \n                "), _c('router-link', {
    attrs: {
      "to": {
        path: '/memberOrderTable/' + _vm.orderList.shopper_id
      },
      "target": "_blank"
    }
  }, [((_vm.roleType === 99 || _vm.roleType === 30) && _vm.checkMemberShow(_vm.orderList.status)) ? _c('i', {
    staticClass: "fa fa-list-alt c-pointer text-primary text-25",
    staticStyle: {
      "top": "3.5px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])], 2)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                訂購者電話\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.phone ? _vm.orderList.phone : '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), (!_vm.isOffline) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                預定取餐時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.orderList.order_method === 2) ? _c('span', {
    staticClass: "label label-success",
    staticStyle: {
      "line-height": "25px"
    }
  }, [_vm._v("預")]) : _vm._e(), _vm._v("\n                " + _vm._s(_vm.orderList.delivery_reserv_time ? _vm.orderList.delivery_reserv_time : '無資料')), (_vm.orderList.delivery_reserv_tolerance) ? _c('span', [_vm._v(" ~ " + _vm._s(_vm.reservEndTime ? _vm.reservEndTime : '無資料'))]) : _vm._e()])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                取餐類型\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm._f("deliveryName")(_vm.orderList.delivery_type)) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.orderList.delivery_type === 21) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                桌號\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.table_no || '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.orderList.order_special_item_setting && Array.isArray(_vm.orderList.order_special_item_setting) && _vm.orderList.order_special_item_setting[0]) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                特殊需求\n              ")]), _vm._v(" "), (_vm.orderList.order_special_item_setting[0].value) ? _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.order_special_item_setting[0].turn_on_text) + "\n              ")]) : (!_vm.orderList.order_special_item_setting[0].value) ? _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.order_special_item_setting[0].turn_off_text) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.orderList.src_type && !_vm.isOffline) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                訂單來源\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderSource(_vm.orderList.src_type) ? _vm.orderSource(_vm.orderList.src_type) : '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.orderList.sub_src_type && !_vm.isOffline) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                訂單瀏覽器來源\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.subSrcType ? _vm.subSrcType : '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.orderList.delivery_type == 3 && !_vm.isOffline) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                外送地址\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.getShortAddress(_vm.orderList.address)
    }
  }, [_vm._v(_vm._s(_vm.orderList.address))])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.orderList.delivery_type == 3 && !_vm.isOffline) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                預估與店家距離\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.distance / 1000) + " 公里\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (!_vm.isOffline) ? _c('div', [_vm._m(4), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.orderList.notify_history && _vm.orderList.notify_history.length) ? _c('div', [_vm._m(5), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn-block"
  }, [(!_vm.orderList.shopper_black_info && !_vm.isGuest) ? _c('div', {
    staticClass: "input-group"
  }, [_c('button', {
    staticClass: "btn btn-danger m-r-5 m-y-5",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#blackModal"
    }
  }, [_vm._v("\n                標記黑名單\n              ")]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.orderList.shopper_black_info) ? _c('div', [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon bg-red",
    staticStyle: {
      "border": "1px solid #dd4b39"
    }
  }, [_vm._v("\n                    黑名單原因\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                    " + _vm._s(_vm.getBReasonText(_vm.orderList.shopper_black_info.reason_type_id)) + "\n                  ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon bg-red",
    staticStyle: {
      "border": "1px solid #dd4b39"
    }
  }, [_vm._v("\n                    黑名單狀態\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                    " + _vm._s(_vm.getBStatusText(_vm.orderList.shopper_black_info.status)) + "\n                  ")])]), _vm._v(" "), _c('br')])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right p-l-0"
  }, [_vm._m(6), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("品牌名稱(ID)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.brand_name) + "(" + _vm._s(_vm.orderList.brand_id) + ")\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("分店(ID)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": 'https://order.nidin.shop/menu/' + _vm.orderList.store_id
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderList.store_name) + "(" + _vm._s(_vm.orderList.store_id) + ")\n                ")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "visible-xs-block"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                下訂時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.order_time ? _vm.orderList.order_time : '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                付款狀態\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.payStateName(_vm.orderList.payment_status) ? _vm.payStateName(_vm.orderList.payment_status) : '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                總份數\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.total_amount) + " 份\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                金額計算\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('p', {
    staticClass: "text-pay-list m-y-5 c-pointer"
  }, [_vm._v("\n                   商品 x " + _vm._s(_vm.orderList.total_amount) + "\n                  "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(" ＄" + _vm._s(_vm.orderList.total_money))])]), _vm._v(" "), (_vm.orderList.shipping_money) ? _c('p', {
    staticClass: "text-pay-list m-y-5"
  }, [_vm._v("\n                   運費\n                  "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(" ＄" + _vm._s(_vm.orderList.shipping_money))])]) : _vm._e(), _vm._v(" "), (_vm.orderList.service_money) ? _c('p', {
    staticClass: "text-pay-list m-y-5"
  }, [_vm._v("\n                   服務費\n                  "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("＄" + _vm._s(_vm.orderList.service_money))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.orderList.payment_list), function(payment) {
    return (payment.method === 5 || payment.method === 31 || payment.method === 41) ? _c('p', {
      staticClass: "text-pay-list m-y-5"
    }, [_vm._v("\n                   " + _vm._s(payment.method === 31 ? '優惠券' : payment.method === 41 ? '電子票券' : payment.name) + "\n                  "), (payment.method === 31 || payment.method === 41) ? _c('button', {
      staticClass: "btn btn-default btn-sm m-l-5",
      on: {
        "click": function($event) {
          payment.method === 31 ? _vm.showCouponModal = true : _vm.showVoucherModal = true
        }
      }
    }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "pull-right text-red"
    }, [_vm._v("- ＄" + _vm._s(payment.money))])]) : _vm._e()
  }), _vm._v(" "), (_vm.isOffline && _vm.combineCouponList.length) ? _c('p', {
    staticClass: "text-pay-list m-y-5"
  }, [_vm._v("\n                   優惠券\n                  "), _c('button', {
    staticClass: "btn btn-default btn-sm m-l-5",
    on: {
      "click": function($event) {
        _vm.showOfflineCouponModal = true
      }
    }
  }, [_vm._v("查看")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-red"
  }, [_vm._v("- ＄" + _vm._s(_vm.totalOfflineCouponMoney))])]) : _vm._e(), _vm._v(" "), (_vm.isOffline && _vm.combineVoucherList.length) ? _c('p', {
    staticClass: "text-pay-list m-y-5"
  }, [_vm._v("\n                   電子票券\n                  "), _c('button', {
    staticClass: "btn btn-default btn-sm m-l-5",
    on: {
      "click": function($event) {
        _vm.showOfflineVoucherModal = true
      }
    }
  }, [_vm._v("查看")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-red"
  }, [_vm._v("- ＄" + _vm._s(_vm.totalOfflineVoucherMoney))])]) : _vm._e(), _vm._v(" "), (_vm.orderList.discount && _vm.orderList.discount.total_discount) ? _c('p', {
    staticClass: "text-pay-list m-y-5"
  }, [_vm._v("\n                   店家優惠\n                  "), _c('button', {
    staticClass: "btn btn-default btn-sm m-l-5",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#discountDetailModal"
    }
  }, [_vm._v("查看")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-red"
  }, [_vm._v("- ＄" + _vm._s(_vm.orderList.discount.total_discount))])]) : _vm._e(), _vm._v(" "), (_vm.orderList.point && _vm.orderList.point.payment && _vm.orderList.point.payment.total_money) ? _c('p', {
    staticClass: "text-pay-list m-y-5"
  }) : _vm._e(), _vm._l((_vm.orderList.point ? _vm.orderList.point.payment.list : []), function(p, index) {
    return _c('div', {
      key: index
    }, [_vm._v("\n                   點數\n                  "), _c('span', {
      staticClass: "pull-right text-red"
    }, [_vm._v("- ＄" + _vm._s(_vm.orderList.point.payment.total_money))])])
  }), _vm._v(" "), (_vm.orderList.point && _vm.orderList.point.payment && _vm.orderList.point.payment.list && _vm.orderList.point.payment.list.length === 0) ? _c('div', [_vm._v("\n                   點數\n                  "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("- ＄0")])]) : _vm._e(), _vm._v(" "), _c('p'), _vm._v(" "), _vm._l((_vm.orderList.payment_list), function(payment) {
    return (payment.method === 6) ? _c('p', {
      staticClass: "text-pay-list m-y-5"
    }, [_vm._v("\n                   自備飲料杯折扣 x " + _vm._s(payment.total_cup_amount) + "\n                  "), _c('span', {
      staticClass: "pull-right text-red"
    }, [_vm._v("- ＄" + _vm._s(payment.money))])]) : _vm._e()
  }), _vm._v(" "), (_vm.orderList.membership_discount) ? _c('p', {
    staticClass: "text-pay-list m-y-5"
  }) : _vm._e(), _vm._l((_vm.membershipDiscount), function(m, index) {
    return _c('div', {
      key: index
    }, [_vm._v("\n                   " + _vm._s(_vm._f("discountText")(_vm.memberCardDiscount, true)) + "\n                  "), _c('span', {
      staticClass: "pull-right text-red"
    }, [_vm._v("- ＄" + _vm._s(m.total_discount))])])
  }), _vm._v(" "), _c('p')], 2)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                總金額\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.total_paid_money) + " 元\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                付款類型\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.tradeType(_vm.orderList.trade_type) ? _vm.tradeType(_vm.orderList.trade_type) : '無資料') + " \n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.roleType === 99 && _vm.showTradeInfo) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                交易明細資訊\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-target": "#refundModal",
      "data-toggle": "modal"
    },
    on: {
      "click": _vm.getTradeInfo
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 詳細內容\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.orderList.shopper_remark) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                購物者備註\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.shopper_remark || '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.orderList.store_memo) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                店家備註\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.store_memo || '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.orderList.store_remark) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                店家備註\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.store_remark || '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.orderList.store_memo) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                店家訂單備註\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.store_memo || '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.orderList.settle_time) ? _c('div', {
    staticClass: "visible-xs-block"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                結帳時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.settle_time) + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.orderList.invoice_type) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                發票類型\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.invoiceType(_vm.orderList.invoice_type, _vm.orderList.email)) + " \n                "), (_vm.orderList.email) ? _c('span', [_vm._v(_vm._s(_vm.orderList.email))]) : _vm._e(), _vm._v(" "), (_vm.orderList.invoice_type === 20) ? _c('span', [_vm._v(_vm._s(_vm.orderList.invoice_carrier_id))]) : (_vm.orderList.invoice_type === 30) ? _c('span', [_vm._v(_vm._s(_vm.orderList.invoice_npoban_name) + " (" + _vm._s(_vm.orderList.invoice_npoban) + ")")]) : _vm._e()])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (!_vm.isGuest) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                發票號碼\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.invoice_no ? _vm.orderList.invoice_no : '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.orderList.invoice_issue_time) ? _c('div', {
    staticClass: "visible-xs-block"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                開立發票時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.invoice_issue_time) + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (!_vm.isGuest && !_vm.isOffline) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                統一編號\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.ein || '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                更新時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.update_time ? _vm.orderList.update_time : '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), (!_vm.isGuest) ? _c('div', {
    staticClass: "visible-xs-block"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                建立時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.create_time ? _vm.orderList.create_time : '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (!_vm.isGuest) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                POS機訂單編號\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.pos_order_sn ? _vm.orderList.pos_order_sn : '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                收銀機(櫃檯代號)\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.pos_cashier_no ? _vm.orderList.pos_cashier_no : '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                POS機當日交易序號\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.pos_order_no ? _vm.orderList.pos_order_no : '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), (!_vm.isGuest) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                POS機取餐號碼\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.pos_take_no ? _vm.orderList.pos_take_no : '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99 && (_vm.orderList.status == 3 || _vm.orderList.status == 100 || _vm.orderList.status == 2 || _vm.orderList.status == 1 || _vm.orderList.status == 100 || _vm.orderList.status == 110 || _vm.orderList.status == 120 || _vm.orderList.status == 122 || _vm.orderList.status == 130 || _vm.orderList.status == 140)) ? _c('div', {
    staticClass: "btn-block"
  }, [_c('div', {
    staticClass: "input-group"
  }, [(_vm.orderList.status == 3 || _vm.orderList.status == 100) ? _c('button', {
    staticClass: "btn btn-danger m-r-5 m-y-5",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#resendOrderNotifyModal"
    }
  }, [_vm._v("\n                重新發送通知給店家\n              ")]) : _vm._e(), _vm._v(" "), (_vm.orderList.status == 2 || _vm.orderList.status == 3) ? _c('button', {
    staticClass: "btn btn-danger m-r-5 m-y-5",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#refundOrderModal"
    }
  }, [_vm._v("\n                訂單退款\n              ")]) : _vm._e(), _vm._v(" "), (_vm.orderList.status == 1 || _vm.orderList.status == 2 || _vm.orderList.status == 3) ? _c('button', {
    staticClass: "btn btn-danger m-r-5 m-y-5",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#cancelShopperOrderModal"
    }
  }, [_vm._v("\n                取消訂購者訂單\n              ")]) : _vm._e(), _vm._v(" "), _c('br')])]) : _vm._e()]), _vm._v(" "), (_vm.bindingShipping) ? _c('div', {
    staticClass: "box-body form-center text-center"
  }, [_c('hr')]) : _vm._e(), _vm._v(" "), (_vm.bindingShipping) ? _c('div', {
    staticClass: "box-body form-left p-l-10 p-r-10-p"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                報價狀態\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('div', {
    staticClass: "inline-block",
    staticStyle: {
      "line-height": "23px"
    }
  }, [_vm._v(" " + _vm._s(_vm.quotedState(_vm.bindingShipping.quoted_status)) + "(" + _vm._s(_vm.bindingShipping.quoted_status) + ") ")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.bindingShipping.status_reason) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                叫件失敗原因\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('div', {
    staticClass: "inline-block",
    staticStyle: {
      "line-height": "23px"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.bindingShipping.status_reason) + "\n                ")])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                預計取件時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.bindingShipping.expected_get_time) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                預計送達時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.bindingShipping.expected_arrived_time) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.bindingShipping.advance_money) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                代收貨款費\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.bindingShipping.advance_money) + " 元\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.bindingShipping.vendor_fee_remark) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                手續費\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.bindingShipping.vendor_fee_remark) + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.bindingShipping) ? _c('div', {
    staticClass: "box-body form-right p-l-0"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                物流業者\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm._f("shippingVendorName")(_vm.bindingShipping.vendor_code)) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                物流預估距離\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.bindingShipping.distance) + " 公尺\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.bindingShipping.weight) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                物流預估重量\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.bindingShipping.weight) + " 公克\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.bindingShipping.vendor_code && _vm.bindingShipping.vendor_code == 'glo') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                預估運費報價\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.bindingShipping.total_fee) + " 元\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.bindingShipping.vendor_code && _vm.bindingShipping.vendor_code.includes('mete')) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                預估外送員運費\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.bindingShipping.total_fee) + " 元 / 位\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.bindingShipping.vendor_quoted_no) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                物流報價單號\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.bindingShipping.vendor_quoted_no) + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.bindingShipping.driver_amount) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                外送員人數\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.bindingShipping.driver_amount) + " 位\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.bindingShipping.remark) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                叫件備註\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.bindingShipping.remark) + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.bindingShipping && _vm.bindingShipping.status >= 100 && _vm.bindingShipping.vendor_code != 'glo') ? _c('div', {
    staticClass: "col-xs-12 hint"
  }, [_vm._v("\n          系統將會優先媒合外送員1，若其餘外送員長時間顯示無資料，請聯絡物流客服。\n        ")]) : _vm._e(), _vm._v(" "), (_vm.bindingShipping) ? _c('div', {
    staticClass: "w-100 box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable no-footer"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', [(_vm.bindingShipping.status < 100) ? _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("尚未叫件")])]) : _vm._l((_vm.shippingCaseList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v("外送員" + _vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.driver_name || '-')), (item.driver_code) ? _c('span', [_vm._v("(" + _vm._s(item.driver_code) + ")")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.driver_phone || '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.delivery_platform_name || '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.customer_order_no || '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.actual_get_time || '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.actual_arrived_time || '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.total_fee || '-'))]), _vm._v(" "), _c('td', [_c('label', {
      staticClass: "label",
      class: _vm.shippingStateColor(item.status)
    }, [_vm._v(_vm._s(_vm._f("shippingStatusName")(item.status)))])]), _vm._v(" "), _c('td', [(item.customer_order_no) ? _c('a', {
      attrs: {
        "data-target": "#driverTimeModal",
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          _vm.driverTimeDialog = item
        }
      }
    }, [_vm._v("查看時間狀態")]) : _c('span', [_vm._v("-")])])])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.ratingList.length) ? _c('div', {
    staticClass: "box-body form-center text-center"
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(8), _vm._v(" "), (_vm.ratingList) ? _c('tbody', _vm._l((_vm.ratingList), function(rating, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [(rating.is_main) ? _c('span', {
      staticClass: "text-danger text-bold"
    }, [_c('i', {
      staticClass: "fa fa-fire",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" 最新")]) : _vm._e()]), _vm._v(" "), _c('td', {
      class: rating.star > 3 ? 'text-success' : 'text-danger'
    }, [_c('i', {
      staticClass: "fa fa-star",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(rating.star))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(rating.comment))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(rating.reply_comment))]), _vm._v(" "), _c('td', [(rating.is_main) ? _c('button', {
      staticClass: "btn btn-default",
      class: {
        'btn-success': !rating.is_replied
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#ratingModal"
      },
      on: {
        "click": function($event) {
          return _vm.openModal(rating)
        }
      }
    }, [(rating.is_replied) ? _c('span', [_vm._v("修改")]) : _c('span', [_vm._v("回覆")]), _vm._v("評價\n                    ")]) : _vm._e()])])
  }), 0) : _vm._e()])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "openModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("會員暱稱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [(_vm.orderList.shopper_black_info) ? _c('span', [_c('label', {
    staticClass: "label label-danger"
  }, [_vm._v("黑名單")]), _vm._v(" ")]) : _vm._e(), _vm._v("\n                  " + _vm._s(_vm.orderList.shopper_nickname) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("會員手機")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.orderList.shopper_phone))])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.roleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("會員信箱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.orderList.shopper_email))])]), _vm._v(" "), _c('br')]) : _vm._e()])])])])]), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.blackOption,
      "selectOptions": _vm.bSelectOptions
    },
    on: {
      "trigger": _vm.trigger,
      "selectOnChange": _vm.changeBlackReason
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.resendOrderNotifyOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.refundOrderOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.cancelShopperOrderOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.cancelPosOrderOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.editOrderStateOption,
      "selectOptions": _vm.selectOptions
    },
    on: {
      "trigger": _vm.trigger,
      "selectOnChange": _vm.selectOnChange,
      "inputOnChange": _vm.inputOnChange
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.forceRefundOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "discountDetailModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(11), _vm._v(" "), (_vm.orderList.discount) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "sorting_1 v-middle text-left bg-dark-gray text-white",
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_vm._v("\n                          -$" + _vm._s(_vm.orderList.discount.total_discount) + "\n                        ")])])]), _vm._v(" "), _vm._l((_vm.orderList.discount.list), function(discount, i) {
    return _c('tr', {
      key: ("product-" + i),
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1 v-middle text-center"
    }, [_vm._v("\n                        " + _vm._s(i + 1) + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "v-middle"
    }, [(discount.activity_name) ? _c('div', [_vm._v("\n                          ◎活動名稱：" + _vm._s(discount.activity_name) + "\n                        ")]) : _vm._e(), _vm._v(" "), (discount.start_date && discount.end_date) ? _c('div', [_vm._v("\n                          ◎活動時間：" + _vm._s(discount.start_date) + " ~ " + _vm._s(discount.end_date) + "\n                        ")]) : _vm._e(), _vm._v(" "), (discount.activity_description) ? _c('div', [_vm._v("\n                          ◎活動說明：" + _vm._s(discount.activity_description) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("\n                          ◎折扣碼：" + _vm._s(discount.exchange_code || '無') + "\n                        ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("-$" + _vm._s(discount.total_discount))])])
  })], 2)])])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "orderDetailModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "flex justify-end"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "sorting_1 v-middle text-left bg-dark-gray text-white",
    attrs: {
      "colspan": _vm.productCouponList.length || _vm.productVoucherList.length ? 4 : 3
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.orderList.name) + "\n                        "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("\n                          ＄" + _vm._s(_vm.orderList.money) + "\n                          "), (_vm.productCouponList.length || _vm.productVoucherList.length) ? _c('span', {
    staticClass: "c-pointer",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#couponModal"
    },
    on: {
      "click": function($event) {
        _vm.info = _vm.orderList;
        _vm.showCouponVoucherModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ticket text-red",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()])])]), _vm._v(" "), _vm._l((_vm.productList), function(p, i) {
    return _c('tr', {
      key: ("product-" + i),
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1 v-middle text-center"
    }, [_vm._v("\n                        " + _vm._s(i + 1) + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "flex row"
    }, [_c('div', [_c('h4', [_vm._v("\n                            " + _vm._s(p.product) + " - ＄" + _vm._s(p.total_money / p.amount) + "\n                          ")]), _vm._v(" "), _c('p', {
      staticClass: "product-option"
    }, [_vm._l((p.option_list), function(option, j) {
      return (p.type === 1) ? _c('span', {
        key: ("option-" + j)
      }, [_vm._v("\n                              " + _vm._s(option) + "\n                              "), (j < p.option_list.length - 1) ? _c('span', [_vm._v(" / ")]) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), _vm._l((p.product_list), function(pList, k) {
      return (p.type === 3) ? _c('span', {
        key: ("pList-" + k)
      }, _vm._l((pList), function(prod, l) {
        return _c('span', {
          key: ("prod-" + l)
        }, [_c('span', [_vm._v("\n                                  " + _vm._s(prod.product) + "\n                                ")]), _vm._v(" "), (prod.amount > 1) ? _c('span', [_vm._v("\n                                  x" + _vm._s(prod.amount) + "\n                                ")]) : _vm._e(), _vm._v(" "), _vm._l((prod.option_list), function(opt, m) {
          return (prod.type === 1) ? _c('span', {
            key: ("opt-" + m)
          }, [(m === 0) ? _c('span', [_vm._v("：")]) : _vm._e(), _vm._v("\n                                  " + _vm._s(opt) + "\n                                  "), (m < prod.option_list.length - 1) ? _c('span', [_vm._v(" / ")]) : _vm._e()]) : _vm._e()
        }), _vm._v(" "), _c('br')], 2)
      }), 0) : _vm._e()
    })], 2), _vm._v(" "), (p.cup_amount) ? _c('p', {
      staticClass: "flex"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(137)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "product-option p-l-5"
    }, [_vm._v("自備飲料杯 x" + _vm._s(p.cup_amount))])]) : _vm._e(), _vm._v(" "), (p.sticker_name) ? _c('p', [_c('span', [_c('i', {
      staticClass: "fa fa-user",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                              " + _vm._s(p.sticker_name) + "\n                            ")])]) : _vm._e(), _vm._v(" "), (p.custom_remark) ? _c('p', [_c('i', {
      staticClass: "fa fa-quote-left",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                            " + _vm._s(p.custom_remark) + "\n                          ")]) : _vm._e()]), _vm._v(" "), (p.amount) ? _c('div', {
      staticClass: "m-l-auto"
    }, [_c('h4', {
      staticClass: "text-right text-bold text-nowrap"
    }, [_vm._v("x " + _vm._s(p.amount))])]) : _vm._e()]), _vm._v(" "), (!_vm.productCouponList.length || !_vm.productVoucherList.length) ? _c('td', [_c('h4', {
      staticClass: "text-right text-bold text-nowrap"
    }, [_vm._v("$" + _vm._s(p.total_money))])]) : _vm._e(), _vm._v(" "), (_vm.productCouponList.length || _vm.productVoucherList.length) ? _c('td', [_c('h4', {
      staticClass: "text-right text-bold"
    }, [_vm._v("$" + _vm._s(p.total_money))]), _vm._v(" "), (_vm.productCouponMap[p.item_set_uid]) ? _c('div', {
      staticClass: "flex align-center justify-between"
    }, [_c('label', {
      staticClass: "label label-default bg-blue mb-0"
    }, [_vm._v("優惠券")]), _vm._v(" "), _c('span', {
      staticClass: "product-option"
    }, [_vm._v(" -$" + _vm._s(_vm.productCouponMap[p.item_set_uid].total_discount))])]) : _vm._e(), _vm._v(" "), (_vm.productVoucherMap[p.item_set_uid]) ? _c('div', {
      staticClass: "flex align-center justify-between"
    }, [_c('label', {
      staticClass: "label label-default bg-blue mb-0"
    }, [_vm._v("電子票券")]), _vm._v(" "), _c('span', {
      staticClass: "product-option"
    }, [_vm._v(" -$" + _vm._s(_vm.productVoucherMap[p.item_set_uid].total_discount))])]) : _vm._e()]) : _vm._e()])
  })], 2)])]), _vm._v(" "), _vm._l((_vm.orderList.group_buy_follower_order_list), function(follower, i) {
    return (_vm.orderList.order_type === 2) ? _c('div', {
      key: ("follower-" + i),
      staticClass: "col-sm-12 table-responsive p-x-0"
    }, [_c('table', {
      staticClass: "table table-bordered table-striped dataTable",
      attrs: {
        "aria-describedby": "example1_info",
        "role": "grid",
        "id": "example2"
      }
    }, [_c('tbody', [_c('tr', [_c('td', {
      staticClass: "sorting_1 text-left bg-dark-gray text-white",
      attrs: {
        "colspan": follower.coupon_list.length || follower.voucher_list.length ? 4 : 3
      }
    }, [_vm._v("\n                        " + _vm._s(follower.contact_name) + "\n                        "), (follower.is_guest_order === 1) ? _c('span', [_vm._v("（非會員）")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "pull-right"
    }, [_vm._v("\n                          ＄" + _vm._s(follower.money) + "\n                          "), (follower.coupon_list.length || follower.voucher_list.length) ? _c('span', {
      staticClass: "c-pointer",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#couponModal"
      },
      on: {
        "click": function($event) {
          _vm.info = follower;
          _vm.showCouponVoucherModal = true
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-ticket text-red",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()])])]), _vm._v(" "), _vm._l((follower.product_list), function(p, index) {
      return _c('tr', {
        attrs: {
          "role": "row"
        }
      }, [_c('td', {
        staticClass: "sorting_1 text-center"
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('h4', [_vm._v(_vm._s(p.product) + " - ＄" + _vm._s(p.total_money / p.amount))]), _vm._v(" "), _c('p', {
        staticClass: "product-option"
      }, [_vm._l((p.option_list), function(option, index) {
        return (p.type === 1) ? _c('span', [_vm._v("\n                            " + _vm._s(option) + " "), (index < p.option_list.length - 1) ? _c('span', [_vm._v(" / ")]) : _vm._e()]) : _vm._e()
      }), _vm._v(" "), _vm._l((p.product_list), function(pList) {
        return (p.type === 3) ? _c('span', _vm._l((pList), function(prod) {
          return _c('span', [_c('span', [_vm._v(_vm._s(prod.product))]), (prod.amount > 1) ? _c('span', [_vm._v("x" + _vm._s(prod.amount))]) : _vm._e(), _vm._l((prod.option_list), function(opt, i) {
            return (prod.type === 1) ? _c('span', [(i === 0) ? _c('span', [_vm._v("：")]) : _vm._e(), _vm._v(_vm._s(opt)), (i < prod.option_list.length - 1) ? _c('span', [_vm._v(" / ")]) : _vm._e()]) : _vm._e()
          }), _vm._v(" "), _c('br')], 2)
        }), 0) : _vm._e()
      })], 2), _vm._v(" "), (p.cup_amount) ? _c('p', {
        staticClass: "flex"
      }, [_c('img', {
        attrs: {
          "src": __webpack_require__(137)
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "product-option p-l-5"
      }, [_vm._v("自備飲料杯 x" + _vm._s(p.cup_amount))])]) : _vm._e(), _vm._v(" "), (p.sticker_name) ? _c('p', [_c('span', [_c('i', {
        staticClass: "fa fa-user",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v("\n                            " + _vm._s(p.sticker_name) + "\n                          ")])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('h4', {
        staticClass: "text-right text-bold text-nowrap"
      }, [_vm._v("x " + _vm._s(p.amount))])]), _vm._v(" "), (follower.coupon_list.length || follower.voucher_list.length) ? _c('td', [_c('h4', {
        staticClass: "text-right text-bold"
      }, [_vm._v("$" + _vm._s(p.total_money))]), _vm._v(" "), (follower.product_coupon_list.item_list && follower.product_coupon_list.item_list[p.item_set_uid]) ? _c('div', {
        staticClass: "flex align-center justify-between"
      }, [_c('label', {
        staticClass: "label label-default bg-blue mb-0"
      }, [_vm._v("優惠券")]), _vm._v(" "), _c('span', {
        staticClass: "product-option"
      }, [_vm._v(" -$" + _vm._s(follower.product_coupon_list.item_list[p.item_set_uid].total_discount))])]) : _vm._e(), _vm._v(" "), (follower.product_voucher_list.item_list && follower.product_voucher_list.item_list[p.item_set_uid]) ? _c('div', {
        staticClass: "flex align-center justify-between"
      }, [_c('label', {
        staticClass: "label label-default bg-blue mb-0"
      }, [_vm._v("電子票券")]), _vm._v(" "), _c('span', {
        staticClass: "product-option"
      }, [_vm._v(" -$" + _vm._s(follower.product_voucher_list.item_list[p.item_set_uid].total_discount))])]) : _vm._e()]) : _vm._e()])
    })], 2), _vm._v(" "), _c('br')])]) : _vm._e()
  })], 2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "couponDetailModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead'), _vm._v(" "), _c('tbody', _vm._l((_vm.couponList), function(c, cIndex) {
    return _c('tr', {
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1 v-middle text-center"
    }, [_vm._v(_vm._s(cIndex + 1))]), _vm._v(" "), _c('td', {
      staticClass: "v-middle"
    }, [_c('h4', [_vm._v(_vm._s(c.name) + " - " + _vm._s(c.coupon_set_code))]), _vm._v(" "), _c('p', {
      staticClass: "product-option"
    }, [_c('span', [_vm._v("\n                            " + _vm._s(_vm.priceTypeName(c.price_type)) + "\n                          ")])])]), _vm._v(" "), _c('td', {
      staticClass: "v-middle text-right"
    }, [_vm._v("x " + _vm._s(c.amount))])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "text-right bg-dark-gray text-white"
  }, [_c('td', {
    staticClass: "text-w-600",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("$ " + _vm._s(_vm.totalCouponMoney))])])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "getCouponDetailModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead'), _vm._v(" "), _c('tbody', _vm._l((_vm.getCouponList), function(c, cIndex) {
    return _c('tr', {
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1 v-middle text-center"
    }, [_vm._v(_vm._s(cIndex + 1))]), _vm._v(" "), _c('td', {
      staticClass: "v-middle"
    }, [_c('h4', [_vm._v(_vm._s(c.name) + " - " + _vm._s(c.coupon_set_code))]), _vm._v(" "), _c('p', {
      staticClass: "product-option"
    }, [_c('span', [_vm._v("\n                            " + _vm._s(_vm.priceTypeName(c.price_type)) + "\n                          ")])])]), _vm._v(" "), _c('td', {
      staticClass: "v-middle"
    }, [_vm._v("\n                        " + _vm._s(_vm.valueName(c.discount_value, c.discount_type)) + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "v-middle text-right"
    }, [_vm._v("x " + _vm._s(c.amount))])])
  }), 0)])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "getPointDetailModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('tbody', [(Object.keys(_vm.groupedPoints).length) ? _c('tr', [_c('td', {
    staticClass: "sorting_1 v-middle text-left bg-dark-gray text-white",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n                        獲得點數\n                      ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.groupedPoints), function(group, src_type, index) {
    return _c('tr', {
      key: src_type
    }, [(group.length) ? _c('td', {
      staticClass: "text-center vertical-m",
      attrs: {
        "rowspan": "group.length"
      }
    }, [_vm._v("\n                        " + _vm._s(index + 1) + "\n                      ")]) : _vm._e(), _vm._v(" "), (group.length) ? _c('td', {
      staticClass: "vertical-m",
      attrs: {
        "rowspan": "group.length",
        "width": "150px"
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.getSrcTypeName('point', src_type)) + "\n                      ")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "p-0",
      attrs: {
        "rowspan": "group.length"
      }
    }, _vm._l((group), function(point, index) {
      return _c('div', {
        key: point.point_id,
        staticClass: "dialog-border"
      }, [_vm._v("\n                            " + _vm._s(point.point_brand_name ? point.point_brand_name : '你訂') + _vm._s(point.point_store_name ? point.point_store_name : '') + "點數\n                        ")])
    }), 0), _vm._v(" "), _c('td', {
      staticClass: "p-0",
      attrs: {
        "rowspan": "group.length"
      }
    }, _vm._l((group), function(point, index) {
      return _c('div', {
        key: point.point_id,
        staticClass: "flex dialog-border justify-end"
      }, [_vm._v(_vm._s(point.amount) + " (點)")])
    }), 0)])
  })], 2)]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('tbody', [(Object.keys(_vm.groupedMembershipScore).length) ? _c('tr', [_c('td', {
    staticClass: "sorting_1 v-middle text-left bg-dark-gray text-white",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n                        獲得積分\n                      ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.groupedMembershipScore), function(group, src_type, index) {
    return _c('tr', {
      key: src_type
    }, [(group.length) ? _c('td', {
      staticClass: "text-center vertical-m",
      attrs: {
        "rowspan": "group.length"
      }
    }, [_vm._v("\n                        " + _vm._s(index + 1) + "\n                      ")]) : _vm._e(), _vm._v(" "), (group.length) ? _c('td', {
      staticClass: "vertical-m",
      attrs: {
        "rowspan": "group.length",
        "width": "150px"
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.getSrcTypeName('memberScore', src_type)) + "\n                      ")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "p-0",
      attrs: {
        "rowspan": "group.length"
      }
    }, _vm._l((group), function(item, index) {
      return _c('div', {
        key: 's_' + index,
        staticClass: "dialog-border"
      }, [_vm._v("\n                        " + _vm._s(item.membership_group_brand_name ? item.membership_group_brand_name : '你訂') + _vm._s(item.membership_group_store_name ? item.membership_group_store_name : '') + "積分\n                      ")])
    }), 0), _vm._v(" "), _c('td', {
      staticClass: "p-0",
      attrs: {
        "rowspan": "group.length"
      }
    }, _vm._l((group), function(item, index) {
      return _c('div', {
        key: item.point_id,
        staticClass: "flex dialog-border justify-end"
      }, [_vm._v(_vm._s(item.amount) + " (積分)")])
    }), 0)])
  })], 2)])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "statusTrackingModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('tbody', _vm._l((_vm.orderList.status_tracking), function(tracking, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                      " + _vm._s(tracking.create_time) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(_vm.orderState(tracking.status)) + "\n                    ")])])
  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "notifyHistoryModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('tbody', _vm._l((_vm.orderList.notify_history), function(history, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                      " + _vm._s(history.create_time) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(_vm.notifyType(history.type)) + "\n                    ")]), _vm._v(" "), _c('td', [(history.is_notified) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("已發送")]) : _vm._e(), _vm._v(" "), (!history.is_notified) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("未發送")]) : _vm._e()])])
  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "allowanceModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog text-left"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, _vm._l((_vm.orderList.allowance), function(allowance, aIndex) {
    return _c('p', [_vm._v("\n            " + _vm._s(aIndex + 1) + ".  購買"), _vm._l((allowance.menu_name_group), function(prod, pIndex) {
      return _c('span', [_vm._v(_vm._s(prod)), (pIndex + 1 < allowance.menu_name_group.length) ? _c('span', [_vm._v("、")]) : _vm._e()])
    }), _vm._v("折" + _vm._s(allowance.total_allowance / allowance.match_amount) + "元\n             "), _c('span', {
      staticClass: "label label-primary",
      staticStyle: {
        "top": "-2px"
      }
    }, [_vm._v("符合 " + _vm._s(allowance.match_amount) + " 組")]), _vm._v("，"), _c('span', {
      staticClass: "label label-danger",
      staticStyle: {
        "top": "-2px"
      }
    }, [_vm._v("共折 " + _vm._s(allowance.total_allowance) + " 元")])], 2)
  }), 0), _vm._v(" "), _vm._m(19)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "driverTimeModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [(_vm.driverTimeDialog) ? _c('tbody', [(_vm.driverTimeDialog.create_time) ? _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.driverTimeDialog.create_time))]), _vm._v(" "), _c('td', [_vm._v("成立物流單")])]) : _vm._e(), _vm._v(" "), (_vm.driverTimeDialog.vendor_confirm_time) ? _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.driverTimeDialog.vendor_confirm_time))]), _vm._v(" "), _c('td', [_vm._v("物流接單")])]) : _vm._e(), _vm._v(" "), (_vm.driverTimeDialog.store_cancel_time) ? _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.driverTimeDialog.store_cancel_time))]), _vm._v(" "), _c('td', [_vm._v("門市取消叫件")])]) : _vm._e(), _vm._v(" "), (_vm.driverTimeDialog.vendor_cancel_time && _vm.driverTimeDialog.status != 900) ? _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.driverTimeDialog.vendor_cancel_time))]), _vm._v(" "), _c('td', [_vm._v("媒合失敗")])]) : _vm._e(), _vm._v(" "), (_vm.driverTimeDialog.actual_get_time) ? _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.driverTimeDialog.actual_get_time))]), _vm._v(" "), _c('td', [_vm._v("已取貨")])]) : _vm._e(), _vm._v(" "), (_vm.driverTimeDialog.actual_arrived_time) ? _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.driverTimeDialog.actual_arrived_time))]), _vm._v(" "), _c('td', [_vm._v("已送達")])]) : _vm._e()]) : _vm._e()])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "ratingModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [(_vm.ratingInfo.is_replied) ? _c('span', [_vm._v("修改")]) : _c('span', [_vm._v("回覆")]), _vm._v("評價")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('p', [_vm._v(_vm._s(_vm.ratingInfo.comment))]), _vm._v(" "), _c('p', {
    staticClass: "text-right"
  }, [_c('small', [_vm._v(_vm._s(_vm.ratingInfo.create_time))])]), _vm._v(" "), _c('div', {
    staticClass: "m-t-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ratingInfo.reply_comment),
      expression: "ratingInfo.reply_comment"
    }],
    staticClass: "w-100-p p-10",
    staticStyle: {
      "min-height": "250px"
    },
    domProps: {
      "value": (_vm.ratingInfo.reply_comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ratingInfo, "reply_comment", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-right"
  }, [_c('small', [_vm._v(_vm._s(_vm.ratingInfo.reply_time))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.defaultComment(1)
      }
    }
  }, [_vm._v("感謝支持")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.defaultComment(2)
      }
    }
  }, [_vm._v("抱歉")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.defaultComment(3)
      }
    }
  }, [_vm._v("已聯絡")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.reply
    }
  }, [_vm._v("確定"), (_vm.ratingInfo.is_replied) ? _c('span', [_vm._v("修改")]) : _c('span', [_vm._v("回覆")])])])])])]), _vm._v(" "), (_vm.showCouponVoucherModal) ? _c('div', {
    staticClass: "modal fade in",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-content coupon-modal"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showCouponVoucherModal = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("詳情")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "overflow-y": "auto",
      "max-height": "400px"
    }
  }, [(_vm.info.coupon_list && _vm.info.coupon_list.length) ? [_c('h5', {
    staticClass: "text-bold "
  }, [_vm._v("優惠券")]), _vm._v(" "), _c('ol', [_vm._l((_vm.infoProductCouponFormat), function(productCoupon) {
    return _vm._l((productCoupon.formatList), function(coupon) {
      return _c('li', {
        staticClass: "mb-2"
      }, [_c('div', {
        staticClass: "d-flex align-center"
      }, [_c('span', {
        staticClass: "label label-default mb-0"
      }, [_vm._v(_vm._s(coupon.productName))]), _vm._v(" "), _c('span', {
        staticClass: "m-l-5"
      }, [_vm._v("使用")]), _vm._v(" "), _c('span', {
        staticClass: "label label-primary m-l-5 mb-0"
      }, [_vm._v(_vm._s(coupon.count) + "張" + _vm._s(coupon.name))]), _vm._v("，"), _c('span', {
        staticClass: "label label-danger mb-0"
      }, [_vm._v("共折" + _vm._s(coupon.count * coupon.unitDiscount) + "元")])])])
    })
  }), _vm._v(" "), _vm._l((_vm.info.coupon_list.filter(function (i) { return !i.product_name; })), function(coupon) {
    return _c('li', {
      staticClass: "mb-2"
    }, [_c('div', {
      staticClass: "d-flex align-center"
    }, [_c('span', {
      staticClass: "label label-default mb-0"
    }, [_vm._v(_vm._s(coupon.product_name))]), _vm._v(" "), _c('span', {
      staticClass: "m-l-5"
    }, [_vm._v("使用")]), _vm._v(" "), _c('span', {
      staticClass: "label label-primary m-l-5 mb-0"
    }, [_vm._v(_vm._s(coupon.amount) + "張" + _vm._s(coupon.name))]), _vm._v("，"), _c('span', {
      staticClass: "label label-danger mb-0"
    }, [_vm._v("共折" + _vm._s(coupon.money) + "元")])])])
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.info.coupon_list && _vm.info.coupon_list.length && _vm.info.voucher_list && _vm.info.voucher_list.length) ? _c('hr', {
    staticStyle: {
      "margin": "1.5em 0"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.info.voucher_list && _vm.info.voucher_list.length) ? [_c('h5', {
    staticClass: "text-bold "
  }, [_vm._v("電子票券")]), _vm._v(" "), _c('ol', [_vm._l((_vm.infoVoucherCouponFormat), function(VoucherCoupon) {
    return _vm._l((VoucherCoupon.formatList), function(coupon) {
      return _c('li', {
        staticClass: "mb-2"
      }, [_c('div', {
        staticClass: "d-flex align-center"
      }, [_c('span', {
        staticClass: "label label-default mb-0"
      }, [_vm._v(_vm._s(coupon.productName))]), _vm._v(" "), _c('span', {
        staticClass: "m-l-5"
      }, [_vm._v("使用")]), _vm._v(" "), _c('span', {
        staticClass: "label label-primary m-l-5 mb-0"
      }, [_vm._v(_vm._s(coupon.count) + "張" + _vm._s(coupon.name))]), _vm._v("，"), _c('span', {
        staticClass: "label label-danger mb-0"
      }, [_vm._v("共折" + _vm._s(coupon.count * coupon.unitDiscount) + "元")])])])
    })
  })], 2)] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showCouponVoucherModal = false
      }
    }
  }, [_vm._v("返回")])])])]) : _vm._e(), _vm._v(" "), (_vm.showCouponModal) ? _c('div', {
    staticClass: "modal fade in",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-content coupon-modal"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showCouponModal = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("優惠券核銷詳情")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "overflow-y": "auto",
      "max-height": "400px"
    }
  }, [_c('ol', [_vm._l((_vm.productCouponListFormat), function(productCoupon) {
    return _vm._l((productCoupon.formatList), function(coupon) {
      return _c('li', {
        staticClass: "mb-2"
      }, [_c('div', {
        staticClass: "d-flex align-center"
      }, [_c('span', {
        staticClass: "label label-default mb-0"
      }, [_vm._v(_vm._s(coupon.productName))]), _vm._v(" "), _c('span', {
        staticClass: "m-l-5"
      }, [_vm._v("使用")]), _vm._v(" "), _c('span', {
        staticClass: "label label-primary m-l-5 mb-0"
      }, [_vm._v(_vm._s(coupon.count) + "張" + _vm._s(coupon.name))]), _vm._v("，"), _c('span', {
        staticClass: "label label-danger mb-0"
      }, [_vm._v("共折" + _vm._s(coupon.count * coupon.unitDiscount) + "元")])])])
    })
  }), _vm._v(" "), _vm._l((_vm.gbProductCouponListFormat), function(gbProductCoupon) {
    return _vm._l((gbProductCoupon.formatList), function(coupon) {
      return _c('li', {
        staticClass: "mb-2"
      }, [_c('div', {
        staticClass: "d-flex align-center"
      }, [_c('span', {
        staticClass: "label label-default mb-0"
      }, [_vm._v(_vm._s(coupon.productName))]), _vm._v(" "), _c('span', {
        staticClass: "m-l-5"
      }, [_vm._v("使用")]), _vm._v(" "), _c('span', {
        staticClass: "label label-primary m-l-5 mb-0"
      }, [_vm._v(_vm._s(coupon.count) + "張" + _vm._s(coupon.name))]), _vm._v("，"), _c('span', {
        staticClass: "label label-danger mb-0"
      }, [_vm._v("共折" + _vm._s(coupon.count * coupon.unitDiscount) + "元")])])])
    })
  }), _vm._v(" "), _vm._l((_vm.couponListWithoutProduct), function(coupon) {
    return _c('li', {
      staticClass: "mb-2"
    }, [_c('div', {
      staticClass: "d-flex align-center"
    }, [_c('span', {
      staticClass: "label label-default mb-0"
    }, [_vm._v(_vm._s(coupon.product_name))]), _vm._v(" "), _c('span', {
      staticClass: "m-l-5"
    }, [_vm._v("使用")]), _vm._v(" "), _c('span', {
      staticClass: "label label-primary m-l-5 mb-0"
    }, [_vm._v(_vm._s(coupon.amount) + "張" + _vm._s(coupon.name))]), _vm._v("，"), _c('span', {
      staticClass: "label label-danger mb-0"
    }, [_vm._v("共折" + _vm._s(coupon.money) + "元")])])])
  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.showVoucherModal) ? _c('div', {
    staticClass: "modal fade in",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-content coupon-modal"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showVoucherModal = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("電子票券核銷詳情")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('ol', [_vm._l((_vm.voucherCouponListFormat), function(voucherCoupon) {
    return _vm._l((voucherCoupon.formatList), function(coupon) {
      return _c('li', {
        staticClass: "mb-2"
      }, [_c('div', {
        staticClass: "d-flex align-center"
      }, [_c('span', {
        staticClass: "label label-default mb-0"
      }, [_vm._v(_vm._s(coupon.productName))]), _vm._v(" "), _c('span', {
        staticClass: "m-l-5"
      }, [_vm._v("使用")]), _vm._v(" "), _c('span', {
        staticClass: "label label-primary m-l-5 mb-0"
      }, [_vm._v(_vm._s(coupon.count) + "張" + _vm._s(coupon.name))]), _vm._v("，"), _c('span', {
        staticClass: "label label-danger mb-0"
      }, [_vm._v("共折" + _vm._s(coupon.count * coupon.unitDiscount) + "元")])])])
    })
  }), _vm._v(" "), _vm._l((_vm.gbVoucherCouponListFormat), function(gbVoucherCoupon) {
    return _vm._l((gbVoucherCoupon.formatList), function(coupon) {
      return _c('li', {
        staticClass: "mb-2"
      }, [_c('div', {
        staticClass: "d-flex align-center"
      }, [_c('span', {
        staticClass: "label label-default mb-0"
      }, [_vm._v(_vm._s(coupon.productName))]), _vm._v(" "), _c('span', {
        staticClass: "m-l-5"
      }, [_vm._v("使用")]), _vm._v(" "), _c('span', {
        staticClass: "label label-primary m-l-5 mb-0"
      }, [_vm._v(_vm._s(coupon.count) + "張" + _vm._s(coupon.name))]), _vm._v("，"), _c('span', {
        staticClass: "label label-danger mb-0"
      }, [_vm._v("共折" + _vm._s(coupon.count * coupon.unitDiscount) + "元")])])])
    })
  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.showProductModal) ? _c('div', {
    staticClass: "modal fade in",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-content product-modal"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showProductModal = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("產品優惠券")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, _vm._l((_vm.info.list), function(product, pIndex) {
    return _c('p', [_vm._v("\n          " + _vm._s(pIndex + 1) + ".  使用 "), _c('span', {
      staticClass: "label label-primary",
      staticStyle: {
        "top": "-2px"
      }
    }, [_vm._v(_vm._s(product.name))]), _vm._v("，"), _c('span', {
      staticClass: "label label-danger",
      staticStyle: {
        "top": "-2px"
      }
    }, [_vm._v("共折" + _vm._s(product.unit_discount) + "元")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showProductModal = false
      }
    }
  }, [_vm._v("返回")])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon bg-blue",
    staticStyle: {
      "border": "1px solid #0073b7"
    }
  }, [_vm._v("\n                產品明細\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-target": "#orderDetailModal",
      "data-toggle": "modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-list",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 產品內容\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon bg-blue",
    staticStyle: {
      "border": "1px solid #0073b7"
    }
  }, [_vm._v("\n                折讓金額\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-target": "#allowanceModal",
      "data-toggle": "modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-list",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 折讓內容\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon bg-blue",
    staticStyle: {
      "border": "1px solid #0073b7"
    }
  }, [_vm._v("\n                獲得優惠券明細\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-target": "#getCouponDetailModal",
      "data-toggle": "modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-list",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 獲得優惠券內容\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon bg-blue",
    staticStyle: {
      "border": "1px solid #0073b7"
    }
  }, [_vm._v("\n                獲得點數/積分明細\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-target": "#getPointDetailModal",
      "data-toggle": "modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-list",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 獲得內容\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                訂單狀態紀錄\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-target": "#statusTrackingModal",
      "data-toggle": "modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 詳細內容\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                門市通知紀錄\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-target": "#notifyHistoryModal",
      "data-toggle": "modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 詳細內容\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "hidden-xs hidden-sm"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("外送員編號")]), _vm._v(" "), _c('th', [_vm._v("外送員(代碼)")]), _vm._v(" "), _c('th', [_vm._v("外送員電話")]), _vm._v(" "), _c('th', [_vm._v("物流廠商")]), _vm._v(" "), _c('th', [_vm._v("物流查詢編號")]), _vm._v(" "), _c('th', [_vm._v("實際取貨時間")]), _vm._v(" "), _c('th', [_vm._v("實際送達時間")]), _vm._v(" "), _c('th', [_vm._v("運費(元)")]), _vm._v(" "), _c('th', [_vm._v("物流狀態")]), _vm._v(" "), _c('th', [_vm._v("物流時間狀態")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("星級")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("留言")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("回覆")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "refundModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "box-body form text-left"
  }, [_c('pre', {
    attrs: {
      "id": "trade-info"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("店家優惠")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("產品明細")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("優惠券明細")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("獲得優惠券明細")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("獲得點數/積分明細")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("訂單狀態紀錄")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("門市通知紀錄")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("商品優惠")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("返回")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("物流狀態時間")])])
}]}

/***/ }),
/* 2313 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-10 flex align-center"
  }, [_c('div', {
    staticClass: "flex grey darken-1"
  }, [(_vm.brand.name || _vm.store.brand_name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s(_vm.brand.name ? _vm.brand.name : _vm.store.brand_name ? _vm.store.brand_name : '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s('/')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.store.name)
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("新增" + _vm._s(_vm.tabName))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row form-inline"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.elementList), function(element, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (element.name),
        expression: "element.name"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": _vm.tabNamePlaceholder,
        "maxlength": "70"
      },
      domProps: {
        "value": (element.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(element, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (element.vendor_custom_id),
        expression: "element.vendor_custom_id"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "對應POS_id"
      },
      domProps: {
        "value": (element.vendor_custom_id)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(element, "vendor_custom_id", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (element.remark),
        expression: "element.remark"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "備註"
      },
      domProps: {
        "value": (element.remark)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(element, "remark", $event.target.value)
        }
      }
    })])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.addElement()
      }
    }
  }, [_vm._v("再新增" + _vm._s(_vm.tabName))])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-fail",
    on: {
      "click": _vm.gotoOut
    }
  }, [_vm._v("\n            返回\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.checkAddBinding
    }
  }, [_vm._v("\n            新增\n          ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("名稱")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("商品料號")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("備註")])])])
}]}

/***/ }),
/* 2314 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('meal-tag-form')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2315 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "box text-center"
  }, [_c('div', {
    staticClass: "box-body form"
  }, [_c('div', [(_vm.$route.name === 'upProductIcon') ? _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "right": "0"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.iconInfo.name),
      expression: "iconInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.iconInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.iconInfo, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.iconInfo.sort),
      expression: "iconInfo.sort"
    }],
    ref: "sort",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "maxlength": "99",
      "type": "tel"
    },
    domProps: {
      "value": (_vm.iconInfo.sort)
    },
    on: {
      "keyup": _vm.veritySort,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.iconInfo, "sort", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.iconInfo.is_visible),
      expression: "iconInfo.is_visible"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.iconInfo, "is_visible", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("啟用")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("停用")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            描述\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.iconInfo.description),
      expression: "iconInfo.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.iconInfo.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.iconInfo, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0 bg-white",
    staticStyle: {
      "border-right": "none"
    }
  }, [_c('span', {
    staticClass: "inline-block h-auto m-t-5"
  }, [(!_vm.iconInfo.image_file) ? _c('div', {
    staticClass: "text-black",
    domProps: {
      "textContent": _vm._s('沒有圖片')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.iconInfo.image_file) ? _c('img', {
    staticClass: "h-auto img-responsive",
    attrs: {
      "src": _vm.iconInfo.image_file,
      "data-toggle": "modal"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [_c('div', [_c('label', {
    staticClass: "btn-upload btn btn-default m-t-25",
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "for": "brand-img-load"
    }
  }, [_vm._v("\n                  選擇圖片\n                ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "brand-img-load"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])])])]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n          取消\n        ")]), _vm._v(" "), (_vm.$route.name === 'crProductIcon') ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkBeforeSend('cr')
      }
    }
  }, [_vm._v("\n          新增\n        ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkBeforeSend('up')
      }
    }
  }, [_vm._v("\n          修改\n        ")])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delIconOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-danger inline-block",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delIconModal"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("名稱\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("排序\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("啟用\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("圖片\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("(圖片最大為200x200)"), _c('br')])
}]}

/***/ }),
/* 2316 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('ad-form')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2317 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [(_vm.getRoleType === 99) ? _c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-10 flex align-center"
  }, [_c('div', {
    staticClass: "flex grey darken-1"
  }, [(_vm.brand.name || _vm.store.brand_name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s(_vm.brand.name ? _vm.brand.name : _vm.store.brand_name ? _vm.store.brand_name : '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s('/')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.store.name)
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('cr-join-menu')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2318 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('search-map')], 1)
},staticRenderFns: []}

/***/ }),
/* 2319 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_c('div', {
    staticClass: "col-xs-12 text-left form-group"
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title",
    on: {
      "click": function($event) {
        return _vm.crElement()
      }
    }
  }, [_vm._v("新增" + _vm._s(_vm.tabName))]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-default btn-table-title",
    on: {
      "click": function($event) {
        return _vm.goToEditElement()
      }
    }
  }, [_vm._v("編輯" + _vm._s(_vm.tabName))]), _vm._v(" "), (_vm.tab === 2) ? _c('div', {
    staticClass: "btn btn-default btn-table-title",
    class: {
      'disabled': _vm.process
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#copy-option-modal"
    }
  }, [_vm._v("\n          複製配料\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.deletestatus) ? _c('div', {
    staticClass: "btn btn-default btn-table-title",
    on: {
      "click": function($event) {
        _vm.deletestatus = true
      }
    }
  }, [_vm._v("批次刪除")]) : _vm._e(), _vm._v(" "), (_vm.deletestatus) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    },
    on: {
      "click": _vm.deleteProducts
    }
  }, [_vm._v("刪除選中")]) : _vm._e(), _vm._v(" "), (_vm.deletestatus) ? _c('div', {
    staticClass: "btn btn-default btn-table-title",
    on: {
      "click": function($event) {
        _vm.deletestatus = false
      }
    }
  }, [_vm._v("取消")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "name"
    }
  }, [_vm._v("名稱")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "vendor_custom_id"
    }
  }, [_vm._v("商品料號")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "remark"
    }
  }, [_vm._v("備註")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchInput),
      expression: "searchInput"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchInput = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": _vm.getList
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [(_vm.deletestatus) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectall),
      expression: "selectall"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectall) ? _vm._i(_vm.selectall, null) > -1 : (_vm.selectall)
    },
    on: {
      "input": function($event) {
        return _vm.selectItemAll()
      },
      "change": function($event) {
        var $$a = _vm.selectall,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectall = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectall = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectall = $$c
        }
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("名稱 (ID)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("商品料號")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("備註")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.bindList), function(bind, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [(_vm.deletestatus) ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (bind.selectItem),
        expression: "bind.selectItem"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(bind.selectItem) ? _vm._i(bind.selectItem, null) > -1 : (bind.selectItem)
      },
      on: {
        "change": function($event) {
          var $$a = bind.selectItem,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(bind, "selectItem", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(bind, "selectItem", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(bind, "selectItem", $$c)
          }
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [(!bind.edit_state) ? _c('div', [_vm._v(_vm._s(bind.name) + " (" + _vm._s(bind.item_id) + ")")]) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (bind.edit_name),
        expression: "bind.edit_name"
      }],
      staticClass: "form-control",
      attrs: {
        "maxlength": "70"
      },
      domProps: {
        "value": (bind.edit_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(bind, "edit_name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [(!bind.edit_state) ? _c('div', [_vm._v(_vm._s(bind.vendor_custom_id))]) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (bind.edit_vendor_custom_id),
        expression: "bind.edit_vendor_custom_id"
      }],
      staticClass: "form-control",
      domProps: {
        "value": (bind.edit_vendor_custom_id)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(bind, "edit_vendor_custom_id", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [(!bind.edit_state) ? _c('div', [_vm._v(_vm._s(bind.remark))]) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (bind.remark),
        expression: "bind.remark"
      }],
      staticClass: "form-control",
      attrs: {
        "maxlength": "45"
      },
      domProps: {
        "value": (bind.remark)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(bind, "remark", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [(!bind.edit_state) ? _c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          bind.edit_state = !bind.edit_state
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e(), _vm._v(" "), (bind.edit_state) ? _c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          return _vm.upElement(bind)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e(), _vm._v(" "), (bind.edit_state) ? _c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          bind.edit_state = !bind.edit_state
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#delModal"
      },
      on: {
        "click": function($event) {
          return _vm.delModalOpen(bind)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [(_vm.pageAmount > 1 && _vm.pageGroup !== 1) ? _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        _vm.pageGroup = _vm.pageGroup - 1
      }
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pageAmount), function(index) {
    return (_vm.pageShow(index)) ? _c('li', {
      staticClass: "paginate_button",
      class: {
        active: _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          return _vm.clickPage(index)
        }
      }
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v(_vm._s(index))])]) : _vm._e()
  }), _vm._v(" "), (_vm.pageAmount > 1 && _vm.pageAmount / _vm.groupAmount > _vm.pageGroup) ? _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        _vm.pageGroup = _vm.pageGroup + 1
      }
    }
  }, [_vm._m(1)]) : _vm._e()], 2)])]), _vm._v(" "), _c('nd-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.copyOptionsConf
    },
    on: {
      "trigger": _vm.trigger
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function() {
        return [_c('nd-copy-options-store', {
          attrs: {
            "brandId": _vm.brandId,
            "getDataH": _vm.getDataH,
            "storeId": _vm.storeId
          },
          on: {
            "update:choose": _vm.updateChoose
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('nd-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.copyOptionsConfChecked
    },
    on: {
      "trigger": _vm.trigger
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function() {
        return [_vm._v("\n      確定複製並套用至門市？\n    ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('nd-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 2320 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-10 flex align-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.goBackInfo.name,
        params: _vm.goBackInfo.params,
        query: _vm.goBackInfo.query
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default m-r-5 flex"
  }, [_c('span', [_vm._v("返回")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.title)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.subtitle)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex grey darken-1"
  }, [(_vm.brand.name || _vm.store.brand_name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s(_vm.brand.name ? _vm.brand.name : _vm.store.brand_name ? _vm.store.brand_name : '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s('/')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.store.name)
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('cr-adjust')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2321 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0"
  }, [_c('span', {
    staticClass: "inline-block h-auto m-t-5"
  }, [(!_vm.image && (_vm.type == 1 || _vm.type == 2)) ? _c('div', {
    staticClass: "text-black",
    domProps: {
      "textContent": _vm._s('沒有圖片')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.image) ? _c('img', {
    staticClass: "h-auto img-responsive",
    attrs: {
      "src": _vm.image,
      "id": 'img-load' + _vm.index + '-' + _vm.type,
      "data-toggle": "modal",
      "data-target": '#myModal-' + _vm.index + '-' + _vm.type
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [_c('label', {
    staticClass: "btn-upload btn btn-default",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "for": 'file-upload-' + _vm.index + '-' + _vm.type
    }
  }, [_vm._v("\n      選擇圖片\n    ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": 'file-upload-' + _vm.index + '-' + _vm.type,
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": 'myModal-' + _vm.index + '-' + _vm.type,
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.image
    }
  })]), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("廣告")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("返回")])])
}]}

/***/ }),
/* 2322 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('designated-table')], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 2323 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('history-table')], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 2324 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "modal",
    staticClass: "btn",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#messageModal"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "messageModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-c",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header border-b-1"
  }, [_c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.message.title))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-content-c"
  }, [_c('div', {
    staticClass: "mb-2",
    domProps: {
      "innerHTML": _vm._s(_vm.message.content)
    }
  }), _vm._v(" "), _vm._l((_vm.message.images), function(img, index) {
    return _c('div', {
      staticClass: "mb-1"
    }, [_c('img', {
      staticClass: "responsive-img",
      attrs: {
        "src": img.image_name,
        "data-toggle": "modal"
      }
    }), _vm._v(" "), _c('br'), _c('span', [_vm._v("圖片 " + _vm._s(index + 1))])])
  }), _vm._v(" "), _vm._l((_vm.message.link), function(url, index) {
    return _c('div', {
      staticClass: "mb-1"
    }, [_c('span', [_vm._v("連結" + _vm._s(index + 1) + "： "), _c('a', {
      attrs: {
        "href": url
      }
    }, [_vm._v(_vm._s(url))])])])
  }), _vm._v(" "), _c('small', {
    staticClass: "time"
  }, [_vm._v("系統通知 ｜ " + _vm._s(_vm.message.update_time))])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-default bt-c",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("關閉")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 2325 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('store-table')
},staticRenderFns: []}

/***/ }),
/* 2326 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-xd-12"
  }, [_c('shopper-money-table', {
    attrs: {
      "memberAmount": _vm.memberAmount
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2327 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('ad-form', {
    attrs: {
      "info": _vm.info
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2328 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [(!_vm.categoryList.length) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._v("\n    無商品分類，請新增\n  ")]) : _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-danger m-y-10 inline-block pull-right",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    },
    on: {
      "click": _vm.delModalOpen
    }
  }, [_vm._v("\n          刪除\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-black m-y-10 inline-block pull-right m-r-10",
    domProps: {
      "textContent": _vm._s('新增')
    },
    on: {
      "click": _vm.gotoCrCategories
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-black m-y-10 inline-block pull-right m-r-10",
    attrs: {
      "data-toggle": "modal"
    },
    on: {
      "click": function($event) {
        _vm.show.easy = !_vm.show.easy
      }
    }
  }, [(!_vm.show.easy) ? _c('span', [_vm._v("簡易")]) : _c('span', [_vm._v("進階")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-2 bg-light-gray select-element-block text-left"
  }, _vm._l((_vm.categoryList), function(category, index) {
    return _c('div', {
      staticClass: "select-element",
      class: {
        'active': _vm.curId === category.item_id
      },
      attrs: {
        "disabled": _vm.isLoad || _vm.curId === category.item_id
      },
      on: {
        "click": function($event) {
          return _vm.clickCategory(category, index)
        }
      }
    }, [_c('span', {
      staticClass: "text-w-600"
    }, [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('small', {
      staticStyle: {
        "opacity": ".7"
      }
    }, [_vm._v("  " + _vm._s(category.remark))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-10"
  }, [_c('div', {
    staticClass: "box-body form menu-form col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6 p-r-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.categoryInfo.name),
      expression: "categoryInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "70"
    },
    domProps: {
      "value": (_vm.categoryInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.categoryInfo, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.categoryInfo.sort),
      expression: "categoryInfo.sort"
    }],
    ref: "sort",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.categoryInfo.sort)
    },
    on: {
      "keyup": _vm.veritySort,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.categoryInfo, "sort", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("備註")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.categoryInfo.remark),
      expression: "categoryInfo.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.categoryInfo.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.categoryInfo, "remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show.easy),
      expression: "!show.easy"
    }],
    staticClass: "col-xs-12 col-md-6 p-l-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("描述")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.categoryInfo.description),
      expression: "categoryInfo.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.categoryInfo.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.categoryInfo, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品料號")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.categoryInfo.vendor_custom_id),
      expression: "categoryInfo.vendor_custom_id"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.categoryInfo.vendor_custom_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.categoryInfo, "vendor_custom_id", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品")]), _vm._v(" "), _c('div', {
    staticClass: "form-control text-left",
    staticStyle: {
      "min-height": "60px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default btn-black m-y-10 inline-block ",
    staticStyle: {
      "position": "absolute",
      "right": "10px",
      "top": "0px",
      "z-index": "3"
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#choseProdModal"
    }
  }, [_vm._v("\n                  選擇商品\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "option-left-block"
  }, _vm._l((_vm.productList), function(prod) {
    return (prod.active) ? _c('div', {
      staticClass: "inline-block m-r-10 option-chose",
      staticStyle: {
        "margin": "5px"
      }
    }, [_vm._v("\n                    " + _vm._s(prod.name) + "\n                  ")]) : _vm._e()
  }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("套餐")]), _vm._v(" "), _c('div', {
    staticClass: "form-control text-left",
    staticStyle: {
      "min-height": "60px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default btn-black m-y-10 inline-block ",
    staticStyle: {
      "position": "absolute",
      "right": "10px",
      "top": "0px",
      "z-index": "3"
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#chosePackModal"
    }
  }, [_vm._v("\n                  選擇套餐\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "option-left-block"
  }, _vm._l((_vm.packageList), function(pack) {
    return (pack.active) ? _c('div', {
      staticClass: "inline-block m-r-10 option-chose",
      staticStyle: {
        "margin": "5px"
      }
    }, [_vm._v("\n                    " + _vm._s(pack.name) + "\n                  ")]) : _vm._e()
  }), 0)])]), _vm._v(" "), _c('br')])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.gotoOut
    }
  }, [_vm._v("\n      返回\n    ")]), _vm._v(" "), (!_vm.categoryList.length) ? _c('button', {
    staticClass: "btn btn-default btn-black",
    on: {
      "click": _vm.gotoCrCategories
    }
  }, [_vm._v("\n      新增\n    ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkInputEmpty()
      }
    }
  }, [_vm._v("\n      儲存\n    ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('c-modal', {
    attrs: {
      "elementList": _vm.productList,
      "option": _vm.choseProduct
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('c-modal', {
    attrs: {
      "elementList": _vm.packageList,
      "option": _vm.chosePackage
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline-block pull-left"
  }, [_c('h4', {
    staticClass: "pull-left"
  }, [_vm._v("\n        商品分類\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("分類名稱")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("排序")])
}]}

/***/ }),
/* 2329 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row m-b-15"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動名稱(後台)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動名稱(前端)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動說明(後台)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuId),
      expression: "menuId"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動說明(前端)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuId),
      expression: "menuId"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動順序")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuId),
      expression: "menuId"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [_c('div', [_c('div', {
    staticClass: "input-group cr-schedule"
  }, [_vm._m(0), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.timeoption,
      "limit": _vm.startLimit
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group cr-schedule"
  }, [_vm._m(1), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.timeoption,
      "limit": _vm.endLimit
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  會員限制\n                ")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.memberType,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "preserve-search": true,
      "placeholder": "會員限制",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.memberLimit),
      callback: function($$v) {
        _vm.memberLimit = $$v
      },
      expression: "memberLimit"
    }
  })], 1), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_c('h5', [_vm._v("參與店家")]), _vm._v(" "), _c('muti-select-two', {
    attrs: {
      "setting": _vm.addStoresSetting
    }
  })], 1), _vm._v(" "), _c('hr', {
    staticClass: "box-body col-xs-12"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_vm._m(2), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-target": "#couponRegisterModal",
      "data-toggle": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.addCoupon()
      }
    }
  }, [_vm._v(" + 贈送優惠券")]), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "width": "calc(100% - 130px)",
      "display": "inline-block"
    },
    attrs: {
      "options": _vm.otherCouponList,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "preserve-search": true,
      "placeholder": "行銷下其他優惠券",
      "label": "label",
      "track-by": "label"
    },
    on: {
      "select": _vm.changeOtherCoupon,
      "remove": _vm.removeOtherCoupon
    },
    model: {
      value: (_vm.otherCoupon),
      callback: function($$v) {
        _vm.otherCoupon = $$v
      },
      expression: "otherCoupon"
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _vm._l((_vm.couponList), function(coupon, index) {
    return _c('div', [_c('div', {
      staticClass: "card m-y-1 pull-left m-y-10 c-pointer",
      staticStyle: {
        "width": "calc(100% - 80px)"
      },
      attrs: {
        "data-target": "#couponRegisterModal",
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          return _vm.clickCoupon()
        }
      }
    }, [_vm._m(3, true), _vm._v(" "), _vm._m(4, true)]), _vm._v(" "), (!coupon.code) ? _c('div', {
      staticClass: "coupon-edit-block pull-left"
    }, [(_vm.couponList.length > 1) ? _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.couponList.splice(index, 1)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e(), _vm._v(" "), (_vm.couponList.length > 1) ? _c('br') : _vm._e(), _vm._v(" "), _vm._m(5, true)]) : _vm._e()])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.crSchedule
    }
  }, [_vm._v("\n      新增\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fail",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n      取消\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "couponRegisterModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog choose-modal"
  }, [_c('div', {
    staticClass: "modal-content pull-left"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "modal-body text-left pull-left"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "card m-y-1 pull-left w-100-p m-y-10 c-pointer"
  }, [_c('div', {
    staticClass: "coupon-left p-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.useType,
      "label": "label",
      "searchable": false,
      "allow-empty": true,
      "close-on-select": true,
      "placeholder": "優惠券型態",
      "show-labels": false
    },
    model: {
      value: (_vm.coupon.useType),
      callback: function($$v) {
        _vm.$set(_vm.coupon, "useType", $$v)
      },
      expression: "coupon.useType"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "優惠券名稱"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "優惠券描述"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "備註"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', {
    staticClass: "text-light-gray m-t-0"
  }, [_vm._v("\n                  使用期限    \n                ")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.deadType,
      "label": "label",
      "searchable": false,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "過期時間種類",
      "show-labels": false
    },
    model: {
      value: (_vm.coupon.type),
      callback: function($$v) {
        _vm.$set(_vm.coupon, "type", $$v)
      },
      expression: "coupon.type"
    }
  }), _vm._v(" "), (_vm.coupon.type.value === 1) ? _c('div', {
    staticClass: "m-t-10 inline-block m-r-10"
  }, [_vm._v("\n                  開始："), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.timeoption,
      "limit": _vm.startLimit
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.coupon.type.value === 1 || _vm.coupon.type.value === 2) ? _c('div', {
    staticClass: "m-t-10 inline-block"
  }, [_vm._v("\n                  結束："), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.timeoption,
      "limit": _vm.endLimit
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.coupon.type.value === 3) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "幾天後到期"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "coupon-right p-10"
  }, [_c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.priceType,
      "label": "label",
      "searchable": false,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "優惠券稅制",
      "show-labels": false
    },
    model: {
      value: (_vm.coupon.price_type),
      callback: function($$v) {
        _vm.$set(_vm.coupon, "price_type", $$v)
      },
      expression: "coupon.price_type"
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.discountType,
      "label": "label",
      "searchable": false,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "優惠券稅制",
      "show-labels": false
    },
    model: {
      value: (_vm.coupon.discount_type),
      callback: function($$v) {
        _vm.$set(_vm.coupon, "discount_type", $$v)
      },
      expression: "coupon.discount_type"
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _vm._m(7)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "pull-left w-100-p"
  }, [_c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.couponSetting,
      "label": "label",
      "searchable": false,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "優惠券稅制",
      "show-labels": false
    },
    model: {
      value: (_vm.coupon.setting),
      callback: function($$v) {
        _vm.$set(_vm.coupon, "setting", $$v)
      },
      expression: "coupon.setting"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-left m-t-20"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("個人訂單最低消費金額")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("個人訂單最低消費商品數")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("最大使用數量")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.coupon.setting.value === 1) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品限制最低單價")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.coupon.setting.value === 1 || _vm.coupon.setting.value === 2) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("每商品限用張數")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.coupon.setting.value === 3) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("滿多少的總金額數值")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.coupon.setting.value === 3) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("每達到金額限用的張數")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.coupon.setting.value === 1 || _vm.coupon.setting.value === 3) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("排除商品")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.coupon.setting.value === 2) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("指定消費商品")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderType),
      expression: "orderType"
    }],
    attrs: {
      "type": "radio",
      "name": "iconOption",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.orderType, "0")
    },
    on: {
      "change": function($event) {
        _vm.orderType = "0"
      }
    }
  }), _vm._v("無限制\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderType),
      expression: "orderType"
    }],
    attrs: {
      "type": "radio",
      "name": "iconOption",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.orderType, "1")
    },
    on: {
      "change": function($event) {
        _vm.orderType = "1"
      }
    }
  }), _vm._v("一般單\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderType),
      expression: "orderType"
    }],
    attrs: {
      "type": "radio",
      "name": "iconOption",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.orderType, "2")
    },
    on: {
      "change": function($event) {
        _vm.orderType = "2"
      }
    }
  }), _vm._v("團購單\n                        ")])])])]), _vm._v(" "), _c('br')])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動開始時間\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動結束時間\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("贈送規則")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coupon-left p-10"
  }, [_c('h4', [_vm._v("Nidin優惠券")]), _vm._v(" "), _c('h5', [_vm._v("優惠券描述(備註)")]), _vm._v(" "), _c('h5', [_c('i', {
    staticClass: "fa fa-clock"
  }), _vm._v("到期：2018-12-29 12:00 ~ 2019-12-22 12:00")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coupon-right p-10"
  }, [_c('div', {
    staticClass: "v-middle"
  }, [_vm._v("\n                    $10\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default m-t-5"
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header pull-left w-100-p"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title text-left"
  }, [_vm._v("優惠券設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "面額"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("可使用優惠券的訂單類型\n                ")])
}]}

/***/ }),
/* 2330 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('group-form', {
    attrs: {
      "info": _vm.info
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2331 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title",
    on: {
      "click": _vm.outputList
    }
  }, [_vm._v(_vm._s(_vm.orderSn ? '匯出單筆拆帳訂單' : '匯出單日店家所有拆帳'))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.info.brandId) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box-body form-left min-m-t-10"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("品牌名稱(ID)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n              " + _vm._s(_vm.info.brandName) + " (" + _vm._s(_vm.info.brandId) + ")\n            ")])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right min-m-t-10"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("店家名稱(ID)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n              " + _vm._s(_vm.info.storeName) + " (" + _vm._s(_vm.info.storeId) + ")\n            ")])]), _vm._v(" "), _c('br')])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.historyList), function(history, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/historyOrderInfo/' + history.order_id
        }
      }
    }, [_c('span', [_vm._v(_vm._s(index + 1))])])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(history.order_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(history.order_sn))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(history.order_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(history.product_amount))]), _vm._v(" "), _c('td', [_vm._v("$ " + _vm._s(history.order_money))]), _vm._v(" "), _c('td', [_vm._v("$ " + _vm._s(history.store_revenue))]), _vm._v(" "), _c('td', [_vm._v("$ " + _vm._s(history.matcher_revenue))]), _vm._v(" "), _c('td', [(history.is_authenticated) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("成功")]) : _vm._e(), _vm._v(" "), (!history.is_authenticated) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("失敗")]) : _vm._e()]), _vm._v(" "), _c('td', [(history.is_posted) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("成功")]) : _vm._e(), _vm._v(" "), (!history.is_posted) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("失敗")]) : _vm._e()]), _vm._v(" "), _c('td', [(history.is_store_paid) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("成功")]) : _vm._e(), _vm._v(" "), (!history.is_store_paid) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("失敗")]) : _vm._e()])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('ul', {
    staticClass: "pagination"
  }, _vm._l((_vm.pageAmount), function(index) {
    return _c('li', {
      staticClass: "paginate_button",
      class: {
        active: _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          return _vm.clickPage(index)
        }
      }
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v(_vm._s(index))])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("下訂日期")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單編號")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單ID")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("總杯數")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("總交易金額")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("店家實得款項金額")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Matcher手續費")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("授權成功")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("取款")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("給付")])])])
}]}

/***/ }),
/* 2332 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-10 grid"
  }, [_c('div', {
    staticClass: "grid",
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.category), function(c, index) {
    return (_vm.category.length) ? _c('div', {
      staticClass: "col-xs-12 col-lg-4 grid-item p-5"
    }, [_c('div', {
      staticClass: "col-xs-12 card"
    }, [_c('div', {
      staticClass: "col-xs-12 card-title text-left p-x-15"
    }, [_c('span', {
      staticClass: "pull-left"
    }, [_vm._v(_vm._s(c.name))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 text-left"
    }, [_c('ul', {
      staticClass: "nav p-x-15"
    }, _vm._l((c.product_list), function(p, index) {
      return _c('li', {
        staticClass: "card-product c-pointer",
        on: {
          "click": function($event) {
            return _vm.openCombineModal('info', p.name, p.product_id)
          }
        }
      }, [_c('div', {
        staticClass: "product-name inline-block"
      }, [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('div', {
        staticClass: "inline-block"
      })])
    }), 0)])])]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [(_vm.pageAmount > 1 && _vm.pageGroup !== 1) ? _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        _vm.pageGroup = _vm.pageGroup - 1
      }
    }
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pageAmount), function(index) {
    return (_vm.pageShow(index)) ? _c('li', {
      staticClass: "paginate_button",
      class: {
        active: _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          return _vm.getMenuCategory(index)
        }
      }
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v(_vm._s(index))])]) : _vm._e()
  }), _vm._v(" "), (_vm.pageAmount > 1 && _vm.pageAmount / _vm.groupAmount > _vm.pageGroup) ? _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        _vm.pageGroup = _vm.pageGroup + 1
      }
    }
  }, [_vm._m(2)]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gotoFrom
    }
  }, [_vm._v("\n      上一步\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.gotoNext
    }
  }, [_vm._v("\n      離開\n    ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('combine-price-modal', {
    attrs: {
      "modalId": "crCombineModal",
      "state": 1,
      "productId": _vm.current.productId,
      "productName": _vm.current.productName,
      "type": _vm.current.type
    }
  }), _vm._v(" "), _c('combine-price-modal', {
    attrs: {
      "modalId": "infoCombineModal",
      "state": 3,
      "productId": _vm.current.productId,
      "productName": _vm.current.productName,
      "type": _vm.current.type
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "inline-block pull-left"
  }, [_c('h4', {
    staticClass: "pull-left"
  }, [_vm._v("\n        商品與組合價格\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 2333 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("門市ID")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("門市名稱")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("上架時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("下架時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("更新時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("建立時間")]), _vm._v(" "), (_vm.path == 'brandScheduleTable') ? _c('th') : _vm._e(), _vm._v(" "), (_vm.path == 'brandScheduleTable') ? _c('th') : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.storeList), function(s, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v("\n          " + _vm._s(index + 1) + "\n        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(s.store_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(s.store_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(s.start_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(s.end_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(s.update_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(s.create_time))]), _vm._v(" "), (_vm.path == 'brandScheduleTable') ? _c('td', [_vm._m(0, true)]) : _vm._e(), _vm._v(" "), (_vm.path == 'brandScheduleTable') ? _c('td', [_c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          return _vm.editStores(s.menu_id, s.store_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e()])
  }), 0)])]), _vm._v(" "), (_vm.path != 'upScheduleAll' && _vm.path != 'upScheduleOne') ? _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('ul', {
    staticClass: "pagination"
  }, _vm._l((5), function(index) {
    return _c('li', {
      staticClass: "paginate_button",
      class: {
        active: _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          return _vm.clickPage(index)
        }
      }
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v(_vm._s(index))])])
  }), 0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default"
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 2334 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('order-line-charts'), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                品牌\n              ")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "placeholder": "選擇品牌",
      "label": "label",
      "track-by": "value",
      "options": _vm.brandBrief,
      "multiple": true,
      "allow-empty": true,
      "close-on-select": false
    },
    model: {
      value: (_vm.content.bindingBrandList),
      callback: function($$v) {
        _vm.$set(_vm.content, "bindingBrandList", $$v)
      },
      expression: "content.bindingBrandList"
    }
  })], 1), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                店家\n              ")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "placeholder": "選擇店家",
      "label": "label",
      "track-by": "value",
      "options": _vm.storeBrief,
      "multiple": true,
      "allow-empty": true,
      "close-on-select": false
    },
    model: {
      value: (_vm.content.bindingStoreList),
      callback: function($$v) {
        _vm.$set(_vm.content, "bindingStoreList", $$v)
      },
      expression: "content.bindingStoreList"
    }
  })], 1), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 text-right pull-right"
  }, [_c('div', {
    staticClass: "form-group input-group time-box no-btn pull-right"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.storeTime,
      "option": _vm.dateoption,
      "limit": _vm.storeLimit
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 table-responsive",
    staticStyle: {
      "min-height": "300px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.storeStatusList), function(store) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(store.store_name) + " (" + _vm._s(store.store_id) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(store.order_count_accept))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(store.order_count_reject))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(store.order_count_accept - store.order_count_finish))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(store.order_count_finish))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(store.order_count_day_normal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(store.order_count_day_group))])])
  }), 0)])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("當日使用者註冊狀態")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "today-shopper"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("累積使用者註冊狀態")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "total-shopper"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("當日不重複之使用者行為")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "shopper-active"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("今日24小時訂單數與金額")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "hour-brief"
    }
  })])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("一日所有店家狀態列表"), _c('span', {
    staticClass: "text-red text-12"
  }, [_vm._v("(最多可選擇10間店家)")])]), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("店名 (ID)")]), _vm._v(" "), _c('th', [_vm._v("已接受數量")]), _vm._v(" "), _c('th', [_vm._v("拒絕數量")]), _vm._v(" "), _c('th', [_vm._v("例外數量")]), _vm._v(" "), _c('th', [_vm._v("已完成數量")]), _vm._v(" "), _c('th', [_vm._v("一般單數量")]), _vm._v(" "), _c('th', [_vm._v("團購單數量")])])])
}]}

/***/ }),
/* 2335 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "column center-block"
  }, [(_vm.getRoleType === 99) ? _c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-10 flex align-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.goBackInfo.name,
        params: _vm.goBackInfo.params,
        query: _vm.goBackInfo.query
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default m-r-5 flex"
  }, [_c('span', [_vm._v("返回")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.title)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.subtitle)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex grey darken-1"
  }, [(_vm.brand.name || _vm.store.brand_name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s(_vm.brand.name ? _vm.brand.name : _vm.store.brand_name ? _vm.store.brand_name : '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s('/')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.store.name)
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "warning-block"
  }, [_vm._v("\n      自備飲料杯模組為新功能，已規劃至「\n      "), _c('a', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.goto
    }
  }, [_vm._v(" 新後台管理系統 > 商品管理 > 一般商品 > 自備飲料杯管理")]), _vm._v("\n    」，請至新後台管理系統操作相關內容。\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 2336 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "popoverElement",
    staticClass: "vfc-popover-container",
    attrs: {
      "tabindex": "0"
    }
  }, [_c('PickerInputs', {
    attrs: {
      "fConfigs": _vm.fConfigs,
      "singleSelectedDate": _vm.singleSelectedDate,
      "calendar": _vm.calendar
    },
    scopedSlots: _vm._u([{
      key: "dateRangeInputs",
      fn: function(props) {
        return [_vm._t("dateRangeInputs", null, {
          "startDate": props.startDate,
          "endDate": props.endDate,
          "isTypeable": _vm.fConfigs.isTypeable
        })]
      }
    }, {
      key: "datePickerInput",
      fn: function(props) {
        return [_vm._t("datePickerInput", null, {
          "selectedDate": props.selectedDate,
          "isTypeable": _vm.fConfigs.isTypeable
        })]
      }
    }], null, true)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCalendar),
      expression: "showCalendar"
    }],
    ref: "mainContainer",
    staticClass: "vfc-main-container",
    class: {
      'vfc-modal':
      _vm.fConfigs.isModal &&
        (_vm.fConfigs.isDatePicker ||
          _vm.fConfigs.isDateRange ||
          _vm.fConfigs.isMultipleDatePicker),
        'vfc-dark': _vm.fConfigs.isDark
    }
  }, [(_vm.showTimePicker) ? _c('time-picker', {
    ref: "timePicker",
    attrs: {
      "height": _vm.$refs.popoverElement.clientHeight
    }
  }) : [_c('div', {
    staticClass: "vfc-calendars-container"
  }, [_c('Arrows', {
    attrs: {
      "isMultiple": false,
      "fConfigs": _vm.fConfigs,
      "allowPreDate": _vm.allowPreDate,
      "allowNextDate": _vm.allowNextDate
    },
    scopedSlots: _vm._u([{
      key: "navigationArrowLeft",
      fn: function() {
        return [_vm._t("navigationArrowLeft")]
      },
      proxy: true
    }, {
      key: "navigationArrowRight",
      fn: function() {
        return [_vm._t("navigationArrowRight")]
      },
      proxy: true
    }], null, true)
  }), _vm._v(" "), _c('div', {
    ref: "calendars",
    staticClass: "vfc-calendars"
  }, _vm._l((_vm.listCalendars), function(calendarItem, key) {
    return _c('div', {
      key: calendarItem.key,
      staticClass: "vfc-calendar"
    }, [_c('month-year-picker', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (
          _vm.showMonthPicker === key + 1 || _vm.showYearPicker === key + 1
        ),
        expression: "\n                showMonthPicker === key + 1 || showYearPicker === key + 1\n              "
      }],
      ref: "monthContainer",
      refInFor: true,
      class: 'vfc-' + _vm.fConfigs.titlePosition,
      attrs: {
        "changeYearStep": _vm.changeYearStep,
        "calendar-key": key
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "vfc-content"
    }, [_c('Arrows', {
      attrs: {
        "isMultiple": true,
        "fConfigs": _vm.fConfigs,
        "allowPreDate": _vm.allowPreDate,
        "allowNextDate": _vm.allowNextDate,
        "calendar-key": key
      },
      scopedSlots: _vm._u([{
        key: "navigationArrowLeft",
        fn: function() {
          return [_vm._t("navigationArrowLeft")]
        },
        proxy: true
      }, {
        key: "navigationArrowRight",
        fn: function() {
          return [_vm._t("navigationArrowRight")]
        },
        proxy: true
      }], null, true)
    }), _vm._v(" "), _c('transition', {
      attrs: {
        "tag": "div",
        "name": _vm.getTransition_(),
        "appear": ""
      }
    }, [(_vm.checkHiddenElement('month')) ? _c('div', {
      staticClass: "vfc-top-date",
      class: 'vfc-' + _vm.fConfigs.titlePosition
    }, [_c('span', {
      class: {
        'vfc-cursor-pointer vfc-underline':
        _vm.fConfigs.changeMonthFunction &&
          _vm.isNotSeparatelyAndFirst(key),
          'vfc-underline-active': _vm.showMonthPicker === key + 1
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.isNotSeparatelyAndFirst(key) && _vm.openMonthPicker(key + 1)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(calendarItem.month))]), _vm._v(" "), _c('span', {
      class: {
        'vfc-cursor-pointer vfc-underline':
        _vm.fConfigs.changeYearFunction &&
          _vm.isNotSeparatelyAndFirst(key),
          'vfc-underline-active': _vm.showYearPicker === key + 1
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.isNotSeparatelyAndFirst(key) && _vm.openYearPicker(key + 1)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(calendarItem.year) + "\n                  ")])]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "tag": "div",
        "name": _vm.getTransition_(),
        "appear": ""
      }
    }, [_c('div', {
      staticClass: "vfc-dayNames"
    }, [(_vm.fConfigs.showWeekNumbers) ? _c('span') : _vm._e(), _vm._v(" "), _vm._l((_vm.fConfigs.dayNames), function(dayName, dayKey) {
      return _c('span', {
        key: key + dayKey + 1,
        staticClass: "vfc-day"
      }, [(_vm.checkHiddenElement('dayNames')) ? [_vm._v("\n                      " + _vm._s(dayName) + "\n                    ")] : _vm._e()], 2)
    })], 2)]), _vm._v(" "), _c('transition-group', {
      attrs: {
        "tag": "div",
        "name": _vm.getTransition_(),
        "appear": ""
      }
    }, [_vm._l((calendarItem.weeks), function(week, week_key) {
      return _c('div', {
        key: key + week_key + 1,
        staticClass: "vfc-week"
      }, [(_vm.showWeekNumbers) ? _c('WeekNumbers', {
        attrs: {
          "number": week.number,
          "borderColor": _vm.borderColor
        }
      }) : _vm._e(), _vm._v(" "), _vm._l((week.days), function(day, day_key) {
        return _c('Day', {
          key: key + week_key + day_key + 1,
          ref: "day",
          refInFor: true,
          attrs: {
            "isMultipleDateRange": _vm.isMultipleDateRange,
            "day": day,
            "fConfigs": _vm.fConfigs,
            "calendar": _vm.calendar,
            "helpCalendar": _vm.helpCalendar,
            "week": week,
            "day_key": day_key,
            "alwaysUseDefaultClasses": _vm.alwaysUseDefaultClasses
          },
          on: {
            "dayMouseOver": _vm.dayMouseOver
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(props) {
              return [_vm._t("default", null, {
                "week": props.week,
                "day": props.day
              })]
            }
          }], null, true)
        })
      })], 2)
    }), _vm._v(" "), (
      calendarItem.weeks.length < 6 &&
      !_vm.fConfigs.isLayoutExpandable
    ) ? _vm._l((6 - calendarItem.weeks.length), function(moreWeekKey) {
      return _c('div', {
        key: key + moreWeekKey + 'moreWeek',
        staticStyle: {
          "height": "32.6px"
        }
      }, [_vm._v("\n                     \n                  ")])
    }) : _vm._e()], 2)], 1)], 1)
  }), 0), _vm._v(" "), (_vm.canClearRange || _vm.$slots['footer']) ? _c('Footer', {
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('div', {
          on: {
            "click": _vm.cleanRange
          }
        }, [_vm._t("cleaner", function() {
          return [(_vm.canClearRange && _vm.fConfigs.isDateRange) ? _c('div', {
            staticClass: "rangeCleaner"
          }, [_c('span', {
            class: [_vm.rangeIsSelected ? 'active' : 'disabled'],
            on: {
              "click": _vm.cleanRange
            }
          }, [_vm._v("Clear Range" + _vm._s(_vm.isMultipleDateRange && 's'))])]) : _vm._e()]
        })], 2), _vm._v(" "), _vm._t("footer")]
      },
      proxy: true
    }], null, true)
  }) : _vm._e()], 1)]], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 2337 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('cr-join-menu')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2338 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('dis-prod')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2339 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('brand-table')], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 此區可新增、編輯品牌下所有菜單的內容")]), _vm._v(" "), _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 如需建立某張菜單，請至菜單管理")])])
}]}

/***/ }),
/* 2340 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('dis-item-table-history')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2341 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('designated-form', {
    attrs: {
      "info": _vm.info
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2342 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('router-link', {
    attrs: {
      "to": "/crMealTag"
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("新增餐點種類")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectActive),
      expression: "selectActive"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectActive = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("顯示")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("隱藏")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchInput),
      expression: "searchInput"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchInput = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.getmealTagList()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.mealTagList), function(mealTag, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('object', {
      staticStyle: {
        "width": "33px"
      },
      attrs: {
        "type": "image/svg+xml",
        "data": mealTag.icon
      }
    })]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(mealTag.name) + " (" + _vm._s(mealTag.tag_id) + ")")])]), _vm._v(" "), _c('td', [_c('img', {
      staticClass: "img-ad-table",
      attrs: {
        "src": mealTag.image
      }
    })]), _vm._v(" "), _c('td', [(mealTag.is_visible) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("顯示")]) : _vm._e(), _vm._v(" "), (!mealTag.is_visible) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("隱藏")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(mealTag.sort))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/upMealTag/' + mealTag.tag_id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])])], 1)])
  }), 0)])]), _vm._v(" "), _c('paginate', {
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    staticClass: "form-control h-38"
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("名稱")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("圖示")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("名稱 (ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("底圖")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("顯示")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("排序")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])])
}]}

/***/ }),
/* 2343 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('cr-product')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2344 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box text-center"
  }, [(_vm.up) ? _c('div', {
    staticClass: "del-block m-t-5"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body form",
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "align-items": "center"
    }
  }, [_c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-xs-12 p-10"
  }, [_c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_vm._m(1), _vm._v(" "), _c('v-multiselect-listbox', {
    staticClass: "col-xs-12",
    attrs: {
      "options": _vm.addStoresSetting.options,
      "reduce-display-property": function (option) { return option.label; },
      "reduce-value-property": function (option) { return option.value; },
      "search-options-placeholder": "搜尋...",
      "selected-options-placeholder": "搜尋..."
    },
    model: {
      value: (_vm.addStoresSetting.choose),
      callback: function($$v) {
        _vm.$set(_vm.addStoresSetting, "choose", $$v)
      },
      expression: "addStoresSetting.choose"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_c('p', {
    staticClass: "text-12"
  }, [_vm._v("已選 " + _vm._s(this.addStoresSetting.choose.length) + " 間")])])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-fail text-black",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n            取消\n          ")]), _vm._v(" "), (!_vm.up) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkSetting()
      }
    }
  }, [_vm._v("\n            確定\n          ")]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-20 text-center",
    staticStyle: {
      "margin-bottom": "4em"
    }
  }, [_c('h3', [_vm._v("複製此分店所有設定至其他店家")])])
}]}

/***/ }),
/* 2345 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "col-xs-12 text-right pull-right"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [(_vm.brandBrief.length > 1 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group form-inline w-auto"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandSelect),
      expression: "brandSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.brandSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.roleType !== 10) ? _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("== 品牌 ==")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.brandBrief), function(brand) {
    return _c('option', {
      domProps: {
        "value": brand.value
      }
    }, [_vm._v("\n                    " + _vm._s(brand.label) + "\n                  ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('div', {
    staticClass: "form-group form-inline w-auto"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeSelect),
      expression: "storeSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.storeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("== 門市 ==")]), _vm._v(" "), _vm._l((_vm.storeBrief), function(store) {
    return _c('option', {
      domProps: {
        "value": store.value
      }
    }, [_vm._v("\n                    " + _vm._s(store.label) + "\n                  ")])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right pull-right"
  }, [_c('div', {
    staticClass: "form-group input-group time-box pull-right"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.dateoption,
      "limit": _vm.startLimit
    }
  }), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.dateoption,
      "limit": _vm.endLimit
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default submit-btn btn-search",
    staticStyle: {
      "height": "72px"
    },
    attrs: {
      "type": "button",
      "id": "search2"
    },
    on: {
      "click": function($event) {
        return _vm.getSearchPosition()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    attrs: {
      "id": _vm.mapName
    }
  })])])])])])])
},staticRenderFns: []}

/***/ }),
/* 2346 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('designated-form', {
    attrs: {
      "info": _vm.info
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2347 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-10"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "grid",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._l((_vm.category), function(c, index) {
    return _c('div', {
      key: index,
      staticClass: "col-xs-12 col-lg-4 grid-item p-5"
    }, [_c('div', {
      staticClass: "col-xs-12 card"
    }, [_c('div', {
      staticClass: "col-xs-12 text-left m-t-10"
    }, [_vm._v("\n               \n              "), _c('label', {
      staticClass: "bg-green label label-text-60-p cursor-pointer",
      on: {
        "click": function($event) {
          return _vm.changeCategoryAdd(c, false)
        }
      }
    }, [_vm._v("全選")]), _vm._v(" \n              "), _c('label', {
      staticClass: "bg-red label label-text-60-p cursor-pointer",
      on: {
        "click": function($event) {
          return _vm.changeCategoryAdd(c, true)
        }
      }
    }, [_vm._v("全取消")]), _vm._v("\n               \n            ")]), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 card-title text-left p-x-15"
    }, [_c('span', {
      staticClass: "pull-left"
    }, [_vm._v(_vm._s(c.name) + " "), _c('small', [_vm._v(_vm._s(c.remark))])]), _vm._v(" "), _c('div', {
      staticClass: "text-right inline-block m-r-15 block-checkbox"
    }, [_c('span', {
      staticClass: "checkbox-addmenu"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (c.is_remove),
        expression: "c.is_remove"
      }],
      staticClass: "css-checkbox",
      attrs: {
        "type": "checkbox",
        "id": 'c-' + c.category_id + '-is-add'
      },
      domProps: {
        "checked": Array.isArray(c.is_remove) ? _vm._i(c.is_remove, null) > -1 : (c.is_remove)
      },
      on: {
        "input": function($event) {
          return _vm.changeCategoryAdd(c)
        },
        "change": function($event) {
          var $$a = c.is_remove,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(c, "is_remove", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(c, "is_remove", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(c, "is_remove", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "css-label css-label-add",
      attrs: {
        "for": 'c-' + c.category_id + '-is-add'
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 text-left"
    }, [_c('ul', {
      staticClass: "nav p-x-15"
    }, [_vm._l((c.product_list), function(p, index) {
      return _c('li', {
        key: index,
        staticClass: "card-product"
      }, [_c('div', {}, [_vm._v("\n                    " + _vm._s(p.name) + " "), _c('small', [_vm._v(_vm._s(p.remark))]), _vm._v(" "), _c('div', {
        staticClass: "text-right inline-block block-checkbox"
      }, [_c('span', {
        staticClass: "checkbox-addmenu"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (p.is_remove),
          expression: "p.is_remove"
        }],
        staticClass: "css-checkbox",
        attrs: {
          "type": "checkbox",
          "id": 'p-' + p.product_id + '-is-add'
        },
        domProps: {
          "checked": Array.isArray(p.is_remove) ? _vm._i(p.is_remove, null) > -1 : (p.is_remove)
        },
        on: {
          "input": function($event) {
            return _vm.changeProductAdd(c, p)
          },
          "change": function($event) {
            var $$a = p.is_remove,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(p, "is_remove", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(p, "is_remove", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(p, "is_remove", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "css-label css-label-add",
        attrs: {
          "for": 'p-' + p.product_id + '-is-add'
        }
      })])]), _vm._v(" "), _vm._l((p.combine_list), function(combine, index) {
        return _c('div', {
          key: index
        }, [_c('span', {
          staticClass: "text-15",
          class: {
            'combine-gray': combine.is_remove
          }
        }, [_c('i', {
          staticClass: "fa fa-caret-right",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("  " + _vm._s(combine.name) + " "), _c('small', [_vm._v(_vm._s(combine.remark))])]), _vm._v(" "), _c('div', {
          staticClass: "text-right inline-block block-checkbox"
        }, [_c('span', {
          staticClass: "checkbox-addmenu"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (combine.is_remove),
            expression: "combine.is_remove"
          }],
          staticClass: "css-checkbox",
          attrs: {
            "type": "checkbox",
            "id": 'com-' + combine.combine_id + '-is-add'
          },
          domProps: {
            "checked": Array.isArray(combine.is_remove) ? _vm._i(combine.is_remove, null) > -1 : (combine.is_remove)
          },
          on: {
            "input": function($event) {
              return _vm.changeCombineAdd(c, p, combine)
            },
            "change": function($event) {
              var $$a = combine.is_remove,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(combine, "is_remove", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(combine, "is_remove", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(combine, "is_remove", $$c)
              }
            }
          }
        }), _vm._v(" "), _c('label', {
          staticClass: "css-label css-label-add",
          attrs: {
            "for": 'com-' + combine.combine_id + '-is-add'
          }
        })])])])
      })], 2)])
    }), _vm._v(" "), _vm._l((c.package_list), function(pa, index) {
      return _c('li', {
        key: index,
        staticClass: "card-product"
      }, [_c('div', {}, [_vm._v("\n                    " + _vm._s(pa.name) + " "), _c('small', [_vm._v(_vm._s(pa.remark))]), _vm._v(" "), _c('div', {
        staticClass: "text-right inline-block block-checkbox"
      }, [_c('span', {
        staticClass: "checkbox-addmenu"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (pa.is_remove),
          expression: "pa.is_remove"
        }],
        staticClass: "css-checkbox",
        attrs: {
          "type": "checkbox",
          "id": pa.package_id + '-is-add'
        },
        domProps: {
          "checked": Array.isArray(pa.is_remove) ? _vm._i(pa.is_remove, null) > -1 : (pa.is_remove)
        },
        on: {
          "input": function($event) {
            return _vm.changeProductAdd(c, pa)
          },
          "change": function($event) {
            var $$a = pa.is_remove,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(pa, "is_remove", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(pa, "is_remove", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(pa, "is_remove", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "css-label css-label-add",
        attrs: {
          "for": pa.package_id + '-is-add'
        }
      })])])])])
    })], 2)])])])
  }), _vm._v(" "), _vm._l((_vm.accessory), function(o, index) {
    return _c('div', {
      key: index,
      staticClass: "col-xs-12 col-lg-4 grid-item p-5"
    }, [_c('div', {
      staticClass: "col-xs-12 card"
    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 card-title text-left p-x-15"
    }, [_c('span', {
      staticClass: "pull-left"
    }, [_vm._v(_vm._s(o.name) + " "), _c('small', [_vm._v(_vm._s(o.remark))])]), _vm._v(" "), _c('div', {
      staticClass: "text-right inline-block m-r-15 block-checkbox"
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 text-left"
    }, [_c('ul', {
      staticClass: "nav p-x-15"
    }, _vm._l((o.product_list), function(p, index) {
      return _c('li', {
        key: index,
        staticClass: "card-product"
      }, [_c('div', {}, [_vm._v("\n                    " + _vm._s(p.name) + " "), _c('small', [_vm._v(_vm._s(p.remark))]), _vm._v(" "), _c('div', {
        staticClass: "text-right inline-block block-checkbox"
      }, [_c('span', {
        staticClass: "checkbox-addmenu"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (p.is_remove),
          expression: "p.is_remove"
        }],
        staticClass: "css-checkbox",
        attrs: {
          "type": "checkbox",
          "id": p.product_id + '-is-add'
        },
        domProps: {
          "checked": Array.isArray(p.is_remove) ? _vm._i(p.is_remove, null) > -1 : (p.is_remove)
        },
        on: {
          "input": function($event) {
            return _vm.changeProductAdd(o, p)
          },
          "change": function($event) {
            var $$a = p.is_remove,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(p, "is_remove", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(p, "is_remove", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(p, "is_remove", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "css-label css-label-add",
        attrs: {
          "for": p.product_id + '-is-add'
        }
      })])]), _vm._v(" "), _vm._l((p.combine_list), function(combine, index) {
        return _c('div', {
          key: index
        }, [_c('span', {
          staticClass: "text-15 text-light-gray"
        }, [_c('i', {
          staticClass: "fa fa-caret-right",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("  " + _vm._s(combine.name) + " "), _c('small', [_vm._v(_vm._s(combine.remark))])]), _vm._v(" "), _c('div', {
          staticClass: "text-right inline-block block-checkbox"
        }, [_c('span', {
          staticClass: "checkbox-addmenu"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (combine.is_remove),
            expression: "combine.is_remove"
          }],
          staticClass: "css-checkbox",
          attrs: {
            "type": "checkbox",
            "id": combine.combine_id + '-is-add'
          },
          domProps: {
            "checked": Array.isArray(combine.is_remove) ? _vm._i(combine.is_remove, null) > -1 : (combine.is_remove)
          },
          on: {
            "input": function($event) {
              return _vm.changeProductAdd(o, p, combine)
            },
            "change": function($event) {
              var $$a = combine.is_remove,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(combine, "is_remove", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(combine, "is_remove", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(combine, "is_remove", $$c)
              }
            }
          }
        }), _vm._v(" "), _c('label', {
          staticClass: "css-label css-label-add",
          attrs: {
            "for": combine.combine_id + '-is-add'
          }
        })])])])
      })], 2)])
    }), 0)])])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gotoFrom
    }
  }, [_vm._v("\n      上一步\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gotoNext
    }
  }, [_vm._v("\n      完成菜單\n    ")])]), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "inline-block pull-left text-left"
  }, [_c('h4', [_vm._v("\n          訂購與否或顯示隱藏\n        ")]), _vm._v(" "), _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" \"不加入\" 為新增菜單時，將勾選的項目排除。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "text-left"
  }, [_c('br'), _vm._v("\n        1.  商品分類與商品與各商品組合\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 m-b-5 text-left p-x-15"
  }, [_c('div', {
    staticClass: "text-right inline-block block-checkbox text-15",
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('span', {
    staticClass: "text-dark-gray text-13"
  }, [_vm._v("不加入")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 m-b-5 text-left p-x-15 m-t-10"
  }, [_c('div', {
    staticClass: "text-right inline-block block-checkbox text-15",
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('span', {
    staticClass: "text-dark-gray text-13"
  }, [_vm._v("不加入")])])])
}]}

/***/ }),
/* 2348 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.storeName) + "排程列表")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row form-inline"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left form-group"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/crSchedule'
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("新增排程")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('store-schedule-list')], 1)])])])]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 2349 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v("\n  滿\n  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.deliveryWays.price),
      expression: "deliveryWays.price",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control w-90 inline-block",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.deliveryWays.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deliveryWays, "price", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n      外送訂單可下單的最低金額門檻。若需設定訂單金額與對應的外送距離，可按「綠色+」按鈕設定。\n    ")])], 1), _vm._v("\n  元即可外送\n  "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.addOtherDelivery()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _vm._l((_vm.deliveryOtherKM), function(delivery, index) {
    return _c('span', {
      key: index
    }, [_c('br'), _vm._v(" "), _c('hr'), _vm._v("\n    滿\n    "), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (delivery.price),
        expression: "delivery.price",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "",
        "type": "text",
        "disabled": index === 0
      },
      domProps: {
        "value": (delivery.price)
      },
      on: {
        "change": function($event) {
          return _vm.changeOtherDelivery()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(delivery, "price", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v("\n    元可外送\n    "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (delivery.distance_km),
        expression: "delivery.distance_km",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "",
        "type": "text"
      },
      domProps: {
        "value": (delivery.distance_km)
      },
      on: {
        "change": function($event) {
          return _vm.changeOtherDelivery()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(delivery, "distance_km", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v("\n    公里以內 "), (!_vm.maxDeliveryDistanceKM && index === _vm.deliveryOtherKM.length - 1) ? _c('span', [_vm._v("(以上)")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          return _vm.removeOtherDelivery(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })])])
  }), _vm._v(" "), _c('hr'), _vm._v("\n  最遠可送\n  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.maxDeliveryDistanceKM),
      expression: "maxDeliveryDistanceKM",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control w-90 inline-block",
    attrs: {
      "maxlength": "6",
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.maxDeliveryDistanceKM)
    },
    on: {
      "change": function($event) {
        return _vm.changeOtherDelivery()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.maxDeliveryDistanceKM = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v("\n  公里\n")], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex text-14 m-b-10"
  }, [_c('div', {
    staticClass: "text-red m-r-5"
  }, [_vm._v("＊")]), _vm._v("\n    因圖資系統計算有機會產生偏差，故系統將自動保留 100 公尺的誤差值。"), _c('br'), _vm._v("\n    例如：若您的門檻設定為 1000 公尺，客人的距離為 1050 公尺，系統將視為符合門檻。\n  ")])
}]}

/***/ }),
/* 2350 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box text-center"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-xs-12 text-left"
  }, [_c('button', {
    staticClass: "btn btn-default m-y-10 inline-block",
    on: {
      "click": _vm.clearCId
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 新增門市群組\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger pull-right m-y-10 ",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    },
    on: {
      "click": _vm.delModalOpen
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-2 bg-light-gray select-element-block text-left"
  }, _vm._l((_vm.storeClassList), function(storeClass, index) {
    return _c('div', {
      staticClass: "select-element",
      class: {
        'active': _vm.curId === storeClass.id
      },
      on: {
        "click": function($event) {
          return _vm.clickOption(storeClass)
        }
      }
    }, [_c('span', {
      staticClass: "text-w-600"
    }, [_vm._v(_vm._s(storeClass.name))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-10"
  }, [_c('div', {
    staticClass: "box-body",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "row m-b-15"
  }, [_c('div', {
    staticClass: "row center-block text-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.name),
      expression: "info.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.info.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('h5', [_vm._v("選擇店家")]), _vm._v(" "), _c('muti-select-two', {
    attrs: {
      "setting": _vm.addStoresSetting,
      "reNew": _vm.reNew,
      "reSet": _vm.reSet
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n                    取消\n                  ")]), _vm._v(" "), (!_vm.curId) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkStoreClass(1)
      }
    }
  }, [_vm._v("\n                    新增\n                  ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkStoreClass(2)
      }
    }
  }, [_vm._v("\n                    編輯\n                  ")])])])])])])])])]), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("門市群組名稱")])
}]}

/***/ }),
/* 2351 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box-body form-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.addNewCoupon()
      }
    }
  }, [_vm._v("新增贈送優惠券")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example2"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.giveCoupons.coupon_set_list), function(coupon, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(coupon.coupon_info.name) + "\n        ")]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          return _vm.changeCur(coupon, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "data-target": "#delCouponModal",
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          _vm.curIndex = index
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), 0)])]), _vm._v(" "), (_vm.curCoupon.coupon_info) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr', {
    staticClass: "box-body form-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body form-center"
  }, [_c('h4', [_vm._v("編輯" + _vm._s(_vm.curCoupon.coupon_info.name))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curCoupon.coupon_info.name),
      expression: "curCoupon.coupon_info.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "名稱",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.curCoupon.coupon_info.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curCoupon.coupon_info, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curCoupon.coupon_info.set_name),
      expression: "curCoupon.coupon_info.set_name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "名稱",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.curCoupon.coupon_info.set_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curCoupon.coupon_info, "set_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curCoupon.coupon_info.description),
      expression: "curCoupon.coupon_info.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "優惠券說明",
      "maxlength": "1024"
    },
    domProps: {
      "value": (_vm.curCoupon.coupon_info.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curCoupon.coupon_info, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curCoupon.coupon_info.set_description),
      expression: "curCoupon.coupon_info.set_description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "優惠券說明",
      "maxlength": "1024"
    },
    domProps: {
      "value": (_vm.curCoupon.coupon_info.set_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curCoupon.coupon_info, "set_description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curCoupon.coupon_info.remark),
      expression: "curCoupon.coupon_info.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "優惠券備註",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.curCoupon.coupon_info.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curCoupon.coupon_info, "remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curCoupon.coupon_info.discount_value),
      expression: "curCoupon.coupon_info.discount_value"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "優惠券折扣金額",
      "type": "text"
    },
    domProps: {
      "value": (_vm.curCoupon.coupon_info.discount_value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curCoupon.coupon_info, "discount_value", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curCoupon.amount_unit),
      expression: "curCoupon.amount_unit"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "張數",
      "type": "text",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.curCoupon.amount_unit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curCoupon, "amount_unit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.priceType,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "優惠券稅制",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.curCoupon.coupon_info.price_type),
      callback: function($$v) {
        _vm.$set(_vm.curCoupon.coupon_info, "price_type", $$v)
      },
      expression: "curCoupon.coupon_info.price_type"
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getRoleType !== 10),
      expression: "getRoleType !== 10"
    }]
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(9), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.couponType,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "優惠券類型",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    on: {
      "select": _vm.selectUSType,
      "input": _vm.changeUSType
    },
    model: {
      value: (_vm.curCoupon.usage_store_config.usage_store_type),
      callback: function($$v) {
        _vm.$set(_vm.curCoupon.usage_store_config, "usage_store_type", $$v)
      },
      expression: "curCoupon.usage_store_config.usage_store_type"
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getRoleType !== 10),
      expression: "getRoleType !== 10"
    }]
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(10), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.usageMethod,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "優惠券稅制",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.curCoupon.usage_store_config.usage_method),
      callback: function($$v) {
        _vm.$set(_vm.curCoupon.usage_store_config, "usage_method", $$v)
      },
      expression: "curCoupon.usage_store_config.usage_method"
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curCoupon.usage_store_config.usage_method.value !== 'order_store' && _vm.getRoleType !== 10),
      expression: "curCoupon.usage_store_config.usage_method.value !== 'order_store' && getRoleType !== 10"
    }]
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(11), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.couponValue,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "優惠券稅制",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    on: {
      "select": _vm.selectUSValue
    },
    model: {
      value: (_vm.curCoupon.usage_store_config.usage_store_value),
      callback: function($$v) {
        _vm.$set(_vm.curCoupon.usage_store_config, "usage_store_value", $$v)
      },
      expression: "curCoupon.usage_store_config.usage_store_value"
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(12), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.timeType,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "優惠券稅制",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.curCoupon.time_config.time_type),
      callback: function($$v) {
        _vm.$set(_vm.curCoupon.time_config, "time_type", $$v)
      },
      expression: "curCoupon.time_config.time_type"
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.curCoupon.time_config.time_type.value === 'all_fixed') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(13), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.curCoupon.time_config.time.start,
      "option": _vm.timeoption,
      "limit": _vm.startLimit
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.curCoupon.time_config.time_type.value === 'day_day' || _vm.curCoupon.time_config.time_type.value === 'day_fixed') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(14), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curCoupon.time_config.use_start_day),
      expression: "curCoupon.time_config.use_start_day"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "天數",
      "type": "text",
      "maxlength": "3"
    },
    domProps: {
      "value": (_vm.curCoupon.time_config.use_start_day)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curCoupon.time_config, "use_start_day", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.curCoupon.time_config.time_type.value === 'all_fixed' || _vm.curCoupon.time_config.time_type.value === 'day_fixed') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(15), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.curCoupon.time_config.time.end,
      "option": _vm.timeoption,
      "limit": _vm.endLimit
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.curCoupon.time_config.time_type.value === 'day_day') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(16), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curCoupon.time_config.use_tolerance_day),
      expression: "curCoupon.time_config.use_tolerance_day"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "天數",
      "type": "text",
      "maxlength": "3"
    },
    domProps: {
      "value": (_vm.curCoupon.time_config.use_tolerance_day)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curCoupon.time_config, "use_tolerance_day", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curCoupon.usage_store_config.usage_method.value === 'manual' && _vm.curCoupon.usage_store_config.usage_store_type.value !== 3 && _vm.getRoleType !== 10),
      expression: "curCoupon.usage_store_config.usage_method.value === 'manual' && curCoupon.usage_store_config.usage_store_type.value !== 3 && getRoleType !== 10"
    }],
    staticClass: "box-body form-center"
  }, [_vm._m(17), _vm._v(" "), _c('muti-select-two', {
    ref: "couponStoresMuti",
    attrs: {
      "setting": _vm.addStoresSetting,
      "reNew": _vm.reNew,
      "reSet": _vm.reSet
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('coupon-modal', {
    attrs: {
      "coupon": _vm.curCoupon
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("優惠券")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("優惠券名稱(前台)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("優惠券名稱(後台)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("優惠券說明(前台)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("優惠券說明(後台)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("優惠券備註(前台)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("優惠券折扣金額")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("一次發送張數")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("優惠券稅制")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("優惠券類型")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("適用門市方式")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("適用對象")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("有效期間設定")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("開始時間")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("拿到優惠券後幾天開始")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("結束時間")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("開始後幾天結束")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("優惠券可用店家")])
}]}

/***/ }),
/* 2352 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "warning-block"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n    廠商對帳記錄表已搬至「\n    "), _c('a', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.goto
    }
  }, [_vm._v("新後台管理系統 > 財務中心 > 帳務明細")]), _vm._v("\n    」，請至新後台管理系統檢視相關內容，此區域(舊後台)功能即將關閉。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row m-b-10"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('ul', {
    staticClass: "nav nav-tabs flex",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      active: _vm.typeSelect === 99
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.typeSelect = 99
      }
    }
  }, [_vm._v("金流\n              ")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.typeSelect === 1
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.typeSelect = 1
      }
    }
  }, [_vm._v("物流\n              ")])]), _vm._v(" "), (_vm.getRestricted.indexOf(900) !== -1) ? _c('li', {
    class: {
      active: _vm.typeSelect === 10
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.typeSelect = 10
      }
    }
  }, [_vm._v("資訊服務費抽成\n              ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "m-l-auto flex"
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-default btn-table-title z-100 h-38",
    attrs: {
      "disabled": ""
    },
    on: {
      "click": _vm.download
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }, [_vm._v("下載報表")]), _vm._v(" "), _c('clip-loader', {
    staticClass: "cliploading",
    attrs: {
      "loading": _vm.isDownloading,
      "color": '#528BB8',
      "size": '16px'
    }
  })], 1)]), _vm._v(" "), _c('div', [(_vm.showHistoryReport) ? _c('button', {
    staticClass: "btn btn-default btn-table-title z-100 h-38 m-l-5",
    attrs: {
      "title": !_vm.brandSelect.value ? '請選擇品牌' : '',
      "disabled": ""
    },
    on: {
      "click": _vm.goCommissionHistory
    }
  }, [_vm._v("\n                  歷史報表\n                ")]) : _vm._e()]), _vm._v(" "), (_vm.typeSelect === 1 && _vm.shippingInfo.mete_portal_url) ? _c('div', [_c('button', {
    staticClass: "btn btn-default btn-table-title z-100 h-38 m-l-5",
    on: {
      "click": _vm.openLink
    }
  }, [_vm._v("\n                  查詢儲值金餘額\n                ")])]) : _vm._e()])])])]), _vm._v(" "), (_vm.typeSelect === 99) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [(_vm.brandBrief.length > 2 || _vm.storeBrief.length > 2) ? _c('div', {
    staticClass: "flex m-b-10"
  }, [(_vm.brandBrief.length > 2) ? _c('div', {
    staticClass: "inline-block from-group pull-left ",
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "==品牌==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.storeBrief.length > 2) ? _c('div', {
    class: ['inline-block from-group pull-left', {
      'm-l-5': _vm.brandBrief.length > 2
    }],
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.storeBrief,
      "label": "label",
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "門市",
      "show-labels": false,
      "preselect-first": true
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accountingSelect),
      expression: "accountingSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.accountingSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, _vm._l((_vm.accountingList), function(type) {
    return _c('option', {
      domProps: {
        "value": type.value
      }
    }, [_vm._v("\n                " + _vm._s(type.label) + "\n              ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-l-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tradeTypeSelect),
      expression: "tradeTypeSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tradeTypeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, _vm._l((_vm.traceTypeOption), function(trade) {
    return _c('option', {
      domProps: {
        "value": trade.value
      }
    }, [_vm._v("\n                " + _vm._s(trade.label) + "\n              ")])
  }), 0)]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', {
    staticClass: "form-group m-l-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reportSelect),
      expression: "reportSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.reportSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 999
    }
  }, [_vm._v("\n                == 報表類型 ==\n              ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("\n                原始報表\n              ")]), _vm._v(" "), (_vm.tradeTypeSelect === 713) ? _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("\n                對外對帳單\n              ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "h-38 m-l-5",
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.dateoption,
      "limit": _vm.startLimit
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "h-38 m-l-5",
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.dateoption,
      "limit": _vm.endLimit
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "m-l-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sourceSelect),
      expression: "sourceSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sourceSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": 999
    }
  }, [_vm._v("\n                == 訂單來源 ==\n              ")]), _vm._v(" "), (_vm.tradeTypeSelect === 908) ? _c('option', {
    domProps: {
      "value": 5
    }
  }, [_vm._v("\n                街口APP\n              ")]) : _vm._e(), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("\n                你訂\n              ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "m-l-auto flex",
    staticStyle: {
      "max-width": "340px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group h-38 m-l-5"
  }, [_c('div', {
    staticClass: "input-group h-38"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderSN),
      expression: "orderSN"
    }],
    staticClass: "form-control h-38",
    staticStyle: {
      "min-width": "150px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.orderSN)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orderSN = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.changePage(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("品牌名稱(ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("門市名稱(ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單編號")]), _vm._v(" "), (_vm.reportSelect === 1 || _vm.reportSelect === 999) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單類型")]) : _vm._e(), _vm._v(" "), (_vm.reportSelect === 1 || _vm.reportSelect === 999) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單狀態")]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("付款完成日")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("支付卡別")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("收單行")]), _vm._v(" "), (_vm.reportSelect === 1 || _vm.reportSelect === 999) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("折扣")]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單總金額")]), _vm._v(" "), (_vm.reportSelect === 1 || _vm.reportSelect === 999) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("付款類型")]) : _vm._e(), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(3)]) : (!_vm.isLoading && _vm.history.length > 0) ? _c('tbody', _vm._l((_vm.history), function(row, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v("\n                          " + _vm._s(index + 1) + "\n                      ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "200px"
      }
    }, [_vm._v("\n                          " + _vm._s(row.brand_name) + "(" + _vm._s(row.brand_id) + ")\n                      ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(row.store_name) + "(" + _vm._s(row.store_id) + ")\n                      ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(row.order_sn) + "\n                      ")]), _vm._v(" "), (_vm.reportSelect === 1 || _vm.reportSelect === 999) ? _c('td', [_vm._v("\n                          " + _vm._s(_vm._f("deliveryName")(row.delivery_type)) + "\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.reportSelect === 1 || _vm.reportSelect === 999) ? _c('td', [_c('label', {
      staticClass: "label",
      class: _vm._f("orderStateColor")(row.order_status)
    }, [_vm._v("\n                            " + _vm._s(_vm._f("orderStatusName")(row.order_status)) + "\n                          ")])]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(row.trade_date) + "\n                      ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(row.trade_finish_date) + "\n                      ")]), _vm._v(" "), _c('td', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.creditCardType(row.card_type))
      }
    })]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(row.acquirer ? row.acquirer : '-') + "\n                      ")]), _vm._v(" "), (_vm.reportSelect === 1 || _vm.reportSelect === 999) ? _c('td', [_vm._v("\n                          $" + _vm._s(row.total_money - row.total_paid_money) + "\n                      ")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n                          $" + _vm._s(row.total_paid_money) + "\n                      ")]), _vm._v(" "), (_vm.reportSelect === 1 || _vm.reportSelect === 999) ? _c('td', [_c('label', {
      staticClass: "label",
      class: _vm.tradeTypeColor(_vm.tradeType(row.trade_type))
    }, [_vm._v(_vm._s(_vm.tradeType(row.trade_type)))])]) : _vm._e(), _vm._v(" "), _c('td', [_c('label', {
      staticClass: "label",
      class: _vm.accountingType(row.accounting_type)
    }, [_vm._v(_vm._s(row.accounting_type === 1 ? '收款' : '退款'))])])])
  }), 0) : (!_vm.isLoading && _vm.history.length === 0) ? _c('tbody', [_vm._m(4)]) : _vm._e()])]), _vm._v(" "), _c('paginate', {
    attrs: {
      "pageAmount": _vm.paymentPageAmount,
      "total": _vm.pagination.paymentFlow.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.pagination.paymentFlow.groupAmount,
      "clickPage": _vm.changePage
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 1) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [(_vm.brandBrief.length > 2 || _vm.storeBrief.length > 2) ? _c('div', {
    staticClass: "flex m-b-10"
  }, [(_vm.brandBrief.length > 2) ? _c('div', {
    staticClass: "inline-block from-group pull-left ",
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "==品牌==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.storeBrief.length > 2) ? _c('div', {
    class: ['inline-block from-group pull-left', {
      'm-l-5': _vm.brandBrief.length > 2
    }],
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.storeBrief,
      "label": "label",
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "門市",
      "show-labels": false,
      "preselect-first": true
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group m-l-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingVendorSelect),
      expression: "shippingVendorSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shippingVendorSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, _vm._l((_vm.shippingVendorList), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v("\n                " + _vm._s(item.label) + "\n              ")])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sourceType),
      expression: "sourceType"
    }],
    staticClass: "form-control h-38",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sourceType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, _vm._l((_vm.sourceTypeList), function(order) {
    return _c('option', {
      domProps: {
        "value": order.value,
        "textContent": _vm._s(order.label)
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-l-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userType),
      expression: "userType"
    }],
    staticClass: "form-control h-38",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, _vm._l((_vm.userTypeList), function(shopper) {
    return _c('option', {
      domProps: {
        "value": shopper.value,
        "textContent": _vm._s(shopper.label)
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-l-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderStatus),
      expression: "orderStatus"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.orderStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, _vm._l((_vm.orderStatusList), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v("\n                  " + _vm._s(item.label) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-l-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingStatus),
      expression: "shippingStatus"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shippingStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, _vm._l((_vm.shippingStatusList), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v("\n                  " + _vm._s(item.label) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "h-38 m-l-5",
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.dateoption,
      "limit": _vm.startLimit
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "h-38 m-l-5",
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.dateoption,
      "limit": _vm.endLimit
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "m-l-auto flex",
    staticStyle: {
      "max-width": "340px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.searchType),
      expression: "searchType",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.searchType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("訂單編號")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("物流查詢編號")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group h-38 m-l-5"
  }, [_c('div', {
    staticClass: "input-group h-38"
  }, [(_vm.searchType == 2) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderSN),
      expression: "orderSN"
    }],
    staticClass: "form-control h-38",
    staticStyle: {
      "min-width": "150px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.orderSN)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orderSN = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.searchType == 3) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.venderOrderNo),
      expression: "venderOrderNo"
    }],
    staticClass: "form-control h-38",
    staticStyle: {
      "min-width": "150px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.venderOrderNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.venderOrderNo = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.changePage(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])])]), _vm._v(" "), (_vm.shippingInfo.overview) ? _c('div', [_c('ul', [_c('li', [_vm._v("訂單總金額：$ " + _vm._s(_vm.shippingInfo.overview.total_money))]), _vm._v(" "), _c('li', [_vm._v("訂單總數：" + _vm._s(_vm.shippingInfo.overview.total_amount))]), _vm._v(" "), _c('li', [_vm._v("物流總費用：$ " + _vm._s(_vm.shippingInfo.overview.total_vendor_fee))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), (_vm.getRoleType !== 10) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("品牌名稱(ID)")]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("門市名稱(ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單來源")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂購人類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單編號")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("物流查詢編號")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("交易日期")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單總金額(元)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單折扣(元)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("物流費用(元)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("物流廠商")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("物流狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("距離")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("實際取貨時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("實際送達時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("預計取貨時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("預計送達時間")])])]), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(5)]) : (!_vm.isLoading && _vm.shippingTableList.length > 0) ? _c('tbody', _vm._l((_vm.shippingTableList), function(row, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v("\n                  " + _vm._s(index + 1) + "\n                ")]), _vm._v(" "), (_vm.getRoleType !== 10) ? _c('td', {
      staticStyle: {
        "width": "200px"
      }
    }, [_vm._v("\n                  " + _vm._s(row.brand_name) + "(" + _vm._s(row.brand_id) + ")\n                ")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.store_name) + "(" + _vm._s(row.store_id) + ")\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.source_type || '-') + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.user_type || '-') + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.order_sn || '-') + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.customer_order_no || '-') + "\n                ")]), _vm._v(" "), _c('td', [_c('label', {
      staticClass: "label",
      class: _vm._f("orderStateColor")(row.order_status)
    }, [_vm._v("\n                    " + _vm._s(_vm._f("orderStatusName")(row.order_status)) + "\n                  ")])]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.order_date || '-') + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.total_paid_money || 0) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.discount_money || 0) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.vendor_fee) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm._f("shippingVendorName")(row.vendor_code)) + "\n                ")]), _vm._v(" "), _c('td', [_c('label', {
      staticClass: "label",
      class: _vm._f("shippingStateColor")(row.shipping_status)
    }, [_vm._v("\n                    " + _vm._s(_vm._f("shippingStatusName")(row.shipping_status)) + "\n                  ")])]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.distance || row.distance === 0 ? Math.round(row.distance / 1000 * 1000) / 1000 + '公里' : '-') + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.actual_get_time || '-') + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.actual_arrived_time || '-') + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.expected_get_time || '-') + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.expected_arrived_time || '-') + "\n                ")])])
  }), 0) : (!_vm.isLoading && _vm.shippingTableList.length === 0) ? _c('tbody', [_vm._m(6)]) : _vm._e()])]), _vm._v(" "), _c('paginate', {
    attrs: {
      "pageAmount": _vm.shippingPageAmount,
      "total": _vm.pagination.shippingFlow.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.pagination.shippingFlow.groupAmount,
      "clickPage": _vm.changePage
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 10) ? _c('div', [((_vm.getRoleType === 99 && !_vm.storeSelect.value) || _vm.commissionInfo.show_allow_void_commission_detail) ? _c('div', [(_vm.getRoleType === 99 && !_vm.storeSelect.value) ? _c('div', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            下列對帳表不含獨立簽約門市的抽成資訊，如需檢視請先切換至該門市。\n          ")]) : _vm._e(), _vm._v(" "), (_vm.commissionInfo.show_allow_void_commission_detail) ? _c('div', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            每月作廢訂單額度於次月 4 日才會納入計算。\n          ")]) : _vm._e(), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.brandBrief.length > 2 || _vm.storeBrief.length > 2) ? _c('div', {
    staticClass: "flex m-b-10"
  }, [(_vm.brandBrief.length > 2) ? _c('div', {
    staticClass: "inline-block from-group pull-left ",
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "==品牌==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.storeBrief.length > 2) ? _c('div', {
    class: ['inline-block from-group pull-left', {
      'm-l-5': _vm.brandBrief.length > 2
    }],
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.storeBrief,
      "label": "label",
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "門市",
      "show-labels": false,
      "preselect-first": true
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeType),
      expression: "timeType"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.timeType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, _vm._l((_vm.timeTypeList), function(type) {
    return _c('option', {
      key: ("type-" + (type.value)),
      domProps: {
        "value": type.value
      }
    }, [_vm._v("\n                  " + _vm._s(type.name) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.year),
      expression: "year"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.year = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, _vm._l((_vm.yearList), function(val) {
    return _c('option', {
      key: ("year" + val),
      domProps: {
        "value": val
      }
    }, [_vm._v("\n                  " + _vm._s(val + '年') + "\n                ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.timeType === 'monthly') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.month),
      expression: "month"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.month = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, _vm._l((12), function(val) {
    return _c('option', {
      key: ("month" + val),
      domProps: {
        "value": val
      }
    }, [_vm._v("\n                  " + _vm._s(val + '月') + "\n                ")])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.timeType === 'quarterly') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quarter),
      expression: "quarter"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.quarter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, _vm._l((_vm.quarterList), function(val) {
    return _c('option', {
      key: ("quarter" + (val.value)),
      domProps: {
        "value": val.value
      }
    }, [_vm._v("\n                  " + _vm._s(val.name) + "\n                ")])
  }), 0) : _vm._e()])])]), _vm._v(" "), (_vm.brandSelect.value) ? _c('ul', {
    staticClass: "m-t-10"
  }, [(_vm.commissionInfo.show_allow_void_commission_detail) ? [_c('li', [_vm._v("\n              資訊服務費抽成原金額(A)： $" + _vm._s(_vm.commissionInfo.original_commission_money) + "\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              可扣除的作廢訂單(B)\n              "), _vm._m(7), _vm._v("\n              ： " + _vm._s(_vm.commissionInfo.allow_void_commission_amount) + "/" + _vm._s(_vm.commissionInfo.allow_invalid_order_quota) + " 筆，共 $" + _vm._s(_vm.commissionInfo.allow_void_commission_money) + "\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              當月資訊服務費抽成金額(A-B)： $" + _vm._s(_vm.commissionInfo.total_commission_money) + "\n            ")])] : [_c('li', [_vm._v("\n              資訊服務費抽成原金額： $" + _vm._s(_vm.commissionInfo.original_commission_money) + "\n            ")])]], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(8), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(9)]) : (_vm.commissionList.length) ? _c('tbody', _vm._l((_vm.commissionList), function(row, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v("\n                  " + _vm._s(index + 1) + "\n                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "200px"
      }
    }, [_vm._v("\n                  " + _vm._s(row.brand_name) + "(" + _vm._s(row.brand_id) + ")\n                ")]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: ("/commissionStore/" + (row.store_id)),
          query: {
            year: _vm.year,
            type: _vm.timeType,
            period: _vm.timeType === 'quarterly' ? _vm.quarter : _vm.month
          }
        }
      }
    }, [_vm._v("\n                    " + _vm._s(row.store_name) + "(" + _vm._s(row.store_id) + ")\n                  ")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.total_paid_money) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.total_finish_commission_money) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.total_void_commission_money) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.total_commission_money) + "\n                ")])])
  }), 0) : _c('tbody', [_vm._m(10)])])]), _vm._v(" "), _c('paginate', {
    attrs: {
      "pageAmount": _vm.commissionPageAmount,
      "total": _vm.pagination.commission.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.pagination.commission.groupAmount,
      "clickPage": _vm.changePage
    }
  })], 1) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    staticClass: "form-control h-38"
  }, [_c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("訂單編號")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("交易日期\n                        "), _c('span', {
    staticClass: "tip-icon",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "訂單建立日期"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("交易類型\n                        "), _c('span', {
    staticClass: "tip-icon",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "退款為已申請退款非完成退款"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "14"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "16"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "16"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "tip-icon",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "以下訂時間，早下訂的先扣除"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("品牌(ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("分店(ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("實付總金額")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("已完成訂單資訊服務費抽成總金額")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("已作廢訂單資訊服務費抽成總金額")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("\n                  資訊服務費抽成總金額\n                  "), _c('span', {
    staticClass: "tip-icon",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "已完成+已作廢訂單資訊服務費抽成金額"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "7"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
}]}

/***/ }),
/* 2353 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/crPlatformAd',
        query: {
          tab: 12
        }
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 新增橫幅廣告")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/crPlatformAd',
        query: {
          tab: 31
        }
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 新增活動Bar")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/crPlatformAd',
        query: {
          tab: 41
        }
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 新增蓋版廣告")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectActive),
      expression: "selectActive"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectActive = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("啟用")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("停用")])])])]), _vm._v(" "), (_vm.$route.query.tab !== 41) ? _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchType),
      expression: "searchType"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("名稱")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("地區")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group search-bar"
  }, [(_vm.searchType === 1) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchInput),
      expression: "searchInput"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchInput = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.getAdList()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])]) : _c('div', {
    staticClass: "input-group"
  }, [_c('multiselect', {
    staticClass: "min-w-150",
    attrs: {
      "options": _vm.cityOption,
      "searchable": true,
      "allow-empty": true,
      "close-on-select": false,
      "show-labels": false,
      "placeholder": "",
      "multiple": true,
      "label": "name",
      "track-by": "code"
    },
    model: {
      value: (_vm.selectCity),
      callback: function($$v) {
        _vm.selectCity = $$v
      },
      expression: "selectCity"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.getAdList()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-xs-12 tab"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      active: _vm.bannerType === 12
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeBannerType(12)
      }
    }
  }, [_vm._v("橫幅廣告\n          ")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.bannerType === 31
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeBannerType(31)
      }
    }
  }, [_vm._v("活動Bar\n          ")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.bannerType === 41
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeBannerType(41)
      }
    }
  }, [_vm._v("蓋版廣告\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 my-10"
  }, [(_vm.$route.query.tab !== 41) ? _c('span', [_c('button', {
    staticClass: "btn btn-default drag-btn col",
    on: {
      "click": _vm.startDrag
    }
  }, [_c('img', {
    staticClass: "sort-icon",
    attrs: {
      "src": __webpack_require__(136)
    }
  }), _vm._v("\n          廣告排序")])]) : _vm._e(), _vm._v(" "), _c('span', [_c('button', {
    staticClass: "btn btn-default col",
    on: {
      "click": _vm.startBatchDelete
    }
  }, [_c('i', {
    staticClass: "fa fa-minus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 批次刪除")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 my-10 row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.isDraggable) ? _c('div', {
    staticClass: "message-info"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊ ")]), _vm._v("\n          可對前20則狀態為啟用的廣告圖片進行排序。"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊ ")]), _vm._v("\n          完成排序並儲存後，請重新整理前台頁面，即可看到廣告排序已變更為最新設定。 \n        ")]) : _vm._e(), _vm._v(" "), (_vm.isBatchDelete) ? _c('div', {
    staticClass: "message-info"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊ ")]), _vm._v("\n          可對廣告圖片進行批次刪除。"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊ ")]), _vm._v("\n          刪除後不可復原。  \n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [(_vm.isDraggable) ? _c('button', {
    staticClass: "btn btn-default btn-secondary",
    on: {
      "click": function($event) {
        return _vm.stopDrag(false)
      }
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), (_vm.isDraggable) ? _c('button', {
    staticClass: "btn btn-default label-success",
    on: {
      "click": function($event) {
        return _vm.stopDrag(true)
      }
    }
  }, [_vm._v("儲存")]) : _vm._e(), _vm._v(" "), (_vm.isBatchDelete) ? _c('button', {
    staticClass: "btn btn-default btn-secondary",
    on: {
      "click": function($event) {
        return _vm.BatchDelete(false)
      }
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), (_vm.isBatchDelete) ? _c('button', {
    staticClass: "btn btn-default label-danger",
    on: {
      "click": function($event) {
        return _vm.BatchDelete(true)
      }
    }
  }, [_vm._v("刪除")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDraggable),
      expression: "isDraggable"
    }],
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("排序")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isBatchDelete),
      expression: "isBatchDelete"
    }]
  }), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("圖片與連結")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("名稱 (ID)")]), _vm._v(" "), (_vm.bannerType !== 41) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("廣告地區")]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("廣告開始時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("廣告結束時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("啟用狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("更新時間")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])]), _vm._v(" "), _c('draggable', {
    attrs: {
      "tag": "tbody",
      "handle": ".handle"
    },
    model: {
      value: (_vm.adList),
      callback: function($$v) {
        _vm.adList = $$v
      },
      expression: "adList"
    }
  }, _vm._l((_vm.adList), function(ad) {
    return _c('tr', {
      key: ad.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isDraggable),
        expression: "isDraggable"
      }]
    }, [_c('i', {
      staticClass: "fa fa-bars handle"
    })]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isBatchDelete),
        expression: "isBatchDelete"
      }]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (ad.selectItem),
        expression: "ad.selectItem"
      }],
      staticClass: "checkbox",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(ad.selectItem) ? _vm._i(ad.selectItem, null) > -1 : (ad.selectItem)
      },
      on: {
        "change": function($event) {
          var $$a = ad.selectItem,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(ad, "selectItem", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(ad, "selectItem", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(ad, "selectItem", $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(ad.index))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": ad.url,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "img-ad-table",
      attrs: {
        "src": ad.image_web
      }
    })])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(ad.name) + " (" + _vm._s(ad.id) + ")")])]), _vm._v(" "), (_vm.bannerType !== 41) ? _c('td', [_c('More', {
      attrs: {
        "moreText": _vm.$options.filters.cityCode(ad.city_code_list),
        "title": "指定區域",
        "height": 46
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(ad.start_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ad.end_time))]), _vm._v(" "), _c('td', [_c('div', {
      class: _vm.timeMethodColor(ad.time_method)
    }, [_vm._v(_vm._s(_vm._f("status")(ad.time_method)))])]), _vm._v(" "), _c('td', [(ad.is_active) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _vm._e(), _vm._v(" "), (!ad.is_active) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("停用")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ad.edit_time))]), _vm._v(" "), _c('td', {
      staticClass: "row"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'upPlatformAd',
          params: {
            ad_id: ad.id,
          },
          query: {
            tab: _vm.bannerType,
          },
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default col"
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default col"
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.deleteBanner(ad.id)
        }
      }
    })])], 1)])
  }), 0)], 1)]), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isDraggable),
      expression: "!isDraggable"
    }],
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 2354 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [_c('div', {
    staticClass: "box-body form"
  }, [_c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.getRoleType !== 10) ? _c('div', {
    staticClass: "text-left"
  }, [_c('h5', [_vm._v("套用門市")]), _vm._v(" "), _vm._l((_vm.storeClassList), function(storeClass, index) {
    return _c('div', {
      key: ("storeClass-" + index),
      staticClass: "m-r-5 m-b-10 inline-block"
    }, [_c('button', {
      staticClass: "btn btn-default",
      class: {
        'active': _vm.curId === storeClass.id
      },
      on: {
        "click": function($event) {
          return _vm.clickOption(storeClass)
        }
      }
    }, [_vm._v("\n          " + _vm._s(storeClass.name) + "\n        ")])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "text-left"
  }, [_vm._v("參與店家")]), _vm._v(" "), _c('muti-select-two', {
    attrs: {
      "setting": _vm.addStoresSetting,
      "reNew": _vm.reNew,
      "reSet": _vm.reSet
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n      取消\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.copySetting
    }
  }, [_vm._v("\n      確定\n    ")])]), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("複製此分店所有設定至其他店家")])])
}]}

/***/ }),
/* 2355 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cov-vue-date"
  }, [_c('div', {
    staticClass: "datepickbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.date.time),
      expression: "date.time"
    }],
    staticClass: "cov-datepicker",
    style: (_vm.option.inputStyle ? _vm.option.inputStyle : {}),
    attrs: {
      "type": "text",
      "title": "input date",
      "readonly": "readonly",
      "placeholder": _vm.option.placeholder,
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.date.time)
    },
    on: {
      "click": _vm.showCheck,
      "foucus": _vm.showCheck,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.date, "time", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.showInfo.check) ? _c('div', {
    staticClass: "datepicker-overlay",
    style: ({
      'background': _vm.option.overlayOpacity ? 'rgba(0,0,0,' + _vm.option.overlayOpacity + ')' : 'rgba(0,0,0,0.5)'
    }),
    on: {
      "click": function($event) {
        return _vm.dismiss($event)
      }
    }
  }, [_c('div', {
    staticClass: "cov-date-body",
    style: ({
      'background-color': _vm.option.color ? _vm.option.color.header : '#3f51b5'
    })
  }, [_c('div', {
    staticClass: "cov-date-monthly"
  }, [_c('div', {
    staticClass: "cov-date-previous",
    on: {
      "click": function($event) {
        return _vm.nextMonth('pre')
      }
    }
  }, [_vm._v("«")]), _vm._v(" "), _c('div', {
    staticClass: "cov-date-caption",
    style: ({
      'color': _vm.option.color ? _vm.option.color.headerText : '#fff'
    })
  }, [_c('span', {
    on: {
      "click": _vm.showYear
    }
  }, [_c('small', [_vm._v(_vm._s(_vm.checked.year))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.showMonth
    }
  }, [_vm._v(_vm._s(_vm.displayInfo.month))])]), _vm._v(" "), _c('div', {
    staticClass: "cov-date-next",
    on: {
      "click": function($event) {
        return _vm.nextMonth('next')
      }
    }
  }, [_vm._v("»")])]), _vm._v(" "), (_vm.showInfo.day) ? _c('div', {
    staticClass: "cov-date-box"
  }, [_c('div', {
    staticClass: "cov-picker-box"
  }, [_c('div', {
    staticClass: "week"
  }, [_c('ul', _vm._l((_vm.library.week), function(weekie) {
    return _c('li', [_vm._v(_vm._s(weekie))])
  }), 0)]), _vm._v(" "), _vm._l((_vm.dayList), function(day) {
    return _c('div', {
      staticClass: "day",
      class: {
        'checked': day.checked, 'unavailable': day.unavailable, 'passive-day': !(day.inMonth)
      },
      style: (day.checked ? (_vm.option.color && _vm.option.color.checkedDay ? {
        background: _vm.option.color.checkedDay
      } : {
        background: '#F50057'
      }) : {}),
      attrs: {
        "track-by": "$index"
      },
      on: {
        "click": function($event) {
          return _vm.checkDay(day)
        }
      }
    }, [_vm._v(_vm._s(day.value))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.showInfo.year) ? _c('div', {
    staticClass: "cov-date-box list-box"
  }, [_c('div', {
    staticClass: "cov-picker-box date-list",
    attrs: {
      "id": "yearList"
    }
  }, _vm._l((_vm.library.year), function(yearItem) {
    return _c('div', {
      staticClass: "date-item",
      attrs: {
        "track-by": "$index"
      },
      on: {
        "click": function($event) {
          return _vm.setYear(yearItem)
        }
      }
    }, [_vm._v(_vm._s(yearItem))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.showInfo.month) ? _c('div', {
    staticClass: "cov-date-box list-box"
  }, [_c('div', {
    staticClass: "cov-picker-box date-list"
  }, _vm._l((_vm.library.month), function(monthItem) {
    return _c('div', {
      staticClass: "date-item",
      attrs: {
        "track-by": "$index"
      },
      on: {
        "click": function($event) {
          return _vm.setMonth(monthItem)
        }
      }
    }, [_vm._v(_vm._s(monthItem))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.showInfo.hour) ? _c('div', {
    staticClass: "cov-date-box list-box"
  }, [_c('div', {
    staticClass: "cov-picker-box date-list"
  }, [_c('div', {
    staticClass: "watch-box"
  }, [_c('div', {
    staticClass: "hour-box"
  }, [_c('div', {
    staticClass: "mui-pciker-rule mui-pciker-rule-ft"
  }), _vm._v(" "), _c('ul', _vm._l((_vm.hours), function(hitem) {
    return _c('li', {
      staticClass: "hour-item",
      class: {
        'active': hitem.checked
      },
      on: {
        "click": function($event) {
          return _vm.setTime('hour', hitem, _vm.hours)
        }
      }
    }, [_vm._v(_vm._s(hitem.value))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "min-box"
  }, [_c('div', {
    staticClass: "mui-pciker-rule mui-pciker-rule-ft"
  }), _vm._v(" "), _vm._l((_vm.mins), function(mitem) {
    return _c('div', {
      staticClass: "min-item",
      class: {
        'active': mitem.checked
      },
      on: {
        "click": function($event) {
          return _vm.setTime('min', mitem, _vm.mins)
        }
      }
    }, [_vm._v(_vm._s(mitem.value))])
  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-box"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.showInfo.check = false
      }
    }
  }, [_vm._v(_vm._s(_vm.option.buttons ? _vm.option.buttons.cancel : 'Cancel'))]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.picked
    }
  }, [_vm._v(_vm._s(_vm.option.buttons ? _vm.option.buttons.ok : 'Ok'))])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2356 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-xd-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('member-table')], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 2357 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box m-h-700"
  }, [_c('div', {
    staticClass: "box-body form-inline"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/crActivity'
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("新增優惠券活動")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.brandBrief.length > 1 && _vm.$route.name !== 'storeInfo' && _vm.ownerTypeSelect !== 1 && _vm.getRoleType !== 10) ? _c('div', {
    staticClass: "form-group",
    on: {
      "change": _vm.getAttendCoupon
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandSelect),
      expression: "brandSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.brandSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.brandBrief), function(brand) {
    return _c('option', {
      domProps: {
        "value": brand.value
      }
    }, [_vm._v("\n                " + _vm._s(brand.label) + "\n              ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.brandSelect !== 999999 && _vm.brandSelect !== '999999' && _vm.storeBrief.length > 1 && _vm.ownerTypeSelect !== 1 && _vm.getRoleType !== 30) ? _c('div', {
    staticClass: "form-group",
    on: {
      "change": _vm.getAttendCoupon
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeSelect),
      expression: "storeSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.storeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.storeBrief), function(store) {
    return _c('option', {
      domProps: {
        "value": store.value
      }
    }, [_vm._v("\n                " + _vm._s(store.label) + "\n              ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruleCodeSelect),
      expression: "ruleCodeSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ruleCodeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getAttendCoupon]
    }
  }, [_c('option', {
    domProps: {
      "value": 999999
    }
  }, [_vm._v("== 活動規則 ==")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SA00001"
    }
  }, [_vm._v("消費金額滿額贈 (SA00001)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SA00002"
    }
  }, [_vm._v("消費商品數量滿額贈 (SA00002)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SA00003"
    }
  }, [_vm._v("消費指定商品滿額贈 (SA00003)")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeMethodSelect),
      expression: "timeMethodSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.timeMethodSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getAttendCoupon]
    }
  }, [_c('option', {
    domProps: {
      "value": 999999
    }
  }, [_vm._v("== 時間狀態 ==")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "notyet"
    }
  }, [_vm._v("未開始")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "going"
    }
  }, [_vm._v("進行中")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "end"
    }
  }, [_vm._v("已結束")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelect),
      expression: "statusSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.statusSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getAttendCoupon]
    }
  }, [_c('option', {
    domProps: {
      "value": 999999
    }
  }, [_vm._v("== 活動狀態 ==")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("初始狀態")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("編輯中")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("待上架")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("已上架")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("已下架")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('activity_id')
      }
    }
  }, [_vm._v("優惠券活動 (ID)\n                    "), (_vm.sortMethod === 'activity_id') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("規則代碼")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("時間狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("活動狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("擁有者")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('start_time')
      }
    }
  }, [_vm._v("活動開始\n                    "), (_vm.sortMethod === 'start_time') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('end_time')
      }
    }
  }, [_vm._v("活動結束\n                    "), (_vm.sortMethod === 'end_time') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.couponList), function(coupon, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": '/activityInfo/' + coupon.activity_id
      }
    }, [_vm._v("\n                      " + _vm._s(coupon.name) + " (" + _vm._s(coupon.activity_id) + ")\n                    ")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(coupon.rule_code))]), _vm._v(" "), _c('td', [(coupon.time_method === 'notyet') ? _c('label', {
      staticClass: "label label-default"
    }, [_vm._v("未開始")]) : (coupon.time_method === 'going') ? _c('label', {
      staticClass: "label label-success"
    }, [_vm._v("進行中")]) : (coupon.time_method === 'end') ? _c('label', {
      staticClass: "label label-danger"
    }, [_vm._v("已結束")]) : _vm._e()]), _vm._v(" "), _c('td', [(coupon.status === 0) ? _c('label', {
      staticClass: "label label-default"
    }, [_vm._v("初始狀態")]) : (coupon.status === 1) ? _c('label', {
      staticClass: "label label-primary"
    }, [_vm._v("編輯中")]) : (coupon.status === 3) ? _c('label', {
      staticClass: "label label-primary"
    }, [_vm._v("待上架")]) : (coupon.status === 4) ? _c('label', {
      staticClass: "label label-success"
    }, [_vm._v("已上架")]) : _c('label', {
      staticClass: "label label-danger"
    }, [_vm._v("已下架")])]), _vm._v(" "), _c('td', [(coupon.owner_type === 1) ? _c('span', [_vm._v("平台")]) : _vm._e(), _vm._v(" "), (coupon.owner_type === 2) ? _c('span', [_vm._v(_vm._s(coupon.owner_brand_name) + " (" + _vm._s(coupon.owner_id) + ")")]) : _vm._e(), _vm._v(" "), (coupon.owner_type === 3) ? _c('span', [_vm._v(_vm._s(coupon.owner_brand_name) + " - " + _vm._s(coupon.owner_store_name) + " (" + _vm._s(coupon.owner_id) + ")")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(coupon.start_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(coupon.end_time))]), _vm._v(" "), _c('td', [((coupon.status === 0 || coupon.status === 1 || coupon.status === 3) && coupon.strategy_time_method === 'notyet') ? _c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          return _vm.orderCouponPush(coupon)
        }
      }
    }, [_vm._v("上架")]) : _vm._e(), _vm._v(" "), (coupon.status === 4) ? _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "data-target": "#stopModal",
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          _vm.curCoupon = coupon
        }
      }
    }, [_vm._v("下架")]) : _vm._e()]), _vm._v(" "), _c('td', [(coupon.status === 0 || coupon.status === 1) ? _c('router-link', {
      attrs: {
        "to": '/upActivity/' + coupon.activity_id
      }
    }, [_c('button', {
      staticClass: "btn btn-primary"
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])]) : ((coupon.status === 3 || coupon.status === 4) && coupon.time_method === 'notyet') ? _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.orderCouponEdit(coupon)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]) : _vm._e()], 1)])
  }), 0)])]), _vm._v(" "), _c('paginate', {
    ref: "orderPaginate",
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "storesModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\"" + _vm._s(_vm.current.name) + "\"使用門市")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 p-x-0"
  }, _vm._l((_vm.current.store_list), function(store) {
    return _c('label', {
      staticClass: "label label-primary",
      staticStyle: {
        "margin-right": "5px"
      }
    }, [_vm._v(_vm._s(store.name))])
  }), 0)])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.stopOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("確定")])])
}]}

/***/ }),
/* 2358 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body form-inline"
  }, [(_vm.brandBrief.length > 1 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 品牌 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.yearSelect),
      expression: "yearSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.yearSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.yearList), function(year) {
    return _c('option', {
      domProps: {
        "value": year.value
      }
    }, [_vm._v("\n              " + _vm._s(year.label) + "\n            ")])
  }), 0)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "overflow": "scroll",
      "max-height": "500px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(1), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(2)]) : (Object.keys(_vm.statementList).length > 0) ? _c('tbody', _vm._l((_vm.statementList), function(statement, key) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": statement,
        "target": "_blank"
      }
    }, [_vm._v("\n                  點擊下載\n                ")])])])
  }), 0) : (Object.keys(_vm.statementList).length === 0) ? _c('tbody', [_vm._m(3)]) : _vm._e()])])])])]), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary bt-explain",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#reportModal"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle mr-5"
  }), _vm._v("報表欄位說明\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "th-fit"
  }, [_vm._v("月份")]), _vm._v(" "), _c('th', [_vm._v("連結")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "reportModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-c",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header border-b-1"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("欄位說明")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-content-c"
  }, [_c('p', [_vm._v(" - 總會員數 : 曾訂購過的消費者人數")]), _vm._v(" "), _c('p', [_vm._v(" - 總訂購人數 : 本月訂購過的人數")]), _vm._v(" "), _c('p', [_vm._v(" - 總訂單數 : 狀態為已完成的(當月)訂單總數")]), _vm._v(" "), _c('p', [_vm._v(" - 總訂單數(平台) : 從你訂網頁進入訂購 "), _c('a', {
    attrs: {
      "href": "https://order.nidin.shop/"
    }
  }, [_vm._v("https://order.nidin.shop/")])]), _vm._v(" "), _c('p', [_vm._v(" - 總訂單數(專屬) : 從品牌專屬網頁進入訂購")]), _vm._v(" "), _c('p', [_vm._v(" - 總售出商品數 : 已完成狀態訂單下的所有售出商品數")]), _vm._v(" "), _c('p', [_vm._v(" - 總商品金額 : 已完成狀態訂單下的所有商品的金額加總")]), _vm._v(" "), _c('p', [_vm._v(" - 總銷售額 : 已完成狀態訂單下的實付總金額")]), _vm._v(" "), _c('p', [_vm._v(" - 總錯誤筆數 : 產生報表時尚未處理的筆數(未被更新為已完成、可對應例外訂單)")]), _vm._v(" "), _c('p', [_vm._v(" - 每日平均訂單數 : 總訂單數/月天數 ")]), _vm._v(" "), _c('p', [_vm._v(" - 訂單平均商品數 : 總訂單商品數/全部訂單數(所有訂單狀態「已接單」、「已完成」、「門市已取消」…等)")]), _vm._v(" "), _c('p', [_vm._v(" - 訂單平均商品金額 : 總商品金額/全部訂單數(所有訂單狀態「已接單」、「已完成」、「門市已取消」…等)")]), _vm._v(" "), _c('p', [_vm._v(" - 訂單平均銷售額 : 總銷售額/全部訂單數(所有訂單狀態「已接單」、「已完成」、「門市已取消」…等)")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-default bt-c",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("關閉")])])])])])
}]}

/***/ }),
/* 2359 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box m-h-700"
  }, [_c('div', {
    staticClass: "box-body form-inline"
  }, [(_vm.brandBrief.length > 1 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandSelect),
      expression: "brandSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.brandSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.brandBrief), function(brand) {
    return _c('option', {
      domProps: {
        "value": brand.value
      }
    }, [_vm._v("\n                " + _vm._s(brand.label) + "\n              ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.brandSelect !== 99 && _vm.brandSelect !== '99' && _vm.storeBrief.length > 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeSelect),
      expression: "storeSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.storeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.storeBrief), function(store) {
    return _c('option', {
      domProps: {
        "value": store.value
      }
    }, [_vm._v("\n                " + _vm._s(store.label) + "\n              ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('dis-item-table', {
    attrs: {
      "storeId": _vm.storeSelect
    }
  })], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 2360 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      'active': _vm.cMethod == 1
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.getIndex(true, 1)
      }
    }
  }, [_c('a', [_vm._v("活動資訊")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.cMethod == 2
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.getIndex(true, 2)
      }
    }
  }, [_c('a', [_vm._v("贈送規則")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.cMethod == 3
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.getIndex(true, 3)
      }
    }
  }, [_c('a', [_vm._v("折抵規則")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.cMethod == 4
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.getIndex(true, 4)
      }
    }
  }, [_c('a', [_vm._v("優惠券")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.cMethod == 5
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.getIndex(true, 5)
      }
    }
  }, [_c('a', [_vm._v("使用統計")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cMethod === 1),
      expression: "cMethod === 1"
    }],
    staticClass: "row m-b-15 center-block"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動名稱(前台)")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.title))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動名稱(後台)")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.name))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動順序")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.sort))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動說明(前台)")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.content))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動說明(後台)")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.description))])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [(_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  擁有者\n                ")]), _vm._v(" "), (_vm.activity.owner_type) ? _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.activity.owner_type.label) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getRoleType === 99 || (_vm.getRoleType === 30 && !_vm.info.info.activity_id)),
      expression: "getRoleType === 99 || (getRoleType === 30 && !info.info.activity_id)"
    }]
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  參與品牌\n                ")]), _vm._v(" "), (_vm.activity.owner_type.value === 1) ? _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.brandSelectMuti), function(mBrand) {
    return _c('label', {
      staticClass: "label-success label"
    }, [_vm._v(_vm._s(mBrand.label))])
  }), 0) : _c('div', {
    staticClass: "form-control form-info"
  }, [_c('label', {
    staticClass: "label-success label"
  }, [_vm._v(_vm._s(_vm.brandSelect.label))])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group cr-schedule"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                活動開始時間\n              ")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.aTime.start.time))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group cr-schedule"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                活動結束時間\n              ")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.aTime.end.time))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動備註")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.remark))])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_c('h5', [_vm._v("參與店家")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.addStoresSetting.choose), function(store) {
    return _c('label', {
      staticClass: "label-primary label m-r-5"
    }, [_vm._v(_vm._s(_vm.getStoreName(store)))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cMethod === 2),
      expression: "cMethod === 2"
    }],
    staticClass: "row m-b-15 center-block"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('activity-strategy', {
    attrs: {
      "activity": _vm.activity,
      "info": _vm.info,
      "brandList": _vm.brandList,
      "addStoresSetting": _vm.addStoresSetting,
      "storeList": _vm.aStoreList,
      "aStoreOption": _vm.aStoreOption,
      "setInfoTimes": _vm.setInfoTimes
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cMethod === 3),
      expression: "cMethod === 3"
    }],
    staticClass: "row m-b-15 center-block"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('coupon-strategy', {
    attrs: {
      "giveCoupons": _vm.giveCoupons,
      "info": _vm.info,
      "brandList": _vm.brandList,
      "addStoresSetting": _vm.addStoresSetting,
      "storeList": _vm.aStoreList,
      "aStoreOption": _vm.aStoreOption,
      "setInfoTimes": _vm.setInfoTimes
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cMethod === 4),
      expression: "cMethod === 4"
    }],
    staticClass: "row m-b-15 center-block"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('coupon-list', {
    attrs: {
      "giveCoupons": _vm.giveCoupons,
      "info": _vm.info,
      "brandList": _vm.brandList,
      "storeList": _vm.aStoreList,
      "activity": _vm.activity,
      "setInfoTimes": _vm.setInfoTimes
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cMethod === 5),
      expression: "cMethod === 5"
    }],
    staticClass: "row m-b-15 center-block"
  }, [_c('activity-summary', {
    attrs: {
      "storeBrief": _vm.aStoreList,
      "getStoreName": _vm.getStoreName
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_vm._v("ˋ\n      "), (_vm.cMethod === 1) ? _c('button', {
    staticClass: "btn btn-fail",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n        取消\n      ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.cMethod--
      }
    }
  }, [_vm._v("\n        上一頁\n      ")]), _vm._v(" "), (_vm.cMethod !== 5) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.cMethod++
      }
    }
  }, [_vm._v("\n        下一頁\n      ")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.couponList), function(cInfo, index) {
    return _c('div', [_c('div', {
      staticClass: "modal fade",
      attrs: {
        "id": 'couponRegisterModal' + index,
        "role": "dialog"
      }
    }, [_c('div', {
      staticClass: "modal-dialog choose-modal"
    }, [_c('div', {
      staticClass: "modal-content pull-left"
    }, [_vm._m(0, true), _vm._v(" "), (_vm.coupon.coupon_info) ? _c('div', {
      staticClass: "card m-y-1 pull-left m-y-10 c-pointer",
      staticStyle: {
        "width": "calc(100% - 80px)"
      },
      attrs: {
        "data-target": '#couponRegisterModal' + index,
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          return _vm.clickCoupon()
        }
      }
    }, [_c('div', {
      staticClass: "coupon-left p-10"
    }, [_c('h4', [(_vm.coupon.coupon_info.name) ? _c('span', [_vm._v(_vm._s(_vm.coupon.coupon_info.name))]) : _c('span', [_vm._v("優惠券名稱")])]), _vm._v(" "), _c('h5', [(_vm.coupon.coupon_info.description) ? _c('span', [_vm._v(_vm._s(_vm.coupon.coupon_info.description))]) : _c('span', [_vm._v("優惠券描述....")])]), _vm._v(" "), _c('h5', [_vm._v("到期："), (_vm.coupon.time_config.start_time.time) ? _c('span', [_vm._v(_vm._s(_vm.coupon.time_config.start_time.time) + " ~ " + _vm._s(_vm.coupon.time_config.end_time.time))]) : _c('span', [_vm._v(_vm._s(_vm.nowTime) + " ~ " + _vm._s(_vm.nowTime))])])]), _vm._v(" "), _c('div', {
      staticClass: "coupon-right p-10"
    }, [_c('div', {
      staticClass: "v-middle"
    }, [_vm._v("\n                  $"), (_vm.coupon.coupon_info.discount_value) ? _c('span', [_vm._v(_vm._s(_vm.coupon.coupon_info.discount_value))]) : _c('span', [_vm._v("10")])])])]) : _vm._e()])])])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header pull-left w-100-p"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title text-left"
  }, [_vm._v("優惠券設定")])])
}]}

/***/ }),
/* 2361 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box text-center"
  }, [_c('div', {
    staticClass: "box-body form"
  }, [_c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandSelect),
      expression: "brandSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.brandSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.brandBrief), function(brand) {
    return _c('option', {
      domProps: {
        "value": brand.value
      }
    }, [_vm._v(_vm._s(brand.label))])
  }), 0)])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeSelect),
      expression: "storeSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.storeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.storeBrief), function(store) {
    return _c('option', {
      domProps: {
        "value": store.value
      }
    }, [_vm._v(_vm._s(store.label))])
  }), 0)])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.trade_no),
      expression: "info.trade_no"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.info.trade_no)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "trade_no", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tradeTypeSelect),
      expression: "tradeTypeSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tradeTypeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.getECtradeType), function(trade) {
    return _c('option', {
      domProps: {
        "value": trade.value
      }
    }, [_vm._v("\n                    " + _vm._s(trade.label) + "\n                  ")])
  }), 0)])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.searchAccount()
      }
    }
  }, [_vm._v("\n            查詢\n          ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body form text-left"
  }, [_c('pre', [_vm._v(_vm._s(JSON.stringify(_vm.tradeInfo, null, 2)))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("品牌\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("店家\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("交易序號\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("線上付款類型\n              ")])
}]}

/***/ }),
/* 2362 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.menuList), function(m, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v("\n          " + _vm._s(index + 1) + "\n        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.menu_name) + " (" + _vm._s(m.menu_id) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.start_time) + " ~ " + _vm._s(m.end_time))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          return _vm.editStores(_vm.s.menu_id, _vm.s.store_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), 0)])]), _vm._v(" "), (_vm.path != 'upScheduleAll' && _vm.path != 'upScheduleOne') ? _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('ul', {
    staticClass: "pagination"
  }, _vm._l((5), function(index) {
    return _c('li', {
      staticClass: "paginate_button",
      class: {
        active: _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          return _vm.clickPage(index)
        }
      }
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v(_vm._s(index))])])
  }), 0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("菜單(ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("上架時間")]), _vm._v(" "), _c('th')])])
}]}

/***/ }),
/* 2363 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.option.id,
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.option.title))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", function() {
    return [_c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.option.body)
      }
    }), _vm._v(" "), (_vm.selectOptions || _vm.option.input) ? _c('div', {
      staticClass: "box-body form p-x-0"
    }, [(_vm.selectOptions) ? _c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n              " + _vm._s(_vm.selectOptions.name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "form-group m-0"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected),
        expression: "selected"
      }],
      staticClass: "form-control h-38",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, _vm.selectOnChange]
      }
    }, _vm._l((_vm.selectOptions.options), function(option) {
      return _c('option', {
        domProps: {
          "value": option.value
        }
      }, [_vm._v("\n                    " + _vm._s(option.text) + " "), (option.value !== null) ? _c('span', [_vm._v("(" + _vm._s(option.value) + ")")]) : _vm._e()])
    }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.option.input) ? _c('div', [_c('br'), _vm._v(" "), _c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v(_vm._s(_vm.option.input.name))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.inputValue),
        expression: "inputValue"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "",
        "type": "text"
      },
      domProps: {
        "value": (_vm.inputValue)
      },
      on: {
        "change": function($event) {
          return _vm.inputOnChange(_vm.inputValue)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.inputValue = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('br')]) : _vm._e()]) : _vm._e()]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    style: ({
      'text-align': _vm.option.footerTextAlign || 'right'
    })
  }, _vm._l((_vm.option.btns), function(btn) {
    return _c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-dismiss": "modal"
      },
      on: {
        "click": function($event) {
          return _vm.trigger(btn.event)
        }
      }
    }, [_vm._v(_vm._s(btn.name))])
  }), 0)])])])
},staticRenderFns: []}

/***/ }),
/* 2364 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.option.id,
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog choose-modal"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title text-left"
  }, [_vm._v(_vm._s(_vm.option.title))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body text-left"
  }, _vm._l((_vm.adjustList), function(adjust) {
    return (adjust.active) ? _c('div', {
      key: adjust.item_id,
      staticClass: "text-left"
    }, [_c('h5', {
      staticClass: "p-l-10"
    }, [_vm._v(_vm._s(adjust.name) + "  \n            $ \n            "), _c('price-input', {
      attrs: {
        "item": adjust,
        "id": adjust.adjust_id
      },
      on: {
        "trigger": _vm.trigger
      }
    })], 1), _vm._v(" "), _vm._l((adjust.child_list), function(option) {
      return (option.active) ? _c('div', {
        key: option.item_id,
        staticClass: "btn-money-element",
        staticStyle: {
          "font-size": "14px"
        }
      }, [_vm._v("\n            " + _vm._s(option.name) + "\n            "), _c('div', {
        staticClass: "m-t-5"
      }, [_vm._v("\n              $ \n              "), _c('price-input', {
        class: {
          disabled: adjust.price
        },
        attrs: {
          "item": option,
          "id": option.option_id
        },
        on: {
          "trigger": _vm.trigger
        }
      })], 1)]) : _vm._e()
    })], 2) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(!_vm.hideCancel) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          確定\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 2365 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [(_vm.getRoleType === 99) ? _c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-10 flex align-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.goBackInfo.name,
        params: _vm.goBackInfo.params,
        query: _vm.goBackInfo.query
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default m-r-5 flex"
  }, [_c('span', [_vm._v("返回")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.title)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.subtitle)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex grey darken-1"
  }, [(_vm.brand.name || _vm.store.brand_name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s(_vm.brand.name ? _vm.brand.name : _vm.store.brand_name ? _vm.store.brand_name : '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s('/')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.store.name)
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 可編輯門市" + _vm._s(_vm.$route.name.includes('ProductImage') ? '圖示' : '別名/描述/警語') + " ")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchSelect),
      expression: "searchSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("名稱")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchInput),
      expression: "searchInput"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchInput = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.searchStore()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("門市")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("名稱 (ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("縮寫")]), _vm._v(" "), (!_vm.history) ? _c('th', {
    staticClass: "th-fat",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("地址")]) : _vm._e(), _vm._v(" "), (_vm.getRoleType !== 50) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.storeList), function(store, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v("\n                        " + _vm._s(index + 1) + "\n                      ")]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "target": "_blank",
        "href": _vm.webDomain + 'menu/' + store.id
      }
    }, [_c('img', {
      staticClass: "img-brand-table",
      attrs: {
        "src": store.image
      }
    })])]), _vm._v(" "), _c('td', [(_vm.$route.name == 'storeHistoryTable') ? _c('span', [_vm._v(_vm._s(store.name) + " (" + _vm._s(store.id) + ")")]) : _vm._e(), _vm._v(" "), (_vm.$route.name != 'storeHistoryTable') ? _c('router-link', {
      attrs: {
        "to": {
          path: '/storeInfo/' + _vm.$route.params.brand_id + '/' + store.id
        }
      }
    }, [_vm._v(_vm._s(store.name) + " (" + _vm._s(store.id) + ")")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(store.name_short))]), _vm._v(" "), (!_vm.history) ? _c('td', [_c('small', [_vm._l((_vm.getPickupType), function(deliveryTeyp) {
      return (_vm.getDTypeInfo(store.delivery_info, deliveryTeyp) && _vm.getDTypeInfo(store.delivery_info, deliveryTeyp).is_support) ? _c('span', [(_vm.getDTypeInfo(store.delivery_info, deliveryTeyp).delivery_type === 1) ? _c('i', {
        staticClass: "fa fa-hand-paper-o",
        attrs: {
          "aria-hidden": "true"
        }
      }) : _vm._e(), _vm._v(" "), (_vm.getDTypeInfo(store.delivery_info, deliveryTeyp).delivery_type === 2) ? _c('i', {
        staticClass: "fa fa-inbox",
        attrs: {
          "aria-hidden": "true"
        }
      }) : _vm._e(), _vm._v(" "), (_vm.getDTypeInfo(store.delivery_info, deliveryTeyp).delivery_type === 3) ? _c('i', {
        staticClass: "fa fa-motorcycle",
        attrs: {
          "aria-hidden": "true"
        }
      }) : _vm._e(), _vm._v(" "), (_vm.getDTypeInfo(store.delivery_info, deliveryTeyp).delivery_type === 4) ? _c('i', {
        staticClass: "fa fa-shopping-bag",
        attrs: {
          "aria-hidden": "true"
        }
      }) : _vm._e(), _vm._v(" "), (_vm.getDTypeInfo(store.delivery_info, deliveryTeyp).delivery_type === 5) ? _c('i', {
        staticClass: "fa fa-glass",
        attrs: {
          "aria-hidden": "true"
        }
      }) : _vm._e(), _vm._v(" "), (_vm.getDTypeInfo(store.delivery_info, deliveryTeyp).delivery_type === 21) ? _c('i', {
        staticClass: "fa fa-qrcode",
        attrs: {
          "aria-hidden": "true"
        }
      }) : _vm._e(), _vm._v("\n                             \n                          ")]) : _vm._e()
    }), _vm._v("\n                          " + _vm._s(store.address) + "\n                        ")], 2)]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "flex"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: _vm.$route.path + '/' + store.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), (_vm.getRoleType !== 10 || _vm.getStores.length > 1) ? _c('button', {
      staticClass: "btn btn-default m-l-5",
      on: {
        "click": function($event) {
          return _vm.copyStore(store.id)
        }
      }
    }, [_vm._v("複製此分店所有設定至其他店家")]) : _vm._e()], 1)])
  }), 0)])]), _vm._v(" "), _c('paginate', {
    ref: "brandPaginate",
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 可複製此分店所有設定至其他店家 ")])
}]}

/***/ }),
/* 2366 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_c('div', {
    staticClass: "col-xs-12 text-left form-group"
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title",
    on: {
      "click": function($event) {
        return _vm.crElement()
      }
    }
  }, [_vm._v("新增菜單圖示")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.imgList), function(img, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('div', [_c('img', {
      staticClass: "img img-responsive",
      attrs: {
        "src": img.url,
        "width": "30"
      }
    })])]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(img.icon_id))])]), _vm._v(" "), _c('td', [(img.is_visible) ? _c('label', {
      staticClass: "label label-success"
    }, [_vm._v("顯示")]) : _c('label', {
      staticClass: "label label-danger"
    }, [_vm._v("隱藏")])]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(img.name) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(img.description) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(img.sort) + "\n          ")]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.upElement(img.icon_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), 0)])]), _vm._v(" "), _c('paginate', {
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("圖示")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("顯示")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("名稱")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("描述")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("排序")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])])
}]}

/***/ }),
/* 2367 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box form-inline"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelect),
      expression: "statusSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.statusSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 99
    }
  }, [_vm._v("== 對帳狀態 ==")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("訂單帳務有衝突")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("帳務紀錄有缺")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 4
    }
  }, [_vm._v("帳務記錄冗余")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.processedSelect),
      expression: "processedSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.processedSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 99
    }
  }, [_vm._v("== 處理狀態 ==")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("已處理")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("未處理")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(1)]) : (_vm.accountList.length > 0) ? _c('tbody', _vm._l((_vm.accountList), function(account, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(account.trade_identifier))]), _vm._v(" "), _c('td', [_vm._v("\n                    $ " + _vm._s(account.money) + "\n                  ")]), _vm._v(" "), _c('td', [(account.accounting_type === 1) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("付款")]) : (account.accounting_type === 2) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("退款")]) : _vm._e()]), _vm._v(" "), _c('td', [(account.is_processed) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("已處理")]) : (!account.is_processed) ? _c('span', {
      staticClass: "label label-default"
    }, [_vm._v("未處理")]) : _vm._e()]), _vm._v(" "), _c('td', [(account.status === 2) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("失敗 訂單帳務有衝突")]) : (account.status === 3) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("失敗 帳務紀錄有缺")]) : (account.status === 4) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("失敗 帳務記錄冗余")]) : _c('span', {
      staticClass: "label label-default"
    }, [_vm._v("尚未對帳")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(account.create_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(account.update_time))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#confirmModal"
      },
      on: {
        "click": function($event) {
          return _vm.getCurrentId(account.error_id, account.is_processed)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), 0) : (_vm.accountList.length === 0) ? _c('tbody', [_vm._m(2)]) : _vm._e()])]), _vm._v(" "), _c('paginate', {
    ref: "brandPaginate",
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])])])]), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.confirmOption,
      "selectOptions": _vm.selectOptions
    },
    on: {
      "trigger": _vm.trigger,
      "selectOnChange": _vm.selectOnChange
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("交易序號")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("交易類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("處理狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("對帳狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("建立時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("更新時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
}]}

/***/ }),
/* 2368 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-left"
  }, [_c('div', {
    staticClass: "box-body form"
  }, [_c('br'), _vm._v(" "), (_vm.info && _vm.show.delBtn) ? _c('div', {
    staticClass: "del-block"
  }, [_c('div', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    }
  }, [_vm._v("刪除群組")])]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("群組ID")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n          " + _vm._s(_vm.info.id) + "\n        ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandName),
      expression: "brandName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.brandName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.brandName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.info) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("建立時間")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n          " + _vm._s(_vm.info.create_time) + "\n        ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("更新時間")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n          " + _vm._s(_vm.info.edit_time) + "\n        ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("綁定店家")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('div', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.goToStoreTable()
      }
    }
  }, [_vm._v("\n            綁定其他店家\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.info.stores), function(store) {
    return _c('div', {
      staticClass: "label-stores inline-block m-y-10"
    }, [_c('span', {
      staticClass: "label label-primary c-pointer",
      on: {
        "click": function($event) {
          return _vm.goToEditStore(store.store_id)
        }
      }
    }, [_vm._v(_vm._s(store.store_name) + " (" + _vm._s(store.store_id) + ")")]), _vm._v(" "), _c('br')])
  })], 2)]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        path: '/groupTable/' + _vm.$route.params.brand_id
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("\n        取消\n      ")])]), _vm._v(" "), (!_vm.info) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.addGroup()
      }
    }
  }, [_vm._v("\n      新增\n    ")]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.upGroup()
      }
    }
  }, [_vm._v("\n      修改\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("群組名稱\n      ")])
}]}

/***/ }),
/* 2369 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    帳務ID\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                    " + _vm._s(_vm.accountInfo.accounting_id) + "\n                  ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    訂單ID\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('router-link', {
    attrs: {
      "target": "_blank",
      "to": '/orderInfo/' + _vm.accountInfo.order_id
    }
  }, [_vm._v(_vm._s(_vm.accountInfo.order_id))]), _vm._v("  \n                    "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-target": "#orderModal",
      "data-toggle": "modal"
    },
    on: {
      "click": _vm.checkOrderInfo
    }
  }, [_vm._v("訂單交易資訊")])], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    付款類型\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.accountInfo.vendor_type === 707) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("LINE PAY")]) : (_vm.accountInfo.vendor_type === 701) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("iPASS MONEY")]) : (_vm.accountInfo.vendor_type === 710) ? _c('span', {
    staticClass: "label label-primary"
  }, [_vm._v("信用卡")]) : (_vm.accountInfo.vendor_type === 713) ? _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v("台灣Pay")]) : (_vm.accountInfo.vendor_type === 716) ? _c('span', {
    staticClass: "label label-primary"
  }, [_vm._v("全盈+PAY")]) : (_vm.accountInfo.vendor_type === 717) ? _c('span', {
    staticClass: "label label-primary"
  }, [_vm._v("悠遊付")]) : (_vm.accountInfo.vendor_type === 718) ? _c('span', {
    staticClass: "label label-info"
  }, [_vm._v("Pi 拍錢包")]) : (_vm.accountInfo.vendor_type === 719) ? _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v("全支付")]) : (_vm.accountInfo.vendor_type === 720) ? _c('span', {
    staticClass: "label label-info"
  }, [_vm._v("icash Pay")]) : (_vm.accountInfo.vendor_type === 908) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("街口支付")]) : (_vm.accountInfo.vendor_type === 909) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("遠傳電信代收")]) : _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v("其他")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    交易類型\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.accountInfo.accounting_type === 1) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("付款")]) : (_vm.accountInfo.accounting_type === 2) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("退款")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    對帳進度\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.accountInfo.is_confirmed) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("已完成")]) : (!_vm.accountInfo.is_confirmed) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("未完成")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    最後狀態\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.accountInfo.latest_status === 1) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("成功")]) : (_vm.accountInfo.latest_status === 2) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("失敗 訂單帳務有衝突")]) : (_vm.accountInfo.latest_status === 3) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("成功 帳務紀錄有缺")]) : (_vm.accountInfo.latest_status === 4) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("成功 帳務記錄冗余")]) : _c('span', {
    staticClass: "label label-default"
  }, [_vm._v("尚未對帳")])])]), _vm._v(" "), _c('br')])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    交易編號 (ID)\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.accountInfo.trade_no) + " (" + _vm._s(_vm.accountInfo.trade_id) + ")\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    交易金額\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                $ " + _vm._s(_vm.accountInfo.money) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    交易日期\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.accountInfo.trade_date) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    更新時間\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.accountInfo.update_time) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    建立時間\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.accountInfo.create_time) + "\n              ")])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', {
    staticClass: "col-xs-12 table-responsive p-x-0"
  }, [_c('br'), _vm._v(" "), _c('h5', [_vm._v("對帳歷史紀錄")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.trackingList), function(track, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(track.tracking_id))]), _vm._v(" "), _c('td', [(track.status === 1) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("成功")]) : (track.status === 2) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("失敗 訂單帳務有衝突")]) : (track.status === 3) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("失敗 帳務紀錄有缺")]) : (track.status === 4) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("失敗 帳務記錄冗余")]) : _c('span', {
      staticClass: "label label-default"
    }, [_vm._v("尚未對帳")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(track.change_remark))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(track.create_time))])])
  }), 0)]), _vm._v(" "), _c('br'), _c('br')])])])])]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-left"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("對帳ID")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("對帳狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("備註")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("建立時間")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "orderModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("訂單交易資訊")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('pre', {
    attrs: {
      "id": "order-info"
    }
  })])])])])])
}]}

/***/ }),
/* 2370 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12 text-left"
  }, [(_vm.roleType === 30) ? _c('div', {
    staticClass: "m-b-15"
  }, [_vm._v("\n        會員總數： " + _vm._s(_vm.total) + " 人\n      ")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginType),
      expression: "loginType"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.loginType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.getMemberList(1)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("== 登入類型 ==")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("手機")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Facebook")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Google")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Line")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("街口")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("車廠")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("品牌既有會員")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchSelect),
      expression: "searchSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.roleType === 99) ? _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("信箱")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("手機")]), _vm._v(" "), (_vm.roleType === 99) ? _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("暱稱")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("會員ID")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("編號")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.result),
      expression: "search.result"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.result)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "result", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.clickSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("編號")]), _vm._v(" "), (_vm.roleType === 99) ? _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("ID")]) : _vm._e(), _vm._v(" "), (_vm.hasExistingMember && (_vm.roleType === 30 || _vm.roleType === 10)) ? _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("品牌既有會員 ID")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("暱稱")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("手機")]), _vm._v(" "), (_vm.roleType === 99) ? _c('th', {
    staticClass: "vertical-m",
    staticStyle: {
      "min-width": "72px"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("登入類型")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("手機認證")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("開通")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("權限")]) : _vm._e(), _vm._v(" "), (_vm.roleType !== 10) ? _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("性別")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("信箱")]) : _vm._e(), _vm._v(" "), (_vm.roleType !== 10) ? _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("生日")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("建立時間")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("整合狀態")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("是否為訪客")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("訂單記錄")]), _vm._v(" "), (_vm.roleType === 99) ? _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("整合紀錄")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }) : _vm._e()])]), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(0)]) : (_vm.memberList.length === 0) ? _c('tbody', [_vm._m(1)]) : (_vm.memberList.length > 0) ? _c('tbody', _vm._l((_vm.memberList), function(member, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n            " + _vm._s(index + 1) + "\n          ")]), _vm._v(" "), _c('td', [(_vm.roleType === 99) ? _c('router-link', {
      attrs: {
        "to": {
          path: 'memberInfo/' + member.shopper_id
        },
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(member.user_no))]) : _vm._e(), _vm._v(" "), (_vm.roleType === 30 || _vm.roleType === 10) ? _c('span', [_vm._v(_vm._s(member.user_no))]) : _vm._e()], 1), _vm._v(" "), (_vm.roleType === 99) ? _c('td', [_vm._v(_vm._s(member.shopper_id))]) : _vm._e(), _vm._v(" "), (_vm.hasExistingMember && (_vm.roleType === 30 || _vm.roleType === 10)) ? _c('td', [_vm._v("\n            " + _vm._s(member.vendor_custom_user_no) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(member.nickname)), (member.last_name || member.first_name) ? _c('span', [_vm._v(" (" + _vm._s(member.last_name) + _vm._s(member.first_name) + ")")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(member.phone))]), _vm._v(" "), (_vm.roleType === 99) ? _c('td', [(member.create_account_type == 1) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      attrs: {
        "src": "/static/img/icon/phone-v2.svg"
      }
    })]) : _vm._e(), _vm._v(" "), (member.create_account_type == 2) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      attrs: {
        "src": "/static/img/icon/fb.png"
      }
    })]) : _vm._e(), _vm._v(" "), (member.create_account_type == 3) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      attrs: {
        "src": "/static/img/icon/google.png"
      }
    })]) : _vm._e(), _vm._v(" "), (member.create_account_type == 4) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      staticStyle: {
        "margin-right": "8px"
      },
      attrs: {
        "src": "/static/img/icon/line.png"
      }
    })]) : _vm._e(), _vm._v(" "), (member.create_account_owner_type == 2 && member.create_account_type == 4) ? _c('span', [_vm._v("\n              (" + _vm._s(member.create_account_owner_brand_name) + ")\n            ")]) : (member.create_account_owner_type == 1 && member.create_account_type == 4) ? _c('span', [_vm._v("\n              (你訂)\n            ")]) : _vm._e(), _vm._v(" "), (member.create_account_type == 5) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      attrs: {
        "src": "/static/img/icon/jkos.svg"
      }
    })]) : _vm._e(), _vm._v(" "), (member.create_account_type == 6) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      attrs: {
        "src": "/static/img/icon/car.png"
      }
    })]) : _vm._e(), _vm._v(" "), (member.create_account_type == 7) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      attrs: {
        "src": "/static/img/icon/existing-member.png",
        "alt": "品牌既有會員"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(member.create_account_owner_brand_name))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('td', [(member.is_phone_valid) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("通過")]) : _vm._e(), _vm._v(" "), (!member.is_phone_valid) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("未通過")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('td', [(member.is_active) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("啟動")]) : _vm._e(), _vm._v(" "), (!member.is_active) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("未啟動")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('td', [(!member.is_suspend) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("正常")]) : _vm._e(), _vm._v(" "), (member.is_suspend) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("停權")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.roleType !== 10) ? _c('td', [(member.sex == 1) ? _c('span', {
      staticClass: "text-blue"
    }, [_c('i', {
      staticClass: "fa fa-male",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e(), _vm._v(" "), (member.sex == 2) ? _c('span', {
      staticClass: "text-red"
    }, [_c('i', {
      staticClass: "fa fa-female",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('td', [_vm._v(_vm._s(member.email))]) : _vm._e(), _vm._v(" "), (_vm.roleType !== 10) ? _c('td', [_vm._v(_vm._s(member.birth))]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('td', [_vm._v(_vm._s(member.create_time))]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('td', [(member.is_integrated === 1 && member.integrated_shopper_list.length > 0) ? _c('span', {
      staticClass: "tag-default text-white bg-blue"
    }, [_vm._v("\n              主帳號\n            ")]) : (member.is_integrated === 1 && member.integrated_shopper_list.length === 0) ? _c('span', {
      staticClass: "tag-default text-white bg-orange"
    }, [_vm._v("\n              副帳號\n            ")]) : _c('span', {
      staticClass: "tag-default text-white bg-gray-2"
    }, [_vm._v("\n              尚未整合\n            ")])]) : _vm._e(), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(member.is_guest ? '是' : '否'))])]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/memberOrderTable/' + member.shopper_id
        },
        "target": "_blank"
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-list-alt",
      attrs: {
        "aria-hidden": "true"
      }
    })])])], 1), _vm._v(" "), (_vm.roleType === 99 && member.integrated_shopper_list) ? _c('td', [(member.integrated_shopper_list.length > 0) ? _c('router-link', {
      attrs: {
        "to": {
          path: '/upgradememberInfo/' + member.shopper_id
        },
        "target": "_blank"
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('img', {
      staticClass: "full-whdth",
      attrs: {
        "src": __webpack_require__(363),
        "alt": "point_icon"
      }
    })])]) : (member.is_integrated && member.main_shopper_id) ? _c('router-link', {
      attrs: {
        "to": {
          path: '/upgradememberInfo/' + member.main_shopper_id
        },
        "target": "_blank"
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('img', {
      staticClass: "full-whdth",
      attrs: {
        "src": __webpack_require__(363),
        "alt": "point_icon"
      }
    })])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/upMember/' + member.shopper_id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])])], 1) : _vm._e()])
  }), 0) : _vm._e()])]), _vm._v(" "), (_vm.memberList.length) ? _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickEnd('pre')
      }
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickGroup('left')
      }
    }
  }, [_vm._m(3)]), _vm._v(" "), _vm._l((_vm.pageAmount), function(index) {
    return (_vm.pageShow(index)) ? _c('li', {
      staticClass: "paginate_button",
      class: {
        active: _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          return _vm.clickPage(index)
        }
      }
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v(_vm._s(index))])]) : _vm._e()
  }), _vm._v(" "), _vm._l(((_vm.groupAmount - Math.ceil(_vm.pageAmount % 10))), function(dis) {
    return (_vm.pageGroup === Math.ceil(_vm.pageAmount / _vm.groupAmount)) ? _c('li', {
      staticClass: "paginate_button disabled"
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v("  ")])]) : _vm._e()
  }), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickGroup('right')
      }
    }
  }, [_vm._m(4)]), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickEnd('forward')
      }
    }
  }, [_vm._m(5)])], 2)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "18"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-step-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-forward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-step-forward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 2371 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [(!_vm.history && (_vm.getRoleType === 99 || _vm.getRoleType === 30)) ? _c('div', {
    staticClass: "form-group text-left"
  }, [(_vm.getRoleType === 99) ? _c('router-link', {
    attrs: {
      "to": {
        path: '/crStore/' + _vm.$route.params.brand_id
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("新增門市")])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType !== 50 && _vm.getRoleType !== 10) ? _c('router-link', {
    attrs: {
      "to": {
        path: '/batchSetupStore/' + _vm.$route.params.brand_id
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("批次設定門市資訊")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelect),
      expression: "statusSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.statusSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.statusTypeList), function(type, index) {
    return _c('option', {
      key: ("option-" + index),
      domProps: {
        "value": type.value
      }
    }, [_vm._v("\n                      " + _vm._s(type.label) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderStatusSelect),
      expression: "orderStatusSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.orderStatusSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("== 接單狀態 ==")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("接單中")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("不接單")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isSearchSelect),
      expression: "isSearchSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isSearchSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("== 搜尋狀態 ==")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("可搜尋")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("不可搜尋")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trTypeSelect),
      expression: "trTypeSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.trTypeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.getTradeType), function(trade) {
    return _c('option', {
      domProps: {
        "value": trade.value
      }
    }, [_vm._v("\n                      " + _vm._s(trade.label) + "\n                    ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchSelect),
      expression: "searchSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("名稱")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchInput),
      expression: "searchInput"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchInput = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.searchStore()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "btn btn-default btn-table-title",
    attrs: {
      "disabled": _vm.isDownloading
    },
    on: {
      "click": function($event) {
        return _vm.exportFile()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v("\n                  匯出門市清單\n                  "), _c('Clip', {
    staticClass: "cliploading",
    attrs: {
      "loading": _vm.isDownloading,
      "color": '#528BB8',
      "size": '16px'
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("門市")]), _vm._v(" "), _c('th', {
    staticClass: "th-fat",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("名稱 (ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("縮寫")]), _vm._v(" "), (!_vm.history) ? _c('th', {
    staticClass: "th-fat",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("地址")]) : _vm._e(), _vm._v(" "), (!_vm.history) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("電話")]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("營業")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("接單")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("前台")]), _vm._v(" "), (!_vm.history) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("搜尋")]) : _vm._e(), _vm._v(" "), (!_vm.history) ? _c('th', {
    staticClass: "th-fit",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("付款")]) : _vm._e(), _vm._v(" "), (!_vm.history && _vm.getRoleType === 99) ? _c('th', {
    staticClass: "th-fat",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("計費方式")]) : _vm._e(), _vm._v(" "), (!_vm.history) ? _c('th', {
    staticClass: "th-fit",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("廣告")]) : _vm._e(), _vm._v(" "), (_vm.getRoleType !== 50) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.storeList), function(store, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v("\n                        " + _vm._s(index + 1) + "\n                      ")]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "target": "_blank",
        "href": _vm.webDomain + 'menu/' + store.id
      }
    }, [_c('img', {
      staticClass: "img-brand-table",
      attrs: {
        "src": store.image
      }
    })])]), _vm._v(" "), _c('td', [(_vm.$route.name == 'storeHistoryTable') ? _c('span', [_vm._v(_vm._s(store.name) + " (" + _vm._s(store.id) + ")")]) : _vm._e(), _vm._v(" "), (_vm.$route.name != 'storeHistoryTable') ? _c('router-link', {
      attrs: {
        "to": {
          path: '/storeInfo/' + _vm.$route.params.brand_id + '/' + store.id
        }
      }
    }, [_vm._v(_vm._s(store.name) + " (" + _vm._s(store.id) + ")")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(store.name_short))]), _vm._v(" "), (!_vm.history) ? _c('td', [_c('small', [_vm._l((_vm.getPickupType), function(deliveryTeyp) {
      return (_vm.getDTypeInfo(store.delivery_info, deliveryTeyp) && _vm.getDTypeInfo(store.delivery_info, deliveryTeyp).is_support) ? _c('span', [(_vm.getDTypeInfo(store.delivery_info, deliveryTeyp).delivery_type === 1) ? _c('i', {
        staticClass: "fa fa-hand-paper-o",
        attrs: {
          "aria-hidden": "true"
        }
      }) : _vm._e(), _vm._v(" "), (_vm.getDTypeInfo(store.delivery_info, deliveryTeyp).delivery_type === 2) ? _c('i', {
        staticClass: "fa fa-inbox",
        attrs: {
          "aria-hidden": "true"
        }
      }) : _vm._e(), _vm._v(" "), (_vm.getDTypeInfo(store.delivery_info, deliveryTeyp).delivery_type === 3) ? _c('i', {
        staticClass: "fa fa-motorcycle",
        attrs: {
          "aria-hidden": "true"
        }
      }) : _vm._e(), _vm._v(" "), (_vm.getDTypeInfo(store.delivery_info, deliveryTeyp).delivery_type === 4) ? _c('i', {
        staticClass: "fa fa-shopping-bag",
        attrs: {
          "aria-hidden": "true"
        }
      }) : _vm._e(), _vm._v(" "), (_vm.getDTypeInfo(store.delivery_info, deliveryTeyp).delivery_type === 5) ? _c('i', {
        staticClass: "fa fa-glass",
        attrs: {
          "aria-hidden": "true"
        }
      }) : _vm._e(), _vm._v(" "), (_vm.getDTypeInfo(store.delivery_info, deliveryTeyp).delivery_type === 21) ? _c('i', {
        staticClass: "fa fa-qrcode",
        attrs: {
          "aria-hidden": "true"
        }
      }) : _vm._e(), _vm._v("\n                             \n                          ")]) : _vm._e()
    }), _vm._v("\n                          " + _vm._s(store.address) + "\n                        ")], 2)]) : _vm._e(), _vm._v(" "), (!_vm.history) ? _c('td', [_vm._v(_vm._s(store.tel) + " "), _c('br'), _vm._v(" " + _vm._s(store.tel2))]) : _vm._e(), _vm._v(" "), _c('td', [(store.status == 2) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v(_vm._s(_vm.getStateName(store.status)))]) : _vm._e(), _vm._v(" "), (store.status != 2) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v(_vm._s(_vm.getStateName(store.status)))]) : _vm._e()]), _vm._v(" "), _c('td', [(store.order_status == 10) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("接單中")]) : _vm._e(), _vm._v(" "), (store.order_status == 20) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("不接單")]) : _vm._e()]), _vm._v(" "), _c('td', [(store.is_visible) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("顯示")]) : _vm._e(), _vm._v(" "), (!store.is_visible) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("隱藏")]) : _vm._e()]), _vm._v(" "), _c('td', [(store.is_search) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("可搜")]) : _vm._e(), _vm._v(" "), (!store.is_search) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("不可搜")]) : _vm._e()]), _vm._v(" "), _c('td', _vm._l((store.trade_info), function(trade) {
      return (trade.is_enable) ? _c('span', [_c('label', {
        staticClass: "label",
        class: _vm.stateColor(trade.name)
      }, [_vm._v(_vm._s(_vm.tradeType(trade.name)))]), _c('br')]) : _vm._e()
    }), 0), _vm._v(" "), (!_vm.history && _vm.getRoleType === 99) ? _c('td', [(store.order_commission_setting && store.order_commission_setting.type === 3) ? _c('span', [_vm._v("資訊服務費抽成")]) : (store.order_commission_setting && store.order_commission_setting.type === 2) ? _c('span', [_vm._v("系統費+資訊服務費抽成")]) : _c('span', [_vm._v("系統費")])]) : _vm._e(), _vm._v(" "), (!_vm.history) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/adTable/' + _vm.$route.params.brand_id + '/' + store.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-file-image-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])])], 1) : _vm._e(), _vm._v(" "), (!_vm.history && _vm.getRoleType !== 50) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/upStore/' + _vm.$route.params.brand_id + '/' + store.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])])], 1) : _vm._e(), _vm._v(" "), (_vm.history) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/oneStoreHistoryTable/' + _vm.$route.params.brand_id + '/' + store.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-info-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })])])], 1) : _vm._e()])
  }), 0)])]), _vm._v(" "), _c('paginate', {
    ref: "brandPaginate",
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "openModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.current.name) + "營業時間")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.current.openList), function(open, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("星期" + _vm._s(_vm.getDayName(open.week_day)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(open.start_time) + " ～ " + _vm._s(open.end_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(open.order_start_time) + " ～ " + _vm._s(open.order_end_time))])])
  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "deliveryModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.current.name) + "外送門檻")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.current.deliveryList), function(delivery, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm._f("deliveryName")(delivery.delivery_type)))]), _vm._v(" "), _c('td', [(delivery.is_support) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("使用")]) : _vm._e(), _vm._v(" "), (!delivery.is_support) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("不使用")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(delivery.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(delivery.order_min_price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(delivery.order_min_distance_m) + "\n                    "), (delivery.delivery_type !== 3) ? _c('span', [_vm._v("(最低)")]) : _vm._e(), _vm._v(" "), (delivery.delivery_type === 3) ? _c('span', [_vm._v("(最高)")]) : _vm._e()])])
  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "payModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.current.name) + "付款方式")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.current.payList), function(pay, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                    " + _vm._s(pay.name) + " (" + _vm._s(pay.trade_type_id) + ")\n                  ")]), _vm._v(" "), _c('td', [(pay.is_enable) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("使用")]) : _vm._e(), _vm._v(" "), (!pay.is_enable) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("不使用")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pay.id))])])
  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "mqttModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.current.name) + "今日連線紀錄")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.current.mqttInfo), function(mqtt, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                    " + _vm._s(_vm.getTime(mqtt.create_time)) + "\n                  ")]), _vm._v(" "), _c('td', [(mqtt.status === 1) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("連線")]) : _vm._e(), _vm._v(" "), (mqtt.status === 2) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("中斷")]) : _vm._e()])])
  }), 0)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("星期")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("營業時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("訂購時間")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("外送類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("店家交付ID")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("最低消費門檻")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("距離門檻")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("付款類型 (ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("店家付款ID")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("連線狀態")])])])
}]}

/***/ }),
/* 2372 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12 y-middle"
  }, [_c('div', {
    staticClass: "inline-block pull-left text-left"
  }, [(_vm.storeName) ? _c('h4', [_vm._v("\n          " + _vm._s(_vm.storeName) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'reDisProduct') ? _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 未勾選解除停賣的項目，會保持原門市設定。")]) : (_vm.$route.name === 'disProduct') ? _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 未勾選停賣的項目，會保持原門市設定。")]) : _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 未勾選者，將會取消停賣功能。")]), _vm._v(" "), (_vm.$route.name == 'reDisProduct') ? _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 各分類中若有相同料號的商品，會同步解除停賣。")]) : (_vm.$route.name === 'disProduct') ? _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 各分類中若有相同料號的商品，會同步停賣。")]) : _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 各分類中若有相同料號的商品，會同步停賣、解除停賣。")]), _vm._v(" "), (_vm.isDaily) ? _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 系統將於您的商店打烊後，自動解除停賣當日停賣商品。")]) : _vm._e(), _vm._v(" "), (_vm.isDaily) ? _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 當日打烊後及公休日無法進行設定，跨日後若無遇公休可設定。")]) : _vm._e(), _vm._v(" "), (_vm.isDaily) ? _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 如您有其他的設定需求，可使用「時段停賣管理」、「永久停賣」進行設定。")]) : _vm._e()])]), _vm._v(" "), (_vm.isDayOff) ? _c('div', {
    staticClass: "col-xs-12 dialy-hint"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" " + _vm._s(_vm.isDayOff) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.category.length > 0) ? _c('div', {
    staticClass: "col-xs-12 y-middle"
  }, [_c('div', {
    staticClass: "hr-line"
  }), _vm._v(" "), (_vm.$route.name === 'reDisProduct') ? _c('div', {
    staticClass: "h3-title"
  }, [_vm._v("商品解除" + _vm._s(_vm.timeType) + "停賣設定")]) : _c('div', {
    staticClass: "h3-title"
  }, [_vm._v("商品" + _vm._s(_vm.timeType) + "停賣設定")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-10"
  }, [_c('div', {
    staticClass: "grid",
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.category), function(c, index) {
    return _c('div', {
      staticClass: "col-xs-12 col-lg-4 grid-item p-5"
    }, [_c('div', {
      staticClass: "col-xs-12 card"
    }, [_c('div', {
      staticClass: "col-xs-12 m-b-5 text-left p-x-15"
    }, [_c('div', {
      staticClass: "text-right inline-block block-checkbox text-15",
      staticStyle: {
        "margin-right": "10px"
      }
    }, [(_vm.$route.name === 'reDisProduct') ? _c('span', {
      staticClass: "text-dark-gray text-13"
    }, [_vm._v("解除停賣")]) : _c('span', {
      staticClass: "text-dark-gray text-13"
    }, [_vm._v("停賣")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 card-title text-left p-x-15"
    }, [_c('span', {
      staticClass: "pull-left"
    }, [_vm._v(_vm._s(c.name) + " "), _c('small', [_vm._v(_vm._s(c.remark))])]), _vm._v(" "), _c('div', {
      staticClass: "text-right inline-block m-r-15 block-checkbox"
    }, [(_vm.$route.name === 'reDisProduct') ? _c('span', {
      staticClass: "checkbox-addmenu"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (c.is_disabled),
        expression: "c.is_disabled"
      }],
      attrs: {
        "type": "checkbox",
        "id": 'c-' + c.product_id + '-is-add'
      },
      domProps: {
        "checked": Array.isArray(c.is_disabled) ? _vm._i(c.is_disabled, null) > -1 : (c.is_disabled)
      },
      on: {
        "input": function($event) {
          return _vm.changeCategoryAdd(c)
        },
        "change": function($event) {
          var $$a = c.is_disabled,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(c, "is_disabled", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(c, "is_disabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(c, "is_disabled", $$c)
          }
        }
      }
    })]) : _c('span', {
      staticClass: "checkbox-addmenu"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (c.is_disabled),
        expression: "c.is_disabled"
      }],
      staticClass: "css-checkbox",
      attrs: {
        "type": "checkbox",
        "id": 'c-' + c.product_id + '-is-add'
      },
      domProps: {
        "checked": Array.isArray(c.is_disabled) ? _vm._i(c.is_disabled, null) > -1 : (c.is_disabled)
      },
      on: {
        "input": function($event) {
          return _vm.changeCategoryAdd(c)
        },
        "change": function($event) {
          var $$a = c.is_disabled,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(c, "is_disabled", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(c, "is_disabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(c, "is_disabled", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "css-label css-label-add",
      attrs: {
        "for": 'c-' + c.product_id + '-is-add'
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 text-left"
    }, [_c('ul', {
      staticClass: "nav p-x-15"
    }, _vm._l((c.child_list), function(p, index) {
      return _c('li', {
        staticClass: "card-product"
      }, [_c('div', {
        class: p.is_disabled && _vm.$route.name !== 'reDisProduct' ? 'delete-line' : ''
      }, [_vm._v("\n                    " + _vm._s(p.name) + " "), _c('small', [_vm._v(_vm._s(p.remark ? ("(" + (p.remark) + ")") : ''))]), _vm._v(" "), _c('div', {
        staticClass: "text-right inline-block block-checkbox"
      }, [(_vm.$route.name === 'reDisProduct') ? _c('span', {
        staticClass: "checkbox-addmenu"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (p.is_disabled),
          expression: "p.is_disabled"
        }],
        attrs: {
          "type": "checkbox",
          "id": 'p-' + p.product_id + '-is-add'
        },
        domProps: {
          "checked": Array.isArray(p.is_disabled) ? _vm._i(p.is_disabled, null) > -1 : (p.is_disabled)
        },
        on: {
          "input": function($event) {
            return _vm.changeProductAdd(c, p)
          },
          "change": function($event) {
            var $$a = p.is_disabled,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(p, "is_disabled", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(p, "is_disabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(p, "is_disabled", $$c)
            }
          }
        }
      })]) : _c('span', {
        staticClass: "checkbox-addmenu"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (p.is_disabled),
          expression: "p.is_disabled"
        }],
        staticClass: "css-checkbox",
        attrs: {
          "type": "checkbox",
          "id": 'p-' + p.product_id + '-is-add'
        },
        domProps: {
          "checked": Array.isArray(p.is_disabled) ? _vm._i(p.is_disabled, null) > -1 : (p.is_disabled)
        },
        on: {
          "input": function($event) {
            return _vm.changeProductAdd(c, p)
          },
          "change": function($event) {
            var $$a = p.is_disabled,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(p, "is_disabled", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(p, "is_disabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(p, "is_disabled", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "css-label css-label-add",
        attrs: {
          "for": 'p-' + p.product_id + '-is-add'
        }
      })])])])])
    }), 0)])])])
  }), 0)]), _vm._v(" "), (_vm.optionsAll && _vm.optionsAll.length > 0 && _vm.$route.name === 'reDisProduct') ? _c('div', {
    staticClass: "col-xs-12 y-middle m-t-10 m-b-10"
  }, [_c('div', {
    staticClass: "hr-line"
  }), _c('div', {
    staticClass: "h3-title"
  }, [_vm._v("配料解除" + _vm._s(_vm.timeType) + "停賣設定")])]) : (_vm.optionsAll && _vm.optionsAll.length > 0) ? _c('div', {
    staticClass: "col-xs-12 y-middle m-t-10 m-b-10"
  }, [_c('div', {
    staticClass: "hr-line"
  }), _c('div', {
    staticClass: "h3-title"
  }, [_vm._v("配料" + _vm._s(_vm.timeType) + "停賣設定")])]) : _vm._e(), _vm._v(" "), (_vm.optionsAll && _vm.optionsAll.length > 0) ? _c('div', {
    staticClass: "col-xs-12 p-10"
  }, [_c('div', {
    staticClass: "gridI",
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.optionsAll), function(ot, otIndex) {
    return _c('div', {
      staticClass: "col-xs-12 col-lg-4 grid-itemI p-5"
    }, [_c('div', {
      staticClass: "col-xs-12 card"
    }, [_c('div', {
      staticClass: "col-xs-12 m-b-5 text-left p-x-15"
    }, [_c('div', {
      staticClass: "text-right inline-block block-checkbox text-15",
      staticStyle: {
        "margin-right": "10px"
      }
    }, [(_vm.$route.name === 'reDisProduct') ? _c('span', {
      staticClass: "text-dark-gray text-13"
    }, [_vm._v("解除停賣")]) : _c('span', {
      staticClass: "text-dark-gray text-13"
    }, [_vm._v("停賣")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 card-title text-left p-x-15"
    }, [_c('span', {
      staticClass: "pull-left"
    }, [_vm._v(_vm._s(ot.name) + " "), _c('small', [_vm._v(_vm._s(ot.remark))])]), _vm._v(" "), _c('div', {
      staticClass: "text-right inline-block m-r-15 block-checkbox"
    }, [(_vm.$route.name === 'reDisProduct') ? _c('span', {
      staticClass: "checkbox-addmenu"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (ot.is_disabled),
        expression: "ot.is_disabled"
      }],
      attrs: {
        "type": "checkbox",
        "id": 'o-' + ot.product_id + '-is-add'
      },
      domProps: {
        "checked": Array.isArray(ot.is_disabled) ? _vm._i(ot.is_disabled, null) > -1 : (ot.is_disabled)
      },
      on: {
        "input": function($event) {
          return _vm.changeAdjustAddAll(ot)
        },
        "change": function($event) {
          var $$a = ot.is_disabled,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(ot, "is_disabled", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(ot, "is_disabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(ot, "is_disabled", $$c)
          }
        }
      }
    })]) : _c('span', {
      staticClass: "checkbox-addmenu"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (ot.is_disabled),
        expression: "ot.is_disabled"
      }],
      staticClass: "css-checkbox",
      attrs: {
        "type": "checkbox",
        "id": 'o-' + ot.product_id + '-is-add'
      },
      domProps: {
        "checked": Array.isArray(ot.is_disabled) ? _vm._i(ot.is_disabled, null) > -1 : (ot.is_disabled)
      },
      on: {
        "input": function($event) {
          return _vm.changeAdjustAddAll(ot)
        },
        "change": function($event) {
          var $$a = ot.is_disabled,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(ot, "is_disabled", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(ot, "is_disabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(ot, "is_disabled", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "css-label css-label-add",
      attrs: {
        "for": 'o-' + ot.product_id + '-is-add'
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 text-left"
    }, [_c('ul', {
      staticClass: "nav p-x-15"
    }, _vm._l((ot.child_list), function(a, index) {
      return _c('li', {
        staticClass: "card-product"
      }, [_c('div', {
        class: a.is_disabled && _vm.$route.name !== 'reDisProduct' ? 'delete-line' : ''
      }, [_vm._v("\n                    " + _vm._s(a.name) + " "), _c('small', [_vm._v(_vm._s(a.remark ? ("(" + (a.remark) + ")") : ''))]), _vm._v(" "), _c('div', {
        staticClass: "text-right inline-block block-checkbox"
      }, [(_vm.$route.name === 'reDisProduct') ? _c('span', {
        staticClass: "checkbox-addmenu"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (a.is_disabled),
          expression: "a.is_disabled"
        }],
        attrs: {
          "type": "checkbox",
          "id": 'a-' + a.product_id + '-is-add'
        },
        domProps: {
          "checked": Array.isArray(a.is_disabled) ? _vm._i(a.is_disabled, null) > -1 : (a.is_disabled)
        },
        on: {
          "input": function($event) {
            return _vm.checkAdjustAll(a, ot)
          },
          "change": function($event) {
            var $$a = a.is_disabled,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(a, "is_disabled", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(a, "is_disabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(a, "is_disabled", $$c)
            }
          }
        }
      })]) : _c('span', {
        staticClass: "checkbox-addmenu"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (a.is_disabled),
          expression: "a.is_disabled"
        }],
        staticClass: "css-checkbox",
        attrs: {
          "type": "checkbox",
          "id": 'a-' + a.product_id + '-is-add'
        },
        domProps: {
          "checked": Array.isArray(a.is_disabled) ? _vm._i(a.is_disabled, null) > -1 : (a.is_disabled)
        },
        on: {
          "input": function($event) {
            return _vm.checkAdjustAll(a, ot)
          },
          "change": function($event) {
            var $$a = a.is_disabled,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(a, "is_disabled", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(a, "is_disabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(a, "is_disabled", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "css-label css-label-add",
        attrs: {
          "for": 'a-' + a.product_id + '-is-add'
        }
      })])])])])
    }), 0)])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (!_vm.$route.params.store_id && _vm.$route.name === 'disProduct') ? _c('div', {
    staticClass: "col-xs-12 p-10"
  }, [_c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('h5', [_vm._v("參與停賣店家\n          ")]), _vm._v(" "), _c('muti-select-two', {
    attrs: {
      "setting": _vm.addStoresSetting
    }
  })], 1)])]) : (!_vm.$route.params.store_id && _vm.$route.name === 'reDisProduct') ? _c('div', {
    staticClass: "col-xs-12 p-10"
  }, [_c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('h5', [_vm._v("參與解除停賣店家\n          ")]), _vm._v(" "), _c('muti-select-two', {
    attrs: {
      "setting": _vm.addStoresSetting
    }
  })], 1)])]) : _vm._e()]), _vm._v(" "), (_vm.isDayOff) ? _c('div', {
    staticClass: "col-xs-12 dialy-hint"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center",
    class: {
      'box-border': !_vm.isDayOff
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/disItemTable"
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("\n        取消\n      ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gotoNext
    }
  }, [_vm._v("\n      確定\n    ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 2373 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('member-form', {
    attrs: {
      "info": _vm.info
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2374 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [(_vm.getRoleType === 99) ? _c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-10 flex align-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.goBackInfo.name,
        params: _vm.goBackInfo.params,
        query: _vm.goBackInfo.query
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default m-r-5 flex"
  }, [_c('span', [_vm._v("返回")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.title)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.subtitle)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex grey darken-1"
  }, [(_vm.brand.name || _vm.store.brand_name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s(_vm.brand.name ? _vm.brand.name : _vm.store.brand_name ? _vm.store.brand_name : '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s('/')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.store.name)
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      'active': _vm.tab == 1
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.updateQuery(1)
      }
    }
  }, [_c('a', [_vm._v("商品")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tab == 3
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.updateQuery(3)
      }
    }
  }, [_c('a', [_vm._v("套餐")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tab == 10
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.updateQuery(10)
      }
    }
  }, [_c('a', [_vm._v("分類")])]), _vm._v(" "), (_vm.getRoleType !== 10) ? _c('li', {
    class: {
      'active': _vm.tab == 99
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.updateQuery(99)
      }
    }
  }, [_c('a', [_vm._v("菜單圖示")])]) : _vm._e()]), _vm._v(" "), (_vm.tab === 99) ? _c('div', {
    staticClass: "row form-inline"
  }, [_c('prod-icon-table', {
    attrs: {
      "imgList": _vm.iconList,
      "tab": 99
    }
  })], 1) : _c('div', {
    staticClass: "row"
  }, [_c('prod-img-table', {
    attrs: {
      "imgList": _vm.imgList,
      "imgMeta": _vm.imgMeta,
      "tab": _vm.tab,
      "getProductImageList": _vm.getProductImageList
    }
  })], 1)])])])])])
},staticRenderFns: []}

/***/ }),
/* 2375 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('ad-form')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2376 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fixed_layout",
    class: ['wrapper', _vm.classes]
  }, [_c('header', {
    staticClass: "main-header"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_vm._m(2), _vm._v(" "), _c('li', {
    class: ['dropdown notifications-menu']
  }, [_c('a', {
    staticStyle: {
      "padding-left": "10px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openNotifyNews = !_vm.openNotifyNews
      }
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-bell-o"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.unReadAmount > 0),
      expression: "unReadAmount > 0"
    }],
    staticClass: "badge badge-bell"
  }, [_vm._v(_vm._s(_vm.unReadAmount))])])])]), _vm._v(" "), (_vm.getRoleType !== 99 && _vm.getNidinLeague) ? _c('li', [_vm._m(3)]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": "/static/img/default_user-02.png",
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.getAccount))])])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown user user-menu",
    on: {
      "click": _vm.clickLogout
    }
  }, [_vm._m(4)])])])])]), _vm._v(" "), _c('sidebar', {
    attrs: {
      "display-name": _vm.demo.displayName,
      "picture-url": _vm.demo.avatar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [(_vm.openNotifyNews) ? _c('div', {
    staticClass: "notifyNews"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: ['col-xs-6 nav-tab text-center right-broder cursor-pointer', {
      'nav-tab-active': !_vm.isRead
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeRead(false)
      }
    }
  }, [_vm._v("未讀")]), _vm._v(" "), _c('div', {
    class: ['col-xs-6 nav-tab text-center cursor-pointer', {
      'nav-tab-active': _vm.isRead
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeRead(true)
      }
    }
  }, [_vm._v("已讀")])]), _vm._v(" "), _c('div', {
    staticClass: "notifyNewsContent"
  }, [(_vm.announcementList.length > 0) ? _c('div', {
    staticClass: "list-group"
  }, [_vm._l((_vm.announcementList), function(news, index) {
    return [_c('a', {
      key: index,
      staticClass: "list-group-item list-group-item-action cursor-pointer",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openNews(news)
        }
      }
    }, [_c('div', [_vm._v(_vm._s(news.title))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(news.content))]), _vm._v(" "), _c('div', [_c('small', {
      staticClass: "time"
    }, [_vm._v("系統通知 ｜ " + _vm._s(news.update_time))])])])]
  })], 2) : _c('div', {
    staticClass: "text-center list-group"
  }, [_vm._v("\n            目前沒有" + _vm._s(_vm.isRead ? '已讀' : '未讀') + "公告\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "footer text-center",
    style: (!_vm.isRead ? 'border-top: 1px solid #f4f4f4;' : 'height:15px')
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isRead),
      expression: "!isRead"
    }],
    staticClass: "cursor-pointer",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.markAsRead(null)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("全部標記為已讀")])])]) : _vm._e(), _vm._v(" "), (_vm.openNotifyNews) ? _c('div', {
    staticClass: "ful-bg",
    on: {
      "click": function($event) {
        _vm.openNotifyNews = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$route.meta.title))]), _vm._v(" "), (_vm.$route.meta.subTitle) ? _c('span', {
    staticClass: "subTitle"
  }, [_vm._v(" -  " + _vm._s(_vm.$route.meta.subTitle))]) : _vm._e(), _vm._v(" "), (_vm.$route.meta.docLink) ? _c('span', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.linkDoc
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle mr-5"
  }), _vm._v("開啟操作手冊\n          ")])]) : _vm._e()])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('nd-announcement-overlay', {
    attrs: {
      "dailog-open": _vm.dailogOpen,
      "message": _vm.message
    },
    on: {
      "update:close": _vm.close
    }
  })], 1), _vm._v(" "), _c('footer', {
    staticClass: "main-footer"
  }, [_c('strong', [_vm._v("Copyright © " + _vm._s(_vm.year) + "\n      "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("Nidin")]), _vm._v(".")]), _vm._v(" All rights reserved.\n      "), _c('small', {
    staticClass: "text-current-time data-real-time pull-right"
  }, [_vm._v("資料來源： " + _vm._s(_vm.currentTime))])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "logo-mini"
  }, [_c('span', {
    staticClass: "img-responsive center-block logo"
  }, [_c('span', {
    staticClass: "sidebar-large"
  }, [_vm._v("Nidin")]), _vm._v(" "), _c('span', {
    staticClass: "sidebar-mini"
  }, [_vm._v("N")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "href": "javascript:;",
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticStyle: {
      "padding-right": "10px"
    },
    attrs: {
      "target": "_blank",
      "href": "https://line.me/ti/p/~@839wddtv"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-headphones fa-md"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('span', {
    staticClass: "nd-tooltip"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(2080)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text alliance-tooltip"
  }, [_vm._v("\n                  你訂聯盟的品牌可享有 ：系統模組9~8折優惠。一~二則你訂首頁Banner一週的曝光。詳情可洽您的商務窗口。\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
}]}

/***/ }),
/* 2377 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 text-left"
  }, [(_vm.brandBrief.length > 1 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group form-inline w-auto"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandSelect),
      expression: "brandSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.brandSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.roleType !== 10) ? _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("== 品牌 ==")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.brandBrief), function(brand) {
    return _c('option', {
      domProps: {
        "value": brand.value
      }
    }, [_vm._v("\n                " + _vm._s(brand.label) + "\n              ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.brandSelect !== 0 && _vm.brandSelect !== '0' && _vm.storeBrief.length > 1) ? _c('div', {
    staticClass: "form-group form-inline w-auto"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeSelect),
      expression: "storeSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.storeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("== 店家 ==")]), _vm._v(" "), _vm._l((_vm.storeBrief), function(store) {
    return _c('option', {
      domProps: {
        "value": store.value
      }
    }, [_vm._v("\n                " + _vm._s(store.label) + "\n              ")])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: " col-xs-12 col-sm-6 text-right pull-right"
  }, [_c('div', {
    staticClass: "form-group input-group time-box pull-right w-short"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.dateoption,
      "limit": _vm.startLimit
    }
  }), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.dateoption,
      "limit": _vm.endLimit
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default submit-btn btn-search",
    staticStyle: {
      "height": "72px"
    },
    attrs: {
      "type": "button",
      "id": "search2"
    },
    on: {
      "click": function($event) {
        return _vm.clickSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("訂單狀態轉移"), ((_vm.brandSelect === 0 || _vm.brandSelect === '0') && _vm.roleType === 99) ? _c('span', {
    staticClass: "text-red text-12"
  }, [_vm._v("(請選擇品牌或店家)")]) : _vm._e()]), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0 col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "overflow": "scroll",
      "max-height": "500px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.transitTimeList), function(transitTime, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [(transitTime.date) ? _c('td', {
      attrs: {
        "rowspan": transitTime.reasonAmount
      }
    }, [_vm._v(_vm._s(_vm.getMonthDay(transitTime.date)))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getTimeString(transitTime.order_create_mean)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getTimeString(transitTime.order_reply_mean)))]), _vm._v(" "), _c('td', [(transitTime.order_create_count) ? _c('span', [_vm._v(_vm._s(transitTime.order_create_count))]) : _vm._e()])])
  }), 0)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "th-fit"
  }, [_vm._v("日期")]), _vm._v(" "), _c('th', [_vm._v("購物車 > 送出訂單")]), _vm._v(" "), _c('th', [_vm._v("送出訂單 > 店家接/拒單")]), _vm._v(" "), _c('th', [_vm._v("樣本數")])])])
}]}

/***/ }),
/* 2378 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuId || _vm.noMenu),
      expression: "menuId || noMenu"
    }],
    staticClass: "text-center",
    staticStyle: {
      "border": "1px solid #eee"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuId),
      expression: "menuId"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isAdd),
      expression: "!isAdd"
    }],
    staticClass: "box-body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-0"
  }, [_c('div', {
    staticClass: "grid",
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.category), function(c, index) {
    return _c('div', {
      staticClass: "col-xs-12 col-lg-4 grid-item p-5"
    }, [_c('div', {
      staticClass: "col-xs-12 card"
    }, [_c('div', {
      staticClass: "col-xs-12 text-left m-t-10"
    }, [_vm._v("\n                 \n                "), _c('label', {
      staticClass: "bg-green label label-text-60-p",
      on: {
        "click": function($event) {
          return _vm.choseAllProduct(c)
        }
      }
    }, [_vm._v("全選")]), _vm._v(" \n                "), _c('label', {
      staticClass: "bg-red label label-text-60-p",
      on: {
        "click": function($event) {
          return _vm.cancelAllProduct(c)
        }
      }
    }, [_vm._v("全取消")]), _vm._v("\n                 \n              ")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 m-b-5 text-left p-x-15"
    }, [_c('div', {
      staticClass: "text-right inline-block block-checkbox text-15",
      staticStyle: {
        "margin-right": "15px",
        "margin-top": "55px"
      }
    }, [(_vm.showWord) ? _c('span', {
      staticClass: "text-dark-gray text-13"
    }, [_vm._v(_vm._s(_vm.showWord))]) : _c('span', {
      staticClass: "text-dark-gray text-13"
    }, [_vm._v("加入")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 card-title text-left p-x-15"
    }, [_c('span', {
      staticClass: "pull-left"
    }, [_vm._v(_vm._s(c.name))]), _vm._v(" "), _c('div', {
      staticClass: "text-right inline-block m-r-15 block-checkbox"
    }, [_c('span', {
      staticClass: "checkbox-addmenu"
    }, [_c('label', {
      staticClass: "css-label css-label-add",
      attrs: {
        "for": 'c-' + c.category_id + '-is-add'
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 text-left"
    }, [_c('ul', {
      staticClass: "nav p-x-15"
    }, [_vm._l((c.product_list), function(p, index) {
      return _c('li', {
        staticClass: "card-product"
      }, [_c('div', {}, [_vm._v("\n                      " + _vm._s(p.name) + " "), _c('small', [_vm._v(_vm._s(p.remark))]), _vm._v(" "), _c('div', {
        staticClass: "text-right inline-block block-checkbox"
      }, [_c('span', {
        staticClass: "checkbox-addmenu"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (p.is_disabled),
          expression: "p.is_disabled"
        }],
        staticClass: "css-checkbox",
        attrs: {
          "type": "checkbox",
          "id": _vm.menuClass + 'p-' + p.product_id + '-is-add'
        },
        domProps: {
          "checked": Array.isArray(p.is_disabled) ? _vm._i(p.is_disabled, null) > -1 : (p.is_disabled)
        },
        on: {
          "input": function($event) {
            return _vm.changeProductAdd(c, p)
          },
          "change": function($event) {
            var $$a = p.is_disabled,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(p, "is_disabled", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(p, "is_disabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(p, "is_disabled", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "css-label css-label-add",
        attrs: {
          "for": _vm.menuClass + 'p-' + p.product_id + '-is-add'
        }
      })])])])])
    }), _vm._v(" "), _vm._l((c.package_list), function(pa, index) {
      return _c('li', {
        staticClass: "card-product"
      }, [_c('div', {}, [_vm._v("\n                      " + _vm._s(pa.name) + " "), _c('small', [_vm._v(_vm._s(pa.remark))]), _vm._v(" "), _c('div', {
        staticClass: "text-right inline-block block-checkbox"
      }, [_c('span', {
        staticClass: "checkbox-addmenu"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (pa.is_disabled),
          expression: "pa.is_disabled"
        }],
        staticClass: "css-checkbox",
        attrs: {
          "type": "checkbox",
          "id": _vm.menuClass + pa.package_id + '-is-add'
        },
        domProps: {
          "checked": Array.isArray(pa.is_disabled) ? _vm._i(pa.is_disabled, null) > -1 : (pa.is_disabled)
        },
        on: {
          "input": function($event) {
            return _vm.changeProductAdd(c, pa)
          },
          "change": function($event) {
            var $$a = pa.is_disabled,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(pa, "is_disabled", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(pa, "is_disabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(pa, "is_disabled", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "css-label css-label-add",
        attrs: {
          "for": _vm.menuClass + pa.package_id + '-is-add'
        }
      })])])])])
    })], 2)])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(_vm.isAdd) ? _c('button', {
    staticClass: "btn btn-success w-100-p text-w-600",
    on: {
      "click": function($event) {
        _vm.isAdd = !_vm.isAdd
      }
    }
  }, [_vm._v("\n        再次選擇\n      ")]) : _c('button', {
    staticClass: "btn btn-primary w-100-p text-w-600",
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("\n        確認\n      ")])])]), _vm._v(" "), (_vm.noMenu) ? _c('div', [_c('br'), _vm._v("\n    無菜單\n    "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "inline-block pull-left text-left"
  })])
}]}

/***/ }),
/* 2379 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav",
    class: ['index' + _vm.pAIndex, {
      'layout-line': _vm.layout == 'line'
    }]
  }, [(!_vm.adjusts.length && !_vm.isBigMilk && !_vm.isIce) ? _c('li', {
    staticClass: "col-xs-12 p-x-0 order-item adjust text-no-adjust"
  }, [_c('div', [_vm._v("此商品不需調整配料/比例")])]) : _vm._e(), _vm._v(" "), (!_vm.adjusts.length && _vm.isBigMilk) ? _c('li', {
    staticClass: "col-xs-12 p-x-0 order-item adjust text-no-adjust"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (!_vm.adjusts.length && _vm.isIce) ? _c('li', {
    staticClass: "col-xs-12 p-x-0 order-item adjust text-no-adjust"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.adjusts), function(adjust, aIndex) {
    return (adjust) ? _c('li', {
      key: _vm.currentProduct[_vm.schema.product.product_id] + '-' + adjust[_vm.schema.adjust.product_id],
      staticClass: "col-xs-12 p-x-0 order-item adjust",
      class: ['adjust-' + _vm.currentProduct[_vm.schema.product.product_id] + '-' + adjust[_vm.schema.adjust.product_id], 'adjust-' + _vm.currentProduct[_vm.schema.product.product_id]]
    }, [_c('h4', [_vm._v(_vm._s(adjust[_vm.schema.adjust.name]) + "選擇\n      "), (adjust[_vm.schema.adjust.max_limit] != 1 && adjust[_vm.schema.adjust.max_limit] != 0) ? _c('span', {
      staticStyle: {
        "top": "0px"
      }
    }, [_vm._v("(最多可選" + _vm._s(adjust[_vm.schema.adjust.max_limit]) + "項)")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "options",
      class: 'options-' + _vm.currentProduct[_vm.schema.product.product_id] + '-' + aIndex,
      staticStyle: {
        "margin-left": "-5px"
      }
    }, _vm._l((adjust[_vm.schema.adjust.option_list]), function(option, oIndex) {
      return _c('div', {
        key: _vm.currentProduct[_vm.schema.product.product_id] + '-' + adjust[_vm.schema.adjust.product_id] + '-' + option[_vm.schema.option.product_id],
        staticClass: "btn btn-default btn-option",
        class: [{
            disabled: adjust[_vm.schema.adjust.is_enable] == 0
          },
          'option-' + _vm.currentProduct[_vm.schema.product.product_id] + '-index' + _vm.pAIndex,
          {
            'btn-option--active': _vm.isActive(_vm.currentProduct[_vm.schema.product.product_id] + '-' + adjust[_vm.schema.adjust.product_id] + '-' + option[_vm.schema.option.product_id])
          }
        ],
        attrs: {
          "id": 'option-' + _vm.currentProduct[_vm.schema.product.product_id] + '-' + option[_vm.schema.option.product_id],
          "optionA": 'adjust-' + adjust[_vm.schema.adjust.product_id]
        },
        on: {
          "click": function($event) {
            return _vm.clickOption(option, oIndex, adjust, aIndex)
          }
        }
      }, [_c('div', {
        staticClass: "option-name"
      }, [_vm._v("\n          " + _vm._s(option[_vm.schema.option.name]) + "\n        ")]), _vm._v(" "), (Array.isArray(option) && Array.isArray(adjust) && _vm.optionPrice(option, adjust)) ? _c('div', {
        staticClass: "option-price"
      }, [_vm._v("\n          " + _vm._s(_vm.optionPrice(option, adjust)) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.optionNumList[0][option[_vm.schema.option.product_id]] && _vm.optionNumList[0][option[_vm.schema.option.product_id]] !== 1) ? _c('div', {
        staticClass: "label option-number"
      }, [_vm._v("\n          " + _vm._s(_vm.optionNumList[0][option[_vm.schema.option.product_id]]) + "\n        ")]) : (_vm.optionNumList[0][option[_vm.schema.option.product_id]] && _vm.optionNumList[0][option[_vm.schema.option.product_id]] === 1 && option[_vm.schema.option.max_limit] !== 1) ? _c('div', {
        staticClass: "label option-number"
      }, [_vm._v("\n          " + _vm._s(_vm.optionNumList[0][option[_vm.schema.product.product_id]]) + "\n        ")]) : _vm._e()])
    }), 0)]) : _vm._e()
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n      嚴選乳源、成分無調整"), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-red text-14"
  }, [_vm._v("★ 此商品不列入外送金額，尚請見諒")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-red text-14"
  }, [_vm._v("★ 為保持鮮奶品質，外送建議一公里內")]), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n      成分無調整"), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-red text-14"
  }, [_vm._v("★ 此商品為冰萃/冰沙口感，現場選購口感較佳，不建議外送時選購")]), _c('br')])
}]}

/***/ }),
/* 2380 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.processSelect),
      expression: "processSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.processSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("== 處理狀態 ==")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("已處理")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未處理")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchSelect),
      expression: "searchSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("時間")])])]), _vm._v(" "), (_vm.searchSelect == 1) ? _c('div', {
    staticClass: "form-group input-group time-box"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.dateoption,
      "limit": _vm.startLimit
    }
  }), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.dateoption,
      "limit": _vm.endLimit
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default submit-btn btn-search",
    staticStyle: {
      "height": "72px"
    },
    attrs: {
      "type": "button",
      "id": "search"
    },
    on: {
      "click": function($event) {
        return _vm.getAbnormalOrderList('search')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單編號")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("類型")]), _vm._v(" "), (_vm.roleType === 99) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("品牌(ID)")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99 || _vm.roleType === 30) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("分店(ID)")]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂購者"), (_vm.roleType === 99) ? _c('span', [_vm._v("(ID)")]) : _vm._e()]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("電話")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("總數")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("總額")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("付款狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("處理狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("下訂時間")])])]), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(0)]) : (_vm.orderList.length === 0) ? _c('tbody', [_vm._m(1)]) : (_vm.orderList.length > 0) ? _c('tbody', _vm._l((_vm.orderList), function(order, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/orderInfo/' + order.order_id
        },
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(order.order_sn))])], 1), _vm._v(" "), _c('td', [_c('label', {
      staticClass: "label",
      class: _vm.orderStateColor(order.status)
    }, [_vm._v(_vm._s(_vm.orderState(order.status)))])]), _vm._v(" "), _c('td', [(order.order_type === 1) ? _c('span', {
      staticClass: "label label-primary"
    }, [_vm._v("一般單")]) : _vm._e(), _vm._v(" "), (order.order_type === 2) ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("團購單")]) : _vm._e()]), _vm._v(" "), (_vm.roleType === 99) ? _c('td', [_vm._v(_vm._s(order.brand_name) + "(" + _vm._s(order.brand_id) + ")")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99 || _vm.roleType === 30) ? _c('td', [_vm._v(_vm._s(order.store_name) + "(" + _vm._s(order.store_id) + ")")]) : _vm._e(), _vm._v(" "), _c('td', [(_vm.roleType !== 99 || _vm.$route.name == 'memberOrderTable') ? _c('span', [_vm._v(_vm._s(order.name)), (_vm.roleType === 99) ? _c('span', [_vm._v("(" + _vm._s(order.shopper_id) + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99 && _vm.$route.name !== 'memberOrderTable') ? _c('router-link', {
      attrs: {
        "target": "_blank",
        "to": {
          path: '/memberOrderTable/' + order.shopper_id
        }
      }
    }, [_vm._v(_vm._s(order.name) + "(" + _vm._s(order.shopper_id) + ")")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.phone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.amount))]), _vm._v(" "), _c('td', [_vm._v("＄" + _vm._s(order.money))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payStateName(order.payment_status)))]), _vm._v(" "), _c('td', [(order.is_processed) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("已處理")]) : _vm._e(), _vm._v(" "), (!order.is_processed) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("未處理")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getTime(order.order_time)))])])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('paginate', {
    ref: "orderPaginate",
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
}]}

/***/ }),
/* 2381 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [_c('div', {
    staticClass: "box-body form"
  }, [_c('br'), _vm._v(" "), _c('div', [_c('h3', [_vm._v(_vm._s(_vm.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "ad-form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 ad-form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adInfo.name),
      expression: "adInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.adInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adInfo, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adInfo.is_active),
      expression: "adInfo.is_active"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.adInfo, "is_active", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("啟用")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("停用")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.bannerType !== 41) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          連結\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adInfo.url),
      expression: "adInfo.url"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.adInfo.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adInfo, "url", $event.target.value)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', [_c('div', {
    staticClass: "input-group cr-schedule cr-ad"
  }, [_vm._m(2), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.timeoption,
      "limit": _vm.startLimit
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group cr-schedule cr-ad"
  }, [_vm._m(3), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.timeoption,
      "limit": _vm.endLimit
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [(_vm.bannerType !== 41) ? _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "form-group select-right"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adInfo.foreverShow),
      expression: "adInfo.foreverShow"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.adInfo, "foreverShow", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")])])])]) : _vm._e()])])]), _vm._v(" "), (_vm.bannerType !== 41) ? _c('div', {
    staticClass: "row"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-12 flex"
  }, [_c('div', {
    staticClass: "cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("廣告地區\n        "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(5)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block cell-right"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adInfo.is_limit_location),
      expression: "adInfo.is_limit_location"
    }],
    attrs: {
      "type": "radio",
      "name": "is_limit_location"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.adInfo.is_limit_location, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.adInfo, "is_limit_location", 0)
      }
    }
  }), _vm._v("\n          不限制\n        ")]), _vm._v(" "), _c('label', {
    staticClass: "ml-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adInfo.is_limit_location),
      expression: "adInfo.is_limit_location"
    }],
    attrs: {
      "type": "radio",
      "name": "is_limit_location"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.adInfo.is_limit_location, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.adInfo, "is_limit_location", 1)
      }
    }
  }), _vm._v("\n          指定區域\n        ")])])]), _vm._v(" "), (_vm.adInfo.is_limit_location) ? _c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('multiselect', {
    staticClass: "min-w-150",
    attrs: {
      "options": _vm.getCityOption,
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "show-labels": false,
      "placeholder": "",
      "multiple": true,
      "label": "name",
      "track-by": "code"
    },
    model: {
      value: (_vm.adInfo.city_code_list),
      callback: function($$v) {
        _vm.$set(_vm.adInfo, "city_code_list", $$v)
      },
      expression: "adInfo.city_code_list"
    }
  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "upload-image"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0 bg-white",
    staticStyle: {
      "border-right": "none"
    }
  }, [_c('span', {
    staticClass: "inline-block h-auto"
  }, [(!_vm.adInfo.image_web_file) ? _c('img', {
    staticClass: "img-responsive h-auto",
    attrs: {
      "src": _vm.defaultImage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.adInfo.image_web_file) ? _c('img', {
    staticClass: "h-auto img-responsive",
    attrs: {
      "src": _vm.adInfo.image_web_file,
      "data-toggle": "modal"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [_c('div', [_c('label', {
    staticClass: "btn-upload btn btn-default m-t-25",
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "for": "brand-img-load"
    }
  }, [_vm._v("\n          選擇圖片\n        ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "brand-img-load"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right text-15 text-red",
    domProps: {
      "textContent": _vm._s(_vm.tipsImage)
    }
  }), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "row store-bannder"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-12 flex"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block cell-right"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCopyStore),
      expression: "isCopyStore"
    }],
    attrs: {
      "type": "radio",
      "name": "setStore"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.isCopyStore, true)
    },
    on: {
      "change": function($event) {
        _vm.isCopyStore = true
      }
    }
  }), _vm._v("\n          是\n        ")]), _vm._v(" "), _c('label', {
    staticClass: "ml-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCopyStore),
      expression: "isCopyStore"
    }],
    attrs: {
      "type": "radio",
      "name": "setStore"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.isCopyStore, false)
    },
    on: {
      "change": function($event) {
        _vm.isCopyStore = false
      }
    }
  }), _vm._v("\n          否\n        ")])])]), _vm._v(" "), (_vm.isCopyStore) ? _c('div', {
    staticClass: " col-12 text-left m-t-25"
  }, [_c('h5', [_vm._v("參與店家")]), _vm._v(" "), _c('div', _vm._l((_vm.storeClassList), function(storeClass, index) {
    return _c('div', {
      staticClass: "m-r-5 m-b-10 inline-block"
    }, [_c('button', {
      staticClass: "btn btn-default",
      class: {
        'active': _vm.curId === storeClass.id
      },
      on: {
        "click": function($event) {
          return _vm.clickOption(storeClass)
        }
      }
    }, [_vm._v("\n            " + _vm._s(storeClass.name) + "\n          ")])])
  }), 0), _vm._v(" "), _c('muti-select-two', {
    attrs: {
      "setting": _vm.addStoresSetting,
      "reNew": _vm.reNew,
      "reSet": _vm.reSet
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 flex"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block cell-right"
  }, [_c('label', {
    style: (_vm.adInfo.is_active === '0' ? 'color: #C2C2C2' : '')
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isJkosOpen),
      expression: "isJkosOpen"
    }],
    attrs: {
      "disabled": _vm.adInfo.is_active === '0',
      "type": "radio",
      "name": "setJkos"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.isJkosOpen, true)
    },
    on: {
      "change": function($event) {
        _vm.isJkosOpen = true
      }
    }
  }), _vm._v("\n          啟用\n        ")]), _vm._v(" "), _c('label', {
    staticClass: "ml-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isJkosOpen),
      expression: "isJkosOpen"
    }],
    attrs: {
      "type": "radio",
      "name": "setJkos"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.isJkosOpen, false)
    },
    on: {
      "change": function($event) {
        _vm.isJkosOpen = false
      }
    }
  }), _vm._v("\n          停用\n        ")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n      取消\n    ")]), _vm._v(" "), (!_vm.info) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkBeforeSend('cr')
      }
    }
  }, [_vm._v("\n      新增\n    ")]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkBeforeSend('up')
      }
    }
  }, [_vm._v("\n      修改\n    ")]) : _vm._e()]), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("名稱\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("啟用\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("開始時間\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("結束時間\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("永久顯示\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text center"
  }, [_vm._v("\n            *依據消費者位置指定廣告要出現的縣市(目前限台灣地區)。"), _c('br'), _vm._v("\n            *若無法判斷位置或在非台灣地區，則預設都顯示。\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("指定區域\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("圖片\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("套用門市設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("套用門市")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("街口平台\n      "), _c('span', {
    staticClass: "tip-icon",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "與街口支付APP合作之你訂獨家功能，有興趣可洽業務窗口。若未簽約合作請勿啟用。"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
}]}

/***/ }),
/* 2382 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body full-height mt-30 p-2-12"
  }, [_c('div', {
    staticClass: "table-row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "table-from"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.announcement.title),
      expression: "announcement.title"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "標題最多100字",
      "maxlength": "100",
      "type": "text"
    },
    domProps: {
      "value": (_vm.announcement.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.announcement, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "table-from"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.announcement.content),
      expression: "announcement.content"
    }],
    staticClass: "form-control",
    attrs: {
      "cols": "30",
      "rows": "10",
      "type": "text",
      "placeholder": "內文最多500字",
      "maxlength": "500"
    },
    domProps: {
      "value": (_vm.announcement.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.announcement, "content", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "table-from w-100"
  }, [_c('date-picker', {
    staticClass: "hide-date-icon",
    attrs: {
      "show-second": false,
      "type": "datetime",
      "valueType": "format",
      "format": "YYYY-MM-DD HH:mm:ss",
      "input-class": "form-control",
      "clearable": false,
      "disabled-time": _vm.notBeforeNow,
      "disabled-date": _vm.notBeforeToday
    },
    model: {
      value: (_vm.formTime.time),
      callback: function($$v) {
        _vm.$set(_vm.formTime, "time", $$v)
      },
      expression: "formTime.time"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "table-from"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.announcement.role_type),
      expression: "announcement.role_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.announcement, "role_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Admin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Brand")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Store")])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "table-from"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.announcement.is_overlay),
      expression: "announcement.is_overlay"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.announcement, "is_overlay", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("不啟用")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("啟用")])])])]), _vm._v(" "), (_vm.$route.name === 'editAnnouncement') ? _c('div', {
    staticClass: "table-row"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "table-from"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.announcement.republish),
      expression: "announcement.republish"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.announcement, "republish", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-left mt-64"
  }, [_c('button', {
    staticClass: "btn btn-success btn_add",
    on: {
      "click": function($event) {
        return _vm.addimg()
      }
    }
  }, [_vm._v("新增圖片")])]), _vm._v(" "), (_vm.img_view) ? _c('div', {
    staticClass: "m-t-10 form-control"
  }, _vm._l((_vm.img_list), function(img, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (img.image_name !== 'delete'),
        expression: "img.image_name !== 'delete'"
      }],
      staticClass: "m-y-20"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon input-img-title"
    }, [_vm._v("\n                圖片 " + _vm._s(index + 1) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "input-group-addon w-100-p text-center p-all-0 bg-white",
      staticStyle: {
        "border-right": "none"
      }
    }, [_c('span', {
      staticClass: "inline-block h-auto m-t-5"
    }, [(!img.image_name) ? _c('div', {
      staticClass: "text-black",
      domProps: {
        "textContent": _vm._s('沒有圖片')
      }
    }) : _vm._e(), _vm._v(" "), (img.image_name) ? _c('img', {
      staticClass: "h-auto img-responsive",
      attrs: {
        "src": img.image_name,
        "data-toggle": "modal"
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "form-control h-100"
    }, [_c('label', {
      staticClass: "btn-upload btn btn-default",
      staticStyle: {
        "margin-top": "25px"
      },
      attrs: {
        "for": 'img-' + index
      },
      on: {
        "click": function($event) {
          return _vm.onFileChangeBtn(index)
        }
      }
    }, [_vm._v("\n                  選擇圖片\n                ")]), _vm._v(" "), _c('input', {
      staticClass: "form-control",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "type": "file",
        "id": 'img-' + index
      },
      on: {
        "change": _vm.onFileChange
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "input-group-addon w-100-p text-center bg-white p-0-32"
    }, [_c('div', {
      staticClass: "btn btn-danger",
      attrs: {
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          return _vm.del_img(_vm.img_list, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "text-right text-15 text-red"
    }, [_vm._v("圖片大小為 寬不限制x高330  512KB 內")])])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-left mt-64"
  }, [_c('button', {
    staticClass: "btn btn-success btn_add",
    on: {
      "click": function($event) {
        return _vm.addurl()
      }
    }
  }, [_vm._v("新增連結")])]), _vm._v(" "), (_vm.url_list && _vm.url_list.length > 0) ? _c('div', {
    staticClass: "m-t-10 form-control"
  }, _vm._l((_vm.url_list), function(url, index) {
    return _c('div', [_c('div', {
      staticClass: "input-group m-y-20"
    }, [_c('span', {
      staticClass: "input-group-addon input-url-title"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v("\n                連結 " + _vm._s(index + 1) + "\n              ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.url_list[index]),
        expression: "url_list[index]"
      }],
      staticClass: "form-control url-input",
      attrs: {
        "placeholder": "網站連結",
        "type": "text",
        "maxlength": "1000"
      },
      domProps: {
        "value": (_vm.url_list[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.url_list, index, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "input-group-addon text-center bg-white"
    }, [_c('div', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.del_url(_vm.url_list, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center mt-64"
  }, [_c('router-link', {
    attrs: {
      "to": "/announcement"
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("\n          取消\n        ")])]), _vm._v(" "), (_vm.$route.name === 'addAnnouncement') ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.updataAll('add')
      }
    }
  }, [_vm._v("\n        新增\n      ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.updataAll('up')
      }
    }
  }, [_vm._v("\n        修改\n      ")])], 1)]), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delDesAlisOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "del-block m-t-15"
  }, [_c('div', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delNewsModal"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("標題\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("內文說明\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("發佈時間\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("發佈對象\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("蓋板開關\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("重新發佈\n        ")])
}]}

/***/ }),
/* 2383 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-center box-body"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          優惠券折抵規則\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.newCouponType.label))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("折抵策略名稱")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.giveCoupons.coupon_strategy.name))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("折抵描述")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.giveCoupons.coupon_strategy.description))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br')])]), _vm._v(" "), (_vm.newCouponType) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr', {
    staticClass: "box-body"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-left box-body"
  }, [(_vm.ruleCode === 'SC00003') ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("滿足商品金額 (買X元，送優惠券)")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.giveCoupons.coupon_strategy.setting.money_unit))])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.ruleCode === 'SC00001') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品限制最低單價")]), _vm._v(" "), (_vm.giveCoupons.coupon_strategy.setting.lowest_unit_price) ? _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.giveCoupons.coupon_strategy.setting.lowest_unit_price) + " 元")]) : _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v("無設定")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("一次最大使用張數")]), _vm._v(" "), (_vm.giveCoupons.coupon_strategy.setting.one_max_amount) ? _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.giveCoupons.coupon_strategy.setting.one_max_amount) + " 張")]) : _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v("無設定")])]), _vm._v(" "), _c('br')])])]) : _vm._e(), _vm._v(" "), (_vm.newCouponType) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr', {
    staticClass: "box-body"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-left box-body"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制主單(或團長)最低購買數")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.giveCoupons.coupon_strategy.limit.min_amount) + " 個")])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.giveCoupons.coupon_strategy.limit.order_types.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            訂單類型\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.giveCoupons.coupon_strategy.limit.order_types), function(ot) {
    return _c('label', {
      staticClass: "label-success label m-r-5"
    }, [_vm._v(_vm._s(ot.label))])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.giveCoupons.coupon_strategy.limit.order_method.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            訂單方案\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.giveCoupons.coupon_strategy.limit.order_method), function(om) {
    return _c('label', {
      staticClass: "label-success label m-r-5"
    }, [_vm._v(_vm._s(om.label))])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-right box-body"
  }, [(_vm.giveCoupons.coupon_strategy.limit.delivery_types.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            取貨方式\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.giveCoupons.coupon_strategy.limit.delivery_types), function(dt) {
    return _c('label', {
      staticClass: "label-success label m-r-5"
    }, [_vm._v(_vm._s(dt.label))])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.giveCoupons.coupon_strategy.limit.min_money) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制主單(或團長)最低總金額")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.giveCoupons.coupon_strategy.limit.min_money) + " 元")])]), _vm._v(" "), _c('br')]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr', {
    staticClass: "box-body"
  }), _vm._v(" "), (_vm.giveCoupons.coupon_strategy.store_exception_items[0].products.length || _vm.giveCoupons.coupon_strategy.setting.vendor_custom_product_list.length) ? _c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [(_vm.ruleCode === 'SC00001' || _vm.ruleCode === 'SC00003') ? _c('h5', [_vm._v("例外商品選擇")]) : _c('h5', [_vm._v("指定商品選擇")])]), _vm._v(" "), (_vm.giveCoupons.coupon_strategy.store_exception_items[0].products.length && (_vm.ruleCode === 'SC00001' || _vm.ruleCode === 'SC00003')) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.giveCoupons.coupon_strategy.store_exception_items[0].products), function(aProduct, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n              " + _vm._s(aIndex + 1) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(aProduct.product_name) + "\n            ")]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(aProduct.vendor_custom_id))])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.giveCoupons.coupon_strategy.setting.vendor_custom_product_list.length && _vm.ruleCode === 'SC00002') ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.giveCoupons.coupon_strategy.setting.vendor_custom_product_list), function(aProduct, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n              " + _vm._s(aIndex + 1) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(aProduct.product_name) + "\n            ")]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(aProduct.vendor_custom_id))])])])
  }), 0)])]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', [_c('h4', [_vm._v("使用規則")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', [_c('h4', [_vm._v("限制規則")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品")]), _vm._v(" "), _c('td', [_vm._v("商品料號")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品")]), _vm._v(" "), _c('td', [_vm._v("商品料號")])])])
}]}

/***/ }),
/* 2384 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-center box-body"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.ruleCodeOptions,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "贈送優惠券規則",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    on: {
      "select": _vm.reNewMenu
    },
    model: {
      value: (_vm.newCouponType),
      callback: function($$v) {
        _vm.newCouponType = $$v
      },
      expression: "newCouponType"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.giveCoupons.coupon_strategy.name),
      expression: "giveCoupons.coupon_strategy.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.giveCoupons.coupon_strategy.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.giveCoupons.coupon_strategy, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.giveCoupons.coupon_strategy.description),
      expression: "giveCoupons.coupon_strategy.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "maxlength": "256"
    },
    domProps: {
      "value": (_vm.giveCoupons.coupon_strategy.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.giveCoupons.coupon_strategy, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br')])]), _vm._v(" "), (_vm.newCouponType) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr', {
    staticClass: "box-body"
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form-left box-body"
  }, [(_vm.ruleCode === 'SC00003') ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.giveCoupons.coupon_strategy.setting.money_unit),
      expression: "giveCoupons.coupon_strategy.setting.money_unit"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.giveCoupons.coupon_strategy.setting.money_unit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.giveCoupons.coupon_strategy.setting, "money_unit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.ruleCode === 'SC00001') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品限制最低單價")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.giveCoupons.coupon_strategy.setting.lowest_unit_price),
      expression: "giveCoupons.coupon_strategy.setting.lowest_unit_price"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.giveCoupons.coupon_strategy.setting.lowest_unit_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.giveCoupons.coupon_strategy.setting, "lowest_unit_price", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("一次最大使用張數")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.giveCoupons.coupon_strategy.setting.one_max_amount),
      expression: "giveCoupons.coupon_strategy.setting.one_max_amount"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.giveCoupons.coupon_strategy.setting.one_max_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.giveCoupons.coupon_strategy.setting, "one_max_amount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])])]) : _vm._e(), _vm._v(" "), (_vm.newCouponType) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr', {
    staticClass: "box-body"
  }), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "form-center box-body"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.giveCoupons.coupon_strategy.limit.min_amount),
      expression: "giveCoupons.coupon_strategy.limit.min_amount"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.giveCoupons.coupon_strategy.limit.min_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.giveCoupons.coupon_strategy.limit, "min_amount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "form-left box-body"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          訂單類型\n        ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.orderType,
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": "訂單類型",
      "show-labels": false,
      "multiple": true,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.giveCoupons.coupon_strategy.limit.order_types),
      callback: function($$v) {
        _vm.$set(_vm.giveCoupons.coupon_strategy.limit, "order_types", $$v)
      },
      expression: "giveCoupons.coupon_strategy.limit.order_types"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          訂單方案\n        ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.orderMethod,
      "searchable": true,
      "allow-empty": true,
      "close-on-select": true,
      "placeholder": "訂單方案",
      "show-labels": false,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.giveCoupons.coupon_strategy.limit.order_method),
      callback: function($$v) {
        _vm.$set(_vm.giveCoupons.coupon_strategy.limit, "order_method", $$v)
      },
      expression: "giveCoupons.coupon_strategy.limit.order_method"
    }
  })], 1)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "form-right box-body"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          取貨方式\n        ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.deliveryType,
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": "取貨方式",
      "show-labels": false,
      "multiple": true,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.giveCoupons.coupon_strategy.limit.delivery_types),
      callback: function($$v) {
        _vm.$set(_vm.giveCoupons.coupon_strategy.limit, "delivery_types", $$v)
      },
      expression: "giveCoupons.coupon_strategy.limit.delivery_types"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制主單(或團長)最低總金額(單位：元)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.giveCoupons.coupon_strategy.limit.min_money),
      expression: "giveCoupons.coupon_strategy.limit.min_money"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.giveCoupons.coupon_strategy.limit.min_money)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.giveCoupons.coupon_strategy.limit, "min_money", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr', {
    staticClass: "box-body"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [(_vm.ruleCode === 'SC00001' || _vm.ruleCode === 'SC00003') ? _c('h5', [_vm._v("例外商品選擇")]) : _c('h5', [_vm._v("指定商品選擇")])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [(_vm.ruleCode === 'SC00002') ? _c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]) : _vm._e(), _vm._v("選擇參與店家菜單")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.storeList,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "店家",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  }, [_vm._v("addExProdToList\n          ")])], 1), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.ruleCode === 'SC00001') ? _c('menu-discount', {
    attrs: {
      "className": 'cs-ae',
      "menuId": _vm.menuSelect.value,
      "showWord": '排除'
    },
    on: {
      "addProdToList": _vm.addExProdToList
    }
  }) : (_vm.ruleCode === 'SC00002') ? _c('menu-discount', {
    attrs: {
      "className": 'cs-pt',
      "menuId": _vm.menuSelect.value,
      "showWord": '加入'
    },
    on: {
      "addProdToList": _vm.addProdToList
    }
  }) : (_vm.ruleCode === 'SC00003') ? _c('menu-discount', {
    attrs: {
      "className": 'cs-pt-3',
      "menuId": _vm.menuSelect.value,
      "showWord": '排除'
    },
    on: {
      "addProdToList": _vm.addExProdToList3
    }
  }) : _vm._e(), _vm._v(" "), (_vm.giveCoupons.coupon_strategy.store_exception_items[0].products.length && (_vm.ruleCode === 'SC00001' || _vm.ruleCode === 'SC00003')) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.giveCoupons.coupon_strategy.store_exception_items[0].products), function(aProduct, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n              " + _vm._s(aIndex + 1) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(aProduct.product_name) + "\n            ")]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(aProduct.vendor_custom_id))])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.giveCoupons.coupon_strategy.store_exception_items[0].products, aIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.giveCoupons.coupon_strategy.setting.vendor_custom_product_list.length && _vm.ruleCode === 'SC00002') ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(8), _vm._v(" "), _c('tbody', _vm._l((_vm.giveCoupons.coupon_strategy.setting.vendor_custom_product_list), function(aProduct, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n              " + _vm._s(aIndex + 1) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(aProduct.product_name) + "\n            ")]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(aProduct.vendor_custom_id))])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.giveCoupons.coupon_strategy.setting.vendor_custom_product_list, aIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)])]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("優惠券折抵規則\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("折抵策略名稱")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("折抵描述")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', [_c('h4', [_vm._v("使用規則")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("滿足商品金額 (買X元，送優惠券)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', [_c('h4', [_vm._v("限制規則")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("限制主單(或團長)最低購買數(單位：個)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品")]), _vm._v(" "), _c('td', [_vm._v("商品料號")]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品")]), _vm._v(" "), _c('td', [_vm._v("商品料號")]), _vm._v(" "), _c('td')])])
}]}

/***/ }),
/* 2385 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('ad-table')], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 2386 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-10 flex align-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.goBackInfo.name,
        params: _vm.goBackInfo.params,
        query: _vm.goBackInfo.query
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default m-r-5 flex"
  }, [_c('span', [_vm._v("返回")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.title)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.subtitle)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex grey darken-1"
  }, [(_vm.brand.name || _vm.store.brand_name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s(_vm.brand.name ? _vm.brand.name : _vm.store.brand_name ? _vm.store.brand_name : '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s('/')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.store.name)
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('cr-category')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2387 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "warning-block"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n    營運報表模組已搬至「\n    "), _c('a', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.goto
    }
  }, [_vm._v("數據分析 > 趨勢分析")]), _vm._v("\n    」，請至新後台管理系統操作、檢視相關內容，此區域(舊後台)功能即將關閉。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "z-index-1"
  }, [(_vm.brandBrief.length > 1) ? _c('div', {
    staticClass: "inline-block from-group pull-left ",
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "label": "label",
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "品牌",
      "show-labels": false,
      "preselect-first": true
    },
    on: {
      "input": _vm.changeBrand
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.storeBrief.length > 1) ? _c('div', {
    staticClass: "from-group pull-left m-l-5 flex"
  }, [_c('div', {
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.storeBrief,
      "label": "label",
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "門市",
      "show-labels": false,
      "preselect-first": true
    },
    on: {
      "input": _vm.changeStore
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1), _vm._v(" "), (_vm.storeSelect.value) ? _c('div', {
    staticClass: "ein"
  }, [_vm._v("\n                統編：" + _vm._s(_vm.ein)), _c('br'), _vm._v("抬頭：" + _vm._s(_vm.storeName) + "\n              ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.storeBrief.length === 0 && _vm.getRoleType === 10) ? _c('div', {
    staticClass: "ein"
  }, [_vm._v("\n              統編：" + _vm._s(_vm.ein)), _c('br'), _vm._v("抬頭：" + _vm._s(_vm.storeName) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-t-50"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      active: _vm.isType('daily')
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectTab = 'daily'
      }
    }
  }, [_vm._v("每日訂單\n                    ")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isType('monthly')
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectTab = 'monthly'
      }
    }
  }, [_vm._v("每月訂單\n                    ")])])]), _vm._v(" "), (_vm.selectTab === 'daily') ? _c('div', {
    staticClass: "download-block m-r-20"
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title",
    attrs: {
      "disabled": _vm.isDownloading
    },
    on: {
      "click": function($event) {
        return _vm.exportFile('chart')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v("\n                    匯出圖表\n                    "), _c('Clip', {
    staticClass: "cliploading",
    attrs: {
      "loading": _vm.isDownloading,
      "color": '#528BB8',
      "size": '16px'
    }
  })], 1)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-t-25 m-l-15"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "flex align-center"
  }, [_c('div', {
    staticClass: "text-14 m-r-15 m-l-15"
  }, [_vm._v("資料期間")]), _vm._v(" "), (_vm.selectTab === 'monthly') ? _c('div', {
    staticClass: "flex align-center"
  }, [_c('date-picker', {
    staticClass: "w-120",
    attrs: {
      "type": "month",
      "valueType": "format",
      "clearable": false,
      "disabled-date": _vm.startMonthLimit
    },
    model: {
      value: (_vm.monthlySearch.start_date),
      callback: function($$v) {
        _vm.$set(_vm.monthlySearch, "start_date", $$v)
      },
      expression: "monthlySearch.start_date"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-l-5 m-r-5"
  }, [_vm._v("-")]), _vm._v(" "), _c('date-picker', {
    staticClass: "w-120",
    attrs: {
      "type": "month",
      "valueType": "format",
      "clearable": false,
      "disabled-date": _vm.endMonthLimit,
      "input-class": "mx-input input-group-input"
    },
    model: {
      value: (_vm.monthlySearch.end_date),
      callback: function($$v) {
        _vm.$set(_vm.monthlySearch, "end_date", $$v)
      },
      expression: "monthlySearch.end_date"
    }
  })], 1) : _c('div', {
    staticClass: "flex align-center"
  }, [_c('date-picker', {
    staticClass: "w-120",
    attrs: {
      "type": "date",
      "valueType": "format",
      "clearable": false,
      "disabled-date": _vm.startDateLimit
    },
    model: {
      value: (_vm.dailySearch.start_date),
      callback: function($$v) {
        _vm.$set(_vm.dailySearch, "start_date", $$v)
      },
      expression: "dailySearch.start_date"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-l-5 m-r-5"
  }, [_vm._v("-")]), _vm._v(" "), _c('date-picker', {
    staticClass: "w-120",
    attrs: {
      "type": "date",
      "valueType": "format",
      "clearable": false,
      "disabled-date": _vm.endDateLimit,
      "input-class": "mx-input input-group-input"
    },
    model: {
      value: (_vm.dailySearch.end_date),
      callback: function($$v) {
        _vm.$set(_vm.dailySearch, "end_date", $$v)
      },
      expression: "dailySearch.end_date"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default submit-btn input-group-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.searchOrderSummary()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 text-right"
  }, [(_vm.selectTab === 'monthly') ? _c('div', {
    staticClass: "m-r-20"
  }, [_c('button', {
    staticClass: "btn btn-xs btn-primary p-x-10",
    on: {
      "click": function($event) {
        return _vm.setDate('year')
      }
    }
  }, [_vm._v("近一年")])]) : _c('div', {
    staticClass: "m-r-20"
  }, [_c('button', {
    staticClass: "btn btn-xs btn-primary p-x-10 m-r-5",
    on: {
      "click": function($event) {
        return _vm.setDate('week')
      }
    }
  }, [_vm._v("近一週")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs btn-primary p-x-10",
    on: {
      "click": function($event) {
        return _vm.setDate('month')
      }
    }
  }, [_vm._v("近一個月")])])])]), _vm._v(" "), _c('div', {
    staticClass: "canvas-block"
  }, [(_vm.selectTab === 'daily') ? _c('div', {
    staticClass: "download-block z-index-1 p-r-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.month),
      expression: "month"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.month = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeMonth]
    }
  }, _vm._l((_vm.monthlyOptions), function(item) {
    return _c('option', {
      key: item.value,
      attrs: {
        "disabled": item.disable
      },
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "m-b-15"
  }, [_vm._v("訂單數量")]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "amount-chart"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-t-64 m-b-15"
  }, [_vm._v("訂單金額")]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "money-chart"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body canvas-block m-t-10"
  }, [_c('div', {
    staticClass: "z-index-1"
  }, [_c('div', {
    staticClass: "m-t-25"
  }, [_vm._v("訂單列表")]), _vm._v(" "), _c('div', {
    staticClass: "row m-t-25 m-b-15"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "flex align-center"
  }, [_c('div', {
    staticClass: "text-14 m-r-15"
  }, [_vm._v("資料期間")]), _vm._v(" "), _c('div', {
    staticClass: "flex align-center"
  }, [_c('date-picker', {
    staticClass: "w-120",
    attrs: {
      "type": "date",
      "valueType": "format",
      "clearable": false,
      "disabled-date": _vm.startDateLimit
    },
    model: {
      value: (_vm.tableSearch.start_date),
      callback: function($$v) {
        _vm.$set(_vm.tableSearch, "start_date", $$v)
      },
      expression: "tableSearch.start_date"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-l-5 m-r-5"
  }, [_vm._v("-")]), _vm._v(" "), _c('date-picker', {
    staticClass: "w-120",
    attrs: {
      "type": "date",
      "valueType": "format",
      "clearable": false,
      "disabled-date": _vm.tableEndDateLimit,
      "input-class": "mx-input input-group-input"
    },
    model: {
      value: (_vm.tableSearch.end_date),
      callback: function($$v) {
        _vm.$set(_vm.tableSearch, "end_date", $$v)
      },
      expression: "tableSearch.end_date"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default submit-btn input-group-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.paginate.tableIndex = 1, _vm.searchTable()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 text-right"
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title",
    attrs: {
      "disabled": _vm.isDownloading
    },
    on: {
      "click": function($event) {
        return _vm.exportFile('table')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v("\n                  下載報表\n                  "), _c('Clip', {
    staticClass: "cliploading",
    attrs: {
      "loading": _vm.isDownloading,
      "color": '#528BB8',
      "size": '16px'
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0 m-t-10"
  }, [_c('table', {
    staticClass: "table table-hover table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData), function(item, key, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm._f("date")(item.date)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.order_amount_accepted))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.order_amount_delivery))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.order_amount_takeout))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.order_amount_qrcode_dinein || 0))]), _vm._v(" "), _c('td', [_c('b', [_vm._v("$" + _vm._s(item.order_money_accepted))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.order_amount_rejected))]), _vm._v(" "), _c('td', [_c('b', [_vm._v("$" + _vm._s(item.order_money_rejected))])])])
  }), 0)])]), _vm._v(" "), _c('paginate', {
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.paginate.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.paginate.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "aria-controls": "example1"
    }
  }, [_vm._v("日期")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-controls": "example1"
    }
  }, [_vm._v("已接單訂單總數")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-controls": "example1"
    }
  }, [_vm._v("外送訂單數")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-controls": "example1"
    }
  }, [_vm._v("自取訂單數")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-controls": "example1"
    }
  }, [_vm._v("內用-桌邊掃碼訂單數")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-controls": "example1"
    }
  }, [_vm._v("已接單訂單總金額")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-controls": "example1"
    }
  }, [_vm._v("\n                    退訂訂單總數\n                    "), _c('span', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "退訂(店家退訂，系統退訂，已取消)訂單總數"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-controls": "example1"
    }
  }, [_vm._v("\n                    退訂訂單總金額\n                    "), _c('span', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "退訂(店家退訂，系統退訂，已取消)訂單總金額"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])
}]}

/***/ }),
/* 2388 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.total) ? _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickEnd('pre')
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickGroup('left')
      }
    }
  }, [_vm._m(1)]), _vm._v(" "), _vm._l((_vm.pageAmount), function(index) {
    return (_vm.pageShow(index)) ? _c('li', {
      staticClass: "paginate_button",
      class: {
        active: _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          return _vm.clickIndex(index)
        }
      }
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v(_vm._s(index))])]) : _vm._e()
  }), _vm._v(" "), _vm._l(((_vm.groupAmount - Math.ceil(_vm.pageAmount % 10))), function(dis) {
    return (_vm.pageGroup === Math.ceil(_vm.pageAmount / _vm.groupAmount)) ? _c('li', {
      staticClass: "paginate_button disabled"
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v("  ")])]) : _vm._e()
  }), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickGroup('right')
      }
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickEnd('forward')
      }
    }
  }, [_vm._m(3)])], 2)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-step-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-forward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-step-forward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 2389 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [(_vm.$config.brand !== 'jkos') ? _c('ul', {
    staticClass: "sidebar-menu"
  }, [(_vm.getRoleType != 50) ? _c('li', {
    staticClass: "active"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-desktop"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            主頁\n          ")])])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.goto
    }
  }, [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            新後台管理系統\n          ")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "header"
  }, [_vm._v("\n        設定\n      ")]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/accountTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-unlock-alt"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            帳號管理\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/platformTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            平台管理\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType !== 10) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/brandTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            品牌管理\n          ")])])], 1) : (_vm.getRoleType === 10 && _vm.sBrandId) ? _c('li', [_c('router-link', {
    attrs: {
      "to": '/storeTable/' + _vm.sBrandId
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            店家管理\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/mealTagTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-tag"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            餐點種類管理\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/announcement"
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            訊息公告\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'TradeSetting'
      }
    }
  }, [_c('img', {
    staticClass: "m-r-5",
    attrs: {
      "src": __webpack_require__(2078)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            金流設定\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType != 50) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("\n        訂單\n      ")]) : _vm._e(), _vm._v(" "), (_vm.getRoleType != 50) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/orderTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            線上訂單列表\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType != 50) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/onSiteOrderTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            線下訂單列表\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType != 50) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/orderExceptionTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            例外訂單\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/blackListTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-frown-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            黑名單\n          ")])])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/ratingTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-star-half-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            評價管理\n          ")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/menuQuerystringView"
    }
  }, [_c('i', {
    staticClass: "fa fa-star-half-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            追蹤碼\n          ")])])], 1), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30 || _vm.getRoleType === 10) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("\n        會員\n      ")]) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/memberTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            會員管理\n          ")])])], 1), _vm._v(" "), (_vm.getRoleType === 99) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/shopperMoneyTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            會員消費管理\n          ")])])], 1) : _vm._e(), _vm._v(" "), (
    _vm.getRoleType !== 50
  ) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("\n        菜單\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.$route.params.brand_id && !_vm.sStoreId && _vm.getRoleType !== 50) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/menuDetailTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-coffee"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            菜單管理\n          ")])])], 1) : _vm._e(), _vm._v(" "), (
    (_vm.$route.params.brand_id || _vm.sStoreId) &&
    _vm.getRoleType !== 50
  ) ? _c('li', [(_vm.getRoleType === 10) ? _c('router-link', {
    attrs: {
      "to": ("/brand/" + _vm.sBrandId + "/ajust/menu")
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-square"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            配料庫\n          ")])]) : _c('router-link', {
    attrs: {
      "to": '/brandMenu/' + _vm.brandId
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-square"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            配料庫\n          ")])])], 1) : _vm._e(), _vm._v(" "), (
    (_vm.$route.params.brand_id || _vm.sStoreId) &&
    _vm.getRoleType !== 50
  ) ? _c('li', [(_vm.getRoleType === 10) ? _c('router-link', {
    attrs: {
      "to": ("/brand/" + _vm.sBrandId + "/build/menu")
    }
  }, [_c('i', {
    staticClass: "fa fa-wrench"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            菜單建置\n          ")])]) : _c('router-link', {
    attrs: {
      "to": '/brandMenuTable/' + _vm.brandId
    }
  }, [_c('i', {
    staticClass: "fa fa-wrench"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            菜單建置\n          ")])])], 1) : _vm._e(), _vm._v(" "), (
    (_vm.$route.params.brand_id || _vm.sStoreId) &&
    _vm.getRoleType !== 50
  ) ? _c('li', [_c('router-link', {
    attrs: {
      "to": '/storeTable/productImage/' + _vm.brandIdForStore + (_vm.sStoreId && _vm.storeList.length === 1 ? '/' + _vm.sStoreId : '')
    }
  }, [_c('i', {
    staticClass: "fa fa-picture-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            圖片庫\n          ")])])], 1) : _vm._e(), _vm._v(" "), (
    (_vm.$route.params.brand_id || _vm.sStoreId) &&
    _vm.getRoleType !== 50
  ) ? _c('li', [_c('router-link', {
    attrs: {
      "to": '/storeTable/productSetting/' + _vm.brandIdForStore + (_vm.sStoreId && _vm.storeList.length === 1 ? '/' + _vm.sStoreId : '')
    }
  }, [_c('i', {
    staticClass: "fa fa-certificate"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            別名 / 描述 / 警語\n          ")])])], 1) : _vm._e(), _vm._v(" "), (
    (_vm.$route.params.brand_id || _vm.sStoreId) &&
    _vm.getRoleType !== 50
  ) ? _c('li', [_c('router-link', {
    attrs: {
      "to": '/cupDiscountTable/' + _vm.brandIdForStore + (_vm.sStoreId && _vm.storeList.length === 1 ? '/' + _vm.sStoreId : '')
    }
  }, [_c('div', {
    staticClass: "flex align-center"
  }, [_c('img', {
    staticClass: "m-r-5",
    staticStyle: {
      "width": "18px",
      "height": "18px"
    },
    attrs: {
      "src": __webpack_require__(2079)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n              自備飲料杯管理\n            ")])])])], 1) : _vm._e(), _vm._v(" "), (
    (_vm.$route.params.brand_id || _vm.sStoreId) &&
    _vm.getRoleType !== 50
  ) ? _c('li', [(_vm.getRoleType === 10) ? _c('router-link', {
    attrs: {
      "to": ("/brand/" + _vm.sBrandId + "/schedule/menu")
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            菜單排程\n          ")])]) : _c('router-link', {
    attrs: {
      "to": '/brandScheduleTable/' + _vm.brandId
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            菜單排程\n          ")])])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "header"
  }, [_vm._v("\n        即時控管\n      ")]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/printerTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            出單機管理\n          ")])])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/disItemTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            停賣管理\n          ")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/disItemScheduleTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            時段停賣管理\n          ")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/limitedItemScheduleTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-university"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            門市限時限量\n          ")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/mqttTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-plug"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            連線管理\n          ")])])], 1), _vm._v(" "), (_vm.getRoleType !== 50) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("\n        活動\n      ")]) : _vm._e(), _vm._v(" "), (_vm.getRoleType !== 50) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/discountTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-tag"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            現折活動管理\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("\n        對帳\n      ")]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/cashAccountTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-credit-card"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            對帳記錄表\n          ")])])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/venderTradeTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-credit-card"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            廠商對帳記錄表\n          ")])])], 1), _vm._v(" "), (_vm.getRoleType === 99) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/cashAccountErrorTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            對帳錯誤紀錄表\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/cashAccountSearch"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            查詢交易資訊\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("\n        統計報表\n      ")]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/weekChartDash"
    }
  }, [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            週報表\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/chartDash"
    }
  }, [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            月報表\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/marketingChart"
    }
  }, [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            行銷報表\n          ")])])], 1) : _vm._e(), _vm._v(" "), ([99, 30, 10].includes(_vm.getRoleType)) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/operatingChart"
    }
  }, [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            營運報表\n          ")])])], 1) : _vm._e(), _vm._v(" "), ([99].includes(_vm.getRoleType)) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/systemUsage"
    }
  }, [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            系統使用率報表\n          ")])])], 1) : _vm._e()]) : _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("\n        設定\n      ")]), _vm._v(" "), (_vm.getRoleType !== 10) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/brandTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            品牌管理\n          ")])])], 1) : (_vm.getRoleType === 10 && _vm.sBrandId) ? _c('li', [_c('router-link', {
    attrs: {
      "to": '/storeTable/' + _vm.sBrandId
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            店家管理\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType !== 50) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("\n        菜單\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.$route.params.brand_id && !_vm.sStoreId && _vm.getRoleType !== 50) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/menuDetailTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-coffee"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            菜單管理\n          ")])])], 1) : _vm._e(), _vm._v(" "), ((_vm.$route.params.brand_id || _vm.sStoreId) && _vm.getRoleType !== 50) ? _c('li', [_c('router-link', {
    attrs: {
      "to": '/brandMenu/' + _vm.brandId
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-square"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            配料庫\n          ")])])], 1) : _vm._e(), _vm._v(" "), ((_vm.$route.params.brand_id || _vm.sStoreId) && _vm.getRoleType !== 50) ? _c('li', [_c('router-link', {
    attrs: {
      "to": '/brandMenuTable/' + _vm.brandId
    }
  }, [_c('i', {
    staticClass: "fa fa-wrench"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            菜單建置\n          ")])])], 1) : _vm._e(), _vm._v(" "), ((_vm.$route.params.brand_id || _vm.sStoreId) && _vm.getRoleType !== 50) ? _c('li', [_c('router-link', {
    attrs: {
      "to": '/storeTable/productImage/' + _vm.brandIdForStore + (_vm.sStoreId && _vm.storeList.length === 1 ? '/' + _vm.sStoreId : '')
    }
  }, [_c('i', {
    staticClass: "fa fa-picture-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            圖片庫\n          ")])])], 1) : _vm._e(), _vm._v(" "), ((_vm.$route.params.brand_id || _vm.sStoreId) && _vm.getRoleType !== 50) ? _c('li', [_c('router-link', {
    attrs: {
      "to": '/storeTable/productSetting/' + _vm.brandIdForStore + (_vm.sStoreId && _vm.storeList.length === 1 ? '/' + _vm.sStoreId : '')
    }
  }, [_c('i', {
    staticClass: "fa fa-certificate"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            別名/描述/警語\n          ")])])], 1) : _vm._e(), _vm._v(" "), ((_vm.$route.params.brand_id || _vm.sStoreId) && _vm.getRoleType !== 50) ? _c('li', [_c('router-link', {
    attrs: {
      "to": '/brandScheduleTable/' + _vm.brandId
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            菜單排程\n          ")])])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "header"
  }, [_vm._v("\n        即時控管\n      ")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/disItemTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            停賣管理\n          ")])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://nidin.shop/resource",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('i', {
    staticClass: "fa fa-cube"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            你訂資源中心\n          ")])])])
}]}

/***/ }),
/* 2390 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('activity-form', {
    attrs: {
      "info": _vm.info
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2391 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('brand-form', {
    attrs: {
      "info": _vm.info
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2392 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row m-b-15"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('div', {
    staticClass: "p-sm-10-p"
  }, [_c('h3', {
    staticClass: "p-a-10 page-title"
  }, [_vm._v(_vm._s(_vm.activityInfo.title))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activityInfo.info),
      expression: "activityInfo.info"
    }]
  }, [_c('div', {
    staticClass: "alert alert-info-bg"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.activityInfo.info)
    }
  })])])]), _vm._v(" "), (_vm.info.info.activity_id && _vm.activity.is_enable.value === 0 && !_vm.info.info.has_used) ? _c('div', {
    staticClass: "box-body form-center"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.info.info.has_used) ? _c('div', {
    staticClass: "box-body form-center"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.name),
      expression: "activity.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.enableOptions,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "啟用",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.is_enable),
      callback: function($$v) {
        _vm.$set(_vm.activity, "is_enable", $$v)
      },
      expression: "activity.is_enable"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.ownerTypeOptions,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "擁有者",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.owner_type),
      callback: function($$v) {
        _vm.$set(_vm.activity, "owner_type", $$v)
      },
      expression: "activity.owner_type"
    }
  })], 1)]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getRoleType === 99 || (_vm.getRoleType === 30 && !_vm.info.info.activity_id)),
      expression: "getRoleType === 99 || (getRoleType === 30 && !info.info.activity_id)"
    }]
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "品牌",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.showWarning
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.enableOptions,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "啟用",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label",
      "disabled": _vm.getRoleType !== 99
    },
    model: {
      value: (_vm.activity.is_platform_visible),
      callback: function($$v) {
        _vm.$set(_vm.activity, "is_platform_visible", $$v)
      },
      expression: "activity.is_platform_visible"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.showWarning
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.enableOptions,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "啟用",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label",
      "disabled": _vm.getRoleType !== 99
    },
    model: {
      value: (_vm.activity.dedicated_visible_setting),
      callback: function($$v) {
        _vm.$set(_vm.activity, "dedicated_visible_setting", $$v)
      },
      expression: "activity.dedicated_visible_setting"
    }
  })], 1)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-sm-10-p"
  }, [_c('div', {
    staticClass: "m-b-15"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.activityInfo.description))])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(9), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.description),
      expression: "activity.description"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "160px"
    },
    attrs: {
      "placeholder": "活動說明",
      "maxlength": "256"
    },
    domProps: {
      "value": (_vm.activity.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-xs-12 p-sm-10-p"
  }, [_c('br'), _vm._v(" "), _c('h3', {
    staticClass: "sub-title"
  }, [_vm._v("活動時間設定")]), _vm._v(" "), _c('div', {
    staticClass: "broder-all"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(10), _vm._v(" "), _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.aTime.type),
      expression: "activity.aTime.type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.activity.aTime, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("依據消費者下訂時間")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("依據消費者的下訂時間+預計取餐時間")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "p-x-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(11), _vm._v(" "), _c('date-time-picker', {
    staticClass: "w-100",
    attrs: {
      "date": _vm.activity.aTime.start,
      "option": _vm.timeoption,
      "limit": _vm.startLimit
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "p-x-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(12), _vm._v(" "), _c('date-time-picker', {
    staticClass: "w-100",
    attrs: {
      "date": _vm.activity.aTime.end,
      "option": _vm.timeoption,
      "limit": _vm.endLimit
    }
  })], 1), _vm._v(" "), _c('br')])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-sm-10-p"
  }, [_c('br'), _vm._v(" "), _c('h4', [_vm._v("參與店家")]), _vm._v(" "), _c('div', _vm._l((_vm.storeClassList), function(storeClass, index) {
    return _c('div', {
      staticClass: "m-r-5 m-b-10 inline-block"
    }, [_c('button', {
      staticClass: "btn btn-default",
      class: {
        'active': _vm.curId === storeClass.id
      },
      on: {
        "click": function($event) {
          return _vm.clickOption(storeClass)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(storeClass.name) + "\n                ")])])
  }), 0), _vm._v(" "), _c('muti-select-two', {
    attrs: {
      "setting": _vm.addStoresSetting,
      "reNew": _vm.reNew,
      "reSet": _vm.reSet
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-sm-10-p"
  }, [_c('h3', {
    staticClass: "sub-title"
  }, [_vm._v("週期/時段活動設定")]), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addProcessTime
    }
  }, [_vm._v("新增某時段的製作時間")])]), _vm._v(" "), _vm._l((_vm.timeSettingList), function(process, pIndex) {
    return _c('div', {
      key: pIndex,
      staticClass: "m-t-10 process-time-block"
    }, [(pIndex !== 0) ? _c('div', {
      staticClass: "text-right m-b-10"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.timeSettingList, pIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]) : _vm._e(), _vm._v(" "), _c('div', [_vm._m(13, true), _vm._v(" "), _c('div', {
      staticClass: "input-group"
    }, [_vm._m(14, true), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (process.value_type),
        expression: "process.value_type"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(process, "value_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.clearProcess(process)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": 0
      }
    }, [_vm._v("無指定")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 1
      }
    }, [_vm._v("日期")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 2
      }
    }, [_vm._v("星期")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), (process.value_type === 2) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(15, true), _vm._v(" "), _c('div', [_c('multiselect', {
      attrs: {
        "placeholder": "新增星期",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdaySetting.options.weekDay,
        "multiple": false,
        "allow-empty": true
      },
      model: {
        value: (process.start_value),
        callback: function($$v) {
          _vm.$set(process, "start_value", $$v)
        },
        expression: "process.start_value"
      }
    })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (process.value_type === 1) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(16, true), _vm._v(" "), _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (process.start_value),
        expression: "process.start_value"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "日期(數字1~31)",
        "type": "text",
        "maxlength": "2"
      },
      domProps: {
        "value": (process.start_value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(process, "start_value", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (process.value_type === 2) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(17, true), _vm._v(" "), _c('div', [_c('multiselect', {
      attrs: {
        "placeholder": "新增星期",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdaySetting.options.weekDay,
        "multiple": false,
        "allow-empty": true
      },
      model: {
        value: (process.end_value),
        callback: function($$v) {
          _vm.$set(process, "end_value", $$v)
        },
        expression: "process.end_value"
      }
    })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (process.value_type === 1) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(18, true), _vm._v(" "), _c('div', [_c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (process.end_value),
        expression: "process.end_value"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "日期(數字1~31)",
        "type": "text",
        "maxlength": "2"
      },
      domProps: {
        "value": (process.end_value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(process, "end_value", $event.target.value)
        }
      }
    })])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(19, true), _vm._v(" "), _c('div', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (process.time_type),
        expression: "process.time_type"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(process, "time_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.changeTimeType(process)
        }]
      }
    }, _vm._l((_vm.timeTypeOption), function(timeType) {
      return _c('option', {
        domProps: {
          "value": timeType.value
        }
      }, [_vm._v(_vm._s(timeType.label))])
    }), 0)])]), _vm._v(" "), _c('br')]), _vm._v(" "), (process.time_type === 2) ? _c('div', {
      staticClass: "text-left"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.addItemTime(process)
        }
      }
    }, [_vm._v("加入時間")])]) : _vm._e(), _vm._v(" "), (process.time_type === 2) ? _c('table', {
      staticClass: "table table-bordered table-striped dataTable"
    }, [_vm._m(20, true), _vm._v(" "), _c('tbody', _vm._l((process.time_interval), function(item, iIndex) {
      return _c('tr', [_c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.start_time),
          expression: "item.start_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.start_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "start_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.end_time),
          expression: "item.end_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.end_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "end_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [(iIndex > 0) ? _c('button', {
        staticClass: "btn btn-danger",
        on: {
          "click": function($event) {
            return _vm.removeListItem(process.time_interval, iIndex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })]) : _vm._e()])])
    }), 0)]) : _vm._e()])
  }), _vm._v(" "), _c('br')], 2), _vm._v(" "), _vm._m(21), _vm._v(" "), (_vm.info.info.has_used) ? _c('div', {
    staticClass: "box-body form-left"
  }, [(_vm.activity.strategy_data.limit.order_types.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  訂單類型\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.activity.strategy_data.limit.order_types), function(orderType) {
    return _c('label', {
      staticClass: "label label-success m-r-5"
    }, [_vm._v("\n                    " + _vm._s(orderType.label) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.order_methods.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  訂單方案\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.activity.strategy_data.limit.order_methods), function(orderMethod) {
    return _c('label', {
      staticClass: "label label-success m-r-5"
    }, [_vm._v("\n                    " + _vm._s(orderMethod.label) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.delivery_types.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  取貨方式\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.activity.strategy_data.limit.delivery_types), function(deliveryType) {
    return _c('label', {
      staticClass: "label label-success m-r-5"
    }, [_vm._v("\n                    " + _vm._s(deliveryType.label) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.trade_types.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  付款方式\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.activity.strategy_data.limit.trade_types), function(tradeType) {
    return _c('label', {
      staticClass: "label label-success m-r-5"
    }, [_vm._v("\n                    " + _vm._s(tradeType.label) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e()]) : _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  訂單類型\n                ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.orderType,
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": _vm.getPlaceholder(_vm.orderType),
      "show-labels": false,
      "multiple": true,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.strategy_data.limit.order_types),
      callback: function($$v) {
        _vm.$set(_vm.activity.strategy_data.limit, "order_types", $$v)
      },
      expression: "activity.strategy_data.limit.order_types"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  訂單方案\n                ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.orderMethod,
      "searchable": true,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": _vm.getPlaceholder(_vm.orderMethod),
      "show-labels": false,
      "multiple": true,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.strategy_data.limit.order_methods),
      callback: function($$v) {
        _vm.$set(_vm.activity.strategy_data.limit, "order_methods", $$v)
      },
      expression: "activity.strategy_data.limit.order_methods"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  取貨方式\n                ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.deliveryType,
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": _vm.getPlaceholder(_vm.deliveryType),
      "show-labels": false,
      "multiple": true,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.strategy_data.limit.delivery_types),
      callback: function($$v) {
        _vm.$set(_vm.activity.strategy_data.limit, "delivery_types", $$v)
      },
      expression: "activity.strategy_data.limit.delivery_types"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  付款方式\n                ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.tradeType,
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": _vm.getPlaceholder(_vm.tradeType),
      "show-labels": false,
      "multiple": true,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.strategy_data.limit.trade_types),
      callback: function($$v) {
        _vm.$set(_vm.activity.strategy_data.limit, "trade_types", $$v)
      },
      expression: "activity.strategy_data.limit.trade_types"
    }
  })], 1)]), _vm._v(" "), _c('br')])]), _vm._v(" "), (_vm.info.info.has_used) ? _c('div', {
    staticClass: "box-body form-right"
  }, [(_vm.activity.strategy_data.limit.min_product_money) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("訂單最低應付金額")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.strategy_data.limit.min_product_money) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.min_product_amount) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.strategy_data.limit.min_product_amount) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (false) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制子單(跟團單)最低訂單數(單位：筆)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.strategy_data.limit.min_sub_order_amount) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e()]) : _c('div', {
    staticClass: "box-body form-right"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(23), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.limit.min_product_money),
      expression: "activity.strategy_data.limit.min_product_money"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "包含扣除折價",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.limit.min_product_money)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.limit, "min_product_money", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(24), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.limit.min_product_amount),
      expression: "activity.strategy_data.limit.min_product_amount"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.limit.min_product_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.limit, "min_product_amount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制子單(跟團單)最低訂單數(單位：筆)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.limit.min_sub_order_amount),
      expression: "activity.strategy_data.limit.min_sub_order_amount"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.limit.min_sub_order_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.limit, "min_sub_order_amount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-sm-10-p form-center box-body"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('h3', {
    staticClass: "sub-title"
  }, [_vm._v("折扣規則")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activityInfo.strategyDataLimitOrderTypes),
      expression: "activityInfo.strategyDataLimitOrderTypes"
    }],
    staticClass: "m-b-15"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.activityInfo.strategyDataLimitOrderTypes))])])]), _vm._v(" "), (_vm.ruleCode === 'SD00001') ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(25), _vm._v(" "), (_vm.info.info.has_used) ? _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.strategy_data.setting.amount_unit) + "\n                ")]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.setting.amount_unit),
      expression: "activity.strategy_data.setting.amount_unit"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.setting.amount_unit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.setting, "amount_unit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : (_vm.ruleCode === 'SD00002') ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "m-b-15"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.activityInfo.strategyDataSettingOneMaxDiscountTips))])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "padding-right": "68px"
    }
  }, [_vm._v("\n                  最大折扣金額\n                ")]), _vm._v(" "), (_vm.info.info.has_used) ? _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.strategy_data.setting.one_max_discount) + "\n                ")]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.setting.one_max_discount),
      expression: "activity.strategy_data.setting.one_max_discount"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "無限制為空",
      "type": "text"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.setting.one_max_discount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.setting, "one_max_discount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : (_vm.ruleCode === 'SD00003') ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(26), _vm._v(" "), (_vm.info.info.has_used) ? _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.strategy_data.setting.amount_unit))]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.setting.amount_unit),
      expression: "activity.strategy_data.setting.amount_unit"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.setting.amount_unit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.setting, "amount_unit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(27), _vm._v(" "), (_vm.info.info.has_used) ? _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.strategy_data.setting.ratio))]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.setting.ratio),
      expression: "activity.strategy_data.setting.ratio"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.setting.ratio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.setting, "ratio", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("\n                  商品限制最低單價\n                  "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activityInfo.strategyDataSettingLowestUnitPriceTips),
      expression: "activityInfo.strategyDataSettingLowestUnitPriceTips"
    }],
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": _vm.activityInfo.strategyDataSettingLowestUnitPriceTips
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), (_vm.info.info.has_used) ? _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.strategy_data.setting.lowest_unit_price) + "\n                ")]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.setting.lowest_unit_price),
      expression: "activity.strategy_data.setting.lowest_unit_price"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.setting.lowest_unit_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.setting, "lowest_unit_price", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : (_vm.ruleCode === 'SD00004') ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "m-b-15"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.activityInfo.strategyDataSettingPercentValueTips))])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(28), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.setting.percent_value),
      expression: "activity.strategy_data.setting.percent_value"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.setting.percent_value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.setting, "percent_value", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "m-b-15"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.activityInfo.strategyDataSettingRoundPolicyTips))])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(29), _vm._v(" "), _c('div', {}, [_c('multiselect', {
    attrs: {
      "options": _vm.roundPolicy,
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": "折扣金額小數點進位方式",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.strategy_data.setting.round_policy),
      callback: function($$v) {
        _vm.$set(_vm.activity.strategy_data.setting, "round_policy", $$v)
      },
      expression: "activity.strategy_data.setting.round_policy"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "padding-right": "145px"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("\n                  是否忽略折讓金額(A+B)\n                  "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activityInfo.strategyDataSettingIgnoreAllowanceTips),
      expression: "activityInfo.strategyDataSettingIgnoreAllowanceTips"
    }],
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": _vm.activityInfo.strategyDataSettingIgnoreAllowanceTips
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {}, [_c('multiselect', {
    attrs: {
      "options": _vm.ignoreAllowance,
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": "是否忽略折讓(A+B)金額",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.strategy_data.setting.ignore_allowance),
      callback: function($$v) {
        _vm.$set(_vm.activity.strategy_data.setting, "ignore_allowance", $$v)
      },
      expression: "activity.strategy_data.setting.ignore_allowance"
    }
  })], 1)]), _vm._v(" "), _c('br')]) : (_vm.ruleCode === 'SD00005') ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("\n                  買X份商品享折扣，X值(單位：份)\n                  "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activityInfo.strategyDataSettingAmountUnitTips),
      expression: "activityInfo.strategyDataSettingAmountUnitTips"
    }],
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": _vm.activityInfo.strategyDataSettingAmountUnitTips
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.setting.amount_unit),
      expression: "activity.strategy_data.setting.amount_unit"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.setting.amount_unit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.setting, "amount_unit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("\n                  折扣金額，Y值(單位：元)\n                  "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activityInfo.strategyDataSettingDiscountUnitTips),
      expression: "activityInfo.strategyDataSettingDiscountUnitTips"
    }],
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": _vm.activityInfo.strategyDataSettingDiscountUnitTips
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.setting.discount_unit),
      expression: "activity.strategy_data.setting.discount_unit"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.setting.discount_unit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.setting, "discount_unit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("\n                  商品限制最低單價\n                  "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activityInfo.strategyDataSettingLowestUnitPriceTips),
      expression: "activityInfo.strategyDataSettingLowestUnitPriceTips"
    }],
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": _vm.activityInfo.strategyDataSettingLowestUnitPriceTips
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.setting.lowest_unit_price),
      expression: "activity.strategy_data.setting.lowest_unit_price"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.setting.lowest_unit_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.setting, "lowest_unit_price", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (!_vm.info.info.has_used) ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [(_vm.ruleCode === 'SD00001' || _vm.ruleCode === 'SD00003' || _vm.ruleCode === 'SD00004' || _vm.ruleCode === 'SD00005') ? [_c('h3', {
    staticClass: "sub-title"
  }, [_vm._v("排除商品選擇")]), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32)] : [_c('h3', {
    staticClass: "sub-title"
  }, [_vm._v("折扣商品選擇")]), _vm._v(" "), _vm._m(33)]], 2) : _vm._e(), _vm._v(" "), (!_vm.info.info.has_used) ? _c('div', {}, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    style: (_vm.selectStorePadding)
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("\n                  選擇店家菜單\n                  "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$route.query.rule_code === 'SD00002'),
      expression: "this.$route.query.rule_code === 'SD00002'"
    }],
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "擇一選擇門市並選取需折扣的商品。"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.storeList,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "店家",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.ruleCode === 'SD00001' && !_vm.info.info.has_used) ? _c('menu-discount', {
    attrs: {
      "menuId": _vm.menuSelect.value,
      "showWord": '排除'
    },
    on: {
      "addProdToList": _vm.addExProdToList
    }
  }) : (_vm.ruleCode === 'SD00002' && !_vm.info.info.has_used) ? _c('menu-discount', {
    attrs: {
      "menuId": _vm.menuSelect.value,
      "showWord": '加入'
    },
    on: {
      "addProdToList": _vm.addProdToList
    }
  }) : (_vm.ruleCode === 'SD00004' && !_vm.info.info.has_used) ? _c('menu-discount', {
    attrs: {
      "menuId": _vm.menuSelect.value,
      "showWord": '排除'
    },
    on: {
      "addProdToList": _vm.addExProdToList
    }
  }) : (_vm.ruleCode === 'SD00005' && !_vm.info.info.has_used) ? _c('menu-discount', {
    attrs: {
      "menuId": _vm.menuSelect.value,
      "showWord": '排除'
    },
    on: {
      "addProdToList": _vm.addExProdToList
    }
  }) : (!_vm.info.info.has_used) ? _c('menu-discount', {
    attrs: {
      "menuId": _vm.menuSelect.value,
      "showWord": '排除'
    },
    on: {
      "addProdToList": _vm.addExProdToList3
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.store_exception_items[0].products.length && (_vm.ruleCode === 'SD00001' || _vm.ruleCode === 'SD00004' || _vm.ruleCode === 'SD00005')) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品")]), _vm._v(" "), _c('td', [_vm._v("商品料號")]), _vm._v(" "), (!_vm.info.info.has_used) ? _c('td') : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.activity.strategy_data.store_exception_items[0].products), function(aProduct, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n                    " + _vm._s(aIndex + 1) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(aProduct.product_name) + "\n                  ")]), _vm._v(" "), _c('td', [(_vm.$route.params.activity_id) ? _c('div', {
      staticClass: "text-primary c-pointer",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#storeProdModal"
      },
      on: {
        "click": function($event) {
          return _vm.getStoreProd(aProduct)
        }
      }
    }, [_vm._v(_vm._s(aProduct.vendor_custom_id))]) : _c('div', [_vm._v(_vm._s(aProduct.vendor_custom_id))])]), _vm._v(" "), (!_vm.info.info.has_used) ? _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.activity.strategy_data.store_exception_items[0].products, aIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]) : _vm._e()])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.setting.product_info.length && _vm.ruleCode === 'SD00002') ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品")]), _vm._v(" "), _c('td', [_vm._v("商品料號")]), _vm._v(" "), _c('td', [_vm._v("折扣規則")]), _vm._v(" "), (!_vm.info.info.has_used) ? _c('td') : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.activity.strategy_data.setting.product_info), function(aProduct, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n                    " + _vm._s(aIndex + 1) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(aProduct.product_name) + "\n                  ")]), _vm._v(" "), _c('td', [(_vm.$route.params.activity_id) ? _c('div', {
      staticClass: "text-primary c-pointer",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#storeProdModal"
      },
      on: {
        "click": function($event) {
          return _vm.getStoreProd(aProduct)
        }
      }
    }, [_vm._v(_vm._s(aProduct.vendor_custom_id))]) : _c('div', [_vm._v(_vm._s(aProduct.vendor_custom_id))])]), _vm._v(" "), (!_vm.info.info.has_used) ? _c('td', [_vm._v("\n                    購買  "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (aProduct.amount_unit),
        expression: "aProduct.amount_unit"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "",
        "type": "text"
      },
      domProps: {
        "value": (aProduct.amount_unit)
      },
      on: {
        "keypress": _vm.returnNum,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(aProduct, "amount_unit", $event.target.value)
        }
      }
    }), _vm._v("  個\n                    折  "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (aProduct.discount),
        expression: "aProduct.discount"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "",
        "type": "text"
      },
      domProps: {
        "value": (aProduct.discount)
      },
      on: {
        "keypress": _vm.returnNum,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(aProduct, "discount", $event.target.value)
        }
      }
    }), _vm._v("  元\n                      "), _c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          return _vm.sameItem(_vm.activity.strategy_data.setting.product_info, aIndex)
        }
      }
    }, [_vm._v("全部套用")])]) : _c('td', [_vm._v("\n                    購買  " + _vm._s(aProduct.amount_unit) + "  個\n                    折  " + _vm._s(aProduct.discount) + "  元\n                  ")]), _vm._v(" "), (!_vm.info.info.has_used) ? _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.activity.strategy_data.setting.product_info, aIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]) : _vm._e()])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.setting.exception_products.length && _vm.ruleCode === 'SD00003') ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品")]), _vm._v(" "), _c('td', [_vm._v("商品料號")]), _vm._v(" "), (!_vm.info.info.has_used) ? _c('td') : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.activity.strategy_data.setting.exception_products), function(aProduct, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n                    " + _vm._s(aIndex + 1) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(aProduct.product_name) + "\n                  ")]), _vm._v(" "), _c('td', [(_vm.$route.params.activity_id) ? _c('div', {
      staticClass: "text-primary c-pointer",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#storeProdModal"
      },
      on: {
        "click": function($event) {
          return _vm.getStoreProd(aProduct)
        }
      }
    }, [_vm._v(_vm._s(aProduct.vendor_custom_id))]) : _c('div', [_vm._v(_vm._s(aProduct.vendor_custom_id))])]), _vm._v(" "), (!_vm.info.info.has_used) ? _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.activity.strategy_data.setting.exception_products, aIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]) : _vm._e()])
  }), 0)])]) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-fail",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n      取消\n    ")]), _vm._v(" "), (_vm.info.info.activity_id) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.checkActivity
    }
  }, [_vm._v("\n      修改\n    ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.checkActivity
    }
  }, [_vm._v("\n      新增\n    ")])]), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "storeProdModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.curVCID) + " 出現的門市")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(34), _vm._v(" "), _c('tbody', _vm._l((_vm.storeProdList), function(sProd, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n                " + _vm._s(aIndex + 1) + "\n              ")]), _vm._v(" "), _c('td', [(sProd.product_id) ? _c('div', [_vm._v("\n                  " + _vm._s(sProd.product_name) + " (" + _vm._s(sProd.product_id) + ")\n                ")]) : _c('div', {
      staticClass: "text-red"
    }, [_vm._v("無對應的商品")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(sProd.store_name))]), _vm._v(" "), _c('td', [(sProd.menu_id) ? _c('div', [_vm._v("\n                  " + _vm._s(sProd.menu_name) + "\n                ")]) : _c('div', {
      staticClass: "text-red"
    }, [_vm._v("無使用中菜單")])])])
  }), 0)])])])])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "warnModal",
    staticClass: "btn",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#warnModal"
    }
  }), _vm._v(" "), _vm._m(35)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-right m-b-10"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-target": "#delModal",
      "data-toggle": "modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "fa fa-star"
  }), _vm._v(" 活動已被使用，無法編輯限制規則、折扣規則，也無法刪除已參與店家 (可新增店家)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "padding-right": "25px"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動名稱")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "padding-right": "25px"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動啟用\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "padding-right": "45px"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("擁有者\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "padding-right": "25px"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("參與品牌\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "padding-right": "25px"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("你訂平台\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon tip-icon-block",
    staticStyle: {
      "padding-right": "25px"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("\n                  街口平台\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "tip-icon",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "與街口支付APP合作之你訂獨家功能，有興趣可洽業務窗口。若未簽約合作請勿啟用。"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("\n                活動說明\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "padding-right": "25px"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動時間\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動開始時間\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動結束時間\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-b-15"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("可指定折扣活動時段：如週一到週三或每日14:00~16:00，若不指定可不需填寫")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("時間類型")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("開始\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("開始\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("結束\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("結束\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("時段設定\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("開始時間")]), _vm._v(" "), _c('td', [_vm._v("結束時間")]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 p-sm-10-p"
  }, [_c('div', [_c('h3', {
    staticClass: "sub-title"
  }, [_vm._v("活動規則")]), _vm._v(" "), _c('div', {
    staticClass: "m-b-15"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("若無特殊限制規則，可不進行異動")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', [_vm._v("訂單最低購買數量(單位：個)")]), _vm._v(" "), _c('span', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "若不限制可不填寫"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', [_vm._v("訂單最低應付金額(單位：元)")]), _vm._v(" "), _c('span', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "訂單需達到最低金額門檻才會觸發活動，若不限制金額可不填寫"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', [_vm._v("訂單最低購買數量(單位：個)")]), _vm._v(" "), _c('span', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "若不限制可不填寫"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n                  折扣滿足總數 (買X送一\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "padding-right": "60px"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("折扣滿足總數 (買X送Y，X數值)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "padding-right": "60px"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("折扣贈送總數 (買X送Y，Y數值)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("\n                  折數設定\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "padding-right": "138px"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("\n                  折扣金額小數點進位方式\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-b-15"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("若有塑膠袋等，記得勾選。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-b-15"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("如排除商品為部分門市限定上架，需使用選擇參與店家找到該門市後再點選排除。 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-b-15"
  }, [_c('div', {
    staticClass: "alert alert-info-bg"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("請注意：先選擇完店家菜單後，再選擇要"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("排除")]), _vm._v("的商品")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-b-15"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("擇一選擇門市並選取需折扣的商品。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品 (ID)")]), _vm._v(" "), _c('td', [_vm._v("門市")]), _vm._v(" "), _c('td', [_vm._v("菜單")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "warnModal",
      "aria-hidden": "true",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("提醒")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "box-body form p-x-0"
  }, [_c('div', [_vm._v("\n              如欲調整揭露平台，請按右上角聯絡客服\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("確定")])])])])])
}]}

/***/ }),
/* 2393 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "warning-block"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n    例外訂單管理功能已搬至「\n    "), _c('a', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.goto
    }
  }, [_vm._v("訂單管理 > 例外訂單")]), _vm._v("\n    」，請至新後台管理系統操作、檢視相關內容，此區域(舊後台)功能即將關閉。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('order-exception-table')], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 2394 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [(_vm.getRoleType === 99) ? _c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-10 flex align-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.goBackInfo.name,
        params: _vm.goBackInfo.params,
        query: _vm.goBackInfo.query
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default m-r-5 flex"
  }, [_c('span', [_vm._v("返回")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.title)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.subtitle)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex grey darken-1"
  }, [(_vm.brand.name || _vm.store.brand_name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s(_vm.brand.name ? _vm.brand.name : _vm.store.brand_name ? _vm.store.brand_name : '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s('/')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.store.name)
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      'active': _vm.scheduleMethod == 1
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.scheduleMethod = 1
      }
    }
  }, [_c('a', [_vm._v("菜單\n              ")])]), _vm._v(" "), (_vm.getRoleType !== 10 && !_vm.isStore) ? _c('li', {
    class: {
      'active': _vm.scheduleMethod == 2
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.scheduleMethod = 2
      }
    }
  }, [_c('a', [_vm._v("各店\n              ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row form-inline"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left form-group"
  }, [_c('div', {
    staticClass: "form-group inline-block"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelect),
      expression: "statusSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.statusSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.statusList), function(status) {
    return _c('option', {
      domProps: {
        "value": status.value
      }
    }, [_vm._v("\n                    " + _vm._s(status.label) + "\n                  ")])
  }), 0)])]), _vm._v(" "), (_vm.scheduleMethod === 2) ? _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchStoreId),
      expression: "searchStoreId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchStoreId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchStoreId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.getList(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), (_vm.scheduleMethod === 2 || _vm.store.name) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("分店(ID)")]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("菜單 (ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("名稱")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("版本碼")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.scheduleMethod === 1 ? '上架時間' : '上架區間') + "\n                ")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.scheduleList), function(menu, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), (_vm.scheduleMethod === 2 || _vm.store.name) ? _c('td', [_vm._v("\n                    " + _vm._s(menu.store_name || _vm.store.name) + " (" + _vm._s(menu.store_id) + ")\n                  ")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(menu.menu_src_id || '-') + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(menu.menu_name) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(menu.menu_ver_stamp) + "\n                  ")]), _vm._v(" "), _c('td', [_c('div', {
      class: [
        'status',
        {
          'status-default': menu.status === 3
        },
        {
          'status-success': menu.status === 4
        },
        {
          'status-danger': menu.status === 5
        } ]
    }, [_vm._v("\n                      " + _vm._s(_vm.statusName(menu.status)) + "\n                    ")])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.getTime(menu.start_time)))]), _vm._v(" "), (_vm.scheduleMethod === 2) ? _c('span', [_vm._v("~ " + _vm._s(_vm.getTime(menu.end_time)))]) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.scheduleMethod === 1 && menu.status !== 4) ? _c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          return _vm.goToStoreMenuScheduleEdit({
            menu: menu,
            type: 1
          })
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]) : (menu.status !== 4) ? _c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          return _vm.goToStoreMenuScheduleEdit({
            menu: menu,
            type: 2
          })
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.scheduleMethod === 1 || _vm.store.name) ? _c('div', [(menu.status === 4) ? _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#removeGNowModal"
      },
      on: {
        "click": function($event) {
          _vm.curGroup = menu.group_id
        }
      }
    }, [_vm._m(1, true), _vm._v("\n                        立即下架\n                      ")]) : (menu.status !== 5 || menu.is_expired !== 1) ? _c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#saleGNowModal"
      },
      on: {
        "click": function($event) {
          _vm.curGroup = menu.group_id
        }
      }
    }, [_vm._m(2, true), _vm._v("\n                        立即上架\n                      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.scheduleMethod === 2) ? _c('div', [(menu.status === 4) ? _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#removeNowModal"
      },
      on: {
        "click": function($event) {
          _vm.curSchedule = menu.schedule_id
        }
      }
    }, [_vm._m(3, true), _vm._v("\n                        立即下架\n                      ")]) : (menu.status !== 5 || menu.is_expired !== 1) ? _c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#saleNowModal"
      },
      on: {
        "click": function($event) {
          _vm.curSchedule = menu.schedule_id
        }
      }
    }, [_vm._m(4, true), _vm._v("\n                        立即上架\n                      ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('td', [(menu.status !== 4) ? _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#delModal"
      },
      on: {
        "click": function($event) {
          _vm.curGroup = menu.group_id
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickEnd('pre')
      }
    }
  }, [_vm._m(5)]), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickGroup('left')
      }
    }
  }, [_vm._m(6)]), _vm._v(" "), _vm._l((_vm.pageAmount), function(index) {
    return (_vm.pageShow(index)) ? _c('li', {
      staticClass: "paginate_button",
      class: {
        active: _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          return _vm.clickPage(index)
        }
      }
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v(_vm._s(index))])]) : _vm._e()
  }), _vm._v(" "), _vm._l(((_vm.groupAmount - Math.ceil(_vm.pageAmount % 10))), function(dis) {
    return (_vm.pageGroup === Math.ceil(_vm.pageAmount / _vm.groupAmount)) ? _c('li', {
      staticClass: "paginate_button disabled"
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v("  ")])]) : _vm._e()
  }), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickGroup('right')
      }
    }
  }, [_vm._m(7)]), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickEnd('forward')
      }
    }
  }, [_vm._m(8)])], 2)])])])])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.removeGNowOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.saleGNowOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.removeNowOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.saleNowOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    staticClass: "form-control h-38"
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("門市ID")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-arrow-circle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-arrow-circle-up"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-arrow-circle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "m-r-1"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-up"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-step-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-forward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-step-forward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 2395 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('store-form')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2396 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-body form-center"
  }, [_c('br'), _vm._v(" "), (_vm.memberInfo.delete_status) ? _c('div', {
    staticClass: "alert alert-info-bg alert-info-border"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.memberInfo.delete_time) + " 會員已註銷\n              ")])]) : _c('div', {
    staticClass: "text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/upMember/' + _vm.memberInfo.shopper_id
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary inherit"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("編號")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.memberInfo.user_no) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("ID")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.memberInfo.shopper_id) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("品牌既有會員ID")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.memberInfo.vendor_custom_user_no) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("暱稱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.memberInfo.nickname) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.roleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("登入類型")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.memberInfo.create_account_type == 1) ? _c('span', [_c('img', {
    staticClass: "img-login-type img-round",
    attrs: {
      "src": "/static/img/icon/phone.svg"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.create_account_type == 2) ? _c('span', [_c('img', {
    staticClass: "img-login-type img-round",
    attrs: {
      "src": "/static/img/icon/fb.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.create_account_type == 3) ? _c('span', [_c('img', {
    staticClass: "img-login-type img-round",
    attrs: {
      "src": "/static/img/icon/google.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.create_account_type == 4) ? _c('span', [_c('img', {
    staticClass: "img-login-type img-round",
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "src": "/static/img/icon/line.png"
    }
  })]) : _vm._e(), (_vm.memberInfo.create_account_owner_type == 2 && _vm.memberInfo.create_account_type == 4) ? _c('span', [_vm._v("(" + _vm._s(_vm.memberInfo.create_account_owner_brand_name) + ")")]) : (_vm.memberInfo.create_account_owner_type == 1 && _vm.memberInfo.create_account_type == 4) ? _c('span', [_vm._v("(你訂)")]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.create_account_type == 5) ? _c('span', [_c('img', {
    staticClass: "img-login-type img-round",
    attrs: {
      "src": "/static/img/icon/jkos.svg"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.create_account_type == 6) ? _c('span', [_c('img', {
    staticClass: "img-login-type img-round",
    attrs: {
      "src": "/static/img/icon/car.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.create_account_type == 7) ? _c('span', [_c('img', {
    staticClass: "img-login-type img-round",
    attrs: {
      "src": "/static/img/icon/existing-member.png"
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("信箱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.memberInfo.email || '未填寫') + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("地址")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.memberInfo.email || '未填寫') + "\n                ")])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [(_vm.memberInfo.birth) ? _c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("生日")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.memberInfo.birth) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("手機")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.memberInfo.phone) + "\n                  "), (_vm.memberInfo.is_phone_valid == 0) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("未通過")]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.is_phone_valid == 1) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("已通過")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [(_vm.roleType === 99) ? _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("停權")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.memberInfo.is_suspend == 0) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("正常")]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.is_suspend == 1) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("停權")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [(_vm.roleType === 99) ? _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("開通")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.memberInfo.is_active == 1) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("啟動")]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.is_active == 0) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("未啟動")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [(_vm.roleType === 99) ? _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("每日交易金額上限")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.memberInfo.daily_trade_limit) + " 元\n                ")])]) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("建立時間")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.memberInfo.create_time) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("備註")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.memberInfo.remark) + "\n                ")])]), _vm._v(" "), _c('br')])]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', {
    staticClass: "box-body form-center"
  }, [_c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group inline-block"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stateType),
      expression: "stateType"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.stateType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.getList(1)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("== 全部狀態 ==")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "avail"
    }
  }, [_vm._v("可使用")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "used"
    }
  }, [_vm._v("已使用")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "invalid"
    }
  }, [_vm._v("無法使用")])])]), _vm._v(" "), (_vm.brandBrief.length > 1) ? _c('div', {
    staticClass: "form-group inline-block"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 品牌 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    on: {
      "input": _vm.changeBrand
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.brandSelect.value !== 0 && _vm.brandSelect.value !== '0' && _vm.storeBrief.length > 1) ? _c('div', {
    staticClass: "form-group inline-block"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.storeBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 門市 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    on: {
      "input": function($event) {
        return _vm.getList(1)
      }
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.couponShallowList.length) ? _c('div', [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.couponShallowList), function(coupon, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                        " + _vm._s(index + 1) + "\n                      ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(coupon.coupon_code) + " (" + _vm._s(coupon.coupon_item_id) + ")\n                      ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(coupon.name))]), _vm._v(" "), _c('td', [(coupon.status === 0) ? _c('span', {
      staticClass: "label label-default"
    }, [_vm._v("未發行")]) : (coupon.status === 9) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("已刪除")]) : (coupon.status === 20) ? _c('span', {
      staticClass: "label label-primary"
    }, [_vm._v("使用中")]) : (coupon.status === 30) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("已使用")]) : (coupon.is_expired) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("已過期")]) : (coupon.is_void) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("已作廢")]) : (coupon.status === 10) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("可使用")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("\n                        ~ " + _vm._s(_vm.getDate(coupon.avail_end_time)) + "\n                      ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.getSourceMethodName(coupon.get_source_method)) + "\n                      ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(coupon.get_time))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickEnd('pre')
      }
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickGroup('left')
      }
    }
  }, [_vm._m(2)]), _vm._v(" "), _vm._l((_vm.pageAmount), function(index) {
    return (_vm.pageShow(index)) ? _c('li', {
      staticClass: "paginate_button",
      class: {
        active: _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          return _vm.clickPage(index)
        }
      }
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v(_vm._s(index))])]) : _vm._e()
  }), _vm._v(" "), _vm._l(((_vm.groupAmount - Math.ceil(_vm.pageAmount % 10))), function(dis) {
    return (_vm.pageGroup === Math.ceil(_vm.pageAmount / _vm.groupAmount)) ? _c('li', {
      staticClass: "paginate_button disabled"
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v("  ")])]) : _vm._e()
  }), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickGroup('right')
      }
    }
  }, [_vm._m(3)]), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickEnd('forward')
      }
    }
  }, [_vm._m(4)])], 2)])])]) : _vm._e()]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("優惠券代碼 (ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("名稱")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("有效期限")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("獲得來源")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("獲得時間")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-step-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-forward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-step-forward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 2397 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.modalId,
    staticClass: "modal fade",
    attrs: {
      "id": _vm.modalId,
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header text-left"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n          " + _vm._s(_vm.modalState) + "\n        ")])]), _vm._v(" "), (!_vm.combineInfo.length && _vm.state != 1) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "text-red"
  }, [_vm._v("\n          請新增此商品的組合  •ᴥ•\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.state != 1 && _vm.combineInfo.length) ? _c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._l((_vm.combineInfo), function(combine, index) {
    return _c('li', {
      class: {
        active: _vm.isTabActive(index + 1)
      },
      attrs: {
        "role": "presentation"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.clickCombine(combine, index)
        }
      }
    }, [_vm._v(_vm._s(combine.name) + "\n              "), (_vm.state == 3 && !_vm.editState && combine.is_common) ? _c('span', [_vm._v(" "), _c('label', {
      staticClass: "badge bg-blue"
    }, [_vm._v("常見")])]) : _vm._e()])])
  }), _vm._v(" "), (_vm.pageAmount > 1) ? _c('li', {
    staticClass: "pull-right"
  }, [_c('ul', {
    staticClass: "pagination",
    staticStyle: {
      "margin": "0px"
    }
  }, _vm._l((_vm.pageAmount), function(index) {
    return _c('li', {
      staticClass: "paginate_button",
      class: {
        active: _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          return _vm.getCombineInfo(index)
        }
      }
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v(_vm._s(index))])])
  }), 0)]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.combineInfo.length) ? _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-right": "10px"
    }
  }, [(_vm.editState) ? _c('button', {
    staticClass: "btn btn-danger icon-modal-del inherit",
    on: {
      "click": function($event) {
        _vm.show.delNotify = !_vm.show.delNotify
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.editState && _vm.state == 3) ? _c('button', {
    staticClass: "btn btn-primary icon-modal-edit inherit",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clickEdit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.editState) ? _c('button', {
    staticClass: "btn btn-primary icon-modal-edit inherit",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.editState = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.show.delNotify) ? _c('div', {
    staticClass: "del-c-block"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.show.delNotify = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.delCombine
    }
  }, [_vm._v("刪除")])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.state == 3 && !_vm.editState && _vm.page == 1 && _vm.combineInfo.length) ? _c('div', {
    staticClass: "box-body form"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("組合名稱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.combineDetail.name))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品名稱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.productName))])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.combineDetail.price) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("價格")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.combineDetail.price) + " (" + _vm._s(_vm.getPriceType(_vm.combineDetail.price_type)) + ")")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.combineDetail.description) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("描述")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.combineDetail.description))])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.combineDetail.remark) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("備註")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.combineDetail.remark))])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("組合更新時間")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.combineDetail.update_time))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("組合建立時間")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.combineDetail.create_time))])]), _vm._v(" "), _c('br')])]) : _vm._e(), _vm._v(" "), (_vm.state == 3 && !_vm.editState && _vm.page == 2) ? _c('div', {
    staticClass: "box-body form",
    class: {
      'form-100-p': _vm.page == 2
    }
  }, [_c('div', {
    staticClass: "col-xs-12 text-left p-x-0"
  }, _vm._l((_vm.isAdjust), function(a, index) {
    return _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "text-black col-xs-12 block-adjust-title"
    }, [_c('span', {
      staticStyle: {
        "top": "6px"
      }
    }, [_vm._v(_vm._s(a.name) + " "), (a.price) ? _c('span', [_vm._v("$" + _vm._s(a.price))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "text-black col-xs-12"
    }, [_c('span', {
      staticClass: "text-15"
    }, [_vm._v(_vm._s(a.description) + " "), (a.remark) ? _c('span', [_vm._v("(" + _vm._s(a.remark) + ")")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "card-body col-xs-12"
    }, _vm._l((a.option_list), function(o, index) {
      return _c('div', {
        staticClass: "col-xs-6 col-md-3 p-5"
      }, [_c('button', {
        staticClass: "btn-options text-16"
      }, [_vm._v(_vm._s(o.name) + " "), (o.price) ? _c('span', [_vm._v("$" + _vm._s(o.price))]) : _vm._e()])])
    }), 0), _vm._v(" "), _vm._m(3, true)])
  }), 0), _vm._v(" "), (_vm.isOption.length) ? _c('div', {
    staticClass: "col-xs-12 text-left p-x-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "card-body col-xs-12"
  }, _vm._l((_vm.isOption), function(o, index) {
    return _c('div', {
      staticClass: "col-xs-6 col-md-3 p-5"
    }, [_c('button', {
      staticClass: "btn-options text-16"
    }, [_vm._v(_vm._s(o.name) + " "), (o.price) ? _c('span', [_vm._v("$" + _vm._s(o.price))]) : _vm._e()])])
  }), 0), _vm._v(" "), _vm._m(5)])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.state == 1 || _vm.editState) ? _c('div', {
    staticClass: "box-body form",
    class: {
      'form-100-p': _vm.page == 2
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page == 1),
      expression: "page == 1"
    }]
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.combineDetail.name),
      expression: "combineDetail.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.combineDetail.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.combineDetail, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品名稱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.productName))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "radio text-left h-38",
    staticStyle: {
      "border-left": "1px solid #d2d6de"
    }
  }, [_c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.combineDetail.is_common),
      expression: "combineDetail.is_common"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "commonRadio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.combineDetail.is_common, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.combineDetail, "is_common", "1")
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("是")])]), _vm._v(" "), _c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.combineDetail.is_common),
      expression: "combineDetail.is_common"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "commonRadio",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.combineDetail.is_common, "0")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.combineDetail, "is_common", "0")
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("否")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("價格")]), _vm._v(" "), (_vm.state == 1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.combineDetail.price),
      expression: "combineDetail.price"
    }],
    ref: "price1",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.combineDetail.price)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityPrice()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.combineDetail, "price", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.state == 3) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.combineDetail.price),
      expression: "combineDetail.price"
    }],
    ref: "price3",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.combineDetail.price)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityPrice()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.combineDetail, "price", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("(選取組合內的選項皆為此價格)")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("價格類型")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.combineDetail.price_type),
      expression: "combineDetail.price_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.combineDetail, "price_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("免稅價格")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("含稅價格")])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("(若無價格則無須更動)")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("備註")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.combineDetail.remark),
      expression: "combineDetail.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.combineDetail.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.combineDetail, "remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page == 2),
      expression: "page == 2"
    }]
  }, [_c('div', {
    staticClass: "col-xs-12 text-left p-x-0"
  }, _vm._l((_vm.adjust), function(a, index) {
    return _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "text-black col-xs-12 block-adjust-title"
    }, [_c('span', {
      staticStyle: {
        "top": "6px"
      }
    }, [_vm._v(_vm._s(a.name) + "  "), (a.price) ? _c('span', [_vm._v("$ " + _vm._s(a.price))]) : _vm._e()]), _vm._v(" "), _c('button', {
      staticClass: "pull-right btn btn-default text-15 btn-add-product btn-success m-l-15",
      on: {
        "click": function($event) {
          return _vm.chooseOptionsByAdjust(a)
        }
      }
    }, [_vm._v("全選")]), _vm._v(" "), _c('button', {
      staticClass: "pull-right btn btn-default text-15 btn-add-product btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeOptionsByAdjust(a)
        }
      }
    }, [_vm._v("全取消")])]), _vm._v(" "), _c('div', {
      staticClass: "text-black col-xs-12"
    }, [_c('span', {
      staticClass: "text-15"
    }, [_vm._v(_vm._s(a.description) + " "), (a.remark) ? _c('span', [_vm._v("(" + _vm._s(a.remark) + ")")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "card-body col-xs-12"
    }, _vm._l((a.option_list), function(o, index) {
      return _c('div', {
        staticClass: "col-xs-6 col-md-3 p-5"
      }, [_c('button', {
        staticClass: "btn-options text-16",
        class: {
          active: o.tag
        }
      }, [_c('span', {
        staticClass: "fake-bg",
        on: {
          "click": function($event) {
            return _vm.chooseOption(o, a)
          }
        }
      }), _vm._v("\n                      " + _vm._s(o.name) + "  "), (o.price) ? _c('span', [_vm._v("$ " + _vm._s(o.price))]) : _vm._e()])])
    }), 0), _vm._v(" "), _vm._m(8, true)])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.state == 3 && !_vm.editState && _vm.page == 1 && _vm.combineInfo.length) ? _c('button', {
    staticClass: "btn btn-primary m-b-15",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.page = 2
      }
    }
  }, [_vm._v("組合內容")]) : _vm._e(), _vm._v(" "), (_vm.state == 3 && !_vm.editState && _vm.page == 2 && _vm.combineInfo.length) ? _c('button', {
    staticClass: "btn btn-primary m-b-15",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.page = 1
      }
    }
  }, [_vm._v("組合明細")]) : _vm._e(), _vm._v(" "), ((_vm.state != 3 || _vm.editState) && _vm.page == 2) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.page = 1
      }
    }
  }, [_vm._v("上一步")]) : _vm._e(), _vm._v(" "), ((_vm.state != 3 || _vm.editState) && _vm.page == 1) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.page = 2
      }
    }
  }, [_vm._v("下一步")]) : _vm._e()])]), _vm._v(" "), (_vm.state != 3 || _vm.editState) ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.state == 1 && _vm.page == 2) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.checkInputEmpty
    }
  }, [_vm._v("新增")]) : _vm._e(), _vm._v(" "), (_vm.editState) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.checkInputEmpty
    }
  }, [_vm._v("編輯")]) : _vm._e()]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header text-left"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("提醒")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body text-left"
  }, [_c('p', [_vm._v("確定刪除此商品？")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "col-xs-12"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-black col-xs-12 block-adjust-title"
  }, [_c('span', {
    staticStyle: {
      "top": "6px"
    }
  }, [_vm._v("其他選項")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "col-xs-12"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("組合名稱")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("常見價格")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "col-xs-12"
  }, [_c('br')])
}]}

/***/ }),
/* 2398 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [_c('div', {
    staticClass: "box-body form text-left"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("編號")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n        " + _vm._s(_vm.memberInfo.user_no) + "\n      ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("ID")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n          " + _vm._s(_vm.memberInfo.shopper_id) + "\n        ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("暱稱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n          " + _vm._s(_vm.memberInfo.nickname) + "\n        ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("登入類型")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.memberInfo.create_account_type == 1) ? _c('span', [_c('img', {
    staticClass: "img-login-type img-round",
    attrs: {
      "src": "/static/img/icon/phone.svg"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.create_account_type == 2) ? _c('span', [_c('img', {
    staticClass: "img-login-type img-round",
    attrs: {
      "src": "/static/img/icon/fb.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.create_account_type == 3) ? _c('span', [_c('img', {
    staticClass: "img-login-type img-round",
    attrs: {
      "src": "/static/img/icon/google.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.create_account_type == 4) ? _c('span', [_c('img', {
    staticClass: "img-login-type img-round",
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "src": "/static/img/icon/line.png"
    }
  })]) : _vm._e(), (_vm.memberInfo.create_account_owner_type == 2 && _vm.memberInfo.create_account_type == 4) ? _c('span', [_vm._v("(" + _vm._s(_vm.memberInfo.create_account_owner_brand_name) + ")")]) : (_vm.memberInfo.create_account_owner_type == 1 && _vm.memberInfo.create_account_type == 4) ? _c('span', [_vm._v("(你訂)")]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.create_account_type == 5) ? _c('span', [_c('img', {
    staticClass: "img-login-type img-round",
    attrs: {
      "src": "/static/img/icon/jkos.svg"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.create_account_type == 6) ? _c('span', [_c('img', {
    staticClass: "img-login-type img-round",
    attrs: {
      "src": "/static/img/icon/car.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.create_account_type == 7) ? _c('span', [_c('img', {
    staticClass: "img-login-type img-round",
    attrs: {
      "src": "/static/img/icon/existing-member.png"
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.memberInfo.sex) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("性別")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.memberInfo.sex == 1) ? _c('span', {
    staticClass: "text-blue"
  }, [_c('i', {
    staticClass: "fa fa-male",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.sex == 2) ? _c('span', {
    staticClass: "text-red"
  }, [_c('i', {
    staticClass: "fa fa-female",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.email) ? _c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("信箱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n          " + _vm._s(_vm.memberInfo.email) + "\n        ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.birth) ? _c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("生日")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n          " + _vm._s(_vm.memberInfo.birth) + "\n        ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('div', [_c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("手機")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.memberInfo.phone),
      expression: "memberInfo.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "10",
      "id": "phone"
    },
    domProps: {
      "value": (_vm.memberInfo.phone)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityPhone()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.memberInfo, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), (!_vm.memberInfo.is_phone_valid) ? _c('div', {
    staticClass: "input-group mb-3",
    staticStyle: {
      "display": "flex"
    }
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.v_code),
      expression: "v_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.v_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.v_code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.v_code),
      expression: "v_code",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    staticClass: "btn btn-secondary m-l-5 m-y-5",
    class: {
      'btn-success': _vm.v_code !== ''
    },
    attrs: {
      "disabled": _vm.v_code === ''
    }
  }, [_vm._v("複製")])])]) : _vm._e(), _vm._v(" "), (!_vm.memberInfo.is_phone_valid) ? _c('span', [_c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          停權\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.memberInfo.is_suspend),
      expression: "memberInfo.is_suspend"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.memberInfo, "is_suspend", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("正常")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("停權")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.memberInfo.create_account_type != 1) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            手機驗證\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.memberInfo.is_phone_valid),
      expression: "memberInfo.is_phone_valid"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.memberInfo, "is_phone_valid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("通過")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未通過")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          " + _vm._s(_vm.memberInfo.create_account_type === 1 ? '手機驗證' : '開通') + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.memberInfo.is_active),
      expression: "memberInfo.is_active"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.memberInfo, "is_active", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("啟動")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("未啟動")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            每日交易金額上限\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.memberInfo.daily_trade_limit),
      expression: "memberInfo.daily_trade_limit"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.memberInfo.daily_trade_limit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.memberInfo, "daily_trade_limit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            居住地\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control"
  }, [_vm._v("\n            " + _vm._s(_vm.cityAreaName(_vm.citySelect, _vm.areaSelect)) + "\n          ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            地址\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.memberInfo.address_short),
      expression: "memberInfo.address_short",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "請輸入地址",
      "type": "text"
    },
    domProps: {
      "value": (_vm.memberInfo.address_short)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.memberInfo, "address_short", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.memberInfo.create_account_type === 7 && !_vm.memberInfo.main_shopper_id) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            備註\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.memberInfo.remark),
      expression: "memberInfo.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "請輸入備註",
      "type": "text"
    },
    domProps: {
      "value": (_vm.memberInfo.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.memberInfo, "remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("\n      取消\n    ")]), _vm._v(" "), (!_vm.info) ? _c('button', {
    staticClass: "btn btn-success"
  }, [_vm._v("\n      新增\n    ")]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.checkInputEmpty
    }
  }, [_vm._v("\n      修改\n    ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.reMessageVerityOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.reMessageWrongOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.sendMessageOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger m-r-5 m-y-5",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#reMessageVerityModal"
    }
  }, [_vm._v("\n              簡訊驗證次數歸零\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger m-r-5 m-y-5",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#reMessageWrongModal"
    }
  }, [_vm._v("\n              驗證錯誤次數歸零\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger m-r-5 m-y-5",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#sendMessageModal"
    }
  }, [_vm._v("\n              產生驗證碼\n            ")])])
}]}

/***/ }),
/* 2399 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('brand-table')], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 此區為建立某張菜單所需的品項")]), _vm._v(" "), _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 如需新增、編輯菜單的內容(商品名稱、分類排序...)，請至品牌菜單內容")])])
}]}

/***/ }),
/* 2400 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h3', {
    staticClass: "text-center",
    staticStyle: {
      "margin-top": "2em",
      "margin-bottom": "1em"
    }
  }, [_vm._v("\n            主帳號資訊\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon min-w-220 text-align-left"
  }, [_vm._v("編號")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.memberInfo.user_no) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon min-w-220 text-align-left"
  }, [_vm._v("暱稱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.memberInfo.nickname) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon min-w-220 text-align-left"
  }, [_vm._v("手機")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.memberInfo.phone) + "\n                  "), (_vm.memberInfo.is_phone_valid == 0) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("未通過")]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.is_phone_valid == 1) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("已通過")]) : _vm._e()])]), _vm._v(" "), _c('br')])]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', {
    staticClass: "box-body form-center min-h-640"
  }, [_c('br'), _vm._v(" "), _c('h3', {
    staticClass: "text-center"
  }, [_vm._v("\n              綁定副帳號資訊\n            ")]), _vm._v(" "), (_vm.integrateMemberList.length) ? _c('div', [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.integrateMemberList), function(mem, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                        " + _vm._s(index + 1) + "\n                      ")]), _vm._v(" "), _c('td', [(mem.account_type == 1) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      attrs: {
        "src": "/static/img/icon/phone.svg"
      }
    })]) : _vm._e(), _vm._v(" "), (mem.account_type == 2) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      attrs: {
        "src": "/static/img/icon/fb.png"
      }
    })]) : _vm._e(), _vm._v(" "), (mem.account_type == 3) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      attrs: {
        "src": "/static/img/icon/google.png"
      }
    })]) : _vm._e(), _vm._v(" "), (mem.account_type == 4) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      staticStyle: {
        "margin-right": "8px"
      },
      attrs: {
        "src": "/static/img/icon/line.png"
      }
    })]) : _vm._e(), (_vm.memberInfo.create_account_owner_type == 2 && _vm.memberInfo.create_account_type == 4) ? _c('span', [_vm._v("(" + _vm._s(_vm.memberInfo.create_account_owner_brand_name) + ")")]) : (_vm.memberInfo.create_account_owner_type == 1 && _vm.memberInfo.create_account_type == 4) ? _c('span', [_vm._v("(你訂)")]) : _vm._e(), _vm._v(" "), (mem.account_type == 5) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      attrs: {
        "src": "/static/img/icon/jkos.svg"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(mem.user_name) + "\n                      ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(mem.provider_owner_name) + "\n                      ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(mem.integrate_time) + "\n                      ")])])
  }), 0)])])])]) : _c('div', [_vm._v("\n              無整合帳號\n            ")])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("暱稱")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("品牌")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("整合時間")])])])
}]}

/***/ }),
/* 2401 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 p-x-0"
  }, [(_vm.productAmount > 1 && _vm.prodType === 'package' && _vm.adjusts.length) ? _c('div', {
    staticClass: "col-xs-12 p-x-0"
  }, [_c('div', {
    staticClass: "inline-block",
    staticStyle: {
      "top": "10px"
    }
  }, [_c('label', {
    staticClass: "text-13 text-black pull-right"
  }, [_c('q-checkbox', {
    model: {
      value: (_vm.adjustSame[_vm.currentProduct[_vm.schema.product.product_id]]),
      callback: function($$v) {
        _vm.$set(_vm.adjustSame, _vm.currentProduct[_vm.schema.product.product_id], $$v)
      },
      expression: "adjustSame[currentProduct[schema.product.product_id]]"
    }
  }), _vm._v("統一口味設定\n      ")], 1)])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pAmountShow), function(pA) {
    return _c('ul', {
      staticClass: "col-xs-12 nav"
    }, [(_vm.pAmountShow > 1) ? _c('li', [_c('hr', {
      staticStyle: {
        "border-top": "dashed 1px #eee"
      }
    }), _vm._v(" "), _c('hr', {
      staticStyle: {
        "border-top": "dashed 1px #eee"
      }
    }), _vm._v("\n      " + _vm._s(pA) + ". " + _vm._s(_vm.currentProduct[_vm.schema.product.name]) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('menu-options', {
      ref: 'menu-options-' + _vm.currentProduct[_vm.schema.product.product_id] + '-index' + pA,
      refInFor: true,
      attrs: {
        "storeState": 2,
        "currentProduct": _vm.currentProduct,
        "prodType": "package",
        "checkPrice": _vm.checkPrice,
        "checkAddProduct": _vm.checkAddProduct,
        "checkAddDifProduct": _vm.checkAddDifProduct,
        "productAmount": _vm.productAmount,
        "optionCheck": _vm.optionCheck,
        "show": _vm.show,
        "productShow": _vm.productShow,
        "adjustSame": _vm.adjustSame,
        "pAIndex": pA,
        "aSameCheck": _vm.aSameCheck,
        "paAdjusts": _vm.adjusts,
        "menuJson": _vm.menuJson,
        "layout": "line",
        "clickProduct": _vm.clickProduct
      }
    })], 1)
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 2402 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [(_vm.categoryList.length === 1 && !_vm.productList.length) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._v("\n    無商品，請新增\n  ")]) : _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12 y-middle"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-danger m-y-10 inline-block pull-right",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    }
  }, [_vm._v("\n          刪除\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-black m-y-10 inline-block m-r-10 pull-right",
    on: {
      "click": _vm.gotoCrProducts
    }
  }, [_vm._v("\n          新增\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-black m-y-10 inline-block m-r-10 pull-right",
    attrs: {
      "data-toggle": "modal"
    },
    on: {
      "click": function($event) {
        _vm.show.easy = !_vm.show.easy
      }
    }
  }, [(!_vm.show.easy) ? _c('span', [_vm._v("簡易")]) : _c('span', [_vm._v("進階")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary m-y-10 pull-right m-r-10 ",
    attrs: {
      "data-toggle": "modal"
    },
    on: {
      "click": _vm.copyProduct
    }
  }, [_vm._v("複製商品")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-2 text-left"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.select.category),
      expression: "select.category"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "46px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.select, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.categoryList), function(category) {
    return _c('option', {
      key: category.item_id,
      domProps: {
        "value": category.item_id
      }
    }, [_vm._v("\n              " + _vm._s(category.name) + _vm._s(category.remark ? (" (" + (category.remark) + ")") : '') + "\n            ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "bg-light-gray m-t-10 select-element-block"
  }, _vm._l((_vm.productList), function(product, index) {
    return _c('div', {
      staticClass: "select-element",
      class: {
        'active': _vm.curId === product.item_id
      },
      attrs: {
        "disabled": _vm.isLoad || _vm.curId === product.item_id
      },
      on: {
        "click": function($event) {
          return _vm.clickProduct(product, index)
        }
      }
    }, [_c('span', {
      staticClass: "text-w-600"
    }, [_vm._v(_vm._s(product.name))]), _vm._v(" "), _c('small', {
      staticStyle: {
        "opacity": ".7"
      }
    }, [_vm._v("  " + _vm._s(product.remark))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-10"
  }, [_c('ul', {
    staticClass: "col-xs-12 nav nav-tabs m-l-10 m-r-10"
  }, [_c('li', {
    class: {
      'active': _vm.tab == 1
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.tab = 1
      }
    }
  }, [_c('a', [_vm._v("明細")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tab == 2
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.tab = 2
      }
    }
  }, [_c('a', [_vm._v("組合 "), (!_vm.combinationList.length) ? _c('span', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()])])]), _vm._v(" "), (!_vm.productList.length) ? _c('div', {
    staticClass: "box-body col-xs-12"
  }, [_c('p', {
    staticClass: "text-center text-danger col-xs-12",
    staticStyle: {
      "margin": "50px 0px"
    }
  }, [_vm._v("此分類無任何商品")])]) : _c('div', {
    staticClass: "box-body form menu-form col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-6 text-left"
  }, [(_vm.tab === 2) ? _c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.combinationList), function(combine) {
    return _c('button', {
      staticClass: "btn btn-default m-y-10 btn-combine",
      class: {
        'active': _vm.curCId === combine.combine_id
      },
      on: {
        "click": function($event) {
          return _vm.clickCombine(combine.combine_id)
        }
      }
    }, [_vm._v(_vm._s(combine.name))])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-left"
  }, [(_vm.tab === 2) ? _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [(_vm.curCId) ? _c('button', {
    staticClass: "btn btn-primary m-y-10 m-r-10 ",
    attrs: {
      "data-target": "#choseProdModal",
      "data-toggle": "modal"
    }
  }, [_vm._v("複製組合")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-black m-y-10 m-r-10 ",
    on: {
      "click": function($event) {
        return _vm.newCombine()
      }
    }
  }, [_vm._v("新增組合")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger m-y-10 inline-block pull-right",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delCombineModal"
    }
  }, [_vm._v("\n                  刪除組合\n                ")])]) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab === 1),
      expression: "tab === 1"
    }],
    staticClass: "col-xs-12 col-md-6 p-r-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.name),
      expression: "productInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.productInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.productInfo, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.sort),
      expression: "productInfo.sort"
    }],
    ref: "sort",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.productInfo.sort)
    },
    on: {
      "keyup": function($event) {
        return _vm.veritySort()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.productInfo, "sort", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.price),
      expression: "productInfo.price"
    }],
    ref: "price",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.productInfo.price)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityPrice()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.productInfo, "price", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.remark),
      expression: "productInfo.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.productInfo.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.productInfo, "remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.sub_type),
      expression: "productInfo.sub_type"
    }],
    staticClass: "form-control h-34",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.productInfo, "sub_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("一般商品")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 101
    }
  }, [_vm._v("塑膠袋")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show.easy && _vm.tab === 1),
      expression: "!show.easy && tab === 1"
    }],
    staticClass: "col-xs-12 col-md-6 p-l-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.min_limit),
      expression: "productInfo.min_limit"
    }],
    ref: "minLimit",
    staticClass: "c-auto form-control",
    staticStyle: {
      "width": "calc(50% - 10px)"
    },
    attrs: {
      "placeholder": "0為無上限",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.productInfo.min_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityMinLimit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.productInfo, "min_limit", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "line-height": "38px",
      "width": "20px"
    }
  }, [_vm._v("~")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.max_limit),
      expression: "productInfo.max_limit"
    }],
    ref: "maxLimit",
    staticClass: "c-auto form-control",
    staticStyle: {
      "width": "calc(50% - 10px)"
    },
    attrs: {
      "placeholder": "0為無上限",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.productInfo.max_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityMaxLimit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.productInfo, "max_limit", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.price_type),
      expression: "productInfo.price_type"
    }],
    staticClass: "form-control h-34",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.productInfo, "price_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("免稅價格")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("含稅價格")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.calorie),
      expression: "productInfo.calorie"
    }],
    ref: "calorie",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.productInfo.calorie)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityCalorie()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.productInfo, "calorie", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.description),
      expression: "productInfo.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.productInfo.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.productInfo, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品料號")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.vendor_custom_id),
      expression: "productInfo.vendor_custom_id"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.productInfo.vendor_custom_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.productInfo, "vendor_custom_id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab === 2),
      expression: "tab === 2"
    }],
    staticClass: "col-xs-12 col-md-6 p-r-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(10), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.combineDetail.name),
      expression: "combineDetail.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.combineDetail.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.combineDetail, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "radio text-left h-38",
    staticStyle: {
      "border-left": "1px solid #d2d6de"
    }
  }, [_c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.combineDetail.is_common),
      expression: "combineDetail.is_common"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "commonRadio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.combineDetail.is_common, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.combineDetail, "is_common", 1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("是")])]), _vm._v(" "), _c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.combineDetail.is_common),
      expression: "combineDetail.is_common"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "commonRadio"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.combineDetail.is_common, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.combineDetail, "is_common", 0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("否")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(12), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.combineDetail.remark),
      expression: "combineDetail.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.combineDetail.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.combineDetail, "remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show.easy && _vm.tab === 2),
      expression: "!show.easy && tab === 2"
    }],
    staticClass: "col-xs-12 col-md-6 p-l-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(14), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.combineDetail.product.edge_price),
      expression: "combineDetail.product.edge_price"
    }],
    ref: "priceProduct",
    staticClass: "form-control",
    attrs: {
      "placeholder": "選取組合內的選項皆為此價格",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.combineDetail.product.edge_price)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityPriceProduct()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.combineDetail.product, "edge_price", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(15), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.combineDetail.price),
      expression: "combineDetail.price"
    }],
    ref: "priceCombine",
    staticClass: "form-control",
    attrs: {
      "placeholder": "選取組合內的選項皆為此價格",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.combineDetail.price)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityPriceCombine()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.combineDetail, "price", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.combineDetail.price_type),
      expression: "combineDetail.price_type"
    }],
    staticClass: "form-control h-34",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.combineDetail, "price_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("免稅價格")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("含稅價格")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkAdjustActive),
      expression: "checkAdjustActive"
    }],
    staticClass: "input-group"
  }, [_vm._m(17), _vm._v(" "), _c('button', {
    staticClass: "form-control btn btn-default",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#choseOptionModal"
    }
  }, [_vm._v("選擇特定配料")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkAdjustActive),
      expression: "checkAdjustActive"
    }],
    staticClass: "input-group"
  }, [_vm._m(18), _vm._v(" "), _c('button', {
    staticClass: "form-control btn btn-default",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#choseMoneyModal"
    }
  }, [_vm._v("變更配料金額")])]), _vm._v(" "), _c('br')])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.gotoOut
    }
  }, [_vm._v("\n      返回\n    ")]), _vm._v(" "), (_vm.categoryList.length === 1 && !_vm.productList.length) ? _c('button', {
    staticClass: "btn btn-default btn-black",
    on: {
      "click": _vm.gotoCrProducts
    }
  }, [_vm._v("\n      新增\n    ")]) : (_vm.productList.length) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.clickSave
    }
  }, [_vm._v("\n      儲存\n    ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('c-modal', {
    attrs: {
      "hideCancel": true,
      "elementList": _vm.allProductList,
      "option": _vm.choseProdOption,
      "curId": _vm.curId
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('c-modal', {
    attrs: {
      "hideCancel": true,
      "elementList": _vm.adjustList,
      "option": _vm.choseOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('c-o-modal', {
    attrs: {
      "hideCancel": true,
      "adjustList": _vm.adjustList,
      "option": _vm.optionOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('c-m-modal', {
    attrs: {
      "hideCancel": true,
      "adjustList": _vm.adjustList,
      "option": _vm.moneyOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delProductOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delCombineOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline-block pull-left"
  }, [_c('h4', {
    staticClass: "pull-left"
  }, [_vm._v("\n          商品\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("產品名稱")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("排"), _c('div', {
    staticClass: "inline-block w-35"
  }), _vm._v("序")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("價"), _c('div', {
    staticClass: "inline-block w-35"
  }), _vm._v("格")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('div', {
    staticClass: "inline-block w-22"
  }), _vm._v("備"), _c('div', {
    staticClass: "inline-block w-35"
  }), _vm._v("註")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("商品類型")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("選購數量")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("價格類型")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('div', {
    staticClass: "inline-block w-22"
  }), _vm._v("熱"), _c('div', {
    staticClass: "inline-block w-35"
  }), _vm._v("量")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('div', {
    staticClass: "inline-block w-22"
  }), _vm._v("描"), _c('div', {
    staticClass: "inline-block w-35"
  }), _vm._v("述")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("組合名稱")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("常見價格")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('div', {
    staticClass: "inline-block w-22"
  }), _vm._v("備"), _c('div', {
    staticClass: "inline-block w-35"
  }), _vm._v("註")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("配料群組")]), _vm._v(" "), _c('button', {
    staticClass: "form-control btn btn-default",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#choseModal"
    }
  }, [_vm._v("選擇配料群組")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('div', {
    staticClass: "inline-block w-22"
  }), _vm._v("商品價格")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('div', {
    staticClass: "inline-block w-22"
  }), _vm._v("組合價格")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('div', {
    staticClass: "inline-block w-22"
  }), _vm._v("價格類型")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("配料單選")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("組合內金額")])
}]}

/***/ }),
/* 2403 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.modalId,
    staticClass: "modal fade",
    attrs: {
      "id": _vm.modalId,
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header text-left"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n          " + _vm._s(_vm.modalState) + "\n        ")])]), _vm._v(" "), (!_vm.combineInfo.length && _vm.state != 1) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "text-red"
  }, [_vm._v("\n          請新增此商品的組合  •ᴥ•\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.state != 1 && _vm.combineInfo.length) ? _c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._l((_vm.combineInfo), function(combine, index) {
    return _c('li', {
      class: {
        active: _vm.isTabActive(index + 1)
      },
      attrs: {
        "role": "presentation"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.clickCombine(combine, index)
        }
      }
    }, [_vm._v(_vm._s(combine.name) + "\n              "), (_vm.state == 3 && !_vm.editState && combine.is_common) ? _c('span', [_vm._v(" "), _c('label', {
      staticClass: "badge bg-blue"
    }, [_vm._v("常見")])]) : _vm._e()])])
  }), _vm._v(" "), (_vm.pageAmount > 1) ? _c('li', {
    staticClass: "pull-right"
  }, [_c('ul', {
    staticClass: "pagination",
    staticStyle: {
      "margin": "0px"
    }
  }, _vm._l((_vm.pageAmount), function(index) {
    return _c('li', {
      staticClass: "paginate_button",
      class: {
        active: _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          return _vm.getCombineInfo(index)
        }
      }
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v(_vm._s(index))])])
  }), 0)]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.combineInfo.length) ? _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-right": "10px"
    }
  }, [(!_vm.editState && _vm.state == 3) ? _c('button', {
    staticClass: "btn btn-primary icon-modal-edit inherit",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.editState = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.editState) ? _c('button', {
    staticClass: "btn btn-primary icon-modal-edit inherit",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.editState = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.state == 3 && !_vm.editState) ? _c('div', {
    staticClass: "box-body form form-100-p"
  }, [_c('div', {
    staticClass: "col-xs-12 text-left p-x-0"
  }, _vm._l((_vm.adjust), function(a, index) {
    return _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "text-black col-xs-12 block-adjust-title"
    }, [_c('span', {
      staticStyle: {
        "top": "6px"
      }
    }, [_vm._v(_vm._s(a.name) + " "), (_vm.getPrice(a.edge_price, a.price)) ? _c('span', [_vm._v("$" + _vm._s(_vm.getPrice(a.edge_price, a.price)))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "text-black col-xs-12"
    }, [_c('span', {
      staticClass: "text-15"
    }, [_vm._v(_vm._s(a.description) + " "), (a.remark) ? _c('span', [_vm._v("(" + _vm._s(a.remark) + ")")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "card-body col-xs-12"
    }, _vm._l((a.option_list), function(o, index) {
      return _c('div', {
        staticClass: "col-xs-6 col-md-3 p-5"
      }, [_c('button', {
        staticClass: "btn-options text-16"
      }, [_vm._v(_vm._s(o.name) + " "), (_vm.getPrice(o.edge_price, o.price)) ? _c('span', [_vm._v("$" + _vm._s(_vm.getPrice(o.edge_price, o.price)))]) : _vm._e()])])
    }), 0), _vm._v(" "), _vm._m(1, true)])
  }), 0), _vm._v(" "), (_vm.option.length) ? _c('div', {
    staticClass: "col-xs-12 text-left p-x-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body col-xs-12"
  }, _vm._l((_vm.option), function(o, index) {
    return _c('div', {
      staticClass: "col-xs-6 col-md-3 p-5"
    }, [_c('button', {
      staticClass: "btn-options text-16"
    }, [_vm._v(_vm._s(o.name) + " "), (_vm.getPrice(o.edge_price, o.price)) ? _c('span', [_vm._v("$" + _vm._s(_vm.getPrice(o.edge_price, o.price)))]) : _vm._e()])])
  }), 0), _vm._v(" "), _vm._m(3)])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.state == 1 || _vm.editState) ? _c('div', {
    staticClass: "box-body form form-100-p"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page),
      expression: "page"
    }]
  }, [_c('div', {
    staticClass: "col-xs-12 text-left p-x-0"
  }, [_vm._l((_vm.adjust), function(a, index) {
    return _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "text-black col-xs-12 block-adjust-title"
    }, [_c('span', {
      staticStyle: {
        "top": "6px"
      }
    }, [_vm._v(_vm._s(a.name) + "  $ "), _c('price-input', {
      attrs: {
        "price": a,
        "id": a.adjust_id
      },
      on: {
        "trigger": _vm.trigger
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "text-black col-xs-12"
    }, [_c('span', {
      staticClass: "text-15"
    }, [_vm._v(_vm._s(a.description) + " "), (a.remark) ? _c('span', [_vm._v("(" + _vm._s(a.remark) + ")")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "card-body col-xs-12"
    }, _vm._l((a.option_list), function(o, index) {
      return _c('div', {
        staticClass: "col-xs-6 col-md-3 p-5"
      }, [_c('button', {
        staticClass: "btn-options text-16",
        class: {
          active: o.tag
        }
      }, [_c('span', [_vm._v(_vm._s(o.name))]), _c('br'), _vm._v("\n                      $ "), _c('price-input', {
        class: {
          disabled: a.price
        },
        staticStyle: {
          "color": "#e1456d"
        },
        attrs: {
          "price": o,
          "id": o.option_id
        },
        on: {
          "trigger": _vm.trigger
        }
      })], 1)])
    }), 0)])
  }), _vm._v(" "), (_vm.option.length) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "card-body col-xs-12"
  }, _vm._l((_vm.option), function(o, index) {
    return _c('div', {
      staticClass: "col-xs-6 col-md-3 p-5"
    }, [_c('button', {
      staticClass: "btn-options text-16"
    }, [_c('span', [_vm._v(_vm._s(o.name))]), _c('br'), _vm._v("\n                      $ "), _c('price-input', {
      staticStyle: {
        "color": "#e1456d"
      },
      attrs: {
        "price": o,
        "id": o.option_id
      },
      on: {
        "trigger": _vm.trigger
      }
    })], 1)])
  }), 0), _vm._v(" "), _vm._m(5)]) : _vm._e()], 2)])]) : _vm._e()]), _vm._v(" "), (_vm.state != 3 || _vm.editState) ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.editState) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.checkInputEmpty
    }
  }, [_vm._v("編輯")]) : _vm._e()]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "col-xs-12"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-black col-xs-12 block-adjust-title"
  }, [_c('span', {
    staticStyle: {
      "top": "6px"
    }
  }, [_vm._v("其他選項")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "col-xs-12"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-black col-xs-12 block-adjust-title"
  }, [_c('span', {
    staticStyle: {
      "top": "6px"
    }
  }, [_vm._v("其他選項")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "col-xs-12"
  }, [_c('br')])
}]}

/***/ }),
/* 2404 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('identity-table')], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 2405 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row m-b-15"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.name),
      expression: "activity.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.title),
      expression: "activity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.sort),
      expression: "activity.sort"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.activity.sort)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "sort", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動說明(後台)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.description),
      expression: "activity.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "活動說明",
      "maxlength": "256"
    },
    domProps: {
      "value": (_vm.activity.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.content),
      expression: "activity.content"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "活動說明",
      "maxlength": "256"
    },
    domProps: {
      "value": (_vm.activity.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "content", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [_c('div', [_c('div', {
    staticClass: "input-group cr-schedule"
  }, [_vm._m(4), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.activity.aTime.start,
      "option": _vm.timeoption,
      "limit": _vm.startLimit
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group cr-schedule"
  }, [_vm._m(5), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.activity.aTime.end,
      "option": _vm.timeoption,
      "limit": _vm.endLimit
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動備註")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.remark),
      expression: "activity.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "活動說明"
    },
    domProps: {
      "value": (_vm.activity.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_c('h5', [_vm._v("參與店家")]), _vm._v(" "), _c('muti-select-two', {
    attrs: {
      "setting": _vm.addStoresSetting
    }
  })], 1), _vm._v(" "), _c('hr', {
    staticClass: "box-body col-xs-12"
  }), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  訂單類型\n                ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.orderType,
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": "訂單類型",
      "show-labels": false,
      "multiple": true,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.strategy_data[0].limit.order_type),
      callback: function($$v) {
        _vm.$set(_vm.activity.strategy_data[0].limit, "order_type", $$v)
      },
      expression: "activity.strategy_data[0].limit.order_type"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  訂單方案\n                ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.orderMethod,
      "searchable": true,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": "訂單方案",
      "show-labels": false,
      "multiple": true,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.strategy_data[0].limit.order_method),
      callback: function($$v) {
        _vm.$set(_vm.activity.strategy_data[0].limit, "order_method", $$v)
      },
      expression: "activity.strategy_data[0].limit.order_method"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  取貨方式\n                ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.deliveryType,
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": "取貨方式",
      "show-labels": false,
      "multiple": true,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.strategy_data[0].limit.delivery_type),
      callback: function($$v) {
        _vm.$set(_vm.activity.strategy_data[0].limit, "delivery_type", $$v)
      },
      expression: "activity.strategy_data[0].limit.delivery_type"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  付款地點\n                ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.payPlaceType,
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": "付款地點",
      "show-labels": false,
      "multiple": true,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.strategy_data[0].limit.pay_place_type),
      callback: function($$v) {
        _vm.$set(_vm.activity.strategy_data[0].limit, "pay_place_type", $$v)
      },
      expression: "activity.strategy_data[0].limit.pay_place_type"
    }
  })], 1)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("訂單最低應付金額(單位：元)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data[0].limit.min_total_paid_money),
      expression: "activity.strategy_data[0].limit.min_total_paid_money"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "包含扣除折價",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data[0].limit.min_total_paid_money)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data[0].limit, "min_total_paid_money", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("訂單最低總金額(單位：元)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data[0].limit.min_total_money),
      expression: "activity.strategy_data[0].limit.min_total_money"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data[0].limit.min_total_money)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data[0].limit, "min_total_money", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("訂單最低購買數(單位：個)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data[0].limit.min_total_amount),
      expression: "activity.strategy_data[0].limit.min_total_amount"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data[0].limit.min_total_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data[0].limit, "min_total_amount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制主單(或團長)最低應付金額(單位：元)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data[0].limit.min_paid_money),
      expression: "activity.strategy_data[0].limit.min_paid_money"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "包含扣除折價",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data[0].limit.min_paid_money)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data[0].limit, "min_paid_money", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制主單(或團長)最低總金額(單位：元)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data[0].limit.min_money),
      expression: "activity.strategy_data[0].limit.min_money"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data[0].limit.min_money)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data[0].limit, "min_money", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制主單(或團長)最低購買數(單位：個)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data[0].limit.min_amount),
      expression: "activity.strategy_data[0].limit.min_amount"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data[0].limit.min_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data[0].limit, "min_amount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制子單(跟團單)最低訂單數(單位：筆)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data[0].limit.min_sub_order_amount),
      expression: "activity.strategy_data[0].limit.min_sub_order_amount"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data[0].limit.min_sub_order_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data[0].limit, "min_sub_order_amount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.checkActivity
    }
  }, [_vm._v("\n      新增\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fail",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n      取消\n    ")])]), _vm._v(" "), _vm._l((_vm.couponList), function(cInfo, index) {
    return _c('div', [_c('div', {
      staticClass: "modal fade",
      attrs: {
        "id": 'couponRegisterModal' + index,
        "role": "dialog"
      }
    }, [_c('div', {
      staticClass: "modal-dialog choose-modal"
    }, [_c('div', {
      staticClass: "modal-content pull-left"
    }, [_vm._m(7, true), _vm._v(" "), (_vm.coupon.coupon_info) ? _c('div', {
      staticClass: "card m-y-1 pull-left m-y-10 c-pointer",
      staticStyle: {
        "width": "calc(100% - 80px)"
      },
      attrs: {
        "data-target": '#couponRegisterModal' + index,
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          return _vm.clickCoupon()
        }
      }
    }, [_c('div', {
      staticClass: "coupon-left p-10"
    }, [_c('h4', [(_vm.coupon.coupon_info.name) ? _c('span', [_vm._v(_vm._s(_vm.coupon.coupon_info.name))]) : _c('span', [_vm._v("優惠券名稱")])]), _vm._v(" "), _c('h5', [(_vm.coupon.coupon_info.description) ? _c('span', [_vm._v(_vm._s(_vm.coupon.coupon_info.description))]) : _c('span', [_vm._v("優惠券描述....")])]), _vm._v(" "), _c('h5', [_vm._v("到期："), (_vm.coupon.time_config.start_time.time) ? _c('span', [_vm._v(_vm._s(_vm.coupon.time_config.start_time.time) + " ~ " + _vm._s(_vm.coupon.time_config.end_time.time))]) : _c('span', [_vm._v(_vm._s(_vm.nowTime) + " ~ " + _vm._s(_vm.nowTime))])])]), _vm._v(" "), _c('div', {
      staticClass: "coupon-right p-10"
    }, [_c('div', {
      staticClass: "v-middle"
    }, [_vm._v("\n                $"), (_vm.coupon.coupon_info.discount_value) ? _c('span', [_vm._v(_vm._s(_vm.coupon.coupon_info.discount_value))]) : _c('span', [_vm._v("10")])])])]) : _vm._e()])])])])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動名稱(後台)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動名稱(前端)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動順序")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動說明(前端)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動開始時間\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動結束時間\n                      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_c('div', [_c('h4', [_vm._v("限制規則")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header pull-left w-100-p"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title text-left"
  }, [_vm._v("優惠券設定")])])
}]}

/***/ }),
/* 2406 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('account-form')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2407 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.brandBrief.length > 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandSelect),
      expression: "brandSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.brandSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.clickSearch]
    }
  }, _vm._l((_vm.brandBrief), function(brand) {
    return _c('option', {
      domProps: {
        "value": brand.value
      }
    }, [_vm._v("\n            " + _vm._s(brand.label) + "\n          ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.storeBrief.length > 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeSelect),
      expression: "storeSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.storeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.clickSearch]
    }
  }, _vm._l((_vm.storeBrief), function(store) {
    return _c('option', {
      domProps: {
        "value": store.value
      }
    }, [_vm._v("\n            " + _vm._s(store.label) + "\n          ")])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-sm-6 col-xs-12 p-x-10"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text m-t-5"
  }, [_vm._v("訂購總人數")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number text-35"
  }, [_vm._v(_vm._s(_vm.platformMoney.shopper_count))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-sm-6 col-xs-12 p-x-10"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text m-t-5"
  }, [_vm._v("累積成交訂單數量")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number text-35"
  }, [_vm._v(_vm._s(_vm.platformMoney.order_count_total))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-sm-6 col-xs-12 p-x-10"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text m-t-5"
  }, [_vm._v("累積成交訂單金額")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number text-35"
  }, [_vm._v(_vm._s(_vm.platformMoney.order_money_total))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-sm-6 col-xs-12 p-x-10"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text m-t-5"
  }, [_vm._v("累積成交商品數量")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number text-35"
  }, [_vm._v(_vm._s(_vm.platformMoney.item_count_total))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-body p-0 col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12 text-left"
  }, [_c('div', {
    staticClass: "m-b-15"
  }, [_c('ion-icon', {
    attrs: {
      "name": "list-box"
    }
  }), _vm._v(" 期間內成交訂單數量： " + _vm._s(_vm.platformMoney.order_count_seg) + " 筆"), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "ion ion-cash"
  }), _vm._v(" 期間內成交訂單金額： " + _vm._s(_vm.platformMoney.order_money_seg) + " 元"), _c('br'), _vm._v(" "), _c('ion-icon', {
    attrs: {
      "name": "restaurant"
    }
  }), _vm._v(" 期間內成交商品數量： " + _vm._s(_vm.platformMoney.item_count_seg) + " 份\n            ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: " col-xs-12 col-sm-6 text-right pull-right"
  }, [_c('div', {
    staticClass: "form-group input-group time-box pull-right"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.dateoption,
      "limit": _vm.startLimit
    }
  }), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.dateoption,
      "limit": _vm.endLimit
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default submit-btn btn-search",
    staticStyle: {
      "height": "72px"
    },
    attrs: {
      "type": "button",
      "id": "search2"
    },
    on: {
      "click": function($event) {
        return _vm.clickSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("使用者")]), _vm._v(" "), (_vm.roleType === 99) ? _c('th', {
    staticClass: "th-fit c-pointer",
    attrs: {
      "rowspan": "2"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('shopper_id')
      }
    }
  }, [_vm._v("ID\n                "), (_vm.sortMethod === 'shopper_id') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "1",
      "colspan": "2"
    }
  }, [_c('ion-icon', {
    attrs: {
      "name": "list-box"
    }
  }), _vm._v(" 成交訂單數")], 1), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "1",
      "colspan": "2"
    }
  }, [_c('ion-icon', {
    attrs: {
      "name": "restaurant"
    }
  }), _vm._v(" 成交商品數")], 1), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "th-fit c-pointer",
    on: {
      "click": function($event) {
        return _vm.checkSort('order_count_seg')
      }
    }
  }, [_vm._v("期間\n                "), (_vm.sortMethod === 'order_count_seg') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "th-fit c-pointer",
    on: {
      "click": function($event) {
        return _vm.checkSort('order_count_total')
      }
    }
  }, [_vm._v("累積\n                "), (_vm.sortMethod === 'order_count_total') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "th-fit c-pointer",
    on: {
      "click": function($event) {
        return _vm.checkSort('money_seg')
      }
    }
  }, [_vm._v("期間\n                "), (_vm.sortMethod === 'money_seg') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "th-fit c-pointer",
    on: {
      "click": function($event) {
        return _vm.checkSort('money_total')
      }
    }
  }, [_vm._v("累積\n                "), (_vm.sortMethod === 'money_total') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "th-fit c-pointer",
    on: {
      "click": function($event) {
        return _vm.checkSort('item_count_seg')
      }
    }
  }, [_vm._v("期間\n                "), (_vm.sortMethod === 'item_count_seg') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "th-fit c-pointer",
    on: {
      "click": function($event) {
        return _vm.checkSort('item_count_total')
      }
    }
  }, [_vm._v("累積\n                "), (_vm.sortMethod === 'item_count_total') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(5)]) : (_vm.shopperMoneyList.length === 0) ? _c('tbody', [_vm._m(6)]) : (_vm.shopperMoneyList.length > 0) ? _c('tbody', _vm._l((_vm.shopperMoneyList), function(shopper, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": '/memberOrderTable/' + shopper.shopper_id,
        "target": "_blank"
      }
    }, [_vm._v("\n                    " + _vm._s(shopper.user_no) + "\n                    | " + _vm._s(shopper.nickname) + "\n                    "), (shopper.last_name || shopper.first_name) ? _c('span', [_vm._v(" (" + _vm._s(shopper.last_name) + _vm._s(shopper.first_name) + ")")]) : _vm._e()])], 1), _vm._v(" "), (_vm.roleType === 99) ? _c('td', [_vm._v(_vm._s(shopper.shopper_id))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(shopper.order_count_seg))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shopper.order_count_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shopper.money_seg))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shopper.money_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shopper.item_count_seg))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shopper.item_count_total))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#shopperMoneyModal"
      },
      on: {
        "click": function($event) {
          return _vm.openModal(shopper)
        }
      }
    }, [_c('i', {
      staticClass: "ion ion-cash"
    })])])])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickEnd('pre')
      }
    }
  }, [_vm._m(7)]), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickGroup('left')
      }
    }
  }, [_vm._m(8)]), _vm._v(" "), _vm._l((_vm.pageAmount), function(index) {
    return (_vm.pageShow(index)) ? _c('li', {
      staticClass: "paginate_button",
      class: {
        active: _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          return _vm.clickPage(index)
        }
      }
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v(_vm._s(index))])]) : _vm._e()
  }), _vm._v(" "), _vm._l(((_vm.groupAmount - Math.ceil(_vm.pageAmount % 10))), function(dis) {
    return (_vm.pageGroup === Math.ceil(_vm.pageAmount / _vm.groupAmount)) ? _c('li', {
      staticClass: "paginate_button disabled"
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v("  ")])]) : _vm._e()
  }), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickGroup('right')
      }
    }
  }, [_vm._m(9)]), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickEnd('forward')
      }
    }
  }, [_vm._m(10)])], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "shopperMoneyModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.shopperInfo.nickname) + "消費統計")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable text-center",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('ion-icon', {
    attrs: {
      "name": "list-box"
    }
  }), _vm._v(" 成交訂單數")], 1), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('ion-icon', {
    attrs: {
      "name": "restaurant"
    }
  }), _vm._v(" 成交商品數")], 1)]), _vm._v(" "), _vm._m(12)]), _vm._v(" "), _c('tbody', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.shopperInfo.order_count_seg) + " / " + _vm._s(_vm.platformMoney.order_count_seg))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shopperInfo.order_count_total) + " / " + _vm._s(_vm.platformMoney.order_count_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shopperInfo.money_seg) + " / " + _vm._s(_vm.platformMoney.order_money_seg))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shopperInfo.money_total) + " / " + _vm._s(_vm.platformMoney.order_money_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shopperInfo.item_count_seg) + " / " + _vm._s(_vm.platformMoney.item_count_seg))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shopperInfo.item_count_total) + " / " + _vm._s(_vm.platformMoney.item_count_total))])]), _vm._v(" "), _c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    class: {
      'text-red': _vm.getPercent(_vm.shopperInfo.order_count_seg, _vm.platformMoney.order_count_seg) > 0.01
    }
  }, [_vm._v(_vm._s(_vm.getPercent(_vm.shopperInfo.order_count_seg, _vm.platformMoney.order_count_seg)) + "％")]), _vm._v(" "), _c('td', {
    class: {
      'text-red': _vm.getPercent(_vm.shopperInfo.order_count_total, _vm.platformMoney.order_count_total) > 0.01
    }
  }, [_vm._v(_vm._s(_vm.getPercent(_vm.shopperInfo.order_count_total, _vm.platformMoney.order_count_total)) + "％")]), _vm._v(" "), _c('td', {
    class: {
      'text-red': _vm.getPercent(_vm.shopperInfo.money_seg, _vm.platformMoney.order_money_seg) > 0.01
    }
  }, [_vm._v(_vm._s(_vm.getPercent(_vm.shopperInfo.money_seg, _vm.platformMoney.order_money_seg)) + "％")]), _vm._v(" "), _c('td', {
    class: {
      'text-red': _vm.getPercent(_vm.shopperInfo.money_total, _vm.platformMoney.order_money_total) > 0.01
    }
  }, [_vm._v(_vm._s(_vm.getPercent(_vm.shopperInfo.money_total, _vm.platformMoney.order_money_total)) + "％")]), _vm._v(" "), _c('td', {
    class: {
      'text-red': _vm.getPercent(_vm.shopperInfo.item_count_seg, _vm.platformMoney.item_count_seg) > 0.01
    }
  }, [_vm._v(_vm._s(_vm.getPercent(_vm.shopperInfo.item_count_seg, _vm.platformMoney.item_count_seg)) + "％")]), _vm._v(" "), _c('td', {
    class: {
      'text-red': _vm.getPercent(_vm.shopperInfo.item_count_total, _vm.platformMoney.item_count_total) > 0.01
    }
  }, [_vm._v(_vm._s(_vm.getPercent(_vm.shopperInfo.item_count_total, _vm.platformMoney.item_count_total)) + "％")])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-red"
  }, [_c('i', {
    staticClass: "ion ion-ios-people"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-aqua"
  }, [_c('i', {
    staticClass: "ion ion-document-text"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-green"
  }, [_c('i', {
    staticClass: "ion ion-cash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-light-blue"
  }, [_c('i', {
    staticClass: "ion ion-wineglass"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "rowspan": "1",
      "colspan": "2"
    }
  }, [_c('i', {
    staticClass: "ion ion-cash"
  }), _vm._v(" 成交訂單金額")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-step-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-forward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-step-forward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('i', {
    staticClass: "ion ion-cash"
  }), _vm._v(" 成交訂單金額")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "c-pointer"
  }, [_vm._v("期間")]), _vm._v(" "), _c('th', {
    staticClass: "c-pointer"
  }, [_vm._v("累積")]), _vm._v(" "), _c('th', {
    staticClass: "c-pointer"
  }, [_vm._v("期間")]), _vm._v(" "), _c('th', {
    staticClass: "c-pointer"
  }, [_vm._v("累積")]), _vm._v(" "), _c('th', {
    staticClass: "c-pointer"
  }, [_vm._v("期間")]), _vm._v(" "), _c('th', {
    staticClass: "c-pointer"
  }, [_vm._v("累積")])])
}]}

/***/ }),
/* 2408 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('v-multiselect-listbox', {
    staticClass: "col-xs-12",
    attrs: {
      "options": _vm.setting.options,
      "reduce-display-property": function (option) { return option.label; },
      "reduce-value-property": function (option) { return option.value; },
      "search-input-class": _vm.setting.class,
      "search-options-placeholder": "搜尋...",
      "selected-options-placeholder": "搜尋..."
    },
    model: {
      value: (_vm.setting.choose),
      callback: function($$v) {
        _vm.$set(_vm.setting, "choose", $$v)
      },
      expression: "setting.choose"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clear-both"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex mb-3 font-size-subtitle-2"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("\n      不套用門市\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "w-md"
  }), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_vm._v("\n      套用門市\n    ")])])
}]}

/***/ }),
/* 2409 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body form-center"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "img-store-info",
    attrs: {
      "src": _vm.info.image_name
    }
  }), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/upBrand/' + _vm.info.id
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary inherit"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("名稱 (ID)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.name) + " (" + _vm._s(_vm.info.id) + ")\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("名稱縮寫")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.name_short) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("名稱別名")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.nameAliasDisplay) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("代碼(鍵值)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.brand_code) + " (" + _vm._s(_vm.info.brand_key) + ")\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("排序")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.sort) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                標語\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.slogan) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.info.comment) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                訊息\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.comment) + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.info.description) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                描述\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.description) + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.info.introduction) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                品牌頁介紹\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.introduction) + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.info.email) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                信箱\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.email) + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.info.youtube_video_code) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                Youtube影片代碼\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.youtube_video_code) + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                品牌上架\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(!_vm.info.is_opening) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("未上架")]) : _vm._e(), _vm._v(" "), (_vm.info.is_opening) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("已上架")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                前端顯示\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(!_vm.info.is_visible) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("未顯示")]) : _vm._e(), _vm._v(" "), (_vm.info.is_visible) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("顯示")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                刪除\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.info.is_delete) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("刪除")]) : _vm._e(), _vm._v(" "), (!_vm.info.is_delete) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("未刪除")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("最後更新時間")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.edit_time) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("建立時間")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.create_time) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("聯名圖")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('img', {
    staticStyle: {
      "max-height": "50px"
    },
    attrs: {
      "src": _vm.info.logo_name
    }
  })])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.info.photo_name) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("底圖")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('img', {
    staticStyle: {
      "max-height": "100px"
    },
    attrs: {
      "src": _vm.info.photo_name
    }
  })])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.info.meal_tag_setting.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                餐點種類\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.info.meal_tag_setting), function(mealSetting) {
    return _c('span', {
      staticClass: "label label-success m-b-5 m-r-5"
    }, [_vm._v(_vm._s(mealSetting.name))])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), (_vm.info.website_setting.length) ? _c('div', {
    staticClass: "box-body form-center"
  }, [_c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.info.website_setting), function(setting, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                    " + _vm._s(setting.name) + "\n                  ")]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": setting.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(setting.url))])])])
  }), 0)])])])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("資訊")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("連結")])])])
}]}

/***/ }),
/* 2410 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [(!_vm.blockList.length) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._v("\n    無選擇區，請新增\n  ")]) : _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-danger inline-block m-y-10 pull-right",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    },
    on: {
      "click": _vm.delModalOpen
    }
  }, [_vm._v("\n          刪除\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-black btn-default inline-block m-r-10 m-y-10 pull-right",
    on: {
      "click": _vm.gotoCrBlocks
    }
  }, [_vm._v("\n          新增\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-black btn-default inline-block m-r-10 m-y-10 pull-right",
    attrs: {
      "data-toggle": "modal"
    },
    on: {
      "click": function($event) {
        _vm.show.easy = !_vm.show.easy
      }
    }
  }, [(!_vm.show.easy) ? _c('span', [_vm._v("簡易")]) : _c('span', [_vm._v("進階")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary m-r-10 m-y-10 pull-right",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#choseModal"
    },
    on: {
      "click": function($event) {
        return _vm.clearAllActive(_vm.blockChoseList)
      }
    }
  }, [_vm._v("\n          複製商品到其他選擇區\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    ref: "selectBlock",
    staticClass: "bg-light-gray col-md-2 col-xs-12 select-element-block text-left"
  }, _vm._l((_vm.blockList), function(block, index) {
    return _c('div', {
      key: block.item_id,
      staticClass: "select-element",
      class: {
        'active': _vm.curId === block.item_id
      },
      attrs: {
        "disabled": _vm.isLoad || _vm.curId === block.item_id
      },
      on: {
        "click": function () { return _vm.clickBlock(block, index); }
      }
    }, [_c('span', {
      staticClass: "text-w-600"
    }, [_vm._v(_vm._s(block.name))]), _vm._v(" "), _c('small', {
      staticStyle: {
        "opacity": ".7"
      }
    }, [_vm._v("  " + _vm._s(block.remark))])])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoad),
      expression: "!isLoad"
    }],
    staticClass: "col-md-10 col-xs-12"
  }, [_c('div', {
    staticClass: "box-body col-xs-12 form menu-form"
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-12 p-r-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.blockInfo.name),
      expression: "blockInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "32"
    },
    domProps: {
      "value": (_vm.blockInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.blockInfo, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.blockInfo.sort),
      expression: "blockInfo.sort"
    }],
    ref: "sort1",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.blockInfo.sort)
    },
    on: {
      "keyup": _vm.veritySort,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.blockInfo, "sort", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "h-38 radio text-left",
    staticStyle: {
      "border-left": "1px solid #d2d6de"
    }
  }, [_c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.blockInfo.is_mandatory),
      expression: "blockInfo.is_mandatory"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "mandatoryRadio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.blockInfo.is_mandatory, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.blockInfo, "is_mandatory", 1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("是")])]), _vm._v(" "), _c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.blockInfo.is_mandatory),
      expression: "blockInfo.is_mandatory"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "mandatoryRadio"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.blockInfo.is_mandatory, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.blockInfo, "is_mandatory", 0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("否")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.blockInfo.min_limit),
      expression: "blockInfo.min_limit"
    }],
    ref: "minLimit",
    staticClass: "c-auto form-control",
    staticStyle: {
      "width": "calc(50% - 10px)"
    },
    attrs: {
      "placeholder": "0為無上限",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.blockInfo.min_limit)
    },
    on: {
      "keyup": _vm.verityMinLimit,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.blockInfo, "min_limit", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "line-height": "38px",
      "width": "20px"
    }
  }, [_vm._v("~")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.blockInfo.max_limit),
      expression: "blockInfo.max_limit"
    }],
    ref: "maxLimit",
    staticClass: "c-auto form-control",
    staticStyle: {
      "width": "calc(50% - 10px)"
    },
    attrs: {
      "placeholder": "0為無上限",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.blockInfo.max_limit)
    },
    on: {
      "keyup": _vm.verityMaxLimit,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.blockInfo, "max_limit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("備註")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.blockInfo.remark),
      expression: "blockInfo.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.blockInfo.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.blockInfo, "remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show.easy),
      expression: "!show.easy"
    }],
    staticClass: "col-md-6 col-xs-12 p-l-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("描述")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.blockInfo.description),
      expression: "blockInfo.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.blockInfo.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.blockInfo, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品料號")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.blockInfo.vendor_custom_id),
      expression: "blockInfo.vendor_custom_id"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.blockInfo.vendor_custom_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.blockInfo, "vendor_custom_id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品")]), _vm._v(" "), _c('div', {
    staticClass: "form-control text-left",
    staticStyle: {
      "min-height": "60px"
    }
  }, [_c('button', {
    staticClass: "btn btn-black btn-default inline-block m-y-10",
    staticStyle: {
      "position": "absolute",
      "right": "10px",
      "top": "0px",
      "z-index": "3"
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#choseProdModal"
    }
  }, [_vm._v("\n                  選擇商品\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "option-left-block"
  }, _vm._l((_vm.productList), function(prod) {
    return (prod.active) ? _c('div', {
      key: prod.item_id,
      staticClass: "inline-block m-r-10 option-chose",
      staticStyle: {
        "margin": "5px"
      }
    }, [_vm._v("\n                    " + _vm._s(prod.name) + "\n                  ")]) : _vm._e()
  }), 0)])]), _vm._v(" "), _c('br')])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.gotoOut
    }
  }, [_vm._v("\n      返回\n    ")]), _vm._v(" "), (!_vm.blockList.length) ? _c('button', {
    staticClass: "btn btn-black btn-default",
    on: {
      "click": _vm.gotoCrBlocks
    }
  }, [_vm._v("\n      新增\n    ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.checkInputEmpty
    }
  }, [_vm._v("\n      儲存\n    ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('CModal', {
    attrs: {
      "element-list": _vm.productList,
      "option": _vm.choseProduct,
      "show-money": true
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('CModal', {
    attrs: {
      "element-list": _vm.blockChoseListWithoutCurrent,
      "option": _vm.choseOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('MModal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('PIModal', {
    attrs: {
      "hide-cancel": true,
      "product-list": _vm.productList,
      "option": _vm.moneyOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline-block pull-left"
  }, [_c('h4', {
    staticClass: "pull-left"
  }, [_vm._v("\n          品項選擇區\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("品項選擇區名稱")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("排序")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("必選項目")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("\n\n                選購數量"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("套餐內的商品")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default form-control",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#choseMoneyModal"
    }
  }, [_vm._v("\n                變更套餐內商品資訊\n              ")])])
}]}

/***/ }),
/* 2411 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mb-3"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brands,
      "searchable": true,
      "allow-empty": true,
      "close-on-select": true,
      "placeholder": '== 品牌 ==',
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.brand),
      callback: function($$v) {
        _vm.brand = $$v
      },
      expression: "brand"
    }
  })], 1), _vm._v(" "), _c('nd-trade-apply-store-multi-select-listbox', {
    attrs: {
      "brandId": _vm.brandId,
      "getDataH": _vm.getDataH,
      "status": _vm.status,
      "storeId": _vm.storeId,
      "tradeType": _vm.tradeType
    },
    on: {
      "update:choose": _vm.updateChoose
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-1 font-size-subtitle-2 text-right",
    domProps: {
      "textContent": _vm._s(("已選 " + (_vm.chose.length) + " 擇"))
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-3 font-size-subtitle-1"
  }, [_c('span', [_vm._v("請選取欲申請的品牌（僅會顯示尚未產出網址的門市）。")])])
}]}

/***/ }),
/* 2412 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.storeInfo.brand_name || _vm.brandInfo.name) ? _c('h1', {
    staticStyle: {
      "position": "absolute",
      "top": "-71px",
      "left": "75px",
      "font-size": "18px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.storeInfo.brand_name ? _vm.storeInfo.brand_name + ' - ' + _vm.storeInfo.name_short : _vm.brandInfo.name ? _vm.brandInfo.name : '') + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "flex col-sm-12 mb-3"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v(" 選擇【停賣內容(名稱)】搜尋時，結果僅顯示操作停賣當下的名稱資料，若曾變更過商品、配料名稱，建議使用【停賣內容(料號)】搜尋。")]), _vm._v(" "), (this.$route.params.store_id &&
    this.$route.params.store_id !== 999999) ? _c('span', {
    staticClass: "m-l-auto"
  }, [(_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('button', {
    staticClass: "btn btn-default btn-table-title",
    on: {
      "click": _vm.goPage
    }
  }, [_vm._v("\n                  查看批次紀錄\n                ")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "dt-bootstrap"
  }, [_c('div', {
    staticClass: " row"
  }, [_c('div', {
    staticClass: "flex col-sm-6 text-light"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-group flex row h-38"
  }, [(!_vm.isLoading) ? _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "enabled": _vm.isLoading,
      "limit": _vm.startLimit,
      "option": _vm.dateoption
    },
    on: {
      "change": function($event) {
        return _vm.queryChange($event, 'start_time')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "flex align-center p-x-5"
  }, [_vm._v("  ~  ")]), _vm._v(" "), (!_vm.isLoading) ? _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "limit": _vm.endLimit,
      "option": _vm.dateoption
    },
    on: {
      "change": function($event) {
        return _vm.queryChange($event, 'end_time')
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 m-l-5"
  }, [(_vm.storeHistory) ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.action_type),
      expression: "action_type"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.action_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.queryChange($event, 'action_type')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("== 操作功能 ==")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("永久停賣")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("當日停賣")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("多店停賣")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("多店解除停賣")])])]) : _vm._e(), _vm._v(" "), (_vm.brandHistory) ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.queryChange($event, 'status')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("== 操作功能 ==")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("多店解除停賣")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("多店停賣")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "flex col-sm-6"
  }, [_c('div', {
    staticClass: "col-sm-10 flex row justify-content-end w-100"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchSelect),
      expression: "searchSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.queryChange($event, 'search_select')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("停賣內容(名稱)")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("停賣內容(料號)")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("操作帳號")]), _vm._v(" "), (!this.$route.params.store_id || this.$route.params.store_id === 99999) ? _c('option', {
    domProps: {
      "value": 4
    }
  }, [_vm._v("停賣指定門市")]) : _vm._e()])]), _vm._v(" "), (_vm.searchSelect === 1) ? _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_name),
      expression: "product_name"
    }],
    staticClass: "form-control h-38",
    attrs: {
      "disabled": _vm.isLoading,
      "type": "text"
    },
    domProps: {
      "value": (_vm.product_name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.product_name = $event.target.value
      }, function($event) {
        return _vm.queryChange($event, 'order_sn')
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.search(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.searchSelect === 2) ? _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vendor_custom_id),
      expression: "vendor_custom_id"
    }],
    staticClass: "form-control h-38",
    attrs: {
      "disabled": _vm.isLoading,
      "type": "text"
    },
    domProps: {
      "value": (_vm.vendor_custom_id)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vendor_custom_id = $event.target.value
      }, function($event) {
        return _vm.queryChange($event, 'vendor_custom_id')
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.search(2)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.searchSelect === 3) ? _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account),
      expression: "account"
    }],
    staticClass: "form-control h-38",
    attrs: {
      "disabled": _vm.isLoading,
      "type": "text"
    },
    domProps: {
      "value": (_vm.account)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.account = $event.target.value
      }, function($event) {
        return _vm.queryChange($event, 'account')
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.search(3)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.searchSelect === 4) ? _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.store_name),
      expression: "store_name"
    }],
    staticClass: "form-control h-38",
    attrs: {
      "disabled": _vm.isLoading,
      "type": "text"
    },
    domProps: {
      "value": (_vm.store_name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.store_name = $event.target.value
      }, function($event) {
        return _vm.queryChange($event, 'store_name')
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.search(4)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "text-center m-a-100 text-light-gray"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0 p-b-20"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("操作來源")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("操作歸屬")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("操作帳號")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("操作功能")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("停賣內容")]), _vm._v(" "), (_vm.brandHistory) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("停賣指定門市")]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("操作時間")])])]), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(0)]) : (!_vm.isLoading && _vm.orderList.length > 0) ? _c('tbody', _vm._l((_vm.orderList), function(order, index) {
    return _c('tr', {
      staticClass: "even",
      class: {
        'bg-pre-order': order.order_method === 2
      },
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm._f("disItemSrcType")(order.src_type)) + "\n                    ")]), _vm._v(" "), (_vm.brandHistory) ? _c('td', [_vm._v("\n                      " + _vm._s(order.brand_name ? order.brand_name : '你訂') + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.storeHistory) ? _c('td', [_vm._v("\n                      " + _vm._s(order.brand_name ? order.brand_name : '你訂') + _vm._s(order.store_name ? order.store_name : '') + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(order.account) + "\n                    ")]), _vm._v(" "), (_vm.brandHistory && order.status !== undefined) ? _c('td', [_vm._v("\n                      " + _vm._s(_vm._f("disItemStatus")(order.status)) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.storeHistory && order.is_batch !== undefined) ? _c('td', [(order.is_batch === 1) ? _c('span', [_vm._v("\n                        " + _vm._s(_vm._f("disItemStatus")(order.status)) + "\n                      ")]) : _c('span', [_vm._v("\n                        " + _vm._s(_vm._f("disItemActionType")(order.action_type)) + "\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.brandHistory && order.item_list) ? _c('td', [(order.item_list.package) ? _c('ul', {
      staticClass: "list-style-none p-0"
    }, [_c('li', {
      staticClass: "text-color-blue"
    }, [_vm._v("套餐")]), _vm._v(" "), _vm._l((order.item_list.package), function(value, key) {
      return _c('li', {
        key: key
      }, [_vm._v("\n                          " + _vm._s(key) + " - " + _vm._s(value) + "\n                        ")])
    })], 2) : _vm._e(), _vm._v(" "), (order.item_list.product) ? _c('ul', {
      staticClass: "list-style-none p-0"
    }, [_c('li', {
      staticClass: "text-color-blue"
    }, [_vm._v("商品")]), _vm._v(" "), _vm._l((order.item_list.product), function(value, key) {
      return _c('li', {
        key: key
      }, [_vm._v("\n                          " + _vm._s(key) + " - " + _vm._s(value) + "\n                        ")])
    })], 2) : _vm._e(), _vm._v(" "), (order.item_list.option) ? _c('ul', {
      staticClass: "list-style-none p-0"
    }, [_c('li', {
      staticClass: "text-color-blue"
    }, [_vm._v("配料")]), _vm._v(" "), _vm._l((order.item_list.option), function(value, key) {
      return _c('li', {
        key: key
      }, [_vm._v("\n                          " + _vm._s(key) + " - " + _vm._s(value) + "\n                        ")])
    })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.storeHistory && order.item_list) ? _c('td', [(
      order.item_list.disable &&
      order.item_list.disable.product &&
      Object.keys(order.item_list.disable.product).length ||
      order.item_list.disable &&
      order.item_list.disable.package &&
      Object.keys(order.item_list.disable.package).length ||
      order.item_list.disable &&
      order.item_list.disable.option &&
      Object.keys(order.item_list.disable.option).length ||
      order.item_list.disable &&
      order.item_list.disable.category &&
      Object.keys(order.item_list.disable.category).length ||
      order.item_list.disable &&
      order.item_list.disable.adjust &&
      Object.keys(order.item_list.disable.adjust).length
    ) ? _c('span', {
      staticClass: "spanst-style-none text-color-blue"
    }, [_vm._v("\n                        新增\n                      ")]) : _vm._e(), _vm._v(" "), (
      order.item_list.disable &&
      order.item_list.disable.package &&
      Object.keys(order.item_list.disable.package).length
    ) ? _c('ul', [_c('li', [_vm._v("套餐")]), _vm._v(" "), _vm._l((order.item_list.disable.package), function(value, key) {
      return _c('li', {
        key: key,
        staticClass: "list-style-none"
      }, [_vm._v("\n                          " + _vm._s(key) + " - " + _vm._s(value) + "\n                        ")])
    })], 2) : _vm._e(), _vm._v(" "), (
      order.item_list.disable &&
      order.item_list.disable.product &&
      Object.keys(order.item_list.disable.product).length
    ) ? _c('ul', [_c('li', [_vm._v("商品")]), _vm._v(" "), _vm._l((order.item_list.disable.product), function(value, key) {
      return _c('li', {
        key: key,
        staticClass: "list-style-none"
      }, [_vm._v("\n                          " + _vm._s(key) + " - " + _vm._s(value) + "\n                        ")])
    })], 2) : _vm._e(), _vm._v(" "), (
      order.item_list.disable &&
      order.item_list.disable.option &&
      Object.keys(order.item_list.disable.option).length
    ) ? _c('ul', [_c('li', [_vm._v("配料")]), _vm._v(" "), _vm._l((order.item_list.disable.option), function(value, key) {
      return _c('li', {
        key: key,
        staticClass: "list-style-none"
      }, [_vm._v("\n                          " + _vm._s(key) + " - " + _vm._s(value) + "\n                        ")])
    })], 2) : _vm._e(), _vm._v(" "), (
      order.item_list.disable &&
      order.item_list.disable.category &&
      Object.keys(order.item_list.disable.category).length
    ) ? _c('ul', [_c('li', [_vm._v("商品分類")]), _vm._v(" "), _vm._l((order.item_list.disable.category), function(value, key) {
      return _c('li', {
        key: key,
        staticClass: "list-style-none"
      }, [_vm._v("\n                          " + _vm._s(key) + " - " + _vm._s(value) + "\n                        ")])
    })], 2) : _vm._e(), _vm._v(" "), (
      order.item_list.disable &&
      order.item_list.disable.adjust &&
      Object.keys(order.item_list.disable.adjust).length
    ) ? _c('ul', [_c('li', [_vm._v("配料群組")]), _vm._v(" "), _vm._l((order.item_list.disable.adjust), function(value, key) {
      return _c('li', {
        key: key,
        staticClass: "list-style-none"
      }, [_vm._v("\n                          " + _vm._s(key) + " - " + _vm._s(value) + "\n                        ")])
    })], 2) : _vm._e(), _vm._v(" "), (
      order.item_list.enable &&
      order.item_list.enable.product &&
      Object.keys(order.item_list.enable.product).length ||
      order.item_list.enable &&
      order.item_list.enable.package &&
      Object.keys(order.item_list.enable.package).length ||
      order.item_list.enable &&
      order.item_list.enable.option &&
      Object.keys(order.item_list.enable.option).length ||
      order.item_list.enable &&
      order.item_list.enable.category &&
      Object.keys(order.item_list.enable.category).length ||
      order.item_list.enable &&
      order.item_list.enable.adjust &&
      Object.keys(order.item_list.enable.adjust).length
    ) ? _c('span', {
      staticClass: "spanst-style-none text-color-blue"
    }, [_vm._v("\n                        解除\n                      ")]) : _vm._e(), _vm._v(" "), (
      order.item_list.enable &&
      order.item_list.enable.package &&
      Object.keys(order.item_list.enable.package).length
    ) ? _c('ul', [_c('li', [_vm._v("套餐")]), _vm._v(" "), _vm._l((order.item_list.enable.package), function(value, key) {
      return _c('li', {
        key: key,
        staticClass: "list-style-none"
      }, [_vm._v("\n                          " + _vm._s(key) + " - " + _vm._s(value) + "\n                        ")])
    })], 2) : _vm._e(), _vm._v(" "), (
      order.item_list.enable &&
      order.item_list.enable.product &&
      Object.keys(order.item_list.enable.product).length
    ) ? _c('ul', [_c('li', [_vm._v("商品")]), _vm._v(" "), _vm._l((order.item_list.enable.product), function(value, key) {
      return _c('li', {
        key: key,
        staticClass: "list-style-none"
      }, [_vm._v("\n                          " + _vm._s(key) + " - " + _vm._s(value) + "\n                        ")])
    })], 2) : _vm._e(), _vm._v(" "), (
      order.item_list.enable &&
      order.item_list.enable.option &&
      Object.keys(order.item_list.enable.option).length
    ) ? _c('ul', [_c('li', [_vm._v("配料")]), _vm._v(" "), _vm._l((order.item_list.enable.option), function(value, key) {
      return _c('li', {
        key: key,
        staticClass: "list-style-none"
      }, [_vm._v("\n                          " + _vm._s(key) + " - " + _vm._s(value) + "\n                        ")])
    })], 2) : _vm._e(), _vm._v(" "), (
      order.item_list.enable &&
      order.item_list.enable.category &&
      Object.keys(order.item_list.enable.category).length
    ) ? _c('ul', [_c('li', [_vm._v("商品分類")]), _vm._v(" "), _vm._l((order.item_list.enable.category), function(value, key) {
      return _c('li', {
        key: key,
        staticClass: "list-style-none"
      }, [_vm._v("\n                          " + _vm._s(key) + " - " + _vm._s(value) + "\n                        ")])
    })], 2) : _vm._e(), _vm._v(" "), (
      order.item_list.enable &&
      order.item_list.enable.adjust &&
      Object.keys(order.item_list.enable.adjust).length
    ) ? _c('ul', [_c('li', [_vm._v("配料群組")]), _vm._v(" "), _vm._l((order.item_list.enable.adjust), function(value, key) {
      return _c('li', {
        key: key,
        staticClass: "list-style-none"
      }, [_vm._v("\n                          " + _vm._s(key) + " - " + _vm._s(value) + "\n                        ")])
    })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.brandHistory && order.store_list) ? _c('td', _vm._l((order.store_list), function(value, key, index) {
      return _c('span', {
        key: key
      }, [_vm._v("\n                          " + _vm._s(value) + "\n                          "), (index < Object.keys(order.store_list).length - 1) ? _c('span', [_vm._v("、")]) : _vm._e()])
    }), 0) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getTime(order.created_time) || _vm.getTime(order.create_time)))])])
  }), 0) : (!_vm.isLoading && _vm.orderList.length === 0) ? _c('tbody', [_vm._m(1)]) : _vm._e()])]), _vm._v(" "), (!_vm.orderList.length && _vm.$route.name === 'onSiteOrderTableInfo') ? _c('div', {
    staticClass: "text-center m-a-100 text-light-gray"
  }, [_vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "m-t-5"
  }, [_vm._v("沒有符合的資料")])]) : _vm._e()]), _vm._v(" "), _c('paginate', {
    attrs: {
      "clickPage": _vm.paginateClickPage,
      "groupAmount": _vm.paginate.groupAmount,
      "isActive": _vm.paginateIsActive,
      "pageAmount": _vm.paginateAmount,
      "total": _vm.paginate.total
    }
  })], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "font-size-80"
  }, [_c('i', {
    staticClass: "ion ion-clipboard"
  })])
}]}

/***/ }),
/* 2413 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [(_vm.getRoleType === 99) ? _c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-10 flex align-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.goBackInfo.name,
        params: _vm.goBackInfo.params,
        query: _vm.goBackInfo.query
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default m-r-5 flex"
  }, [_c('span', [_vm._v("返回")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.title)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.subtitle)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex grey darken-1"
  }, [(_vm.brand.name || _vm.store.brand_name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s(_vm.brand.name ? _vm.brand.name : _vm.store.brand_name ? _vm.store.brand_name : '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s('/')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.store.name)
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            如需新增、修改菜單內容，請至\n            "), _c('router-link', {
    attrs: {
      "to": {
        name: _vm.goStepViewInfo.name,
        params: _vm.goStepViewInfo.params
      }
    },
    domProps: {
      "textContent": _vm._s(_vm.goStepViewInfo.title)
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 text-left"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title",
    on: {
      "click": _vm.goToCrMenu
    }
  }, [_vm._v("\n                    新增菜單\n                  ")])]), _vm._v(" "), (!_vm.isStore) ? _c('div', {
    staticClass: "form-group text-left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'crStoreClass',
        params: {
          brand_id: _vm.$route.params.brand_id
        }
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("\n                      門市群組\n                    ")])])], 1) : _vm._e(), _vm._v(" "), (!_vm.isStore) ? _c('div', {
    staticClass: "form-group text-left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'MenuSettingRuleStoreCopyView',
        params: {
          brand_id: _vm.$route.params.brand_id
        }
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("菜單同步權限設定")])])], 1) : _vm._e(), _vm._v(" "), (!_vm.isStore) ? _c('div', {
    staticClass: "form-group text-left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'MenuSettingRuleStoreUpdateView',
        params: {
          brand_id: _vm.$route.params.brand_id
        }
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("菜單編輯權限設定")])])], 1) : _vm._e()]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [(_vm.menuList.length) ? _c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.menuList), function(menu, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.goToMenuInfo(menu.menu_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-bars",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(index + 1)
      }
    })])]), _vm._v(" "), _c('td', {
      domProps: {
        "textContent": _vm._s(menu.menu_id)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "textContent": _vm._s(menu.name)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "textContent": _vm._s(menu.ver_stamp)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "textContent": _vm._s(menu.description)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "textContent": _vm._s(menu.remark)
      }
    }), _vm._v(" "), _c('td', [(!menu.is_locked) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("開啟")]) : _vm._e(), _vm._v(" "), (menu.is_locked) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("鎖定")]) : _vm._e()]), _vm._v(" "), _c('td', [(menu.status == 1) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("編輯中")]) : _vm._e(), _vm._v(" "), (menu.status == 2) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("編輯完畢")]) : _vm._e()]), _vm._v(" "), _c('td', {
      domProps: {
        "textContent": _vm._s(menu.ver_time)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "textContent": _vm._s(menu.update_time)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "textContent": _vm._s(menu.create_time)
      }
    }), _vm._v(" "), _c('td', [(menu.is_locked) ? _c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          return _vm.menuUnlock(menu.menu_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lock",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e(), _vm._v(" "), (!menu.is_locked && menu.status === 2) ? _c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          return _vm.menuLock(menu.menu_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-unlock-alt",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', [(!menu.is_locked) ? _c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          return _vm.goToUpMenu(menu.menu_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', [(menu.status == 2) ? _c('button', {
      staticClass: "btn btn-primary",
      domProps: {
        "textContent": _vm._s('複本')
      },
      on: {
        "click": function($event) {
          return _vm.goToCrMenu({
            menu: menu,
            type: 1
          }, 1111)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [(menu.is_locked) ? _c('button', {
      staticClass: "btn bg-black",
      domProps: {
        "textContent": _vm._s('上架')
      },
      on: {
        "click": function($event) {
          return _vm.goToCrSchedule(menu)
        }
      }
    }) : _vm._e()])])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [(_vm.pageAmount > 1 && _vm.pageGroup !== 1) ? _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        _vm.pageGroup = _vm.pageGroup - 1
      }
    }
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pageAmount), function(index) {
    return (_vm.pageShow(index)) ? _c('li', {
      staticClass: "paginate_button",
      class: {
        active: _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          return _vm.getMenuList(index)
        }
      }
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v(_vm._s(index))])]) : _vm._e()
  }), _vm._v(" "), (_vm.pageAmount > 1 && _vm.pageAmount / _vm.groupAmount > _vm.pageGroup) ? _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        _vm.pageGroup = _vm.pageGroup + 1
      }
    }
  }, [_vm._m(3)]) : _vm._e()], 2)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    staticClass: "form-control h-38"
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("代碼")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("時間")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("菜單ID")]), _vm._v(" "), _c('th', [_vm._v("名稱")]), _vm._v(" "), _c('th', [_vm._v("版本碼")]), _vm._v(" "), _c('th', [_vm._v("描述")]), _vm._v(" "), _c('th', [_vm._v("備註")]), _vm._v(" "), _c('th', [_vm._v("鎖定")]), _vm._v(" "), _c('th', [_vm._v("狀態")]), _vm._v(" "), _c('th', [_vm._v("版本時間")]), _vm._v(" "), _c('th', [_vm._v("修改時間")]), _vm._v(" "), _c('th', [_vm._v("建立時間")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 2414 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', {
    staticClass: "col-xs-12 m-b-10"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'MenuSettingRuleStoreUpdateView',
        params: {
          brand_id: _vm.$route.params.brand_id
        }
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default"
  }, [_vm._v("\n          返回菜單同步權限設定\n        ")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [(_vm.list) ? _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.list), function(item, i) {
    return _c('tr', {
      key: _vm.list.id
    }, [_c('td', {
      staticClass: "w-xs"
    }, [_vm._v(_vm._s(i + 1))]), _vm._v(" "), _c('td', {
      staticClass: "w-sm"
    }, [_vm._v(_vm._s(item.manager_account))]), _vm._v(" "), _c('td', {
      staticClass: "w-md"
    }, [_vm._v(_vm._s(_vm.moment(item.action_time).format('YYYY/MM/DD HH:mm:ss')))]), _vm._v(" "), _c('td', {
      staticClass: "w-auto"
    }, [_c('div', {
      staticClass: "mb-1"
    }, [_vm._v("新增：" + _vm._s(_vm.handleName(item.action.add)))]), _vm._v(" "), _c('div', {
      staticClass: "mb-1"
    }, [_vm._v("移除：" + _vm._s(_vm.handleName(item.action.remove)))]), _vm._v(" "), _c('div', [_vm._v("結果：" + _vm._s(_vm.handleName(item.action.result)))])])])
  }), 0)]) : _vm._e()])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("帳號名稱")]), _vm._v(" "), _c('th', [_vm._v("時間")]), _vm._v(" "), _c('th', [_vm._v("門市（新增、移除、結果）")])])])
}]}

/***/ }),
/* 2415 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [(!_vm.optionList.length) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._v("\n    無配料，請新增\n  ")]) : _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-danger m-y-10 inline-block pull-right",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    },
    on: {
      "click": _vm.delModalOpen
    }
  }, [_vm._v("\n          刪除\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-black m-y-10 inline-block pull-right m-r-10",
    on: {
      "click": _vm.goCrOptions
    }
  }, [_vm._v("\n          新增\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-black m-y-10 inline-block pull-right m-r-10",
    attrs: {
      "data-toggle": "modal"
    },
    on: {
      "click": function($event) {
        _vm.show.easy = !_vm.show.easy
      }
    }
  }, [(!_vm.show.easy) ? _c('span', [_vm._v("簡易")]) : _c('span', [_vm._v("進階")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary m-y-10 pull-right m-r-10 ",
    attrs: {
      "data-toggle": "modal"
    },
    on: {
      "click": _vm.copyOption
    }
  }, [_vm._v("複製配料")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-2 bg-light-gray select-element-block text-left"
  }, _vm._l((_vm.optionList), function(option, index) {
    return _c('div', {
      key: index,
      staticClass: "select-element",
      class: {
        'active': _vm.curId === option.item_id
      },
      attrs: {
        "disabled": _vm.curId === _vm.adjust.item_id
      },
      on: {
        "click": function($event) {
          return _vm.clickOption(option, index)
        }
      }
    }, [_c('span', {
      staticClass: "text-w-600"
    }, [_vm._v("\n            " + _vm._s(option.name) + "\n          ")]), _vm._v(" "), _c('small', {
      staticStyle: {
        "opacity": ".7"
      }
    }, [_vm._v("\n            " + _vm._s(option.remark) + "\n          ")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-10"
  }, [_c('div', {
    staticClass: "box-body form menu-form col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6 p-r-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.sub_type),
      expression: "optionInfo.sub_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.optionInfo, "sub_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.subTypeList), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.label))])
  }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.name),
      expression: "optionInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "32"
    },
    domProps: {
      "value": (_vm.optionInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.sort),
      expression: "optionInfo.sort"
    }],
    ref: "sort",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.optionInfo.sort)
    },
    on: {
      "keyup": function($event) {
        return _vm.veritySort()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "sort", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.min_limit),
      expression: "optionInfo.min_limit"
    }],
    ref: "minLimit",
    staticClass: "c-auto form-control",
    staticStyle: {
      "width": "calc(50% - 10px)"
    },
    attrs: {
      "placeholder": "請輸入數量",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.optionInfo.min_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityMinLimit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "min_limit", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "line-height": "38px",
      "width": "20px"
    }
  }, [_vm._v("~")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.max_limit),
      expression: "optionInfo.max_limit"
    }],
    ref: "maxLimit",
    staticClass: "c-auto form-control",
    staticStyle: {
      "width": "calc(50% - 10px)"
    },
    attrs: {
      "placeholder": "請輸入數量",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.optionInfo.max_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityMaxLimit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "max_limit", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.price),
      expression: "optionInfo.price"
    }],
    ref: "price",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.optionInfo.price)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityPrice()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "price", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "radio text-left h-38",
    staticStyle: {
      "border-left": "1px solid #d2d6de"
    }
  }, [_c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.is_mandatory),
      expression: "optionInfo.is_mandatory"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "mandatoryRadio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.optionInfo.is_mandatory, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.optionInfo, "is_mandatory", 1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("是")])]), _vm._v(" "), _c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.is_mandatory),
      expression: "optionInfo.is_mandatory"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "mandatoryRadio"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.optionInfo.is_mandatory, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.optionInfo, "is_mandatory", 0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("否")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("備註")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.remark),
      expression: "optionInfo.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.optionInfo.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show.easy),
      expression: "!show.easy"
    }],
    staticClass: "col-xs-12 col-md-6 p-l-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "radio text-left h-38",
    staticStyle: {
      "border-left": "1px solid #d2d6de"
    }
  }, [_c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.is_common),
      expression: "optionInfo.is_common"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "commonRadio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.optionInfo.is_common, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.optionInfo, "is_common", 1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("是")])]), _vm._v(" "), _c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.is_common),
      expression: "optionInfo.is_common"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "commonRadio"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.optionInfo.is_common, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.optionInfo, "is_common", 0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("否")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.price_type),
      expression: "optionInfo.price_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.optionInfo, "price_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("免稅價格")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("含稅價格")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("熱量")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.calorie),
      expression: "optionInfo.calorie"
    }],
    ref: "calorie",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.optionInfo.calorie)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityCalorie()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "calorie", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("描述")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.description),
      expression: "optionInfo.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.optionInfo.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品料號")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.vendor_custom_id),
      expression: "optionInfo.vendor_custom_id"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.optionInfo.vendor_custom_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "vendor_custom_id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.optionInfo.adjust_id) ? _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("分類")]), _vm._v(" "), _c('button', {
    staticClass: "form-control btn-primary btn",
    staticStyle: {
      "text-align": "left"
    },
    on: {
      "click": _vm.goAdjust
    }
  }, [_vm._v(_vm._s(_vm.optionInfo.adjust_name) + " "), _c('i', {
    staticClass: "fa fa-arrow-circle-right pull-right t-5",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('br')])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.gotoOut
    }
  }, [_vm._v("\n      返回\n    ")]), _vm._v(" "), (!_vm.optionList.length) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.goCrOptions
    }
  }, [_vm._v("\n      新增\n    ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.checkInputEmpty
    }
  }, [_vm._v("\n      儲存\n    ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline-block pull-left"
  }, [_c('h4', {
    staticClass: "pull-left"
  }, [_vm._v("\n        配料\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n                類型\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("配料名稱")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("排序")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("選購數量")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("價格")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("必選項目")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("常見價格")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("價格類型")])
}]}

/***/ }),
/* 2416 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body form-left p-l-10 p-r-10-p"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-control b-0 p-0"
  }, [_vm._v("訂單明細")]), _vm._v(" "), _c('div', {
    staticClass: "order-list-box m-x-0"
  }, _vm._l((_vm.productList), function(p, index) {
    return _c('div', [_c('h4', [_vm._v(_vm._s(index + 1) + ". " + _vm._s(p.product))]), _vm._v(" "), _c('p', [_vm._l((p.option_list), function(option) {
      return _c('span', [_vm._v(_vm._s(option) + " / ")])
    }), _vm._v(" " + _vm._s(p.total_money) + "元 / " + _vm._s(p.amount) + "杯")], 2), _vm._v(" "), (_vm.productList.length !== index + 1) ? _c('hr') : _vm._e()])
  }), 0), _vm._v(" "), _c('br')])])])])])
},staticRenderFns: []}

/***/ }),
/* 2417 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "infoPackageModal",
    staticClass: "modal fade",
    attrs: {
      "id": "infoPackageModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header text-left"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title text-red",
    staticStyle: {
      "font-size": "20px"
    },
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("\n          套餐 - " + _vm._s(_vm.currentProduct[_vm.schema.product.name]) + "\n        ")])]), _vm._v(" "), (_vm.currentProduct) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "col-xs-12 p-x-0"
  }, [_c('ul', {
    staticClass: "col-xs-12 nav"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.packageLayer.show),
      expression: "packageLayer.show"
    }],
    staticClass: "col-xs-12 p-x-0 line-style"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.bActiveList), function(node, nIndex) {
    return (_vm.currentProduct && _vm.checkDisableBlock(node.block.product[_vm.schema.block.product_id], _vm.currentProduct[_vm.schema.product.product_id])) ? _c('div', {
      staticClass: "col-xs-12 p-x-0 order-item adjust"
    }, [_c('h5', [_vm._v(_vm._s(node.block.product[_vm.schema.block.name]) + "\n                    "), (node.block.product[_vm.schema.block.min_limit] !== 1 && node.block.product[_vm.schema.block.min_limit] !== 0 &&
      node.block.product[_vm.schema.block.max_limit] !== 1 && node.block.product[_vm.schema.block.max_limit] !== 0 && node.block.product[_vm.schema.block.min_limit] === node.block.product[_vm.schema.block.max_limit]) ? _c('span', {
      staticClass: "text-13",
      staticStyle: {
        "top": "0px"
      }
    }, [_vm._v("(以下必選" + _vm._s(node.block.product[_vm.schema.block.min_limit]) + "項)")]) : (node.block.product[_vm.schema.block.min_limit] !== 1 && node.block.product[_vm.schema.block.min_limit] !== 0 &&
      node.block.product[_vm.schema.block.max_limit] !== 1 && node.block.product[_vm.schema.block.max_limit] !== 0) ? _c('span', {
      staticClass: "text-13",
      staticStyle: {
        "top": "0px"
      }
    }, [_vm._v("(可選擇" + _vm._s(node.block.product[_vm.schema.block.min_limit]) + " ~ " + _vm._s(node.block.product[_vm.schema.block.max_limit]) + "項)")]) : (node.block.product[_vm.schema.block.min_limit] !== 1 && node.block.product[_vm.schema.block.min_limit] !== 0) ? _c('span', {
      staticClass: "text-13",
      staticStyle: {
        "top": "0px"
      }
    }, [_vm._v("(最少可選擇" + _vm._s(node.block.product[_vm.schema.block.min_limit]) + "項)")]) : (node.block.product[_vm.schema.block.max_limit] !== 1 && node.block.product[_vm.schema.block.max_limit] !== 0) ? _c('span', {
      staticClass: "text-13",
      staticStyle: {
        "top": "0px"
      }
    }, [_vm._v("(最多可選擇" + _vm._s(node.block.product[_vm.schema.block.max_limit]) + ")")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.sortObj(node.prod)), function(node2, n2Index) {
      return _c('div', {
        staticClass: "inline-block choose-block c-pointer",
        attrs: {
          "prodActive": node2.active && _vm.checkDisableItem(node2.product[_vm.schema.product.product_id], node.block.product[_vm.schema.block.product_id]),
          "disabled": !_vm.checkDisableItem(node2.product[_vm.schema.product.product_id], node.block.product[_vm.schema.block.product_id])
        },
        on: {
          "click": function($event) {
            _vm.clickBlock(parseInt(node2.product[_vm.schema.product.product_id], 10), node)
          }
        }
      }, [(node2.product[_vm.schema.product.is_mandatory]) ? _c('span', {
        staticClass: "text-red text-14"
      }, [_vm._v("* ")]) : _vm._e(), _vm._v("\n                    " + _vm._s(node2.product[_vm.schema.product.name]) + "\n                    "), (_vm.optionNumList[0][node2.product[_vm.schema.product.product_id]] && _vm.optionNumList[0][node2.product[_vm.schema.product.product_id]] !== 1) ? _c('div', {
        staticClass: "label option-number"
      }, [_vm._v("\n                      " + _vm._s(_vm.optionNumList[0][node2.product[_vm.schema.product.product_id]]) + "\n                    ")]) : (_vm.optionNumList[0][node2.product[_vm.schema.product.product_id]] && _vm.optionNumList[0][node2.product[_vm.schema.product.product_id]] === 1 && node2.product[_vm.schema.product.max_limit] !== 1) ? _c('div', {
        staticClass: "label option-number"
      }, [_vm._v("\n                      " + _vm._s(_vm.optionNumList[0][node2.product[_vm.schema.product.product_id]]) + "\n                    ")]) : _vm._e()])
    }), _vm._v(" "), (nIndex < _vm.bActiveList.length - 1 || _vm.otherActiveList.length) ? _c('hr', {
      staticClass: "m-y-0",
      staticStyle: {
        "top": "5px"
      }
    }) : _vm._e()], 2) : _vm._e()
  }), _vm._v(" "), (_vm.currentProduct && _vm.otherActiveList.length) ? _c('div', {
    staticClass: "col-xs-12 p-x-0 order-item adjust"
  }, [_c('h6', {}, [_vm._v("副餐")]), _vm._v(" "), _vm._l((_vm.otherActiveList), function(p, pIndex) {
    return _c('div', {
      staticClass: "inline-block choose-block c-pointer",
      attrs: {
        "prodActive": p.active
      },
      on: {
        "click": function($event) {
          _vm.clickOtherP(parseInt(p.id, 10), p)
        }
      }
    }, [(_vm.getProduct(p.id)[_vm.schema.product.is_mandatory]) ? _c('span', {
      staticClass: "text-pin text-14"
    }, [_vm._v("* ")]) : _vm._e(), _vm._v("\n                    " + _vm._s(_vm.getProduct(p.id)[_vm.schema.product.name]) + "\n                    ")])
  })], 2) : _vm._e()], 2)]), _vm._v(" "), _c('ul', {
    staticClass: "col-xs-12 nav",
    staticStyle: {
      "padding-top": "6px"
    }
  }, [_c('li', {
    staticClass: "col-xs-12 p-x-0"
  }, [_c('div', {
    staticClass: "col-xs-12 p-x-0 order-item adjust"
  }, [_c('div', {
    staticClass: "col-xs-12 p-x-0 form-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n                    已選取商品\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-10",
    staticStyle: {
      "background": "#f4f4f4",
      "border": "3px dashed #eee",
      "border-top": "0px",
      "border-radius": "0px 0px 6px 6px"
    }
  }, [_vm._l((_vm.getProductContainer), function(pc, pcIndex) {
    return (_vm.pShow(pc)) ? _c('div', {
      staticClass: "inline-block choose-block c-pointer",
      staticStyle: {
        "border-radius": "20px"
      },
      attrs: {
        "prodActive": _vm.curProduct(pc)
      },
      on: {
        "click": function($event) {
          return _vm.clickProduct(pc)
        }
      }
    }, [(pc[_vm.schema.product.is_mandatory]) ? _c('span', {
      staticClass: "text-red text-14"
    }, [_vm._v("* ")]) : _vm._e(), _vm._v("\n                      " + _vm._s(pc[_vm.schema.product.name]) + "\n                      "), (_vm.optionNumList[0][pc[_vm.schema.product.product_id]] && _vm.optionNumList[0][pc[_vm.schema.product.product_id]] !== 1) ? _c('div', {
      staticClass: "label option-number"
    }, [_vm._v("\n                        " + _vm._s(_vm.optionNumList[0][pc[_vm.schema.product.product_id]]) + "\n                      ")]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.packageLayer.show) ? _c('div', {
    staticClass: "pull-right inline-block choose-block c-pointer bg-pink text-white m-t-20 text-w-600",
    staticStyle: {
      "margin-right": "0px"
    },
    on: {
      "click": _vm.clickChoseP
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 步驟一 - 變更套餐內容\n                    ")]) : _c('div', {
    staticClass: "pull-right inline-block choose-block c-pointer bg-pink text-white m-t-20 text-w-600",
    staticStyle: {
      "margin-right": "0px"
    },
    on: {
      "click": _vm.clickChangeOption
    }
  }, [_vm._v("\n                      步驟二 - 調整商品細節 "), _c('i', {
    staticClass: "fa fa-caret-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2)])]), _vm._v(" "), _vm._l((_vm.getProductContainer), function(pcDetail, pIndex) {
    return (_vm.allProduct[pcDetail[_vm.schema.product.product_id]]) ? _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.packageLayer.show && _vm.pShow(pcDetail) && _vm.curProduct(pcDetail)),
        expression: "!packageLayer.show && pShow(pcDetail) && curProduct(pcDetail)"
      }],
      staticClass: "col-xs-12 p-x-0 line-style"
    }, [_c('muti-prod', {
      ref: 'menu-options-' + pcDetail[_vm.schema.product.product_id],
      refInFor: true,
      attrs: {
        "storeState": 2,
        "modalView": _vm.modalView,
        "currentProduct": pcDetail,
        "brandId": _vm.brandId,
        "prodType": "package",
        "checkPrice": _vm.checkPrice,
        "checkAddProduct": _vm.checkAddProduct,
        "checkAddDifProduct": _vm.checkAddDifProduct,
        "productAmount": _vm.getPAmount(pcDetail),
        "optionCheck": _vm.optionCheck,
        "show": _vm.show,
        "productShow": _vm.pShow(pcDetail),
        "adjustSame": _vm.adjustSame,
        "menuJson": _vm.menuJson,
        "clickProduct": _vm.clickProduct
      }
    }), _vm._v(" "), (_vm.cheeseWording(pcDetail[_vm.schema.product.name])) ? _c('p', {
      staticClass: "text-red text-14"
    }, [_c('br'), _vm._v("★ 此產品已含起司，請斟酌加購起司")]) : _vm._e()], 1) : _vm._e()
  })], 2)]), _vm._v(" "), (_vm.adjusts.length) ? _c('li', {
    staticClass: "col-xs-12 p-x-0"
  }, [_c('hr', {
    staticStyle: {
      "margin": "15px 0px 0px 0px"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "col-xs-12 p-x-0 order-item m-t-15 p-5"
  }, [_c('p', [_vm._v("總金額：" + _vm._s(_vm.totalPrice()) + " 元")]), _vm._v(" "), _c('div', {
    staticClass: "q-numeric textfield row inline items-center input-number m-x-0 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon numeric-left c-pointer bg-pink",
    on: {
      "click": function($event) {
        _vm.number--
      }
    }
  }, [_vm._v("\n                    -\n                  ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.number),
      expression: "number"
    }],
    staticClass: "no-style auto q-input-field inline-block text-center",
    attrs: {
      "type": "tel",
      "pattern": "[0-9]*",
      "tabindex": "0",
      "step": "1",
      "min": "1",
      "max": "99",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.number = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon numeric-right  c-pointer bg-pink",
    on: {
      "click": function($event) {
        _vm.number++
      }
    }
  }, [_vm._v("\n                    +\n                  ")])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("關閉")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clickAdd
    }
  }, [_vm._v("測試")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 p-x-0"
  }, [_c('p', {
    staticClass: "text-13 text-red"
  }, [_c('i', {
    staticClass: "fa fa-star",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 如更動套餐品項，需重新調整項目")])])
}]}

/***/ }),
/* 2418 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('meal-tag-table')], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 2419 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('nd-multi-select-listbox', {
    attrs: {
      "brandId": _vm.brandId,
      "getDataH": _vm.getDataH,
      "storeId": _vm.storeId,
      "type": 1
    },
    on: {
      "update:choose": _vm.updateChoose
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clear-both"
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-1 font-size-subtitle-2 text-right"
  }, [_vm._v("已選" + _vm._s(_vm.chose.length) + "擇")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-3 font-size-subtitle-2 font-weight-regular"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("已選取全部配料庫，請選擇要套用至哪些門市，按下確認後即複製")])])
}]}

/***/ }),
/* 2420 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box text-center"
  }, [(_vm.up) ? _c('div', {
    staticClass: "del-block m-t-5"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body form",
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "align-items": "center"
    }
  }, [_c('br'), _vm._v(" "), _c('div', [_c('div', [(_vm.brandBrief.length > 1 && !_vm.up) ? _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "max-width": "400px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "==品牌==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group",
    staticStyle: {
      "max-width": "400px"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "width": "120px",
      "text-align": "left"
    }
  }, [_vm._v("\n                  設定名稱\n                ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "placeholder": "備註用，不會顯示在菜單",
      "type": "text",
      "maxlength": "32"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group",
    staticStyle: {
      "max-width": "400px"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "width": "120px",
      "text-align": "left"
    }
  }, [_vm._v("\n                  設定描述\n                ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "placeholder": "備註用，不會顯示在菜單",
      "type": "text",
      "maxlength": "32"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group cr-schedule cr-ad",
    staticStyle: {
      "max-width": "calc(30vw - 190px)"
    }
  }, [_vm._m(2), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.dateoption,
      "limit": _vm.startLimit
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group cr-schedule cr-ad",
    staticStyle: {
      "max-width": "calc(30vw - 190px)"
    }
  }, [_vm._m(3), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.dateoption,
      "limit": _vm.endLimit
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addRule
    }
  }, [_vm._v("新增規則")])]), _vm._v(" "), _vm._l((_vm.rule_list), function(rule, rIndex) {
    return _c('div', {
      staticClass: "process-time-block",
      staticStyle: {
        "max-width": "400px"
      }
    }, [_c('div', {
      staticClass: "text-right m-b-10"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.rule_list, rIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(4, true), _vm._v(" "), _c('div', [_c('multiselect', {
      attrs: {
        "placeholder": "規則類型",
        "label": "label",
        "track-by": "value",
        "options": _vm.ruleTypeOptions,
        "multiple": false,
        "allow-empty": true
      },
      model: {
        value: (rule.rule_type),
        callback: function($$v) {
          _vm.$set(rule, "rule_type", $$v)
        },
        expression: "rule.rule_type"
      }
    })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), (rule.rule_type.value === 1) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(5, true), _vm._v(" "), _c('div', [_c('date-time-picker', {
      attrs: {
        "date": rule.rule_date,
        "option": _vm.dateoption_rule,
        "limit": _vm.limit_rule
      }
    })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (rule.rule_type.value === 2 || rule.rule_type.value === 3) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon",
      staticStyle: {
        "width": "120px",
        "text-align": "left"
      }
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v(_vm._s(rule.rule_type.value === 2 ? '星期' : '日期') + "\n                  ")]), _vm._v(" "), _c('div', [(rule.rule_type.value === 2) ? _c('multiselect', {
      staticStyle: {
        "width": "248px"
      },
      attrs: {
        "placeholder": "星期",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdaySetting.options.weekDay,
        "multiple": false,
        "allow-empty": true
      },
      model: {
        value: (rule.rule_day),
        callback: function($$v) {
          _vm.$set(rule, "rule_day", $$v)
        },
        expression: "rule.rule_day"
      }
    }) : (rule.rule_type.value === 3) ? _c('multiselect', {
      staticStyle: {
        "width": "248px"
      },
      attrs: {
        "placeholder": "幾號",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdateSetting.options.dateDay,
        "multiple": false,
        "allow-empty": true
      },
      model: {
        value: (rule.rule_month_day),
        callback: function($$v) {
          _vm.$set(rule, "rule_month_day", $$v)
        },
        expression: "rule.rule_month_day"
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (rule.rule_month_day),
        expression: "rule.rule_month_day"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "日期",
        "type": "text",
        "maxlength": "1"
      },
      domProps: {
        "value": (rule.rule_month_day)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(rule, "rule_month_day", $event.target.value)
        }
      }
    })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon",
      staticStyle: {
        "width": "120px",
        "text-align": "left"
      }
    }, [_vm._v("\n                    起始時間\n                  ")]), _vm._v(" "), _c('div', [_c('vue-timepicker', {
      attrs: {
        "manual-input": "",
        "placeholder": "hh:mm",
        "input-width": "248px",
        "input-class": "form-control"
      },
      model: {
        value: (rule.rule_start_time),
        callback: function($$v) {
          _vm.$set(rule, "rule_start_time", $$v)
        },
        expression: "rule.rule_start_time"
      }
    })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon",
      staticStyle: {
        "width": "120px",
        "text-align": "left"
      }
    }, [_vm._v("\n                    結束時間\n                  ")]), _vm._v(" "), _c('div', [_c('vue-timepicker', {
      attrs: {
        "manual-input": "",
        "placeholder": "hh:mm",
        "input-width": "248px",
        "input-class": "form-control"
      },
      model: {
        value: (rule.rule_end_time),
        callback: function($$v) {
          _vm.$set(rule, "rule_end_time", $$v)
        },
        expression: "rule.rule_end_time"
      }
    })], 1)]), _vm._v(" "), _c('br')])])
  })], 2)]), _vm._v(" "), (_vm.addStoresSetting.options.length > 0 && (_vm.$route.query.usage_type === '1' && _vm.$route.name === 'upDisableSchedule' || _vm.$route.name === 'crDisableSchedule')) ? _c('div', [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-10"
  }, [_c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_vm._m(7), _vm._v(" "), (_vm.addStoresSetting.options.length > 0) ? _c('v-multiselect-listbox', {
    staticClass: "col-xs-12",
    attrs: {
      "options": _vm.addStoresSetting.options,
      "reduce-display-property": function (option) { return option.label; },
      "reduce-value-property": function (option) { return option.value; },
      "show-select-all-buttons": _vm.checkSelectAll,
      "search-options-placeholder": "搜尋...",
      "selected-options-placeholder": "搜尋..."
    },
    model: {
      value: (_vm.addStoresSetting.choose),
      callback: function($$v) {
        _vm.$set(_vm.addStoresSetting, "choose", $$v)
      },
      expression: "addStoresSetting.choose"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_c('p', {
    staticClass: "text-12"
  }, [_vm._v("已選 " + _vm._s(this.addStoresSetting.choose.length) + " 間")])])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.category.length > 0) ? _c('div', {
    staticClass: "col-xs-12 y-middle"
  }, [_vm._m(8)]) : _vm._e(), _vm._v(" "), (_vm.category.length > 0) ? _c('div', {
    staticClass: "col-xs-12 y-middle"
  }, [_c('div', {
    staticClass: "hr-line"
  }), _c('div', {
    staticClass: "h3-title"
  }, [_vm._v("商品時段停賣設定")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-10"
  }, [_c('div', {
    staticClass: "grid",
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.category), function(c, index) {
    return _c('div', {
      staticClass: "col-xs-12 col-lg-4 grid-item p-5"
    }, [_c('div', {
      staticClass: "col-xs-12 card"
    }, [_vm._m(9, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 card-title text-left p-x-15"
    }, [_c('span', {
      staticClass: "pull-left"
    }, [_vm._v(_vm._s(c.name))]), _vm._v(" "), _c('div', {
      staticClass: "text-right inline-block m-r-15 block-checkbox"
    }, [_c('span', {
      staticClass: "checkbox-addmenu"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (c.is_disabled),
        expression: "c.is_disabled"
      }],
      staticClass: "css-checkbox",
      attrs: {
        "type": "checkbox",
        "id": 'c-' + c.product_id + '-is-add'
      },
      domProps: {
        "checked": Array.isArray(c.is_disabled) ? _vm._i(c.is_disabled, null) > -1 : (c.is_disabled)
      },
      on: {
        "input": function($event) {
          return _vm.changeCategoryAdd(c)
        },
        "change": function($event) {
          var $$a = c.is_disabled,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(c, "is_disabled", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(c, "is_disabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(c, "is_disabled", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "css-label css-label-add",
      attrs: {
        "for": 'c-' + c.product_id + '-is-add'
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 text-left"
    }, [_c('ul', {
      staticClass: "nav p-x-15"
    }, _vm._l((c.child_list), function(p, index) {
      return _c('li', {
        staticClass: "card-product"
      }, [_c('div', {
        class: p.is_disabled ? 'delete-line' : ''
      }, [_vm._v("\n                            " + _vm._s(p.name) + " "), _c('small', [_vm._v(_vm._s(p.remark ? ("(" + (p.remark) + ")") : ''))]), _vm._v(" "), _c('div', {
        staticClass: "text-right inline-block block-checkbox"
      }, [_c('span', {
        staticClass: "checkbox-addmenu"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (p.is_disabled),
          expression: "p.is_disabled"
        }],
        staticClass: "css-checkbox",
        attrs: {
          "type": "checkbox",
          "id": 'p-' + p.product_id + '-is-add'
        },
        domProps: {
          "checked": Array.isArray(p.is_disabled) ? _vm._i(p.is_disabled, null) > -1 : (p.is_disabled)
        },
        on: {
          "input": function($event) {
            return _vm.changeProductAdd(c, p)
          },
          "change": function($event) {
            var $$a = p.is_disabled,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(p, "is_disabled", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(p, "is_disabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(p, "is_disabled", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "css-label css-label-add",
        attrs: {
          "for": 'p-' + p.product_id + '-is-add'
        }
      })])])])])
    }), 0)])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-fail text-black",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n            返回\n          ")]), _vm._v(" "), (!_vm.up) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkSetting()
      }
    }
  }, [_vm._v("\n            新增\n          ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkSetting()
      }
    }
  }, [_vm._v("\n            更新\n          ")])])])])]), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delItemOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "width": "120px",
      "text-align": "left"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("品牌\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("開始時間\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("結束時間\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("規則類型\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "width": "120px",
      "text-align": "left"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("日期\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 m-t-64 y-middle"
  }, [_c('div', {
    staticClass: "inline-block pull-left text-left"
  }, [_c('h5', {
    staticClass: "text-14-4 "
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("多店編輯限同菜單")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 p-x-0"
  }, [_c('div', {
    staticClass: "left_store_sec text-14-4 "
  }, [_vm._v("不參與停賣店家")]), _vm._v(" "), _c('div', {
    staticClass: "middle_store_sec"
  }, [_vm._v("  ")]), _vm._v(" "), _c('div', {
    staticClass: "right_store_sec text-14-4 "
  }, [_vm._v("參與停賣店家")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline-block pull-left text-left"
  }, [_c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 未勾選者，將會取消停賣功能。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 m-b-5 text-left p-x-15"
  }, [_c('div', {
    staticClass: "text-right inline-block block-checkbox text-15",
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('span', {
    staticClass: "text-dark-gray text-13"
  }, [_vm._v("停賣")])])])
}]}

/***/ }),
/* 2421 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('ad-table')], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("廣告列表")])])
}]}

/***/ }),
/* 2422 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('brand-table')], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 2423 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [(_vm.getRoleType === 99) ? _c('div', {
    staticClass: "box-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      'active': _vm.tab == 1
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(1)
      }
    }
  }, [_c('a', [_vm._v("基本資訊")])]), _vm._v(" "), (_vm.hasCommissionPermission) ? _c('li', {
    class: {
      'active': _vm.tab == 2
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(2)
      }
    }
  }, [_c('a', [_vm._v("作廢訂單額度")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab === 1),
      expression: "tab === 1"
    }],
    staticClass: "box-body form"
  }, [(_vm.$route.name === 'upBrand' && _vm.getRoleType === 99) ? _c('div', {
    staticClass: "del-block"
  }, [_c('div', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    }
  }, [_vm._v("刪除品牌")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.brand_code),
      expression: "brandInfo.brand_code"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "小英數組合",
      "type": "text",
      "id": "brand-code",
      "minlength": "6",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.brandInfo.brand_code)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityCode()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.brandInfo, "brand_code", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (!_vm.info && _vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n         鍵值(專屬用brand_key)\n      ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.brand_key),
      expression: "brandInfo.brand_key"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "id": "brand-key",
      "minlength": "1",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.brandInfo.brand_key)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityKey()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.brandInfo, "brand_key", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.info && _vm.getRoleType === 99) ? _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("(數字組合)"), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.name),
      expression: "brandInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.brandInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.brandInfo, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.name_short),
      expression: "brandInfo.name_short"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.brandInfo.name_short)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.brandInfo, "name_short", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          品牌別名\n        ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.nameAliasList,
      "tag-placeholder": "新增品牌別名",
      "placeholder": "新增品牌別名",
      "label": "label",
      "track-by": "value",
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addAliasTag
    },
    model: {
      value: (_vm.brandInfo.name_alias),
      callback: function($$v) {
        _vm.$set(_vm.brandInfo, "name_alias", $$v)
      },
      expression: "brandInfo.name_alias"
    }
  })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n        標語\n      ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.slogan),
      expression: "brandInfo.slogan"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.brandInfo.slogan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.brandInfo, "slogan", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n        訊息\n      ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.comment),
      expression: "brandInfo.comment"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.brandInfo.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.brandInfo, "comment", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n        描述\n      ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.description),
      expression: "brandInfo.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.brandInfo.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.brandInfo, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n        品牌頁介紹\n      ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.introduction),
      expression: "brandInfo.introduction"
    }],
    staticClass: "w-100-p form-control",
    attrs: {
      "name": "introduction",
      "cols": "30",
      "rows": "10",
      "maxlength": "65535"
    },
    domProps: {
      "value": (_vm.brandInfo.introduction)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.brandInfo, "introduction", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n        Youtube影片代碼\n      ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.youtube_video_code),
      expression: "brandInfo.youtube_video_code"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.brandInfo.youtube_video_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.brandInfo, "youtube_video_code", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n        電子信箱\n      ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.email),
      expression: "brandInfo.email"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.brandInfo.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.brandInfo, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n        品牌資訊\n      ")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "tag-placeholder": "前端顯示的品牌資訊",
      "placeholder": "選擇類型",
      "label": "label",
      "track-by": "value",
      "options": _vm.typeOptions,
      "multiple": true,
      "allow-empty": true
    },
    model: {
      value: (_vm.select.websiteSetting),
      callback: function($$v) {
        _vm.$set(_vm.select, "websiteSetting", $$v)
      },
      expression: "select.websiteSetting"
    }
  })], 1), _vm._v(" "), (_vm.select.websiteSetting.length) ? _c('div', {
    staticClass: "form-control"
  }, _vm._l((_vm.select.websiteSetting), function(website) {
    return _c('div', {
      staticClass: "input-group m-y-10"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v(_vm._s(website.label) + "\n          ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (website.url),
        expression: "website.url"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "網站連結",
        "type": "text",
        "maxlength": "1000"
      },
      domProps: {
        "value": (website.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(website, "url", $event.target.value)
        }
      }
    })])
  }), 0) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.is_visible),
      expression: "brandInfo.is_visible"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.brandInfo, "is_visible", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("顯示")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("不顯示")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          LOGO\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0 bg-white",
    staticStyle: {
      "border-right": "none"
    }
  }, [_c('span', {
    staticClass: "inline-block h-auto m-t-5"
  }, [(!_vm.brandInfo.image_name) ? _c('div', {
    staticClass: "text-black",
    domProps: {
      "textContent": _vm._s('沒有圖片')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.brandInfo.image_name) ? _c('img', {
    staticClass: "h-auto img-responsive",
    attrs: {
      "src": _vm.brandInfo.image_name,
      "data-toggle": "modal"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [_c('label', {
    staticClass: "btn-upload btn btn-default",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "for": "brand-img-load"
    }
  }, [_vm._v("\n            選擇圖片\n          ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "brand-img-load"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("(圖片大小為200x200)"), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          聯名圖\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0 bg-white",
    staticStyle: {
      "border-right": "none"
    }
  }, [_c('span', {
    staticClass: "inline-block h-auto m-t-5"
  }, [(!_vm.brandInfo.logo_name) ? _c('div', {
    staticClass: "text-black",
    domProps: {
      "textContent": _vm._s('沒有圖片')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.brandInfo.logo_name) ? _c('div', {
    staticClass: "h-auto img-responsive"
  }, [_c('object', {
    staticClass: "svg-img",
    staticStyle: {
      "height": "90px"
    },
    attrs: {
      "type": "image/svg+xml",
      "data": _vm.brandInfo.logo_name
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [_c('label', {
    staticClass: "btn-upload btn btn-default",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "for": "brand-logo-load"
    }
  }, [_vm._v("\n            選擇圖片\n          ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "brand-logo-load"
    },
    on: {
      "change": _vm.onLogoFileChange
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("(圖片大小為300x90)"), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          底圖照片\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0 bg-white",
    staticStyle: {
      "border-right": "none"
    }
  }, [_c('span', {
    staticClass: "inline-block h-auto m-t-5"
  }, [(!_vm.brandInfo.photo_name) ? _c('div', {
    staticClass: "text-black",
    domProps: {
      "textContent": _vm._s('沒有圖片')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.brandInfo.photo_name) ? _c('img', {
    staticClass: "h-auto img-responsive",
    attrs: {
      "src": _vm.brandInfo.photo_name,
      "data-toggle": "modal"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [_c('label', {
    staticClass: "btn-upload btn btn-default",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "for": "brand-photo-load"
    }
  }, [_vm._v("\n            選擇圖片\n          ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "brand-photo-load"
    },
    on: {
      "change": _vm.onPhotoFileChange
    }
  })])]), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("(圖片大小為800x460)")]) : _vm._e(), _vm._v(" "), (_vm.$route.name !== 'crBrand') ? _c('div', {
    staticClass: "photo-setup text-left"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "form-control"
  }, [_c('div', {
    staticClass: "radio inline-block cell-right"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCopyStore),
      expression: "isCopyStore"
    }],
    attrs: {
      "type": "radio",
      "name": "setStore"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.isCopyStore, true)
    },
    on: {
      "change": function($event) {
        _vm.isCopyStore = true
      }
    }
  }), _vm._v("\n                是\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "ml-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCopyStore),
      expression: "isCopyStore"
    }],
    attrs: {
      "type": "radio",
      "name": "setStore"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.isCopyStore, false)
    },
    on: {
      "change": function($event) {
        _vm.isCopyStore = false
      }
    }
  }), _vm._v("\n                否\n              ")])])])]), _vm._v(" "), (_vm.isCopyStore) ? _c('muti-select-two', {
    attrs: {
      "setting": _vm.addStoresSetting,
      "reNew": _vm.reNew,
      "reSet": _vm.reSet
    }
  }) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', {
    staticClass: "m-t-20"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          餐點種類\n        ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "tag-placeholder": "餐點種類",
      "placeholder": "餐點種類",
      "label": "label",
      "track-by": "value",
      "options": _vm.mealTagList,
      "multiple": true
    },
    model: {
      value: (_vm.brandInfo.binding_meal_tag_ids),
      callback: function($$v) {
        _vm.$set(_vm.brandInfo, "binding_meal_tag_ids", $$v)
      },
      expression: "brandInfo.binding_meal_tag_ids"
    }
  })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          品牌主色\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-b-5 text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.clear_main_color_code),
      expression: "brandInfo.clear_main_color_code"
    }],
    attrs: {
      "name": "clearMainColor",
      "type": "radio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.brandInfo.clear_main_color_code, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.brandInfo, "clear_main_color_code", 1)
      }
    }
  }), _vm._v("\n              預設(你訂)\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "m-l-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.clear_main_color_code),
      expression: "brandInfo.clear_main_color_code"
    }],
    staticClass: "m-t-4",
    attrs: {
      "name": "clearMainColor",
      "type": "radio"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.brandInfo.clear_main_color_code, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.brandInfo, "clear_main_color_code", 0)
      }
    }
  }), _vm._v("\n              自訂顏色\n              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.main_color_code),
      expression: "brandInfo.main_color_code"
    }],
    staticClass: "m-l-10",
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": (_vm.brandInfo.main_color_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.brandInfo, "main_color_code", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          品牌副色\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-b-5 text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.clear_sub_color_code),
      expression: "brandInfo.clear_sub_color_code"
    }],
    attrs: {
      "name": "clearSubColor",
      "type": "radio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.brandInfo.clear_sub_color_code, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.brandInfo, "clear_sub_color_code", 1)
      }
    }
  }), _vm._v("\n              預設(你訂)\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "m-l-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.clear_sub_color_code),
      expression: "brandInfo.clear_sub_color_code"
    }],
    staticClass: "m-t-4",
    attrs: {
      "name": "clearSubColor",
      "type": "radio"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.brandInfo.clear_sub_color_code, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.brandInfo, "clear_sub_color_code", 0)
      }
    }
  }), _vm._v("\n              自訂顏色\n              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.sub_color_code),
      expression: "brandInfo.sub_color_code"
    }],
    staticClass: "m-l-10",
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": (_vm.brandInfo.sub_color_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.brandInfo, "sub_color_code", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab === 2 && _vm.getRoleType === 99),
      expression: "tab === 2 && getRoleType === 99"
    }],
    staticClass: "box-body form text-left"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "flex align-center h-34"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderCommissionSetting.quota_type),
      expression: "orderCommissionSetting.quota_type"
    }],
    attrs: {
      "type": "radio",
      "name": "independent"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.orderCommissionSetting.quota_type, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.orderCommissionSetting, "quota_type", 1)
      }
    }
  }), _vm._v("\n            品牌總額度\n            "), _vm._m(6)])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderCommissionSetting.quota_type),
      expression: "orderCommissionSetting.quota_type"
    }],
    attrs: {
      "type": "radio",
      "name": "independent"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.orderCommissionSetting.quota_type, 2)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.orderCommissionSetting, "quota_type", 2)
      }
    }
  }), _vm._v("\n            每間門市額度\n            "), _vm._m(7)])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.brandInfo.order_commission_setting.allow_invalid_order_quota),
      expression: "brandInfo.order_commission_setting.allow_invalid_order_quota",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.brandInfo.order_commission_setting.allow_invalid_order_quota)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.brandInfo.order_commission_setting, "allow_invalid_order_quota", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.info) ? _c('div', [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("獨立產出抽成對帳表門市")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(10), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(11)]) : (_vm.independentStoreList.length === 0) ? _c('tbody', [_vm._m(12)]) : _c('tbody', _vm._l((_vm.independentStoreList), function(row, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.allow_invalid_order_quota))])])
  }), 0)])]), _vm._v(" "), _c('paginate', {
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [(!_vm.info && _vm.tab !== 1) ? _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.tab--
      }
    }
  }, [_vm._v("\n      上一步\n    ")]) : _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n      取消\n    ")]), _vm._v(" "), (!_vm.info && _vm.tab !== _vm.tabTotal) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.tab++
      }
    }
  }, [_vm._v("\n      下一步\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.info && _vm.tab === _vm.tabTotal) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkInputEmpty('cr')
      }
    }
  }, [_vm._v("\n      新增\n    ")]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkInputEmpty('up')
      }
    }
  }, [_vm._v("\n      修改\n    ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n          代碼\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n          名稱\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n          縮寫名稱\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("前端顯示\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("套用指定門市\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("額度計算")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "m-l-5",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "此為整個品牌的作廢訂單總額度，非單一門市。"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "m-l-5",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "每間門市都有指定的作廢額度。例如 : 當額度設定為 5 筆時，每間門市都有 5 筆的作廢額度。"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("每月作廢訂單額度 (筆)\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 如需調整請至編輯門市-計費方式設定")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("門市名稱")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("額度")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "3"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
}]}

/***/ }),
/* 2424 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade bd-example-modal-lg",
    attrs: {
      "id": _vm.option.id,
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "p-b-10"
  }, [_c('h5', [_c('span', {
    staticClass: "text-pink"
  }, [_vm._v("＊")]), _vm._v(" " + _vm._s(_vm.tooltip))])]), _vm._v(" "), (_vm.getRoleType !== 10) ? _c('div', {
    staticClass: "text-left"
  }, [_c('h5', [_vm._v("套用門市")]), _vm._v(" "), _vm._l((_vm.storeClassList), function(storeClass, index) {
    return _c('div', {
      key: ("storeClass-" + index),
      staticClass: "m-r-5 m-b-10 inline-block"
    }, [_c('button', {
      staticClass: "btn btn-default",
      class: {
        'active': _vm.curId === storeClass.id
      },
      on: {
        "click": function($event) {
          return _vm.clickOption(storeClass)
        }
      }
    }, [_vm._v("\n              " + _vm._s(storeClass.name) + "\n            ")])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "min-h-260"
  }, [_c('h5', {
    staticClass: "text-left"
  }, [_vm._v("參與店家")]), _vm._v(" "), _c('muti-select-two', {
    attrs: {
      "setting": _vm.addStoresSetting,
      "reNew": _vm.reNew,
      "reSet": _vm.reSet
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          取消\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.copyStore
    }
  }, [_vm._v("\n          確定\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("複製選取設定至其他店家")])])
}]}

/***/ }),
/* 2425 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-left"
  }, [(_vm.brandSelectShow) ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandSelect),
      expression: "brandSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.brandSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.brandBrief), function(brand) {
    return _c('option', {
      domProps: {
        "value": brand.value
      }
    }, [_vm._v("\n            " + _vm._s(brand.label) + "\n          ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.storeSelectShow) ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeSelect),
      expression: "storeSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.storeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.storeBrief), function(store) {
    return _c('option', {
      domProps: {
        "value": store.value
      }
    }, [_vm._v("\n            " + _vm._s(store.label) + "\n          ")])
  }), 0)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.notifyList), function(notify, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_c('span', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(notify.alarm_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.notifyMethodName(notify.notify_method)))]), _vm._v(" "), _c('td', [(notify.toggle) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("正常")]) : _vm._e(), _vm._v(" "), (!notify.toggle) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("停用")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(notify.update_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(notify.create_time))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#delStoreModal"
      },
      on: {
        "click": function($event) {
          return _vm.getCurrent(notify.alarm_id, notify.target_name)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          return _vm.toggleModal('up', notify)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [(_vm.pageAmount > 1 && _vm.pageGroup !== 1) ? _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        _vm.pageGroup = _vm.pageGroup - 1
      }
    }
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pageAmount), function(index) {
    return (_vm.pageShow(index)) ? _c('li', {
      staticClass: "paginate_button",
      class: {
        active: _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          return _vm.getNotifyBindingList(index)
        }
      }
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v(_vm._s(index))])]) : _vm._e()
  }), _vm._v(" "), (_vm.pageAmount > 1 && _vm.pageAmount / _vm.groupAmount > _vm.pageGroup) ? _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        _vm.pageGroup = _vm.pageGroup + 1
      }
    }
  }, [_vm._m(2)]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "editStoreNotifyModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "box-body form p-x-0"
  }, [_c('div', [(!_vm.show.cr) ? _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.binding.toggleSelect),
      expression: "binding.toggleSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.binding, "toggleSelect", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("啟用")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("停用")])]), _vm._v(" "), _c('br')]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("取消")]), _vm._v(" "), (!_vm.show.cr) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.notifyBinding('up')
      }
    }
  }, [_vm._v("修改")]) : _vm._e()])])])]), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("綁定ID")]), _vm._v(" "), _c('th', [_vm._v("方式")]), _vm._v(" "), _c('th', [_vm._v("啟用")]), _vm._v(" "), _c('th', [_vm._v("更新時間")]), _vm._v(" "), _c('th', [_vm._v("建立時間")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("門市綁定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("啟用")])
}]}

/***/ }),
/* 2426 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [_c('div', {
    staticClass: "box-body form"
  }, [_c('br'), _vm._v(" "), _c('div', [_c('h3', {
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "ad-form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 ad-form-left"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adInfo.name),
      expression: "adInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.adInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adInfo, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adInfo.is_active),
      expression: "adInfo.is_active"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.adInfo, "is_active", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("啟用")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("停用")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          連結\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adInfo.url),
      expression: "adInfo.url"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.adInfo.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adInfo, "url", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "input-group cr-schedule cr-ad"
  }, [_vm._m(2), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.timeoption,
      "limit": _vm.startLimit
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group cr-schedule cr-ad"
  }, [_vm._m(3), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.timeoption,
      "limit": _vm.endLimit
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.bannerType !== 41) ? _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adInfo.foreverShow),
      expression: "adInfo.foreverShow"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.adInfo, "foreverShow", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")])])])]) : _vm._e()]), _vm._v(" "), (_vm.bannerType !== 41) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("廣告地區\n          "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(5)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-0 p-5 text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adInfo.is_limit_location),
      expression: "adInfo.is_limit_location"
    }],
    attrs: {
      "type": "radio",
      "name": "invoiceOption"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.adInfo.is_limit_location, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.adInfo, "is_limit_location", 0)
      }
    }
  }), _vm._v("不限制\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adInfo.is_limit_location),
      expression: "adInfo.is_limit_location"
    }],
    attrs: {
      "type": "radio",
      "name": "invoiceOption"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.adInfo.is_limit_location, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.adInfo, "is_limit_location", 1)
      }
    }
  }), _vm._v("指定區域\n            ")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.adInfo.is_limit_location) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('multiselect', {
    staticClass: "min-w-150",
    attrs: {
      "options": _vm.getCityOption,
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "show-labels": false,
      "placeholder": "",
      "multiple": true,
      "label": "name",
      "track-by": "code"
    },
    model: {
      value: (_vm.adInfo.city_code_list),
      callback: function($$v) {
        _vm.$set(_vm.adInfo, "city_code_list", $$v)
      },
      expression: "adInfo.city_code_list"
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.bannerType === 12) ? _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("標籤名稱\n        "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(7)], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adInfo.tag_list[0]['name']),
      expression: "adInfo.tag_list[0]['name']"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "請輸入完整4字",
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.adInfo.tag_list[0]['name'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adInfo.tag_list[0], 'name', $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.bannerType === 12) ? _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("廣告文案\n        "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(8)], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adInfo.tag_list[0]['description']),
      expression: "adInfo.tag_list[0]['description']"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "請輸入10 ~ 17字",
      "type": "text",
      "minlength": "10",
      "maxlength": "17"
    },
    domProps: {
      "value": (_vm.adInfo.tag_list[0]['description'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adInfo.tag_list[0], 'description', $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "input-group upload-image"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0 bg-white",
    staticStyle: {
      "border-right": "none"
    }
  }, [_c('span', {
    staticClass: "inline-block h-auto"
  }, [(!_vm.adInfo.image_web_file) ? _c('img', {
    staticClass: "img-responsive h-auto",
    attrs: {
      "src": _vm.defaultImage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.adInfo.image_web_file) ? _c('img', {
    staticClass: "h-auto img-responsive",
    attrs: {
      "src": _vm.adInfo.image_web_file,
      "data-toggle": "modal"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [_c('div', [_c('label', {
    staticClass: "btn-upload btn btn-default m-t-25",
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "for": "brand-img-load"
    }
  }, [_vm._v("\n          選擇圖片\n        ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "brand-img-load"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right text-15 text-red",
    domProps: {
      "textContent": _vm._s(_vm.tipsImage)
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n      取消\n    ")]), _vm._v(" "), (!_vm.info) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkBeforeSend('cr')
      }
    }
  }, [_vm._v("\n      新增\n    ")]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkBeforeSend('up')
      }
    }
  }, [_vm._v("\n      修改\n    ")]) : _vm._e()]), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("名稱\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("啟用\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("開始時間\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("結束時間\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("永久顯示\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text center"
  }, [_vm._v("\n              *依據消費者位置指定廣告要出現的縣市(目前限台灣地區)。"), _c('br'), _vm._v("\n              *若無法判斷位置或在非台灣地區，則預設都顯示。\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("指定區域\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text center"
  }, [_vm._v("\n            顯示於你訂平台首頁，如下標籤區塊\n            "), _c('img', {
    attrs: {
      "src": "/static/img/ad-form-temp-01.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text center"
  }, [_vm._v("\n            顯示於你訂平台首頁，如下文案區塊\n            "), _c('img', {
    attrs: {
      "src": "/static/img/ad-form-temp-02.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("圖片\n    ")])
}]}

/***/ }),
/* 2427 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [_c('div', {
    staticClass: "box-body form"
  }, [(_vm.info) ? _c('div', {
    staticClass: "del-block"
  }, [_c('div', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    }
  }, [_vm._v("刪除門市綁定")])]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('br') : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n        名稱\n      ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.name),
      expression: "content.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.content.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), (!_vm.info) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('multiselect', {
    attrs: {
      "tag-placeholder": "品牌綁定",
      "placeholder": "選擇品牌",
      "label": "label",
      "track-by": "value",
      "options": _vm.brandBrief,
      "multiple": false,
      "allow-empty": false
    },
    model: {
      value: (_vm.select.bindingBrandList),
      callback: function($$v) {
        _vm.$set(_vm.select, "bindingBrandList", $$v)
      },
      expression: "select.bindingBrandList"
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (!_vm.info) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('multiselect', {
    attrs: {
      "tag-placeholder": "店家綁定",
      "placeholder": "選擇店家",
      "label": "label",
      "track-by": "value",
      "options": _vm.storeBrief,
      "multiple": false,
      "allow-empty": false
    },
    model: {
      value: (_vm.select.bindingStoreList),
      callback: function($$v) {
        _vm.$set(_vm.select, "bindingStoreList", $$v)
      },
      expression: "select.bindingStoreList"
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n        啟用\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.is_enabled),
      expression: "content.is_enabled"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.content, "is_enabled", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("啟用")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("不啟用")])])])]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('router-link', {
    attrs: {
      "to": '/printerInfo/' + _vm.$route.params.printer_id
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("\n        取消\n      ")])]), _vm._v(" "), (!_vm.info) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.crPrinterStore
    }
  }, [_vm._v("\n      新增\n    ")]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.upPrinterStore
    }
  }, [_vm._v("\n      修改\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("品牌\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("店家\n      ")])
}]}

/***/ }),
/* 2428 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box m-h-700"
  }, [_c('div', {
    staticClass: "box-body form-inline"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/crActivity'
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("新增優惠券活動")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/upCouponTable'
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("管理活動列表")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.brandBrief.length > 1 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandSelect),
      expression: "brandSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.brandSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.brandBrief), function(brand) {
    return _c('option', {
      domProps: {
        "value": brand.value
      }
    }, [_vm._v("\n                " + _vm._s(brand.label) + "\n              ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.brandSelect !== 999999 && _vm.brandSelect !== '999999' && _vm.storeBrief.length > 2) ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeSelect),
      expression: "storeSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.storeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.storeBrief), function(store) {
    return _c('option', {
      domProps: {
        "value": store.value
      }
    }, [_vm._v("\n                " + _vm._s(store.label) + "\n              ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruleCodeSelect),
      expression: "ruleCodeSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ruleCodeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getAttendCoupon]
    }
  }, [_c('option', {
    domProps: {
      "value": 999999
    }
  }, [_vm._v("== 贈送規則 ==")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SA00001"
    }
  }, [_vm._v("消費滿X元贈送Y張優惠券")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SA00002"
    }
  }, [_vm._v("消費滿X個贈送Y張優惠券")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SA00003"
    }
  }, [_vm._v("買指定商品贈送Y張優惠券")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeMethodSelect),
      expression: "timeMethodSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.timeMethodSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getAttendCoupon]
    }
  }, [_c('option', {
    domProps: {
      "value": 999999
    }
  }, [_vm._v("== 時間狀態 ==")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "notyet"
    }
  }, [_vm._v("未開始")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "going"
    }
  }, [_vm._v("進行中")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "end"
    }
  }, [_vm._v("已結束")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelect),
      expression: "statusSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.statusSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getAttendCoupon]
    }
  }, [_c('option', {
    domProps: {
      "value": 999999
    }
  }, [_vm._v("== 活動狀態 ==")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("初始狀態")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("編輯中")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("待上架")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("已上架")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("已下架")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('activity_id')
      }
    }
  }, [_vm._v("優惠券活動 (ID)\n                    "), (_vm.sortMethod === 'activity_id') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("贈送規則")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("時間狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("活動狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("擁有者")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('start_time')
      }
    }
  }, [_vm._v("活動開始\n                    "), (_vm.sortMethod === 'start_time') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('end_time')
      }
    }
  }, [_vm._v("活動結束\n                    "), (_vm.sortMethod === 'end_time') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.couponList), function(coupon, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": '/activityInfo/' + coupon.activity_id
      }
    }, [_vm._v("\n                        " + _vm._s(coupon.name) + " (" + _vm._s(coupon.activity_id) + ")\n                      ")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRuleName(coupon.rule_code)) + " (" + _vm._s(coupon.rule_code) + ")")]), _vm._v(" "), _c('td', [(coupon.time_method === 'notyet') ? _c('label', {
      staticClass: "label label-default"
    }, [_vm._v("未開始")]) : (coupon.time_method === 'going') ? _c('label', {
      staticClass: "label label-success"
    }, [_vm._v("進行中")]) : (coupon.time_method === 'end') ? _c('label', {
      staticClass: "label label-danger"
    }, [_vm._v("已結束")]) : _vm._e()]), _vm._v(" "), _c('td', [(coupon.status === 0) ? _c('label', {
      staticClass: "label label-default"
    }, [_vm._v("初始狀態")]) : (coupon.status === 1) ? _c('label', {
      staticClass: "label label-primary"
    }, [_vm._v("編輯中")]) : (coupon.status === 3) ? _c('label', {
      staticClass: "label label-primary"
    }, [_vm._v("待上架")]) : (coupon.status === 4) ? _c('label', {
      staticClass: "label label-success"
    }, [_vm._v("已上架")]) : _c('label', {
      staticClass: "label label-danger"
    }, [_vm._v("已下架")])]), _vm._v(" "), _c('td', [(coupon.owner_type === 1) ? _c('span', [_vm._v("平台")]) : _vm._e(), _vm._v(" "), (coupon.owner_type === 2) ? _c('span', [_vm._v(_vm._s(coupon.owner_brand_name) + " (" + _vm._s(coupon.owner_id) + ")")]) : _vm._e(), _vm._v(" "), (coupon.owner_type === 3) ? _c('span', [_vm._v(_vm._s(coupon.owner_brand_name) + " - " + _vm._s(coupon.owner_store_name) + " (" + _vm._s(coupon.owner_id) + ")")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getDate(coupon.start_time)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getDate(coupon.end_time)))])])
  }), 0)])]), _vm._v(" "), _c('paginate', {
    ref: "orderPaginate",
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "storesModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\"" + _vm._s(_vm.current.name) + "\"使用門市")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 p-x-0"
  }, _vm._l((_vm.current.store_list), function(store) {
    return _c('label', {
      staticClass: "label label-primary",
      staticStyle: {
        "margin-right": "5px"
      }
    }, [_vm._v(_vm._s(store.name))])
  }), 0)])]), _vm._v(" "), _vm._m(0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("確定")])])
}]}

/***/ }),
/* 2429 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('dis-prod')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2430 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('copy-ad-form')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2431 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      'active': _vm.chartMethod == 1
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.chartMethod = 1
      }
    }
  }, [_c('a', [_vm._v("行銷統計\n              ")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.chartMethod == 2
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.chartMethod = 2
      }
    }
  }, [_c('a', [_vm._v("各店統計\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row form-inline m-b-10"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_c('div', {
    staticClass: "from-group inline-block pull-left"
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title h-38",
    on: {
      "click": _vm.reportPromotion
    }
  }, [_vm._v("產生報表")])]), _vm._v(" "), (_vm.storeBrief.length > 1 && _vm.chartMethod === 2) ? _c('div', {
    staticClass: "inline-block from-group pull-left m-l-5",
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.storeBrief,
      "label": "label",
      "searchable": false,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "門市",
      "show-labels": false,
      "preselect-first": true
    },
    on: {
      "input": _vm.changeSelect
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('div', {
    staticClass: "form-group input-group time-box pull-right"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.dateoption,
      "limit": _vm.startLimit
    }
  }), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.dateoption,
      "limit": _vm.endLimit
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default submit-btn btn-search",
    staticStyle: {
      "height": "72px"
    },
    attrs: {
      "type": "button",
      "id": "search"
    },
    on: {
      "click": function($event) {
        return _vm.search(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-body col-xs-12 text-center"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn-all bg-primary btn-detail-edit p-10",
    class: {
      'active': _vm.typeSelect !== 1
    },
    on: {
      "click": function($event) {
        _vm.typeSelect = 1
      }
    }
  }, [_vm._v("\n                    累積\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn-basic bg-primary btn-detail-edit p-10",
    class: {
      'active': _vm.typeSelect !== 2
    },
    on: {
      "click": function($event) {
        _vm.typeSelect = 2
      }
    }
  }, [_vm._v("\n                    期間\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn-gb bg-primary btn-detail-edit p-10",
    class: {
      'active': _vm.typeSelect !== 3
    },
    on: {
      "click": function($event) {
        _vm.typeSelect = 3
      }
    }
  }, [_vm._v("\n                    目前\n                  ")])])])])]), _vm._v(" "), (_vm.chartMethod === 1) ? _c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', {
    staticClass: "middle"
  }, [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "2",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "320px"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "2",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("優惠券")]), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "2",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("贈送")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "2",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("已折")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "2",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("折抵中")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "2",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("作廢")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('th', {
    attrs: {
      "colspan": "2",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("有效")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('th', {
    attrs: {
      "colspan": "2",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("逾期")]) : _vm._e()]), _vm._v(" "), _c('tr', {
    attrs: {
      "role": "row"
    }
  }, [(_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('give_coupon_amount')
      }
    }
  }, [_vm._v("張數\n                  "), (_vm.sortMethod === 'give_coupon_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('used_coupon_amount')
      }
    }
  }, [_vm._v("張數\n                  "), (_vm.sortMethod === 'used_coupon_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('using_coupon_amount')
      }
    }
  }, [_vm._v("張數\n                  "), (_vm.sortMethod === 'using_coupon_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('void_coupon_amount')
      }
    }
  }, [_vm._v("張數\n                  "), (_vm.sortMethod === 'void_coupon_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('valid_coupon_amount')
      }
    }
  }, [_vm._v("張數\n                  "), (_vm.sortMethod === 'valid_coupon_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('exp_coupon_amount')
      }
    }
  }, [_vm._v("張數\n                  "), (_vm.sortMethod === 'exp_coupon_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]) : _vm._e()])]), _vm._v(" "), _c('tbody', {
    staticClass: "middle"
  }, _vm._l((_vm.promotionList), function(coupon, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "padding": "10px 15px",
        "background": "#efefef",
        "border-radius": "6px",
        "min-width": "320px"
      }
    }, [_c('div', {
      staticClass: "coupon-left"
    }, [_c('h4', [_vm._v(_vm._s(coupon.coupon_set_name))]), _vm._v(" "), _c('p', [_c('small', [_vm._v(_vm._s(coupon.coupon_set_description))])]), _vm._v(" "), _c('p', {
      staticClass: "text-blue"
    }, [_c('small', [_vm._v("•  " + _vm._s(_vm.getItemType(coupon.get_item_type)))])])]), _vm._v(" "), _c('div', {
      staticClass: "coupon-right"
    }, [(coupon.discount_type === 1) ? _c('p', {
      staticClass: "v-middle"
    }, [_vm._v("\n                        $ " + _vm._s(coupon.discount_value) + "\n                      ")]) : _vm._e(), _vm._v(" "), (coupon.discount_type === 2) ? _c('p', {
      staticClass: "v-middle"
    }, [_vm._v("\n                        " + _vm._s((100 - coupon.discount_value) / 10) + " 折\n                      ")]) : _vm._e()])])]), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-success"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.give_coupon_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.give_coupon_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-success"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v("$ " + _vm._s(coupon.give_coupon_money))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v("$ " + _vm._s(coupon.give_coupon_money_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-warning"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.used_coupon_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.used_coupon_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-warning"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v("$ " + _vm._s(coupon.used_coupon_money))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v("$ " + _vm._s(coupon.used_coupon_money_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-primary"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.using_coupon_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.using_coupon_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-primary"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v("$ " + _vm._s(coupon.using_coupon_money))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v("$ " + _vm._s(coupon.using_coupon_money_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-danger"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.void_coupon_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.void_coupon_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-danger"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v("$ " + _vm._s(coupon.void_coupon_money))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v("$ " + _vm._s(coupon.void_coupon_money_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('td', {
      staticClass: "td-success"
    }, [_vm._v("\n                  " + _vm._s(coupon.valid_coupon_amount) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('td', {
      staticClass: "td-success"
    }, [_vm._v("\n                  $ " + _vm._s(coupon.valid_coupon_money) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('td', {
      staticClass: "td-danger"
    }, [_vm._v("\n                  " + _vm._s(coupon.exp_coupon_amount) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('td', {
      staticClass: "td-danger"
    }, [_vm._v("\n                  $ " + _vm._s(coupon.exp_coupon_money) + "\n                ")]) : _vm._e()])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.chartMethod === 2) ? _c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example2"
    }
  }, [_c('thead', {
    staticClass: "middle"
  }, [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "2",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "320px"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "2",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("優惠券")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "2",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("門市")]), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "3",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("贈送")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "3",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("已折")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "3",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("折抵中")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "3",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("作廢")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('th', {
    attrs: {
      "colspan": "2",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("有效")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('th', {
    attrs: {
      "colspan": "2",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("逾期")]) : _vm._e()]), _vm._v(" "), _c('tr', {
    attrs: {
      "role": "row"
    }
  }, [(_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('give_order_amount')
      }
    }
  }, [_vm._v("訂單\n                  "), (_vm.sortMethod === 'give_order_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('give_coupon_amount')
      }
    }
  }, [_vm._v("張數\n                  "), (_vm.sortMethod === 'give_coupon_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('used_order_amount')
      }
    }
  }, [_vm._v("訂單\n                  "), (_vm.sortMethod === 'used_order_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('used_coupon_amount')
      }
    }
  }, [_vm._v("張數\n                  "), (_vm.sortMethod === 'used_coupon_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('using_order_amount')
      }
    }
  }, [_vm._v("訂單\n                  "), (_vm.sortMethod === 'using_order_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('using_coupon_amount')
      }
    }
  }, [_vm._v("張數\n                  "), (_vm.sortMethod === 'using_coupon_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('void_order_amount')
      }
    }
  }, [_vm._v("訂單\n                  "), (_vm.sortMethod === 'void_order_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('void_coupon_amount')
      }
    }
  }, [_vm._v("張數\n                  "), (_vm.sortMethod === 'void_coupon_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('valid_coupon_amount')
      }
    }
  }, [_vm._v("張數\n                  "), (_vm.sortMethod === 'valid_coupon_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('exp_coupon_amount')
      }
    }
  }, [_vm._v("張數\n                  "), (_vm.sortMethod === 'exp_coupon_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]) : _vm._e()])]), _vm._v(" "), _c('tbody', {
    staticClass: "middle"
  }, _vm._l((_vm.storeCouponList), function(coupon, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "padding": "10px 15px",
        "background": "#efefef",
        "border-radius": "6px",
        "min-width": "320px"
      }
    }, [_c('div', {
      staticClass: "coupon-left"
    }, [_c('h4', [_vm._v(_vm._s(coupon.coupon_set_name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(coupon.coupon_set_description))])]), _vm._v(" "), _c('div', {
      staticClass: "coupon-right"
    }, [(coupon.discount_type === 1) ? _c('p', {
      staticClass: "v-middle"
    }, [_vm._v("\n                        $ " + _vm._s(coupon.discount_value) + "\n                      ")]) : _vm._e(), _vm._v(" "), (coupon.discount_type === 2) ? _c('p', {
      staticClass: "v-middle"
    }, [_vm._v("\n                        " + _vm._s((100 - coupon.discount_value) / 10) + " 折\n                      ")]) : _vm._e()])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(coupon.store_name) + " (" + _vm._s(coupon.store_id) + ")")]), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-success"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.give_order_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.give_order_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-success"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.give_coupon_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.give_coupon_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-success"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v("$ " + _vm._s(coupon.give_coupon_money))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v("$ " + _vm._s(coupon.give_coupon_money_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-warning"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.used_order_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.used_order_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-warning"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.used_coupon_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.used_coupon_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-warning"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v("$ " + _vm._s(coupon.used_coupon_money))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v("$ " + _vm._s(coupon.used_coupon_money_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-primary"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.using_order_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.using_order_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-primary"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.using_coupon_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.using_coupon_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-primary"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v("$ " + _vm._s(coupon.using_coupon_money))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v("$ " + _vm._s(coupon.using_coupon_money_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-danger"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.void_order_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.void_order_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-danger"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.void_coupon_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.void_coupon_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-danger"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v("$ " + _vm._s(coupon.void_coupon_money))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v("$ " + _vm._s(coupon.void_coupon_money_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('td', {
      staticClass: "td-success"
    }, [_vm._v("\n                  " + _vm._s(coupon.valid_coupon_amount) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('td', {
      staticClass: "td-success"
    }, [_vm._v("\n                  $ " + _vm._s(coupon.valid_coupon_money) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('td', {
      staticClass: "td-danger"
    }, [_vm._v("\n                  " + _vm._s(coupon.exp_coupon_amount) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('td', {
      staticClass: "td-danger"
    }, [_vm._v("\n                  $ " + _vm._s(coupon.exp_coupon_money) + "\n                ")]) : _vm._e()])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickEnd('pre')
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickGroup('left')
      }
    }
  }, [_vm._m(1)]), _vm._v(" "), _vm._l((_vm.pageAmount), function(index) {
    return (_vm.pageShow(index)) ? _c('li', {
      staticClass: "paginate_button",
      class: {
        active: _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          return _vm.clickPage(index)
        }
      }
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v(_vm._s(index))])]) : _vm._e()
  }), _vm._v(" "), _vm._l(((_vm.groupAmount - Math.ceil(_vm.pageAmount % 10))), function(dis) {
    return (_vm.pageGroup === Math.ceil(_vm.pageAmount / _vm.groupAmount)) ? _c('li', {
      staticClass: "paginate_button disabled"
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v("  ")])]) : _vm._e()
  }), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickGroup('right')
      }
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickEnd('forward')
      }
    }
  }, [_vm._m(3)])], 2)])])])])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delMOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delAOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.removeGNowOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.saleGNowOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.removeNowOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.saleNowOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-step-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-forward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-step-forward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 2432 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('printer-form')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2433 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-10 flex align-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.goBackInfo.name,
        params: _vm.goBackInfo.params,
        query: _vm.goBackInfo.query
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default m-r-5 flex"
  }, [_c('span', [_vm._v("返回")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.title)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.subtitle)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex grey darken-1"
  }, [(_vm.brand.name || _vm.store.brand_name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s(_vm.brand.name ? _vm.brand.name : _vm.store.brand_name ? _vm.store.brand_name : '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s('/')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.store.name)
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('cr-option')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2434 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('brand-table')], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 2435 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box text-center"
  }, [(_vm.up) ? _c('div', {
    staticClass: "del-block m-t-5"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.up) ? _c('div', {
    staticClass: "copy-block m-t-5"
  }, [_c('router-link', {
    attrs: {
      "to": '/copyLimiScheduleItem/' + _vm.$route.params.setting_id + '?brand_id=' + _vm.$route.query.brand_id + '&store_id=' + _vm.$route.query.store_id
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("複製門市限時限量設定")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body form"
  }, [_c('br'), _vm._v(" "), _c('div', [_c('h3', {
    staticStyle: {
      "margin-bottom": "3em"
    }
  }, [_vm._v("\n              基本設定\n            ")]), _vm._v(" "), _c('div', [_vm._m(1), _vm._v(" "), (_vm.brandBrief.length > 1 || _vm.up) ? _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), (!_vm.up) ? _c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "==品牌==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value",
      "disable": true
    },
    on: {
      "input": function($event) {
        return _vm.routerEvent('brand')
      }
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.up) ? _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v("\n                  " + _vm._s(_vm.brandSelect.label) + "\n                ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), (!_vm.up) ? _c('multiselect', {
    attrs: {
      "options": _vm.storeBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 門市 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    on: {
      "input": function($event) {
        return _vm.routerEvent('store')
      }
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.up) ? _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeSelect.label) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "min-width": "138px",
      "text-align": "left"
    }
  }, [_vm._v("\n                  設定名稱\n                ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "備註用，不會顯示在菜單",
      "type": "text",
      "maxlength": "16"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "min-width": "138px",
      "text-align": "left"
    }
  }, [_vm._v("\n                  設定描述\n                ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "備註用，不會顯示在菜單",
      "type": "text",
      "maxlength": "200"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('h3', {
    staticStyle: {
      "margin-top": "2em",
      "margin-bottom": "1em"
    }
  }, [_vm._v("\n                指定區間設定\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addSectionSetting
    }
  }, [_vm._v("新增指定區間設定")])]), _vm._v(" "), _c('div', {
    staticClass: "box-table",
    staticStyle: {
      "height": "400px",
      "min-height": "300px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 p-x-0  position-relative",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('table', {
    staticClass: "table table-striped dataTable",
    class: _vm.show_section_overlap ? 'table-borderless' : 'table-bordered'
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.rule_section_list), function(section, sIndex) {
    return _c('tr', {
      key: sIndex + ' week',
      class: section.show_overlap ? 'overlap' : ''
    }, [_c('td', {
      style: (_vm.show_section_overlap ? 'vertical-align: middle' : '')
    }, [_c('div', {}, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (section.delivery_type),
        expression: "section.delivery_type"
      }],
      staticClass: "form-control min-w p-0",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(section, "delivery_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "0"
      }
    }, [_vm._v("不限")]), _vm._v(" "), _vm._l((_vm.storedeliveryInfo), function(main) {
      return _c('option', {
        domProps: {
          "value": main.value
        }
      }, [_vm._v("\n                                  " + _vm._s(main.label) + "\n                                ")])
    })], 2)])]), _vm._v(" "), _c('td', {
      style: (_vm.show_section_overlap ? 'vertical-align: middle' : '')
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "justify-content": "center"
      }
    }, [_c('div', [_c('date-time-picker', {
      attrs: {
        "placeholder": "YYYMM-DD",
        "date": section.sectionTime.start,
        "option": _vm.dateoption,
        "limit": section.startLimit
      },
      on: {
        "change": function($event) {
          return _vm.changeDate($event, 'start', sIndex)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-left": "4px",
        "margin-right": "4px",
        "align-self": "center"
      }
    }, [_vm._v("\n                                -\n                              ")]), _vm._v(" "), _c('div', [_c('date-time-picker', {
      attrs: {
        "placeholder": "YYYMM-DD",
        "date": section.sectionTime.end,
        "option": _vm.dateoption,
        "limit": section.endLimit
      },
      on: {
        "change": function($event) {
          return _vm.changeDate($event, 'end', sIndex)
        }
      }
    })], 1)])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      style: (_vm.show_section_overlap ? 'vertical-align: middle' : '')
    }, [_c('vue-timepicker', {
      attrs: {
        "hide-disabled-items": "",
        "manual-input": "",
        "placeholder": "hh:mm",
        "minute-interval": 30,
        "input-class": "form-control"
      },
      model: {
        value: (section.rule_start_time),
        callback: function($$v) {
          _vm.$set(section, "rule_start_time", $$v)
        },
        expression: "section.rule_start_time"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      style: (_vm.show_section_overlap ? 'vertical-align: middle' : '')
    }, [_c('vue-timepicker', {
      attrs: {
        "hide-disabled-items": "",
        "manual-input": "",
        "placeholder": "hh:mm",
        "minute-range": [29, 59],
        "input-class": "form-control"
      },
      model: {
        value: (section.rule_end_time),
        callback: function($$v) {
          _vm.$set(section, "rule_end_time", $$v)
        },
        expression: "section.rule_end_time"
      }
    })], 1), _vm._v(" "), _c('td', {
      style: (_vm.show_section_overlap ? 'vertical-align: middle' : '')
    }, [_c('div', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (section.src_type),
        expression: "section.src_type"
      }],
      staticClass: "form-control min-w p-0",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(section, "src_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v("訂單")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "2"
      }
    }, [_vm._v("份數")])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (section.amount),
        expression: "section.amount"
      }],
      staticStyle: {
        "max-width": "86px",
        "height": "34px",
        "border": "1px solid #d2d6de",
        "border-radius": "0px 3px 3px 0px",
        "padding-left": "4px"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (section.amount)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(section, "amount", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "vertical-align": "middle",
        "min-width": "100px"
      }
    }, [_c('div', {
      staticClass: "text-left"
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (section.is_enabled),
        expression: "section.is_enabled"
      }],
      attrs: {
        "type": "radio",
        "value": "1"
      },
      domProps: {
        "checked": _vm._q(section.is_enabled, "1")
      },
      on: {
        "change": function($event) {
          return _vm.$set(section, "is_enabled", "1")
        }
      }
    }), _vm._v("\n                                  開啟\n                                ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block",
      staticStyle: {
        "margin-top": "0px"
      }
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (section.is_enabled),
        expression: "section.is_enabled"
      }],
      attrs: {
        "type": "radio",
        "value": "0"
      },
      domProps: {
        "checked": _vm._q(section.is_enabled, "0")
      },
      on: {
        "change": function($event) {
          return _vm.$set(section, "is_enabled", "0")
        }
      }
    }), _vm._v("\n                                  關閉\n                                ")])])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      },
      style: (_vm.show_section_overlap ? 'vertical-align: middle' : '')
    }, [_c('div', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.rule_section_list, sIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)])])])])]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-bottom": "1em",
      "margin-top": "2em"
    }
  }, [_vm._v("\n              週期設定\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addWeekSetting
    }
  }, [_vm._v("新增週期設定")])]), _vm._v(" "), _c('div', {
    staticClass: "box-table",
    staticStyle: {
      "height": "500px",
      "min-height": "300px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 p-x-0 position-relative",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('table', {
    staticClass: "table table-striped dataTable",
    class: _vm.show_section_overlap ? 'table-borderless' : 'table-bordered'
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.rule_week_list), function(item, index) {
    return _c('tr', {
      key: item.id,
      class: {
        'overlap': item.show_overlap
      }
    }, [_c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.delivery_type),
        expression: "item.delivery_type"
      }],
      staticClass: "form-control min-w p-0",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "delivery_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "0"
      }
    }, [_vm._v("不限")]), _vm._v(" "), _vm._l((_vm.storedeliveryInfo), function(main) {
      return _c('option', {
        domProps: {
          "value": main.value
        }
      }, [_vm._v("\n                              " + _vm._s(main.label) + "\n                            ")])
    })], 2)]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.rule_day),
        expression: "item.rule_day"
      }],
      staticClass: "form-control min-w p-0",
      style: (item.rule_day === '' ? 'color: rgb(149,149,149)' : ''),
      attrs: {
        "required": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "rule_day", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "value": "",
        "selected": ""
      }
    }, [_vm._v("星期")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v("週日")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "2"
      }
    }, [_vm._v("週一")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "3"
      }
    }, [_vm._v("週二")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "4"
      }
    }, [_vm._v("週三")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "5"
      }
    }, [_vm._v("週四")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "6"
      }
    }, [_vm._v("週五")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "7"
      }
    }, [_vm._v("週六")])])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.rule_start_time),
        expression: "item.rule_start_time"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "time"
      },
      domProps: {
        "value": (item.rule_start_time)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "rule_start_time", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.rule_end_time),
        expression: "item.rule_end_time"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "time"
      },
      domProps: {
        "value": (item.rule_end_time)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "rule_end_time", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.src_type),
        expression: "item.src_type"
      }],
      staticClass: "form-control min-w p-0",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "src_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v("訂單")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "2"
      }
    }, [_vm._v("份數")])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.amount),
        expression: "item.amount"
      }],
      staticStyle: {
        "max-width": "86px",
        "height": "34px",
        "border": "1px solid #d2d6de",
        "border-radius": "0px 3px 3px 0px",
        "padding-left": "4px"
      },
      attrs: {
        "type": "number",
        "min": "1"
      },
      domProps: {
        "value": (item.amount)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "amount", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "vertical-align": "middle",
        "min-width": "100px"
      }
    }, [_c('div', {
      staticClass: "text-left"
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.is_enabled),
        expression: "item.is_enabled"
      }],
      attrs: {
        "type": "radio",
        "value": "1"
      },
      domProps: {
        "checked": _vm._q(item.is_enabled, "1")
      },
      on: {
        "change": function($event) {
          return _vm.$set(item, "is_enabled", "1")
        }
      }
    }), _vm._v(" 開啟")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block",
      staticStyle: {
        "margin-top": "0px"
      }
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.is_enabled),
        expression: "item.is_enabled"
      }],
      attrs: {
        "type": "radio",
        "value": "0"
      },
      domProps: {
        "checked": _vm._q(item.is_enabled, "0")
      },
      on: {
        "change": function($event) {
          return _vm.$set(item, "is_enabled", "0")
        }
      }
    }), _vm._v(" 關閉")])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.rule_week_list, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-fail text-black",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n            返回\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    domProps: {
      "textContent": _vm._s(_vm.checkSettingText)
    },
    on: {
      "click": function($event) {
        return _vm.checkSetting()
      }
    }
  })])])])]), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    class: [{
      'in show': _vm.checkedFormModal
    }],
    attrs: {
      "option": _vm.checkedFormModalOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-left m-b-15"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("若限量條件重複，會以滿足條件的最小值為主。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "min-width": "138px",
      "text-align": "left"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("品牌\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "min-width": "138px",
      "text-align": "left"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("門市\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary position-sticky"
  }, [_c('tr', [_c('td', [_vm._v("取貨方式")]), _vm._v(" "), _c('td', [_vm._v("指定區間")]), _vm._v(" "), _c('td', [_vm._v("開始時間")]), _vm._v(" "), _c('td', [_vm._v("結束時間")]), _vm._v(" "), _c('td', [_vm._v("限量單位")]), _vm._v(" "), _c('td', [_vm._v("數量上限")]), _vm._v(" "), _c('td', [_vm._v("開啟狀態")]), _vm._v(" "), _c('td', [_vm._v("操作")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary position-sticky"
  }, [_c('tr', [_c('td', [_vm._v("取貨方式")]), _vm._v(" "), _c('td', [_vm._v("指定區間")]), _vm._v(" "), _c('td', [_vm._v("開始時間")]), _vm._v(" "), _c('td', [_vm._v("結束時間")]), _vm._v(" "), _c('td', [_vm._v("限量單位")]), _vm._v(" "), _c('td', [_vm._v("數量上限")]), _vm._v(" "), _c('td', [_vm._v("開啟狀態")]), _vm._v(" "), _c('td', [_vm._v("操作")])])])
}]}

/***/ }),
/* 2436 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [(!_vm.isChart) ? _c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      'active': _vm.scheduleMethod == 1
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.scheduleMethod = 1
      }
    }
  }, [_c('a', [_vm._v("行銷列表\n              ")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.scheduleMethod == 2
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.scheduleMethod = 2
      }
    }
  }, [_c('a', [_vm._v("活動列表\n              ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row form-inline m-b-10"
  }, [_c('div', {
    staticClass: "col-sm-12 text-left"
  }, [(_vm.scheduleMethod === 1 && !_vm.isChart) ? _c('div', {
    staticClass: "from-group inline-block pull-left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/crMarketing'
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title h-38"
  }, [_vm._v("新增行銷")])])], 1) : _vm._e(), _vm._v(" "), (_vm.brandBrief.length > 1 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "inline-block from-group pull-left ",
    class: {
      'm-l-5': _vm.scheduleMethod === 1
    },
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "label": "label",
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "品牌",
      "show-labels": false,
      "preselect-first": true
    },
    on: {
      "input": _vm.changeBrand
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.brandSelect !== 0 && _vm.brandSelect !== '0' && _vm.storeBrief.length > 1) ? _c('div', {
    staticClass: "inline-block from-group pull-left m-l-5",
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.storeBrief,
      "label": "label",
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "門市",
      "show-labels": false,
      "preselect-first": true
    },
    on: {
      "input": _vm.changeSelect
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row form-inline"
  }, [_c('div', {
    staticClass: "col-sm-12 text-left"
  }, [_c('div', {
    staticClass: "inline-block from-group pull-left",
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.statusList,
      "label": "label",
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "行銷狀態",
      "show-labels": false,
      "preselect-first": true
    },
    on: {
      "input": _vm.changeSelect
    },
    model: {
      value: (_vm.statusSelect),
      callback: function($$v) {
        _vm.statusSelect = $$v
      },
      expression: "statusSelect"
    }
  })], 1), _vm._v(" "), (_vm.roleType === 99 || _vm.roleType === 30) ? _c('div', {
    staticClass: "inline-block from-group pull-left m-l-5",
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.timeMethodList,
      "label": "label",
      "searchable": false,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "行銷時間狀態",
      "show-labels": false,
      "preselect-first": true
    },
    on: {
      "input": _vm.changeSelect
    },
    model: {
      value: (_vm.timeMethodSelect),
      callback: function($$v) {
        _vm.timeMethodSelect = $$v
      },
      expression: "timeMethodSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.roleType === 99 || _vm.roleType === 30) && !_vm.isChart) ? _c('div', {
    staticClass: "inline-block from-group m-l-5",
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('multiselect', {
    staticClass: "pull-left",
    staticStyle: {
      "min-width": "160px",
      "width": "auto"
    },
    attrs: {
      "options": _vm.ownerTypeList,
      "label": "label",
      "searchable": false,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "舉辦者",
      "show-labels": false,
      "preselect-first": true
    },
    on: {
      "input": _vm.changeSelect
    },
    model: {
      value: (_vm.ownerTypeSelect),
      callback: function($$v) {
        _vm.ownerTypeSelect = $$v
      },
      expression: "ownerTypeSelect"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), (_vm.scheduleMethod === 1) ? _c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("行銷名稱(ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("狀態")]), _vm._v(" "), (!_vm.isChart) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("備註")]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("檔期")]), _vm._v(" "), (!_vm.isChart) ? _c('th', {
    staticClass: " ",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("舉辦者")]) : _vm._e(), _vm._v(" "), (!_vm.isChart) ? _c('th') : _vm._e(), _vm._v(" "), (!_vm.isChart) ? _c('th') : _vm._e(), _vm._v(" "), (!_vm.isChart) ? _c('th') : _vm._e()])]), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(0)]) : (_vm.marketingList.length === 0) ? _c('tbody', [_vm._m(1)]) : (_vm.marketingList.length > 0) ? _c('tbody', _vm._l((_vm.marketingList), function(marketing, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [(!_vm.isChart) ? _c('router-link', {
      attrs: {
        "to": {
          path: '/marketingInfo/1/detail'
        }
      }
    }, [_vm._v("\n                    " + _vm._s(marketing.name) + " (" + _vm._s(marketing.promotion_id) + ")\n                  ")]) : _c('router-link', {
      attrs: {
        "to": {
          path: '/couponChart/' + marketing.promotion_id
        }
      }
    }, [_vm._v("\n                    " + _vm._s(marketing.name) + " (" + _vm._s(marketing.promotion_id) + ")\n                  ")])], 1), _vm._v(" "), _c('td', [(marketing.status === 0) ? _c('label', {
      staticClass: "label label-default"
    }, [_vm._v("未發佈")]) : (marketing.status === 4) ? _c('label', {
      staticClass: "label label-success"
    }, [_vm._v("已發佈")]) : _c('label', {
      staticClass: "label label-danger"
    }, [_vm._v("已下架")])]), _vm._v(" "), (!_vm.isChart) ? _c('td', [_vm._v("\n                  " + _vm._s(marketing.remark) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('td', [(marketing.time_method === 'notyet') ? _c('label', {
      staticClass: "label label-default"
    }, [_vm._v("未開始")]) : (marketing.time_method === 'going') ? _c('label', {
      staticClass: "label label-success"
    }, [_vm._v("進行中")]) : _c('label', {
      staticClass: "label label-danger"
    }, [_vm._v("已結束")]), _vm._v("\n                   " + _vm._s(_vm.getTime(marketing.start_time)) + " ~ " + _vm._s(_vm.getTime(marketing.end_time)) + "\n                ")]), _vm._v(" "), (!_vm.isChart) ? _c('td', [_vm._v(_vm._s(_vm.ownerTypeName(marketing.owner_type)))]) : _vm._e(), _vm._v(" "), (!_vm.isChart) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/activityList/' + marketing.promotion_id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-primary"
    }, [_c('i', {
      staticClass: "fa fa-volume-down",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" 活動")])])], 1) : _vm._e(), _vm._v(" "), (!_vm.isChart) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/upMarketing/' + marketing.promotion_id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])])], 1) : _vm._e(), _vm._v(" "), (!_vm.isChart) ? _c('td', [(marketing.status !== 4) ? _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "data-target": "#delModal",
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          return _vm.setMarketing(marketing.promotion_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()]) : _vm._e()])
  }), 0) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.scheduleMethod === 2) ? _c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example2"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.activityList), function(activity, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/activityInfo/' + activity.activity_id
        }
      }
    }, [_vm._v("\n                    " + _vm._s(activity.name) + " (" + _vm._s(activity.activity_id) + ")\n                  ")])], 1), _vm._v(" "), _c('td', [(activity.status === 0) ? _c('label', {
      staticClass: "label label-default"
    }, [_vm._v("初始化")]) : (activity.status === 1) ? _c('label', {
      staticClass: "label label-default"
    }, [_vm._v("編輯中")]) : (activity.status === 3) ? _c('label', {
      staticClass: "label label-default"
    }, [_vm._v("待上架")]) : (activity.status === 4) ? _c('label', {
      staticClass: "label label-success"
    }, [_vm._v("已上架")]) : _c('label', {
      staticClass: "label label-danger"
    }, [_vm._v("已下架")])]), _vm._v(" "), _c('td', [(activity.give_type === 1) ? _c('label', {
      staticClass: "label label-primary"
    }, [_vm._v("優惠券")]) : (activity.give_type === 2) ? _c('label', {
      staticClass: "label label-success"
    }, [_vm._v("點數")]) : (activity.give_type === 3) ? _c('label', {
      staticClass: "label label-warning"
    }, [_vm._v("虛擬序號")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(activity.remark) + "\n                ")]), _vm._v(" "), _c('td', [(activity.time_method === 'notyet') ? _c('label', {
      staticClass: "label label-default"
    }, [_vm._v("未開始")]) : (activity.time_method === 'going') ? _c('label', {
      staticClass: "label label-success"
    }, [_vm._v("進行中")]) : _c('label', {
      staticClass: "label label-danger"
    }, [_vm._v("已結束")]), _vm._v("\n                  " + _vm._s(_vm.getTime(activity.start_time)) + " ~ " + _vm._s(_vm.getTime(activity.end_time)) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(activity.promotion_name) + " (" + _vm._s(activity.promotion_id) + ")")]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/upActivity/1'
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-primary"
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])])], 1), _vm._v(" "), _vm._m(3, true)])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.marketingList.length !== 0) ? _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickEnd('pre')
      }
    }
  }, [_vm._m(4)]), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickGroup('left')
      }
    }
  }, [_vm._m(5)]), _vm._v(" "), _vm._l((_vm.pageAmount), function(index) {
    return (_vm.pageShow(index)) ? _c('li', {
      staticClass: "paginate_button",
      class: {
        active: _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          return _vm.clickPage(index)
        }
      }
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v(_vm._s(index))])]) : _vm._e()
  }), _vm._v(" "), _vm._l(((_vm.groupAmount - Math.ceil(_vm.pageAmount % 10))), function(dis) {
    return (_vm.pageGroup === Math.ceil(_vm.pageAmount / _vm.groupAmount)) ? _c('li', {
      staticClass: "paginate_button disabled"
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v("  ")])]) : _vm._e()
  }), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickGroup('right')
      }
    }
  }, [_vm._m(6)]), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickEnd('forward')
      }
    }
  }, [_vm._m(7)])], 2)]) : _vm._e()])])])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delMOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delAOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.removeGNowOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.saleGNowOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.removeNowOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.saleNowOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("活動名稱(ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("商品類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("備註")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("檔期")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("行銷分類 (ID)")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-target": "#delModal",
      "data-toggle": "modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-step-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-forward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-step-forward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 2437 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/crAccount'
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("新增帳號")])])], 1)]), _vm._v(" "), (_vm.selectRoleType != 'pos') ? _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "name"
    }
  }, [_vm._v("名稱")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "account"
    }
  }, [_vm._v("帳號")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchValue),
      expression: "searchValue"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.getAccountList(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      active: _vm.isType('admin')
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectRoleType = 'admin'
      }
    }
  }, [_vm._v("系統\n          ")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isType('brand')
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectRoleType = 'brand'
      }
    }
  }, [_vm._v("品牌\n          ")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isType('store')
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectRoleType = 'store'
      }
    }
  }, [_vm._v("店家\n          ")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isType('pos')
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectRoleType = 'pos'
      }
    }
  }, [_vm._v("POS\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [(_vm.managerList.length) ? _c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.managerList), function(manager, index) {
    return (_vm.showSelect(manager.role_type)) ? _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_c('span', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(manager.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(manager.account))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(manager.manager_id))]), _vm._v(" "), _c('td', [(!manager.is_suspend) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("正常")]) : _vm._e(), _vm._v(" "), (manager.is_suspend) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("停權")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(manager.create_time))]), _vm._v(" "), _c('td', [(manager.account != 'admin' && manager.account != 'matcher_admin') ? _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#delModal"
      },
      on: {
        "click": function($event) {
          return _vm.getCurrent(manager.role_type, manager.manager_id, manager.account, manager.name)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/upAccount/' + manager.role_type + '/' + manager.manager_id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])])], 1)]) : _vm._e()
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('paginate', {
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("名稱")]), _vm._v(" "), _c('th', [_vm._v("帳號")]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("權限")]), _vm._v(" "), _c('th', [_vm._v("建立時間")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
}]}

/***/ }),
/* 2438 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fade modal",
    attrs: {
      "id": _vm.option.id,
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "choose-modal modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title text-left"
  }, [_vm._v("\n          " + _vm._s(_vm.option.title) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body text-left"
  }, [_c('div', {
    staticClass: "text-left"
  }, _vm._l((_vm.productList), function(elem) {
    return (elem.active) ? _c('button', {
      staticClass: "btn btn-choose-element btn-default",
      class: {
        'active': elem.item_id === _vm.curClick
      },
      on: {
        "click": function () { return _vm.clickElement(elem); }
      }
    }, [_vm._v("\n            " + _vm._s(elem.name)), _c('span', [_vm._v("  $" + _vm._s(_vm.getPrice(elem.price)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "text-remark"
    }, [_c('small', [_vm._v(" " + _vm._s(elem.remark) + " ")])])]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', [_c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.sort),
      expression: "productInfo.sort"
    }],
    ref: "sort",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.productInfo.sort)
    },
    on: {
      "keyup": _vm.veritySort,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.productInfo, "sort", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.newPrice),
      expression: "productInfo.newPrice"
    }],
    ref: "price",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.productInfo.newPrice)
    },
    on: {
      "keyup": _vm.verityPrice,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.productInfo, "newPrice", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("必選項目")]), _vm._v(" "), _c('div', {
    staticClass: "h-38 radio text-left",
    staticStyle: {
      "border-left": "1px solid #d2d6de"
    }
  }, [_c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.is_mandatory),
      expression: "productInfo.is_mandatory"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "productInfoMandatoryRadio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.productInfo.is_mandatory, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.productInfo, "is_mandatory", 1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("是")])]), _vm._v(" "), _c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.is_mandatory),
      expression: "productInfo.is_mandatory"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "productInfoMandatoryRadio"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.productInfo.is_mandatory, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.productInfo, "is_mandatory", 0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("否")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("預設選取")]), _vm._v(" "), _c('div', {
    staticClass: "h-38 radio text-left",
    staticStyle: {
      "border-left": "1px solid #d2d6de"
    }
  }, [_c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.is_default),
      expression: "productInfo.is_default"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "defaultRadio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.productInfo.is_default, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.productInfo, "is_default", 1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("是")])]), _vm._v(" "), _c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.is_default),
      expression: "productInfo.is_default"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "defaultRadio"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.productInfo.is_default, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.productInfo, "is_default", 0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("否")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("選購數量")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.min_limit),
      expression: "productInfo.min_limit"
    }],
    ref: "minLimit",
    staticClass: "c-auto form-control",
    staticStyle: {
      "width": "calc(50% - 10px)"
    },
    attrs: {
      "placeholder": "0為無上限",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.productInfo.min_limit)
    },
    on: {
      "keyup": _vm.verityMinLimit,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.productInfo, "min_limit", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "line-height": "38px",
      "width": "20px"
    }
  }, [_vm._v("~")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.max_limit),
      expression: "productInfo.max_limit"
    }],
    ref: "maxLimit",
    staticClass: "c-auto form-control",
    staticStyle: {
      "width": "calc(50% - 10px)"
    },
    attrs: {
      "placeholder": "0為無上限",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.productInfo.max_limit)
    },
    on: {
      "keyup": _vm.verityMaxLimit,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.productInfo, "max_limit", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.trigger(_vm.option.event)
      }
    }
  }, [_vm._v("\n          確定\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("排"), _c('div', {
    staticClass: "inline-block w-35"
  }), _vm._v("序")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("價"), _c('div', {
    staticClass: "inline-block w-35"
  }), _vm._v("格")])
}]}

/***/ }),
/* 2439 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-10 flex align-center"
  }, [_c('div', {
    staticClass: "flex grey darken-1"
  }, [(_vm.storeInfo.brand_name || _vm.storeInfo.name_short) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s(_vm.storeInfo.brand_name ? _vm.storeInfo.brand_name : _vm.storeInfo.name_short ? _vm.store.brand_name : '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.storeInfo.name_short) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s('/')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.storeInfo.name_short) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.storeInfo.name_short)
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('store-form', {
    attrs: {
      "info": _vm.info
    },
    on: {
      "update:store-info": _vm.updateStoreInfo
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2440 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('choose-store-modal', {
    attrs: {
      "option": _vm.storeOption,
      "tooltip": "此操作將會覆蓋該門市原有的設定內容"
    },
    on: {
      "copyStore": _vm.copyStore
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delExceptionOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box text-center"
  }, [(_vm.storeInfo.brand_name) ? _c('h1', {
    staticStyle: {
      "position": "absolute",
      "top": "-74px",
      "left": "165px",
      "font-size": "18px"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.storeInfo.brand_name) + " - " + _vm._s(_vm.storeInfo.name_short) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    class: {
      'active': _vm.storeMethod == 1
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(1)
      }
    }
  }, [_c('a', {
    class: {
      'cursor-none': _vm.$route.name === 'crStore'
    }
  }, [_vm._v("基本資訊")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 2
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(2)
      }
    }
  }, [_c('a', {
    class: {
      'cursor-none': _vm.$route.name === 'crStore'
    }
  }, [_vm._v("細部設定")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 3
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(3)
      }
    }
  }, [_c('a', {
    class: {
      'cursor-none': _vm.$route.name === 'crStore'
    }
  }, [_vm._v("預訂/訂購時間")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 4
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(4)
      }
    }
  }, [_c('a', {
    class: {
      'cursor-none': _vm.$route.name === 'crStore'
    }
  }, [_vm._v("付款方式")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 5
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(5)
      }
    }
  }, [_c('a', {
    class: {
      'cursor-none': _vm.$route.name === 'crStore'
    }
  }, [_vm._v("製作/取餐時間")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 6
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(6)
      }
    }
  }, [_c('a', {
    class: {
      'cursor-none': _vm.$route.name === 'crStore'
    }
  }, [_vm._v("取餐方式/門檻")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 7
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(7)
      }
    }
  }, [_c('a', {
    class: {
      'cursor-none': _vm.$route.name === 'crStore'
    }
  }, [_vm._v("營業/公休時間")])]), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30 || _vm.getRoleType === 10) ? _c('li', {
    class: {
      'active': _vm.storeMethod == 8
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(8)
      }
    }
  }, [_c('a', {
    class: {
      'cursor-none': _vm.$route.name === 'crStore'
    }
  }, [_vm._v("塑膠袋")])]) : _vm._e(), _vm._v(" "), (_vm.info && _vm.getRoleType === 99) ? _c('li', {
    class: {
      'active': _vm.storeMethod == 10
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(10)
      }
    }
  }, [_c('a', {
    class: {
      'cursor-none': _vm.$route.name === 'crStore'
    }
  }, [_vm._v("出單機")])]) : _vm._e(), _vm._v(" "), (_vm.$route.name !== 'crStore') ? _c('li', {
    class: {
      'active': _vm.storeMethod == 11
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(11)
      }
    }
  }, [_c('a', {
    class: {
      'cursor-none': _vm.$route.name === 'crStore'
    }
  }, [_vm._v("網址設定")])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 && _vm.hasCommissionPermission) ? _c('li', {
    class: {
      'active': _vm.storeMethod == 12
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(12)
      }
    }
  }, [_c('a', {
    class: {
      'cursor-none': _vm.$route.name === 'crStore'
    }
  }, [_vm._v("計費方式設定")])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('li', {
    class: {
      'active': _vm.storeMethod == 13
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 13
      }
    }
  }, [_c('a', {
    class: {
      'cursor-none': _vm.$route.name === 'crStore'
    }
  }, [_vm._v("物流設定")])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('li', {
    class: {
      'active': _vm.storeMethod == 14
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(14)
      }
    }
  }, [_c('a', {
    class: {
      'cursor-none': _vm.$route.name === 'crStore'
    }
  }, [_vm._v("服務費設定")])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30 || _vm.getRoleType === 10) ? _c('li', {
    class: {
      'active': _vm.storeMethod == 15
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 15
      }
    }
  }, [_c('a', [_vm._v("特殊需求")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 1),
      expression: "storeMethod === 1"
    }],
    staticClass: "box-body form"
  }, [(_vm.getRoleType === 99) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.name),
      expression: "storeInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.storeInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.name_short),
      expression: "storeInfo.name_short"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.storeInfo.name_short)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "name_short", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.$route.name !== 'upStore') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.groupSelect),
      expression: "groupSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.groupSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.groupList), function(group, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": group.id
      }
    }, [_vm._v("\n                  " + _vm._s(group.name) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              城市\n              "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                  如有開通米特物流服務，修改地址後請同步通知米特物流窗口。\n                ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.citySelect),
      expression: "citySelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.citySelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.cityOption), function(city, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": city.value
      }
    }, [_vm._v("\n                  " + _vm._s(city.name) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              區域\n              "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                  如有開通米特物流服務，修改地址後請同步通知米特物流窗口。\n                ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.areaSelect),
      expression: "areaSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.areaSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.areaOption), function(area, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": area.value
      }
    }, [_vm._v("\n                  " + _vm._s(area.name) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              地址\n              "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                  如有開通米特物流服務，修改地址後請同步通知米特物流窗口。\n                ")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.address_short),
      expression: "storeInfo.address_short"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "120"
    },
    domProps: {
      "value": (_vm.storeInfo.address_short)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "address_short", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              地址備註\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.address_remark),
      expression: "storeInfo.address_remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.storeInfo.address_remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "address_remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.tel),
      expression: "storeInfo.tel"
    }],
    ref: "tel",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "15"
    },
    domProps: {
      "value": (_vm.storeInfo.tel)
    },
    on: {
      "keyup": _vm.verityTel,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "tel", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              電話2\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.tel2),
      expression: "storeInfo.tel2"
    }],
    ref: "tel2",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "15"
    },
    domProps: {
      "value": (_vm.storeInfo.tel2)
    },
    on: {
      "keyup": _vm.verityTel2,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "tel2", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              電子信箱\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.email),
      expression: "storeInfo.email"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.storeInfo.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              描述\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.description),
      expression: "storeInfo.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.storeInfo.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              描述(搜尋引擎顯示)\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.search_description),
      expression: "storeInfo.search_description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.storeInfo.search_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "search_description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              品牌頁介紹\n            ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.introduction),
      expression: "storeInfo.introduction"
    }],
    staticClass: "w-100-p form-control",
    attrs: {
      "name": "introduction",
      "cols": "30",
      "rows": "10",
      "maxlength": "65535"
    },
    domProps: {
      "value": (_vm.storeInfo.introduction)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "introduction", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              Youtube影片代碼\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.youtube_video_code),
      expression: "storeInfo.youtube_video_code"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.storeInfo.youtube_video_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "youtube_video_code", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              店家公告\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.comment),
      expression: "storeInfo.comment"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.storeInfo.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "comment", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              統一編號\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.ein),
      expression: "storeInfo.ein"
    }],
    ref: "ein",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "8"
    },
    domProps: {
      "value": (_vm.storeInfo.ein)
    },
    on: {
      "keyup": _vm.verityEin,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "ein", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              抬頭\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.bl_name),
      expression: "storeInfo.bl_name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.storeInfo.bl_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "bl_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              食品業者登錄字號\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.food_business_no),
      expression: "storeInfo.food_business_no"
    }],
    ref: "foodBusinessNo",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "19",
      "placeholder": "範例：F-123456789-00000-0"
    },
    domProps: {
      "value": (_vm.storeInfo.food_business_no)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "food_business_no", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              肉品產地說明\n            ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.meat_origin_description),
      expression: "storeInfo.meat_origin_description"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "maxlength": "500",
      "placeholder": "範例：本店牛肉來源－澳洲 / 豬肉來源－台灣"
    },
    domProps: {
      "value": (_vm.storeInfo.meat_origin_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "meat_origin_description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              LOGO\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0 bg-white",
    staticStyle: {
      "border-right": "none"
    }
  }, [_c('span', {
    staticClass: "inline-block h-auto m-t-5"
  }, [(!_vm.storeInfo.image_name) ? _c('div', {
    staticClass: "text-black",
    domProps: {
      "textContent": _vm._s('沒有圖片')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.storeInfo.image_name) ? _c('img', {
    staticClass: "h-auto img-responsive",
    attrs: {
      "src": _vm.storeInfo.image_name,
      "data-toggle": "modal"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [(_vm.imgLogoOption.length) ? _c('div', {
    staticClass: "pull-left"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imgLogoSelect),
      expression: "imgLogoSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.imgLogoSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.imgLogoOption), function(img, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": img.name
      }
    }, [_vm._v("\n                    " + _vm._s(img.name) + "\n                  ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pull-left"
  }, [_c('label', {
    staticClass: "btn-upload btn btn-default",
    class: {
      'm-t-25': !_vm.imgLogoOption.length
    },
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "for": "brand-img-load"
    }
  }, [_vm._v("\n                  選擇圖片\n                ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "brand-img-load"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])])])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              底圖照片\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0 bg-white",
    staticStyle: {
      "border-right": "none"
    }
  }, [_c('span', {
    staticClass: "inline-block h-auto m-t-5"
  }, [(!_vm.storeInfo.photo_name) ? _c('div', {
    staticClass: "text-black",
    domProps: {
      "textContent": _vm._s('沒有圖片')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.storeInfo.photo_name) ? _c('img', {
    staticClass: "h-auto img-responsive",
    attrs: {
      "src": _vm.storeInfo.photo_name,
      "data-toggle": "modal"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [_c('label', {
    staticClass: "btn-upload btn btn-default",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "for": "brand-photo-load"
    }
  }, [_vm._v("\n                選擇圖片\n              ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "brand-photo-load"
    },
    on: {
      "change": _vm.onPhotoFileChange
    }
  })])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              餐點種類\n            ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "tag-placeholder": "餐點種類",
      "placeholder": "餐點種類",
      "label": "label",
      "track-by": "value",
      "options": _vm.mealTagList,
      "multiple": true
    },
    model: {
      value: (_vm.storeInfo.binding_meal_tag_ids),
      callback: function($$v) {
        _vm.$set(_vm.storeInfo, "binding_meal_tag_ids", $$v)
      },
      expression: "storeInfo.binding_meal_tag_ids"
    }
  })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              品牌下店家代碼\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.branch_code),
      expression: "storeInfo.branch_code"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.storeInfo.branch_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "branch_code", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              POS店家代碼\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.pos_branch_code),
      expression: "storeInfo.pos_branch_code"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.storeInfo.pos_branch_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "pos_branch_code", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 10 || _vm.getRoleType === 30) ? _c('div', [_vm._m(7), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              店家公告\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.comment),
      expression: "storeInfo.comment"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.storeInfo.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "comment", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              城市\n              "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                  如有開通米特物流服務，修改地址後請同步通知米特物流窗口。\n                ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.citySelect),
      expression: "citySelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.citySelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.cityOption), function(city, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": city.value
      }
    }, [_vm._v("\n                  " + _vm._s(city.name) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              區域\n              "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                  如有開通米特物流服務，修改地址後請同步通知米特物流窗口。\n                ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.areaSelect),
      expression: "areaSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.areaSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.areaOption), function(area, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": area.value
      }
    }, [_vm._v("\n                  " + _vm._s(area.name) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              地址\n              "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                  如有開通米特物流服務，修改地址後請同步通知米特物流窗口。\n                ")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.address_short),
      expression: "storeInfo.address_short"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "120"
    },
    domProps: {
      "value": (_vm.storeInfo.address_short)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "address_short", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              地址備註\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.address_remark),
      expression: "storeInfo.address_remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.storeInfo.address_remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "address_remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.tel),
      expression: "storeInfo.tel"
    }],
    ref: "tel",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "15"
    },
    domProps: {
      "value": (_vm.storeInfo.tel)
    },
    on: {
      "keyup": _vm.verityTel,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "tel", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              電話2\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.tel2),
      expression: "storeInfo.tel2"
    }],
    ref: "tel2",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "15"
    },
    domProps: {
      "value": (_vm.storeInfo.tel2)
    },
    on: {
      "keyup": _vm.verityTel2,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "tel2", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              描述\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.description),
      expression: "storeInfo.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.storeInfo.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              描述(搜尋引擎顯示)\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.search_description),
      expression: "storeInfo.search_description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.storeInfo.search_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "search_description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              品牌頁介紹\n            ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.introduction),
      expression: "storeInfo.introduction"
    }],
    staticClass: "w-100-p form-control",
    attrs: {
      "name": "introduction",
      "cols": "30",
      "rows": "10",
      "maxlength": "65535"
    },
    domProps: {
      "value": (_vm.storeInfo.introduction)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "introduction", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              Youtube影片代碼\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.youtube_video_code),
      expression: "storeInfo.youtube_video_code"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.storeInfo.youtube_video_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "youtube_video_code", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              食品業者登錄字號\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.food_business_no),
      expression: "storeInfo.food_business_no"
    }],
    ref: "foodBusinessNo",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "19",
      "placeholder": "範例：F-123456789-00000-0"
    },
    domProps: {
      "value": (_vm.storeInfo.food_business_no)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "food_business_no", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              肉品產地說明\n            ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.meat_origin_description),
      expression: "storeInfo.meat_origin_description"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "2",
      "maxlength": "500",
      "placeholder": "範例：本店牛肉來源－澳洲 / 豬肉來源－台灣"
    },
    domProps: {
      "value": (_vm.storeInfo.meat_origin_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "meat_origin_description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              LOGO\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0 bg-white",
    staticStyle: {
      "border-right": "none"
    }
  }, [_c('span', {
    staticClass: "inline-block h-auto m-t-5"
  }, [(!_vm.storeInfo.image_name) ? _c('div', {
    staticClass: "text-black",
    domProps: {
      "textContent": _vm._s('沒有圖片')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.storeInfo.image_name) ? _c('img', {
    staticClass: "h-auto img-responsive",
    attrs: {
      "src": _vm.storeInfo.image_name,
      "data-toggle": "modal"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [(_vm.imgLogoOption.length) ? _c('div', {
    staticClass: "pull-left"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imgLogoSelect),
      expression: "imgLogoSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.imgLogoSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.imgLogoOption), function(img, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": img.name
      }
    }, [_vm._v("\n                    " + _vm._s(img.name) + "\n                  ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pull-left"
  }, [_c('label', {
    staticClass: "btn-upload btn btn-default",
    class: {
      'm-t-25': !_vm.imgLogoOption.length
    },
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "for": "brand-img-load"
    }
  }, [_vm._v("\n                  選擇圖片\n                ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "brand-img-load"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])])])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              底圖照片\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0 bg-white",
    staticStyle: {
      "border-right": "none"
    }
  }, [_c('span', {
    staticClass: "inline-block h-auto m-t-5"
  }, [(!_vm.storeInfo.photo_name) ? _c('div', {
    staticClass: "text-black",
    domProps: {
      "textContent": _vm._s('沒有圖片')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.storeInfo.photo_name) ? _c('img', {
    staticClass: "h-auto img-responsive",
    attrs: {
      "src": _vm.storeInfo.photo_name,
      "data-toggle": "modal"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [_c('label', {
    staticClass: "btn-upload btn btn-default",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "for": "brand-photo-load"
    }
  }, [_vm._v("\n                選擇圖片\n              ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "brand-photo-load"
    },
    on: {
      "change": _vm.onPhotoFileChange
    }
  })])])]), _vm._v(" "), _vm._m(10)]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 2),
      expression: "storeMethod === 2"
    }],
    staticClass: "box-body form"
  }, [_c('div', [(_vm.getRoleType !== 10) ? _c('div', [_c('h3', [_vm._v("細部設定")]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.apiTypeSelect),
      expression: "apiTypeSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.apiTypeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("專屬客製POS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("公版POS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("平板接單")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              門市類型\n              "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                  若尚未設定門市類型，將會影響加盟/直營對帳的計費功能\n                ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeTypeSelect),
      expression: "storeTypeSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.storeTypeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未分類")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("直營")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("加盟")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelect),
      expression: "statusSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.statusSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("尚未營業")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("籌備中")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("營業中(上架)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("休息中")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("已歇業")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.disModeSelect),
      expression: "disModeSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.disModeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("走路模式(WALKING)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("開車模式(DRIVING)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "13"
    }
  }, [_vm._v("機車(SCOOTER)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14"
    }
  }, [_vm._v("大眾運輸(TRANSIT)")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.barcodeSelect),
      expression: "barcodeSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.barcodeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("不支援")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("一維條碼")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("二維條碼(QRcode)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("一維、二維都支援")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.roundingTypeSelect),
      expression: "roundingTypeSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.roundingTypeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("無條件進位")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("無條件捨去")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("四捨五入")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("保留小數點")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.couponFormSelect),
      expression: "couponFormSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.couponFormSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("依付款方式使用優惠券")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("依虛擬商品使用優惠券")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showProdSettingSelect),
      expression: "showProdSettingSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.showProdSettingSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("別名跟描述不顯示")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("別名跟描述都顯示")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("只顯示別名")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("只顯示描述")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isInvoiceException),
      expression: "isInvoiceException"
    }],
    attrs: {
      "type": "radio",
      "name": "invoiceException",
      "disabled": !_vm.hasInvoiceSelected
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.isInvoiceException, 0)
    },
    on: {
      "change": function($event) {
        _vm.isInvoiceException = 0
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'radio-text--disabled': !_vm.hasInvoiceSelected
    }
  }, [_vm._v("\n                    開發票\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isInvoiceException),
      expression: "isInvoiceException"
    }],
    attrs: {
      "type": "radio",
      "name": "invoiceException",
      "disabled": _vm.hasInvoiceSelected
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.isInvoiceException, 1)
    },
    on: {
      "change": function($event) {
        _vm.isInvoiceException = 1
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'radio-text--disabled': _vm.hasInvoiceSelected
    }
  }, [_vm._v("\n                    免開發票\n                  ")])])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasInvoicePaperSelect),
      expression: "hasInvoicePaperSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "invoicePaperOption"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.hasInvoicePaperSelect, 1)
    },
    on: {
      "change": function($event) {
        _vm.hasInvoicePaperSelect = 1
      }
    }
  }), _vm._v("開放\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasInvoicePaperSelect),
      expression: "hasInvoicePaperSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "invoicePaperOption"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.hasInvoicePaperSelect, 0)
    },
    on: {
      "change": function($event) {
        _vm.hasInvoicePaperSelect = 0
      }
    }
  }), _vm._v("停用\n                ")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasInvoiceCarrierSelect),
      expression: "hasInvoiceCarrierSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "invoiceOption"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.hasInvoiceCarrierSelect, 1)
    },
    on: {
      "change": function($event) {
        _vm.hasInvoiceCarrierSelect = 1
      }
    }
  }), _vm._v("\n                  開放 (請確認POS端是否支援此功能)\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasInvoiceCarrierSelect),
      expression: "hasInvoiceCarrierSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "invoiceOption"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.hasInvoiceCarrierSelect, 0)
    },
    on: {
      "change": function($event) {
        _vm.hasInvoiceCarrierSelect = 0
      }
    }
  }), _vm._v("\n                  停用\n                ")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.hasInvoiceCarrierSelect) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              開放愛心捐贈發票\n              "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                  門市接單APP暫不支援\n                ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasInvoiceNpobnaSelect),
      expression: "hasInvoiceNpobnaSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "invoiceNpobnaOption",
      "disabled": !_vm.hasInvoiceCarrierSelect
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.hasInvoiceNpobnaSelect, 1)
    },
    on: {
      "change": function($event) {
        _vm.hasInvoiceNpobnaSelect = 1
      }
    }
  }), _vm._v("開放\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasInvoiceNpobnaSelect),
      expression: "hasInvoiceNpobnaSelect"
    }],
    attrs: {
      "type": "radio",
      "disabled": true,
      "name": "invoiceNpobnaOption"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.hasInvoiceNpobnaSelect, 0)
    },
    on: {
      "change": function($event) {
        _vm.hasInvoiceNpobnaSelect = 0
      }
    }
  }), _vm._v("停用\n                ")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              發票備註\n            ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceRemark),
      expression: "invoiceRemark"
    }],
    staticClass: "w-100-p form-control",
    attrs: {
      "name": "invoiceRemark",
      "cols": "30",
      "rows": "3",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.invoiceRemark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.invoiceRemark = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.invoiceRemark ? _vm.invoiceRemark.length : 0) + "/100")]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isVisibleSelect),
      expression: "isVisibleSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "showOption",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.isVisibleSelect, "1")
    },
    on: {
      "change": function($event) {
        _vm.isVisibleSelect = "1"
      }
    }
  }), _vm._v("顯示\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isVisibleSelect),
      expression: "isVisibleSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "showOption",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.isVisibleSelect, "0")
    },
    on: {
      "change": function($event) {
        _vm.isVisibleSelect = "0"
      }
    }
  }), _vm._v("隱藏\n                  ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isSearchSelect),
      expression: "isSearchSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "searchOption",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.isSearchSelect, "1")
    },
    on: {
      "change": function($event) {
        _vm.isSearchSelect = "1"
      }
    }
  }), _vm._v("是\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isSearchSelect),
      expression: "isSearchSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "searchOption",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.isSearchSelect, "0")
    },
    on: {
      "change": function($event) {
        _vm.isSearchSelect = "0"
      }
    }
  }), _vm._v("否\n                  ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isStickerSelect),
      expression: "isStickerSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "stickerOption"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.isStickerSelect, 1)
    },
    on: {
      "change": function($event) {
        _vm.isStickerSelect = 1
      }
    }
  }), _vm._v("支援 (請確認POS端是否支援此功能)\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isStickerSelect),
      expression: "isStickerSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "stickerOption"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.isStickerSelect, 0)
    },
    on: {
      "change": function($event) {
        _vm.isStickerSelect = 0
      }
    }
  }), _vm._v("不支援\n                  ")])])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(24), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number.lazy.trim",
      value: (_vm.storeInfo.custom_sticker_max_length),
      expression: "storeInfo.custom_sticker_max_length",
      modifiers: {
        "number": true,
        "lazy": true,
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "僅可輸入數字",
      "type": "number",
      "min": "1",
      "max": "10"
    },
    domProps: {
      "value": (_vm.storeInfo.custom_sticker_max_length)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.storeInfo, "custom_sticker_max_length", _vm._n($event.target.value.trim()))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("強制阻擋外送門檻")]), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                若選擇強制阻擋外送門檻，消費者訂購時必須符合「取餐方式/門檻-消費金額與距離門檻」的設定才可下單。注意 : 無論是否強制阻擋外送門檻，外送訂單均須符合最低金額門檻才可下單。\n              ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.delivery_stage_limit_type),
      expression: "storeInfo.delivery_stage_limit_type"
    }],
    attrs: {
      "type": "radio",
      "name": "deliveryStageLimit"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.delivery_stage_limit_type, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "delivery_stage_limit_type", 1)
      }
    }
  }), _vm._v("不強制\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.delivery_stage_limit_type),
      expression: "storeInfo.delivery_stage_limit_type"
    }],
    attrs: {
      "type": "radio",
      "name": "deliveryStageLimit"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.storeInfo.delivery_stage_limit_type, 2)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "delivery_stage_limit_type", 2)
      }
    }
  }), _vm._v("強制\n                ")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(25), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_support_custom_remark),
      expression: "storeInfo.is_support_custom_remark"
    }],
    attrs: {
      "type": "radio",
      "name": "customRemark"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.is_support_custom_remark, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_support_custom_remark", 1)
      }
    }
  }), _vm._v("開啟 (請確認POS端是否支援此功能)\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_support_custom_remark),
      expression: "storeInfo.is_support_custom_remark"
    }],
    attrs: {
      "type": "radio",
      "name": "customRemark"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.is_support_custom_remark, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_support_custom_remark", 0)
      }
    }
  }), _vm._v("停用\n                ")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            網址跳轉設定\n          ")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.urlRedirection.stores,
      "tag-placeholder": "選擇網址跳轉門市",
      "placeholder": "選擇網址跳轉門市",
      "label": "name",
      "track-by": "store_id",
      "max": 1,
      "multiple": true,
      "allow-empty": true
    },
    model: {
      value: (_vm.urlRedirection.new_store_info),
      callback: function($$v) {
        _vm.$set(_vm.urlRedirection, "new_store_info", $$v)
      },
      expression: "urlRedirection.new_store_info"
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 && _vm.membershipGroupType === 2) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(26), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.membership_provider_parent_id),
      expression: "storeInfo.membership_provider_parent_id"
    }],
    attrs: {
      "type": "radio",
      "name": "providerId"
    },
    domProps: {
      "value": _vm.providerId,
      "checked": _vm._q(_vm.storeInfo.membership_provider_parent_id, _vm.providerId)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "membership_provider_parent_id", _vm.providerId)
      }
    }
  }), _vm._v("是\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.membership_provider_parent_id),
      expression: "storeInfo.membership_provider_parent_id"
    }],
    attrs: {
      "type": "radio",
      "name": "providerId"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.membership_provider_parent_id, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "membership_provider_parent_id", 0)
      }
    }
  }), _vm._v("否\n                ")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('br'), _vm._v(" "), _c('h3', [_vm._v("門市下訂金額限制")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(27), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.one_order_max_money),
      expression: "storeInfo.one_order_max_money"
    }],
    ref: "oneOrderMaxMoney",
    staticClass: "form-control",
    attrs: {
      "placeholder": "單筆訂單最高上限",
      "type": "text",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.storeInfo.one_order_max_money)
    },
    on: {
      "keyup": _vm.verityOneOrderMaxMoney,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "one_order_max_money", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('h3', [_vm._v("菜單設定")]), _vm._v(" "), (_vm.getRoleType === 30) ? _c('br') : _vm._e(), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "text-left mb-3"
  }, [_vm._v("菜單呈現")]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(28), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_layout_type),
      expression: "storeInfo.menu_layout_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.storeInfo, "menu_layout_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.menuLayout), function(layout) {
    return _c('option', {
      key: layout.value,
      domProps: {
        "value": layout.value
      }
    }, [_vm._v("\n                    " + _vm._s(layout.label) + "\n                  ")])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(29), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showMenuIconSelect),
      expression: "showMenuIconSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "iconOption",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.showMenuIconSelect, "0")
    },
    on: {
      "change": function($event) {
        _vm.showMenuIconSelect = "0"
      }
    }
  }), _vm._v("全部顯示\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showMenuIconSelect),
      expression: "showMenuIconSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "iconOption",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.showMenuIconSelect, "1")
    },
    on: {
      "change": function($event) {
        _vm.showMenuIconSelect = "1"
      }
    }
  }), _vm._v("無溫度顯示冷\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showMenuIconSelect),
      expression: "showMenuIconSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "iconOption",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.showMenuIconSelect, "2")
    },
    on: {
      "change": function($event) {
        _vm.showMenuIconSelect = "2"
      }
    }
  }), _vm._v("皆顯示無溫度\n                    ")])])])])]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(30), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.show_menu_product_icon),
      expression: "storeInfo.show_menu_product_icon"
    }],
    attrs: {
      "type": "radio",
      "name": "prodIconOption"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.show_menu_product_icon, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "show_menu_product_icon", 1)
      }
    }
  }), _vm._v("顯示\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.show_menu_product_icon),
      expression: "storeInfo.show_menu_product_icon"
    }],
    attrs: {
      "type": "radio",
      "name": "prodIconOption"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.show_menu_product_icon, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "show_menu_product_icon", 0)
      }
    }
  }), _vm._v("隱藏\n                    ")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(31), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_expand_type),
      expression: "storeInfo.menu_expand_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menuExpandType"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.menu_expand_type, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_expand_type", 1)
      }
    }
  }), _vm._v("隱藏\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_expand_type),
      expression: "storeInfo.menu_expand_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menuExpandType"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.storeInfo.menu_expand_type, 2)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_expand_type", 2)
      }
    }
  }), _vm._v("展開\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(32), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_stop_sale_today_type),
      expression: "storeInfo.menu_stop_sale_today_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menuStopSaleTodayType"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.menu_stop_sale_today_type, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_stop_sale_today_type", 1)
      }
    }
  }), _vm._v("顯示當日停賣ICON\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_stop_sale_today_type),
      expression: "storeInfo.menu_stop_sale_today_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menuStopSaleTodayType"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.storeInfo.menu_stop_sale_today_type, 2)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_stop_sale_today_type", 2)
      }
    }
  }), _vm._v("隱藏當日停賣商品\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(33), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_stop_sale_type),
      expression: "storeInfo.menu_stop_sale_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menuStopSaleType"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.menu_stop_sale_type, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_stop_sale_type", 1)
      }
    }
  }), _vm._v("顯示永久停賣ICON\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_stop_sale_type),
      expression: "storeInfo.menu_stop_sale_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menuStopSaleType"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.storeInfo.menu_stop_sale_type, 2)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_stop_sale_type", 2)
      }
    }
  }), _vm._v("隱藏永久停賣商品\n                    ")])])])])]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(34), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.show_menu_zero_money),
      expression: "storeInfo.show_menu_zero_money"
    }],
    attrs: {
      "type": "radio",
      "name": "show_menu_zero_money"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.show_menu_zero_money, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "show_menu_zero_money", 1)
      }
    }
  }), _vm._v("\n                      開啟\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.show_menu_zero_money),
      expression: "storeInfo.show_menu_zero_money"
    }],
    attrs: {
      "type": "radio",
      "name": "show_menu_zero_money"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.show_menu_zero_money, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "show_menu_zero_money", 0)
      }
    }
  }), _vm._v("\n                      關閉\n                    ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(35), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.allow_update_menu),
      expression: "storeInfo.allow_update_menu"
    }],
    attrs: {
      "type": "radio",
      "name": "allow_update_menu"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.allow_update_menu, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "allow_update_menu", 1)
      }
    }
  }), _vm._v("\n                      開啟\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.allow_update_menu),
      expression: "storeInfo.allow_update_menu"
    }],
    attrs: {
      "type": "radio",
      "name": "allow_update_menu"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.allow_update_menu, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "allow_update_menu", 0)
      }
    }
  }), _vm._v("\n                      關閉\n                    ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(36), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.allow_copy_menu),
      expression: "storeInfo.allow_copy_menu"
    }],
    attrs: {
      "type": "radio",
      "name": "allow_copy_menu"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.allow_copy_menu, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "allow_copy_menu", 1)
      }
    }
  }), _vm._v("\n                      開啟\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.allow_copy_menu),
      expression: "storeInfo.allow_copy_menu"
    }],
    attrs: {
      "type": "radio",
      "name": "allow_copy_menu"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.allow_copy_menu, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "allow_copy_menu", 0)
      }
    }
  }), _vm._v("\n                      關閉\n                    ")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "input-group mb-3"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("銷售折扣組合(紅配綠)菜單分類顯示")]), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                    若開啟，菜單分類會再新增「紅區」、「綠區」，提升活動能見度！\n                  ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_ab_block_type),
      expression: "storeInfo.menu_ab_block_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menu_ab_block_type"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.menu_ab_block_type, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_ab_block_type", 1)
      }
    }
  }), _vm._v("\n                      開啟\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_ab_block_type),
      expression: "storeInfo.menu_ab_block_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menu_ab_block_type"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.menu_ab_block_type, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_ab_block_type", 0)
      }
    }
  }), _vm._v("\n                      關閉\n                    ")])])])])])]), _vm._v(" "), (_vm.getRoleType === 99 && _vm.$route.name === 'crStore') ? _c('div', [_c('h4', {
    staticClass: "text-left mb-3"
  }, [_vm._v("菜單管理")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(37), _vm._v(" "), _c('div', {
    staticClass: "flex align-center"
  }, [_c('div', {
    staticClass: "ml-md flex-shrink-0"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copyInfo.menuStore),
      expression: "copyInfo.menuStore"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.copyInfo.menuStore, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.copyInfo, "menuStore", false)
      }
    }
  }), _vm._v("\n                      自訂\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ml-md flex-shrink-0"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copyInfo.menuStore),
      expression: "copyInfo.menuStore"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.copyInfo.menuStore, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.copyInfo, "menuStore", true)
      }
    }
  }), _vm._v("\n                      複製\n                    ")])])]), _vm._v(" "), _c('multiselect', {
    class: [
      'flex-grow-1 ml-md',
      {
        'visibility-hidden': !_vm.copyInfo.menuStore
      }
    ],
    attrs: {
      "placeholder": "選擇店家",
      "label": "label",
      "track-by": "value",
      "allow-empty": false,
      "options": _vm.storeBrief
    },
    model: {
      value: (_vm.copyInfo.menuStoreId),
      callback: function($$v) {
        _vm.$set(_vm.copyInfo, "menuStoreId", $$v)
      },
      expression: "copyInfo.menuStoreId"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(38), _vm._v(" "), _c('div', {
    staticClass: "flex align-center"
  }, [_c('div', {
    staticClass: "ml-md flex-shrink-0"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copyInfo.productAlias),
      expression: "copyInfo.productAlias"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.copyInfo.productAlias, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.copyInfo, "productAlias", false)
      }
    }
  }), _vm._v("\n                      自訂\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ml-md flex-shrink-0"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copyInfo.productAlias),
      expression: "copyInfo.productAlias"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.copyInfo.productAlias, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.copyInfo, "productAlias", true)
      }
    }
  }), _vm._v("\n                      複製\n                    ")])])]), _vm._v(" "), _c('multiselect', {
    class: [
      'flex-grow-1 ml-md',
      {
        'visibility-hidden': !_vm.copyInfo.productAlias
      }
    ],
    attrs: {
      "placeholder": "選擇店家",
      "label": "label",
      "track-by": "value",
      "allow-empty": false,
      "options": _vm.storeBrief
    },
    model: {
      value: (_vm.copyInfo.productAliasStoreId),
      callback: function($$v) {
        _vm.$set(_vm.copyInfo, "productAliasStoreId", $$v)
      },
      expression: "copyInfo.productAliasStoreId"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(39), _vm._v(" "), _c('div', {
    staticClass: "flex align-center"
  }, [_c('div', {
    staticClass: "ml-md flex-shrink-0"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copyInfo.productImage),
      expression: "copyInfo.productImage"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.copyInfo.productImage, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.copyInfo, "productImage", false)
      }
    }
  }), _vm._v("\n                      自訂\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ml-md flex-shrink-0"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copyInfo.productImage),
      expression: "copyInfo.productImage"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.copyInfo.productImage, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.copyInfo, "productImage", true)
      }
    }
  }), _vm._v("\n                      複製\n                    ")])])]), _vm._v(" "), _c('multiselect', {
    class: [
      'flex-grow-1 ml-md',
      {
        'visibility-hidden': !_vm.copyInfo.productImage
      }
    ],
    attrs: {
      "placeholder": "選擇店家",
      "label": "label",
      "track-by": "value",
      "allow-empty": false,
      "options": _vm.storeBrief
    },
    model: {
      value: (_vm.copyInfo.productImageStoreId),
      callback: function($$v) {
        _vm.$set(_vm.copyInfo, "productImageStoreId", $$v)
      },
      expression: "copyInfo.productImageStoreId"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(40), _vm._v(" "), _c('div', {
    staticClass: "flex align-center"
  }, [_c('div', {
    staticClass: "ml-md flex-shrink-0"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.binding_class),
      expression: "storeInfo.binding_class"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.storeInfo.binding_class, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "binding_class", true)
      }
    }
  }), _vm._v("\n                      是\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ml-md flex-shrink-0"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.binding_class),
      expression: "storeInfo.binding_class"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.storeInfo.binding_class, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "binding_class", false)
      }
    }
  }), _vm._v("\n                      否\n                    ")])])])])]), _vm._v(" "), (_vm.storeInfo.binding_class) ? _c('div', {
    staticClass: "text-left mb-3"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              請選擇要加入的門市群組，若後續需異動請至菜單建置-門市群組。\n            ")]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.binding_class) ? _c('div', {
    staticClass: "input-group"
  }, [_vm._m(41), _vm._v(" "), _c('multiselect', {
    attrs: {
      "tag-placeholder": "選擇要加入的群組名稱",
      "placeholder": "選擇要加入的群組名稱",
      "label": "label",
      "track-by": "value",
      "options": _vm.bindingClassList,
      "multiple": true
    },
    model: {
      value: (_vm.storeInfo.binding_class_ids),
      callback: function($$v) {
        _vm.$set(_vm.storeInfo, "binding_class_ids", $$v)
      },
      expression: "storeInfo.binding_class_ids"
    }
  })], 1) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('h3', [_vm._v("POS帳號")]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(42), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isPosAccount),
      expression: "isPosAccount"
    }],
    attrs: {
      "type": "radio",
      "name": "sexOption"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.isPosAccount, 1)
    },
    on: {
      "change": function($event) {
        _vm.isPosAccount = 1
      }
    }
  }), _vm._v("\n                是\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isPosAccount),
      expression: "isPosAccount"
    }],
    attrs: {
      "type": "radio",
      "name": "sexOption"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.isPosAccount, 0)
    },
    on: {
      "change": function($event) {
        _vm.isPosAccount = 0
      }
    }
  }), _vm._v("\n                否\n              ")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (parseInt(_vm.isPosAccount, 10) === 1 && _vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.newPosAccount
    }
  }, [_vm._v("綁定POS帳號")]), _vm._v(" "), _c('div', {
    staticClass: " table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(43), _vm._v(" "), _vm._l((_vm.posList), function(item, index) {
    return _c('tbody', {
      staticClass: "even"
    }, [_c('tr', [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('div', {
      class: [
        'input-group has-feedback',
        item.account && !_vm.repeatPosAccount(item.account) && item.vaildSingleAccount ? 'has-success' : 'has-error'
      ]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.account),
        expression: "item.account"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.account)
      },
      on: {
        "focusout": function($event) {
          return _vm.checkPosSingleAccount(item, index)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "account", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      class: ['form-control-feedback', item.account && !_vm.repeatPosAccount(item.account) && item.vaildSingleAccount ? 'fa fa-check' : 'fa fa-times']
    })])]), _vm._v(" "), _c('td', [_c('div', {
      class: [' input-group has-feedback', item.password ? 'has-success' : 'has-error']
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.password),
        expression: "item.password"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.password)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "password", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      class: ['form-control-feedback', item.password ? 'fa fa-check' : 'fa fa-times']
    })])]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.pos_vendor_id),
        expression: "item.pos_vendor_id"
      }],
      staticClass: "form-control",
      attrs: {
        "disabled": item.pos_account_id
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "pos_vendor_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.posBrief), function(pos, k) {
      return _c('option', {
        key: k,
        domProps: {
          "value": pos.value
        }
      }, [_vm._v("\n                        " + _vm._s(pos.label) + "\n                      ")])
    }), 0)]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.role_type),
        expression: "item.role_type"
      }],
      staticClass: "form-control",
      attrs: {
        "disabled": item.pos_account_id
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "role_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "10"
      }
    }, [_vm._v("公版")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v("特定POS")])])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.remark),
        expression: "item.remark"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.remark)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "remark", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group text-left"
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.is_active),
        expression: "item.is_active"
      }],
      attrs: {
        "type": "radio",
        "name": 'active' + index
      },
      domProps: {
        "value": 0,
        "checked": _vm._q(item.is_active, 0)
      },
      on: {
        "change": function($event) {
          return _vm.$set(item, "is_active", 0)
        }
      }
    }), _vm._v("\n                          關閉\n                        ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.is_active),
        expression: "item.is_active"
      }],
      attrs: {
        "type": "radio",
        "name": 'active' + index
      },
      domProps: {
        "value": 1,
        "checked": _vm._q(item.is_active, 1)
      },
      on: {
        "change": function($event) {
          return _vm.$set(item, "is_active", 1)
        }
      }
    }), _vm._v("\n                          啟用\n                        ")])])])]), _vm._v(" "), _c('td', [(!item.pos_account_id) ? _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.deletePosAccount(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()])])])
  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.storeBrief.length && _vm.$route.name !== 'upStore') ? _c('div', [_c('h3', [_vm._v("廣告設定")]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.storeBrief.length && _vm.$route.name !== 'upStore') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(44), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCopy),
      expression: "isCopy"
    }],
    attrs: {
      "type": "radio",
      "name": "copyOption",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.isCopy, "1")
    },
    on: {
      "change": function($event) {
        _vm.isCopy = "1"
      }
    }
  }), _vm._v("\n                複製\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCopy),
      expression: "isCopy"
    }],
    attrs: {
      "type": "radio",
      "name": "copyOption",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.isCopy, "0")
    },
    on: {
      "change": function($event) {
        _vm.isCopy = "0"
      }
    }
  }), _vm._v("\n                自訂\n              ")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.isCopy == 1 && _vm.storeBrief.length && _vm.$route.name !== 'upStore') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(45), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copyBannerTypeList),
      expression: "copyBannerTypeList"
    }],
    attrs: {
      "type": "radio",
      "name": "copyBannerTypeList"
    },
    domProps: {
      "value": [12],
      "checked": _vm._q(_vm.copyBannerTypeList, [12])
    },
    on: {
      "change": function($event) {
        _vm.copyBannerTypeList = [12]
      }
    }
  }), _vm._v("\n                橫幅廣告\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copyBannerTypeList),
      expression: "copyBannerTypeList"
    }],
    attrs: {
      "type": "radio",
      "name": "copyBannerTypeList"
    },
    domProps: {
      "value": [41],
      "checked": _vm._q(_vm.copyBannerTypeList, [41])
    },
    on: {
      "change": function($event) {
        _vm.copyBannerTypeList = [41]
      }
    }
  }), _vm._v("\n                蓋板廣告\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copyBannerTypeList),
      expression: "copyBannerTypeList"
    }],
    attrs: {
      "type": "radio",
      "name": "copyBannerTypeList"
    },
    domProps: {
      "value": [12, 41],
      "checked": _vm._q(_vm.copyBannerTypeList, [12, 41])
    },
    on: {
      "change": function($event) {
        _vm.copyBannerTypeList = [12, 41]
      }
    }
  }), _vm._v("\n                兩者\n              ")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.isCopy === 1 || _vm.isCopy === '1') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(46), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copyStoreSelect),
      expression: "copyStoreSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.copyStoreSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.storeBrief), function(store, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": store.value
      }
    }, [_vm._v("\n                " + _vm._s(store.label) + "\n              ")])
  }), 0)])]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 3),
      expression: "storeMethod === 3"
    }],
    staticClass: "box-body form"
  }, [_vm._m(47), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30 || _vm.getRoleType === 10) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(48), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.order_start_day),
      expression: "storeInfo.order_start_day"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.storeInfo.order_start_day)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "order_start_day", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30 || _vm.getRoleType === 10) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(49), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.order_tolerance_day),
      expression: "storeInfo.order_tolerance_day"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.storeInfo.order_tolerance_day)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "order_tolerance_day", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(50), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.auto_reject_order_reserve_m),
      expression: "storeInfo.auto_reject_order_reserve_m"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.storeInfo.auto_reject_order_reserve_m)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "auto_reject_order_reserve_m", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(51), _vm._v(" "), _c('br'), _vm._v(" "), ((_vm.getDenyList.indexOf(331) < 0)) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(52), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderStatusSelect),
      expression: "orderStatusSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "orderOption",
      "value": "10"
    },
    domProps: {
      "checked": _vm._q(_vm.orderStatusSelect, "10")
    },
    on: {
      "change": function($event) {
        _vm.orderStatusSelect = "10"
      }
    }
  }), _vm._v("\n                  接單中\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderStatusSelect),
      expression: "orderStatusSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "orderOption",
      "value": "20"
    },
    domProps: {
      "checked": _vm._q(_vm.orderStatusSelect, "20")
    },
    on: {
      "change": function($event) {
        _vm.orderStatusSelect = "20"
      }
    }
  }), _vm._v("\n                  不接單\n                ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), ((_vm.getDenyList.indexOf(331) < 0)) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(53), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.order_status_reason),
      expression: "storeInfo.order_status_reason"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.storeInfo.order_status_reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "order_status_reason", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(54), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.auto_reject_order_m),
      expression: "storeInfo.auto_reject_order_m"
    }],
    ref: "rejectTime",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.storeInfo.auto_reject_order_m)
    },
    on: {
      "keyup": _vm.verityRejectTime,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "auto_reject_order_m", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30 || _vm.getRoleType === 10) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(55), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_preparing_allow_order),
      expression: "storeInfo.is_preparing_allow_order"
    }],
    attrs: {
      "type": "radio",
      "name": "isPreparingAllow"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.is_preparing_allow_order, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_preparing_allow_order", 1)
      }
    }
  }), _vm._v("\n                  可下單\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_preparing_allow_order),
      expression: "storeInfo.is_preparing_allow_order"
    }],
    attrs: {
      "type": "radio",
      "name": "isPreparingAllow"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.is_preparing_allow_order, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_preparing_allow_order", 0)
      }
    }
  }), _vm._v("\n                  不可下單\n                ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30 || _vm.getRoleType === 10) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(56), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_close_allow_order),
      expression: "storeInfo.is_close_allow_order"
    }],
    attrs: {
      "type": "radio",
      "name": "isCloseAllow"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.is_close_allow_order, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_close_allow_order", 1)
      }
    }
  }), _vm._v("\n                  可下單\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_close_allow_order),
      expression: "storeInfo.is_close_allow_order"
    }],
    attrs: {
      "type": "radio",
      "name": "isCloseAllow"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.is_close_allow_order, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_close_allow_order", 0)
      }
    }
  }), _vm._v("\n                  不可下單\n                ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(57), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.order_start_time_m),
      expression: "storeInfo.order_start_time_m"
    }],
    ref: "startTime",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.storeInfo.order_start_time_m)
    },
    on: {
      "keyup": _vm.verityStartTime,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "order_start_time_m", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(58), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.order_end_time_m),
      expression: "storeInfo.order_end_time_m"
    }],
    ref: "endTime",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.storeInfo.order_end_time_m)
    },
    on: {
      "keyup": _vm.verityEndTime,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "order_end_time_m", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 4),
      expression: "storeMethod === 4"
    }],
    staticClass: "box-body form"
  }, [_vm._m(59), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("付款類型")]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('td', {
    staticStyle: {
      "min-width": "100px"
    }
  }, [_vm._v("支援與否")]) : _vm._e(), _vm._v(" "), _c('td', {
    staticStyle: {
      "min-width": "100px"
    }
  }, [_vm._v("\n                開啟狀態\n                "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                    若無法調整開啟狀態表示門市尚未開通此支付別，如需啟用請洽你訂團隊。\n                  ")])], 1)]), _vm._v(" "), (_vm.getRoleType === 99) ? [_c('td', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("線上key (自取、外送)")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("線下key (內用、內用-桌邊掃碼)")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "min-width": "150px"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "min-width": "150px"
    }
  })] : _vm._e(), _vm._v(" "), _c('td', {
    staticStyle: {
      "min-width": "180px"
    }
  }, [_vm._v("\n                備註 (顯示在購物車頁面上，消費者可查看)\n                "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(60)], 1)])], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.tradeInfo), function(tradeType, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊")]), _vm._v("\n                " + _vm._s(tradeType.name) + "\n              ")]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('td', [_c('div', {
      staticClass: "form-group text-left"
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tradeType.is_support),
        expression: "tradeType.is_support"
      }],
      attrs: {
        "disabled": _vm.getRoleType === 10,
        "type": "radio",
        "value": "1"
      },
      domProps: {
        "checked": _vm._q(tradeType.is_support, "1")
      },
      on: {
        "change": function($event) {
          return _vm.$set(tradeType, "is_support", "1")
        }
      }
    }), _vm._v("\n                      支援\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tradeType.is_support),
        expression: "tradeType.is_support"
      }],
      attrs: {
        "disabled": _vm.getRoleType === 10,
        "type": "radio",
        "value": "0"
      },
      domProps: {
        "checked": _vm._q(tradeType.is_support, "0")
      },
      on: {
        "change": [function($event) {
          return _vm.$set(tradeType, "is_support", "0")
        }, function($event) {
          return _vm.clickClose('tradeType', tradeType.is_default, index)
        }]
      }
    }), _vm._v("\n                      不支援\n                    ")])])])]) : _vm._e(), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group text-left"
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tradeType.is_enable),
        expression: "tradeType.is_enable"
      }],
      attrs: {
        "type": "radio",
        "value": "1",
        "disabled": tradeType.is_support == 0
      },
      domProps: {
        "checked": _vm._q(tradeType.is_enable, "1")
      },
      on: {
        "input": function($event) {
          _vm.reload = true
        },
        "change": function($event) {
          return _vm.$set(tradeType, "is_enable", "1")
        }
      }
    }), _vm._v(" "), _c('span', {
      class: {
        'radio-text--disabled': tradeType.is_support == 0
      }
    }, [_vm._v("\n                        開啟\n                      ")])])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tradeType.is_enable),
        expression: "tradeType.is_enable"
      }],
      attrs: {
        "type": "radio",
        "value": "0",
        "disabled": tradeType.is_support == 0
      },
      domProps: {
        "checked": _vm._q(tradeType.is_enable, "0")
      },
      on: {
        "change": [function($event) {
          return _vm.$set(tradeType, "is_enable", "0")
        }, function($event) {
          return _vm.clickClose('tradeType', tradeType.is_default, index)
        }]
      }
    }), _vm._v(" "), _c('span', {
      class: {
        'radio-text--disabled': tradeType.is_support == 0
      }
    }, [_vm._v("\n                        關閉\n                      ")])])])])]), _vm._v(" "), (_vm.getRoleType === 99) ? [_vm._l((['online', 'offline']), function(groupType, i) {
      return _c('td', {
        key: i
      }, [(tradeType.meta) ? [(tradeType.meta[groupType == 'online' ? 'delete_key' : 'delete_offline_key']) ? _c('div', {
        staticClass: "text-danger"
      }, [_c('small', {
        staticClass: "text-w-600"
      }, [_vm._v("＊移除先前設定")])]) : _vm._e(), _vm._v(" "), (tradeType.meta[groupType == 'online' ? 'use_key' : 'use_offline_key'] == 1 && !tradeType.meta[groupType == 'online' ? 'delete_key' : 'delete_offline_key']) ? _c('div', [_vm._v("\n                      已設定\n                      "), _c('br'), _vm._v(" "), _c('button', {
        staticClass: "btn btn-default",
        on: {
          "click": function($event) {
            tradeType.meta[groupType == 'online' ? 'use_key' : 'use_offline_key'] = 2
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil"
      })]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-danger",
        on: {
          "click": function($event) {
            _vm.reload = true;
            tradeType.meta[groupType == 'online' ? 'delete_key' : 'delete_offline_key'] = 1;
            tradeType.meta[groupType == 'online' ? 'use_key' : 'use_offline_key'] = 2
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })])]) : _c('div', _vm._l((tradeType.meta.group[groupType]), function(value, key) {
        return _c('div', {
          key: key
        }, [_c('span', {
          staticClass: "text-w-600"
        }, [_vm._v(_vm._s(key) + "：")]), _vm._v(" "), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (tradeType.meta.group[groupType][key]),
            expression: "tradeType.meta.group[groupType][key]"
          }],
          staticClass: "form-control",
          attrs: {
            "placeholder": "",
            "type": "text",
            "disabled": groupType == 'offline' && !tradeType.check_offline
          },
          domProps: {
            "value": (tradeType.meta.group[groupType][key])
          },
          on: {
            "input": [function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(tradeType.meta.group[groupType], key, $event.target.value)
            }, function($event) {
              _vm.reload = true;
              tradeType.meta[groupType == 'online' ? 'use_key' : 'use_offline_key'] = 2
            }]
          }
        })])
      }), 0)] : _vm._e()], 2)
    }), _vm._v(" "), _c('td', [(tradeType.custom_config) ? _c('div', _vm._l((tradeType.custom_config.key), function(tradeValue, key) {
      return _c('div', {
        key: key
      }, [_c('span', {
        staticClass: "text-w-600"
      }, [_vm._v(_vm._s(key) + "：")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (tradeType.custom_config.key[key]),
          expression: "tradeType.custom_config.key[key]"
        }],
        staticClass: "form-control",
        attrs: {
          "placeholder": "",
          "type": "text"
        },
        domProps: {
          "value": (tradeType.custom_config.key[key])
        },
        on: {
          "input": [function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(tradeType.custom_config.key, key, $event.target.value)
          }, function($event) {
            _vm.reload = true
          }]
        }
      })])
    }), 0) : _vm._e()]), _vm._v(" "), _c('td', [(tradeType.meta || tradeType.custom_config) ? _c('div', [_c('span', {
      staticClass: "text-w-600"
    }, [_vm._v("金流帳戶統一編號")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tradeType.ein),
        expression: "tradeType.ein"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "",
        "type": "text",
        "maxlength": "8"
      },
      domProps: {
        "value": (tradeType.ein)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(tradeType, "ein", $event.target.value)
        }, function($event) {
          return _vm.verityTradeEin(index)
        }]
      }
    })]) : _vm._e()])] : _vm._e(), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tradeType.remark),
        expression: "tradeType.remark"
      }],
      staticClass: "w-100-p form-control",
      attrs: {
        "rows": "2",
        "maxlength": _vm.remarkMaxlength
      },
      domProps: {
        "value": (tradeType.remark)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(tradeType, "remark", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-right"
    }, [_vm._v("\n                  " + _vm._s(tradeType.remark ? tradeType.remark.length : 0) + "/" + _vm._s(_vm.remarkMaxlength) + "\n                ")])])], 2)
  }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(61), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(62), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("內用-桌邊掃碼")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumber.is_cash_pay_after_meal),
      expression: "tableNumber.is_cash_pay_after_meal"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.tableNumber.is_cash_pay_after_meal, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tableNumber, "is_cash_pay_after_meal", 0)
      }
    }
  }), _vm._v("\n                      餐前付款\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumber.is_cash_pay_after_meal),
      expression: "tableNumber.is_cash_pay_after_meal"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.tableNumber.is_cash_pay_after_meal, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tableNumber, "is_cash_pay_after_meal", 1)
      }
    }
  }), _vm._v("\n                      餐後付款\n                    ")])])])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.info) ? _c('div', [_c('h3', [_vm._v("付款方式與取餐金額")])]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addExceptionTrade
    }
  }, [_vm._v("\n          新增限制\n        ")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.exceptionTradeList.length) ? _c('div', [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(63), _vm._v(" "), _c('tbody', _vm._l((_vm.exceptionTradeList), function(exceptionTrade, eIndex) {
    return _c('tr', {
      key: eIndex
    }, [_c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (exceptionTrade.delivery_type),
        expression: "exceptionTrade.delivery_type"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(exceptionTrade, "delivery_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": 0
      }
    }, [_vm._v("全部")]), _vm._v(" "), _vm._l((_vm.deliveryInfo), function(delivery, i) {
      return _c('option', {
        key: i,
        domProps: {
          "value": delivery.value
        }
      }, [_vm._v("\n                    " + _vm._s(delivery.label) + "\n                  ")])
    }), _vm._v(" "), (exceptionTrade.delivery) ? _c('option', {
      domProps: {
        "value": exceptionTrade.delivery_type
      }
    }, [_vm._v(_vm._s(exceptionTrade.delivery))]) : _vm._e()], 2)]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (exceptionTrade.trade_type),
        expression: "exceptionTrade.trade_type"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(exceptionTrade, "trade_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_vm._l((_vm.tradeList), function(trade, i) {
      return _c('option', {
        key: i,
        domProps: {
          "value": trade.value
        }
      }, [_vm._v("\n                    " + _vm._s(trade.label) + "\n                  ")])
    }), _vm._v(" "), (exceptionTrade.trade) ? _c('option', {
      domProps: {
        "value": exceptionTrade.trade_type
      }
    }, [_vm._v(_vm._s(exceptionTrade.trade))]) : _vm._e()], 2)]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (exceptionTrade.start_money),
        expression: "exceptionTrade.start_money"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "",
        "type": "text"
      },
      domProps: {
        "value": (exceptionTrade.start_money)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(exceptionTrade, "start_money", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (exceptionTrade.end_money),
        expression: "exceptionTrade.end_money"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "",
        "type": "text"
      },
      domProps: {
        "value": (exceptionTrade.end_money)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(exceptionTrade, "end_money", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(_vm._f("deliveryName")(exceptionTrade.delivery_type)) + "\n                "), (exceptionTrade.start_money) ? _c('span', [_vm._v("\n                  " + _vm._s(exceptionTrade.start_money) + " 元以上\n                ")]) : _vm._e(), _vm._v(" "), (exceptionTrade.start_money && exceptionTrade.end_money) ? _c('span', [_vm._v("\n                  ～\n                ")]) : _vm._e(), _vm._v(" "), (exceptionTrade.end_money) ? _c('span', [_vm._v("\n                  " + _vm._s(exceptionTrade.end_money) + " 元以下\n                ")]) : _vm._e(), _vm._v("\n                不可用" + _vm._s(_vm._f("tradeName")(exceptionTrade.trade_type)) + "付款\n              ")]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.exceptionTradeList, eIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 5),
      expression: "storeMethod === 5"
    }],
    staticClass: "box-body form"
  }, [_vm._m(64), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(65), _vm._v(" "), _c('tbody', _vm._l((_vm.takeTimeInfo), function(takeTime, i) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.hideDeliveryType.includes(takeTime.take_type)),
        expression: "!hideDeliveryType.includes(takeTime.take_type)"
      }],
      key: i
    }, [_c('td', [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊")]), _vm._v("\n                " + _vm._s(_vm._f("deliveryName")(takeTime.take_type)) + "\n              ")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (takeTime.prepare_time_seg),
        expression: "takeTime.prepare_time_seg"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "",
        "type": "text"
      },
      domProps: {
        "value": (takeTime.prepare_time_seg)
      },
      on: {
        "keypress": _vm.returnNum,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(takeTime, "prepare_time_seg", $event.target.value)
        }
      }
    }), _vm._v("\n                分鐘\n              ")]), _vm._v(" "), _c('td', [(takeTime.take_type < 3 && _vm.$route.name === 'upStore') ? _c('span', [_vm._v("\n                  不需設定\n                ")]) : (takeTime.take_type === 21) ? _c('span', [_vm._v("\n                  不需設定\n                ")]) : _c('div', {
      staticClass: "flex align-center"
    }, [_c('div', {
      staticClass: "input-group-btn flex w-auto"
    }, [_c('button', {
      staticClass: "btn btn-default w-36px",
      attrs: {
        "disabled": !takeTime.take_time_seg
      },
      on: {
        "click": function($event) {
          return _vm.setTakeTime('minus', takeTime)
        }
      }
    }, [_vm._v("\n                      -\n                    ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (takeTime.take_time_seg),
        expression: "takeTime.take_time_seg"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "",
        "type": "text"
      },
      domProps: {
        "value": (takeTime.take_time_seg)
      },
      on: {
        "keypress": _vm.returnNum,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(takeTime, "take_time_seg", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default w-36px",
      on: {
        "click": function($event) {
          return _vm.setTakeTime('add', takeTime)
        }
      }
    }, [_vm._v("\n                      +\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "m-l-5"
    }, [_vm._v("分鐘")])])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addProcessTime
    }
  }, [_vm._v("\n          新增某時段的製作時間\n        ")])]), _vm._v(" "), _vm._l((_vm.processTimeList), function(process, pIndex) {
    return _c('div', {
      key: pIndex,
      staticClass: "m-t-10 process-time-block"
    }, [_c('div', {
      staticClass: "text-right m-b-10"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.processTimeList, pIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(66, true), _vm._v(" "), _c('div', [_c('multiselect', {
      attrs: {
        "placeholder": "新增月份",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdaySetting.options.month,
        "multiple": false,
        "allow-empty": true
      },
      model: {
        value: (process.month),
        callback: function($$v) {
          _vm.$set(process, "month", $$v)
        },
        expression: "process.month"
      }
    })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(67, true), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (process.value_type),
        expression: "process.value_type"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(process, "value_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.clearProcess(process)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": 1
      }
    }, [_vm._v("日期")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 2
      }
    }, [_vm._v("星期")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), (process.value_type === 2) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(68, true), _vm._v(" "), _c('div', [_c('multiselect', {
      attrs: {
        "placeholder": "新增星期",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdaySetting.options.weekDay,
        "multiple": false,
        "allow-empty": true
      },
      model: {
        value: (process.start_value),
        callback: function($$v) {
          _vm.$set(process, "start_value", $$v)
        },
        expression: "process.start_value"
      }
    })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (process.value_type === 1) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(69, true), _vm._v(" "), _c('div', [_c('multiselect', {
      attrs: {
        "tag-placeholder": "數字為1~31",
        "placeholder": "新增日期 (格式為數字1~31)",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdaySetting.options.monthDay,
        "multiple": false,
        "taggable": true,
        "id": 'process-start-' + pIndex
      },
      on: {
        "tag": _vm.addStartMonthDayTag
      },
      model: {
        value: (process.start_value),
        callback: function($$v) {
          _vm.$set(process, "start_value", $$v)
        },
        expression: "process.start_value"
      }
    })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (process.value_type === 2) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(70, true), _vm._v(" "), _c('div', [_c('multiselect', {
      attrs: {
        "placeholder": "新增星期",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdaySetting.options.weekDay,
        "multiple": false,
        "allow-empty": true
      },
      model: {
        value: (process.end_value),
        callback: function($$v) {
          _vm.$set(process, "end_value", $$v)
        },
        expression: "process.end_value"
      }
    })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (process.value_type === 1) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(71, true), _vm._v(" "), _c('div', [_c('multiselect', {
      attrs: {
        "tag-placeholder": "數字為1~31",
        "placeholder": "新增日期 (格式為數字1~31)",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdaySetting.options.monthDay,
        "multiple": false,
        "taggable": true
      },
      on: {
        "tag": _vm.addEndMonthDayTag
      },
      model: {
        value: (process.end_value),
        callback: function($$v) {
          _vm.$set(process, "end_value", $$v)
        },
        expression: "process.end_value"
      }
    })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(72, true), _vm._v(" "), _c('div', [_c('multiselect', {
      attrs: {
        "placeholder": "選擇取餐類型",
        "label": "label",
        "track-by": "value",
        "options": _vm.deliveryTypeOption,
        "multiple": false,
        "allow-empty": true
      },
      model: {
        value: (process.delivery_type),
        callback: function($$v) {
          _vm.$set(process, "delivery_type", $$v)
        },
        expression: "process.delivery_type"
      }
    })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "text-left"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.addItemTime(process)
        }
      }
    }, [_vm._v("\n            加入時間\n          ")])]), _vm._v(" "), _c('table', {
      staticClass: "table table-bordered table-striped dataTable"
    }, [_vm._m(73, true), _vm._v(" "), _c('tbody', _vm._l((process.item_list), function(item, iIndex) {
      return _c('tr', {
        key: iIndex
      }, [_c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.start_time),
          expression: "item.start_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.start_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "start_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.end_time),
          expression: "item.end_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.end_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "end_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.process_time),
          expression: "item.process_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "",
          "type": "text"
        },
        domProps: {
          "value": (item.process_time)
        },
        on: {
          "keypress": _vm.returnNum,
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "process_time", $event.target.value)
          }
        }
      }), _vm._v("  分鐘\n              ")]), _vm._v(" "), _c('td', [(iIndex > 0) ? _c('button', {
        staticClass: "btn btn-danger",
        on: {
          "click": function($event) {
            return _vm.removeListItem(process.item_list, iIndex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })]) : _vm._e()])])
    }), 0)])])
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 6),
      expression: "storeMethod === 6"
    }],
    staticClass: "box-body form"
  }, [_vm._m(74), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(75), _vm._v(" "), (_vm.getRoleType === 10) ? _c('div', {
    staticClass: "text-left m-b-15"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("若要啟用特定取餐方式請按右上角聯絡客服")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("取餐類型")]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('td', [_vm._v("支援與否")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("開啟狀態")]), _vm._v(" "), _c('td', [_vm._v("\n                預設\n                "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text center"
  }, [_vm._v("\n                    購物車預設的取餐方式。開啟狀態為 \"開啟\" 的取餐方式才能設為預設。\n                  ")])], 1)]), _vm._v(" "), _c('td', [_c('span', [_vm._v("消費金額與距離門檻")]), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(76)], 1)]), _vm._v(" "), _c('td', [_c('span', [_vm._v("備註")]), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(77)], 1)]), _vm._v(" "), _c('td', [_c('span', [_vm._v("取餐提醒")]), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(78)], 1)])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.deliveryWaysInfo), function(deliveryWays, i) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.hideDeliveryType.includes(deliveryWays.take_type)),
        expression: "!hideDeliveryType.includes(deliveryWays.take_type)"
      }],
      key: i
    }, [_c('td', [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊")]), _vm._v("\n              " + _vm._s(_vm._f("deliveryName")(deliveryWays.take_type)) + "\n            ")]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('td', [_c('div', {
      staticClass: "form-group text-left"
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.is_support),
        expression: "deliveryWays.is_support"
      }],
      attrs: {
        "disabled": _vm.getRoleType === 10,
        "type": "radio",
        "value": "1"
      },
      domProps: {
        "checked": _vm._q(deliveryWays.is_support, "1")
      },
      on: {
        "change": function($event) {
          return _vm.$set(deliveryWays, "is_support", "1")
        }
      }
    }), _vm._v("\n                    支援\n                  ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.is_support),
        expression: "deliveryWays.is_support"
      }],
      attrs: {
        "disabled": _vm.getRoleType === 10,
        "type": "radio",
        "value": "0"
      },
      domProps: {
        "checked": _vm._q(deliveryWays.is_support, "0")
      },
      on: {
        "change": [function($event) {
          return _vm.$set(deliveryWays, "is_support", "0")
        }, function($event) {
          return _vm.clickClose('deliveryWays', true, deliveryWays.is_default, i)
        }]
      }
    }), _vm._v("\n                    不支援\n                  ")])])])]) : _vm._e(), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group text-left"
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.is_enable),
        expression: "deliveryWays.is_enable"
      }],
      attrs: {
        "type": "radio",
        "disabled": deliveryWays.is_support === 0,
        "value": "1"
      },
      domProps: {
        "checked": _vm._q(deliveryWays.is_enable, "1")
      },
      on: {
        "change": function($event) {
          return _vm.$set(deliveryWays, "is_enable", "1")
        }
      }
    }), _vm._v(" "), _c('span', {
      class: {
        'radio-text--disabled': deliveryWays.is_support == 0
      }
    }, [_vm._v("\n                      開啟\n                    ")])])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.is_enable),
        expression: "deliveryWays.is_enable"
      }],
      attrs: {
        "type": "radio",
        "value": "0",
        "disabled": deliveryWays.is_support === 0
      },
      domProps: {
        "checked": _vm._q(deliveryWays.is_enable, "0")
      },
      on: {
        "change": [function($event) {
          return _vm.$set(deliveryWays, "is_enable", "0")
        }, function($event) {
          return _vm.clickClose('deliveryWays', false, deliveryWays.is_default, i)
        }]
      }
    }), _vm._v(" "), _c('span', {
      class: {
        'radio-text--disabled': deliveryWays.is_support == 0
      }
    }, [_vm._v("\n                      關閉\n                    ")])])])])]), _vm._v(" "), _c('td', [(deliveryWays.take_type !== 21) ? _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.is_default),
        expression: "deliveryWays.is_default"
      }],
      attrs: {
        "type": "radio",
        "value": "1",
        "disabled": parseInt(deliveryWays.is_support, 10) === 0 || parseInt(deliveryWays.is_enable, 10) === 0
      },
      domProps: {
        "checked": _vm._q(deliveryWays.is_default, "1")
      },
      on: {
        "change": [function($event) {
          return _vm.$set(deliveryWays, "is_default", "1")
        }, function($event) {
          return _vm.checkDefault(deliveryWays.take_type)
        }]
      }
    })]) : _vm._e()]), _vm._v(" "), (deliveryWays.take_type !== 3) ? _c('td', [_vm._v("\n              滿\n              "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.price),
        expression: "deliveryWays.price"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "",
        "type": "text",
        "disabled": _vm.getRoleType === 10 && deliveryWays.is_support === 0
      },
      domProps: {
        "value": (deliveryWays.price)
      },
      on: {
        "keypress": _vm.returnNum,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(deliveryWays, "price", $event.target.value)
        }
      }
    }), _vm._v("\n              元即可" + _vm._s(_vm._f("deliveryName")(deliveryWays.take_type)) + "\n            ")]) : _vm._e(), _vm._v(" "), (deliveryWays.take_type === 3) ? _c('td', [_c('delivery-limit', {
      attrs: {
        "store-info": _vm.storeInfo,
        "delivery-ways": deliveryWays,
        "delivery-ways-info": _vm.deliveryWaysInfo,
        "delivery-other": _vm.deliveryOther
      },
      on: {
        "update:deliveryWaysInfo": function($event) {
          _vm.deliveryWaysInfo = $event
        },
        "update:deliveryOther": function($event) {
          _vm.deliveryOther = $event
        },
        "update:storeInfo": function($event) {
          _vm.storeInfo = $event
        },
        "update:deliveryWays": function($event) {
          deliveryWays = $event
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.memo),
        expression: "deliveryWays.memo"
      }],
      staticClass: "w-100-p form-control",
      attrs: {
        "disabled": _vm.getRoleType === 10 && deliveryWays.is_support === 0,
        "rows": "2",
        "maxlength": _vm.remarkMaxlength
      },
      domProps: {
        "value": (deliveryWays.memo)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(deliveryWays, "memo", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(deliveryWays.memo.length || 0) + "/" + _vm._s(_vm.remarkMaxlength))])]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.pickup_memo),
        expression: "deliveryWays.pickup_memo"
      }],
      staticClass: "w-100-p form-control",
      attrs: {
        "disabled": _vm.getRoleType === 10 && deliveryWays.is_support === 0,
        "rows": "2",
        "maxlength": _vm.remarkMaxlength
      },
      domProps: {
        "value": (deliveryWays.pickup_memo)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(deliveryWays, "pickup_memo", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(deliveryWays.pickup_memo.length || 0) + "/" + _vm._s(_vm.remarkMaxlength))])])])
  }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(79), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }), _vm._m(80), _vm._v(" "), _vm._m(81), _vm._v(" "), _vm._m(82), _vm._v(" "), _vm._m(83), _vm._v(" "), _c('p'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "text-left m-b-15"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.addProductItem('search')
      }
    }
  }, [_vm._v("\n            搜尋商品\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.addProductItem('insert')
      }
    }
  }, [_vm._v("\n            新增商品\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "grey darken-1 m-l-5"
  }, [_vm._v("提示：若商品已在菜單中，請優先使用「搜尋商品」")])]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto m-b-15"
  }, [(!_vm.deliveryExceptionProductSelect) ? _c('div', {
    key: "default-mode"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": !_vm.checkDeliveryExceptionProductList,
      "data-toggle": "modal",
      "data-target": "#copyModal"
    }
  }, [_vm._v("\n              複製所有排除項目至其他店家\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.deliveryExceptionProductSelect = true
      }
    }
  }, [_vm._v("\n              批次選取\n            ")])]) : _c('div', {
    key: "select-mode"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.deliveryExceptionProductSelect = false
      }
    }
  }, [_vm._v("\n              取消選取\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": !_vm.deliveryExceptionProductSelectItems.length,
      "data-toggle": "modal",
      "data-target": "#delExceptionModal"
    }
  }, [_vm._v("\n              批次刪除\n            ")])])])]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [(_vm.deliveryExceptionProductSelect) ? _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deliveryExceptionProductSelectAll),
      expression: "deliveryExceptionProductSelectAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.deliveryExceptionProductSelectAll) ? _vm._i(_vm.deliveryExceptionProductSelectAll, null) > -1 : (_vm.deliveryExceptionProductSelectAll)
    },
    on: {
      "click": function($event) {
        return _vm.selectAllProducts()
      },
      "change": function($event) {
        var $$a = _vm.deliveryExceptionProductSelectAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.deliveryExceptionProductSelectAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.deliveryExceptionProductSelectAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.deliveryExceptionProductSelectAll = $$c
        }
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("#")]), _vm._v(" "), _c('td', [_vm._v("類型")]), _vm._v(" "), _c('td', [_vm._v("商品名稱")]), _vm._v(" "), _c('td', [_vm._v("商品料號")]), _vm._v(" "), _c('td', [_vm._v("狀態")]), _vm._v(" "), _c('td', [_vm._v("操作")])])]), _vm._v(" "), _c('tbody', [(_vm.deliveryExceptionProductList.length === 0) ? _c('tr', [_vm._m(84)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.deliveryExceptionProductList), function(item, index) {
    return _c('tr', {
      key: index
    }, [(_vm.deliveryExceptionProductSelect) ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.selected),
        expression: "item.selected"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.selected) ? _vm._i(item.selected, null) > -1 : (item.selected)
      },
      on: {
        "change": function($event) {
          var $$a = item.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "selected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "selected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "selected", $$c)
          }
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.product_type),
        expression: "item.product_type"
      }],
      staticClass: "form-control inline-block",
      attrs: {
        "disabled": item.item_type === 'search' || item.updated
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "product_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": 1
      }
    }, [_vm._v("商品")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 3
      }
    }, [_vm._v("套餐")])])]), _vm._v(" "), _c('td', [(item.item_type === 'search') ? _c('multiselect', {
      attrs: {
        "options": _vm.optionsList,
        "searchable": true,
        "allow-empty": true,
        "close-on-select": true,
        "placeholder": "請輸入商品名稱",
        "show-labels": false,
        "multiple": false,
        "label": "name",
        "track-by": "id"
      },
      on: {
        "input": function($event) {
          return _vm.handleProductSelect(item)
        }
      },
      scopedSlots: _vm._u([{
        key: "option",
        fn: function(props) {
          return [_c('span', [_vm._v(_vm._s(props.option.name))]), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(props.option.id) + ")")])]
        }
      }], null, true),
      model: {
        value: (item.search_result),
        callback: function($$v) {
          _vm.$set(item, "search_result", $$v)
        },
        expression: "item.search_result"
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.product_name),
        expression: "item.product_name"
      }],
      staticClass: "form-control inline-block deliveryExceptionInput",
      attrs: {
        "type": "text",
        "disabled": item.updated,
        "placeholder": "請輸入商品名稱"
      },
      domProps: {
        "value": (item.product_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "product_name", $event.target.value)
        }
      }
    })], 1), _vm._v(" "), _c('td', [(item.item_type === 'search') ? _c('multiselect', {
      attrs: {
        "options": _vm.optionsList,
        "searchable": true,
        "allow-empty": true,
        "close-on-select": true,
        "placeholder": "請輸入商品料號",
        "show-labels": false,
        "multiple": false,
        "label": "id",
        "track-by": "id"
      },
      on: {
        "input": function($event) {
          return _vm.handleProductSelect(item)
        }
      },
      scopedSlots: _vm._u([{
        key: "option",
        fn: function(props) {
          return [_c('span', [_vm._v(_vm._s(props.option.name))]), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(props.option.id) + ")")])]
        }
      }], null, true),
      model: {
        value: (item.search_result),
        callback: function($$v) {
          _vm.$set(item, "search_result", $$v)
        },
        expression: "item.search_result"
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.vendor_custom_id),
        expression: "item.vendor_custom_id"
      }],
      staticClass: "form-control inline-block deliveryExceptionInput",
      attrs: {
        "type": "text",
        "disabled": item.item_type === 'search' || item.updated,
        "placeholder": "請輸入商品料號"
      },
      domProps: {
        "value": (item.vendor_custom_id)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "vendor_custom_id", $event.target.value)
        }
      }
    })], 1), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group text-left"
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.is_enabled),
        expression: "item.is_enabled"
      }],
      attrs: {
        "type": "radio",
        "name": 'status_' + index
      },
      domProps: {
        "value": 1,
        "checked": _vm._q(item.is_enabled, 1)
      },
      on: {
        "change": function($event) {
          return _vm.$set(item, "is_enabled", 1)
        }
      }
    }), _vm._v("開啟\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.is_enabled),
        expression: "item.is_enabled"
      }],
      attrs: {
        "type": "radio",
        "name": 'status_' + index
      },
      domProps: {
        "value": 0,
        "checked": _vm._q(item.is_enabled, 0)
      },
      on: {
        "change": function($event) {
          return _vm.$set(item, "is_enabled", 0)
        }
      }
    }), _vm._v("關閉\n                    ")])])])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.deleteProductItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  })], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.shippingInfo.is_support && _vm.shippingInfo.is_enable) ? _c('shipping-form', {
    ref: "shippingInfo",
    attrs: {
      "show-vendor-id": _vm.apiTypeSelect == 1,
      "store-info": _vm.storeInfo
    },
    on: {
      "update:store-info": function($event) {
        _vm.storeInfo = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.isEnableOnSite) ? _c('div', [_c('h3', [_vm._v("桌邊掃碼")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(85), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumber.sub_delivery_type),
      expression: "tableNumber.sub_delivery_type"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.tableNumber.sub_delivery_type, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tableNumber, "sub_delivery_type", 1)
      }
    }
  }), _vm._v("\n                  叫號取餐\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumber.sub_delivery_type),
      expression: "tableNumber.sub_delivery_type"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.tableNumber.sub_delivery_type, 2)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tableNumber, "sub_delivery_type", 2)
      }
    }
  }), _vm._v("\n                  店家送餐\n                ")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.tableNumber.sub_delivery_type === 2) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(86), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumber.is_table_no_required),
      expression: "tableNumber.is_table_no_required"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableNumber, "is_table_no_required", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("非必填")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("必填")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.tableNumber.sub_delivery_type === 2) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(87), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumber.is_table_no_editable),
      expression: "tableNumber.is_table_no_editable"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableNumber, "is_table_no_editable", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("不可編輯")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("可編輯")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.tableNumber.sub_delivery_type === 2) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(88), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumber.show_table_no),
      expression: "tableNumber.show_table_no"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableNumber, "show_table_no", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("隱藏")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("顯示")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(89), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, _vm._l((_vm.deliveryWaysInfo), function(deliveryWays, i) {
    return (deliveryWays.take_type === 21) ? _c('div', {
      key: i
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.is_allow_guest_order),
        expression: "deliveryWays.is_allow_guest_order"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": 1,
        "checked": _vm._q(deliveryWays.is_allow_guest_order, 1)
      },
      on: {
        "change": function($event) {
          return _vm.$set(deliveryWays, "is_allow_guest_order", 1)
        }
      }
    }), _vm._v("\n                      開啟\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.is_allow_guest_order),
        expression: "deliveryWays.is_allow_guest_order"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": 0,
        "checked": _vm._q(deliveryWays.is_allow_guest_order, 0)
      },
      on: {
        "change": function($event) {
          return _vm.$set(deliveryWays, "is_allow_guest_order", 0)
        }
      }
    }), _vm._v("\n                      關閉\n                    ")])])]) : _vm._e()
  }), 0)])]), _vm._v(" "), _c('br')]), _vm._v(" "), _vm._l((_vm.deliveryWaysInfo), function(deliveryWays, i) {
    return (deliveryWays.take_type === 21 && deliveryWays.is_allow_guest_order === 1) ? _c('div', {
      key: i
    }, [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(90, true), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.tableNumber.default_login_type),
        expression: "tableNumber.default_login_type"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.tableNumber, "default_login_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": 1
      }
    }, [_vm._v("會員")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 2
      }
    }, [_vm._v("訪客")])])])]), _vm._v(" "), _c('br')]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('div', [_c('h3', [_vm._v("排除設定")])]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('div', [_c('p', [_vm._v("某時間(日期、星期、每月幾號)無法取餐(自取、外送、內用、桌邊掃碼)")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.info) ? _c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addExCalendar
    }
  }, [_vm._v("新增店家排除時段設定")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.exceptionCalendar), function(exCalendar, caIndex) {
    return _c('div', {
      staticClass: "m-t-10 process-time-block"
    }, [_c('div', {
      staticClass: "text-right m-b-10"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.exceptionCalendar, caIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(91, true), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (exCalendar.delivery_type),
        expression: "exCalendar.delivery_type"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(exCalendar, "delivery_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.deliveryInfo), function(delivery) {
      return _c('option', {
        domProps: {
          "value": delivery.value
        }
      }, [_vm._v(_vm._s(delivery.label))])
    }), 0)])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "text-left"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.addExDate(exCalendar)
        }
      }
    }, [_vm._v("加入指定日期")])]), _vm._v(" "), (exCalendar.date_type.length) ? _c('table', {
      staticClass: "table table-bordered table-striped dataTable"
    }, [_vm._m(92, true), _vm._v(" "), _c('tbody', _vm._l((exCalendar.date_type), function(item, daIndex) {
      return _c('tr', [_c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.date),
          expression: "item.date"
        }],
        staticClass: "form-control inline-block",
        attrs: {
          "placeholder": "YYYY-MM-DD",
          "type": "text"
        },
        domProps: {
          "value": (item.date)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "date", $event.target.value)
          }
        }
      }), _vm._v("  \n            ")]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.start_time),
          expression: "item.start_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.start_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "start_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.end_time),
          expression: "item.end_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.end_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "end_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('button', {
        staticClass: "btn btn-danger",
        on: {
          "click": function($event) {
            return _vm.removeListItem(exCalendar.date_type, daIndex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })])])])
    }), 0)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "text-left"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.addExWeekDay(exCalendar)
        }
      }
    }, [_vm._v("加入星期")])]), _vm._v(" "), (exCalendar.week_day.length) ? _c('table', {
      staticClass: "table table-bordered table-striped dataTable"
    }, [_vm._m(93, true), _vm._v(" "), _c('tbody', _vm._l((exCalendar.week_day), function(item, weIndex) {
      return _c('tr', [_c('td', [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.day),
          expression: "item.day"
        }],
        staticClass: "form-control",
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(item, "day", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.offdaySetting.options.weekDay), function(weekDay) {
        return (weekDay.value) ? _c('option', {
          domProps: {
            "value": weekDay.value
          }
        }, [_vm._v("\n                  " + _vm._s(weekDay.label) + "\n                ")]) : _vm._e()
      }), 0)]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.start_time),
          expression: "item.start_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.start_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "start_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.end_time),
          expression: "item.end_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.end_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "end_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('button', {
        staticClass: "btn btn-danger",
        on: {
          "click": function($event) {
            return _vm.removeListItem(exCalendar.week_day, weIndex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })])])])
    }), 0)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "text-left"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.addExMonthDay(exCalendar)
        }
      }
    }, [_vm._v("加入每月幾號")])]), _vm._v(" "), (exCalendar.month_day.length) ? _c('table', {
      staticClass: "table table-bordered table-striped dataTable"
    }, [_vm._m(94, true), _vm._v(" "), _c('tbody', _vm._l((exCalendar.month_day), function(item, moIndex) {
      return _c('tr', [_c('td', [_vm._v("\n              每月"), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.day),
          expression: "item.day"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "DD",
          "type": "text"
        },
        domProps: {
          "value": (item.day)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "day", $event.target.value)
          }
        }
      }), _vm._v("  日\n            ")]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.start_time),
          expression: "item.start_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.start_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "start_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.end_time),
          expression: "item.end_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.end_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "end_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('button', {
        staticClass: "btn btn-danger",
        on: {
          "click": function($event) {
            return _vm.removeListItem(exCalendar.month_day, moIndex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })])])])
    }), 0)]) : _vm._e()])
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "pickupWarnModal",
    staticClass: "btn",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#pickupWarnModal"
    }
  }), _vm._v(" "), _vm._m(95)], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 7),
      expression: "storeMethod === 7"
    }],
    staticClass: "box-body form"
  }, [_vm._m(96), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "overflow": "inherit"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(97), _vm._v(" "), _c('tbody', _vm._l((_vm.openingInfo), function(weekDay) {
    return _c('tr', [_c('td', [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v(_vm._s(_vm.getWeekDayName(weekDay.week_day)))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (weekDay.start),
        expression: "weekDay.start"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "hh:mm",
        "type": "text"
      },
      domProps: {
        "value": (weekDay.start)
      },
      on: {
        "blur": function($event) {
          return _vm.validateTimeRange(weekDay, 'start', 'end')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(weekDay, "start", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (weekDay.end),
        expression: "weekDay.end"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "hh:mm",
        "type": "text"
      },
      domProps: {
        "value": (weekDay.end)
      },
      on: {
        "blur": function($event) {
          return _vm.validateTimeRange(weekDay, 'start', 'end')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(weekDay, "end", $event.target.value)
        }
      }
    })])])
  }), 0)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addSpecialDay
    }
  }, [_vm._v("新增指定日期")])]), _vm._v(" "), (_vm.selectSpecialDay.length) ? _c('div', {
    staticClass: "m-t-10"
  }, [_vm._m(98), _vm._v(" "), _vm._m(99), _vm._v(" "), _c('div', {
    staticClass: "table-responsive specialDayCalendarTable-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_c('thead', {
    staticClass: "bg-primary sticky-header"
  }, [_c('tr', [_c('td', [_vm._v("指定日期")]), _vm._v(" "), _c('td', [_vm._v("營業時間")]), _vm._v(" "), _c('td', [_vm._v("打烊時間")]), _vm._v(" "), _c('td', [_vm._v("備註\n                  "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(100)], 1)]), _vm._v(" "), _c('td')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.selectSpecialDay), function(item, daIndex) {
    return _c('tr', [_c('td', {
      staticClass: "date-picker-cell"
    }, [_c('div', {
      staticClass: "calendar-container"
    }, [(item.showSpecialDayCalendar) ? _c('div', {
      staticClass: "calendar",
      on: {
        "blur": function($event) {
          item.showSpecialDayCalendar = false
        }
      }
    }, [_c('FunctionalCalendar', {
      attrs: {
        "is-multiple-date-picker": true,
        "limits": _vm.calendarLimits
      },
      on: {
        "dayClicked": function($event) {
          return _vm.specialDayCalendarSelected(daIndex, $event)
        }
      },
      model: {
        value: (_vm.tempSpecialDayCalendar),
        callback: function($$v) {
          _vm.tempSpecialDayCalendar = $$v
        },
        expression: "tempSpecialDayCalendar"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "calenderClose"
    }, [_c('button', {
      staticClass: "btn btn-primary btn-xs btn-close",
      on: {
        "click": function($event) {
          item.showSpecialDayCalendar = false
        }
      }
    }, [_vm._v("\n                        關閉\n                      ")])])], 1) : _vm._e(), _vm._v(" "), _c('multiselect', {
      staticClass: "calendar-multiselect",
      attrs: {
        "tag-placeholder": "格式為YYYY-MM-DD",
        "placeholder": "新增日期 (格式為YYYY-MM-DD)",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdaySetting.options.date,
        "multiple": true,
        "optionsLimit": 0,
        "hideSelected": true
      },
      on: {
        "remove": function($event) {
          return _vm.removeTag('specialDay', daIndex, _vm.val)
        },
        "open": function($event) {
          return _vm.openSpecialDayCalendar(daIndex)
        }
      },
      model: {
        value: (item.calendar_list),
        callback: function($$v) {
          _vm.$set(item, "calendar_list", $$v)
        },
        expression: "item.calendar_list"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.start_time),
        expression: "item.start_time"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "hh:mm",
        "type": "text"
      },
      domProps: {
        "value": (item.start_time)
      },
      on: {
        "blur": function($event) {
          return _vm.validateTimeRange(item)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "start_time", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.end_time),
        expression: "item.end_time"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "hh:mm",
        "type": "text"
      },
      domProps: {
        "value": (item.end_time)
      },
      on: {
        "blur": function($event) {
          return _vm.validateTimeRange(item)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "end_time", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "remark-cell"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.remark),
        expression: "item.remark"
      }],
      staticClass: "w-100-p form-control",
      attrs: {
        "rows": "1",
        "maxlength": _vm.specialDayRemarkMaxlength
      },
      domProps: {
        "value": (item.remark)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "remark", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s((item.remark || '').length) + "/" + _vm._s(_vm.specialDayRemarkMaxlength))])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.selectSpecialDay, daIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)])])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(101), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(102), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_off_allow_order),
      expression: "storeInfo.is_off_allow_order"
    }],
    attrs: {
      "type": "radio",
      "name": "isOffAllow"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.is_off_allow_order, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_off_allow_order", 1)
      }
    }
  }), _vm._v("可下單\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_off_allow_order),
      expression: "storeInfo.is_off_allow_order"
    }],
    attrs: {
      "type": "radio",
      "name": "isOffAllow"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.is_off_allow_order, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_off_allow_order", 0)
      }
    }
  }), _vm._v("不可下單\n                ")])])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            指定日期\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "calendar-container"
  }, [(_vm.showCalendar) ? _c('div', {
    staticClass: "calendar",
    on: {
      "blur": function($event) {
        _vm.showCalendar = false
      }
    }
  }, [_c('FunctionalCalendar', {
    attrs: {
      "is-multiple-date-picker": true,
      "limits": _vm.calendarLimits
    },
    on: {
      "dayClicked": _vm.calendarSelected
    },
    model: {
      value: (_vm.selectDate),
      callback: function($$v) {
        _vm.selectDate = $$v
      },
      expression: "selectDate"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "calenderClose"
  }, [(_vm.info) ? _c('button', {
    staticClass: "btn btn-primary btn-xs btn-close",
    on: {
      "click": function($event) {
        _vm.showCalendar = false
      }
    }
  }, [_vm._v("\n                關閉\n              ")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('multiselect', {
    staticClass: "calendar-multiselect",
    attrs: {
      "tag-placeholder": "格式為YYYY-MM-DD",
      "placeholder": "新增日期 (格式為YYYY-MM-DD)",
      "label": "label",
      "track-by": "value",
      "options": _vm.offdaySetting.options.date,
      "multiple": true,
      "optionsLimit": 0,
      "hideSelected": true
    },
    on: {
      "remove": function($event) {
        return _vm.removeTag('date', 0, $event)
      },
      "open": _vm.openDateCalendar
    },
    model: {
      value: (_vm.offdaySetting.date),
      callback: function($$v) {
        _vm.$set(_vm.offdaySetting, "date", $$v)
      },
      expression: "offdaySetting.date"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            每週幾\n          ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "placeholder": "新增日期",
      "label": "label",
      "track-by": "value",
      "options": _vm.offdayWeekDayOptions,
      "multiple": true,
      "allow-empty": true
    },
    model: {
      value: (_vm.offdaySetting.weekDay),
      callback: function($$v) {
        _vm.$set(_vm.offdaySetting, "weekDay", $$v)
      },
      expression: "offdaySetting.weekDay"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            每月幾號\n          ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "tag-placeholder": "數字為1~31",
      "placeholder": "新增日期 (格式為數字1~31)",
      "label": "label",
      "track-by": "value",
      "options": _vm.offdayMonthDayOptions,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addMonthDayTag
    },
    model: {
      value: (_vm.offdaySetting.monthDay),
      callback: function($$v) {
        _vm.$set(_vm.offdaySetting, "monthDay", $$v)
      },
      expression: "offdaySetting.monthDay"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 8),
      expression: "storeMethod === 8"
    }],
    staticClass: "box-body form"
  }, [(_vm.getRoleType === 99 || _vm.getRoleType === 30 || _vm.getRoleType === 10) ? _c('div', [_vm._m(103), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(104), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plasticSelect),
      expression: "plasticSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "plasticOption",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.plasticSelect, "1")
    },
    on: {
      "change": function($event) {
        _vm.plasticSelect = "1"
      }
    }
  }), _vm._v("開啟（此功能需於菜單上架塑膠袋商品方可支援）\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plasticSelect),
      expression: "plasticSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "plasticOption",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.plasticSelect, "0")
    },
    on: {
      "change": function($event) {
        _vm.plasticSelect = "0"
      }
    }
  }), _vm._v("關閉\n                  ")])])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              塑膠袋數量可自行調整\n              "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text",
    domProps: {
      "textContent": _vm._s('消費者可否在購物車中自行調整塑膠袋的數量')
    }
  })])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: " text-left flex align-center"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plasticAmountAdjustable),
      expression: "plasticAmountAdjustable"
    }],
    attrs: {
      "type": "radio",
      "name": "plasticAmountAdjustable",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.plasticAmountAdjustable, "1")
    },
    on: {
      "change": function($event) {
        _vm.plasticAmountAdjustable = "1"
      }
    }
  }), _vm._v("開啟\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plasticAmountAdjustable),
      expression: "plasticAmountAdjustable"
    }],
    attrs: {
      "type": "radio",
      "name": "plasticAmountAdjustable",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.plasticAmountAdjustable, "0")
    },
    on: {
      "change": function($event) {
        _vm.plasticAmountAdjustable = "0"
      }
    }
  }), _vm._v("關閉\n                  ")])])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(105), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number.trim",
      value: (_vm.storeInfo.plastic_unit),
      expression: "storeInfo.plastic_unit",
      modifiers: {
        "number": true,
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.storeInfo.plastic_unit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "plastic_unit", _vm._n($event.target.value.trim()))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            預設勾選塑膠袋\n          ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "placeholder": "選擇取餐方式",
      "label": "label",
      "track-by": "value",
      "options": _vm.deliveryInfo,
      "multiple": true,
      "allow-empty": true
    },
    model: {
      value: (_vm.deliveryWayPlastic),
      callback: function($$v) {
        _vm.deliveryWayPlastic = $$v
      },
      expression: "deliveryWayPlastic"
    }
  })], 1)]), _vm._v(" "), _c('br')])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 10),
      expression: "storeMethod === 10"
    }],
    staticClass: "box-body form"
  }, [_vm._m(106), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.printerStoreList.length) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(107), _vm._v(" "), _c('tbody', _vm._l((_vm.printerStoreList), function(printer, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v("\n                出單機" + _vm._s(printer.printer_id) + "號 (" + _vm._s(printer.printer_id) + ")\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(printer.binding_name) + " (" + _vm._s(printer.binding_id) + ")\n              ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.printerType(printer.printer_type)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(printer.printer_identity))]), _vm._v(" "), _c('td', [(printer.printer_is_enabled) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _vm._e(), _vm._v(" "), (!printer.printer_is_enabled) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("未啟用")]) : _vm._e()]), _vm._v(" "), _c('td', [(printer.binding_is_enabled) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _vm._e(), _vm._v(" "), (!printer.binding_is_enabled) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("未啟用")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#editModal"
      },
      on: {
        "click": function($event) {
          return _vm.getCurrent(printer)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#delModal"
      },
      on: {
        "click": function($event) {
          return _vm.getCurrent(printer)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)]), _vm._v(" "), _c('br')])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(108), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerSelect),
      expression: "printerSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.printerSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("使用現有")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.printerSelect === 1) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(109), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerInfo.identity),
      expression: "printerInfo.identity"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.printerInfo.identity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.printerInfo, "identity", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.printerSelect === 1) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(110), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerInfo.type),
      expression: "printerInfo.type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.printerInfo, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("W牌出單機(1)")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("F牌出單機(2)")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("F牌貼紙機(3)")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.printerSelect === 2) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(111), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isPrinterSelect),
      expression: "isPrinterSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isPrinterSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.printerList), function(printer) {
    return _c('option', {
      domProps: {
        "value": printer.printer_id
      }
    }, [_vm._v(_vm._s(printer.printer_identity))])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.info && _vm.storeMethod === 10) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.checkPrinter
    }
  }, [_vm._v("\n        綁定\n      ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr', {
    staticClass: "m-t-20"
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.printerLayoutSetting.length) ? _c('div', [_vm._m(112), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(113), _vm._v(" "), _c('tbody', _vm._l((_vm.printerLayoutSetting), function(printer, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(printer.layout_name) + "\n                ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (printer.trigger_type),
        expression: "printer.trigger_type"
      }],
      attrs: {
        "type": "radio",
        "name": 'triggerType' + index
      },
      domProps: {
        "value": 1,
        "checked": _vm._q(printer.trigger_type, 1)
      },
      on: {
        "change": function($event) {
          return _vm.$set(printer, "trigger_type", 1)
        }
      }
    }), _vm._v("手動\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (printer.trigger_type),
        expression: "printer.trigger_type"
      }],
      attrs: {
        "type": "radio",
        "name": 'triggerType' + index
      },
      domProps: {
        "value": 2,
        "checked": _vm._q(printer.trigger_type, 2)
      },
      on: {
        "change": function($event) {
          return _vm.$set(printer, "trigger_type", 2)
        }
      }
    }), _vm._v("自動\n                    ")])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (printer.is_enabled),
        expression: "printer.is_enabled"
      }],
      attrs: {
        "type": "radio",
        "name": 'isEnable' + index
      },
      domProps: {
        "value": 1,
        "checked": _vm._q(printer.is_enabled, 1)
      },
      on: {
        "change": function($event) {
          return _vm.$set(printer, "is_enabled", 1)
        }
      }
    }), _vm._v("啟用\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (printer.is_enabled),
        expression: "printer.is_enabled"
      }],
      attrs: {
        "type": "radio",
        "name": 'isEnable' + index
      },
      domProps: {
        "value": 0,
        "checked": _vm._q(printer.is_enabled, 0)
      },
      on: {
        "change": function($event) {
          return _vm.$set(printer, "is_enabled", 0)
        }
      }
    }), _vm._v("未啟用\n                    ")])])])])
  }), 0)]), _vm._v(" "), _c('br')])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 11 && _vm.$route.name !== 'crStore'),
      expression: "storeMethod === 11 && $route.name !== 'crStore'"
    }],
    staticClass: "box-body form"
  }, [_vm._m(114), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(115), _vm._v(" "), _c('div', {
    staticClass: "table-responsive m-b-15"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("入口")]), _vm._v(" "), _c('td', [_vm._v("桌號\n                "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text center"
  }, [_vm._v("\n                    限10字以內，僅限英數大小寫不可符號，桌號間請使用「，」分隔。\n                  ")])], 1)]), _vm._v(" "), _c('td')])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumberUrl.type),
      expression: "tableNumberUrl.type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableNumberUrl, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.enterType), function(item) {
    return _c('option', {
      key: ("enter-" + (item.value)),
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.tableNumberUrl.text),
      expression: "tableNumberUrl.text",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control inline-block",
    attrs: {
      "rows": "3",
      "placeholder": "範例：A01,A02,A03..."
    },
    domProps: {
      "value": (_vm.tableNumberUrl.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tableNumberUrl, "text", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn btn-default btn-table-title",
    on: {
      "click": _vm.exportUrl
    }
  }, [_vm._v("匯出網址")])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 12),
      expression: "storeMethod === 12"
    }],
    staticClass: "box-body form"
  }, [_vm._m(116), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(117), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderCommissionSetting.type),
      expression: "orderCommissionSetting.type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.orderCommissionSetting, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("系統費")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("系統費+資訊服務費抽成")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("資訊服務費抽成")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.orderCommissionSetting.type > 1) ? _c('div', {
    staticClass: "text-left"
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.orderCommissionSetting.item_list.push(JSON.parse(JSON.stringify(_vm.commissionItemList)))
      }
    }
  }, [_vm._v("\n            新增資訊服務費抽成設定\n          ")])]), _vm._v(" "), _vm._l((_vm.orderCommissionSetting.item_list), function(item, pIndex) {
    return _c('div', {
      key: pIndex,
      class: ['process-time-block', {
        'm-t-10': pIndex !== 0
      }, {
        'overlap': _vm.showOverlapErrorIndex.includes(pIndex)
      }]
    }, [_c('div', {
      staticClass: "text-right m-b-10"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.orderCommissionSetting.item_list, pIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(118, true), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.ratio),
        expression: "item.ratio"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "輸入數字",
        "type": "number",
        "maxlength": "2"
      },
      domProps: {
        "value": (item.ratio)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "ratio", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-addon-icon"
    }, [_vm._v("\n                %\n              ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "input-group"
    }, [_vm._m(119, true), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.delivery_type),
        expression: "item.delivery_type"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "delivery_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": 0
      }
    }, [_vm._v("全部")]), _vm._v(" "), _vm._l((_vm.supportDeliveryOption), function(delivery) {
      return _c('option', {
        key: ("takeType" + (delivery.value)),
        domProps: {
          "value": delivery.value
        }
      }, [_vm._v("\n                    " + _vm._s(delivery.label) + "\n                  ")])
    })], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "table-row"
    }, [_vm._m(120, true), _vm._v(" "), _c('div', {
      staticClass: "table-from"
    }, [_c('date-picker', {
      staticClass: "hide-date-icon",
      attrs: {
        "show-second": false,
        "type": "datetime",
        "valueType": "format",
        "format": "YYYY-MM-DD HH:mm",
        "input-class": "form-control",
        "placeholder": "新增日期 (格式為：YYYY-MM-DD HH:mm)",
        "clearable": false,
        "disabled-time": _vm.notBeforeTodayAddTwoMins,
        "disabled-date": _vm.notBeforeToday
      },
      model: {
        value: (item.start_time),
        callback: function($$v) {
          _vm.$set(item, "start_time", $$v)
        },
        expression: "item.start_time"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "table-row p-t-10"
    }, [_vm._m(121, true), _vm._v(" "), _c('div', {
      staticClass: "table-from"
    }, [_c('date-picker', {
      staticClass: "hide-date-icon",
      attrs: {
        "show-second": false,
        "type": "datetime",
        "valueType": "format",
        "format": "YYYY-MM-DD HH:mm",
        "input-class": "form-control",
        "placeholder": "新增日期 (格式為：YYYY-MM-DD HH:mm)",
        "clearable": false,
        "disabled-time": _vm.notBeforeTodayAddTwoMins,
        "disabled-date": _vm.notBeforeToday
      },
      model: {
        value: (item.end_time),
        callback: function($$v) {
          _vm.$set(item, "end_time", $$v)
        },
        expression: "item.end_time"
      }
    })], 1)])])])
  }), _vm._v(" "), _c('br')], 2) : _vm._e(), _vm._v(" "), (_vm.orderCommissionSetting.type !== 1) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(122), _vm._v(" "), _c('div', {
    staticClass: "flex align-center h-34"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.orderCommissionSetting.has_independent_report),
      expression: "orderCommissionSetting.has_independent_report",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "independent"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.orderCommissionSetting.has_independent_report, _vm._n(1))
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.orderCommissionSetting, "has_independent_report", _vm._n(1))
      }
    }
  }), _vm._v("\n                是\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.orderCommissionSetting.has_independent_report),
      expression: "orderCommissionSetting.has_independent_report",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "independent"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.orderCommissionSetting.has_independent_report, _vm._n(0))
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.orderCommissionSetting, "has_independent_report", _vm._n(0))
      }
    }
  }), _vm._v("\n                否\n              ")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.orderCommissionSetting.has_independent_report),
      expression: "!orderCommissionSetting.has_independent_report"
    }],
    staticClass: "process-time-block"
  }, [_vm._m(123), _vm._v(" "), _c('div', {
    staticClass: "input-group m-b-15"
  }, [_vm._m(124), _vm._v(" "), _c('div', {
    staticClass: "flex align-center m-l-15 h-34"
  }, [_vm._v("\n              " + _vm._s(_vm.orderCommissionSetting.brand_setting.quota_type === 1 ? '品牌總' : '每間門市') + "額度\n              "), _c('span', {
    staticClass: "m-l-5",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": _vm.orderCommissionSetting.brand_setting.quota_type === 1 ? '整個品牌的作廢訂單總額度，非單一門市值。' : '每間門市都有指定的作廢額度。例如 : 當額度設定為 5 筆時，每間門市都有 5 筆的作廢額度。'
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(125), _vm._v(" "), _c('div', {
    staticClass: "flex align-center m-l-15 h-34"
  }, [_vm._v("\n              " + _vm._s(_vm.brandInvalidQuota) + "\n            ")])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderCommissionSetting.has_independent_report),
      expression: "orderCommissionSetting.has_independent_report"
    }],
    staticClass: "input-group"
  }, [_vm._m(126), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderCommissionSetting.allow_invalid_order_quota),
      expression: "orderCommissionSetting.allow_invalid_order_quota"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.orderCommissionSetting.allow_invalid_order_quota)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderCommissionSetting, "allow_invalid_order_quota", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 13),
      expression: "storeMethod === 13"
    }],
    staticClass: "box-body form"
  }, [_vm._m(127), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$route.name === 'upStore' && _vm.storeInfo.shipping_info && _vm.storeInfo.shipping_info.mete_store_id) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(128), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pay_party),
      expression: "pay_party"
    }],
    attrs: {
      "type": "radio",
      "name": "brand",
      "disabled": true
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.pay_party, 2)
    },
    on: {
      "change": function($event) {
        _vm.pay_party = 2
      }
    }
  }), _vm._v("\n                  品牌\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pay_party),
      expression: "pay_party"
    }],
    attrs: {
      "type": "radio",
      "name": "brand",
      "disabled": true
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.pay_party, 1)
    },
    on: {
      "change": function($event) {
        _vm.pay_party = 1
      }
    }
  }), _vm._v("\n                  門市\n                ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(129), _vm._v(" "), _c('tbody', _vm._l((_vm.supportShippingVendor), function(vendor, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v("\n                " + _vm._s(_vm._f("shippingVendorName")(vendor.vendor_code)) + "\n              ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group text-left"
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (vendor.is_enable),
        expression: "vendor.is_enable"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": 1,
        "checked": _vm._q(vendor.is_enable, 1)
      },
      on: {
        "input": function($event) {
          _vm.reload = true
        },
        "change": function($event) {
          return _vm.$set(vendor, "is_enable", 1)
        }
      }
    }), _vm._v("\n                      啟用\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (vendor.is_enable),
        expression: "vendor.is_enable"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": 0,
        "checked": _vm._q(vendor.is_enable, 0)
      },
      on: {
        "input": function($event) {
          _vm.reload = true
        },
        "change": function($event) {
          return _vm.$set(vendor, "is_enable", 0)
        }
      }
    }), _vm._v("\n                      不啟用\n                    ")])])])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 14),
      expression: "storeMethod === 14"
    }],
    staticClass: "box-body form"
  }, [_c('h3', {
    domProps: {
      "textContent": _vm._s('服務費設定')
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s('服務費說明')
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text",
    domProps: {
      "textContent": _vm._s('填寫資訊會顯示在前台畫面中。例本店收取服務費10%。')
    }
  })], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.service_fee_description),
      expression: "storeInfo.service_fee_description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "服務費說明設定",
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.storeInfo.service_fee_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "service_fee_description", $event.target.value)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 15),
      expression: "storeMethod === 15"
    }],
    staticClass: "box-body form"
  }, [(_vm.getRoleType === 99 || _vm.getRoleType === 30 || _vm.getRoleType === 10) ? _c('div', [_vm._m(130), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(131), _vm._v(" "), _c('div', {
    staticClass: "flex align-center h-34"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.showTablewareStrawOption),
      expression: "showTablewareStrawOption",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "showTablewareStrawOption"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.showTablewareStrawOption, _vm._n(1))
    },
    on: {
      "change": function($event) {
        _vm.showTablewareStrawOption = _vm._n(1)
      }
    }
  }), _vm._v("開啟\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.showTablewareStrawOption),
      expression: "showTablewareStrawOption",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "showTablewareStrawOption"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.showTablewareStrawOption, _vm._n(0))
    },
    on: {
      "change": function($event) {
        _vm.showTablewareStrawOption = _vm._n(0)
      }
    }
  }), _vm._v("關閉\n                ")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(132), _vm._v(" "), _c('div', {
    staticClass: "flex align-center h-34"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.setTablewareStrawDefaultVal),
      expression: "setTablewareStrawDefaultVal",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "setTablewareStrawDefaultVal"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.setTablewareStrawDefaultVal, _vm._n(1))
    },
    on: {
      "change": function($event) {
        _vm.setTablewareStrawDefaultVal = _vm._n(1)
      }
    }
  }), _vm._v("開啟\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.setTablewareStrawDefaultVal),
      expression: "setTablewareStrawDefaultVal",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "setTablewareStrawDefaultVal"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.setTablewareStrawDefaultVal, _vm._n(0))
    },
    on: {
      "change": function($event) {
        _vm.setTablewareStrawDefaultVal = _vm._n(0)
      }
    }
  }), _vm._v("關閉\n                ")])])])]), _vm._v(" "), _c('br')])]) : _vm._e()]), _vm._v(" "), (![9, 11].includes(_vm.storeMethod)) ? _c('div', {
    staticClass: "box-footer text-center"
  }, [((!_vm.info && _vm.storeMethod === 1) || _vm.info) ? _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.goToStoreTable()
      }
    }
  }, [_vm._v("\n        取消\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.info && _vm.storeMethod !== 1) ? _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.goStep(-1)
      }
    }
  }, [_vm._v("\n        上一步\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.info && _vm.storeMethod !== _vm.crStep[_vm.crStep.length - 1]) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.goStep(1)
      }
    }
  }, [_vm._v("\n        下一步\n      ")]) : (!_vm.info) ? _c('button', {
    staticClass: "btn btn-success",
    class: {
      'disabled': _vm.loading
    },
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.checkBeforeSend('cr')
      }
    }
  }, [_vm._v("\n        新增\n      ")]) : _vm._e(), _vm._v(" "), (_vm.info) ? [(_vm.addressChanged) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#addressModal"
    }
  }, [_vm._v("\n          修改\n        ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkBeforeSend('up')
      }
    }
  }, [_vm._v("\n          修改\n        ")])] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.editOption,
      "selectChange": _vm.selectChange,
      "selectOptions": _vm.selectOptions
    },
    on: {
      "trigger": _vm.trigger,
      "selectOnChange": _vm.selectOnChange,
      "inputOnChange": _vm.inputOnChange
    }
  }), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.leaveOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.addressOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.einOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }, [_c('template', {
    slot: "body"
  }, [_c('div', {
    staticClass: "row ein-row"
  }, [_c('div', {
    staticClass: "col-sm-6 ein-col"
  }, [_c('div', {
    staticClass: "ein-card"
  }, [_c('div', {
    staticClass: "ein-card-title"
  }, [_vm._v("門市基本資訊")]), _vm._v(" "), _c('div', {
    staticClass: "ein-card-item"
  }, [_c('span', {
    staticClass: "ein-card-dot"
  }, [_vm._v("・")]), _vm._v("\n                統一編號\n                "), _c('span', {
    staticClass: "label label-primary"
  }, [_vm._v(_vm._s(_vm.einCheckStoreEin || '無'))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 ein-col"
  }, [_c('div', {
    staticClass: "ein-card"
  }, [_c('div', {
    staticClass: "ein-card-title"
  }, [_vm._v("付款方式")]), _vm._v(" "), _c('div', {
    staticClass: "ein-card-item"
  }, [_c('span', {
    staticClass: "ein-card-dot"
  }, [_vm._v("・")]), _vm._v("\n                金流帳戶統一編號\n              ")]), _vm._v(" "), _c('ol', {
    staticClass: "ein-card-list"
  }, _vm._l((_vm.einCheckList), function(trade, index) {
    return _c('li', {
      key: index
    }, [_vm._v("\n                  " + _vm._s(trade.name) + "\n                  "), _c('span', {
      staticClass: "label label-primary"
    }, [_vm._v(_vm._s(trade.ein || '無'))])])
  }), 0)])])]), _vm._v(" "), _c('p', {
    staticClass: "ein-message"
  }, [_vm._v("\n          您設定的統編不一致，將可能影響款項對帳作業，請問是否仍要儲存？\n        ")])])], 2)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("店家資訊")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              店名\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              店名縮寫\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              群組\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              電話1\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("\n          (圖片大小為200x200)\n          "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("\n          (圖片大小為800x460)\n          "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("店家資訊")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              電話1\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("\n          (圖片大小為200x200)\n          "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("\n          (圖片大小為800x460)\n          "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              API服務類型\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              營業狀態\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              距離計算模式\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              條碼類型\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              金額進位\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              優惠券形式\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              自訂設定顯示方式\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              店家是否開立發票\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              開放紙本發票\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              開放電子載具\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              前端顯示此店家\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              首頁是否搜尋的到店家\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("支援客製餐點貼紙\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("貼紙限制字數\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            單品備註\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("開通門市會員卡\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("單筆訂單最高上限(單位:元)\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("菜單版型\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("飲料溫度顯示(冷 熱 無溫度)\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("菜單產品圖示顯示\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("菜單選項展開類型\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("菜單當日停賣樣式\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("菜單永久停賣樣式\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("菜單0元價格顯示")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("菜單編輯權限")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("菜單同步權限")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n                自訂或複製店家的菜單\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n                自訂或複製店家的別名/描述/警語\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n                自訂或複製店家的圖片庫\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n                加入至門市群組\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n                選擇要加入的群組名稱\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            綁定POS帳號\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("POS帳號")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("密碼")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("POS廠商")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("角色類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("備註")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("啟用")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("動作")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            自訂或複製店家的廣告\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            複製廣告類型\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            選擇店家\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("預訂設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            開始預訂(距今日幾天，0為當日)\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            結束預訂(距開始預訂幾天，0為開始預訂日)\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            自動拒絕預約單時間(單位:分鐘)\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("接單/送單設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n          接單狀態\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            暫停接單理由\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            自動拒單時間(單位:分鐘)\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n          當日訂購時間前下單\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            結束訂購時間後下單\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            距營業時間多久方可訂購(單位:分鐘)\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            距打烊時間多久為最後訂購(單位:分鐘)\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("付款方式")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                    前台顯示畫面，如下方粉色備註區塊\n                    "), _c('img', {
    attrs: {
      "src": "/static/img/trade_remark_ex.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("現金付款設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("取餐方式")]), _vm._v(" "), _c('td', [_vm._v("付款順序")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("取餐方式")]), _vm._v(" "), _c('td', [_vm._v("付款方式")]), _vm._v(" "), _c('td', [_vm._v("起始金額")]), _vm._v(" "), _c('td', [_vm._v("結束金額")]), _vm._v(" "), _c('td', [_vm._v("描述")]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("製作/取餐時間")]), _vm._v(" "), _c('div', [_vm._v("\n          準備時間需設定 3 分鐘以上，取餐時間間隔需設定 10 的倍數\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("取餐類型")]), _vm._v(" "), _c('td', [_vm._v("準備時間")]), _vm._v(" "), _c('td', [_vm._v("取餐時間間隔")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              月份\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              時間類型\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              開始\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              開始\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              結束\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              結束\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              取餐類型\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("開始時間")]), _vm._v(" "), _c('td', [_vm._v("結束時間")]), _vm._v(" "), _c('td', [_vm._v("準備時間")]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("取餐方式/門檻")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 各列設定為群組功能，需將取餐類型的每個規則一併設定後才可進行修改。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text text-align-left"
  }, [_vm._v("\n                    ．計算商品金額 (折扣後) ，不含塑膠袋。"), _c('br'), _vm._v("\n                    ．0元為最低消費金額\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                    顯示在購物車頁面上，消費者可查看，前台顯示畫面，如下方粉色備註區塊\n                    "), _c('img', {
    attrs: {
      "alt": "備註描述圖片",
      "src": "/static/img/delivery_memo_ex.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                    顯示在訂單確認頁面上，消費者可查看，如預覽圖所示。\n                    "), _c('img', {
    attrs: {
      "alt": "取餐提醒圖片",
      "src": "/static/img/delivery_pickup_memo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("外送門檻排除指定商品")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("新增排除商品/套餐後，該商品金額將不納入外送門檻金額計算")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("商品、套餐當中存在相同商品，設定互不影響 (例如：若僅排除商品「珍珠奶茶」，未排除套餐「珍珠奶茶+雞排」，套餐仍會被計算於外送門檻費用中。)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("若您設定了多個相同商品名稱但商品料號不同的商品，前台將會合併顯示為一筆項目，以簡化消費者的瀏覽體驗")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("所有排除項目皆需儲存後，才能使用複製功能")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("無資料")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            送餐方式\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              桌號必填\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              桌號編輯\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              桌號顯示\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              訪客下單\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              預設登入方式\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("排除取餐類型")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("指定日期")]), _vm._v(" "), _c('td', [_vm._v("開始時間")]), _vm._v(" "), _c('td', [_vm._v("結束時間")]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("星期")]), _vm._v(" "), _c('td', [_vm._v("開始時間")]), _vm._v(" "), _c('td', [_vm._v("結束時間")]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("每月幾號")]), _vm._v(" "), _c('td', [_vm._v("開始時間")]), _vm._v(" "), _c('td', [_vm._v("結束時間")]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade text-left",
    attrs: {
      "role": "dialog",
      "id": "pickupWarnModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("提醒")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\n              預設項目不可關閉，請先調整預設的取餐類型\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("確定")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("營業時間")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("星期")]), _vm._v(" "), _c('td', [_vm._v("營業時間")]), _vm._v(" "), _c('td', [_vm._v("打烊時間")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 設定完成後，指定日期將套用此營業時間顯示，期間結束後即恢復預設營業時間。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 若與公休日期重複，會優先顯示指定日期的營業時間。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                    顯示在前台門市營業時間後方，如下範例："), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/specialDay_remark_tooltips.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("公休時間")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("公休時間下單\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("塑膠袋設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                塑膠袋功能\n                "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text alliance-tooltip"
  }, [_vm._v("\n                    「 塑膠袋功能 」將顯示於購車第一步驟，提供消費者選擇。\n                    "), _c('img', {
    attrs: {
      "src": "/static/img/plastic-select-sample-img.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              塑膠袋單位(幾份商品一個塑膠袋)\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("出單機設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("出單機名稱(ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("綁定名稱(ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("辨識碼")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("出單機啟用")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("綁定機啟用")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("方式\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("識別碼\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("類型\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("選擇出單機\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("出單機列印格式設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("列印格式")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("觸發類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("啟用")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("網址設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 若開啟內用-桌邊掃碼取餐類型，門市可利用網址設定功能，新增桌號並獲取各桌獨立網址，將該網址轉為QRCode後即可運用於提供給顧客做桌邊掃碼點餐。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("計費方式設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("選擇計費方式\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("資訊服務費抽成%\n                "), _c('span', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "請勿輸入空格"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("取貨方式\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("抽成生效日\n                "), _c('span', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "系統依據該日期開始計算到資訊服務費抽成報表"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("抽成結束日\n                "), _c('span', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "系統依據該日期停止計算到資訊服務費抽成報表"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("門市獨立產出抽成對帳表")]), _vm._v(" "), _c('span', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "適用於門市獨立簽約的類型"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-left m-b-15"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#leaveModal"
    }
  }, [_vm._v("\n              前往修改\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("額度計算\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("每月作廢訂單額度（筆）\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("門市每月作廢訂單額度（筆）\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("物流設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n          扣款對象\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("配送物流")]), _vm._v(" "), _c('td', [_vm._v("開啟狀態")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("特殊需求")]), _vm._v(" "), _c('div', [_vm._v("請確認POS端是否支援此功能")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              自選吸管或餐具功能\n              "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text alliance-tooltip"
  }, [_vm._v("\n                  「 自選吸管或餐具功能 」 將顯示於購車第一步驟，提供消費者選擇。\n                  "), _c('img', {
    attrs: {
      "src": "/static/img/straw-option-sample-img.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("預設吸管或餐具選項\n            ")])
}]}

/***/ }),
/* 2441 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('router-link', {
    attrs: {
      "to": "/printerTable"
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("返回出單機列表")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/crPrinterStore/' + _vm.$route.params.printer_id
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("新增門市綁定")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    名稱 (ID)\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                    出單機" + _vm._s(_vm.printerInfo.printer_id) + "號 (" + _vm._s(_vm.printerInfo.printer_id) + ")\n                  ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    類型\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                    " + _vm._s(_vm.printerInfo.printer_type) + "\n                  ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    辨識碼\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                    " + _vm._s(_vm.printerInfo.printer_identity) + "\n                  ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    啟用\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.printerInfo.printer_is_enabled) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("啟用")]) : _vm._e(), _vm._v(" "), (!_vm.printerInfo.printer_is_enabled) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("未啟用")]) : _vm._e()])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.storeList), function(store, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": '/printerStore/' + _vm.$route.params.printer_id + '/' + store.store_id
      }
    }, [_vm._v(_vm._s(store.store_name) + " (" + _vm._s(store.store_id) + ")")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(store.binding_name) + " (" + _vm._s(store.binding_id) + ")")]), _vm._v(" "), _c('td', [(store.binding_is_enabled) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _vm._e(), _vm._v(" "), (!store.binding_is_enabled) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("未啟用")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": '/upPrinterStore/' + _vm.$route.params.printer_id + '/' + store.binding_id
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])])], 1)])
  }), 0)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("綁定店名 (ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("綁定名稱 (ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("啟用")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])])
}]}

/***/ }),
/* 2442 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-table"
  }, [_c('div', {
    staticClass: "row vertical-10p"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/404-page-error.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("你迷路了嗎？")]), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-6 col-sm-offset-3"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("請按此返回首頁")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 2443 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "dragBox"
    }
  }, [_c('vue-dropzone', {
    ref: "myVueDropzone",
    attrs: {
      "id": _vm.id,
      "options": _vm.dropzoneOptions,
      "duplicateCheck": true
    },
    on: {
      "vdropzone-file-added": _vm.vfileAdded,
      "vdropzone-success": _vm.vsuccess,
      "vdropzone-error": _vm.verror,
      "vdropzone-removed-file": _vm.vremoved,
      "vdropzone-sending": _vm.vsending,
      "vdropzone-success-multiple": _vm.vsuccessMuliple,
      "vdropzone-sending-multiple": _vm.vsendingMuliple,
      "vdropzone-queue-complete": _vm.vqueueComplete,
      "vdropzone-total-upload-progress": _vm.vprogress,
      "vdropzone-mounted": _vm.vmounted,
      "vdropzone-drop": _vm.vddrop,
      "vdropzone-drag-start": _vm.vdstart,
      "vdropzone-drag-end": _vm.vdend,
      "vdropzone-drag-enter": _vm.vdenter,
      "vdropzone-drag-over": _vm.vdover,
      "vdropzone-drag-leave": _vm.vdleave,
      "vdropzone-duplicate-file": _vm.vdduplicate
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2444 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('discount-info', {
    attrs: {
      "isUp": _vm.isUp
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 2445 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box text-center"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-xs-12 text-left"
  }, [_c('button', {
    staticClass: "btn btn-default m-y-10 inline-block",
    on: {
      "click": _vm.clearCId
    }
  }, [_vm._v("\n                新增門市群組\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger pull-right m-y-10 ",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    },
    on: {
      "click": _vm.delModalOpen
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-2 bg-light-gray select-element-block text-left"
  }, _vm._l((_vm.storeClassList), function(storeClass, index) {
    return _c('div', {
      staticClass: "select-element",
      class: {
        'active': _vm.curId === storeClass.id
      },
      on: {
        "click": function($event) {
          return _vm.clickOption(storeClass)
        }
      }
    }, [_c('span', {
      staticClass: "text-w-600"
    }, [_vm._v(_vm._s(storeClass.name))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-10"
  }, [_c('div', {
    staticClass: "box-body",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "row m-b-15"
  }, [_c('div', {
    staticClass: "row center-block text-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.name),
      expression: "info.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.info.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('h5', [_vm._v("選擇門市")]), _vm._v(" "), _c('muti-select-two', {
    attrs: {
      "setting": _vm.addStoresSetting,
      "reNew": _vm.reNew,
      "reSet": _vm.reSet
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n                    取消\n                  ")]), _vm._v(" "), (!_vm.curId) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkStoreClass(1)
      }
    }
  }, [_vm._v("\n                    新增\n                  ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkStoreClass(2)
      }
    }
  }, [_vm._v("\n                    編輯\n                  ")])])])])])])])])]), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("門市群組名稱")])
}]}

/***/ }),
/* 2446 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', [(_vm.activity.strategy_data.rule_code === 'SA00001') ? _c('h4', [_vm._v("消費金額滿額")]) : (_vm.activity.strategy_data.rule_code === 'SA00002') ? _c('h4', [_vm._v("消費商品數量滿額")]) : (_vm.activity.strategy_data.rule_code === 'SA00003') ? _c('h4', [_vm._v("指定商品滿額")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-center"
  }, [(_vm.activity.strategy_data.rule_code === 'SA00001') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.setting.money_unit),
      expression: "activity.strategy_data.setting.money_unit"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "贈送條件達成金額",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.setting.money_unit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.setting, "money_unit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.rule_code === 'SA00002' || _vm.activity.strategy_data.rule_code === 'SA00003') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.setting.amount_unit),
      expression: "activity.strategy_data.setting.amount_unit"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "贈送條件達成商品數",
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.setting.amount_unit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.setting, "amount_unit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.rule_code === 'SA00002') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品限制最低單價(單位：元)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.setting.lowest_unit_price),
      expression: "activity.strategy_data.setting.lowest_unit_price"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "商品限制最低單價",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.setting.lowest_unit_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.setting, "lowest_unit_price", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("每次贈送最大份數")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.setting.max_count),
      expression: "activity.strategy_data.setting.max_count"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "每次贈送最大份數",
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.setting.max_count)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.setting, "max_count", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr', {
    staticClass: "box-body"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  訂單類型\n                ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.orderType,
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": "訂單類型",
      "show-labels": false,
      "multiple": true,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.strategy_data.limit.order_type),
      callback: function($$v) {
        _vm.$set(_vm.activity.strategy_data.limit, "order_type", $$v)
      },
      expression: "activity.strategy_data.limit.order_type"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  訂單方案\n                ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.orderMethod,
      "searchable": true,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": "訂單方案",
      "show-labels": false,
      "multiple": true,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.strategy_data.limit.order_method),
      callback: function($$v) {
        _vm.$set(_vm.activity.strategy_data.limit, "order_method", $$v)
      },
      expression: "activity.strategy_data.limit.order_method"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("訂單最低應付金額(單位：元)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.limit.min_total_paid_money),
      expression: "activity.strategy_data.limit.min_total_paid_money"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "包含扣除折價",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.limit.min_total_paid_money)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.limit, "min_total_paid_money", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("訂單最低總金額(單位：元)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.limit.min_total_money),
      expression: "activity.strategy_data.limit.min_total_money"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.limit.min_total_money)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.limit, "min_total_money", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("訂單最低購買數(單位：個)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.limit.min_total_amount),
      expression: "activity.strategy_data.limit.min_total_amount"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.limit.min_total_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.limit, "min_total_amount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  取貨方式\n                ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.deliveryType,
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": "取貨方式",
      "show-labels": false,
      "multiple": true,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.strategy_data.limit.delivery_type),
      callback: function($$v) {
        _vm.$set(_vm.activity.strategy_data.limit, "delivery_type", $$v)
      },
      expression: "activity.strategy_data.limit.delivery_type"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  付款地點\n                ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.payPlaceType,
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": "付款地點",
      "show-labels": false,
      "multiple": true,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.strategy_data.limit.pay_place_type),
      callback: function($$v) {
        _vm.$set(_vm.activity.strategy_data.limit, "pay_place_type", $$v)
      },
      expression: "activity.strategy_data.limit.pay_place_type"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制主單(或團長)最低總金額(單位：元)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.limit.min_money),
      expression: "activity.strategy_data.limit.min_money"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.limit.min_money)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.limit, "min_money", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制主單(或團長)最低購買數(單位：個)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.limit.min_amount),
      expression: "activity.strategy_data.limit.min_amount"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.limit.min_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.limit, "min_amount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制子單(跟團單)最低訂單數(單位：筆)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.limit.min_sub_order_amount),
      expression: "activity.strategy_data.limit.min_sub_order_amount"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.limit.min_sub_order_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.limit, "min_sub_order_amount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-center",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制主單(或團長)最低應付金額(單位：元)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.limit.min_paid_money),
      expression: "activity.strategy_data.limit.min_paid_money"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "包含扣除折價",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.limit.min_paid_money)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.limit, "min_paid_money", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr', {
    staticClass: "box-body"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [(_vm.ruleCode === 'SA00001' || _vm.ruleCode === 'SA00002') ? _c('h5', [_vm._v("例外商品選擇")]) : _c('h5', [_vm._v("指定商品選擇")])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [(_vm.ruleCode === 'SA00003') ? _c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]) : _vm._e(), _vm._v("選擇參與店家菜單")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.storeList,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "店家",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.ruleCode === 'SA00001') ? _c('menu-discount', {
    attrs: {
      "menuId": _vm.menuSelect.value,
      "showWord": '排除'
    },
    on: {
      "addProdToList": _vm.addExProdToList
    }
  }) : (_vm.ruleCode === 'SA00002') ? _c('menu-discount', {
    attrs: {
      "menuId": _vm.menuSelect.value,
      "showWord": '加入'
    },
    on: {
      "addProdToList": _vm.addExProdToList2
    }
  }) : (_vm.ruleCode === 'SA00003') ? _c('menu-discount', {
    attrs: {
      "menuId": _vm.menuSelect.value,
      "showWord": '排除'
    },
    on: {
      "addProdToList": _vm.addProdToList
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.store_exception_items[0].products.length && (_vm.ruleCode === 'SA00001' || _vm.ruleCode === 'SA00002')) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.activity.strategy_data.store_exception_items[0].products), function(aProduct, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n              " + _vm._s(aIndex + 1) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(aProduct.product_name) + "\n            ")]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(aProduct.vendor_custom_id))])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.activity.strategy_data.store_exception_items[0].products, aIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.setting.vendor_custom_product_list.length && _vm.ruleCode === 'SA00003') ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.activity.strategy_data.setting.vendor_custom_product_list), function(aProduct, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n              " + _vm._s(aIndex + 1) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(aProduct.product_name) + "\n            ")]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(aProduct.vendor_custom_id))])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.activity.strategy_data.setting.vendor_custom_product_list, aIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)])]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("贈送條件達成金額(單位：元)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("贈送條件達成商品數(單位：個)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', [_c('h4', [_vm._v("限制規則")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品")]), _vm._v(" "), _c('td', [_vm._v("商品料號")]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品")]), _vm._v(" "), _c('td', [_vm._v("商品料號")]), _vm._v(" "), _c('td')])])
}]}

/***/ }),
/* 2447 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('ad-table')], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("廣告列表")])])
}]}

/***/ }),
/* 2448 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vfc-day"
  }, [(_vm.startActive) ? _c('div', {
    staticClass: "vfc-base-start"
  }) : _vm._e(), _vm._v(" "), (_vm.endActive) ? _c('div', {
    staticClass: "vfc-base-end"
  }) : _vm._e(), _vm._v(" "), (!_vm.day.hideLeftAndRightDays) ? _c('span', {
    class: _vm.getClassNames(_vm.day),
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.$parent.$parent.clickDay(_vm.day, _vm.isDisabledDate)
      },
      "mouseover": _vm.dayMouseOver
    }
  }, [_vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.day.day))]
  }, {
    "week": _vm.week,
    "day": _vm.day
  }), _vm._v(" "), (_vm.timesShow) ? _c('span', {
    staticClass: "times",
    on: {
      "click": _vm.clearRange
    }
  }, [_vm._v("×")]) : _vm._e(), _vm._v(" "), (_vm.numberShow) ? _c('span', {
    staticClass: "number",
    on: {
      "mouseover": function($event) {
        _vm.toolTip && (_vm.onNumber = true)
      },
      "mouseleave": function($event) {
        _vm.onNumber = false
      }
    }
  }, [_vm._v(_vm._s(_vm.getDaysNumber) + "\n      "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toolTip && _vm.onNumber),
      expression: "toolTip && onNumber"
    }],
    staticClass: "toolTip"
  }, [_vm._v("\n        " + _vm._s(_vm.toolTipTxt().join(' ')) + "\n      ")])]) : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2449 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('router-link', {
    attrs: {
      "to": "/crDesignated"
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("新增特約")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.brandBrief.length > 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandSelect),
      expression: "brandSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.brandSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.brandBrief), function(brand) {
    return _c('option', {
      domProps: {
        "value": brand.value
      }
    }, [_vm._v("\n            " + _vm._s(brand.label) + "\n          ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.brandSelect !== 0 && _vm.brandSelect !== '0' && _vm.storeBrief.length > 1 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeSelect),
      expression: "storeSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.storeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("== 門市 ==")]), _vm._v(" "), _vm._l((_vm.storeBrief), function(store) {
    return _c('option', {
      domProps: {
        "value": store.value
      }
    }, [_vm._v("\n            " + _vm._s(store.label) + "\n          ")])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.typeSelect),
      expression: "typeSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.typeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.typeList), function(type) {
    return _c('option', {
      domProps: {
        "value": type.value
      }
    }, [_vm._v("\n            " + _vm._s(type.label) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ownerSelect),
      expression: "ownerSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ownerSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.ownerList), function(owner) {
    return _c('option', {
      domProps: {
        "value": owner.value
      }
    }, [_vm._v("\n            " + _vm._s(owner.label) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchSelect),
      expression: "searchSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("單位名稱")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("廠區名稱")])])]), _vm._v(" "), (_vm.searchSelect == 1) ? _c('div', {
    staticClass: "form-group input-group time-box"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unit),
      expression: "unit"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.unit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.unit = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.search(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.searchSelect == 2) ? _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.branch),
      expression: "branch"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.branch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.branch = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.search(2)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("特約單位 (ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("廠區名稱")]), _vm._v(" "), (_vm.roleType === 99) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("品牌(ID)")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99 || _vm.roleType === 30) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("分店(ID)")]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("擁有者")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("統一編號")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("建立時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])]), _vm._v(" "), (_vm.designatedList) ? _c('tbody', _vm._l((_vm.designatedList), function(designated, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(designated.unit) + " (" + _vm._s(designated.id) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(designated.branch))]), _vm._v(" "), (_vm.roleType === 99) ? _c('td', [_vm._v(_vm._s(designated.brand_name) + "(" + _vm._s(designated.brand_id) + ")")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99 || _vm.roleType === 30) ? _c('td', [(designated.store_id) ? _c('span', [_vm._v(_vm._s(designated.store_name) + "(" + _vm._s(designated.store_id) + ")")]) : _c('span', [_vm._v("全部")])]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.ownerName(designated.owner)) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(designated.ein))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getTime(designated.create_time)))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": '/upDesignated/' + designated.brand_id + '/' + designated.id
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])])], 1)])
  }), 0) : _vm._e()])])])])
},staticRenderFns: []}

/***/ }),
/* 2450 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "btn btn-default",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#trade-apply-store-modal"
    },
    domProps: {
      "textContent": _vm._s('新增門市申請網址')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn btn-default",
    domProps: {
      "textContent": _vm._s('批次啟用')
    },
    on: {
      "click": function($event) {
        _vm.formType = !_vm.formType
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brands,
      "searchable": true,
      "allow-empty": true,
      "close-on-select": true,
      "placeholder": "== 品牌 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.select.brand),
      callback: function($$v) {
        _vm.$set(_vm.select, "brand", $$v)
      },
      expression: "select.brand"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.stores,
      "searchable": true,
      "allow-empty": true,
      "close-on-select": true,
      "placeholder": "== 門市 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.select.store),
      callback: function($$v) {
        _vm.$set(_vm.select, "store", $$v)
      },
      expression: "select.store"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.select.trade_type),
      expression: "select.trade_type"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.select, "trade_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 999
    }
  }, [_vm._v("== 金流 ==")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 720
    }
  }, [_vm._v("icash Pay")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.select.status),
      expression: "select.status"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.select, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 999
    }
  }, [_vm._v("== 申請狀態 ==")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("產出網址")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("審核完成")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("已完成")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.select.is_enable),
      expression: "select.is_enable"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.select, "is_enable", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 999
    }
  }, [_vm._v("== 啟用狀態 ==")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("未啟用")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("啟用")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-auto text-right"
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title",
    attrs: {
      "disabled": _vm.isDownloading
    },
    on: {
      "click": function($event) {
        return _vm.exportFile()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v("\n                  下載報表\n                  "), _c('clip', {
    staticClass: "cliploading",
    attrs: {
      "loading": _vm.isDownloading,
      "color": '#528BB8',
      "size": '16px'
    }
  })], 1)]), _vm._v(" "), (_vm.formType) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-auto"
  }, [_c('div', {
    staticClass: "betch-btns"
  }, [_c('div', {
    staticClass: "btn btn-default m-r-5",
    domProps: {
      "textContent": _vm._s('取消')
    },
    on: {
      "click": function($event) {
        return _vm.setBetch(0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn btn-success",
    domProps: {
      "textContent": _vm._s('啟用')
    },
    on: {
      "click": function($event) {
        return _vm.setBetch(1)
      }
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [(_vm.formType) ? _c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkBoxSelectAll),
      expression: "checkBoxSelectAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkBoxSelectAll) ? _vm._i(_vm.checkBoxSelectAll, null) > -1 : (_vm.checkBoxSelectAll)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.checkBoxSelectAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkBoxSelectAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkBoxSelectAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkBoxSelectAll = $$c
        }
      }, _vm.selectAll]
    }
  })]) : _vm._e(), _vm._v(" "), _c('th', {}, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "w-text"
  }, [_vm._v("品牌")]), _vm._v(" "), _c('th', {
    staticClass: "w-text"
  }, [_vm._v("門市（ID）")]), _vm._v(" "), _c('th', {
    staticClass: "w-text"
  }, [_vm._v("申請狀態")]), _vm._v(" "), _c('th', {
    staticClass: "w-text"
  }, [_vm._v("啟用")]), _vm._v(" "), _c('th', {
    staticClass: "w-url"
  }, [_vm._v("申請網址")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.list), function(item, k) {
    return _c('tr', {
      key: item.id
    }, [(_vm.formType) ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.selectItem),
        expression: "item.selectItem"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.selectItem) ? _vm._i(item.selectItem, null) > -1 : (item.selectItem)
      },
      on: {
        "change": function($event) {
          var $$a = item.selectItem,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "selectItem", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "selectItem", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "selectItem", $$c)
          }
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(k + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.brand_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.store_name) + " (" + _vm._s(item.store_id) + ")")]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "label",
      class: _vm.handleStatus(item.status).class
    }, [_vm._v("\n                          " + _vm._s(_vm.handleStatus(item.status).text) + "\n                        ")])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "label",
      class: _vm.handleIsEnable(item.is_enable).class
    }, [_vm._v("\n                          " + _vm._s(_vm.handleIsEnable(item.is_enable).text) + "\n                        ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-url"
    }, [_c('div', {
      staticClass: "row align-center"
    }, [_c('div', {
      staticClass: "col control-url"
    }, [_vm._v(_vm._s(item.url))]), _vm._v(" "), _c('div', {
      staticClass: "col-auto"
    }, [_c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (item.url),
        expression: "item.url",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.onCopy),
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.onError),
        expression: "onError",
        arg: "error"
      }],
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button"
      },
      domProps: {
        "textContent": _vm._s('複製')
      }
    })])])])])
  }), _vm._v(" "), (!_vm.list || !_vm.list.length) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12"
    }
  }, [_c('div', {
    staticClass: "no-data"
  }, [_c('img', {
    staticClass: "center-block no-data-img",
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "textContent": _vm._s('沒有符合的資料')
    }
  })])])]) : _vm._e()], 2)])]), _vm._v(" "), _c('paginate', {
    attrs: {
      "clickPage": _vm.paginateClickPage,
      "groupAmount": _vm.paginate.groupAmount,
      "isActive": _vm.paginateIsActive,
      "pageAmount": _vm.paginateAmount,
      "total": _vm.paginate.total
    }
  })], 1)])])])])]), _vm._v(" "), _c('nd-modal', {
    attrs: {
      "option": _vm.optionConfigApplyStoreModal
    },
    on: {
      "trigger": _vm.trigger
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function() {
        return [_c('nd-trade-apply-store', {
          attrs: {
            "brands": _vm.brands,
            "getDataH": _vm.getDataH,
            "tradeType": _vm.select.trade_type
          },
          on: {
            "update:choose": _vm.updateChoose
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('nd-modal', {
    attrs: {
      "option": _vm.optionsConfCheckedBetchStore
    },
    on: {
      "trigger": _vm.trigger
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function() {
        return [_vm._v("\n      確定啟用門市？\n    ")]
      },
      proxy: true
    }])
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "tips"
  }, [_c('div', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n                        請注意：merchant ID 若是已有設定過，會覆蓋原先設定的 ID。\n                      ")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n                        請選取欲批次啟用的門市（僅有產出網址狀態無法啟用）。\n                      ")])])])
}]}

/***/ }),
/* 2451 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body form"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('h3', {
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  })])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row fit gutter mx-auto"
  }, [_c('div', {
    staticClass: "col-md-6 gutter"
  }, [_c('div', {
    staticClass: "table-row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "table-from"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adInfo.name),
      expression: "adInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.adInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adInfo, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.bannerType === 41) ? _c('div', {
    staticClass: "table-row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "table-from"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adInfo.is_active),
      expression: "adInfo.is_active"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.adInfo, "is_active", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("啟用")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("停用")])])])]) : _vm._e(), _vm._v(" "), (_vm.bannerType !== 41) ? _c('div', {
    staticClass: "table-row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "table-from"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adInfo.sort),
      expression: "adInfo.sort"
    }],
    ref: "sort",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "maxlength": "99",
      "type": "tel"
    },
    domProps: {
      "value": (_vm.adInfo.sort)
    },
    on: {
      "keyup": _vm.veritySort,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adInfo, "sort", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "table-from"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adInfo.is_platform_visible),
      expression: "adInfo.is_platform_visible"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.adInfo, "is_platform_visible", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("啟用")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("停用")])])])]), _vm._v(" "), (_vm.bannerType !== 41) ? _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "table-cell"
  }, [_vm._v("\n            連結\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "table-from"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adInfo.url),
      expression: "adInfo.url"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.adInfo.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adInfo, "url", $event.target.value)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "table-row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "table-from"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.timeoption,
      "limit": _vm.startLimit
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "table-from"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.timeoption,
      "limit": _vm.endLimit
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "table-from"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adInfo.is_jkos_visible),
      expression: "adInfo.is_jkos_visible"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.adInfo, "is_jkos_visible", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("啟用")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("停用")])])])]), _vm._v(" "), (_vm.bannerType !== 41) ? _c('div', {
    staticClass: "table-row"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "table-from"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adInfo.foreverShow),
      expression: "adInfo.foreverShow"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.adInfo, "foreverShow", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")])])])]) : _vm._e()]), _vm._v(" "), (_vm.bannerType !== 41) ? _c('div', {
    staticClass: "col-xs-12 input-group m-b-10"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("廣告地區\n          "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(8)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-0 p-5 text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adInfo.is_limit_location),
      expression: "adInfo.is_limit_location"
    }],
    attrs: {
      "type": "radio",
      "name": "invoiceOption"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.adInfo.is_limit_location, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.adInfo, "is_limit_location", 0)
      }
    }
  }), _vm._v("不限制\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adInfo.is_limit_location),
      expression: "adInfo.is_limit_location"
    }],
    attrs: {
      "type": "radio",
      "name": "invoiceOption"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.adInfo.is_limit_location, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.adInfo, "is_limit_location", 1)
      }
    }
  }), _vm._v("指定區域\n            ")])])])]) : _vm._e(), _vm._v(" "), (_vm.adInfo.is_limit_location) ? _c('div', {
    staticClass: "col-xs-12 input-group m-b-10"
  }, [_vm._m(9), _vm._v(" "), _c('multiselect', {
    staticClass: "min-w-150",
    attrs: {
      "options": _vm.getCityOption,
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "show-labels": false,
      "placeholder": "",
      "multiple": true,
      "label": "name",
      "track-by": "code"
    },
    model: {
      value: (_vm.adInfo.city_code_list),
      callback: function($$v) {
        _vm.$set(_vm.adInfo, "city_code_list", $$v)
      },
      expression: "adInfo.city_code_list"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 input-group"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0 bg-white",
    staticStyle: {
      "border-right": "none"
    }
  }, [_c('span', {
    staticClass: "inline-block h-auto m-t-5"
  }, [(!_vm.adInfo.image_web_file) ? _c('img', {
    staticClass: "img-responsive h-auto",
    attrs: {
      "src": _vm.defaultImage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.adInfo.image_web_file) ? _c('img', {
    staticClass: "h-auto img-responsive",
    attrs: {
      "src": _vm.adInfo.image_web_file,
      "data-toggle": "modal"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [_c('div', [_c('label', {
    staticClass: "btn-upload btn btn-default m-t-25",
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "for": "brand-img-load"
    }
  }, [_vm._v("\n              選擇圖片\n            ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "brand-img-load"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right text-15 text-red",
    domProps: {
      "textContent": _vm._s(_vm.tipsImage)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n      取消\n    ")]), _vm._v(" "), (!_vm.info) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkBeforeSend('cr')
      }
    }
  }, [_vm._v("\n      新增\n    ")]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkBeforeSend('up')
      }
    }
  }, [_vm._v("\n      修改\n    ")]) : _vm._e()]), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("名稱\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("啟用\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("排序\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("你訂平台\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("開始時間\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("結束時間\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("街口平台\n            "), _c('span', {
    staticClass: "tip-icon",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "與街口支付APP合作之你訂獨家功能，有興趣可洽業務窗口。若未簽約合作請勿啟用。"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("永久顯示\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text center"
  }, [_vm._v("\n              *依據消費者位置指定廣告要出現的縣市(目前限台灣地區)。"), _c('br'), _vm._v("\n              *若無法判斷位置或在非台灣地區，則預設都顯示。\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("指定區域\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("圖片\n        ")])
}]}

/***/ }),
/* 2452 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box form-inline"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('router-link', {
    attrs: {
      "to": '/printerInfo/' + _vm.$route.params.printer_id
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("返回出單機資訊")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.printerList), function(printer, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v("\n                    出單機" + _vm._s(printer.printer_id) + "號 (" + _vm._s(printer.printer_id) + ")\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(printer.binding_name) + " (" + _vm._s(printer.binding_id) + ")\n                  ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.printerType(printer.printer_type)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(printer.printer_identity))]), _vm._v(" "), _c('td', [(printer.printer_is_enabled) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _vm._e(), _vm._v(" "), (!printer.printer_is_enabled) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("未啟用")]) : _vm._e()]), _vm._v(" "), _c('td', [(printer.binding_is_enabled) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _vm._e(), _vm._v(" "), (!printer.binding_is_enabled) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("未啟用")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": '/upPrinterStore/' + printer.printer_id + '/' + printer.binding_id
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])])], 1)])
  }), 0)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("出單機名稱(ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("綁定名稱(ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("辨識碼")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("出單機啟用")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("綁定機啟用")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])])
}]}

/***/ }),
/* 2453 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [(!_vm.packageList.length) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._v("\n    無套餐，請新增\n  ")]) : _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-danger m-y-10 inline-block pull-right",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    },
    on: {
      "click": _vm.delModalOpen
    }
  }, [_vm._v("\n          刪除\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-black m-y-10 inline-block pull-right m-r-10",
    on: {
      "click": _vm.gotoCrPackages
    }
  }, [_vm._v("\n          新增\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-black m-y-10 inline-block pull-right m-r-10",
    attrs: {
      "data-toggle": "modal"
    },
    on: {
      "click": function($event) {
        _vm.show.easy = !_vm.show.easy
      }
    }
  }, [(!_vm.show.easy) ? _c('span', [_vm._v("簡易")]) : _c('span', [_vm._v("進階")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-2 text-left"
  }, [_c('div', {
    staticClass: "bg-light-gray select-element-block ",
    staticStyle: {
      "max-height": "calc(100vh - 396px)",
      "margin-left": "0px",
      "margin-right": "0px",
      "width": "100%"
    }
  }, _vm._l((_vm.packageList), function(package, index) {
    return _c('div', {
      staticClass: "select-element",
      class: {
        'active': _vm.curId === package.item_id
      },
      attrs: {
        "disabled": _vm.isLoad || _vm.curId === package.item_id
      },
      on: {
        "click": function($event) {
          return _vm.clickPackage(package, index)
        }
      }
    }, [_c('span', {
      staticClass: "text-w-600"
    }, [_vm._v(_vm._s(package.name))]), _vm._v(" "), _c('small', {
      staticStyle: {
        "opacity": ".7"
      }
    }, [_vm._v("  " + _vm._s(package.remark))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-10"
  }, [_c('div', {
    staticClass: "box-body form menu-form col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6 p-r-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageInfo.name),
      expression: "packageInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "32"
    },
    domProps: {
      "value": (_vm.packageInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.packageInfo, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageInfo.sort),
      expression: "packageInfo.sort"
    }],
    ref: "sort",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.packageInfo.sort)
    },
    on: {
      "keyup": _vm.veritySort,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.packageInfo, "sort", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageInfo.price),
      expression: "packageInfo.price"
    }],
    ref: "price",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.packageInfo.price)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityPrice()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.packageInfo, "price", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageInfo.min_limit),
      expression: "packageInfo.min_limit"
    }],
    ref: "minLimit",
    staticClass: "c-auto form-control",
    staticStyle: {
      "width": "calc(50% - 10px)"
    },
    attrs: {
      "placeholder": "0為無上限",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.packageInfo.min_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityMinLimit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.packageInfo, "min_limit", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "line-height": "38px",
      "width": "20px"
    }
  }, [_vm._v("~")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageInfo.max_limit),
      expression: "packageInfo.max_limit"
    }],
    ref: "maxLimit",
    staticClass: "c-auto form-control",
    staticStyle: {
      "width": "calc(50% - 10px)"
    },
    attrs: {
      "placeholder": "0為無上限",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.packageInfo.max_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityMaxLimit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.packageInfo, "max_limit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageInfo.remark),
      expression: "packageInfo.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.packageInfo.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.packageInfo, "remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show.easy),
      expression: "!show.easy"
    }],
    staticClass: "col-xs-12 col-md-6 p-l-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageInfo.price_type),
      expression: "packageInfo.price_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.packageInfo, "price_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("免稅價格")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("含稅價格")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageInfo.description),
      expression: "packageInfo.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.packageInfo.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.packageInfo, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品料號")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageInfo.vendor_custom_id),
      expression: "packageInfo.vendor_custom_id"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.packageInfo.vendor_custom_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.packageInfo, "vendor_custom_id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("選擇區")]), _vm._v(" "), _c('div', {
    staticClass: "form-control text-left",
    staticStyle: {
      "min-height": "60px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default btn-black m-y-10 inline-block ",
    staticStyle: {
      "position": "absolute",
      "right": "10px",
      "top": "0px",
      "z-index": "3"
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#choseModal"
    }
  }, [_vm._v("\n                  選擇選擇區\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "option-left-block"
  }, _vm._l((_vm.blockList), function(block) {
    return (block.active) ? _c('div', {
      staticClass: "inline-block m-r-10 option-chose",
      staticStyle: {
        "margin": "5px"
      }
    }, [_vm._v("\n                    " + _vm._s(block.name) + "\n                  ")]) : _vm._e()
  }), 0)])]), _vm._v(" "), _c('br')])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.gotoOut
    }
  }, [_vm._v("\n      返回\n    ")]), _vm._v(" "), (!_vm.packageList.length) ? _c('button', {
    staticClass: "btn btn-default btn-black",
    on: {
      "click": _vm.gotoCrPackages
    }
  }, [_vm._v("\n      新增\n    ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.checkInputEmpty
    }
  }, [_vm._v("\n      儲存\n    ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('c-modal', {
    attrs: {
      "elementList": _vm.blockList,
      "option": _vm.choseOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline-block pull-left"
  }, [_c('h4', {
    staticClass: "pull-left"
  }, [_vm._v("\n        套餐\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("套餐名稱")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("排"), _c('div', {
    staticClass: "inline-block w-35"
  }), _vm._v("序")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("價"), _c('div', {
    staticClass: "inline-block w-35"
  }), _vm._v("格")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("選購數量"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("備"), _c('div', {
    staticClass: "inline-block w-35"
  }), _vm._v("註")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("價格類型")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("描"), _c('div', {
    staticClass: "inline-block w-35"
  }), _vm._v("述")])
}]}

/***/ }),
/* 2454 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [(_vm.getRoleType === 99) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [(_vm.$route.name == 'brandTable') ? _c('div', {
    staticClass: "form-group text-left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/crBrand'
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("\n            新增品牌\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-default btn-table-title",
    attrs: {
      "disabled": _vm.show.isDownloading
    },
    on: {
      "click": function($event) {
        return _vm.exportFile()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v("\n          下載報表\n          "), _c('clip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.isDownloading),
      expression: "show.isDownloading"
    }],
    staticClass: "cliploading",
    attrs: {
      "loading": _vm.show.isDownloading,
      "color": '#528BB8',
      "size": '16px'
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-offset-6 col-sm-6 text-right"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchResult),
      expression: "searchResult"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchResult)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchResult = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.clickPage(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchResult),
      expression: "searchResult"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchResult)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchResult = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.clickPage(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("品牌")]), _vm._v(" "), _c('th', [_vm._v("名稱（ID）")]), _vm._v(" "), (_vm.show.brand) ? _c('th', [_vm._v("縮寫")]) : _vm._e(), _vm._v(" "), (!_vm.show.menuDetail) ? _c('th', [_vm._v("代碼(鍵值)")]) : _vm._e(), _vm._v(" "), (_vm.show.brand && _vm.getRoleType === 99) ? _c('th', [_vm._v("\n              門市數量\n              "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.show.brand || _vm.show.history) ? _c('th', [_vm._v("狀態")]) : _vm._e(), _vm._v(" "), (_vm.show.brand || _vm.show.history) ? _c('th', [_vm._v("前端")]) : _vm._e(), _vm._v(" "), (_vm.show.brand || _vm.show.history) ? _c('th', [_vm._v("刪除狀態")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("你訂聯盟")]), _vm._v(" "), (_vm.show.brand && _vm.getRoleType === 99) ? _c('th', [_vm._v("群組")]) : _vm._e(), _vm._v(" "), (_vm.show.brand && _vm.getRoleType !== 10 && _vm.getRoleType !== 50) ? _c('th', [_vm._v("廣告")]) : _vm._e(), _vm._v(" "), (_vm.show.brand || _vm.show.history) ? _c('th', [_vm._v("店家")]) : _vm._e(), _vm._v(" "), (!_vm.show.history && !_vm.show.menu && !_vm.show.menuDetail && _vm.getRoleType !== 10 && _vm.getRoleType !== 50) ? _c('th') : _vm._e(), _vm._v(" "), (_vm.show.menuDetail) ? _c('th') : _vm._e(), _vm._v(" "), (_vm.show.menuDetail) ? _c('th') : _vm._e(), _vm._v(" "), (_vm.show.menuDetail) ? _c('th') : _vm._e(), _vm._v(" "), (_vm.show.menuDetail) ? _c('th') : _vm._e(), _vm._v(" "), (_vm.show.menuDetail) ? _c('th') : _vm._e(), _vm._v(" "), (_vm.show.menuDetail) ? _c('th') : _vm._e(), _vm._v(" "), (_vm.show.menuDetail) ? _c('th', [_vm._v("店家")]) : _vm._e(), _vm._v(" "), (_vm.show.activity) ? _c('th') : _vm._e()])]), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(3)]) : (_vm.brandList.length) ? _c('tbody', _vm._l((_vm.brandList), function(brand, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v("\n            " + _vm._s(index + 1) + "\n          ")]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": _vm.webDomain + 'brand/' + brand.brand_code,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "img-brand-table",
      attrs: {
        "src": brand.image_name
      }
    })])]), _vm._v(" "), _c('td', [(_vm.show.brand) ? _c('router-link', {
      attrs: {
        "to": {
          path: '/brandInfo/' + brand.id
        }
      }
    }, [_vm._v("\n              " + _vm._s(brand.name) + " (" + _vm._s(brand.id) + ")\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.show.brand) ? _c('span', [_vm._v("\n              " + _vm._s(brand.name) + " (" + _vm._s(brand.id) + ")\n            ")]) : _vm._e()], 1), _vm._v(" "), (_vm.show.brand) ? _c('td', [_vm._v("\n            " + _vm._s(brand.name_short) + "\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.show.menuDetail) ? _c('td', [_vm._v("\n            " + _vm._s(brand.brand_code) + "(" + _vm._s(brand.brand_key) + ")\n          ")]) : _vm._e(), _vm._v(" "), (_vm.show.brand && _vm.getRoleType === 99) ? _c('td', [_vm._v("\n            " + _vm._s(brand.store_amount || 0) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.show.brand || _vm.show.history) ? _c('td', [(brand.is_opening) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("\n              已上架\n            ")]) : _vm._e(), _vm._v(" "), (!brand.is_opening) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("\n              未上架\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.show.brand || _vm.show.history) ? _c('td', [(brand.is_visible) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("\n              顯示\n            ")]) : _vm._e(), _vm._v(" "), (!brand.is_visible) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("\n              隱藏\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.show.brand || _vm.show.history) ? _c('td', [(!brand.is_delete) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("\n              未刪除\n            ")]) : _vm._e(), _vm._v(" "), (brand.is_delete) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("\n              刪除\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', _vm._l((brand.nidin_league_levels), function(level, index) {
      return (brand.nidin_league_levels.length) ? _c('span', {
        key: index,
        class: level === 1 ? 'label label-primary mr-1' : 'label label-warning mr-1'
      }, [_vm._v("\n              " + _vm._s(level === 1 ? '等級一' : '等級二') + "\n            ")]) : _c('span', [_vm._v("\n              -\n            ")])
    }), 0), _vm._v(" "), (_vm.show.brand && _vm.getRoleType === 99) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/groupTable/' + brand.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-object-group"
    })])])], 1) : _vm._e(), _vm._v(" "), (_vm.show.brand && _vm.getRoleType !== 10 && _vm.getRoleType !== 50) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/brandAdTable/' + brand.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-file-image-o"
    })])])], 1) : _vm._e(), _vm._v(" "), (_vm.show.brand) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/storeTable/' + brand.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-home"
    })])])], 1) : _vm._e(), _vm._v(" "), (_vm.show.history) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/storeHistoryTable/' + brand.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-home"
    })])])], 1) : _vm._e(), _vm._v(" "), (_vm.show.brand && _vm.getRoleType !== 10 && _vm.getRoleType !== 50) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/upBrand/' + brand.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])])], 1) : _vm._e(), _vm._v(" "), (_vm.show.menuDetail) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/brandMenu/' + brand.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-plus-square"
    }), _vm._v("\n                配料庫\n              ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.show.menuDetail) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/brandMenuTable/' + brand.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-wrench"
    }), _vm._v("\n                菜單建置\n              ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.show.menuDetail) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/storeTable/productImage/' + brand.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-picture-o"
    }), _vm._v("\n                圖片庫\n              ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.show.menuDetail) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/storeTable/productSetting/' + brand.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-certificate"
    }), _vm._v("\n                別名 / 描述 / 警語\n              ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.show.menuDetail) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/cupDiscountTable/' + brand.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default flex align-center "
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(137)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "text-center"
    }, [_vm._v("自備飲料杯管理")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.show.menuDetail) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/brandScheduleTable/' + brand.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-primary"
    }, [_c('i', {
      staticClass: "fa fa-clock-o"
    }), _vm._v("\n                排程\n              ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.show.menuDetail) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'StoreMenu',
          params: {
            brand_id: brand.id,
          },
          query: {
            back_page: _vm.tableIndex
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-home"
    })])])], 1) : _vm._e(), _vm._v(" "), (_vm.show.activity) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/activityScheduleTable/' + brand.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-info-circle"
    })])])], 1) : _vm._e(), _vm._v(" "), (_vm.show.schedule) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/brandScheduleTable/' + brand.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-info-circle"
    })])])], 1) : _vm._e()])
  }), 0) : (_vm.brandList.length === 0) ? _c('tbody', [_vm._m(4)]) : _vm._e()])]), _vm._v(" "), _c('paginate', {
    ref: "brandPaginate",
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    staticClass: "form-control h-38"
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("\n            名稱\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    staticClass: "form-control h-38"
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("\n            名稱\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text alliance-tooltip"
  }, [_vm._v("\n                  統計該品牌下目前營業中且可被搜尋到的門市總數\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("\n              資料讀取中...\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("\n                沒有符合的資料\n              ")])])])
}]}

/***/ }),
/* 2455 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_c('div', {
    staticClass: "col-xs-12 text-left form-group"
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title",
    on: {
      "click": function($event) {
        return _vm.crElement()
      }
    }
  }, [_vm._v("新增" + _vm._s(_vm.tabName) + "圖示")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-table-title",
    attrs: {
      "disabled": !_vm.selectItems.length,
      "data-toggle": "modal",
      "data-target": "#delModal"
    },
    on: {
      "click": function($event) {
        return _vm.setDeleteModal()
      }
    }
  }, [_vm._v("批次刪除")]), _vm._v(" "), (_vm.getRoleType !== 10 || _vm.getStores.length > 1) ? _c('button', {
    staticClass: "btn btn-default btn-table-title",
    attrs: {
      "disabled": !_vm.selectItems.length,
      "data-toggle": "modal",
      "data-target": "#copyModal"
    }
  }, [_vm._v("複製選取設定至其他店家")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right form-inline"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchType),
      expression: "searchType"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "name"
    }
  }, [_vm._v("商品名稱")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "id"
    }
  }, [_vm._v("商品料號")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [(_vm.searchType === 'name') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchInput.name),
      expression: "searchInput.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchInput.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchInput, "name", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.searchType === 'id') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchInput.id),
      expression: "searchInput.id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchInput.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchInput, "id", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": _vm.search
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkBoxSelectAll),
      expression: "checkBoxSelectAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkBoxSelectAll) ? _vm._i(_vm.checkBoxSelectAll, null) > -1 : (_vm.checkBoxSelectAll)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.checkBoxSelectAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkBoxSelectAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkBoxSelectAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkBoxSelectAll = $$c
        }
      }, _vm.selectAll]
    }
  })]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("小圖")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("商品名稱")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("商品料號")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("啟用")]), _vm._v(" "), (_vm.tab !== 10) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("大圖")]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])]), _vm._v(" "), (_vm.imgList.length) ? _c('tbody', _vm._l((_vm.imgList), function(img, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (img.selectItem),
        expression: "img.selectItem"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(img.selectItem) ? _vm._i(img.selectItem, null) > -1 : (img.selectItem)
      },
      on: {
        "change": function($event) {
          var $$a = img.selectItem,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(img, "selectItem", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(img, "selectItem", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(img, "selectItem", $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('div', [_c('img', {
      staticClass: "img img-responsive",
      attrs: {
        "src": img.main_image.img_url
      }
    })])]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(img.product_name))])]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(img.vendor_custom_id))])]), _vm._v(" "), _c('td', [(img.is_enabled) ? _c('label', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _c('label', {
      staticClass: "label label-danger"
    }, [_vm._v("停用")])]), _vm._v(" "), (_vm.tab !== 10) ? _c('td', _vm._l((img.sub_image_list), function(bigImg) {
      return _c('div', {
        staticClass: "inline-block"
      }, [_c('img', {
        staticClass: "img img-responsive",
        staticStyle: {
          "height": "30px"
        },
        attrs: {
          "src": bigImg.img_url
        }
      })])
    }), 0) : _vm._e(), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.upElement(img.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#delModal"
      },
      on: {
        "click": function($event) {
          return _vm.clickCurrent(img.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), 0) : _c('tbody', [_vm._m(0)])])]), _vm._v(" "), _c('paginate', {
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('choose-store-modal', {
    attrs: {
      "option": _vm.storeOption
    },
    on: {
      "copyStore": _vm.copyStore
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "9"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
}]}

/***/ }),
/* 2456 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.info),
      expression: "show.info"
    }],
    staticClass: "row m-b-15"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動名稱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.name))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  活動啟用\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.activity.is_enable.value === 1) ? _c('label', {
    staticClass: "label label-success"
  }, [_vm._v("啟用")]) : _c('label', {
    staticClass: "label label-danger"
  }, [_vm._v("未啟用")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  擁有者\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.activity.owner_type.value === 1) ? _c('span', [_vm._v("平台")]) : (_vm.activity.owner_type.value === 2) ? _c('span', [_vm._v("品牌 - " + _vm._s(_vm.activity.owner_brand_name))]) : (_vm.activity.owner_type.value === 3) ? _c('span', [_vm._v("店家 - " + _vm._s(_vm.activity.owner_brand_name) + " - " + _vm._s(_vm.activity.owner_store_name))]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  參與品牌\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.brandSelect.label) + "\n                ")])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [_c('div', [_c('div', {
    staticClass: "input-group cr-schedule"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  活動開始時間\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.aTime.start.time) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group cr-schedule"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  活動結束時間\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.aTime.end.time) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動說明")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.description) + "\n                ")])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  參與店家\n                ")]), _vm._v(" "), _vm._l((_vm.info.attend_stores), function(brand) {
    return _c('div', {
      staticClass: "form-control form-info"
    }, _vm._l((brand.store_list), function(store) {
      return _c('div', {
        staticClass: "inline-block",
        staticStyle: {
          "margin-bottom": "13px"
        }
      }, [_c('label', {
        staticClass: "label label-primary m-r-5 m-b-5"
      }, [_c('div', {
        staticClass: "is-enable-store",
        class: [store.is_enable ? 'success' : 'danger']
      }), _vm._v("\n                      " + _vm._s(store.store_name) + "\n                    ")])])
    }), 0)
  })], 2), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_c('h5', [_vm._v("生效日設定")]), _vm._v(" "), _vm._l((_vm.timeSettingList), function(process, pIndex) {
    return _c('div', {
      staticClass: "m-t-10 process-time-block"
    }, [(!process.value_type) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("時間類型")]), _vm._v(" "), _c('div', {
      staticClass: "form-control form-info"
    }, [(!process.value_type) ? _c('span', [_vm._v("無指定")]) : (process.value_type === 1) ? _c('span', [_vm._v("日期")]) : (process.value_type === 2) ? _c('span', [_vm._v("星期")]) : _vm._e()])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (process.value_type === 2) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n                    開始\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "form-control form-info"
    }, [_c('span', [_vm._v(_vm._s(_vm.getWeekDay(process.start_value.value)))])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (process.value_type === 1) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n                    開始\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "form-control form-info"
    }, [_c('span', [_vm._v(_vm._s(process.start_value.label) + " 日")])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (process.value_type === 2) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n                    結束\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "form-control form-info"
    }, [_c('span', [_vm._v(_vm._s(_vm.getWeekDay(process.end_value.value)))])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (process.value_type === 1) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n                    結束\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "form-control form-info"
    }, [_c('span', [_vm._v(_vm._s(process.end_value.label) + " 日")])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (process.time_type === 1) ? _c('div', [_vm._m(0, true), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (process.time_type === 2) ? _c('table', {
      staticClass: "table table-bordered table-striped dataTable"
    }, [_vm._m(1, true), _vm._v(" "), _c('tbody', _vm._l((process.time_interval), function(item, iIndex) {
      return _c('tr', [_c('td', [_vm._v("\n                    " + _vm._s(item.start_time) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(item.end_time) + "\n                  ")])])
    }), 0)]) : _vm._e()])
  }), _vm._v(" "), _c('br')], 2), _vm._v(" "), _c('hr', {
    staticClass: "box-body col-xs-12"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [(_vm.activity.strategy_data.limit.order_types.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  訂單類型\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.activity.strategy_data.limit.order_types), function(orderType) {
    return _c('label', {
      staticClass: "label label-success m-r-5"
    }, [_vm._v("\n                    " + _vm._s(orderType.label) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.order_methods.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  訂單方案\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.activity.strategy_data.limit.order_methods), function(orderMethod) {
    return _c('label', {
      staticClass: "label label-success m-r-5"
    }, [_vm._v("\n                    " + _vm._s(orderMethod.label) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.delivery_types.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  取貨方式\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.activity.strategy_data.limit.delivery_types), function(deliveryType) {
    return _c('label', {
      staticClass: "label label-success m-r-5"
    }, [_vm._v("\n                    " + _vm._s(deliveryType.label) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.trade_types.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  付款方式\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.activity.strategy_data.limit.trade_types), function(tradeType) {
    return _c('label', {
      staticClass: "label label-success m-r-5"
    }, [_vm._v("\n                    " + _vm._s(tradeType.label) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [(_vm.activity.strategy_data.limit.min_product_money) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("訂單最低應付金額(單位：元)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.strategy_data.limit.min_product_money) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.min_product_amount) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制主單(或團長)最低購買數(單位：個)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.strategy_data.limit.min_product_amount) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.min_sub_order_amount) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制子單(跟團單)最低訂單數(單位：筆)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.strategy_data.limit.min_sub_order_amount) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('hr', {
    staticClass: "box-body col-xs-12"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-center box-body"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('h4', [_vm._v("\n                折扣規則\n                "), (_vm.activity.rule_code === 'SD00001') ? _c('small', [_vm._v("  買X送一依金額個位數取固定折抵規則")]) : (_vm.activity.rule_code === 'SD00002') ? _c('small', [_vm._v("  買指定商品買X份可折Y元")]) : (_vm.activity.rule_code === 'SD00003') ? _c('small', [_vm._v("  買X送Y依數量最低價格折抵規則")]) : (_vm.activity.rule_code === 'SD00004') ? _c('small', [_vm._v("  全品項折扣規則")]) : (_vm.activity.rule_code === 'SD00005') ? _c('small', [_vm._v("  購買X數量滿額可折Y元折抵規則")]) : _vm._e()])]), _vm._v(" "), (_vm.activity.strategy_data.setting.amount_unit && (_vm.activity.rule_code === 'SD00001' || _vm.activity.rule_code === 'SD00005')) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("折扣滿足總數 (買X送一)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  買" + _vm._s(_vm.activity.strategy_data.setting.amount_unit) + "送一\n                ")])]), _vm._v(" "), _c('br')]) : (_vm.activity.strategy_data.setting.amount_unit && _vm.activity.strategy_data.setting.ratio && _vm.activity.rule_code === 'SD00003') ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("折扣滿足總數 (買X送Y)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  買" + _vm._s(_vm.activity.strategy_data.setting.amount_unit) + "送" + _vm._s(_vm.activity.strategy_data.setting.ratio) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.setting.lowest_unit_price !== '') ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制列入計算/折抵商品最低項目單價")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.strategy_data.setting.lowest_unit_price) + " 元\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.setting.one_max_discount) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("最大折扣金額")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.strategy_data.setting.one_max_discount) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.setting.discount_unit) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("每達到數量贈送的金額")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.strategy_data.setting.discount_unit) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.setting.percent_value) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("折扣數值")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.strategy_data.setting.percent_value) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.setting.ignore_allowance) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("是否忽略折讓(A+B)金額")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.strategy_data.setting.ignore_allowance.label) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.setting.round_policy) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("折扣金額小數點進位方式")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.strategy_data.setting.round_policy.label) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.setting.product_info.length || _vm.activity.strategy_data.store_exception_items[0].products.length) ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [(_vm.ruleCode === 'SD00001' || _vm.ruleCode === 'SD00003' || _vm.ruleCode === 'SD00004' || _vm.ruleCode === 'SD00005') ? _c('h5', [_vm._v("例外商品")]) : _c('h5', [_vm._v("折扣商品")])]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.setting.product_info.length) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.activity.strategy_data.setting.product_info), function(aProduct, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n                    " + _vm._s(aIndex + 1) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(aProduct.product_name) + "\n                  ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-primary c-pointer",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#storeProdModal"
      },
      on: {
        "click": function($event) {
          return _vm.getStoreProd(aProduct)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(aProduct.vendor_custom_id) + "\n                      ")])]), _vm._v(" "), _c('td', [_vm._v("\n                    購買  " + _vm._s(aProduct.amount_unit) + "  個\n                    折  " + _vm._s(aProduct.discount) + "  元\n                  ")])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.store_exception_items[0].products.length) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.activity.strategy_data.store_exception_items[0].products), function(aProduct, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n                    " + _vm._s(aIndex + 1) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(aProduct.product_name) + "\n                  ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-primary c-pointer",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#storeProdModal"
      },
      on: {
        "click": function($event) {
          return _vm.getStoreProd(aProduct)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(aProduct.vendor_custom_id) + "\n                    ")])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.setting.exception_products.length) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.activity.strategy_data.setting.exception_products), function(aProduct, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n                    " + _vm._s(aIndex + 1) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(aProduct.product_name) + "\n                  ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-primary c-pointer",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#storeProdModal"
      },
      on: {
        "click": function($event) {
          return _vm.getStoreProd(aProduct)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(aProduct.vendor_custom_id) + "\n                    ")])])])
  }), 0)])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "storeProdModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.curVCID) + " 出現的門市")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.storeProdList), function(sProd, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n                " + _vm._s(aIndex + 1) + "\n              ")]), _vm._v(" "), _c('td', [(sProd.product_id) ? _c('div', [_vm._v("\n                  " + _vm._s(sProd.product_name) + " (" + _vm._s(sProd.product_id) + ")\n                ")]) : _c('div', {
      staticClass: "text-red"
    }, [_vm._v("無對應的商品")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(sProd.store_name))]), _vm._v(" "), _c('td', [(sProd.menu_id) ? _c('div', [_vm._v("\n                  " + _vm._s(sProd.menu_name) + "\n                ")]) : _c('div', {
      staticClass: "text-red"
    }, [_vm._v("無使用中菜單")])])])
  }), 0)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    時段\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('span', [_vm._v("全時段")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("開始時間")]), _vm._v(" "), _c('td', [_vm._v("結束時間")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_c('div', [_c('h4', [_vm._v("限制規則")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品")]), _vm._v(" "), _c('td', [_vm._v("商品料號")]), _vm._v(" "), _c('td', [_vm._v("折扣規則")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品")]), _vm._v(" "), _c('td', [_vm._v("商品料號")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品")]), _vm._v(" "), _c('td', [_vm._v("商品料號")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品 (ID)")]), _vm._v(" "), _c('td', [_vm._v("門市")]), _vm._v(" "), _c('td', [_vm._v("菜單")])])])
}]}

/***/ }),
/* 2457 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('activity-info', {
    attrs: {
      "info": _vm.info
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2458 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_vm._l((this.menu.categoryList), function(categoryList, index) {
    return (categoryList !== 'undefined' && categoryList[_vm.schema.category.is_visible] == '1') ? _c('div', {
      staticClass: "col-xs-12 col-lg-4 grid-item p-5 p-r-10"
    }, [_c('div', {
      staticClass: "col-xs-12 card"
    }, [_c('div', {
      staticClass: "col-xs-12 card-title text-left p-x-15"
    }, [_c('span', {
      staticClass: "pull-left"
    }, [_vm._v(_vm._s(categoryList[_vm.schema.category.name]))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 text-left"
    }, [_c('ul', {
      staticClass: "nav p-x-15"
    }, _vm._l((categoryList[_vm.schema.category.product_list]), function(productListNumber) {
      return _c('li', {
        key: productListNumber,
        staticClass: "card-product c-pointer",
        class: {
          disabled: categoryList[_vm.schema.category.is_enable] == '0'
        },
        attrs: {
          "data-toggle": "modal",
          "data-target": _vm.changeToProductList(productListNumber)[_vm.schema.product.type] === 1 ? '#infoProductModal' : '#infoPackageModal',
          "disabled": !_vm.checkDisableItem(productListNumber, categoryList[_vm.schema.category.product_id])
        },
        on: {
          "click": function($event) {
            _vm.openModal(productListNumber, _vm.checkDisableItem(productListNumber, categoryList[_vm.schema.category.product_id]))
          }
        }
      }, [_c('div', {
        staticClass: "p-name"
      }, [_vm._v(_vm._s(_vm.changeToProductList(productListNumber)[_vm.schema.product.name]))]), _vm._v(" "), _vm._l((_vm.getLower(productListNumber)), function(price) {
        return _c('div', {
          staticClass: "block-price text-15"
        }, [(!isNaN(_vm.getElement(price, 2))) ? _c('span', {
          class: _vm.getTempE(price, 1)
        }, [(_vm.getTempE(price, 1) === 'text-light-pink') ? _c('img', {
          staticClass: "icon-temp",
          attrs: {
            "src": "/static/img/icon/hot_icon.png"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.getTempE(price, 1) === 'text-blue') ? _c('img', {
          staticClass: "icon-temp",
          attrs: {
            "src": "/static/img/icon/cold_icon.png"
          }
        }) : _vm._e(), _vm._v("\n                " + _vm._s(_vm.getElement(price, 2)) + "\n              ")]) : _vm._e()])
      })], 2)
    }), 0)])])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "clear-both"
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 2459 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [_c('div', {
    staticClass: "box-body form"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [(_vm.info) ? _c('button', {
    staticClass: "btn btn-danger inherit",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delMenuModal"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuInfo.name),
      expression: "menuInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "32"
    },
    domProps: {
      "value": (_vm.menuInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.menuInfo, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n        菜單描述\n      ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuInfo.description),
      expression: "menuInfo.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuInfo.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.menuInfo, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n        菜單備註\n      ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuInfo.remark),
      expression: "menuInfo.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuInfo.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.menuInfo, "remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-default btn-fail",
    on: {
      "click": _vm.goToBack
    }
  }, [_vm._v("\n      取消\n    ")]), _vm._v(" "), (!_vm.info) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkInputEmpty('cr')
      }
    }
  }, [_vm._v("\n      新增\n    ")]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkInputEmpty('up')
      }
    }
  }, [_vm._v("\n      修改\n    ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delMenuOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("名稱\n      ")])
}]}

/***/ }),
/* 2460 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "center-block row"
  }, [_c('div', {
    staticClass: "align-center col-xs-12 flex m-b-10 p-x-0"
  }, [_c('router-link', {
    attrs: {
      "to": {
        'name': _vm.goBackInfo.name,
        'params': _vm.goBackInfo.params,
        'query': _vm.goBackInfo.query
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default flex m-r-5"
  }, [_c('span', [_vm._v("返回")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.title)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.subtitle)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "darken-1 flex grey"
  }, [(_vm.brand.name || _vm.store.brand_name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s(_vm.brand.name ?
        _vm.brand.name :
        _vm.store.brand_name ?
        _vm.store.brand_name :
        '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s('/')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.store.name)
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('CrBlock')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2461 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('order-line-charts'), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                門市\n              ")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "placeholder": "選擇店家",
      "label": "label",
      "track-by": "value",
      "options": _vm.storeBrief,
      "multiple": true,
      "allow-empty": true,
      "close-on-select": false
    },
    model: {
      value: (_vm.content.bindingStoreList),
      callback: function($$v) {
        _vm.$set(_vm.content, "bindingStoreList", $$v)
      },
      expression: "content.bindingStoreList"
    }
  })], 1), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 text-right pull-right"
  }, [_c('div', {
    staticClass: "form-group input-group time-box pull-right no-btn"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.storeTime,
      "option": _vm.dateoption,
      "limit": _vm.storeLimit
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 table-responsive ",
    staticStyle: {
      "min-height": "300px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.storeStatusList), function(store) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(store.store_name) + " (" + _vm._s(store.store_id) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(store.order_count_accept))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(store.order_count_reject))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(store.order_count_accept - store.order_count_finish))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(store.order_count_finish))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(store.order_count_day_normal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(store.order_count_day_group))])])
  }), 0)])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("當日訂單數量與份數比較")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "today-amount-compare"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("當日訂單數量與總額比較")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "today-money-compare"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("當日訂單平均金額")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "today-money-average"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("當日會員數量")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "shopper-brief"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("今日24小時訂單數與金額")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "hour-brief"
    }
  })])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("一日所有店家狀態列表"), _c('span', {
    staticClass: "text-red text-12"
  }, [_vm._v("(最多可選擇10間店家)")])]), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("店名 (ID)")]), _vm._v(" "), _c('th', [_vm._v("已接受數量")]), _vm._v(" "), _c('th', [_vm._v("拒絕數量")]), _vm._v(" "), _c('th', [_vm._v("例外數量")]), _vm._v(" "), _c('th', [_vm._v("已完成數量")]), _vm._v(" "), _c('th', [_vm._v("一般單數量")]), _vm._v(" "), _c('th', [_vm._v("團購單數量")])])])
}]}

/***/ }),
/* 2462 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [_c('div', {
    staticClass: "box-body form"
  }, [_c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n        排除的店家\n      ")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "placeholder": "選擇排除的店家",
      "label": "label",
      "track-by": "value",
      "options": _vm.storeBrief,
      "multiple": true,
      "allow-empty": true,
      "close-on-select": false
    },
    model: {
      value: (_vm.bindingStoreList),
      callback: function($$v) {
        _vm.bindingStoreList = $$v
      },
      expression: "bindingStoreList"
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.iconTypeSelect),
      expression: "iconTypeSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.iconTypeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.iconTypeList), function(iconType) {
    return _c('option', {
      domProps: {
        "value": iconType.value
      }
    }, [_vm._v(_vm._s(iconType.label))])
  }), 0)])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          圖片\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0 bg-white",
    staticStyle: {
      "border-right": "none"
    }
  }, [_c('span', {
    staticClass: "inline-block h-auto m-t-5"
  }, [(!_vm.storeInfo.image_name && (_vm.iconTypeSelect === 1 || _vm.iconTypeSelect === 4)) ? _c('div', {
    staticClass: "text-black",
    domProps: {
      "textContent": _vm._s('沒有圖片')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.storeInfo.image_name) ? _c('img', {
    staticClass: "h-auto img-responsive",
    attrs: {
      "src": _vm.storeInfo.image_name,
      "data-toggle": "modal"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [(_vm.imgLogoOption.length) ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imgLogoSelect),
      expression: "imgLogoSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.imgLogoSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.imgLogoOption), function(img, index) {
    return _c('option', {
      domProps: {
        "value": img.name
      }
    }, [_vm._v(_vm._s(img.name))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "btn-upload btn btn-default",
    class: {
      'm-t-25': !_vm.imgLogoOption.length
    },
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "for": "brand-img-load"
    }
  }, [_vm._v("\n              選擇圖片\n            ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "brand-img-load"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("(圖片大小為" + _vm._s(_vm.iconTypeSelect === 1 ? '200x200' : '800x460') + ")"), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('router-link', {
    attrs: {
      "to": '/storeTable/' + _vm.$route.params.brand_id
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("\n        取消\n      ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.updatedLogoImg
    }
  }, [_vm._v("\n      確定\n    ")])], 1), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("修改品牌下所有店家圖示")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("種類\n      ")])
}]}

/***/ }),
/* 2463 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "warning-block"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n    系統使用率報表模組已搬至「\n    "), _c('a', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.goto
    }
  }, [_vm._v("數據分析 > 趨勢分析")]), _vm._v("\n    」，請至新後台管理系統操作、檢視相關內容，此區域(舊後台)功能即將關閉。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "z-index-1"
  }, [(_vm.brandBrief.length > 1) ? _c('div', {
    staticClass: "inline-block from-group pull-left ",
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "label": "label",
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "品牌",
      "show-labels": false,
      "preselect-first": true
    },
    on: {
      "input": _vm.changeBrand
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.storeBrief.length > 1) ? _c('div', {
    staticClass: "from-group pull-left m-l-5 flex"
  }, [_c('div', {
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.storeBrief,
      "label": "label",
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "門市",
      "show-labels": false,
      "preselect-first": true
    },
    on: {
      "input": _vm.changeStore
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1), _vm._v(" "), (_vm.storeSelect.value) ? _c('div', {
    staticClass: "ein"
  }, [_vm._v("\n                統編：" + _vm._s(_vm.ein)), _c('br'), _vm._v("抬頭：" + _vm._s(_vm.storeName) + "\n              ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.storeBrief.length === 0 && _vm.getRoleType === 10) ? _c('div', {
    staticClass: "ein"
  }, [_vm._v("\n              統編：" + _vm._s(_vm.ein)), _c('br'), _vm._v("抬頭：" + _vm._s(_vm.storeName) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-t-50"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      active: _vm.isType('daily')
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectTab = 'daily'
      }
    }
  }, [_vm._v("每日統計\n                    ")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isType('monthly')
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectTab = 'monthly'
      }
    }
  }, [_vm._v("每月統計\n                    ")])])]), _vm._v(" "), (_vm.selectTab === 'daily') ? _c('div', {
    staticClass: "download-block m-r-20"
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title",
    on: {
      "click": function($event) {
        return _vm.exportFile('chart')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v("\n                    匯出圖表\n                  ")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-t-25 m-l-15"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "flex align-center"
  }, [_c('div', {
    staticClass: "text-14 m-r-15 m-l-15"
  }, [_vm._v("資料期間")]), _vm._v(" "), (_vm.selectTab === 'monthly') ? _c('div', {
    staticClass: "flex align-center"
  }, [_c('date-picker', {
    staticClass: "w-120",
    attrs: {
      "type": "month",
      "valueType": "format",
      "clearable": false,
      "disabled-date": _vm.startMonthLimit
    },
    model: {
      value: (_vm.monthlySearch.start_date),
      callback: function($$v) {
        _vm.$set(_vm.monthlySearch, "start_date", $$v)
      },
      expression: "monthlySearch.start_date"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-l-5 m-r-5"
  }, [_vm._v("-")]), _vm._v(" "), _c('date-picker', {
    staticClass: "w-120",
    attrs: {
      "type": "month",
      "valueType": "format",
      "clearable": false,
      "disabled-date": _vm.endMonthLimit,
      "input-class": "mx-input input-group-input"
    },
    model: {
      value: (_vm.monthlySearch.end_date),
      callback: function($$v) {
        _vm.$set(_vm.monthlySearch, "end_date", $$v)
      },
      expression: "monthlySearch.end_date"
    }
  })], 1) : _c('div', {
    staticClass: "flex align-center"
  }, [_c('date-picker', {
    staticClass: "w-120",
    attrs: {
      "type": "date",
      "valueType": "format",
      "clearable": false,
      "disabled-date": _vm.startDateLimit
    },
    model: {
      value: (_vm.dailySearch.start_date),
      callback: function($$v) {
        _vm.$set(_vm.dailySearch, "start_date", $$v)
      },
      expression: "dailySearch.start_date"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-l-5 m-r-5"
  }, [_vm._v("-")]), _vm._v(" "), _c('date-picker', {
    staticClass: "w-120",
    attrs: {
      "type": "date",
      "valueType": "format",
      "clearable": false,
      "disabled-date": _vm.endDateLimit,
      "input-class": "mx-input input-group-input"
    },
    model: {
      value: (_vm.dailySearch.end_date),
      callback: function($$v) {
        _vm.$set(_vm.dailySearch, "end_date", $$v)
      },
      expression: "dailySearch.end_date"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default submit-btn input-group-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.searchOrderSummary()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 text-right"
  }, [(_vm.selectTab === 'monthly') ? _c('div', {
    staticClass: "m-r-20"
  }, [_c('button', {
    staticClass: "btn btn-xs btn-primary p-x-10",
    on: {
      "click": function($event) {
        return _vm.setDate('year')
      }
    }
  }, [_vm._v("近一年")])]) : _c('div', {
    staticClass: "m-r-20"
  }, [_c('button', {
    staticClass: "btn btn-xs btn-primary p-x-10 m-r-5",
    on: {
      "click": function($event) {
        return _vm.setDate('week')
      }
    }
  }, [_vm._v("近一週")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs btn-primary p-x-10",
    on: {
      "click": function($event) {
        return _vm.setDate('month')
      }
    }
  }, [_vm._v("近一個月")])])])]), _vm._v(" "), _c('div', {
    staticClass: "canvas-block"
  }, [(_vm.selectTab === 'daily') ? _c('div', {
    staticClass: "download-block z-index-1 p-r-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.month),
      expression: "month"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.month = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeMonth]
    }
  }, _vm._l((_vm.monthlyOptions), function(item) {
    return _c('option', {
      key: item.value,
      attrs: {
        "disabled": item.disable
      },
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "m-b-15 chart-title"
  }, [_vm._v("ORDER")]), _vm._v(" "), _c('div', {
    staticClass: "chart-subtitle m-b-5"
  }, [_vm._v("系統觸發/使用次數統計")]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "order-chart"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-t-64 m-b-15 chart-title"
  }, [_vm._v("CRM")]), _vm._v(" "), _c('div', {
    staticClass: "chart-subtitle m-b-5"
  }, [_vm._v("系統觸發/使用次數統計")]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "crm-chart"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-t-64 m-b-15 m-b-5 chart-title"
  }, [_vm._v("DATA")]), _vm._v(" "), _c('div', {
    staticClass: "chart-subtitle"
  }, [_vm._v("系統觸發/使用次數統計")]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "data-chart"
    }
  })])])])])])])
},staticRenderFns: []}

/***/ }),
/* 2464 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-box text-center"
  }, [(_vm.storeInfo.brand_name) ? _c('h1', {
    staticStyle: {
      "position": "absolute",
      "top": "-57px",
      "left": "90px",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.storeInfo.brand_name) + " - " + _vm._s(_vm.storeInfo.name_short))]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      'active': _vm.storeMethod == 1
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 1
      }
    }
  }, [_c('a', [_vm._v("基本資訊")])]), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('li', {
    class: {
      'active': _vm.storeMethod == 2
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 2
      }
    }
  }, [_c('a', [_vm._v("細部設定")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 3
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 3
      }
    }
  }, [_c('a', [_vm._v("預訂/訂購時間")])]), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('li', {
    class: {
      'active': _vm.storeMethod == 4
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 4
      }
    }
  }, [_c('a', [_vm._v("付款方式")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 5
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 5
      }
    }
  }, [_c('a', [_vm._v("製作/取餐時間")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 6
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 6
      }
    }
  }, [_c('a', [_vm._v("取餐方式/門檻")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 7
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 7
      }
    }
  }, [_c('a', [_vm._v("營業/公休時間")])]), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30 || _vm.getRoleType === 10) ? _c('li', {
    class: {
      'active': _vm.storeMethod == 8
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 8
      }
    }
  }, [_c('a', [_vm._v("塑膠袋")])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 && _vm.getRestricted.indexOf(900) !== -1) ? _c('li', {
    class: {
      'active': _vm.storeMethod == 12
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 12
      }
    }
  }, [_c('a', [_vm._v("計費方式設定")])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('li', {
    class: {
      'active': _vm.storeMethod == 13
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 13
      }
    }
  }, [_c('a', [_vm._v("物流設定")])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30 || _vm.getRoleType === 10) ? _c('li', {
    class: {
      'active': _vm.storeMethod == 15
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 15
      }
    }
  }, [_c('a', [_vm._v("特殊需求")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        return _vm.clearPage()
      }
    }
  }, [_vm._v("\n            清空此頁面設定\n          ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 1),
      expression: "storeMethod === 1"
    }],
    staticClass: "box-body form"
  }, [_c('h3', [_vm._v("店家資訊")]), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              店家公吿設定\n              "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block pt-5"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.removeComment),
      expression: "removeComment"
    }],
    attrs: {
      "type": "radio",
      "name": "removeComment"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.removeComment, false)
    },
    on: {
      "change": function($event) {
        _vm.removeComment = false
      }
    }
  }), _vm._v("編輯店家公告\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.removeComment),
      expression: "removeComment"
    }],
    attrs: {
      "type": "radio",
      "name": "removeComment"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.removeComment, true)
    },
    on: {
      "change": function($event) {
        _vm.removeComment = true
      }
    }
  }), _vm._v("清空現有店家公告\n                  ")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', [(!_vm.removeComment && _vm.removeComment != null) ? _c('div', {
    staticClass: "input-group m-t-25"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              店家公告\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.comment),
      expression: "storeInfo.comment"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.storeInfo.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "comment", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br')]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group m-t-5"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              餐點種類\n            ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "tag-placeholder": "餐點種類",
      "placeholder": "餐點種類",
      "label": "label",
      "track-by": "value",
      "options": _vm.mealTagList,
      "multiple": true
    },
    model: {
      value: (_vm.storeInfo.binding_meal_tag_ids),
      callback: function($$v) {
        _vm.$set(_vm.storeInfo, "binding_meal_tag_ids", $$v)
      },
      expression: "storeInfo.binding_meal_tag_ids"
    }
  })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              描述\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.description),
      expression: "storeInfo.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.storeInfo.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              描述(搜尋引擎顯示)\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.search_description),
      expression: "storeInfo.search_description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.storeInfo.search_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "search_description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              品牌頁介紹\n            ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.introduction),
      expression: "storeInfo.introduction"
    }],
    staticClass: "w-100-p form-control",
    attrs: {
      "name": "introduction",
      "cols": "30",
      "rows": "10",
      "maxlength": "65535"
    },
    domProps: {
      "value": (_vm.storeInfo.introduction)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "introduction", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', [_c('div', {
    staticClass: "input-group m-t-5"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              Youtube 影片代碼\n            ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.youtube_video_code),
      expression: "storeInfo.youtube_video_code"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.storeInfo.youtube_video_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "youtube_video_code", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              肉品產地說明\n            ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.meat_origin_description),
      expression: "storeInfo.meat_origin_description"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "maxlength": "500",
      "placeholder": "範例：本店牛肉來源－澳洲 / 豬肉來源－台灣"
    },
    domProps: {
      "value": (_vm.storeInfo.meat_origin_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "meat_origin_description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              LOGO\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0 bg-white",
    staticStyle: {
      "border-right": "none"
    }
  }, [_c('span', {
    staticClass: "inline-block h-auto m-t-5"
  }, [(!_vm.storeInfo.image_name) ? _c('div', {
    staticClass: "text-black",
    domProps: {
      "textContent": _vm._s('沒有圖片')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.storeInfo.image_name) ? _c('img', {
    staticClass: "h-auto img-responsive",
    attrs: {
      "src": _vm.storeInfo.image_name,
      "data-toggle": "modal"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [(_vm.imgLogoOption.length) ? _c('div', {
    staticClass: "pull-left"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imgLogoSelect),
      expression: "imgLogoSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.imgLogoSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.imgLogoOption), function(img, index) {
    return _c('option', {
      domProps: {
        "value": img.name
      }
    }, [_vm._v(_vm._s(img.name))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pull-left"
  }, [_c('label', {
    staticClass: "btn-upload btn btn-default",
    class: {
      'm-t-25': !_vm.imgLogoOption.length
    },
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "for": "brand-img-load"
    }
  }, [_vm._v("\n                    選擇圖片\n                  ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "brand-img-load"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                底圖照片\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0 bg-white",
    staticStyle: {
      "border-right": "none"
    }
  }, [_c('span', {
    staticClass: "inline-block h-auto m-t-5"
  }, [(!_vm.storeInfo.photo_name) ? _c('div', {
    staticClass: "text-black",
    domProps: {
      "textContent": _vm._s('沒有圖片')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.storeInfo.photo_name) ? _c('img', {
    staticClass: "h-auto img-responsive",
    attrs: {
      "src": _vm.storeInfo.photo_name,
      "data-toggle": "modal"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [_c('label', {
    staticClass: "btn-upload btn btn-default",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "for": "brand-photo-load"
    }
  }, [_vm._v("\n                  選擇圖片\n                ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "brand-photo-load"
    },
    on: {
      "change": _vm.onPhotoFileChange
    }
  })])])]) : _vm._e(), _vm._v(" "), _vm._m(3)]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 2),
      expression: "storeMethod === 2"
    }],
    staticClass: "box-body form"
  }, [_c('div', [_vm._m(4), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.reCheckOption.body) ? _c('div', {
    staticClass: "hint mb-1"
  }, [_c('i', {
    staticClass: "fa fa-close re-check-close",
    on: {
      "click": function($event) {
        _vm.invalidStoreMap = null
      }
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.reCheckOption.body)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                API服務類型\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.apiTypeSelect),
      expression: "apiTypeSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.apiTypeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("專屬客製POS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("公版POS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("平板接單")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                營業狀態\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelect),
      expression: "statusSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.statusSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("尚未營業")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("籌備中")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("營業中(上架)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("休息中")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("已歇業")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              距離計算模式\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.disModeSelect),
      expression: "disModeSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.disModeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("走路模式(WALKING)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("開車模式(DRIVING)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "13"
    }
  }, [_vm._v("機車(SCOOTER)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14"
    }
  }, [_vm._v("大眾運輸(TRANSIT)")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            條碼類型\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.barcodeSelect),
      expression: "barcodeSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.barcodeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("不支援")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("一維條碼")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("二維條碼(QRcode)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("一維、二維都支援")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                金額進位\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.roundingTypeSelect),
      expression: "roundingTypeSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.roundingTypeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("無條件進位")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("無條件捨去")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("四捨五入")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("保留小數點")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                優惠券形式\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.couponFormSelect),
      expression: "couponFormSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.couponFormSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("依付款方式使用優惠券")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("依虛擬商品使用優惠券")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                自訂設定顯示方式\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showProdSettingSelect),
      expression: "showProdSettingSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.showProdSettingSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("別名跟描述不顯示")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("別名跟描述都顯示")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("只顯示別名")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("只顯示描述")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon b-r"
  }, [_vm._v("\n              開放紙本發票\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasInvoicePaperSelect),
      expression: "hasInvoicePaperSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "invoicePaperOption"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.hasInvoicePaperSelect, 1)
    },
    on: {
      "change": function($event) {
        _vm.hasInvoicePaperSelect = 1
      }
    }
  }), _vm._v("開放\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasInvoicePaperSelect),
      expression: "hasInvoicePaperSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "invoicePaperOption"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.hasInvoicePaperSelect, 0)
    },
    on: {
      "change": function($event) {
        _vm.hasInvoicePaperSelect = 0
      }
    }
  }), _vm._v("停用\n                  ")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon b-r"
  }, [_vm._v("\n                開放電子載具\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasInvoiceCarrierSelect),
      expression: "hasInvoiceCarrierSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "invoiceCarrierOption"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.hasInvoiceCarrierSelect, 1)
    },
    on: {
      "change": function($event) {
        _vm.hasInvoiceCarrierSelect = 1
      }
    }
  }), _vm._v("開放 (請確認POS端是否支援此功能)\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasInvoiceCarrierSelect),
      expression: "hasInvoiceCarrierSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "invoiceCarrierOption"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.hasInvoiceCarrierSelect, 0)
    },
    on: {
      "change": function($event) {
        _vm.hasInvoiceCarrierSelect = 0
      }
    }
  }), _vm._v("停用\n                  ")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                發票備註\n              ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceRemark),
      expression: "invoiceRemark"
    }],
    staticClass: "w-100-p form-control",
    attrs: {
      "name": "invoiceRemark",
      "cols": "30",
      "rows": "3",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.invoiceRemark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.invoiceRemark = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.invoiceRemark ? _vm.invoiceRemark.length : 0) + "/100")]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon b-r"
  }, [_vm._v("\n              開放愛心捐贈發票\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasInvoiceNpobnaSelect),
      expression: "hasInvoiceNpobnaSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "invoiceNpobnaOption"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.hasInvoiceNpobnaSelect, 1)
    },
    on: {
      "change": function($event) {
        _vm.hasInvoiceNpobnaSelect = 1
      }
    }
  }), _vm._v("開放\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasInvoiceNpobnaSelect),
      expression: "hasInvoiceNpobnaSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "invoiceNpobnaOption"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.hasInvoiceNpobnaSelect, 0)
    },
    on: {
      "change": function($event) {
        _vm.hasInvoiceNpobnaSelect = 0
      }
    }
  }), _vm._v("停用\n                  ")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon b-r"
  }, [_vm._v("\n              店家是否開立發票\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isInvoiceException),
      expression: "isInvoiceException"
    }],
    attrs: {
      "type": "radio",
      "name": "invoiceException",
      "disabled": _vm.allInvoiceClosed
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.isInvoiceException, 0)
    },
    on: {
      "change": function($event) {
        _vm.isInvoiceException = 0
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'radio-text--disabled': _vm.allInvoiceClosed
    }
  }, [_vm._v("\n                      開發票\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isInvoiceException),
      expression: "isInvoiceException"
    }],
    attrs: {
      "type": "radio",
      "name": "invoiceException",
      "disabled": _vm.hasInvoiceSelected
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.isInvoiceException, 1)
    },
    on: {
      "change": function($event) {
        _vm.isInvoiceException = 1
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'radio-text--disabled': _vm.hasInvoiceSelected
    }
  }, [_vm._v("\n                      免開發票\n                    ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            前端顯示此店家\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isVisibleSelect),
      expression: "isVisibleSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "showOption",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.isVisibleSelect, "1")
    },
    on: {
      "change": function($event) {
        _vm.isVisibleSelect = "1"
      }
    }
  }), _vm._v("顯示\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isVisibleSelect),
      expression: "isVisibleSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "showOption",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.isVisibleSelect, "0")
    },
    on: {
      "change": function($event) {
        _vm.isVisibleSelect = "0"
      }
    }
  }), _vm._v("隱藏\n                    ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                首頁是否搜尋的到店家\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isSearchSelect),
      expression: "isSearchSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "searchOption",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.isSearchSelect, "1")
    },
    on: {
      "change": function($event) {
        _vm.isSearchSelect = "1"
      }
    }
  }), _vm._v("是\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isSearchSelect),
      expression: "isSearchSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "searchOption",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.isSearchSelect, "0")
    },
    on: {
      "change": function($event) {
        _vm.isSearchSelect = "0"
      }
    }
  }), _vm._v("否\n                    ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              支援客製餐點貼紙\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isStickerSelect),
      expression: "isStickerSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "stickerOption"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.isStickerSelect, 1)
    },
    on: {
      "change": function($event) {
        _vm.isStickerSelect = 1
      }
    }
  }), _vm._v("支援 (請確認POS端是否支援此功能)\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isStickerSelect),
      expression: "isStickerSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "stickerOption"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.isStickerSelect, 0)
    },
    on: {
      "change": function($event) {
        _vm.isStickerSelect = 0
      }
    }
  }), _vm._v("不支援\n                    ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number.lazy.trim",
      value: (_vm.storeInfo.custom_sticker_max_length),
      expression: "storeInfo.custom_sticker_max_length",
      modifiers: {
        "number": true,
        "lazy": true,
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "僅可輸入數字，最多10字",
      "type": "number",
      "min": "1",
      "max": "10"
    },
    domProps: {
      "value": (_vm.storeInfo.custom_sticker_max_length)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.storeInfo, "custom_sticker_max_length", _vm._n($event.target.value.trim()))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon b-r"
  }, [_c('span', [_vm._v("強制阻擋外送門檻")]), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                  若選擇強制阻擋外送門檻，消費者訂購時必須符合「取餐方式/門檻-消費金額與距離門檻」的設定才可下單。注意 : 無論是否強制阻擋外送門檻，外送訂單均須符合最低金額門檻才可下單。\n                ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.delivery_stage_limit_type),
      expression: "storeInfo.delivery_stage_limit_type"
    }],
    attrs: {
      "type": "radio",
      "name": "deliveryStageLimit"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.delivery_stage_limit_type, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "delivery_stage_limit_type", 1)
      }
    }
  }), _vm._v("不強制\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.delivery_stage_limit_type),
      expression: "storeInfo.delivery_stage_limit_type"
    }],
    attrs: {
      "type": "radio",
      "name": "deliveryStageLimit"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.storeInfo.delivery_stage_limit_type, 2)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "delivery_stage_limit_type", 2)
      }
    }
  }), _vm._v("強制\n                  ")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon b-r"
  }, [_vm._v("\n              單品備註\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_support_custom_remark),
      expression: "storeInfo.is_support_custom_remark"
    }],
    attrs: {
      "type": "radio",
      "name": "customRemark"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.is_support_custom_remark, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_support_custom_remark", 1)
      }
    }
  }), _vm._v("開啟 (請確認POS端是否支援此功能)\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_support_custom_remark),
      expression: "storeInfo.is_support_custom_remark"
    }],
    attrs: {
      "type": "radio",
      "name": "customRemark"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.is_support_custom_remark, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_support_custom_remark", 0)
      }
    }
  }), _vm._v("停用\n                  ")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            單筆訂單最高上限(單位:元)\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.one_order_max_money),
      expression: "storeInfo.one_order_max_money"
    }],
    ref: "oneOrderMaxMoney",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.storeInfo.one_order_max_money)
    },
    on: {
      "keyup": _vm.verityOneOrderMaxMoney,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "one_order_max_money", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            菜單版型\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_layout_type),
      expression: "storeInfo.menu_layout_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.storeInfo, "menu_layout_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.menuLayout), function(layout) {
    return _c('option', {
      domProps: {
        "value": layout.value
      }
    }, [_vm._v(_vm._s(layout.label))])
  }), 0)])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            飲料溫度顯示(冷 熱 無溫度)\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showMenuIconSelect),
      expression: "showMenuIconSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "iconOption",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.showMenuIconSelect, "0")
    },
    on: {
      "change": function($event) {
        _vm.showMenuIconSelect = "0"
      }
    }
  }), _vm._v("全部顯示\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showMenuIconSelect),
      expression: "showMenuIconSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "iconOption",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.showMenuIconSelect, "1")
    },
    on: {
      "change": function($event) {
        _vm.showMenuIconSelect = "1"
      }
    }
  }), _vm._v("無溫度顯示冷\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showMenuIconSelect),
      expression: "showMenuIconSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "iconOption",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.showMenuIconSelect, "2")
    },
    on: {
      "change": function($event) {
        _vm.showMenuIconSelect = "2"
      }
    }
  }), _vm._v("皆顯示無溫度\n                    ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            菜單產品圖示顯示\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.show_menu_product_icon),
      expression: "storeInfo.show_menu_product_icon"
    }],
    attrs: {
      "type": "radio",
      "name": "prodIconOption"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.show_menu_product_icon, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "show_menu_product_icon", 1)
      }
    }
  }), _vm._v("顯示\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.show_menu_product_icon),
      expression: "storeInfo.show_menu_product_icon"
    }],
    attrs: {
      "type": "radio",
      "name": "prodIconOption"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.show_menu_product_icon, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "show_menu_product_icon", 0)
      }
    }
  }), _vm._v("隱藏\n                    ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              菜單選項展開類型\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_expand_type),
      expression: "storeInfo.menu_expand_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menuExpandType"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.menu_expand_type, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_expand_type", 1)
      }
    }
  }), _vm._v("隱藏\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_expand_type),
      expression: "storeInfo.menu_expand_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menuExpandType"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.storeInfo.menu_expand_type, 2)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_expand_type", 2)
      }
    }
  }), _vm._v("展開\n                    ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              菜單當日停賣樣式\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_stop_sale_today_type),
      expression: "storeInfo.menu_stop_sale_today_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menuStopSaleTodayType"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.menu_stop_sale_today_type, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_stop_sale_today_type", 1)
      }
    }
  }), _vm._v("顯示當日停賣ICON\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_stop_sale_today_type),
      expression: "storeInfo.menu_stop_sale_today_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menuStopSaleTodayType"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.storeInfo.menu_stop_sale_today_type, 2)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_stop_sale_today_type", 2)
      }
    }
  }), _vm._v("隱藏當日停賣商品\n                    ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              菜單永久停賣樣式\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_stop_sale_type),
      expression: "storeInfo.menu_stop_sale_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menuStopSaleType"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.menu_stop_sale_type, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_stop_sale_type", 1)
      }
    }
  }), _vm._v("顯示永久停賣ICON\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_stop_sale_type),
      expression: "storeInfo.menu_stop_sale_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menuStopSaleType"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.storeInfo.menu_stop_sale_type, 2)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_stop_sale_type", 2)
      }
    }
  }), _vm._v("隱藏永久停賣商品\n                    ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                銷售折扣組合(紅配綠)菜單分類顯示\n                "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                    若開啟，菜單分類會再新增「紅區」、「綠區」，提升活動能見度！\n                  ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_ab_block_type),
      expression: "storeInfo.menu_ab_block_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menu_ab_block_type"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.menu_ab_block_type, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_ab_block_type", 1)
      }
    }
  }), _vm._v("開啟\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_ab_block_type),
      expression: "storeInfo.menu_ab_block_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menu_ab_block_type"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.menu_ab_block_type, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_ab_block_type", 0)
      }
    }
  }), _vm._v("關閉\n                    ")])])])])]), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 3),
      expression: "storeMethod === 3"
    }],
    staticClass: "box-body form"
  }, [_vm._m(8), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            開始預訂(距今日幾天，0為當日)\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.order_start_day),
      expression: "storeInfo.order_start_day"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.storeInfo.order_start_day)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "order_start_day", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            結束預訂(距開始預訂幾天，0為開始預訂日)\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.order_tolerance_day),
      expression: "storeInfo.order_tolerance_day"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.storeInfo.order_tolerance_day)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "order_tolerance_day", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            自動拒絕預約單時間(單位:分鐘)\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.auto_reject_order_reserve_m),
      expression: "storeInfo.auto_reject_order_reserve_m"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.storeInfo.auto_reject_order_reserve_m)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "auto_reject_order_reserve_m", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            接單狀態\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderStatusSelect),
      expression: "orderStatusSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "orderOption",
      "value": "10"
    },
    domProps: {
      "checked": _vm._q(_vm.orderStatusSelect, "10")
    },
    on: {
      "change": function($event) {
        _vm.orderStatusSelect = "10"
      }
    }
  }), _vm._v("接單中\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderStatusSelect),
      expression: "orderStatusSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "orderOption",
      "value": "20"
    },
    domProps: {
      "checked": _vm._q(_vm.orderStatusSelect, "20")
    },
    on: {
      "change": function($event) {
        _vm.orderStatusSelect = "20"
      }
    }
  }), _vm._v("不接單\n                  ")])])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              暫停接單理由\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.order_status_reason),
      expression: "storeInfo.order_status_reason"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.storeInfo.order_status_reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "order_status_reason", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            自動拒單時間(單位:分鐘)\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.auto_reject_order_m),
      expression: "storeInfo.auto_reject_order_m"
    }],
    ref: "rejectTime",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.storeInfo.auto_reject_order_m)
    },
    on: {
      "keyup": _vm.verityRejectTime,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "auto_reject_order_m", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            當日訂購時間前下單\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_preparing_allow_order),
      expression: "storeInfo.is_preparing_allow_order"
    }],
    attrs: {
      "type": "radio",
      "name": "isPreparingAllow"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.is_preparing_allow_order, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_preparing_allow_order", 1)
      }
    }
  }), _vm._v("可下單\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_preparing_allow_order),
      expression: "storeInfo.is_preparing_allow_order"
    }],
    attrs: {
      "type": "radio",
      "name": "isPreparingAllow"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.is_preparing_allow_order, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_preparing_allow_order", 0)
      }
    }
  }), _vm._v("不可下單\n                  ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            結束訂購時間後下單\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_close_allow_order),
      expression: "storeInfo.is_close_allow_order"
    }],
    attrs: {
      "type": "radio",
      "name": "isCloseAllow"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.is_close_allow_order, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_close_allow_order", 1)
      }
    }
  }), _vm._v("可下單\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_close_allow_order),
      expression: "storeInfo.is_close_allow_order"
    }],
    attrs: {
      "type": "radio",
      "name": "isCloseAllow"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.is_close_allow_order, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_close_allow_order", 0)
      }
    }
  }), _vm._v("不可下單\n                  ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 4),
      expression: "storeMethod === 4"
    }],
    staticClass: "box-body form"
  }, [_vm._m(10), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("付款類型")]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('td', [_vm._v("支援與否")]) : _vm._e(), _vm._v(" "), (_vm.getRoleType !== 10) ? _c('td', [_vm._v("開啟狀態")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n                備註 (顯示在購物車頁面上，消費者可查看)\n                "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(11)], 1)])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tradeInfo), function(tradeType, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(tradeType.name))]), _vm._v(" "), (_vm.getRoleType == 99) ? _c('td', [_c('div', {
      staticClass: "form-group text-left"
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tradeType.is_support),
        expression: "tradeType.is_support"
      }],
      attrs: {
        "type": "radio",
        "value": "1"
      },
      domProps: {
        "checked": _vm._q(tradeType.is_support, "1")
      },
      on: {
        "change": function($event) {
          return _vm.$set(tradeType, "is_support", "1")
        }
      }
    }), _vm._v("支援\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tradeType.is_support),
        expression: "tradeType.is_support"
      }],
      attrs: {
        "type": "radio",
        "value": "0"
      },
      domProps: {
        "checked": _vm._q(tradeType.is_support, "0")
      },
      on: {
        "change": [function($event) {
          return _vm.$set(tradeType, "is_support", "0")
        }, function($event) {
          return _vm.clickClose('tradeType', false, tradeType.is_default, _vm.dIndex)
        }]
      }
    }), _vm._v("不支援\n                    ")])])])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType !== 10) ? _c('td', [_c('div', {
      staticClass: "form-group text-left"
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tradeType.is_enable),
        expression: "tradeType.is_enable"
      }],
      attrs: {
        "type": "radio",
        "value": "1"
      },
      domProps: {
        "checked": _vm._q(tradeType.is_enable, "1")
      },
      on: {
        "input": _vm.setReload,
        "change": function($event) {
          return _vm.$set(tradeType, "is_enable", "1")
        }
      }
    }), _vm._v("開啟\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tradeType.is_enable),
        expression: "tradeType.is_enable"
      }],
      attrs: {
        "type": "radio",
        "value": "0"
      },
      domProps: {
        "checked": _vm._q(tradeType.is_enable, "0")
      },
      on: {
        "input": _vm.setReload,
        "change": [function($event) {
          return _vm.$set(tradeType, "is_enable", "0")
        }, function($event) {
          return _vm.clickClose('tradeType', false, tradeType.is_default, _vm.dIndex)
        }]
      }
    }), _vm._v("關閉\n                    ")])])])]) : _vm._e(), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tradeType.remark),
        expression: "tradeType.remark"
      }],
      staticClass: "w-100-p form-control",
      attrs: {
        "rows": "2",
        "maxlength": _vm.remarkMaxlength
      },
      domProps: {
        "value": (tradeType.remark)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(tradeType, "remark", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(tradeType.remark.length || 0) + "/" + _vm._s(_vm.remarkMaxlength))])])])
  }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(13), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("內用-桌邊掃碼")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumber.is_cash_pay_after_meal),
      expression: "tableNumber.is_cash_pay_after_meal"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.tableNumber.is_cash_pay_after_meal, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tableNumber, "is_cash_pay_after_meal", 0)
      }
    }
  }), _vm._v("\n                        餐前付款\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumber.is_cash_pay_after_meal),
      expression: "tableNumber.is_cash_pay_after_meal"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.tableNumber.is_cash_pay_after_meal, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tableNumber, "is_cash_pay_after_meal", 1)
      }
    }
  }), _vm._v("\n                        餐後付款\n                      ")])])])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addExceptionTrade
    }
  }, [_vm._v("新增限制")])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.exceptionTradeList.length) ? _c('div', [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(15), _vm._v(" "), _c('tbody', _vm._l((_vm.exceptionTradeList), function(exceptionTrade, eIndex) {
    return _c('tr', [_c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (exceptionTrade.delivery_type),
        expression: "exceptionTrade.delivery_type"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(exceptionTrade, "delivery_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": 0
      }
    }, [_vm._v("全部")]), _vm._v(" "), _vm._l((_vm.deliveryInfo), function(delivery) {
      return _c('option', {
        domProps: {
          "value": delivery.value
        }
      }, [_vm._v(_vm._s(delivery.label))])
    })], 2)]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (exceptionTrade.trade_type),
        expression: "exceptionTrade.trade_type"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(exceptionTrade, "trade_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.tradeList), function(trade) {
      return _c('option', {
        domProps: {
          "value": trade.value
        }
      }, [_vm._v(_vm._s(trade.label))])
    }), 0)]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (exceptionTrade.start_money),
        expression: "exceptionTrade.start_money"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "",
        "type": "text"
      },
      domProps: {
        "value": (exceptionTrade.start_money)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(exceptionTrade, "start_money", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (exceptionTrade.end_money),
        expression: "exceptionTrade.end_money"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "",
        "type": "text"
      },
      domProps: {
        "value": (exceptionTrade.end_money)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(exceptionTrade, "end_money", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm._f("deliveryName")(exceptionTrade.delivery_type)) + "\n                  "), (exceptionTrade.start_money) ? _c('span', [_vm._v("\n                    " + _vm._s(exceptionTrade.start_money) + " 元以上\n                  ")]) : _vm._e(), _vm._v(" "), (exceptionTrade.start_money && exceptionTrade.end_money) ? _c('span', [_vm._v("\n                    ～\n                  ")]) : _vm._e(), _vm._v(" "), (exceptionTrade.end_money) ? _c('span', [_vm._v("\n                    " + _vm._s(exceptionTrade.end_money) + " 元以下\n                  ")]) : _vm._e(), _vm._v("\n                  不可用" + _vm._s(_vm._f("tradeName")(exceptionTrade.trade_type)) + "付款\n                ")]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.exceptionTradeList, eIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 5),
      expression: "storeMethod === 5"
    }],
    staticClass: "box-body form"
  }, [_vm._m(16), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(18), _vm._v(" "), _c('tbody', _vm._l((_vm.takeTimeInfo), function(takeTime) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.hideDeliveryType.includes(takeTime.take_type)),
        expression: "!hideDeliveryType.includes(takeTime.take_type)"
      }]
    }, [_c('td', [_vm._v(_vm._s(_vm._f("deliveryName")(takeTime.take_type)))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (takeTime.prepare_time_seg),
        expression: "takeTime.prepare_time_seg"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "",
        "type": "text"
      },
      domProps: {
        "value": (takeTime.prepare_time_seg)
      },
      on: {
        "keypress": _vm.returnNum,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(takeTime, "prepare_time_seg", $event.target.value)
        }
      }
    }), _vm._v("  分鐘\n              ")]), _vm._v(" "), _c('td', [(takeTime.take_type < 3) ? _c('span', [_vm._v("不需設定")]) : (takeTime.take_type === 21) ? _c('span', [_vm._v("不需設定")]) : _c('div', {
      staticClass: "flex align-center"
    }, [_c('div', {
      staticClass: "input-group-btn flex w-auto"
    }, [_c('button', {
      staticClass: "btn btn-default w-36px",
      attrs: {
        "disabled": !takeTime.take_time_seg
      },
      on: {
        "click": function($event) {
          return _vm.setTakeTime('minus', takeTime)
        }
      }
    }, [_vm._v("\n                      -\n                    ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (takeTime.take_time_seg),
        expression: "takeTime.take_time_seg"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "",
        "type": "text"
      },
      domProps: {
        "value": (takeTime.take_time_seg)
      },
      on: {
        "keypress": _vm.returnNum,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(takeTime, "take_time_seg", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default w-36px",
      on: {
        "click": function($event) {
          return _vm.setTakeTime('add', takeTime)
        }
      }
    }, [_vm._v("\n                      +\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "m-l-5"
    }, [_vm._v("分鐘")])])])])
  }), 0)])]), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', {
    staticClass: "text-left"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addProcessTime
    }
  }, [_vm._v("新增某時段的製作時間")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.processTimeList), function(process, pIndex) {
    return _c('div', {
      staticClass: "m-t-10 process-time-block"
    }, [_c('div', {
      staticClass: "text-right m-b-10"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.processTimeList, pIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n              月份\n            ")]), _vm._v(" "), _c('div', [_c('multiselect', {
      attrs: {
        "placeholder": "新增月份",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdaySetting.options.month,
        "multiple": false,
        "allow-empty": true
      },
      model: {
        value: (process.month),
        callback: function($$v) {
          _vm.$set(process, "month", $$v)
        },
        expression: "process.month"
      }
    })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("時間類型")]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (process.value_type),
        expression: "process.value_type"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(process, "value_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.clearProcess(process)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": 1
      }
    }, [_vm._v("日期")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 2
      }
    }, [_vm._v("星期")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), (process.value_type === 2) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n              開始\n            ")]), _vm._v(" "), _c('div', [_c('multiselect', {
      attrs: {
        "placeholder": "新增星期",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdaySetting.options.weekDay,
        "multiple": false,
        "allow-empty": true
      },
      model: {
        value: (process.start_value),
        callback: function($$v) {
          _vm.$set(process, "start_value", $$v)
        },
        expression: "process.start_value"
      }
    })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (process.value_type === 1) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n              開始\n            ")]), _vm._v(" "), _c('div', [_c('multiselect', {
      attrs: {
        "tag-placeholder": "數字為1~31",
        "placeholder": "新增日期 (格式為數字1~31)",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdaySetting.options.monthDay,
        "multiple": false,
        "taggable": true,
        "id": 'process-start-' + pIndex
      },
      on: {
        "tag": _vm.addStartMonthDayTag
      },
      model: {
        value: (process.start_value),
        callback: function($$v) {
          _vm.$set(process, "start_value", $$v)
        },
        expression: "process.start_value"
      }
    })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (process.value_type === 2) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n              結束\n            ")]), _vm._v(" "), _c('div', [_c('multiselect', {
      attrs: {
        "placeholder": "新增星期",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdaySetting.options.weekDay,
        "multiple": false,
        "allow-empty": true
      },
      model: {
        value: (process.end_value),
        callback: function($$v) {
          _vm.$set(process, "end_value", $$v)
        },
        expression: "process.end_value"
      }
    })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (process.value_type === 1) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n              結束\n            ")]), _vm._v(" "), _c('div', [_c('multiselect', {
      attrs: {
        "tag-placeholder": "數字為1~31",
        "placeholder": "新增日期 (格式為數字1~31)",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdaySetting.options.monthDay,
        "multiple": false,
        "taggable": true
      },
      on: {
        "tag": _vm.addEndMonthDayTag
      },
      model: {
        value: (process.end_value),
        callback: function($$v) {
          _vm.$set(process, "end_value", $$v)
        },
        expression: "process.end_value"
      }
    })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n              取餐類型\n            ")]), _vm._v(" "), _c('div', [_c('multiselect', {
      attrs: {
        "placeholder": "選擇取餐類型",
        "label": "label",
        "track-by": "value",
        "options": _vm.deliveryTypeOption,
        "multiple": false,
        "allow-empty": true
      },
      model: {
        value: (process.delivery_type),
        callback: function($$v) {
          _vm.$set(process, "delivery_type", $$v)
        },
        expression: "process.delivery_type"
      }
    })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "text-left"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.addItemTime(process)
        }
      }
    }, [_vm._v("加入時間")])]), _vm._v(" "), _c('table', {
      staticClass: "table table-bordered table-striped dataTable"
    }, [_vm._m(19, true), _vm._v(" "), _c('tbody', _vm._l((process.item_list), function(item, iIndex) {
      return _c('tr', [_c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.start_time),
          expression: "item.start_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.start_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "start_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.end_time),
          expression: "item.end_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.end_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "end_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.process_time),
          expression: "item.process_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "",
          "type": "text"
        },
        domProps: {
          "value": (item.process_time)
        },
        on: {
          "keypress": _vm.returnNum,
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "process_time", $event.target.value)
          }
        }
      }), _vm._v("  分鐘\n              ")]), _vm._v(" "), _c('td', [(iIndex > 0) ? _c('button', {
        staticClass: "btn btn-danger",
        on: {
          "click": function($event) {
            return _vm.removeListItem(process.item_list, iIndex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })]) : _vm._e()])])
    }), 0)])])
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 6),
      expression: "storeMethod === 6"
    }],
    staticClass: "box-body form"
  }, [_vm._m(20), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), (_vm.reCheckOption.body) ? _c('div', {
    staticClass: "hint mb-1"
  }, [_c('i', {
    staticClass: "fa fa-close re-check-close",
    on: {
      "click": function($event) {
        _vm.invalidStoreMap = null
      }
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.reCheckOption.body)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("取餐類型")]), _vm._v(" "), (_vm.getRoleType == 99) ? _c('td', [_vm._v("支援與否")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("開啟狀態")]), _vm._v(" "), _c('td', [_vm._v("\n                預設\n                "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text center"
  }, [_vm._v("\n                    購物車預設的取餐方式。開啟狀態為 \"開啟\" 的取餐方式才能設為預設。\n                  ")])], 1)]), _vm._v(" "), _c('td', [_c('span', [_vm._v("消費金額與距離門檻")]), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(24)], 1)]), _vm._v(" "), _c('td', [_c('span', [_vm._v("備註")]), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(25)], 1)]), _vm._v(" "), _c('td', [_c('span', [_vm._v("取餐提醒")]), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(26)], 1)])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.deliveryWaysInfo), function(deliveryWays, dIndex) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.hideDeliveryType.includes(deliveryWays.take_type)),
        expression: "!hideDeliveryType.includes(deliveryWays.take_type)"
      }],
      key: dIndex
    }, [_c('td', [_vm._v(_vm._s(_vm._f("deliveryName")(deliveryWays.take_type)))]), _vm._v(" "), (_vm.getRoleType == 99) ? _c('td', [_c('div', {
      staticClass: "form-group text-left"
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.is_support),
        expression: "deliveryWays.is_support"
      }],
      attrs: {
        "type": "radio",
        "value": "1"
      },
      domProps: {
        "checked": _vm._q(deliveryWays.is_support, "1")
      },
      on: {
        "change": function($event) {
          return _vm.$set(deliveryWays, "is_support", "1")
        }
      }
    }), _vm._v("\n                      支援\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.is_support),
        expression: "deliveryWays.is_support"
      }],
      attrs: {
        "type": "radio",
        "value": "0"
      },
      domProps: {
        "checked": _vm._q(deliveryWays.is_support, "0")
      },
      on: {
        "change": [function($event) {
          return _vm.$set(deliveryWays, "is_support", "0")
        }, function($event) {
          return _vm.clickClose('deliveryWays', true, deliveryWays.is_default, dIndex)
        }]
      }
    }), _vm._v("\n                      不支援\n                    ")])])])]) : _vm._e(), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group text-left"
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.is_enable),
        expression: "deliveryWays.is_enable"
      }],
      attrs: {
        "type": "radio",
        "disabled": parseInt(deliveryWays.is_support, 10) === 0,
        "value": "1"
      },
      domProps: {
        "checked": _vm._q(deliveryWays.is_enable, "1")
      },
      on: {
        "change": function($event) {
          return _vm.$set(deliveryWays, "is_enable", "1")
        }
      }
    }), _vm._v(" "), _c('span', {
      class: {
        'radio-text--disabled': deliveryWays.is_support == 0
      }
    }, [_vm._v("\n                          開啟\n                        ")])])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.is_enable),
        expression: "deliveryWays.is_enable"
      }],
      attrs: {
        "type": "radio",
        "value": "0",
        "disabled": parseInt(deliveryWays.is_support, 10) === 0
      },
      domProps: {
        "checked": _vm._q(deliveryWays.is_enable, "0")
      },
      on: {
        "change": [function($event) {
          return _vm.$set(deliveryWays, "is_enable", "0")
        }, function($event) {
          return _vm.clickClose('deliveryWays', false, deliveryWays.is_default, dIndex)
        }]
      }
    }), _vm._v(" "), _c('span', {
      class: {
        'radio-text--disabled': deliveryWays.is_support == 0
      }
    }, [_vm._v("\n                          關閉\n                        ")])])])])]), _vm._v(" "), _c('td', [(deliveryWays.take_type !== 21) ? _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.is_default),
        expression: "deliveryWays.is_default"
      }],
      attrs: {
        "type": "radio",
        "value": "1",
        "disabled": parseInt(deliveryWays.is_support, 10) === 0 || parseInt(deliveryWays.is_enable, 10) === 0
      },
      domProps: {
        "checked": _vm._q(deliveryWays.is_default, "1")
      },
      on: {
        "change": [function($event) {
          return _vm.$set(deliveryWays, "is_default", "1")
        }, function($event) {
          return _vm.checkDefault(deliveryWays.take_type)
        }]
      }
    })]) : _vm._e()]), _vm._v(" "), (deliveryWays.take_type !== 3) ? _c('td', [_vm._v("\n                滿  "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.price),
        expression: "deliveryWays.price"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "",
        "type": "text"
      },
      domProps: {
        "value": (deliveryWays.price)
      },
      on: {
        "keypress": _vm.returnNum,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(deliveryWays, "price", $event.target.value)
        }
      }
    }), _vm._v("  元即可" + _vm._s(_vm._f("deliveryName")(deliveryWays.take_type)) + "\n              ")]) : _vm._e(), _vm._v(" "), (deliveryWays.take_type === 3) ? _c('td', [_c('delivery-limit', {
      attrs: {
        "store-info": _vm.storeInfo,
        "delivery-ways": deliveryWays,
        "delivery-ways-info": _vm.deliveryWaysInfo,
        "delivery-other": _vm.deliveryOther
      },
      on: {
        "update:deliveryWaysInfo": function($event) {
          _vm.deliveryWaysInfo = $event
        },
        "update:deliveryOther": function($event) {
          _vm.deliveryOther = $event
        },
        "update:storeInfo": function($event) {
          _vm.storeInfo = $event
        },
        "update:deliveryWays": function($event) {
          deliveryWays = $event
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.memo),
        expression: "deliveryWays.memo"
      }],
      staticClass: "w-100-p form-control",
      attrs: {
        "rows": "2",
        "maxlength": _vm.remarkMaxlength
      },
      domProps: {
        "value": (deliveryWays.memo)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(deliveryWays, "memo", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(deliveryWays.memo ? deliveryWays.memo.length : 0) + "/" + _vm._s(_vm.remarkMaxlength))])]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.pickup_memo),
        expression: "deliveryWays.pickup_memo"
      }],
      staticClass: "w-100-p form-control",
      attrs: {
        "disabled": _vm.getRoleType === 10 && deliveryWays.is_support === 0,
        "rows": "2",
        "maxlength": _vm.remarkMaxlength
      },
      domProps: {
        "value": (deliveryWays.pickup_memo)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(deliveryWays, "pickup_memo", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(deliveryWays.pickup_memo ? deliveryWays.pickup_memo.length : 0) + "/" + _vm._s(_vm.remarkMaxlength))])])])
  }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('shipping-form', {
    ref: "shippingInfo",
    attrs: {
      "store-info": _vm.storeInfo,
      "resetShopping": _vm.resetShopping
    },
    on: {
      "update:store-info": function($event) {
        _vm.storeInfo = $event
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('h3', [_vm._v("桌號設定")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              送餐方式\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumber.sub_delivery_type),
      expression: "tableNumber.sub_delivery_type"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.tableNumber.sub_delivery_type, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tableNumber, "sub_delivery_type", 1)
      }
    }
  }), _vm._v("\n                    叫號取餐\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumber.sub_delivery_type),
      expression: "tableNumber.sub_delivery_type"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.tableNumber.sub_delivery_type, 2)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tableNumber, "sub_delivery_type", 2)
      }
    }
  }), _vm._v("\n                    店家送餐\n                  ")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.tableNumber.sub_delivery_type === 2) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("桌號必填")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumber.is_table_no_required),
      expression: "tableNumber.is_table_no_required"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableNumber, "is_table_no_required", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("非必填")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("必填")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.tableNumber.sub_delivery_type === 2) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                桌號編輯\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumber.is_table_no_editable),
      expression: "tableNumber.is_table_no_editable"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableNumber, "is_table_no_editable", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("不可編輯")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("可編輯")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.tableNumber.sub_delivery_type === 2) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                桌號顯示\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumber.show_table_no),
      expression: "tableNumber.show_table_no"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableNumber, "show_table_no", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("顯示")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("隱藏")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                訪客下單\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, _vm._l((_vm.deliveryWaysInfo), function(deliveryWays, i) {
    return (deliveryWays.take_type === 21) ? _c('div', {
      key: i
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.is_allow_guest_order),
        expression: "deliveryWays.is_allow_guest_order"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": 1,
        "checked": _vm._q(deliveryWays.is_allow_guest_order, 1)
      },
      on: {
        "change": function($event) {
          return _vm.$set(deliveryWays, "is_allow_guest_order", 1)
        }
      }
    }), _vm._v("\n                        開啟\n                      ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.is_allow_guest_order),
        expression: "deliveryWays.is_allow_guest_order"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": 0,
        "checked": _vm._q(deliveryWays.is_allow_guest_order, 0)
      },
      on: {
        "change": function($event) {
          return _vm.$set(deliveryWays, "is_allow_guest_order", 0)
        }
      }
    }), _vm._v("\n                        關閉\n                      ")])])]) : _vm._e()
  }), 0)])]), _vm._v(" "), _c('br')]), _vm._v(" "), _vm._l((_vm.deliveryWaysInfo), function(deliveryWays, i) {
    return (deliveryWays.take_type === 21 && deliveryWays.is_allow_guest_order === 1) ? _c('div', {
      key: i
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n                預設登入方式\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.tableNumber.default_login_type),
        expression: "tableNumber.default_login_type"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.tableNumber, "default_login_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": 1
      }
    }, [_vm._v("會員")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 2
      }
    }, [_vm._v("訪客")])])])]), _vm._v(" "), _c('br')]) : _vm._e()
  })], 2), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', [_c('h3', [_vm._v("排除設定")])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', [_c('p', [_vm._v("某時間(日期、星期、每月幾號)無法取餐(自取、外送、內用、桌邊掃碼)")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addExCalendar
    }
  }, [_vm._v("新增店家排除時段設定")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.exceptionCalendar), function(exCalendar, caIndex) {
    return _c('div', {
      staticClass: "m-t-10 process-time-block"
    }, [_c('div', {
      staticClass: "text-right m-b-10"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.exceptionCalendar, caIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("排除取餐類型")]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (exCalendar.delivery_type),
        expression: "exCalendar.delivery_type"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(exCalendar, "delivery_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.deliveryInfo), function(delivery) {
      return _c('option', {
        domProps: {
          "value": delivery.value
        }
      }, [_vm._v(_vm._s(delivery.label))])
    }), 0)])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "text-left"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.addExDate(exCalendar)
        }
      }
    }, [_vm._v("加入指定日期")])]), _vm._v(" "), (exCalendar.date_type.length) ? _c('table', {
      staticClass: "table table-bordered table-striped dataTable"
    }, [_vm._m(27, true), _vm._v(" "), _c('tbody', _vm._l((exCalendar.date_type), function(item, daIndex) {
      return _c('tr', [_c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.date),
          expression: "item.date"
        }],
        staticClass: "form-control inline-block",
        attrs: {
          "placeholder": "YYYY-MM-DD",
          "type": "text"
        },
        domProps: {
          "value": (item.date)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "date", $event.target.value)
          }
        }
      }), _vm._v("  \n              ")]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.start_time),
          expression: "item.start_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.start_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "start_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.end_time),
          expression: "item.end_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.end_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "end_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('button', {
        staticClass: "btn btn-danger",
        on: {
          "click": function($event) {
            return _vm.removeListItem(exCalendar.date_type, daIndex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })])])])
    }), 0)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "text-left"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.addExWeekDay(exCalendar)
        }
      }
    }, [_vm._v("加入星期")])]), _vm._v(" "), (exCalendar.week_day.length) ? _c('table', {
      staticClass: "table table-bordered table-striped dataTable"
    }, [_vm._m(28, true), _vm._v(" "), _c('tbody', _vm._l((exCalendar.week_day), function(item, weIndex) {
      return _c('tr', [_c('td', [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.day),
          expression: "item.day"
        }],
        staticClass: "form-control",
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(item, "day", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.offdaySetting.options.weekDay), function(weekDay) {
        return (weekDay.value) ? _c('option', {
          domProps: {
            "value": weekDay.value
          }
        }, [_vm._v("\n                    " + _vm._s(weekDay.label) + "\n                  ")]) : _vm._e()
      }), 0)]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.start_time),
          expression: "item.start_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.start_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "start_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.end_time),
          expression: "item.end_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.end_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "end_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('button', {
        staticClass: "btn btn-danger",
        on: {
          "click": function($event) {
            return _vm.removeListItem(exCalendar.week_day, weIndex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })])])])
    }), 0)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "text-left"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.addExMonthDay(exCalendar)
        }
      }
    }, [_vm._v("加入每月幾號")])]), _vm._v(" "), (exCalendar.month_day.length) ? _c('table', {
      staticClass: "table table-bordered table-striped dataTable"
    }, [_vm._m(29, true), _vm._v(" "), _c('tbody', _vm._l((exCalendar.month_day), function(item, moIndex) {
      return _c('tr', [_c('td', [_vm._v("\n                每月"), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.day),
          expression: "item.day"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "1-31",
          "type": "text"
        },
        domProps: {
          "value": (item.day)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "day", $event.target.value)
          }
        }
      }), _vm._v("  日\n              ")]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.start_time),
          expression: "item.start_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.start_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "start_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.end_time),
          expression: "item.end_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.end_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "end_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('button', {
        staticClass: "btn btn-danger",
        on: {
          "click": function($event) {
            return _vm.removeListItem(exCalendar.month_day, moIndex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })])])])
    }), 0)]) : _vm._e()])
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "pickupWarnModal",
    staticClass: "btn",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#pickupWarnModal"
    }
  }), _vm._v(" "), _vm._m(30)], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 7),
      expression: "storeMethod === 7"
    }],
    staticClass: "box-body form"
  }, [_vm._m(31), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(32), _vm._v(" "), _c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "overflow": "inherit"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(33), _vm._v(" "), _c('tbody', _vm._l((_vm.openingInfo), function(weekDay) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.getWeekDayName(weekDay.week_day)))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (weekDay.start),
        expression: "weekDay.start"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "hh:mm",
        "type": "text"
      },
      domProps: {
        "value": (weekDay.start)
      },
      on: {
        "blur": function($event) {
          return _vm.validateTimeRange(weekDay, 'start', 'end')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(weekDay, "start", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (weekDay.end),
        expression: "weekDay.end"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "hh:mm",
        "type": "text"
      },
      domProps: {
        "value": (weekDay.end)
      },
      on: {
        "blur": function($event) {
          return _vm.validateTimeRange(weekDay, 'start', 'end')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(weekDay, "end", $event.target.value)
        }
      }
    })])])
  }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addSpecialDay
    }
  }, [_vm._v("新增指定日期")])]), _vm._v(" "), (_vm.selectSpecialDay.length) ? _c('div', {
    staticClass: "m-t-10"
  }, [_vm._m(34), _vm._v(" "), _vm._m(35), _vm._v(" "), _c('div', {
    staticClass: "table-responsive specialDayCalendarTable-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_c('thead', {
    staticClass: "bg-primary sticky-header"
  }, [_c('tr', [_c('td', [_vm._v("指定日期")]), _vm._v(" "), _c('td', [_vm._v("營業時間")]), _vm._v(" "), _c('td', [_vm._v("打烊時間")]), _vm._v(" "), _c('td', [_vm._v("備註\n                  "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(36)], 1)]), _vm._v(" "), _c('td')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.selectSpecialDay), function(item, daIndex) {
    return _c('tr', [_c('td', {
      staticClass: "date-picker-cell"
    }, [_c('div', {
      staticClass: "calendar-container"
    }, [(item.showSpecialDayCalendar) ? _c('div', {
      staticClass: "calendar"
    }, [_c('FunctionalCalendar', {
      attrs: {
        "is-multiple-date-picker": true,
        "limits": _vm.calendarLimits
      },
      on: {
        "dayClicked": function($event) {
          return _vm.specialDayCalendarSelected(daIndex, $event)
        }
      },
      model: {
        value: (_vm.tempSpecialDayCalendar),
        callback: function($$v) {
          _vm.tempSpecialDayCalendar = $$v
        },
        expression: "tempSpecialDayCalendar"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "calenderClose"
    }, [_c('button', {
      staticClass: "btn btn-primary btn-xs btn-close",
      on: {
        "click": function($event) {
          item.showSpecialDayCalendar = false
        }
      }
    }, [_vm._v("\n                        關閉\n                      ")])])], 1) : _vm._e(), _vm._v(" "), _c('multiselect', {
      staticClass: "calendar-multiselect",
      attrs: {
        "tag-placeholder": "格式為YYYY-MM-DD",
        "placeholder": "新增日期 (格式為YYYY-MM-DD)",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdaySetting.options.date,
        "multiple": true,
        "optionsLimit": 0,
        "hideSelected": true,
        "∂": ""
      },
      on: {
        "remove": function($event) {
          return _vm.removeTag('specialDay', daIndex, _vm.val)
        },
        "open": function($event) {
          return _vm.openSpecialDayCalendar(daIndex)
        }
      },
      model: {
        value: (item.calendar_list),
        callback: function($$v) {
          _vm.$set(item, "calendar_list", $$v)
        },
        expression: "item.calendar_list"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.start_time),
        expression: "item.start_time"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "hh:mm",
        "type": "text"
      },
      domProps: {
        "value": (item.start_time)
      },
      on: {
        "blur": function($event) {
          return _vm.validateTimeRange(item)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "start_time", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.end_time),
        expression: "item.end_time"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "hh:mm",
        "type": "text"
      },
      domProps: {
        "value": (item.end_time)
      },
      on: {
        "blur": function($event) {
          return _vm.validateTimeRange(item)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "end_time", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "remark-cell"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.remark),
        expression: "item.remark"
      }],
      staticClass: "w-100-p form-control",
      attrs: {
        "rows": "1",
        "maxlength": _vm.specialDayRemarkMaxlength
      },
      domProps: {
        "value": (item.remark)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "remark", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s((item.remark || '').length) + "/" + _vm._s(_vm.specialDayRemarkMaxlength))])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.selectSpecialDay, daIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), _vm._m(37), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            公休時間下單\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_off_allow_order),
      expression: "storeInfo.is_off_allow_order"
    }],
    attrs: {
      "type": "radio",
      "name": "isOffAllow"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.is_off_allow_order, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_off_allow_order", 1)
      }
    }
  }), _vm._v("可下單\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_off_allow_order),
      expression: "storeInfo.is_off_allow_order"
    }],
    attrs: {
      "type": "radio",
      "name": "isOffAllow"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.is_off_allow_order, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_off_allow_order", 0)
      }
    }
  }), _vm._v("不可下單\n                  ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              指定日期\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "calendar-container"
  }, [(_vm.showCalendar) ? _c('div', {
    staticClass: "calendar",
    on: {
      "blur": function($event) {
        _vm.showCalendar = false
      }
    }
  }, [_c('FunctionalCalendar', {
    attrs: {
      "is-multiple-date-picker": true,
      "limits": _vm.calendarLimits
    },
    on: {
      "dayClicked": _vm.calendarSelected
    },
    model: {
      value: (_vm.selectDate),
      callback: function($$v) {
        _vm.selectDate = $$v
      },
      expression: "selectDate"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "calenderClose"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xs btn-close nd-ml-5",
    on: {
      "click": function($event) {
        _vm.showCalendar = false
      }
    }
  }, [_vm._v("\n                  關閉\n                ")])])], 1) : _vm._e(), _vm._v(" "), _c('multiselect', {
    staticClass: "calendar-multiselect",
    attrs: {
      "tag-placeholder": "格式為YYYY-MM-DD",
      "placeholder": "新增日期 (格式為YYYY-MM-DD)",
      "label": "label",
      "track-by": "value",
      "options": _vm.offdaySetting.options.date,
      "multiple": true,
      "optionsLimit": 0,
      "hideSelected": true
    },
    on: {
      "remove": function($event) {
        return _vm.removeTag('date', 0, $event)
      },
      "open": _vm.openDateCalendar
    },
    model: {
      value: (_vm.offdaySetting.date),
      callback: function($$v) {
        _vm.$set(_vm.offdaySetting, "date", $$v)
      },
      expression: "offdaySetting.date"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              每週幾\n            ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "placeholder": "新增日期",
      "label": "label",
      "track-by": "value",
      "options": _vm.offdayWeekDayOptions,
      "multiple": true,
      "allow-empty": true
    },
    model: {
      value: (_vm.offdaySetting.weekDay),
      callback: function($$v) {
        _vm.$set(_vm.offdaySetting, "weekDay", $$v)
      },
      expression: "offdaySetting.weekDay"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              每月幾號\n            ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "tag-placeholder": "數字為1~31",
      "placeholder": "新增日期 (格式為數字1~31)",
      "label": "label",
      "track-by": "value",
      "options": _vm.offdayMonthDayOptions,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addMonthDayTag
    },
    model: {
      value: (_vm.offdaySetting.monthDay),
      callback: function($$v) {
        _vm.$set(_vm.offdaySetting, "monthDay", $$v)
      },
      expression: "offdaySetting.monthDay"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 8),
      expression: "storeMethod === 8"
    }],
    staticClass: "box-body form"
  }, [(_vm.getRoleType === 99 || _vm.getRoleType === 30 || _vm.getRoleType === 10) ? _c('div', [_vm._m(38), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(39), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plasticSelect),
      expression: "plasticSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "plasticOption",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.plasticSelect, "1")
    },
    on: {
      "change": function($event) {
        _vm.plasticSelect = "1"
      }
    }
  }), _vm._v("開啟（此功能需於菜單上架塑膠袋商品方可支援）\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plasticSelect),
      expression: "plasticSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "plasticOption",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.plasticSelect, "0")
    },
    on: {
      "change": function($event) {
        _vm.plasticSelect = "0"
      }
    }
  }), _vm._v("關閉\n                    ")])])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                塑膠袋數量可自行調整\n                "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text",
    domProps: {
      "textContent": _vm._s('消費者可否在購物車中自行調整塑膠袋的數量')
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plasticAmountAdjustable),
      expression: "plasticAmountAdjustable"
    }],
    attrs: {
      "type": "radio",
      "name": "plasticAmountAdjustable",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.plasticAmountAdjustable, "1")
    },
    on: {
      "change": function($event) {
        _vm.plasticAmountAdjustable = "1"
      }
    }
  }), _vm._v("開啟\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plasticAmountAdjustable),
      expression: "plasticAmountAdjustable"
    }],
    attrs: {
      "type": "radio",
      "name": "plasticAmountAdjustable",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.plasticAmountAdjustable, "0")
    },
    on: {
      "change": function($event) {
        _vm.plasticAmountAdjustable = "0"
      }
    }
  }), _vm._v("關閉\n                    ")])])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                塑膠袋單位(幾份商品一個塑膠袋)\n              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number.trim",
      value: (_vm.storeInfo.plastic_unit),
      expression: "storeInfo.plastic_unit",
      modifiers: {
        "number": true,
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.storeInfo.plastic_unit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "plastic_unit", _vm._n($event.target.value.trim()))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                預設勾選塑膠袋\n              ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "placeholder": "選擇取餐方式",
      "label": "label",
      "track-by": "value",
      "options": _vm.deliveryInfo,
      "multiple": true,
      "allow-empty": true
    },
    model: {
      value: (_vm.deliveryWayPlastic),
      callback: function($$v) {
        _vm.deliveryWayPlastic = $$v
      },
      expression: "deliveryWayPlastic"
    }
  })], 1)]), _vm._v(" "), _c('br')])]) : _vm._e()]), _vm._v(" "), _c('shipping-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 9),
      expression: "storeMethod === 9"
    }],
    ref: "shipping",
    attrs: {
      "resetShopping": _vm.resetShopping
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 10),
      expression: "storeMethod === 10"
    }],
    staticClass: "box-body form"
  }, [_vm._m(40), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.printerStoreList.length) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(41), _vm._v(" "), _c('tbody', _vm._l((_vm.printerStoreList), function(printer, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v("\n                  出單機" + _vm._s(printer.printer_id) + "號 (" + _vm._s(printer.printer_id) + ")\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(printer.binding_name) + " (" + _vm._s(printer.binding_id) + ")\n                ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.printerType(printer.printer_type)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(printer.printer_identity))]), _vm._v(" "), _c('td', [(printer.printer_is_enabled) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _vm._e(), _vm._v(" "), (!printer.printer_is_enabled) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("未啟用")]) : _vm._e()]), _vm._v(" "), _c('td', [(printer.binding_is_enabled) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _vm._e(), _vm._v(" "), (!printer.binding_is_enabled) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("未啟用")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#editModal"
      },
      on: {
        "click": function($event) {
          return _vm.getCurrent(printer)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#delModal"
      },
      on: {
        "click": function($event) {
          return _vm.getCurrent(printer)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)]), _vm._v(" "), _c('br')])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            方式\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerSelect),
      expression: "printerSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.printerSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("使用現有")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.printerSelect === 1) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            識別碼\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerInfo.identity),
      expression: "printerInfo.identity"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.printerInfo.identity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.printerInfo, "identity", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.printerSelect === 1) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            類型\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerInfo.type),
      expression: "printerInfo.type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.printerInfo, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("W牌出單機(1)")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("F牌出單機(2)")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("F牌貼紙機(3)")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.printerSelect === 2) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            選擇出單機\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isPrinterSelect),
      expression: "isPrinterSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isPrinterSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.printerList), function(printer) {
    return _c('option', {
      domProps: {
        "value": printer.printer_id
      }
    }, [_vm._v(_vm._s(printer.printer_identity))])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.storeMethod === 10) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.checkPrinter
    }
  }, [_vm._v("\n          綁定\n        ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr', {
    staticClass: "m-t-20"
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.printerLayoutSetting.length) ? _c('div', [_vm._m(42), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(43), _vm._v(" "), _c('tbody', _vm._l((_vm.printerLayoutSetting), function(printer, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(printer.layout_name) + "\n                  ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (printer.trigger_type),
        expression: "printer.trigger_type"
      }],
      attrs: {
        "type": "radio",
        "name": 'triggerType' + index
      },
      domProps: {
        "value": 1,
        "checked": _vm._q(printer.trigger_type, 1)
      },
      on: {
        "change": function($event) {
          return _vm.$set(printer, "trigger_type", 1)
        }
      }
    }), _vm._v("手動\n                      ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (printer.trigger_type),
        expression: "printer.trigger_type"
      }],
      attrs: {
        "type": "radio",
        "name": 'triggerType' + index
      },
      domProps: {
        "value": 2,
        "checked": _vm._q(printer.trigger_type, 2)
      },
      on: {
        "change": function($event) {
          return _vm.$set(printer, "trigger_type", 2)
        }
      }
    }), _vm._v("自動\n                      ")])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (printer.is_enabled),
        expression: "printer.is_enabled"
      }],
      attrs: {
        "type": "radio",
        "name": 'isEnable' + index
      },
      domProps: {
        "value": 1,
        "checked": _vm._q(printer.is_enabled, 1)
      },
      on: {
        "change": function($event) {
          return _vm.$set(printer, "is_enabled", 1)
        }
      }
    }), _vm._v("啟用\n                      ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (printer.is_enabled),
        expression: "printer.is_enabled"
      }],
      attrs: {
        "type": "radio",
        "name": 'isEnable' + index
      },
      domProps: {
        "value": 0,
        "checked": _vm._q(printer.is_enabled, 0)
      },
      on: {
        "change": function($event) {
          return _vm.$set(printer, "is_enabled", 0)
        }
      }
    }), _vm._v("未啟用\n                      ")])])])])
  }), 0)]), _vm._v(" "), _c('br')])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 11 && _vm.$route.name !== 'crStore'),
      expression: "storeMethod === 11 && $route.name !== 'crStore'"
    }],
    staticClass: "box-body form"
  }, [_vm._m(44), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(45), _vm._v(" "), _c('div', {
    staticClass: "table-responsive m-b-15"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("入口")]), _vm._v(" "), _c('td', [_vm._v("桌號\n                  "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text center"
  }, [_vm._v("\n                      限10字以內，僅限英數大小寫不可符號，桌號間請使用「，」分隔。\n                    ")])], 1)]), _vm._v(" "), _c('td')])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumberUrl.type),
      expression: "tableNumberUrl.type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableNumberUrl, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.enterType), function(item) {
    return _c('option', {
      key: ("enter-" + (item.value)),
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.tableNumberUrl.text),
      expression: "tableNumberUrl.text",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control inline-block",
    attrs: {
      "rows": "3",
      "placeholder": "範例：A01,A02,A03..."
    },
    domProps: {
      "value": (_vm.tableNumberUrl.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tableNumberUrl, "text", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn btn-default btn-table-title",
    on: {
      "click": _vm.exportUrl
    }
  }, [_vm._v("匯出網址")])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 12),
      expression: "storeMethod === 12"
    }],
    staticClass: "box-body form"
  }, [_vm._m(46), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              選擇計費方式\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderCommissionSetting.type),
      expression: "orderCommissionSetting.type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.orderCommissionSetting, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("系統費")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("系統費+資訊服務費抽成")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("資訊服務費抽成")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.orderCommissionSetting.type > 1) ? _c('div', {
    staticClass: "text-left"
  }, [_c('div', [_vm._m(47), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.orderCommissionSetting.item_list.push(JSON.parse(JSON.stringify(_vm.commissionItemList)))
      }
    }
  }, [_vm._v("\n              新增資訊服務費抽成設定\n            ")])]), _vm._v(" "), _vm._l((_vm.orderCommissionSetting.item_list), function(item, pIndex) {
    return _c('div', {
      key: pIndex,
      class: ['process-time-block', {
        'm-t-10': pIndex !== 0
      }, {
        'overlap': _vm.showOverlapErrorIndex.includes(pIndex)
      }]
    }, [_c('div', {
      staticClass: "text-right m-b-10"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.orderCommissionSetting.item_list, pIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(48, true), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.ratio),
        expression: "item.ratio"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "輸入數字",
        "type": "number",
        "maxlength": "2"
      },
      domProps: {
        "value": (item.ratio)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "ratio", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-addon-icon"
    }, [_vm._v("\n                  %\n                ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n                  取貨方式\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.delivery_type),
        expression: "item.delivery_type"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "delivery_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": 0
      }
    }, [_vm._v("全部")]), _vm._v(" "), _vm._l((_vm.supportDeliveryOption), function(delivery) {
      return _c('option', {
        key: ("takeType" + (delivery.value)),
        domProps: {
          "value": delivery.value
        }
      }, [_vm._v("\n                      " + _vm._s(delivery.label) + "\n                    ")])
    })], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "table-row"
    }, [_vm._m(49, true), _vm._v(" "), _c('div', {
      staticClass: "table-from"
    }, [_c('date-picker', {
      staticClass: "hide-date-icon",
      attrs: {
        "show-second": false,
        "type": "datetime",
        "valueType": "format",
        "format": "YYYY-MM-DD HH:mm",
        "input-class": "form-control",
        "placeholder": "新增日期 (格式為：YYYY-MM-DD HH:mm)",
        "clearable": false,
        "disabled-time": _vm.notBeforeTodayAddTwoMins,
        "disabled-date": _vm.notBeforeToday
      },
      model: {
        value: (item.start_time),
        callback: function($$v) {
          _vm.$set(item, "start_time", $$v)
        },
        expression: "item.start_time"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "table-row p-t-10"
    }, [_vm._m(50, true), _vm._v(" "), _c('div', {
      staticClass: "table-from"
    }, [_c('date-picker', {
      staticClass: "hide-date-icon",
      attrs: {
        "show-second": false,
        "type": "datetime",
        "valueType": "format",
        "format": "YYYY-MM-DD HH:mm",
        "input-class": "form-control",
        "placeholder": "新增日期 (格式為：YYYY-MM-DD HH:mm)",
        "clearable": false,
        "disabled-time": _vm.notBeforeTodayAddTwoMins,
        "disabled-date": _vm.notBeforeToday
      },
      model: {
        value: (item.end_time),
        callback: function($$v) {
          _vm.$set(item, "end_time", $$v)
        },
        expression: "item.end_time"
      }
    })], 1)])])])
  }), _vm._v(" "), _c('br')], 2) : _vm._e(), _vm._v(" "), (_vm.orderCommissionSetting.type !== 1) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(51), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderCommissionSetting.has_independent_report),
      expression: "orderCommissionSetting.has_independent_report"
    }],
    attrs: {
      "type": "radio",
      "name": "independent"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.orderCommissionSetting.has_independent_report, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.orderCommissionSetting, "has_independent_report", 1)
      }
    }
  }), _vm._v("是\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderCommissionSetting.has_independent_report),
      expression: "orderCommissionSetting.has_independent_report"
    }],
    attrs: {
      "type": "radio",
      "name": "independent"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.orderCommissionSetting.has_independent_report, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.orderCommissionSetting, "has_independent_report", 0)
      }
    }
  }), _vm._v("否\n                    ")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.orderCommissionSetting.has_independent_report === 1) ? _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                門市每月作廢訂單額度(筆)\n              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderCommissionSetting.allow_invalid_order_quota),
      expression: "orderCommissionSetting.allow_invalid_order_quota"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.orderCommissionSetting.allow_invalid_order_quota)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderCommissionSetting, "allow_invalid_order_quota", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.orderCommissionSetting.has_independent_report === 0) ? _c('div', [_vm._m(52), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(53), _vm._v(" "), _c('div', {
    staticClass: "flex align-center"
  }, [_c('span', {
    staticClass: "w-35 text-left m-l-15"
  }, [_vm._v(_vm._s(_vm.brandInvalidQuota))])])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 13),
      expression: "storeMethod === 13"
    }],
    staticClass: "box-body form"
  }, [_vm._m(54), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(55), _vm._v(" "), _c('tbody', _vm._l((_vm.storeInfo.store_shipping_vendor), function(vendor, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v("\n                  " + _vm._s(_vm._f("shippingVendorName")(vendor.vendor_code)) + "\n                ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group text-left"
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (vendor.is_enable),
        expression: "vendor.is_enable"
      }],
      attrs: {
        "type": "radio",
        "value": "1"
      },
      domProps: {
        "checked": _vm._q(vendor.is_enable, "1")
      },
      on: {
        "input": _vm.setReload,
        "change": function($event) {
          return _vm.$set(vendor, "is_enable", "1")
        }
      }
    }), _vm._v("\n                        啟用\n                      ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (vendor.is_enable),
        expression: "vendor.is_enable"
      }],
      attrs: {
        "type": "radio",
        "value": "0"
      },
      domProps: {
        "checked": _vm._q(vendor.is_enable, "0")
      },
      on: {
        "input": _vm.setReload,
        "change": function($event) {
          return _vm.$set(vendor, "is_enable", "0")
        }
      }
    }), _vm._v("\n                        不啟用\n                      ")])])])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 15),
      expression: "storeMethod === 15"
    }],
    staticClass: "box-body form"
  }, [(_vm.getRoleType === 99 || _vm.getRoleType === 30 || _vm.getRoleType === 10) ? _c('div', [_vm._m(56), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(57), _vm._v(" "), _c('div', {
    staticClass: "flex align-center h-34"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.showTablewareStrawOption),
      expression: "showTablewareStrawOption",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "showTablewareStrawOption",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.showTablewareStrawOption, _vm._n("1"))
    },
    on: {
      "change": function($event) {
        _vm.showTablewareStrawOption = _vm._n("1")
      }
    }
  }), _vm._v("開啟\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.showTablewareStrawOption),
      expression: "showTablewareStrawOption",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "showTablewareStrawOption",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.showTablewareStrawOption, _vm._n("0"))
    },
    on: {
      "change": function($event) {
        _vm.showTablewareStrawOption = _vm._n("0")
      }
    }
  }), _vm._v("關閉\n                  ")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(58), _vm._v(" "), _c('div', {
    staticClass: "flex align-center h-34"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.setTablewareStrawDefaultVal),
      expression: "setTablewareStrawDefaultVal",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "setTablewareStrawDefaultVal",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.setTablewareStrawDefaultVal, _vm._n("1"))
    },
    on: {
      "change": function($event) {
        _vm.setTablewareStrawDefaultVal = _vm._n("1")
      }
    }
  }), _vm._v("開啟\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.setTablewareStrawDefaultVal),
      expression: "setTablewareStrawDefaultVal",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "setTablewareStrawDefaultVal",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.setTablewareStrawDefaultVal, _vm._n("0"))
    },
    on: {
      "change": function($event) {
        _vm.setTablewareStrawDefaultVal = _vm._n("0")
      }
    }
  }), _vm._v("關閉\n                  ")])])])]), _vm._v(" "), _c('br')])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pb-10"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.goToStoreTable
    }
  }, [_vm._v("\n        取消\n      ")]), _vm._v(" "), _c('button', {
    ref: "modal",
    staticClass: "btn btn-success",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#selectStoreModal"
    }
  }, [_vm._v("\n        完成並選擇門市\n      ")])]), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.reCheckOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.updateOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.editOption,
      "selectChange": _vm.selectChange,
      "selectOptions": _vm.selectOptions
    },
    on: {
      "trigger": _vm.trigger,
      "selectOnChange": _vm.selectOnChange,
      "inputOnChange": _vm.inputOnChange
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "selectStoreModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content p-a-0"
  }, [_vm._m(59), _vm._v(" "), _c('div', {
    staticClass: "modal-body pa-20"
  }, [_c('div', [_vm._v("請選取所有欲套用設定的門市至右側「套用門市」區塊，按下「確認變更」後指定的變更項目將覆蓋門市原有設定並立即套用。")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "form-group mr-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.statusSelect),
      expression: "form.statusSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "statusSelect", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.statusTypeList), function(type, index) {
    return _c('option', {
      key: ("option-" + index),
      domProps: {
        "value": type.value
      }
    }, [_vm._v("\n                " + _vm._s(type.label) + "\n              ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group mr-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.orderStatusSelect),
      expression: "form.orderStatusSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "orderStatusSelect", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 99
    }
  }, [_vm._v("== 接單狀態 ==")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 10
    }
  }, [_vm._v("接單中")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 20
    }
  }, [_vm._v("不接單")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.isSearchSelect),
      expression: "form.isSearchSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "isSearchSelect", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 99
    }
  }, [_vm._v("== 搜尋狀態 ==")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("可搜尋")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("不可搜尋")])])])]), _vm._v(" "), _vm._m(60), _vm._v(" "), _c('muti-select-two', {
    attrs: {
      "setting": _vm.includeStoresSetting,
      "reNew": _vm.reNew,
      "reSet": _vm.reSet
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "display": "flex",
      "justify-content": "end"
    }
  }, [_c('button', {
    staticClass: "btn btn-default bt-c",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    ref: "modal",
    staticClass: "btn btn-default bt-c",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "data-toggle": "modal",
      "data-target": "#updateModal"
    }
  }, [_vm._v("確認變更")]), _vm._v(" "), _c('button', {
    ref: "modal",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "reCheckButton",
      "type": "button",
      "data-dismiss": "modal",
      "data-toggle": "modal",
      "data-target": "#reCheckModal"
    }
  }, [_vm._v("顯示錯誤")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-20"
  }, [_c('h5', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("請輸入/選取需批次變更的項目，指定的變更項目會一鍵套用在所有選擇的門市中，並覆蓋門市原有的設定。")]), _vm._v(" "), _c('h5', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("不同分頁設定項目需分次操作。")]), _vm._v(" "), _c('h5', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("無需變更的項目請維持空白，套用變更時，空白項目將維持門市原有的設定。")]), _vm._v(" "), _c('h5', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("若無需變更的項目誤選取到，可按右方的「清空此頁面設定」按鈕清除（不會變更門市原有的設定）。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text center"
  }, [_vm._v("\n                  選擇\"清空現有店家公告\"將會"), _c('br'), _vm._v("清除套用門市的原有公告。\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("(圖片大小為200x200)"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("(圖片大小為800x460)"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("細部設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("貼紙限制字數\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("門市下訂金額限制")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("菜單呈現設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("預訂設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("接單/送單設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("付款方式")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                    前台顯示畫面，如下方粉色備註區塊\n                    "), _c('img', {
    attrs: {
      "src": "/static/img/trade_remark_ex.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("現金付款設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("取餐方式")]), _vm._v(" "), _c('td', [_vm._v("付款順序")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("付款方式與取餐金額")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("取餐方式")]), _vm._v(" "), _c('td', [_vm._v("付款方式")]), _vm._v(" "), _c('td', [_vm._v("起始金額")]), _vm._v(" "), _c('td', [_vm._v("結束金額")]), _vm._v(" "), _c('td', [_vm._v("描述")]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("製作/取餐時間")]), _vm._v(" "), _c('div', [_vm._v("\n            準備時間需設定 3 分鐘以上，取餐時間間隔需設定 10 的倍數\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 各列設定為群組功能，需將取餐類型的\"準備時間+取餐時間間隔\"一併設定後才可進行修改。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("取餐類型")]), _vm._v(" "), _c('td', [_vm._v("準備時間")]), _vm._v(" "), _c('td', [_vm._v("取餐時間間隔")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("開始時間")]), _vm._v(" "), _c('td', [_vm._v("結束時間")]), _vm._v(" "), _c('td', [_vm._v("準備時間")]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("取餐方式/門檻")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 外送的\"消費金額與距離門檻\"設定為群組功能，需將每個級距規則一併設定後才可進行修改。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 於單一門市資訊已設為預設的取餐方式，不可於此處設定為關閉，該門市關閉設定將不被覆蓋。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 當門市的取餐類型為\"不支援\"時，若在此設定為開啟，該門市開啟狀態將維持關閉。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text text-align-left"
  }, [_vm._v("\n                    ．計算商品金額 (折扣後) ，不含塑膠袋。"), _c('br'), _vm._v("\n                    ．0元為最低消費金額\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                    顯示在購物車頁面上，消費者可查看，前台顯示畫面，如下方粉色備註區塊\n                    "), _c('img', {
    attrs: {
      "alt": "備註描述圖片",
      "src": "/static/img/delivery_memo_ex.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                    顯示在訂單確認頁面上，消費者可查看，如預覽圖所示。\n                    "), _c('img', {
    attrs: {
      "alt": "取餐提醒圖片",
      "src": "/static/img/delivery_pickup_memo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("指定日期")]), _vm._v(" "), _c('td', [_vm._v("開始時間")]), _vm._v(" "), _c('td', [_vm._v("結束時間")]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("星期")]), _vm._v(" "), _c('td', [_vm._v("開始時間")]), _vm._v(" "), _c('td', [_vm._v("結束時間")]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("每月幾號")]), _vm._v(" "), _c('td', [_vm._v("開始時間")]), _vm._v(" "), _c('td', [_vm._v("結束時間")]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade text-left",
    attrs: {
      "role": "dialog",
      "id": "pickupWarnModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("提醒")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\n                預設項目不可關閉，請先調整預設的取餐類型\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("確定")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("營業時間")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 各列設定為群組功能，需將每個星期的的\"營業時間+打烊時間\"一併設定後才可進行修改。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("星期")]), _vm._v(" "), _c('td', [_vm._v("營業時間")]), _vm._v(" "), _c('td', [_vm._v("打烊時間")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 設定完成後，指定日期將套用此營業時間顯示，期間結束後即恢復預設營業時間。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 若與公休日期重複，會優先顯示指定日期的營業時間。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                    顯示在前台門市營業時間後方，如下範例："), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/specialDay_remark_tooltips.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("公休時間")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("塑膠袋設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                塑膠袋功能\n                "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text alliance-tooltip"
  }, [_vm._v("\n                    「 塑膠袋功能 」將顯示於購車第一步驟，提供消費者選擇。\n                    "), _c('img', {
    attrs: {
      "src": "/static/img/plastic-select-sample-img.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("出單機設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("出單機名稱(ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("綁定名稱(ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("辨識碼")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("出單機啟用")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("綁定機啟用")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("出單機列印格式設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("列印格式")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("觸發類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("啟用")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("網址設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 若開啟內用-桌邊掃碼取餐類型，門市可利用網址設定功能，新增桌號並獲取各桌獨立網址，將該網址轉為QRCode後即可運用於提供給顧客做桌邊掃碼點餐。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("計費方式設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("新增資訊服務費抽成設定為群組功能，無法單獨設定。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  資訊服務費抽成%\n                  "), _c('span', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "請勿輸入空格"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_vm._v("\n                  抽成生效日\n                  "), _c('span', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "系統依據該日期開始計算到資訊服務費抽成報表"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_vm._v("\n                  抽成結束日\n                  "), _c('span', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "系統依據該日期停止計算到資訊服務費抽成報表"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                門市獨立產出抽成對帳表/計算作廢額度\n                "), _c('span', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "適用於門市獨立簽約的類型"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("可至「編輯品牌」調整作廢訂單額度。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                每月作廢訂單額度(筆)\n                "), _c('span', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "此為整個品牌的作廢訂單總額度，非單一門市；若修改會同步更新其他門市此欄位值"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("物流設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("配送物流")]), _vm._v(" "), _c('td', [_vm._v("開啟狀態")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("特殊需求")]), _vm._v(" "), _c('div', [_vm._v("請確認POS端是否支援此功能")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n                自選吸管或餐具功能\n                "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text alliance-tooltip"
  }, [_vm._v("\n                    「 自選吸管或餐具功能 」 將顯示於購車第一步驟，提供消費者選擇。\n                    "), _c('img', {
    attrs: {
      "src": "/static/img/straw-option-sample-img.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("預設吸管或餐具選項\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header border-bottom pa-20"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("批次門市設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex text-blod"
  }, [_c('h5', {
    staticStyle: {
      "width": "315px"
    }
  }, [_vm._v("不套用門市")]), _vm._v(" "), _c('h5', [_vm._v("套用門市")])])
}]}

/***/ }),
/* 2465 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('brand-table')], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 2466 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box-body form"
  }, [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          運費說明\n          "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(1)], 1)]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sInfo.shipping_description),
      expression: "sInfo.shipping_description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.sInfo.shipping_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sInfo, "shipping_description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.sInfo.shipping_description ? _vm.sInfo.shipping_description.length : 0) + "/100")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          運費計算\n        ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.feeTypeSelect),
      expression: "feeTypeSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.feeTypeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("不計算運費")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("依訂單金額計算")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("依運送距離計算")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("依運送距離+訂單金額計算")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.showVendorId) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          POS廠商ID\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vendorCustomId),
      expression: "vendorCustomId"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.vendorCustomId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vendorCustomId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.feeTypeSelect === 1) ? [_c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.addItem()
      }
    }
  }, [_vm._v("新增運費")]), _vm._v(" "), (_vm.$route.name !== 'batchSetupStore') ? _c('button', {
    staticClass: "btn btn-default pull-right",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#openModal"
    }
  }, [_vm._v("複製運費至其他店家")]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_c('span', [_vm._v("訂單金額")]), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                  計算商品金額 (折扣前) ，不含塑膠袋。\n                ")])], 1)]), _vm._v(" "), _c('td', [_vm._v("運費設定")]), _vm._v(" "), _c('td')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.itemList), function(item, iIndex) {
    return _c('tr', [_c('td', [(item.money === -1) ? [(_vm.itemList[iIndex - 1]) ? [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v("＄ " + _vm._s(_vm.maxValue(_vm.itemList, 'money') + 1) + " 以上 \n                ")] : [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v("不限金額\n                ")]] : [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v("\n                ＄ "), _c('input', {
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "金額",
        "type": "text",
        "disabled": ""
      },
      domProps: {
        "value": _vm.itemList[iIndex - 1] ? (_vm.itemList[iIndex - 1].money * 1 + 1) : 0
      }
    }), _vm._v("\n                ～\n                ＄ "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (item.money),
        expression: "item.money",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "金額",
        "type": "text"
      },
      domProps: {
        "value": (item.money)
      },
      on: {
        "change": function($event) {
          return _vm.updateValue(_vm.itemList, 'money')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "money", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]], 2), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v("\n              運費 $ "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (item.fee),
        expression: "item.fee",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "運費",
        "type": "text"
      },
      domProps: {
        "value": (item.fee)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "fee", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('td', [(item.money > -1) ? _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeItemTime(iIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()])])
  }), 0)])] : _vm._e(), _vm._v(" "), (_vm.feeTypeSelect === 2) ? [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.addItem()
      }
    }
  }, [_vm._v("新增運費")]), _vm._v(" "), (_vm.$route.name !== 'batchSetupStore') ? _c('button', {
    staticClass: "btn btn-default pull-right",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#openModal"
    }
  }, [_vm._v("複製運費至其他店家")]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.itemListKM), function(item, iIndex) {
    return _c('tr', [_c('td', [(item.distance === -1) ? [(_vm.itemListKM[iIndex - 1]) ? [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v(_vm._s(_vm.numeral(_vm.maxValue(_vm.itemListKM, 'distance')).add(0.1).value()) + " 公里以上\n                ")] : [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v("不限距離\n                ")]] : [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v(" "), _c('input', {
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "距離",
        "type": "text",
        "disabled": ""
      },
      domProps: {
        "value": _vm.itemListKM[iIndex - 1] ? (_vm.numeral(_vm.itemListKM[iIndex - 1].distance).add(0.1).value()) : 0
      }
    }), _vm._v(" 公里\n                ～\n                "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (item.distance),
        expression: "item.distance",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "距離",
        "type": "text"
      },
      domProps: {
        "value": (item.distance)
      },
      on: {
        "change": function($event) {
          return _vm.updateValue(_vm.itemListKM, 'distance')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "distance", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" 公里\n              ")]], 2), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v("\n              運費 $ "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (item.fee),
        expression: "item.fee",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "運費",
        "type": "text"
      },
      domProps: {
        "value": (item.fee)
      },
      on: {
        "change": function($event) {
          return _vm.updateValue(_vm.itemListKM, 'distance')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "fee", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('td', [(item.distance > -1) ? _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeItemTime(iIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()])])
  }), 0)])] : _vm._e(), _vm._v(" "), (_vm.feeTypeSelect === 3) ? [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.addItem()
      }
    }
  }, [_vm._v("新增運費")]), _vm._v(" "), (_vm.$route.name !== 'batchSetupStore') ? _c('button', {
    staticClass: "btn btn-default pull-right",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#openModal"
    }
  }, [_vm._v("複製運費至其他店家")]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped dataTable deliveryTable"
  }, [_c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("運送距離")]), _vm._v(" "), _c('td', [_c('span', [_vm._v("訂單金額")]), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                  計算商品金額 (折扣前) ，不含塑膠袋。\n                ")])], 1)]), _vm._v(" "), _c('td', [_vm._v("運費設定")]), _vm._v(" "), _c('td')])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.itemListKM), function(item, iIndex) {
    return [_c('tr', {
      class: iIndex % 2 ? 'even' : 'odd'
    }, [_c('td', {
      attrs: {
        "rowspan": item.range.length + 1
      }
    }, [(_vm.itemList.length == 1) ? [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v("不限距離\n                ")] : (item.distance == -1) ? [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v(_vm._s(_vm.numeral(_vm.maxValue(_vm.itemListKM, 'distance')).add(0.1).value()) + " 公里以上\n                ")] : [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v(" "), _c('input', {
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "距離",
        "type": "text",
        "disabled": ""
      },
      domProps: {
        "value": _vm.itemListKM[iIndex - 1] ? (_vm.numeral(_vm.itemListKM[iIndex - 1].distance).add(0.1).value()) : 0
      }
    }), _vm._v(" 公里\n                  ～\n                  "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (item.distance),
        expression: "item.distance",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "距離",
        "type": "text"
      },
      domProps: {
        "value": (item.distance)
      },
      on: {
        "change": function($event) {
          return _vm.updateValue(_vm.itemListKM, 'distance')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "distance", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" 公里\n                ")]], 2)]), _vm._v(" "), _vm._l((item.range), function(range, index) {
      return _c('tr', {
        class: iIndex % 2 ? 'even' : 'odd'
      }, [_c('td', [(range.money == -1) ? [_c('span', {
        staticClass: "text-red"
      }, [_vm._v("＊ ")]), _vm._v("$ " + _vm._s(_vm.maxValue(item.range, 'money') + 1) + " 以上\n                ")] : [_c('span', {
        staticClass: "text-red"
      }, [_vm._v("＊ ")]), _vm._v("\n                  $ "), _c('input', {
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "金額",
          "type": "text",
          "disabled": ""
        },
        domProps: {
          "value": item.range[index - 1] ? (item.range[index - 1].money * 1 + 1) : 0
        }
      }), _vm._v("\n                  ～\n                  $ "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model.number",
          value: (range.money),
          expression: "range.money",
          modifiers: {
            "number": true
          }
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "金額",
          "type": "text"
        },
        domProps: {
          "value": (range.money)
        },
        on: {
          "click": function($event) {
            return _vm.updateValue(item.range, 'money')
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(range, "money", _vm._n($event.target.value))
          },
          "blur": function($event) {
            return _vm.$forceUpdate()
          }
        }
      })], _vm._v(" "), (index == 0) ? _c('button', {
        staticClass: "btn btn-success",
        on: {
          "click": function($event) {
            item.range.splice(item.range.length - 1, 0, {
              money: item.range[index - 1] ? (item.range[index - 1].money * 1 + 1) : 0,
              fee: 0
            });
            _vm.updateValue(item.range, 'money');
            _vm.$forceUpdate()
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-plus-circle",
        attrs: {
          "aria-hidden": "true"
        }
      })]) : _vm._e()], 2), _vm._v(" "), _c('td', [_c('span', {
        staticClass: "text-red"
      }, [_vm._v("＊ ")]), _vm._v("運費 $ "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model.number",
          value: (range.fee),
          expression: "range.fee",
          modifiers: {
            "number": true
          }
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "運費",
          "type": "text"
        },
        domProps: {
          "value": (range.fee)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(range, "fee", _vm._n($event.target.value))
          },
          "blur": function($event) {
            return _vm.$forceUpdate()
          }
        }
      })]), _vm._v(" "), _c('td', [(range.money > -1 && (item.range.length > 2 || item.distance > -1)) ? _c('button', {
        staticClass: "btn btn-danger",
        on: {
          "click": function($event) {
            item.range.length == 2 ? _vm.removeItemTime(iIndex) : item.range.splice(index, 1);
            _vm.$forceUpdate()
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })]) : _vm._e()])])
    })]
  })], 2)])] : _vm._e(), _vm._v(" "), _c('br')], 2), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "openModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 p-x-0"
  }, [_c('div', [_c('h5', {
    staticClass: "text-left"
  }, [_vm._v("參與店家")]), _vm._v(" "), _c('muti-select-two', {
    attrs: {
      "setting": _vm.addStoresSetting
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.copyShipping
    }
  }, [_vm._v("確定")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("運費設定")]), _vm._v(" "), _c('div', [_vm._v("請確認POS端是否支援此功能")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n              紅框處，即為「運費說明」的文字內容，將顯示於菜單頁的訂餐資訊中 。\n              "), _c('img', {
    attrs: {
      "alt": "運費說明圖片",
      "src": "/static/img/shipping_description.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v(" 距離請勿超過「取餐方式/門檻」設定的最遠可外送距離。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("運送距離")]), _vm._v(" "), _c('td', [_vm._v("運費設定")]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v(" 距離請勿超過「取餐方式/門檻」設定的最遠可外送距離。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("複製此分店運費至其他店家")]), _vm._v(" "), _c('p', {
    staticClass: "text-light-gray"
  }, [_vm._v("計算類型、運費描述依然需至該店設定")]), _vm._v(" "), _c('br')])
}]}

/***/ }),
/* 2467 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 p-x-0"
  }, [_c('menu-list', {
    attrs: {
      "menu": _vm.menu,
      "schema": _vm.schema,
      "showMenuIcon": _vm.showMenuIcon,
      "getElement": _vm.getElement,
      "changeToProductList": _vm.changeToProductList,
      "checkDisableItem": _vm.checkDisableItem,
      "layout": _vm.layout,
      "showProductIcon": _vm.showProductIcon,
      "checkLowerPrice": _vm.checkLowerPrice,
      "getLower": _vm.getLower,
      "openModal": _vm.openModal,
      "getIcon": _vm.getIcon,
      "getTempE": _vm.getTempE,
      "prodImgList": _vm.prodImgList
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2468 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "infoProductModal",
    staticClass: "modal fade",
    attrs: {
      "id": "infoProductModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header text-left"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title text-red",
    staticStyle: {
      "font-size": "20px"
    },
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.currentProduct[_vm.schema.product.name]) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('menu-options', {
    ref: 'menu-options-' + _vm.currentProduct[_vm.schema.product.product_id],
    attrs: {
      "currentProduct": _vm.currentProduct,
      "checkPrice": _vm.checkPrice,
      "checkAddProduct": _vm.checkAddProduct,
      "checkAddDifProduct": _vm.checkAddDifProduct,
      "productAmount": _vm.number,
      "pAIndex": 1,
      "menuJson": _vm.menuJson
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "col-xs-12 p-x-0 order-item m-t-15 p-5"
  }, [_c('p', [_vm._v("總金額：" + _vm._s(_vm.totalPrice()) + " 元")]), _vm._v(" "), _c('div', {
    staticClass: "q-numeric textfield row inline items-center input-number m-x-0 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon numeric-left c-pointer bg-pink",
    on: {
      "click": function($event) {
        _vm.number--
      }
    }
  }, [_vm._v("\n                    -\n                  ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.number),
      expression: "number"
    }],
    staticClass: "no-style auto q-input-field inline-block text-center",
    attrs: {
      "type": "tel",
      "pattern": "[0-9]*",
      "tabindex": "0",
      "step": "1",
      "min": "1",
      "max": "99",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.number = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon numeric-right  c-pointer bg-pink",
    on: {
      "click": function($event) {
        _vm.number++
      }
    }
  }, [_vm._v("\n                    +\n                  ")])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("關閉")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clickAdd
    }
  }, [_vm._v("測試")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])])
}]}

/***/ }),
/* 2469 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner"
  }, [_c('div', {
    staticClass: "v-clip",
    style: (_vm.spinnerStyle)
  })])
},staticRenderFns: []}

/***/ }),
/* 2470 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'crAd',
        params: {
          brand_id: _vm.$route.params.brand_id,
          store_id: _vm.$route.params.store_id,
        },
        query: {
          new: true,
          tab: 12,
        },
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 新增橫幅廣告")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'crAd',
        params: {
          brand_id: _vm.$route.params.brand_id,
          store_id: _vm.$route.params.store_id,
        },
        query: {
          new: true,
          tab: 41,
        },
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 新增蓋版廣告")])])], 1), _vm._v(" "), (_vm.getRoleType !== 10) ? _c('div', {
    staticClass: "form-group text-left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'copyAd',
        params: {
          brand_id: _vm.$route.params.brand_id,
          store_id: _vm.$route.params.store_id,
        },
        query: {
          tab: 12,
        },
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("複製橫幅廣告")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType !== 10) ? _c('div', {
    staticClass: "form-group text-left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'copyAd',
        params: {
          brand_id: _vm.$route.params.brand_id,
          store_id: _vm.$route.params.store_id,
        },
        query: {
          tab: 41,
        },
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("複製蓋板廣告")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectActive),
      expression: "selectActive"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectActive = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("啟用")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("停用")])])])]), _vm._v(" "), (_vm.bannerType !== 41) ? _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchType),
      expression: "searchType"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("名稱")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("地區")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group search-bar"
  }, [(_vm.searchType === 1) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchInput),
      expression: "searchInput"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchInput = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.getAdList()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])]) : _c('div', {
    staticClass: "input-group"
  }, [_c('multiselect', {
    staticClass: "min-w-150",
    attrs: {
      "options": _vm.cityOption,
      "searchable": true,
      "allow-empty": true,
      "close-on-select": false,
      "show-labels": false,
      "placeholder": "",
      "multiple": true,
      "label": "name",
      "track-by": "code"
    },
    model: {
      value: (_vm.selectCity),
      callback: function($$v) {
        _vm.selectCity = $$v
      },
      expression: "selectCity"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.getAdList()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 tab"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      active: _vm.bannerType === 12
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeBannerType(12)
      }
    }
  }, [_vm._v("橫幅廣告\n          ")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.bannerType === 41
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeBannerType(41)
      }
    }
  }, [_vm._v("蓋版廣告\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 my-10"
  }, [_c('span', [_c('button', {
    staticClass: "btn btn-default drag-btn",
    on: {
      "click": _vm.startDrag
    }
  }, [_c('img', {
    staticClass: "sort-icon",
    attrs: {
      "src": __webpack_require__(136)
    }
  }), _vm._v("\n        廣告排序")])]), _vm._v(" "), _c('span', [_c('button', {
    staticClass: "btn btn-default col",
    on: {
      "click": _vm.startBatchDelete
    }
  }, [_c('i', {
    staticClass: "fa fa-minus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 批次刪除")])]), _vm._v(" "), _c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'storeGroup',
        params: {
          brand_id: _vm.$route.params.brand_id
        }
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title padding-6"
  }, [_vm._v("門市群組")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 my-10 row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.isDraggable) ? _c('div', {
    staticClass: "message-info"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊ ")]), _vm._v("\n          可對前20則狀態為啟用的廣告圖片進行排序。"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊ ")]), _vm._v("\n          完成排序並儲存後，請重新整理前台頁面，即可看到廣告排序已變更為最新設定。\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isBatchDelete) ? _c('div', {
    staticClass: "message-info"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊ ")]), _vm._v("\n          可對廣告圖片進行批次刪除。"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊ ")]), _vm._v("\n          刪除後不可復原。\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [(_vm.isDraggable) ? _c('button', {
    staticClass: "btn btn-default btn-secondary",
    on: {
      "click": function($event) {
        return _vm.stopDrag(false)
      }
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), (_vm.isDraggable) ? _c('button', {
    staticClass: "btn btn-default label-success",
    on: {
      "click": function($event) {
        return _vm.stopDrag(true)
      }
    }
  }, [_vm._v("儲存")]) : _vm._e(), _vm._v(" "), (_vm.isBatchDelete) ? _c('button', {
    staticClass: "btn btn-default btn-secondary",
    on: {
      "click": function($event) {
        return _vm.BatchDelete(false)
      }
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), (_vm.isBatchDelete) ? _c('button', {
    staticClass: "btn btn-default label-danger",
    on: {
      "click": function($event) {
        return _vm.BatchDelete(true)
      }
    }
  }, [_vm._v("刪除")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDraggable),
      expression: "isDraggable"
    }],
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("排序")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isBatchDelete),
      expression: "isBatchDelete"
    }],
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("圖片與連結")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("名稱 (ID)")]), _vm._v(" "), (_vm.bannerType !== 41) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("廣告地區")]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("廣告開始時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("廣告結束時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("更新時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("你訂平台")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("街口平台")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])]), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(0)]) : (_vm.adList.length > 0) ? _c('draggable', {
    attrs: {
      "tag": "tbody",
      "handle": ".handle"
    },
    model: {
      value: (_vm.adList),
      callback: function($$v) {
        _vm.adList = $$v
      },
      expression: "adList"
    }
  }, _vm._l((_vm.adList), function(ad, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isDraggable),
        expression: "isDraggable"
      }]
    }, [_c('i', {
      staticClass: "fa fa-bars handle"
    })]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isBatchDelete),
        expression: "isBatchDelete"
      }]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (ad.selectItem),
        expression: "ad.selectItem"
      }],
      staticClass: "checkbox",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(ad.selectItem) ? _vm._i(ad.selectItem, null) > -1 : (ad.selectItem)
      },
      on: {
        "change": function($event) {
          var $$a = ad.selectItem,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(ad, "selectItem", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(ad, "selectItem", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(ad, "selectItem", $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": ad.url,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "img-ad-table",
      attrs: {
        "src": ad.image_web
      }
    })])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(ad.name) + " (" + _vm._s(ad.id) + ")")])]), _vm._v(" "), (_vm.bannerType !== 41) ? _c('td', [_c('More', {
      attrs: {
        "moreText": _vm.$options.filters.cityCode(ad.city_code_list),
        "title": "指定區域",
        "height": 46
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(ad.start_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ad.end_time))]), _vm._v(" "), _c('td', [_c('div', {
      class: _vm.timeMethodColor(ad.time_method)
    }, [_vm._v(_vm._s(_vm._f("status")(ad.time_method)))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ad.edit_time))]), _vm._v(" "), _c('td', [(ad.is_platform_visible) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _vm._e(), _vm._v(" "), (!ad.is_platform_visible) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("停用")]) : _vm._e()]), _vm._v(" "), _c('td', [(ad.dedicated_visible_setting.indexOf(1) > -1) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _vm._e(), _vm._v(" "), (ad.dedicated_visible_setting.indexOf(1) < 0) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("停用")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'upAd',
          params: {
            brand_id: _vm.$route.params.brand_id,
            store_id: _vm.$route.params.store_id,
            ad_id: ad.id,
          },
          query: {
            tab: _vm.bannerType,
          },
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default col"
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.deleteBanner(ad.id)
        }
      }
    })])], 1)])
  }), 0) : (_vm.adList.length === 0) ? _c('tbody', [_vm._m(1)]) : _vm._e()], 1)]), _vm._v(" "), _c('paginate', {
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
}]}

/***/ }),
/* 2471 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box m-h-700"
  }, [_c('div', {
    staticClass: "box-body form-inline"
  }, [(_vm.brandBrief.length > 1 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 品牌 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    on: {
      "input": function($event) {
        return _vm.getAmountLimitSetting('useBrand')
      }
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.brandSelect.value !== 999999 && _vm.brandSelect.value !== '999999' && _vm.storeBrief.length > 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.storeBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 門市 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    on: {
      "input": function($event) {
        return _vm.getAmountLimitSetting('useStore')
      }
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.enable_limit
    }
  }, [_vm._v("啟用門市限時限量")])]), _vm._v(" "), (!_vm.del_fun) ? _c('button', {
    staticClass: "btn btn-default pull-right",
    on: {
      "click": function($event) {
        return _vm.del_item()
      }
    }
  }, [_vm._v("\n            刪除\n          ")]) : _vm._e(), _vm._v(" "), (_vm.del_fun) ? _c('button', {
    staticClass: "btn btn-danger m-y-10 pull-right",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#limiModal"
    }
  }, [_vm._v("\n            刪除\n          ")]) : _vm._e(), _vm._v(" "), (_vm.del_fun) ? _c('button', {
    staticClass: "btn btn-default m-y-10 inline-block pull-right  m-r-10",
    attrs: {
      "data-toggle": "modal"
    },
    on: {
      "click": function($event) {
        _vm.del_fun = false
      }
    }
  }, [_vm._v("\n            取消\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [(_vm.del_fun) ? _c('th', {
    attrs: {
      "width": "2%",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAllItem),
      expression: "selectAllItem"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAllItem) ? _vm._i(_vm.selectAllItem, null) > -1 : (_vm.selectAllItem)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.selectAllItem,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAllItem = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectAllItem = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAllItem = $$c
        }
      }, _vm.selectAll]
    }
  })]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "width": "3%",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("序號")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "width": "15%",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("門市限時限量名稱")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "width": "30%",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("描述")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "width": "15%",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("門市名稱(ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  })])]), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(0)]) : (_vm.settingList.length === 0) ? _c('tbody', [_vm._m(1)]) : (_vm.settingList.length > 0) ? _c('tbody', _vm._l((_vm.settingList), function(setting, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [(_vm.del_fun) ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (setting.selectItem),
        expression: "setting.selectItem"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(setting.selectItem) ? _vm._i(setting.selectItem, null) > -1 : (setting.selectItem)
      },
      on: {
        "change": function($event) {
          var $$a = setting.selectItem,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(setting, "selectItem", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(setting, "selectItem", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(setting, "selectItem", $$c)
          }
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(setting.name) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(setting.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(setting.store_name) + "(" + _vm._s(setting.store_id) + ")")]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": '/upLimitScheduleItem/' + setting.setting_id + '?brand_id=' + setting.brand_id + '&store_id=' + setting.store_id
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": '/copyLimiScheduleItem/' + setting.setting_id + '?brand_id=' + setting.brand_id + '&store_id=' + setting.store_id
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_vm._v("複製門市限時限量設定")])])], 1)])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('paginate', {
    ref: "orderPaginate",
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "storesModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\"" + _vm._s(_vm.current.name) + "\"使用門市")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 p-x-0"
  }, _vm._l((_vm.current.store_list), function(store) {
    return _c('div', {
      staticClass: "inline-block",
      staticStyle: {
        "margin": "2.5px 5px 2.5px 0px"
      }
    }, [_c('label', {
      staticClass: "label label-primary"
    }, [_vm._v(_vm._s(store.name))])])
  }), 0)])]), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delLimitAmountOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("確定")])])
}]}

/***/ }),
/* 2472 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-relative"
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "moreModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.moreText)
    }
  })])])])])]), _vm._v(" "), _c('div', {
    ref: 'ellipsis' + this.random,
    class: {
      'ellipsis-2-lines': _vm.showMore
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.moreText)
    }
  })]), _vm._v(" "), (_vm.showMore) ? _c('a', {
    staticClass: "text-primary show-more",
    attrs: {
      "data-target": "#moreModal",
      "data-toggle": "modal"
    }
  }, [_vm._v("\n    ...更多\n  ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2473 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-table"
  }, [_c('div', {
    staticClass: "row vertical-10p"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/nidin_long_logo.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-center text-black"
  }, [_vm._v("後台管理系統")]), _vm._v(" "), _c('div', {
    staticClass: "text-center col-md-4 col-md-offset-4"
  }, [_c('form', {
    staticClass: "ui form loginForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkInput.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account),
      expression: "account"
    }],
    staticClass: "form-control h-55",
    attrs: {
      "name": "account",
      "placeholder": "帳號",
      "type": "text",
      "maxlength": "45",
      "autocomplete": "account"
    },
    domProps: {
      "value": (_vm.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.account = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control h-55",
    attrs: {
      "name": "password",
      "placeholder": "密碼",
      "type": "password",
      "autocomplete": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn-blue",
    class: 'btn btn-primary btn-lg ' + _vm.loading,
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("登入")])]), _vm._v(" "), (_vm.response) ? _c('div', {
    staticClass: "text-red"
  }, [_c('p', [_vm._v(_vm._s(_vm.response))])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon p-y-0"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon p-y-0"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
}]}

/***/ }),
/* 2474 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: ("/crBrandAd/" + (_vm.$route.params.brand_id)),
        query: {
          new: true,
          tab: 12,
        },
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 新增橫幅廣告")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: ("/crBrandAd/" + (_vm.$route.params.brand_id)),
        query: {
          new: true,
          tab: 41,
        }
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 新增蓋版廣告")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectActive),
      expression: "selectActive"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectActive = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("啟用")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("停用")])])])]), _vm._v(" "), (_vm.bannerType !== 41) ? _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchType),
      expression: "searchType"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("名稱")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("地區")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group search-bar"
  }, [(_vm.searchType === 1) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchInput),
      expression: "searchInput"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchInput = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.getAdList()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])]) : _c('div', {
    staticClass: "input-group"
  }, [_c('multiselect', {
    staticClass: "min-w-150",
    attrs: {
      "options": _vm.cityOption,
      "searchable": true,
      "allow-empty": true,
      "close-on-select": false,
      "show-labels": false,
      "placeholder": "",
      "multiple": true,
      "label": "name",
      "track-by": "code"
    },
    model: {
      value: (_vm.selectCity),
      callback: function($$v) {
        _vm.selectCity = $$v
      },
      expression: "selectCity"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.getAdList()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 tab"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      active: _vm.bannerType == 12
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeBannerType(12)
      }
    }
  }, [_vm._v("橫幅廣告\n          ")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.bannerType == 41
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeBannerType(41)
      }
    }
  }, [_vm._v("蓋版廣告\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 my-10"
  }, [(_vm.$route.query.tab !== 41) ? _c('span', [_c('button', {
    staticClass: "btn btn-default drag-btn col",
    on: {
      "click": _vm.startDrag
    }
  }, [_c('img', {
    staticClass: "sort-icon",
    attrs: {
      "src": __webpack_require__(136)
    }
  }), _vm._v("\n          廣告排序")])]) : _vm._e(), _vm._v(" "), _c('span', [_c('button', {
    staticClass: "btn btn-default col",
    on: {
      "click": _vm.startBatchDelete
    }
  }, [_c('i', {
    staticClass: "fa fa-minus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 批次刪除")])]), _vm._v(" "), _c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'storeGroup',
        params: {
          brand_id: _vm.$route.params.brand_id
        }
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title padding-6"
  }, [_vm._v("門市群組")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 my-10 row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.isDraggable) ? _c('div', {
    staticClass: "message-info"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊ ")]), _vm._v("\n          可對前20則狀態為啟用的廣告圖片進行排序。"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊ ")]), _vm._v("\n          完成排序並儲存後，請重新整理前台頁面，即可看到廣告排序已變更為最新設定。\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isBatchDelete) ? _c('div', {
    staticClass: "message-info"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊ ")]), _vm._v("\n          可對廣告圖片進行批次刪除。"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊ ")]), _vm._v("\n          刪除後不可復原。\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [(_vm.isDraggable) ? _c('button', {
    staticClass: "btn btn-default btn-secondary",
    on: {
      "click": function($event) {
        return _vm.stopDrag(false)
      }
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), (_vm.isDraggable) ? _c('button', {
    staticClass: "btn btn-default label-success",
    on: {
      "click": function($event) {
        return _vm.stopDrag(true)
      }
    }
  }, [_vm._v("儲存")]) : _vm._e(), _vm._v(" "), (_vm.isBatchDelete) ? _c('button', {
    staticClass: "btn btn-default btn-secondary",
    on: {
      "click": function($event) {
        return _vm.BatchDelete(false)
      }
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), (_vm.isBatchDelete) ? _c('button', {
    staticClass: "btn btn-default label-danger",
    on: {
      "click": function($event) {
        return _vm.BatchDelete(true)
      }
    }
  }, [_vm._v("刪除")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDraggable),
      expression: "isDraggable"
    }],
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("排序")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isBatchDelete),
      expression: "isBatchDelete"
    }],
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("圖片與連結")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("名稱 (ID)")]), _vm._v(" "), (_vm.bannerType !== 41) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("廣告地區")]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("廣告開始時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("廣告結束時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("啟用狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("建立時間")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])]), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(0)]) : (_vm.adList.length === 0) ? _c('tbody', [_vm._m(1)]) : (_vm.adList.length > 0) ? _c('draggable', {
    attrs: {
      "tag": "tbody",
      "handle": ".handle"
    },
    model: {
      value: (_vm.adList),
      callback: function($$v) {
        _vm.adList = $$v
      },
      expression: "adList"
    }
  }, _vm._l((_vm.adList), function(ad, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isDraggable),
        expression: "isDraggable"
      }]
    }, [_c('i', {
      staticClass: "fa fa-bars handle"
    })]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isBatchDelete),
        expression: "isBatchDelete"
      }]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (ad.selectItem),
        expression: "ad.selectItem"
      }],
      staticClass: "checkbox",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(ad.selectItem) ? _vm._i(ad.selectItem, null) > -1 : (ad.selectItem)
      },
      on: {
        "change": function($event) {
          var $$a = ad.selectItem,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(ad, "selectItem", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(ad, "selectItem", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(ad, "selectItem", $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(ad.index))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": ad.url,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "img-ad-table",
      attrs: {
        "src": ad.image_web
      }
    })])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(ad.name) + " (" + _vm._s(ad.id) + ")")])]), _vm._v(" "), (_vm.bannerType !== 41) ? _c('td', [_c('More', {
      attrs: {
        "moreText": _vm.$options.filters.cityCode(ad.city_code_list),
        "title": "指定區域",
        "height": 46
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(ad.start_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ad.end_time))]), _vm._v(" "), _c('td', [_c('div', {
      class: _vm.timeMethodColor(ad.time_method)
    }, [_vm._v(_vm._s(_vm._f("status")(ad.time_method)))])]), _vm._v(" "), _c('td', [(ad.is_active) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _vm._e(), _vm._v(" "), (!ad.is_active) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("停用")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ad.edit_time))]), _vm._v(" "), _c('td', {
      staticClass: "row"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'upBrandAd',
          params: {
            brand_id: _vm.$route.params.brand_id,
            ad_id: ad.id,
          },
          query: {
            tab: _vm.bannerType || 12,
          },
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default col"
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.deleteBanner(ad.id)
        }
      }
    })])], 1)])
  }), 0) : _vm._e()], 1)]), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isDraggable),
      expression: "!isDraggable"
    }],
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
}]}

/***/ }),
/* 2475 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "couponModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v("\n      " + _vm._s(_vm.coupon) + "\n      "), (_vm.coupon.name) ? _c('div', {
    staticClass: "modal-body"
  }) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("設定優惠券")])])
}]}

/***/ }),
/* 2476 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('account-table')], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 2477 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('copy-prod')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2478 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('printer-form', {
    attrs: {
      "info": _vm.info
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2479 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "center-block row"
  }, [(_vm.getRoleType === 99) ? _c('div', {
    staticClass: "align-center col-xs-12 flex m-b-10 p-x-0"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.goBackInfo
    }
  }, [_c('div', {
    staticClass: "btn btn-default flex m-r-5"
  }, [_c('span', [_vm._v("返回")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.title)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.subtitle)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "darken-1 flex grey"
  }, [(_vm.brand.name || _vm.store.brand_name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s(_vm.brand.name ?
        _vm.brand.name :
        _vm.store.brand_name ?
        _vm.store.brand_name :
        '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s('/')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.store.name)
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("ID")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.menu_id) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("名稱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.name) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("描述")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.description) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("備註")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.remark) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                版本號\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.ver_stamp) + "\n              ")])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                鎖定狀態\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.info.is_locked) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("\n                  鎖定\n                ")]) : _vm._e(), _vm._v(" "), (!_vm.info.is_locked) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("\n                  可更新\n                ")]) : _vm._e(), _vm._v(" "), (_vm.info.is_locked && _vm.info.status === 2) ? _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.menuUnlock
    }
  }, [_vm._v("\n                  解除鎖定\n                ")]) : _vm._e(), _vm._v(" "), (!_vm.info.is_locked && _vm.info.status === 2) ? _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.menuLock
    }
  }, [_vm._v("\n                  鎖定\n                ")]) : _vm._e(), _vm._v(" "), (_vm.info.is_locked && _vm.info.status === 2) ? _c('button', {
    staticClass: "bg-black btn",
    on: {
      "click": function($event) {
        return _vm.goToCrSchedule(_vm.info)
      }
    }
  }, [_vm._v("\n                  上架\n                ")]) : _vm._e(), _vm._v(" "), (_vm.info.is_locked && _vm.info.status === 2) ? _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.exportFile
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v("\n                  匯出菜單\n                  "), _c('clip-loader', {
    staticClass: "cliploading",
    attrs: {
      "loading": _vm.show.download,
      "color": "#528BB8",
      "size": "16px"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                菜單狀態\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.status) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                版本時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.ver_time) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                更新時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.update_time) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                建立時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.create_time) + "\n              ")])]), _vm._v(" "), _c('br')])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.show.noMenu) ? _c('div', {
    staticClass: "text-center text-red"
  }, [_vm._v("\n            尚未建立菜單喔！\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dataTables_wrapper dt-bootstrap form-inline",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "grid row"
  }, [_c('MenuLogic', {
    attrs: {
      "type": "list",
      "menu": _vm.menu,
      "schema": _vm.schema,
      "layout": _vm.layout,
      "show-product-icon": _vm.showProductIcon,
      "change-to-product-list": _vm.changeToProductList,
      "check-disable-item": _vm.checkDisableItem,
      "open-modal": _vm.openModal,
      "get-icon": _vm.getIcon,
      "is-search": _vm.isSearch,
      "show-menu-icon": _vm.showMenuIcon,
      "loading": _vm.loading,
      "min-price": _vm.minPrice
    }
  })], 1)])])])]), _vm._v(" "), _c('MenuModal', {
    attrs: {
      "current-product": _vm.currentProduct,
      "menu-json": _vm.currentMenuJson
    }
  }), _vm._v(" "), _c('PackageModal', {
    attrs: {
      "current-product": _vm.currentProduct,
      "menu-json": _vm.currentMenuJson
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("\n            菜單資訊\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("\n            菜單\n          ")])])
}]}

/***/ }),
/* 2480 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("品牌成交量前五名")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [(_vm.topOrderAmount.brand) ? _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('canvas', {
    attrs: {
      "id": "today-brand-top"
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("店家成交量前五名")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [(_vm.topOrderAmount.store) ? _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('canvas', {
    attrs: {
      "id": "today-store-top"
    }
  })]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "col-xs-12 text-right pull-right"
  }, [_c('div', {
    staticClass: "form-group input-group time-box pull-right"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.dateoption,
      "limit": _vm.startLimit
    }
  }), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.dateoption,
      "limit": _vm.endLimit
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default submit-btn btn-search",
    staticStyle: {
      "height": "72px"
    },
    attrs: {
      "type": "button",
      "id": "search"
    },
    on: {
      "click": function($event) {
        return _vm.getShopperStatus()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [(_vm.brandBrief.length > 1 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group form-inline w-auto"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandSelect),
      expression: "brandSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.brandSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.roleType !== 10) ? _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("== 品牌 ==")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.brandBrief), function(brand) {
    return _c('option', {
      domProps: {
        "value": brand.value
      }
    }, [_vm._v("\n                    " + _vm._s(brand.label) + "\n                  ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.brandSelect !== 0 && _vm.brandSelect !== '0' && _vm.storeBrief.length > 1 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group form-inline w-auto"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeSelect),
      expression: "storeSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.storeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("== 門市 ==")]), _vm._v(" "), _vm._l((_vm.storeBrief), function(store) {
    return _c('option', {
      domProps: {
        "value": store.value
      }
    }, [_vm._v("\n                    " + _vm._s(store.label) + "\n                  ")])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right pull-right"
  }, [_c('div', {
    staticClass: "form-group input-group time-box pull-right"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.dateoption,
      "limit": _vm.startLimit
    }
  }), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.dateoption,
      "limit": _vm.endLimit
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default submit-btn btn-search",
    staticStyle: {
      "height": "72px"
    },
    attrs: {
      "type": "button",
      "id": "search2"
    },
    on: {
      "click": function($event) {
        return _vm.getShopperStatus()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])], 1)])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("交易訂單統計"), (_vm.brandSelect === 0 || _vm.brandSelect === '0') ? _c('span', {
    staticClass: "text-red text-12"
  }, [_vm._v("(請選擇品牌或店家)")]) : _vm._e()]), _c('br'), _c('br'), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("交易金額統計"), (_vm.brandSelect === 0 || _vm.brandSelect === '0') ? _c('span', {
    staticClass: "text-red text-12"
  }, [_vm._v("(請選擇品牌或店家)")]) : _vm._e()]), _c('br'), _c('br'), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("交易數量統計"), (_vm.brandSelect === 0 || _vm.brandSelect === '0') ? _c('span', {
    staticClass: "text-red text-12"
  }, [_vm._v("(請選擇品牌或店家)")]) : _vm._e()]), _c('br'), _c('br'), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("拒單原因統計"), (_vm.brandSelect === 0 || _vm.brandSelect === '0') ? _c('span', {
    staticClass: "text-red text-12"
  }, [_vm._v("(請選擇品牌或店家)")]) : _vm._e()]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_vm._m(6), _vm._v(" "), (_vm.rejectedOrderList) ? _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "overflow": "scroll",
      "max-height": "500px"
    }
  }, [(_vm.rejectedOrderList.length) ? _c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.rejectedOrderList), function(reject, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [(reject.date) ? _c('td', {
      attrs: {
        "rowspan": reject.reasonAmount
      }
    }, [_vm._v(_vm._s(_vm.getMonthDay(reject.date)))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(reject.reject_reason) + " (" + _vm._s(reject.reject_status) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(reject.order_count) + " 筆")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(reject.item_count) + " 杯")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(reject.money) + " 元")])])
  }), 0)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.rejectedOrderList) ? _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [(_vm.rejectedOrderList.length) ? _c('div', [_c('h6', [_vm._v("共損失 " + _vm._s(_vm.total.orderCount) + " 筆訂單")]), _vm._v(" "), _c('h6', [_vm._v(" " + _vm._s(_vm.total.itemCount) + " 杯飲料")]), _vm._v(" "), _c('h6', [_vm._v(" " + _vm._s(_vm.total.money) + " 元收入")])]) : _vm._e()]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [(_vm.brandBrief.length > 1 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group form-inline w-auto"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandSelect),
      expression: "brandSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.brandSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.roleType !== 10) ? _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("== 品牌 ==")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.brandBrief), function(brand) {
    return _c('option', {
      domProps: {
        "value": brand.value
      }
    }, [_vm._v("\n                    " + _vm._s(brand.label) + "\n                  ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.brandSelect !== 0 && _vm.brandSelect !== '0' && _vm.storeBrief.length > 1 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group form-inline w-auto"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeSelect),
      expression: "storeSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.storeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("== 門市 ==")]), _vm._v(" "), _vm._l((_vm.storeBrief), function(store) {
    return _c('option', {
      domProps: {
        "value": store.value
      }
    }, [_vm._v("\n                    " + _vm._s(store.label) + "\n                  ")])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 text-right pull-right"
  }, [_c('div', {
    staticClass: "form-group input-group time-box pull-right"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.week,
      "option": _vm.dateoption,
      "limit": _vm.weekLimit
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default submit-btn btn-search",
    staticStyle: {
      "height": "36px"
    },
    attrs: {
      "type": "button",
      "id": "search3"
    },
    on: {
      "click": function($event) {
        return _vm.setProductSale()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])], 1)])]), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("銷售量統計(以週期計算)"), (_vm.brandSelect === 0 || _vm.brandSelect === '0') ? _c('span', {
    staticClass: "text-red text-12"
  }, [_vm._v("(請選擇品牌或店家)")]) : _vm._e()]), _c('br'), _c('br'), _vm._v(" "), (_vm.productSaleList.length) ? _c('div', {
    staticClass: "box-body p-0",
    staticStyle: {
      "min-height": "100px"
    }
  }, [(_vm.productSaleList.length) ? _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.productSaleList[0]) ? _c('div', {
    staticClass: "col-xs-12 text-center col-md-4 col-lg-3"
  }, [_vm._m(8), _vm._v(" "), _c('h3', {
    staticClass: "text-yellow"
  }, [_vm._v(_vm._s(_vm.productSaleList[0].name))])]) : _vm._e(), _vm._v(" "), (_vm.productSaleList[1]) ? _c('div', {
    staticClass: "col-xs-12 text-center col-md-4 col-lg-3 hidden-xs hidden-sm"
  }, [_vm._m(9), _vm._v(" "), _c('h3', {
    staticClass: "text-yellow"
  }, [_vm._v(_vm._s(_vm.productSaleList[1].name))])]) : _vm._e(), _vm._v(" "), (_vm.productSaleList[2]) ? _c('div', {
    staticClass: "col-xs-12 text-center col-md-4 col-lg-3 hidden-xs hidden-sm"
  }, [_vm._m(10), _vm._v(" "), _c('h3', {
    staticClass: "text-yellow"
  }, [_vm._v(_vm._s(_vm.productSaleList[2].name))])]) : _vm._e(), _vm._v(" "), (_vm.productSaleList[3]) ? _c('div', {
    staticClass: "col-xs-12 text-center col-md-4 col-lg-3 visible-lg-block"
  }, [_vm._m(11), _vm._v(" "), _c('h3', {
    staticClass: "text-yellow"
  }, [_vm._v(_vm._s(_vm.productSaleList[3].name))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('tbody', _vm._l((_vm.productSaleList), function(product, index) {
    return (index + 1 <= 10) ? _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                      No." + _vm._s(index + 1) + "\n                    ")]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(product.name))])]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(product.amount) + " 杯\n                    ")])]) : _vm._e()
  }), 0)])])]) : _vm._e()]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("當日使用者註冊狀態")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    staticClass: "line-canvas",
    attrs: {
      "id": "today-shopper"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("累積使用者註冊狀態")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    staticClass: "line-canvas",
    attrs: {
      "id": "total-shopper"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("當日不重複之使用者行為")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    staticClass: "line-canvas",
    attrs: {
      "id": "shopper-active"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    staticClass: "line-canvas",
    attrs: {
      "id": "order-transactions"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    staticClass: "line-canvas",
    attrs: {
      "id": "money-transactions"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    staticClass: "line-canvas",
    attrs: {
      "id": "amount-transactions"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    staticClass: "line-canvas",
    attrs: {
      "id": "rejected-orders"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "th-fit"
  }, [_vm._v("日期")]), _vm._v(" "), _c('th', [_vm._v("拒單原因 (狀態)")]), _vm._v(" "), _c('th', [_vm._v("筆數")]), _vm._v(" "), _c('th', [_vm._v("杯數")]), _vm._v(" "), _c('th', [_vm._v("金額")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/crown.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/crown.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/crown.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/crown.png"
    }
  })])
}]}

/***/ }),
/* 2481 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 p-x-0",
    class: _vm.setting.class,
    attrs: {
      "id": _vm.setting.id
    }
  }, [_c('div', {
    staticClass: "j-mutiple-left"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "name": "from",
      "id": "multiselect",
      "size": "8"
    }
  }, _vm._l((_vm.setting.options), function(option, index) {
    return _c('option', {
      class: 'o-' + option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n        " + _vm._s(option.label) + "\n      ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "j-mutiple-middle"
  }, [_c('button', {
    staticClass: "btn btn-block",
    attrs: {
      "type": "button",
      "id": 'multiselect_rightSelected-' + _vm.setting.class
    },
    on: {
      "click": function($event) {
        _vm.isChoose = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block",
    attrs: {
      "type": "button",
      "id": 'multiselect_leftSelected-' + _vm.setting.class
    },
    on: {
      "click": function($event) {
        _vm.isChoose = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "j-mutiple-right"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "name": "to",
      "id": 'multiselect_to-' + _vm.setting.class,
      "size": "8",
      "multiple": "multiple"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_c('p', {
    staticClass: "text-12"
  }, [_vm._v("已選 " + _vm._s(this.setting.choose.length) + " 間")])])])
},staticRenderFns: []}

/***/ }),
/* 2482 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('discount-form', {
    attrs: {
      "isUp": _vm.isUp
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 2483 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAllItem),
      expression: "selectAllItem"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAllItem) ? _vm._i(_vm.selectAllItem, null) > -1 : (_vm.selectAllItem)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.selectAllItem,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAllItem = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectAllItem = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAllItem = $$c
        }
      }, _vm.selectAll]
    }
  })]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "180px"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v(_vm._s(_vm.type === 'alias' ? '別名' : '描述（上限 500 字）'))]), _vm._v(" "), (_vm.type === 'description') ? _c('th', {
    staticStyle: {
      "min-width": "180px"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("警語（上限 200 字）")]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("商品名稱")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("商品料號")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("啟用")]), _vm._v(" "), _c('th', {
    staticClass: "actions-td",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("品項編輯")]), _vm._v(" "), _c('th', {
    staticClass: "actions-td",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("品項刪除")])])]), _vm._v(" "), (!_vm.settingList.length) ? _c('tbody', [_vm._m(0)]) : _c('tbody', _vm._l((_vm.settingList), function(item, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.selectItem),
        expression: "item.selectItem"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.selectItem) ? _vm._i(item.selectItem, null) > -1 : (item.selectItem)
      },
      on: {
        "change": function($event) {
          var $$a = item.selectItem,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "selectItem", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "selectItem", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "selectItem", $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "row"
    }, [_vm._l((item.item_list), function(item) {
      return _c('div', {
        staticClass: "col-xs-8"
      }, [(_vm.type === 'alias') ? _c('span', [_vm._v(_vm._s(item.name))]) : _vm._e(), _vm._v(" "), (item.type === 1) ? _c('span', [_vm._v(_vm._s(item.description))]) : _vm._e()])
    }), _vm._v(" "), (_vm.type === 'description' && _vm.checkEmptyBtnShow(item.item_list, 1)) ? _c('div', {
      staticClass: "col text-right"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.emptyDescrption(item.item_list, item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e()], 2)]), _vm._v(" "), (_vm.type === 'description') ? _c('td', [_c('div', {
      staticClass: "row"
    }, [_vm._l((item.item_list), function(item) {
      return _c('div', {
        staticClass: "col-xs-8"
      }, [(item.type === 2) ? _c('span', [_vm._v(_vm._s(item.description))]) : _vm._e()])
    }), _vm._v(" "), (_vm.checkEmptyBtnShow(item.item_list, 2)) ? _c('div', {
      staticClass: "col text-right"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.emptyWarning(item.item_list, item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(item.product_name))])]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(item.vendor_custom_id))])]), _vm._v(" "), _c('td', [(item.is_enabled) ? _c('label', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _c('label', {
      staticClass: "label label-danger"
    }, [_vm._v("停用")])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.upElement(item.id, _vm.type)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "inline-block",
      on: {
        "click": function($event) {
          return _vm.delElement(item.id, _vm.type)
        }
      }
    }, [_vm._m(1, true)])])])
  }), 0)])]), _vm._v(" "), _c('paginate', {
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("無資料")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delDesAlisModal"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 2484 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row m-b-15 center-block"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.designated.unit),
      expression: "designated.unit"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.designated.unit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.designated, "unit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.designated.branch),
      expression: "designated.branch"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.designated.branch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.designated, "branch", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.designated.tel),
      expression: "designated.tel"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.designated.tel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.designated, "tel", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.designated.address),
      expression: "designated.address"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.designated.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.designated, "address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.typeOption,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "公司型態",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.designated.type),
      callback: function($$v) {
        _vm.$set(_vm.designated, "type", $$v)
      },
      expression: "designated.type"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), (_vm.getRoleType === 99 && !_vm.up) ? _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.ownerTypeOptions,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "擁有者",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.designated.owner),
      callback: function($$v) {
        _vm.$set(_vm.designated, "owner", $$v)
      },
      expression: "designated.owner"
    }
  })], 1) : _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.designated.owner.label) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), ((_vm.getRoleType === 99 || _vm.getRoleType === 30) && !_vm.up) ? _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "品牌",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    on: {
      "input": _vm.getStore
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.brandSelect.label) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), ((_vm.getRoleType === 99 || _vm.getRoleType === 30) && !_vm.up) ? _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.addStoresSetting.options,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "店家",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    on: {
      "input": _vm.getStore
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1) : _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.storeSelect.label) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.designated.ein),
      expression: "designated.ein"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.designated.ein)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.designated, "ein", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.designated.contact_name),
      expression: "designated.contact_name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.designated.contact_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.designated, "contact_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(10), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.designated.contact_phone),
      expression: "designated.contact_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.designated.contact_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.designated, "contact_phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(11), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.designated.contact_email),
      expression: "designated.contact_email"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.designated.contact_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.designated, "contact_email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_vm._v("ˋ\n      "), _c('button', {
    staticClass: "btn btn-fail",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n        取消\n      ")]), _vm._v(" "), (_vm.up) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.checkDesigned
    }
  }, [_vm._v("\n        修改\n      ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.checkDesigned
    }
  }, [_vm._v("\n        新增\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("單位名稱")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("廠區名稱")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("電話")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("地址")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("公司型態\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("擁有者\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("參與品牌\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("參與店家\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("統一編號")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("窗口名稱")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("窗口電話")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("窗口email")])
}]}

/***/ }),
/* 2485 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box text-center",
    staticStyle: {
      "padding": "100px 0px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4",
    staticStyle: {
      "padding": "0px 5px 0px 10px"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/crActivityInfoForm?rule_code=SA00001'
    }
  }, [_c('button', {
    staticClass: "btn btn-success btn-activity"
  }, [_c('span', {
    staticClass: "text-w-600"
  }, [_vm._v("贈送優惠券")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("消費金額滿額")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4",
    staticStyle: {
      "padding": "0px 10px 0px 5px"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/crActivityInfoForm?rule_code=SA00002'
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-activity"
  }, [_c('span', {
    staticClass: "text-w-600"
  }, [_vm._v("贈送優惠券")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("消費商品數量滿額")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4",
    staticStyle: {
      "padding": "0px 10px 0px 5px"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/crActivityInfoForm?rule_code=SA00003'
    }
  }, [_c('button', {
    staticClass: "btn btn-warning btn-activity"
  }, [_c('span', {
    staticClass: "text-w-600"
  }, [_vm._v("贈送優惠券")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("消費指定商品滿額")])])])], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 2486 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-10 grid"
  }, [_c('div', {
    staticClass: "grid",
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.category), function(c, index) {
    return (_vm.category.length) ? _c('div', {
      staticClass: "col-xs-12 col-lg-4 grid-item p-5"
    }, [_c('div', {
      staticClass: "col-xs-12 card"
    }, [_c('div', {
      staticClass: "col-xs-12 card-title text-left p-x-15"
    }, [_c('span', {
      staticClass: "pull-left"
    }, [_vm._v(_vm._s(c.name))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 text-left"
    }, [_c('ul', {
      staticClass: "nav p-x-15"
    }, _vm._l((c.product_list), function(p, index) {
      return _c('li', {
        staticClass: "card-product c-pointer"
      }, [_c('div', {
        staticClass: "product-name inline-block"
      }, [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('div', {
        staticClass: "inline-block"
      }, [_vm._v("\n                      "), _c('i', {
        staticClass: "fa fa-info-circle c-pointer ",
        attrs: {
          "aria-hidden": "true",
          "data-toggle": "modal"
        },
        on: {
          "click": function($event) {
            return _vm.openCombineModal('info', p.name, p.product_id)
          }
        }
      })]), _vm._v(" "), _c('button', {
        staticClass: "pull-right btn btn-default text-15 btn-add-combine btn-black inline-block",
        attrs: {
          "data-toggle": "modal"
        },
        on: {
          "click": function($event) {
            return _vm.openCombineModal('cr', p.name, p.product_id)
          }
        }
      }, [_vm._v("\n                    新增組合\n                  ")])])
    }), 0)])])]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [(_vm.pageAmount > 1 && _vm.pageGroup !== 1) ? _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        _vm.pageGroup = _vm.pageGroup - 1
      }
    }
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pageAmount), function(index) {
    return (_vm.pageShow(index)) ? _c('li', {
      staticClass: "paginate_button",
      class: {
        active: _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          return _vm.getMenuCategory(index)
        }
      }
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v(_vm._s(index))])]) : _vm._e()
  }), _vm._v(" "), (_vm.pageAmount > 1 && _vm.pageAmount / _vm.groupAmount > _vm.pageGroup) ? _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        _vm.pageGroup = _vm.pageGroup + 1
      }
    }
  }, [_vm._m(2)]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gotoFrom
    }
  }, [_vm._v("\n      上一步\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gotoNext
    }
  }, [_vm._v("\n      下一步\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.gotoOut
    }
  }, [_vm._v("\n      離開\n    ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('combine-modal', {
    attrs: {
      "modalId": "crCombineModal",
      "state": 1,
      "productId": _vm.current.productId,
      "productName": _vm.current.productName,
      "type": _vm.current.type
    }
  }), _vm._v(" "), _c('combine-modal', {
    attrs: {
      "modalId": "infoCombineModal",
      "state": 3,
      "productId": _vm.current.productId,
      "productName": _vm.current.productName,
      "type": _vm.current.type
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "inline-block pull-left"
  }, [_c('h4', {
    staticClass: "pull-left"
  }, [_vm._v("\n        商品與組合\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 2487 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-10 flex align-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.goBackInfo.name,
        params: _vm.goBackInfo.params,
        query: _vm.goBackInfo.query
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default m-r-5 flex"
  }, [_c('span', [_vm._v("返回")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.title)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.subtitle)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex grey darken-1"
  }, [(_vm.brand.name || _vm.store.brand_name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s(_vm.brand.name ? _vm.brand.name : _vm.store.brand_name ? _vm.store.brand_name : '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s('/')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.store.name)
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs mb-3"
  }, [_c('li', {
    class: {
      'active': _vm.tab == 2
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.updateQuery(2)
      }
    }
  }, [_c('a', [_vm._v("配料")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tab == 20
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.updateQuery(20)
      }
    }
  }, [_c('a', [_vm._v("配料群組")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tab == 10
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.updateQuery(10)
      }
    }
  }, [_c('a', [_vm._v("商品分類")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tab == 1
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.updateQuery(1)
      }
    }
  }, [_c('a', [_vm._v("商品")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tab == 11
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.updateQuery(11)
      }
    }
  }, [_c('a', [_vm._v("品項選擇區")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tab == 3
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.updateQuery(3)
      }
    }
  }, [_c('a', [_vm._v("套餐")])])]), _vm._v(" "), _c('div', {
    staticClass: "row form-inline"
  }, [_c('nd-binding-table', {
    attrs: {
      "bindList": _vm.bindList,
      "bindMeta": _vm.bindMeta,
      "tab": _vm.tab,
      "skey": _vm.skey,
      "input": _vm.input,
      "sPage": _vm.sPage,
      "getBindingList": _vm.getBindingList,
      "selectAll": _vm.selectAll,
      "isDeleteStatus": _vm.isDeleteStatus
    }
  })], 1)])])])])])
},staticRenderFns: []}

/***/ }),
/* 2488 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box form-inline"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmedSelect),
      expression: "confirmedSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.confirmedSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 99
    }
  }, [_vm._v("== 成功對帳 ==")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("成功")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("失敗")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vendorSelect),
      expression: "vendorSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.vendorSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.getEtradeType), function(trade) {
    return _c('option', {
      domProps: {
        "value": trade.value
      }
    }, [_vm._v("\n                      " + _vm._s(trade.label) + "\n                    ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchSelect),
      expression: "searchSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("訂單ID")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("交易編號")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("交易日期")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group search-bar"
  }, [(_vm.searchSelect === 3) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchResult),
      expression: "searchResult"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchResult)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchResult = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.clickPage(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])]) : _vm._e(), _vm._v(" "), (_vm.searchSelect === 1) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchResult),
      expression: "searchResult"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchResult)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchResult = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.clickPage(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])]) : (_vm.searchSelect === 2) ? _c('div', {
    staticClass: "input-group time-box"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.tradeDate,
      "option": _vm.dateoption,
      "limit": _vm.tradeLimit
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.clickPage(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(1)]) : (_vm.accountList.length > 0) ? _c('tbody', _vm._l((_vm.accountList), function(account, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "target": "_blank",
        "to": '/cashAccountInfo/' + account.accounting_id
      }
    }, [_vm._v("\n                      " + _vm._s(account.trade_no) + " (" + _vm._s(account.trade_id) + ")\n                    ")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(account.order_id) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    $ " + _vm._s(account.money) + "\n                  ")]), _vm._v(" "), _c('td', [(account.vendor_type === 707) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("LINE PAY")]) : (account.vendor_type === 701) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("iPASS MONEY")]) : (account.vendor_type === 710) ? _c('span', {
      staticClass: "label label-primary"
    }, [_vm._v("信用卡")]) : (account.vendor_type === 713) ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("台灣Pay")]) : (account.vendor_type === 716) ? _c('span', {
      staticClass: "label label-primary"
    }, [_vm._v("全盈+PAY")]) : (account.vendor_type === 717) ? _c('span', {
      staticClass: "label label-primary"
    }, [_vm._v("悠遊付")]) : (account.vendor_type === 718) ? _c('span', {
      staticClass: "label label-info"
    }, [_vm._v("Pi 拍錢包")]) : (account.vendor_type === 719) ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("全支付")]) : (account.vendor_type === 720) ? _c('span', {
      staticClass: "label label-info"
    }, [_vm._v("icash Pay")]) : (account.vendor_type === 908) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("街口支付")]) : (account.vendor_type === 909) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("遠傳電信代收")]) : _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("其他")])]), _vm._v(" "), _c('td', [(account.accounting_type === 1) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("付款")]) : (account.accounting_type === 2) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("退款")]) : _vm._e()]), _vm._v(" "), _c('td', [(account.is_confirmed) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("已完成")]) : (!account.is_confirmed) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("未完成")]) : _vm._e()]), _vm._v(" "), _c('td', [(account.latest_status === 1) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("成功")]) : (account.latest_status === 2) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("失敗 訂單帳務有衝突")]) : (account.latest_status === 3) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("失敗 帳務紀錄有缺")]) : (account.latest_status === 4) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("失敗 帳務記錄冗余")]) : _c('span', {
      staticClass: "label label-default"
    }, [_vm._v("尚未對帳")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(account.trade_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(account.create_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(account.update_time))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#confirmModal"
      },
      on: {
        "click": function($event) {
          return _vm.getCurrentId(account.accounting_id, account.is_confirmed)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), 0) : (_vm.accountList.length === 0) ? _c('tbody', [_vm._m(2)]) : _vm._e()])]), _vm._v(" "), _c('paginate', {
    ref: "brandPaginate",
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])])])]), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.confirmOption,
      "selectOptions": _vm.selectOptions
    },
    on: {
      "trigger": _vm.trigger,
      "selectOnChange": _vm.selectOnChange
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("交易序號 (ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單ID")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("付款方式")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("交易類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("對帳進度")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("最後狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("交易日期")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("建立時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("更新時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
}]}

/***/ }),
/* 2489 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [_c('div', {
    staticClass: "box-body form"
  }, [(_vm.show.delBtn) ? _c('div', {
    staticClass: "del-block"
  }, [_c('div', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    }
  }, [_vm._v("刪除帳號")])]) : _vm._e(), _vm._v(" "), (_vm.show.delBtn) ? _c('br') : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.info) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioRoleType),
      expression: "radioRoleType"
    }],
    attrs: {
      "type": "radio",
      "name": "roleTypeOption",
      "value": "admin"
    },
    domProps: {
      "checked": _vm._q(_vm.radioRoleType, "admin")
    },
    on: {
      "change": function($event) {
        _vm.radioRoleType = "admin"
      }
    }
  }), _vm._v("系統\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioRoleType),
      expression: "radioRoleType"
    }],
    attrs: {
      "type": "radio",
      "name": "roleTypeOption",
      "value": "brand"
    },
    domProps: {
      "checked": _vm._q(_vm.radioRoleType, "brand")
    },
    on: {
      "change": function($event) {
        _vm.radioRoleType = "brand"
      }
    }
  }), _vm._v("品牌\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioRoleType),
      expression: "radioRoleType"
    }],
    attrs: {
      "type": "radio",
      "name": "roleTypeOption",
      "value": "store"
    },
    domProps: {
      "checked": _vm._q(_vm.radioRoleType, "store")
    },
    on: {
      "change": function($event) {
        _vm.radioRoleType = "store"
      }
    }
  }), _vm._v("店家\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioRoleType),
      expression: "radioRoleType"
    }],
    attrs: {
      "type": "radio",
      "name": "roleTypeOption",
      "value": "pos"
    },
    domProps: {
      "checked": _vm._q(_vm.radioRoleType, "pos")
    },
    on: {
      "change": function($event) {
        _vm.radioRoleType = "pos"
      }
    }
  }), _vm._v("POS\n            ")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (!_vm.info) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.account),
      expression: "content.account"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.content.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content, "account", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("帳號")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v("\n          " + _vm._s(_vm.info.account) + "\n        ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [(!_vm.info) ? _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("密碼\n      ")]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n        新密碼\n      ")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.password),
      expression: "content.password"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "password",
      "maxlength": "20",
      "minlength": "6"
    },
    domProps: {
      "value": (_vm.content.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [(!_vm.info) ? _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("密碼確認\n      ")]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n        新密碼確認\n      ")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.re_password),
      expression: "content.re_password"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "password",
      "maxlength": "20",
      "minlength": "6"
    },
    domProps: {
      "value": (_vm.content.re_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content, "re_password", $event.target.value)
      }
    }
  }), _vm._v(" "), (!_vm.$v.content.re_password.sameAsPassword) ? _c('span', {
    staticClass: "form-group__message"
  }, [_vm._v("密碼不正確")]) : _vm._e()]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.name),
      expression: "content.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.content.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.radioRoleType === 'brand' || _vm.$route.params.role_type === 'brand') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('multiselect', {
    attrs: {
      "tag-placeholder": "品牌綁定",
      "placeholder": "選擇品牌",
      "label": "label",
      "track-by": "value",
      "options": _vm.brandBrief,
      "multiple": true,
      "allow-empty": false
    },
    model: {
      value: (_vm.select.bindingBrandList),
      callback: function($$v) {
        _vm.$set(_vm.select, "bindingBrandList", $$v)
      },
      expression: "select.bindingBrandList"
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.radioRoleType === 'store' || _vm.$route.params.role_type === 'store') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 品牌 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.brandDefault),
      callback: function($$v) {
        _vm.brandDefault = $$v
      },
      expression: "brandDefault"
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.radioRoleType === 'store' || _vm.$route.params.role_type === 'store') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('multiselect', {
    attrs: {
      "tag-placeholder": "店家綁定",
      "placeholder": "選擇店家",
      "label": "label",
      "track-by": "value",
      "options": _vm.storeBrief,
      "multiple": true,
      "allow-empty": false
    },
    model: {
      value: (_vm.select.bindingStoreList),
      callback: function($$v) {
        _vm.$set(_vm.select, "bindingStoreList", $$v)
      },
      expression: "select.bindingStoreList"
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.radioRoleType === 'pos' || _vm.$route.params.role_type === 'pos') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('multiselect', {
    attrs: {
      "tag-placeholder": "POS綁定",
      "placeholder": "選擇POS",
      "label": "label",
      "track-by": "value",
      "options": _vm.posBrief,
      "multiple": false,
      "allow-empty": false
    },
    model: {
      value: (_vm.select.bindingPosList),
      callback: function($$v) {
        _vm.$set(_vm.select, "bindingPosList", $$v)
      },
      expression: "select.bindingPosList"
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group form-group m-y-0"
  }, [_c('span', {
    staticClass: "input-group-addon form__label"
  }, [_vm._v("\n          手機號碼\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.content.phone),
      expression: "content.phone",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control form__input",
    attrs: {
      "placeholder": "",
      "type": "tel",
      "maxlength": "10",
      "id": "phone"
    },
    domProps: {
      "value": (_vm.content.phone)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content, "phone", $event.target.value.trim())
      }, function($event) {
        return _vm.$v.content.phone.$touch()
      }],
      "keyup": function($event) {
        return _vm.verityPhone()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.$v.content.phone.minLength) ? _c('span', {
    staticClass: "form-group__message"
  }, [_vm._v("手機號碼長度錯誤")]) : _vm._e()]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group form-group m-y-0"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          電子信箱\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.content.email),
      expression: "content.email",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control form__input",
    attrs: {
      "placeholder": "",
      "type": "email",
      "maxlength": "80"
    },
    domProps: {
      "value": (_vm.content.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content, "email", $event.target.value.trim())
      }, function($event) {
        return _vm.$v.content.phone.$touch()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.$v.content.email.email) ? _c('span', {
    staticClass: "form-group__message"
  }, [_vm._v("信箱格式錯誤")]) : _vm._e()]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          生日\n        ")]), _vm._v(" "), _c('date-time-picker', {
    staticClass: "form-date-picker w-100-p",
    attrs: {
      "date": _vm.birth,
      "option": _vm.dateoption,
      "limit": _vm.dateLimit
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon b-r"
  }, [_vm._v("\n          性別\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.sex),
      expression: "content.sex"
    }],
    attrs: {
      "type": "radio",
      "name": "sexOption",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.content.sex, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.content, "sex", "1")
      }
    }
  }), _vm._v("男\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.sex),
      expression: "content.sex"
    }],
    attrs: {
      "type": "radio",
      "name": "sexOption",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.content.sex, "2")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.content, "sex", "2")
      }
    }
  }), _vm._v("\n              女\n            ")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.info) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n        停權\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.is_suspend),
      expression: "content.is_suspend"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.content, "is_suspend", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("正常")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("停權")])])])]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('router-link', {
    attrs: {
      "to": "/accountTable"
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("\n        取消\n      ")])]), _vm._v(" "), (!_vm.info) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addAccount
    }
  }, [_vm._v("\n      新增\n    ")]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.upAccount
    }
  }, [_vm._v("\n      修改\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon b-r"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("角色\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("帳號\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("名稱\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("品牌綁定\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("品牌\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("店家綁定\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("POS廠ID綁定\n      ")])
}]}

/***/ }),
/* 2490 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/addAnnouncement'
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("新增公告")])]), _vm._v(" "), (!_vm.isDeleteStatus) ? _c('div', {
    staticClass: "btn btn-default btn-table-title",
    on: {
      "click": function($event) {
        _vm.isDeleteStatus = true
      }
    }
  }, [_vm._v("批次刪除")]) : _vm._e(), _vm._v(" "), (_vm.isDeleteStatus) ? _c('div', {
    staticClass: "btn btn-default btn-table-title",
    on: {
      "click": function($event) {
        _vm.isDeleteStatus = false
      }
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), (_vm.isDeleteStatus) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delNewsModal"
    },
    on: {
      "click": _vm.deleteAnnouncement
    }
  }, [_vm._v("刪除")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [(_vm.isDeleteStatus) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("序號")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("標題")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("蓋板公告")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("發布對象")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("發布時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("最後編輯時機")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("最後編輯編輯者")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])]), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(0)]) : (!_vm.isLoading && _vm.announcementList.length > 0) ? _c('tbody', _vm._l((_vm.announcementList), function(news, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [(_vm.isDeleteStatus) ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (news.selectItem),
        expression: "news.selectItem"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(news.selectItem) ? _vm._i(news.selectItem, null) > -1 : (news.selectItem)
      },
      on: {
        "change": function($event) {
          var $$a = news.selectItem,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(news, "selectItem", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(news, "selectItem", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(news, "selectItem", $$c)
          }
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v("\n                              " + _vm._s(index + 1) + "\n                          ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "200px"
      }
    }, [_vm._v("\n                              " + _vm._s(news.title) + "\n                          ")]), _vm._v(" "), _c('td', [_c('span', {
      class: ['label', news.is_overlay ? 'label-success' : 'label label-danger']
    }, [_vm._v(_vm._s(news.is_overlay ? '啟用' : '不啟用'))])]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(_vm._f("roleType")(news.role_type)) + "\n                          ")]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(news.announce_time) + "\n                          ")]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(news.update_time) + "\n                          ")]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(news.user_account) + "\n                          ")]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/editAnnouncement/' + news.announcement_id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#delNewsModal"
      },
      on: {
        "click": function($event) {
          return _vm.deleteSingleAnnouncement(news.announcement_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1)])
  }), 0) : (!_vm.isLoading && _vm.announcementList.length === 0) ? _c('tbody', [_vm._m(1)]) : _vm._e()])]), _vm._v(" "), _c('paginate', {
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)]), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delDesAlisOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
}]}

/***/ }),
/* 2491 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title",
    on: {
      "click": _vm.outputList
    }
  }, [_vm._v("匯出店家時間內拆帳")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchSelect),
      expression: "searchSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("時間")])])]), _vm._v(" "), (_vm.searchSelect == 1) ? _c('div', {
    staticClass: "form-group input-group time-box"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.dateoption,
      "limit": _vm.startLimit
    }
  }), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.dateoption,
      "limit": _vm.endLimit
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default submit-btn btn-search",
    staticStyle: {
      "height": "72px"
    },
    attrs: {
      "type": "button",
      "id": "search"
    },
    on: {
      "click": function($event) {
        return _vm.getRangeHistory(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.info.brandId) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box-body form-left min-m-t-10"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("品牌名稱(ID)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n              " + _vm._s(_vm.info.brandName) + " (" + _vm._s(_vm.info.brandId) + ")\n            ")])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right min-m-t-10"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("店家名稱(ID)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n              " + _vm._s(_vm.info.storeName) + " (" + _vm._s(_vm.info.storeId) + ")\n            ")])]), _vm._v(" "), _c('br')])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.historyList), function(history, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_c('span', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(history.order_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(history.total_order_count))]), _vm._v(" "), _c('td', [_vm._v("$ " + _vm._s(history.total_order_money))]), _vm._v(" "), _c('td', [_vm._v("$ " + _vm._s(history.total_store_revenue))]), _vm._v(" "), _c('td', [_vm._v("$ " + _vm._s(history.total_matcher_revenue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(history.total_posted_count))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/oneDayHistoryTable/' + history.brand_id + '/' + history.store_id + '/' + history.order_date
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-info-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })])])], 1)])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("下訂日期")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單總數")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單總金額")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("店家實得款項金額")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Matcher手續費")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("完成過帳筆數")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])])
}]}

/***/ }),
/* 2492 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', {
    staticClass: "col-xs-12 m-b-10"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'brandMenuTable',
        params: {
          brand_id: _vm.$route.params.brand_id
        }
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default"
  }, [_vm._v("\n          返回品牌菜單管理\n        ")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 mb-3"
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#editModal"
    },
    domProps: {
      "textContent": _vm._s('不可編輯菜單門市設定')
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'MenuSettingRuleStoreUpdateLogsView'
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title",
    domProps: {
      "textContent": _vm._s('操作歷程')
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [(_vm.setting.blacklist) ? _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "w-xs"
  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
    staticClass: "w-sm"
  }, [_vm._v("可編輯菜單門市")]), _vm._v(" "), _c('td', {
    staticClass: "w-auto",
    domProps: {
      "textContent": _vm._s(_vm.whitelist)
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w-xs"
  }, [_vm._v("2")]), _vm._v(" "), _c('td', {
    staticClass: "w-sm"
  }, [_vm._v("不可編輯菜單門市")]), _vm._v(" "), _c('td', {
    staticClass: "w-auto",
    domProps: {
      "textContent": _vm._s(_vm.blacklist)
    }
  })])])]) : _vm._e()])])])])])]), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.black.option
    },
    on: {
      "trigger": _vm.trigger
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function() {
        return [_c('div', [_c('div', {
          staticClass: "mb-2"
        }, [_vm._v("請選擇要新增或編輯至不可編輯的門市")]), _vm._v(" "), _c('multiselect', {
          attrs: {
            "label": _vm.black.label,
            "options": _vm.setting.whitelist,
            "multiple": true,
            "placeholder": _vm.black.placeholder,
            "tag-placeholder": _vm.black.placeholder,
            "track-by": _vm.black.trackBy
          },
          model: {
            value: (_vm.black.temp),
            callback: function($$v) {
              _vm.$set(_vm.black, "temp", $$v)
            },
            expression: "black.temp"
          }
        })], 1)]
      },
      proxy: true
    }])
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("設定")]), _vm._v(" "), _c('th', [_vm._v("門市")])])])
}]}

/***/ }),
/* 2493 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [(_vm.getRoleType === 99) ? _c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-10 flex align-center"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.goBackInfo
    }
  }, [_c('div', {
    staticClass: "btn btn-default m-r-5 flex"
  }, [_c('span', [_vm._v("返回")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.title)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.subtitle)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex grey darken-1"
  }, [(_vm.brand.name || _vm.store.brand_name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s(_vm.brand.name ? _vm.brand.name : _vm.store.brand_name ? _vm.store.brand_name : '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s('/')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.store.name)
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            完成步驟後，再至\n            "), _c('router-link', {
    attrs: {
      "to": _vm.goToBuild
    }
  }, [_vm._v("\n              菜單建置\n            ")]), _vm._v("\n            建立菜單\n          ")], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "box-body col-xs-12 text-center"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.goToBindingPos
    }
  }, [_c('button', {
    staticClass: "btn btn-detail-edit"
  }, [_vm._v("\n                1 - 建立菜單庫 (綁定商品料號)\n              ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.goToOption
    }
  }, [_c('button', {
    staticClass: "btn-a-o btn-detail-edit"
  }, [_vm._v("\n                2 - 配料 (option)\n              ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.goToAdjust
    }
  }, [_c('button', {
    staticClass: "btn-p-com btn-detail-edit"
  }, [_vm._v("\n                3 - 配料群組 (adjust)\n              ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.goToCategory
    }
  }, [_c('button', {
    staticClass: "btn-com-price btn-detail-edit"
  }, [_vm._v("\n                4 - 商品分類 (category)\n              ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.goToProduct
    }
  }, [_c('button', {
    staticClass: "btn-c-p btn-detail-edit"
  }, [_vm._v("\n                5 - 商品 (product)\n              ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.goToBlock
    }
  }, [_c('button', {
    staticClass: "btn-a-o btn-detail-edit"
  }, [_vm._v("\n                6 - 品項選擇區 (block)\n              ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.goToPackage
    }
  }, [_c('button', {
    staticClass: "btn-p-com btn-detail-edit"
  }, [_vm._v("\n                7 - 套餐 (package)\n              ")])])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            若無套餐需求，只需完成步驟 1~5\n          ")])
}]}

/***/ }),
/* 2494 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('ad-form', {
    attrs: {
      "info": _vm.info
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2495 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm._v(" "), _c('notifications')], 1)
},staticRenderFns: []}

/***/ }),
/* 2496 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('queryString-table')], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 2497 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('cr-option')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2498 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.memberInfo.nickname)), (_vm.realName) ? _c('span', [_vm._v("(" + _vm._s(_vm.realName) + ")")]) : _vm._e(), _vm._v("的訂單列表")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('order-table')], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 2499 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box m-h-700"
  }, [_c('div', {
    staticClass: "box-body form-inline"
  }, [(_vm.roleType !== 10) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [(_vm.brandBrief.length > 1 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 品牌 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchSelect),
      expression: "searchSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("名稱")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.val),
      expression: "search.val"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.val)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "val", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.clickSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]) : _vm._e(), _vm._v(" "), _c('mqtt-table', {
    attrs: {
      "brandId": _vm.brandSelect.value,
      "search": _vm.search
    }
  })], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 2500 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('discount-form')], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 2501 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "center-block"
  }, [_c('div', [_c('div', {
    staticClass: "box",
    staticStyle: {
      "padding": "50px"
    }
  }, [_c('div', {
    staticClass: "warning-info"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("\n              「現折活動」與其他優惠活動併用規則請\n              "), _c('a', {
    attrs: {
      "href": "https://docs.google.com/spreadsheets/d/1_nFqJPrfvsNEvTXBTHKeSrm9oYwJc4-BPFK6ocBo-bg/edit#gid=0",
      "target": "_blank",
      "rel": "noopener noreferrer"
    },
    domProps: {
      "textContent": _vm._s('點我開啟')
    }
  }), _vm._v("。\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.list), function(item, index) {
    return [_c('div', {
      key: 'index' + index,
      class: ['col-md-6']
    }, [_c('div', {
      class: ['info-block', ("bg-light-" + (item.color))]
    }, [_c('div', {
      class: [("bg-" + (item.color)), 'order-block text-center title subNumber']
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      class: ['discount-block', ("bg-light-" + (item.color))]
    }, [_c('div', {
      staticClass: "flex discount-inside-block"
    }, [_c('div', [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "desciption"
    }, [_vm._v(_vm._s(item.desciption))])]), _vm._v(" "), _c('div', {
      staticClass: "edit-block"
    }, [_c('router-link', {
      attrs: {
        "to": '/crDiscount?rule_code=' + item.link
      }
    }, [_c('button', {
      staticClass: "btn btn-black"
    }, [_vm._v("新增")])])], 1)])])])])]
  })], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("請選擇欲建立的折扣類型，按下新增後進入編輯。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("若同時有兩檔現折活動，訂單若同時符合條件，會以先設定的現折活動為優先套用（消費者不可選擇）。")])
}]}

/***/ }),
/* 2502 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [_c('div', {
    staticClass: "box-body form"
  }, [_c('br'), _vm._v(" "), (_vm.$route.params.tag_id) ? _c('div', {
    staticClass: "del-block"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body form"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mealTagInfo.name),
      expression: "mealTagInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.mealTagInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.mealTagInfo, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n      排序\n    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mealTagInfo.sort),
      expression: "mealTagInfo.sort"
    }],
    ref: "sort",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "maxlength": "99",
      "type": "tel"
    },
    domProps: {
      "value": (_vm.mealTagInfo.sort)
    },
    on: {
      "keyup": _vm.veritySort,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.mealTagInfo, "sort", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "box-body form"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mealTagInfo.is_visible),
      expression: "mealTagInfo.is_visible"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.mealTagInfo, "is_visible", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("顯示")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("隱藏")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0 bg-white",
    staticStyle: {
      "border-right": "none"
    }
  }, [_c('span', {
    staticClass: "inline-block h-auto m-t-5"
  }, [(!_vm.mealTagInfo.icon_file) ? _c('div', {
    staticClass: "text-black",
    domProps: {
      "textContent": _vm._s('沒有圖片')
    }
  }) : _c('object', {
    staticStyle: {
      "width": "33px",
      "height": "33px"
    },
    attrs: {
      "type": "image/svg+xml",
      "data": _vm.mealTagInfo.icon_file
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [_c('div', [_c('label', {
    staticClass: "btn-upload btn btn-default m-t-25",
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "for": "meal-tag-icon-load"
    }
  }, [_vm._v("\n              選擇圖片\n            ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "meal-tag-icon-load"
    },
    on: {
      "change": _vm.onIconChange
    }
  })])])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          底圖\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0 bg-white",
    staticStyle: {
      "border-right": "none"
    }
  }, [_c('span', {
    staticClass: "inline-block h-auto m-t-5"
  }, [(!_vm.mealTagInfo.image_file) ? _c('div', {
    staticClass: "text-black",
    domProps: {
      "textContent": _vm._s('沒有圖片')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mealTagInfo.image_file) ? _c('img', {
    staticClass: "h-auto img-responsive",
    attrs: {
      "src": _vm.mealTagInfo.image_file,
      "data-toggle": "modal"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [_c('div', [_c('label', {
    staticClass: "btn-upload btn btn-default m-t-25",
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "for": "meal-tag-img-load"
    }
  }, [_vm._v("\n              選擇圖片\n            ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "meal-tag-img-load"
    },
    on: {
      "change": _vm.onImageChange
    }
  })])])])]), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('router-link', {
    attrs: {
      "to": "/mealTagTable"
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("\n        取消\n      ")])]), _vm._v(" "), (!_vm.$route.params.tag_id) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkBeforeSend('cr')
      }
    }
  }, [_vm._v("\n      新增\n    ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkBeforeSend('up')
      }
    }
  }, [_vm._v("\n      修改\n    ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("餐點種類")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("名稱\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "hidden-lg hidden-md"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("顯示\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("圖示\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("(圖示為40x40~200x200)"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("(底圖大小為800x460)"), _c('br')])
}]}

/***/ }),
/* 2503 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [(_vm.getRoleType === 99) ? _c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-10 flex align-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.goBackInfo.name,
        params: _vm.goBackInfo.params,
        query: _vm.goBackInfo.query
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default m-r-5 flex"
  }, [_c('span', [_vm._v("返回")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.title)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.subtitle)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex grey darken-1"
  }, [(_vm.brand.name || _vm.store.brand_name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s(_vm.brand.name ? _vm.brand.name : _vm.store.brand_name ? _vm.store.brand_name : '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s('/')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.store.name)
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      'active': _vm.tab == 1
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.updateQuery(1)
      }
    }
  }, [_c('a', [_vm._v("商品")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tab == 3
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.updateQuery(3)
      }
    }
  }, [_c('a', [_vm._v("套餐")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tab == 10
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.updateQuery(10)
      }
    }
  }, [_c('a', [_vm._v("分類")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-t-10"
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title",
    on: {
      "click": function($event) {
        return _vm.crElement()
      }
    }
  }, [_vm._v("新增" + _vm._s(_vm.tabName) + "別名/描述/警示")])]), _vm._v(" "), _c('div', {
    staticClass: "p-t-50 m-t-15"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-2 bg-light-gray text-left"
  }, _vm._l((_vm.subMenuList), function(option) {
    return _c('div', {
      key: ("option-" + (option.value)),
      staticClass: "select-element",
      class: {
        'active': _vm.subMenu === option.value
      },
      attrs: {
        "disabled": _vm.subMenu === option.value
      },
      on: {
        "click": function($event) {
          return _vm.clickSubMenu(option.value)
        }
      }
    }, [_c('span', {
      staticClass: "text-w-600 p-x-15"
    }, [_vm._v(_vm._s(option.text))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-10 p-l-10"
  }, [_c('div', {
    staticClass: "flex justify-between"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchType),
      expression: "searchType"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "name"
    }
  }, [_vm._v("商品名稱")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "id"
    }
  }, [_vm._v("商品料號")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": _vm.search
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-center title"
  }, [_vm._v(_vm._s(_vm.subMenu === 'alias' ? '商品別名' : '商品描述/警語'))]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [(_vm.getRoleType !== 10 || _vm.getStores.length > 1) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": !_vm.selectItems.length,
      "data-toggle": "modal",
      "data-target": "#copyModal"
    }
  }, [_vm._v("\n                    複製選取設定至其他店家\n                  ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": !_vm.selectItems.length,
      "data-toggle": "modal",
      "data-target": "#delDesAlisModal"
    },
    on: {
      "click": _vm.setDeleteItem
    }
  }, [_vm._v("\n                    批次刪除\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('prod-setting-table', {
    attrs: {
      "setting-list": _vm.list,
      "search-text": _vm.searchText,
      "meta": _vm.meta,
      "tab": _vm.tab,
      "type": _vm.subMenu,
      "tableIndex": _vm.page
    },
    on: {
      "update:settingList": function($event) {
        _vm.list = $event
      },
      "update:setting-list": function($event) {
        _vm.list = $event
      },
      "update:tableIndex": function($event) {
        _vm.page = $event
      },
      "update:table-index": function($event) {
        _vm.page = $event
      },
      "updatePagination": _vm.updatePagination,
      "updateDel": _vm.updateDelElement,
      "selectItem": _vm.setSelectItem
    }
  })], 1)])])])])])]), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delDesAlisOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('choose-store-modal', {
    attrs: {
      "option": _vm.storeOption
    },
    on: {
      "copyStore": _vm.copyStore
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2504 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box m-h-700"
  }, [_c('div', {
    staticClass: "box-body form-inline"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/chooseDiscount'
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("新增折扣活動")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.brandBrief.length > 1 && _vm.$route.name !== 'storeInfo' && _vm.ownerTypeSelect !== 1 && _vm.getRoleType !== 10) ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 品牌 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    on: {
      "input": _vm.getAttendDiscount
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.brandSelect.value !== 999999 && _vm.brandSelect.value !== '999999' && _vm.storeBrief.length > 1 && _vm.ownerTypeSelect !== 1 && _vm.getRoleType !== 30) ? _c('div', {
    staticClass: "form-group",
    on: {
      "change": _vm.getAttendDiscount
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.storeBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 門市 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    on: {
      "input": _vm.getAttendDiscount
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruleCodeSelect),
      expression: "ruleCodeSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ruleCodeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getAttendDiscount]
    }
  }, [_c('option', {
    domProps: {
      "value": 999999
    }
  }, [_vm._v("== 折扣規則 ==")]), _vm._v(" "), _vm._l((_vm.ruleCode), function(item) {
    return _c('option', {
      domProps: {
        "value": item.rule_code
      }
    }, [_vm._v("\n                " + _vm._s(item.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeMethodSelect),
      expression: "timeMethodSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.timeMethodSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getAttendDiscount]
    }
  }, [_c('option', {
    domProps: {
      "value": 999999
    }
  }, [_vm._v("== 狀態 ==")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "notyet"
    }
  }, [_vm._v("未開始")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "going"
    }
  }, [_vm._v("進行中")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "end"
    }
  }, [_vm._v("已結束")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isEnableSelect),
      expression: "isEnableSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isEnableSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getAttendDiscount]
    }
  }, [_c('option', {
    domProps: {
      "value": 999999
    }
  }, [_vm._v("== 啟用狀態 ==")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("啟用")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未啟用")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('id')
      }
    }
  }, [_vm._v("折扣活動 (ID)\n                    "), (_vm.sortMethod === 'id') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("折扣規則 (代碼)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("狀態")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("啟用")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("擁有者")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('start_date')
      }
    }
  }, [_vm._v("活動"), _c('br'), _vm._v("開始\n                    "), (_vm.sortMethod === 'start_date') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('end_date')
      }
    }
  }, [_vm._v("活動"), _c('br'), _vm._v("結束\n                    "), (_vm.sortMethod === 'end_date') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.discountList), function(discount, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [(_vm.canEdit(discount)) ? _c('router-link', {
      attrs: {
        "to": '/discountInfo/' + discount.activity_id
      }
    }, [_vm._v("\n                        " + _vm._s(discount.name) + " (" + _vm._s(discount.activity_id) + ")\n                      ")]) : _c('div', [_vm._v(_vm._s(discount.name) + " (" + _vm._s(discount.activity_id) + ")")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(discount.rule_name) + " (" + _vm._s(discount.rule_code) + ")")]), _vm._v(" "), _c('td', [(discount.time_method === 'notyet') ? _c('label', {
      staticClass: "label label-default"
    }, [_vm._v("未開始")]) : (discount.time_method === 'going') ? _c('label', {
      staticClass: "label label-success"
    }, [_vm._v("進行中")]) : (discount.time_method === 'end') ? _c('label', {
      staticClass: "label label-danger"
    }, [_vm._v("已結束")]) : _vm._e()]), _vm._v(" "), _c('td', [(discount.is_enable === 1) ? _c('label', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _c('label', {
      staticClass: "label label-danger"
    }, [_vm._v("未啟用")])]), _vm._v(" "), _c('td', [(discount.owner_type === 1) ? _c('span', [_vm._v("平台")]) : _vm._e(), _vm._v(" "), (discount.owner_type === 2) ? _c('span', [_vm._v(_vm._s(discount.owner_brand_name) + " (" + _vm._s(discount.owner_id) + ")")]) : _vm._e(), _vm._v(" "), (discount.owner_type === 3) ? _c('span', [_vm._v(_vm._s(discount.owner_brand_name) + " - " + _vm._s(discount.owner_store_name) + " (" + _vm._s(discount.owner_id) + ")")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(discount.start_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(discount.end_date))]), _vm._v(" "), _c('td', [(discount.is_platform_visible === 1) ? _c('label', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _c('label', {
      staticClass: "label label-danger"
    }, [_vm._v("未啟用")])]), _vm._v(" "), _c('td', [(discount.dedicated_visible_setting[0] === 1) ? _c('label', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _c('label', {
      staticClass: "label label-danger"
    }, [_vm._v("未啟用")])]), _vm._v(" "), _c('td', [(_vm.canEdit(discount)) ? _c('router-link', {
      attrs: {
        "to": '/discountStore/' + discount.activity_id
      }
    }, [_c('button', {
      staticClass: "btn btn-primary"
    }, [_c('i', {
      staticClass: "fa fa-home"
    })])]) : _vm._e()], 1), _vm._v(" "), _c('td', [(_vm.canEdit(discount)) ? _c('router-link', {
      attrs: {
        "to": '/upDiscount/' + discount.activity_id
      }
    }, [_c('button', {
      staticClass: "btn btn-primary"
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])]) : _vm._e()], 1)])
  }), 0)])]), _vm._v(" "), _c('paginate', {
    ref: "orderPaginate",
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "storesModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\"" + _vm._s(_vm.current.name) + "\"使用門市")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 p-x-0"
  }, _vm._l((_vm.current.store_list), function(store) {
    return _c('label', {
      staticClass: "label label-primary",
      staticStyle: {
        "margin-right": "5px"
      }
    }, [_vm._v(_vm._s(store.name))])
  }), 0)])]), _vm._v(" "), _vm._m(3)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("你訂"), _c('br'), _vm._v("平台")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("街口"), _c('br'), _vm._v("平台")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_vm._v("參與"), _c('br'), _vm._v("店家")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("確定")])])
}]}

/***/ }),
/* 2505 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [(!_vm.adjustList.length) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._v("\n    無配料群組，請新增\n  ")]) : _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-danger m-y-10 inline-block pull-right",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    },
    on: {
      "click": _vm.delModalOpen
    }
  }, [_vm._v("\n          刪除\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-black m-y-10 inline-block pull-right m-r-10",
    on: {
      "click": _vm.gotoCrAdjusts
    }
  }, [_vm._v("\n          新增\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-black m-y-10 inline-block pull-right m-r-10",
    attrs: {
      "data-toggle": "modal"
    },
    on: {
      "click": function($event) {
        _vm.show.easy = !_vm.show.easy
      }
    }
  }, [(!_vm.show.easy) ? _c('span', [_vm._v("簡易")]) : _c('span', [_vm._v("進階")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-2 bg-light-gray select-element-block text-left"
  }, _vm._l((_vm.adjustList), function(adjust, index) {
    return _c('div', {
      staticClass: "select-element",
      class: {
        'active': _vm.curId === adjust.item_id
      },
      attrs: {
        "disabled": _vm.isLoad || _vm.curId === adjust.item_id
      },
      on: {
        "click": function($event) {
          return _vm.clickAdjust(adjust, index)
        }
      }
    }, [_c('span', {
      staticClass: "text-w-600"
    }, [_vm._v(_vm._s(adjust.name))]), _vm._v(" "), _c('small', {
      staticStyle: {
        "opacity": ".7"
      }
    }, [_vm._v("  " + _vm._s(adjust.remark))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-10"
  }, [_c('div', {
    staticClass: "box-body form menu-form col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6 p-r-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.sub_type),
      expression: "adjustInfo.sub_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.adjustInfo, "sub_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 10
    }
  }, [_vm._v("大小")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 20
    }
  }, [_vm._v("容器")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 30
    }
  }, [_vm._v("甜度")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 40
    }
  }, [_vm._v("溫度")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("其他")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.name),
      expression: "adjustInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "32"
    },
    domProps: {
      "value": (_vm.adjustInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.sort),
      expression: "adjustInfo.sort"
    }],
    ref: "sort",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.adjustInfo.sort)
    },
    on: {
      "keyup": _vm.veritySort,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "sort", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "radio text-left h-38",
    staticStyle: {
      "border-left": "1px solid #d2d6de"
    }
  }, [_c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.is_mandatory),
      expression: "adjustInfo.is_mandatory"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "mandatoryRadio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.adjustInfo.is_mandatory, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.adjustInfo, "is_mandatory", 1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("是")])]), _vm._v(" "), _c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.is_mandatory),
      expression: "adjustInfo.is_mandatory"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "mandatoryRadio"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.adjustInfo.is_mandatory, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.adjustInfo, "is_mandatory", 0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("否")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.min_limit),
      expression: "adjustInfo.min_limit"
    }],
    ref: "minLimit",
    staticClass: "c-auto form-control",
    staticStyle: {
      "width": "calc(50% - 10px)"
    },
    attrs: {
      "placeholder": "0為無上限",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.adjustInfo.min_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityMinLimit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "min_limit", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "line-height": "38px",
      "width": "20px"
    }
  }, [_vm._v("~")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.max_limit),
      expression: "adjustInfo.max_limit"
    }],
    ref: "maxLimit",
    staticClass: "c-auto form-control",
    staticStyle: {
      "width": "calc(50% - 10px)"
    },
    attrs: {
      "placeholder": "0為無上限",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.adjustInfo.max_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityMaxLimit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "max_limit", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("備註")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.remark),
      expression: "adjustInfo.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.adjustInfo.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show.easy),
      expression: "!show.easy"
    }],
    staticClass: "col-xs-12 col-md-6 p-l-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "radio text-left h-38",
    staticStyle: {
      "border-left": "1px solid #d2d6de"
    }
  }, [_c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.is_common),
      expression: "adjustInfo.is_common"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "commonRadio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.adjustInfo.is_common, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.adjustInfo, "is_common", 1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("是")])]), _vm._v(" "), _c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.is_common),
      expression: "adjustInfo.is_common"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "commonRadio"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.adjustInfo.is_common, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.adjustInfo, "is_common", 0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("否")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("價格")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.price),
      expression: "adjustInfo.price"
    }],
    ref: "price",
    staticClass: "form-control",
    attrs: {
      "placeholder": "調整類別內的選項皆為此價格",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.adjustInfo.price)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityPrice()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "price", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("價格類型")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.price_type),
      expression: "adjustInfo.price_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.adjustInfo, "price_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("免稅價格")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("含稅價格")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("熱量")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.calorie),
      expression: "adjustInfo.calorie"
    }],
    ref: "calorie",
    staticClass: "form-control",
    attrs: {
      "placeholder": "調整類別內的選項皆為此熱量",
      "type": "text"
    },
    domProps: {
      "value": (_vm.adjustInfo.calorie)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityCalorie()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "calorie", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("描述")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.description),
      expression: "adjustInfo.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.adjustInfo.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品料號")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.vendor_custom_id),
      expression: "adjustInfo.vendor_custom_id"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.adjustInfo.vendor_custom_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "vendor_custom_id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("配料")]), _vm._v(" "), _c('div', {
    staticClass: "form-control text-left",
    staticStyle: {
      "min-height": "60px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default btn-black m-y-10 inline-block ",
    staticStyle: {
      "position": "absolute",
      "right": "10px",
      "top": "0px",
      "z-index": "3"
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#choseModal"
    }
  }, [_vm._v("\n                  選擇配料\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "option-left-block"
  }, _vm._l((_vm.optionList), function(option) {
    return (option.active) ? _c('div', {
      staticClass: "inline-block m-r-10 option-chose",
      staticStyle: {
        "margin": "5px"
      }
    }, [_vm._v("\n                    " + _vm._s(option.name) + "\n                  ")]) : _vm._e()
  }), 0)])]), _vm._v(" "), _c('br')])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.gotoOut
    }
  }, [_vm._v("\n      返回\n    ")]), _vm._v(" "), (!_vm.adjustList.length) ? _c('button', {
    staticClass: "btn btn-default btn-black",
    on: {
      "click": _vm.gotoCrAdjusts
    }
  }, [_vm._v("\n      新增\n    ")]) : _vm._e(), _vm._v(" "), (_vm.adjustList.length) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.checkInputEmpty
    }
  }, [_vm._v("\n      儲存\n    ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('c-modal', {
    attrs: {
      "elementList": _vm.optionList,
      "option": _vm.choseOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline-block pull-left"
  }, [_c('h4', {
    staticClass: "pull-left"
  }, [_vm._v("配料群組")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("分類")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("調整類別名稱")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("排序\n                "), _c('span', {
    staticClass: "tip-icon",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "data-container": "body",
      "title": "菜單上呈現分類順序預設為：(大小)>(溫度>甜度>容器)>(其他)，括弧內的項目可依排序值調整順序。"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("必選項目")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("選購數量")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("常見價格")])
}]}

/***/ }),
/* 2506 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('history-table')], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 2507 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row m-b-15"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  參與店家\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((10), function(index) {
    return _c('label', {
      staticClass: "label label-primary m-r-5"
    }, [_vm._v("\n                    中山店\n                  ")])
  }), 0)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr', {
    staticClass: "box-body col-xs-12"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_vm._m(2), _vm._v(" "), _c('div', [(_vm.giftSelect === 1) ? _c('div', [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("排除特殊商品")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((2), function(index) {
    return _c('label', {
      staticClass: "label label-primary m-r-5"
    }, [_vm._v("\n                        珍珠奶茶/2931821\n                      ")])
  }), 0)]), _vm._v(" "), _c('br')])]) : (_vm.giftSelect === 2) ? _c('div', [_vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("排除特殊商品")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((2), function(index) {
    return _c('label', {
      staticClass: "label label-primary m-r-5"
    }, [_vm._v("\n                        珍珠奶茶/2931821\n                      ")])
  }), 0)]), _vm._v(" "), _c('br')])]) : (_vm.giftSelect === 3) ? _c('div', [_vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("指定消費商品")]), _vm._v(" "), _vm._l((2), function(index) {
    return _c('label', {
      staticClass: "label label-primary m-r-5"
    }, [_vm._v("\n                      紅茶/3294838\n                    ")])
  })], 2), _vm._v(" "), _c('br')])]) : _vm._e()])]), _vm._v(" "), _c('hr', {
    staticClass: "box-body col-xs-12"
  }), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10)])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.crSchedule
    }
  }, [_vm._v("\n      新增\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fail",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n      取消\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "couponRegisterModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog choose-modal"
  }, [_c('div', {
    staticClass: "modal-content pull-left"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "modal-body text-left pull-left"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "card m-y-1 pull-left w-100-p m-y-10 c-pointer"
  }, [_c('div', {
    staticClass: "coupon-left p-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.useType,
      "label": "label",
      "searchable": false,
      "allow-empty": true,
      "close-on-select": true,
      "placeholder": "優惠券型態",
      "show-labels": false
    },
    model: {
      value: (_vm.coupon.useType),
      callback: function($$v) {
        _vm.$set(_vm.coupon, "useType", $$v)
      },
      expression: "coupon.useType"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "優惠券名稱"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "優惠券描述"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "備註"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', {
    staticClass: "text-light-gray m-t-0"
  }, [_vm._v("\n                  使用期限    \n                ")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.deadType,
      "label": "label",
      "searchable": false,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "過期時間種類",
      "show-labels": false
    },
    model: {
      value: (_vm.coupon.type),
      callback: function($$v) {
        _vm.$set(_vm.coupon, "type", $$v)
      },
      expression: "coupon.type"
    }
  }), _vm._v(" "), (_vm.coupon.type.value === 1) ? _c('div', {
    staticClass: "m-t-10 inline-block m-r-10"
  }, [_vm._v("\n                  開始："), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.timeoption,
      "limit": _vm.startLimit
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.coupon.type.value === 1 || _vm.coupon.type.value === 2) ? _c('div', {
    staticClass: "m-t-10 inline-block"
  }, [_vm._v("\n                  結束："), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.timeoption,
      "limit": _vm.endLimit
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.coupon.type.value === 3) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "幾天後到期"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "coupon-right p-10"
  }, [_c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.priceType,
      "label": "label",
      "searchable": false,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "優惠券稅制",
      "show-labels": false
    },
    model: {
      value: (_vm.coupon.price_type),
      callback: function($$v) {
        _vm.$set(_vm.coupon, "price_type", $$v)
      },
      expression: "coupon.price_type"
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.discountType,
      "label": "label",
      "searchable": false,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "優惠券稅制",
      "show-labels": false
    },
    model: {
      value: (_vm.coupon.discount_type),
      callback: function($$v) {
        _vm.$set(_vm.coupon, "discount_type", $$v)
      },
      expression: "coupon.discount_type"
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _vm._m(12)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "pull-left w-100-p"
  }, [_c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.couponSetting,
      "label": "label",
      "searchable": false,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "優惠券稅制",
      "show-labels": false
    },
    model: {
      value: (_vm.coupon.setting),
      callback: function($$v) {
        _vm.$set(_vm.coupon, "setting", $$v)
      },
      expression: "coupon.setting"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-left m-t-20"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("個人訂單最低消費金額")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("個人訂單最低消費商品數")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("最大使用數量")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.coupon.setting.value === 1) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品限制最低單價")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.coupon.setting.value === 1 || _vm.coupon.setting.value === 2) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("每商品限用張數")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.coupon.setting.value === 3) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("滿多少的總金額數值")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.coupon.setting.value === 3) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("每達到金額限用的張數")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.coupon.setting.value === 1 || _vm.coupon.setting.value === 3) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("排除商品")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.coupon.setting.value === 2) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("指定消費商品")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderType),
      expression: "orderType"
    }],
    attrs: {
      "type": "radio",
      "name": "iconOption",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.orderType, "0")
    },
    on: {
      "change": function($event) {
        _vm.orderType = "0"
      }
    }
  }), _vm._v("無限制\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderType),
      expression: "orderType"
    }],
    attrs: {
      "type": "radio",
      "name": "iconOption",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.orderType, "1")
    },
    on: {
      "change": function($event) {
        _vm.orderType = "1"
      }
    }
  }), _vm._v("一般單\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderType),
      expression: "orderType"
    }],
    attrs: {
      "type": "radio",
      "name": "iconOption",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.orderType, "2")
    },
    on: {
      "change": function($event) {
        _vm.orderType = "2"
      }
    }
  }), _vm._v("團購單\n                        ")])])])]), _vm._v(" "), _c('br')])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動名稱(後台)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  12/2 - 12/31 贈送策略\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動名稱(前端)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  線上消費 - 消費金額滿額送券\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動說明(後台)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  線上消費滿100送10\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動說明(前端)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  線上消費滿100送10\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動順序")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("1")])]), _vm._v(" "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body form-right"
  }, [_c('div', [_c('div', {
    staticClass: "input-group cr-schedule"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動開始時間\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("2018-1-1 00:00")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group cr-schedule"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動結束時間\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("2018-12-31 00:00")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  會員限制\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('label', {
    staticClass: "label label-danger m-r-5"
  }, [_vm._v("\n                    FB\n                  ")])])]), _vm._v(" "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("贈送規則")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("累積滿多少金額，送一份優惠券(單位：元)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("20")])]), _vm._v(" "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("最高贈送份數(單位：份/次)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("1")])]), _vm._v(" "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("累積滿多少商品單價，送一份優惠券(單位：元)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("20")])]), _vm._v(" "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("最高贈送份數(單位：份/次)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("1")])]), _vm._v(" "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("累積滿多少個指定商品數量，送一份優惠券(單位：元)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("10")])]), _vm._v(" "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("最高贈送份數(單位：份/次)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("2")])]), _vm._v(" "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("訂單類型\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("無限制")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("訂單方案\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("無限制")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("取貨方式\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("無限制")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("付款地點\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("無限制")])])]), _vm._v(" "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body form-right"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("訂單最低金額(單位：元)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("100")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("訂單最低購買數(單位：個)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("2")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制主單(或團長)最低金額(單位：元)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("0")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制主單(或團長)最低購買數(單位：個)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("0")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制子單(跟團單)最低訂單數(單位：筆)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("0")])]), _vm._v(" "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header pull-left w-100-p"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title text-left"
  }, [_vm._v("優惠券設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "面額"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("可使用優惠券的訂單類型\n                ")])
}]}

/***/ }),
/* 2508 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 p-10 text-center"
  }, [_c('div', {
    staticClass: "form-group input-group pull-left"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeIds),
      expression: "storeIds"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.storeIds = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _vm._l((_vm.storeBrief), function(store) {
    return _c('option', {
      domProps: {
        "value": store.value
      }
    }, [_vm._v(_vm._s(store.label))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group input-group pull-right"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.dateoption,
      "limit": _vm.startLimit
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v("  ~  ")]), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.dateoption,
      "limit": _vm.endLimit
    }
  }), _vm._v(" "), _c('span', [_c('button', {
    staticClass: "btn btn-success submit-btn btn-search",
    staticStyle: {
      "top": "-2px"
    },
    attrs: {
      "type": "button",
      "id": "brand-chart-search"
    },
    on: {
      "click": _vm.getChart
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6 p-10"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("當日訂單數量與杯數比較")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "today-amount-compare"
    }
  })])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6 p-10"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("當日訂單數量與總額比較")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "today-money-compare"
    }
  })])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6 p-10"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("當日訂單平均金額")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "today-money-average"
    }
  })])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6 p-10"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("當日會員數量")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "shopper-brief"
    }
  })])])])])])])])
}]}

/***/ }),
/* 2509 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.roleType != 99) ? _c('div', {
    staticClass: "col-lg-3 col-sm-6 col-xs-12 p-x-10",
    class: {
      'col-lg-20-p': _vm.roleType != 99
    }
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text m-t-5"
  }, [_vm._v("今日已完成訂單數")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number text-35"
  }, [_vm._v(_vm._s(_vm.ordersAmount.today.amount))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-sm-6 col-xs-12 p-x-10",
    class: {
      'col-lg-20-p': _vm.roleType != 99
    }
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text m-t-5"
  }, [_vm._v("今日成交金額")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number text-35"
  }, [_vm._v(_vm._s(_vm.ordersAmount.today.money))])])])]), _vm._v(" "), (_vm.roleType == 99) ? _c('div', {
    staticClass: "col-lg-3 col-sm-6 col-xs-12 p-x-10"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text m-t-5"
  }, [_vm._v("總會員")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number text-35"
  }, [_vm._v(_vm._s(_vm.shoppersAmount))])])])]) : _vm._e(), _vm._v(" "), (_vm.roleType != 99) ? _c('div', {
    staticClass: "col-lg-3 col-sm-6 col-xs-12 p-x-10",
    class: {
      'col-lg-20-p': _vm.roleType != 99
    }
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text m-t-5"
  }, [_vm._v("今日退訂金額")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number text-35"
  }, [_vm._v(_vm._s(_vm.disAmount.today))])])])]) : _vm._e(), _vm._v(" "), (_vm.roleType != 99) ? _c('div', {
    staticClass: "col-lg-3 col-sm-6 col-xs-12 p-x-10",
    class: {
      'col-lg-20-p': _vm.roleType != 99
    }
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text m-t-5"
  }, [_vm._v("今日賣出份數")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number text-35"
  }, [_vm._v(_vm._s(_vm.successItem.today))])])])]) : _vm._e(), _vm._v(" "), (_vm.roleType != 99) ? _c('div', {
    staticClass: "col-lg-3 col-sm-6 col-xs-12 p-x-10",
    class: {
      'col-lg-20-p': _vm.roleType != 99
    }
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text m-t-5"
  }, [_vm._v("今日未完成筆數")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number text-35"
  }, [_vm._v(_vm._s(_vm.errorAmount.today))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-sm-6 col-xs-12 p-x-10",
    class: {
      'col-lg-20-p': _vm.roleType != 99
    }
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text m-t-5"
  }, [_vm._v("累積總訂單數")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number text-35"
  }, [_vm._v(_vm._s(_vm.ordersAmount.total.amount))])])])]), _vm._v(" "), (_vm.roleType != 99) ? _c('div', {
    staticClass: "col-lg-3 col-sm-6 col-xs-12 p-x-10",
    class: {
      'col-lg-20-p': _vm.roleType != 99
    }
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text m-t-5"
  }, [_vm._v("累積成交金額")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number text-35"
  }, [_vm._v(_vm._s(_vm.ordersAmount.total.money))])])])]) : _vm._e(), _vm._v(" "), (_vm.roleType != 99) ? _c('div', {
    staticClass: "col-lg-3 col-sm-6 col-xs-12 p-x-10",
    class: {
      'col-lg-20-p': _vm.roleType != 99
    }
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text m-t-5"
  }, [_vm._v("累積退訂金額")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number text-35"
  }, [_vm._v(_vm._s(_vm.disAmount.total))])])])]) : _vm._e(), _vm._v(" "), (_vm.roleType != 99) ? _c('div', {
    staticClass: "col-lg-3 col-sm-6 col-xs-12 p-x-10",
    class: {
      'col-lg-20-p': _vm.roleType != 99
    }
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text m-t-5"
  }, [_vm._v("累積賣出份數")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number text-35"
  }, [_vm._v(_vm._s(_vm.successItem.total))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-sm-6 col-xs-12 p-x-10",
    class: {
      'col-lg-20-p': _vm.roleType != 99
    }
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text m-t-5"
  }, [_vm._v("累積錯誤筆數")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number text-35"
  }, [_vm._v(_vm._s(_vm.errorAmount.total))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-10"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6 p-r-10"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("即時訂單狀態數量統計")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 table-responsive",
    staticStyle: {
      "overflow": "scroll",
      "max-height": "500px"
    }
  }, [_c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(12), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.allStatistic.total.amount) + "筆")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.allStatistic.noAccept.amount) + "筆")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.allStatistic.accept.amount) + "筆")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.allStatistic.refuse.amount) + "筆")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.allStatistic.done.amount) + "筆")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.allStatistic.del.amount) + "筆")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 p-l-10"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("即時訂單狀態金額統計")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 table-responsive",
    staticStyle: {
      "overflow": "scroll",
      "max-height": "500px"
    }
  }, [_c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(14), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.allStatistic.total.money) + "元")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.allStatistic.noAccept.money) + "元")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.allStatistic.accept.money) + "元")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.allStatistic.refuse.money) + "元")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.allStatistic.done.money) + "元")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.allStatistic.del.money) + "元")])])])])])])])])]), _vm._v(" "), (_vm.roleType == 99 && _vm.topOrderAmount.brand) ? _c('div', {
    staticClass: "col-xs-12 col-md-6 p-10"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("品牌成交量前五名")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.topOrderAmount.brand.length !== 1) ? _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_vm._m(15), _vm._v(" "), _c('h3', {
    staticClass: "text-yellow"
  }, [_vm._v(_vm._s(_vm.topOrderAmount.brand[0].brand_name))])]) : _vm._e(), _vm._v(" "), (_vm.topOrderAmount.brand.length !== 1) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('tbody', _vm._l((_vm.topOrderAmount.brand), function(brand, index) {
    return (index + 1 != _vm.topOrderAmount.brand.length) ? _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                    No." + _vm._s(index + 1) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(brand.brand_name) + "\n                  ")]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                    " + _vm._s(brand.amount) + " 筆\n                  ")]), _vm._v(" "), (_vm.roleType == 30) ? _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                    " + _vm._s(brand.money) + " 元\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.roleType == 30) ? _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                    " + _vm._s(brand.item_count) + " 份\n                  ")]) : _vm._e()]) : _vm._e()
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_c('h6', [_vm._v("其餘品牌共 " + _vm._s(_vm.topOrderAmount.brand[_vm.topOrderAmount.brand.length - 1].amount) + " 筆")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.roleType == 99 && _vm.topOrderAmount.store) ? _c('div', {
    staticClass: "col-xs-12 col-md-6 p-10"
  }, [(_vm.topOrderAmount.store.length) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [(_vm.roleType == 30) ? _c('span', [_vm._v("今日")]) : _vm._e(), _vm._v("店家成交量前五名")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.topOrderAmount.store.length !== 1) ? _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_vm._m(16), _vm._v(" "), (_vm.roleType === 99) ? _c('h3', {
    staticClass: "text-yellow"
  }, [_vm._v(_vm._s(_vm.topOrderAmount.store[0].brand_name) + " - " + _vm._s(_vm.topOrderAmount.store[0].store_name))]) : _vm._e(), _vm._v(" "), (_vm.roleType === 30) ? _c('h3', {
    staticClass: "text-yellow"
  }, [_vm._v(_vm._s(_vm.topOrderAmount.store[0].store_name))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.topOrderAmount.store.length !== 1) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('tbody', _vm._l((_vm.topOrderAmount.store), function(store, index) {
    return (index + 1 != _vm.topOrderAmount.store.length) ? _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                    No." + _vm._s(index + 1) + "\n                  ")]), _vm._v(" "), _c('td', [(_vm.roleType === 99) ? _c('span', [_vm._v(_vm._s(store.brand_name) + " - " + _vm._s(store.store_name))]) : _vm._e(), _vm._v(" "), (_vm.roleType === 30) ? _c('span', [_vm._v(_vm._s(store.store_name))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                    " + _vm._s(store.amount) + " 筆\n                  ")])]) : _vm._e()
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_c('h6', [_vm._v("其餘店家共 " + _vm._s(_vm.topOrderAmount.store[_vm.topOrderAmount.store.length - 1].amount) + " 筆")])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.roleType == 30 && _vm.topTradeMoney.store) ? _c('div', {
    staticClass: "col-xs-12 col-md-6 p-10"
  }, [(_vm.topTradeMoney.store.length) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [(_vm.roleType == 30) ? _c('span', [_vm._v("今日")]) : _vm._e(), _vm._v("店家成交金額前五名")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.topTradeMoney.store.length !== 1) ? _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_vm._m(17), _vm._v(" "), _c('h3', {
    staticClass: "text-yellow"
  }, [_vm._v(_vm._s(_vm.topTradeMoney.store[0].store_name))])]) : _vm._e(), _vm._v(" "), (_vm.topTradeMoney.store.length !== 1) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('tbody', _vm._l((_vm.topTradeMoney.store), function(store, index) {
    return (index + 1 != _vm.topTradeMoney.store.length) ? _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                    No." + _vm._s(index + 1) + "\n                  ")]), _vm._v(" "), _c('td', [(_vm.roleType === 99) ? _c('span', [_vm._v(_vm._s(store.brand_name) + " - " + _vm._s(store.store_name))]) : _vm._e(), _vm._v(" "), (_vm.roleType === 30) ? _c('span', [_vm._v(_vm._s(store.store_name))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                    " + _vm._s(store.money) + " 元\n                  ")]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                    " + _vm._s(store.order_count) + " 筆\n                  ")]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                    " + _vm._s(store.item_count) + " 份\n                  ")])]) : _vm._e()
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_c('h6', [_vm._v("其餘店家共 " + _vm._s(_vm.topTradeMoney.store[_vm.topTradeMoney.store.length - 1].money) + " 元")])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.roleType == 30 && _vm.topRejectedMoney.store) ? _c('div', {
    staticClass: "col-xs-12 col-md-6 p-10"
  }, [(_vm.topRejectedMoney.store.length) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [(_vm.roleType == 30) ? _c('span', [_vm._v("今日")]) : _vm._e(), _vm._v("店家退訂金額前五名")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.topRejectedMoney.store.length !== 1) ? _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_vm._m(18), _vm._v(" "), _c('h3', {
    staticClass: "text-yellow"
  }, [_vm._v(_vm._s(_vm.topRejectedMoney.store[0].store_name))])]) : _vm._e(), _vm._v(" "), (_vm.topRejectedMoney.store.length !== 1) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('tbody', _vm._l((_vm.topRejectedMoney.store), function(store, index) {
    return (index + 1 != _vm.topRejectedMoney.store.length) ? _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                    No." + _vm._s(index + 1) + "\n                  ")]), _vm._v(" "), _c('td', [(_vm.roleType === 99) ? _c('span', [_vm._v(_vm._s(store.brand_name) + " - " + _vm._s(store.store_name))]) : _vm._e(), _vm._v(" "), (_vm.roleType === 30) ? _c('span', [_vm._v(_vm._s(store.store_name))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                    " + _vm._s(store.money) + " 元\n                  ")]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                    " + _vm._s(store.order_count) + " 筆\n                  ")]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                    " + _vm._s(store.item_count) + " 份\n                  ")])]) : _vm._e()
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_c('h6', [_vm._v("其餘店家共 " + _vm._s(_vm.topRejectedMoney.store[_vm.topRejectedMoney.store.length - 1].money) + " 元")])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.roleType == 99) ? _c('div', {
    staticClass: "col-xs-12"
  }) : _vm._e(), _vm._v(" "), (_vm.roleType == 99) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', [_c('system-dashboard')], 1)]) : _vm._e(), _vm._v(" "), (_vm.roleType == 30) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', [_c('brand-dashboard')], 1)]) : _vm._e(), _vm._v(" "), (_vm.roleType == 10) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('order-line-charts')], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "reload-button"
  }, [_c('div', {
    staticClass: "btn btn-reload bg-red",
    on: {
      "click": function($event) {
        return _vm.reload()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-aqua"
  }, [_c('i', {
    staticClass: "ion ion-document-text"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-green"
  }, [_c('i', {
    staticClass: "ion ion-cash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-red"
  }, [_c('i', {
    staticClass: "ion ion-ios-people"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-red"
  }, [_c('i', {
    staticClass: "ion ion-heart-broken"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-light-blue"
  }, [_c('i', {
    staticClass: "ion ion-wineglass"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "ion ion-sad"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-aqua"
  }, [_c('i', {
    staticClass: "ion ion-document-text"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-green"
  }, [_c('i', {
    staticClass: "ion ion-cash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-red"
  }, [_c('i', {
    staticClass: "ion ion-heart-broken"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-light-blue"
  }, [_c('i', {
    staticClass: "ion ion-wineglass"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "ion ion-sad"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "all-amount-brief",
      "height": "100"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("總訂單")]), _vm._v(" "), _c('th', [_vm._v("未接單")]), _vm._v(" "), _c('th', [_vm._v("已接單")]), _vm._v(" "), _c('th', [_vm._v("被退訂")]), _vm._v(" "), _c('th', [_vm._v("已完成")]), _vm._v(" "), _c('th', [_vm._v("已作廢")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    staticClass: "small-pie",
    attrs: {
      "id": "all-money-brief",
      "height": "100"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("總訂單")]), _vm._v(" "), _c('th', [_vm._v("未接單")]), _vm._v(" "), _c('th', [_vm._v("已接單")]), _vm._v(" "), _c('th', [_vm._v("被退訂")]), _vm._v(" "), _c('th', [_vm._v("已完成")]), _vm._v(" "), _c('th', [_vm._v("已作廢")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/crown.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/crown.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/crown.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/crying.png"
    }
  })])
}]}

/***/ }),
/* 2510 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('printer-form')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2511 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {}, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row form-inline m-b-10"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_c('div', {
    staticClass: "from-group inline-block pull-left"
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title h-38",
    on: {
      "click": _vm.reportPromotion
    }
  }, [_vm._v("產生報表")])]), _vm._v(" "), (_vm.storeBrief.length > 1) ? _c('div', {
    staticClass: "inline-block from-group pull-left m-l-5",
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.newStoreBrief,
      "label": "label",
      "searchable": false,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "門市",
      "show-labels": false,
      "preselect-first": true
    },
    on: {
      "input": _vm.changeSelect
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('div', {
    staticClass: "form-group input-group time-box pull-right"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.dateoption,
      "limit": _vm.startLimit
    }
  }), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.dateoption,
      "limit": _vm.endLimit
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default submit-btn btn-search",
    staticStyle: {
      "height": "72px"
    },
    attrs: {
      "type": "button",
      "id": "search"
    },
    on: {
      "click": function($event) {
        return _vm.search(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-body col-xs-12 text-center"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn-all bg-primary btn-detail-edit p-10",
    class: {
      'active': _vm.typeSelect !== 1
    },
    on: {
      "click": function($event) {
        _vm.typeSelect = 1
      }
    }
  }, [_vm._v("\n                  累積\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn-basic bg-primary btn-detail-edit p-10",
    class: {
      'active': _vm.typeSelect !== 2
    },
    on: {
      "click": function($event) {
        _vm.typeSelect = 2
      }
    }
  }, [_vm._v("\n                  期間\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn-gb bg-primary btn-detail-edit p-10",
    class: {
      'active': _vm.typeSelect !== 3
    },
    on: {
      "click": function($event) {
        _vm.typeSelect = 3
      }
    }
  }, [_vm._v("\n                  目前\n                ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example2"
    }
  }, [_c('thead', {
    staticClass: "middle"
  }, [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "2",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "320px"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "2",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("優惠券")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "2",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("門市")]), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "3",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("贈送")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "3",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("已折")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "3",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("折抵中")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "3",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("作廢")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('th', {
    attrs: {
      "colspan": "2",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("有效")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('th', {
    attrs: {
      "colspan": "2",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("逾期")]) : _vm._e()]), _vm._v(" "), _c('tr', {
    attrs: {
      "role": "row"
    }
  }, [(_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('give_order_amount')
      }
    }
  }, [_vm._v("訂單\n                "), (_vm.sortMethod === 'give_order_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('give_coupon_amount')
      }
    }
  }, [_vm._v("張數\n                "), (_vm.sortMethod === 'give_coupon_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('used_order_amount')
      }
    }
  }, [_vm._v("訂單\n                "), (_vm.sortMethod === 'used_order_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('used_coupon_amount')
      }
    }
  }, [_vm._v("張數\n                "), (_vm.sortMethod === 'used_coupon_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('using_order_amount')
      }
    }
  }, [_vm._v("訂單\n                "), (_vm.sortMethod === 'using_order_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('using_coupon_amount')
      }
    }
  }, [_vm._v("張數\n                "), (_vm.sortMethod === 'using_coupon_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('void_order_amount')
      }
    }
  }, [_vm._v("訂單\n                "), (_vm.sortMethod === 'void_order_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('void_coupon_amount')
      }
    }
  }, [_vm._v("張數\n                "), (_vm.sortMethod === 'void_coupon_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('valid_coupon_amount')
      }
    }
  }, [_vm._v("張數\n                "), (_vm.sortMethod === 'valid_coupon_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('exp_coupon_amount')
      }
    }
  }, [_vm._v("張數\n                "), (_vm.sortMethod === 'exp_coupon_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]) : _vm._e()])]), _vm._v(" "), _c('tbody', {
    staticClass: "middle"
  }, _vm._l((_vm.storeCouponList), function(coupon, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "padding": "10px 15px",
        "background": "#efefef",
        "border-radius": "6px",
        "min-width": "320px"
      }
    }, [_c('div', {
      staticClass: "coupon-left"
    }, [_c('h4', [_vm._v(_vm._s(coupon.coupon_set_name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(coupon.coupon_set_description))])]), _vm._v(" "), _c('div', {
      staticClass: "coupon-right"
    }, [(coupon.discount_type === 1) ? _c('p', {
      staticClass: "v-middle"
    }, [_vm._v("\n                      $ " + _vm._s(coupon.discount_value) + "\n                    ")]) : _vm._e(), _vm._v(" "), (coupon.discount_type === 2) ? _c('p', {
      staticClass: "v-middle"
    }, [_vm._v("\n                      " + _vm._s((100 - coupon.discount_value) / 10) + " 折\n                    ")]) : _vm._e()])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(coupon.store_name) + " (" + _vm._s(coupon.store_id) + ")")]), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-success"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.give_order_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.give_order_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-success"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.give_coupon_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.give_coupon_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-success"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v("$ " + _vm._s(coupon.give_coupon_money))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v("$ " + _vm._s(coupon.give_coupon_money_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-warning"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.used_order_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.used_order_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-warning"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.used_coupon_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.used_coupon_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-warning"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v("$ " + _vm._s(coupon.used_coupon_money))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v("$ " + _vm._s(coupon.used_coupon_money_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-primary"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.using_order_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.using_order_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-primary"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.using_coupon_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.using_coupon_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-primary"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v("$ " + _vm._s(coupon.using_coupon_money))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v("$ " + _vm._s(coupon.using_coupon_money_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-danger"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.void_order_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.void_order_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-danger"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.void_coupon_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.void_coupon_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-danger"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v("$ " + _vm._s(coupon.void_coupon_money))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v("$ " + _vm._s(coupon.void_coupon_money_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('td', {
      staticClass: "td-success"
    }, [_vm._v("\n                " + _vm._s(coupon.valid_coupon_amount) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('td', {
      staticClass: "td-success"
    }, [_vm._v("\n                $ " + _vm._s(coupon.valid_coupon_money) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('td', {
      staticClass: "td-danger"
    }, [_vm._v("\n                " + _vm._s(coupon.exp_coupon_amount) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('td', {
      staticClass: "td-danger"
    }, [_vm._v("\n                $ " + _vm._s(coupon.exp_coupon_money) + "\n              ")]) : _vm._e()])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickEnd('pre')
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickGroup('left')
      }
    }
  }, [_vm._m(1)]), _vm._v(" "), _vm._l((_vm.pageAmount), function(index) {
    return (_vm.pageShow(index)) ? _c('li', {
      staticClass: "paginate_button",
      class: {
        active: _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          return _vm.clickPage(index)
        }
      }
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v(_vm._s(index))])]) : _vm._e()
  }), _vm._v(" "), _vm._l(((_vm.groupAmount - Math.ceil(_vm.pageAmount % 10))), function(dis) {
    return (_vm.pageGroup === Math.ceil(_vm.pageAmount / _vm.groupAmount)) ? _c('li', {
      staticClass: "paginate_button disabled"
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v("  ")])]) : _vm._e()
  }), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickGroup('right')
      }
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickEnd('forward')
      }
    }
  }, [_vm._m(3)])], 2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-step-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-forward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-step-forward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 2512 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      'active': _vm.storeMethod == 1
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 1
      }
    }
  }, [_c('a', [_vm._v("基本資訊")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 2
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 2
      }
    }
  }, [_c('a', [_vm._v("細部設定")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 3
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 3
      }
    }
  }, [_c('a', [_vm._v("預訂/訂購時間")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 4
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 4
      }
    }
  }, [_c('a', [_vm._v("付款方式")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 5
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 5
      }
    }
  }, [_c('a', [_vm._v("製作/取餐時間")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 6
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 6
      }
    }
  }, [_c('a', [_vm._v("取餐方式/門檻")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 7
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 7
      }
    }
  }, [_c('a', [_vm._v("營業/公休時間")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 8
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 8
      }
    }
  }, [_c('a', [_vm._v("塑膠袋")])]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('li', {
    class: {
      'active': _vm.storeMethod == 10
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 10
      }
    }
  }, [_c('a', [_vm._v("出單機")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 98
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 98
      }
    }
  }, [_c('a', [_vm._v("排除商品")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 99
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 99
      }
    }
  }, [_c('a', [_vm._v("連線紀錄")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 15
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 15
      }
    }
  }, [_c('a', [_vm._v("特殊需求")])])])]), _vm._v(" "), (_vm.storeMethod === 1) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-body m-b-10"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "img-store-info",
    attrs: {
      "src": _vm.storeInfo.image
    }
  }), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("名稱 (ID)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.name) + " (" + _vm._s(_vm.storeInfo.id) + ")\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("縮寫名稱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.name_short) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("所屬品牌 (ID)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.brand_name) + " (" + _vm._s(_vm.storeInfo.brand_id) + ")\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("所屬群組 (ID)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.store_group_name) + " (" + _vm._s(_vm.storeInfo.store_group_id) + ")\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                城市 (代碼)\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.city_name) + " (" + _vm._s(_vm.storeInfo.city_code) + ")\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                區域 (代碼)\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.area_name) + " (" + _vm._s(_vm.storeInfo.area_code) + ")\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                地址 (x, y)\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.address) + " (" + _vm._s(_vm.storeInfo.longitude) + ", " + _vm._s(_vm.storeInfo.latitude) + ")\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                電話\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.tel) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.storeInfo.tel2) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                電話2\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.tel2) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.email) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                電子信箱\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.email) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.youtube_video_code) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  Youtube影片代碼\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.youtube_video_code) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [(_vm.storeInfo.ein) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                統一編號\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.ein) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.bl_name) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                抬頭\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.bl_name) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.description) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                描述\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.description) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.search_description) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                描述(搜尋引擎顯示)\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.search_description) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.introduction) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                門市頁介紹\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info",
    staticStyle: {
      "white-space": "pre-line"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.storeInfo.introduction)
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.branch_code) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                品牌下店家代碼\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.branch_code) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.pos_branch_code) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                POS的店家代碼\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.pos_branch_code) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                最後更新時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.edit_time) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                建立時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.create_time) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.storeInfo.photo) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                底圖\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('img', {
    staticStyle: {
      "max-height": "100px"
    },
    attrs: {
      "src": _vm.storeInfo.photo
    }
  })])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.meal_tag_info) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  餐點種類\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.storeInfo.meal_tag_info), function(mealSetting) {
    return _c('span', {
      staticClass: "label label-success m-b-5 m-r-5"
    }, [_vm._v(_vm._s(mealSetting.name))])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.storeMethod === 2) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                API服務類型\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.api_type === 1) ? _c('span', [_vm._v("專屬客製POS")]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.api_type === 2) ? _c('span', [_vm._v("公版POS")]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.api_type === 3) ? _c('span', [_vm._v("平板接單")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                門市類型\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.store_type === 0) ? _c('span', [_vm._v("未分類")]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.store_type === 1) ? _c('span', [_vm._v("直營")]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.store_type === 2) ? _c('span', [_vm._v("加盟")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                距離計算模式\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.distance_service_model === 11) ? _c('span', [_vm._v("走路模式(WALKING)")]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.distance_service_model === 12) ? _c('span', [_vm._v("開車模式(DRIVING)")]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.distance_service_model === 13) ? _c('span', [_vm._v("機車(SCOOTER)")]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.distance_service_model === 14) ? _c('span', [_vm._v("大眾運輸(TRANSIT)")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                營業狀態\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.status === 2) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm.getStateName(_vm.storeInfo.status)))]) : _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.getStateName(_vm.storeInfo.status)))])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                條碼類型\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.barcodeTypeName(_vm.storeInfo.barcode_type)) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                金額進位\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.roundTypeName(_vm.storeInfo.rounding_type)) + "\n                ")])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                優惠券形式\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.couponFormName(_vm.storeInfo.coupon_form)) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  開放紙本發票\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.has_invoice_paper) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("開啟")]) : _vm._e(), _vm._v(" "), (!_vm.storeInfo.has_invoice_paper) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("停用")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  開放電子載具\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.has_invoice_carrier) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("開啟")]) : _vm._e(), _vm._v(" "), (!_vm.storeInfo.has_invoice_carrier) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("停用")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  發票備註\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.invoice_remark) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  開放愛心捐贈發票\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.has_invoice_npoban) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("開啟")]) : _vm._e(), _vm._v(" "), (!_vm.storeInfo.has_invoice_npoban) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("停用")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  店家是否開發票\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(!_vm.storeInfo.is_invoice_exception) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("開發票")]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.is_invoice_exception) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("免開發票")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                前端顯示\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.is_visible) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("顯示")]) : _vm._e(), _vm._v(" "), (!_vm.storeInfo.is_visible) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("未顯示")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                首頁是否搜尋的到店家\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.is_search) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("可搜尋")]) : _vm._e(), _vm._v(" "), (!_vm.storeInfo.is_search) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("不可搜尋")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                支援客製餐點貼紙\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.is_support_custom_sticker) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("支援")]) : _vm._e(), _vm._v(" "), (!_vm.storeInfo.is_support_custom_sticker) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("不支援")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                單品備註\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('span', {
    class: ['label', _vm.storeInfo.is_support_custom_remark ? 'label-success' : 'label-danger']
  }, [_vm._v("\n                    " + _vm._s(_vm.storeInfo.is_support_custom_remark ? '啟用' : '停用') + "\n                  ")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    domProps: {
      "textContent": _vm._s('單品備註')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info",
    domProps: {
      "textContent": _vm._s(_vm.storeInfo.custom_sticker_max_length)
    }
  })]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body  form-center"
  }, [_c('h3', [_vm._v("門市下訂金額限制")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                單筆最高上限\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.one_order_max_money) + " 元\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                到店付款(現金)單筆訂單最高上限\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.to_store_pay_max_money) + " 元\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('h3', [_vm._v("菜單呈現設定")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                菜單版型\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info",
    domProps: {
      "textContent": _vm._s(_vm.menuLayout(_vm.storeInfo.menu_layout_type))
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                飲料溫度顯示(冷 熱 無溫度)\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(!_vm.storeInfo.show_menu_icon) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("全部顯示")]) : (_vm.storeInfo.show_menu_icon === 1) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("無溫度顯示冷")]) : (_vm.storeInfo.show_menu_icon === 2) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("皆顯示無溫度")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                菜單產品圖示顯示\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.show_menu_product_icon) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("顯示")]) : _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("不顯示")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                菜單當日停賣樣式\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.menu_stop_sale_today_type === 1) ? _c('span', [_vm._v("顯示當日停賣ICON")]) : _c('span', [_vm._v("隱藏當日停賣商品")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                菜單永久停賣樣式\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.menu_stop_sale_type === 1) ? _c('span', [_vm._v("顯示永久停賣ICON")]) : _c('span', [_vm._v("隱藏永久停賣商品")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                菜單編輯權限\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.allow_update_menu === 0) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("關閉")]) : _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("開啟")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                銷售折扣組合(紅配綠)菜單分類顯示\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.menu_ab_block_type) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("開啟")]) : _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("關閉")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                菜單同步權限\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.allow_copy_menu === 0) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("關閉")]) : _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("開啟")])])]), _vm._v(" "), _c('br')])])]) : _vm._e(), _vm._v(" "), (_vm.storeMethod === 3) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-body  form-center"
  }, [_c('h3', [_vm._v("預訂設定")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                開始預訂(距今日幾天，0為當日)\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.order_start_day) + " 天\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                結束預訂(距開始預訂幾天，0為開始預訂日)\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.order_tolerance_day) + " 天\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                 自動拒絕預約單時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.auto_reject_order_reserve_m) + " 分\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('h3', [_vm._v("接單/送單設定")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                接單狀態\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.order_status == 10) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm.orderStatusName(_vm.storeInfo.order_status)))]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.order_status == 20) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.orderStatusName(_vm.storeInfo.order_status)))]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.storeInfo.order_status_reason) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  暫停接單理由\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.order_status_reason) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                系統設定接單狀態\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.system_order_status == 0) ? _c('span', {
    staticClass: "label label-default"
  }, [_vm._v(_vm._s(_vm.orderStatusName(_vm.storeInfo.system_order_status)))]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.system_order_status == 10) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm.orderStatusName(_vm.storeInfo.system_order_status)))]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.system_order_status == 20) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.orderStatusName(_vm.storeInfo.system_order_status)))]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                觸發系統自動設定的原因\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.systemReasonName) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                自動拒絕接單\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.auto_reject_order_m) + " 分\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                當日訂購時間前下單\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.is_preparing_allow_order === 1) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("可下單")]) : _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("不可下單")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                結束訂購時間後下單\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.is_close_allow_order === 1) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("可下單")]) : _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("不可下單")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                距營業方開始可以訂購時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.order_start_time_m) + " 分\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                距營業結束方可最後訂購時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.order_end_time_m) + " 分\n                ")])]), _vm._v(" "), _c('br')])])]) : _vm._e(), _vm._v(" "), (_vm.storeMethod === 4) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-body form-center"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("付款類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("支援")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("狀態")]), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30 || _vm.getRoleType === 10) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("金流帳戶統一編號")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.storeInfo.trade_info), function(pay, index) {
    return (pay.is_valid) ? _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                      " + _vm._s(pay.name) + "\n                    ")]), _vm._v(" "), _c('td', [(pay.is_support) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("支援")]) : _vm._e(), _vm._v(" "), (!pay.is_support) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("不支援")]) : _vm._e(), _vm._v(" "), (pay.use_key) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("已設定")]) : _vm._e()]), _vm._v(" "), _c('td', [(pay.is_enable) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("使用")]) : _vm._e(), _vm._v(" "), (!pay.is_enable) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("不使用")]) : _vm._e(), _vm._v(" "), (pay.use_key) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("已設定")]) : _vm._e()]), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30 || _vm.getRoleType === 10) ? _c('td', [_vm._v(_vm._s(pay.ein))]) : _vm._e()]) : _vm._e()
  }), 0)])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("內用-桌邊掃碼")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("payAfterMeal")(_vm.storeInfo.delivery_way_custom_config[21].is_cash_pay_after_meal)))])])])])]), _vm._v(" "), (_vm.exceptionTradeList.length) ? _c('div', [_c('h3', [_vm._v("付款方式與取餐金額")])]) : _vm._e(), _vm._v(" "), (_vm.exceptionTradeList.length) ? _c('div', [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.exceptionTradeList), function(exceptionTrade, eIndex) {
    return _c('tr', [_c('td', [_vm._v("\n                    " + _vm._s(_vm._f("deliveryName")(exceptionTrade.delivery_type)) + "\n                    "), (exceptionTrade.start_money) ? _c('span', [_vm._v("\n                      " + _vm._s(exceptionTrade.start_money) + " 元以上\n                    ")]) : _vm._e(), _vm._v(" "), (exceptionTrade.start_money && exceptionTrade.end_money) ? _c('span', [_vm._v("\n                      ～\n                    ")]) : _vm._e(), _vm._v(" "), (exceptionTrade.end_money) ? _c('span', [_vm._v("\n                      " + _vm._s(exceptionTrade.end_money) + " 元以下\n                    ")]) : _vm._e(), _vm._v("\n                    不可用" + _vm._s(_vm._f("tradeName")(exceptionTrade.trade_type)) + "付款\n                  ")])])
  }), 0)])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.storeMethod === 5) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.storeInfo.take_time_info), function(take, index) {
    return (!_vm.hidePickupType.includes(take.take_type)) ? _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                        " + _vm._s(_vm.getDeliveryName(take.take_type)) + "\n                      ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(take.prepare_time_seg) + " 分")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(take.take_time_seg) + " 分")])]) : _vm._e()
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-center"
  }, _vm._l((_vm.storeInfo.process_time_info), function(process, pIndex) {
    return _c('div', {
      staticClass: "m-t-10 process-time-block"
    }, [_c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n                  時間\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "form-control form-info"
    }, [_vm._v("\n                    " + _vm._s(process.month) + " 月  \n                    "), (_vm.getTimeValue(process.start_value, process.value_type) && _vm.getTimeValue(process.end_value, process.value_type)) ? _c('span', [_vm._v("\n                      " + _vm._s(_vm.getTimeValue(process.start_value, process.value_type)) + " ~ " + _vm._s(_vm.getTimeValue(process.end_value, process.value_type)) + "\n                    ")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n                    取餐類型\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "form-control form-info"
    }, [_vm._v("\n                    " + _vm._s(_vm.getDeliveryName(process.delivery_type)) + "\n                  ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('table', {
      staticClass: "table table-bordered table-striped dataTable"
    }, [_vm._m(6, true), _vm._v(" "), _c('tbody', _vm._l((process.item_list), function(item, iIndex) {
      return _c('tr', [_c('td', [_vm._v("\n                    " + _vm._s(item.start_time) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(item.end_time) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(item.process_time) + " 分\n                  ")])])
    }), 0)])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.storeMethod === 6) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-body form-center"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(8), _vm._v(" "), _c('tbody', _vm._l((_vm.storeInfo.delivery_info), function(delivery, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm.getDeliveryName(delivery.delivery_type)))]), _vm._v(" "), _c('td', [(delivery.is_support) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("支援")]) : _vm._e(), _vm._v(" "), (!delivery.is_support) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("不支援")]) : _vm._e()]), _vm._v(" "), _c('td', [(delivery.is_enable) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("開啟")]) : _vm._e(), _vm._v(" "), (!delivery.is_enable) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("關閉")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(delivery.is_default ? 'V' : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(delivery.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(delivery.order_min_price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(delivery.order_min_distance_m) + "\n                      "), (delivery.delivery_type !== 3) ? _c('span', [_vm._v("(最低)")]) : _vm._e(), _vm._v(" "), (delivery.delivery_type === 3) ? _c('span', [_vm._v("(最高)")]) : _vm._e()]), _vm._v(" "), _c('td', [(delivery.delivery_type === 21 && (_vm.storeInfo.delivery_way_custom_config || _vm.subDeliveryType)) ? _c('span', [_vm._v("\n                        " + _vm._s(_vm._f("subDeliveryType")(_vm.storeInfo.delivery_way_custom_config[21].sub_delivery_type)) + "\n                      ")]) : _vm._e()]), _vm._v(" "), _c('td', [(delivery.is_allow_guest_order) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("開啟")]) : _vm._e(), _vm._v(" "), (!delivery.is_allow_guest_order) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("關閉")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.showMemo(delivery.delivery_type, 'memo')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.showMemo(delivery.delivery_type, 'pickup_memo')))])])
  }), 0)])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                 外送最大距離 (單位: 公里)\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm._f("km")(_vm.storeInfo.max_delivery_distance_m)) + "\n                  "), (!_vm.storeInfo.max_delivery_distance_m) ? _c('span', [_vm._v("無限制")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(10), _vm._v(" "), _c('tbody', _vm._l((_vm.storeInfo.delivery_exception_product_info), function(item, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(item.product_type === 3 ? '套餐' : '商品'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.product_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vendor_custom_id))]), _vm._v(" "), _c('td', [(item.is_enabled) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("開啟")]) : _vm._e(), _vm._v(" "), (!item.is_enabled) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("關閉")]) : _vm._e()])])
  }), 0)])])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(11), _vm._v(" "), (_vm.shippingInfo.is_support && _vm.shippingInfo.is_enable) ? _c('div', [(_vm.storeInfo.shipping_description) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("運費說明")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                    " + _vm._s(_vm.storeInfo.shipping_description) + "\n                  ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("運費計算")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.shipping_fee_type == 0) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("不計算運費")]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.shipping_fee_type == 1) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("依訂單金額計算")]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.shipping_fee_type == 2) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("依運送距離計算")]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.shipping_fee_type == 3) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("依運送距離+訂單金額計算")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.storeInfo.shipping_fee_normal_info.vendor_custom_id) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                    " + _vm._s(_vm.storeInfo.shipping_fee_normal_info.vendor_custom_id) + "\n                  ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.shipping_fee_type === 1) ? _c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(13), _vm._v(" "), _c('tbody', [_vm._l((_vm.showItemList), function(item, iIndex) {
    return (item.money && item.money !== null) ? _c('tr', [_c('td', [_vm._v("\n                    $ " + _vm._s(iIndex ? _vm.showItemList[iIndex - 1].money + 1 : 0) + " ～ $ " + _vm._s(item.money) + "\n                  ")]), _vm._v(" "), _c('td', [(item.fee) ? _c('span', [_vm._v("運費 $ " + _vm._s(item.fee))]) : _c('span', {
      staticClass: "text-danger"
    }, [_vm._v("免運")])])]) : _vm._e()
  }), _vm._v(" "), _c('tr', [_c('td', [(!_vm.showItemList.length || !_vm.showItemList[_vm.showItemList.length - 2] || !_vm.showItemList[_vm.showItemList.length - 2].money) ? _c('span', [_vm._v("不限金額")]) : _c('span', [_vm._v("$ " + _vm._s(_vm.showItemList[_vm.showItemList.length - 2].money + 1) + " 以上")])]), _vm._v(" "), _c('td', [(_vm.getShippingMaxFee) ? _c('span', [_vm._v("運費 $ " + _vm._s(_vm.getShippingMaxFee))]) : _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("免運")])])])], 2)]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.shipping_fee_type === 2) ? _c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(14), _vm._v(" "), _c('tbody', _vm._l((_vm.showItemList), function(item, iIndex) {
    return _c('tr', [_c('td', [(_vm.showItemList.length <= 1 && item.distance === null) ? [_vm._v("\n                      不限距離\n                    ")] : (_vm.showItemList.length > 1 && item.distance === null) ? [_vm._v("\n                      " + _vm._s(_vm._f("km")(_vm.numeral(_vm.showItemList[iIndex - 1].distance).add(100).value())) + " 公里以上\n                    ")] : [_vm._v("\n                      " + _vm._s(_vm._f("km")((_vm.showItemList[iIndex - 1] ? _vm.numeral(_vm.showItemList[iIndex - 1].distance).add(100).value() : 0))) + " 公里 ～ " + _vm._s(_vm._f("km")(item.distance)) + " 公里\n                    ")]], 2), _vm._v(" "), _c('td', [(item.fee) ? _c('span', [_vm._v("運費 $" + _vm._s(item.fee))]) : _c('span', {
      staticClass: "text-danger"
    }, [_vm._v("免運")])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.shipping_fee_type === 3) ? _c('table', {
    staticClass: "table table-bordered table-striped dataTable delivery-table"
  }, [_vm._m(15), _vm._v(" "), _c('tbody', [_vm._l((_vm.showItemList), function(item, index) {
    return [_c('tr', {
      class: index % 2 ? 'even' : 'odd'
    }, [_c('td', {
      attrs: {
        "rowspan": item.range.length + 1
      }
    }, [(_vm.showItemList.length <= 1 && item.distance == null) ? [_c('span', [_vm._v("\n                            不限距離\n                          ")])] : (_vm.showItemList.length > 1 && item.distance == null) ? [_vm._v("\n                          " + _vm._s(_vm._f("km")(_vm.numeral(_vm.showItemList[index - 1].distance).add(100).value())) + " 公里以上\n                        ")] : [_vm._v("\n                          " + _vm._s(_vm._f("km")((_vm.showItemList[index - 1] ? _vm.numeral(_vm.showItemList[index - 1].distance).add(100).value() : 0))) + " 公里 ～ " + _vm._s(_vm._f("km")(item.distance)) + " 公里\n                        ")]], 2)]), _vm._v(" "), _vm._l((item.range), function(range, idx) {
      return _c('tr', {
        class: index % 2 ? 'even' : 'odd'
      }, [_c('td', [(idx !== item.range.length - 1) ? _c('span', [_vm._v("$ " + _vm._s(idx ? item.range[idx - 1].money + 1 : 0) + " ～ $ " + _vm._s(range.money))]) : _c('span', [_vm._v("$ " + _vm._s(item.range[idx - 1].money + 1) + " 以上")])]), _vm._v(" "), _c('td', [(range.fee) ? _c('span', [_vm._v("運費 $ " + _vm._s(range.fee))]) : _c('span', {
        staticClass: "text-danger"
      }, [_vm._v("免運")])])])
    })]
  })], 2)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showTableNumber) ? [_vm._m(16), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  桌號必填\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                    " + _vm._s(_vm.storeInfo.delivery_way_custom_config[21].is_table_no_required ? '必填' : '非必填') + "\n                  ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  桌號編輯\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                    " + _vm._s(_vm.storeInfo.delivery_way_custom_config[21].is_table_no_editable ? '可' : '不可') + "編輯\n                  ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  桌號顯示\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                    " + _vm._s(_vm.storeInfo.delivery_way_custom_config[21].show_table_no ? '顯示' : '隱藏') + "\n                  ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br')] : _vm._e(), _vm._v(" "), (_vm.exceptionCalendar.length) ? _c('div', [_c('h3', [_vm._v("排除設定")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.exceptionCalendar), function(exCalendar, caIndex) {
    return _c('div', {
      staticClass: "m-t-10"
    }, [_c('table', {
      staticClass: "table table-bordered table-striped dataTable"
    }, [_c('thead', {
      staticClass: "bg-primary"
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("deliveryName")(exCalendar.delivery_type)))])])]), _vm._v(" "), _c('tbody', [_vm._l((exCalendar.date_type), function(item, daIndex) {
      return _c('tr', [_c('td', [_vm._v("\n                    " + _vm._s(item.date) + " " + _vm._s(item.start_time) + " ~ " + _vm._s(item.end_time) + " 不可" + _vm._s(_vm._f("deliveryName")(exCalendar.delivery_type)) + "\n                  ")])])
    }), _vm._v(" "), _vm._l((exCalendar.week_day), function(weItem, weIndex) {
      return _c('tr', [_c('td', [_vm._v("\n                    週" + _vm._s(_vm.getDayName(weItem.day)) + " " + _vm._s(weItem.start_time) + " ~ " + _vm._s(weItem.end_time) + " 不可" + _vm._s(_vm._f("deliveryName")(exCalendar.delivery_type)) + "\n                  ")])])
    }), _vm._v(" "), _vm._l((exCalendar.month_day), function(moItem, moIndex) {
      return _c('tr', [_c('td', [_vm._v("\n                    每月" + _vm._s(moItem.day) + "號 " + _vm._s(moItem.start_time) + " ~ " + _vm._s(moItem.end_time) + " 不可" + _vm._s(_vm._f("deliveryName")(exCalendar.delivery_type)) + "\n                  ")])])
    })], 2)])])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.storeMethod === 7) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-body  form-center"
  }, [_c('h3', [_vm._v("營業時間")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(17), _vm._v(" "), _c('tbody', _vm._l((_vm.storeInfo.opening_info), function(open, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("星期" + _vm._s(_vm.getDayName(open.week_day)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(open.start_time) + " ～ " + _vm._s(open.end_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(open.order_start_time) + " ～ " + _vm._s(open.order_end_time))])])
  }), 0)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(18), _vm._v(" "), _c('tbody', _vm._l((_vm.specialOpenTime), function(open, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', _vm._l((open.calendarList), function(date, index) {
      return _c('span', [_vm._v(_vm._s(date)), (index < open.calendarList.length - 1) ? _c('span', [_vm._v("、")]) : _vm._e()])
    }), 0), _vm._v(" "), _c('td', [_vm._v(_vm._s(open.start_time) + " ～ " + _vm._s(open.end_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(open.order_start_time) + " ～ " + _vm._s(open.order_end_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(open.remark))])])
  }), 0)])])]), _vm._v(" "), _c('h3', [_vm._v("公休時間")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  公休時間下單\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.is_off_allow_order === 1) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("可下單")]) : _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("不可下單")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.storeInfo.offday_info.date.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  指定日期\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.storeInfo.offday_info.date), function(offDate, odIndex) {
    return _c('span', [_vm._v(_vm._s(offDate)), (odIndex < _vm.storeInfo.offday_info.date.length - 1) ? _c('span', [_vm._v("、")]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.offday_info.week_day.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  每週幾\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.storeInfo.offday_info.week_day), function(offWeek, owIndex) {
    return _c('span', [_vm._v(_vm._s(_vm.getWeek(offWeek))), (owIndex < _vm.storeInfo.offday_info.week_day.length - 1) ? _c('span', [_vm._v("、")]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.offday_info.month_day.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  每月幾號\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.storeInfo.offday_info.month_day), function(offMonth, omIndex) {
    return _c('span', [_vm._v(_vm._s(offMonth) + "日"), (omIndex < _vm.storeInfo.offday_info.month_day.length - 1) ? _c('span', [_vm._v("、")]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.storeMethod === 8) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-body  form-center"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("塑膠袋功能")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.plastic_option) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("開啟")]) : _vm._e(), _vm._v(" "), (!_vm.storeInfo.plastic_option) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("關閉")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("塑膠袋數量可自行調整")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.is_plastic_amount_adjustable) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("開啟")]) : _vm._e(), _vm._v(" "), (!_vm.storeInfo.is_plastic_amount_adjustable) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("關閉")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("塑膠袋單位")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.plastic_unit) + "個餐點 → 1個塑膠袋\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.storeInfo.delivery_way_plastic_selected) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("預設勾選塑膠袋")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.storeInfo.delivery_way_plastic_selected), function(defaultP) {
    return _c('span', {
      staticClass: "label label-success m-b-5 m-r-5"
    }, [_vm._v(_vm._s(_vm._f("deliveryName")(defaultP)))])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 10),
      expression: "storeMethod === 10"
    }],
    staticClass: "box-body form-center"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(19), _vm._v(" "), _c('tbody', [(!_vm.printerStoreList.length) ? _c('tr', {
    staticClass: "text-center"
  }, [_c('td', {
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("無出單機")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.printerStoreList), function(printer, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v("\n                    出單機" + _vm._s(printer.printer_id) + "號 (" + _vm._s(printer.printer_id) + ")\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(printer.binding_name) + " (" + _vm._s(printer.binding_id) + ")\n                  ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.printerType(printer.printer_type)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(printer.printer_identity))]), _vm._v(" "), _c('td', [(printer.printer_is_enabled) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _vm._e(), _vm._v(" "), (!printer.printer_is_enabled) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("未啟用")]) : _vm._e()]), _vm._v(" "), _c('td', [(printer.binding_is_enabled) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _vm._e(), _vm._v(" "), (!printer.binding_is_enabled) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("未啟用")]) : _vm._e()])])
  })], 2)]), _vm._v(" "), _c('br')])])]), _vm._v(" "), (_vm.storeMethod === 98) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "box-body  form-center"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, _vm._l((_vm.storeInfo.delivery_exception_items_info), function(value, key) {
    return _c('table', {
      staticClass: "table table-bordered table-striped dataTable",
      staticStyle: {
        "border": "0px"
      },
      attrs: {
        "aria-describedby": "example1_info",
        "role": "grid"
      }
    }, [_vm._l((value), function(category, cKey) {
      return (value.adjust.length || value.block.length || value.category.length || value.combination.length ||
        value.option.length || value.package.length || value.product.length) ? _c('thead', [(category.length) ? _c('tr', {
        attrs: {
          "role": "row"
        }
      }, [_c('th', {
        attrs: {
          "colspan": "2",
          "rowspan": "1",
          "aria-controls": "example1",
          "tabindex": "0"
        }
      }, [_vm._v(_vm._s(_vm._f("deliveryName")(parseInt(key, 10))) + "排除")]), _vm._v(" "), _c('th', {
        attrs: {
          "colspan": "1",
          "rowspan": "1",
          "aria-controls": "example1",
          "tabindex": "0"
        }
      }, [_vm._v("POS料號")])]) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), _vm._l((value), function(category, cKey) {
      return (value.adjust.length || value.block.length || value.category.length || value.combination.length ||
        value.option.length || value.package.length || value.product.length) ? _c('tbody', {
        staticStyle: {
          "border": "1px solid gray"
        }
      }, _vm._l((category), function(item) {
        return _c('tr', {
          staticClass: "even",
          attrs: {
            "role": "row"
          }
        }, [_c('td', [_vm._v(_vm._s(_vm.getCategoryName(cKey)))]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(item.name) + " (" + _vm._s(item.item_id) + ")\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(item.vendor_custom_id) + "\n                    ")])])
      }), 0) : _vm._e()
    })], 2)
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.storeMethod === 99) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-body  form-center"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(21), _vm._v(" "), _c('tbody', [_vm._l((_vm.storeInfo.mqtt_info), function(mqtt, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                      " + _vm._s(_vm.getTime(mqtt.create_time)) + "\n                    ")]), _vm._v(" "), _c('td', [(mqtt.status === 1) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("連線")]) : _vm._e(), _vm._v(" "), (mqtt.status === 2) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("中斷")]) : _vm._e()])])
  }), _vm._v(" "), (!_vm.storeInfo.mqtt_info) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("無任何連線紀錄")])]) : _vm._e()], 2)])])])])]) : _vm._e(), _vm._v(" "), (_vm.storeMethod === 15) ? _c('div', {
    staticClass: "box-body"
  }, [(_vm.storeInfo.store_special_item_setting && Array.isArray(_vm.storeInfo.store_special_item_setting) && _vm.storeInfo.store_special_item_setting.length > 0) ? _c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("自選吸管或餐具功能")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.store_special_item_setting[0].is_show) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("開啟")]) : _vm._e(), _vm._v(" "), (!_vm.storeInfo.store_special_item_setting[0].is_show) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("關閉")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("預設吸管或餐具選項")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.store_special_item_setting[0].default_value) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("開啟")]) : _vm._e(), _vm._v(" "), (!_vm.storeInfo.store_special_item_setting[0].default_value) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("關閉")]) : _vm._e()])]), _vm._v(" "), _c('br')])]) : _c('div', {
    staticClass: "box-body form-center"
  }, [_vm._m(22), _vm._v(" "), _vm._m(23)])]) : _vm._e()])]), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "openModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.storeInfo.name) + "營業時間")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(25), _vm._v(" "), _c('tbody', _vm._l((_vm.storeInfo.opening_info), function(open, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("星期" + _vm._s(_vm.getDayName(open.week_day)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(open.start_time) + " ～ " + _vm._s(open.end_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(open.order_start_time) + " ～ " + _vm._s(open.order_end_time))])])
  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "deliveryModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.storeInfo.name) + "外送門檻")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(26), _vm._v(" "), _c('tbody', _vm._l((_vm.storeInfo.delivery_info), function(delivery, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm.getDeliveryName(delivery.delivery_type)))]), _vm._v(" "), _c('td', [(delivery.is_support) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("使用")]) : _vm._e(), _vm._v(" "), (!delivery.is_support) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("不使用")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(delivery.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(delivery.order_min_price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(delivery.order_min_distance_m) + "\n                      "), (delivery.delivery_type !== 3) ? _c('span', [_vm._v("(最低)")]) : _vm._e(), _vm._v(" "), (delivery.delivery_type === 3) ? _c('span', [_vm._v("(最高)")]) : _vm._e()])])
  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "payModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.storeInfo.name) + "付款方式")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(27), _vm._v(" "), _c('tbody', _vm._l((_vm.storeInfo.trade_info), function(pay, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                      " + _vm._s(pay.name) + "\n                    ")]), _vm._v(" "), _c('td', [(pay.is_enable) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("使用")]) : _vm._e(), _vm._v(" "), (!pay.is_enable) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("不使用")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pay.id))])])
  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "takeTimeModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.storeInfo.name) + "製作/取餐時間")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(28), _vm._v(" "), _c('tbody', _vm._l((_vm.storeInfo.take_time_info), function(take, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                      " + _vm._s(_vm.getDeliveryName(take.take_type)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(take.prepare_time_seg) + " 分")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(take.take_time_seg) + " 分")])])
  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "mqttModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.storeInfo.name) + "今日連線紀錄")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(29), _vm._v(" "), _c('tbody', _vm._l((_vm.storeInfo.mqtt_info), function(mqtt, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                      " + _vm._s(_vm.getTime(mqtt.create_time)) + "\n                    ")]), _vm._v(" "), _c('td', [(mqtt.status === 1) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("連線")]) : _vm._e(), _vm._v(" "), (mqtt.status === 2) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("中斷")]) : _vm._e()])])
  }), 0)])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body form-center"
  }, [_c('h3', [_vm._v("細部設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("付款方式")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("現金付款設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("取餐方式")]), _vm._v(" "), _c('td', [_vm._v("付款順序")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("條件")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("取餐類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("所需準備時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("取餐間隔")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("開始時間")]), _vm._v(" "), _c('td', [_vm._v("結束時間")]), _vm._v(" "), _c('td', [_vm._v("準備時間")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("取餐方式/門檻")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("外送類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("支援")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("開啟")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("預設")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("店家取餐ID")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("最低消費門檻")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("距離門檻")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("送餐方式")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("訪客下單\t")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("備註")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("取餐提醒")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("外送門檻排除指定商品")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("商品名稱")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("商品料號")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("狀態")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("運費設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("\n                    POS廠商ID\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("訂單金額")]), _vm._v(" "), _c('td', [_vm._v("運費設定")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("運送距離")]), _vm._v(" "), _c('td', [_vm._v("運費設定")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("運送距離")]), _vm._v(" "), _c('td', [_vm._v("訂單金額")]), _vm._v(" "), _c('td', [_vm._v("運費設定")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("桌號設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("星期")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("營業時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("訂購時間")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("指定時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("營業時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("訂購時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("備註")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("出單機名稱(ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("綁定名稱(ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("辨識碼")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("出單機啟用")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("綁定機啟用")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body form-center"
  }, [_c('h3', [_vm._v("排除商品")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("連線狀態")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("自選吸管或餐具功能")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('span', {
    staticClass: "label label-success"
  }, [_vm._v("未設定")])])]), _vm._v(" "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("預設吸管或餐具選項")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('span', {
    staticClass: "label label-success"
  }, [_vm._v("未設定")])])]), _vm._v(" "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "aria-labelledby": "myModalLabel",
      "aria-hidden": "true",
      "id": "ad-modal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("廣告")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "https://s3-ap-northeast-1.amazonaws.com/matcher-images-beta/banner/milkshop_0502_w_002.png"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-control form-info text-wrap",
    staticStyle: {
      "min-width": "224px"
    }
  }, [_vm._v("\n                https://beta-matcher-testing-web.soonsource.com/#/menu/12\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("返回")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("星期")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("營業時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("訂購時間")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("外送類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("店家取餐ID")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("最低消費門檻")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("距離門檻")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("付款類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("店家付款ID")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("取餐類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("所需準備時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("取餐間隔")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("連線狀態")])])])
}]}

/***/ }),
/* 2513 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.show.category) ? _c('div', {
    staticClass: "col-xs-12 col-md-3 p-10 text-center border"
  }, [_c('h4', {
    staticClass: "text-red"
  }, [_vm._v("停賣分類")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('tbody', _vm._l((_vm.disTableList.category), function(category, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n            " + _vm._s(index + 1) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(category.name) + "\n          ")])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.show.product) ? _c('div', {
    staticClass: "col-xs-12 col-md-3 p-10 text-center border"
  }, [_c('h4', {
    staticClass: "text-red"
  }, [_vm._v("停賣商品")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('tbody', _vm._l((_vm.disTableList.product), function(product, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n            " + _vm._s(index + 1) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(product.name) + "\n          ")])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.show.adjust) ? _c('div', {
    staticClass: "col-xs-12 col-md-3 p-10 text-center border"
  }, [_c('h4', {
    staticClass: "text-red"
  }, [_vm._v("停賣調整類別")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('tbody', _vm._l((_vm.disTableList.adjust), function(adjust, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n            " + _vm._s(index + 1) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(adjust.name) + "\n          ")])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.show.option) ? _c('div', {
    staticClass: "col-xs-12 col-md-3 p-10 text-center"
  }, [_c('h4', {
    staticClass: "text-red"
  }, [_vm._v("停賣調整項目")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('tbody', _vm._l((_vm.disTableList.option), function(option, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n            " + _vm._s(index + 1) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(option.name) + "\n          ")])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.show.combination) ? _c('div', {
    staticClass: "col-xs-12 col-md-3 p-10 text-center border"
  }, [_c('h4', {
    staticClass: "text-red"
  }, [_vm._v("停賣組合")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('tbody', _vm._l((_vm.disTableList.combination), function(combination, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n            " + _vm._s(index + 1) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(combination.name) + "\n          ")])])
  }), 0)])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2514 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', {
    staticClass: "col-xs-12 m-b-10"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'MenuSettingRuleStoreCopyView',
        params: {
          brand_id: _vm.$route.params.brand_id
        }
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default"
  }, [_vm._v("\n          返回菜單同步權限設定\n        ")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [(_vm.list) ? _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.list), function(item, i) {
    return _c('tr', {
      key: _vm.list.id
    }, [_c('td', {
      staticClass: "w-xs"
    }, [_vm._v(_vm._s(i + 1))]), _vm._v(" "), _c('td', {
      staticClass: "w-sm"
    }, [_vm._v(_vm._s(item.manager_account))]), _vm._v(" "), _c('td', {
      staticClass: "w-md"
    }, [_vm._v(_vm._s(_vm.moment(item.action_time).format('YYYY/MM/DD HH:mm:ss')))]), _vm._v(" "), _c('td', {
      staticClass: "w-auto"
    }, [_c('div', {
      staticClass: "mb-1"
    }, [_vm._v("新增：" + _vm._s(_vm.handleName(item.action.add)))]), _vm._v(" "), _c('div', {
      staticClass: "mb-1"
    }, [_vm._v("移除：" + _vm._s(_vm.handleName(item.action.remove)))]), _vm._v(" "), _c('div', [_vm._v("結果：" + _vm._s(_vm.handleName(item.action.result)))])])])
  }), 0)]) : _vm._e()])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("帳號名稱")]), _vm._v(" "), _c('th', [_vm._v("時間")]), _vm._v(" "), _c('th', [_vm._v("門市（新增、移除、結果）")])])])
}]}

/***/ }),
/* 2515 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box m-h-700"
  }, [_c('div', {
    staticClass: "box-body form-inline"
  }, [(_vm.brandBrief.length > 1 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 品牌 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    on: {
      "input": function($event) {
        return _vm.getOnlineMenu('useBrand')
      }
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.brandSelect.value !== 999999 && _vm.brandSelect.value !== '999999' && _vm.storeBrief.length > 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.storeBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 門市 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    on: {
      "input": function($event) {
        return _vm.getOnlineMenu('useStore')
      }
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [(_vm.getRoleType === 99) ? _c('router-link', {
    attrs: {
      "to": {
        path: '/crDisableSchedule' + '?brand_id=' + _vm.brandSelect.value
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("新增時段停賣")])]) : _c('router-link', {
    attrs: {
      "to": {
        path: '/crDisableSchedule'
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("新增時段停賣")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(1)]) : (_vm.settingList.length === 0) ? _c('tbody', [_vm._m(2)]) : (_vm.settingList.length > 0) ? _c('tbody', _vm._l((_vm.settingList), function(setting, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(setting.name) + " (" + _vm._s(setting.id) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(setting.description))]), _vm._v(" "), _c('td', [(setting.is_enabled === 1) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _vm._e(), _vm._v(" "), (setting.is_enabled === 0) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("停用")]) : _vm._e()]), _vm._v(" "), _c('td', [(setting.usage_type === 1) ? _c('span', [_vm._v(_vm._s(setting.brand_name))]) : (setting.usage_type === 2) ? _c('span', [_vm._v(_vm._s(setting.store_name))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(setting.start_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(setting.end_date))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": '/upDisableSchedule/' + setting.id + '?usage_type=' + setting.usage_type + '&brand_id=' + setting.brand_id + '&store_id=' + setting.store_id
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])])], 1)])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('paginate', {
    ref: "orderPaginate",
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "storesModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\"" + _vm._s(_vm.current.name) + "\"使用門市")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 p-x-0"
  }, _vm._l((_vm.current.store_list), function(store) {
    return _c('div', {
      staticClass: "inline-block",
      staticStyle: {
        "margin": "2.5px 5px 2.5px 0px"
      }
    }, [_c('label', {
      staticClass: "label label-primary"
    }, [_vm._v(_vm._s(store.name))])])
  }), 0)])]), _vm._v(" "), _vm._m(3)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("停賣名稱 (ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("描述")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("啟用")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("建立單位")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("開始日期")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("結束日期")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("確定")])])
}]}

/***/ }),
/* 2516 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-10"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n        返回抽成列表\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(1), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(2)]) : (_vm.list.length === 0) ? _c('tbody', [_vm._m(3)]) : _c('tbody', _vm._l((_vm.list), function(row, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v("\n                      " + _vm._s(index + 1) + "\n                    ")]), _vm._v(" "), (row.unit_value) ? _c('td', [_vm._v("\n                      " + _vm._s(row.year) + "-" + _vm._s(row.unit_type === 1 ? row.unit_value.toString().padStart(2, '0') : 'Q' + row.unit_value) + "\n                      " + _vm._s(row.unit_type === 2 ? ("(" + (_vm.quarterList[row.unit_value - 1]) + ")") : '') + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": row.url
      }
    }, [_vm._v("點擊下載")])])])
  }), 0)])]), _vm._v(" "), _c('paginate', {
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])])])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "refreshModal",
    staticClass: "btn btn-danger pull-right m-y-10 ",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#refreshModal"
    }
  }), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.refreshOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            每月4號 00:00 產出前一個月份報表\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("月份")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("連結 (ID)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "3"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
}]}

/***/ }),
/* 2517 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footerCon"
  }, [_vm._t("cleaner"), _vm._v(" "), _vm._t("footer")], 2)
},staticRenderFns: []}

/***/ }),
/* 2518 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body form-inline"
  }, [(_vm.brandBrief.length > 1 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 品牌 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.yearSelect),
      expression: "yearSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.yearSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.yearList), function(year) {
    return _c('option', {
      domProps: {
        "value": year.value
      }
    }, [_vm._v("\n              " + _vm._s(year.label) + "\n            ")])
  }), 0)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "overflow": "scroll",
      "max-height": "500px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(1), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(2)]) : (_vm.statementList.length > 0) ? _c('tbody', _vm._l((_vm.statementList), function(statement, key) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(statement.week))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(statement.start_date) + " ~ " + _vm._s(_vm.endDate(statement.start_date)))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": statement.link,
        "target": "_blank"
      }
    }, [_vm._v("\n                  點擊下載\n                ")])])])
  }), 0) : (_vm.statementList.length === 0) ? _c('tbody', [_vm._m(3)]) : _vm._e()])])])])]), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary bt-explain",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#reportModal"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle mr-5"
  }), _vm._v("報表欄位說明\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "th-fit"
  }, [_vm._v("週數")]), _vm._v(" "), _c('th', [_vm._v("日期")]), _vm._v(" "), _c('th', [_vm._v("連結")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "reportModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-c",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header border-b-1"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("欄位說明")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-content-c"
  }, [_c('p', [_vm._v(" - 總會員數 : 曾訂購過的消費者人數")]), _vm._v(" "), _c('p', [_vm._v(" - 總訂購人數 : 本週訂購過的人數")]), _vm._v(" "), _c('p', [_vm._v(" - 總訂單數 : 狀態為已完成的(當週)訂單總數")]), _vm._v(" "), _c('p', [_vm._v(" - 總訂單數(平台) : 從你訂網頁進入訂購 "), _c('a', {
    attrs: {
      "href": "https://order.nidin.shop/"
    }
  }, [_vm._v("https://order.nidin.shop/")])]), _vm._v(" "), _c('p', [_vm._v(" - 總訂單數(專屬) : 從品牌專屬網頁進入訂購")]), _vm._v(" "), _c('p', [_vm._v(" - 總售出商品數 : 已完成狀態訂單下的所有售出商品數")]), _vm._v(" "), _c('p', [_vm._v(" - 總商品金額 : 已完成狀態訂單下的所有商品的金額加總")]), _vm._v(" "), _c('p', [_vm._v(" - 總銷售額 : 已完成狀態訂單下的實付總金額")]), _vm._v(" "), _c('p', [_vm._v(" - 總錯誤筆數 : 產生報表時尚未處理的筆數(未被更新為已完成、可對應例外訂單)")]), _vm._v(" "), _c('p', [_vm._v(" - 每日平均訂單數 : 總訂單數/7(週) ")]), _vm._v(" "), _c('p', [_vm._v(" - 訂單平均商品數 : 總訂單商品數/全部訂單數(所有訂單狀態「已接單」、「已完成」、「門市已取消」…等)")]), _vm._v(" "), _c('p', [_vm._v(" - 訂單平均商品金額 : 總商品金額/全部訂單數(所有訂單狀態「已接單」、「已完成」、「門市已取消」…等)")]), _vm._v(" "), _c('p', [_vm._v(" - 訂單平均銷售額 : 總銷售額/全部訂單數(所有訂單狀態「已接單」、「已完成」、「門市已取消」…等)")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-default bt-c",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("關閉")])])])])])
}]}

/***/ }),
/* 2519 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [(!_vm.history) ? _c('div', {
    staticClass: "form-group text-left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/crGroup/' + _vm.$route.params.brand_id
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("新增群組")])])], 1) : _vm._e()]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.groupList), function(group, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v("\n                        " + _vm._s(index + 1) + "\n                      ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(group.name) + " (" + _vm._s(group.id) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(group.create_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(group.edit_time))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/upGroup/' + _vm.$route.params.brand_id + '/' + group.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])])], 1)])
  }), 0)])]), _vm._v(" "), _c('paginate', {
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    staticClass: "form-control h-38"
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("名稱")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("代碼")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("名稱 (ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("建立時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("更新時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])])
}]}

/***/ }),
/* 2520 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box form-inline"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/crPrinter'
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("新增出單機")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchResult),
      expression: "searchResult"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchResult)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchResult = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.clickPage(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(1), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(2)]) : (_vm.printerList.length === 0) ? _c('tbody', [_vm._m(3)]) : (_vm.printerList.length > 0) ? _c('tbody', _vm._l((_vm.printerList), function(printer, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": '/printerInfo/' + printer.printer_id
      }
    }, [_vm._v("出單機" + _vm._s(printer.printer_id) + "號 (" + _vm._s(printer.printer_id) + ")")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(printer.printer_type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(printer.printer_identity))]), _vm._v(" "), _c('td', [(printer.printer_is_enabled) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _vm._e(), _vm._v(" "), (!printer.printer_is_enabled) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("未啟用")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": 'upPrinter/' + printer.printer_id
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])])], 1)])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('paginate', {
    ref: "brandPaginate",
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    staticClass: "form-control h-38"
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("辨識碼")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("出單機名稱(ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("辨識碼")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("啟用")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
}]}

/***/ }),
/* 2521 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [_c('div', {
    staticClass: "box-body form"
  }, [(_vm.show.delBtn) ? _c('div', {
    staticClass: "del-block"
  }, [_c('div', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    }
  }, [_vm._v("刪除出單機")])]) : _vm._e(), _vm._v(" "), (_vm.show.delBtn) ? _c('br') : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.identity),
      expression: "content.identity"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.content.identity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content, "identity", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.type),
      expression: "content.type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.content, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("W牌出單機(1)")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("F牌出單機(2)")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("F牌貼紙機(3)")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.info) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n        啟用\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.is_enabled),
      expression: "content.is_enabled"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.content, "is_enabled", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("啟用")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("不啟用")])])])]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('router-link', {
    attrs: {
      "to": "/printerTable"
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("\n        取消\n      ")])]), _vm._v(" "), (!_vm.info) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkPrinter('cr')
      }
    }
  }, [_vm._v("\n      新增\n    ")]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkPrinter('up')
      }
    }
  }, [_vm._v("\n      修改\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("識別碼\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("類型\n      ")])
}]}

/***/ }),
/* 2522 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box m-h-700"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderSn),
      expression: "orderSn"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.orderSn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orderSn = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": _vm.goToOneDatHistoryTable
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("請輸入訂單編號")])])
}]}

/***/ }),
/* 2523 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row m-b-15"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "row fit gutter mx-auto"
  }, [_c('div', {
    staticClass: "col-md-6 gutter"
  }, [(_vm.$route.name === 'upStoreSchedule') ? _c('div', {
    staticClass: "table-row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "table-from"
  }, [_c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.scheduleInfo.store_name))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "table-from"
  }, [(!_vm.$route.query.menu_id) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuId),
      expression: "menuId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuId = $event.target.value
      }
    }
  }) : _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.menuId))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 gutter"
  }, [_c('div', {
    staticClass: "table-row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "table-from w-100"
  }, [_c('date-picker', {
    staticClass: "hide-date-icon",
    attrs: {
      "show-second": false,
      "type": "datetime",
      "valueType": "format",
      "format": "YYYY-MM-DD HH:mm:ss",
      "input-class": "form-control",
      "clearable": false,
      "disabled-time": _vm.notBeforeTodayAddTwoMins,
      "disabled-date": _vm.notBeforeToday
    },
    model: {
      value: (_vm.menuTime.start.time),
      callback: function($$v) {
        _vm.$set(_vm.menuTime.start, "time", $$v)
      },
      expression: "menuTime.start.time"
    }
  })], 1)]), _vm._v(" "), _c('div', [_vm._v("（更換菜單後請確認已接收預訂單是否受影響。）")])]), _vm._v(" "), (_vm.$route.name === 'upSchedule' && _vm.getRoleType !== 10) ? _c('div', {
    staticClass: "col-xs-12 m-x-10"
  }, [_c('div', [_c('h5', [_vm._v("店家綁定")]), _vm._v(" "), _c('div', _vm._l((_vm.storeClassList), function(storeClass, index) {
    return _c('div', {
      staticClass: "m-r-5 m-b-10 inline-block"
    }, [_c('button', {
      staticClass: "btn btn-default",
      class: {
        'active': _vm.curId === storeClass.id
      },
      on: {
        "click": function($event) {
          return _vm.clickOption(storeClass)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(storeClass.name) + "\n                          ")])])
  }), 0), _vm._v(" "), _c('muti-select-two', {
    attrs: {
      "setting": _vm.addStoresSetting,
      "reSet": _vm.reSet
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-fail",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n              返回\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.updateInfo
    }
  }, [_vm._v("\n              編輯\n            ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_c('span', [_vm._v("店家名稱")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_c('span', [_vm._v("菜單ID")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("上架時間\n                        ")])
}]}

/***/ }),
/* 2524 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "warning-block"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n    評價管理功能已搬至「\n    "), _c('a', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.goto
    }
  }, [_vm._v("訂單管理 > 評價管理")]), _vm._v("\n    」，請至新後台管理系統操作、檢視相關內容，此區域(舊後台)功能即將關閉。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('rating-table')], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 2525 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('stores-icon-form')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2526 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('brand-form')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2527 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(!_vm.tableList.id) ? _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('p', [_vm._v("此店家無桌位！")])]) : _vm._e(), _vm._v(" "), (_vm.tableList.id) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_vm._v("桌位設定ID：" + _vm._s(_vm.tableList.id))]), _vm._v(" "), _c('p', [_vm._v("桌位建立時間：" + _vm._s(_vm.tableList.create_time))])]) : _vm._e(), _vm._v(" "), (_vm.tableList.id) ? _c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.tableList.item_list), function(floor) {
    return _c('div', {
      staticClass: "col-xs-12"
    }, [_c('table', {
      staticClass: "table table-bordered table-striped dataTable",
      attrs: {
        "aria-describedby": "example1_info",
        "role": "grid"
      }
    }, [_c('thead', [_c('tr', {
      attrs: {
        "role": "row"
      }
    }, [_c('th', [_vm._v(_vm._s(floor.name) + " (" + _vm._s(floor.id) + ")\n            "), _c('span', {
      staticClass: "pull-right"
    }, [_vm._v("pos table_id：" + _vm._s(floor.vendor_custom_id))])])])]), _vm._v(" "), _c('tbody', [_c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_c('div', {
      staticClass: "col-xs-12 col-md-6"
    }, [_c('p', [_vm._v("排序：" + _vm._s(floor.sort))]), _vm._v(" "), _c('p', [_vm._v("前端顯示：\n                  "), (floor.is_visible) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("顯示")]) : _vm._e(), _vm._v(" "), (!floor.is_visible) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("不顯示")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-6"
    }, [_c('p', [_vm._v("暫停使用：\n                  "), (!floor.is_suspend) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("正常")]) : _vm._e(), _vm._v(" "), (floor.is_suspend) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("暫停")]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v("使用狀況：\n                  "), (!floor.is_available) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("無人")]) : _vm._e(), _vm._v(" "), (floor.is_available) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("使用中")]) : _vm._e()])])])]), _vm._v(" "), _c('tr', {
      attrs: {
        "role": "row"
      }
    }, _vm._l((floor.child_list), function(table) {
      return _c('div', {
        staticClass: "inline-block table-block"
      }, [_c('h4', {
        staticClass: "text-center text-600 table-header"
      }, [_vm._v(_vm._s(table.name) + " (" + _vm._s(table.id) + ")")]), _vm._v(" "), _c('div', {
        staticClass: "word-block"
      }, [_c('p', [_vm._v("\n                  pos table_id：" + _vm._s(table.vendor_custom_id) + "\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                  排序：" + _vm._s(table.sort) + "\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                  前端顯示：\n                  "), (table.is_visible) ? _c('span', {
        staticClass: "label label-success"
      }, [_vm._v("顯示")]) : _vm._e(), _vm._v(" "), (!table.is_visible) ? _c('span', {
        staticClass: "label label-danger"
      }, [_vm._v("不顯示")]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v("暫停使用：\n                  "), (!table.is_suspend) ? _c('span', {
        staticClass: "label label-success"
      }, [_vm._v("正常")]) : _vm._e(), _vm._v(" "), (table.is_suspend) ? _c('span', {
        staticClass: "label label-danger"
      }, [_vm._v("暫停")]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v("使用狀況：\n                  "), (!table.is_available) ? _c('span', {
        staticClass: "label label-success"
      }, [_vm._v("無人")]) : _vm._e(), _vm._v(" "), (table.is_available) ? _c('span', {
        staticClass: "label label-danger"
      }, [_vm._v("使用中")]) : _vm._e()])])])
    }), 0)])]), _vm._v(" "), _c('br')])
  }), 0) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2528 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-xd-12"
  }, [_c('shopper-money-table', {
    attrs: {
      "memberAmount": _vm.memberAmount
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2529 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.option.id,
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog choose-modal"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title text-left"
  }, [_vm._v(_vm._s(_vm.option.title))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body text-left"
  }, _vm._l((_vm.adjustList), function(adjust) {
    return (adjust.active) ? _c('div', {
      staticClass: "text-left"
    }, [_c('h5', {
      staticClass: "p-l-10"
    }, [_vm._v(_vm._s(adjust.name) + "\n            "), _c('button', {
      staticClass: "pull-right btn btn-default text-15 btn-add-product btn-success",
      staticStyle: {
        "top": "-12px"
      },
      on: {
        "click": function($event) {
          return _vm.choseOption(adjust, true)
        }
      }
    }, [_vm._v("全選")]), _vm._v(" "), _c('button', {
      staticClass: "pull-right btn btn-default text-15 btn-add-product btn-danger m-r-10",
      staticStyle: {
        "top": "-12px"
      },
      on: {
        "click": function($event) {
          return _vm.choseOption(adjust, false)
        }
      }
    }, [_vm._v("全取消")])]), _vm._v(" "), _vm._l((adjust.child_list), function(option) {
      return _c('button', {
        staticClass: "btn btn-default btn-choose-element",
        class: {
          active: option.active
        },
        on: {
          "click": function($event) {
            return _vm.clickElement(option, adjust)
          }
        }
      }, [_vm._v("\n            " + _vm._s(option.name)), _c('br'), _vm._v(" "), _c('div', {
        staticClass: "text-remark"
      }, [_c('small', [_vm._v(" " + _vm._s(option.remark) + " ")])])])
    })], 2) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(!_vm.hideCancel) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          確定\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 2530 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('ad-form', {
    attrs: {
      "info": _vm.info
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2531 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vfc-months-container"
  }, [_c('div', {
    staticClass: "vfc-content vfc-content-MY-picker"
  }, [_c('div', {
    staticClass: "vfc-navigation-buttons"
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.changePicker('left')
      }
    }
  }, [_c('div', {
    staticClass: "vfc-arrow-left"
  })]), _vm._v(" "), _c('h2', {
    class: ['vfc-top-date', _vm.delta !== 0 && 'vfc-top-date-has-delta'],
    on: {
      "click": function($event) {
        _vm.delta = 0
      }
    }
  }, [_c('span', {
    staticClass: "vfc-popover-caret"
  }), _vm._v("\n        " + _vm._s(_vm.$parent.listCalendars[_vm.calendarKey].date.getFullYear()) + "\n      ")]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        return _vm.changePicker('right')
      }
    }
  }, [_c('div', {
    staticClass: "vfc-arrow-right"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "vfc-months"
  }, [(_vm.$parent.showMonthPicker) ? _vm._l((_vm.$parent.fConfigs.shortMonthNames), function(month, key) {
    return _c('div', {
      key: key,
      staticClass: "vfc-item",
      class: {
        'vfc-selected':
        _vm.$parent.listCalendars[_vm.calendarKey].date.getMonth() === key
      },
      on: {
        "click": function($event) {
          return _vm.$parent.pickMonth(key, _vm.calendarKey)
        }
      }
    }, [_vm._v("\n          " + _vm._s(month) + "\n        ")])
  }) : (_vm.$parent.showYearPicker) ? _vm._l((_vm.$parent.getYearList(
    _vm.$parent.listCalendars[_vm.calendarKey].date,
    _vm.delta
  )), function(year, key) {
    return _c('div', {
      key: key,
      staticClass: "vfc-item",
      class: {
        'vfc-selected':
        _vm.$parent.listCalendars[_vm.calendarKey].date.getFullYear() ===
          year.year
      },
      on: {
        "click": function($event) {
          return _vm.$parent.pickYear(year.year, _vm.calendarKey)
        }
      }
    }, [_vm._v("\n          " + _vm._s(year.year) + "\n        ")])
  }) : _vm._e()], 2)])])
},staticRenderFns: []}

/***/ }),
/* 2532 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('dis-item-table-history')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2533 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vfc-time-picker-container"
  }, [_c('div', {
    staticClass: "vfc-close",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "vfc-modal-time-mechanic"
  }, [_c('div', {
    staticClass: "vfc-modal-time-line",
    attrs: {
      "id": "time-line"
    }
  }, [_c('span', [(_vm.$parent.fConfigs.isDateRange) ? [_c('span', {
    class: {
      'vfc-active': _vm.startDateActive
    },
    on: {
      "click": function($event) {
        _vm.startDateActive = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$parent.calendar.dateRange.start))]), _vm._v(" "), (_vm.$parent.calendar.dateRange.end) ? [_c('span', [_vm._v("-")]), _vm._v(" "), _c('span', {
    class: {
      'vfc-active': !_vm.startDateActive
    },
    on: {
      "click": function($event) {
        _vm.startDateActive = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$parent.calendar.dateRange.end))])] : _vm._e()] : (_vm.$parent.fConfigs.isMultipleDatePicker) ? [_vm._v(_vm._s(_vm.getCurrentDateTime))] : [_vm._v(_vm._s(_vm.$parent.calendar.selectedDateTime))]], 2)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "vfc-time-picker"
  }, [_c('div', {
    ref: "hourList",
    staticClass: "vfc-time-picker__list vfc-time-picker__list--hours"
  }, _vm._l((24), function(i) {
    return _c('div', {
      key: i,
      staticClass: "vfc-time-picker__item",
      class: {
        'vfc-time-picker__item--selected': _vm.checkHourActiveClass(i)
      },
      on: {
        "click": function($event) {
          _vm.changeHour(_vm.formatTime(i))
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.formatTime(i)) + "\n        ")])
  }), 0), _vm._v(" "), _c('div', {
    ref: "minuteList",
    staticClass: "vfc-time-picker__list vfc-time-picker__list--minutes"
  }, _vm._l((60), function(i) {
    return _c('div', {
      key: i,
      staticClass: "vfc-time-picker__item",
      class: {
        'vfc-time-picker__item--selected': _vm.checkMinuteActiveClass(i)
      },
      on: {
        "click": function($event) {
          _vm.changeMinute(_vm.formatTime(i))
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.formatTime(i)) + "\n        ")])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titles"
  }, [_c('div', [_vm._v("Hour")]), _vm._v(" "), _c('div', [_vm._v("Minute")])])
}]}

/***/ }),
/* 2534 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row m-b-15"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "row fit gutter mx-auto"
  }, [_c('div', {
    staticClass: "col-md-6 gutter"
  }, [_c('div', {
    staticClass: "table-row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "table-from"
  }, [_c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.menuName))])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "table-from"
  }, [(!_vm.$route.query.menu_id) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuId),
      expression: "menuId"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuId = $event.target.value
      }
    }
  }) : _c('div', {
    staticClass: "form-control form-info",
    domProps: {
      "textContent": _vm._s(_vm.menuId)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 gutter"
  }, [_c('div', {
    staticClass: "table-row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "table-from"
  }, [_c('date-picker', {
    staticClass: "hide-date-icon",
    attrs: {
      "show-second": false,
      "type": "datetime",
      "valueType": "format",
      "format": "YYYY-MM-DD HH:mm:ss",
      "input-class": "form-control",
      "clearable": false,
      "disabled-time": _vm.notBeforeTodayAddTwoMins,
      "disabled-date": _vm.notBeforeToday
    },
    model: {
      value: (_vm.menuTime.start.time),
      callback: function($$v) {
        _vm.$set(_vm.menuTime.start, "time", $$v)
      },
      expression: "menuTime.start.time"
    }
  })], 1)]), _vm._v(" "), _c('div', [_vm._v("（更換菜單後請確認已接收預訂單是否受影響。）")])]), _vm._v(" "), (
    this.getRoleType !== 10 &&
    _vm.$route.name !== 'StoreMenuScheduleCreate'
  ) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('nd-multi-select-listbox', {
    attrs: {
      "brandId": _vm.brandId,
      "getDataH": _vm.getDataH,
      "storeId": _vm.storeId,
      "type": 1
    },
    on: {
      "update:choose": _vm.updateChoose
    }
  })], 1) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n              取消\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.crSchedule
    }
  }, [_vm._v("\n              新增\n            ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_c('span', [_vm._v("菜單名稱")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_c('span', [_vm._v("菜單ID")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("上架時間\n                        ")])
}]}

/***/ }),
/* 2535 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("1")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('td', [_vm._v("\n              Nidin\n            ")]), _vm._v(" "), _c('td', [_c('router-link', {
    attrs: {
      "to": "/platformAdTable"
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_c('i', {
    staticClass: "fa fa-file-image-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("平台")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("名稱")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("廣告")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('img', {
    staticClass: "img-brand-table",
    attrs: {
      "src": "/static/img/nidin_logo.png"
    }
  })])
}]}

/***/ }),
/* 2536 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_c('div', {
    staticClass: "inline-block pull-left"
  }, [_c('label', {
    staticClass: "c-pointer btn btn-default",
    attrs: {
      "for": 'file-upload-' + _vm.index + '-' + _vm.type
    }
  }, [(_vm.image) ? _c('div', {
    staticClass: "inline-block",
    staticStyle: {
      "line-height": "50px"
    }
  }, [(_vm.image) ? _c('img', {
    staticClass: "h-auto img-responsive inline-block",
    attrs: {
      "src": _vm.image,
      "id": 'img-load' + _vm.index + '-' + _vm.type
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.image && _vm.type === 1) ? _c('i', {
    staticClass: "fa fa-picture-o inline-block",
    staticStyle: {
      "font-size": "50px"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.image && _vm.type === 2) ? _c('i', {
    staticClass: "fa fa-picture-o inline-block",
    staticStyle: {
      "font-size": "98px"
    }
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": 'file-upload-' + _vm.index + '-' + _vm.type,
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": 'myModal-' + _vm.index + '-' + _vm.type,
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), (_vm.type === 1) ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("小圖")]) : _vm._e(), _vm._v(" "), (_vm.type === 2) ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("小圖")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.image
    }
  })]), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("返回")])])
}]}

/***/ }),
/* 2537 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "warning-block"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n    週報表模組已搬至「\n    "), _c('a', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.goto
    }
  }, [_vm._v("報表中心 > 報表下載區 > 定期報表")]), _vm._v("\n    」，請至新後台管理系統操作、檢視相關內容，此區域(舊後台)功能即將關閉。\n  ")]), _vm._v(" "), (_vm.roleType === 99 || _vm.roleType === 30) ? _c('w-chart-share') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 2538 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title",
    on: {
      "click": function($event) {
        return _vm.toggleModal('cr')
      }
    }
  }, [_vm._v("新增綁定")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.managerSelect),
      expression: "managerSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.managerSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.getNewList(_vm.managerSelect)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("此帳號管理者")]), _vm._v(" "), _vm._l((_vm.managerList), function(manager) {
    return _c('option', {
      domProps: {
        "value": manager.manager_id
      }
    }, [_vm._v("\n            " + _vm._s(manager.name) + "\n          ")])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.notifyList), function(notify, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_c('span', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(notify.notify_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.notifyMethodName(notify.notify_method)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(notify.alias_name) + " (" + _vm._s(notify.manager_id) + ")")]), _vm._v(" "), _c('td', [(notify.toggle) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("正常")]) : _vm._e(), _vm._v(" "), (!notify.toggle) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("停用")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(notify.update_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(notify.create_time))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#delModal"
      },
      on: {
        "click": function($event) {
          return _vm.getCurrent(notify.manager_id, notify.alias_name, notify.notify_id, notify.notify_method)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          return _vm.storeCombine(notify.manager_id)
        }
      }
    }, [_vm._v("綁定門市")])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#sendMsgModal"
      },
      on: {
        "click": function($event) {
          return _vm.getCurrent(notify.manager_id, notify.alias_name, notify.notify_id, notify.notify_method)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-comment",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          return _vm.toggleModal('up', notify)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [(_vm.pageAmount > 1 && _vm.pageGroup !== 1) ? _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        _vm.pageGroup = _vm.pageGroup - 1
      }
    }
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pageAmount), function(index) {
    return (_vm.pageShow(index)) ? _c('li', {
      staticClass: "paginate_button",
      class: {
        active: _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          return _vm.getNotifyBindingList(index)
        }
      }
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v(_vm._s(index))])]) : _vm._e()
  }), _vm._v(" "), (_vm.pageAmount > 1 && _vm.pageAmount / _vm.groupAmount > _vm.pageGroup) ? _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        _vm.pageGroup = _vm.pageGroup + 1
      }
    }
  }, [_vm._m(2)]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "addNotifyModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "box-body form p-x-0"
  }, [_c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lineUserName),
      expression: "lineUserName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.lineUserName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lineUserName = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.show.cr) ? _c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toggleSelect),
      expression: "toggleSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.toggleSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("啟用")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("停用")])]), _vm._v(" "), _c('br')]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("取消")]), _vm._v(" "), (_vm.show.cr) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.checkInput('cr')
      }
    }
  }, [_vm._v("新增")]) : _vm._e(), _vm._v(" "), (!_vm.show.cr) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.checkInput('up')
      }
    }
  }, [_vm._v("修改")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "addStoreNotifyModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "box-body form p-x-0"
  }, [_c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.cr),
      expression: "show.cr"
    }],
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.binding.brandSelect),
      expression: "binding.brandSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.binding, "brandSelect", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.binding.brandBrief), function(brand) {
    return _c('option', {
      domProps: {
        "value": brand.value
      }
    }, [_vm._v("\n                    " + _vm._s(brand.label) + "\n                  ")])
  }), 0), _vm._v(" "), _c('br')]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.cr),
      expression: "show.cr"
    }]
  }, [_vm._m(9), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.cr),
      expression: "show.cr"
    }],
    staticClass: "input-group"
  }, [_vm._m(10), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.binding.storeSelect),
      expression: "binding.storeSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.binding, "storeSelect", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.binding.storeBrief), function(store) {
    return _c('option', {
      domProps: {
        "value": store.value
      }
    }, [_vm._v("\n                    " + _vm._s(store.label) + "\n                  ")])
  }), 0), _vm._v(" "), _c('br')]), _vm._v(" "), _vm._m(11), _vm._v(" "), (!_vm.show.cr) ? _c('div', {
    staticClass: "input-group"
  }, [_vm._m(12), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toggleSelect),
      expression: "toggleSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.toggleSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("啟用")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("停用")])]), _vm._v(" "), _c('br')]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("取消")]), _vm._v(" "), (_vm.show.cr) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.crStoreCombine
    }
  }, [_vm._v("新增")]) : _vm._e()])])])]), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.sendMsgOption
    },
    on: {
      "trigger": _vm.trigger,
      "inputOnChange": _vm.inputOnChange
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("綁定ID")]), _vm._v(" "), _c('th', [_vm._v("通知方式")]), _vm._v(" "), _c('th', [_vm._v("系統稱呼 (ID)")]), _vm._v(" "), _c('th', [_vm._v("啟用")]), _vm._v(" "), _c('th', [_vm._v("更新時間")]), _vm._v(" "), _c('th', [_vm._v("建立時間")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("綁定LINE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("系統稱呼")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "text-red text-15"
  }, [_vm._v("(目前一組Line帳號只可綁定一組後台帳號)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("啟用")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("門市綁定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("品牌")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "hidden-xs hidden-sm"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("店家")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', {
    staticClass: "hidden-xs hidden-sm"
  }, [_c('br')]), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("啟用")])
}]}

/***/ }),
/* 2539 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "warning-block"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n    月報表模組已搬至「\n    "), _c('a', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.goto
    }
  }, [_vm._v("報表中心 > 報表下載區 > 定期報表")]), _vm._v("\n    」，請至新後台管理系統操作、檢視相關內容，此區域(舊後台)功能即將關閉。\n  ")]), _vm._v(" "), (_vm.roleType === 99 || _vm.roleType === 30) ? _c('chart-share') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 2540 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0"
  }, [_c('span', {
    staticClass: "inline-block h-auto m-t-5"
  }, [(!_vm.image && (_vm.type == 1 || _vm.type == 2)) ? _c('div', {
    staticClass: "text-black",
    domProps: {
      "textContent": _vm._s('沒有圖片')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.image) ? _c('img', {
    staticClass: "h-auto img-responsive",
    attrs: {
      "src": _vm.image,
      "id": 'img-load' + _vm.index + '-' + _vm.type,
      "data-toggle": "modal",
      "data-target": '#myModal-' + _vm.index + '-' + _vm.type
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [_c('label', {
    staticClass: "btn-upload btn btn-default",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "for": 'file-upload-' + _vm.index + '-' + _vm.type
    }
  }, [_vm._v("\n      選擇圖片\n    ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": 'file-upload-' + _vm.index + '-' + _vm.type,
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": 'myModal-' + _vm.index + '-' + _vm.type,
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.image
    }
  })]), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("廣告")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("返回")])])
}]}

/***/ }),
/* 2541 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "warning-block"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n    黑名單管理功能已搬至「\n    "), _c('a', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.goto
    }
  }, [_vm._v("訂單管理 > 黑名單")]), _vm._v("\n    」，請至新後台管理系統操作、檢視相關內容，此區域(舊後台)功能即將關閉。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('order-table')], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 2542 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-body form-left p-l-10 p-r-10-p"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            店家名稱(ID)\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n            " + _vm._s(_vm.storeInfo.name) + " (" + _vm._s(_vm.storeInfo.id) + ")\n          ")])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right p-l-10 p-r-10-p"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            電話\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n            " + _vm._s(_vm.storeInfo.tel) + "\n          ")])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.mqttList), function(mqtt, index) {
    return _c('tr', {
      staticClass: "even td-status",
      attrs: {
        "role": "row",
        "status": mqtt.status
      }
    }, [_c('td', [_vm._v("\n            " + _vm._s(_vm.getTime(mqtt.create_time)) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(mqtt.client_id))]), _vm._v(" "), _c('td', [(mqtt.status === 1) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("建立")]) : _vm._e(), _vm._v(" "), (mqtt.status === 2) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("中斷")]) : _vm._e()])])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("連線ID")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("連線狀態")])])])
}]}

/***/ }),
/* 2543 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vfc-day vfc-week-number",
    style: ({
      borderRightColor: _vm.borderColor
    })
  }, [_c('span', {
    staticClass: "vfc-span-day"
  }, [_vm._v(_vm._s(_vm.number))])])
},staticRenderFns: []}

/***/ }),
/* 2544 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', {
    staticClass: "col-xs-12 m-b-10"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'brandMenuTable',
        params: {
          brand_id: _vm.$route.params.brand_id
        }
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default"
  }, [_vm._v("\n          返回菜單建置\n        ")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#blackModal"
    },
    domProps: {
      "textContent": _vm._s('黑名單設定')
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'MenuSettingRuleStoreCopyLogsView'
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title",
    domProps: {
      "textContent": _vm._s('操作歷程')
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [(_vm.setting.blacklist) ? _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "w-xs"
  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
    staticClass: "w-sm"
  }, [_vm._v("白名單")]), _vm._v(" "), _c('td', {
    staticClass: "w-auto",
    domProps: {
      "textContent": _vm._s(_vm.whitelist)
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w-xs"
  }, [_vm._v("2")]), _vm._v(" "), _c('td', {
    staticClass: "w-sm"
  }, [_vm._v("黑名單")]), _vm._v(" "), _c('td', {
    staticClass: "w-auto",
    domProps: {
      "textContent": _vm._s(_vm.blacklist)
    }
  })])])]) : _vm._e()])])])])])])]), _vm._v(" "), _c('nd-modal', {
    attrs: {
      "option": _vm.black.option
    },
    on: {
      "trigger": _vm.trigger
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function() {
        return [_c('div', [_c('div', {
          staticClass: "mb-2"
        }, [_vm._v("請選擇要新增或編輯至黑名單的門市，可複選")]), _vm._v(" "), _c('multiselect', {
          attrs: {
            "tag-placeholder": "請輸入或選擇門市",
            "placeholder": "請輸入或選擇門市",
            "label": "name",
            "track-by": "id",
            "options": _vm.setting.whitelist,
            "multiple": true
          },
          model: {
            value: (_vm.black.temp),
            callback: function($$v) {
              _vm.$set(_vm.black, "temp", $$v)
            },
            expression: "black.temp"
          }
        })], 1)]
      },
      proxy: true
    }])
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "font-size-subtitle-2 font-weight-regular"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("白名單：名單內的門市當進行配料庫複製時「可」被覆寫，菜單上架時「可」被複寫")])]), _vm._v(" "), _c('div', {
    staticClass: "font-size-subtitle-2 font-weight-regular"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("黑名單：名單內的門市當進行配料庫複製時「不可」被覆寫，菜單上架時「不可」被複寫")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("設定")]), _vm._v(" "), _c('th', [_vm._v("門市")])])])
}]}

/***/ }),
/* 2545 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.modalId,
    staticClass: "modal fade",
    attrs: {
      "id": _vm.modalId,
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header text-left"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n          " + _vm._s(_vm.modalState) + "  \n          "), (_vm.state == 3 && !_vm.editState && _vm.adjustInfo.is_mandatory) ? _c('label', {
    staticClass: "badge bg-red"
  }, [_vm._v("必選")]) : _vm._e(), _vm._v(" "), (_vm.state == 3 && !_vm.editState && _vm.adjustInfo.is_common) ? _c('label', {
    staticClass: "badge bg-blue"
  }, [_vm._v("常見")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-right": "10px"
    }
  }, [(_vm.editState) ? _c('button', {
    staticClass: "btn btn-danger icon-modal-del",
    on: {
      "click": function($event) {
        _vm.show.delNotify = !_vm.show.delNotify
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.editState && _vm.state == 3) ? _c('button', {
    staticClass: "btn btn-primary icon-modal-edit",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.editState = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.editState) ? _c('button', {
    staticClass: "btn btn-primary icon-modal-edit",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.editState = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.show.delNotify) ? _c('div', {
    staticClass: "del-c-block"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.show.delNotify = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.delAdjust
    }
  }, [_vm._v("刪除")])])])])]) : _vm._e()]), _vm._v(" "), (_vm.state == 3 && !_vm.editState) ? _c('div', {
    staticClass: "box-body form"
  }, [_c('div', [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("分類")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.getSubType(_vm.adjustInfo.sub_type)))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("調整類別名稱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.adjustInfo.name))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("排序")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.adjustInfo.sort))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("選擇項目個數")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.adjustInfo.min_limit) + " ～ " + _vm._s(_vm.maxAmount(_vm.adjustInfo.max_limit)))])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.adjustInfo.price) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("價格")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.adjustInfo.price) + " (" + _vm._s(_vm.getPriceType(_vm.adjustInfo.price_type)) + ")")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.adjustInfo.calorie) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("熱量")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.adjustInfo.calorie) + " cal")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.adjustInfo.description) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("描述")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.adjustInfo.description))])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.adjustInfo.remark) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("備註")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.adjustInfo.remark))])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.adjustInfo.adjust_custom_id) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("POS廠自定義的ID")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.adjustInfo.adjust_custom_id))])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("調整類別更新時間")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.adjustInfo.update_time))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("調整類別建立時間")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.adjustInfo.create_time))])]), _vm._v(" "), _c('br')])]) : _vm._e(), _vm._v(" "), (_vm.state == 1 || _vm.editState) ? _c('div', {
    staticClass: "box-body form"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.sub_type),
      expression: "adjustInfo.sub_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.adjustInfo, "sub_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("大小")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("容器")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v("甜度")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "40"
    }
  }, [_vm._v("溫度")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("其他")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.name),
      expression: "adjustInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "32"
    },
    domProps: {
      "value": (_vm.adjustInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), (_vm.state == 1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.sort),
      expression: "adjustInfo.sort"
    }],
    ref: "sort1",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.adjustInfo.sort)
    },
    on: {
      "keyup": _vm.veritySort,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "sort", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.state == 3) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.sort),
      expression: "adjustInfo.sort"
    }],
    ref: "sort3",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.adjustInfo.sort)
    },
    on: {
      "keyup": _vm.veritySort,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "sort", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "radio text-left h-38",
    staticStyle: {
      "border-left": "1px solid #d2d6de"
    }
  }, [_c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.is_mandatory),
      expression: "adjustInfo.is_mandatory"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "mandatoryRadio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.adjustInfo.is_mandatory, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.adjustInfo, "is_mandatory", "1")
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("是")])]), _vm._v(" "), _c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.is_mandatory),
      expression: "adjustInfo.is_mandatory"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "mandatoryRadio",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.adjustInfo.is_mandatory, "0")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.adjustInfo, "is_mandatory", "0")
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("否")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "radio text-left h-38",
    staticStyle: {
      "border-left": "1px solid #d2d6de"
    }
  }, [_c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.is_common),
      expression: "adjustInfo.is_common"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "commonRadio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.adjustInfo.is_common, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.adjustInfo, "is_common", "1")
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("是")])]), _vm._v(" "), _c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.is_common),
      expression: "adjustInfo.is_common"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "commonRadio",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.adjustInfo.is_common, "0")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.adjustInfo, "is_common", "0")
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("否")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), (_vm.state == 1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.min_limit),
      expression: "adjustInfo.min_limit"
    }],
    ref: "minLimit1",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.adjustInfo.min_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityMinLimit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "min_limit", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.state == 3) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.min_limit),
      expression: "adjustInfo.min_limit"
    }],
    ref: "minLimit3",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.adjustInfo.min_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityMinLimit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "min_limit", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(9), _vm._v(" "), (_vm.state == 1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.max_limit),
      expression: "adjustInfo.max_limit"
    }],
    ref: "maxLimit1",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.adjustInfo.max_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityMaxLimit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "max_limit", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.state == 3) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.max_limit),
      expression: "adjustInfo.max_limit"
    }],
    ref: "maxLimit3",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.adjustInfo.max_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityMaxLimit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "max_limit", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("價格")]), _vm._v(" "), (_vm.state == 1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.price),
      expression: "adjustInfo.price"
    }],
    ref: "price1",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.adjustInfo.price)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityPrice()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "price", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.state == 3) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.price),
      expression: "adjustInfo.price"
    }],
    ref: "price3",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.adjustInfo.price)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityPrice()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "price", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("(調整類別內的選項皆為此價格)")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("價格類型")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.price_type),
      expression: "adjustInfo.price_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.adjustInfo, "price_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("免稅價格")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("含稅價格")])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("(若無價格則無須更動)")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("熱量")]), _vm._v(" "), (_vm.state == 1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.calorie),
      expression: "adjustInfo.calorie"
    }],
    ref: "calorie1",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.adjustInfo.calorie)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityCalorie()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "calorie", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.state == 3) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.calorie),
      expression: "adjustInfo.calorie"
    }],
    ref: "calorie3",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.adjustInfo.calorie)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityCalorie()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "calorie", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("(調整類別內的選項皆為此熱量)")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("描述")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.description),
      expression: "adjustInfo.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.adjustInfo.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("備註")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.remark),
      expression: "adjustInfo.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.adjustInfo.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("POS廠自定義的ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.adjust_custom_id),
      expression: "adjustInfo.adjust_custom_id"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.adjustInfo.adjust_custom_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "adjust_custom_id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])]) : _vm._e()]), _vm._v(" "), (_vm.state != 3 || _vm.editState) ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.state == 1) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.checkInputEmpty()
      }
    }
  }, [_vm._v("新增")]) : _vm._e(), _vm._v(" "), (_vm.editState) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.checkInputEmpty()
      }
    }
  }, [_vm._v("編輯")]) : _vm._e()]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header text-left"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("提醒")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body text-left"
  }, [_c('p', [_vm._v("確定刪除此調整類別？")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("分類")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("調整類別名稱")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("排序")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("必選項目")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("常見價格")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("最低選擇項目個數")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("最高選擇項目個數")])
}]}

/***/ }),
/* 2546 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('cr-combine')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2547 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('discount-form', {
    attrs: {
      "isUp": _vm.isUp
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 2548 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.fConfigs.isModal && _vm.fConfigs.isDateRange) ? _c('div', {
    staticClass: "vfc-multiple-input",
    class: {
      'vfc-dark': _vm.fConfigs.isDark
    }
  }, [_vm._t("dateRangeInputs", function() {
    return [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.dateRangeSelectedStartDate),
        expression: "dateRangeSelectedStartDate"
      }],
      attrs: {
        "type": "text",
        "title": "Start Date",
        "placeholder": _vm.fConfigs.placeholder.split(' ')[0],
        "readonly": !_vm.fConfigs.isTypeable,
        "maxlength": _vm.fConfigs.dateFormat.length
      },
      domProps: {
        "value": (_vm.dateRangeSelectedStartDate)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.dateRangeSelectedStartDate = $event.target.value
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.dateRangeSelectedEndDate),
        expression: "dateRangeSelectedEndDate"
      }],
      attrs: {
        "type": "text",
        "title": "End Date",
        "placeholder": _vm.fConfigs.placeholder.split(' ')[0],
        "readonly": !_vm.fConfigs.isTypeable,
        "maxlength": _vm.fConfigs.dateFormat.length
      },
      domProps: {
        "value": (_vm.dateRangeSelectedEndDate)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.dateRangeSelectedEndDate = $event.target.value
        }
      }
    })]
  }, {
    "startDate": _vm.dateRangeSelectedStartDate,
    "endDate": _vm.dateRangeSelectedEndDate,
    "isTypeable": _vm.fConfigs.isTypeable
  })], 2) : (_vm.fConfigs.isModal && _vm.fConfigs.isDatePicker) ? _c('div', {
    class: {
      'vfc-dark': _vm.fConfigs.isDark
    }
  }, [_vm._t("datePickerInput", function() {
    return [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.singleSelectedDate),
        expression: "singleSelectedDate"
      }],
      staticClass: "vfc-single-input",
      attrs: {
        "type": "text",
        "title": "Date",
        "placeholder": _vm.fConfigs.placeholder,
        "readonly": !_vm.fConfigs.isTypeable,
        "maxlength": _vm.fConfigs.dateFormat.length
      },
      domProps: {
        "value": (_vm.singleSelectedDate)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.singleSelectedDate = $event.target.value
        }
      }
    })]
  }, {
    "selectedDate": _vm.singleSelectedDate,
    "isTypeable": _vm.fConfigs.isTypeable
  })], 2) : (_vm.fConfigs.isModal && _vm.fConfigs.isMultipleDatePicker) ? _c('div', {
    staticClass: "vfc-tags-input-root",
    class: {
      'vfc-dark': _vm.fConfigs.isDark
    }
  }, [_c('div', {
    staticClass: "vfc-tags-input-wrapper-default vfc-tags-input"
  }, [_vm._l((_vm.calendar.selectedDates), function(date, index) {
    return _c('span', {
      key: index,
      staticClass: "vfc-tags-input-badge vfc-tags-input-badge-pill vfc-tags-input-badge-selected-default"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(date.date)
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "vfc-tags-input-remove",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeFromSelectedDates(index)
        }
      }
    })])
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calendar.selectedDatesItem),
      expression: "calendar.selectedDatesItem"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Add a date"
    },
    domProps: {
      "value": (_vm.calendar.selectedDatesItem)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.$parent.addToSelectedDates.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.calendar, "selectedDatesItem", $event.target.value)
      }
    }
  })], 2)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2549 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('lim-prod')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2550 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "warning-block"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n    " + _vm._s(_vm.moveToBdmsConfig.text) + "管理功能已搬至「\n    "), _c('a', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.goto
    }
  }, [_vm._v(_vm._s(_vm.moveToBdmsConfig.linkText))]), _vm._v("\n    」，請至新後台管理系統操作、檢視相關內容，此區域(舊後台)功能即將關閉。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('order-table')], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 2551 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box m-h-700"
  }, [_c('div', {
    staticClass: "box-body form-inline"
  }, [(_vm.brandBrief.length > 1 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandSelect),
      expression: "brandSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.brandSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.brandBrief), function(brand) {
    return _c('option', {
      domProps: {
        "value": brand.value
      }
    }, [_vm._v("\n                " + _vm._s(brand.label) + "\n              ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.brandSelect !== 0 && _vm.brandSelect !== '0' && _vm.storeBrief.length > 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeSelect),
      expression: "storeSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.storeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.storeBrief), function(store) {
    return _c('option', {
      domProps: {
        "value": store.value
      }
    }, [_vm._v("\n                " + _vm._s(store.label) + "\n              ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('table-setting-table', {
    attrs: {
      "storeId": _vm.storeSelect
    }
  })], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 2552 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [(_vm.brandBrief.length > 2 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 品牌 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.brandSelect.value !== 0 && _vm.brandSelect.value !== '0' && _vm.storeBrief.length > 2 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.storeBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 門市 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.typeSelect),
      expression: "typeSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.typeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.typeList), function(type) {
    return _c('option', {
      domProps: {
        "value": type.value
      }
    }, [_vm._v("\n            " + _vm._s(type.label) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchSelect),
      expression: "searchSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("訂單編號")]), _vm._v(" "), (_vm.roleType === 99) ? _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("使用者ID")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchResult),
      expression: "searchResult"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchResult)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchResult = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.getOrderList(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單編號")]), _vm._v(" "), (_vm.roleType === 99) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("品牌(ID)")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99 || _vm.roleType === 30) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("分店(ID)")]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂購者"), (_vm.roleType === 99) ? _c('span', [_vm._v("(ID)")]) : _vm._e()]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("電話")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("取餐")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("總額")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("原因")]), _vm._v(" "), _c('th')])]), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(0)]) : (_vm.orderList.length === 0) ? _c('tbody', [_vm._m(1)]) : (_vm.orderList.length > 0) ? _c('tbody', _vm._l((_vm.orderList), function(order, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/orderInfo/' + order.order_id
        },
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(order.order_sn))])], 1), _vm._v(" "), (_vm.roleType === 99) ? _c('td', [_vm._v(_vm._s(order.brand_name) + "(" + _vm._s(order.brand_id) + ")")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99 || _vm.roleType === 30) ? _c('td', [_vm._v(_vm._s(order.store_name) + "(" + _vm._s(order.store_id) + ")")]) : _vm._e(), _vm._v(" "), _c('td', [(_vm.roleType !== 99 || _vm.$route.name == 'memberOrderTable') ? _c('span', [_vm._v(_vm._s(order.name)), (_vm.roleType === 99) ? _c('span', [_vm._v("(" + _vm._s(order.shopper_id) + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99 && _vm.$route.name !== 'memberOrderTable') ? _c('router-link', {
      attrs: {
        "target": "_blank",
        "to": {
          path: '/memberOrderTable/' + order.shopper_id
        }
      }
    }, [_vm._v(_vm._s(order.name) + "(" + _vm._s(order.shopper_id) + ")")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.phone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("deliveryName")(order.delivery_type)))]), _vm._v(" "), _c('td', [_vm._v("＄" + _vm._s(order.money))]), _vm._v(" "), _c('td', [_c('label', {
      staticClass: "label",
      class: _vm.statusColor(order.score_status)
    }, [_vm._v(_vm._s(_vm.scoreStatusName(order.score_status)))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.reason))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#scoreModal"
      },
      on: {
        "click": function($event) {
          return _vm.getCurrentId(order.score_id, order.score_status)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('paginate', {
    ref: "orderPaginate",
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.scoreOption,
      "selectOptions": _vm.selectOptions,
      "selectDefault": _vm.order.scoreStatus
    },
    on: {
      "trigger": _vm.trigger,
      "selectOnChange": _vm.selectOnChange
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
}]}

/***/ }),
/* 2553 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('ad-form')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2554 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('platform-table')], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 2555 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "warning-block"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n    現折活動模組已搬至「\n    "), _c('a', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.goto
    }
  }, [_vm._v("新後台管理系統 > 行銷活動管理 > 現折活動管理")]), _vm._v("\n    」，請至新後台管理系統操作、檢視相關內容，此區域(舊後台)功能即將關閉。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box m-h-700"
  }, [_c('div', {
    staticClass: "box-body form-inline"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.brandBrief.length > 1 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 品牌 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    on: {
      "input": _vm.getAttendDiscount
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.brandSelect !== 999999 && _vm.brandSelect !== '999999' && _vm.storeBrief.length > 2) ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.storeBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 門市 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    on: {
      "input": _vm.getAttendDiscount
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruleCodeSelect),
      expression: "ruleCodeSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ruleCodeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getAttendDiscount]
    }
  }, [_c('option', {
    domProps: {
      "value": 999999
    }
  }, [_vm._v("== 折扣規則 ==")]), _vm._v(" "), _vm._l((_vm.ruleCode), function(item) {
    return _c('option', {
      domProps: {
        "value": item.rule_code
      }
    }, [_vm._v("\n                " + _vm._s(item.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeMethodSelect),
      expression: "timeMethodSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.timeMethodSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getAttendDiscount]
    }
  }, [_c('option', {
    domProps: {
      "value": 999999
    }
  }, [_vm._v("== 狀態 ==")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "notyet"
    }
  }, [_vm._v("未開始")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "going"
    }
  }, [_vm._v("進行中")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "end"
    }
  }, [_vm._v("已結束")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isEnableSelect),
      expression: "isEnableSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isEnableSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getAttendDiscount]
    }
  }, [_c('option', {
    domProps: {
      "value": 999999
    }
  }, [_vm._v("== 啟用狀態 ==")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("啟用")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未啟用")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('id')
      }
    }
  }, [_vm._v("折扣活動 (ID)\n                    "), (_vm.sortMethod === 'id') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("折扣規則 (代碼)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("啟用")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("擁有者")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('start_date')
      }
    }
  }, [_vm._v("活動開始\n                    "), (_vm.sortMethod === 'start_date') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('end_date')
      }
    }
  }, [_vm._v("活動結束\n                    "), (_vm.sortMethod === 'end_date') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("你訂平台")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("街口平台")])])]), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(2)]) : (_vm.discountList.length === 0) ? _c('tbody', [_vm._m(3)]) : (_vm.discountList.length > 0) ? _c('tbody', _vm._l((_vm.discountList), function(discount, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [(_vm.canEdit(discount)) ? _c('router-link', {
      attrs: {
        "to": '/discountInfo/' + discount.activity_id
      }
    }, [_vm._v("\n                        " + _vm._s(discount.name) + " (" + _vm._s(discount.activity_id) + ")\n                      ")]) : _c('div', [_vm._v(_vm._s(discount.name) + " (" + _vm._s(discount.activity_id) + ")")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(discount.rule_name) + " (" + _vm._s(discount.rule_code) + ")")]), _vm._v(" "), _c('td', [(discount.time_method === 'notyet') ? _c('label', {
      staticClass: "label label-default"
    }, [_vm._v("未開始")]) : (discount.time_method === 'going') ? _c('label', {
      staticClass: "label label-success"
    }, [_vm._v("進行中")]) : (discount.time_method === 'end') ? _c('label', {
      staticClass: "label label-danger"
    }, [_vm._v("已結束")]) : _vm._e()]), _vm._v(" "), _c('td', [(discount.is_enable === 1) ? _c('label', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _c('label', {
      staticClass: "label label-danger"
    }, [_vm._v("未啟用")])]), _vm._v(" "), _c('td', [(discount.owner_type === 1) ? _c('span', [_vm._v("平台")]) : _vm._e(), _vm._v(" "), (discount.owner_type === 2) ? _c('span', [_vm._v(_vm._s(discount.owner_brand_name) + " (" + _vm._s(discount.owner_id) + ")")]) : _vm._e(), _vm._v(" "), (discount.owner_type === 3) ? _c('span', [_vm._v(_vm._s(discount.owner_brand_name) + " - " + _vm._s(discount.owner_store_name) + " (" + _vm._s(discount.owner_id) + ")")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(discount.start_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(discount.end_date))]), _vm._v(" "), _c('td', [(discount.is_platform_visible === 1) ? _c('label', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _c('label', {
      staticClass: "label label-danger"
    }, [_vm._v("未啟用")])]), _vm._v(" "), _c('td', [(discount.dedicated_visible_setting[0] === 1) ? _c('label', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _c('label', {
      staticClass: "label label-danger"
    }, [_vm._v("未啟用")])])])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('paginate', {
    ref: "orderPaginate",
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "storesModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\"" + _vm._s(_vm.current.name) + "\"使用門市")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 p-x-0"
  }, _vm._l((_vm.current.store_list), function(store) {
    return _c('label', {
      staticClass: "label label-primary",
      staticStyle: {
        "margin-right": "5px"
      }
    }, [_vm._v(_vm._s(store.name))])
  }), 0)])]), _vm._v(" "), _vm._m(4)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title disabled"
  }, [_vm._v("新增折扣活動")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title disabled"
  }, [_vm._v("管理活動列表")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("確定")])])
}]}

/***/ }),
/* 2556 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-10 flex align-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.goBackInfo.name,
        params: _vm.goBackInfo.params,
        query: _vm.goBackInfo.query
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default m-r-5 flex"
  }, [_c('span', [_vm._v("返回")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.title)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.subtitle)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex grey darken-1"
  }, [(_vm.brand.name || _vm.store.brand_name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s(_vm.brand.name ? _vm.brand.name : _vm.store.brand_name ? _vm.store.brand_name : '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s('/')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.store.name)
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('cr-package')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2557 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [(_vm.brandBrief.length > 2 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "==品牌==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value",
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        return _vm.queryChange($event, 'brand_id')
      }
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.brandSelect.value !== 0 && _vm.brandSelect.value !== '0' && _vm.storeBrief.length > 2 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.storeBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "==品牌==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value",
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        return _vm.queryChange($event, 'store_id')
      }
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deTypeSelect),
      expression: "deTypeSelect"
    }],
    staticClass: "form-control h-38",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        return _vm.queryChange($event, 'delivery_type')
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.deTypeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.deliveryTypeList), function(item) {
    return _c('option', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((item.value !== 21) || (item.value === 21 && _vm.$route.name !== 'onSiteOrderTable')),
        expression: "(item.value !== 21) || (item.value === 21 && $route.name !== 'onSiteOrderTable')"
      }],
      key: item.value,
      domProps: {
        "value": item.value,
        "textContent": _vm._s(item.label)
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelect),
      expression: "statusSelect"
    }],
    staticClass: "form-control h-38",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        return _vm.queryChange($event, 'status')
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.statusSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.statusList), function(status) {
    return _c('option', {
      domProps: {
        "value": status.value,
        "textContent": _vm._s(status.label)
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trTypeSelect),
      expression: "trTypeSelect"
    }],
    staticClass: "form-control h-38",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        return _vm.queryChange($event, 'trade_type')
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.trTypeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.getTradeType), function(trade) {
    return _c('option', {
      domProps: {
        "value": trade.value,
        "textContent": _vm._s(trade.label)
      }
    })
  }), 0)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchSelect),
      expression: "searchSelect"
    }],
    staticClass: "form-control h-38",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        return _vm.queryChange($event, 'search_select')
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("時間")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("訂單編號")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("訂購者")]), _vm._v(" "), (!_vm.isGuestTab) ? _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("最低跟團人數")]) : _vm._e()])]), _vm._v(" "), (_vm.searchSelect == 1) ? _c('div', {
    staticClass: "form-group input-group time-box"
  }, [(!_vm.isLoading) ? _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "enabled": _vm.isLoading,
      "option": _vm.dateoption,
      "limit": _vm.startLimit
    },
    on: {
      "change": function($event) {
        return _vm.queryChange($event, 'start_time')
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuTime.start.time),
      expression: "menuTime.start.time"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "",
      "placeholder": "起始時間"
    },
    domProps: {
      "value": (_vm.menuTime.start.time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.menuTime.start, "time", $event.target.value)
      }
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.dateoption,
      "limit": _vm.endLimit
    },
    on: {
      "change": function($event) {
        return _vm.queryChange($event, 'end_time')
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuTime.end.time),
      expression: "menuTime.end.time"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "",
      "placeholder": "結束時間"
    },
    domProps: {
      "value": (_vm.menuTime.end.time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.menuTime.end, "time", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default submit-btn btn-search",
    staticStyle: {
      "height": "72px"
    },
    attrs: {
      "disabled": _vm.isLoading,
      "type": "button",
      "id": "search"
    },
    on: {
      "click": function($event) {
        return _vm.search(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])], 1) : _vm._e(), _vm._v(" "), (_vm.searchSelect == 2) ? _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderSn),
      expression: "orderSn"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isLoading,
      "type": "text"
    },
    domProps: {
      "value": (_vm.orderSn)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.orderSn = $event.target.value
      }, function($event) {
        return _vm.queryChange($event, 'order_sn')
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.search(2)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.searchSelect == 3) ? _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shopper),
      expression: "shopper"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isLoading,
      "type": "text"
    },
    domProps: {
      "value": (_vm.shopper)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.shopper = $event.target.value
      }, function($event) {
        return _vm.queryChange($event, 'shopper_name')
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.search(3)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.searchSelect == 4) ? _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subOrderAmount),
      expression: "subOrderAmount"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isLoading,
      "type": "text"
    },
    domProps: {
      "value": (_vm.subOrderAmount)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.subOrderAmount = $event.target.value
      }, function($event) {
        return _vm.queryChange($event, 'sub_order_amount')
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.search(4)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]) : _vm._e()])]), _vm._v(" "), (_vm.isOnline) ? _c('div', {
    staticStyle: {
      "height": "35px"
    }
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      active: _vm.typeSelect === 99
    },
    attrs: {
      "role": "presentation"
    }
  }, [(!_vm.isLoading) ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.typeSelect = 99
      }
    }
  }, [_vm._v("全部\n          ")]) : _c('a', {
    staticClass: "filter-load"
  }, [_vm._v("全部")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.typeSelect === 1
    },
    attrs: {
      "disabled": _vm.isLoading,
      "role": "presentation"
    }
  }, [(!_vm.isLoading) ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.typeSelect = 1
      }
    }
  }, [_vm._v("一般單\n          ")]) : _c('a', {
    staticClass: "filter-load"
  }, [_vm._v("一般單")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.typeSelect === 2
    },
    attrs: {
      "disabled": _vm.isLoading,
      "role": "presentation"
    }
  }, [(!_vm.isLoading) ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.typeSelect = 2
      }
    }
  }, [_vm._v("團購單\n          ")]) : _c('a', {
    staticClass: "filter-load"
  }, [_vm._v("團購單")])])])])]) : _c('div', {
    staticStyle: {
      "height": "35px"
    }
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      active: _vm.$route.name === 'onSiteOrderMemberTable'
    },
    attrs: {
      "disabled": _vm.isLoading,
      "role": "presentation"
    }
  }, [_c('router-link', {
    attrs: {
      "replace": "",
      "to": {
        path: '/onSiteOrderTable/member',
        query: _vm.$route.query
      }
    }
  }, [_vm._v("會員單")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.$route.name === 'onSiteOrderGuestTable'
    },
    attrs: {
      "disabled": _vm.isLoading,
      "role": "presentation"
    }
  }, [_c('router-link', {
    attrs: {
      "replace": "",
      "to": {
        path: '/onSiteOrderTable/guest',
        query: _vm.$route.query
      }
    }
  }, [_vm._v("訪客單")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "download-block"
  }, [_c('div', [_vm._v("每個檔案最多" + _vm._s(this.exportMaxLimit) + "筆資料，超過上限會分成數個檔案下載。"), _c('span', {
    staticClass: "text-bold"
  }, [_vm._v("（ 目前資料筆數：" + _vm._s(this.total) + " ）")])]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_c('button', {
    staticClass: "btn btn-default btn-table-title z-100",
    attrs: {
      "disabled": _vm.isDownloading || _vm.isLoading
    },
    on: {
      "click": _vm.exportFile
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v("下載報表\n          "), _c('Clip', {
    staticClass: "cliploading",
    attrs: {
      "loading": _vm.isDownloading,
      "color": '#528BB8',
      "size": '16px'
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0 p-b-20"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [(_vm.isGuestTab) ? _c('span', [_vm._v("POS機")]) : _vm._e(), _vm._v("訂單編號")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單類型")]), _vm._v(" "), (_vm.roleType === 99) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("品牌(ID)")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99 || _vm.roleType === 30) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("分店(ID)")]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂購人"), (_vm.isGuestTab) ? _c('span', [_vm._v("姓名")]) : (_vm.roleType === 99) ? _c('span', [_vm._v("(ID)")]) : _vm._e()]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("總數")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("實付金額")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("付款狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v(_vm._s(_vm.isGuestTab ? '訂單建立時間' : '下訂時間'))]), _vm._v(" "), (_vm.isOnline) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("\n            追蹤碼\n            "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(0)], 1)]) : _vm._e()])]), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(1)]) : (!_vm.isLoading && _vm.orderList.length > 0) ? _c('tbody', _vm._l((_vm.orderList), function(order, index) {
    return _c('tr', {
      staticClass: "even",
      class: {
        'bg-pre-order': order.order_method === 2
      },
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), (!_vm.isGuestTab) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: _vm.isOffline ? '/onSiteOrderTableInfo/' + order.order_id : '/orderInfo/' + order.order_id
        },
        "target": "_blank"
      }
    }, [_vm._v("\n              " + _vm._s(order.order_sn) + "\n            ")]), _vm._v(" \n            ")], 1) : _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/onSiteOrderTableInfo/' + order.shipping_case_id + '?is_guest=1'
        },
        "target": "_blank"
      }
    }, [_vm._v("\n              " + _vm._s(order.pos_order_sn) + "\n            ")]), _vm._v(" \n            ")], 1), _vm._v(" "), _c('td', [_c('label', {
      staticClass: "label",
      class: _vm.orderStateColor(order.status)
    }, [_vm._v(_vm._s(_vm.orderState(order.status)))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "inline-block",
      staticStyle: {
        "width": "22px"
      }
    }, [(order.delivery_type === 1) ? _c('i', {
      staticClass: "fa fa-hand-paper-o",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" "), (order.delivery_type === 2) ? _c('i', {
      staticClass: "fa fa-inbox",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" "), (order.delivery_type === 3) ? _c('i', {
      staticClass: "fa fa-motorcycle",
      class: _vm.shippingStateColor(order.shipping_case_status),
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "mouseover": function($event) {
          return _vm.selectStyle(order)
        },
        "mouseout": function($event) {
          return _vm.outStyle(order)
        }
      }
    }) : _vm._e(), _vm._v(" "), (order.delivery_type === 4) ? _c('i', {
      staticClass: "fa fa-shopping-bag",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" "), (order.delivery_type === 5) ? _c('i', {
      staticClass: "fa fa-glass",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" "), (order.delivery_type === 21) ? _c('i', {
      staticClass: "fa fa-qrcode",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (order.active),
        expression: "order.active"
      }],
      staticClass: "shipping-state-label",
      class: _vm.shippingStateColorBg(order.shipping_case_status)
    }, [_vm._v("\n                " + _vm._s(_vm.shippingState(order.shipping_case_status)) + "\n              ")])]), _vm._v(" \n            "), (order.order_type === 1) ? _c('span', {
      staticClass: "label label-primary"
    }, [_vm._v("一般")]) : _vm._e(), _vm._v(" "), (order.order_type === 2) ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("團購"), (order.sub_order_amount) ? _c('span', [_vm._v(_vm._s(order.sub_order_amount) + "人跟")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (order.src_type === 1) ? _c('span', {
      staticClass: "text-12 text-w-600 label-default",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("P")]) : _vm._e(), _vm._v(" "), (order.src_type === 2) ? _c('span', {
      staticClass: "text-12 text-w-600 label-default",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("D")]) : _vm._e(), _vm._v(" "), (order.src_type === 3) ? _c('span', {
      staticClass: "text-12 text-w-600 label-default",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("PL")]) : _vm._e(), _vm._v(" "), (order.src_type === 4) ? _c('span', {
      staticClass: "text-12 text-w-600 label-warning",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("DL")]) : _vm._e(), _vm._v(" "), (order.src_type === 6) ? _c('span', {
      staticClass: "text-12 text-w-600 label-default",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("A")]) : _vm._e(), _vm._v(" "), (order.sub_src_type === 1) ? _c('span', {
      staticClass: "text-12 text-w-600 label-default",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("W")]) : (order.sub_src_type === 2) ? _c('span', {
      staticClass: "text-12 text-w-600 label-success",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("L")]) : (order.sub_src_type === 3) ? _c('span', {
      staticClass: "text-12 text-w-600 label-primary",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("M")]) : (order.sub_src_type === 4) ? _c('span', {
      staticClass: "text-12 text-w-600 label-success",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("LI")]) : (order.sub_src_type === 5) ? _c('span', {
      staticClass: "text-12 text-w-600 label-danger",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("J")]) : _vm._e()]), _vm._v(" "), (_vm.roleType === 99) ? _c('td', [_vm._v(_vm._s(order.brand_name) + "(" + _vm._s(order.brand_id) + ")")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99 || _vm.roleType === 30) ? _c('td', [_vm._v(_vm._s(order.store_name) + "(" + _vm._s(order.store_id) + ")")]) : _vm._e(), _vm._v(" "), _c('td', [(_vm.isGuestTab) ? _c('span', [_vm._v("\n              " + _vm._s(order.name) + "\n            ")]) : ((_vm.roleType === 30 || _vm.roleType === 99) && _vm.$route.name !== 'memberOrderTable' && _vm.checkMemberShow(order.status) && _vm.isOnline) ? _c('router-link', {
      attrs: {
        "to": {
          path: '/memberOrderTable/' + order.shopper_id
        },
        "target": "_blank"
      }
    }, [_vm._v("\n              " + _vm._s(order.name) + "\n              "), (_vm.roleType === 99) ? _c('span', [_vm._v("\n                (" + _vm._s(order.shopper_id) + ")\n              ")]) : _vm._e()]) : _c('span', [_vm._v("\n              " + _vm._s(order.name) + "\n              "), (_vm.roleType === 99) ? _c('span', [_vm._v("\n                (" + _vm._s(order.shopper_id) + ")\n              ")]) : _vm._e()]), _vm._v(" "), (order.main_shopper_id) ? _c('span', {
      staticClass: "tag-default text-white bg-blue",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        "title": 'ID(' + order.main_shopper_id + ')'
      }
    }, [_vm._v("主")]) : _vm._e(), _vm._v(" "), (order.sub_shopper_id) ? _c('span', {
      staticClass: "tag-default text-white bg-orange",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        "title": 'ID(' + order.sub_shopper_id + ')'
      }
    }, [_vm._v("副")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.amount))]), _vm._v(" "), (_vm.isOffline) ? _c('td', [_c('span', {
      class: {
        'text-del': _vm.hasPaidMoneyChanged(order)
      }
    }, [_vm._v("＄" + _vm._s(order.money) + " ")]), _vm._v(" "), (_vm.hasPaidMoneyChanged(order)) ? _c('span', {
      staticClass: "text-red"
    }, [_vm._v("＄" + _vm._s(order.paid_money))]) : _vm._e()]) : _c('td', [_c('span', {
      class: {
        'text-del': order.paid_money !== order.money + order.shipping_money
      }
    }, [_vm._v("＄" + _vm._s(order.money + order.shipping_money) + " ")]), _vm._v(" "), (order.paid_money !== order.money + order.shipping_money) ? _c('span', {
      staticClass: "text-red"
    }, [_vm._v("＄" + _vm._s(order.paid_money))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('label', {
      staticClass: "label",
      class: _vm.stateColor(order.payment_status)
    }, [_vm._v("\n              " + _vm._s(_vm._f("tradeName")(order.trade_type)) + " " + _vm._s(_vm.payStateName(order.payment_status)) + "\n            ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.isGuestTab ? _vm.getTime(order.create_time) : _vm.getTime(order.order_time)))]), _vm._v(" "), (_vm.isOnline) ? _c('td', [_vm._v(_vm._s(order.src_vendor_code))]) : _vm._e()])
  }), 0) : (!_vm.isLoading && _vm.orderList.length === 0) ? _c('tbody', [_vm._m(2)]) : _vm._e()])]), _vm._v(" "), (!_vm.orderList.length && _vm.$route.name === 'onSiteOrderTableInfo') ? _c('div', {
    staticClass: "text-center m-a-100 text-light-gray"
  }, [_vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "m-t-5"
  }, [_vm._v("沒有符合的資料")])]) : _vm._e(), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }],
    ref: "orderPaginate",
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.changePage
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text center"
  }, [_vm._v("\n                「你訂團隊持續在進行系統優化，如有追蹤訂單來源需求，可自【新後台管理系統】-【成效數據中心】使用[自訂報表]下載報表分析。\n                "), _c('br'), _vm._v("\n                此追蹤碼功能於近期將不再進行相關維護，如需更進階數據分析需求，可洽你訂同仁詢問GA4數據分析，會有專人與您詳細說明完整方案。」\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "font-size-80"
  }, [_c('i', {
    staticClass: "ion ion-clipboard"
  })])
}]}

/***/ }),
/* 2558 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 p-x-0",
    class: _vm.setting.class,
    attrs: {
      "id": _vm.setting.id
    }
  }, [_c('div', {
    staticClass: "j-mutiple-left"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "name": "from",
      "id": "multiselect",
      "size": "8",
      "multiple": "multiple"
    },
    on: {
      "dblclick": function($event) {
        $event.preventDefault();
      }
    }
  }, _vm._l((_vm.setting.options), function(option, index) {
    return _c('option', {
      class: 'o-' + option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n        " + _vm._s(option.label) + "\n      ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "j-mutiple-middle"
  }, [_c('button', {
    staticClass: "btn btn-block",
    attrs: {
      "type": "button",
      "id": 'multiselect_rightAll-' + _vm.setting.class
    },
    on: {
      "click": function($event) {
        _vm.isChoose = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-forward"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block",
    attrs: {
      "type": "button",
      "id": 'multiselect_rightSelected-' + _vm.setting.class
    },
    on: {
      "click": function($event) {
        _vm.isChoose = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block",
    attrs: {
      "type": "button",
      "id": 'multiselect_leftSelected-' + _vm.setting.class
    },
    on: {
      "click": function($event) {
        _vm.isChoose = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block",
    attrs: {
      "type": "button",
      "id": 'multiselect_leftAll-' + _vm.setting.class
    },
    on: {
      "click": function($event) {
        _vm.isChoose = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-backward"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "j-mutiple-right"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "name": "to",
      "id": 'multiselect_to-' + _vm.setting.class,
      "size": "8",
      "multiple": "multiple"
    },
    on: {
      "dblclick": function($event) {
        $event.preventDefault();
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_c('p', {
    staticClass: "text-12"
  }, [_vm._v("已選 " + _vm._s(_vm.setting.choose.length) + " 間")])])])
},staticRenderFns: []}

/***/ }),
/* 2559 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', [(_vm.activity.strategy_data.rule_code === 'SA00001') ? _c('h4', [_vm._v("消費金額滿額")]) : (_vm.activity.strategy_data.rule_code === 'SA00002') ? _c('h4', [_vm._v("消費商品數量滿額")]) : (_vm.activity.strategy_data.rule_code === 'SA00003') ? _c('h4', [_vm._v("指定商品滿額")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-center"
  }, [(_vm.activity.strategy_data.rule_code === 'SA00001') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("贈送條件達成金額")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.strategy_data.setting.money_unit) + " 元")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.rule_code === 'SA00002' || _vm.activity.strategy_data.rule_code === 'SA00003') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("贈送條件達成商品數")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.strategy_data.setting.amount_unit) + " 個")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.rule_code === 'SA00002') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品限制最低單價")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.strategy_data.setting.lowest_unit_price) + " 元")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.setting.max_count) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("每次贈送最大份數")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.strategy_data.setting.max_count))])]), _vm._v(" "), _c('br')]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr', {
    staticClass: "box-body"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [(_vm.showNoLimit) ? _c('div', [_vm._v("\n        不限制\n        "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.order_type.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            訂單類型\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.activity.strategy_data.limit.order_type), function(ot) {
    return _c('label', {
      staticClass: "label-success label m-r-5"
    }, [_vm._v(_vm._s(ot.label))])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.order_method.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            訂單方案\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.activity.strategy_data.limit.order_method), function(om) {
    return _c('label', {
      staticClass: "label-success label m-r-5"
    }, [_vm._v(_vm._s(om.label))])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.min_total_paid_money) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("訂單最低應付金額(單位：元)")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.strategy_data.limit.min_total_paid_money))])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.min_total_money) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("訂單最低總金額(單位：元)")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.strategy_data.limit.min_total_money))])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.min_total_amount) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("訂單最低購買數(單位：個)")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.strategy_data.limit.min_total_amount))])]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [(_vm.activity.strategy_data.limit.delivery_type.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            取貨方式\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.activity.strategy_data.limit.delivery_type), function(dt) {
    return _c('label', {
      staticClass: "label-success label m-r-5"
    }, [_vm._v(_vm._s(dt.label))])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.pay_place_type.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            付款地點\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.activity.strategy_data.limit.pay_place_type), function(pt) {
    return _c('label', {
      staticClass: "label-success label m-r-5"
    }, [_vm._v(_vm._s(pt.label))])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.min_money) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制主單(或團長)最低總金額")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.strategy_data.limit.min_money) + " 元")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.min_amount) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制主單(或團長)最低購買數")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.strategy_data.limit.min_amount) + " 個")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.min_sub_order_amount) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制子單(跟團單)最低訂單數")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.strategy_data.limit.min_sub_order_amount) + " 筆")])]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), (_vm.activity.strategy_data.limit.min_paid_money) ? _c('div', {
    staticClass: "box-body form-center",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制主單(或團長)最低應付金額(單位：元)")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.strategy_data.limit.min_paid_money))])]), _vm._v(" "), _c('br')])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr', {
    staticClass: "box-body"
  }), _vm._v(" "), (_vm.activity.strategy_data.store_exception_items[0].products.length || _vm.activity.strategy_data.setting.vendor_custom_product_list.length) ? _c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [(_vm.ruleCode === 'SA00001' || _vm.ruleCode === 'SA00002') ? _c('h5', [_vm._v("例外商品")]) : _c('h5', [_vm._v("指定商品")])]), _vm._v(" "), (_vm.activity.strategy_data.store_exception_items[0].products.length && (_vm.ruleCode === 'SA00001' || _vm.ruleCode === 'SA00002')) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.activity.strategy_data.store_exception_items[0].products), function(aProduct, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n              " + _vm._s(aIndex + 1) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(aProduct.product_name) + "\n            ")]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(aProduct.vendor_custom_id))])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.setting.vendor_custom_product_list.length && _vm.ruleCode === 'SA00003') ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.activity.strategy_data.setting.vendor_custom_product_list), function(aProduct, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n              " + _vm._s(aIndex + 1) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(aProduct.product_name) + "\n            ")]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(aProduct.vendor_custom_id))])])])
  }), 0)])]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', [_c('h4', [_vm._v("限制規則")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品")]), _vm._v(" "), _c('td', [_vm._v("商品料號")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品")]), _vm._v(" "), _c('td', [_vm._v("商品料號")])])])
}]}

/***/ }),
/* 2560 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.getRoleType === 99) ? _c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-10 flex align-center"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.goBackInfo
    }
  }, [_c('div', {
    staticClass: "btn btn-default m-r-5 flex"
  }, [_c('span', [_vm._v("返回")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.title)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.subtitle)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex grey darken-1"
  }, [(_vm.brand.name || _vm.store.brand_name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s(_vm.brand.name ? _vm.brand.name : _vm.store.brand_name ? _vm.store.brand_name : '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s('/')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.store.name)
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 text-right"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKeyword),
      expression: "searchKeyword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchKeyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKeyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.clickPage(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [(_vm.list) ? _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.list), function(item, k) {
    return _c('tr', {
      key: k
    }, [_c('td', {
      domProps: {
        "textContent": _vm._s(k + 1)
      }
    }), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": (_vm.webDomain + "menu/" + (item.id)),
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "w-100 rounded",
      attrs: {
        "src": item.image
      }
    })])]), _vm._v(" "), _c('td', {
      domProps: {
        "textContent": _vm._s(item.name || item.name_short)
      }
    }), _vm._v(" "), _c('td', [(_vm.getRoleType === 10) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'brandMenu',
          params: {
            brand_id: item.id
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-plus-square"
    }), _vm._v("\n                          配料庫\n                        ")])]) : _c('router-link', {
      attrs: {
        "to": {
          name: 'StoreMenuStep',
          params: {
            store_id: item.id
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-plus-square"
    }), _vm._v("\n                          配料庫\n                        ")])])], 1), _vm._v(" "), _c('td', [(_vm.getRoleType === 10) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'brandMenuTable',
          params: {
            brand_id: item.id
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-wrench"
    }), _vm._v("\n                          菜單建置\n                        ")])]) : _c('router-link', {
      attrs: {
        "to": {
          name: 'StoreMenuBuild',
          params: {
            brand_id: _vm.$route.params.brand_id,
            store_id: item.id
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-wrench"
    }), _vm._v("\n                          菜單建置\n                        ")])])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'StoreMenuImage',
          params: {
            brand_id: _vm.$route.params.brand_id,
            store_id: item.id
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-picture-o"
    }), _vm._v("\n                          圖片庫\n                        ")])])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'StoreMenuSetting',
          params: {
            brand_id: _vm.$route.params.brand_id,
            store_id: item.id
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-certificate"
    }), _vm._v("\n                          別名 / 描述 / 警語\n                        ")])])], 1), _vm._v(" "), _c('td', [(_vm.getRoleType === 10) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'brandScheduleTable',
          params: {
            brand_id: item.id,
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-primary"
    }, [_c('i', {
      staticClass: "fa fa-clock-o"
    }), _vm._v("\n                          排程管理\n                        ")])]) : _c('router-link', {
      attrs: {
        "to": {
          name: 'StoreMenuSchedule',
          params: {
            brand_id: _vm.$route.params.brand_id,
            store_id: item.id
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-primary"
    }, [_c('i', {
      staticClass: "fa fa-clock-o"
    }), _vm._v("\n                          排程管理\n                        ")])])], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('paginate', {
    ref: "brandPaginate",
    attrs: {
      "clickPage": _vm.clickPage,
      "groupAmount": _vm.paginate.count,
      "isActive": _vm.isActive,
      "pageAmount": _vm.pageAmount,
      "total": _vm.paginate.total
    }
  })], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-8 text-left"
  }, [_c('div', {
    staticClass: "font-size-subtitle-2 font-weight-regular"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("此區可新增、編輯品牌下所有菜單的內容")])]), _vm._v(" "), _c('div', {
    staticClass: "font-size-subtitle-2 font-weight-regular"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("黑名單：名單內的門市當進行配料庫複製時「不可」被覆寫，菜單上架時「不可」被複寫")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    staticClass: "form-control h-38"
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("關鍵字")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "w-xl"
  }, [_vm._v("品牌")]), _vm._v(" "), _c('th', [_vm._v("門市")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
}]}

/***/ }),
/* 2561 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box m-h-700"
  }, [_c('div', {
    staticClass: "box-body form-inline"
  }, [(_vm.brandBrief.length > 1 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 品牌 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.brandSelect.value !== 99 && _vm.brandSelect.value !== '99' && _vm.storeBrief.length > 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.storeBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 門市 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group pull-right"
  }, [(_vm.$route.name !== 'storeInfo' &&
    _vm.storeSelect.value === 999999 && _vm.roleType !== 10) ? _c('span', [_c('button', {
    staticClass: "btn btn-default btn-table-title",
    on: {
      "click": _vm.goPage
    }
  }, [_vm._v("\n                查看批次紀錄\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.brandSelect.value !== 99 && _vm.brandSelect.value !== '99' && _vm.storeSelect.value !== 999999) ? _c('span', [_c('button', {
    staticClass: "btn btn-default btn-table-title",
    on: {
      "click": _vm.goPage
    }
  }, [_vm._v("\n                查看歷程紀錄\n              ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(1)]) : (_vm.menuList.length === 0) ? _c('tbody', [_vm._m(2)]) : (_vm.menuList.length > 0) ? _c('tbody', _vm._l((_vm.menuList), function(menu, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(menu.name) + " (" + _vm._s(menu.id) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(menu.remark))]), _vm._v(" "), (_vm.storeSelect.value && _vm.storeSelect.value !== 999999) ? _c('td', [_c('router-link', {
      attrs: {
        "to": '/disProduct/' + menu.brand_id + '/' + menu.id + '/' + _vm.storeSelect.value + '/forever'
      }
    }, [_c('button', {
      staticClass: "btn btn-danger"
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v("  永久停賣")])]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": '/disProduct/' + menu.brand_id + '/' + menu.id + '/' + _vm.storeSelect.value + '/daily'
      }
    }, [_c('button', {
      staticClass: "btn btn-success"
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v("  當日停賣")])])], 1) : _c('td', [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#storesModal"
      },
      on: {
        "click": function($event) {
          return _vm.clickCurrent(menu)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-home"
    })]), _vm._v(" \n                      "), _c('router-link', {
      attrs: {
        "to": '/disProduct/' + menu.brand_id + '/' + menu.id
      }
    }, [_c('button', {
      staticClass: "btn btn-danger"
    }, [_c('img', {
      staticClass: "full-whdth",
      attrs: {
        "src": __webpack_require__(2077),
        "alt": "point_icon"
      }
    }), _vm._v("  多店停賣")])]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": '/reDisProduct/' + menu.brand_id + '/' + menu.id
      }
    }, [_c('button', {
      staticClass: "btn btn-success"
    }, [_c('img', {
      staticClass: "full-whdth",
      attrs: {
        "src": __webpack_require__(2081),
        "alt": "point_icon"
      }
    }), _vm._v("  多店解除停賣")])])], 1)])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('paginate', {
    ref: "orderPaginate",
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "storesModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\"" + _vm._s(_vm.current.name) + "\"使用門市")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 p-x-0"
  }, _vm._l((_vm.current.store_list), function(store) {
    return _c('div', {
      staticClass: "inline-block",
      staticStyle: {
        "margin": "2.5px 5px 2.5px 0px"
      }
    }, [_c('label', {
      staticClass: "label label-primary"
    }, [_vm._v(_vm._s(store.name))])])
  }), 0)])]), _vm._v(" "), _vm._m(3)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("菜單 (ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("備註")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("確定")])])
}]}

/***/ }),
/* 2562 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [(_vm.getRoleType === 99) ? _c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-10 flex align-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.goBackInfo.name,
        params: _vm.goBackInfo.params,
        query: _vm.goBackInfo.query
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default m-r-5 flex"
  }, [_c('span', [_vm._v("返回")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.title)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.subtitle)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex grey darken-1"
  }, [(_vm.brand.name || _vm.store.brand_name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s(_vm.brand.name ? _vm.brand.name : _vm.store.brand_name ? _vm.store.brand_name : '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s('/')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.store.name)
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('menu-info-form', {
    attrs: {
      "info": _vm.menuInfo
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2563 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cov-vue-date"
  }, [_c('div', {
    staticClass: "datepickbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.date.time),
      expression: "date.time"
    }],
    staticClass: "cov-datepicker",
    style: (_vm.option.inputStyle ? _vm.option.inputStyle : {}),
    attrs: {
      "type": "text",
      "title": "input date",
      "readonly": "readonly",
      "placeholder": _vm.option.placeholder,
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.date.time)
    },
    on: {
      "click": _vm.showCheck,
      "foucus": _vm.showCheck,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.date, "time", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.showInfo.check) ? _c('div', {
    staticClass: "datepicker-overlay",
    style: ({
      'background': _vm.option.overlayOpacity ? 'rgba(0,0,0,' + _vm.option.overlayOpacity + ')' : 'rgba(0,0,0,0.5)'
    }),
    on: {
      "click": function($event) {
        return _vm.dismiss($event)
      }
    }
  }, [_c('div', {
    staticClass: "cov-date-body",
    style: ({
      'background-color': _vm.option.color ? _vm.option.color.header : '#3f51b5'
    })
  }, [_c('div', {
    staticClass: "cov-date-monthly"
  }, [_c('div', {
    staticClass: "cov-date-previous",
    on: {
      "click": function($event) {
        return _vm.nextMonth('pre')
      }
    }
  }, [_vm._v("«")]), _vm._v(" "), _c('div', {
    staticClass: "cov-date-caption",
    style: ({
      'color': _vm.option.color ? _vm.option.color.headerText : '#fff'
    })
  }, [_c('span', {
    on: {
      "click": _vm.showYear
    }
  }, [_c('small', [_vm._v(_vm._s(_vm.checked.year))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.showMonth
    }
  }, [_vm._v(_vm._s(_vm.displayInfo.month))])]), _vm._v(" "), _c('div', {
    staticClass: "cov-date-next",
    on: {
      "click": function($event) {
        return _vm.nextMonth('next')
      }
    }
  }, [_vm._v("»")])]), _vm._v(" "), (_vm.showInfo.day) ? _c('div', {
    staticClass: "cov-date-box"
  }, [_c('div', {
    staticClass: "cov-picker-box"
  }, [_c('div', {
    staticClass: "week"
  }, [_c('ul', _vm._l((_vm.library.week), function(weekie) {
    return _c('li', [_vm._v(_vm._s(weekie))])
  }), 0)]), _vm._v(" "), _vm._l((_vm.dayList), function(day) {
    return _c('div', {
      staticClass: "day",
      class: {
        'checked': day.checked, 'unavailable': day.unavailable, 'passive-day': !(day.inMonth)
      },
      style: (day.checked ? (_vm.option.color && _vm.option.color.checkedDay ? {
        background: _vm.option.color.checkedDay
      } : {
        background: '#F50057'
      }) : {}),
      attrs: {
        "track-by": "$index"
      },
      on: {
        "click": function($event) {
          return _vm.checkDay(day)
        }
      }
    }, [_vm._v(_vm._s(day.value))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.showInfo.year) ? _c('div', {
    staticClass: "cov-date-box list-box"
  }, [_c('div', {
    staticClass: "cov-picker-box date-list",
    attrs: {
      "id": "yearList"
    }
  }, _vm._l((_vm.library.year), function(yearItem) {
    return _c('div', {
      staticClass: "date-item",
      attrs: {
        "track-by": "$index"
      },
      on: {
        "click": function($event) {
          return _vm.setYear(yearItem)
        }
      }
    }, [_vm._v(_vm._s(yearItem))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.showInfo.month) ? _c('div', {
    staticClass: "cov-date-box list-box"
  }, [_c('div', {
    staticClass: "cov-picker-box date-list"
  }, _vm._l((_vm.library.month), function(monthItem) {
    return _c('div', {
      staticClass: "date-item",
      attrs: {
        "track-by": "$index"
      },
      on: {
        "click": function($event) {
          return _vm.setMonth(monthItem)
        }
      }
    }, [_vm._v(_vm._s(monthItem))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.showInfo.hour) ? _c('div', {
    staticClass: "cov-date-box list-box"
  }, [_c('div', {
    staticClass: "cov-picker-box date-list"
  }, [_c('div', {
    staticClass: "watch-box"
  }, [_c('div', {
    staticClass: "hour-box"
  }, [_c('div', {
    staticClass: "mui-pciker-rule mui-pciker-rule-ft"
  }), _vm._v(" "), _c('ul', _vm._l((_vm.hours), function(hitem) {
    return _c('li', {
      staticClass: "hour-item",
      class: {
        'active': hitem.checked
      },
      on: {
        "click": function($event) {
          return _vm.setTime('hour', hitem, _vm.hours)
        }
      }
    }, [_vm._v(_vm._s(hitem.value))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "min-box"
  }, [_c('div', {
    staticClass: "mui-pciker-rule mui-pciker-rule-ft"
  }), _vm._v(" "), _vm._l((_vm.mins), function(mitem) {
    return _c('div', {
      staticClass: "min-item",
      class: {
        'active': mitem.checked
      },
      on: {
        "click": function($event) {
          return _vm.setTime('min', mitem, _vm.mins)
        }
      }
    }, [_vm._v(_vm._s(mitem.value))])
  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-box"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.showInfo.check = false
      }
    }
  }, [_vm._v(_vm._s(_vm.option.buttons ? _vm.option.buttons.cancel : 'Cancel'))]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.picked
    }
  }, [_vm._v(_vm._s(_vm.option.buttons ? _vm.option.buttons.ok : 'Ok'))])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2564 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "font-size-title font-weight-regular mb-3"
  }, [_vm._v("選擇店家")]), _vm._v(" "), _c('div', _vm._l((_vm.storeClassList), function(storeClass, i) {
    return _c('div', {
      key: ("store-class-" + i),
      staticClass: "m-r-5 m-b-10 inline-block"
    }, [_c('button', {
      staticClass: "btn btn-default",
      class: {
        'active': _vm.curId === storeClass.id
      },
      domProps: {
        "textContent": _vm._s(storeClass.name)
      },
      on: {
        "click": function($event) {
          return _vm.clickOption(storeClass)
        }
      }
    })])
  }), 0)]), _vm._v(" "), _c('v-multiselect-listbox', {
    staticClass: "col-xs-12",
    attrs: {
      "options": _vm.setting.options,
      "reduce-display-property": function (option) { return option.label; },
      "reduce-value-property": function (option) { return option.value; },
      "search-options-placeholder": "搜尋...",
      "selected-options-placeholder": "搜尋..."
    },
    model: {
      value: (_vm.setting.choose),
      callback: function($$v) {
        _vm.$set(_vm.setting, "choose", $$v)
      },
      expression: "setting.choose"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2565 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('cr-combine')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2566 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [(_vm.getRoleType === 99) ? _c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-10 flex align-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.goBackInfo.name,
        params: _vm.goBackInfo.params,
        query: _vm.goBackInfo.query
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default m-r-5 flex"
  }, [_c('span', [_vm._v("返回")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.title)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.subtitle)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex grey darken-1"
  }, [(_vm.brand.name || _vm.store.brand_name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s(_vm.brand.name ? _vm.brand.name : _vm.store.brand_name ? _vm.store.brand_name : '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s('/')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.store.name)
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('menu-info-form')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2567 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('group-form')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2568 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "th-fit",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("名稱 (ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("電話")]), _vm._v(" "), _c('th', {
    staticClass: "th-fat",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("地址")]), _vm._v(" "), _c('th', {
    staticClass: "th-fit",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("營業狀態")]), _vm._v(" "), _c('th', {
    staticClass: "th-fit",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("接單狀態")]), _vm._v(" "), _c('th', {
    staticClass: "th-fit",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("連線狀態")]), _vm._v(" "), _c('th', {
    staticClass: "th-fit",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("今日連線紀錄")]), _vm._v(" "), (_vm.roleType != 10) ? _c('th', {
    staticClass: "th-fit",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("查詢連線紀錄")]) : _vm._e()])]), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(0)]) : (_vm.storeList.length === 0) ? _c('tbody', [_vm._m(1)]) : (_vm.storeList.length > 0) ? _c('tbody', _vm._l((_vm.storeList), function(store, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v("\n            " + _vm._s(index + 1) + "\n          ")]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(store.name) + " (" + _vm._s(store.id) + ")")])]), _vm._v(" "), (!_vm.history) ? _c('td', [_vm._v(_vm._s(store.tel) + " "), _c('br'), _vm._v(" " + _vm._s(store.tel2))]) : _vm._e(), _vm._v(" "), (!_vm.history) ? _c('td', [_vm._v(_vm._s(store.address))]) : _vm._e(), _vm._v(" "), _c('td', [(store.status == 2) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v(_vm._s(_vm.getStateName(store.status)))]) : _vm._e(), _vm._v(" "), (store.status != 2) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v(_vm._s(_vm.getStateName(store.status)))]) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.roleType !== 50) ? _c('div', [_c('div', {
      staticClass: "c-pointer",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#closeStatusModal"
      },
      on: {
        "click": function($event) {
          return _vm.openModal(store)
        }
      }
    }, [(store.order_status == 10) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("接單中")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "c-pointer",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#openStatusModal"
      },
      on: {
        "click": function($event) {
          return _vm.openModal(store)
        }
      }
    }, [(store.order_status == 20) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("未接單")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.roleType === 50) ? _c('div', [(store.order_status == 10) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("接單中")]) : _vm._e(), _vm._v(" "), (store.order_status == 20) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("未接單")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('td', [(!store.mqtt_info) ? _c('span', {
      staticClass: "label label-default"
    }, [_vm._v("無紀錄")]) : _vm._e(), _vm._v(" "), (store.mqtt_info) ? _c('span', [(store.mqtt_info[0].status === 2) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("中斷")]) : _vm._e(), _vm._v(" "), (store.mqtt_info[0].status === 1) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("連線")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('td', [(store.mqtt_info) ? _c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#mqttModal"
      },
      on: {
        "click": function($event) {
          return _vm.openModal(store)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plug",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()]), _vm._v(" "), (_vm.roleType != 10) ? _c('td', [_c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          return _vm.gotoSearchMqtt(store)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-search",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e()])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('paginate', {
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "mqttModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.current.name) + "今日連線紀錄")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.current.mqttInfo), function(mqtt, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                    " + _vm._s(_vm.getTime(mqtt.create_time)) + "\n                  ")]), _vm._v(" "), _c('td', [(mqtt.status === 1) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("建立")]) : _vm._e(), _vm._v(" "), (mqtt.status === 2) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("中斷")]) : _vm._e()])])
  }), 0)])])])])])])]), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.openStatusOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.closeStatusOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("連線狀態")])])])
}]}

/***/ }),
/* 2569 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box m-h-700"
  }, [_c('div', {
    staticClass: "box-body form-inline"
  }, [(_vm.roleType !== 10) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelect),
      expression: "statusSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.statusSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("== 連線狀態 ==")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("建立")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("中斷")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 text-right pull-right"
  }, [_c('div', {
    staticClass: "form-group input-group time-box pull-right"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.date,
      "option": _vm.dateoption,
      "limit": _vm.dateLimit
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default submit-btn btn-search",
    staticStyle: {
      "height": "36px"
    },
    attrs: {
      "type": "button",
      "id": "search3"
    },
    on: {
      "click": function($event) {
        return _vm.clickSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])], 1)])]) : _vm._e(), _vm._v(" "), _c('mqtt-table', {
    attrs: {
      "isSearch": _vm.isSearch,
      "date": _vm.date.time,
      "statusSelect": _vm.statusSelect
    }
  })], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 2570 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [_c('div', {
    staticClass: "box-body form"
  }, [_c('br'), _vm._v(" "), _c('div', [_c('h3', [_vm._v("複製此分店" + _vm._s(_vm.titleType) + "廣告至其他店家")])]), _vm._v(" "), _c('p', {
    staticClass: "text-light-gray"
  }, [_vm._v("將特定店家尚有效的廣告全數複製到指定同步的店家，原店家的有效廣告會立即刪除")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('h5', [_vm._v("套用門市")]), _vm._v(" "), _vm._l((_vm.storeClassList), function(storeClass, index) {
    return _c('div', {
      key: ("storeClass-" + index),
      staticClass: "m-r-5 m-b-10 inline-block"
    }, [_c('button', {
      staticClass: "btn btn-default",
      class: {
        'active': _vm.curId === storeClass.id
      },
      on: {
        "click": function($event) {
          return _vm.clickOption(storeClass)
        }
      }
    }, [_vm._v("\n          " + _vm._s(storeClass.name) + "\n        ")])])
  })], 2), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "text-left"
  }, [_vm._v("參與店家")]), _vm._v(" "), _c('muti-select-two', {
    attrs: {
      "setting": _vm.addStoresSetting,
      "reNew": _vm.reNew,
      "reSet": _vm.reSet
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('router-link', {
    attrs: {
      "to": '/adTable/' + _vm.$route.params.brand_id + '/' + _vm.$route.params.store_id
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("\n        取消\n      ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.copyAd()
      }
    }
  }, [_vm._v("\n      確定\n    ")])], 1), _vm._v(" "), _c('br')])
},staticRenderFns: []}

/***/ }),
/* 2571 */,
/* 2572 */,
/* 2573 */,
/* 2574 */,
/* 2575 */,
/* 2576 */,
/* 2577 */,
/* 2578 */,
/* 2579 */,
/* 2580 */,
/* 2581 */,
/* 2582 */,
/* 2583 */,
/* 2584 */,
/* 2585 */,
/* 2586 */,
/* 2587 */,
/* 2588 */,
/* 2589 */,
/* 2590 */,
/* 2591 */,
/* 2592 */,
/* 2593 */,
/* 2594 */,
/* 2595 */,
/* 2596 */,
/* 2597 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2598 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2599 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2600 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2601 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2602 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2603 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2604 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2605 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2606 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2607 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2608 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2609 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2610 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2611 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[463]);


// WEBPACK FOOTER //
// static/js/app.5822bb4acf8fa93b122e.js